(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('.eye-button{display:flex;align-items:center;justify-content:center;cursor:pointer;pointer-events:auto;padding:0;background-color:transparent;border:none}.channel-title__container{position:relative;display:flex;align-items:center;box-sizing:border-box;justify-content:flex-start;gap:8px;margin-left:8px;pointer-events:auto}.channel-title__container:hover,.channel-title__container:has(.channel-title__resize-handle:active){background-color:#f5faff}.channel-title__container--hidden,.channel-title__container--hidden:hover{background-color:#f0f0f0;border-radius:8px 0 0 8px}.channel-title__container--hidden .channel-title__text{color:#b0b0b0;font-weight:400}.channel-title__container--hidden .channel-title__drag-handle{opacity:.4}.channel-title__text{display:block;box-sizing:border-box;padding:0;font-family:Noto Sans,sans-serif;font-weight:600;font-size:16px;color:#000;line-height:24px;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.channel-title__controls{display:flex;align-items:center;gap:8px;margin-left:auto;margin-right:16px}.channel-title__drag-handle{display:flex;align-items:center;cursor:grab}.channel-title__drag-handle,.channel-title__controls{visibility:hidden}.channel-title__container:hover .channel-title__drag-handle,.channel-title__container:hover .channel-title__controls{visibility:visible}.channel-title__drag-handle:active{cursor:grabbing}.channel-title__resize-handle{position:absolute;bottom:0;left:0;right:0;height:8px;cursor:row-resize}.channel-title__resize-handle:after{content:"";position:absolute;bottom:0;left:0;right:0;height:4px;background-color:#91d5ff;opacity:0}.channel-title__resize-handle:hover:after,.channel-title__resize-handle:active:after{opacity:1}.chart-container__root{position:relative;min-width:0;display:flex;flex-direction:column;overflow:hidden;flex:1 1 auto}.chart-container__panel{position:relative;display:flex;width:100%;height:100%;min-width:0;min-height:0}.chart-container__titles-column{flex:0 0 auto;display:flex;flex-direction:column}.chart-container__chart-column{position:relative;flex:1 1 auto;min-width:0;min-height:0}.chart-container__channel-gap{position:absolute;left:0;right:0;background:#fff;pointer-events:none;z-index:2}.chart-container__channel-hidden{position:absolute;left:0;right:0;background:#f0f0f0;pointer-events:none;z-index:2}.chart-container__channel-placeholder{position:absolute;left:0;right:0;display:flex;align-items:center;justify-content:center;overflow:hidden;font-family:Noto Sans,sans-serif;font-size:14px;color:#8b8b8b;pointer-events:none;z-index:2}.chart-container__drop-indicator{display:none;position:absolute;left:0;right:0;height:4px;background:#91d5ff;transform:translateY(-50%);pointer-events:none;z-index:3}.chart-container__tooltip{position:fixed;background-color:#ffffffe6;border:none;box-shadow:0 4px 15px #0035681f;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);color:#333;font-family:Noto Sans,sans-serif;font-size:13px;padding:12px 16px;border-radius:8px;pointer-events:none;opacity:0;transition:opacity .15s ease-out;z-index:9999;min-width:220px;width:max-content;max-width:calc(100vw - 16px)}.chart-container__cursor-line{position:fixed;width:2px;background-color:#1890ff;pointer-events:none;z-index:9998;opacity:0;transition:opacity .15s ease-out}.therapy-protocol-hide-button{width:36px;height:36px;border:none;border-radius:8px;background:transparent;color:#5d5d5d;display:inline-flex;align-items:center;justify-content:center;cursor:pointer}.therapy-protocol-hide-button:hover{background:#f5faff}.therapy-protocol-hide-button:active{transform:scale(.98)}.therapy-protocol-hide-button:focus-visible{outline:2px solid #0a66d9;outline-offset:2px}.selected-data-panel{--selected-data-panel-duration-value-color: #181818;--selected-data-panel-metric-time-color: #5D5D5D;font-family:Noto Sans,sans-serif;width:100%;height:100%;background:#fff;overflow:hidden;box-sizing:border-box}.selected-data-panel button,.selected-data-panel input,.selected-data-panel select,.selected-data-panel textarea{font-family:inherit}.selected-data-panel__content{height:100%;display:flex;flex-direction:column;box-sizing:border-box;min-height:0}.selected-data-panel__header{box-sizing:border-box;margin:0;background:#fff;padding:16px 18px 14px;text-align:left;width:100%;display:flex;align-items:center;gap:8px;justify-content:space-between;flex:0 0 auto;font-size:18px;font-weight:600;color:#1b2733}.selected-data-panel__title{min-width:0}.selected-data-panel__title-actions{display:inline-flex;align-items:center;flex:0 0 auto;gap:4px;margin-left:auto}.selected-data-panel__summary{flex:0 0 auto;padding:0 20px}.selected-data-panel__interval{font-family:Noto Sans,sans-serif;font-size:14px;line-height:20px;font-weight:600;color:#181818;margin-bottom:4px}.selected-data-panel__duration{font-family:Noto Sans,sans-serif;font-size:14px;line-height:20px;margin-bottom:4px}.selected-data-panel__duration-label{color:#5d5d5d}.selected-data-panel__duration-value{color:var(--selected-data-panel-duration-value-color)}.selected-data-panel__divider{height:1px;background:#e8e8e8;margin:14px 20px;flex:0 0 auto}.selected-data-panel__signals{flex:1 1 auto;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:14px;padding:0 24px 20px 20px}.selected-data-panel__empty{flex:1 1 auto;min-height:0;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:0 28px 32px;text-align:center}.selected-data-panel__empty-title{margin-top:20px;font-size:18px;line-height:28px;font-weight:500;color:#5d5d5d}.selected-data-panel__empty-text{margin-top:8px;max-width:180px;font-size:14px;line-height:20px;font-weight:500;color:#5d5d5d}.selected-data-panel__empty-accent{color:#096dd9;white-space:nowrap}.selected-data-panel__signal{padding-bottom:14px;border-bottom:1px solid #e3e3e3}.selected-data-panel__signal:last-child{padding-bottom:0;border-bottom:none}.selected-data-panel__signal-header{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:10px}.selected-data-panel__signal-name-wrap{display:flex;align-items:center;gap:8px;min-width:0}.selected-data-panel__signal-color{width:12px;height:12px;border-radius:2px;flex:0 0 auto}.selected-data-panel__signal-name{font-family:Noto Sans,sans-serif;font-size:14px;line-height:20px;font-weight:600;color:#181818;min-width:0;word-break:break-word}.selected-data-panel__signal-unit{font-family:Noto Sans,sans-serif;font-size:14px;font-weight:400;line-height:20px;color:#5d5d5d;white-space:nowrap}.selected-data-panel__metric-row{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;font-family:Noto Sans,sans-serif;font-size:14px;line-height:20px;color:#181818}.selected-data-panel__metric-label{min-width:0;color:#181818}.selected-data-panel__metric-time{color:var(--selected-data-panel-metric-time-color)}.selected-data-panel__metric-value{flex:0 0 auto;color:#181818}.selected-data-panel__metric-row+.selected-data-panel__metric-row{margin-top:8px}.chip-tab{display:inline-flex;align-items:center;min-width:0;max-width:100%;height:31px;padding:0 10px 0 14px;border-radius:8px;background:#f2f2f2;color:#5f6368;font-size:14px;font-weight:400;line-height:20px;box-sizing:border-box}.chip-tab__label{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.chip-tab__remove{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;width:16px;height:16px;margin-left:8px;padding:0;border:0;background:transparent;color:#8b8b8b;cursor:pointer;line-height:0}.chip-tab__remove:hover{color:#5f6368}.therapy-protocol-filter-button{width:36px;height:36px;border:none;border-radius:8px;background:transparent;color:#5d5d5d;display:inline-flex;align-items:center;justify-content:center;cursor:pointer}.therapy-protocol-filter-button:hover{background:#f5faff}.therapy-protocol-filter-button:active{transform:scale(.98)}.therapy-protocol-filter-button:focus-visible{outline:2px solid #0a66d9;outline-offset:2px}.therapy-protocol-filter-button--active{background:#e6f7ff;color:#096dd9}.therapy-protocol-filter-button--active:hover{background:#eaf4ff}.event-type-multiselect-select-all-checkbox{position:relative;flex:0 0 auto;width:20px;height:20px;border:1px solid #8b8b8b;border-radius:4px;background:#fff;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box}.event-type-multiselect-select-all-checkbox:hover{background:#e6f7ff;border-color:#096dd9}.event-type-multiselect-select-all-checkbox--checked,.event-type-multiselect-select-all-checkbox--partial{border-color:#096dd9}.event-type-multiselect-select-all-checkbox--checked:after{content:"";position:absolute;left:50%;top:50%;width:12px;height:9px;background:#096dd9;transform:translate(-50%,-50%);clip-path:path("M10.2411 0.349048C10.6006 -0.069974 11.2311 -0.118678 11.6503 0.24065C12.0693 0.600008 12.1178 1.23057 11.7587 1.64983L5.75871 8.64983C5.57754 8.86119 5.31617 8.98765 5.03801 8.99846C4.75985 9.00907 4.48977 8.90326 4.29289 8.70647L0.292893 4.70647C-0.0976311 4.31595 -0.0976308 3.68293 0.292893 3.29241C0.683442 2.9022 1.31654 2.90199 1.70696 3.29241L4.94328 6.52874L10.2411 0.349048Z")}.event-type-multiselect-select-all-checkbox--partial:after{content:"";position:absolute;top:50%;left:50%;width:11px;height:2px;background:#096dd9;transform:translate(-50%,-50%);clip-path:path("M10 0C10.5523 0 11 0.447715 11 1C11 1.55228 10.5523 2 10 2H1C0.447715 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0H10Z")}.event-type-multiselect{position:relative;width:100%;font-family:Noto Sans,sans-serif}.event-type-multiselect__trigger{width:100%;min-height:40px;padding:0 40px 0 14px;border:1px solid #b8c4d6;border-radius:4px;background:#fff;color:#222;font-family:inherit;font-size:14px;display:flex;align-items:center;justify-content:space-between;text-align:left;cursor:pointer;box-sizing:border-box;outline:none}.event-type-multiselect__trigger:focus-visible{border-color:#4a90ff}.event-type-multiselect__trigger:focus-within{border-color:#4a90ff}.event-type-multiselect--open .event-type-multiselect__trigger{border-color:#69c0ff}.event-type-multiselect__value{position:absolute;left:14px;right:40px;color:#222;font-size:14px;font-weight:400;line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.event-type-multiselect__value--placeholder{color:#9b9b9b}.event-type-multiselect__search{position:relative;z-index:1;width:100%;min-width:0;border:none;background:transparent;color:#222;font-family:inherit;font-size:14px;font-weight:400;line-height:20px;outline:none;padding:0}.event-type-multiselect__search::placeholder,.event-type-multiselect__search--placeholder::placeholder{color:#9b9b9b;opacity:1}.event-type-multiselect:not(.event-type-multiselect--open) .event-type-multiselect__search{color:transparent}.event-type-multiselect__arrow{position:absolute;right:14px;top:50%;transform:translateY(-50%) rotate(0);transition:transform .2s ease;display:inline-flex;align-items:center;justify-content:center;pointer-events:none}.event-type-multiselect--open .event-type-multiselect__arrow{transform:translateY(-50%) rotate(180deg)}.event-type-multiselect__dropdown{position:absolute;top:calc(100% + 8px);left:0;right:0;z-index:1000;max-height:280px;overflow-y:auto;background:#fff;border-radius:10px;box-shadow:0 8px 24px #1224401f;padding:6px 0}.event-type-multiselect__select-all{position:sticky;top:0;z-index:1;width:100%;min-height:40px;padding:0 14px;border:none;background:#fff;color:#222;display:flex;align-items:center;justify-content:space-between;gap:8px;font-family:inherit;font-size:14px;font-weight:400;line-height:20px;text-align:left;cursor:pointer;box-sizing:border-box;border-bottom:1px solid #e8edf3}.event-type-multiselect__select-all:hover{background:#f5faff}.event-type-multiselect__select-all:disabled{color:#9b9b9b;cursor:not-allowed}.event-type-multiselect__option{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;min-height:40px;padding:0 14px;color:#222;font-family:inherit;font-size:14px;box-sizing:border-box;cursor:pointer}.event-type-multiselect__option:hover{background:#f5faff}.event-type-multiselect__option:has(input:checked){background:#e6f7ff}.event-type-multiselect__option input{position:absolute;width:1px;height:1px;opacity:0;pointer-events:none}.event-type-multiselect__option-check{flex:0 0 auto;width:20px;height:20px;display:inline-flex;align-items:center;justify-content:center}.event-type-multiselect__empty{min-height:40px;padding:0 14px;color:#9b9b9b;display:flex;align-items:center;font-family:inherit;font-size:14px;line-height:20px;box-sizing:border-box}.event-type-multiselect__dropdown::-webkit-scrollbar{width:8px}.event-type-multiselect__dropdown::-webkit-scrollbar-track{background:transparent}.event-type-multiselect__dropdown::-webkit-scrollbar-thumb{background:#00000024;border-radius:999px}.visible-events{font-family:Noto Sans,sans-serif;box-sizing:border-box}.visible-events button,.visible-events input,.visible-events select,.visible-events textarea{font-family:inherit}.visible-events{display:flex;flex-direction:column;width:500px;height:100%;background:#fff;overflow:hidden}.visible-events__title{box-sizing:border-box;margin:0;background:#fff;padding:16px 18px 14px;text-align:left;width:100%;display:flex;align-items:center;gap:8px;justify-content:space-between;font-size:18px;font-weight:600;color:#1b2733}.visible-events__title-text{min-width:0}.visible-events__title-actions{display:inline-flex;align-items:center;flex:0 0 auto;gap:4px;margin-left:auto}.visible-events__body{display:flex;flex-direction:column;gap:14px;padding:24px 18px 16px;flex:1 1 auto;min-height:0}.visible-events__filters-container{display:flex;flex-direction:column;gap:14px}.visible-events__select-wrap{display:block;position:relative}.visible-events__filters-card{display:flex;flex-direction:column}.visible-events__select-label{display:block;margin-bottom:6px;color:#6a7785;font-size:14px}.visible-events__range-row{display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr);gap:10px;align-items:center}.visible-events__date-time-group{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:8px;min-width:0}.visible-events__filter-input{width:100%;min-width:0;min-height:40px;padding:0 14px;border:1px solid #b8c4d6;border-radius:4px;background:#fff;color:#222;font-family:inherit;font-size:14px;font-weight:400;line-height:20px;box-sizing:border-box;outline:none}.visible-events__filter-input::placeholder{color:#9b9b9b}.visible-events__filter-input:focus-visible{border-color:#4a90ff}.visible-events__range-separator{color:#6a7785;font-size:16px;line-height:1}.visible-events__select-hint{display:block;margin-top:6px;color:#7d8794;font-size:12px}.visible-events__selected-types{display:flex;flex-wrap:wrap;gap:8px 10px;margin-top:8px}.visible-events__selected-types-more{display:inline-flex;align-items:center;height:31px;color:#8b8b8b;font-size:14px;line-height:20px;white-space:nowrap}.visible-events__list-container{flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:hidden;padding-right:4px}.visible-events__sessions{display:flex;flex-direction:column;gap:16px}.visible-events__session{display:flex;flex-direction:column}.visible-events__session-header{display:flex;flex-direction:row;align-items:center;justify-content:start;margin-bottom:8px}.visible-events__session-header-divider{height:20px;width:1px;margin:0 8px;background:#e8e8e8}.visible-events__session-title{font-size:14px;line-height:20px;font-weight:600;color:#2a3440;display:inline-block;margin:0}.visible-events__session-title-duration{border:none;background:transparent;text-align:left;margin:0;padding:0}.visible-events__session-title-duration:hover{color:#096dd9;cursor:pointer}.visible-events__header{display:grid;grid-template-columns:140px minmax(0,1fr) auto;gap:12px;padding:0 0 8px;margin-right:8px;color:#7d8794;font-size:12px;border-bottom:1px solid #e8edf3;justify-items:start}.visible-events__header-btn{display:inline-flex;align-items:center;gap:4px;padding:0;border:none;background:transparent;color:inherit;font:inherit;cursor:pointer;text-align:left}.visible-events__sort-indicator{color:#096dd9;font-size:11px;line-height:1}.visible-events__list{margin:0;list-style:none;padding:0 8px 0 0}.visible-events__item{margin:0;border-bottom:1px solid #edf1f5}.visible-events__item:last-child{border-bottom:none}.visible-events__item-btn{width:100%;display:grid;grid-template-columns:140px minmax(0,1fr) auto;gap:12px;align-items:start;justify-items:start;border:none;background:transparent;text-align:left;padding:10px 0;cursor:pointer}.visible-events__item-btn:hover .visible-events__time{color:#096dd9}.visible-events__name{display:inline-flex;align-items:center;gap:6px;color:#1f2933;font-size:14px;font-weight:400;line-height:1.25;max-width:22ch;overflow-wrap:anywhere;word-break:break-word}.visible-events__alarm-icon{display:inline-flex;flex:0 0 auto;width:20px;height:20px}.visible-events__time{display:block;width:100%;color:#536476;font-size:14px;font-weight:400;line-height:1.3;justify-self:start;text-align:left;font-variant-numeric:tabular-nums;white-space:nowrap}.visible-events__link-icon{color:#7b8da0;font-size:12px;flex:0 0 auto}.visible-events__duration{color:#1f2933;font-size:14px;font-variant-numeric:tabular-nums;white-space:nowrap}.visible-events__empty{margin:0;padding:16px 4px;font-size:13px;color:#6a7785}.feature-sidebar{flex:0 0 auto;min-width:0;display:flex;gap:0;border-radius:10px;background:#fff;box-shadow:0 4px 15px #0035681f;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);overflow:hidden;position:relative;z-index:5}.feature-sidebar--stretch{align-self:stretch;align-items:stretch}.feature-sidebar--top-aligned{align-self:flex-start;align-items:stretch}.feature-sidebar--collapsed{width:auto;min-width:auto;flex-basis:auto;background:transparent;box-shadow:none;overflow:visible}.feature-sidebar--expanded{width:520px;min-width:520px;flex-basis:min-content}.feature-sidebar__rail{position:relative;box-sizing:border-box;width:60px;min-width:60px;height:100%;background:#fff;padding:12px;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;gap:8px;flex:0 0 auto}.feature-sidebar--collapsed .feature-sidebar__rail{border-radius:10px;box-shadow:0 4px 15px #0035681f;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);flex:0 0 60px}.feature-sidebar__button{position:relative;flex:0 0 auto;width:36px;height:36px;border:none;border-radius:8px;background:transparent;color:#5d5d5d;display:inline-flex;align-items:center;justify-content:center;cursor:pointer}.feature-sidebar__button:hover{background:#f5faff}.feature-sidebar__button-icon{display:inline-flex;align-items:center;justify-content:center}.feature-sidebar__button:active:not(:disabled) .feature-sidebar__button-icon{transform:scale(.98)}.feature-sidebar__button:focus-visible{outline:2px solid #0a66d9;outline-offset:2px}.feature-sidebar__button:disabled{color:#bababa;cursor:default}.feature-sidebar__button:disabled:hover{background:transparent}.feature-sidebar__separator{flex:0 0 auto;width:36px;height:1px;margin:2px 0;background:#e8e8e8}.feature-sidebar__tooltip{position:absolute;top:50%;right:calc(100% + 6px);z-index:10;transform:translateY(-50%);padding:2px 6px;border-radius:4px;background:#181818cc;color:#fff;box-shadow:0 4px 15px #0035681f;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);display:flex;align-items:center;gap:10px;font-family:Noto Sans,sans-serif;font-size:14px;font-weight:400;line-height:20px;white-space:nowrap;pointer-events:none;opacity:0;visibility:hidden}.feature-sidebar__tooltip-shortcut{color:#bababa}.feature-sidebar__button:hover .feature-sidebar__tooltip,.feature-sidebar__button:focus-visible .feature-sidebar__tooltip{opacity:1;visibility:visible}.feature-sidebar__button--active{background:#e6f7ff;color:#096dd9}.feature-sidebar__button--active:hover{background:#e6f7ff}.feature-sidebar__panel{flex:1 1 auto;min-width:0;background:#fff}.feature-sidebar--collapsed .feature-sidebar__panel{display:none}.feature-sidebar--expanded .feature-sidebar__rail{z-index:1;box-shadow:0 4px 15px #0035681f}.event-editor{box-sizing:border-box;height:100%;padding:16px 18px;font-family:Noto Sans,sans-serif;color:#181818}.event-editor__header{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px}.event-editor__title{font-size:13px;font-weight:600;letter-spacing:.04em;color:#5d5d5d}.event-editor__mode{display:grid;grid-template-columns:1fr 1fr;gap:6px;padding:4px;margin-bottom:18px;border-radius:10px;background:#f2f6fa}.event-editor__mode button{height:32px;border:0;border-radius:8px;background:transparent;color:#5d5d5d;cursor:pointer}.event-editor__mode .event-editor__mode-btn--active{background:#fff;color:#181818;box-shadow:0 1px 4px #0000001f}.event-editor__section{display:flex;flex-direction:column;gap:12px}.event-editor__label{display:flex;flex-direction:column;gap:6px;font-size:13px;color:#5d5d5d}.event-editor__select{height:34px;border:1px solid #d8e0e8;border-radius:8px;padding:0 10px;background:#fff;color:#181818}.event-editor__hint,.event-editor__footer{margin:0;font-size:13px;line-height:18px;color:#6d7782}.event-editor__footer{margin-top:20px;padding-top:14px;border-top:1px solid #e8eef3}.event-editor__selected-name{font-size:16px;font-weight:600}.event-editor__details{display:grid;gap:10px;margin:0}.event-editor__details div{display:grid;gap:2px}.event-editor__details dt{font-size:12px;color:#6d7782}.event-editor__details dd{margin:0;font-size:14px;color:#181818}.event-editor__visual-controls{display:flex;flex-direction:column;gap:32px}.event-editor__height-control,.event-editor__vertical-control,.event-editor__color-control{display:flex;width:252px;flex-direction:column;gap:8px}.event-editor__height-header,.event-editor__vertical-header,.event-editor__color-label{display:flex;align-items:center;justify-content:space-between;color:#8b8b8b;font-size:14px;font-weight:400;line-height:20px}.event-editor__height-header span:last-child,.event-editor__vertical-header span:last-child{color:#181818}.event-editor__height-slider{position:relative;box-sizing:border-box;display:flex;width:252px;height:32px;align-items:center;touch-action:none;-webkit-user-select:none;user-select:none}.event-editor__height-track{position:relative;box-sizing:border-box;width:100%;height:32px;overflow:hidden;border-radius:4px;background:#f3f3f3}.event-editor__height-fill{position:absolute;top:0;bottom:0;min-width:4px;border-radius:4px;background:#dff4ff}.event-editor__height-fill:after{position:absolute;top:0;right:0;width:4px;height:32px;border-radius:0 4px 4px 0;background:#40a9ff;content:""}.event-editor__height-thumb{display:block;width:20px;height:32px;border:0;background:transparent;cursor:grab}.event-editor__height-thumb:active{cursor:grabbing}.event-editor__height-thumb:focus-visible{outline:2px solid #40a9ff;outline-offset:2px}.event-editor__height-mark{position:absolute;top:13px;width:2px;height:6px;border-radius:50px;background:#bfbfbf}.event-editor__height-marks{position:absolute;inset:0;z-index:1;pointer-events:none}.event-editor__height-mark--active{background:#40a9ff}.event-editor__vertical-options{display:flex;width:252px;justify-content:space-between}.event-editor__vertical-option{position:relative;width:44px;height:32px;border:0;border-radius:4px;background:#f3f3f3;cursor:pointer}.event-editor__vertical-option--active{background:#dff4ff}.event-editor__vertical-option:focus-visible{outline:2px solid #40a9ff;outline-offset:2px}.event-editor__vertical-option-mark{position:absolute;left:8px;width:28px;height:6px;border-radius:2px;background:#bfbfbf}.event-editor__vertical-option--active .event-editor__vertical-option-mark{background:#40a9ff}.event-editor__color-input-wrap{box-sizing:border-box;display:flex;width:252px;height:32px;align-items:center;gap:8px;padding:6px 6px 6px 12px;border:1px solid #b7c8db;border-radius:4px;background:#fff}.event-editor__color-input-wrap:focus-within{border-color:#6aa9df;box-shadow:0 0 0 2px #6aa9df29}.event-editor__color-input{min-width:0;flex:1 1 auto;padding:0;border:0;background:transparent;color:#181818;font-family:Noto Sans,sans-serif;font-size:14px;font-weight:400;line-height:20px;outline:none}.event-editor__color-swatch-wrap{position:relative;width:20px;height:20px;flex:0 0 auto}.event-editor__color-swatch{display:block;width:20px;height:20px;border-radius:2px}.event-editor__color-native{position:absolute;inset:0;width:20px;height:20px;padding:0;border:0;opacity:0;cursor:pointer}.event-editor__time-range{display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr);gap:8px;align-items:end}.event-editor__time-group{display:flex;min-width:0;flex-direction:column;gap:4px;font-size:12px;color:#6d7782}.event-editor__range-separator{padding-bottom:8px;color:#6d7782}.event-editor__time-input{width:100%;height:32px;box-sizing:border-box;border:1px solid #d8e0e8;border-radius:8px;padding:0 10px;font:inherit;color:#181818}.event-editor__time-input:focus{border-color:#6aa9df;outline:none;box-shadow:0 0 0 2px #6aa9df29}.event-editor__actions{display:flex;flex-direction:column}.event-editor__action-btn{display:flex;width:100%;height:36px;align-items:center;gap:8px;padding:0;border:0;background:transparent;color:#5d5d5d;font-family:Noto Sans,sans-serif;font-size:14px;font-weight:400;line-height:20px;text-align:left}.event-editor__action-btn:not(:disabled){cursor:pointer}.event-editor__action-btn:focus-visible{outline:2px solid #40a9ff;outline-offset:2px}.event-editor__action-btn:disabled{cursor:default}.event-editor__action-btn--delete{margin-top:16px}.event-editor__action-icon{width:20px;height:20px;flex:0 0 auto}.signal-viewer{display:flex;align-items:stretch;width:100%;min-width:0}.signal-viewer__charts-layout{flex:1 1 auto;min-width:0;display:flex;flex-direction:column}.signal-channel-selector{width:100%;font-family:Noto Sans,sans-serif}.signal-channel-selector__section-title{font-size:14px;font-weight:600;color:#000000d9;margin-bottom:12px}.signal-channel-selector__signals-list{max-height:200px;overflow:auto;margin-bottom:20px}.signal-channel-selector__signal-label{display:flex;align-items:center;gap:8px;padding:6px 0;cursor:pointer;font-size:14px;color:#000000d9}.signal-channel-selector__checkbox{display:flex;width:20px;height:20px;flex-shrink:0;border-radius:2px;border:1px solid #ccd7e1;background:#fff;padding:2px;cursor:pointer;gap:8px;align-items:center;font-weight:400;line-height:20px;color:#181818}.signal-channel-selector-suggestions-container{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:24px}.signal-channel-selector-suggestions-container__btn{padding:6px 12px;background-color:#e3f2fd;color:#349bd5;border:none;border-radius:4px;cursor:pointer;font-size:14px;font-weight:500;transition:background-color .2s ease;display:flex;justify-content:center;align-items:center;gap:8px}.signal-channel-selector-suggestions-container__btn:hover{background-color:#bbdefb}.signal-channel-selector__footer{display:flex;justify-content:flex-end;gap:12px;padding-top:16px}.signal-channel-selector__cancel-btn{display:flex;height:40px;padding:8px 16px;background-color:transparent;justify-content:center;align-items:center;gap:8px;border:1px solid #349bd5;color:#349bd5;line-height:20px;border-radius:4px;cursor:pointer;font-size:14px;font-weight:500}.signal-channel-selector__create-btn{display:flex;padding:10px 16px;align-items:center;justify-content:center;background-color:#349bd5;color:#fff;text-align:center;border:none;border-radius:4px;gap:4px;cursor:pointer;font-size:14px;font-weight:600;line-height:20px}.signal-channel-selector__create-btn:disabled{background-color:#ccc;cursor:not-allowed}.combo-box{position:relative;width:100%;font-family:Noto Sans,sans-serif}.combo-box__trigger{font-family:inherit;width:100%;min-height:40px;padding:0 40px 0 14px;border:1px solid #b8c4d6;border-radius:4px;background:#fff;display:flex;align-items:center;justify-content:space-between;text-align:left;cursor:pointer;box-sizing:border-box;outline:none}.combo-box__trigger:focus-visible{border-color:#4a90ff;box-shadow:0 0 0 3px #4a90ff26}.combo-box__value{color:#222;font-size:14px;font-weight:400;line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.combo-box__value--placeholder{color:#9b9b9b}.combo-box__arrow{position:absolute;right:14px;top:50%;transform:translateY(-50%) rotate(0);transition:transform .2s ease;display:inline-flex;align-items:center;justify-content:center;pointer-events:none}.combo-box--open .combo-box__arrow{transform:translateY(-50%) rotate(180deg)}.combo-box__dropdown{position:absolute;top:calc(100% + 8px);left:0;right:0;background:#fff;border-radius:10px;overflow:hidden;box-shadow:0 8px 24px #1224401f;z-index:1000;max-height:280px;overflow-y:auto}.combo-box__option{width:100%;min-height:40px;padding:0 14px;border:none;background:#fff;color:#222;display:flex;align-items:center;text-align:left;cursor:pointer;font-family:inherit;font-size:14px;font-weight:400;line-height:20px;box-sizing:border-box}.combo-box__option--highlighted{background:#f5faff}.combo-box__option--selected,.combo-box__option--selected.combo-box__option--highlighted{background:#e6f7ff}.combo-box--disabled .combo-box__trigger{background:#f5f5f5;border-color:#d9d9d9;cursor:not-allowed}.combo-box--disabled .combo-box__value{color:#a3a3a3}.combo-box__dropdown::-webkit-scrollbar{width:8px}.combo-box__dropdown::-webkit-scrollbar-track{background:transparent}.combo-box__dropdown::-webkit-scrollbar-thumb{background:#00000024;border-radius:999px}.combo-box--open .combo-box__trigger{border-color:#69c0ff}')),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import * as Yt from "react";
import Ql, { useMemo as ni, useEffect as mi, useState as ze, createContext as rv, useContext as nv, useRef as Ei, useLayoutEffect as by, useCallback as Fi, useImperativeHandle as Ey } from "react";
import { usePrepareTherapyData as ov } from "@lmt/signal-viewer-processor";
import "react-dom";
import av from "lottie-react";
function lv(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Mh = { exports: {} }, sl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c0;
function hv() {
  if (c0) return sl;
  c0 = 1;
  var r = Ql, t = Symbol.for("react.element"), e = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, s = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function n(a, l, h) {
    var u, c = {}, d = null, f = null;
    h !== void 0 && (d = "" + h), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (f = l.ref);
    for (u in l) i.call(l, u) && !o.hasOwnProperty(u) && (c[u] = l[u]);
    if (a && a.defaultProps) for (u in l = a.defaultProps, l) c[u] === void 0 && (c[u] = l[u]);
    return { $$typeof: t, type: a, key: d, ref: f, props: c, _owner: s.current };
  }
  return sl.Fragment = e, sl.jsx = n, sl.jsxs = n, sl;
}
var rl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d0;
function uv() {
  return d0 || (d0 = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = Ql, t = Symbol.for("react.element"), e = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), n = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), c = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function y(J) {
      if (J === null || typeof J != "object")
        return null;
      var pt = p && J[p] || J[g];
      return typeof pt == "function" ? pt : null;
    }
    var m = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function A(J) {
      {
        for (var pt = arguments.length, St = new Array(pt > 1 ? pt - 1 : 0), Ft = 1; Ft < pt; Ft++)
          St[Ft - 1] = arguments[Ft];
        v("error", J, St);
      }
    }
    function v(J, pt, St) {
      {
        var Ft = m.ReactDebugCurrentFrame, Qt = Ft.getStackAddendum();
        Qt !== "" && (pt += "%s", St = St.concat([Qt]));
        var Se = St.map(function(ce) {
          return String(ce);
        });
        Se.unshift("Warning: " + pt), Function.prototype.apply.call(console[J], console, Se);
      }
    }
    var b = !1, w = !1, k = !1, R = !1, L = !1, x;
    x = Symbol.for("react.module.reference");
    function M(J) {
      return !!(typeof J == "string" || typeof J == "function" || J === i || J === o || L || J === s || J === h || J === u || R || J === f || b || w || k || typeof J == "object" && J !== null && (J.$$typeof === d || J.$$typeof === c || J.$$typeof === n || J.$$typeof === a || J.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      J.$$typeof === x || J.getModuleId !== void 0));
    }
    function C(J, pt, St) {
      var Ft = J.displayName;
      if (Ft)
        return Ft;
      var Qt = pt.displayName || pt.name || "";
      return Qt !== "" ? St + "(" + Qt + ")" : St;
    }
    function S(J) {
      return J.displayName || "Context";
    }
    function E(J) {
      if (J == null)
        return null;
      if (typeof J.tag == "number" && A("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof J == "function")
        return J.displayName || J.name || null;
      if (typeof J == "string")
        return J;
      switch (J) {
        case i:
          return "Fragment";
        case e:
          return "Portal";
        case o:
          return "Profiler";
        case s:
          return "StrictMode";
        case h:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof J == "object")
        switch (J.$$typeof) {
          case a:
            var pt = J;
            return S(pt) + ".Consumer";
          case n:
            var St = J;
            return S(St._context) + ".Provider";
          case l:
            return C(J, J.render, "ForwardRef");
          case c:
            var Ft = J.displayName || null;
            return Ft !== null ? Ft : E(J.type) || "Memo";
          case d: {
            var Qt = J, Se = Qt._payload, ce = Qt._init;
            try {
              return E(ce(Se));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var T = Object.assign, I = 0, F, D, P, V, _, O, B;
    function z() {
    }
    z.__reactDisabledLog = !0;
    function W() {
      {
        if (I === 0) {
          F = console.log, D = console.info, P = console.warn, V = console.error, _ = console.group, O = console.groupCollapsed, B = console.groupEnd;
          var J = {
            configurable: !0,
            enumerable: !0,
            value: z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: J,
            log: J,
            warn: J,
            error: J,
            group: J,
            groupCollapsed: J,
            groupEnd: J
          });
        }
        I++;
      }
    }
    function G() {
      {
        if (I--, I === 0) {
          var J = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: T({}, J, {
              value: F
            }),
            info: T({}, J, {
              value: D
            }),
            warn: T({}, J, {
              value: P
            }),
            error: T({}, J, {
              value: V
            }),
            group: T({}, J, {
              value: _
            }),
            groupCollapsed: T({}, J, {
              value: O
            }),
            groupEnd: T({}, J, {
              value: B
            })
          });
        }
        I < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Y = m.ReactCurrentDispatcher, U;
    function $(J, pt, St) {
      {
        if (U === void 0)
          try {
            throw Error();
          } catch (Qt) {
            var Ft = Qt.stack.trim().match(/\n( *(at )?)/);
            U = Ft && Ft[1] || "";
          }
        return `
` + U + J;
      }
    }
    var Z = !1, q;
    {
      var Q = typeof WeakMap == "function" ? WeakMap : Map;
      q = new Q();
    }
    function nt(J, pt) {
      if (!J || Z)
        return "";
      {
        var St = q.get(J);
        if (St !== void 0)
          return St;
      }
      var Ft;
      Z = !0;
      var Qt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Se;
      Se = Y.current, Y.current = null, W();
      try {
        if (pt) {
          var ce = function() {
            throw Error();
          };
          if (Object.defineProperty(ce.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ce, []);
            } catch (Ni) {
              Ft = Ni;
            }
            Reflect.construct(J, [], ce);
          } else {
            try {
              ce.call();
            } catch (Ni) {
              Ft = Ni;
            }
            J.call(ce.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ni) {
            Ft = Ni;
          }
          J();
        }
      } catch (Ni) {
        if (Ni && Ft && typeof Ni.stack == "string") {
          for (var se = Ni.stack.split(`
`), Si = Ft.stack.split(`
`), Le = se.length - 1, We = Si.length - 1; Le >= 1 && We >= 0 && se[Le] !== Si[We]; )
            We--;
          for (; Le >= 1 && We >= 0; Le--, We--)
            if (se[Le] !== Si[We]) {
              if (Le !== 1 || We !== 1)
                do
                  if (Le--, We--, We < 0 || se[Le] !== Si[We]) {
                    var gi = `
` + se[Le].replace(" at new ", " at ");
                    return J.displayName && gi.includes("<anonymous>") && (gi = gi.replace("<anonymous>", J.displayName)), typeof J == "function" && q.set(J, gi), gi;
                  }
                while (Le >= 1 && We >= 0);
              break;
            }
        }
      } finally {
        Z = !1, Y.current = Se, G(), Error.prepareStackTrace = Qt;
      }
      var Di = J ? J.displayName || J.name : "", ns = Di ? $(Di) : "";
      return typeof J == "function" && q.set(J, ns), ns;
    }
    function et(J, pt, St) {
      return nt(J, !1);
    }
    function it(J) {
      var pt = J.prototype;
      return !!(pt && pt.isReactComponent);
    }
    function rt(J, pt, St) {
      if (J == null)
        return "";
      if (typeof J == "function")
        return nt(J, it(J));
      if (typeof J == "string")
        return $(J);
      switch (J) {
        case h:
          return $("Suspense");
        case u:
          return $("SuspenseList");
      }
      if (typeof J == "object")
        switch (J.$$typeof) {
          case l:
            return et(J.render);
          case c:
            return rt(J.type, pt, St);
          case d: {
            var Ft = J, Qt = Ft._payload, Se = Ft._init;
            try {
              return rt(Se(Qt), pt, St);
            } catch {
            }
          }
        }
      return "";
    }
    var tt = Object.prototype.hasOwnProperty, at = {}, ut = m.ReactDebugCurrentFrame;
    function ht(J) {
      if (J) {
        var pt = J._owner, St = rt(J.type, J._source, pt ? pt.type : null);
        ut.setExtraStackFrame(St);
      } else
        ut.setExtraStackFrame(null);
    }
    function st(J, pt, St, Ft, Qt) {
      {
        var Se = Function.call.bind(tt);
        for (var ce in J)
          if (Se(J, ce)) {
            var se = void 0;
            try {
              if (typeof J[ce] != "function") {
                var Si = Error((Ft || "React class") + ": " + St + " type `" + ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof J[ce] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Si.name = "Invariant Violation", Si;
              }
              se = J[ce](pt, ce, Ft, St, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Le) {
              se = Le;
            }
            se && !(se instanceof Error) && (ht(Qt), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ft || "React class", St, ce, typeof se), ht(null)), se instanceof Error && !(se.message in at) && (at[se.message] = !0, ht(Qt), A("Failed %s type: %s", St, se.message), ht(null));
          }
      }
    }
    var bt = Array.isArray;
    function ct(J) {
      return bt(J);
    }
    function Mt(J) {
      {
        var pt = typeof Symbol == "function" && Symbol.toStringTag, St = pt && J[Symbol.toStringTag] || J.constructor.name || "Object";
        return St;
      }
    }
    function vt(J) {
      try {
        return mt(J), !1;
      } catch {
        return !0;
      }
    }
    function mt(J) {
      return "" + J;
    }
    function Xt(J) {
      if (vt(J))
        return A("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Mt(J)), mt(J);
    }
    var Rt = m.ReactCurrentOwner, Dt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Kt, _t;
    function Ut(J) {
      if (tt.call(J, "ref")) {
        var pt = Object.getOwnPropertyDescriptor(J, "ref").get;
        if (pt && pt.isReactWarning)
          return !1;
      }
      return J.ref !== void 0;
    }
    function te(J) {
      if (tt.call(J, "key")) {
        var pt = Object.getOwnPropertyDescriptor(J, "key").get;
        if (pt && pt.isReactWarning)
          return !1;
      }
      return J.key !== void 0;
    }
    function ye(J, pt) {
      typeof J.ref == "string" && Rt.current;
    }
    function ne(J, pt) {
      {
        var St = function() {
          Kt || (Kt = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pt));
        };
        St.isReactWarning = !0, Object.defineProperty(J, "key", {
          get: St,
          configurable: !0
        });
      }
    }
    function ti(J, pt) {
      {
        var St = function() {
          _t || (_t = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pt));
        };
        St.isReactWarning = !0, Object.defineProperty(J, "ref", {
          get: St,
          configurable: !0
        });
      }
    }
    var fe = function(J, pt, St, Ft, Qt, Se, ce) {
      var se = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: J,
        key: pt,
        ref: St,
        props: ce,
        // Record the component responsible for creating this element.
        _owner: Se
      };
      return se._store = {}, Object.defineProperty(se._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(se, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ft
      }), Object.defineProperty(se, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Qt
      }), Object.freeze && (Object.freeze(se.props), Object.freeze(se)), se;
    };
    function ve(J, pt, St, Ft, Qt) {
      {
        var Se, ce = {}, se = null, Si = null;
        St !== void 0 && (Xt(St), se = "" + St), te(pt) && (Xt(pt.key), se = "" + pt.key), Ut(pt) && (Si = pt.ref, ye(pt, Qt));
        for (Se in pt)
          tt.call(pt, Se) && !Dt.hasOwnProperty(Se) && (ce[Se] = pt[Se]);
        if (J && J.defaultProps) {
          var Le = J.defaultProps;
          for (Se in Le)
            ce[Se] === void 0 && (ce[Se] = Le[Se]);
        }
        if (se || Si) {
          var We = typeof J == "function" ? J.displayName || J.name || "Unknown" : J;
          se && ne(ce, We), Si && ti(ce, We);
        }
        return fe(J, se, Si, Qt, Ft, Rt.current, ce);
      }
    }
    var ci = m.ReactCurrentOwner, At = m.ReactDebugCurrentFrame;
    function yt(J) {
      if (J) {
        var pt = J._owner, St = rt(J.type, J._source, pt ? pt.type : null);
        At.setExtraStackFrame(St);
      } else
        At.setExtraStackFrame(null);
    }
    var ft;
    ft = !1;
    function Tt(J) {
      return typeof J == "object" && J !== null && J.$$typeof === t;
    }
    function oe() {
      {
        if (ci.current) {
          var J = E(ci.current.type);
          if (J)
            return `

Check the render method of \`` + J + "`.";
        }
        return "";
      }
    }
    function vi(J) {
      return "";
    }
    var Te = {};
    function Ze(J) {
      {
        var pt = oe();
        if (!pt) {
          var St = typeof J == "string" ? J : J.displayName || J.name;
          St && (pt = `

Check the top-level render call using <` + St + ">.");
        }
        return pt;
      }
    }
    function ps(J, pt) {
      {
        if (!J._store || J._store.validated || J.key != null)
          return;
        J._store.validated = !0;
        var St = Ze(pt);
        if (Te[St])
          return;
        Te[St] = !0;
        var Ft = "";
        J && J._owner && J._owner !== ci.current && (Ft = " It was passed a child from " + E(J._owner.type) + "."), yt(J), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', St, Ft), yt(null);
      }
    }
    function Fe(J, pt) {
      {
        if (typeof J != "object")
          return;
        if (ct(J))
          for (var St = 0; St < J.length; St++) {
            var Ft = J[St];
            Tt(Ft) && ps(Ft, pt);
          }
        else if (Tt(J))
          J._store && (J._store.validated = !0);
        else if (J) {
          var Qt = y(J);
          if (typeof Qt == "function" && Qt !== J.entries)
            for (var Se = Qt.call(J), ce; !(ce = Se.next()).done; )
              Tt(ce.value) && ps(ce.value, pt);
        }
      }
    }
    function qe(J) {
      {
        var pt = J.type;
        if (pt == null || typeof pt == "string")
          return;
        var St;
        if (typeof pt == "function")
          St = pt.propTypes;
        else if (typeof pt == "object" && (pt.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        pt.$$typeof === c))
          St = pt.propTypes;
        else
          return;
        if (St) {
          var Ft = E(pt);
          st(St, J.props, "prop", Ft, J);
        } else if (pt.PropTypes !== void 0 && !ft) {
          ft = !0;
          var Qt = E(pt);
          A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Qt || "Unknown");
        }
        typeof pt.getDefaultProps == "function" && !pt.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function rs(J) {
      {
        for (var pt = Object.keys(J.props), St = 0; St < pt.length; St++) {
          var Ft = pt[St];
          if (Ft !== "children" && Ft !== "key") {
            yt(J), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ft), yt(null);
            break;
          }
        }
        J.ref !== null && (yt(J), A("Invalid attribute `ref` supplied to `React.Fragment`."), yt(null));
      }
    }
    function ii(J, pt, St, Ft, Qt, Se) {
      {
        var ce = M(J);
        if (!ce) {
          var se = "";
          (J === void 0 || typeof J == "object" && J !== null && Object.keys(J).length === 0) && (se += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Si = vi();
          Si ? se += Si : se += oe();
          var Le;
          J === null ? Le = "null" : ct(J) ? Le = "array" : J !== void 0 && J.$$typeof === t ? (Le = "<" + (E(J.type) || "Unknown") + " />", se = " Did you accidentally export a JSX literal instead of a component?") : Le = typeof J, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Le, se);
        }
        var We = ve(J, pt, St, Qt, Se);
        if (We == null)
          return We;
        if (ce) {
          var gi = pt.children;
          if (gi !== void 0)
            if (Ft)
              if (ct(gi)) {
                for (var Di = 0; Di < gi.length; Di++)
                  Fe(gi[Di], J);
                Object.freeze && Object.freeze(gi);
              } else
                A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Fe(gi, J);
        }
        return J === i ? rs(We) : qe(We), We;
      }
    }
    function Ge(J, pt, St) {
      return ii(J, pt, St, !0);
    }
    function vn(J, pt, St) {
      return ii(J, pt, St, !1);
    }
    var Bt = vn, Wt = Ge;
    rl.Fragment = i, rl.jsx = Bt, rl.jsxs = Wt;
  })()), rl;
}
var f0;
function cv() {
  return f0 || (f0 = 1, process.env.NODE_ENV === "production" ? Mh.exports = hv() : Mh.exports = uv()), Mh.exports;
}
var X = cv();
/**
 * uuidv7: A JavaScript implementation of UUID version 7
 *
 * Copyright 2021-2025 LiosK
 *
 * @license Apache-2.0
 * @packageDocumentation
 */
const Ch = "0123456789abcdef";
class So {
  /** @param bytes - The 16-byte byte array representation. */
  constructor(t) {
    this.bytes = t;
  }
  /**
   * Creates an object from the internal representation, a 16-byte byte array
   * containing the binary UUID representation in the big-endian byte order.
   *
   * This method does NOT shallow-copy the argument, and thus the created object
   * holds the reference to the underlying buffer.
   *
   * @throws TypeError if the length of the argument is not 16.
   */
  static ofInner(t) {
    if (t.length !== 16)
      throw new TypeError("not 128-bit length");
    return new So(t);
  }
  /**
   * Builds a byte array from UUIDv7 field values.
   *
   * @param unixTsMs - A 48-bit `unix_ts_ms` field value.
   * @param randA - A 12-bit `rand_a` field value.
   * @param randBHi - The higher 30 bits of 62-bit `rand_b` field value.
   * @param randBLo - The lower 32 bits of 62-bit `rand_b` field value.
   * @throws RangeError if any field value is out of the specified range.
   */
  static fromFieldsV7(t, e, i, s) {
    if (!Number.isInteger(t) || !Number.isInteger(e) || !Number.isInteger(i) || !Number.isInteger(s) || t < 0 || e < 0 || i < 0 || s < 0 || t > 281474976710655 || e > 4095 || i > 1073741823 || s > 4294967295)
      throw new RangeError("invalid field value");
    const o = new Uint8Array(16);
    return o[0] = t / 2 ** 40, o[1] = t / 2 ** 32, o[2] = t / 2 ** 24, o[3] = t / 2 ** 16, o[4] = t / 2 ** 8, o[5] = t, o[6] = 112 | e >>> 8, o[7] = e, o[8] = 128 | i >>> 24, o[9] = i >>> 16, o[10] = i >>> 8, o[11] = i, o[12] = s >>> 24, o[13] = s >>> 16, o[14] = s >>> 8, o[15] = s, new So(o);
  }
  /**
   * Builds a byte array from a string representation.
   *
   * This method accepts the following formats:
   *
   * - 32-digit hexadecimal format without hyphens: `0189dcd553117d408db09496a2eef37b`
   * - 8-4-4-4-12 hyphenated format: `0189dcd5-5311-7d40-8db0-9496a2eef37b`
   * - Hyphenated format with surrounding braces: `{0189dcd5-5311-7d40-8db0-9496a2eef37b}`
   * - RFC 9562 URN format: `urn:uuid:0189dcd5-5311-7d40-8db0-9496a2eef37b`
   *
   * Leading and trailing whitespaces represents an error.
   *
   * @throws SyntaxError if the argument could not parse as a valid UUID string.
   */
  static parse(t) {
    var e, i, s, o;
    let n;
    switch (t.length) {
      case 32:
        n = (e = /^[0-9a-f]{32}$/i.exec(t)) === null || e === void 0 ? void 0 : e[0];
        break;
      case 36:
        n = (i = /^([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})$/i.exec(t)) === null || i === void 0 ? void 0 : i.slice(1, 6).join("");
        break;
      case 38:
        n = (s = /^\{([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})\}$/i.exec(t)) === null || s === void 0 ? void 0 : s.slice(1, 6).join("");
        break;
      case 45:
        n = (o = /^urn:uuid:([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})$/i.exec(t)) === null || o === void 0 ? void 0 : o.slice(1, 6).join("");
        break;
    }
    if (n) {
      const a = new Uint8Array(16);
      for (let l = 0; l < 16; l += 4) {
        const h = parseInt(n.substring(2 * l, 2 * l + 8), 16);
        a[l + 0] = h >>> 24, a[l + 1] = h >>> 16, a[l + 2] = h >>> 8, a[l + 3] = h;
      }
      return new So(a);
    } else
      throw new SyntaxError("could not parse UUID string");
  }
  /**
   * @returns The 8-4-4-4-12 canonical hexadecimal string representation
   * (`0189dcd5-5311-7d40-8db0-9496a2eef37b`).
   */
  toString() {
    let t = "";
    for (let e = 0; e < this.bytes.length; e++)
      t += Ch.charAt(this.bytes[e] >>> 4), t += Ch.charAt(this.bytes[e] & 15), (e === 3 || e === 5 || e === 7 || e === 9) && (t += "-");
    return t;
  }
  /**
   * @returns The 32-digit hexadecimal representation without hyphens
   * (`0189dcd553117d408db09496a2eef37b`).
   */
  toHex() {
    let t = "";
    for (let e = 0; e < this.bytes.length; e++)
      t += Ch.charAt(this.bytes[e] >>> 4), t += Ch.charAt(this.bytes[e] & 15);
    return t;
  }
  /** @returns The 8-4-4-4-12 canonical hexadecimal string representation. */
  toJSON() {
    return this.toString();
  }
  /**
   * Reports the variant field value of the UUID or, if appropriate, "NIL" or
   * "MAX".
   *
   * For convenience, this method reports "NIL" or "MAX" if `this` represents
   * the Nil or Max UUID, although the Nil and Max UUIDs are technically
   * subsumed under the variants `0b0` and `0b111`, respectively.
   */
  getVariant() {
    const t = this.bytes[8] >>> 4;
    if (t < 0)
      throw new Error("unreachable");
    if (t <= 7)
      return this.bytes.every((e) => e === 0) ? "NIL" : "VAR_0";
    if (t <= 11)
      return "VAR_10";
    if (t <= 13)
      return "VAR_110";
    if (t <= 15)
      return this.bytes.every((e) => e === 255) ? "MAX" : "VAR_RESERVED";
    throw new Error("unreachable");
  }
  /**
   * Returns the version field value of the UUID or `undefined` if the UUID does
   * not have the variant field value of `0b10`.
   */
  getVersion() {
    return this.getVariant() === "VAR_10" ? this.bytes[6] >>> 4 : void 0;
  }
  /** Creates an object from `this`. */
  clone() {
    return new So(this.bytes.slice(0));
  }
  /** Returns true if `this` is equivalent to `other`. */
  equals(t) {
    return this.compareTo(t) === 0;
  }
  /**
   * Returns a negative integer, zero, or positive integer if `this` is less
   * than, equal to, or greater than `other`, respectively.
   */
  compareTo(t) {
    for (let e = 0; e < 16; e++) {
      const i = this.bytes[e] - t.bytes[e];
      if (i !== 0)
        return Math.sign(i);
    }
    return 0;
  }
}
class dv {
  /**
   * Creates a generator object with the default random number generator, or
   * with the specified one if passed as an argument. The specified random
   * number generator should be cryptographically strong and securely seeded.
   */
  constructor(t) {
    this.timestamp_biased = 0, this.counter = 0, this.random = t ?? fv();
  }
  /**
   * Generates a new UUIDv7 object from the current timestamp, or resets the
   * generator upon significant timestamp rollback.
   *
   * This method returns a monotonically increasing UUID by reusing the previous
   * timestamp even if the up-to-date timestamp is smaller than the immediately
   * preceding UUID's. However, when such a clock rollback is considered
   * significant (i.e., by more than ten seconds), this method resets the
   * generator and returns a new UUID based on the given timestamp, breaking the
   * increasing order of UUIDs.
   *
   * See {@link generateOrAbort} for the other mode of generation and
   * {@link generateOrResetCore} for the low-level primitive.
   */
  generate() {
    return this.generateOrResetCore(Date.now(), 1e4);
  }
  /**
   * Generates a new UUIDv7 object from the current timestamp, or returns
   * `undefined` upon significant timestamp rollback.
   *
   * This method returns a monotonically increasing UUID by reusing the previous
   * timestamp even if the up-to-date timestamp is smaller than the immediately
   * preceding UUID's. However, when such a clock rollback is considered
   * significant (i.e., by more than ten seconds), this method aborts and
   * returns `undefined` immediately.
   *
   * See {@link generate} for the other mode of generation and
   * {@link generateOrAbortCore} for the low-level primitive.
   */
  generateOrAbort() {
    return this.generateOrAbortCore(Date.now(), 1e4);
  }
  /**
   * Generates a new UUIDv7 object from the `unixTsMs` passed, or resets the
   * generator upon significant timestamp rollback.
   *
   * This method is equivalent to {@link generate} except that it takes a custom
   * timestamp and clock rollback allowance.
   *
   * @param rollbackAllowance - The amount of `unixTsMs` rollback that is
   * considered significant. A suggested value is `10_000` (milliseconds).
   * @throws RangeError if `unixTsMs` is not a 48-bit unsigned integer.
   */
  generateOrResetCore(t, e) {
    let i = this.generateOrAbortCore(t, e);
    return i === void 0 && (this.timestamp_biased = 0, i = this.generateOrAbortCore(t, e)), i;
  }
  /**
   * Generates a new UUIDv7 object from the `unixTsMs` passed, or returns
   * `undefined` upon significant timestamp rollback.
   *
   * This method is equivalent to {@link generateOrAbort} except that it takes a
   * custom timestamp and clock rollback allowance.
   *
   * @param rollbackAllowance - The amount of `unixTsMs` rollback that is
   * considered significant. A suggested value is `10_000` (milliseconds).
   * @throws RangeError if `unixTsMs` is not a 48-bit unsigned integer.
   */
  generateOrAbortCore(t, e) {
    if (!Number.isInteger(t) || t < 0 || t > 281474976710655)
      throw new RangeError("`unixTsMs` must be a 48-bit unsigned integer");
    if (e < 0 || e > 281474976710655)
      throw new RangeError("`rollbackAllowance` out of reasonable range");
    if (t++, t > this.timestamp_biased)
      this.timestamp_biased = t, this.resetCounter();
    else if (t + e >= this.timestamp_biased)
      this.counter++, this.counter > 4398046511103 && (this.timestamp_biased++, this.resetCounter());
    else
      return;
    return So.fromFieldsV7(this.timestamp_biased - 1, Math.trunc(this.counter / 2 ** 30), this.counter & 2 ** 30 - 1, this.random.nextUint32());
  }
  /** Initializes the counter at a 42-bit random integer. */
  resetCounter() {
    this.counter = this.random.nextUint32() * 1024 + (this.random.nextUint32() & 1023);
  }
  /**
   * Generates a new UUIDv4 object utilizing the random number generator inside.
   *
   * @internal
   */
  generateV4() {
    const t = new Uint8Array(Uint32Array.of(this.random.nextUint32(), this.random.nextUint32(), this.random.nextUint32(), this.random.nextUint32()).buffer);
    return t[6] = 64 | t[6] >>> 4, t[8] = 128 | t[8] >>> 2, So.ofInner(t);
  }
}
const fv = () => {
  if (typeof crypto < "u" && typeof crypto.getRandomValues < "u")
    return new gv();
  if (typeof UUIDV7_DENY_WEAK_RNG < "u" && UUIDV7_DENY_WEAK_RNG)
    throw new Error("no cryptographically strong RNG available");
  return {
    nextUint32: () => Math.trunc(Math.random() * 65536) * 65536 + Math.trunc(Math.random() * 65536)
  };
};
class gv {
  constructor() {
    this.buffer = new Uint32Array(8), this.cursor = 65535;
  }
  nextUint32() {
    return this.cursor >= this.buffer.length && (crypto.getRandomValues(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
  }
}
let g0;
const id = () => pv().toString(), pv = () => (g0 || (g0 = new dv())).generate();
var Ct = /* @__PURE__ */ ((r) => (r[r.EventOnly = 0] = "EventOnly", r[r.SignalOnly = 1] = "SignalOnly", r[r.SignalsWithEvents = 2] = "SignalsWithEvents", r))(Ct || {});
const yv = (r, t) => {
  const e = r.find((i) => i.id === t);
  if (!e)
    throw new Error(`No configuration found for channel id ${t}`);
  return e;
};
function mv(r, t, e, i) {
  const s = t.signals, o = t.events, n = t.generation, a = t.therapySettings, l = ni(
    () => ({
      kind: "raw",
      edfFiles: s,
      generation: n
    }),
    [s, n]
  ), h = ni(
    () => r.map((p) => ({
      id: p.id,
      signalTypes: p.signals.map((g) => g.type)
    })),
    [r]
  ), u = ov(
    l,
    h,
    i
  ), c = ni(
    () => u.channels.map((p) => {
      const g = yv(
        r,
        p.id
      ), y = (A) => {
        const v = g.signals.find(
          (b) => b.type === A
        );
        if (!v)
          throw new Error(
            `No signal config found for signal type ${A} in channel ${p.id}`
          );
        return v.config;
      }, m = (A) => {
        const v = g.events.find(
          (b) => b.type === A
        );
        if (!v)
          throw new Error(
            `No event config found for event type ${A} in channel ${p.id}`
          );
        return v.config;
      };
      return {
        id: p.id,
        configuration: g.configuration,
        signals: p.signals.map((A) => ({
          type: A.type,
          data: {
            type: A.type,
            physicalDimension: A.physicalDimension,
            samplingRate: A.samplingRate,
            startMs: A.startMs,
            dtMs: A.dtMs,
            samples: A.samples
          },
          config: y(A.type)
        })),
        events: g.events.map((A) => ({
          type: A.type,
          data: o.filter(
            (v) => v.eventType === A.type
          ),
          config: m(A.type)
        }))
      };
    }),
    [u.channels, r, o]
  );
  mi(() => {
    e && u.edfInfo.length > 0 && e(u.edfInfo);
  }, [JSON.stringify(u.edfInfo)]);
  const d = ni(
    () => a ? [a] : [],
    [a]
  ), f = ni(
    () => t.limits ?? [],
    [t.limits]
  );
  return {
    channels: c,
    startTimeMs: u.edfInfo[0]?.startMs ?? null,
    parseErrors: u.parseErrors,
    therapySettings: d,
    limits: f
  };
}
const xv = "https://signal-viewer.demo-prismacloud.com", Hd = rv(void 0), vv = (r) => `${((r ?? "").trim() || xv).replace(/\/$/, "")}/license-key`, JT = ({ clientKey: r, apiKey: t, backendUrl: e, licenseInformation: i, children: s }) => {
  const [o, n] = ze({
    license: "",
    loading: !0,
    error: null
  });
  mi(() => {
    let l = !1;
    return n({ license: "", loading: !0, error: null }), (async () => {
      try {
        const u = await fetch(vv(e), {
          headers: { ApiKey: t, ClientKey: r }
        });
        if (!u.ok)
          throw new Error(`HTTP ${u.status}`);
        const c = (await u.text()).trim();
        if (!c)
          throw new Error("Empty license received");
        l || n({ license: c, loading: !1, error: null });
      } catch (u) {
        l || n({
          license: "",
          loading: !1,
          error: u instanceof Error ? u.message : "Failed to load license"
        });
      }
    })(), () => {
      l = !0;
    };
  }, [r, t, e]);
  const a = ni(
    () => ({ ...o, licenseInformation: i }),
    [o, i]
  );
  return /* @__PURE__ */ X.jsx(Hd.Provider, { value: a, children: s });
}, QT = ({ license: r, licenseInformation: t, children: e }) => {
  const i = ni(
    () => ({ license: r, licenseInformation: t, loading: !1, error: null }),
    [r, t]
  );
  return /* @__PURE__ */ X.jsx(Hd.Provider, { value: i, children: e });
}, Sv = () => {
  const r = nv(Hd);
  if (r === void 0)
    throw new Error(
      "SignalViewer must be wrapped in a license provider (<SignalViewerManagedLicenseProvider> or <SignalViewerDirectLicenseProvider>)."
    );
  return r;
}, Av = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M10.0001 9.00003C11.6569 9.00003 13.0001 10.3432 13.0001 12C13.0001 13.6569 11.6569 15 10.0001 15C8.34321 15 7.00006 13.6569 7.00006 12C7.00006 10.3432 8.34321 9.00003 10.0001 9.00003ZM10.0001 10C8.89549 10 8.00006 10.8955 8.00006 12C8.00006 13.1046 8.89549 14 10.0001 14C11.1046 14 12.0001 13.1046 12.0001 12C12.0001 10.8955 11.1046 10 10.0001 10ZM10.0001 5.00003C13.8661 5.00003 17.0001 8.13404 17.0001 12H16.0001C16.0001 8.68632 13.3138 6.00003 10.0001 6.00003C6.68635 6.00003 4.00006 8.68632 4.00006 12H3.00006C3.00006 8.13404 6.13407 5.00003 10.0001 5.00003Z",
        fill: "#8B8B8B"
      }
    )
  }
), bv = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M7.32471 13.4702C8.14898 13.8114 9.05288 14.0005 10.0005 14.0005C10.948 14.0004 11.8511 13.8105 12.6753 13.4692L13.8579 15.8335L14.7524 15.3862L13.5688 13.021C14.7069 12.345 15.6356 11.3562 16.2388 10.1724L18.5923 11.3081L19.0278 10.4077L16.6284 9.24951C16.868 8.54344 17.0004 7.7875 17.0005 7.00049H16.0005C16.0003 10.3139 13.3139 13.0003 10.0005 13.0005C6.6869 13.0005 4.00069 10.314 4.00049 7.00049H3.00049C3.00053 7.78749 3.13206 8.54345 3.37158 9.24951L0.978027 10.4058L1.41357 11.3062L3.76025 10.1724C4.36332 11.3562 5.29219 12.3459 6.43018 13.022L5.23682 15.4087L6.13135 15.856L7.32471 13.4702Z",
        fill: "#8B8B8B"
      }
    )
  }
), Ev = ({
  onClick: r,
  isHidden: t = !1
}) => /* @__PURE__ */ X.jsx(
  "button",
  {
    type: "button",
    onClick: r,
    className: "eye-button",
    "aria-label": t ? "Show channel" : "Hide channel",
    children: t ? /* @__PURE__ */ X.jsx(bv, {}) : /* @__PURE__ */ X.jsx(Av, {})
  }
), Mv = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M16 21C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22C15 21.4477 15.4477 21 16 21ZM20 21C20.5523 21 21 21.4477 21 22C21 22.5523 20.5523 23 20 23C19.4477 23 19 22.5523 19 22C19 21.4477 19.4477 21 20 21ZM16 17C16.5523 17 17 17.4477 17 18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17ZM20 17C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19C19.4477 19 19 18.5523 19 18C19 17.4477 19.4477 17 20 17ZM16 13C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13ZM20 13C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15C19.4477 15 19 14.5523 19 14C19 13.4477 19.4477 13 20 13Z",
        fill: "#A3A3A3"
      }
    )
  }
), Cv = ({
  title: r,
  channelId: t,
  isHidden: e = !1,
  heightPx: i,
  containerRef: s,
  onEyeButtonClick: o,
  onDragStart: n,
  onDragEnd: a,
  onResizeStart: l,
  onResizeHeight: h,
  onResizeEnd: u
}) => /* @__PURE__ */ X.jsxs(
  "div",
  {
    className: [
      "channel-title__container",
      e && "channel-title__container--hidden"
    ].filter(Boolean).join(" "),
    ref: s,
    style: {
      height: i !== void 0 ? `${i}px` : void 0,
      visibility: i !== void 0 ? void 0 : "hidden"
    },
    children: [
      /* @__PURE__ */ X.jsx(
        "div",
        {
          className: "channel-title__drag-handle",
          draggable: !0,
          onDragStart: (c) => {
            c.dataTransfer.effectAllowed = "move", c.dataTransfer.setData("text/plain", t), n();
          },
          onDragEnd: a,
          children: /* @__PURE__ */ X.jsx(Mv, {})
        }
      ),
      /* @__PURE__ */ X.jsx("span", { className: "channel-title__text", children: r }),
      /* @__PURE__ */ X.jsx("div", { className: "channel-title__controls", children: /* @__PURE__ */ X.jsx(Ev, { onClick: o, isHidden: e }) }),
      !e && /* @__PURE__ */ X.jsx(
        "div",
        {
          className: "channel-title__resize-handle",
          onMouseDown: (c) => {
            c.preventDefault(), l();
            const d = c.clientY, f = i ?? 80, p = (y) => {
              h(f + (y.clientY - d));
            };
            h(f);
            const g = () => {
              document.removeEventListener("mousemove", p), document.removeEventListener("mouseup", g), u();
            };
            document.addEventListener("mousemove", p), document.addEventListener("mouseup", g);
          }
        }
      )
    ]
  }
), Yn = (r) => r.centerYPx - r.heightPx / 2, Ou = (r) => r.centerYPx + r.heightPx / 2, My = (r, t) => !r || !t ? 0 : Math.max(0, Yn(t) - Ou(r)), wv = (r, t) => t === "above" ? r : r + 1, Tv = (r, t, e, i) => {
  const s = r.findIndex((a) => a.id === t), o = r.findIndex((a) => a.id === e);
  if (s === -1 || o === -1) return !1;
  const n = wv(o, i);
  return n === s || n === s + 1;
}, kv = {
  "none-selected": "No signals or events selected",
  "no-data": "No data for the selected signals and events"
}, Cy = (r) => {
  if (r.signals.length === 0 && r.events.length === 0)
    return "none-selected";
  if (r.signals.length === 0) return null;
  const t = r.signals.some(
    (i) => i.data && i.data.samples.length > 0 && i.data.dtMs > 0
  ), e = r.events.some(
    (i) => (i.data?.length ?? 0) > 0
  );
  return t || e ? null : "no-data";
}, Dv = (r, t, e) => {
  const i = [...r].sort((u, c) => {
    const d = t.get(u.id), f = t.get(c.id);
    return !d || !f ? 0 : d.centerYPx - f.centerYPx;
  }), s = i.length > 0 ? t.get(i[0].id) : void 0, o = s ? Yn(s) : 0, n = i.flatMap((u, c) => {
    if (c === i.length - 1) return [];
    const d = t.get(u.id), f = t.get(i[c + 1].id);
    return !d || !f ? [] : [
      {
        afterChannelId: u.id,
        topPx: Ou(d),
        heightPx: My(d, f)
      }
    ];
  }), a = i.flatMap((u) => {
    if (!e.has(u.id)) return [];
    const c = t.get(u.id);
    return c ? [
      {
        channelId: u.id,
        topPx: Yn(c),
        heightPx: c.heightPx
      }
    ] : [];
  }), l = i.flatMap(
    (u) => {
      if (e.has(u.id)) return [];
      const c = Cy(u);
      if (!c) return [];
      const d = t.get(u.id);
      return d ? [
        {
          channelId: u.id,
          topPx: Yn(d),
          heightPx: d.heightPx,
          text: kv[c]
        }
      ] : [];
    }
  ), h = new Map(
    n.map((u) => [u.afterChannelId, u])
  );
  return {
    channelsByPosition: i,
    paddingTop: o,
    gapBands: n,
    hiddenBands: a,
    placeholderBands: l,
    gapByAfterChannelId: h
  };
}, Fv = (r) => {
  const t = Ei(/* @__PURE__ */ new Map()), e = Ei(/* @__PURE__ */ new Map()), i = Ei(/* @__PURE__ */ new Map()), s = Ei(
    /* @__PURE__ */ new Map()
  ), o = (h, u, c) => {
    const d = t.current, f = d.get(h) ?? { wrapper: null, container: null };
    f[u] = c, !f.wrapper && !f.container ? d.delete(h) : d.set(h, f);
  }, n = (h, u) => {
    u ? e.current.set(h, u) : e.current.delete(h);
  }, a = (h, u) => {
    u ? i.current.set(h, u) : i.current.delete(h);
  }, l = (h, u) => {
    u ? s.current.set(h, u) : s.current.delete(h);
  };
  return by(() => {
    if (!r) return;
    r.registerTitles(t.current), r.registerGapBands(e.current), r.registerHiddenBands(i.current), r.registerPlaceholderBands(s.current);
    const h = r.getSnapshot();
    r.apply(
      h.positions,
      h.plotLeftPx,
      h.plotRightPx
    );
  }), { setTitleNode: o, setGapBand: n, setHiddenBand: a, setPlaceholderBand: l };
}, Lv = (r, t, e) => r - t < e / 2 ? "above" : "below", Pv = ({
  draggedChannelId: r,
  geometryByChannelId: t,
  channelsByPosition: e,
  gapByAfterChannelId: i
}) => {
  const s = Ei(null), o = Ei(null), n = (d, f, p) => {
    let g = o.current;
    if (!g || g.channelId !== f) {
      const m = d.currentTarget.getBoundingClientRect();
      g = { channelId: f, top: m.top, height: m.height }, o.current = g;
    }
    const y = p ?? g.height;
    return Lv(d.clientY, g.top, y);
  }, a = (d) => {
    const f = s.current;
    f && (f.style.top = `${d}px`, f.style.display = "block");
  }, l = () => {
    const d = s.current;
    d && (d.style.display = ""), o.current = null;
  }, h = (d, f) => {
    const p = e.findIndex(
      (m) => m.id === d
    );
    if (p === -1) return null;
    const g = f === "above" ? p : p + 1;
    if (g <= 0) {
      const m = t.get(e[0].id);
      return m ? Yn(m) : null;
    }
    if (g >= e.length) {
      const m = t.get(
        e[e.length - 1].id
      );
      return m ? Ou(m) : null;
    }
    const y = i.get(e[g - 1].id);
    return y ? y.topPx + y.heightPx / 2 : null;
  };
  return {
    dropIndicatorRef: s,
    onWrapperDragOver: (d, f, p) => {
      if (d.preventDefault(), !r) return;
      const g = h(
        f,
        n(d, f, p)
      );
      g === null ? l() : a(g);
    },
    resolveDropPosition: n,
    onColumnDragLeave: (d) => {
      d.currentTarget.contains(d.relatedTarget) || l();
    },
    clear: l
  };
}, pc = ({ className: r, topPx: t, heightPx: e, right: i, left: s, bandRef: o, children: n }) => /* @__PURE__ */ X.jsx(
  "div",
  {
    ref: o,
    className: r,
    style: { left: s, right: i, top: `${t}px`, height: `${e}px` },
    children: n
  }
), Rv = ({
  side: r,
  chartId: t,
  channels: e,
  hiddenChannelIds: i,
  draggedChannelId: s,
  geometryByChannelId: o,
  plotLeftPx: n,
  plotRightPx: a,
  layoutStore: l,
  onToggleVisibility: h,
  onDragStart: u,
  onDragEnd: c,
  onDropOnChannel: d,
  onChannelDelete: f,
  onResizeStart: p,
  onResizeHeight: g,
  onResizeEnd: y
}) => {
  const { setTitleNode: m, setGapBand: A, setHiddenBand: v, setPlaceholderBand: b } = Fv(l), w = new Set(i), k = n !== void 0 ? `${n}px` : 0, R = a !== void 0 ? `calc(100% - ${a}px)` : 0, {
    channelsByPosition: L,
    paddingTop: x,
    gapBands: M,
    hiddenBands: C,
    placeholderBands: S,
    gapByAfterChannelId: E
  } = Dv(e, o, w), T = Pv({
    draggedChannelId: s,
    geometryByChannelId: o,
    channelsByPosition: L,
    gapByAfterChannelId: E
  }), I = () => {
    T.clear(), c();
  };
  return /* @__PURE__ */ X.jsxs("div", { className: "chart-container__panel", children: [
    /* @__PURE__ */ X.jsx(
      "div",
      {
        className: "chart-container__titles-column",
        ref: (F) => l?.registerTitlesColumn(F),
        style: { paddingTop: `${x}px` },
        onDragLeave: T.onColumnDragLeave,
        children: L.map((F) => {
          const D = o.get(F.id), P = E.get(F.id)?.heightPx ?? 0;
          return (
            // The wrapper is the drop zone: its paddingBottom holds the gap to
            // the next channel, so the inter-channel space registers drag/drop
            // instead of being a dead margin.
            /* @__PURE__ */ X.jsx(
              "div",
              {
                ref: (V) => m(F.id, "wrapper", V),
                style: { paddingBottom: `${P}px` },
                onDragOver: (V) => T.onWrapperDragOver(V, F.id, D?.heightPx),
                onDragEnter: (V) => V.preventDefault(),
                onDrop: (V) => {
                  V.preventDefault(), d(
                    F.id,
                    T.resolveDropPosition(
                      V,
                      F.id,
                      D?.heightPx
                    )
                  );
                },
                children: /* @__PURE__ */ X.jsx(
                  Cv,
                  {
                    title: F.configuration.name,
                    channelId: F.id,
                    isHidden: w.has(F.id),
                    heightPx: D?.heightPx,
                    containerRef: (V) => m(F.id, "container", V),
                    onEyeButtonClick: () => h(F.id),
                    onDragStart: () => u(F.id),
                    onDragEnd: I,
                    onResizeStart: p,
                    onResizeHeight: (V) => g(F.id, V),
                    onResizeEnd: y
                  }
                )
              },
              `${r}-${F.id}`
            )
          );
        })
      }
    ),
    /* @__PURE__ */ X.jsxs("div", { className: "chart-container__chart-column", children: [
      M.map((F) => /* @__PURE__ */ X.jsx(
        pc,
        {
          className: "chart-container__channel-gap",
          topPx: F.topPx,
          heightPx: F.heightPx,
          left: k,
          right: R,
          bandRef: (D) => A(F.afterChannelId, D)
        },
        `${r}-gap-${F.afterChannelId}`
      )),
      C.map((F) => /* @__PURE__ */ X.jsx(
        pc,
        {
          className: "chart-container__channel-hidden",
          topPx: F.topPx,
          heightPx: F.heightPx,
          right: R,
          bandRef: (D) => v(F.channelId, D)
        },
        `${r}-hidden-${F.channelId}`
      )),
      S.map((F) => /* @__PURE__ */ X.jsx(
        pc,
        {
          className: "chart-container__channel-placeholder",
          topPx: F.topPx,
          heightPx: F.heightPx,
          left: k,
          right: R,
          bandRef: (D) => b(F.channelId, D),
          children: F.text
        },
        `${r}-placeholder-${F.channelId}`
      )),
      /* @__PURE__ */ X.jsx(
        "div",
        {
          id: `${t}-${r}`,
          style: { width: "100%", height: "100%", minWidth: 0 }
        }
      )
    ] }),
    /* @__PURE__ */ X.jsx(
      "div",
      {
        ref: T.dropIndicatorRef,
        className: "chart-container__drop-indicator"
      }
    )
  ] });
};
var th = "delete", yi = 5, br = 1 << yi, Ns = br - 1, Oe = {};
function sd() {
  return { value: !1 };
}
function Er(r) {
  r && (r.value = !0);
}
function Yd() {
}
function la(r) {
  return r.size === void 0 && (r.size = r.__iterate(wy)), r.size;
}
function Xn(r, t) {
  if (typeof t != "number") {
    var e = t >>> 0;
    if ("" + e !== t || e === 4294967295)
      return NaN;
    t = e;
  }
  return t < 0 ? la(r) + t : t;
}
function wy() {
  return !0;
}
function Nu(r, t, e) {
  return (r === 0 && !ky(r) || e !== void 0 && r <= -e) && (t === void 0 || e !== void 0 && t >= e);
}
function eh(r, t) {
  return Ty(r, t, 0);
}
function Bu(r, t) {
  return Ty(r, t, t);
}
function Ty(r, t, e) {
  return r === void 0 ? e : ky(r) ? t === 1 / 0 ? t : Math.max(0, t + r) | 0 : t === void 0 || t === r ? r : Math.min(t, r) | 0;
}
function ky(r) {
  return r < 0 || r === 0 && 1 / r === -1 / 0;
}
var Dy = "@@__IMMUTABLE_ITERABLE__@@";
function ir(r) {
  return !!(r && r[Dy]);
}
var Fy = "@@__IMMUTABLE_KEYED__@@";
function Mi(r) {
  return !!(r && r[Fy]);
}
var Ly = "@@__IMMUTABLE_INDEXED__@@";
function qs(r) {
  return !!(r && r[Ly]);
}
function zu(r) {
  return Mi(r) || qs(r);
}
var _i = function(t) {
  return ir(t) ? t : dr(t);
}, Lr = /* @__PURE__ */ (function(r) {
  function t(e) {
    return Mi(e) ? e : so(e);
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t;
})(_i), Po = /* @__PURE__ */ (function(r) {
  function t(e) {
    return qs(e) ? e : $r(e);
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t;
})(_i), Da = /* @__PURE__ */ (function(r) {
  function t(e) {
    return ir(e) && !zu(e) ? e : Ra(e);
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t;
})(_i);
_i.Keyed = Lr;
_i.Indexed = Po;
_i.Set = Da;
var Py = "@@__IMMUTABLE_SEQ__@@";
function jd(r) {
  return !!(r && r[Py]);
}
var Ry = "@@__IMMUTABLE_RECORD__@@";
function Fa(r) {
  return !!(r && r[Ry]);
}
function pn(r) {
  return ir(r) || Fa(r);
}
var La = "@@__IMMUTABLE_ORDERED__@@";
function Ur(r) {
  return !!(r && r[La]);
}
var ih = 0, Yr = 1, Dr = 2, rd = typeof Symbol == "function" && Symbol.iterator, Iy = "@@iterator", Wu = rd || Iy, Ke = function(t) {
  this.next = t;
};
Ke.prototype.toString = function() {
  return "[Iterator]";
};
Ke.KEYS = ih;
Ke.VALUES = Yr;
Ke.ENTRIES = Dr;
Ke.prototype.inspect = Ke.prototype.toSource = function() {
  return this.toString();
};
Ke.prototype[Wu] = function() {
  return this;
};
function wi(r, t, e, i) {
  var s = r === 0 ? t : r === 1 ? e : [t, e];
  return i ? i.value = s : i = {
    value: s,
    done: !1
  }, i;
}
function sr() {
  return { value: void 0, done: !0 };
}
function Vy(r) {
  return Array.isArray(r) ? !0 : !!Gu(r);
}
function p0(r) {
  return r && typeof r.next == "function";
}
function nd(r) {
  var t = Gu(r);
  return t && t.call(r);
}
function Gu(r) {
  var t = r && (rd && r[rd] || r[Iy]);
  if (typeof t == "function")
    return t;
}
function Iv(r) {
  var t = Gu(r);
  return t && t === r.entries;
}
function Vv(r) {
  var t = Gu(r);
  return t && t === r.keys;
}
var Pa = Object.prototype.hasOwnProperty;
function _y(r) {
  return Array.isArray(r) || typeof r == "string" ? !0 : r && typeof r == "object" && Number.isInteger(r.length) && r.length >= 0 && (r.length === 0 ? (
    // Only {length: 0} is considered Array-like.
    Object.keys(r).length === 1
  ) : (
    // An object is only Array-like if it has a property where the last value
    // in the array-like may be found (which could be undefined).
    r.hasOwnProperty(r.length - 1)
  ));
}
var dr = /* @__PURE__ */ (function(r) {
  function t(e) {
    return e == null ? Xd() : pn(e) ? e.toSeq() : Ov(e);
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.toSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, t.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, t.prototype.__iterate = function(i, s) {
    var o = this._cache;
    if (o) {
      for (var n = o.length, a = 0; a !== n; ) {
        var l = o[s ? n - ++a : a++];
        if (i(l[1], l[0], this) === !1)
          break;
      }
      return a;
    }
    return this.__iterateUncached(i, s);
  }, t.prototype.__iterator = function(i, s) {
    var o = this._cache;
    if (o) {
      var n = o.length, a = 0;
      return new Ke(function() {
        if (a === n)
          return sr();
        var l = o[s ? n - ++a : a++];
        return wi(i, l[0], l[1]);
      });
    }
    return this.__iteratorUncached(i, s);
  }, t;
})(_i), so = /* @__PURE__ */ (function(r) {
  function t(e) {
    return e == null ? Xd().toKeyedSeq() : ir(e) ? Mi(e) ? e.toSeq() : e.fromEntrySeq() : Fa(e) ? e.toSeq() : Zd(e);
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.toKeyedSeq = function() {
    return this;
  }, t;
})(dr), $r = /* @__PURE__ */ (function(r) {
  function t(e) {
    return e == null ? Xd() : ir(e) ? Mi(e) ? e.entrySeq() : e.toIndexedSeq() : Fa(e) ? e.toSeq().entrySeq() : Oy(e);
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toIndexedSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, t;
})(dr), Ra = /* @__PURE__ */ (function(r) {
  function t(e) {
    return (ir(e) && !zu(e) ? e : $r(e)).toSetSeq();
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toSetSeq = function() {
    return this;
  }, t;
})(dr);
dr.isSeq = jd;
dr.Keyed = so;
dr.Set = Ra;
dr.Indexed = $r;
dr.prototype[Py] = !0;
var wo = /* @__PURE__ */ (function(r) {
  function t(e) {
    this._array = e, this.size = e.length;
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.get = function(i, s) {
    return this.has(i) ? this._array[Xn(this, i)] : s;
  }, t.prototype.__iterate = function(i, s) {
    for (var o = this._array, n = o.length, a = 0; a !== n; ) {
      var l = s ? n - ++a : a++;
      if (i(o[l], l, this) === !1)
        break;
    }
    return a;
  }, t.prototype.__iterator = function(i, s) {
    var o = this._array, n = o.length, a = 0;
    return new Ke(function() {
      if (a === n)
        return sr();
      var l = s ? n - ++a : a++;
      return wi(i, l, o[l]);
    });
  }, t;
})($r), $d = /* @__PURE__ */ (function(r) {
  function t(e) {
    var i = Object.keys(e).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e) : []
    );
    this._object = e, this._keys = i, this.size = i.length;
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.get = function(i, s) {
    return s !== void 0 && !this.has(i) ? s : this._object[i];
  }, t.prototype.has = function(i) {
    return Pa.call(this._object, i);
  }, t.prototype.__iterate = function(i, s) {
    for (var o = this._object, n = this._keys, a = n.length, l = 0; l !== a; ) {
      var h = n[s ? a - ++l : l++];
      if (i(o[h], h, this) === !1)
        break;
    }
    return l;
  }, t.prototype.__iterator = function(i, s) {
    var o = this._object, n = this._keys, a = n.length, l = 0;
    return new Ke(function() {
      if (l === a)
        return sr();
      var h = n[s ? a - ++l : l++];
      return wi(i, h, o[h]);
    });
  }, t;
})(so);
$d.prototype[La] = !0;
var _v = /* @__PURE__ */ (function(r) {
  function t(e) {
    this._collection = e, this.size = e.length || e.size;
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.__iterateUncached = function(i, s) {
    if (s)
      return this.cacheResult().__iterate(i, s);
    var o = this._collection, n = nd(o), a = 0;
    if (p0(n))
      for (var l; !(l = n.next()).done && i(l.value, a++, this) !== !1; )
        ;
    return a;
  }, t.prototype.__iteratorUncached = function(i, s) {
    if (s)
      return this.cacheResult().__iterator(i, s);
    var o = this._collection, n = nd(o);
    if (!p0(n))
      return new Ke(sr);
    var a = 0;
    return new Ke(function() {
      var l = n.next();
      return l.done ? l : wi(i, a++, l.value);
    });
  }, t;
})($r), y0;
function Xd() {
  return y0 || (y0 = new wo([]));
}
function Zd(r) {
  var t = Kd(r);
  if (t)
    return t.fromEntrySeq();
  if (typeof r == "object")
    return new $d(r);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + r
  );
}
function Oy(r) {
  var t = Kd(r);
  if (t)
    return t;
  throw new TypeError(
    "Expected Array or collection object of values: " + r
  );
}
function Ov(r) {
  var t = Kd(r);
  if (t)
    return Iv(r) ? t.fromEntrySeq() : Vv(r) ? t.toSetSeq() : t;
  if (typeof r == "object")
    return new $d(r);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + r
  );
}
function Kd(r) {
  return _y(r) ? new wo(r) : Vy(r) ? new _v(r) : void 0;
}
var Ny = "@@__IMMUTABLE_MAP__@@";
function qd(r) {
  return !!(r && r[Ny]);
}
function By(r) {
  return qd(r) && Ur(r);
}
function m0(r) {
  return !!(r && typeof r.equals == "function" && typeof r.hashCode == "function");
}
function hr(r, t) {
  if (r === t || r !== r && t !== t)
    return !0;
  if (!r || !t)
    return !1;
  if (typeof r.valueOf == "function" && typeof t.valueOf == "function") {
    if (r = r.valueOf(), t = t.valueOf(), r === t || r !== r && t !== t)
      return !0;
    if (!r || !t)
      return !1;
  }
  return !!(m0(r) && m0(t) && r.equals(t));
}
var nl = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(t, e) {
  t |= 0, e |= 0;
  var i = t & 65535, s = e & 65535;
  return i * s + ((t >>> 16) * s + i * (e >>> 16) << 16 >>> 0) | 0;
};
function Uu(r) {
  return r >>> 1 & 1073741824 | r & 3221225471;
}
var Nv = Object.prototype.valueOf;
function ar(r) {
  if (r == null)
    return x0(r);
  if (typeof r.hashCode == "function")
    return Uu(r.hashCode(r));
  var t = Hv(r);
  if (t == null)
    return x0(t);
  switch (typeof t) {
    case "boolean":
      return t ? 1108378657 : 1108378656;
    case "number":
      return Bv(t);
    case "string":
      return t.length > Yv ? zv(t) : od(t);
    case "object":
    case "function":
      return Gv(t);
    case "symbol":
      return Wv(t);
    default:
      if (typeof t.toString == "function")
        return od(t.toString());
      throw new Error("Value type " + typeof t + " cannot be hashed.");
  }
}
function x0(r) {
  return r === null ? 1108378658 : (
    /* undefined */
    1108378659
  );
}
function Bv(r) {
  if (r !== r || r === 1 / 0)
    return 0;
  var t = r | 0;
  for (t !== r && (t ^= r * 4294967295); r > 4294967295; )
    r /= 4294967295, t ^= r;
  return Uu(t);
}
function zv(r) {
  var t = xc[r];
  return t === void 0 && (t = od(r), mc === jv && (mc = 0, xc = {}), mc++, xc[r] = t), t;
}
function od(r) {
  for (var t = 0, e = 0; e < r.length; e++)
    t = 31 * t + r.charCodeAt(e) | 0;
  return Uu(t);
}
function Wv(r) {
  var t = A0[r];
  return t !== void 0 || (t = zy(), A0[r] = t), t;
}
function Gv(r) {
  var t;
  if (ad && (t = ld.get(r), t !== void 0) || (t = r[yo], t !== void 0) || !S0 && (t = r.propertyIsEnumerable && r.propertyIsEnumerable[yo], t !== void 0 || (t = Uv(r), t !== void 0)))
    return t;
  if (t = zy(), ad)
    ld.set(r, t);
  else {
    if (v0 !== void 0 && v0(r) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (S0)
      Object.defineProperty(r, yo, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: t
      });
    else if (r.propertyIsEnumerable !== void 0 && r.propertyIsEnumerable === r.constructor.prototype.propertyIsEnumerable)
      r.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, r.propertyIsEnumerable[yo] = t;
    else if (r.nodeType !== void 0)
      r[yo] = t;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return t;
}
var v0 = Object.isExtensible, S0 = (function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
})();
function Uv(r) {
  if (r && r.nodeType > 0)
    switch (r.nodeType) {
      case 1:
        return r.uniqueID;
      case 9:
        return r.documentElement && r.documentElement.uniqueID;
    }
}
function Hv(r) {
  return r.valueOf !== Nv && typeof r.valueOf == "function" ? r.valueOf(r) : r;
}
function zy() {
  var r = ++yc;
  return yc & 1073741824 && (yc = 0), r;
}
var ad = typeof WeakMap == "function", ld;
ad && (ld = /* @__PURE__ */ new WeakMap());
var A0 = /* @__PURE__ */ Object.create(null), yc = 0, yo = "__immutablehash__";
typeof Symbol == "function" && (yo = Symbol(yo));
var Yv = 16, jv = 255, mc = 0, xc = {}, Hu = /* @__PURE__ */ (function(r) {
  function t(e, i) {
    this._iter = e, this._useKeys = i, this.size = e.size;
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.get = function(i, s) {
    return this._iter.get(i, s);
  }, t.prototype.has = function(i) {
    return this._iter.has(i);
  }, t.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, t.prototype.reverse = function() {
    var i = this, s = Jd(this, !0);
    return this._useKeys || (s.valueSeq = function() {
      return i._iter.toSeq().reverse();
    }), s;
  }, t.prototype.map = function(i, s) {
    var o = this, n = Yy(this, i, s);
    return this._useKeys || (n.valueSeq = function() {
      return o._iter.toSeq().map(i, s);
    }), n;
  }, t.prototype.__iterate = function(i, s) {
    var o = this;
    return this._iter.__iterate(function(n, a) {
      return i(n, a, o);
    }, s);
  }, t.prototype.__iterator = function(i, s) {
    return this._iter.__iterator(i, s);
  }, t;
})(so);
Hu.prototype[La] = !0;
var Wy = /* @__PURE__ */ (function(r) {
  function t(e) {
    this._iter = e, this.size = e.size;
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.includes = function(i) {
    return this._iter.includes(i);
  }, t.prototype.__iterate = function(i, s) {
    var o = this, n = 0;
    return s && la(this), this._iter.__iterate(
      function(a) {
        return i(a, s ? o.size - ++n : n++, o);
      },
      s
    );
  }, t.prototype.__iterator = function(i, s) {
    var o = this, n = this._iter.__iterator(Yr, s), a = 0;
    return s && la(this), new Ke(function() {
      var l = n.next();
      return l.done ? l : wi(
        i,
        s ? o.size - ++a : a++,
        l.value,
        l
      );
    });
  }, t;
})($r), Gy = /* @__PURE__ */ (function(r) {
  function t(e) {
    this._iter = e, this.size = e.size;
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.has = function(i) {
    return this._iter.includes(i);
  }, t.prototype.__iterate = function(i, s) {
    var o = this;
    return this._iter.__iterate(function(n) {
      return i(n, n, o);
    }, s);
  }, t.prototype.__iterator = function(i, s) {
    var o = this._iter.__iterator(Yr, s);
    return new Ke(function() {
      var n = o.next();
      return n.done ? n : wi(i, n.value, n.value, n);
    });
  }, t;
})(Ra), Uy = /* @__PURE__ */ (function(r) {
  function t(e) {
    this._iter = e, this.size = e.size;
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, t.prototype.__iterate = function(i, s) {
    var o = this;
    return this._iter.__iterate(function(n) {
      if (n) {
        E0(n);
        var a = ir(n);
        return i(
          a ? n.get(1) : n[1],
          a ? n.get(0) : n[0],
          o
        );
      }
    }, s);
  }, t.prototype.__iterator = function(i, s) {
    var o = this._iter.__iterator(Yr, s);
    return new Ke(function() {
      for (; ; ) {
        var n = o.next();
        if (n.done)
          return n;
        var a = n.value;
        if (a) {
          E0(a);
          var l = ir(a);
          return wi(
            i,
            l ? a.get(0) : a[0],
            l ? a.get(1) : a[1],
            n
          );
        }
      }
    });
  }, t;
})(so);
Wy.prototype.cacheResult = Hu.prototype.cacheResult = Gy.prototype.cacheResult = Uy.prototype.cacheResult = ef;
function Hy(r) {
  var t = yn(r);
  return t._iter = r, t.size = r.size, t.flip = function() {
    return r;
  }, t.reverse = function() {
    var e = r.reverse.apply(this);
    return e.flip = function() {
      return r.reverse();
    }, e;
  }, t.has = function(e) {
    return r.includes(e);
  }, t.includes = function(e) {
    return r.has(e);
  }, t.cacheResult = ef, t.__iterateUncached = function(e, i) {
    var s = this;
    return r.__iterate(function(o, n) {
      return e(n, o, s) !== !1;
    }, i);
  }, t.__iteratorUncached = function(e, i) {
    if (e === Dr) {
      var s = r.__iterator(e, i);
      return new Ke(function() {
        var o = s.next();
        if (!o.done) {
          var n = o.value[0];
          o.value[0] = o.value[1], o.value[1] = n;
        }
        return o;
      });
    }
    return r.__iterator(
      e === Yr ? ih : Yr,
      i
    );
  }, t;
}
function Yy(r, t, e) {
  var i = yn(r);
  return i.size = r.size, i.has = function(s) {
    return r.has(s);
  }, i.get = function(s, o) {
    var n = r.get(s, Oe);
    return n === Oe ? o : t.call(e, n, s, r);
  }, i.__iterateUncached = function(s, o) {
    var n = this;
    return r.__iterate(
      function(a, l, h) {
        return s(t.call(e, a, l, h), l, n) !== !1;
      },
      o
    );
  }, i.__iteratorUncached = function(s, o) {
    var n = r.__iterator(Dr, o);
    return new Ke(function() {
      var a = n.next();
      if (a.done)
        return a;
      var l = a.value, h = l[0];
      return wi(
        s,
        h,
        t.call(e, l[1], h, r),
        a
      );
    });
  }, i;
}
function Jd(r, t) {
  var e = this, i = yn(r);
  return i._iter = r, i.size = r.size, i.reverse = function() {
    return r;
  }, r.flip && (i.flip = function() {
    var s = Hy(r);
    return s.reverse = function() {
      return r.flip();
    }, s;
  }), i.get = function(s, o) {
    return r.get(t ? s : -1 - s, o);
  }, i.has = function(s) {
    return r.has(t ? s : -1 - s);
  }, i.includes = function(s) {
    return r.includes(s);
  }, i.cacheResult = ef, i.__iterate = function(s, o) {
    var n = this, a = 0;
    return o && la(r), r.__iterate(
      function(l, h) {
        return s(l, t ? h : o ? n.size - ++a : a++, n);
      },
      !o
    );
  }, i.__iterator = function(s, o) {
    var n = 0;
    o && la(r);
    var a = r.__iterator(Dr, !o);
    return new Ke(function() {
      var l = a.next();
      if (l.done)
        return l;
      var h = l.value;
      return wi(
        s,
        t ? h[0] : o ? e.size - ++n : n++,
        h[1],
        l
      );
    });
  }, i;
}
function jy(r, t, e, i) {
  var s = yn(r);
  return i && (s.has = function(o) {
    var n = r.get(o, Oe);
    return n !== Oe && !!t.call(e, n, o, r);
  }, s.get = function(o, n) {
    var a = r.get(o, Oe);
    return a !== Oe && t.call(e, a, o, r) ? a : n;
  }), s.__iterateUncached = function(o, n) {
    var a = this, l = 0;
    return r.__iterate(function(h, u, c) {
      if (t.call(e, h, u, c))
        return l++, o(h, i ? u : l - 1, a);
    }, n), l;
  }, s.__iteratorUncached = function(o, n) {
    var a = r.__iterator(Dr, n), l = 0;
    return new Ke(function() {
      for (; ; ) {
        var h = a.next();
        if (h.done)
          return h;
        var u = h.value, c = u[0], d = u[1];
        if (t.call(e, d, c, r))
          return wi(o, i ? c : l++, d, h);
      }
    });
  }, s;
}
function $v(r, t, e) {
  var i = Va().asMutable();
  return r.__iterate(function(s, o) {
    i.update(t.call(e, s, o, r), 0, function(n) {
      return n + 1;
    });
  }), i.asImmutable();
}
function Xv(r, t, e) {
  var i = Mi(r), s = (Ur(r) ? Dn() : Va()).asMutable();
  r.__iterate(function(n, a) {
    s.update(
      t.call(e, n, a, r),
      function(l) {
        return l = l || [], l.push(i ? [a, n] : n), l;
      }
    );
  });
  var o = tf(r);
  return s.map(function(n) {
    return ai(r, o(n));
  }).asImmutable();
}
function Zv(r, t, e) {
  var i = Mi(r), s = [[], []];
  r.__iterate(function(n, a) {
    s[t.call(e, n, a, r) ? 1 : 0].push(
      i ? [a, n] : n
    );
  });
  var o = tf(r);
  return s.map(function(n) {
    return ai(r, o(n));
  });
}
function Qd(r, t, e, i) {
  var s = r.size;
  if (Nu(t, e, s))
    return r;
  if (typeof s > "u" && (t < 0 || e < 0))
    return Qd(r.toSeq().cacheResult(), t, e, i);
  var o = eh(t, s), n = Bu(e, s), a = n - o, l;
  a === a && (l = a < 0 ? 0 : a);
  var h = yn(r);
  return h.size = l === 0 ? l : r.size && l || void 0, !i && jd(r) && l >= 0 && (h.get = function(u, c) {
    return u = Xn(this, u), u >= 0 && u < l ? r.get(u + o, c) : c;
  }), h.__iterateUncached = function(u, c) {
    var d = this;
    if (l === 0)
      return 0;
    if (c)
      return this.cacheResult().__iterate(u, c);
    var f = 0, p = !0, g = 0;
    return r.__iterate(function(y, m) {
      if (!(p && (p = f++ < o)))
        return g++, u(y, i ? m : g - 1, d) !== !1 && g !== l;
    }), g;
  }, h.__iteratorUncached = function(u, c) {
    if (l !== 0 && c)
      return this.cacheResult().__iterator(u, c);
    if (l === 0)
      return new Ke(sr);
    var d = r.__iterator(u, c), f = 0, p = 0;
    return new Ke(function() {
      for (; f++ < o; )
        d.next();
      if (++p > l)
        return sr();
      var g = d.next();
      return i || u === Yr || g.done ? g : u === ih ? wi(u, p - 1, void 0, g) : wi(u, p - 1, g.value[1], g);
    });
  }, h;
}
function Kv(r, t, e) {
  var i = yn(r);
  return i.__iterateUncached = function(s, o) {
    var n = this;
    if (o)
      return this.cacheResult().__iterate(s, o);
    var a = 0;
    return r.__iterate(
      function(l, h, u) {
        return t.call(e, l, h, u) && ++a && s(l, h, n);
      }
    ), a;
  }, i.__iteratorUncached = function(s, o) {
    var n = this;
    if (o)
      return this.cacheResult().__iterator(s, o);
    var a = r.__iterator(Dr, o), l = !0;
    return new Ke(function() {
      if (!l)
        return sr();
      var h = a.next();
      if (h.done)
        return h;
      var u = h.value, c = u[0], d = u[1];
      return t.call(e, d, c, n) ? s === Dr ? h : wi(s, c, d, h) : (l = !1, sr());
    });
  }, i;
}
function $y(r, t, e, i) {
  var s = yn(r);
  return s.__iterateUncached = function(o, n) {
    var a = this;
    if (n)
      return this.cacheResult().__iterate(o, n);
    var l = !0, h = 0;
    return r.__iterate(function(u, c, d) {
      if (!(l && (l = t.call(e, u, c, d))))
        return h++, o(u, i ? c : h - 1, a);
    }), h;
  }, s.__iteratorUncached = function(o, n) {
    var a = this;
    if (n)
      return this.cacheResult().__iterator(o, n);
    var l = r.__iterator(Dr, n), h = !0, u = 0;
    return new Ke(function() {
      var c, d, f;
      do {
        if (c = l.next(), c.done)
          return i || o === Yr ? c : o === ih ? wi(o, u++, void 0, c) : wi(o, u++, c.value[1], c);
        var p = c.value;
        d = p[0], f = p[1], h && (h = t.call(e, f, d, a));
      } while (h);
      return o === Dr ? c : wi(o, d, f, c);
    });
  }, s;
}
function qv(r, t) {
  var e = Mi(r), i = [r].concat(t).map(function(n) {
    return ir(n) ? e && (n = Lr(n)) : n = e ? Zd(n) : Oy(Array.isArray(n) ? n : [n]), n;
  }).filter(function(n) {
    return n.size !== 0;
  });
  if (i.length === 0)
    return r;
  if (i.length === 1) {
    var s = i[0];
    if (s === r || e && Mi(s) || qs(r) && qs(s))
      return s;
  }
  var o = new wo(i);
  return e ? o = o.toKeyedSeq() : qs(r) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = i.reduce(function(n, a) {
    if (n !== void 0) {
      var l = a.size;
      if (l !== void 0)
        return n + l;
    }
  }, 0), o;
}
function Xy(r, t, e) {
  var i = yn(r);
  return i.__iterateUncached = function(s, o) {
    if (o)
      return this.cacheResult().__iterate(s, o);
    var n = 0, a = !1;
    function l(h, u) {
      h.__iterate(function(c, d) {
        return (!t || u < t) && ir(c) ? l(c, u + 1) : (n++, s(c, e ? d : n - 1, i) === !1 && (a = !0)), !a;
      }, o);
    }
    return l(r, 0), n;
  }, i.__iteratorUncached = function(s, o) {
    if (o)
      return this.cacheResult().__iterator(s, o);
    var n = r.__iterator(s, o), a = [], l = 0;
    return new Ke(function() {
      for (; n; ) {
        var h = n.next();
        if (h.done !== !1) {
          n = a.pop();
          continue;
        }
        var u = h.value;
        if (s === Dr && (u = u[1]), (!t || a.length < t) && ir(u))
          a.push(n), n = u.__iterator(s, o);
        else
          return e ? h : wi(s, l++, u, h);
      }
      return sr();
    });
  }, i;
}
function Jv(r, t, e) {
  var i = tf(r);
  return r.toSeq().map(function(s, o) {
    return i(t.call(e, s, o, r));
  }).flatten(!0);
}
function Qv(r, t) {
  var e = yn(r);
  return e.size = r.size && r.size * 2 - 1, e.__iterateUncached = function(i, s) {
    var o = this, n = 0;
    return r.__iterate(
      function(a) {
        return (!n || i(t, n++, o) !== !1) && i(a, n++, o) !== !1;
      },
      s
    ), n;
  }, e.__iteratorUncached = function(i, s) {
    var o = r.__iterator(Yr, s), n = 0, a;
    return new Ke(function() {
      return (!a || n % 2) && (a = o.next(), a.done) ? a : n % 2 ? wi(i, n++, t) : wi(i, n++, a.value, a);
    });
  }, e;
}
function ha(r, t, e) {
  t || (t = Zy);
  var i = Mi(r), s = 0, o = r.toSeq().map(function(n, a) {
    return [a, n, s++, e ? e(n, a, r) : n];
  }).valueSeq().toArray();
  return o.sort(function(n, a) {
    return t(n[3], a[3]) || n[2] - a[2];
  }).forEach(
    i ? function(n, a) {
      o[a].length = 2;
    } : function(n, a) {
      o[a] = n[1];
    }
  ), i ? so(o) : qs(r) ? $r(o) : Ra(o);
}
function wh(r, t, e) {
  if (t || (t = Zy), e) {
    var i = r.toSeq().map(function(s, o) {
      return [s, e(s, o, r)];
    }).reduce(function(s, o) {
      return b0(t, s[1], o[1]) ? o : s;
    });
    return i && i[0];
  }
  return r.reduce(function(s, o) {
    return b0(t, s, o) ? o : s;
  });
}
function b0(r, t, e) {
  var i = r(e, t);
  return i === 0 && e !== t && (e == null || e !== e) || i > 0;
}
function Th(r, t, e, i) {
  var s = yn(r), o = new wo(e).map(function(n) {
    return n.size;
  });
  return s.size = i ? o.max() : o.min(), s.__iterate = function(n, a) {
    for (var l = this.__iterator(Yr, a), h, u = 0; !(h = l.next()).done && n(h.value, u++, this) !== !1; )
      ;
    return u;
  }, s.__iteratorUncached = function(n, a) {
    var l = e.map(
      function(c) {
        return c = _i(c), nd(a ? c.reverse() : c);
      }
    ), h = 0, u = !1;
    return new Ke(function() {
      var c;
      return u || (c = l.map(function(d) {
        return d.next();
      }), u = i ? c.every(function(d) {
        return d.done;
      }) : c.some(function(d) {
        return d.done;
      })), u ? sr() : wi(
        n,
        h++,
        t.apply(
          null,
          c.map(function(d) {
            return d.value;
          })
        )
      );
    });
  }, s;
}
function ai(r, t) {
  return r === t ? r : jd(r) ? t : r.constructor(t);
}
function E0(r) {
  if (r !== Object(r))
    throw new TypeError("Expected [K, V] tuple: " + r);
}
function tf(r) {
  return Mi(r) ? Lr : qs(r) ? Po : Da;
}
function yn(r) {
  return Object.create(
    (Mi(r) ? so : qs(r) ? $r : Ra).prototype
  );
}
function ef() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : dr.prototype.cacheResult.call(this);
}
function Zy(r, t) {
  return r === void 0 && t === void 0 ? 0 : r === void 0 ? 1 : t === void 0 ? -1 : r > t ? 1 : r < t ? -1 : 0;
}
function on(r, t) {
  t = t || 0;
  for (var e = Math.max(0, r.length - t), i = new Array(e), s = 0; s < e; s++)
    i[s] = r[s + t];
  return i;
}
function sf(r, t) {
  if (!r)
    throw new Error(t);
}
function lr(r) {
  sf(
    r !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function Ky(r) {
  if (_y(r) && typeof r != "string")
    return r;
  if (Ur(r))
    return r.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + r
  );
}
var tS = Object.prototype.toString;
function eS(r) {
  if (!r || typeof r != "object" || tS.call(r) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(r);
  if (t === null)
    return !0;
  for (var e = t, i = Object.getPrototypeOf(t); i !== null; )
    e = i, i = Object.getPrototypeOf(e);
  return e === t;
}
function Zn(r) {
  return typeof r == "object" && (pn(r) || Array.isArray(r) || eS(r));
}
function Pl(r) {
  try {
    return typeof r == "string" ? JSON.stringify(r) : String(r);
  } catch {
    return JSON.stringify(r);
  }
}
function iS(r, t) {
  return pn(r) ? r.has(t) : Zn(r) && Pa.call(r, t);
}
function qy(r, t, e) {
  return pn(r) ? r.get(t, e) : iS(r, t) ? typeof r.get == "function" ? r.get(t) : r[t] : e;
}
function sh(r) {
  return typeof r == "string" && (r === "__proto__" || r === "constructor");
}
function mu(r) {
  if (Array.isArray(r))
    return on(r);
  var t = {};
  for (var e in r)
    sh(e) || Pa.call(r, e) && (t[e] = r[e]);
  return t;
}
function sS(r, t) {
  if (!Zn(r))
    throw new TypeError(
      "Cannot update non-data-structure value: " + r
    );
  if (pn(r)) {
    if (!r.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + r
      );
    return r.remove(t);
  }
  if (!Pa.call(r, t))
    return r;
  var e = mu(r);
  return Array.isArray(e) ? e.splice(t, 1) : delete e[t], e;
}
function rS(r, t, e) {
  if (sh(t))
    return r;
  if (!Zn(r))
    throw new TypeError(
      "Cannot update non-data-structure value: " + r
    );
  if (pn(r)) {
    if (!r.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + r
      );
    return r.set(t, e);
  }
  if (Pa.call(r, t) && e === r[t])
    return r;
  var i = mu(r);
  return i[t] = e, i;
}
function Ia(r, t, e, i) {
  i || (i = e, e = void 0);
  var s = Jy(
    pn(r),
    r,
    Ky(t),
    0,
    e,
    i
  );
  return s === Oe ? e : s;
}
function Jy(r, t, e, i, s, o) {
  var n = t === Oe;
  if (i === e.length) {
    var a = n ? s : t, l = o(a);
    return l === a ? t : l;
  }
  if (!n && !Zn(t))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + e.slice(0, i).map(Pl) + "]: " + t
    );
  var h = e[i], u = n ? Oe : qy(t, h, Oe), c = Jy(
    u === Oe ? r : pn(u),
    u,
    e,
    i + 1,
    s,
    o
  );
  return c === u ? t : c === Oe ? sS(t, h) : rS(
    n ? r ? Br() : {} : t,
    h,
    c
  );
}
function nS(r, t, e) {
  return Ia(r, t, Oe, function() {
    return e;
  });
}
function rf(r, t) {
  return nS(this, r, t);
}
function oS(r, t) {
  return Ia(r, t, function() {
    return Oe;
  });
}
function nf(r) {
  return oS(this, r);
}
function Qy(r, t, e, i) {
  return Ia(r, [t], e, i);
}
function of(r, t, e) {
  return arguments.length === 1 ? r(this) : Qy(this, r, t, e);
}
function af(r, t, e) {
  return Ia(this, r, t, e);
}
function tm() {
  for (var r = [], t = arguments.length; t--; ) r[t] = arguments[t];
  return im(this, r);
}
function em(r) {
  for (var t = [], e = arguments.length - 1; e-- > 0; ) t[e] = arguments[e + 1];
  if (typeof r != "function")
    throw new TypeError("Invalid merger function: " + r);
  return im(this, t, r);
}
function im(r, t, e) {
  for (var i = [], s = 0; s < t.length; s++) {
    var o = Lr(t[s]);
    o.size !== 0 && i.push(o);
  }
  return i.length === 0 ? r : r.toSeq().size === 0 && !r.__ownerID && i.length === 1 ? r.constructor(i[0]) : r.withMutations(function(n) {
    for (var a = e ? function(h, u) {
      Qy(
        n,
        u,
        Oe,
        function(c) {
          return c === Oe ? h : e(c, h, u);
        }
      );
    } : function(h, u) {
      n.set(u, h);
    }, l = 0; l < i.length; l++)
      i[l].forEach(a);
  });
}
function lf(r, t, e) {
  return hf(r, t, aS(e));
}
function hf(r, t, e) {
  if (!Zn(r))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + r
    );
  if (pn(r))
    return typeof e == "function" && r.mergeWith ? r.mergeWith.apply(r, [e].concat(t)) : r.merge ? r.merge.apply(r, t) : r.concat.apply(r, t);
  for (var i = Array.isArray(r), s = r, o = i ? Po : Lr, n = i ? function(l) {
    s === r && (s = mu(s)), s.push(l);
  } : function(l, h) {
    if (!sh(h)) {
      var u = Pa.call(s, h), c = u && e ? e(s[h], l, h) : l;
      (!u || c !== s[h]) && (s === r && (s = mu(s)), s[h] = c);
    }
  }, a = 0; a < t.length; a++)
    o(t[a]).forEach(n);
  return s;
}
function aS(r) {
  function t(e, i, s) {
    return Zn(e) && Zn(i) && lS(e, i) ? hf(e, [i], t) : r ? r(e, i, s) : i;
  }
  return t;
}
function lS(r, t) {
  var e = dr(r), i = dr(t);
  return qs(e) === qs(i) && Mi(e) === Mi(i);
}
function sm() {
  for (var r = [], t = arguments.length; t--; ) r[t] = arguments[t];
  return lf(this, r);
}
function rm(r) {
  for (var t = [], e = arguments.length - 1; e-- > 0; ) t[e] = arguments[e + 1];
  return lf(this, t, r);
}
function uf(r) {
  for (var t = [], e = arguments.length - 1; e-- > 0; ) t[e] = arguments[e + 1];
  return Ia(this, r, Br(), function(i) {
    return hf(i, t);
  });
}
function cf(r) {
  for (var t = [], e = arguments.length - 1; e-- > 0; ) t[e] = arguments[e + 1];
  return Ia(
    this,
    r,
    Br(),
    function(i) {
      return lf(i, t);
    }
  );
}
function rh(r) {
  var t = this.asMutable();
  return r(t), t.wasAltered() ? t.__ensureOwner(this.__ownerID) : this;
}
function nh() {
  return this.__ownerID ? this : this.__ensureOwner(new Yd());
}
function oh() {
  return this.__ensureOwner();
}
function df() {
  return this.__altered;
}
var Va = /* @__PURE__ */ (function(r) {
  function t(e) {
    return e == null ? Br() : qd(e) && !Ur(e) ? e : Br().withMutations(function(i) {
      var s = r(e);
      lr(s.size), s.forEach(function(o, n) {
        return i.set(n, o);
      });
    });
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.of = function() {
    for (var i = [], s = arguments.length; s--; ) i[s] = arguments[s];
    return Br().withMutations(function(o) {
      for (var n = 0; n < i.length; n += 2) {
        if (n + 1 >= i.length)
          throw new Error("Missing value for key: " + i[n]);
        o.set(i[n], i[n + 1]);
      }
    });
  }, t.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, t.prototype.get = function(i, s) {
    return this._root ? this._root.get(0, void 0, i, s) : s;
  }, t.prototype.set = function(i, s) {
    return w0(this, i, s);
  }, t.prototype.remove = function(i) {
    return w0(this, i, Oe);
  }, t.prototype.deleteAll = function(i) {
    var s = _i(i);
    return s.size === 0 ? this : this.withMutations(function(o) {
      s.forEach(function(n) {
        return o.remove(n);
      });
    });
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : Br();
  }, t.prototype.sort = function(i) {
    return Dn(ha(this, i));
  }, t.prototype.sortBy = function(i, s) {
    return Dn(ha(this, s, i));
  }, t.prototype.map = function(i, s) {
    var o = this;
    return this.withMutations(function(n) {
      n.forEach(function(a, l) {
        n.set(l, i.call(s, a, l, o));
      });
    });
  }, t.prototype.__iterator = function(i, s) {
    return new hS(this, i, s);
  }, t.prototype.__iterate = function(i, s) {
    var o = this, n = 0;
    return this._root && this._root.iterate(function(a) {
      return n++, i(a[1], a[0], o);
    }, s), n;
  }, t.prototype.__ensureOwner = function(i) {
    return i === this.__ownerID ? this : i ? ff(this.size, this._root, i, this.__hash) : this.size === 0 ? Br() : (this.__ownerID = i, this.__altered = !1, this);
  }, t;
})(Lr);
Va.isMap = qd;
var xi = Va.prototype;
xi[Ny] = !0;
xi[th] = xi.remove;
xi.removeAll = xi.deleteAll;
xi.setIn = rf;
xi.removeIn = xi.deleteIn = nf;
xi.update = of;
xi.updateIn = af;
xi.merge = xi.concat = tm;
xi.mergeWith = em;
xi.mergeDeep = sm;
xi.mergeDeepWith = rm;
xi.mergeIn = uf;
xi.mergeDeepIn = cf;
xi.withMutations = rh;
xi.wasAltered = df;
xi.asImmutable = oh;
xi["@@transducer/init"] = xi.asMutable = nh;
xi["@@transducer/step"] = function(r, t) {
  return r.set(t[0], t[1]);
};
xi["@@transducer/result"] = function(r) {
  return r.asImmutable();
};
var Rl = function(t, e) {
  this.ownerID = t, this.entries = e;
};
Rl.prototype.get = function(t, e, i, s) {
  for (var o = this.entries, n = 0, a = o.length; n < a; n++)
    if (hr(i, o[n][0]))
      return o[n][1];
  return s;
};
Rl.prototype.update = function(t, e, i, s, o, n, a) {
  for (var l = o === Oe, h = this.entries, u = 0, c = h.length; u < c && !hr(s, h[u][0]); u++)
    ;
  var d = u < c;
  if (d ? h[u][1] === o : l)
    return this;
  if (Er(a), (l || !d) && Er(n), !(l && h.length === 1)) {
    if (!d && !l && h.length >= pS)
      return uS(t, h, s, o);
    var f = t && t === this.ownerID, p = f ? h : on(h);
    return d ? l ? u === c - 1 ? p.pop() : p[u] = p.pop() : p[u] = [s, o] : p.push([s, o]), f ? (this.entries = p, this) : new Rl(t, p);
  }
};
var ua = function(t, e, i) {
  this.ownerID = t, this.bitmap = e, this.nodes = i;
};
ua.prototype.get = function(t, e, i, s) {
  e === void 0 && (e = ar(i));
  var o = 1 << ((t === 0 ? e : e >>> t) & Ns), n = this.bitmap;
  return (n & o) === 0 ? s : this.nodes[nm(n & o - 1)].get(
    t + yi,
    e,
    i,
    s
  );
};
ua.prototype.update = function(t, e, i, s, o, n, a) {
  i === void 0 && (i = ar(s));
  var l = (e === 0 ? i : i >>> e) & Ns, h = 1 << l, u = this.bitmap, c = (u & h) !== 0;
  if (!c && o === Oe)
    return this;
  var d = nm(u & h - 1), f = this.nodes, p = c ? f[d] : void 0, g = gf(
    p,
    t,
    e + yi,
    i,
    s,
    o,
    n,
    a
  );
  if (g === p)
    return this;
  if (!c && g && f.length >= yS)
    return dS(t, f, u, l, g);
  if (c && !g && f.length === 2 && T0(f[d ^ 1]))
    return f[d ^ 1];
  if (c && g && f.length === 1 && T0(g))
    return g;
  var y = t && t === this.ownerID, m = c ? g ? u : u ^ h : u | h, A = c ? g ? om(f, d, g, y) : gS(f, d, y) : fS(f, d, g, y);
  return y ? (this.bitmap = m, this.nodes = A, this) : new ua(t, m, A);
};
var Il = function(t, e, i) {
  this.ownerID = t, this.count = e, this.nodes = i;
};
Il.prototype.get = function(t, e, i, s) {
  e === void 0 && (e = ar(i));
  var o = (t === 0 ? e : e >>> t) & Ns, n = this.nodes[o];
  return n ? n.get(t + yi, e, i, s) : s;
};
Il.prototype.update = function(t, e, i, s, o, n, a) {
  i === void 0 && (i = ar(s));
  var l = (e === 0 ? i : i >>> e) & Ns, h = o === Oe, u = this.nodes, c = u[l];
  if (h && !c)
    return this;
  var d = gf(
    c,
    t,
    e + yi,
    i,
    s,
    o,
    n,
    a
  );
  if (d === c)
    return this;
  var f = this.count;
  if (!c)
    f++;
  else if (!d && (f--, f < mS))
    return cS(t, u, f, l);
  var p = t && t === this.ownerID, g = om(u, l, d, p);
  return p ? (this.count = f, this.nodes = g, this) : new Il(t, f, g);
};
var ca = function(t, e, i) {
  this.ownerID = t, this.keyHash = e, this.entries = i;
};
ca.prototype.get = function(t, e, i, s) {
  for (var o = this.entries, n = 0, a = o.length; n < a; n++)
    if (hr(i, o[n][0]))
      return o[n][1];
  return s;
};
ca.prototype.update = function(t, e, i, s, o, n, a) {
  i === void 0 && (i = ar(s));
  var l = o === Oe;
  if (i !== this.keyHash)
    return l ? this : (Er(a), Er(n), pf(this, t, e, i, [s, o]));
  for (var h = this.entries, u = 0, c = h.length; u < c && !hr(s, h[u][0]); u++)
    ;
  var d = u < c;
  if (d ? h[u][1] === o : l)
    return this;
  if (Er(a), (l || !d) && Er(n), l && c === 2)
    return new kn(t, this.keyHash, h[u ^ 1]);
  var f = t && t === this.ownerID, p = f ? h : on(h);
  return d ? l ? u === c - 1 ? p.pop() : p[u] = p.pop() : p[u] = [s, o] : p.push([s, o]), f ? (this.entries = p, this) : new ca(t, this.keyHash, p);
};
var kn = function(t, e, i) {
  this.ownerID = t, this.keyHash = e, this.entry = i;
};
kn.prototype.get = function(t, e, i, s) {
  return hr(i, this.entry[0]) ? this.entry[1] : s;
};
kn.prototype.update = function(t, e, i, s, o, n, a) {
  var l = o === Oe, h = hr(s, this.entry[0]);
  if (h ? o === this.entry[1] : l)
    return this;
  if (Er(a), l) {
    Er(n);
    return;
  }
  return h ? t && t === this.ownerID ? (this.entry[1] = o, this) : new kn(t, this.keyHash, [s, o]) : (Er(n), pf(this, t, e, ar(s), [s, o]));
};
Rl.prototype.iterate = ca.prototype.iterate = function(r, t) {
  for (var e = this.entries, i = 0, s = e.length - 1; i <= s; i++)
    if (r(e[t ? s - i : i]) === !1)
      return !1;
};
ua.prototype.iterate = Il.prototype.iterate = function(r, t) {
  for (var e = this.nodes, i = 0, s = e.length - 1; i <= s; i++) {
    var o = e[t ? s - i : i];
    if (o && o.iterate(r, t) === !1)
      return !1;
  }
};
kn.prototype.iterate = function(r, t) {
  return r(this.entry);
};
var hS = /* @__PURE__ */ (function(r) {
  function t(e, i, s) {
    this._type = i, this._reverse = s, this._stack = e._root && M0(e._root);
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.next = function() {
    for (var i = this._type, s = this._stack; s; ) {
      var o = s.node, n = s.index++, a = void 0;
      if (o.entry) {
        if (n === 0)
          return vc(i, o.entry);
      } else if (o.entries) {
        if (a = o.entries.length - 1, n <= a)
          return vc(
            i,
            o.entries[this._reverse ? a - n : n]
          );
      } else if (a = o.nodes.length - 1, n <= a) {
        var l = o.nodes[this._reverse ? a - n : n];
        if (l) {
          if (l.entry)
            return vc(i, l.entry);
          s = this._stack = M0(l, s);
        }
        continue;
      }
      s = this._stack = this._stack.__prev;
    }
    return sr();
  }, t;
})(Ke);
function vc(r, t) {
  return wi(r, t[0], t[1]);
}
function M0(r, t) {
  return {
    node: r,
    index: 0,
    __prev: t
  };
}
function ff(r, t, e, i) {
  var s = Object.create(xi);
  return s.size = r, s._root = t, s.__ownerID = e, s.__hash = i, s.__altered = !1, s;
}
var C0;
function Br() {
  return C0 || (C0 = ff(0));
}
function w0(r, t, e) {
  var i, s;
  if (r._root) {
    var o = sd(), n = sd();
    if (i = gf(
      r._root,
      r.__ownerID,
      0,
      void 0,
      t,
      e,
      o,
      n
    ), !n.value)
      return r;
    s = r.size + (o.value ? e === Oe ? -1 : 1 : 0);
  } else {
    if (e === Oe)
      return r;
    s = 1, i = new Rl(r.__ownerID, [[t, e]]);
  }
  return r.__ownerID ? (r.size = s, r._root = i, r.__hash = void 0, r.__altered = !0, r) : i ? ff(s, i) : Br();
}
function gf(r, t, e, i, s, o, n, a) {
  return r ? r.update(
    t,
    e,
    i,
    s,
    o,
    n,
    a
  ) : o === Oe ? r : (Er(a), Er(n), new kn(t, i, [s, o]));
}
function T0(r) {
  return r.constructor === kn || r.constructor === ca;
}
function pf(r, t, e, i, s) {
  if (r.keyHash === i)
    return new ca(t, i, [r.entry, s]);
  var o = (e === 0 ? r.keyHash : r.keyHash >>> e) & Ns, n = (e === 0 ? i : i >>> e) & Ns, a, l = o === n ? [pf(r, t, e + yi, i, s)] : (a = new kn(t, i, s), o < n ? [r, a] : [a, r]);
  return new ua(t, 1 << o | 1 << n, l);
}
function uS(r, t, e, i) {
  r || (r = new Yd());
  for (var s = new kn(r, ar(e), [e, i]), o = 0; o < t.length; o++) {
    var n = t[o];
    s = s.update(r, 0, void 0, n[0], n[1]);
  }
  return s;
}
function cS(r, t, e, i) {
  for (var s = 0, o = 0, n = new Array(e), a = 0, l = 1, h = t.length; a < h; a++, l <<= 1) {
    var u = t[a];
    u !== void 0 && a !== i && (s |= l, n[o++] = u);
  }
  return new ua(r, s, n);
}
function dS(r, t, e, i, s) {
  for (var o = 0, n = new Array(br), a = 0; e !== 0; a++, e >>>= 1)
    n[a] = e & 1 ? t[o++] : void 0;
  return n[i] = s, new Il(r, o + 1, n);
}
function nm(r) {
  return r -= r >> 1 & 1431655765, r = (r & 858993459) + (r >> 2 & 858993459), r = r + (r >> 4) & 252645135, r += r >> 8, r += r >> 16, r & 127;
}
function om(r, t, e, i) {
  var s = i ? r : on(r);
  return s[t] = e, s;
}
function fS(r, t, e, i) {
  var s = r.length + 1;
  if (i && t + 1 === s)
    return r[t] = e, r;
  for (var o = new Array(s), n = 0, a = 0; a < s; a++)
    a === t ? (o[a] = e, n = -1) : o[a] = r[a + n];
  return o;
}
function gS(r, t, e) {
  var i = r.length - 1;
  if (e && t === i)
    return r.pop(), r;
  for (var s = new Array(i), o = 0, n = 0; n < i; n++)
    n === t && (o = 1), s[n] = r[n + o];
  return s;
}
var pS = br / 4, yS = br / 2, mS = br / 4, am = "@@__IMMUTABLE_LIST__@@";
function lm(r) {
  return !!(r && r[am]);
}
var ah = /* @__PURE__ */ (function(r) {
  function t(e) {
    var i = ru();
    if (e == null)
      return i;
    if (lm(e))
      return e;
    var s = r(e), o = s.size;
    return o === 0 ? i : (lr(o), o > 0 && o < br ? Vl(0, o, yi, null, new jn(s.toArray())) : i.withMutations(function(n) {
      n.setSize(o), s.forEach(function(a, l) {
        return n.set(l, a);
      });
    }));
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, t.prototype.get = function(i, s) {
    if (i = Xn(this, i), i >= 0 && i < this.size) {
      i += this._origin;
      var o = hm(this, i);
      return o && o.array[i & Ns];
    }
    return s;
  }, t.prototype.set = function(i, s) {
    return xS(this, i, s);
  }, t.prototype.remove = function(i) {
    return this.has(i) ? i === 0 ? this.shift() : i === this.size - 1 ? this.pop() : this.splice(i, 1) : this;
  }, t.prototype.insert = function(i, s) {
    return this.splice(i, 0, s);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = yi, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : ru();
  }, t.prototype.push = function() {
    var i = arguments, s = this.size;
    return this.withMutations(function(o) {
      zn(o, 0, s + i.length);
      for (var n = 0; n < i.length; n++)
        o.set(s + n, i[n]);
    });
  }, t.prototype.pop = function() {
    return zn(this, 0, -1);
  }, t.prototype.unshift = function() {
    var i = arguments;
    return this.withMutations(function(s) {
      zn(s, -i.length);
      for (var o = 0; o < i.length; o++)
        s.set(o, i[o]);
    });
  }, t.prototype.shift = function() {
    return zn(this, 1);
  }, t.prototype.concat = function() {
    for (var i = arguments, s = [], o = 0; o < arguments.length; o++) {
      var n = i[o], a = r(
        typeof n != "string" && Vy(n) ? n : [n]
      );
      a.size !== 0 && s.push(a);
    }
    return s.length === 0 ? this : this.size === 0 && !this.__ownerID && s.length === 1 ? this.constructor(s[0]) : this.withMutations(function(l) {
      s.forEach(function(h) {
        return h.forEach(function(u) {
          return l.push(u);
        });
      });
    });
  }, t.prototype.setSize = function(i) {
    return zn(this, 0, i);
  }, t.prototype.map = function(i, s) {
    var o = this;
    return this.withMutations(function(n) {
      for (var a = 0; a < o.size; a++)
        n.set(a, i.call(s, n.get(a), a, o));
    });
  }, t.prototype.slice = function(i, s) {
    var o = this.size;
    return Nu(i, s, o) ? this : zn(
      this,
      eh(i, o),
      Bu(s, o)
    );
  }, t.prototype.__iterator = function(i, s) {
    var o = s ? this.size : 0, n = k0(this, s);
    return new Ke(function() {
      var a = n();
      return a === El ? sr() : wi(i, s ? --o : o++, a);
    });
  }, t.prototype.__iterate = function(i, s) {
    for (var o = s ? this.size : 0, n = k0(this, s), a; (a = n()) !== El && i(a, s ? --o : o++, this) !== !1; )
      ;
    return o;
  }, t.prototype.__ensureOwner = function(i) {
    return i === this.__ownerID ? this : i ? Vl(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      i,
      this.__hash
    ) : this.size === 0 ? ru() : (this.__ownerID = i, this.__altered = !1, this);
  }, t;
})(Po);
ah.isList = lm;
var Ui = ah.prototype;
Ui[am] = !0;
Ui[th] = Ui.remove;
Ui.merge = Ui.concat;
Ui.setIn = rf;
Ui.deleteIn = Ui.removeIn = nf;
Ui.update = of;
Ui.updateIn = af;
Ui.mergeIn = uf;
Ui.mergeDeepIn = cf;
Ui.withMutations = rh;
Ui.wasAltered = df;
Ui.asImmutable = oh;
Ui["@@transducer/init"] = Ui.asMutable = nh;
Ui["@@transducer/step"] = function(r, t) {
  return r.push(t);
};
Ui["@@transducer/result"] = function(r) {
  return r.asImmutable();
};
var jn = function(t, e) {
  this.array = t, this.ownerID = e;
};
jn.prototype.removeBefore = function(t, e, i) {
  if (i === e ? 1 << e : this.array.length === 0)
    return this;
  var s = i >>> e & Ns;
  if (s >= this.array.length)
    return new jn([], t);
  var o = s === 0, n;
  if (e > 0) {
    var a = this.array[s];
    if (n = a && a.removeBefore(t, e - yi, i), n === a && o)
      return this;
  }
  if (o && !n)
    return this;
  var l = da(this, t);
  if (!o)
    for (var h = 0; h < s; h++)
      l.array[h] = void 0;
  return n && (l.array[s] = n), l;
};
jn.prototype.removeAfter = function(t, e, i) {
  if (i === (e ? 1 << e : 0) || this.array.length === 0)
    return this;
  var s = i - 1 >>> e & Ns;
  if (s >= this.array.length)
    return this;
  var o;
  if (e > 0) {
    var n = this.array[s];
    if (o = n && n.removeAfter(t, e - yi, i), o === n && s === this.array.length - 1)
      return this;
  }
  var a = da(this, t);
  return a.array.splice(s + 1), o && (a.array[s] = o), a;
};
var El = {};
function k0(r, t) {
  var e = r._origin, i = r._capacity, s = _l(i), o = r._tail;
  return n(r._root, r._level, 0);
  function n(h, u, c) {
    return u === 0 ? a(h, c) : l(h, u, c);
  }
  function a(h, u) {
    var c = u === s ? o && o.array : h && h.array, d = u > e ? 0 : e - u, f = i - u;
    return f > br && (f = br), function() {
      if (d === f)
        return El;
      var p = t ? --f : d++;
      return c && c[p];
    };
  }
  function l(h, u, c) {
    var d, f = h && h.array, p = c > e ? 0 : e - c >> u, g = (i - c >> u) + 1;
    return g > br && (g = br), function() {
      for (; ; ) {
        if (d) {
          var y = d();
          if (y !== El)
            return y;
          d = null;
        }
        if (p === g)
          return El;
        var m = t ? --g : p++;
        d = n(
          f && f[m],
          u - yi,
          c + (m << u)
        );
      }
    };
  }
}
function Vl(r, t, e, i, s, o, n) {
  var a = Object.create(Ui);
  return a.size = t - r, a._origin = r, a._capacity = t, a._level = e, a._root = i, a._tail = s, a.__ownerID = o, a.__hash = n, a.__altered = !1, a;
}
var D0;
function ru() {
  return D0 || (D0 = Vl(0, 0, yi));
}
function xS(r, t, e) {
  if (t = Xn(r, t), t !== t)
    return r;
  if (t >= r.size || t < 0)
    return r.withMutations(function(n) {
      t < 0 ? zn(n, t).set(0, e) : zn(n, 0, t + 1).set(t, e);
    });
  t += r._origin;
  var i = r._tail, s = r._root, o = sd();
  return t >= _l(r._capacity) ? i = hd(i, r.__ownerID, 0, t, e, o) : s = hd(
    s,
    r.__ownerID,
    r._level,
    t,
    e,
    o
  ), o.value ? r.__ownerID ? (r._root = s, r._tail = i, r.__hash = void 0, r.__altered = !0, r) : Vl(r._origin, r._capacity, r._level, s, i) : r;
}
function hd(r, t, e, i, s, o) {
  var n = i >>> e & Ns, a = r && n < r.array.length;
  if (!a && s === void 0)
    return r;
  var l;
  if (e > 0) {
    var h = r && r.array[n], u = hd(
      h,
      t,
      e - yi,
      i,
      s,
      o
    );
    return u === h ? r : (l = da(r, t), l.array[n] = u, l);
  }
  return a && r.array[n] === s ? r : (o && Er(o), l = da(r, t), s === void 0 && n === l.array.length - 1 ? l.array.pop() : l.array[n] = s, l);
}
function da(r, t) {
  return t && r && t === r.ownerID ? r : new jn(r ? r.array.slice() : [], t);
}
function hm(r, t) {
  if (t >= _l(r._capacity))
    return r._tail;
  if (t < 1 << r._level + yi) {
    for (var e = r._root, i = r._level; e && i > 0; )
      e = e.array[t >>> i & Ns], i -= yi;
    return e;
  }
}
function zn(r, t, e) {
  t !== void 0 && (t |= 0), e !== void 0 && (e |= 0);
  var i = r.__ownerID || new Yd(), s = r._origin, o = r._capacity, n = s + t, a = e === void 0 ? o : e < 0 ? o + e : s + e;
  if (n === s && a === o)
    return r;
  if (n >= a)
    return r.clear();
  for (var l = r._level, h = r._root, u = 0; n + u < 0; )
    h = new jn(
      h && h.array.length ? [void 0, h] : [],
      i
    ), l += yi, u += 1 << l;
  u && (n += u, s += u, a += u, o += u);
  for (var c = _l(o), d = _l(a); d >= 1 << l + yi; )
    h = new jn(
      h && h.array.length ? [h] : [],
      i
    ), l += yi;
  var f = r._tail, p = d < c ? hm(r, a - 1) : d > c ? new jn([], i) : f;
  if (f && d > c && n < o && f.array.length) {
    h = da(h, i);
    for (var g = h, y = l; y > yi; y -= yi) {
      var m = c >>> y & Ns;
      g = g.array[m] = da(g.array[m], i);
    }
    g.array[c >>> yi & Ns] = f;
  }
  if (a < o && (p = p && p.removeAfter(i, 0, a)), n >= d)
    n -= d, a -= d, l = yi, h = null, p = p && p.removeBefore(i, 0, n);
  else if (n > s || d < c) {
    for (u = 0; h; ) {
      var A = n >>> l & Ns;
      if (A !== d >>> l & Ns)
        break;
      A && (u += (1 << l) * A), l -= yi, h = h.array[A];
    }
    h && n > s && (h = h.removeBefore(i, l, n - u)), h && d < c && (h = h.removeAfter(
      i,
      l,
      d - u
    )), u && (n -= u, a -= u);
  }
  return r.__ownerID ? (r.size = a - n, r._origin = n, r._capacity = a, r._level = l, r._root = h, r._tail = p, r.__hash = void 0, r.__altered = !0, r) : Vl(n, a, l, h, p);
}
function _l(r) {
  return r < br ? 0 : r - 1 >>> yi << yi;
}
var Dn = /* @__PURE__ */ (function(r) {
  function t(e) {
    return e == null ? yl() : By(e) ? e : yl().withMutations(function(i) {
      var s = Lr(e);
      lr(s.size), s.forEach(function(o, n) {
        return i.set(n, o);
      });
    });
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, t.prototype.get = function(i, s) {
    var o = this._map.get(i);
    return o !== void 0 ? this._list.get(o)[1] : s;
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : yl();
  }, t.prototype.set = function(i, s) {
    return L0(this, i, s);
  }, t.prototype.remove = function(i) {
    return L0(this, i, Oe);
  }, t.prototype.__iterate = function(i, s) {
    var o = this;
    return this._list.__iterate(
      function(n) {
        return n && i(n[1], n[0], o);
      },
      s
    );
  }, t.prototype.__iterator = function(i, s) {
    return this._list.fromEntrySeq().__iterator(i, s);
  }, t.prototype.__ensureOwner = function(i) {
    if (i === this.__ownerID)
      return this;
    var s = this._map.__ensureOwner(i), o = this._list.__ensureOwner(i);
    return i ? yf(s, o, i, this.__hash) : this.size === 0 ? yl() : (this.__ownerID = i, this.__altered = !1, this._map = s, this._list = o, this);
  }, t;
})(Va);
Dn.isOrderedMap = By;
Dn.prototype[La] = !0;
Dn.prototype[th] = Dn.prototype.remove;
function yf(r, t, e, i) {
  var s = Object.create(Dn.prototype);
  return s.size = r ? r.size : 0, s._map = r, s._list = t, s.__ownerID = e, s.__hash = i, s.__altered = !1, s;
}
var F0;
function yl() {
  return F0 || (F0 = yf(Br(), ru()));
}
function L0(r, t, e) {
  var i = r._map, s = r._list, o = i.get(t), n = o !== void 0, a, l;
  if (e === Oe) {
    if (!n)
      return r;
    s.size >= br && s.size >= i.size * 2 ? (l = s.filter(function(h, u) {
      return h !== void 0 && o !== u;
    }), a = l.toKeyedSeq().map(function(h) {
      return h[0];
    }).flip().toMap(), r.__ownerID && (a.__ownerID = l.__ownerID = r.__ownerID)) : (a = i.remove(t), l = o === s.size - 1 ? s.pop() : s.set(o, void 0));
  } else if (n) {
    if (e === s.get(o)[1])
      return r;
    a = i, l = s.set(o, [t, e]);
  } else
    a = i.set(t, s.size), l = s.set(s.size, [t, e]);
  return r.__ownerID ? (r.size = a.size, r._map = a, r._list = l, r.__hash = void 0, r.__altered = !0, r) : yf(a, l);
}
var um = "@@__IMMUTABLE_STACK__@@";
function ud(r) {
  return !!(r && r[um]);
}
var mf = /* @__PURE__ */ (function(r) {
  function t(e) {
    return e == null ? kh() : ud(e) ? e : kh().pushAll(e);
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, t.prototype.get = function(i, s) {
    var o = this._head;
    for (i = Xn(this, i); o && i--; )
      o = o.next;
    return o ? o.value : s;
  }, t.prototype.peek = function() {
    return this._head && this._head.value;
  }, t.prototype.push = function() {
    var i = arguments;
    if (arguments.length === 0)
      return this;
    for (var s = this.size + arguments.length, o = this._head, n = arguments.length - 1; n >= 0; n--)
      o = {
        value: i[n],
        next: o
      };
    return this.__ownerID ? (this.size = s, this._head = o, this.__hash = void 0, this.__altered = !0, this) : ml(s, o);
  }, t.prototype.pushAll = function(i) {
    if (i = r(i), i.size === 0)
      return this;
    if (this.size === 0 && ud(i))
      return i;
    lr(i.size);
    var s = this.size, o = this._head;
    return i.__iterate(
      function(n) {
        s++, o = {
          value: n,
          next: o
        };
      },
      /* reverse */
      !0
    ), this.__ownerID ? (this.size = s, this._head = o, this.__hash = void 0, this.__altered = !0, this) : ml(s, o);
  }, t.prototype.pop = function() {
    return this.slice(1);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : kh();
  }, t.prototype.slice = function(i, s) {
    if (Nu(i, s, this.size))
      return this;
    var o = eh(i, this.size), n = Bu(s, this.size);
    if (n !== this.size)
      return r.prototype.slice.call(this, i, s);
    for (var a = this.size - o, l = this._head; o--; )
      l = l.next;
    return this.__ownerID ? (this.size = a, this._head = l, this.__hash = void 0, this.__altered = !0, this) : ml(a, l);
  }, t.prototype.__ensureOwner = function(i) {
    return i === this.__ownerID ? this : i ? ml(this.size, this._head, i, this.__hash) : this.size === 0 ? kh() : (this.__ownerID = i, this.__altered = !1, this);
  }, t.prototype.__iterate = function(i, s) {
    var o = this;
    if (s)
      return new wo(this.toArray()).__iterate(
        function(l, h) {
          return i(l, h, o);
        },
        s
      );
    for (var n = 0, a = this._head; a && i(a.value, n++, this) !== !1; )
      a = a.next;
    return n;
  }, t.prototype.__iterator = function(i, s) {
    if (s)
      return new wo(this.toArray()).__iterator(i, s);
    var o = 0, n = this._head;
    return new Ke(function() {
      if (n) {
        var a = n.value;
        return n = n.next, wi(i, o++, a);
      }
      return sr();
    });
  }, t;
})(Po);
mf.isStack = ud;
var Bs = mf.prototype;
Bs[um] = !0;
Bs.shift = Bs.pop;
Bs.unshift = Bs.push;
Bs.unshiftAll = Bs.pushAll;
Bs.withMutations = rh;
Bs.wasAltered = df;
Bs.asImmutable = oh;
Bs["@@transducer/init"] = Bs.asMutable = nh;
Bs["@@transducer/step"] = function(r, t) {
  return r.unshift(t);
};
Bs["@@transducer/result"] = function(r) {
  return r.asImmutable();
};
function ml(r, t, e, i) {
  var s = Object.create(Bs);
  return s.size = r, s._head = t, s.__ownerID = e, s.__hash = i, s.__altered = !1, s;
}
var P0;
function kh() {
  return P0 || (P0 = ml(0));
}
var cm = "@@__IMMUTABLE_SET__@@";
function xf(r) {
  return !!(r && r[cm]);
}
function dm(r) {
  return xf(r) && Ur(r);
}
function fm(r, t) {
  if (r === t)
    return !0;
  if (!ir(t) || r.size !== void 0 && t.size !== void 0 && r.size !== t.size || r.__hash !== void 0 && t.__hash !== void 0 && r.__hash !== t.__hash || Mi(r) !== Mi(t) || qs(r) !== qs(t) || Ur(r) !== Ur(t))
    return !1;
  if (r.size === 0 && t.size === 0)
    return !0;
  var e = !zu(r);
  if (Ur(r)) {
    var i = r.entries();
    return t.every(function(l, h) {
      var u = i.next().value;
      return u && hr(u[1], l) && (e || hr(u[0], h));
    }) && i.next().done;
  }
  var s = !1;
  if (r.size === void 0)
    if (t.size === void 0)
      typeof r.cacheResult == "function" && r.cacheResult();
    else {
      s = !0;
      var o = r;
      r = t, t = o;
    }
  var n = !0, a = t.__iterate(function(l, h) {
    if (e ? !r.has(l) : s ? !hr(l, r.get(h, Oe)) : !hr(r.get(h, Oe), l))
      return n = !1, !1;
  });
  return n && r.size === a;
}
function Ro(r, t) {
  var e = function(i) {
    r.prototype[i] = t[i];
  };
  return Object.keys(t).forEach(e), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(e), r;
}
function xu(r) {
  if (!r || typeof r != "object")
    return r;
  if (!ir(r)) {
    if (!Zn(r))
      return r;
    r = dr(r);
  }
  if (Mi(r)) {
    var t = {};
    return r.__iterate(function(i, s) {
      sh(s) || (t[s] = xu(i));
    }), t;
  }
  var e = [];
  return r.__iterate(function(i) {
    e.push(xu(i));
  }), e;
}
var Yu = /* @__PURE__ */ (function(r) {
  function t(e) {
    return e == null ? xl() : xf(e) && !Ur(e) ? e : xl().withMutations(function(i) {
      var s = r(e);
      lr(s.size), s.forEach(function(o) {
        return i.add(o);
      });
    });
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(i) {
    return this(Lr(i).keySeq());
  }, t.intersect = function(i) {
    return i = _i(i).toArray(), i.length ? cs.intersect.apply(t(i.pop()), i) : xl();
  }, t.union = function(i) {
    return i = _i(i).toArray(), i.length ? cs.union.apply(t(i.pop()), i) : xl();
  }, t.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, t.prototype.has = function(i) {
    return this._map.has(i);
  }, t.prototype.add = function(i) {
    return Dh(this, this._map.set(i, i));
  }, t.prototype.remove = function(i) {
    return Dh(this, this._map.remove(i));
  }, t.prototype.clear = function() {
    return Dh(this, this._map.clear());
  }, t.prototype.map = function(i, s) {
    var o = this, n = !1, a = Dh(
      this,
      this._map.mapEntries(function(l) {
        var h = l[1], u = i.call(s, h, h, o);
        return u !== h && (n = !0), [u, u];
      }, s)
    );
    return n ? a : this;
  }, t.prototype.union = function() {
    for (var i = [], s = arguments.length; s--; ) i[s] = arguments[s];
    return i = i.filter(function(o) {
      return o.size !== 0;
    }), i.length === 0 ? this : this.size === 0 && !this.__ownerID && i.length === 1 ? this.constructor(i[0]) : this.withMutations(function(o) {
      for (var n = 0; n < i.length; n++)
        typeof i[n] == "string" ? o.add(i[n]) : r(i[n]).forEach(function(a) {
          return o.add(a);
        });
    });
  }, t.prototype.intersect = function() {
    for (var i = [], s = arguments.length; s--; ) i[s] = arguments[s];
    if (i.length === 0)
      return this;
    i = i.map(function(n) {
      return r(n);
    });
    var o = [];
    return this.forEach(function(n) {
      i.every(function(a) {
        return a.includes(n);
      }) || o.push(n);
    }), this.withMutations(function(n) {
      o.forEach(function(a) {
        n.remove(a);
      });
    });
  }, t.prototype.subtract = function() {
    for (var i = [], s = arguments.length; s--; ) i[s] = arguments[s];
    if (i.length === 0)
      return this;
    i = i.map(function(n) {
      return r(n);
    });
    var o = [];
    return this.forEach(function(n) {
      i.some(function(a) {
        return a.includes(n);
      }) && o.push(n);
    }), this.withMutations(function(n) {
      o.forEach(function(a) {
        n.remove(a);
      });
    });
  }, t.prototype.sort = function(i) {
    return Ol(ha(this, i));
  }, t.prototype.sortBy = function(i, s) {
    return Ol(ha(this, s, i));
  }, t.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, t.prototype.__iterate = function(i, s) {
    var o = this;
    return this._map.__iterate(function(n) {
      return i(n, n, o);
    }, s);
  }, t.prototype.__iterator = function(i, s) {
    return this._map.__iterator(i, s);
  }, t.prototype.__ensureOwner = function(i) {
    if (i === this.__ownerID)
      return this;
    var s = this._map.__ensureOwner(i);
    return i ? this.__make(s, i) : this.size === 0 ? this.__empty() : (this.__ownerID = i, this._map = s, this);
  }, t;
})(Da);
Yu.isSet = xf;
var cs = Yu.prototype;
cs[cm] = !0;
cs[th] = cs.remove;
cs.merge = cs.concat = cs.union;
cs.withMutations = rh;
cs.asImmutable = oh;
cs["@@transducer/init"] = cs.asMutable = nh;
cs["@@transducer/step"] = function(r, t) {
  return r.add(t);
};
cs["@@transducer/result"] = function(r) {
  return r.asImmutable();
};
cs.__empty = xl;
cs.__make = gm;
function Dh(r, t) {
  return r.__ownerID ? (r.size = t.size, r._map = t, r) : t === r._map ? r : t.size === 0 ? r.__empty() : r.__make(t);
}
function gm(r, t) {
  var e = Object.create(cs);
  return e.size = r ? r.size : 0, e._map = r, e.__ownerID = t, e;
}
var R0;
function xl() {
  return R0 || (R0 = gm(Br()));
}
var vS = /* @__PURE__ */ (function(r) {
  function t(e, i, s) {
    if (!(this instanceof t))
      return new t(e, i, s);
    if (sf(s !== 0, "Cannot step a Range by 0"), e = e || 0, i === void 0 && (i = 1 / 0), s = s === void 0 ? 1 : Math.abs(s), i < e && (s = -s), this._start = e, this._end = i, this._step = s, this.size = Math.max(0, Math.ceil((i - e) / s - 1) + 1), this.size === 0) {
      if (Sc)
        return Sc;
      Sc = this;
    }
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, t.prototype.get = function(i, s) {
    return this.has(i) ? this._start + Xn(this, i) * this._step : s;
  }, t.prototype.includes = function(i) {
    var s = (i - this._start) / this._step;
    return s >= 0 && s < this.size && s === Math.floor(s);
  }, t.prototype.slice = function(i, s) {
    return Nu(i, s, this.size) ? this : (i = eh(i, this.size), s = Bu(s, this.size), s <= i ? new t(0, 0) : new t(
      this.get(i, this._end),
      this.get(s, this._end),
      this._step
    ));
  }, t.prototype.indexOf = function(i) {
    var s = i - this._start;
    if (s % this._step === 0) {
      var o = s / this._step;
      if (o >= 0 && o < this.size)
        return o;
    }
    return -1;
  }, t.prototype.lastIndexOf = function(i) {
    return this.indexOf(i);
  }, t.prototype.__iterate = function(i, s) {
    for (var o = this.size, n = this._step, a = s ? this._start + (o - 1) * n : this._start, l = 0; l !== o && i(a, s ? o - ++l : l++, this) !== !1; )
      a += s ? -n : n;
    return l;
  }, t.prototype.__iterator = function(i, s) {
    var o = this.size, n = this._step, a = s ? this._start + (o - 1) * n : this._start, l = 0;
    return new Ke(function() {
      if (l === o)
        return sr();
      var h = a;
      return a += s ? -n : n, wi(i, s ? o - ++l : l++, h);
    });
  }, t.prototype.equals = function(i) {
    return i instanceof t ? this._start === i._start && this._end === i._end && this._step === i._step : fm(this, i);
  }, t;
})($r), Sc;
function pm(r, t, e) {
  for (var i = Ky(t), s = 0; s !== i.length; )
    if (r = qy(r, i[s++], Oe), r === Oe)
      return e;
  return r;
}
function ym(r, t) {
  return pm(this, r, t);
}
function SS(r, t) {
  return pm(r, t, Oe) !== Oe;
}
function AS(r) {
  return SS(this, r);
}
function mm() {
  lr(this.size);
  var r = {};
  return this.__iterate(function(t, e) {
    sh(e) || (r[e] = t);
  }), r;
}
_i.isIterable = ir;
_i.isKeyed = Mi;
_i.isIndexed = qs;
_i.isAssociative = zu;
_i.isOrdered = Ur;
_i.Iterator = Ke;
Ro(_i, {
  // ### Conversion to other types
  toArray: function() {
    lr(this.size);
    var t = new Array(this.size || 0), e = Mi(this), i = 0;
    return this.__iterate(function(s, o) {
      t[i++] = e ? [o, s] : s;
    }), t;
  },
  toIndexedSeq: function() {
    return new Wy(this);
  },
  toJS: function() {
    return xu(this);
  },
  toKeyedSeq: function() {
    return new Hu(this, !0);
  },
  toMap: function() {
    return Va(this.toKeyedSeq());
  },
  toObject: mm,
  toOrderedMap: function() {
    return Dn(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Ol(Mi(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return Yu(Mi(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new Gy(this);
  },
  toSeq: function() {
    return qs(this) ? this.toIndexedSeq() : Mi(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return mf(Mi(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return ah(Mi(this) ? this.valueSeq() : this);
  },
  // ### Common JavaScript methods and properties
  toString: function() {
    return "[Collection]";
  },
  __toString: function(t, e) {
    return this.size === 0 ? t + e : t + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  concat: function() {
    for (var t = [], e = arguments.length; e--; ) t[e] = arguments[e];
    return ai(this, qv(this, t));
  },
  includes: function(t) {
    return this.some(function(e) {
      return hr(e, t);
    });
  },
  entries: function() {
    return this.__iterator(Dr);
  },
  every: function(t, e) {
    lr(this.size);
    var i = !0;
    return this.__iterate(function(s, o, n) {
      if (!t.call(e, s, o, n))
        return i = !1, !1;
    }), i;
  },
  filter: function(t, e) {
    return ai(this, jy(this, t, e, !0));
  },
  partition: function(t, e) {
    return Zv(this, t, e);
  },
  find: function(t, e, i) {
    var s = this.findEntry(t, e);
    return s ? s[1] : i;
  },
  forEach: function(t, e) {
    return lr(this.size), this.__iterate(e ? t.bind(e) : t);
  },
  join: function(t) {
    lr(this.size), t = t !== void 0 ? "" + t : ",";
    var e = "", i = !0;
    return this.__iterate(function(s) {
      i ? i = !1 : e += t, e += s != null ? s.toString() : "";
    }), e;
  },
  keys: function() {
    return this.__iterator(ih);
  },
  map: function(t, e) {
    return ai(this, Yy(this, t, e));
  },
  reduce: function(t, e, i) {
    return I0(
      this,
      t,
      e,
      i,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(t, e, i) {
    return I0(
      this,
      t,
      e,
      i,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return ai(this, Jd(this, !0));
  },
  slice: function(t, e) {
    return ai(this, Qd(this, t, e, !0));
  },
  some: function(t, e) {
    lr(this.size);
    var i = !1;
    return this.__iterate(function(s, o, n) {
      if (t.call(e, s, o, n))
        return i = !0, !1;
    }), i;
  },
  sort: function(t) {
    return ai(this, ha(this, t));
  },
  values: function() {
    return this.__iterator(Yr);
  },
  // ### More sequential methods
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(t, e) {
    return la(
      t ? this.toSeq().filter(t, e) : this
    );
  },
  countBy: function(t, e) {
    return $v(this, t, e);
  },
  equals: function(t) {
    return fm(this, t);
  },
  entrySeq: function() {
    var t = this;
    if (t._cache)
      return new wo(t._cache);
    var e = t.toSeq().map(ES).toIndexedSeq();
    return e.fromEntrySeq = function() {
      return t.toSeq();
    }, e;
  },
  filterNot: function(t, e) {
    return this.filter(Ac(t), e);
  },
  findEntry: function(t, e, i) {
    var s = i;
    return this.__iterate(function(o, n, a) {
      if (t.call(e, o, n, a))
        return s = [n, o], !1;
    }), s;
  },
  findKey: function(t, e) {
    var i = this.findEntry(t, e);
    return i && i[0];
  },
  findLast: function(t, e, i) {
    return this.toKeyedSeq().reverse().find(t, e, i);
  },
  findLastEntry: function(t, e, i) {
    return this.toKeyedSeq().reverse().findEntry(t, e, i);
  },
  findLastKey: function(t, e) {
    return this.toKeyedSeq().reverse().findKey(t, e);
  },
  first: function(t) {
    return this.find(wy, null, t);
  },
  flatMap: function(t, e) {
    return ai(this, Jv(this, t, e));
  },
  flatten: function(t) {
    return ai(this, Xy(this, t, !0));
  },
  fromEntrySeq: function() {
    return new Uy(this);
  },
  get: function(t, e) {
    return this.find(function(i, s) {
      return hr(s, t);
    }, void 0, e);
  },
  getIn: ym,
  groupBy: function(t, e) {
    return Xv(this, t, e);
  },
  has: function(t) {
    return this.get(t, Oe) !== Oe;
  },
  hasIn: AS,
  isSubset: function(t) {
    return t = typeof t.includes == "function" ? t : _i(t), this.every(function(e) {
      return t.includes(e);
    });
  },
  isSuperset: function(t) {
    return t = typeof t.isSubset == "function" ? t : _i(t), t.isSubset(this);
  },
  keyOf: function(t) {
    return this.findKey(function(e) {
      return hr(e, t);
    });
  },
  keySeq: function() {
    return this.toSeq().map(bS).toIndexedSeq();
  },
  last: function(t) {
    return this.toSeq().reverse().first(t);
  },
  lastKeyOf: function(t) {
    return this.toKeyedSeq().reverse().keyOf(t);
  },
  max: function(t) {
    return wh(this, t);
  },
  maxBy: function(t, e) {
    return wh(this, e, t);
  },
  min: function(t) {
    return wh(
      this,
      t ? V0(t) : O0
    );
  },
  minBy: function(t, e) {
    return wh(
      this,
      e ? V0(e) : O0,
      t
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(t) {
    return t === 0 ? this : this.slice(Math.max(0, t));
  },
  skipLast: function(t) {
    return t === 0 ? this : this.slice(0, -Math.max(0, t));
  },
  skipWhile: function(t, e) {
    return ai(this, $y(this, t, e, !0));
  },
  skipUntil: function(t, e) {
    return this.skipWhile(Ac(t), e);
  },
  sortBy: function(t, e) {
    return ai(this, ha(this, e, t));
  },
  take: function(t) {
    return this.slice(0, Math.max(0, t));
  },
  takeLast: function(t) {
    return this.slice(-Math.max(0, t));
  },
  takeWhile: function(t, e) {
    return ai(this, Kv(this, t, e));
  },
  takeUntil: function(t, e) {
    return this.takeWhile(Ac(t), e);
  },
  update: function(t) {
    return t(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  // ### Hashable Object
  hashCode: function() {
    return this.__hash || (this.__hash = MS(this));
  }
  // ### Internal
  // abstract __iterate(fn, reverse)
  // abstract __iterator(type, reverse)
});
var Ds = _i.prototype;
Ds[Dy] = !0;
Ds[Wu] = Ds.values;
Ds.toJSON = Ds.toArray;
Ds.__toStringMapper = Pl;
Ds.inspect = Ds.toSource = function() {
  return this.toString();
};
Ds.chain = Ds.flatMap;
Ds.contains = Ds.includes;
Ro(Lr, {
  // ### More sequential methods
  flip: function() {
    return ai(this, Hy(this));
  },
  mapEntries: function(t, e) {
    var i = this, s = 0;
    return ai(
      this,
      this.toSeq().map(function(o, n) {
        return t.call(e, [n, o], s++, i);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(t, e) {
    var i = this;
    return ai(
      this,
      this.toSeq().flip().map(function(s, o) {
        return t.call(e, s, o, i);
      }).flip()
    );
  }
});
var lh = Lr.prototype;
lh[Fy] = !0;
lh[Wu] = Ds.entries;
lh.toJSON = mm;
lh.__toStringMapper = function(r, t) {
  return Pl(t) + ": " + Pl(r);
};
Ro(Po, {
  // ### Conversion to other types
  toKeyedSeq: function() {
    return new Hu(this, !1);
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  filter: function(t, e) {
    return ai(this, jy(this, t, e, !1));
  },
  findIndex: function(t, e) {
    var i = this.findEntry(t, e);
    return i ? i[0] : -1;
  },
  indexOf: function(t) {
    var e = this.keyOf(t);
    return e === void 0 ? -1 : e;
  },
  lastIndexOf: function(t) {
    var e = this.lastKeyOf(t);
    return e === void 0 ? -1 : e;
  },
  reverse: function() {
    return ai(this, Jd(this, !1));
  },
  slice: function(t, e) {
    return ai(this, Qd(this, t, e, !1));
  },
  splice: function(t, e) {
    var i = arguments.length;
    if (e = Math.max(e || 0, 0), i === 0 || i === 2 && !e)
      return this;
    t = eh(t, t < 0 ? this.count() : this.size);
    var s = this.slice(0, t);
    return ai(
      this,
      i === 1 ? s : s.concat(on(arguments, 2), this.slice(t + e))
    );
  },
  // ### More collection methods
  findLastIndex: function(t, e) {
    var i = this.findLastEntry(t, e);
    return i ? i[0] : -1;
  },
  first: function(t) {
    return this.get(0, t);
  },
  flatten: function(t) {
    return ai(this, Xy(this, t, !1));
  },
  get: function(t, e) {
    return t = Xn(this, t), t < 0 || this.size === 1 / 0 || this.size !== void 0 && t > this.size ? e : this.find(function(i, s) {
      return s === t;
    }, void 0, e);
  },
  has: function(t) {
    return t = Xn(this, t), t >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || t < this.size : this.indexOf(t) !== -1);
  },
  interpose: function(t) {
    return ai(this, Qv(this, t));
  },
  interleave: function() {
    var t = [this].concat(on(arguments)), e = Th(this.toSeq(), $r.of, t), i = e.flatten(!0);
    return e.size && (i.size = e.size * t.length), ai(this, i);
  },
  keySeq: function() {
    return vS(0, this.size);
  },
  last: function(t) {
    return this.get(-1, t);
  },
  skipWhile: function(t, e) {
    return ai(this, $y(this, t, e, !1));
  },
  zip: function() {
    var t = [this].concat(on(arguments));
    return ai(this, Th(this, _0, t));
  },
  zipAll: function() {
    var t = [this].concat(on(arguments));
    return ai(this, Th(this, _0, t, !0));
  },
  zipWith: function(t) {
    var e = on(arguments);
    return e[0] = this, ai(this, Th(this, t, e));
  }
});
var _a = Po.prototype;
_a[Ly] = !0;
_a[La] = !0;
Ro(Da, {
  // ### ES6 Collection methods (ES6 Array and Map)
  get: function(t, e) {
    return this.has(t) ? t : e;
  },
  includes: function(t) {
    return this.has(t);
  },
  // ### More sequential methods
  keySeq: function() {
    return this.valueSeq();
  }
});
var fa = Da.prototype;
fa.has = Ds.includes;
fa.contains = fa.includes;
fa.keys = fa.values;
Ro(so, lh);
Ro($r, _a);
Ro(Ra, fa);
function I0(r, t, e, i, s, o) {
  return lr(r.size), r.__iterate(function(n, a, l) {
    s ? (s = !1, e = n) : e = t.call(i, e, n, a, l);
  }, o), e;
}
function bS(r, t) {
  return t;
}
function ES(r, t) {
  return [t, r];
}
function Ac(r) {
  return function() {
    return !r.apply(this, arguments);
  };
}
function V0(r) {
  return function() {
    return -r.apply(this, arguments);
  };
}
function _0() {
  return on(arguments);
}
function O0(r, t) {
  return r < t ? 1 : r > t ? -1 : 0;
}
function MS(r) {
  if (r.size === 1 / 0)
    return 0;
  var t = Ur(r), e = Mi(r), i = t ? 1 : 0, s = r.__iterate(
    e ? t ? function(o, n) {
      i = 31 * i + N0(ar(o), ar(n)) | 0;
    } : function(o, n) {
      i = i + N0(ar(o), ar(n)) | 0;
    } : t ? function(o) {
      i = 31 * i + ar(o) | 0;
    } : function(o) {
      i = i + ar(o) | 0;
    }
  );
  return CS(s, i);
}
function CS(r, t) {
  return t = nl(t, 3432918353), t = nl(t << 15 | t >>> -15, 461845907), t = nl(t << 13 | t >>> -13, 5), t = (t + 3864292196 | 0) ^ r, t = nl(t ^ t >>> 16, 2246822507), t = nl(t ^ t >>> 13, 3266489909), t = Uu(t ^ t >>> 16), t;
}
function N0(r, t) {
  return r ^ t + 2654435769 + (r << 6) + (r >> 2) | 0;
}
var Ol = /* @__PURE__ */ (function(r) {
  function t(e) {
    return e == null ? cd() : dm(e) ? e : cd().withMutations(function(i) {
      var s = Da(e);
      lr(s.size), s.forEach(function(o) {
        return i.add(o);
      });
    });
  }
  return r && (t.__proto__ = r), t.prototype = Object.create(r && r.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(i) {
    return this(Lr(i).keySeq());
  }, t.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, t;
})(Yu);
Ol.isOrderedSet = dm;
var Io = Ol.prototype;
Io[La] = !0;
Io.zip = _a.zip;
Io.zipWith = _a.zipWith;
Io.zipAll = _a.zipAll;
Io.__empty = cd;
Io.__make = xm;
function xm(r, t) {
  var e = Object.create(Io);
  return e.size = r ? r.size : 0, e._map = r, e.__ownerID = t, e;
}
var B0;
function cd() {
  return B0 || (B0 = xm(yl()));
}
function wS(r) {
  if (Fa(r))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (pn(r))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (r === null || typeof r != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var De = function(t, e) {
  var i;
  wS(t);
  var s = function(a) {
    var l = this;
    if (a instanceof s)
      return a;
    if (!(this instanceof s))
      return new s(a);
    if (!i) {
      i = !0;
      var h = Object.keys(t), u = o._indices = {};
      o._name = e, o._keys = h, o._defaultValues = t;
      for (var c = 0; c < h.length; c++) {
        var d = h[c];
        u[d] = c, o[d] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + Sf(this) + ' with property "' + d + '" since that property name is part of the Record API.'
        ) : TS(o, d);
      }
    }
    return this.__ownerID = void 0, this._values = ah().withMutations(function(f) {
      f.setSize(l._keys.length), Lr(a).forEach(function(p, g) {
        f.set(l._indices[g], p === l._defaultValues[g] ? void 0 : p);
      });
    }), this;
  }, o = s.prototype = Object.create(fi);
  return o.constructor = s, e && (s.displayName = e), s;
};
De.prototype.toString = function() {
  for (var t = Sf(this) + " { ", e = this._keys, i, s = 0, o = e.length; s !== o; s++)
    i = e[s], t += (s ? ", " : "") + i + ": " + Pl(this.get(i));
  return t + " }";
};
De.prototype.equals = function(t) {
  return this === t || Fa(t) && ga(this).equals(ga(t));
};
De.prototype.hashCode = function() {
  return ga(this).hashCode();
};
De.prototype.has = function(t) {
  return this._indices.hasOwnProperty(t);
};
De.prototype.get = function(t, e) {
  if (!this.has(t))
    return e;
  var i = this._indices[t], s = this._values.get(i);
  return s === void 0 ? this._defaultValues[t] : s;
};
De.prototype.set = function(t, e) {
  if (this.has(t)) {
    var i = this._values.set(
      this._indices[t],
      e === this._defaultValues[t] ? void 0 : e
    );
    if (i !== this._values && !this.__ownerID)
      return vf(this, i);
  }
  return this;
};
De.prototype.remove = function(t) {
  return this.set(t);
};
De.prototype.clear = function() {
  var t = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : vf(this, t);
};
De.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
De.prototype.toSeq = function() {
  return ga(this);
};
De.prototype.toJS = function() {
  return xu(this);
};
De.prototype.entries = function() {
  return this.__iterator(Dr);
};
De.prototype.__iterator = function(t, e) {
  return ga(this).__iterator(t, e);
};
De.prototype.__iterate = function(t, e) {
  return ga(this).__iterate(t, e);
};
De.prototype.__ensureOwner = function(t) {
  if (t === this.__ownerID)
    return this;
  var e = this._values.__ensureOwner(t);
  return t ? vf(this, e, t) : (this.__ownerID = t, this._values = e, this);
};
De.isRecord = Fa;
De.getDescriptiveName = Sf;
var fi = De.prototype;
fi[Ry] = !0;
fi[th] = fi.remove;
fi.deleteIn = fi.removeIn = nf;
fi.getIn = ym;
fi.hasIn = Ds.hasIn;
fi.merge = tm;
fi.mergeWith = em;
fi.mergeIn = uf;
fi.mergeDeep = sm;
fi.mergeDeepWith = rm;
fi.mergeDeepIn = cf;
fi.setIn = rf;
fi.update = of;
fi.updateIn = af;
fi.withMutations = rh;
fi.asMutable = nh;
fi.asImmutable = oh;
fi[Wu] = fi.entries;
fi.toJSON = fi.toObject = Ds.toObject;
fi.inspect = fi.toSource = function() {
  return this.toString();
};
function vf(r, t, e) {
  var i = Object.create(Object.getPrototypeOf(r));
  return i._values = t, i.__ownerID = e, i;
}
function Sf(r) {
  return r.constructor.displayName || r.constructor.name || "Record";
}
function ga(r) {
  return Zd(r._keys.map(function(t) {
    return [t, r.get(t)];
  }));
}
function TS(r, t) {
  try {
    Object.defineProperty(r, t, {
      get: function() {
        return this.get(t);
      },
      set: function(e) {
        sf(this.__ownerID, "Cannot set on an immutable record."), this.set(t, e);
      }
    });
  } catch {
  }
}
var Fh = { exports: {} }, z0;
function kS() {
  if (z0) return Fh.exports;
  z0 = 1, Fh.exports = r, Fh.exports.default = r;
  function r(F, D, P) {
    P = P || 2;
    var V = D && D.length, _ = V ? D[0] * P : F.length, O = t(F, 0, _, P, !0), B = [];
    if (!O || O.next === O.prev) return B;
    var z, W, G, Y, U, $, Z;
    if (V && (O = l(F, D, O, P)), F.length > 80 * P) {
      z = G = F[0], W = Y = F[1];
      for (var q = P; q < _; q += P)
        U = F[q], $ = F[q + 1], U < z && (z = U), $ < W && (W = $), U > G && (G = U), $ > Y && (Y = $);
      Z = Math.max(G - z, Y - W), Z = Z !== 0 ? 32767 / Z : 0;
    }
    return i(O, B, P, z, W, Z, 0), B;
  }
  function t(F, D, P, V, _) {
    var O, B;
    if (_ === I(F, D, P, V) > 0)
      for (O = D; O < P; O += V) B = S(O, F[O], F[O + 1], B);
    else
      for (O = P - V; O >= D; O -= V) B = S(O, F[O], F[O + 1], B);
    return B && b(B, B.next) && (E(B), B = B.next), B;
  }
  function e(F, D) {
    if (!F) return F;
    D || (D = F);
    var P = F, V;
    do
      if (V = !1, !P.steiner && (b(P, P.next) || v(P.prev, P, P.next) === 0)) {
        if (E(P), P = D = P.prev, P === P.next) break;
        V = !0;
      } else
        P = P.next;
    while (V || P !== D);
    return D;
  }
  function i(F, D, P, V, _, O, B) {
    if (F) {
      !B && O && f(F, V, _, O);
      for (var z = F, W, G; F.prev !== F.next; ) {
        if (W = F.prev, G = F.next, O ? o(F, V, _, O) : s(F)) {
          D.push(W.i / P | 0), D.push(F.i / P | 0), D.push(G.i / P | 0), E(F), F = G.next, z = G.next;
          continue;
        }
        if (F = G, F === z) {
          B ? B === 1 ? (F = n(e(F), D, P), i(F, D, P, V, _, O, 2)) : B === 2 && a(F, D, P, V, _, O) : i(e(F), D, P, V, _, O, 1);
          break;
        }
      }
    }
  }
  function s(F) {
    var D = F.prev, P = F, V = F.next;
    if (v(D, P, V) >= 0) return !1;
    for (var _ = D.x, O = P.x, B = V.x, z = D.y, W = P.y, G = V.y, Y = _ < O ? _ < B ? _ : B : O < B ? O : B, U = z < W ? z < G ? z : G : W < G ? W : G, $ = _ > O ? _ > B ? _ : B : O > B ? O : B, Z = z > W ? z > G ? z : G : W > G ? W : G, q = V.next; q !== D; ) {
      if (q.x >= Y && q.x <= $ && q.y >= U && q.y <= Z && m(_, z, O, W, B, G, q.x, q.y) && v(q.prev, q, q.next) >= 0) return !1;
      q = q.next;
    }
    return !0;
  }
  function o(F, D, P, V) {
    var _ = F.prev, O = F, B = F.next;
    if (v(_, O, B) >= 0) return !1;
    for (var z = _.x, W = O.x, G = B.x, Y = _.y, U = O.y, $ = B.y, Z = z < W ? z < G ? z : G : W < G ? W : G, q = Y < U ? Y < $ ? Y : $ : U < $ ? U : $, Q = z > W ? z > G ? z : G : W > G ? W : G, nt = Y > U ? Y > $ ? Y : $ : U > $ ? U : $, et = g(Z, q, D, P, V), it = g(Q, nt, D, P, V), rt = F.prevZ, tt = F.nextZ; rt && rt.z >= et && tt && tt.z <= it; ) {
      if (rt.x >= Z && rt.x <= Q && rt.y >= q && rt.y <= nt && rt !== _ && rt !== B && m(z, Y, W, U, G, $, rt.x, rt.y) && v(rt.prev, rt, rt.next) >= 0 || (rt = rt.prevZ, tt.x >= Z && tt.x <= Q && tt.y >= q && tt.y <= nt && tt !== _ && tt !== B && m(z, Y, W, U, G, $, tt.x, tt.y) && v(tt.prev, tt, tt.next) >= 0)) return !1;
      tt = tt.nextZ;
    }
    for (; rt && rt.z >= et; ) {
      if (rt.x >= Z && rt.x <= Q && rt.y >= q && rt.y <= nt && rt !== _ && rt !== B && m(z, Y, W, U, G, $, rt.x, rt.y) && v(rt.prev, rt, rt.next) >= 0) return !1;
      rt = rt.prevZ;
    }
    for (; tt && tt.z <= it; ) {
      if (tt.x >= Z && tt.x <= Q && tt.y >= q && tt.y <= nt && tt !== _ && tt !== B && m(z, Y, W, U, G, $, tt.x, tt.y) && v(tt.prev, tt, tt.next) >= 0) return !1;
      tt = tt.nextZ;
    }
    return !0;
  }
  function n(F, D, P) {
    var V = F;
    do {
      var _ = V.prev, O = V.next.next;
      !b(_, O) && w(_, V, V.next, O) && x(_, O) && x(O, _) && (D.push(_.i / P | 0), D.push(V.i / P | 0), D.push(O.i / P | 0), E(V), E(V.next), V = F = O), V = V.next;
    } while (V !== F);
    return e(V);
  }
  function a(F, D, P, V, _, O) {
    var B = F;
    do {
      for (var z = B.next.next; z !== B.prev; ) {
        if (B.i !== z.i && A(B, z)) {
          var W = C(B, z);
          B = e(B, B.next), W = e(W, W.next), i(B, D, P, V, _, O, 0), i(W, D, P, V, _, O, 0);
          return;
        }
        z = z.next;
      }
      B = B.next;
    } while (B !== F);
  }
  function l(F, D, P, V) {
    var _ = [], O, B, z, W, G;
    for (O = 0, B = D.length; O < B; O++)
      z = D[O] * V, W = O < B - 1 ? D[O + 1] * V : F.length, G = t(F, z, W, V, !1), G === G.next && (G.steiner = !0), _.push(y(G));
    for (_.sort(h), O = 0; O < _.length; O++)
      P = u(_[O], P);
    return P;
  }
  function h(F, D) {
    return F.x - D.x;
  }
  function u(F, D) {
    var P = c(F, D);
    if (!P)
      return D;
    var V = C(P, F);
    return e(V, V.next), e(P, P.next);
  }
  function c(F, D) {
    var P = D, V = F.x, _ = F.y, O = -1 / 0, B;
    do {
      if (_ <= P.y && _ >= P.next.y && P.next.y !== P.y) {
        var z = P.x + (_ - P.y) * (P.next.x - P.x) / (P.next.y - P.y);
        if (z <= V && z > O && (O = z, B = P.x < P.next.x ? P : P.next, z === V))
          return B;
      }
      P = P.next;
    } while (P !== D);
    if (!B) return null;
    var W = B, G = B.x, Y = B.y, U = 1 / 0, $;
    P = B;
    do
      V >= P.x && P.x >= G && V !== P.x && m(_ < Y ? V : O, _, G, Y, _ < Y ? O : V, _, P.x, P.y) && ($ = Math.abs(_ - P.y) / (V - P.x), x(P, F) && ($ < U || $ === U && (P.x > B.x || P.x === B.x && d(B, P))) && (B = P, U = $)), P = P.next;
    while (P !== W);
    return B;
  }
  function d(F, D) {
    return v(F.prev, F, D.prev) < 0 && v(D.next, F, F.next) < 0;
  }
  function f(F, D, P, V) {
    var _ = F;
    do
      _.z === 0 && (_.z = g(_.x, _.y, D, P, V)), _.prevZ = _.prev, _.nextZ = _.next, _ = _.next;
    while (_ !== F);
    _.prevZ.nextZ = null, _.prevZ = null, p(_);
  }
  function p(F) {
    var D, P, V, _, O, B, z, W, G = 1;
    do {
      for (P = F, F = null, O = null, B = 0; P; ) {
        for (B++, V = P, z = 0, D = 0; D < G && (z++, V = V.nextZ, !!V); D++)
          ;
        for (W = G; z > 0 || W > 0 && V; )
          z !== 0 && (W === 0 || !V || P.z <= V.z) ? (_ = P, P = P.nextZ, z--) : (_ = V, V = V.nextZ, W--), O ? O.nextZ = _ : F = _, _.prevZ = O, O = _;
        P = V;
      }
      O.nextZ = null, G *= 2;
    } while (B > 1);
    return F;
  }
  function g(F, D, P, V, _) {
    return F = (F - P) * _ | 0, D = (D - V) * _ | 0, F = (F | F << 8) & 16711935, F = (F | F << 4) & 252645135, F = (F | F << 2) & 858993459, F = (F | F << 1) & 1431655765, D = (D | D << 8) & 16711935, D = (D | D << 4) & 252645135, D = (D | D << 2) & 858993459, D = (D | D << 1) & 1431655765, F | D << 1;
  }
  function y(F) {
    var D = F, P = F;
    do
      (D.x < P.x || D.x === P.x && D.y < P.y) && (P = D), D = D.next;
    while (D !== F);
    return P;
  }
  function m(F, D, P, V, _, O, B, z) {
    return (_ - B) * (D - z) >= (F - B) * (O - z) && (F - B) * (V - z) >= (P - B) * (D - z) && (P - B) * (O - z) >= (_ - B) * (V - z);
  }
  function A(F, D) {
    return F.next.i !== D.i && F.prev.i !== D.i && !L(F, D) && // dones't intersect other edges
    (x(F, D) && x(D, F) && M(F, D) && // locally visible
    (v(F.prev, F, D.prev) || v(F, D.prev, D)) || // does not create opposite-facing sectors
    b(F, D) && v(F.prev, F, F.next) > 0 && v(D.prev, D, D.next) > 0);
  }
  function v(F, D, P) {
    return (D.y - F.y) * (P.x - D.x) - (D.x - F.x) * (P.y - D.y);
  }
  function b(F, D) {
    return F.x === D.x && F.y === D.y;
  }
  function w(F, D, P, V) {
    var _ = R(v(F, D, P)), O = R(v(F, D, V)), B = R(v(P, V, F)), z = R(v(P, V, D));
    return !!(_ !== O && B !== z || _ === 0 && k(F, P, D) || O === 0 && k(F, V, D) || B === 0 && k(P, F, V) || z === 0 && k(P, D, V));
  }
  function k(F, D, P) {
    return D.x <= Math.max(F.x, P.x) && D.x >= Math.min(F.x, P.x) && D.y <= Math.max(F.y, P.y) && D.y >= Math.min(F.y, P.y);
  }
  function R(F) {
    return F > 0 ? 1 : F < 0 ? -1 : 0;
  }
  function L(F, D) {
    var P = F;
    do {
      if (P.i !== F.i && P.next.i !== F.i && P.i !== D.i && P.next.i !== D.i && w(P, P.next, F, D)) return !0;
      P = P.next;
    } while (P !== F);
    return !1;
  }
  function x(F, D) {
    return v(F.prev, F, F.next) < 0 ? v(F, D, F.next) >= 0 && v(F, F.prev, D) >= 0 : v(F, D, F.prev) < 0 || v(F, F.next, D) < 0;
  }
  function M(F, D) {
    var P = F, V = !1, _ = (F.x + D.x) / 2, O = (F.y + D.y) / 2;
    do
      P.y > O != P.next.y > O && P.next.y !== P.y && _ < (P.next.x - P.x) * (O - P.y) / (P.next.y - P.y) + P.x && (V = !V), P = P.next;
    while (P !== F);
    return V;
  }
  function C(F, D) {
    var P = new T(F.i, F.x, F.y), V = new T(D.i, D.x, D.y), _ = F.next, O = D.prev;
    return F.next = D, D.prev = F, P.next = _, _.prev = P, V.next = P, P.prev = V, O.next = V, V.prev = O, V;
  }
  function S(F, D, P, V) {
    var _ = new T(F, D, P);
    return V ? (_.next = V.next, _.prev = V, V.next.prev = _, V.next = _) : (_.prev = _, _.next = _), _;
  }
  function E(F) {
    F.next.prev = F.prev, F.prev.next = F.next, F.prevZ && (F.prevZ.nextZ = F.nextZ), F.nextZ && (F.nextZ.prevZ = F.prevZ);
  }
  function T(F, D, P) {
    this.i = F, this.x = D, this.y = P, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
  }
  r.deviation = function(F, D, P, V) {
    var _ = D && D.length, O = _ ? D[0] * P : F.length, B = Math.abs(I(F, 0, O, P));
    if (_)
      for (var z = 0, W = D.length; z < W; z++) {
        var G = D[z] * P, Y = z < W - 1 ? D[z + 1] * P : F.length;
        B -= Math.abs(I(F, G, Y, P));
      }
    var U = 0;
    for (z = 0; z < V.length; z += 3) {
      var $ = V[z] * P, Z = V[z + 1] * P, q = V[z + 2] * P;
      U += Math.abs(
        (F[$] - F[q]) * (F[Z + 1] - F[$ + 1]) - (F[$] - F[Z]) * (F[q + 1] - F[$ + 1])
      );
    }
    return B === 0 && U === 0 ? 0 : Math.abs((U - B) / B);
  };
  function I(F, D, P, V) {
    for (var _ = 0, O = D, B = P - V; O < P; O += V)
      _ += (F[B] - F[O]) * (F[O + 1] + F[B + 1]), B = O;
    return _;
  }
  return r.flatten = function(F) {
    for (var D = F[0][0].length, P = { vertices: [], holes: [], dimensions: D }, V = 0, _ = 0; _ < F.length; _++) {
      for (var O = 0; O < F[_].length; O++)
        for (var B = 0; B < D; B++) P.vertices.push(F[_][O][B]);
      _ > 0 && (V += F[_ - 1].length, P.holes.push(V));
    }
    return P;
  }, Fh.exports;
}
var DS = kS();
const vm = /* @__PURE__ */ lv(DS);
let Sm = class {
  constructor() {
    this.u = !0;
  }
  S() {
    return this.u;
  }
}, FS = class extends Sm {
  constructor(t, e) {
    super(), this.M = t, this._ = t, this.u = e;
  }
  C(t) {
    return t !== this.M && (this._ = this.M, this.M = t, this.u = !0), this;
  }
  T() {
    return this.M;
  }
  S() {
    return super.S();
  }
};
const j = (r, t) => ({ x: r, y: t }), Kn = (r, t) => ({ x: r, y: t }), Am = (r, t, e) => ({ position: r, high: t, low: e }), Ht = (r, t, e) => ({ x: r, y: t, z: e }), bm = (r) => {
  const t = Array(0), e = Array(0);
  return r.length > 0 && r.forEach(((i) => {
    t.push(j(i.position, i.high)), e.push(j(i.position, i.low));
  })), [t, e];
}, Ee = (r, t) => ({ min: r, max: t }), Af = (r, t, e, i) => ({ x: r, y: t, width: e, height: i }), le = (r, t = !0) => new FS(r, t), To = (r = 0, t = 0, e = 0, i = 0) => ({ left: r, top: t, right: e, bottom: i }), vl = To, pa = (r, t) => ({ left: t.left !== void 0 ? t.left : r.left, top: t.top !== void 0 ? t.top : r.top, right: t.right !== void 0 ? t.right : r.right, bottom: t.bottom !== void 0 ? t.bottom : r.bottom }), LS = De({ type: "color", r: 1, g: 1, b: 1, a: 1 });
class ur extends LS {
  constructor(t) {
    super(t);
  }
  toUint32() {
    return this.F !== void 0 || (this.F = RS(this.getR(), this.getG(), this.getB(), this.getA())), this.F;
  }
  toString() {
    return `color:${this.r},${this.g},${this.b},${this.a}`;
  }
  setA(t) {
    return this.set("a", t / 255);
  }
  setR(t) {
    return this.set("r", t / 255);
  }
  setG(t) {
    return this.set("g", t / 255);
  }
  setB(t) {
    return this.set("b", t / 255);
  }
  getA() {
    return 255 * this.get("a");
  }
  getR() {
    return 255 * this.get("r");
  }
  getG() {
    return 255 * this.get("g");
  }
  getB() {
    return 255 * this.get("b");
  }
  getHighlight() {
    return this.I || (this.I = new ur({ r: this.r + 0.45 * (1 - this.r), g: this.g + 0.45 * (1 - this.g), b: this.b + 0.45 * (1 - this.b), a: this.a < 1 ? this.a + 0.45 * (1 - this.a) : 1 })), this.I;
  }
  getLighter() {
    return this.P || (this.P = new ur({ r: this.r + 0.4 * (1 - this.r), g: this.g + 0.4 * (1 - this.g), b: this.b + 0.4 * (1 - this.b), a: this.a })), this.P;
  }
  getDarker() {
    return this.L || (this.L = new ur({ r: this.r - 0.4 * (1 - this.r), g: this.g - 0.4 * (1 - this.g), b: this.b - 0.4 * (1 - this.b), a: this.a })), this.L;
  }
  toRGBAString() {
    return `rgba(${(255 * this.r).toFixed(0)},${(255 * this.g).toFixed(0)},${(255 * this.b).toFixed(0)},${this.a})`;
  }
}
const ko = (r) => !(!r || typeof r != "object" || !("type" in r) || r.type !== "color"), N = (r, t, e, i = 255) => new ur({ r: r / 255, g: t / 255, b: e / 255, a: i / 255 }), Xe = (r) => {
  const t = r.startsWith("#") ? r.substring(1) : r.startsWith("0x") ? r.substr(2) : r;
  switch (t.length) {
    case 8:
      return new ur({ r: +`0x${t.substring(0, 2)}` / 255, g: +`0x${t.substring(2, 4)}` / 255, b: +`0x${t.substring(4, 6)}` / 255, a: +`0x${t.substring(6, 8)}` / 255 });
    case 6:
      return new ur({ r: +`0x${t.substring(0, 2)}` / 255, g: +`0x${t.substring(2, 4)}` / 255, b: +`0x${t.substring(4, 6)}` / 255 });
    case 4:
      return new ur({ r: +`0x${t.charAt(0)}${t.charAt(0)}` / 255, g: +`0x${t.charAt(1)}${t.charAt(1)}` / 255, b: +`0x${t.charAt(2)}${t.charAt(2)}` / 255, a: +`0x${t.charAt(3)}${t.charAt(3)}` / 255 });
    case 3:
      return new ur({ r: +`0x${t.charAt(0)}${t.charAt(0)}` / 255, g: +`0x${t.charAt(1)}${t.charAt(1)}` / 255, b: +`0x${t.charAt(2)}${t.charAt(2)}` / 255 });
    default:
      throw new Error(`ColorHEX parsing error | input: ${r}`);
  }
}, PS = (r, t = 1, e = 1) => {
  let i, s, o;
  r /= 360;
  const n = Math.floor(6 * r), a = 6 * r - n, l = e * (1 - t), h = e * (1 - a * t), u = e * (1 - (1 - a) * t);
  switch (n % 6) {
    case 0:
      i = e, s = u, o = l;
      break;
    case 1:
      i = h, s = e, o = l;
      break;
    case 2:
      i = l, s = e, o = u;
      break;
    case 3:
      i = l, s = h, o = e;
      break;
    case 4:
      i = u, s = l, o = e;
      break;
    default:
      i = e, s = l, o = h;
  }
  return new ur({ r: i, g: s, b: o });
}, Em = (r) => N(255 & r, 255 & (r >>= 8), 255 & (r >>= 8), 255 & (r >>= 8)), ya = new ur({}), Qe = N(0, 0, 0, 0), RS = (r, t, e, i = 255) => (i << 24 | e << 16 | t << 8 | r) >>> 0, IS = De({ type: "font", size: 14, family: "Arial", weight: "normal", style: "normal", variant: !1 });
class qn extends IS {
  constructor(t) {
    super(t);
  }
  setSize(t) {
    return this.set("size", t);
  }
  setFamily(t) {
    return this.set("family", t);
  }
  setWeight(t) {
    return this.set("weight", t);
  }
  setStyle(t) {
    return this.set("style", t);
  }
  setVariant(t) {
    return this.set("variant", t);
  }
  getSize() {
    return this.get("size");
  }
  getFamily() {
    return this.get("family");
  }
  getWeight() {
    return this.get("weight");
  }
  getStyle() {
    return this.get("style");
  }
  getVariant() {
    return this.get("variant");
  }
}
const sa = (r) => !(!r || typeof r != "object" || !("type" in r) || r.type !== "font"), Mm = new qn();
var Cs, hs;
(function(r) {
  r.circle = "circle", r.ellipse = "ellipse";
})(Cs || (Cs = {})), (function(r) {
  r.closestSide = "closest-side", r.closestCorner = "closest-corner", r.farthestSide = "farthest-side", r.farthestCorner = "farthest-corner";
})(hs || (hs = {}));
const VS = De({ type: "fillstyle", fillType: "radial-gradient", ditheringEnabled: !0, stops: [{ color: Xe("#f00"), offset: 0 }, { color: Xe("#0f0"), offset: 1 }], position: j(0.5, 0.5), shape: Cs.ellipse, extent: hs.farthestCorner });
class Gi extends VS {
  constructor(t) {
    if (super(t), t === null || t && t.stops === null || t && t.stops && !Array.isArray(t.stops) || t && t.stops && Array.isArray(t.stops) && t.stops.length < 2) throw new Error("RadialGradientFill requires minimum two color stops to be defined.");
  }
  toString() {
    return `radialGradientFill:${this.shape},${this.ditheringEnabled},${this.extent},${this.position.x},${this.position.y},${this.stops.map(((t) => `${t.offset},${t.color.toString()}`)).join(",")}`;
  }
  toCSS() {
    return `radial-gradient(${this.shape} ${this.extent} at ${100 * this.position.x}% ${100 * this.position.y}%, ${this.stops.map(((t) => `${t.color.toString()} ${100 * t.offset}%`)).join(", ")})`;
  }
  setColorStops(t) {
    if (t.length < 2) throw new Error("Minimum of two color stops required");
    return this.set("stops", t);
  }
  getColorStops() {
    return this.get("stops");
  }
  setPosition(t) {
    return this.set("position", t);
  }
  getPosition() {
    return this.get("position");
  }
  setShape(t) {
    return this.set("shape", t);
  }
  getShape() {
    return this.get("shape");
  }
  setExtent(t) {
    return this.set("extent", t);
  }
  getExtent() {
    return this.get("extent");
  }
  setDitheringEnabled(t) {
    return this.set("ditheringEnabled", t);
  }
  getDitheringEnabled() {
    return this.get("ditheringEnabled");
  }
}
const li = (r) => !!(r && typeof r == "object" && "type" in r && r.type === "fillstyle" && "fillType" in r && r.fillType === "radial-gradient"), _S = De({ type: "fillstyle", fillType: "linear-gradient", stops: [{ color: Xe("#f00"), offset: 0 }, { color: Xe("#0f0"), offset: 1 }], angle: 0 });
class Ci extends _S {
  constructor(t) {
    if (super(t), t === null || t && t.stops === null || t && t.stops && !Array.isArray(t.stops) || t && t.stops && Array.isArray(t.stops) && t.stops.length < 2) throw new Error("LinearGradientFill requires minimum two color stops to be defined.");
  }
  toString() {
    return `linearGradientFill:${this.angle},${this.stops.map(((t) => `${t.offset},${t.color.toString()}`)).join(",")}`;
  }
  toCSS() {
    return `linear-gradient(${this.angle}deg, ${this.stops.map(((t) => `${t.color.toString()} ${100 * t.offset}%`)).join(", ")})`;
  }
  setColorStops(t) {
    if (t.length < 2) throw new Error("Minimum of two color stops required");
    const e = t.sort(((i, s) => i.offset - s.offset));
    return this.set("stops", e);
  }
  getColorStops() {
    return this.get("stops");
  }
  setAngle(t, e) {
    return this.set("angle", e ? (function(i) {
      return 180 * i / Math.PI;
    })(t) : t);
  }
  getAngle(t) {
    return t ? $n(this.get("angle")) : this.get("angle");
  }
}
const hi = (r) => !!(r && typeof r == "object" && "type" in r && r.type === "fillstyle" && "fillType" in r && r.fillType === "linear-gradient");
class Cm {
  constructor(t, e, i, s) {
    this.D = new Nt(), this.cellIndex = t, this.cellSpan = e, this.cellsAmount = i, this.observedAmount = s, this.x = new bc(), this.y = new bc(), this.z = new bc();
    const o = { ...t }, n = { ...e };
    if (s) {
      const a = (h) => {
        const u = h.value;
        this.cellsAmount.x = u.reduce(zl, 0), this.cellIndex.x = u.reduce(((c, d, f) => f >= o.x ? c : c + d), 0), this.cellSpan.x = u.reduce(((c, d, f) => f >= o.x && f < o.x + n.x ? c + d : c), 0), this.D.R("cellresize", {});
      };
      s.x.O("change", a), a({ value: s.x.T() });
      const l = (h) => {
        const u = h.value;
        this.cellsAmount.y = u.reduce(zl, 0), this.cellIndex.y = u.reduce(((c, d, f) => f >= o.y ? c : c + d), 0), this.cellSpan.y = u.reduce(((c, d, f) => f >= o.y && f < o.y + n.y ? c + d : c), 0), this.D.R("cellresize", {});
      };
      s.y.O("change", l), l({ value: s.y.T() }), this.V = () => {
        s.x.N("change", a), s.y.N("change", l);
      };
    }
  }
  G() {
    return this.V && (this.V(), this.V = void 0), this;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class bc extends Sm {
  constructor() {
    super(...arguments), this.$ = 0, this.U = 10, this.j = 1, this.Y = !1;
  }
  H() {
    return !1;
  }
  W() {
    return this.u = !1, this;
  }
  X() {
    return this.u = !0, this;
  }
  getInnerStart() {
    return this.$;
  }
  getInnerEnd() {
    return this.U;
  }
  getInnerInterval() {
    return Math.abs(this.getInnerEnd() - this.getInnerStart());
  }
  Z(t, e) {
    return this.$ = t, this.U = e, this.J(), this;
  }
  K(t) {
    return this.j = t, this.J(), this;
  }
  q(t) {
    return t / this.j;
  }
  J() {
    const t = this.q(this.U - this.$), e = this.j;
    this.tt !== void 0 && Pi(t, this.tt) !== !1 || (this.u = !0, this.it = e, this.tt = t);
    let i = this.$;
    this.U;
    let s = 0;
    this.Y && (i = 0, this.U, this.$, s = this.$);
    const o = t, n = i + 0.5 * o * e;
    this.st = { displacement: n, scaling: o, highPrecisionOffset: s };
  }
  et() {
    return this.tt;
  }
  rt() {
    return this.U < this.$;
  }
  ht() {
    return this.st;
  }
  nt(t, e) {
    return !0;
  }
}
class OS {
  constructor() {
    this.ot = !0;
  }
  getInnerStart() {
    return this.$;
  }
  getInnerEnd() {
    return this.U;
  }
  getInnerInterval() {
    return Math.abs(this.U - this.$);
  }
  Z(t, e) {
    return t === this.$ && e === this.U || (this.ot = !0), this.$ = t, this.U = e, this;
  }
  W() {
    return this.ot = !1, this;
  }
  X() {
    return this.ot = !0, this;
  }
}
class wm extends OS {
  constructor(t, e, i, s) {
    if (super(), this.ut = !0, this.ct = !0, this.dt = [0, 0], this.ft = !0, this.At = t, this.vt = e, this.yt = i, this.St = t, this.bt = e, s) {
      const o = (n) => {
        this.xt(n.value);
      };
      s.O("change", o), this.xt(s.T()), this.Mt = () => s.N("change", o);
    }
  }
  H() {
    return this.ct;
  }
  K(t) {
    return this.j = t, this.ct = !0, this;
  }
  _t(t) {
    return this.dt = t.map(Math.abs), this.ft = !0, this;
  }
  wt() {
    return this.At / this.yt * this.j + this.dt[0];
  }
  kt() {
    return (this.At + this.vt) / this.yt * this.j - this.dt[1];
  }
  Ct() {
    return this.getCellSize() - this.Tt();
  }
  Ft() {
    return this.j;
  }
  getCellSize() {
    return this.It(this.j);
  }
  Tt() {
    return this.dt[0] + this.dt[1];
  }
  Pt() {
    return this.dt;
  }
  xt(t) {
    this.yt = t.reduce(zl, 0), this.At = t.reduce(((e, i, s) => s >= this.St ? e : e + i), 0), this.vt = t.reduce(((e, i, s) => s >= this.St && s < this.St + this.bt ? e + i : e), 0), this.ut = !0, this.Lt();
  }
  It(t) {
    return t * this.vt / this.yt;
  }
  W() {
    return super.W(), this.ct = !1, this.ft = !1, this.ut = !1, this;
  }
  X() {
    return super.X(), this.ct = !0, this.ft = !0, this.ut = !0, this;
  }
}
class ts extends wm {
  constructor(t, e, i, s) {
    super(t, e, i, s), this.Y = !1, this.Bt = !1, this.Dt = 0, this.j = 1e3, this.Z(0, 10), this.J();
  }
  Et() {
    return this.Bt;
  }
  nt(t, e, i, s, o) {
    if (t === e) return !1;
    const n = Math.abs(s - i), a = Math.abs(e - t);
    if (!this.Y) {
      const c = fA(t, e, this.getCellSize());
      if (c === void 0) return !1;
      if (a > c) return !0;
      const d = (e + t) / 2, f = (o ? c / 2 : n / 2) * (t > e ? -1 : 1);
      return { start: d - f, end: d + f };
    }
    const l = 10 ** -(12 - Math.log10(Math.max(Math.abs(t), 1)));
    if (a > l) return !0;
    const h = (e + t) / 2, u = (o ? l / 2 : n / 2) * (t > e ? -1 : 1);
    return { start: h - u, end: h + u };
  }
  Lt() {
    this.J();
  }
  Rt(t) {
    return this.wt() + (t - this.$) / (this.U - this.$) * (this.kt() - this.wt());
  }
  Ot(t) {
    return this.$ + (t - this.wt()) / (this.kt() - this.wt()) * (this.U - this.$);
  }
  Z(t, e) {
    return super.Z(t, e), this.J(), this;
  }
  _t(t) {
    return super._t(t), this.J(), this;
  }
  K(t) {
    return super.K(t), this.zt = Ec(this.U - this.$, this.dt, this.j, this.vt, this.yt), this.J(), this;
  }
  Vt() {
    return this.Y = !0, this;
  }
  Nt() {
    return this.Y;
  }
  Gt() {
    return Math.abs(this.$t);
  }
  Ut() {
    return this.Gt() / this.zt;
  }
  jt() {
    return this.Yt;
  }
  Ht() {
    return this.Wt;
  }
  getPixelSize() {
    return this.zt;
  }
  ht() {
    return this.st;
  }
  X() {
    return super.X(), this.Bt = !0, this;
  }
  W() {
    return super.W(), this.Bt = !1, this;
  }
  Xt(t, e = en.Numeric) {
    return e(t, { start: this.$, end: this.U });
  }
  Zt() {
    const t = Math.abs(this.getInnerEnd()).toString().length, e = Math.abs(this.getInnerStart()).toString().length;
    return t > e ? t : e;
  }
  Jt(t) {
    return Ec(t, this.dt, this.j, this.vt, this.yt);
  }
  J() {
    let t = this.$, e = this.U, i = 0;
    this.Y && (t = 0, e = this.U - this.$, i = this.$);
    const s = e - t, o = Ec(s, this.dt, this.j, this.vt, this.yt);
    this.Wt = this.$ - this.dt[0] * o, this.Yt = this.U + this.dt[1] * o;
    const n = t - this.dt[0] * o, a = e + this.dt[1] * o - n, l = a - this.$t, h = Math.abs(l / o), u = s - this.Dt, c = Math.abs(u / o);
    (!this.st || h >= 0.4 || c >= 0.4) && (this.Dt = s, this.$t = a, this.zt = o, this.Bt = !0);
    const d = this.$t * this.yt / (2 * this.vt), f = -(n - this.$t * this.At / this.vt) - d, p = 2 * this.wt() / this.j - 1, g = 2 * this.kt() / this.j - 1 - p;
    this.st = { displacement: f, scaling: d, highPrecisionOffset: i, viewportStart: p, viewportSize: g, scaleStartLog: 0, scaleIntervalLog: 0 };
  }
  Qt(t, e) {
    return t + this.zt * e;
  }
}
const Ec = (r, t, e, i = 1, s = 1) => r / (e * i / s - (t[0] + t[1]));
class yr {
  Kt(t, e) {
    return "x" in t ? (this.x = t.x, this.y = t.y) : (this.x = t, this.y = e), this;
  }
  W() {
    return this.x.W(), this.y.W(), this;
  }
  X() {
    return this.x.X(), this.y.X(), this;
  }
  K(t, e) {
    return typeof t == "object" ? (this.x.K(t.x), this.y.K(t.y)) : (this.x.K(t), this.y.K(e)), this;
  }
  Ft() {
    return j(this.x.Ft(), this.y.Ft());
  }
  qt(t) {
    return this.x._t(t), this;
  }
  ti(t) {
    return this.y._t(t), this;
  }
  Tt() {
    return j(this.x.Tt(), this.y.Tt());
  }
  ii(t, e) {
    return this.x.Z(t, e), this;
  }
  si(t, e) {
    return this.y.Z(t, e), this;
  }
  getInnerIntervalPixels() {
    const t = this.x.getCellSize(), e = this.y.getCellSize();
    return { x: t - this.x.Tt(), y: e - this.y.Tt() };
  }
  ei() {
    return this.x.Et() || this.y.Et();
  }
}
class we extends yr {
  constructor() {
    super(...arguments), this.ri = "LinearScaleXY";
  }
  hi(t, e, i, s) {
    return this.x = new ts(t.x, e.x, i.x, s ? s.x : void 0), this.y = new ts(t.y, e.y, i.y, s ? s.y : void 0), this;
  }
  Nt() {
    return this.x.Nt() || this.y.Nt();
  }
  ni() {
    return j(this.x.getPixelSize(), this.y.getPixelSize());
  }
  ht() {
    return { x: this.x.ht(), y: this.y.ht() };
  }
  Qt(t, e) {
    const i = this.ni();
    return { x: t.x + e.x * i.x, y: t.y + e.y * i.y };
  }
  oi(t, e, i, s) {
    const o = this.ni(), n = $u(t, e);
    return n.x *= s, n.y *= s, { x: t.x + i * o.x * n.x, y: t.y + i * o.y * n.y };
  }
}
class Ti extends yr {
  constructor() {
    super(...arguments), this.ri = "MixedScaleXY";
  }
  Nt() {
    return !1;
  }
  Qt(t, e) {
    const i = this.x.Rt(t.x), s = this.y.Rt(t.y), o = { x: i + e.x, y: s + e.y };
    return { x: this.x.Ot(o.x), y: this.y.Ot(o.y) };
  }
  oi(t, e, i, s) {
    const o = { x: this.x.Rt(t.x), y: this.y.Rt(t.y) }, n = { x: this.x.Rt(e.x), y: this.y.Rt(e.y) }, a = Os(oi(n, o)), l = $u(n, o), h = { x: o.x + a.x * s + l.x * i, y: o.y + a.y * s + l.y * i };
    return { x: this.x.Ot(h.x), y: this.y.Ot(h.y) };
  }
  ht() {
    const t = this.x.ht(), e = this.y.ht();
    return { uScaleStart: [this.x.$, this.y.$], uScaleInterval: [this.x.U - this.x.$, this.y.U - this.y.$], uScaleStartLog: [t.scaleStartLog, e.scaleStartLog], uScaleIntervalLog: [t.scaleIntervalLog, e.scaleIntervalLog], uViewportStart: [t.viewportStart, e.viewportStart], uViewportSize: [t.viewportSize, e.viewportSize] };
  }
}
const ki = { d1: (r) => new r.scale1DConstructor(0, 1, 1, void 0), d2: (r) => new r.scaleXYConstructor().hi({ x: 0, y: 0 }, { x: 1, y: 1 }, { x: 1, y: 1 }, void 0), d3: () => new Cm({ x: 0, y: 0 }, { x: 1, y: 1 }, { x: 1, y: 1 }, void 0) }, Nl = (r, t, e) => t === e ? r : e.Ot(t.Rt(r)), xt = (r, t, e) => {
  if (t === e) return r;
  const i = t instanceof yr ? t.x : t.x instanceof yr ? t.x.x : t.x.ai, s = t instanceof yr ? t.y : t.y instanceof yr ? t.y.y : t.y.ai, o = e instanceof yr ? e.x : e.x instanceof yr ? e.x.x : e.x.ai, n = e instanceof yr ? e.y : e.y instanceof yr ? e.y.y : e.y.ai;
  return { ...r, x: Nl(r.x, i, o), y: Nl(r.y, s, n) };
}, NS = (...r) => {
  if (r.length === 0) return { remove: ie };
  let t = !1;
  const e = r.map(((o) => {
    const n = (a) => {
      ((l, h, u) => {
        t || (t = !0, r.filter(((c) => c !== l)).forEach(((c) => c.li(h, u, !1, l.getStopped(), "synchronizedAxis"))), t = !1);
      })(o, a.start, a.end);
    };
    return o.addEventListener("intervalchange", n), n;
  }));
  let i = !1;
  const s = r.map(((o) => {
    const n = (a) => {
      ((l, h) => {
        i || (i = !0, r.filter(((u) => u !== l)).forEach(((u) => u.setStopped(h))), i = !1);
      })(o, a.isStopped);
    };
    return o.addEventListener("stoppedchange", n), n;
  }));
  return { remove: () => {
    r.forEach(((o, n) => {
      o.removeEventListener("intervalchange", e[n]), o.removeEventListener("stoppedchange", s[n]);
    }));
  } };
}, BS = (r) => r && typeof r == "object" && "column" in r && "row" in r, zS = (r) => r && typeof r == "object" && "z" in r && "column" in r && "row" in r, WS = (r) => r && typeof r == "object" && "annulus" in r && "sector" in r, GS = (r) => r && typeof r == "object" && "index" in r, W0 = (r) => r && typeof r == "object" && "x" in r && "y" in r, Ki = (r, t, e, i) => e < 0 ? r : e > 1 ? t : N(r.getR() + e * (t.getR() - r.getR()), r.getG() + e * (t.getG() - r.getG()), r.getB() + e * (t.getB() - r.getB()), i === void 0 ? r.getA() + e * (t.getA() - r.getA()) : i);
var Ms;
(function(r) {
  r[r.Nearest = 0] = "Nearest", r[r.NearestX = 1] = "NearestX", r[r.NearestY = 2] = "NearestY";
})(Ms || (Ms = {}));
const Tm = (r, t, e, i, s, o, n, a, l, h) => {
  const u = r.length;
  if (u === 0) return;
  const c = i ? 1 : 0, d = u - (s ? 2 : 1);
  if (e === Ms.Nearest) return US(r, t, o, n, c, d);
  if (e === Ms.NearestX || e === Ms.NearestY) {
    if (typeof h == "boolean" && (l === "x" && e === Ms.NearestX || l === "y" && e === Ms.NearestY)) return dd(r, xt(t, n, o), l, h, c, d);
    if (e === Ms.NearestX) return HS(r, xt(t, n, o), a, c, d);
    if (e === Ms.NearestY) return YS(r, xt(t, n, o), a, c, d);
  }
}, US = (r, t, e, i, s, o) => {
  let n, a = Number.MAX_VALUE;
  for (let l = s; l <= o; l += 1) {
    const h = r[l];
    if (!Number.isNaN(h.x) && !Number.isNaN(h.y)) {
      const u = xt(h, e, i), c = (u.x - t.x) ** 2 + (u.y - t.y) ** 2;
      c < a && (a = c, n = l);
    }
  }
  return n;
}, HS = (r, t, e, i, s) => {
  if (t.x < e.min.x || t.x > e.max.x) return;
  let o, n = Number.MAX_VALUE;
  for (let a = i; a <= s; a += 1) {
    const l = r[a], h = l.x > t.x ? l.x - t.x : t.x - l.x;
    h < n && !Number.isNaN(l.x) && !Number.isNaN(l.y) && (n = h, o = a);
  }
  return o;
}, YS = (r, t, e, i, s) => {
  if (t.y < e.min.y || t.y > e.max.y) return;
  let o, n = Number.MAX_VALUE;
  for (let a = i; a <= s; a += 1) {
    const l = r[a], h = l.y > t.y ? l.y - t.y : t.y - l.y;
    h < n && !Number.isNaN(l.x) && !Number.isNaN(l.y) && (n = h, o = a);
  }
  return o;
}, dd = (r, t, e, i, s, o) => {
  const n = e === "x", a = n ? t.x : t.y, l = r[s], h = r[o], u = l.x < h.x ? l.x : h.x, c = l.y < h.y ? l.y : h.y, d = l.x > h.x ? l.x : h.x, f = l.y > h.y ? l.y : h.y;
  if (n && (a < u || a > d) || !n && (a < c || a > f)) return;
  let p = s, g = Math.floor((s + o) / 2), y = o, m = -1;
  for (; ; ) {
    const A = a - (n ? r[g].x : r[g].y);
    if (A * (i ? -1 : 1) > 0) p = Math.min(g + 1, y), m = Math.floor((p + y) / 2);
    else {
      if (Math.abs(A) === 0) return g;
      y = Math.max(g - 1, p), m = Math.floor((p + y) / 2);
    }
    if (m === g) {
      const v = g > s ? Math.abs(a - (n ? r[g - 1].x : r[g - 1].y)) : wt, b = g < o ? Math.abs(a - (n ? r[g + 1].x : r[g + 1].y)) : wt, w = Math.abs(A);
      switch (Math.min(w, v, b)) {
        case v:
          return g - 1;
        case b:
          return g + 1;
        default:
          return g;
      }
    } else g = m;
  }
}, km = (r, t, e, i, s, o) => {
  const n = e === "x", a = n ? t.x : t.y, l = r[s], h = r[o], u = l.x < h.x ? l.x : h.x, c = l.y < h.y ? l.y : h.y, d = l.x > h.x ? l.x : h.x, f = l.y > h.y ? l.y : h.y;
  if (n && (a < u || a > d) || !n && (a < c || a > f)) return;
  let p = s, g = Math.floor((s + o) / 2), y = o, m = -1;
  for (; ; ) {
    const A = a - (n ? r[g].x : r[g].y);
    if (A * (i ? -1 : 1) > 0) p = Math.min(g + 1, y), m = Math.floor((p + y) / 2);
    else {
      if (Math.abs(A) === 0) return { a: g, b: g, lerpAmount: 0 };
      y = Math.max(g - 1, p), m = Math.floor((p + y) / 2);
    }
    if (m === g) {
      if (A * (i ? -1 : 1) < 0 && g > s) {
        const v = r[g - 1], b = r[g];
        return { a: g - 1, b: g, lerpAmount: n ? (t.x - v.x) / (b.x - v.x) : (t.y - v.y) / (b.y - v.y) };
      }
      if (g < o) {
        const v = r[g], b = r[g + 1];
        return { a: g, b: g + 1, lerpAmount: n ? (t.x - v.x) / (b.x - v.x) : (t.y - v.y) / (b.y - v.y) };
      }
      return { a: g, b: g, lerpAmount: 0 };
    }
    g = m;
  }
};
let G0 = 0;
class Dm {
  constructor(t, e, i) {
    this.ui = le(!0), this.ci = !1, this.di = !0, this.fi = !1, this.Ai = void 0, this.gi = 0, this.D = new Nt(), this.yi = t, this.pi = e, this.mi = i, this.Si = G0, G0 += 1, this.bi = t.xi.highlightColorOffset;
  }
  Mi() {
    let t;
    return this._i("DataPattern", ((e) => (t = e.pattern, !0))), t === "ProgressiveX" || t === "RegressiveX" ? Ms.NearestX : t === "ProgressiveY" || t === "RegressiveY" ? Ms.NearestY : Ms.Nearest;
  }
  wi() {
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  R(t, e, i, s) {
    this.D.R(t, e, { collectionMember: i, info: s });
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  ki(t) {
    return this.mi.find(((e) => e.type === t)) !== void 0;
  }
  _i(t, e) {
    var i;
    return !!this.ki(t) && e((i = this.mi.find(((s) => s.type === t))) === null || i === void 0 ? void 0 : i.args) === !0;
  }
  dispose() {
    return this.ci || (this.yi.Ci(this), this.ci = !0, this.pi(this), this.D.R("dispose", {})), this;
  }
  isDisposed() {
    return this.ci;
  }
  setVisible(t) {
    const e = this.di;
    return this.di = t, !t && e && this.ui.T() && this.yi.Ci(this), this;
  }
  getVisible() {
    return this.di;
  }
  setPointerEvents(t) {
    const e = this.ui.T();
    return this.ui.C(t), t || e && this.yi.Ci(this), this;
  }
  getPointerEvents() {
    return this.ui.T();
  }
  Ti(t) {
    return this.Ai = t, this;
  }
  Fi() {
    return this.Ai ? this.Ai : jS;
  }
  Ii(t) {
    return this.gi = t, this;
  }
  Pi() {
    return this.gi;
  }
  Li(t) {
    return this.bi = t, this;
  }
  Bi() {
    return this.bi;
  }
}
const jS = Ee(j(0, 0), j(0, 0)), Ml = { click: !0, contextmenu: !0, dblclick: !0, gotpointercapture: !0, lostpointercapture: !0, pointercancel: !0, pointerdown: !0, pointerenter: !0, pointerleave: !0, pointermove: !0, pointerout: !0, pointerover: !0, pointerup: !0, touchcancel: !0, touchend: !0, touchmove: !0, touchstart: !0, wheel: !0, drag: !0, dragend: !0, dragenter: !0, dragleave: !0, dragover: !0, dragstart: !0, drop: !0 };
class Nt {
  constructor() {
    this.Di = new Array(), this.Ei = [], this.ui = !0, this.Ri = !1, this.Oi = /* @__PURE__ */ new Map();
  }
  setPointerEvents(t) {
    this.ui = t, this.Ei.forEach(((e) => e.setPointerEvents(t)));
  }
  getPointerEvents() {
    return this.ui;
  }
  addEventListener(t, e, i) {
    this.Di.push({ listener: e, key: t, options: i || {} });
  }
  removeEventListener(t, e) {
    const i = this.Di.findIndex(((s) => s.listener === e));
    i >= 0 && this.Di.splice(i, 1);
  }
  set draggable(t) {
    this.Ri = t, this.Ei.forEach(((e) => {
      e.fi = t;
    }));
  }
  get draggable() {
    return this.Ri;
  }
  R(t, e, i = void 0) {
    const s = this.Di.slice();
    for (let o = s.length - 1; o >= 0; o -= 1) {
      const n = s[o];
      n.key === t && (n.listener(e, i), n.options.once === !0 && this.removeEventListener(t, n.listener));
    }
  }
  zi(t, e) {
    const i = [];
    Object.keys(Ml).forEach(((o) => {
      const n = (a, l) => {
        const h = bf(a) ? { clientX: a.changedTouches[0].clientX, clientY: a.changedTouches[0].clientY } : a, u = e?.getExtraData && h.clientX !== void 0 ? e.getExtraData(h, l.collectionMember, l.info) : {};
        this.R(o, a, u), !a.defaultPrevented && e?.continueIfNotPrevented && e.continueIfNotPrevented(o, a, u);
      };
      t.addEventListener(o, n), i.push((() => t.removeEventListener(o, n)));
    })), this.Ei.push(t);
    const s = () => {
      const o = this.Ei.indexOf(t);
      o >= 0 && this.Ei.splice(o, 1), i.forEach(((n) => n()));
    };
    t.addEventListener("dispose", s), i.push((() => t.removeEventListener("dispose", s))), this.Oi.set(t, (() => {
      i.forEach(((o) => o()));
    })), t.fi = this.Ri, t.setPointerEvents(this.ui);
  }
  Vi() {
    this.Oi.forEach(((t) => t())), this.Oi.clear(), this.Ei.length = 0;
  }
  Ni(t, e) {
    const i = [];
    Object.keys(Ml).forEach(((o) => {
      const n = (a, l) => {
        const h = e(l.collectionMember);
        h && this.R(o, a, h);
      };
      t.addEventListener(o, n), i.push((() => t.removeEventListener(o, n)));
    })), this.Ei.push(t);
    const s = () => {
      const o = this.Ei.indexOf(t);
      o >= 0 && this.Ei.splice(o, 1), i.forEach(((n) => n()));
    };
    t.addEventListener("dispose", s), i.push((() => t.removeEventListener("dispose", s))), this.Oi.set(t, (() => {
      i.forEach(((o) => o()));
    })), t.setPointerEvents(this.ui), t.fi = this.Ri;
  }
  Gi(t) {
    Object.keys(Ml).forEach(((e) => {
      t.addEventListener(e, ((i, s) => {
        this.R(e, i, s);
      }));
    })), t.setPointerEvents(this.ui), t.draggable = this.Ri;
  }
}
const bf = (r) => !(!r || typeof r != "object" || !("touches" in r)), Cr = { linear: (r, t, e) => {
  const i = t - r;
  return (s) => s < e ? r + i / e * s : t;
}, easeIn: (r, t, e) => (i) => i < e ? r + Math.abs(2 * (Math.sqrt(0.5) * i / e) ** 2) * (t - r) : t, easeOut: (r, t, e) => (i) => i < e ? r + Math.abs(1 - 2 * (Math.sqrt(0.5) * (1 - i / e)) ** 2) * (t - r) : t, ease: (r, t, e) => (i) => i < e ? r + (i < e / 2 ? 0.5 * (i / e * 2) ** 2.5 : 0.5 + 0.5 * (1 - (1 - 2 * (i / e - 0.5)) ** 2.5)) * (t - r) : t, logarithmic: (r) => {
  const t = Cf(r);
  return (e, i, s) => {
    const o = t(e), n = t(i);
    return (a) => a < s ? r ** (o + Math.abs(1 - 2 * (Math.sqrt(0.5) * (1 - a / s)) ** 2) * (n - o)) : i;
  };
} };
class Ef {
  constructor(t, e, i, s = Cr.linear, o) {
    this.delta = 0, this.nextAnimations = new Array(), this.$i = !1, this.easing = Cr.linear, this.isOver = () => (this.delta === this.duration || this.$i) && this.nextAnimations.length === 0, this.D = new Nt(), this.values = t, this.action = e, this.duration = i, this.easing = s, this.Ui = o, this.eases = t.map((([n, a]) => s(n, a, i)));
  }
  ji() {
    this.D.R("start", {});
  }
  start() {
    return this.Ui.includes(this) || this.Ui.push(this), this;
  }
  addNextAnimations(t) {
    return t instanceof Array ? t.forEach(((e) => this.nextAnimations.push(e))) : this.nextAnimations.push(t), this;
  }
  NextAnimation(t, e, i = this.duration, s = this.easing) {
    const o = new Ef(t, e, i, s, this.Ui);
    return this.nextAnimations.push(o), o;
  }
  finish(t = !0) {
    if (this.$i = !0, this.Ui.splice(this.Ui.indexOf(this), 1), this.nextAnimations.length > 0) {
      const e = this.nextAnimations[0];
      return t && this.D.Di.forEach(((i) => {
        i.key === "allAnimationEnd" && e.addEventListener("allAnimationEnd", i.listener), i.key === "everyAnimationEnd" && e.addEventListener("everyAnimationEnd", i.listener);
      })), e.addNextAnimations(this.nextAnimations.slice(1)), e.start(), t && (this.D.R("end", { nextAnimation: e }), this.D.R("everyAnimationEnd", { nextAnimation: e })), e;
    }
    t && (this.D.R("end", { nextAnimation: void 0 }), this.D.R("everyAnimationEnd", { nextAnimation: void 0 }), this.D.R("allAnimationEnd", {}));
  }
  finishAll(t = !0) {
    let e = this;
    for (; e; ) e = e.finish(t);
  }
  getFinalValues() {
    return this.nextAnimations.length > 0 ? this.nextAnimations[this.nextAnimations.length - 1].values.map($0) : this.values.map($0);
  }
  getTimeUntilFinish() {
    let t = this.duration - this.delta;
    for (let e = 0; e < this.nextAnimations.length; e += 1) t += this.nextAnimations[e].duration - this.nextAnimations[e].delta;
    return t;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Fn = (r, t = 60) => {
  t > 60 && console.log("Note: Animator FPS is usually capped at 60 by the browser!");
  const e = [];
  let i, s, o = 0;
  const n = () => {
    i = void 0;
    const a = Date.now();
    s = s || a, o = a - s, o / 1e3 >= 1 / t && (s = Date.now() - o % (1e3 / t), e.forEach(((l) => {
      l.delta === 0 && l.ji(), l.delta += o - o % (1e3 / t), l.delta > l.duration && (l.delta = l.duration), l.action(l.eases.map(((h) => h(l.delta)))), l.delta === l.duration && l.finish();
    })), r()), e.length > 0 ? i = H.requestAnimationFrame(n) : (i = void 0, s = void 0);
  };
  return (a = 1e3, l = Cr.linear) => (h, u, c = a) => {
    const d = new Ef(h, u, c, l, e).start();
    return i || (i = H.requestAnimationFrame(n)), d;
  };
};
var Li;
(function(r) {
  r[r.Fill = 0] = "Fill", r[r.Fit = 1] = "Fit", r[r.Stretch = 2] = "Stretch", r[r.Center = 3] = "Center", r[r.Tile = 4] = "Tile";
})(Li || (Li = {}));
const $S = De({ type: "fillstyle", fillType: "image", source: void 0, surroundingColor: N(0, 0, 0, 0), sourceMissingColor: N(0, 0, 0, 0), fitMode: Li.Fill });
class wr extends $S {
  constructor(t) {
    super(t);
  }
  setSource(t) {
    return this.set("source", t);
  }
  getSource() {
    return this.get("source");
  }
  setSurroundingColor(t) {
    return ko(t) ? this.set("surroundingColor", t) : this.set("surroundingColor", t(this.get("surroundingColor")));
  }
  getSurroundingColor() {
    return this.get("surroundingColor");
  }
  setSourceMissingColor(t) {
    return ko(t) ? this.set("sourceMissingColor", t) : this.set("sourceMissingColor", t(this.get("sourceMissingColor")));
  }
  getSourceMissingColor() {
    return this.get("sourceMissingColor");
  }
  setFitMode(t) {
    return this.set("fitMode", t);
  }
  getFitMode() {
    return this.get("fitMode");
  }
  toString() {
    return `imagefill:${this.fitMode}`;
  }
  toCSS() {
    return `url(${this.getSource().src})`;
  }
}
const cn = (r) => !!(r && typeof r == "object" && "type" in r && r.type === "fillstyle" && "fillType" in r && r.fillType === "image"), XS = De({ type: "linestyle", lineType: "empty" }), Et = new class extends XS {
  constructor() {
    super(...arguments), this.thickness = 0;
  }
  setThickness(r) {
    return this;
  }
  getThickness() {
    return 0;
  }
  Yi() {
    return 0;
  }
  setFillStyle(r) {
    return this;
  }
  getFillStyle() {
    return Lt;
  }
}(), U0 = (r) => !(!r || typeof r != "object" || !("lineType" in r) || r.lineType !== "empty"), ju = -34028234663852886e22, H0 = "-340282346638528859811704183484516925440.0";
var be, Y0, zr, ae;
(function(r) {
  r[r.Content = 0] = "Content", r[r.PaddedContent = 1] = "PaddedContent", r[r.PaddedBackground = 2] = "PaddedBackground", r[r.Everything = 3] = "Everything";
})(be || (be = {})), (function(r) {
  r[r.never = 0] = "never", r[r.always = 1] = "always", r[r.whenHovered = 2] = "whenHovered", r[r.whenDragged = 3] = "whenDragged", r[r.whenNotDragged = 4] = "whenNotDragged", r[r.whenHoveredOrDragged = 5] = "whenHoveredOrDragged";
})(Y0 || (Y0 = {})), (function(r) {
  r[r.notDraggable = 0] = "notDraggable", r[r.draggable = 1] = "draggable", r[r.onlyHorizontal = 2] = "onlyHorizontal", r[r.onlyVertical = 3] = "onlyVertical";
})(zr || (zr = {})), (function(r) {
  r[r.Up = 0] = "Up", r[r.Right = 1] = "Right", r[r.Down = 2] = "Down", r[r.Left = 3] = "Left";
})(ae || (ae = {}));
const Fm = (r) => "getHighlight" in r && "setHighlight" in r, Lm = (r, t, e) => r === void 0 || typeof r == "number" || typeof r == "string" ? r : Array.isArray(r) ? r.slice(t, e) : r.subarray(t, e), Zi = (...r) => {
  const t = (e) => e && typeof e == "object" && !Array.isArray(e);
  return r.reduce(((e, i) => (i && Object.keys(i).forEach(((s) => {
    const o = e[s], n = i[s];
    t(o) && t(n) ? e[s] = Zi(o, n) : e[s] = n;
  })), e)), {});
}, Pm = (r) => {
  if (r.resourcesBaseUrl) {
    const i = r.styleFactory(r.resourcesBaseUrl), s = cn(i) && i.getSource(), o = s && s instanceof Image ? s : void 0;
    return o?.addEventListener("error", (() => {
      gd(r.resourcesBaseUrl, o.src, "Theme resource", { shouldCrash: !1 });
    })), i;
  }
  const t = `${H.location.origin}/resources`, e = r.styleFactory(t);
  if (cn(e)) {
    const i = e.getSource();
    i instanceof Image && i.addEventListener("error", (() => {
      const s = r.styleFactory("https://lcjs-resources.lightningchart.com/v1"), o = cn(s) && s.getSource(), n = o && o instanceof Image ? o : void 0;
      H.console.warn(`LightningChart JS warning | fallbacking to publicly hosted asset resources.
For more information, please see https://lightningchart.com/js-charts/docs/troubleshooting/warning-using-publicly-hosted-resources/`), n?.addEventListener("load", (() => {
        r.apply(s);
      })), n?.addEventListener("error", (() => {
        gd(r.resourcesBaseUrl, i.src, "Theme resource", { shouldCrash: !1 });
      }));
    }));
  }
  return e;
};
let ZS = 0;
const Mf = () => {
  const r = Date.now().toString(36), t = (1048575 & ZS++).toString(36);
  return `${r}-${Math.floor(4294967295 * Math.random()).toString(36)}-${t}`;
}, H = typeof window < "u" ? window : typeof global < "u" && global._lcjs ? global._lcjs : {}, j0 = (r, t) => r.x === t.x && r.y === t.y, Lh = (r) => r !== wt && r !== Pt && !Number.isNaN(r) && Number.isFinite(r) && r !== 1 / 0 && r !== -1 / 0, $0 = (r) => r[1], Eo = (r) => r.dispose(), ie = () => {
}, Pi = (r, t) => r === t, Jt = (r, t, e) => e > t ? Math.min(Math.max(r, t), e) : Math.min(Math.max(r, e), t), vu = (r) => Array.prototype.concat.apply([], r), $e = (r, t) => r === void 0 || Number.isNaN(r) ? t : r, KS = (r) => r.Hi(), qS = (r) => r.Wi(), JS = (r) => r.Xi(), QS = (r) => r.Zi(), tA = (r) => r.min.x, eA = (r) => r.max.x, iA = (r) => r.min.y, sA = (r) => r.max.y, Ph = (r, t, e, i, s) => {
  if (r.length > 0) {
    let o = s ? i(s) : void 0;
    for (let n = 0; n < r.length; n += 1) {
      const a = t(r[n]);
      a !== void 0 && (o = o !== void 0 ? e(o, a) : a);
    }
    return o;
  }
  if (s) return i(s);
}, rA = j(0, 1), nA = j(1, 0), oA = j(0, -1), aA = j(-1, 0), lA = j(0, 0), Rm = (r) => {
  switch (r) {
    case ae.Up:
      return rA;
    case ae.Right:
      return nA;
    case ae.Down:
      return oA;
    case ae.Left:
      return aA;
    default:
      return lA;
  }
}, X0 = (r) => r === ae.Left || r === ae.Right, It = (r) => {
  r.stopPropagation(), r.preventDefault();
}, Mn = (r, t) => {
  if (!t) return r;
  const e = r.length, i = new Float32Array(2 * e);
  let s = 0;
  for (let o = 0; o < e; o += 1) {
    const n = r[o], a = Math.fround(n);
    i[s + 0] = a, i[s + 1] = n - a, s += 2;
  }
  return i;
}, ks = (r, t, e = Float32Array) => {
  if (!t) {
    const n = r.length, a = new e(2 * n);
    let l = 0;
    for (let h = 0; h < n; h += 1) {
      const u = r[h];
      a[l + 0] = u.x, a[l + 1] = u.y, l += 2;
    }
    return a;
  }
  const i = r.length, s = new e(4 * i);
  let o = 0;
  for (let n = 0; n < i; n += 1) {
    const a = r[n], l = Math.fround(a.x), h = Math.fround(a.y);
    s[o + 0] = l, s[o + 1] = h, s[o + 2] = a.x - l, s[o + 3] = a.y - h, o += 4;
  }
  return s;
}, Im = (r, t) => {
  if (!t) {
    const o = r.length, n = new Float32Array(3 * o);
    let a = 0;
    for (let l = 0; l < o; l += 1) {
      const h = r[l];
      n[a + 0] = h.x, n[a + 1] = h.y, n[a + 2] = h.z, a += 3;
    }
    return n;
  }
  const e = r.length, i = new Float32Array(6 * e);
  let s = 0;
  for (let o = 0; o < e; o += 1) {
    const n = r[o], a = Math.fround(n.x), l = Math.fround(n.y), h = Math.fround(n.z);
    i[s + 0] = a, i[s + 1] = l, i[s + 2] = h, i[s + 3] = n.x - a, i[s + 4] = n.y - l, i[s + 5] = n.z - h, s += 6;
  }
  return i;
}, Vm = (r, t, e, i, s) => r || t || e || i ? !r || t || e || i || s ? r || !t || e || i || s ? r || t || !e || i || s ? r || t || e || !i || s ? (o, n, a) => {
  const l = 3 + (s ? 3 : 0) + (r ? 4 : 0) + (t ? 1 : 0) + (e ? 1 : 0) + (i ? 3 : 0), h = o.length, u = new Float32Array(h * l);
  let c = 0, d = c;
  if (s) {
    for (let f = 0; f < h; f += 1) {
      const p = o[f], g = Math.fround(p.x), y = Math.fround(p.y), m = Math.fround(p.z);
      u[d + 0] = g, u[d + 1] = y, u[d + 2] = m, u[d + 3] = p.x - g, u[d + 4] = p.y - y, u[d + 5] = p.z - m, d += l;
    }
    c += 6;
  } else {
    for (let f = 0; f < h; f += 1) {
      const p = o[f];
      u[d + 0] = p.x, u[d + 1] = p.y, u[d + 2] = p.z, d += l;
    }
    c += 3;
  }
  if (r) {
    const f = a && Tr(a) && a.getFallbackColor() || ya;
    d = c;
    for (let p = 0; p < h; p += 1) {
      const g = o[p].color || f;
      u[d + 0] = g.r, u[d + 1] = g.g, u[d + 2] = g.b, u[d + 3] = g.a, d += l;
    }
    c += 4;
  }
  if (t) {
    const f = n && n.getSize();
    let p = 1;
    typeof f == "number" && (p = f), d = c;
    for (let g = 0; g < h; g += 1) {
      const y = o[g], m = y.size !== void 0 ? y.size : p;
      u[d + 0] = m, d += l;
    }
    c += 1;
  }
  if (e) {
    d = c;
    for (let f = 0; f < h; f += 1) {
      const p = o[f];
      u[d + 0] = p.value !== void 0 ? p.value : ju, d += l;
    }
    c += 1;
  }
  if (i) {
    const f = n && n.getSize();
    let p = { x: 1, y: 1, z: 1 };
    typeof f == "object" && (p = f), d = c;
    for (let g = 0; g < h; g += 1) {
      const y = o[g], m = y.sizeAxisX !== void 0 ? y.sizeAxisX : p.x, A = y.sizeAxisY !== void 0 ? y.sizeAxisY : p.y, v = y.sizeAxisZ !== void 0 ? y.sizeAxisZ : p.z;
      u[d + 0] = m, u[d + 1] = A, u[d + 2] = v, d += l;
    }
    c += 3;
  }
  return u;
} : (o, n, a) => hA(o, n) : (o, n, a) => dA(o) : (o, n, a) => cA(o, n) : (o, n, a) => uA(o, a) : (o, n, a) => Im(o, s), hA = (r, t) => {
  const e = t && t.getSize();
  let i = { x: 1, y: 1, z: 1 };
  typeof e == "object" && (i = e);
  const s = r.length, o = new Float32Array(6 * s);
  let n = 0;
  for (let a = 0; a < s; a += 1) {
    const l = r[a];
    o[n + 0] = l.x, o[n + 1] = l.y, o[n + 2] = l.z;
    const h = l.sizeAxisX !== void 0 ? l.sizeAxisX : i.x, u = l.sizeAxisY !== void 0 ? l.sizeAxisY : i.y, c = l.sizeAxisZ !== void 0 ? l.sizeAxisZ : i.z;
    o[n + 3] = h, o[n + 4] = u, o[n + 5] = c, n += 6;
  }
  return o;
}, uA = (r, t) => {
  const e = t && Tr(t) && t.getFallbackColor() || ya, i = r.length, s = new Float32Array(7 * i);
  for (let o = 0, n = 0; o < i; o += 1) {
    const a = r[o];
    s[n + 0] = a.x, s[n + 1] = a.y, s[n + 2] = a.z;
    const l = a.color || e;
    s[n + 3] = l.r, s[n + 4] = l.g, s[n + 5] = l.b, s[n + 6] = l.a, n += 7;
  }
  return s;
}, cA = (r, t) => {
  const e = t && t.getSize();
  let i = 1;
  typeof e == "number" && (i = e);
  const s = r.length, o = new Float32Array(4 * s);
  for (let n = 0, a = 0; n < s; n += 1) {
    const l = r[n];
    o[a + 0] = l.x, o[a + 1] = l.y, o[a + 2] = l.z;
    const h = l.size !== void 0 ? l.size : i;
    o[a + 3] = h, a += 4;
  }
  return o;
}, dA = (r) => {
  const t = r.length, e = new Float32Array(4 * t);
  for (let i = 0, s = 0; i < t; i += 1) {
    const o = r[i];
    e[s + 0] = o.x, e[s + 1] = o.y, e[s + 2] = o.z, e[s + 3] = o.value !== void 0 ? o.value : ju, s += 4;
  }
  return e;
}, _m = (r) => (t) => {
  const e = r.indexOf(t);
  e >= 0 && r.splice(e, 1);
}, fA = (r, t, e) => {
  const i = ((s, o) => {
    if (o < wt && o > Pt && s < wt && s > Pt) {
      const n = Math.abs(s / 8388608), a = Math.abs(o / 2 ** 23), l = Math.min(n, a);
      return 10 ** Math.floor(Math.log10(l));
    }
  })(r, t);
  if (i !== void 0) return i * e;
}, Om = (r) => {
  let t = r.length;
  for (let e = 0; e < t - 1; e += 1) r[e].x === r[e + 1].x && r[e].y === r[e + 1].y && (r.splice(e, 1), e -= 1, t -= 1);
  return r;
}, Cf = (r) => {
  const t = Math.log(r);
  return (e) => Math.log(e) / t;
}, gA = Cf(Math.E), Nm = (r, t) => {
  const e = t[r];
  return e ? e() : void 0;
}, Z0 = (r, t) => {
  let e;
  if (t) e = t;
  else {
    const i = { x: 0, y: 0 };
    for (let s = 0; s < r.length; s += 1) i.x += r[s].x / r.length, i.y += r[s].y / r.length;
    e = i;
  }
  return r.sort(((i, s) => Wl(oi(i, e)) - Wl(oi(s, e))));
}, us = (r, t, e) => {
  if (r.length === 0) return e.canReturnB === !1 ? t.slice() : t;
  const i = t.length;
  if (i < 1e5) return r.push.apply(r, t), r;
  for (let s = 0; s < i; s += 1) r.push(t[s]);
  return r;
}, fd = (r) => r.getA() === 255 ? r : r.setA(255), Su = (() => {
  const r = N(0, 0, 0);
  return (t) => (t = fd(t), new Ci({ angle: 180, stops: [{ offset: 0, color: t }, { offset: 1, color: Ki(t, r, 0.5) }] }));
})(), Bl = /* @__PURE__ */ (() => {
  const r = (t, e) => {
    var i;
    if (t) {
      if (de(t))
        return t.getColor().getA() === 0 ? void 0 : t.getColor();
      if (li(t) || hi(t)) {
        const s = t.getColorStops();
        return s.length === 2 ? s[1].color : (i = s[0]) === null || i === void 0 ? void 0 : i.color;
      }
      return Ve(t) && e !== void 0 ? t.lut.getColors(e, void 0) : void 0;
    }
  };
  return (t, e, i) => {
    var s;
    const o = [];
    if (i.fill && o.push(i.fill), i.fill2 && o.push(i.fill2), i.stroke) {
      const h = i.stroke.getFillStyle();
      h !== Lt && (((s = i.behavior) === null || s === void 0 ? void 0 : s.priority) === "stroke" ? o.unshift(h) : o.push(h));
    }
    if (i.point3D) {
      const h = i.point3D;
      o.push(h.getFillStyle());
    }
    let n;
    if (i.behavior && i.behavior.colorStep === !0) {
      const [h, u] = o.reduce(((c, d) => {
        if (c[0] && c[1]) return c;
        const f = r(d, i.lutValue);
        return f && (c[0] === void 0 ? c[0] = f : c[1] = f), c;
      }), [void 0, void 0]);
      n = h && u ? (a = h) === (l = u) || a.getR() === l.getR() && a.getG() === l.getG() && a.getB() === l.getB() ? Su(a) : (a = fd(a), l = fd(l), new Ci({ angle: 0, stops: [{ offset: 0, color: l }, { offset: 0.5, color: l }, { offset: 0.5, color: a }, { offset: 1, color: a }] })) : t.uiButtonFillStyle;
    } else {
      const h = o.reduce(((u, c) => u || r(c, i.lutValue)), void 0);
      n = h ? e ? new ot({ color: h }) : Su(h) : t.uiButtonFillStyle;
    }
    var a, l;
    return n;
  };
})(), is = (r, t) => {
  const e = r;
  if (Ve(e)) return { lut: e.getPalette(), lookUpProperty: e.getLookUpProperty(), valueRange: t };
}, wf = (r) => {
  let t = 0;
  return () => (t += 1, `${r}-${t}`);
}, ji = (r, t) => {
  let e = typeof r == "string" ? r : String(r);
  const i = e.indexOf(".");
  let s = i >= 0 ? i : e.length;
  for (; s < t; s += 1) e = `0${e}`;
  return e;
}, ue = (r, t) => typeof r == "function" ? r(t) : r, Js = (r, t) => t(), Bm = () => new Error(`LightningChart JS encountered an unexpected error.
Please report this issue to https://lightningchart.com/js-charts/docs/contact`), K0 = (r) => r === Ie || r.min.x === Ie.min.x && r.max.x === Ie.max.x && r.min.y === Ie.min.y && r.max.y === Ie.max.y, Cn = (r) => Array.from(new Set(r)), Mr = (r) => r.filter(((t) => t !== void 0)), dn = (r) => typeof r == "boolean" ? r ? 1 : 0 : r > 1 ? 1 : r < 0 ? 0 : r, Oa = (r, t) => {
  throw new Error(t);
}, hh = (r) => {
  let t;
  return () => t || (t = r(), t);
}, qi = (r) => {
  if (r === Et) return 0;
  const t = r.getThickness();
  return t < 0 ? 1 : 1 * t;
}, gd = (r, t, e, i) => {
  const s = `LightningChart JS Resources not found.
resourcesBaseUrl: "${r}"
initiator: ${e}
resource url: ${t}
For more information, please see https://lightningchart.com/js-charts/docs/troubleshooting/error-resources-not-found/`;
  if (i.shouldCrash) throw H.alert(s), new Error(s);
  H.console.warn(s);
}, Mc = (r, t, e, i = 0) => {
  if (r < e(i) || e(t) < r) return;
  const s = t;
  for (; i !== t; ) {
    const n = Math.ceil((i + t) / 2);
    r < e(n) ? t = n - 1 : i = n;
  }
  const o = Math.abs(r - e(i));
  return i < s && Math.abs(r - e(i + 1)) < o ? i + 1 : i;
}, Vo = () => {
  const r = /* @__PURE__ */ new Map();
  return { Ji: (t) => (Object.keys(Ml).forEach(((e) => {
    t.addEventListener(e, ((i, s) => {
      const o = s.collectionMember && r.get(s.collectionMember);
      if (!o) return;
      const n = bf(i) ? { clientX: i.changedTouches[0].clientX, clientY: i.changedTouches[0].clientY } : i, a = o.Qi(s.info, n, s.collectionMember);
      o.D.R(e, i, a);
    }));
  })), t), Ki: (t, e) => {
    r.set(t, e);
  }, Vi: () => {
    r.clear();
  } };
}, Me = { left: 0, right: 0, top: 0, bottom: 0 }, zm = () => Math.round(Math.random() * Number.MAX_SAFE_INTEGER), Wm = (r, t, e) => {
  t && t.qi();
  const i = e();
  return Object.keys(i).forEach(((s) => {
    const o = s, n = i[o];
    r.addEventListener(o, n);
  })), { ts: r, qi: () => {
    Object.entries(i).forEach((([s, o]) => {
      const n = s, a = o;
      r.removeEventListener(n, a);
    }));
  } };
}, Pr = (r, t, e) => {
  let i;
  const s = () => (i = e(), i), o = { ...r, resolve: () => i || s() };
  for (const n of Object.keys(t)) Object.defineProperty(o, n, { get: function() {
    return i ? i[n] : s()[n];
  } });
  return o;
}, q0 = (r) => {
  if (r) return "resolve" in r ? r.resolve() : r;
}, Cl = (r) => {
  let t = r;
  return { es: (e) => {
    const i = t;
    return t = i + e, [i, e];
  } };
}, Ao = (r) => {
  const t = Date.now();
  H.document.body.addEventListener(r, ((e) => {
    Date.now() - t > 500 || (e.stopPropagation(), e.preventDefault());
  }), { once: !0, capture: !0 });
}, sn = () => {
  const r = H.performance.now();
  H.document.body.addEventListener("contextmenu", ((t) => {
    H.performance.now() - r > 5e3 || t.preventDefault();
  }), { once: !0 });
}, Wr = () => {
  const r = H.performance.now();
  H.document.body.addEventListener("touchstart", ((t) => {
    H.performance.now() - r > 5e3 || t.preventDefault();
  }), { once: !0 });
}, gt = { add: (r, t) => Ht(r.x + t, r.y + t, r.z + t), addVec(r, ...t) {
  const e = { x: r.x, y: r.y, z: r.z };
  for (const i of t) e.x += i.x, e.y += i.y, e.z += i.z;
  return e;
}, subtract: (r, t) => Ht(r.x - t, r.y - t, r.z - t), subtractVec(r, ...t) {
  const e = { x: r.x, y: r.y, z: r.z };
  for (const i of t) e.x -= i.x, e.y -= i.y, e.z -= i.z;
  return e;
}, multiply: (r, t) => Ht(r.x * t, r.y * t, r.z * t), divide: (r, t) => Ht(r.x / t, r.y / t, r.z / t), multiplyVec(r, ...t) {
  const e = { x: r.x, y: r.y, z: r.z };
  for (const i of t) e.x *= i.x, e.y *= i.y, e.z *= i.z;
  return e;
}, divideVec(r, ...t) {
  const e = { x: r.x, y: r.y, z: r.z };
  for (const i of t) e.x /= i.x, e.y /= i.y, e.z /= i.z;
  return e;
}, length: (r) => Math.sqrt(r.x * r.x + r.y * r.y + r.z * r.z), normalize: (r) => gt.divide(r, gt.length(r)), dot: (r, t) => r.x * t.x + r.y * t.y + r.z * t.z, cross: (r, t) => Ht(r.y * t.z - r.z * t.y, r.z * t.x - r.x * t.z, r.x * t.y - r.y * t.x), angle: (r, t) => Math.acos(gt.dot(r, t) / (gt.length(r) * gt.length(t))), rotateAroundAxis(r, t, e) {
  const i = Math.cos(e), s = Math.sin(e), o = gt.dot(t, r), n = gt.cross(t, r);
  return gt.addVec(gt.multiply(r, i), gt.addVec(gt.multiply(t, (1 - i) * o), gt.multiply(n, s)));
}, lerp: (r, t, e) => (e = Jt(e, 0, 1), gt.addVec(gt.multiply(r, 1 - e), gt.multiply(t, e))), equals: (r, t) => Pi(r.x, t.x) && Pi(r.y, t.y) && Pi(r.z, t.z), abs: (r) => ({ x: Math.abs(r.x), y: Math.abs(r.y), z: Math.abs(r.z) }), sign: (r) => ({ x: Math.sign(r.x), y: Math.sign(r.y), z: Math.sign(r.z) }) }, wt = Number.MAX_VALUE, Pt = -Number.MAX_VALUE, Ie = Ee(j(wt, wt), j(Pt, Pt)), _s = Ee(Ht(wt, wt, wt), Ht(Pt, Pt, Pt)), pd = (r, t) => {
  const e = Math.log(r) / Math.log(t);
  return Math.floor(((i) => (Math.ceil(i) - i < 1e-4 ? i = Math.ceil(i) : i - Math.floor(i) < 1e-4 && (i = Math.floor(i)), i))(e));
}, ma = (r, t) => !(t.min.x > r.max.x || t.max.x < r.min.x || t.min.y > r.max.y || t.max.y < r.min.y), yd = (r, t) => !(r[1].x < t[0].x || r[0].x > t[1].x || r[3].y < t[0].y || r[0].y > t[3].y), pA = (r, t) => ({ min: { x: Math.min(r[0].x, t[0].x), y: Math.min(r[0].y, t[0].y) }, max: { x: Math.max(r[2].x, t[2].x), y: Math.max(r[2].y, t[2].y) } }), Gm = (r) => {
  const t = r.length;
  for (let e = 0; e < t; e += 1) for (let i = e + 1; i < t; i += 1) if (ma(r[e], r[i])) return !0;
  return !1;
}, zl = (r, t) => t + r, yA = (r, t, e) => {
  const i = oi(t, r), s = i.x * i.x + i.y * i.y;
  if (s === 0) return r;
  const o = oi(e, r), n = (o.x * i.x + o.y * i.y) / s;
  return n <= 0 ? r : n >= 1 ? t : j(r.x + n * i.x, r.y + n * i.y);
}, Ii = (r, t, e) => e > t ? r >= t && r <= e : r >= e && r <= t, ws = (r, t) => {
  const e = r.x - t.x, i = r.y - t.y;
  return Math.sqrt(e * e + i * i);
}, Au = (r, t) => {
  const e = r.x - t.x, i = r.y - t.y;
  return e * e + i * i;
}, mA = (r, t, e) => {
  let i = e.x - t.x, s = e.y - t.y;
  const o = i * i + s * s;
  if (o < 0.01) return Number.MAX_VALUE;
  const n = ((r.x - t.x) * i + (r.y - t.y) * s) / o, a = t.x + n * i, l = t.y + n * s;
  return i = r.x - a, s = r.y - l, i * i + s * s;
}, Ln = (r, t, e) => qt(r, pe(oi(t, r), e)), Cc = (r, t, e) => gt.addVec(r, gt.multiply(gt.subtractVec(t, r), e));
function Vi(r) {
  const t = r.length;
  if (t > 0) {
    let e = r[0].x, i = r[0].x, s = r[0].y, o = r[0].y;
    for (let n = 1; n < t; n += 1) {
      const a = r[n];
      a.x > e && (e = a.x), a.x < i && (i = a.x), a.y > s && (s = a.y), a.y < o && (o = a.y);
    }
    return Ee(j(i, o), j(e, s));
  }
  return Ie;
}
function Tf(r) {
  const t = r.length;
  if (t > 0) {
    let e = r[0].x, i = r[0].x, s = r[0].y, o = r[0].y, n = r[0].z, a = r[0].z;
    for (let l = 0; l < t; l += 1) {
      const h = r[l];
      h.x > e && (e = h.x), h.x < i && (i = h.x), h.y > s && (s = h.y), h.y < o && (o = h.y), h.z > n && (n = h.z), h.z < a && (a = h.z);
    }
    return Ee(Ht(i, o, a), Ht(e, s, n));
  }
  return _s;
}
const Qs = (...r) => {
  const t = { min: { x: wt, y: wt }, max: { x: Pt, y: Pt } };
  for (const e of r) t.min.x = t.min.x < e.min.x ? t.min.x : e.min.x, t.max.x = t.max.x > e.max.x ? t.max.x : e.max.x, t.min.y = t.min.y < e.min.y ? t.min.y : e.min.y, t.max.y = t.max.y > e.max.y ? t.max.y : e.max.y;
  return t;
}, bu = (r, t) => Ee(Ht(r.min.x < t.min.x ? r.min.x : t.min.x, r.min.y < t.min.y ? r.min.y : t.min.y, r.min.z < t.min.z ? r.min.z : t.min.z), Ht(r.max.x > t.max.x ? r.max.x : t.max.x, r.max.y > t.max.y ? r.max.y : t.max.y, r.max.z > t.max.z ? r.max.z : t.max.z));
function xA(r, t, e, i) {
  const s = r.x - i.x, o = r.y - i.y, n = i.x - e.x, a = e.y - i.y, l = a * s + n * o, h = (i.y - t.y) * s + (t.x - i.x) * o, u = a * (t.x - i.x) + n * (t.y - i.y);
  return u < 0 ? l <= 0 && h <= 0 && l + h >= u : l >= 0 && h >= 0 && l + h <= u;
}
const wc = (r, t, e) => !(r.x > e.x || r.y > e.y || r.x < t.x || r.y < t.y);
function Un(r, t, e) {
  return j(Math.cos(e) * (r.x - t.x) + Math.sin(e) * (r.y - t.y) + t.x, -Math.sin(e) * (r.x - t.x) + Math.cos(e) * (r.y - t.y) + t.y);
}
function J0(r, t) {
  return j(r.x - t.x, r.y - t.y);
}
function Os(r) {
  const t = an(r);
  return t === 0 ? j(0, 0) : j(r.x / t, r.y / t);
}
function $u(r, t) {
  let e = { x: t.x - r.x, y: t.y - r.y };
  e = Os(e);
  const i = Math.PI / 2, s = e.x;
  return e.x = -Math.sin(i) * e.y, e.y = s * Math.sin(i), e;
}
function an(r) {
  return Math.sqrt(r.x * r.x + r.y * r.y);
}
function pe(r, t) {
  return j(r.x * t, r.y * t);
}
function qt(r, t) {
  return j(r.x + t.x, r.y + t.y);
}
function oi(r, t) {
  return j(r.x - t.x, r.y - t.y);
}
function ls(r, t) {
  return j(r.x * t.x, r.y * t.y);
}
function wl(r, t) {
  return j(r.x / t.x, r.y / t.y);
}
function Q0(r) {
  return pe(r, -1);
}
function nu(r, t) {
  return r.x * t.x + r.y * t.y;
}
const Rh = (r, t, e) => {
  const i = (e.y - t.y) / (e.x - t.x), s = t.y + (r - t.x) * i;
  return j(r, s);
};
function $n(r) {
  return r * Math.PI / 180;
}
function Wl(r) {
  return 180 * Math.atan2(r.y, r.x) / Math.PI;
}
function kf(r) {
  return j(Math.cos(r), Math.sin(r));
}
const Um = (r, t, e, i) => {
  let s, o, n, a;
  if (t.x - r.x != 0 || i.x - e.x != 0) return t.x - r.x == 0 ? (n = t.x, o = (i.y - e.y) / (i.x - e.x), a = o * (n - e.x) + e.y) : i.x - e.x == 0 ? (n = i.x, s = (t.y - r.y) / (t.x - r.x), a = s * (n - r.x) + r.y) : (s = (t.y - r.y) / (t.x - r.x), o = (i.y - e.y) / (i.x - e.x), n = (e.y - o * e.x + s * r.x - r.y) / (s - o), a = s * (n - r.x) + r.y), j(n, a);
}, tg = (r, t) => {
  const e = r.length, i = t.length, s = new Uint16Array(e + i);
  return s.set(r, 0), s.set(t, e), s;
};
class Jn extends wm {
  constructor(t, e, i, s) {
    super(t, e, i, s), this.rs = { internal: 10, function: bo(10), number: 10 }, this.j = 1e3, this.Z(1, 1e3), this.st = this.hs();
  }
  nt(t, e, i, s, o) {
    if (t === e) return !1;
    const n = Math.min(t, e) < Ih, a = Math.max(t, e) > Tc;
    return !n && !a || !!o && (e > t ? { start: n ? Ih : t, end: a ? Tc : e } : { start: a ? Tc : t, end: n ? Ih : e });
  }
  Rt(t) {
    const e = this.wt(), i = this.kt(), s = Math.max(t, Ih);
    return e + (this.rs.function(s) - this.st.scaleStartLog) / this.st.scaleIntervalLog * (i - e);
  }
  Ot(t) {
    const e = this.wt(), i = (t - e) / (this.kt() - e), s = this.st.scaleStartLog + i * this.st.scaleIntervalLog;
    return this.rs.number ** s;
  }
  Lt() {
    this.rs && this.hs();
  }
  Z(t, e) {
    return super.Z(t, e), this.rs && this.hs(), this;
  }
  _t(t) {
    return super._t(t), this.rs && this.hs(), this;
  }
  K(t) {
    return super.K(t), this.rs && this.hs(), this;
  }
  ns(t) {
    return this.rs = { internal: t, function: bo(t), number: xa(t) }, this;
  }
  ls() {
    return this.rs.internal;
  }
  Qt(t, e) {
    const i = this.Rt(t) + e;
    return this.Ot(i);
  }
  Et() {
    return this.ct || this.ot || this.ft || this.ut;
  }
  hs() {
    const t = this.rs.function(this.$), e = this.rs.function(this.U) - t, i = 2 * this.wt() / this.j - 1, s = 2 * this.kt() / this.j - 1 - i;
    return this.st = { scaleStartLog: t, scaleIntervalLog: e, viewportStart: i, viewportSize: s }, this.st;
  }
  ht() {
    return this.st;
  }
}
const bo = (r) => r === "e" ? gA : Cf(r), xa = (r) => r === "e" ? Math.E : r, Ih = 0.9 * 10 ** -20, Tc = 1.1 * 10 ** 25, vA = [{ prefix: "T", unit: 10 ** 12 }, { prefix: "B", unit: 10 ** 9 }, { prefix: "M", unit: 1e6 }, { prefix: "K", unit: 1e3 }], Hm = (r, t, e) => {
  const i = Math.abs(e - t);
  if (i === 0) return r.toFixed(0);
  const s = Math.max(2 - pd(i, 10), 0);
  return r.toFixed(s);
}, en = { Numeric: (r, t) => {
  const { start: e, end: i } = t;
  return Hm(r, e, i);
}, NumericUnits: (r, t) => {
  const { start: e, end: i } = t, s = Math.abs(i - e), o = r < 0;
  r = Math.abs(r);
  let n = "", a = "";
  if (s >= 1e3 && r > 1e3) {
    let l = "";
    for (const h of vA) {
      const u = Math.round(1e3 * r / h.unit) / 1e3;
      if (u >= 1) {
        l = u.toString(), a = h.prefix;
        break;
      }
    }
    n = (o ? "-" : "") + l;
  } else {
    let l = String(Math.floor(r));
    const h = pd(r, 1e3);
    for (let u = 1; u <= h; u += 1) {
      const c = l.length - (3 * u + (u - 1));
      l = `${l.substring(0, c)} ${l.substring(c, l.length)}`;
    }
    n = (o ? "-" : "") + l + (s <= 10 ? ((u, c) => {
      if (c === 0) return "";
      let d = (Math.abs(u) - Math.abs(Math.floor(u))).toString().substring(1);
      return d.length > c && (d = d.substring(0, c + 1)), d;
    })(r, 2 - pd(s, 10)) : "");
  }
  return n += a, n;
}, LogarithmicExponentsRounded: (r, t, e, i = 10) => {
  const s = bo(i)(r);
  return `${i}${kc(s)}`;
}, LogarithmicExponents: (r, t, e, i = 10) => {
  const s = bo(i), o = Math.floor(s(r)), n = r / xa(i) ** o;
  return `${Math.round(n)}×${i}${kc(o)}`;
}, LogarithmicExtreme: (r, t, e, i = 10) => {
  const s = bo(i), o = Math.floor(s(r));
  return `${(r / xa(i) ** o).toFixed(2)}×${i}${kc(o)}`;
}, LogarithmicNoExponents: (r, t, e, i = 10) => {
  const s = bo(i);
  if (i === "e") return `${Math.floor(s(r))}e`;
  const o = r.toString();
  if (r > 1) return o;
  const n = Math.floor(s(r));
  return r.toFixed(Math.abs(n));
}, Scientific: (r, t) => {
  const { start: e, end: i } = t, s = Math.max(Math.abs(e), Math.abs(i)), o = Math.floor(Math.log10(s));
  return r === 0 ? `0.00e${o < 0 ? "" : "+"}${o}` : r.toExponential(2);
} }, kc = (r) => Math.round(r).toString().split("").map(((t) => {
  switch (t) {
    case "0":
      return "⁰";
    case "1":
      return "¹";
    case "2":
      return "²";
    case "3":
      return "³";
    case "4":
      return "⁴";
    case "5":
      return "⁵";
    case "6":
      return "⁶";
    case "7":
      return "⁷";
    case "8":
      return "⁸";
    case "9":
      return "⁹";
    case "-":
      return "⁻";
    default:
      return t;
  }
})).join(""), SA = (r, t) => r.value - t.value, AA = De({ type: "lut", steps: [], title: "", units: "", interpolate: !0, color: N(0, 0, 0, 255), length: 0, min: 0, max: 0, subranges: [], isValid: !1, percentageValues: !1, formatter: (r, t) => Hm(r, t.min, t.max) }), eg = (r) => {
  const { steps: t } = r, e = t.length;
  t.sort(SA);
  const [i, s] = e > 0 ? [t[0].value, t[e - 1].value] : [0, 0], o = e > 0 ? e - 1 : 0, n = Array(o);
  for (let a = 0; a < o; a += 1) n[a] = { min: t[a], max: t[a + 1] };
  return { min: i, max: s, length: e, steps: t, subranges: n, isValid: e > 0 && i !== s };
};
class bA extends AA {
  constructor(t) {
    super(((e, i) => ({ steps: e.steps, title: e.title, units: e.units, interpolate: e.interpolate, percentageValues: e.percentageValues, color: e.color, formatter: e.formatter, length: i.length, min: i.min, max: i.max, subranges: i.subranges, isValid: i.isValid }))(t, eg(t)));
  }
  toString() {
    return `LUT:interpolate=${this.interpolate},steps=${this.steps.length},percentage=${this.percentageValues}`;
  }
  setSteps(t) {
    return this.merge(eg({ ...this, steps: t }));
  }
  getSteps() {
    return this.get("steps");
  }
  setTitle(t) {
    return this.set("title", t);
  }
  getTitle() {
    return this.get("title");
  }
  setUnits(t) {
    return this.set("units", t);
  }
  getUnits() {
    return this.get("units");
  }
  setInterpolation(t) {
    return this.set("interpolate", t);
  }
  getInterpolation() {
    return this.get("interpolate");
  }
  setFallbackColor(t) {
    return this.set("color", t);
  }
  getFallbackColor() {
    return this.get("color");
  }
  setPercentageValues(t) {
    return this.set("percentageValues", t);
  }
  getPercentageValues() {
    return this.get("percentageValues");
  }
  setFormatter(t) {
    return this.set("formatter", t);
  }
  getFormatter() {
    return this.get("formatter");
  }
  getColors(t, e) {
    if (Array.isArray(t)) {
      if (Array.isArray(t[0])) {
        const n = t, a = n.length, l = n[0].length, h = [...Array(a)].map((() => Array(l)));
        for (let u = 0; u < a; u += 1) for (let c = 0; c < l; c += 1) h[u][c] = this.us(n[u][c], e);
        return h;
      }
      const i = t, s = i.length, o = Array(s);
      for (let n = 0; n < s; n += 1) o[n] = this.us(i[n], e);
      return o;
    }
    return this.us(t, e);
  }
  us(t, e) {
    const { steps: i } = this, s = i.length;
    if (s === 0) return this.getFallbackColor();
    if (s === 1) return i[0].color || this.color;
    if (this.percentageValues, this.percentageValues && e && (t = Math.max(Math.min((t - e.min) / (e.max - e.min), 1), 0)), this.interpolate) {
      for (let l = 0; l < s - 1; l += 1) {
        const h = i[l], u = i[l + 1], c = Math.min(h.value, u.value), d = Math.max(h.value, u.value);
        if (t >= c && t <= d) {
          if (c === d) return h.color;
          const f = (t - h.value) / (u.value - h.value);
          return o = h.color, n = u.color, a = f, new ur({ r: o.r + (n.r - o.r) * a, g: o.g + (n.g - o.g) * a, b: o.b + (n.b - o.b) * a, a: o.a + (n.a - o.a) * a });
        }
      }
      return t < i[0].value ? i[0].color : i[s - 1].color;
    }
    var o, n, a;
    for (let l = s - 1; l >= 0; l -= 1) if (t >= i[l].value) return i[l].color;
    return i[0].color;
  }
}
const EA = (r) => !(!r || typeof r != "object" || !("type" in r) || r.type !== "lut"), va = (r, t) => r.formatter(t, { min: r.min, max: r.max, percentageValues: r.percentageValues }), MA = De({ type: "fillstyle", fillType: "empty" });
class CA extends MA {
  toString() {
    return "emptyFill";
  }
  toCSS() {
    return "transparent";
  }
}
const Lt = new CA(), Qn = (r) => !!(r && typeof r == "object" && "type" in r && r.type === "fillstyle" && "fillType" in r && r.fillType === "empty"), wA = De({ type: "fillstyle", fillType: "solid", color: N(255, 255, 255) });
class Ym extends wA {
}
class ot extends Ym {
  constructor(t) {
    super({ ...t, fillType: "solid" });
  }
  toString() {
    return `solidFill:${this.color.toString()}`;
  }
  toCSS() {
    return this.color.toRGBAString();
  }
  setColor(t) {
    return ko(t) ? this.set("color", t) : this.set("color", t(this.get("color")));
  }
  getColor() {
    return this.get("color");
  }
  setA(t) {
    return this.setColor(this.getColor().setA(t));
  }
  setR(t) {
    return this.setColor(this.getColor().setR(t));
  }
  setG(t) {
    return this.setColor(this.getColor().setG(t));
  }
  setB(t) {
    return this.setColor(this.getColor().setB(t));
  }
}
const de = (r) => !!(r && typeof r == "object" && "type" in r && r.type === "fillstyle" && "fillType" in r && r.fillType === "solid");
class md extends Ym {
  constructor(t) {
    super({ ...t, fillType: "individual" });
  }
  toString() {
    return `individualPointFill:${this.color.toString()}`;
  }
  toCSS() {
    return this.getFallbackColor().toRGBAString();
  }
  setFallbackColor(t) {
    return ko(t) ? this.set("color", t) : this.set("color", t(this.get("color")));
  }
  getFallbackColor() {
    return this.get("color");
  }
}
const Tr = (r) => !!(r && typeof r == "object" && "type" in r && r.type === "fillstyle" && "fillType" in r && r.fillType === "individual"), TA = De({ type: "fillstyle", fillType: "palette", lut: new bA({ steps: [] }), lookUpProperty: "value" });
class kA extends TA {
  constructor(t) {
    super({ ...t, fillType: "palette" });
  }
  toString() {
    return `palettedFill:lut=${this.lut.toString()},lookUpProperty=${this.lookUpProperty}`;
  }
  toCSS() {
    return `linear-gradient(${this.lut.getSteps().map(((t) => t.color.toRGBAString())).join(", ")})`;
  }
  getPalette() {
    return this.get("lut");
  }
  setLookUpProperty(t) {
    return typeof t == "function" ? this.set("lookUpProperty", t(this.get("lookUpProperty"))) : this.set("lookUpProperty", t);
  }
  getLookUpProperty() {
    return this.get("lookUpProperty");
  }
}
const Ve = (r) => !!(r && typeof r == "object" && "type" in r && r.type === "fillstyle" && "fillType" in r && r.fillType === "palette"), jm = (r, t) => r instanceof Jn || t instanceof Jn ? new Ti().Kt(r, t) : new we().Kt(r, t), Mo = (r) => r === "client", Df = (r) => !!(r && typeof r == "object" && "clientX" in r && typeof r.clientX == "number" && "clientY" in r && typeof r.clientY == "number"), kr = (r) => r === "relative", ig = (r) => !!(r && typeof r == "object" && "x" in r && typeof r.x == "number" && "y" in r && typeof r.y == "number"), _o = (r, t, e, i) => {
  let s, o, n = Number.MAX_VALUE;
  for (let a = 0; a < t.length; a += 1) {
    const l = t[a], h = e(l, r);
    if (h) {
      const u = i(r, h);
      (s === void 0 || u < n) && (s = h, o = l, n = u);
    }
  }
  return s && o ? [s, o] : void 0;
}, ge = (r, t, e, i, s, o) => {
  if (!r) return;
  let n = r;
  const a = e instanceof PointerEvent && e.pointerType === "mouse" && e;
  if (a) {
    if (a.button === 0) {
      if (r.lmb === !1) return;
      r.lmb !== void 0 && (n = Zi(n, r.lmb));
    } else if (a.button === 1) {
      if (r.mmb === !1) return;
      r.mmb !== void 0 && (n = Zi(n, r.mmb));
    } else if (a.button === 2) {
      if (r.rmb === !1) return;
      r.rmb !== void 0 && (n = Zi(n, r.rmb));
    }
  }
  if (i) {
    if (r.shift === !1) return;
    n = Zi(n, r.shift);
  }
  if (s) {
    if (r.ctrl === !1) return;
    n = Zi(n, r.ctrl);
  }
  if (o) {
    if (r.alt === !1) return;
    n = Zi(n, r.alt);
  }
  if (!t) return n;
  const l = n[t];
  return l ? l === !0 ? n : Zi(n, l) : void 0;
}, xr = (r) => {
  const t = [];
  return { push: (e, i) => {
    t.push({ clbk: i, label: e });
  }, end: () => {
    t.length > 1 && r && H.console.warn(`LightningChart JS warning | event handler triggered more than 1 interaction.
This likely means that your \`chart.setUserInteractions\` configuration either enables conflicting interactions or more likely doesn't disable conflicting default interactions.
Fired interactions: ${t.map(((e) => e.label)).join(", ")}`), t.forEach(((e) => e.clbk()));
  } };
}, Ff = (r, t, e) => {
  if (r) {
    const i = { x: e.x.wt(), y: e.y.wt(), width: e.x.Ct(), height: e.y.Ct() };
    t.forEach(((s) => {
      s.fs = i;
    }));
  } else t.forEach(((i) => {
    i.fs = void 0;
  }));
}, Ai = (r, t) => {
  var e;
  return t ? typeof t == "string" ? `${r} ${t}` : ((e = t.As) === null || e === void 0 ? void 0 : e.displayInCursor) !== !1 && t.getUnits() ? `${r} ${t.getUnits()}` : r : r;
}, xd = (r) => {
  let t = !1, e = { type: "linear" };
  if (r && (r.opposite !== void 0 && (t = r.opposite), r.type && r.type === "linear-highPrecision" && (e = { type: "linear-highPrecision" }), r.type && r.type === "logarithmic")) {
    let i = 10;
    if (r.base) {
      if (r.base === "E" || r.base === "e" || r.base === "natural") i = "e";
      else if (typeof r.base == "number") i = r.base;
      else if (typeof r.base == "string") try {
        i = Number(r.base);
      } catch {
        console.warn(`Unidentified logarithmic base "${r.base}"`);
      }
    }
    e = { base: i, type: "logarithmic" };
  }
  return { opposite: t, type: e };
}, Sa = (r, t, e, i = 1) => Jt(r + 0.1 * i * (t - r) + 0.5 * i * Math.abs(e.getPixelSize()) * Math.sign(t - r), r, t), Eu = (r, t, e, i = 1) => {
  const s = e.Rt(r), o = e.Rt(t);
  return Jt(e.Ot(s + 0.1 * i * (o - s) + 0.5 * i * Math.sign(o - s)), r, t);
};
var Qi, es;
(function(r) {
  r[r.noHighlighting = 0] = "noHighlighting", r[r.onHover = 1] = "onHover", r[r.onHoverIndividual = 2] = "onHoverIndividual";
})(Qi || (Qi = {}));
class to {
  constructor(t, e, i, s) {
    this.gs = Qi.onHover, this.ci = !1, this.di = !0, this.vs = [], this.chart = t, this.ys = e, this.xi = i, this.ps = /* @__PURE__ */ new Map(), this.Ss = s, this.bs = this.Ss.xs(this, { Ms: { themeEffectEnabled: this.xi.effectsText }, _s: {} }), this.chart.yi.ks.ws(this, ((o) => {
      this.ps.forEach(((n, a) => a.Ii(o))), this.vs.forEach(((n) => n.Ii(o)));
    }), { animationEnabled: this.chart.getAnimationsEnabled() }), H.requestAnimationFrame((() => {
      this.ci || (this.addEventListener("pointerenter", (() => {
        this.gs === Qi.onHover && this.setHighlight(!0);
      })), this.addEventListener("pointerleave", (() => {
        this.gs === Qi.onHover && this.setHighlight(!1);
      })));
    }));
  }
  Cs() {
  }
  Ts(t, e) {
    const i = e?.setEventHandlers === void 0 || e.setEventHandlers, s = e?.pointerEventsDisabled !== void 0 && e.pointerEventsDisabled, o = e?.isText !== void 0 && e.isText;
    this.ps.set(t, { isText: o, pointerEventsDisabled: s });
    const n = Array.from(this.ps);
    this.bs.Ms.Fs(n.filter(((l) => l[1].isText)).map(((l) => l[0]))), this.bs._s.Fs(n.filter(((l) => !l[1].isText)).map(((l) => l[0]))), t.setVisible(this.di).Ii(this.chart.yi.ks.Is(this, !0)), H.requestAnimationFrame((() => {
      this.ci || t.isDisposed() || (t.setPointerEvents(e?.pointerEventsDisabled !== !0 && this.getPointerEvents()), i && this.D.zi(t, { getExtraData: (l, h, u) => this.Qi(u, l, h) }));
    }));
    const a = (l) => {
      t.removeEventListener("dispose", a), this.ps.delete(t);
    };
    t.addEventListener("dispose", a);
  }
  Ps(t) {
    this.vs = t;
    const e = this.chart.yi.ks.Is(this, !0);
    t.forEach(((i) => {
      i.Ii(e).Ls(this.di);
    }));
  }
  Qi(t, e, i) {
  }
  Bs(t) {
    const e = this.chart.yi.Ds(t);
    if (e && Array.from(this.ps.keys()).includes(e.entity)) return this.Qi(e.info, t, e.collectionMember);
  }
  setEffect(t) {
    return this.bs.Ms.Es(t && this.xi.effectsText), this.bs._s.Es(t), this.chart.yi.Rs(), this;
  }
  getEffect() {
    return this.bs.Ms.Os() || this.bs._s.Os();
  }
  setIcon(t) {
    return this.zs = t, this.chart.yi.Rs(), this;
  }
  getIcon() {
    return this.zs;
  }
  setName(t) {
    return this.Vs = t, this;
  }
  getName() {
    return this.Vs || "Component";
  }
  dispose() {
    return this.ci || (this.ci = !0, this.ps.forEach(((t, e) => e.dispose())), this.ys(this), this.D.R("dispose", {}), this.chart.legend.remove(this), this.chart.yi.Rs()), this;
  }
  setVisible(t) {
    return t === this.di || (this.di = t, this.ps.forEach(((e, i) => i.setVisible(t))), this.vs.forEach(((e) => e.Ls(t))), this.D.R("visiblechange", { isVisible: t }), this.chart.Ns.forEach(((e) => e.Gs())), this.chart.yi.Rs()), this;
  }
  getVisible() {
    return this.di;
  }
  setHighlight(t) {
    return this.chart.yi.ks.$s(this, t), this.D.R("highlightchange", { highlight: dn(t) }), this;
  }
  getHighlight() {
    return this.chart.yi.ks.Is(this);
  }
  setAnimationHighlight(t) {
    return this.chart.yi.ks.Us(this, t), this;
  }
  getAnimationHighlight() {
    return this.chart.yi.ks.js(this);
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
  getPointed() {
    if (!this.chart.yi.Ys()) return !1;
    for (const t of this.ps) if (this.chart.yi.Hs(t[0])) return !0;
    for (const t of this.vs) if (this.chart.yi.Hs(void 0, t)) return !0;
    return !1;
  }
  setHighlightOnHover(t) {
    return this.gs = typeof t == "boolean" ? t ? Qi.onHover : Qi.noHighlighting : t, this.gs === Qi.noHighlighting && this.getHighlight() > 0 && this.setHighlight(!1), this;
  }
  getHighlightOnHover() {
    return this.gs !== Qi.noHighlighting;
  }
  Ws() {
  }
  Xs() {
    return this.zs;
  }
  isDisposed() {
    return this.ci;
  }
  set draggable(t) {
    this.D.draggable = t;
  }
  get draggable() {
    return this.D.draggable;
  }
}
class $m extends to {
  constructor(t, e, i, s, o, n, a, l) {
    super(e, i, a, l), this.Zs = !0, this.Js = t, this.axis = s, this.ai = o, this.Qs = n, H.requestAnimationFrame((() => this.Ks()));
  }
  setClipping(t) {
    return this.Zs = t, this.Js.Rs(), this;
  }
  getClipping() {
    return this.Zs;
  }
}
(function(r) {
  r[r.Other = 0] = "Other", r[r.CursorResultTable = 1] = "CursorResultTable", r[r.CursorTickMarker = 2] = "CursorTickMarker", r[r.ChartTitle = 3] = "ChartTitle", r[r.AxisTitle = 4] = "AxisTitle";
})(es || (es = {}));
const Xm = (r) => typeof r == "object" && r !== null && "setCornerRadius" in r;
var Je;
(function(r) {
  r[r.Square = 0] = "Square", r[r.Circle = 1] = "Circle", r[r.HollowCircle = 2] = "HollowCircle", r[r.Triangle = 3] = "Triangle", r[r.Cross = 4] = "Cross", r[r.Diamond = 5] = "Diamond", r[r.Plus = 6] = "Plus", r[r.Minus = 7] = "Minus", r[r.Arrow = 8] = "Arrow", r[r.Star = 9] = "Star";
})(Je || (Je = {}));
const js = (r) => r === "ProgressiveX" || r === "RegressiveX" ? "x" : "y", Wn = (r) => r === "ProgressiveX" || r === "ProgressiveY", tr = (r, t, e) => r * (1 - e) + t * e, Lf = (r, t, e, i, s) => {
  if (t.value === void 0 || e.value === void 0 || i.value === void 0 || s.value === void 0) return;
  const o = (r.x - e.point.x) / (s.point.x - e.point.x), n = (s.point.y - e.point.y) * o + e.point.y, a = (r.x - t.point.x) / (i.point.x - t.point.x), l = (i.point.y - t.point.y) * a + t.point.y, h = (r.y - l) / (n - l), u = tr(e.value, s.value, o), c = tr(t.value, i.value, a);
  return tr(c, u, h);
};
class Pf {
  constructor() {
    this.type = "simple";
  }
}
const Na = new Pf();
class DA {
  constructor(t) {
    this.type = "phong", this.ambientReflection = 1, this.specularReflection = 0.1, this.diffuseReflection = 1, this.ambientColor = Xe("#000"), this.specularColor = Xe("#fff"), this.shininess = 32, t && (this.ambientReflection = Number.isNaN(Number(t.ambientReflection)) ? this.ambientReflection : Number(t.ambientReflection), this.specularReflection = Number.isNaN(Number(t.specularReflection)) ? this.specularReflection : Number(t.specularReflection), this.diffuseReflection = Number.isNaN(Number(t.diffuseReflection)) ? this.diffuseReflection : Number(t.diffuseReflection), this.ambientColor = t.ambientColor || this.ambientColor, this.specularColor = t.specularColor || this.specularColor, this.shininess = t.shininess || this.shininess);
  }
}
const Ba = new DA(), Zm = { Simple: Pf };
class Km {
  getFillStyle() {
    return Lt;
  }
}
const sg = new Km(), FA = De({ type: "triangulated-points-3d", shape: "sphere", size: 10, fillStyle: new ot(), wireframeStyle: Et });
class Rf extends FA {
  constructor(t) {
    super(t);
  }
  setSize(t) {
    return this.set("size", t);
  }
  getSize() {
    return this.get("size");
  }
  setFillStyle(t) {
    return typeof t == "function" ? this.set("fillStyle", t(this.get("fillStyle"))) : this.set("fillStyle", t);
  }
  getFillStyle() {
    return this.get("fillStyle");
  }
  setWireframeStyle(t) {
    return typeof t == "function" ? this.set("wireframeStyle", t(this.get("wireframeStyle"))) : this.set("wireframeStyle", t);
  }
  getWireframeStyle() {
    return this.get("wireframeStyle");
  }
  setShape(t) {
    return this.set("shape", t);
  }
  getShape() {
    return this.get("shape");
  }
}
const wn = (r) => !(!r || typeof r != "object" || !("type" in r) || r.type !== "triangulated-points-3d"), LA = De({ type: "pixelated-points-3d", size: 5, fillStyle: new ot() });
class PA extends LA {
  constructor(t) {
    super(t);
  }
  setSize(t) {
    return this.set("size", t);
  }
  getSize() {
    return this.get("size");
  }
  setFillStyle(t) {
    return typeof t == "function" ? this.set("fillStyle", t(this.get("fillStyle"))) : this.set("fillStyle", t);
  }
  getFillStyle() {
    return this.get("fillStyle");
  }
}
const rg = (r) => !(!r || typeof r != "object" || !("type" in r) || r.type !== "pixelated-points-3d"), Mu = { Triangulated: Rf, Pixelated: PA }, RA = De({ type: "linestyle", lineType: "solid", fillStyle: new ot({ color: N(255, 255, 255) }), thickness: 1 });
class $t extends RA {
  constructor(t) {
    super({ ...t, lineType: "solid" });
  }
  setFillStyle(t) {
    return typeof t == "function" ? this.set("fillStyle", t(this.getFillStyle())) : this.set("fillStyle", t);
  }
  getFillStyle() {
    return this.get("fillStyle");
  }
  setThickness(t) {
    return typeof t == "function" ? this.set("thickness", t(this.getThickness())) : this.set("thickness", t);
  }
  getThickness() {
    return this.get("thickness");
  }
  Yi() {
    const t = this.getThickness();
    return t < 0 ? 1 : t;
  }
}
const Oi = (r) => !(!r || typeof r != "object" || !("lineType" in r) || r.lineType !== "solid"), uh = { Dotted: [1, 3], Dashed: [3, 1], DashedEqual: [2, 2], DashedLoose: [2, 4] }, IA = De({ type: "linestyle", lineType: "dashed", pattern: uh.DashedEqual, fillStyle: new ot({ color: N(255, 255, 255) }), thickness: 1, patternScale: 3 });
class Xu extends IA {
  constructor(t) {
    super({ ...t, lineType: "dashed" });
  }
  setFillStyle(t) {
    return typeof t == "function" ? this.set("fillStyle", t(this.getFillStyle())) : this.set("fillStyle", t);
  }
  getFillStyle() {
    return this.get("fillStyle");
  }
  setThickness(t) {
    return typeof t == "function" ? this.set("thickness", t(this.getThickness())) : this.set("thickness", t);
  }
  getThickness() {
    return this.get("thickness");
  }
  Yi() {
    const t = this.getThickness();
    return t < 0 ? 1 : t;
  }
  setPattern(t) {
    return typeof t == "function" ? this.set("pattern", t(this.getPattern())) : this.set("pattern", t);
  }
  getPattern() {
    return this.get("pattern");
  }
  setPatternScale(t) {
    return typeof t == "function" ? this.set("patternScale", t(this.getPatternScale())) : this.set("patternScale", t);
  }
  getPatternScale() {
    return this.get("patternScale");
  }
}
const Oo = (r) => !(!r || typeof r != "object" || !("lineType" in r) || r.lineType !== "dashed"), VA = De({ type: "icon", width: void 0, height: void 0, qs: void 0, te: ie, ie });
class _A extends VA {
  constructor(t, e, i, s) {
    super({ ...s, qs: t, te: e, ie: i });
  }
  dispose() {
    return this.ie(this), this;
  }
  setWidth(t) {
    const e = this.set("width", t);
    return this.te(e), e;
  }
  getWidth() {
    return this.get("width");
  }
  setHeight(t) {
    const e = this.set("height", t);
    return this.te(e), e;
  }
  getHeight() {
    return this.get("height");
  }
  setSize(t, e) {
    const i = this.withMutations(((s) => {
      s.set("width", t).set("height", e);
    }));
    return this.te(i), i;
  }
  Ft() {
    if (!this.qs) return { x: 0, y: 0 };
    const t = this.qs.width, e = this.qs.height;
    if (t === 0 || e === 0) return { x: 0, y: 0 };
    const i = this.width, s = this.height;
    return typeof i == "number" && typeof s == "number" ? { x: i, y: s } : typeof i == "number" ? { x: i, y: e * i / t } : typeof s == "number" ? { x: t * s / e, y: s } : { x: t, y: e };
  }
}
const Pn = (r) => !(!r || typeof r != "object" || !("type" in r) || r.type !== "icon"), OA = De({ type: "glow", color: N(255, 255, 255, 50), spread: 1, blur: 4, offset: { x: 0, y: 0 } });
class Zu extends OA {
  constructor(t) {
    super(t);
  }
  setSpread(t) {
    return this.set("spread", typeof t == "function" ? t(this.get("spread")) : t);
  }
  getSpread() {
    return this.get("spread");
  }
  setBlur(t) {
    return this.set("blur", typeof t == "function" ? t(this.get("blur")) : t);
  }
  getBlur() {
    return this.get("blur");
  }
  setColor(t) {
    return this.set("color", typeof t == "function" ? t(this.get("color")) : t);
  }
  getColor() {
    return this.get("color");
  }
  setOffset(t) {
    return this.set("offset", typeof t == "function" ? t(this.get("offset")) : t);
  }
  getOffset() {
    return this.get("offset");
  }
}
class zs extends yr {
  constructor() {
    super(...arguments), this.ri = "RadialScale", this.se = { start: 0, end: 1 }, this.ee = !1, this.re = 0, this.j = j(0, 0), this.he = [0, 0], this.ne = [0, 0], this.u = !0, this.Bt = !0, this.oe = !0, this.ae = !0, this.le = { x: 0, y: 0 }, this.st = { x: { displacement: 0, scaling: 0, highPrecisionOffset: 0 }, y: { displacement: 0, scaling: 0, highPrecisionOffset: 0 } };
  }
  ue(t, e) {
    return t === this.se.start && e === this.se.end || (this.se = { start: t, end: e }, this.oe = !0, this.ce()), this;
  }
  de() {
    return this.se;
  }
  fe() {
    return this.se.end >= this.se.start;
  }
  Ae(t) {
    this.ee = t, this.ae = !0;
  }
  ge() {
    return this.ee === !1;
  }
  ve(t) {
    this.re = t, this.ae = !0;
  }
  ye() {
    return this.re;
  }
  Et() {
    return this.Bt;
  }
  Nt() {
    return !1;
  }
  hi(t, e, i, s) {
    return this.x = new ts(t.x, e.x, i.x, s ? s.x : void 0), this.y = new ts(t.y, e.y, i.y, s ? s.y : void 0), this;
  }
  ht() {
    return this.st;
  }
  pe() {
    return this.oe;
  }
  me() {
    return this.ae;
  }
  ni() {
    return this.le;
  }
  W() {
    return this.u = !1, this.Bt = !1, this.oe = !1, this.ae = !1, this;
  }
  X() {
    return this.u = !0, this.Bt = !0, this.oe = !0, this.ae = !0, this;
  }
  K(t, e) {
    return typeof t == "object" ? (this.j.x = t.x, this.j.y = t.y) : (this.j.x = t, this.j.y = e), this.ce(), this;
  }
  qt(t) {
    return this.he = t, this.ce(), this;
  }
  ti(t) {
    return this.ne = t, this.ce(), this;
  }
  Tt() {
    return j(this.he[0] + this.he[1], this.ne[0] + this.ne[1]);
  }
  Ft() {
    return this.j;
  }
  ce() {
    const t = this.se, e = j(this.x.It(this.j.x), this.y.It(this.j.y)), i = this.he[0] + this.he[1], s = this.ne[0] + this.ne[1], o = Math.max(e.x - i, 0), n = Math.max(e.y - s, 0), a = 0.5 * (o > n ? n : o), l = [this.he[0] + Math.max((o - 2 * a) / 2, 0), this.he[1] + Math.max((o - 2 * a) / 2, 0)], h = [this.ne[0] + Math.max((n - 2 * a) / 2, 0), this.ne[1] + Math.max((n - 2 * a) / 2, 0)], u = Math.abs(t.end - t.start);
    this.x.K(this.j.x)._t(l).Z(-u, u), this.y.K(this.j.y)._t(h).Z(-u, u), this.le = { x: this.x.getPixelSize(), y: this.y.getPixelSize() }, this.st = { x: this.x.ht(), y: this.y.ht() }, this.X();
  }
  Qt(t, e) {
    const i = this.ni();
    return { x: t.x + e.x * i.x, y: t.y + e.y * i.y };
  }
  oi(t, e, i, s) {
    const o = this.ni(), n = $u(t, e);
    return n.x *= s, n.y *= s, { x: t.x + i * o.x * n.x, y: t.y + i * o.y * n.y };
  }
}
const jt = (r) => {
  if (r instanceof we || r instanceof zs) return r.Nt() ? "linear-highPrecision" : "linear";
  if (r instanceof Ti) {
    const t = {};
    return r.x instanceof Jn && (t.x = { base: r.x.ls() }), r.y instanceof Jn && (t.y = { base: r.y.ls() }), ["logarithmic", t];
  }
  return r.x.Y || r.y.Y || r.z.Y ? "linear-highPrecision" : "linear";
}, qm = (r, t, e) => {
  if (e === 0 || e === 360 || e === 180 || e % 180 == 0) return { x: r, y: t };
  if (e === 90 || e === -90 || (e + 90) % 180 == 0) return { x: t, y: r };
  const i = e * Math.PI / 180, s = Math.cos(i), o = Math.sin(i);
  return { x: Math.abs(r * s) + Math.abs(t * o), y: Math.abs(r * o) + Math.abs(t * s) };
}, ss = (r) => {
  const t = Object.keys(r), e = {};
  return t.forEach(((i) => {
    const s = r[i];
    let o = !1;
    e[i] = (n) => {
      if (!n) return o;
      const a = s();
      return o = a, a;
    };
  })), e;
}, er = (r, t, e) => r.getLookUpProperty() === "value" ? e : r.getLookUpProperty() === "x" ? { min: t.Hi(), max: t.Wi() } : r.getLookUpProperty() === "y" ? { min: t.Xi(), max: t.Zi() } : r.getLookUpProperty() === "z" ? { min: t.Se(), max: t.be() } : void 0, Dc = (r) => !(!r || r.lookUpProperty !== "value" || !r.lut.percentageValues), NA = { init: (r) => ((t) => {
  const e = /* @__PURE__ */ new Map();
  t.engine.addEventListener("locationchange", (() => {
    e.forEach(((n) => {
      n.bounds = void 0;
    }));
  }));
  const i = (n) => {
    let a = e.get(n.uid);
    if (!a) {
      const l = document.createElement("p");
      l.className = "lcjs-text", t.engine.container.append(l), l.style.userSelect = "none", l.style.whiteSpace = "nowrap", l.style.margin = "0px", a = { span: l, active: !0 }, e.set(n.uid, a), l.addEventListener("pointerenter", ((h) => t.handleEvent(n, h))), l.addEventListener("pointermove", ((h) => t.handleEvent(n, h))), l.addEventListener("pointerleave", ((h) => t.handleEvent(n, h)));
    }
    if (a.text !== n.text && (((l, h) => {
      const u = l.includes("latex:"), c = !u && l.includes("tex:");
      let d = !0;
      if (u || c) try {
        H.MathJax && u ? (d = !1, h.innerHTML = l.replace(/latex:/g, ""), H.MathJax.typesetPromise([h]).catch(((f) => H.console.error(f.message)))) : H.katex && c && (d = !1, H.katex.render(l.replace(/tex:/g, ""), h, { throwOnError: !1 }));
      } catch {
        d = !0;
      }
      d && (h.innerHTML = l);
    })(n.text, a.span), a.bounds = void 0), a.font !== n.font && (a.span.style.font = n.font, a.bounds = void 0), a.position !== n.position && (a.span.style.position = n.position, a.bounds = void 0), a.color !== n.color && (a.span.style.color = n.color), a.padding !== n.padding && (a.span.style.padding = n.padding, a.bounds = void 0), a.rotation !== n.rotation && (a.span.style.transform = `rotate(${n.rotation}deg)`, a.bounds = void 0), a.span.style.lineHeight = "80%", a.text !== n.text || a.left !== n.left || a.top !== n.top || a.alignmentX !== n.alignmentX || a.alignmentY !== n.alignmentY || a.padding !== n.padding || a.rotation !== n.rotation || a.font !== n.font) {
      a.span.style.width = "unset", a.span.style.height = "unset";
      const l = a.span.clientWidth, h = a.span.clientHeight, u = qm(l, h, n.rotation), c = { x: (u.x - l) / 2, y: (u.y - h) / 2 };
      a.span.style.left = `${n.left + (-0.5 * n.alignmentX - 0.5) * u.x + c.x}px`, a.span.style.top = `${n.top + (0.5 * n.alignmentY - 0.5) * u.y + c.y}px`, a.bounds = void 0;
    }
    return a.text = n.text, a.font = n.font, a.position = n.position, a.color = n.color, a.padding = n.padding, a.rotation = n.rotation, a.left = n.left, a.top = n.top, a.alignmentX = n.alignmentX, a.alignmentY = n.alignmentY, a;
  }, s = (n) => {
    const a = i(n);
    let l = a.bounds;
    return l || (l = a.span.getBoundingClientRect(), a.bounds = l), l;
  }, o = "polygon(0 0, 0 0, 0 0, 0 0)";
  return { update: (n) => {
    e.forEach(((a) => a.active = !1)), n.textList.forEach(((a) => {
      const l = i(a);
      l.active = !0, l.span.style.clipPath = "unset", a.identifier, es.Other;
    })), n.obstructingOverlays.forEach(((a) => {
      const l = Math.min(a.p1.clientX, a.p2.clientX) - 0, h = Math.min(a.p1.clientY, a.p2.clientY) - 0, u = Math.max(a.p1.clientX, a.p2.clientX) + 0, c = Math.max(a.p1.clientY, a.p2.clientY) + 0;
      n.textList.forEach(((d) => {
        if (a.blacklist.includes(d.identifier)) return;
        const f = e.get(d.uid), p = s(d);
        var g, y, m, A, v, b, w, k;
        if (g = l, y = h, m = u, A = c, v = p.left - 0, b = p.top - 0, w = p.right + 0, k = p.bottom + 0, !((g >= m ? g : m) < (v < w ? v : w) || (g < m ? g : m) > (v >= w ? v : w) || (y >= A ? y : A) < (b < k ? b : k) || (y < A ? y : A) > (b >= k ? b : k)) && f) if (d.rotation !== 0) f.span.style.clipPath = o;
        else {
          const R = ((L, x, M, C, S, E, T, I) => {
            const F = L < M ? L : M, D = L >= M ? L : M, P = x < C ? x : C, V = x >= C ? x : C, _ = S < T ? S : T, O = S >= T ? S : T, B = E < I ? E : I, z = E >= I ? E : I;
            if (_ < F && O > D && B < P && z > V) return [];
            if (_ >= F && O <= D && B >= P && z <= V) {
              const W = 0.5 * (V + P);
              return [{ x: F, y: P }, { x: D, y: P }, { x: D, y: W }, { x: O, y: W }, { x: O, y: B }, { x: _, y: B }, { x: _, y: z }, { x: O, y: z }, { x: O, y: W }, { x: D, y: W }, { x: D, y: V }, { x: F, y: V }];
            }
            if (F < _ && D > _ && D < O) {
              if (P < B && z < V) return [{ x: F, y: P }, { x: D, y: P }, { x: D, y: B }, { x: _, y: B }, { x: _, y: z }, { x: D, y: z }, { x: D, y: V }, { x: F, y: V }];
              if (P > B && P < z && V > z) return [{ x: F, y: P }, { x: _, y: P }, { x: _, y: z }, { x: D, y: z }, { x: D, y: V }, { x: F, y: V }];
              if (B < P && z > V) return [{ x: F, y: P }, { x: _, y: P }, { x: _, y: V }, { x: F, y: V }];
              if (B < V) return [{ x: F, y: P }, { x: D, y: P }, { x: D, y: B }, { x: _, y: B }, { x: _, y: V }, { x: F, y: V }];
            }
            if (_ < F && O > F && O < D) {
              if (P < B && z < V) return [{ x: F, y: P }, { x: D, y: P }, { x: D, y: V }, { x: F, y: V }, { x: F, y: z }, { x: O, y: z }, { x: O, y: B }, { x: F, y: B }];
              if (z > P && B < P && z < V) return [{ x: D, y: P }, { x: D, y: V }, { x: F, y: V }, { x: F, y: z }, { x: O, y: z }, { x: O, y: P }];
              if (B < P && z > V) return [{ x: O, y: P }, { x: D, y: P }, { x: D, y: V }, { x: O, y: V }];
              if (B < V) return [{ x: F, y: P }, { x: D, y: P }, { x: D, y: V }, { x: O, y: V }, { x: O, y: B }, { x: F, y: B }];
            }
            if (F > _ && D < O) {
              if (B < P && z > P && z < V) return [{ x: F, y: z }, { x: D, y: z }, { x: D, y: V }, { x: F, y: V }];
              if (P < B && B < V && z > V) return [{ x: F, y: P }, { x: D, y: P }, { x: D, y: B }, { x: F, y: B }];
              if (P < B && z < V) return [{ x: F, y: P }, { x: D, y: P }, { x: D, y: B }, { x: F, y: B }, { x: F, y: z }, { x: D, y: z }, { x: D, y: V }, { x: F, y: V }];
            }
            if (F < _ && D > O) {
              if (P < B && V > B) return [{ x: F, y: P }, { x: D, y: P }, { x: D, y: V }, { x: O, y: V }, { x: O, y: B }, { x: _, y: B }, { x: _, y: V }, { x: F, y: V }];
              if (B < P && z > P && z < V) return [{ x: F, y: P }, { x: _, y: P }, { x: _, y: z }, { x: O, y: z }, { x: O, y: P }, { x: D, y: P }, { x: D, y: V }, { x: F, y: V }];
              if (B < P && B < V && z > V) return [{ x: F, y: P }, { x: _, y: P }, { x: _, y: V }, { x: O, y: V }, { x: O, y: P }, { x: D, y: P }, { x: D, y: V }, { x: F, y: V }];
            }
            return [{ x: F, y: P }, { x: D, y: P }, { x: D, y: V }, { x: F, y: V }];
          })(p.left - 0, p.top - 0, p.right + 0, p.bottom + 0, l, h, u, c);
          f.span.style.clipPath = R.length === 0 ? o : `polygon(${R.map(((L) => `${100 * (L.x - p.left) / p.width}% ${100 * (L.y - p.top) / p.height}%`)).join(", ")})`;
        }
      }));
    })), e.forEach(((a, l) => {
      a.active || (a.span.remove(), e.delete(l));
    }));
  }, measureText: (n) => {
    if (!n.visible) return { x: 0, y: 0 };
    const a = s(n);
    return { x: a.width, y: a.height };
  }, getTextBoundingBox: (n) => {
    if (n.visible) return s(n);
  }, dispose: () => {
    e.forEach(((n) => {
      n.span.remove();
    }));
  } };
})(r) };
class BA {
  constructor(t, e) {
    this.xe = t, this.Me = e, this._e = e.rows * ab, this.we = e.columns * lb;
  }
}
var Nr, ra;
(function(r) {
  r[r.ZoomIn = 0] = "ZoomIn", r[r.ZoomInX = 1] = "ZoomInX", r[r.ZoomInY = 2] = "ZoomInY", r[r.ZoomOut = 3] = "ZoomOut", r[r.ZoomOutX = 4] = "ZoomOutX", r[r.ZoomOutY = 5] = "ZoomOutY", r[r.ZoomToFit = 6] = "ZoomToFit", r[r.ToggleAnimations = 7] = "ToggleAnimations";
})(Nr || (Nr = {})), (function(r) {
  r[r.Circle = 0] = "Circle", r[r.Rectangle = 1] = "Rectangle", r[r.RoundedRectangle = 2] = "RoundedRectangle";
})(ra || (ra = {}));
const zA = { x: -43, y: 0 }, WA = { x: -65, y: 0 }, GA = { x: -86, y: 0 }, UA = { x: -107, y: -1 }, HA = { x: -128, y: -3 }, YA = { x: -150, y: 0 }, jA = { x: -171, y: 0 }, $A = { x: -276, y: 0 }, XA = { x: -298, y: 0 }, ZA = { x: 0, y: 0 }, KA = { x: -21, y: 0 };
class In extends BA {
  constructor(t, e, i, s) {
    super(t, i), this.ke = H.document.createElement("button"), this.Ce = H.document.createElement("div"), this.Te = H.document.createElement("label"), this.Me = i, this.Fe = e, this.Ie = s;
  }
  Pe(t, e, i, s) {
    this.Le(t, s), this.Be(), this.De(e), this.Ee(), this.Te.textContent = i || "";
    const o = H.document.createElement("div");
    this.Re(o), this.ke.onclick = this.onClick.bind(this), o.appendChild(this.Ce), o.appendChild(this.Te), this.ke.appendChild(o);
  }
  Ee() {
    this.ke.style.cursor = "pointer";
  }
  Re(t) {
    t.style.display = "flex", t.style.justifyContent = "center", t.style.alignContent = "center", t.style.flexDirection = "column";
  }
  De(t) {
    typeof t == "string" ? (this.Ce.style.backgroundImage = `url(${t})`, this.Ce.style.backgroundSize = "100%", this.Ce.style.backgroundRepeat = "no-repeat", this.Ce.style.backgroundPosition = "center", this.Ce.style.width = "20px", this.Ce.style.height = "20px") : this.applyStyleForSprite(t), this.Ce.style.margin = "auto";
  }
  Be() {
    switch (this.Fe) {
      case ra.RoundedRectangle:
        this.ke.style.borderRadius = "10px";
        break;
      case ra.Rectangle:
        this.ke.style.borderRadius = "0px";
        break;
      case ra.Circle:
      default:
        this.ke.style.borderRadius = "31px";
    }
  }
  Le(t, e) {
    this.ke.style.width = `${this.we.toString()}px`, this.ke.style.height = `${this._e.toString()}px`, this.ke.style.backgroundColor = t, this.ke.style.opacity = e || hb, this.ke.style.alignItems = "center", this.ke.style.border = "2px solid #707070", this.ke.style.transition = "background-color .8s ease";
  }
  applyStyleForSprite(t) {
    this.Ce.style.backgroundImage = `url(${this.xe}/${tx})`, this.Ce.style.backgroundPositionX = `${t.x}px`, this.Ce.style.backgroundPositionY = `${t.y}px`, this.Ce.style.backgroundSize = "1600%", this.Ce.style.backgroundRepeat = "no-repeat", this.Ce.style.width = "20px", this.Ce.style.height = "20px";
  }
  Oe(t) {
    return t.appendChild(this.ke), t;
  }
  ze() {
    return this.ke;
  }
}
class Jm extends In {
  constructor(t, e, i, s) {
    super(t, e, i, s), this.Ve = "", this.Ne = "", this.Ge = !1, this.Ie = s;
  }
  $e() {
    this.Ue(), this.onToggledStateAction();
  }
  je() {
    this.Ye(), this.onInitialStateAction();
  }
  Ye() {
    this.He(this.Ve);
  }
  Ue() {
    this.He(this.Ne);
  }
  He(t) {
    typeof t == "string" ? this.Ce.style.background = t : (this.Ce.style.backgroundImage = `url(${this.xe}/${tx})`, this.Ce.style.backgroundPositionX = `${t.x}px`, this.Ce.style.backgroundPositionY = `${t.y}px`);
  }
  onClick() {
    this.Ge ? this.je() : this.$e(), this.Ge = !this.Ge;
  }
}
class qA extends In {
  constructor(t, e, i) {
    super(t, i, { rows: 1, columns: 1 }, e), this.Ie = e;
    const s = this.Ie.getTheme();
    this.Pe(s.onScreenMenuBackgroundColor.toRGBAString(), zA);
  }
  onClick() {
    const t = this.Ie.We();
    t && this.Ie.zoom(t, { x: -1, y: -1 });
  }
}
class JA extends In {
  constructor(t, e, i) {
    super(t, i, { rows: 1, columns: 1 }, e), this.Ie = e;
    const s = this.Ie.getTheme();
    this.Pe(s.onScreenMenuBackgroundColor.toRGBAString(), UA);
  }
  onClick() {
    const t = this.Ie.We();
    t && this.Ie.zoom(t, { x: -1, y: 0 });
  }
}
class QA extends In {
  constructor(t, e, i) {
    super(t, i, { rows: 1, columns: 1 }, e), this.Ie = e;
    const s = this.Ie.getTheme();
    this.Pe(s.onScreenMenuBackgroundColor.toRGBAString(), YA);
  }
  onClick() {
    const t = this.Ie.We();
    t && this.Ie.zoom(t, { x: 0, y: -1 });
  }
}
class tb extends In {
  constructor(t, e, i) {
    super(t, i, { rows: 1, columns: 1 }, e), this.Ie = e;
    const s = this.Ie.getTheme();
    this.Pe(s.onScreenMenuBackgroundColor.toRGBAString(), WA);
  }
  onClick() {
    const t = this.Ie.We();
    t && this.Ie.zoom(t, { x: 1, y: 1 });
  }
}
class eb extends In {
  constructor(t, e, i) {
    super(t, i, { rows: 1, columns: 1 }, e), this.Ie = e;
    const s = this.Ie.getTheme();
    this.Pe(s.onScreenMenuBackgroundColor.toRGBAString(), HA);
  }
  onClick() {
    const t = this.Ie.We();
    t && this.Ie.zoom(t, { x: 1, y: 0 });
  }
}
class ib extends In {
  constructor(t, e, i) {
    super(t, i, { rows: 1, columns: 1 }, e), this.Ie = e;
    const s = this.Ie.getTheme();
    this.Pe(s.onScreenMenuBackgroundColor.toRGBAString(), jA);
  }
  onClick() {
    const t = this.Ie.We();
    t && this.Ie.zoom(t, { x: 0, y: 1 });
  }
}
class sb extends Jm {
  constructor(t, e, i) {
    super(t, i, { rows: 1, columns: 1 }, e), this.Ie = e;
    const s = this.Ie.getTheme();
    this.Ve = $A, this.Ne = XA, this.Pe(s.onScreenMenuBackgroundColor.toRGBAString(), this.Ve);
  }
  onToggledStateAction() {
    this.Ie.setAnimationsEnabled(!1);
  }
  onInitialStateAction() {
    this.Ie.setAnimationsEnabled(!0);
  }
}
class rb extends In {
  constructor(t, e, i) {
    super(t, i, { rows: 1, columns: 1 }, e), this.Ie = e;
    const s = this.Ie.getTheme();
    this.Pe(s.onScreenMenuBackgroundColor.toRGBAString(), GA);
  }
  onClick() {
    this.Ie.forEachAxis(((t) => {
      t.fit(!0);
    }));
  }
}
class nb extends In {
  constructor(t, e, i) {
    super(t, e.shape || ex, e.dimensions || { rows: 1, columns: 1 }, i);
    const s = i.getTheme(), o = e.color || s.onScreenMenuBackgroundColor.toRGBAString(), n = e.icon || "", a = e.label || "", l = e.opacity || "";
    this.Pe(o, n, a, l), this.Xe = e.action;
  }
  onClick() {
    this.Xe(this.Ie);
  }
}
class ob extends Jm {
  constructor(t, e, i, s) {
    super(t, e, { rows: 1, columns: 1 }, i), this.Ie = i, this.Ze = s, this.Ve = KA, this.Ne = ZA, this.Pe(ng, this.Ve);
  }
  Ye() {
    this.He(this.Ve), this.ke.style.backgroundColor = ng, this.ke.style.border = "2px solid #707070", this.ke.style.margin = "0px";
  }
  Ue() {
    this.He(this.Ne), this.ke.style.background = "#FECC00 0% 0% no-repeat padding-box", this.ke.style.border = "10px solid #BCBCBC12", this.ke.style.margin = "1px";
  }
  onToggledStateAction() {
    var t;
    (t = this.Ze) === null || t === void 0 || t.style.setProperty("display", "block");
  }
  onInitialStateAction() {
    var t;
    (t = this.Ze) === null || t === void 0 || t.style.setProperty("display", "none");
  }
}
var Gt;
(function(r) {
  r.Move = "move", r.ResizeColumn = "col-resize", r.ResizeRow = "row-resize", r.Horizontal = "ew-resize", r.Vertical = "ns-resize", r.NorthWest = "nw-resize", r.NorthEast = "ne-resize", r.Copy = "copy", r.CrossHair = "crosshair", r.Default = "default", r.Help = "help", r.Restricted = "not-allowed", r.None = "none", r.Point = "pointer", r.Text = "text", r.Wait = "wait", r.ZoomIn = "zoom-in", r.ZoomOut = "zoom-out", r.Grab = "grab", r.Grabbing = "grabbing";
})(Gt || (Gt = {}));
const Sl = { LeftBottom: j(-1, -1), RightBottom: j(1, -1), LeftTop: j(-1, 1), RightTop: j(1, 1) }, Qm = new ot({ color: N(255, 255, 255, 0) });
new $t({ thickness: 1, fillStyle: Qm });
const ab = 60, lb = 60, hb = "1.0", tx = "osm/osm-sprite-transparent.png", ex = ra.Circle, ng = "#363636";
var Qo;
(function(r) {
  r[r.TopRight = 0] = "TopRight", r[r.TopLeft = 1] = "TopLeft", r[r.BottomLeft = 2] = "BottomLeft", r[r.BottomRight = 3] = "BottomRight";
})(Qo || (Qo = {}));
class ub extends $m {
  constructor(t, e, i, s, o, n, a, l) {
    super(t, e, i, s, o, n, a, l), this.Vs = "Band", this.Je = 0, this.Qe = 1, this.Ke = this.xi.bandFillStyle, this.qe = this.xi.bandStrokeStyle, this.D = new Nt(), this.tr = this.Js.er(this.ai).sr(this.Ke).ir(this.qe).Ii(this.getHighlight()), this.Ts(this.tr);
  }
  setValueStart(t) {
    return this.Je = t, this.D.R("valuechange", { start: this.Je, end: this.Qe }), this.Js.Rs(), this;
  }
  getValueStart() {
    return this.Je;
  }
  setValueEnd(t) {
    return this.Qe = t, this.D.R("valuechange", { start: this.Je, end: this.Qe }), this.Js.Rs(), this;
  }
  getValueEnd() {
    return this.Qe;
  }
  setFillStyle(t) {
    this.Ke = typeof t == "function" ? t(this.Ke) : t;
    const e = this.Ke;
    return this.tr.sr(e), this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setStrokeStyle(t) {
    this.qe = typeof t == "function" ? t(this.qe) : t;
    const e = this.qe;
    return this.tr.ir(e), this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  rr() {
    return this.tr.hr(this.Qs.toVec2(this.Je, this.Qs.getHeight(this.ai).getInnerStart())).K(this.Qs.toVec2(this.Qe - this.Je, this.Qs.getHeight(this.ai).getInnerInterval())), Ff(this.Zs, [this.tr], this.ai), this;
  }
  nr() {
    return { fill: this.Ke, stroke: this.qe };
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  Ks() {
    let t, e, i;
    const s = (l, h, u) => {
      const c = xt(this.Js.yi.lr(l.clientX, l.clientY), this.Js.yi.ai, this.ai), d = this.Qs.getWidth(c), f = this.axis.ai.Rt(this.Je), p = this.axis.ai.Rt(this.Qe), g = (this.axis.ai.Rt(d) - f) / (p - f);
      t = h && (!(g < 0.1 || g > 0.9) || !u), e = u && !t, e && (i = g < 0.5);
    }, o = (l) => {
      const h = this.getUserInteractions(), u = ge(h.move, "drag", l, l.shiftKey, l.ctrlKey, l.altKey), c = ge(h.scale, "drag", l, l.shiftKey, l.ctrlKey, l.altKey);
      s(l, !!u?.drag, !!c?.drag);
      const d = t ? Gt.Point : e ? this.Qs.getWidth({ x: Gt.Horizontal, y: Gt.Vertical }) : Gt.Default;
      this.ur = this.chart.engine.setMouseStyle(d, this.ur);
    }, n = (l) => {
      this.ur = this.chart.engine.restoreMouseStyle(this.ur);
    };
    this.addEventListener("pointermove", o), this.addEventListener("pointerleave", n);
    const a = (l, h, u, c) => {
      const d = this.Qs.getWidth(l);
      if (t) {
        this.Je = this.axis.ai.Qt(this.Je, d), this.Qe = this.axis.ai.Qt(this.Qe, d);
        const f = u?.on;
        f && f({ event: h });
      } else if (e && i) {
        this.Je = this.axis.ai.Qt(this.Je, d);
        const f = c?.on;
        f && f({ event: h });
      } else if (e && !i) {
        this.Qe = this.axis.ai.Qt(this.Qe, d);
        const f = c?.on;
        f && f({ event: h });
      }
      It(h), this.D.R("valuechange", { start: this.Je, end: this.Qe }), this.Js.Rs();
    };
    this.addEventListener("pointerdown", ((l) => {
      const h = this.getUserInteractions(), u = ge(h.move, "drag", l, l.shiftKey, l.ctrlKey, l.altKey), c = ge(h.scale, "drag", l, l.shiftKey, l.ctrlKey, l.altKey);
      if (!u?.drag && t || !c?.drag && e) return;
      It(l);
      let d = l;
      const f = (g) => {
        if (g.pointerId !== l.pointerId) return;
        const y = { x: g.clientX - d.clientX, y: d.clientY - g.clientY };
        a(y, g, u, c), d = g;
      }, p = (g) => {
        g.pointerId === l.pointerId && (this.addEventListener("pointermove", o), this.addEventListener("pointerleave", n), H.removeEventListener("pointermove", f), H.removeEventListener("pointerup", p), sn());
      };
      this.removeEventListener("pointermove", o), this.removeEventListener("pointerleave", n), H.addEventListener("pointermove", f), H.addEventListener("pointerup", p);
    }));
  }
  setUserInteractions(t) {
    return this.cr = t === void 0 ? { move: !1, scale: !1 } : t, this;
  }
  getUserInteractions() {
    return Zi({ move: { drag: !0 }, scale: { drag: !0 } }, this.cr);
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class cb extends $m {
  constructor(t, e, i, s, o, n, a, l) {
    super(t, e, i, s, o, n, a, l), this.Vs = "Constant Line", this.M = 0, this.qe = this.xi.constantLineStrokeStyle, this.dr = !0, this.D = new Nt(), this.Ar = this.Js.vr(this.ai).gr(this.qe).Ii(this.getHighlight()), this.Ts(this.Ar);
  }
  setValue(t) {
    return this.M = t, this.D.R("valuechange", { value: this.M }), this.Js.Rs(), this;
  }
  getValue() {
    return this.M;
  }
  setStrokeStyle(t) {
    this.qe = typeof t == "function" ? t(this.qe) : t;
    const e = this.qe;
    return this.Ar.gr(e), this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  rr() {
    return this.Ar.pr(this.Qs.toVec2(this.M, this.Qs.getHeight(this.ai).getInnerStart())).yr(this.Qs.toVec2(this.M, this.Qs.getHeight(this.ai).getInnerEnd())), Ff(this.Zs, [this.Ar], this.ai), this;
  }
  nr() {
    return { stroke: this.qe };
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  setUserInteractions(t) {
    return this.cr = t === void 0 ? { move: !1 } : t, this;
  }
  getUserInteractions() {
    return Zi({ move: { drag: !0 } }, this.cr);
  }
  Ks() {
    this.addEventListener("pointerenter", ((t) => {
      const e = this.getUserInteractions();
      if (ge(e.move, "drag", t, t.shiftKey, t.ctrlKey, t.altKey)) {
        const i = this.Qs.getWidth({ x: Gt.Horizontal, y: Gt.Vertical });
        this.ur = this.chart.engine.setMouseStyle(i, this.ur);
      }
    })), this.addEventListener("pointerleave", ((t) => {
      this.ur = this.chart.engine.restoreMouseStyle(this.ur);
    })), this.addEventListener("pointerdown", ((t) => {
      const e = this.getUserInteractions(), i = ge(e.move, "drag", t, t.shiftKey, t.ctrlKey, t.altKey);
      if (i) {
        It(t), sn();
        let s = t;
        const o = (a) => {
          const l = { x: a.clientX - s.clientX, y: s.clientY - a.clientY };
          s = a, this.M = this.axis.ai.Qt(this.M, this.Qs.getWidth(l)), this.D.R("valuechange", { value: this.M }), this.Js.Rs();
          const h = i.on;
          h && h({ event: a });
        }, n = (a) => {
          a.pointerId === t.pointerId && (H.removeEventListener("pointermove", o), H.removeEventListener("pointerup", n));
        };
        H.addEventListener("pointermove", o), H.addEventListener("pointerup", n);
      }
    }));
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Fc = "fitting", ix = "expansion", Gl = "progressive", Aa = "regressive", za = { fitting: (r) => {
  const t = r?.start === void 0 || r.start, e = r?.end === void 0 || r.end, i = r?.considerVisibleRangeOnly === void 0 || r.considerVisibleRangeOnly;
  return { id: Fc, init: (s) => {
    s.axis.mr(((o) => o.curEnd > o.curStart ? { startMin: o.dataMin, endMax: o.dataMax } : { endMin: o.dataMin, startMax: o.dataMax }));
  }, considerVisibleRangeOnly: i, apply: (s) => {
    if (s.seriesDataRange) return { start: t ? s.curEnd >= s.curStart ? s.seriesDataRange.min : s.seriesDataRange.max : s.curStart, end: e ? s.curEnd >= s.curStart ? s.seriesDataRange.max : s.seriesDataRange.min : s.curEnd, allowIntervalLengthChange: !0 };
  } };
}, scrolling: (r) => {
  const t = r?.progressive !== void 0 && !r.progressive, e = r?.realTime === !0 ? {} : r?.realTime;
  if (e) {
    const i = e.catchUpThresholdMs !== void 0 ? e.catchUpThresholdMs : 3e3;
    let s;
    const o = (n) => {
      n.isStopped && (s = void 0);
    };
    return { id: t ? Aa : Gl, init: (n) => {
      n.axis.mr(((a) => t ? a.curEnd > a.curStart ? { startMin: a.dataMin } : { endMin: a.dataMin } : a.curEnd > a.curStart ? { endMax: a.dataMax } : { startMax: a.dataMax })), n.axis.addEventListener("stoppedchange", o);
    }, dispose: (n) => {
      n.axis.removeEventListener("stoppedchange", o);
    }, considerVisibleRangeOnly: !0, apply: (n) => {
      if (!n.seriesDataRange) return;
      const a = H.performance.now();
      if (s !== void 0) {
        const l = (a - s) * (t ? -1 : 1);
        let h = n.curStart + l, u = n.curEnd + l;
        const c = n.axis.Sr({ forStart: h, forEnd: u, allowIntervalLengthChange: !1 });
        if (!t && c && n.curEnd > n.curStart && c.end - u >= i) {
          const d = c.end - u;
          u += d, h += d;
        }
        if (!t && c && n.curEnd < n.curStart && c.start - h >= i) {
          const d = c.start - h;
          u += d, h += d;
        }
        return s = a, { start: h, end: u, allowIntervalLengthChange: !1, keepScrolling: !0, allowAnimation: !1 };
      }
      return s = a, { keepScrolling: !0, start: n.curStart, end: n.curEnd, allowIntervalLengthChange: !1, allowAnimation: !1 };
    } };
  }
  return { id: t ? Aa : Gl, init: (i) => {
    i.axis.mr(((s) => t ? s.curEnd > s.curStart ? { startMin: s.dataMin } : { endMin: s.dataMin } : s.curEnd > s.curStart ? { endMax: s.dataMax } : { startMax: s.dataMax }));
  }, considerVisibleRangeOnly: !0, apply: (i) => {
    if (i.seriesDataRange !== void 0) {
      if (Math.sign(i.curEnd - i.curStart) * Math.sign(t ? -1 : 1) > 0) {
        const s = t ? i.seriesDataRange.min : i.seriesDataRange.max;
        return { end: s, start: s + (i.curStart - i.curEnd), allowIntervalLengthChange: !1 };
      }
      {
        const s = t ? i.seriesDataRange.min : i.seriesDataRange.max;
        return { start: s, end: s + (i.curEnd - i.curStart), allowIntervalLengthChange: !1 };
      }
    }
  } };
}, expansion: (r) => {
  const t = r?.start === void 0 || r.start, e = r?.end === void 0 || r.end;
  return { id: ix, considerVisibleRangeOnly: !0, apply: (i) => {
    if (i.seriesDataRange !== void 0) return { start: t ? i.curEnd >= i.curStart ? i.seriesDataRange.min < i.curStart ? i.seriesDataRange.min : i.curStart : i.seriesDataRange.max > i.curStart ? i.seriesDataRange.max : i.curStart : i.curStart, end: e ? i.curEnd >= i.curStart ? i.seriesDataRange.max > i.curEnd ? i.seriesDataRange.max : i.curEnd : i.seriesDataRange.min < i.curEnd ? i.seriesDataRange.min : i.curEnd : i.curEnd, allowIntervalLengthChange: !0 };
  } };
}, nextPowerOf10: { id: Fc, start: (r, t, e, i) => t >= r ? e : i, end: (r, t, e, i) => t >= r ? 10 ** Math.ceil(Math.log10(i)) : 10 ** Math.ceil(Math.log10(e)), allowIntervalLengthChange: !0 }, fittingStepped: (r) => {
  const t = r?.start === void 0 || r.start, e = r?.end === void 0 || r.end;
  return { id: Fc, considerVisibleRangeOnly: !0, apply: (i) => {
    if (i.seriesDataRange === void 0) return;
    let s, o;
    if (t) if (i.curEnd >= i.curStart) if (i.seriesDataRange.min < i.curStart) s = i.curStart - (i.curEnd - i.curStart);
    else {
      const n = i.curStart + 0.5 * (i.curEnd - i.curStart);
      s = i.seriesDataRange.min > n ? n : i.curStart;
    }
    else if (i.seriesDataRange.max > i.curStart) s = i.curStart + (i.curStart - i.curEnd);
    else {
      const n = i.curStart - 0.5 * (i.curStart - i.curEnd);
      s = i.seriesDataRange.max < n ? n : i.curStart;
    }
    else s = i.curStart;
    if (e) if (i.curEnd >= i.curStart) if (i.seriesDataRange.max > i.curEnd) o = i.curEnd + (i.curEnd - i.curStart);
    else {
      const n = i.curEnd - 0.5 * (i.curEnd - i.curStart);
      o = i.seriesDataRange.max < n ? n : i.curEnd;
    }
    else if (i.seriesDataRange.min < i.curEnd) o = i.curEnd - (i.curStart - i.curEnd);
    else {
      const n = i.curEnd + 0.5 * (i.curStart - i.curEnd);
      o = i.seriesDataRange.min > n ? n : i.curEnd;
    }
    else o = i.curEnd;
    return { start: s, end: o, allowIntervalLengthChange: !0 };
  } };
} }, jr = { Empty: "Empty", Numeric: "Numeric", DateTime: "DateTime" }, og = (r) => r.br !== void 0, ag = (r) => r.Mr !== void 0, db = (r) => r._r !== void 0, fb = (r, t, e, i, s, o, n) => [o, n], Vs = (r, t, e, i) => {
  const s = [], o = Math.round(Math.abs((r - t) / e));
  for (let n = 1; n < o; n += 1) {
    let a = r + e * n;
    i !== void 0 && (a = Math.round(a * i) / i), a < t && s.push(a);
  }
  return s;
}, As = (r, t, e, i, s) => {
  Pi(r, 0) && (r = 0), Pi(t, 0) && (t = 0);
  const o = [], n = i !== void 0 ? ((h, u, c) => h - (h - c) % u)(r, e, i) : r;
  let a = n;
  if (e <= 0) throw new Error(`_getRegularGreatKeyValues unit less than or equal to 0, unit: ${e}`);
  let l = 0;
  for (; (a - r) / (t - r) < 0.98; ) o.push(a), l += 1, a = n + l * e, s !== void 0 && (a = Math.round(a * s) / s);
  return o.push(a), o;
}, sx = (r, t, e, i) => {
  const s = [];
  let o = e(r), n = 0;
  for (; o < t && Pi(o, t) === !1; ) if (s.push(o), o = i(o), n += 1, n > 1e3) throw new Error("Infinite loop in Axis tick key values logic.");
  return s.push(o), s;
}, re = (r, ...t) => {
  const e = t.length > 0 ? t.length : r ? 1 : 0;
  return (i, s, o, n, a, l) => {
    if (s >= e) return;
    const h = t[s] || 1;
    let u = !1, c = !1, d = 1;
    return r && (u = "ignore" in r ? r.ignore === "first" || r.ignore === "both" : u, c = "ignore" in r ? r.ignore === "last" || r.ignore === "both" : c, d = "offset" in r && r.offset !== void 0 ? r.offset : d), ((f, p, g, y, m) => (g && (f = f.filter(((A, v) => v > 0))), y && (f = f.filter(((A, v) => v < f.length - 1))), f.filter(((A, v) => (v + m) % p == 0))))(i, h, u, c, d);
  };
}, Lc = (...r) => {
  const t = r.length > 0 ? r.length : 0;
  return (e, i, s, o, n, a) => {
    if (i >= t) return;
    const l = r[i] || 1;
    return e.filter(((h, u) => u % l == 0));
  };
}, gb = De({ cursorFormatter: void 0 });
class rx extends gb {
  wr(t) {
    return { kr: [], Cr: [], Tr: this.cursorFormatter ? this.cursorFormatter : en.Numeric, Fr: void 0, Ir: void 0 };
  }
  setCursorFormatter(t) {
    return this.set("cursorFormatter", t);
  }
  getCursorFormatter() {
    return this.get("cursorFormatter");
  }
}
const If = (r) => r && typeof r == "function" ? r() : r, Vh = (r, t, e, i, s, o, n, a, l, h, u) => {
  let c = l.get(n);
  if (c || (c = /* @__PURE__ */ new Map(), l.set(n, c)), c.has(r)) return c.get(r);
  if (t.length === 0) return Ie;
  const d = u.Pr(t, n.Lr.labelFont, s), f = a.Qt(e, { x: -(i.x / 2 + 0.5) * d.x + o.x - h, y: -(i.y / 2 + 0.5) * d.y + o.y - h }), p = a.Qt(f, { x: d.x + h, y: d.y + h }), g = { min: { x: Math.min(f.x, p.x), y: Math.min(f.y, p.y) }, max: { x: Math.max(f.x, p.x), y: Math.max(f.y, p.y) } };
  return c.set(r, g), g;
}, pb = new rx().wr({ type: "linear" });
class eo {
  constructor(t, e, i, s, o, n, a) {
    this.Br = pb, this.Dr = jr.Empty, this.Er = /* @__PURE__ */ new Map(), this.Rr = !0, this.Or = Fn((() => this.chart.yi.Rs()))(300, Cr.linear), this.zr = !0, this.di = !0, this.Vr = !1, this.Nr = Pt, this.Gr = !1, this.$r = !1, this.Ur = Pt, this.jr = Pt, this.Yr = Pt, this.Hr = !1, this.Wr = "", this.Xr = !1, this.Zr = !1, this.Jr = !1, this.Qr = () => {
      this.qr.Kr = es.AxisTitle, this.qr.setPointerEvents(!0), this.title.zi(this.qr), this.Qr = void 0;
    }, this.th = (l, h, u, c, d, f, p, g, y, m, A) => {
      const v = this.ih(), b = [], w = l.filter(((R) => this.eh(R.keyValue, R.labelText, h))), k = [...w, ...y.filter(((R) => this.eh(R.keyValue, R.labelText, R.tickLevel))), ...m.filter(((R) => R.labelText.length > 0))];
      for (let R = 0; R < w.length; R += 1) {
        const L = w[R];
        let x, M = [];
        if (this.eh(L.keyValue, L.labelText, h)) {
          const C = Vh(L.keyValue, L.labelText, L.labelPosition, L.labelAlignment, L.labelRotation, L.labelOffset, h, v, g, A, this.chart.yi.rh);
          M = Mr(k.map(((S) => S && S !== L && ma(C, Vh(S.keyValue, S.labelText, S.labelPosition, S.labelAlignment, S.labelRotation, S.labelOffset, S.tickLevel, v, g, A, this.chart.yi.rh)) ? S : void 0))), x = M.length > 0;
        } else x = !1;
        if (x) {
          let C = !0;
          if (C && M.every(((S) => og(S.tickLevel))) && (C = !1), C && h.hh && h.hh.oh && h.hh.oh(L.keyValue, u, c, d, f, p) === !1 && (C = !1), C === !1) {
            w.splice(R, 1), R -= 1;
            continue;
          }
          return !0;
        }
        b.push(L);
      }
      return b;
    }, this.formatValue = (l) => this.Br.Tr(l, { start: this.ai.getInnerStart(), end: this.ai.getInnerEnd() }), this.ah = !0, this.uh = !0, this.title = new Nt(), this.chart = t, this.dh = e, this.xi = s, this.fh = n, this.ai = i, this.Ah = a, a.type === "logarithmic" && this.setAnimationZoom(Cr.logarithmic(xa(a.base))), this.gh = n.numeric, this.ph("Numeric"), this.mh = i.getInnerStart(), this.Sh = i.getInnerEnd(), this.setAnimationsEnabled(o), this.setScrollStrategy(za.fitting);
  }
  setUnits(t, e = {}) {
    return this.bh = t, this.As = e, this.Mh(), this;
  }
  getUnits() {
    return this.bh;
  }
  setDefaultInterval(t, e) {
    return this._h = t, e?.applyImmediately !== !1 && (this.Hr = !0, this.chart.yi.Rs()), this.wh = e?.skipIntervalRestrictions !== void 0 ? e.skipIntervalRestrictions : void 0, this;
  }
  getDefaultInterval() {
    return this._h;
  }
  getTitle() {
    return this.Wr;
  }
  setTitle(t) {
    return this.Wr = t, this.Mh(), this;
  }
  getTitleFillStyle() {
    return this.qr.kh();
  }
  setIntervalRestrictions(t) {
    return this.Ch = t, this.Xr = !0, this.chart.yi.Rs(), this;
  }
  getIntervalRestrictions() {
    if (typeof this.Ch == "function") {
      const t = this.Th();
      return this.Ch({ curStart: this.mh, curEnd: this.Sh, dataMin: t?.min, dataMax: t?.max });
    }
    return this.Ch;
  }
  mr(t) {
    this.Xr || this.Zr || (this.Ch = t);
  }
  setTitleFillStyle(t) {
    return this.qr.sr(t), this.chart.yi.Rs(), this;
  }
  getTitleFont() {
    return this.qr.Fh();
  }
  setTitleFont(t) {
    return this.qr.Ih(t), this.chart.yi.Rs(), this;
  }
  setTitleRotation(t) {
    return this.qr.Ph(t), this.chart.yi.Rs(), this.Jr = !0, this;
  }
  getTitleRotation() {
    return this.qr.Lh();
  }
  setTitleEffect(t) {
    return this.Bh.Es(t), this.chart.yi.Rs(), this;
  }
  getTitleEffect() {
    return this.Bh.Os();
  }
  ph(t, e) {
    if (this.Er.size > 0 && this.Dh(), t === "Empty") {
      const i = e || ((s) => s);
      this.gh = i(new rx()), this.Br = this.gh.wr(this.Ah), this.Dr = t;
    } else if (t === "Numeric") {
      this.Dr !== "Numeric" && (this.gh = this.fh.numeric);
      const i = e || ((s) => s);
      this.gh = i(this.gh), this.Br = this.gh.wr(this.Ah), this.Dr = t;
    } else if (t === "DateTime") {
      this.Dr !== "DateTime" && (this.gh = this.fh.datetime);
      const i = e || ((s) => s);
      this.gh = i(this.gh), this.Br = this.gh.wr(this.Ah), this.Dr = t;
    } else if (t === "Time") {
      this.Dr !== "Time" && (this.gh = this.fh.time);
      const i = e || ((s) => s);
      this.gh = i(this.gh), this.Br = this.gh.wr(this.Ah), this.Dr = t;
    }
    return this.chart.yi.Rs(), this;
  }
  Eh() {
    return this.Br;
  }
  Rh(t, e) {
    this.Br = t, this.Dr = e, this.chart.yi.Rs();
  }
  setInterval(t) {
    const { start: e, end: i, animate: s, stopAxisAfter: o } = t;
    return this.Xr || (this.Zr = !0, this.Ch = void 0), this.li(e !== void 0 ? e : this.mh, i !== void 0 ? i : this.Sh, s !== void 0 && s, o === void 0 || o, "userSetInterval"), this;
  }
  li(t, e, i = !1, s = !0, o) {
    let n = { start: t, end: e };
    const a = o === "synchronizedAxis" || o === "setDefaultInterval" && this.wh !== !1, l = o !== "setDefaultInterval", h = Math.abs(e - t), u = Math.abs(this.Sh - this.mh);
    if (this.Br.Fr !== void 0 && this.Br.Fr > h) {
      const f = (e + t) / 2, p = (l ? this.Br.Fr / 2 : u / 2) * (t > e ? -1 : 1);
      n = { start: f - p, end: f + p };
    }
    if (this.Br.Ir !== void 0 && this.Br.Ir < h) {
      const f = (e + t) / 2, p = (l ? this.Br.Ir / 2 : u / 2) * (t > e ? -1 : 1);
      n = { start: f - p, end: f + p };
    }
    const c = this.ai.nt(n.start, n.end, this.mh, this.Sh, l);
    if (c === !1) return this;
    if (c !== !0) {
      if (n = c, o === "zoomBandChartOther") return this;
    }
    let d;
    switch (o) {
      case "userSetInterval":
      case "userFit":
      case "interactionSetInterval":
      case "interactionZoom":
      case "setDefaultInterval":
      case "zoomBandChartClick":
        d = !0;
        break;
      case "zoomBandChartOther":
      case "synchronizedAxis":
        d = !1;
        break;
      default:
        return Oa(0, ""), this;
    }
    if (this.Oh && this.Oh.finishAll(!1), this.Or && (i === !0 || i > 0)) {
      this.setStopped(!0);
      const f = i === !0 ? void 0 : i, p = !this.Oh || this.Oh.isOver() ? this.Or : this.Oh.NextAnimation.bind(this);
      this.Oh = p([[this.mh, n.start], [this.Sh, n.end]], (([g, y]) => {
        this.zh(g, y, { allowIntervalLengthChange: l, skipIntervalRestriction: a });
      }), f), this.Oh.addEventListener("end", (() => {
        this.Oh = void 0, d && (this.Yr = H.performance.now());
      })), this.Oh.addEventListener("end", (() => {
        this.setStopped(s);
      }));
    } else this.zh(n.start, n.end, { allowIntervalLengthChange: l, skipIntervalRestriction: a }), this.setStopped(s), d && (this.Yr = H.performance.now());
    return this;
  }
  getInterval() {
    return { start: this.mh, end: this.Sh };
  }
  setStopped(t) {
    return t === this.Vr || (t && (this.Oh && this.Oh.finishAll(!1), this.Oh = void 0), this.Vr = t, this.D.R("stoppedchange", { isStopped: this.Vr }), this.Nr = H.performance.now(), this.chart.yi.Rs()), this;
  }
  getStopped() {
    return this.Vr;
  }
  fit(t, e) {
    const i = this.Th(), s = this._h || mb, o = typeof s == "function" ? s({ curStart: this.mh, curEnd: this.Sh, dataMin: i?.min, dataMax: i?.max }) : s;
    return this.li(o.start !== void 0 ? o.start : this.mh, o.end !== void 0 ? o.end : this.Sh, t !== void 0 ? t : o.animate !== void 0 ? o.animate : this.zr, e !== void 0 ? e : o.stopAxisAfter === void 0 || o.stopAxisAfter, this._h ? "setDefaultInterval" : "userFit"), this;
  }
  setScrollStrategy(t) {
    var e, i;
    return !((e = this.Vh) === null || e === void 0) && e.dispose && this.Vh.dispose({ axis: this }), this.Vh = If(t), this.Xr || (this.Ch = void 0), !((i = this.Vh) === null || i === void 0) && i.init && this.Vh.init({ axis: this }), this.chart.yi.Rs(), this;
  }
  getScrollStrategy() {
    return this.Vh;
  }
  setAnimationScroll(t) {
    return this.Rr = !!t, this.chart.yi.Rs(), this;
  }
  setAnimationZoom(t, e = 300) {
    return this.Oh && (this.Oh.finishAll(!1), this.Oh = void 0), this.Or = t ? Fn((() => this.chart.yi.Rs()))(e, t) : void 0, this;
  }
  setAnimationsEnabled(t) {
    return this.zr = t, t ? (this.setAnimationScroll(!0), this.setAnimationZoom(Cr.ease, void 0)) : (this.setAnimationScroll(void 0), this.setAnimationZoom(void 0)), this;
  }
  getAnimationsEnabled() {
    return this.zr;
  }
  setVisible(t) {
    const e = this.di !== t;
    return this.di = t, this.qr.setVisible(t), this.Nh(((i) => {
      i.Gh.setVisible(t);
    })), e && this.D.R("visiblechange", { isVisible: this.di }), this;
  }
  getVisible() {
    return this.di;
  }
  $h(t) {
    return !1;
  }
  Uh(t) {
    this.Qr && this.Qr(), this.title.setPointerEvents(this.title.Di.length > 0);
    const e = this.jh(), i = e.min, s = e.max;
    if (!this.$h(t) || !this.Yh || this.Jr) {
      const n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), l = yb(this.Br, i, s, this.mh, this.Sh, t.physicalAxisSize, Math.min(this.mh, this.Sh), Math.max(this.mh, this.Sh));
      this.Hh();
      const h = tr(3, 20, Jt((t.physicalAxisSize - 30) / 270, 0, 1)), u = { ...t, ...this.Wh(t) }, c = this.Xh(this.Br, Math.min(i, this.mh, this.Sh), Math.max(s, this.mh, this.Sh), l, n, u, a, h), d = this.Zh(this.Br, Math.min(i, this.mh, this.Sh), Math.max(s, this.mh, this.Sh), l, n, u, c, a, h), f = new Map([...c, ...d]), p = this.Br.Jh, g = this.Br.Cr.find(((y) => ag(y) && !Qn(y.Lr.labelFillStyle))) !== void 0;
      if (p && g && Array.from(f).reduce(((y, m) => y + (m[1].labelText.length > 0 && !Qn(m[0].Gh.kh()) ? 1 : 0)), 0) <= 1) {
        this.Hh(), f.clear();
        const y = [Math.min(this.mh, this.Sh), Math.max(this.mh, this.Sh)], m = { start: this.ai.getInnerStart(), end: this.ai.getInnerEnd() };
        y.forEach(((A) => {
          const v = this.Qh(A, p, p.Mr(A, m), t, u), b = this.Kh(v.keyValue, p, u, v, v.labelText);
          f.set(b, v);
        }));
      }
      return this.qh(), this.Yh = { ...u, ...this.tn(t, f, !0), min: i, max: s }, this.Yh;
    }
    let o = !1;
    return this.Er.forEach(((n) => {
      n.forEach(((a, l) => {
        (l < i || l > s) && (a.dispose(), n.delete(l), o = !0);
      }));
    })), { ...this.Yh, updatedTicks: o };
  }
  sn(t, e, i) {
    const s = e.Lr;
    i.length > 0 ? t.Gh.sr(s.getLabelFillStyle()).Ih(s.getLabelFont()).rn(i).setVisible(this.getVisible()).en(s.getLabelShadow()) : t.Gh.setVisible(!1);
  }
  Kh(t, e, i, s, o) {
    const n = this.Er.get(e) || /* @__PURE__ */ new Map();
    this.Er.set(e, n);
    let a = n.get(t);
    return a || (a = this.hn(t, e, i, s), n.set(t, a)), this.sn(a, e, o), a.nn = !1, a;
  }
  Xh(t, e, i, s, o, n, a, l) {
    const h = /* @__PURE__ */ new Map(), u = this.ih(), c = [];
    for (const d of t.kr) {
      const f = s.get(d).filter(((g) => g >= e && g <= i)), p = f.map(((g) => this.Qh(g, d, d.Mr(g, { start: this.ai.getInnerStart(), end: this.ai.getInnerEnd() }), n, n)));
      for (let g = 0; g < f.length; g += 1) {
        const y = f[g], m = p[g], A = this.Kh(y, d, n, m, m.labelText), v = Vh(A.M, A.Gh.an(), m.labelPosition, m.labelAlignment, m.labelRotation, { x: 0, y: 0 }, d, u, o, l, this.chart.yi.rh);
        c.find(((b, w) => {
          const k = p[w];
          return ma(v, Vh(b.M, b.Gh.an(), k.labelPosition, k.labelAlignment, k.labelRotation, { x: 0, y: 0 }, d, u, o, l, this.chart.yi.rh));
        })) && A.Gh.setVisible(!1), A.nn = !1, a.set(A, m), c.push(A), h.set(A, m);
      }
    }
    return h;
  }
  Zh(t, e, i, s, o, n, a, l, h) {
    var u;
    const c = { start: this.ai.getInnerStart(), end: this.ai.getInnerEnd() }, d = /* @__PURE__ */ new Map(), f = Array.from(a.values());
    let p, g = [];
    for (const y of t.Cr) {
      const m = y === t.Cr[t.Cr.length - 1], A = s.get(y);
      if (!A) break;
      let v;
      if (p === void 0) v = [{ start: e, end: i, keyValues: A }];
      else {
        v = [];
        for (let S = 0; S < p.length - 1; S += 1) {
          const E = p[S], T = p[S + 1], I = { start: E, end: T, keyValues: [] };
          for (const F of A) F >= E && F < T && I.keyValues.push(F);
          I.end < e || I.start > i || v.push(I);
        }
      }
      if (p = A, y.ln && (p = void 0), db(y)) continue;
      let b, w = 0, k = !1, R = -1, L = !0, x = [];
      for (let S = 0; S < v.length; S += 1) {
        const E = v[S].keyValues.map(((T) => this.Qh(T, y, y.Mr(T, c), n, n)));
        x = x.concat(E);
      }
      if (y.Lr.getLabelFillStyle() !== Lt) for (b = []; ++R < v.length; ) {
        const S = v[R], E = S.start, T = S.end;
        let I = S.keyValues;
        if (w > 0) {
          if (y.hh === void 0) {
            L = !1;
            break;
          }
          if (I = (0, y.hh.un)(S.keyValues, w - 1, E, T, e, i), I === void 0) break;
        }
        const F = Mr(I.map(((D) => x.find(((P) => P.keyValue === D)))));
        if (k) b = b.concat(F);
        else {
          const D = this.th(F, y, w, E, T, e, i, o, f, g, h);
          if (D === !0) {
            w += 1, R = -1, b = [];
            continue;
          }
          b = b.concat(D);
        }
        S !== v[v.length - 1] || a.size + b.reduce(((D, P) => D + (Ii(P.keyValue, e, i) ? 1 : 0)), 0) >= 2 || m || k || (k = !0, w -= 1, R = -1, b = []);
      }
      else b = x;
      const M = b.reduce(((S, E) => S + (Ii(E.keyValue, e, i) ? 1 : 0)), 0);
      y.cn !== void 0 && M < y.cn && (b.length = 0);
      const C = [];
      for (const S of x) {
        if (S.keyValue < e || S.keyValue > i) continue;
        const E = b.includes(S);
        if (!E && ((u = y.hh) === null || u === void 0 ? void 0 : u.dn) === "hide-tick") continue;
        S.labelText = E ? S.labelText : "";
        const T = this.Kh(S.keyValue, y, n, S, S.labelText);
        l.set(T, S), C.push(S), d.set(T, S);
      }
      if (g = C, !L) break;
    }
    return d;
  }
  Nh(t) {
    for (const e of this.Er.values()) for (const i of e.values()) t(i);
  }
  fn(t, e) {
    for (const i of this.Er.values()) for (const s of i.values()) e = t(e, s);
    return e;
  }
  Dh() {
    this.Er.forEach(((t, e) => {
      t.forEach(((i) => {
        i.dispose();
      }));
    })), this.Er.clear();
  }
  Hh() {
    for (const t of this.Er.values()) for (const e of t.values()) e.nn = !0;
  }
  qh() {
    for (const t of this.Er.values()) {
      const e = Array.from(t.entries());
      for (let i = 0; i < e.length; i += 1) {
        const [s, o] = e[i];
        o.nn && (o.dispose(), t.delete(s));
      }
    }
  }
  jh() {
    const t = this.ai.getInnerStart() < this.ai.getInnerEnd() ? this.ai.getInnerStart() : this.ai.getInnerEnd(), e = this.ai.getInnerEnd() > this.ai.getInnerStart() ? this.ai.getInnerEnd() : this.ai.getInnerStart();
    return Ee(t, e);
  }
  eh(t, e, i) {
    return e.length !== 0 && (!og(i) || i.An === !0);
  }
  gn(t, e) {
    return this.Dr === "Empty" || (this.Br.kr.forEach(((i) => {
      e = t(e, i.Lr);
    })), this.Br.Cr.forEach(((i) => {
      ag(i) && (e = t(e, i.Lr));
    }))), e;
  }
  getSeriesDataRange() {
    const t = this.Th();
    if (t && t.emptyBounds !== !0) return t;
  }
  Sr(t) {
    const e = t.forStart !== void 0 ? t.forStart : this.mh, i = t.forEnd !== void 0 ? t.forEnd : this.Sh, s = this.Th();
    if (s) return _h(this.Ch, s, { start: i > e ? s.min : s.max, end: i > e ? s.max : s.min }, { start: e, end: i }, !0);
  }
  Th() {
    const t = !this.Vh || this.Vh.considerVisibleRangeOnly;
    let e = this.dh.vn(t);
    const i = this.dh.yn(t);
    let s;
    if (e !== void 0 && Lh(e) && i !== void 0 && Lh(i) && (this.Ah.type === "logarithmic" && (e === 0 && (e = Math.min(1, i)), Math.sign(e) !== Math.sign(i) && (e = Math.min(1, i - 0.1))), s ? (s.min = Math.min(s.min, e), s.max = Math.max(s.max, i)) : s = Ee(e, i)), s && Lh(s.min) && Lh(s.max)) return Pi(s.min, s.max) ? { min: s.min - 1, max: s.max + 1, emptyBounds: !0 } : s;
  }
  pn() {
    if (this.ah === !1) return { start: 0, end: 0 };
    if (typeof this.ah == "object") return this.ah;
    let t = 0;
    const e = this.dh.Sn();
    return e && (t = Math.max(t, e)), { start: t, end: t };
  }
  setScrollMargins(t) {
    return this.ah = t !== void 0 && (typeof t == "number" ? { start: t, end: t } : t), this.chart.yi.Rs(), this;
  }
  getScrollMargins() {
    return this.ah;
  }
  setAutoRegionsEnabled(t) {
    return this.setScrollMargins(t), this;
  }
  bn() {
    const t = this.Gr;
    let e = !1;
    if (this.Hr && this._h) {
      const i = this.Th();
      if (i) {
        const s = typeof this._h == "function" ? this._h({ curStart: this.mh, curEnd: this.Sh, dataMin: i?.min, dataMax: i?.max }) : this._h;
        if (typeof this._h == "object" && !this.Xr) {
          const o = _h(this.Ch, i, { start: s.start !== void 0 ? s.start : this.mh, end: s.end !== void 0 ? s.end : this.Sh }, this.getInterval(), !0);
          o.start === s.start && o.end === s.end || (this.Zr = !0, this.Ch = void 0);
        }
        this.li(s.start !== void 0 ? s.start : this.mh, s.end !== void 0 ? s.end : this.Sh, s.animate !== void 0 && s.animate, s.stopAxisAfter === void 0 || s.stopAxisAfter, "setDefaultInterval"), this.Hr = !1, this.wh = void 0;
      }
    }
    if (this.Vh && !this.Vr) {
      let i = this.Th();
      i?.emptyBounds && this.Vh.id === ix && (i = void 0);
      const s = this.mh, o = this.Sh, n = this.Vh.apply({ axis: this, curStart: s, curEnd: o, seriesDataRange: i });
      if (n) {
        const a = _h(this.Ch, i, { start: n.start, end: n.end }, { start: s, end: o }, n.allowIntervalLengthChange);
        let l = a.start, h = a.end;
        const u = this.ai.H(), c = Pi(s, l) === !1 || n.keepScrolling, d = Pi(o, h) === !1 || n.keepScrolling;
        if (l = c ? l : s, h = d ? h : o, c || d || u) {
          let f = !1;
          if (this.Rr && !this.uh && n.allowAnimation !== !1) if (this.Rr) {
            f = !0;
            const p = c ? this.xn(s, l) : s, g = d ? this.xn(o, h) : o;
            if (this.zh(p, g, { allowIntervalLengthChange: n.allowIntervalLengthChange, skipIntervalRestriction: !1 }) === !0 && (c && Pi(p, l) === !1 || d && Pi(g, h) === !1) || n.keepScrolling === !0) {
              this.chart.yi.Rs(!0), e = !0;
              let y = Math.abs(h - l) / Math.abs(p - g);
              y < 1 && (y = 1 / y), this.$r = y >= 1.4;
            }
          } else f = !1;
          f || (this.zh(l, h, { allowIntervalLengthChange: n.allowIntervalLengthChange, skipIntervalRestriction: !1 }), n.keepScrolling === !0 && this.chart.yi.Rs(!0)), this.uh = !1;
        }
      }
    }
    return e ? (this.Gr !== e && (this.Gr = e, this.Ur = H.performance.now()), this.Mn && (clearTimeout(this.Mn), this.Mn = void 0)) : t === !0 && this.Mn === void 0 && (this.$r = !1, this.Mn = setTimeout((() => {
      this.Gr !== !1 && (this.Gr = !1, this.Ur = H.performance.now()), this.Mn = void 0, this.chart.yi.Rs();
    }), 200)), this;
  }
  _n() {
    const t = this.getInterval(), e = this.Th();
    return typeof this.Ch == "function" ? this.Ch({ curStart: t.start, curEnd: t.end, dataMin: e?.min, dataMax: e?.max }) : this.Ch;
  }
  zh(t, e, i) {
    let s = { start: t, end: e };
    const { allowIntervalLengthChange: o, skipIntervalRestriction: n } = i;
    let a = !0;
    if (this.Ch && !n) {
      const f = this.Th();
      s = _h(this.Ch, f, s, { start: this.mh, end: this.Sh }, o);
    }
    const l = Math.abs(e - t), h = Math.abs(this.Sh - this.mh);
    if (this.Br.Fr !== void 0 && this.Br.Fr > l) {
      const f = (e + t) / 2, p = (o ? this.Br.Fr / 2 : h / 2) * (t > e ? -1 : 1);
      s = { start: f - p, end: f + p }, a = !1;
    }
    if (this.Br.Ir !== void 0 && this.Br.Ir < l) {
      const f = (e + t) / 2, p = (o ? this.Br.Ir / 2 : h / 2) * (t > e ? -1 : 1);
      s = { start: f - p, end: f + p }, a = !1;
    }
    let u = this.ai.nt(s.start, s.end, this.mh, this.Sh, o);
    if (u === !1) return !1;
    u !== !0 && (s = u);
    const c = this.pn(), d = this.wn(s.start, s.end, c);
    return u = this.ai.nt(d.start, d.end, this.mh, this.Sh, !1), !!u && (u === !0 ? this.ai.Z(d.start, d.end) : this.ai.Z(s.start, s.end), this.mh = s.start, this.Sh = s.end, this.D.R("intervalchange", { start: s.start, end: s.end }), this.jr = H.performance.now(), this.chart.yi.Rs(), a);
  }
  kn() {
    return this.Gr;
  }
  Cn() {
    return this.Oh !== void 0;
  }
  Mh() {
    var t;
    const e = ((t = this.As) === null || t === void 0 ? void 0 : t.displayOnAxis) !== !1;
    this.qr.rn(this.bh && e && this.Wr ? `${this.Wr} (${this.bh})` : this.Wr), this.chart.yi.Rs();
  }
}
class Wa {
  constructor(t, e, i, s, o = i.In(s).Fn(Me).Tn(Me).setPointerEvents(!1)) {
    this.nn = !1, this.ci = !1, this.ps = [], this.Pn = t, this.M = e, this.Ln = i, this.Bn = s, this.Gh = o, this.ps.push(o);
  }
  Ls(t) {
    this.ps.forEach(((e) => e.setVisible(t)));
  }
  dispose() {
    return this.ci || (this.ci = !0, this.ps.forEach(((t) => t.dispose()))), this;
  }
}
const yb = (r, t, e, i, s, o, n, a, l = !1) => {
  const h = /* @__PURE__ */ new Map();
  for (const c of r.kr) {
    let d = c.Dn(t, e, i, s, o, n, a);
    d = lg(d), h.set(c, d);
  }
  let u;
  for (const c of r.Cr) {
    let d;
    if (c.ln) d = c.ln({ interval: { start: i, end: s }, axisSizePixels: o }).map(((f) => f.position));
    else if (u === void 0) d = c.Dn(t, e, t, e, o);
    else {
      if (l && c === r.Cr[r.Cr.length - 1]) break;
      let f = [];
      const p = u.filter(((g) => t <= g && g <= e)).length;
      if (p > 0) {
        const g = o / (p - 1);
        if (c.En !== void 0 && c.En > g) break;
      }
      for (let g = 0; g < u.length - 1; g += 1) {
        const y = c.Dn(u[g], u[g + 1], t, e, o);
        f = f.concat(y);
      }
      d = f;
    }
    d = lg(d), h.set(c, d), u = d;
  }
  return h;
}, lg = (r) => Array.from(new Set(r)), _h = (r, t, e, i, s) => {
  const o = typeof r == "function" ? r({ curStart: i.start, curEnd: i.end, dataMin: t?.min, dataMax: t?.max }) : r;
  if (!o) return e;
  const n = { start: e.start, end: e.end };
  let a = Math.abs(e.end - e.start);
  if (o.intervalMin !== void 0 && a < o.intervalMin) {
    const l = (n.start + n.end) / 2;
    n.start = l + 0.5 * Math.sign(e.start - l) * o.intervalMin, n.end = l + 0.5 * Math.sign(e.end - l) * o.intervalMin;
  }
  if (a = Math.abs(e.end - e.start), o.intervalMax !== void 0 && a > o.intervalMax) {
    const l = (n.start + n.end) / 2;
    n.start = l + 0.5 * Math.sign(e.start - l) * o.intervalMax, n.end = l + 0.5 * Math.sign(e.end - l) * o.intervalMax;
  }
  return a = Math.abs(e.end - e.start), o.startMin !== void 0 && (n.start = Math.max(n.start, o.startMin), s || Pi(Math.abs(n.start - n.end), a) || (n.end = n.start + Math.sign(e.end - e.start) * a)), a = Math.abs(e.end - e.start), o.startMax !== void 0 && (n.start = Math.min(n.start, o.startMax), s || Pi(Math.abs(n.start - n.end), a) || (n.end = n.start + Math.sign(e.end - e.start) * a)), a = Math.abs(e.end - e.start), o.endMin !== void 0 && (n.end = Math.max(n.end, o.endMin), s || Pi(Math.abs(n.start - n.end), a) || (n.start = n.end + Math.sign(e.start - e.end) * a)), a = Math.abs(e.end - e.start), o.endMax !== void 0 && (n.end = Math.min(n.end, o.endMax), s || Pi(Math.abs(n.start - n.end), a) || (n.start = n.end + Math.sign(e.start - e.end) * a)), Math.sign(n.end - n.start) !== Math.sign(e.end - e.start) ? { end: n.start, start: n.end } : n;
}, mb = (r) => {
  if (r.dataMin === void 0 || r.dataMax === void 0) return { stopAxisAfter: !1 };
  const t = r.curEnd >= r.curStart;
  return { start: t ? r.dataMin : r.dataMax, end: t ? r.dataMax : r.dataMin, stopAxisAfter: !1 };
}, xb = (r) => {
  const t = r.getDraggingMode();
  return t !== void 0 && t !== zr.notDraggable ? t === zr.draggable ? Gt.Move : t === zr.onlyHorizontal ? Gt.Horizontal : Gt.Vertical : void 0;
};
class Vf {
  constructor() {
    this.di = !0;
  }
  set draggable(t) {
    this.D.draggable = t;
  }
  get draggable() {
    return this.D.draggable;
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
  setVisible(t) {
    const e = this.di !== t;
    return this.di = t, e && this.D.R("visiblechange", { isVisible: this.di }), this;
  }
  getVisible() {
    return this.di;
  }
}
class Ga extends Vf {
  constructor(t, e, i, s, o) {
    super(), this.D = new Nt(), this.Rn = j(50, 50), this.origin = j(0, 0), this.size = j(0, 0), this.ci = !1, this.On = void 0, this.zn = void 0, this.Vn = xb, this.Nn = void 0, this.dt = To(0, 0, 0, 0), this.Js = t, this.renderingScale = e, this.scale = i, this.pi = s, this.xi = o, this.Js.Rs(), this.xi = o, this.addEventListener("pointerenter", (() => {
      const a = typeof this.Vn == "function" ? this.Vn(this) : this.Vn;
      a && (this.zn = this.Js.yi.Gn(a));
    })), this.addEventListener("pointerleave", (() => {
      this.Js.yi.$n(this.zn);
    }));
    const n = (a) => {
      const l = this.getDraggingMode();
      if (l === zr.notDraggable) return;
      It(a);
      let h = a;
      const u = (d) => {
        const f = { x: d.clientX - h.clientX, y: d.clientY - h.clientY };
        h = d;
        const p = this.scale.Qt(this.getPosition(), { x: l !== zr.onlyVertical ? f.x : 0, y: l !== zr.onlyHorizontal ? -f.y : 0 }), g = this.scale, y = this.getSize(), m = this.getOrigin(), A = g.Qt({ x: g.x.getInnerStart(), y: g.y.getInnerStart() }, ls({ x: (1 + m.x) / 2, y: (1 + m.y) / 2 }, y)), v = g.Qt({ x: g.x.getInnerEnd(), y: g.y.getInnerEnd() }, ls({ x: (m.x - 1) / 2, y: (m.y - 1) / 2 }, y)), b = { x: Math.min(Math.max(p.x, A.x), v.x), y: Math.min(Math.max(p.y, A.y), v.y) };
        this.setPosition(b);
      }, c = (d) => {
        this.Js.yi.Un.removeEventListener("pointermove", u), this.Js.yi.Un.removeEventListener("pointerup", c), this.addEventListener("pointerdown", n);
      };
      this.removeEventListener("pointerdown", n), this.Js.yi.Un.addEventListener("pointermove", u), this.Js.yi.Un.addEventListener("pointerup", c);
    };
    this.addEventListener("pointerdown", n);
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
  setEffect(t) {
    return this.bs = this.bs || this.Js.yi.bs.xs(this, { jn: { shapes: this.Yn() } }), this.bs.jn.Es(t), this;
  }
  getEffect() {
    return !!this.bs && this.bs.jn.Os();
  }
  setAutoDispose(t) {
    return this.Nn = t, this.Js.Rs(), this;
  }
  getAutoDispose() {
    return this.Nn;
  }
  getSize(t = be.Everything) {
    return t === be.Everything ? j(this.size.x + (this.dt.left + this.dt.right), this.size.y + (this.dt.bottom + this.dt.top)) : this.size;
  }
  setContentSize(t) {
    this.size = t;
  }
  setMargin(t) {
    return this.dt = typeof t == "object" ? pa(this.dt, t) : { left: t, top: t, right: t, bottom: t }, this.Js.Rs(), this;
  }
  getMargin() {
    return this.dt;
  }
  rr() {
    if (this.Nn) {
      const t = this.size, e = this.renderingScale.Ft(), i = { x: t.x / e.x, y: t.y / e.y };
      (this.Nn.type === "max-width" && i.x >= this.Nn.maxWidth || this.Nn.type === "max-height" && i.y >= this.Nn.maxHeight) && this.dispose();
    }
    return this;
  }
  Uh() {
    return this;
  }
  dispose() {
    return this.ci || (this.Js.Rs(), this.ci = !0, this.pi(this), this.D.R("dispose", {}), this.Yn().forEach(((t) => t.dispose()))), this;
  }
  setVisible(t) {
    return super.setVisible(t), this.Yn().forEach(((e) => e.setVisible(t))), this.Js.Rs(), this;
  }
  isDisposed() {
    return this.ci;
  }
  setPosition(t) {
    return this.Rn = t, this.Js.Rs(), this;
  }
  getPosition(t = this.origin, e = be.Everything) {
    const i = this.getSize(be.Everything), s = this.scale.Qt(this.Rn, ls({ x: -(this.origin.x + 1) / 2, y: -(this.origin.y + 1) / 2 }, i));
    if (e === be.Everything) return this.scale.Qt(s, ls({ x: (t.x + 1) / 2, y: (t.y + 1) / 2 }, i));
    const o = this.scale.Qt(s, { x: this.dt.left, y: this.dt.bottom }), n = this.getSize(be.Content);
    return this.scale.Qt(o, ls({ x: (t.x + 1) / 2, y: (t.y + 1) / 2 }, n));
  }
  setOrigin(t) {
    return this.origin = t, this.Js.Rs(), this;
  }
  getOrigin() {
    return this.origin;
  }
  setDraggingMode(t = zr.notDraggable) {
    return this.On = t, this.Js.Rs(), this;
  }
  getDraggingMode() {
    return this.On !== void 0 ? this.On : zr.notDraggable;
  }
  setMouseStyle(t) {
    return this.Vn = t, this;
  }
  getMouseStyle() {
    return this.Vn;
  }
}
class vb extends Ga {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, o, n), this.Hn = To(), this.Wn = 0, this.Xn = s, this.backgroundElement = new this.Xn(this.Js, this.renderingScale, this.scale, ie, n), this.D.Gi(this.backgroundElement);
  }
  setPointerEvents(t) {
    return super.setPointerEvents(t), this.backgroundElement.setPointerEvents(t), this;
  }
  Yn() {
    return this.backgroundElement.Yn();
  }
  setBackground(t) {
    return t(this.backgroundElement), this;
  }
  getBackground() {
    return this.backgroundElement;
  }
  rr() {
    return super.rr(), this.ci || (this.Zn !== void 0 && (this.backgroundElement.Zn = this.Zn - 0.01), this.backgroundElement.setOrigin(this.origin).setPosition(this.getPosition(this.origin, be.PaddedBackground)).rr()), this;
  }
  Uh() {
    const t = this.getSize(be.PaddedContent);
    return this.backgroundElement.Jn(t).Uh(), super.Uh();
  }
  dispose() {
    return super.dispose(), this.backgroundElement.dispose(), this;
  }
  setVisible(t) {
    return super.setVisible(t), this.backgroundElement.setVisible(t), this;
  }
  setPadding(t) {
    return this.Hn = typeof t == "object" ? pa(this.Hn, t) : { left: t, top: t, right: t, bottom: t }, this.Js.Rs(), this;
  }
  getPadding() {
    return this.Hn;
  }
  getSize(t = be.Everything) {
    let e = super.getSize(t);
    return t >= be.PaddedContent && (e = j(e.x + this.Hn.left + this.Hn.right, e.y + this.Hn.bottom + this.Hn.top)), t >= be.PaddedBackground && (e = j(e.x + this.backgroundElement.Qn() + this.backgroundElement.Kn(), e.y + this.backgroundElement.qn() + this.backgroundElement.io())), e;
  }
  getPosition(t = this.origin, e = be.Everything) {
    if (e === be.Everything) return super.getPosition(t, e);
    const i = super.getPosition(j(-1, -1), be.Everything), s = this.getMargin(), o = this.scale.Qt(i, { x: s.left, y: s.bottom });
    if (e === be.PaddedBackground) {
      const u = this.getSize(be.PaddedBackground);
      return this.scale.Qt(o, ls({ x: (t.x + 1) / 2, y: (t.y + 1) / 2 }, u));
    }
    const n = this.scale.Qt(o, { x: this.backgroundElement.Qn(), y: this.backgroundElement.qn() });
    if (e === be.PaddedContent) {
      const u = this.getSize(be.PaddedContent);
      return this.scale.Qt(n, ls({ x: (t.x + 1) / 2, y: (t.y + 1) / 2 }, u));
    }
    const a = this.getPadding(), l = this.scale.Qt(n, { x: a.left, y: a.bottom }), h = this.getSize(be.Content);
    return this.scale.Qt(l, ls({ x: (t.x + 1) / 2, y: (t.y + 1) / 2 }, h));
  }
  getHighlight() {
    return this.Wn;
  }
  setHighlight(t) {
    return this.Wn = dn(t), this.backgroundElement.setHighlight(t), this.D.R("highlightchange", { highlight: this.Wn }), this;
  }
}
const vd = (r) => "setBackground" in r, nx = (r) => {
  const t = r.getPosition({ x: -1, y: -1 }, be.PaddedBackground), e = r.getSize(be.PaddedBackground), i = r.scale.Qt(t, e), s = xt(t, r.scale, r.Js.yi.ai), o = xt(i, r.scale, r.Js.yi.ai), n = r.Js.yi.so(s.x, s.y), a = r.Js.yi.so(o.x, o.y);
  return { p1: { clientX: n.x, clientY: n.y }, p2: { clientX: a.x, clientY: a.y } };
};
class Sb extends Vf {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(), this.M = 0, this.eo = 1, this.ro = !0, this.ho = new qn(), this.no = !0, this.ci = !1, this.D = new Nt(), this.axisScale = s, this.renderingScale = o, this.oo = a, this.ao = l, this.lo = h, this.pi = u, this.uo = e, this.co = i, this.do = this.uo.vr(this.renderingScale), this.D.zi(this.do), this.xi = c, this.fo = this.lo.setDirection(this.ao).Ao(this.co, this.renderingScale, n, ie, this.xi, !1).setOrigin(Rm(this.ao)), this.D.Gi(this.fo), this.axis = t, this.setPointerEvents(!1), this.fo.vo === "major" ? this.do.gr(c.xAxisNumericTicks.majorTickStyle.gridStrokeStyle) : this.fo.vo === "minor" ? this.do.gr(c.xAxisNumericTicks.minorTickStyle.gridStrokeStyle) : this.fo.vo === "other" && this.do.gr(c.cursorGridStrokeStyleX);
  }
  setValue(t) {
    return this.M = t, this.co.Rs(), this.D.R("valuechange", { value: this.M }), this;
  }
  getValue() {
    return this.M;
  }
  setTextFormatter(t) {
    return this.yo = t, this.co.Rs(), this;
  }
  setTickLength(t) {
    return this.fo.setPointerLength(t), this.uo.Rs(), this;
  }
  getTickLength() {
    return this.fo.getPointerLength();
  }
  setTickLabelAlignment(t, e) {
    return this.fo.setTickLabelAlignment(t, e), this.uo.Rs(), this;
  }
  getTickLabelAlignment() {
    return this.fo.getTickLabelAlignment();
  }
  setTickLabelPadding(t) {
    return this.fo.setTickLabelPadding(t), this.uo.Rs(), this;
  }
  setTickLabelRotation(t) {
    return this.fo.setTextRotation(t), this.uo.Rs(), this;
  }
  getTickLabelRotation() {
    return this.fo.getTextRotation();
  }
  getTickLabelPadding() {
    return this.fo.getTickLabelPadding();
  }
  setGridStrokeLength(t) {
    return this.eo = t, this.uo.Rs(), this;
  }
  getGridStrokeLength() {
    return this.eo;
  }
  setGridStrokeStyle(t) {
    return this.do.gr(t), this.uo.Rs(), this;
  }
  getGridStrokeStyle() {
    return this.do.po();
  }
  dispose() {
    return this.ci || (this.ci = !0, this.do.dispose(), this.fo.dispose(), this.pi(this), this.uo.yi.Rs(), this.D.R("dispose", {})), this;
  }
  setMarkerVisible(t) {
    return this.ro = t, this.co.Rs(), this;
  }
  getMarkerVisible() {
    return this.ro;
  }
  setMarker(t) {
    return t(this.fo), this.co.Rs(), this;
  }
  getMarker() {
    return this.fo;
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
  setAllocatesAxisSpace(t) {
    return this.no = t, this.co.Rs(), this;
  }
  getAllocatesAxisSpace() {
    return this.no;
  }
  isInScale() {
    return Ii(this.M, this.axisScale.getInnerStart(), this.axisScale.getInnerEnd());
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Ab extends Sb {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(t, e, i, s, o, n, a, l, c, h, u), this.mo = !1, this.pi = h, this.uo = e, this.co = i;
  }
  dispose() {
    return this.mo = !1, super.dispose();
  }
  update() {
    return this;
  }
  plot(t, e, i, s, o) {
    if (this.isInScale() && this.getVisible() && t) {
      this.mo = !1;
      const n = Nl(this.M, this.axisScale, this.oo.getWidth(this.renderingScale));
      this.do.setVisible(!0).pr(this.oo.toPoint(n, e)).yr(this.oo.toPoint(n, e - (s + i * this.eo))), this.ro ? (this.yo && this.fo.setText(this.yo(this.M, this)), this.fo.setVisible(!0).setPosition(this.oo.toPoint(n, o))) : this.fo.setVisible(!1);
    } else this.do.setVisible(!1), this.fo.setVisible(!1);
    return this.fo.Uh().rr(), this;
  }
  So() {
    this.ro ? (this.yo && this.fo.setText(this.yo(this.M, this)), this.fo.setVisible(!0)) : this.fo.setVisible(!1);
    const t = this.fo.Uh().getSize();
    return this.oo.getHeight(t);
  }
}
const Ot = { bo: "X0Z1bGxBY2Nlc3M=", xo: "X0Jhc2VDaGFydHM=", Mo: "RGF0YSBHcmlk", _o: "X0hhc0hhcmRFeHBpcmF0aW9u", wo: "X0lzVHJpYWw=", ko: "X0lzQ29tbXVuaXR5", Co: "T0hMQyBTZXJpZXM=", To: "QmFyIENoYXJ0", Fo: "c2xpY2VkIGNoYXJ0cw==", Io: "R2F1Z2UgQ2hhcnQ=", Po: "U3BpZGVyIENoYXJ0", Lo: "UG9sYXIgQ2hhcnQ=", Bo: "M0QgQ2hhcnQ=", Do: "Wm9vbSBCYW5kIENoYXJ0", Eo: "TWFwIENoYXJ0", Ro: "WFkgQ2hhcnQ=", Oo: "WFkgU2VyaWVz", zo: "SGVhdG1hcCBTZXJpZXM=", Vo: "RmlndXJlIFNlcmllcw==", No: "bG9nYXJpdGhtaWMgYXhpcw==", Go: "cmVhbC10aW1lIHZpc3VhbGl6YXRpb24=", $o: "aW5kaXZpZHVhbCBwb2ludCBzaXpl", Uo: "aW5kaXZpZHVhbCBwb2ludCBjb2xvcg==", jo: "VHJlZU1hcCBDaGFydA==", Yo: "UGFyYWxsZWwgQ29vcmRpbmF0ZSBDaGFydA==", Ho: "X1B5dGhvbkxpY2Vuc2U=", Wo: "X1N0dWRlbnRMaWNlbnNl" }, Ku = (r, t) => r.setTextFillStyle(t.uiTextFillStyle).setTextFont(t.uiTextFont), ro = (r, t, e) => {
  e && vd(r) && r.setBackground(((i) => i.setFillStyle(t.uiBackgroundFillStyle).setStrokeStyle(t.uiBackgroundStrokeStyle))).setEffect(!0);
}, mn = { uiElement: void 0, stylers: ah(), addStyler(r) {
  return { ...this, stylers: this.stylers.push(r) };
}, applyStylers(r, t) {
  return this.stylers.forEach(((e) => e !== void 0 ? e(r, t) : void 0)), r;
} }, ch = { background: void 0, setBackground(r) {
  return { ...this, background: r };
} }, _f = { Ao(r, t, e, i, s, o) {
  const n = this.applyStylers(new this.uiElement(r, t, e, i, s), s);
  return ro(n, s, o), n;
} }, bb = { Ao(r, t, e, i, s, o) {
  const n = this.applyStylers(new this.uiElement(r, t, e, this.background, i, s), s);
  return ro(n, s, o), n;
} };
class ox extends Ga {
  constructor() {
    super(...arguments), this.Xo = !0;
  }
  rr() {
    return super.rr(), this;
  }
  setPointerEvents(t) {
    return this.Xo = t, this;
  }
  getPointerEvents() {
    return this.Xo;
  }
  Yn() {
    return [];
  }
}
class Eb extends ox {
  Jn(t) {
    return this.size = t, this;
  }
  Qn() {
    return 0;
  }
  Kn() {
    return 0;
  }
  io() {
    return 0;
  }
  qn() {
    return 0;
  }
  setHighlight(t) {
    return this;
  }
  getHighlight() {
    return 0;
  }
  setFillStyle() {
    return this;
  }
  getFillStyle() {
    return Lt;
  }
  setStrokeStyle() {
    return this;
  }
  getStrokeStyle() {
    return Et;
  }
  setStrokeThickness() {
    return this;
  }
  getStrokeThickness() {
    return 0;
  }
}
class Mb {
  constructor(t) {
    this.Zo = /* @__PURE__ */ new Map(), this.yi = t;
  }
  ws(t, e, i) {
    const s = i.animationEnabled;
    this.Zo.set(t, { applyHighlight: e, curUnanimatedHighlightValue: 0, curAnimationPositionMillis: 0, animationEnabled: s, curAnimatedHighlightValue: 0 });
    const o = () => {
      this.Zo.delete(t), t.removeEventListener("dispose", o);
    };
    H.requestAnimationFrame((() => {
      t.addEventListener("dispose", o);
    }));
  }
  Jo(t, e) {
    let i = e.animationEnabled;
    const s = [], o = () => {
      s.forEach(((n) => {
        this.Zo.delete(n);
      })), t.removeEventListener("dispose", o);
    };
    return H.requestAnimationFrame((() => {
      t.addEventListener("dispose", o);
    })), { Qo: (n, a) => {
      const l = { applyHighlight: a, curUnanimatedHighlightValue: 0, curAnimationPositionMillis: 0, animationEnabled: i, curAnimatedHighlightValue: 0 };
      s.push(n), this.Zo.set(n, l);
    }, Ko: () => {
      s.forEach(((n) => {
        this.Zo.delete(n);
      })), s.length = 0;
    }, qo: (n) => {
      i = n, s.forEach(((a) => {
        this.Us(a, i);
      }));
    }, ta: () => i };
  }
  $s(t, e) {
    const i = this.Zo.get(t);
    i && (i.curUnanimatedHighlightValue = dn(e), this.yi.Rs());
  }
  Is(t, e = !1) {
    const i = this.Zo.get(t);
    return i ? e ? i.curAnimatedHighlightValue : i.curUnanimatedHighlightValue : 0;
  }
  Us(t, e) {
    const i = this.Zo.get(t);
    i && (i.animationEnabled = e);
  }
  js(t) {
    const e = this.Zo.get(t);
    return !!e && e.animationEnabled;
  }
  Uh(t) {
    let e = !1;
    this.Zo.forEach(((i, s) => {
      let o;
      if (i.animationEnabled)
        if (i.curUnanimatedHighlightValue > 0) {
          const a = i.curAnimationPositionMillis / 1e3;
          o = i.curUnanimatedHighlightValue * Math.abs(Math.sin(a * Math.PI / 2 + 0.5));
          const l = i.curAnimatedHighlightValue === 0 ? 1 : t;
          i.curAnimationPositionMillis += l, e = !0;
        } else i.curAnimatedHighlightValue > 0 && i.curUnanimatedHighlightValue === 0 ? (o = Math.max(i.curAnimatedHighlightValue - t / 1e3, 0), e = e || o > 0) : o = 0, i.curAnimationPositionMillis = 0;
      else o = i.curUnanimatedHighlightValue;
      o !== i.curAnimatedHighlightValue && (i.applyHighlight(o), i.curAnimatedHighlightValue = o);
    })), e && this.yi.Rs(!0);
  }
}
const hg = /* @__PURE__ */ new Map(), qu = (r, t) => {
  const e = r.getSize(), i = r.getFamily(), s = r.getWeight(), o = r.getStyle(), n = r.getVariant(), a = `${o} ${n ? "small-caps" : "normal"} ${s} ${e}px ${i}`, l = `${a} ${t.toFixed(2)}`;
  let h = hg.get(l);
  return h || (h = /* @__PURE__ */ ((u, c, d, f) => ({ font: u, properties: c, dpr: d, id: f }))(a, { type: "font", size: e, family: i, style: o, variant: n, weight: s }, t, l), hg.set(l, h)), h;
}, Cb = (r) => ({ container: r.Un, setMouseStyle: (t, e) => r.Gn(t, e), restoreMouseStyle: (t) => r.$n(t), clearMouseStyle: () => r.ia(), captureFrame: (t, e, i, s) => r.sa(t, e, i, s), renderFrame: (t, e, i = !1) => r.ea(t, e, i), layout: () => {
  r.ra(), r.ha(), r.oa.na(), r.Rs();
}, setBackgroundFillStyle(t) {
  return r.setBackgroundFillStyle(t), this;
}, setBackgroundStrokeStyle(t) {
  return r.setBackgroundStrokeStyle(t), this;
}, getBackgroundFillStyle: () => r.getBackgroundFillStyle(), getBackgroundStrokeStyle: () => r.getBackgroundStrokeStyle(), addCustomIcon: (t, e) => r.aa(t, e), addEventListener: (t, e, i) => r.O(t, e, i), removeEventListener: (t, e) => r.N(t, e) }), mo = [];
let tn;
const Pc = () => {
  if (tn !== void 0) {
    const r = H.getComputedStyle(H.document.body), t = Number(r.getPropertyValue("margin-top").replace("px", "")) + Number(r.getPropertyValue("margin-bottom").replace("px", ""));
    tn.style.height = H.innerHeight - t + "px", (() => {
      for (let e = 0; e < mo.length; e += 1) mo[e]();
    })();
  }
}, ug = new ot({ color: N(255, 255, 255) }), Hi = { font: qu(Mm, 0), fillStyle: ug, lineStyle: new $t({ fillStyle: ug, thickness: 1 }), pointStyle3D: new Mu.Triangulated() };
class wb {
  constructor(t, e, i) {
    this.ai = ki.d2({ scaleXYConstructor: we }), this.la = /* @__PURE__ */ new Map(), this.ua = Fn((() => this.Rs()), 60), this.ca = j(0, 0), this.da = !1, this.fa = ie, this.Aa = () => {
    }, this.ga = [], this.va = -1, this.ya = [], this.ci = !1, this.pa = !1, this.ma = /* @__PURE__ */ new Set(), this.Sa = (n) => {
      n.dataTransfer && n.dataTransfer.setDragImage(new Image(), 0, 0);
    }, this.ba = /* @__PURE__ */ new Map(), this.xa = (n, a) => {
      var l, h, u;
      const c = a instanceof PointerEvent && a, d = bf(a) ? { clientX: a.changedTouches[0].clientX, clientY: a.changedTouches[0].clientY } : { clientX: a.clientX, clientY: a.clientY };
      if (c) {
        if (!c.pointerType) return;
        this.Ma = a;
      }
      const f = this.Ds({ x: d.clientX, y: d.clientY });
      if ((n === "pointermove" || n === "pointerenter") && f && c) {
        const p = this.ba.get(c.pointerId);
        let g = p;
        g || (g = { lastEvent: c, entity: f.entity, collectionMember: f.collectionMember, info: f.info }, this.ba.set(c.pointerId, g));
        const y = p === void 0 || p.entity !== f.entity || p.collectionMember !== f.collectionMember;
        y && p && p.entity.R("pointerleave", a, p.collectionMember, p.info), y && f && f.entity.R("pointerenter", a, f.collectionMember, f.info), f && (f.entity.R("pointermove", a, f.collectionMember, f.info), this.Un.draggable = (l = f.entity.fi) !== null && l !== void 0 && l), g.lastEvent = c, g.entity = f.entity, g.collectionMember = f.collectionMember, g.info = f.info;
      } else if (n === "pointerleave" && c) {
        const p = this.ba.get(c.pointerId);
        p && (p.entity.R("pointerleave", a, p.collectionMember, p.info), this.ba.delete(c.pointerId));
      } else if (n === "click" && c) {
        const p = ((h = this._a) === null || h === void 0 ? void 0 : h.event) instanceof PointerEvent && this._a.event.pointerId === c.pointerId && this._a;
        p && p.entity.R("click", c, p.collectionMember, p.info);
      } else if (n === "dblclick" && a instanceof MouseEvent) {
        const p = ((u = this._a) === null || u === void 0 ? void 0 : u.event.type) === "click" && this._a;
        p && p.entity.R("dblclick", a, p.collectionMember, p.info);
      } else {
        const p = a instanceof PointerEvent ? this.ba.get(a.pointerId) : f;
        p?.entity.R(n, a, p.collectionMember, p.info);
      }
      a && f && !["touchend"].includes(n) && (this._a = { ...f, event: a });
    }, this.ha = () => {
      const { bottom: n, left: a } = this.Un.getBoundingClientRect(), l = j(Math.floor(a), Math.floor(n));
      return l.x === this.ca.x && l.y === this.ca.y || this.D.R("locationchange", {}), this.ca = l, this.wa = H.performance.now(), this;
    }, this.ra = () => {
      this.ka && this.ka();
    }, this.Gn = (n, a) => {
      if (a !== void 0) {
        const h = this.ya.find(((u) => u[0] === a));
        return h && (h[1] = n, this.ya.indexOf(h) === this.ya.length - 1 && (this.Un.style.cursor = n)), a;
      }
      const l = this.va;
      return this.va += 1, this.ya.push([l, n]), this.Un.style.cursor = n, l;
    }, this.$n = (n) => {
      var a;
      const l = this.ya.find(((h) => h[0] === n));
      if (l) {
        const h = this.ya.indexOf(l), u = h === this.ya.length - 1;
        if (this.ya.splice(h, 1), u) {
          const c = ((a = this.ya[this.ya.length - 1]) === null || a === void 0 ? void 0 : a[1]) || "default";
          this.Un.style.cursor = c;
        }
      }
    }, this.Ca = (n) => (this.Ta.C(n), this), this.Fa = () => this.Ta.T(), this.Ia = () => {
      this.fa && this.fa(1e3 / 60), this.Pa(), this.La(), this.Aa && this.Aa();
    }, this.Ba = (n) => (this.la.set(n.Da(), n), this.la = new Map([...this.la.entries()].sort(((a, l) => a[0] - l[0]))), n), this.Ea = (n) => (this.la.delete(n), this), this.W = () => (this.Ta.u = !1, this), this.X = () => (this.Ta.u = !0, this), this.Ra = () => this.Ma, this.D = new Nt(), this.oa = t, this.xi = e.theme, this.Oa = i.Oa, this.za = i.Va, this.Na = t.Na, this.Ga = { xe: e && e.resourcesBaseUrl !== void 0 && e.resourcesBaseUrl !== null ? e.resourcesBaseUrl : void 0, $a: !e || !("warnings" in e) || typeof e.warnings != "boolean" || e.warnings, Ua: (() => {
      const n = e?.pickingPrecision;
      if (typeof n == "string") {
        const a = n.toLowerCase();
        if (a === "best") return 1;
        if (a === "high") return 0.5;
        if (a === "low") return 1 / 8;
      }
      return 1 / 4;
    })(), ja: e?.interactable === void 0 || e.interactable, Ya: e.textPixelSnappingEnabled === void 0 || e.textPixelSnappingEnabled };
    const s = e ? e.container : void 0;
    if (s) {
      if (typeof s == "string") {
        const n = H.document.getElementById(s);
        if (!n) throw new Error(`Container "${s}" doesn't exist.`);
        this.Un = n;
      } else this.Un = s;
      H.addEventListener("resize", this.ra), this.ga.push((() => {
        H.removeEventListener("resize", this.ra);
      }));
    } else {
      if (tn === void 0) {
        const a = H.document.createElement("div");
        a.id = "lcjs-auto-flexbox", a.style.position = "relative", a.style.width = "100%", a.style.display = "flex", a.style.flexDirection = "column", H.document.body.appendChild(a), tn = a, H.addEventListener("resize", Pc);
      }
      let n = 1;
      for (; H.document.getElementById(`chart-${n}`) !== null; ) n += 1;
      this.Un = H.document.createElement("div"), this.Un.id = `chart-${n}`, this.Un.style.flex = "1", this.Un.style.height = "100%", tn.appendChild(this.Un), Pc(), mo.push(this.ra), this.ga.push((() => {
        tn && tn.removeChild(this.Un), mo.includes(this.ra) && mo.splice(mo.indexOf(this.ra), 1), mo.length === 0 && tn && (H.document.body.removeChild(tn), tn = void 0, H.removeEventListener("resize", Pc));
      }));
    }
    if (H.ResizeObserver) {
      const n = (a) => {
        for (const l of a) l.target === this.Un && this.ra();
      };
      this.Ha = new H.ResizeObserver(n.bind(this)), this.Ha.observe(this.Un);
    }
    this.Un.style.position = "relative", this.Un.style.boxSizing = "content-box", this.Ga.ja !== !1 && (this.Un.style.touchAction = "none"), this.Un.style.overflow = "hidden", this.Un.addEventListener("fullscreenchange", this.ra), this.Un.addEventListener("webkitfullscreenchange", this.ra), this.Un.addEventListener("dragstart", this.Sa);
    const o = e ? e.maxFps : void 0;
    this.Wa = o ? o === -1 ? -1 : o !== 0 ? 1e3 / o : 0 : 0, Object.keys(Ml).forEach(((n) => {
      const a = (l) => {
        this.xa(n, l);
      };
      this.Un.addEventListener(n, a), this.ga.push((() => {
        this.Un.removeEventListener(n, a);
      }));
    })), H.addEventListener("scroll", this.ha, { passive: !0 }), this.Ta = le(new ur({ r: 0, g: 0, b: 0, a: 0 })), this.ks = new Mb(this);
  }
  Xa() {
    const t = Mf();
    return this.ma.add(t), { Za: () => {
      this.ma.delete(t);
    } };
  }
  Ja(t, e, i) {
    this.Qa = t ? { entity: t, timestamp: i, pointed: e } : void 0;
  }
  Ka(t, e) {
    const i = Array.from(this.ba.values()).find(((s) => s.entity === t.entity && (t.collectionMember === void 0 || t.collectionMember === s.collectionMember)));
    i && (i.entity = e.entity, i.collectionMember = e.collectionMember);
  }
  Ci(t, e = void 0) {
    const i = Array.from(this.ba.values()).find(((s) => s.entity === t && (e === void 0 || e === s.collectionMember)));
    i && (t.R("pointerleave", i.lastEvent, i.collectionMember, i.info), this.ba.delete(i.lastEvent.pointerId));
  }
  qa() {
    this.pa = !0, this.fa = void 0, this.Aa = void 0;
  }
  ia() {
    this.ya.length = 0, this.Un.style.cursor = "unset";
  }
  tl() {
    return this.il;
  }
  sl() {
    return this.el;
  }
  setBackgroundFillStyle(t) {
    return this.rl.sr(t), this.Rs(), this;
  }
  getBackgroundFillStyle() {
    return this.rl.kh();
  }
  setBackgroundStrokeStyle(t) {
    return this.rl.ir(t), this.Rs(), this;
  }
  getBackgroundStrokeStyle() {
    return this.rl.hl();
  }
  nl(t) {
    return this.Aa = t, this;
  }
  ol(t) {
    return this.fa = t, this;
  }
  al(t) {
    return this.la.get(t);
  }
  ll() {
    return Array.from(this.la.keys()).reverse().reduce(((t, e) => e !== Number.MAX_SAFE_INTEGER && e > t ? e : t), 0) + 1;
  }
  G() {
    if (!this.ci) {
      if (this.ci = !0, this.la) for (const t of this.la.values()) t.G();
      this.fa = void 0, this.Aa = void 0, H.removeEventListener("scroll", this.ha), this.Un.removeEventListener("fullscreenchange", this.ra), this.Un.removeEventListener("webkitfullscreenchange", this.ra), this.Un.removeEventListener("dragstart", this.Sa), this.Ha && (this.Ha.disconnect(), this.Ha = void 0), this.ga.forEach(((t) => {
        t();
      })), this.ga.length = 0;
    }
  }
  lr(t, e) {
    return j(t - this.ca.x, this.ca.y - e);
  }
  so(t, e) {
    return j(t + this.ca.x, this.ca.y - e);
  }
  ul(t) {
    const e = this.lr(t.clientX, t.clientY);
    return { engineX: e.x, engineY: e.y };
  }
  cl(t) {
    const e = this.so(t.engineX, t.engineY);
    return { clientX: e.x, clientY: e.y };
  }
  dl(t, e, i, s) {
    const o = xt(t, i, this.ai), n = xt(e, i, this.ai), a = this.cl({ engineX: o.x, engineY: o.y }), l = this.cl({ engineX: n.x, engineY: n.y });
    return { p1: { clientX: Math.min(a.clientX, l.clientX) - s.left, clientY: Math.min(a.clientY, l.clientY) - s.top }, p2: { clientX: Math.max(a.clientX, l.clientX) + s.right, clientY: Math.max(a.clientY, l.clientY) + s.bottom } };
  }
  O(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  N(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Cu extends Dm {
  constructor(t, e, i, s) {
    super(t, i, s), this.Zn = 0, this.Js = e, this.Js.fl = !0;
  }
  Al() {
  }
  vl(t) {
    return this.Zn === t || (this.Zn = t, this.Js.fl = !0), this;
  }
  yl() {
    return this.Zn;
  }
}
class Of extends Cu {
  constructor(t, e, i, s, o) {
    super(t, e, s, o), this.pl = !0, this.ai = i;
  }
}
const Ul = (r, t, e) => {
  if (e instanceof we) {
    const i = e.ni(), s = ls(t, { x: Math.abs(i.x), y: Math.abs(i.y) });
    return Ee(j(r.min.x - s.x, r.min.y - s.y), j(r.max.x + s.x, r.max.y + s.y));
  }
  return Ee(e.Qt(j(r.min.x, r.min.y), pe(t, -1)), e.Qt(j(r.max.x, r.max.y), t));
}, ba = (r, t) => typeof t == "function" ? t(r) : t, Ea = (r, t) => !r || r !== t, Tb = (r, t) => r === Lt && t !== Lt, ax = (r) => r !== Lt;
class Ua extends Of {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.Ke = Hi.fillStyle, this.yi = t;
  }
  sr(t) {
    return this.Ke = ba(this.Ke, t), this;
  }
  kh() {
    return this.Ke;
  }
  ml() {
    return Ea(this.Sl, this.Ke);
  }
  bl() {
    return Tb(this.Sl, this.Ke);
  }
  xl() {
    return ax(this.Ke);
  }
  Ml(t) {
    this.Sl = t;
  }
}
class dh extends Ua {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.qe = Hi.lineStyle, this.yi = t;
  }
  ir(t) {
    return this.qe = typeof t == "function" ? t(this.qe) : t, this;
  }
  hl() {
    return this.qe;
  }
  _l() {
    return !this.wl || this.wl !== this.qe;
  }
  kl(t) {
    return !this.wl || this.wl.getThickness() !== t;
  }
  xl() {
    return this.qe !== Et || super.xl();
  }
  bl() {
    return (this.qe !== Et || this.Ke !== Lt) && this.wl === Et && this.Sl === Lt;
  }
  Cl(t) {
    this.wl = t;
  }
}
class Nf extends Ua {
  constructor(t, e, i, s, o, n = le(Hi.font)) {
    super(t, e, i, s, o), this.Tl = le(""), this.Fl = !1, this.Il = { x: 1, y: -1 }, this.Rn = le(j(0, 0)), this.Pl = le(0), this.Ll = le(0), this.Bl = le(j(0, 0)), this.Dl = le(0), this.El = le(Mm), this.Rl = j(0, 0), this.dt = le(To(1, 1, 1, 1)), this.Hn = le(vl(4, 4, 4, 4)), this.font = le(Hi.font), this.Ol = !1, this.font = n;
  }
  xl() {
    return ax(this.Ke) && this.Tl.T().length > 0;
  }
  bl() {
    return this.Ol === !1 && this.xl();
  }
  rn(t) {
    return this.Tl.C(t), this;
  }
  an() {
    return this.Tl.T();
  }
  Ih(t) {
    return sa(t) ? this.El.C(t) : this.El.C(t(this.El.T())), this;
  }
  Fh() {
    return this.El.T();
  }
  zl(t) {
    return this.El.C(this.El.T().setFamily(t)), this;
  }
  Vl() {
    return this.El.T().getFamily();
  }
  Nl(t) {
    return this.El.C(this.El.T().setSize(t)), this;
  }
  Gl() {
    return this.El.T().getSize();
  }
  $l(t) {
    return this.El.C(this.El.T().setWeight(t)), this;
  }
  Ul() {
    return this.El.T().getWeight();
  }
  jl(t) {
    return this.El.C(this.El.T().setStyle(t)), this;
  }
  Yl() {
    return this.El.T().getStyle();
  }
  Hl(t) {
    return this.El.C(this.El.T().setVariant(t)), this;
  }
  Wl() {
    return this.El.T().getVariant();
  }
  hr(t) {
    return this.Rn.C(t), this;
  }
  Xl() {
    return this.Rn.T();
  }
  Ph(t) {
    return this.Dl.C(t), this;
  }
  Lh() {
    return this.Dl.T();
  }
  en(t) {
    return this.Zl = t, this;
  }
  Jl() {
    return this.Zl;
  }
  Ql(t, e) {
    return this.Bl.C(j(t, e)), this;
  }
  Kl() {
    return this.Bl.T();
  }
  ql(t) {
    return this.Ll.C(t), this;
  }
  tu() {
    return this.Ll.T();
  }
  iu() {
    return { x: this.Ll.T(), y: this.Pl.T() };
  }
  su(t) {
    return this.Pl.C(t), this;
  }
  eu() {
    return this.Pl.T();
  }
  ru(t) {
    return this.Ll.C(t.x), this.Pl.C(t.y), this;
  }
  Tn(t) {
    return this.dt.C(t), this;
  }
  hu() {
    return this.dt.T();
  }
  Fn(t) {
    return this.Hn.C(t), this;
  }
  nu() {
    return this.Hn.T();
  }
}
class kb extends dh {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.Rn = le(j(0, 0)), this.j = le(j(100, 100)), this.Dl = le(0), this.Rl = le(j(0, 0)), this.ou = !1;
  }
  Uh() {
    return this.au(), this;
  }
  hr(t) {
    const e = this.Rn.T();
    return t.x === e.x && t.y === e.y || (this.Rn.C(t), this.au()), this;
  }
  Xl() {
    return this.Rn.T();
  }
  lu(t) {
    const e = this.Rn.T();
    return t !== e.x && (this.Rn.C(j(t, e.y)), this.au()), this;
  }
  uu(t) {
    const e = this.Rn.T();
    return t !== e.y && (this.Rn.C(j(e.x, t)), this.au()), this;
  }
  K(t) {
    const e = this.j.T();
    return t.x === e.x && t.y === e.y || (this.j.C(j(t.x, t.y)), this.au()), this;
  }
  Ft() {
    return this.j.T();
  }
  cu(t) {
    const e = this.j.T();
    return t !== e.x && (this.j.C(j(t, e.y)), this.au()), this;
  }
  du(t) {
    const e = this.j.T();
    return t !== e.x && (this.j.C(j(e.x, t)), this.au()), this;
  }
  Ph(t) {
    return this.Dl.C(t), this;
  }
  Lh() {
    return this.Dl.T();
  }
  fu(t) {
    const e = this.Rl.T();
    return t === e && e.x === t.x && e.y === t.y || (t === void 0 ? (this.ou = !1, this.au()) : (this.ou = !0, this.Rl.C(t))), this;
  }
  au() {
    if (!this.ou) {
      const t = this.Rn.T(), e = this.j.T(), i = j(t.x + e.x / 2, t.y + e.y / 2), s = this.Rl.T();
      i.x === s.x && i.y === s.y || this.Rl.C(i);
    }
  }
}
class Db extends dh {
  constructor() {
    super(...arguments), this.Au = [], this.Rn = le(j(0, 0)), this.gu = Ie, this.vu = !1;
  }
  yu(t) {
    return t = Om(t), this.Au = t, this.vu = !0, this;
  }
  pu() {
    return this.Au;
  }
  Wi() {
    return this.gu.max.x;
  }
  Hi() {
    return this.gu.min.x;
  }
  Zi() {
    return this.gu.max.y;
  }
  Xi() {
    return this.gu.min.y;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
}
class Fb extends Ua {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.bu = new Array(), this.xu = new Array(), this.gu = Ie, this.Mu = 0, this._u = !1, this.wu = [Array(), Array()], this.ku = !1, this.Cu = new ot().setColor(N(42, 171, 240)), this.Tu = !1, this.Fu = !1, this.Iu = !1;
  }
  Pu(t, e) {
    const i = this.Mu - 1, s = i > 0 && !this.ku;
    let [o, n] = s ? [[this.bu[i]], [this.xu[i]]] : [[], []];
    if (t instanceof Array) {
      const [a, l] = bm(t);
      o = us(o, a, { canReturnB: !0 }), n = us(n, l, { canReturnB: !0 });
    } else {
      const a = t.position;
      o.push(j(a, t.high)), n.push(j(a, t.low));
    }
    return this.ku ? (this.wu[0] = us(this.wu[0], o, { canReturnB: !0 }), this.wu[1] = us(this.wu[1], n, { canReturnB: !0 })) : (this.wu = [o, n], this.ku = !0), this.gu = Qs(this.gu, e || Qs(Vi(o), Vi(n))), this;
  }
  Vi() {
    return this.Tu = !0, this.bu.length = 0, this.xu.length = 0, this.Mu = 0, this.gu = Ie, this;
  }
  Lu() {
    return [this.bu, this.xu];
  }
  Bu() {
    return [this.wu[0], this.wu[1]];
  }
  Du(t) {
    return this.Cu = typeof t == "function" ? t(this.Cu) : t, this;
  }
  Eu() {
    return this.Cu;
  }
  Ru() {
    return this.Mu - (Number(this.Fu) + Number(this.Iu));
  }
  Ou() {
    return this.wu.length;
  }
  zu(t) {
    return this.Fu = t, this;
  }
  Vu() {
    return this.Fu;
  }
  Nu(t) {
    return this.Iu = t, this;
  }
  Gu() {
    return this.Iu;
  }
  bl() {
    return this.Sl === Lt && this.$u === Lt && (this.Ke !== Lt || this.Cu !== Lt);
  }
  Uu(t) {
    this.$u = t;
  }
  xl() {
    return this.Cu !== Lt || super.xl();
  }
  ml() {
    return super.ml() || !this.$u || this.$u !== this.Cu;
  }
}
class Lb extends dh {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.Rn = le(j(0, 0)), this.ju = le(0), this.Yt = le(360), this.Yu = le(100), this.Hu = le(100), this.Wu = le(0), this.Xu = le(void 0), this.Zu = j(0, 0), this.Ju = j(0, 0), this.Qu = j(0, 0);
  }
  Ku() {
    return this.Yu.T();
  }
  qu() {
    return this.Hu.T();
  }
  Xl() {
    return this.Rn.T();
  }
  tc() {
    return this.ju.T();
  }
  jt() {
    return this.Yt.T();
  }
  sc() {
    return this.Wu.T();
  }
  rc() {
    return this.Xu.T();
  }
  hc() {
    return this.Zu;
  }
  oc() {
    return this.Ju;
  }
  ac() {
    return this.Qu;
  }
  hr(t) {
    return this.Rn.C(t), this;
  }
  lc(t) {
    return this.ju.C(t), this;
  }
  yr(t) {
    return this.Yt.C(t), this;
  }
  uc(t) {
    return this.Hu.C(t), this.Yu.C(t), this;
  }
  cc(t) {
    return this.Yu.C(t), this;
  }
  fc(t) {
    return this.Hu.C(t), this;
  }
  Ac(t) {
    return this.Wu.C(t < 0 ? 0 : t), this;
  }
  gc(t) {
    return this.Xu.C(t !== void 0 && t <= 0 ? void 0 : t), this;
  }
}
var fr;
(function(r) {
  r[r.Complex = 0] = "Complex", r[r.Simple = 1] = "Simple";
})(fr || (fr = {}));
const Pb = (r, t) => typeof t == "function" ? t(r) : t, Rb = (r, t) => !r || r !== t, Ib = (r, t) => !r || r.getThickness() !== t, Vb = (r, t) => r === Et && t !== Et, _b = (r) => r !== Et && r.getFillStyle() !== Lt;
class Ju extends Of {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.vc = Hi.lineStyle, this.engine = t, this.yc = i instanceof Ti;
  }
  gr(t) {
    return this.vc = Pb(this.vc, t), this.yc && Oo(this.vc) && (H.console.error("LightningChart JS error | DashedLine is not supported together with logarithmic axis"), this.vc = Hi.lineStyle), this;
  }
  po() {
    return this.vc;
  }
  _l() {
    return Rb(this.mc, this.vc);
  }
  Sc(t) {
    return Ib(this.mc, t);
  }
  bl() {
    return Vb(this.mc, this.vc);
  }
  xl() {
    return _b(this.vc);
  }
  bc(t) {
    this.mc = t;
  }
}
class Ob extends Ju {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.Wt = j(0, 0), this.Yt = j(0, 0), this.xc = !1;
  }
  C({ min: t, max: e }) {
    return t.x === this.Wt.x && t.y === this.Wt.y && e.x === this.Yt.x && e.y === this.Yt.y || (this.xc = !0, this.Wt = t, this.Yt = e), this;
  }
  Ht() {
    return this.Wt;
  }
  jt() {
    return this.Yt;
  }
  pr(t) {
    return t.x === this.Wt.x && t.y === this.Wt.y || (this.xc = !0, this.Wt = t), this;
  }
  yr(t) {
    return t.x === this.Yt.x && t.y === this.Yt.y || (this.xc = !0, this.Yt = t), this;
  }
}
class Nb extends Ju {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.Mc = void 0, this._c = 0;
  }
}
class Bb extends Ju {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.wc = [], this.gu = Ie, this.wu = new Array(), this.kc = 0, this.Tu = !1, this.Cc = le(void 0), this.Fu = !1, this.Iu = !1;
  }
  Bu() {
    return this.wu;
  }
  Lu() {
    return this.wc;
  }
  Vi() {
    return this.Tu = !0, this.wc.length = 0, this.kc = 0, this.wu = [], this.gu = Ie, this;
  }
  Ru() {
    return this.kc - (Number(this.Fu) + Number(this.Iu));
  }
  Ou() {
    return this.wu.length;
  }
  zu(t) {
    return this.Fu = t, this;
  }
  Vu() {
    return this.Fu;
  }
  Nu(t) {
    return this.Iu = t, this;
  }
  Gu() {
    return this.Iu;
  }
}
class lx extends Nf {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, []), this.Tc = { uid: o, text: "", font: "", color: "", position: "absolute", left: 0, top: 0, padding: "", alignmentX: 0, alignmentY: 0, rotation: 0, identifier: es.Other, visible: !0 };
  }
  Fc() {
    var t;
    if (!this.getVisible() || this.Tl.T().length === 0 || Qn(this.Ke)) return this.Tc.visible = !1, this.Tc;
    this.Tc.visible = !0;
    const e = qu(this.El.T(), devicePixelRatio);
    this.Tc.identifier = (t = this.Kr) !== null && t !== void 0 ? t : es.Other, this.Tc.text = this.Tl.T(), this.Tc.font = e.font, this.Tc.color = de(this.Ke) ? `rgba(${255 * this.Ke.color.r},${255 * this.Ke.color.g},${255 * this.Ke.color.b},${this.Ke.color.a})` : this.Tc.color;
    const i = this.Rn.T(), s = xt(i, this.ai, this.yi.ai), o = Math.round(10 * s.x) / 10, n = Math.round(10 * (this.yi.Ft().y - s.y)) / 10;
    this.Tc.top = n, this.Tc.left = o, this.Tc.alignmentX = this.Ll.T(), this.Tc.alignmentY = this.Pl.T(), this.Tc.rotation = this.Dl.T();
    const a = this.dt.T(), l = this.Hn.T();
    return this.Tc.padding = `${a.top + l.top}px ${a.right + l.right}px ${a.bottom + l.bottom}px ${a.left + l.left}px`, this.Tc;
  }
  Ic() {
    var t;
    this.Fc();
    const e = (t = this.yi.Pc) === null || t === void 0 ? void 0 : t.Lc.getTextBoundingBox;
    if (e) {
      const i = e(this.Tc);
      if (i) {
        const s = this.yi.ul({ clientX: i.left, clientY: i.top }), o = this.yi.ul({ clientX: i.left + i.width, clientY: i.top + i.height }), n = xt({ x: s.engineX, y: s.engineY }, this.yi.ai, this.ai), a = xt({ x: o.engineX, y: o.engineY }, this.yi.ai, this.ai);
        return { min: { x: Math.min(n.x, a.x), y: Math.min(n.y, a.y) }, max: { x: Math.max(n.x, a.x), y: Math.max(n.y, a.y) } };
      }
    }
    return Ie;
  }
  Bc() {
    var t;
    this.Fc();
    const e = (t = this.yi.Pc) === null || t === void 0 ? void 0 : t.Lc.measureText;
    if (e) {
      const i = e(this.Tc);
      if (i) return i;
    }
    return this.yi.Dc.rh.Pr(this.Tl.T(), this.El.T(), this.Dl.T());
  }
  Ft() {
    if (!(this.ai instanceof we)) return { x: 0, y: 0 };
    const t = this.ai.ni(), e = this.Bc();
    return { x: e.x * t.x, y: e.y * t.y };
  }
  Uh() {
    return this;
  }
  Wi() {
    return 0;
  }
  Hi() {
    return 0;
  }
  Zi() {
    return 0;
  }
  Xi() {
    return 0;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
  Ec(t, e) {
    return {};
  }
  Rc() {
    return this;
  }
  Oc(t, e, i, s, o) {
    return {};
  }
}
class Bf extends Ga {
  constructor() {
    super(...arguments), this.Wn = 0;
  }
  getHighlight() {
    return this.Wn;
  }
  setHighlight(t) {
    return this.Wn = t, this.Yn().forEach(((e) => e.Ii(t))), this.D.R("highlightchange", { highlight: t }), this.Js.Rs(), this;
  }
}
class hx extends Bf {
}
class zb extends hx {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, o, n), this.zc = this.Js.Vc(this.renderingScale, fr.Simple).setVisible(!1).sr(Lt).ir(Et), this.D.zi(this.zc);
  }
  Nc() {
    const t = this.Gc();
    if (t.length > 2) {
      const e = Vi(t), i = j(e.max.x - e.min.x, e.max.y - e.min.y);
      this.setContentSize(i);
      const s = t.map(((o) => {
        const n = qt(o, pe(e.min, -1));
        return this.scale.Qt(this.Rn, qt(n, ls(pe(qt(this.origin, j(1, 1)), -0.5), i)));
      })).map(((o) => xt(o, this.scale, this.renderingScale)));
      this.zc.yu(s).setVisible(this.getVisible()).setVisible(this.getVisible());
    } else this.zc && this.zc.setVisible(!1), this.setContentSize(j(0, 0));
  }
  rr() {
    return super.rr(), this.ci || (this.Nc(), this.Zn !== void 0 && this.zc.vl(this.Zn)), this;
  }
  Uh() {
    return this.Nc(), super.Uh();
  }
  setVisible(t) {
    return super.setVisible(t), this.zc.setVisible(t), this;
  }
}
const cg = (r) => !(!r || typeof r != "object" || !("elementAt" in r)), vr = (r) => {
  if ("srcLoopArray" in r) {
    const { srcLoopArray: t, dataRanges: e, NewArray: i } = r;
    return { length: e.reduce(((s, o) => s + o.count), 0), elementAt: (s) => {
      let o = 0;
      for (const n of e) {
        if (o + n.count - 1 >= s) {
          const a = n.offset + (s - o);
          return t[a];
        }
        o += n.count;
      }
      return Js(0, (() => {
      })), -1;
    }, toArray: (s, o) => {
      const n = o - s + 1;
      if (e.length === 1) {
        const a = e[0], l = a.offset + s, h = a.offset + o;
        return t.subarray(l, h + 1);
      }
      {
        const a = e[0], l = e[1], h = 0, u = h + a.count - 1, c = u + 1, d = c + l.count - 1, f = new i(n);
        let p = 0;
        if (!(o < h || s > u)) {
          const g = Math.max(h, s), y = Math.min(u, o) - g + 1, m = a.offset + (s + p - h);
          f.set(t.subarray(m, m + y), p), p += y;
        }
        if (!(o < c || s > d)) {
          const g = Math.max(c, s), y = Math.min(d, o) - g + 1, m = l.offset + (s + p - c);
          f.set(t.subarray(m, m + y), p), p += y;
        }
        return f;
      }
    } };
  }
  return { length: r.length, elementAt: (t) => r[t], toArray: (t, e) => Lm(r, t, e + 1) };
}, qo = H.SharedArrayBuffer !== void 0, Al = (r) => !!(r && qo && r instanceof H.SharedArrayBuffer), dg = (r, t) => Object.keys(r).length === Object.keys(t).length && !Object.keys(r).find(((e) => t[e] === void 0)) && !Object.entries(r).find((([e, i]) => t[e] !== i));
class cr {
  constructor(t) {
    if (this.$c = 0, this.Uc = 0, this.jc = 0, this.Yc = !1, this.Hc = !0, this.Wc = !1, this.Xc = { warningDisplayed: !1, expandEvents: [] }, this.Zc = !1, this.D = new Nt(), this.Ga = t, this.Hc = !t || t.autoSortingEnabled === void 0 || t.autoSortingEnabled, this.Jc = t?.allowInputModification !== !1, this.Qc = t?.includesNaN === void 0 || t.includesNaN, this.Kc = t?.strictMode !== void 0 && t.strictMode, this.$a = t?.warnings === void 0 || t.warnings, this.qc = t?.autoDetectPatterns === void 0 || t.autoDetectPatterns, t?.schema) {
      const e = {};
      Object.entries(t.schema).forEach((([i, s]) => {
        var o;
        if (!s) return;
        let n = s.pattern !== void 0 ? s.pattern : void 0;
        s.auto && (n = (typeof s.auto == "object" && (o = s.auto.step) !== null && o !== void 0 ? o : 1) > 0 ? "progressive" : "regressive");
        const a = { dataStorage: s.storage, td: { effective: n, userSpecified: n }, auto: s.auto, cache: void 0, ensureNoDuplication: s.ensureNoDuplication !== void 0 && s.ensureNoDuplication, nonNumeric: s.nonNumeric };
        if (a.nonNumeric && (a.dataStorage = Array), this.Kc && s.pattern === void 0) throw new Error(`LightningChart JS error - DataSetXY property ('${i}') data pattern not specified. This is not allowed when strict mode is enabled.`);
        e[i] = a;
      })), this.sd = e;
    }
    if (this.Kc && !this.sd) throw new Error("LightningChart JS error - DataSetXY schema not defined. This is not allowed when strict mode is enabled.");
    if (t?.useSharedArrayBuffers && !qo && H.console.error(`LightningChart JS error - Attempting to use DataSetXY shared array buffers mode, but SharedArrayBuffers are not available in JS runtime
Please read https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer for information how to enable SharedArrayBuffers`), t?.useSharedArrayBuffers) {
      const e = new SharedArrayBuffer(4), i = new Int32Array(e);
      this.ed = { sab: e, view: i };
    }
  }
  appendJSON(t, e, i) {
    if (!Array.isArray(t)) return this.appendJSON([t]);
    const s = t.length;
    if (s === 0) return this;
    const o = Object.keys(t[0]).filter(((l) => (!e?.whitelist || e.whitelist.includes(l)) && (!e?.blacklist || !e.blacklist.includes(l))));
    if (o.length === 0) return this;
    const n = t[0], a = Object.fromEntries(o.map(((l) => {
      if (typeof n[l] != "number") return [l, []];
      const h = this.sd && this.sd[l];
      return [l, h ? this.rd(h, s) : new Float64Array(s)];
    })));
    for (let l = 0; l < s; l += 1) {
      const h = t[l];
      for (const u of o) a[u][l] = h[u];
    }
    return i && Object.entries(i).forEach((([l, h]) => {
      a[l] = h;
    })), this.appendSamples(a, e), this;
  }
  appendSample(t, e) {
    const i = Object.keys(t).filter(((n) => (!e?.whitelist || e.whitelist.includes(n)) && (!e?.blacklist || !e.blacklist.includes(n)))), s = Object.fromEntries(i.map(((n) => {
      var a, l, h;
      return [n, ol(t[n], this.sd && (l = (a = this.sd[n]) === null || a === void 0 ? void 0 : a.dataStorage) !== null && l !== void 0 ? l : Float64Array, !(!this.sd || ((h = this.sd[n]) === null || h === void 0 ? void 0 : h.nonNumeric) !== !0))];
    }))), o = this.hd({ appendCount: 1, keys: i, parsedDataArrs: s, opts: e });
    if (!o.incomingDataReplacedCache && this.Hc) {
      let n = this.nd(s);
      if (n = n && n.filter(((a) => this.sd && this.sd[a].td && !("autoDetectResult" in this.sd[a].td))), n && n.length > 0 && !this.Wc) {
        n.length > 1 && this.$a && H.console.warn("LightningChart JS warning - DataSetXY data pushed in order that doesn't match data pattern. Automatic sorting is attempted, but there is more than 1 data pattern mismatch. Behavior may be compromised.");
        for (const a of n) {
          const l = this.sd ? this.sd[a] : void 0;
          if (!(l && l.td && "autoDetectResult" in l.td)) return this.od(a, { parsedDataArrs: Object.fromEntries(o.keys.map(((h) => [h, typeof s[h] == "number" ? new Array(1).fill(s[h]) : s[h]]))), offset: 0, count: 1 }), this;
        }
        H.console.error(`LightningChart JS error - data is arriving in wrong order and auto sorting is either disabled or not applicable. Chart functionality is compromised. Following data properties didn't match their configured pattern: ${n.map(((a) => `'${a}'`)).join(", ")}`);
      }
    }
    this.ad(1);
    for (const n of o.keys) {
      const a = o.buckets[n].cache;
      if (!a) continue;
      const l = s[n];
      a[this.$c] = al(l) ? l[0] : l;
    }
    return this.D.R("change", { type: "change", iDataStart: this.$c, iDataEnd: this.$c }), this.$c += 1, this.$c > o.maxSampleCount - 1 && this.ld !== void 0 && (this.$c = 0, this.Yc = !0, this.D.R("loop", { type: "loop" })), this.Uc = Math.min(this.Uc + 1, o.maxSampleCount), this.jc += 1, this;
  }
  appendSamples(t, e) {
    const i = Object.entries(t).filter((([, d]) => d !== void 0)).map(((d) => d[0])), s = Object.entries(t).filter((([, d]) => typeof d == "object" && "length" in d)).map(((d) => d[0]));
    let o = s.reduce(((d, f) => Math.min(d, t[f].length)), Number.MAX_SAFE_INTEGER);
    o === Number.MAX_SAFE_INTEGER && (o = 0), s.forEach(((d) => {
      const f = t[d];
      f.length > o && (H.console.warn(`LightningChart JS warning - insymmetric DataSetXY input (${d}). Extra measurements will be dropped`), Array.isArray(f) ? this.Jc ? f.length = o : t[d] = f.slice(0, o) : t[d] = f.subarray(0, o));
    }));
    let n = e?.offset, a = e?.count;
    n = n !== void 0 ? n : 0, a = a !== void 0 ? a : o - n;
    const l = Object.fromEntries(i.map(((d) => {
      var f, p, g;
      const y = t[d];
      return this.sd && this.sd[d] && this.sd[d].dataStorage !== void 0 || this.Kc || !Xs(y) ? [d, ol(t[d], this.sd && (p = (f = this.sd[d]) === null || f === void 0 ? void 0 : f.dataStorage) !== null && p !== void 0 ? p : Float64Array, !(!this.sd || ((g = this.sd[d]) === null || g === void 0 ? void 0 : g.nonNumeric) !== !0))] : [d, y];
    }))), h = this.hd({ appendCount: a, keys: i, parsedDataArrs: l, opts: e });
    if (Object.entries(h.buckets).forEach((([d, f]) => {
      if (this.Uc === 0 && f.ensureNoDuplication) {
        const p = l[d], g = f.cache;
        if (Array.isArray(p) || g !== p && (!Xs(g) || !Xs(p) || g.buffer === p.buffer)) throw new Error(`LightningChart JS error | DataSetXY ensureNoDuplication check failed for '${d}'`);
      }
    })), !h.incomingDataReplacedCache && this.Hc) {
      let d = this.nd(l);
      if (d = d && d.filter(((f) => this.sd && this.sd[f].td && !("autoDetectResult" in this.sd[f].td))), d && d.length > 0 && !this.Wc) {
        d.length > 1 && this.$a && H.console.warn("LightningChart JS warning - DataSetXY data pushed in order that doesn't match data pattern. Automatic sorting is attempted, but there is more than 1 data pattern mismatch. Behavior may be compromised.");
        for (const f of d) {
          const p = this.sd ? this.sd[f] : void 0;
          if (!(p && p.td && "autoDetectResult" in p.td)) return this.od(f, { parsedDataArrs: Object.fromEntries(i.map(((g) => [g, typeof l[g] == "number" ? new Array(a).fill(l[g]) : l[g]]))), offset: n, count: a }), this;
        }
        H.console.error(`LightningChart JS error - data is arriving in wrong order and auto sorting is either disabled or not applicable. Chart functionality is compromised. Following data properties didn't match their configured pattern: ${d.map(((f) => `'${f}'`)).join(", ")}`);
      }
    }
    const u = h.maxSampleCount - this.$c, c = Math.min(a, u);
    if (this.ad(c), c > 0) {
      if (!h.incomingDataReplacedCache) for (const d of h.keys) {
        const f = h.buckets[d].cache, p = l[d];
        Jr(f, p, n, c, this.$c);
      }
      this.D.R("change", { type: "change", iDataStart: this.$c, iDataEnd: this.$c + c - 1 }), this.$c += c, this.$c > h.maxSampleCount - 1 && (this.$c = 0, this.Yc = !0, this.D.R("loop", { type: "loop" }));
    }
    if (this.Uc = Math.min(this.Uc + c, h.maxSampleCount), this.jc += c, a - c > 0 && !h.incomingDataReplacedCache) {
      const d = {};
      for (const f of h.keys) {
        const p = l[f];
        d[f] = al(p) ? Lm(p, n + c, void 0) : p;
      }
      this.appendSamples(d, e);
    } else this.ud();
    return this;
  }
  fill(t) {
    return this.sd ? (Object.keys(t).forEach(((e) => {
      this.sd && !this.sd[e] && this.$a && H.console.warn(`LightningChart JS warning - DataSetXY.fill() tried to fill data property that doesn't exist in schema ("${e}")`);
    })), Object.entries(this.sd).forEach((([e, i]) => {
      let s = t[e];
      i.cache && s !== void 0 && (ko(s) && (s = s.toUint32()), Array.isArray(i.cache) ? i.cache.fill(String(s)) : typeof s == "number" && i.cache.fill(s));
    })), this.D.R("clear", { type: "clear" }), this) : this;
  }
  setSamples(t, e) {
    return this.clear().appendSamples(t, e);
  }
  alterSamplesStartingFrom(t, e, i) {
    var s, o, n;
    const a = Object.values(e).find(((b) => typeof b != "number"));
    let l = i?.offset, h = i?.count;
    const u = a ? a.length : 1;
    if (l = l !== void 0 ? l : 0, h = h !== void 0 ? h : u - l, h <= 0) return this;
    const c = Object.keys(e), d = Object.fromEntries(c.map(((b) => {
      var w, k, R;
      return [b, ol(e[b], this.sd && (k = (w = this.sd[b]) === null || w === void 0 ? void 0 : w.dataStorage) !== null && k !== void 0 ? k : Float64Array, !(!this.sd || ((R = this.sd[b]) === null || R === void 0 ? void 0 : R.nonNumeric) !== !0))];
    }))), f = this.jc - 1, p = this.ld !== void 0 ? Math.max(this.jc - this.ld, 0) : 0, g = t + h - 1, y = Math.max(t, p), m = Math.min(g, f), A = m - y + 1;
    if (this.jc > 0 && A > 0) {
      const b = this.hd({ appendCount: 0, keys: c, parsedDataArrs: d, opts: i }), w = (n = (o = (s = Object.values(b.buckets).find(((k) => k.cache))) === null || s === void 0 ? void 0 : s.cache) === null || o === void 0 ? void 0 : o.length) !== null && n !== void 0 ? n : 0;
      if (this.ld !== void 0 && this.Yc && this.jc % this.ld != 0) {
        const k = this.jc - this.jc % this.ld, R = this.jc - 1, L = this.jc - this.Uc, x = k - 1, M = Math.max(y, L), C = Math.min(m, x) - M + 1;
        if (C > 0) {
          const T = M - t, I = ri(M, this.jc, w, this.$c);
          for (const F of b.keys) {
            const D = b.buckets[F].cache, P = d[F];
            Jr(D, P, l + T, C, I);
          }
        }
        const S = Math.max(y, k), E = Math.min(m, R) - S + 1;
        if (E > 0) {
          const T = S - t, I = ri(S, this.jc, w, this.$c);
          for (const F of b.keys) {
            const D = b.buckets[F].cache, P = d[F];
            Jr(D, P, l + T, E, I);
          }
        }
      } else {
        const k = y - p;
        for (const R of b.keys) {
          const L = b.buckets[R].cache, x = d[R];
          Jr(L, x, l, A, k);
        }
      }
      this.D.R("clear", { type: "clear" });
    }
    const v = t + h - 1 - f;
    if (v > 0) {
      const b = m + 1 - t;
      this.appendSamples(e, { offset: l + b, count: v });
    }
    return this;
  }
  alterSamplesByIndex(t, e) {
    var i;
    if (!this.sd) return this;
    const s = t.length, o = Object.keys(e), n = Object.fromEntries(o.map(((c) => {
      var d, f, p;
      return [c, ol(e[c], this.sd && (f = (d = this.sd[c]) === null || d === void 0 ? void 0 : d.dataStorage) !== null && f !== void 0 ? f : Float64Array, !(!this.sd || ((p = this.sd[c]) === null || p === void 0 ? void 0 : p.nonNumeric) !== !0))];
    }))), a = this.jc - 1, l = this.ld !== void 0 ? Math.max(this.jc - this.ld, 0) : 0;
    if (s <= 0) return this;
    let h = !1;
    const u = Object.values(this.sd).find(((c) => c.cache)).cache.length;
    for (let c = 0; c < s; c += 1) {
      const d = t[c];
      if (d < l || d > a) continue;
      const f = ri(d, this.jc, u, this.$c);
      for (const p of o) {
        const g = (i = this.sd[p]) === null || i === void 0 ? void 0 : i.cache, y = n[p];
        g && (g[f] = al(y) ? y[c] : y, h = !0);
      }
    }
    return h && this.D.R("clear", { type: "clear" }), this;
  }
  alterSamplesByMatch(t, e, i) {
    var s;
    if (!this.sd) return this;
    const o = e.length, n = this.Uc, a = this.jc - 1, l = Math.max(a - n + 1, 0), h = Object.keys(i), u = Object.fromEntries(h.map(((g) => {
      var y, m, A;
      return [g, ol(i[g], this.sd && (m = (y = this.sd[g]) === null || y === void 0 ? void 0 : y.dataStorage) !== null && m !== void 0 ? m : Float64Array, !(!this.sd || ((A = this.sd[g]) === null || A === void 0 ? void 0 : A.nonNumeric) !== !0))];
    })));
    if (o <= 0) return this;
    let c = !1;
    const d = this.sd[t].cache, f = this.dd(t);
    if (!d) return this;
    const p = d.length;
    for (let g = 0; g < o; g += 1) {
      const y = e[g];
      let m;
      if (f) {
        const A = ln(y, l, a, !0, ((v) => d[ri(v, this.jc, p, this.$c)]));
        m = ri(A, this.jc, p, this.$c);
      } else for (let A = 0; A < p; A += 1) if (d[A] === y) {
        m = A;
        break;
      }
      if (m !== void 0) {
        if (d[m] === y) for (const A of h) {
          const v = (s = this.sd[A]) === null || s === void 0 ? void 0 : s.cache, b = u[A];
          v && (v[m] = al(b) ? b[g] : b, c = !0);
        }
      } else this.$a && H.console.warn(`LightningChart JS warning - DataSetXY.alterSamplesByMatch no match found for "${t}=${y}"`);
    }
    return c && this.D.R("clear", { type: "clear" }), this;
  }
  ud(t = !1) {
    this.sd && this.qc && Object.entries(this.sd).forEach((([e, i]) => {
      if (!i.cache || i.nonNumeric) return;
      const s = i.cache;
      let o;
      if (i.td && "userSpecified" in i.td) o = i.td.userSpecified;
      else if (i.td && "autoDetectResult" in i.td) o = i.td.autoDetectResult;
      else if (s && this.jc > 0 && !t) {
        const n = this.ld !== void 0 && this.Yc ? this.$c : 0, a = this.Uc - 1, l = this.ld !== void 0 && this.Yc ? 0 : void 0, h = this.ld !== void 0 && this.Yc ? this.$c - 1 : void 0, [u, c] = l !== void 0 && h !== void 0 && Math.abs(h - l) > Math.abs(a - n) ? [l, h] : [n, a];
        if (1 + c - u >= 5) {
          let d, f = s[u];
          for (let p = u + 1; p <= c; p += 1) if (d !== !1) {
            const g = s[p], y = Math.sign(g - f);
            y !== 0 && d && d.direction !== y ? d = !1 : y === 0 || d || (d = { direction: y }), f = g;
          }
          o = d && d.direction > 0 ? "progressive" : d && d.direction < 0 ? "regressive" : null, i.td = { autoDetectResult: o, effective: o }, this.$a && H.console.warn(`LightningChart JS DataSetXY warning | Data pattern was detected automatically (${e}=${o}).
Automatic detection is only intended for kick-starting application development, not for production use.
Define data patterns in schema when creating series or DataSetXY to clear this warning and improve performance.`);
        }
      }
    }));
  }
  rd(t, e) {
    var i, s, o;
    if (!(!((i = this.Ga) === null || i === void 0) && i.useSharedArrayBuffers) || !qo) return new ((s = t.dataStorage) !== null && s !== void 0 ? s : Float64Array)(e);
    const n = (o = t.dataStorage) !== null && o !== void 0 ? o : Float64Array, a = n.BYTES_PER_ELEMENT, l = e * a;
    if (t.fd && t.fd.byteLength === l) return new n(t.fd);
    const h = new H.SharedArrayBuffer(e * a), u = new n(h);
    return t.Ad !== t.fd && (this.Zc = !0, t.Ad = t.fd), t.fd !== h && (this.Zc = !0, t.fd = h), u;
  }
  gd() {
    var t, e, i, s, o, n;
    if (!this.Zc || !(!((t = this.Ga) === null || t === void 0) && t.useSharedArrayBuffers) || !qo) return;
    const a = typeof ((e = this.Ga) === null || e === void 0 ? void 0 : e.useSharedArrayBuffers) == "object" && this.Ga.useSharedArrayBuffers.onNewBuffers, l = typeof ((i = this.Ga) === null || i === void 0 ? void 0 : i.useSharedArrayBuffers) == "object" && this.Ga.useSharedArrayBuffers.onRemovedBuffers, h = Object.fromEntries(Object.entries((s = this.sd) !== null && s !== void 0 ? s : {}).filter(((c) => c[1].fd)).map((([c, d]) => [c, d.fd]))), u = Object.fromEntries(Object.entries((o = this.sd) !== null && o !== void 0 ? o : {}).filter(((c) => c[1].Ad)).map((([c, d]) => [c, d.Ad])));
    l && l(u), a && a(h), Object.values((n = this.sd) !== null && n !== void 0 ? n : {}).forEach(((c) => {
      c.Ad = void 0;
    })), this.Zc = !1;
  }
  hd(t) {
    var e, i, s, o, n, a, l, h, u;
    if (this.sd || (this.sd = Object.fromEntries(t.keys.map(((f) => [f, { dataStorage: ou(t.parsedDataArrs[f]), td: void 0 }])))), this.Uc === 0 && this.sd && !this.Kc) {
      const f = this.sd;
      t.keys.forEach(((p) => {
        f[p] || (f[p] = { dataStorage: ou(t.parsedDataArrs[p]) });
      }));
    }
    if ((this.Uc > 0 || this.Kc) && this.sd) {
      const f = this.sd, p = t.keys.filter(((g) => !f[g]));
      if (p.length > 0 && t.appendCount > 0) {
        if (this.Kc) throw new Error(`LightningChart JS error - Input data includes data properties that are not defined in schema. This is not allowed when strict mode is enabled. Extra data properties: ${p.map(((g) => `'${g}'`)).join(", ")}`);
        this.$a && H.console.warn(`LightningChart JS warning - Input data includes data properties that are not defined in schema. This is OK for data sets that don't yet have data pushed in, but this was not the case. Extra data properties were dropped: ${p.map(((g) => `'${g}'`)).join(", ")}`);
      }
      p.forEach(((g) => {
        delete t.parsedDataArrs[g];
      })), t.keys = Object.keys(t.parsedDataArrs);
    }
    if (Object.entries(this.sd).forEach((([f, p]) => {
      p.dataStorage || (p.dataStorage = ou(t.parsedDataArrs[f]));
    })), this.Uc === 0 && Object.keys(this.sd).length === 1 && !this.Kc) {
      const f = ((i = (e = t.opts) === null || e === void 0 ? void 0 : e.step) !== null && i !== void 0 ? i : 1) > 0 ? "progressive" : "regressive";
      this.sd._auto = { dataStorage: Float64Array, auto: { start: (o = (s = t.opts) === null || s === void 0 ? void 0 : s.start) !== null && o !== void 0 ? o : 0, step: (a = (n = t.opts) === null || n === void 0 ? void 0 : n.step) !== null && a !== void 0 ? a : 1 }, td: { userSpecified: f, effective: f } };
    }
    Object.entries(this.sd).forEach((([f, p]) => {
      var g, y, m, A, v, b, w, k;
      if (!p.auto) return;
      const R = (m = (y = (g = t.opts) === null || g === void 0 ? void 0 : g.step) !== null && y !== void 0 ? y : typeof p.auto == "object" ? p.auto.step : void 0) !== null && m !== void 0 ? m : 1;
      let L;
      if (this.Uc === 0) L = (b = (v = (A = t.opts) === null || A === void 0 ? void 0 : A.start) !== null && v !== void 0 ? v : typeof p.auto == "object" ? p.auto.start : void 0) !== null && b !== void 0 ? b : 0;
      else if (((w = t.opts) === null || w === void 0 ? void 0 : w.start) !== void 0) L = t.opts.start;
      else {
        const M = this.vd();
        if (!M) return;
        L = M[f] + R;
      }
      const x = new ((k = p.dataStorage) !== null && k !== void 0 ? k : Float64Array)(t.appendCount);
      for (let M = 0; M < t.appendCount; M += 1) x[M] = L + M * R;
      t.parsedDataArrs[f] = x;
    })), t.keys = Object.keys(t.parsedDataArrs);
    const c = Object.keys(this.sd).filter(((f) => !t.keys.includes(f)));
    if (c.length > 0 && t.appendCount > 0) {
      if (this.Kc) throw new Error(`LightningChart JS error - Input data is missing keys that were defined in schema. This is not allowed when strict mode is enabled. Missing keys: ${c.map(((f) => `'${f}'`)).join(", ")}`);
      this.$a && H.console.warn(`LightningChart JS warning - Input data is missing keys that were defined in schema. They will be filled with \`0\`. Missing keys: ${c.map(((f) => `'${f}'`)).join(", ")}`);
    }
    for (const f of c) t.parsedDataArrs[f] = new ((l = this.sd[f].dataStorage) !== null && l !== void 0 ? l : Float64Array)(t.appendCount).fill(0);
    if (t.keys = Object.keys(t.parsedDataArrs), this.Uc === 0 && (this.ld === void 0 || this.ld === t.appendCount) && this.Jc && (((h = t.opts) === null || h === void 0 ? void 0 : h.offset) === 0 || ((u = t.opts) === null || u === void 0 ? void 0 : u.offset) === void 0)) return Object.entries(this.sd).forEach((([f, p]) => {
      var g, y, m, A, v;
      if (typeof t.parsedDataArrs[f] == "number") !((g = this.Ga) === null || g === void 0) && g.useSharedArrayBuffers && qo ? (p.cache = this.rd(p, t.appendCount), p.cache.fill(t.parsedDataArrs[f])) : p.cache = new ((y = p.dataStorage) !== null && y !== void 0 ? y : Float64Array)(t.appendCount).fill(t.parsedDataArrs[f]);
      else if (!((m = this.Ga) === null || m === void 0) && m.useSharedArrayBuffers && qo) {
        const b = t.parsedDataArrs[f];
        if (Xs(b)) {
          const w = b.buffer;
          if (Al(w)) return p.cache = pg(b, (A = p.dataStorage) !== null && A !== void 0 ? A : Float64Array, p.nonNumeric), p.fd = w, void (this.Zc = !0);
        }
        p.cache = this.rd(p, t.appendCount), p.cache.set(b);
      } else p.cache = pg(t.parsedDataArrs[f], (v = p.dataStorage) !== null && v !== void 0 ? v : Float64Array, p.nonNumeric);
    })), this.ud(), this.gd(), { maxSampleCount: t.appendCount, buckets: this.sd, incomingDataReplacedCache: !0, keys: t.keys };
    if (this.ld === void 0) {
      const f = this.Uc + t.appendCount;
      if (Object.values(this.sd).some(((g) => !g.cache))) return Object.values(this.sd).forEach(((g) => {
        g.cache = this.rd(g, f);
      })), this.ud(), { maxSampleCount: f, buckets: this.sd, keys: t.keys };
      const p = Object.values(this.sd)[0].cache.length;
      if (p < f) {
        if (!this.Xc.warningDisplayed) {
          const g = H.performance.now();
          if (this.Xc.expandEvents = this.Xc.expandEvents.filter(((y) => g - y.timestamp < 5e3)), f > 1e3 && this.Xc.expandEvents.push({ timestamp: g }), this.Xc.expandEvents.length > 5) return this.$a && H.console.warn(`LightningChart JS warning - DataSetXY append operation was performed more than 5 times in 5 seconds.
Automatic max sample count control was enabled.
For streaming applications, DataSetXY.setMaxSampleCount() or Series.setMaxSampleCount() should be configured explicitly to get rid of this warning.`), this.Xc.warningDisplayed = !0, this.setMaxSampleCount({ mode: "auto" }), this.hd(t);
        }
        return Object.values(this.sd).forEach(((g) => {
          const y = this.rd(g, f);
          Jr(y, g.cache, 0, g.cache.length, 0), g.cache = y;
        })), this.$c = this.Uc, this.ud(), this.gd(), { maxSampleCount: f, buckets: this.sd, keys: t.keys };
      }
      return p > 4 * f ? (Object.values(this.sd).forEach(((g) => {
        const y = this.rd(g, f);
        Jr(y, g.cache, 0, this.Uc, 0), g.cache = y;
      })), this.ud(), this.gd(), { maxSampleCount: f, buckets: this.sd, keys: t.keys }) : (this.ud(), { maxSampleCount: f, buckets: this.sd, keys: t.keys });
    }
    t.appendCount + this.Uc > this.ld && this.D.R("maxsamplecountexceed", { type: "maxsamplecountexceed", currentSampleCount: this.Uc, currentMaxSampleCount: this.ld, newTotalSampleCount: this.Uc + t.appendCount });
    const d = this.ld;
    return Object.values(this.sd).forEach(((f) => {
      f.cache = f.cache || this.rd(f, d);
    })), this.ud(), this.gd(), { maxSampleCount: d, buckets: this.sd, keys: t.keys };
  }
  getSampleCount() {
    return this.Uc;
  }
  getNextSampleIndex() {
    return this.jc;
  }
  dd(t) {
    const e = this.sd && this.sd[t];
    if (e) return e.td && "userSpecified" in e.td ? e.td.userSpecified : e.td && "autoDetectResult" in e.td ? e.td.autoDetectResult : void 0;
  }
  yd(t) {
    if (!this.sd) return;
    const e = t?.x, i = t?.y, s = e !== void 0 ? this.sd[e] : void 0, o = i !== void 0 ? this.sd[i] : void 0;
    if (s && s.td && "userSpecified" in s.td) {
      if (s.td.userSpecified === "progressive") return "ProgressiveX";
      if (s.td.userSpecified === "regressive") return "RegressiveX";
    }
    if (o && o.td && "userSpecified" in o.td) {
      if (o.td.userSpecified === "progressive") return "ProgressiveY";
      if (o.td.userSpecified === "regressive") return "RegressiveY";
    }
    if (s && s.td && "autoDetectResult" in s.td && s.td.autoDetectResult) {
      if (s.td.autoDetectResult === "progressive") return "ProgressiveX";
      if (s.td.autoDetectResult === "regressive") return "RegressiveX";
    }
    if (o && o.td && "autoDetectResult" in o.td && o.td.autoDetectResult) {
      if (o.td.autoDetectResult === "progressive") return "ProgressiveY";
      if (o.td.autoDetectResult === "regressive") return "RegressiveY";
    }
  }
  pd(t) {
    if (!t || !this.sd) return { dataPattern: void 0, md: Float64Array, Sd: Float64Array };
    const e = { dataPattern: this.yd(t) };
    for (const i of Object.keys(t)) {
      const s = i, o = t[s];
      if (o === void 0) continue;
      const n = this.sd[o];
      if (!n || !n.cache || n.nonNumeric) continue;
      const a = n.cache, l = n.dataStorage;
      s === "x" && (e.bd = a, e.md = l), s === "y" && (e.xd = a, e.Sd = l), s === "color" && (e.Md = a), s === "rotation" && (e._d = a), s === "size" && (e.wd = a), s === "lookupValue" && (e.kd = a);
    }
    return e;
  }
  setMaxSampleCount(t) {
    if (typeof t == "object") {
      this.Cd && this.removeEventListener("maxsamplecountexceed", this.Cd);
      const e = t.max, i = t.initial;
      this.Cd = (s) => {
        if (e !== void 0 && s.currentMaxSampleCount >= e) return;
        let o = Math.max(2 * s.currentMaxSampleCount, s.newTotalSampleCount);
        e !== void 0 && (o = Math.min(o, e)), this.setMaxSampleCount(o);
      }, this.addEventListener("maxsamplecountexceed", this.Cd), this.ld === void 0 && (i !== void 0 ? this.setMaxSampleCount(i) : this.setMaxSampleCount(Math.min(2 * this.Uc, e !== void 0 ? e : Number.MAX_SAFE_INTEGER)));
    } else if (typeof t == "number") {
      const e = t;
      if (this.ld !== void 0 && this.ld > e) throw new Error("LightningChart JS | DataSetXY.setMaxSampleCount attempted to shrink data set. This is currently not supported.");
      if (!this.sd || !Object.values(this.sd).find(((i) => i.cache))) return this.ld = e, this;
      if (e === this.ld) return this;
      if (this.Yc && this.$c !== 0 && this.$c !== this.getSampleCount()) throw new Error("LightningChart JS | DataSetXY.setMaxSampleCount attempted to expand data set that has exceeded its max sample count. This is currently not supported.");
      this.ld = e, this.Uc < e ? (this.$c = this.Uc, this.Yc = !1) : (this.$c = 0, this.Yc = !0), Object.values(this.sd).forEach(((i) => {
        const s = this.rd(i, e);
        Jr(s, i.cache, 0, i.cache.length, 0), i.cache = s;
      })), this.gd();
    }
    return this;
  }
  getMaxSampleCount() {
    return this.ld;
  }
  clear() {
    return this.$c = 0, this.Uc = 0, this.jc = 0, this.Yc = !1, this.D.R("clear", { type: "clear" }), this;
  }
  readBack(t) {
    var e;
    if (!this.sd) return { data: {}, iSampleFirst: 0 };
    const i = (e = Object.values(this.sd).find(((h) => h.cache))) === null || e === void 0 ? void 0 : e.cache;
    if (!i) return { data: {}, iSampleFirst: 0 };
    const s = i.length;
    let o, n = [];
    if (t?.onlyInRange) {
      const h = this.sd[t.onlyInRange.key], u = this.dd(t.onlyInRange.key), c = h.cache;
      if (!u) throw new Error("LightningChart JS - attempted to use `DataSetXY.readBack` with `onlyInRange` without a data pattern.\nThis operation is only supported for progressive data");
      if (!c) return { data: {}, iSampleFirst: 0 };
      const d = Math.min(t.onlyInRange.start, t.onlyInRange.end), f = Math.max(t.onlyInRange.start, t.onlyInRange.end), p = zf(d, f, c, this.jc, this.Uc, this.$c, u, 0);
      if (!p) return { data: {}, iSampleFirst: 0 };
      n = p.dataRanges, o = p.iFirstSample;
    } else if (this.ld !== void 0 && this.Yc && this.jc % this.ld != 0) {
      const h = this.$c, u = s - h, c = this.$c - 1;
      n.push({ offset: h, count: u }), n.push({ offset: 0, count: c + 1 }), o = this.jc - s;
    } else n.push({ offset: 0, count: this.Uc }), o = 0;
    const a = n.reduce(((h, u) => h + u.count), 0);
    return { data: Object.fromEntries(Object.entries(this.sd).filter((([, h]) => h.cache)).map((([h, u]) => {
      var c;
      const d = u.cache;
      let f;
      if (n.length === 1 && n[0].count === d.length) f = d;
      else {
        f = new ((c = u.dataStorage) !== null && c !== void 0 ? c : Float64Array)(a);
        let p = 0;
        for (const g of n) Jr(f, u.cache, g.offset, g.count, p), p += g.count;
      }
      return [h, f];
    }))), iSampleFirst: o };
  }
  Td(t, e) {
    var i, s;
    const o = this.readBack(e);
    return { xValues: (i = o.data[t.x]) !== null && i !== void 0 ? i : new Float64Array(), yValues: (s = o.data[t.y]) !== null && s !== void 0 ? s : new Float64Array(), lookupValues: t.lookupValue ? o.data[t.lookupValue] : void 0, colors: t.color ? o.data[t.color] : void 0, sizes: t.size ? o.data[t.size] : void 0, rotations: t.rotation ? o.data[t.rotation] : void 0, iSampleFirst: o.iSampleFirst };
  }
  Fd(t) {
  }
  Id() {
    return { min: 0, max: this.ld !== void 0 && this.Yc ? this.ld - 1 : this.Uc - 1 };
  }
  Pd(t) {
    t = Math.min(t, this.Uc), this.jc -= t, this.Uc -= t, this.$c -= t, this.$c < 0 && this.ld !== void 0 && (this.$c += this.ld);
  }
  od(t, e) {
    const i = this.sd;
    if (!i) return;
    const s = this.dd(t), o = s === "progressive", n = i[t].cache, a = e.parsedDataArrs[t], l = Object.keys(e.parsedDataArrs);
    if (!s || !n || !a) return;
    const h = e.count, u = a[0];
    if (this.nd(Object.fromEntries(l.map(((c) => {
      const d = e.parsedDataArrs[c];
      return [c, al(d) ? d[e.offset + e.count - 1] : d];
    }))))) {
      const c = n.length, d = this.Uc, f = this.jc - 1, p = Math.max(f - d + 1, 0), g = ln(u, p, f, o, ((x) => n[ri(x, this.jc, c, this.$c)])), y = g - 1, m = g + 1, A = n[ri(g, this.jc, c, this.$c)], v = m <= this.jc - 1 ? n[ri(m, this.jc, c, this.$c)] : void 0, b = v !== void 0 && (o && v < u || !o && v > u) ? m + 1 : o && A < u || !o && A > u ? g + 1 : y + 1, w = f - b + 1, k = Object.fromEntries(l.map(((x) => {
        var M;
        return [x, new ((M = i[x].dataStorage) !== null && M !== void 0 ? M : Float64Array)(w)];
      })));
      let R = 0;
      for (let x = b; x <= f; x += 1) {
        const M = ri(x, this.jc, c, this.$c);
        for (const C of l) k[C][R] = i[C].cache[M];
        R += 1;
      }
      this.Pd(w);
      const L = Object.fromEntries(l.map(((x) => {
        var M;
        const C = new ((M = i[x].dataStorage) !== null && M !== void 0 ? M : Float64Array)(h + w);
        return Jr(C, e.parsedDataArrs[x], 0, e.count, 0), Jr(C, k[x], 0, k[x].length, h), [x, C];
      })));
      this.Wc = !0, this.appendSamples(L), this.Wc = !1, this.D.R("clear", { type: "clear" });
    } else {
      const c = this.vd(), d = c ? c[t] : 0;
      let f = 0;
      for (let p = 0; p < h; p += 1) if (a[p] > d) {
        f = p;
        break;
      }
      this.Wc = !0, this.appendSamples(e.parsedDataArrs, { offset: f }), this.Wc = !1;
    }
  }
  nd(t) {
    const e = this.vd();
    if (!e || !this.sd) return;
    const i = Object.keys(t), s = [];
    for (const o of i) {
      const n = this.dd(o);
      if (!n) continue;
      const a = e[o], l = t[o], h = typeof l == "number" ? l : l[0];
      (n === "progressive" && h < a || n === "regressive" && h > a) && s.push(o);
    }
    return s.length > 0 ? s : void 0;
  }
  Ld(t) {
    const e = this.pd(t);
    if (!e.bd || !e.xd || this.Uc === 0) return;
    if (this.ld === void 0) return this.jc > 0 ? { x: e.bd[0], y: e.xd[0] } : void 0;
    if (!this.Yc) return { x: e.bd[0], y: e.xd[0] };
    let i = this.$c - this.Uc;
    return i < 0 && (i += this.ld), { x: e.bd[i], y: e.xd[i] };
  }
  Bd(t) {
    const e = this.pd(t);
    if (!e.bd || !e.xd || this.Uc === 0) return;
    if (this.ld === void 0) {
      const s = this.Uc - 1;
      return s >= 0 ? { x: e.bd[s], y: e.xd[s] } : void 0;
    }
    let i = this.$c - 1;
    return i < 0 && (i += this.ld), { x: e.bd[i], y: e.xd[i] };
  }
  Dd() {
    if (!this.sd || this.Uc === 0) return;
    let t;
    if (this.ld === void 0) {
      if (this.jc > 0) return;
      t = 0;
    } else this.Yc ? (t = this.$c - this.Uc, t < 0 && (t += this.ld)) : t = 0;
    return Object.fromEntries(Object.entries(this.sd).map((([e, i]) => [e, i.cache[t]])));
  }
  vd() {
    if (!this.sd || this.Uc === 0) return;
    let t;
    return this.ld === void 0 ? t = this.Uc - 1 : (t = this.$c - 1, t < 0 && (t += this.ld)), Object.fromEntries(Object.entries(this.sd).map((([e, i]) => [e, i.cache[t]])));
  }
  Ed(t, e) {
    const i = this.pd(t);
    if (!(this.sd && this.Uc !== 0 && i && i.bd && i.xd)) return;
    const s = i.bd.length, o = this.Uc, n = this.jc - 1, a = Math.max(n - o + 1, 0) + e, l = ri(a, this.jc, s, this.$c);
    return { x: i.bd[l], y: i.xd[l], lookupValue: i.kd ? i.kd[l] : void 0, color: i.Md ? i.Md[l] : void 0, size: i.wd ? i.wd[l] : void 0, rotation: i._d ? i._d[l] : void 0, iSample: a, sample: Object.fromEntries(Object.entries(this.sd).map((([h, u]) => [h, u.cache ? u.cache[l] : void 0]))) };
  }
  ad(t) {
    if (this.ed && t > 0) {
      const e = this.jc + t;
      Atomics.store(this.ed.view, 0, e);
    }
  }
  Rd(t, e, i, s, o) {
    if (!t) return;
    const n = this.sd, a = this.pd(t), l = a.dataPattern, h = a.bd, u = a.xd;
    if (!h || !u || !n) return;
    const c = (b, w) => ({ x: h[b], y: u[b], lookupValue: a.kd ? a.kd[b] : void 0, color: a.Md ? a.Md[b] : void 0, size: a.wd ? a.wd[b] : void 0, rotation: a._d ? a._d[b] : void 0, iSample: w, sample: Object.fromEntries(Object.entries(n).map((([k, R]) => [k, R.cache ? R.cache[b] : void 0]))) }), d = h.length, f = this.Uc, p = this.jc - 1, g = Math.max(p - f + 1, 0);
    if (l) {
      const b = Wn(l), w = this.Ld(t), k = this.Bd(t);
      if (!(w && k && a.bd && a.xd)) return;
      const R = l === "ProgressiveX" || l === "RegressiveX" ? "x" : "y", L = R === "x" ? "y" : "x", x = R === "x" ? a.bd : a.xd, M = L === "x" ? a.bd : a.xd, C = e[R], S = Math.min(w[R], k[R]), E = Math.max(w[R], k[R]);
      if (C < S || C > E) return;
      const T = ln(C, g, p, b, ((Y) => x[ri(Y, this.jc, d, this.$c)])), I = ri(T, this.jc, d, this.$c);
      if (!i) return c(I, T);
      const F = T - 1, D = T + 1, P = x[I], V = b ? C >= P ? D <= p ? D : void 0 : F >= g ? F : void 0 : C <= P ? D <= p ? D : void 0 : F >= g ? F : void 0;
      if (V === void 0) return;
      const _ = ri(V, this.jc, d, this.$c), O = T < V ? { pos: x[I], val: M[I], iSample: T } : { pos: x[_], val: M[_], iSample: V }, B = T > V ? { pos: x[I], val: M[I], iSample: T } : { pos: x[_], val: M[_], iSample: V }, z = (C - O.pos) / (B.pos - O.pos), W = tr(O.val, B.val, z), G = Object.fromEntries(Object.entries(n).map((([Y, U]) => [Y, U.cache ? U.cache[I] : void 0])));
      return js(l) === "x" ? { x: C, y: W, iSample: tr(O.iSample, B.iSample, z), sample: G } : { y: C, x: W, iSample: tr(O.iSample, B.iSample, z), sample: G };
    }
    let y, m = Number.MAX_VALUE;
    const A = xt(e, s, o), v = this.Uc - 1;
    for (let b = 0; b <= v; b += 1) {
      const w = h[b], k = u[b];
      if (!this.Qc || !Number.isNaN(w) && !Number.isNaN(k)) {
        const R = Nl(w, s.x, o.x), L = Nl(k, s.y, o.y), x = (R - A.x) ** 2 + (L - A.y) ** 2;
        x < m && (m = x, y = b);
      }
    }
    return y === void 0 ? void 0 : c(y, y);
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const fg = /* @__PURE__ */ new WeakMap(), gg = (r) => {
  let t = fg.get(r);
  return t || (t = Mf(), fg.set(r, t)), t;
}, ri = (r, t, e, i) => r % e, zf = (r, t, e, i, s, o, n, a) => {
  if (i === 0 || s === 0) return;
  const l = n === "progressive", h = e.length, u = i - 1, c = Math.max(u - s + 1, 0), d = cg(e) ? ln(r, c, u, l, ((b) => e.elementAt(ri(b, i, h)))) : ln(r, c, u, l, ((b) => e[ri(b, i, h)])), f = cg(e) ? ln(t, c, u, l, ((b) => e.elementAt(ri(b, i, h)))) : ln(t, c, u, l, ((b) => e[ri(b, i, h)])), p = Math.min(d, f), g = Math.max(d, f);
  if (p === g && (p === 0 || p === u)) return;
  const y = Math.max(p - a, c), m = Math.min(g + a, u), A = ri(y, i, h), v = ri(m, i, h);
  return A > v ? { iFirstSample: y, iLastSample: m, iFirstSampleDataArray: A, iLastSampleDataArray: v, dataRanges: [{ offset: A, count: h - A }, { offset: 0, count: v + 1 }] } : { iFirstSample: y, iLastSample: m, iFirstSampleDataArray: A, iLastSampleDataArray: v, dataRanges: [{ offset: A, count: v - A + 1 }] };
}, ln = (r, t, e, i, s) => {
  const o = e;
  for (; t !== e; ) {
    const a = Math.ceil((t + e) / 2), l = s(a);
    i && r < l || !i && r > l ? e = a - 1 : t = a;
  }
  const n = Math.abs(r - s(t));
  return t < o && Math.abs(r - s(t + 1)) < n ? t + 1 : t;
}, Jr = (r, t, e, i, s) => {
  if (Xs(t) || Array.isArray(t)) {
    const o = t.length;
    if (Array.isArray(t)) for (let n = 0; n < i; n += 1) r[s + n] = t[e + n];
    else if (Array.isArray(r)) for (let n = 0; n < i; n += 1) r[s + n] = t[e + n];
    else r.set(o === i ? t : t.subarray(e, e + i), s);
  } else r.fill(t, s, s + i);
}, pg = (r, t, e) => e ? r : r === void 0 ? void 0 : Array.isArray(r) ? new t(r) : r instanceof t ? r : new t(r), Wb = /^(\d{4}-\d{2}-\d{2})(?:T(\d{2}:\d{2}:\d{2}(?:\.\d+)?)(Z|[+-]\d{2}:\d{2})?)?$/, yg = (r) => typeof r == "string" && Wb.test(r) && !H.isNaN(Date.parse(r)), ol = (r, t, e) => {
  if (typeof r == "number") return r;
  if (ko(r)) return r.toUint32();
  if (r instanceof Date) return r.getTime();
  if (e) return r;
  if (typeof r == "string") {
    if (yg(r)) return new Date(r).getTime();
    throw new Error(`LightningChart JS error - XY coordinate supplied as unrecognized String format. Coordinates must be Numbers, Date objects or ISO 8601 Date strings.
If you want to load string values to be displayed in cursors etc. see https://lightningchart.com/js-charts/docs/features/xy/line/#string-data-types`);
  }
  const i = r.length, s = r[0] && r[0] instanceof Date, o = r[0] && yg(r[0]), n = r[0] && ko(r[0]);
  if (!o && r[0] && typeof r[0] == "string") throw new Error(`LightningChart JS error - XY coordinate supplied as unrecognized String format. Coordinates must be Numbers, Date objects or ISO 8601 Date strings
If you want to load string values to be displayed in cursors etc. see https://lightningchart.com/js-charts/docs/features/xy/line/#string-data-types`);
  if (o) {
    const a = new t(i);
    for (let l = 0; l < i; l += 1) a[l] = new Date(r[l]).getTime();
    return a;
  }
  if (s) {
    const a = new t(i);
    for (let l = 0; l < i; l += 1) a[l] = r[l].getTime();
    return a;
  }
  if (n) {
    const a = r.length, l = new Uint32Array(a);
    for (let h = 0; h < a; h += 1) {
      const u = r[h], c = 255 * u.a << 24 | 255 * u.b << 16 | 255 * u.g << 8 | 255 * u.r;
      l[h] = c;
    }
    return l;
  }
  return r;
}, ou = (r) => {
  if (r && Array.isArray(r)) return Float64Array;
  const t = typeof r == "object" ? Object.getPrototypeOf(r).constructor : void 0;
  return t ?? Float64Array;
}, Xs = (r) => !!r && !Array.isArray(r) && (r instanceof Float64Array || r instanceof Float32Array || r instanceof Uint32Array || r instanceof Int32Array || r instanceof Uint16Array || r instanceof Int16Array || r instanceof Int8Array || r instanceof Uint8Array || r instanceof Uint8ClampedArray), al = (r) => {
  const t = typeof r;
  return t !== "number" && t !== "string" && (Array.isArray(r) || Xs(r));
};
class Sd extends Bf {
  constructor(t, e, i, s, o) {
    var n;
    super(t, e, i, s, o), this.Tl = "label", this.zc = this.Js.In(this.renderingScale).rn(this.Tl).sr(Lt).Tn(Me).Fn(Me), this.setMargin((n = o.uiTextPadding) !== null && n !== void 0 ? n : 5), this.D.zi(this.zc);
  }
  Yn() {
    return [this.zc];
  }
  setFillStyle(t) {
    return this.zc.sr(t), this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.zc.kh();
  }
  rr() {
    this.Zn !== void 0 && this.zc.vl(this.Zn);
    const t = this.getPosition(j(0, 0), be.Content), e = xt(t, this.scale, this.renderingScale);
    return this.zc.hr(e), this.zc.Kr = this.Kr, this;
  }
  Uh() {
    this.zc.Uh();
    const t = this.Tl.length === 0 ? j(0, 0) : this.zc.Bc();
    return this.setContentSize(t), super.Uh();
  }
  setText(t) {
    return this.Tl = t, this.zc.rn(this.Tl), this.Js.Rs(), this;
  }
  getText() {
    return this.Tl;
  }
  setFont(t) {
    return this.zc.Ih(t), this.Js.Rs(), this;
  }
  getFont() {
    return this.zc.Fh();
  }
  setTextRotation(t) {
    return this.zc.Ph(t), this.Js.Rs(), this;
  }
  getTextRotation() {
    return this.zc.Lh();
  }
}
const Qu = { ...mn, ..._f, uiElement: Sd };
class xn extends hx {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.fitTo = this.Jn.bind(this), this.setSize = this.fitTo, this.zc = this.Js.Od(e).sr(Lt).ir(Et), this.zd = this.zc.Qo(), this.D.zi(this.zc);
  }
  Yn() {
    return [this.zc];
  }
  setCornerRadius(t, e) {
    var i, s, o, n;
    return this.Vd = t, this.zd.Nd(t ? { extent: t, c_x1_y1: (i = e?.bottomLeft) === null || i === void 0 || i, c_x1_y2: (s = e?.topLeft) === null || s === void 0 || s, c_x2_y1: (o = e?.bottomRight) === null || o === void 0 || o, c_x2_y2: (n = e?.topRight) === null || n === void 0 || n, skipTooSmallCheck: !!e } : void 0), this.Js.Rs(), this;
  }
  getCornerRadius() {
    return this.Vd;
  }
  setFillStyle(t) {
    return this.zc.sr(t), this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.zc.kh();
  }
  setStrokeStyle(t) {
    return this.zc.ir(t), this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.zc.hl();
  }
  rr() {
    this.Zn !== void 0 && this.zc.vl(this.Zn);
    const t = Vi([this.getPosition(j(-1, -1), be.Content), this.getPosition(j(1, 1), be.Content)].map(((e) => xt(e, this.scale, this.renderingScale))));
    return this.zd.Gd(t.min.x, t.min.y, t.max.x, t.max.y), this;
  }
  Jn(t) {
    return this.setContentSize(t), this.Js.Rs(), this;
  }
  Qn() {
    return 0;
  }
  Kn() {
    return 0;
  }
  io() {
    return 0;
  }
  qn() {
    return 0;
  }
}
class Gb extends zb {
  constructor(t, e, i, s, o) {
    super(t, e, i, fr.Simple, s, o), this.Hd = le(j(0, 0)), this.Wd = le(10), this.Xd = le(void 0), this.ao = le(ae.Right), this.Nc();
  }
  Yn() {
    return [this.zc];
  }
  setFillStyle(t) {
    return this.zc.sr(t), this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.zc.kh();
  }
  setStrokeStyle(t) {
    return this.zc.ir(t), this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.zc.hl();
  }
  setDirection(t) {
    return this.ao.C(t), this.Js.Rs(), this;
  }
  getDirection() {
    return this.ao.T();
  }
  setPointerLength(t) {
    return this.Wd.C(t), this.Js.Rs(), this;
  }
  getPointerLength() {
    return this.Wd.T();
  }
  setPointerAngle(t) {
    return this.Xd.C(t), this.Js.Rs(), this;
  }
  getPointerAngle() {
    let t = this.Xd.T();
    if (t === void 0) {
      const e = this.Zd();
      if (e === 0) return 0;
      t = e !== 0 ? 180 * Math.atan(2 * this.getPointerLength() / e) / Math.PI : 0;
    }
    return Math.min(Math.max(t, 1), 89);
  }
  Jn(t) {
    return this.Hd.C(t), this.Js.Rs(), this;
  }
  Jd() {
    const t = this.getPointerAngle();
    return t === 0 ? 0 : 2 * this.getPointerLength() / Math.tan(t * Math.PI / 180);
  }
  Qd() {
    return X0(this.ao.T()) ? this.Hd.T().x : this.Hd.T().y;
  }
  Zd() {
    return X0(this.ao.T()) ? this.Hd.T().y : this.Hd.T().x;
  }
  Qn() {
    switch (this.ao.T()) {
      case ae.Right:
        return 0;
      case ae.Left:
        return this.getPointerLength();
      case ae.Up:
      case ae.Down:
        return Math.max(0, this.Jd() - this.Zd());
      default:
        return 0;
    }
  }
  Kn() {
    switch (this.ao.T()) {
      case ae.Right:
        return this.getPointerLength();
      case ae.Left:
        return 0;
      case ae.Up:
      case ae.Down:
        return Math.max(0, this.Jd() - this.Zd());
      default:
        return 0;
    }
  }
  io() {
    switch (this.ao.T()) {
      case ae.Right:
      case ae.Left:
        return Math.max(0, this.Jd() - this.Zd());
      case ae.Up:
        return this.getPointerLength();
      case ae.Down:
      default:
        return 0;
    }
  }
  qn() {
    switch (this.ao.T()) {
      case ae.Right:
      case ae.Left:
        return Math.max(0, this.Jd() - this.Zd());
      case ae.Up:
        return 0;
      case ae.Down:
        return this.getPointerLength();
      default:
        return 0;
    }
  }
  Gc() {
    const t = Rm(this.ao.T()), e = $u(j(0, 0), t), i = this.getPointerLength(), s = this.Jd(), o = this.Qd(), n = this.Zd();
    if (!(i !== 0 && s !== 0 || o !== 0 && n !== 0)) return [];
    const a = j(0, 0), l = qt(qt(a, pe(t, -i)), pe(e, s / 2)), h = qt(l, pe(e, (n - s) / 2)), u = qt(h, pe(t, -o)), c = qt(qt(a, pe(t, -i)), pe(e, -s / 2)), d = qt(c, pe(e, -(n - s) / 2)), f = qt(d, pe(t, -o));
    let p;
    return p = o === 0 || n === 0 ? [a, l, c] : i === 0 || s === 0 ? [h, u, f, d] : Pi(n, s) ? [a, l, u, f, c] : [a, l, h, u, f, d, c], p;
  }
}
class Ha extends Bf {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.fitTo = this.Jn.bind(this), this.setSize = this.fitTo, this.Kd = new cr(), this.zc = this.Js.ef(e).gr(Et).sf(Lt).tf(Lt).qd(this.Kd, { x: "x", y: "y" }), this.D.zi(this.zc);
  }
  Yn() {
    return [this.zc];
  }
  setShape(t) {
    return this.zc.rf(t), this;
  }
  getShape() {
    return this.zc.hf();
  }
  setRotation(t) {
    return this.zc.nf(t), this;
  }
  getRotation() {
    return this.zc.af();
  }
  setFillStyle(t) {
    return this.zc.tf(t), this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.zc.lf();
  }
  setStrokeStyle(t) {
    return this.zc.uf(t), this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.zc.cf();
  }
  rr() {
    this.Zn !== void 0 && this.zc.vl(this.Zn);
    const t = xt(this.getPosition({ x: 0, y: 0 }, be.Content), this.scale, this.renderingScale), e = Math.max(this.size.x, this.size.y);
    if (this.Kd.clear(), e > 0) {
      const i = this.zc.hf(), s = this.zc.lf(), o = Pn(i) && i, n = cn(s) && s;
      if (o) {
        const a = e / o.Ft().y;
        this.zc.df(a);
      } else if (n) {
        const a = n.source;
        if (a instanceof Image) {
          const l = e / a.height;
          this.zc.df(l);
        }
      } else this.zc.df(e);
      this.Kd.appendSample(t);
    }
    return this;
  }
  Jn(t) {
    return this.setContentSize(t), this.Js.Rs(), this;
  }
  Qn() {
    return 0;
  }
  Kn() {
    return 0;
  }
  io() {
    return 0;
  }
  qn() {
    return 0;
  }
}
const Ub = { ...mn, ..._f, uiElement: Ha };
class Ma extends ox {
  setSize(t) {
    return this.setContentSize(t), this.Js.Rs(), this;
  }
}
class ux extends vb {
  constructor() {
    super(...arguments), this.ff = [], this.Af = 0, this.gf = (t) => {
      const e = this.ff.indexOf(t);
      e >= 0 && this.ff.splice(e, 1);
    };
  }
  getMembers() {
    return this.ff;
  }
  getMemberCount() {
    return this.ff.length;
  }
  setMinimumSize(t) {
    return this.vf = t, this.Js.Rs(), this;
  }
  getMinimumSize() {
    return this.vf;
  }
  addElement(t, e = -1) {
    const i = t.Ao(this.Js, this.renderingScale, this.scale, this.gf, this.xi, !1);
    return i.setPointerEvents(this.getPointerEvents()), e >= 0 ? this.ff.splice(e, 0, i) : this.ff.push(i), i.setVisible(this.getVisible()), this.D.Gi(i), this.ci && (Js(0, (() => {
    })), i.dispose()), i;
  }
  dispose() {
    return super.dispose(), this.ff.slice().forEach(Eo), this;
  }
  rr() {
    super.rr(), this.ff.forEach(((e) => {
      e.Kr = this.Kr;
    }));
    const t = this.Zn;
    return t !== void 0 && this.ff.forEach(((e, i) => {
      e.Zn = t + 1 + 0.01 * i;
    })), this;
  }
  setVisible(t) {
    return super.setVisible(t), this.ff.forEach(((e) => e.setVisible(t))), this;
  }
  setPointerEvents(t) {
    super.setPointerEvents(t);
    for (let e = 0; e < this.ff.length; e += 1) this.ff[e].setPointerEvents(t);
    return this;
  }
  getPointerEvents() {
    if (super.getPointerEvents()) return !0;
    for (let t = 0; t < this.ff.length; t += 1) if (this.ff[t].getPointerEvents()) return !0;
    return !1;
  }
  setHighlight(t) {
    super.setHighlight(t);
    for (let e = 0; e < this.ff.length; e += 1) {
      const i = this.ff[e];
      Fm(i) && i.setHighlight(t);
    }
    return this;
  }
}
class Ca extends ux {
  rr() {
    super.rr();
    const t = this.getPosition(j(-1, 1), be.Content), e = this.ff.reduce(((s, o) => s + +(o instanceof Ma)), 0), i = e > 0 ? (this.size.x - this.Af) / e : 0;
    return this.ff.reduce(((s, o) => o instanceof Ma ? this.scale.Qt({ x: s, y: t.y }, { x: i + o.getSize().x, y: 0 }).x : o.setOrigin(j(-1, 1)).setPosition(j(s, t.y)).rr().getPosition(j(1, 0)).x), t.x), this;
  }
  Uh() {
    for (let i = 0; i < this.ff.length; i += 1) {
      const s = this.ff[i];
      s instanceof Hl && s.setMinimumSize(0), s.Uh();
    }
    const t = this.ff.reduce(this.yf.bind(this), Kn(0, 0));
    this.Af = t.x;
    const e = this.vf === void 0 ? t : j(Math.max(t.x, this.vf), t.y);
    this.setContentSize(e);
    for (let i = 0; i < this.ff.length; i += 1) {
      const s = this.ff[i];
      s instanceof Hl && s.setMinimumSize(e.y).Uh();
    }
    return super.Uh();
  }
  yf(t, e) {
    const i = e.getSize();
    return t.x += i.x, t.y = Math.max(t.y, i.y), t;
  }
  addGap(t = 0, e = -1) {
    return this.addElement(cx, e).setSize(j(0, t));
  }
}
class Hl extends ux {
  rr() {
    super.rr();
    const t = this.getPosition(j(-1, 1), be.Content), e = this.ff.reduce(((s, o) => s + +(o instanceof Ma)), 0), i = e > 0 ? (this.size.y - this.Af) / e : 0;
    return this.ff.reduce(((s, o) => o instanceof Ma ? this.scale.Qt({ x: t.x, y: s }, { x: 0, y: -(i + o.getSize().y) }).y : o.setOrigin(j(-1, 1)).setPosition(j(t.x, s)).rr().getPosition(j(0, -1)).y), t.y), this;
  }
  Uh() {
    for (let i = 0; i < this.ff.length; i += 1) {
      const s = this.ff[i];
      s instanceof Ca && s.setMinimumSize(0), s.Uh();
    }
    const t = this.ff.reduce(this.yf.bind(this), Kn(0, 0));
    this.Af = t.y;
    const e = this.vf === void 0 ? t : j(t.x, Math.max(t.y, this.vf));
    this.setContentSize(e);
    for (let i = 0; i < this.ff.length; i += 1) {
      const s = this.ff[i];
      s instanceof Ca && s.setMinimumSize(e.x).Uh();
    }
    return super.Uh();
  }
  yf(t, e) {
    const i = e.getSize();
    return t.y += i.y, t.x = Math.max(t.x, i.x), t;
  }
  addGap(t = 0, e = -1) {
    return this.addElement(cx, e).setSize(j(0, t));
  }
}
const cx = { ...mn, ..._f, uiElement: Ma };
class Hb extends Hl {
  constructor() {
    super(...arguments), this.ff = [];
  }
  addRow() {
    return this.addElement(Yb, void 0);
  }
  getRow(t, e = !1) {
    return e && this.ff.length <= t ? (this.addRow(), this.getRow(t, !0)) : this.ff[t];
  }
}
const dx = { ...mn, ...ch, ...bb }, mg = { ...dx, uiElement: Hl, background: xn }, Yb = { ...dx, uiElement: Ca, background: xn }, Wf = { setTextLabel: null, setText(r) {
  return this.setTextLabel.setText(r), this;
}, getText() {
  return this.setTextLabel.getText();
} }, tc = ((r) => {
  const t = {}, e = `stylable${r}s`;
  return t[e] = [], t[`set${r}FillStyle`] = function(i) {
    return this[e].forEach(((s) => s.setFillStyle(i))), this;
  }, t[`get${r}FillStyle`] = function() {
    return this[e][0].getFillStyle();
  }, t[`set${r}Font`] = function(i) {
    return this[e].forEach(((s) => s.setFont(i))), this;
  }, t[`get${r}Font`] = function() {
    return this[e][0].getFont();
  }, t[`set${r}Rotation`] = function(i) {
    return this[e].forEach(((s) => s.setTextRotation(i))), this;
  }, t[`get${r}Rotation`] = function() {
    return this[e][0].getTextRotation();
  }, t;
})("Text"), jb = { button: void 0, isLocked: !1, setOn(r) {
  const t = this.button.getOn() !== r;
  return this.button.setOn(r), t && this.D.R("switch", { state: r }), this;
}, getOn() {
  return this.button.getOn();
}, setLocked(r) {
  return this.isLocked = r, this;
}, getLocked() {
  return this.isLocked;
}, setButtonOffFillStyle(r) {
  return this.button.setOffFillStyle(r), this;
}, getButtonOffFillStyle() {
  return this.button.getOffFillStyle();
}, setButtonOnFillStyle(r) {
  return this.button.setOnFillStyle(r), this;
}, getButtonOnFillStyle() {
  return this.button.getOnFillStyle();
}, setButtonStrokeStyle(r) {
  return this.button.setStrokeStyle(r), this;
}, getButtonStrokeStyle() {
  return this.button.getStrokeStyle();
}, setButtonSize(r) {
  return this.button.setSize(r), this;
}, getButtonSize() {
  return this.button.getSize();
}, setButtonShape(r) {
  return this.button.setButtonShape(r), this;
}, getButtonShape() {
  return this.button.getButtonShape();
} }, $b = { textFillStyleHidden: void 0, setTextFillStyleHidden(r) {
  return this.textFillStyleHidden = typeof r == "function" ? r(this.textFillStyleHidden) : r, this;
}, getTextFillStyleHidden() {
  return this.textFillStyleHidden;
} }, Xb = { pointable: void 0, setDirection(r) {
  return this.pointable.setDirection(r), this;
}, getDirection() {
  return this.pointable.getDirection();
}, setPointerLength(r) {
  return this.pointable.setPointerLength(r), this;
}, getPointerLength() {
  return this.pointable.getPointerLength();
} }, Gf = { ...mn, ...ch, background: xn, Ao(r, t, e, i, s, o) {
  const n = new Ca(r, t, e, this.background, i, s), a = n.addElement(Qu, void 0), l = Object.assign(n, Wf, { setTextLabel: a }, tc, { stylableTexts: [a] });
  return ro(l, s, o), this.applyStylers(l, s);
} }.addStyler(Ku), Zb = { ...mn, ...ch, background: Gb, direction: ae.Up, setDirection(r) {
  return this.direction = r, this;
}, Ao(r, t, e, i, s, o) {
  const n = this.direction, a = new Ca(r, t, e, this.background, i, s), l = a.addElement(Qu, void 0), h = a.getBackground().setDirection(n), u = a.rr.bind(a), c = Object.assign(a, Wf, { setTextLabel: l }, tc, { stylableTexts: [l] }, Xb, { pointable: h }, { setTickLabelPadding(d) {
    return this.getDirection() === ae.Up ? (this.setPadding({ top: d }), l.setMargin({ top: 0 })) : this.getDirection() === ae.Down ? (this.setPadding({ bottom: d }), l.setMargin({ bottom: 0 })) : this.getDirection() === ae.Right ? (this.setPadding({ right: d }), l.setMargin({ right: 0 })) : this.getDirection() === ae.Left && (this.setPadding({ left: d }), l.setMargin({ left: 0 })), this;
  }, getTickLabelPadding() {
    return this.getDirection() === ae.Up ? this.getPadding().top : this.getDirection() === ae.Down ? this.getPadding().bottom : this.getDirection() === ae.Right ? this.getPadding().right : this.getPadding().left;
  }, setTickLabelAlignment(d, f) {
    return this;
  }, getTickLabelAlignment: () => 0, Kr: void 0, rr() {
    l.Kr = this.Kr, u();
  } });
  return c.vo = "other", c.setPointerLength(s.xAxisNumericTicks.majorTickStyle.getTickLength()).setTickLabelPadding(s.xAxisNumericTicks.majorTickStyle.getTickPadding()).setTextFont(s.uiTextFont).setTextFillStyle(s.uiTextFillStyle).setBackground(((d) => d.setFillStyle(s.uiBackgroundFillStyle).setStrokeStyle(s.uiBackgroundStrokeStyle))), ro(c, s, o), this.applyStylers(c, s);
} };
class Kb extends Ga {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, o, n), this.pf = !1, this.mf = Lt, this.Sf = Lt, this.getOn = () => this.pf, this.Sf = n.uiButtonFillStyleHidden || n.uiButtonFillStyle, this.bf = new Ha(this.Js, this.renderingScale, this.scale, ie, n).setShape(s).setFillStyle(this.Sf), this.D.Gi(this.bf);
  }
  Yn() {
    return [...this.bf.Yn()];
  }
  setOn(t) {
    return this.pf = t, this.bf.setFillStyle(t ? this.mf : this.Sf), this.Js.Rs(), this;
  }
  setOffFillStyle(t) {
    return this.Sf = typeof t == "function" ? t(this.Sf) : t, this.pf || this.bf.setFillStyle(this.Sf), this;
  }
  getOffFillStyle() {
    return this.Sf;
  }
  setSize(t) {
    return this.bf.fitTo(typeof t == "number" ? j(t, t) : t), this;
  }
  getSize() {
    return this.bf.getSize();
  }
  setOnFillStyle(t) {
    return this.mf = typeof t == "function" ? t(this.mf) : t, this.pf && this.bf.setFillStyle(this.mf), this;
  }
  getOnFillStyle() {
    return this.mf;
  }
  setStrokeStyle(t) {
    return this.bf.setStrokeStyle(t), this;
  }
  getStrokeStyle() {
    return this.bf.getStrokeStyle();
  }
  setButtonShape(t) {
    return this.bf.setShape(t), this.Js.Rs(), this;
  }
  getButtonShape() {
    return this.bf.getShape();
  }
  rr() {
    return super.rr(), this.bf.Zn = this.Zn, this.bf.setVisible(this.getVisible()).setPosition(this.getPosition(j(0, 0), be.Content)).rr(), this;
  }
  Uh() {
    const t = this.bf.Uh().getSize();
    return this.setContentSize(t), super.Uh();
  }
  dispose() {
    return super.dispose(), this.bf.dispose(), this;
  }
  setPointerEvents(t) {
    return this.bf.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.bf.getPointerEvents();
  }
  setHighlight(t) {
    const e = dn(t);
    return this.bf.setHighlight(e), this.D.R("highlightchange", { highlight: e }), this.Js.Rs(), this;
  }
  getHighlight() {
    return this.bf.getHighlight();
  }
}
const qb = { ...mn, uiElement: Kb, buttonShape: Je.Circle, setButtonShape(r) {
  return { ...this, buttonShape: r };
}, Ao(r, t, e, i, s, o) {
  const n = this.applyStylers(new this.uiElement(r, t, e, this.buttonShape, i, s), s);
  return ro(n, s, o), n;
} }, fx = { ...mn, ...ch, background: xn, buttonBuilder: qb, setButtonShape(r) {
  return { ...this, buttonBuilder: this.buttonBuilder.setButtonShape(r) };
}, Ao(r, t, e, i, s, o) {
  var n;
  const a = new Ca(r, t, e, this.background, i, s), l = a.addElement(mg);
  l.addGap();
  const h = l.addElement(this.buttonBuilder);
  l.addGap();
  const u = a.addElement(mg);
  u.addGap();
  const c = u.addElement(Qu);
  u.addGap(), a.addGap();
  const d = Object.assign(a, Wf, { setTextLabel: c }, tc, { stylableTexts: [c] }, jb, { button: h }, $b);
  let f;
  return d.addEventListener("click", (() => {
    d.getLocked() || d.setOn(!d.getOn());
  })), d.addEventListener("pointerenter", (() => {
    d.setHighlight(!0);
  })), d.addEventListener("pointerleave", (() => {
    d.setHighlight(!1);
  })), d.setMouseStyle(Gt.Point), d.setTextFillStyleHidden(s.uiTextFillStyleHidden || s.uiTextFillStyle), d.addEventListener("switch", ((p) => {
    p.state ? f && d.setTextFillStyle(f) : (f = d.getTextFillStyle(), d.setTextFillStyle(d.getTextFillStyleHidden()));
  })), d.setPadding({ left: (n = s.uiTextPadding) !== null && n !== void 0 ? n : 5 }), ro(d, s, o), this.applyStylers(d, s);
} }.addStyler(Ku).addStyler(((r, t) => (r.setButtonOnFillStyle(t.uiButtonFillStyle).setButtonOffFillStyle(t.uiButtonFillStyleHidden).setButtonSize(t.uiButtonSize).setButtonStrokeStyle(t.uiButtonStrokeStyle), r)));
class Jb extends Ga {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.xf = 10, this.Mf = ae.Up, this._f = 0, this.vo = "major", this.wf = 0, this.kf = 1, this.Tl = t.In(this.renderingScale).Tn(Me).Fn(Me), this.D.zi(this.Tl), this.Ar = t.vr(this.renderingScale), this.D.zi(this.Ar);
  }
  Yn() {
    return [this.Tl];
  }
  rr() {
    if (super.rr(), this.ci) return this;
    const t = xt(this.getPosition(), this.scale, this.renderingScale), e = this.renderingScale.Qt(t, { x: this.Mf === ae.Right ? -this.xf : this.Mf === ae.Left ? this.xf : 0, y: this.Mf === ae.Up ? -this.xf : this.Mf === ae.Down ? this.xf : 0 }), i = this.renderingScale.Qt(e, { x: this.Mf === ae.Right ? -this._f : this.Mf === ae.Left ? this._f : 0, y: this.Mf === ae.Up ? -this._f : this.Mf === ae.Down ? this._f : 0 });
    return this.Ar.pr(t).yr(e), this.Tl.hr(i).ru(this.Mf === ae.Up ? { x: this.wf, y: this.kf } : this.Mf === ae.Down ? { x: this.wf, y: -this.kf } : this.Mf === ae.Right ? { x: this.kf, y: this.wf } : { x: -this.kf, y: this.wf }), this.Tl.Kr = this.Kr, this;
  }
  Uh() {
    const t = this.Ar.po().getThickness();
    return this.size = this.Mf === ae.Left || this.Mf === ae.Right ? { x: this.xf + this._f + this.Tl.Uh().Bc().x, y: t } : { y: this.xf + this._f + this.Tl.Uh().Bc().y, x: t }, super.Uh();
  }
  dispose() {
    return super.dispose(), this.Tl.dispose(), this.Ar.dispose(), this;
  }
  setVisible(t) {
    return super.setVisible(t), this.Tl.setVisible(t), this.Ar.setVisible(t), this;
  }
  setPointerEvents(t) {
    return this.Tl.setPointerEvents(t), this.Ar.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.Tl.getPointerEvents();
  }
  getText() {
    return this.Tl.an();
  }
  setTextFillStyle(t) {
    return this.Tl.sr(t), this.Js.Rs(), this;
  }
  getTextFillStyle() {
    return this.Tl.kh();
  }
  setTextFont(t) {
    return this.Tl.Ih(t), this;
  }
  setTextRotation(t) {
    return this.Tl.Ph(t), this;
  }
  getTextRotation() {
    return this.Tl.Lh();
  }
  getTextFont() {
    return this.Tl.Fh();
  }
  setText(t) {
    return this.Tl.rn(t), this.Js.Rs(), this;
  }
  setDirection(t) {
    return this.Mf = t, this.Js.Rs(), this;
  }
  getDirection() {
    return this.Mf;
  }
  setPointerLength(t) {
    return this.xf = t, this.Js.Rs(), this;
  }
  getPointerLength() {
    return this.xf;
  }
  setTickLabelPadding(t) {
    return this._f = t, this.Js.Rs(), this;
  }
  getTickLabelPadding() {
    return this._f;
  }
  setTickStyle(t) {
    return this.Ar.gr(t), this.Js.Rs(), this;
  }
  getTickStyle() {
    return this.Ar.po();
  }
  setTickLabelAlignment(t, e) {
    return this.wf = t, e && (this.kf = e), this.Js.Rs(), this;
  }
  getTickLabelAlignment() {
    return this.wf;
  }
}
const gx = { ...mn, direction: ae.Up, setDirection(r) {
  return this.direction = r, this;
}, Ao(r, t, e, i, s, o) {
  const n = this.direction, a = new Jb(r, t, e, i, s);
  return ro(a, s, o), a.setDirection(n), this.applyStylers(a, s);
} }.addStyler(Ku), Qb = gx.addStyler(((r, t) => (r.vo = "major", r.setPointerLength(t.xAxisNumericTicks.majorTickStyle.tickLength).setTickLabelPadding(t.xAxisNumericTicks.majorTickStyle.tickPadding).setTickStyle(t.xAxisNumericTicks.majorTickStyle.tickStyle).setTextFont(t.xAxisNumericTicks.majorTickStyle.labelFont).setTextFillStyle(t.xAxisNumericTicks.majorTickStyle.labelFillStyle))));
gx.addStyler(((r, t) => (r.vo = "minor", r.setPointerLength(t.xAxisNumericTicks.minorTickStyle.tickLength).setTickLabelPadding(t.xAxisNumericTicks.minorTickStyle.tickPadding).setTickStyle(t.xAxisNumericTicks.minorTickStyle.tickStyle).setTextFont(t.xAxisNumericTicks.minorTickStyle.labelFont).setTextFillStyle(t.xAxisNumericTicks.minorTickStyle.labelFillStyle))));
class px extends Ga {
  constructor(t, e, i, s, o, n) {
    var a, l, h, u, c, d;
    super(t, e, i, s, o), this.Cf = [], this.Tf = "", this.Ff = (f, p) => f.label !== void 0 ? f.label : p.percentageValues ? `${(100 * f.value).toFixed(0)}%` : va(p, f.value), this.If = 0, this.Pf = !1, this.wf = n, this.Lf = t.Od(e).ir(Et), this.zd = this.Lf.Qo().Nd(typeof o.legendLUTCornerRadius == "number" ? { extent: o.legendLUTCornerRadius, c_x1_y1: !0, c_x1_y2: !0, c_x2_y1: !0, c_x2_y2: !0 } : void 0), this.D.zi(this.Lf), this.Bf = t.In(e).sr(o.uiTextFillStyle).Ih(o.uiTextFont).setPointerEvents(!1), this.D.zi(this.Bf), this.Df = (a = o.legendLUTLabelMargin) !== null && a !== void 0 ? a : 7, this.Ef = (l = o.legendLUTUnitLabelMargin) !== null && l !== void 0 ? l : 7, n === "vertical" ? (this.Rf = (h = o.legendLUTLengthVertical) !== null && h !== void 0 ? h : 140, this.Of = (u = o.legendLUTThicknessVertical) !== null && u !== void 0 ? u : 25) : (this.Rf = (c = o.legendLUTLengthHorizontal) !== null && c !== void 0 ? c : 160, this.Of = (d = o.legendLUTThicknessHorizontal) !== null && d !== void 0 ? d : 15);
  }
  Yn() {
    return [this.Lf, this.Bf];
  }
  zf(t) {
    return this.Bf.Tn(t), this.Cf.forEach(((e) => e.Tn(t))), this.Js.Rs(), this;
  }
  Vf(t) {
    this.Nf = t;
    const e = xg(t, this.wf === "vertical" ? 0 : 90, this.Pf);
    return this.Lf.sr(e), this.Js.Rs(), this;
  }
  Ws() {
    return this.Nf;
  }
  Gf(t) {
    return this.Rf = t, this.Js.Rs(), this;
  }
  ru(t) {
    return this.wf = t, this.Js.Rs(), this;
  }
  $f() {
    return this.Rf;
  }
  Uf(t) {
    return this.Of = t, this.Js.Rs(), this;
  }
  jf() {
    return this.Of;
  }
  Yf(t) {
    return this.Tf = t, this.Js.Rs(), this;
  }
  Hf() {
    return this.Tf;
  }
  Wf(t) {
    return this.Ff = t, this.Js.Rs(), this;
  }
  setLUTDisplayProportionalSteps(t) {
    if (this.Pf = t, this.Nf) {
      const e = xg(this.Nf, this.wf === "vertical" ? 0 : 90, this.Pf);
      this.Lf.sr(e);
    }
    return this.Js.Rs(), this;
  }
  getLUTDisplayProportionalSteps() {
    return this.Pf;
  }
  setFillStyle(t) {
    return this.Bf.sr(t), this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.Bf.kh();
  }
  setFont(t) {
    return this.Bf.Ih(t), this.Js.Rs(), this;
  }
  getFont() {
    return this.Bf.Fh();
  }
  setTextRotation(t) {
    return this.If = t, this.Bf.Ph(t), this.Js.Rs(), this;
  }
  getTextRotation() {
    return this.Bf.Lh();
  }
  rr() {
    var t, e, i, s;
    if (super.rr(), this.ci || !this.getVisible()) return this;
    const o = this.Nf;
    if (o) {
      const n = this.renderingScale.ni(), a = o.min, l = o.max;
      if (this.wf === "vertical") {
        const h = this.getPosition({ x: -1, y: -1 }, be.Content), u = qt(h, { x: this.Of * this.renderingScale.x.getPixelSize() + this.Df * n.x, y: 0 }), c = { x: u.x, y: u.y + (this.Tf.length > 0 ? this.Ef * n.y + this.Bf.Ft().y : 0) + 0.5 * (((t = this.Cf[0]) === null || t === void 0 ? void 0 : t.Ft().y) || 0) }, d = { x: c.x, y: this.getPosition({ x: -1, y: 1 }, be.Content).y - 0.5 * (((e = this.Cf[this.Cf.length - 1]) === null || e === void 0 ? void 0 : e.Ft().y) || 0) };
        this.zd.Gd(h.x, c.y, h.x + this.Of * this.renderingScale.x.getPixelSize(), c.y + this.Rf * this.renderingScale.y.getPixelSize()), this.Bf.ru({ x: -1, y: -1 }).hr(u), o.getSteps().forEach(((f, p) => {
          const g = Ln(c, d, this.Pf ? o.getInterpolation() === !0 ? (f.value - a) / (l - a) : 0.9 * (f.value - a) / (l - a) : o.getInterpolation() === !0 ? p / (o.getSteps().length - 1) : p / o.getSteps().length);
          this.Cf[p].ru({ x: -1, y: 0 }).hr(g);
        }));
      } else {
        const h = this.getPosition({ x: -1, y: -1 }, be.Content), u = this.getPosition({ x: 1, y: 1 }, be.Content), c = Math.max(this.Cf.reduce(((y, m) => Math.max(y, m.Ft().y)), 0), this.Bf.Uh().Ft().y), d = qt(h, { x: 0.5 * (((i = this.Cf[0]) === null || i === void 0 ? void 0 : i.Ft().x) || 0), y: c }), f = { x: u.x, y: d.y }, p = { x: o.getInterpolation() ? f.x - (0.5 * (((s = this.Cf[this.Cf.length - 1]) === null || s === void 0 ? void 0 : s.Ft().x) || 0) + (this.Tf.length > 0 ? this.Ef * n.x + this.Bf.Ft().x : 0)) : d.x + this.Rf * this.renderingScale.x.getPixelSize(), y: d.y }, g = { x: d.x, y: d.y + this.Df * n.y };
        this.zd.Gd(g.x, g.y, g.x + this.Rf * this.renderingScale.x.getPixelSize(), g.y + this.Of * this.renderingScale.y.getPixelSize()), this.Bf.ru({ x: 1, y: 1 }).hr(f), o.getSteps().forEach(((y, m) => {
          const A = Ln(d, p, this.Pf ? o.getInterpolation() === !0 ? (y.value - a) / (l - a) : 0.9 * (y.value - a) / (l - a) : o.getInterpolation() === !0 ? m / (o.getSteps().length - 1) : m / o.getSteps().length);
          this.Cf[m].ru({ x: 0, y: 1 }).hr(A);
        }));
      }
    }
    return this;
  }
  Uh() {
    if (this.Nf && this.getVisible()) {
      const t = this.Nf.getSteps();
      for (let e = this.Cf.length; e < t.length; e += 1) {
        const i = this.Js.In(this.renderingScale).setPointerEvents(!1);
        this.Cf.push(i), this.D.zi(i);
      }
      for (let e = 0; e < t.length; e += 1) this.Cf[e].sr(this.Bf.kh()).Ih(this.Bf.Fh()).rn(this.Ff(t[e], this.Nf)).Ph(this.If);
      for (let e = t.length; e < this.Cf.length; e += 1) this.Cf[e].dispose();
      if (this.Cf.length = t.length, this.Bf.rn(this.Tf), this.wf === "vertical") {
        const e = this.Of, i = this.Rf, s = e + Math.max(this.Cf.reduce(((n, a) => Math.max(n, a.Uh().Bc().x)), 0), this.Bf.Uh().Bc().x), o = (this.Tf.length > 0 ? this.Ef + this.Bf.Uh().Bc().y : 0) + i + 0.5 * this.Cf[0].Uh().Bc().y + 0.5 * this.Cf[this.Cf.length - 1].Uh().Bc().y;
        this.setContentSize({ x: s, y: o });
      } else {
        const e = this.Rf, i = this.Of, s = Math.max(this.Tf.length > 0 ? this.Ef + this.Bf.Uh().Bc().x + (this.Nf.getInterpolation() ? 0.5 * this.Cf[this.Cf.length - 1].Uh().Bc().x : 0) : 0, this.Nf.getInterpolation() ? 0.5 * this.Cf[this.Cf.length - 1].Uh().Bc().x : 0), o = e + 0.5 * this.Cf[0].Uh().Bc().x + s, n = i + this.Df + Math.max(this.Cf.reduce(((a, l) => Math.max(a, l.Uh().Bc().y)), 0), this.Bf.Uh().Bc().y);
        this.setContentSize({ x: o, y: n });
      }
    } else this.Cf.forEach(((t) => t.dispose())), this.Cf.length = 0, this.Bf.setVisible(!1), this.Lf.setVisible(!1), this.setContentSize({ x: 0, y: 0 });
    return super.Uh();
  }
  dispose() {
    return super.dispose(), this.Lf.dispose(), this.Cf.forEach(Eo), this.Bf.dispose(), this;
  }
  setPointerEvents(t) {
    return this.Lf.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.Lf.getPointerEvents();
  }
}
const t2 = { lutElement: {}, setLUT(r) {
  return this.lutElement.Vf(r), this;
}, getLUT() {
  return this.lutElement.Ws();
}, setLUTLength(r) {
  return this.lutElement.Gf(r), this;
}, getLUTLength() {
  return this.lutElement.$f();
}, setLUTThickness(r) {
  return this.lutElement.Uf(r), this;
}, getLUTThickness() {
  return this.lutElement.jf();
}, setLookUpUnit(r) {
  return this.lutElement.Yf(r), this;
}, getLookUpUnit() {
  return this.lutElement.Hf();
}, setLUTStepValueFormatter(r) {
  return this.lutElement.Wf(r), this;
}, setLUTDisplayProportionalSteps(r) {
  return this.lutElement.setLUTDisplayProportionalSteps(r), this;
}, getLUTDisplayProportionalSteps() {
  return this.lutElement.getLUTDisplayProportionalSteps();
} };
({ ...mn, ...ch, background: xn, alignment: "horizontal", setAlignment(r) {
  return { ...this, alignment: r };
}, Ao(r, t, e, i, s, o) {
  const n = new Hl(r, t, e, this.background, i, s), a = n.addElement({ Ao: () => new px(r, t, e, ie, s, this.alignment) }), l = Object.assign(n, tc, { stylableTexts: [a] }, t2, { lutElement: a });
  return ro(l, s, o), this.applyStylers(l, s);
} }).addStyler(Ku);
const xg = (r, t, e) => {
  const i = r.getSteps(), s = r.min, o = r.max - s;
  if (r.getInterpolation() === !0) return new Ci({ angle: t, stops: i.map(((a, l) => ({ offset: e ? (a.value - s) / o : l / (i.length - 1), color: a.color || r.color }))) });
  const n = [];
  for (let a = 0; a < i.length; a += 1) {
    const l = i[a];
    n.push({ offset: e ? 0.9 * (l.value - s) / o : a / i.length, color: l.color || r.color });
    const h = a < i.length - 1 ? i[a + 1] : void 0;
    n.push({ offset: e ? h ? 0.9 * (h.value - s) / o : 1 : h ? (a + 1) / i.length : 1, color: l.color || r.color });
  }
  return new Ci({ angle: t, stops: n });
};
fx.addStyler(((r) => r.addEventListener("switch", ((t) => t.state === !0 ? setTimeout((() => r.setOn(!1)), 300) : void 0))));
const Yl = { TextBox: Gf, PointableTextBox: Zb, AxisTickMajor: Qb };
class e2 extends Wa {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, n), this.Xf = o;
  }
}
class wu extends eo {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d, f, p, g, y) {
    var m, A, v;
    super(u, h, a, p, g, { numeric: h.getWidth({ x: p.xAxisNumericTicks, y: p.yAxisNumericTicks }), datetime: h.getWidth({ x: p.xAxisDateTimeTicks, y: p.yAxisDateTimeTicks }), time: h.getWidth({ x: p.xAxisTimeTicks, y: p.yAxisTimeTicks }) }, y), this.Zf = /* @__PURE__ */ new Map(), this.Jf = void 0, this.Qf = 0, this.Kf = [], this.qf = [], this.tA = !0, this.iA = [], this.sA = (b) => {
      const w = this.qf.indexOf(b);
      w >= 0 && this.qf.splice(w, 1);
    }, this.eA = (b) => (this.qf.indexOf(b) < 0 && this.qf.push(b), this.sA), this.rA = !0, this.hA = _m(this.iA), this.Rf = { relative: 1 }, this.nA = (b, w) => w.getAllocatesAxisSpace() && Ii(w.getValue(), this.mh, this.Sh) ? Math.max(b, w.update().So()) : b, this.oA = (b) => {
      const w = this.Kf.indexOf(b);
      w !== -1 && this.Kf.splice(w, 1);
    }, this.gs = Qi.onHover, this.D = new Nt(), this.cr = {}, this.aA = a instanceof ts ? a : void 0, this.isX = this.dh.getWidth({ x: !0, y: !1 }), this.isY = this.dh.getHeight({ x: !0, y: !1 }), this.lA = t, this.uA = e, this.cA = s, this.dA = o, this.chart = u, this.fA = d, this.AA = i, this.Ss = n, y.type === "logarithmic" && this.chart.yi.Oa(Ot.No), this.Ch = i2, f(this, this.eA), a.gA = this, this.vA = c, this.yA = this.vA > 50 ? 1 : -1, this.pA = (v = this.dh.toPoint(0, -this.yA), Math.abs(v.x) >= Math.abs(v.y) ? v.x >= 0 ? ae.Right : ae.Left : v.y >= 0 ? ae.Up : ae.Down), this.mA = l, this.SA = this.ai instanceof ts ? new we().Kt(this.dh.toVec2(this.ai, this.mA)) : new Ti().Kt(this.dh.toVec2(this.ai, this.mA)), this.bA = this.chart.xA, this.MA = new we().Kt(this.dh.toVec2(this.dh.getWidth(this.bA), this.mA)), this._A = this.uA.vr(this.SA).setPointerEvents(!1), this.wA = this.AA.er(this.bA).sr(h.getWidth({ x: p.xAxisOverlayStyle, y: p.yAxisOverlayStyle })).ir(Et).Li(p.highlightColorOffsetAxisOverlay || p.highlightColorOffset), this.kA = this.AA.er(this.bA).sr(h.getWidth({ x: p.xAxisZoomingBandFillStyle, y: p.yAxisZoomingBandFillStyle })).ir(h.getWidth({ x: p.xAxisZoomingBandStrokeStyle, y: p.yAxisZoomingBandStrokeStyle })).Li(p.highlightColorOffsetAxisOverlay || p.highlightColorOffset), this.qr = this.AA.In(this.SA).setPointerEvents(!1).Ph(this.dh.getTitleTextRotation(this.yA)).Fn(Me).Tn(Me), this.chart.yi.ks.ws(this.wA, ((b) => this.wA.Ii(b)), { animationEnabled: this.zr }), this.D.zi(this.wA), this._A.gr(h.getWidth({ x: p.xAxisStrokeStyle, y: p.yAxisStrokeStyle })), this.qr.sr(h.getWidth({ x: p.xAxisTitleFillStyle, y: p.yAxisTitleFillStyle })).Ih(h.getWidth({ x: p.xAxisTitleFont, y: p.yAxisTitleFont })), this.bs = n.xs(this, {}), this.Bh = this.bs.CA([this.qr]).Es(p.effectsText), this.TA = (m = h.getWidth({ x: p.xAxisMarginAfterTicks, y: p.yAxisMarginAfterTicks })) !== null && m !== void 0 ? m : 7, this.FA = (A = h.getWidth({ x: p.xAxisMarginAfterTitle, y: p.yAxisMarginAfterTitle })) !== null && A !== void 0 ? A : 7;
  }
  setHighlight(t) {
    return this.chart.yi.ks.$s(this.wA, t), this.D.R("highlightchange", { highlight: dn(t) }), this;
  }
  getHighlight() {
    return this.chart.yi.ks.Is(this);
  }
  kn() {
    return this.Gr;
  }
  Cn() {
    return this.Oh !== void 0;
  }
  setKeepTickLabelsInAxisBounds(t) {
    return this.rA = t, this.chart.yi.Rs(), this;
  }
  getKeepTickLabelsInAxisBounds() {
    return this.rA;
  }
  setTickStrategy(t, e) {
    return super.ph(t, e);
  }
  getTickStrategy() {
    return this.Dr;
  }
  addBand(t) {
    var e;
    const i = (e = t?.onTop) === null || e === void 0 || e, s = t?.legend, o = i ? this.dA : this.cA, n = new ub(o, this.chart, this.hA, this, this.SA, this.dh, this.xi, this.Ss);
    return s && this.chart.legend.add(n, s), this.iA.push(n), n;
  }
  addConstantLine(t) {
    var e;
    const i = (e = t?.onTop) === null || e === void 0 || e, s = t?.legend, o = i ? this.dA : this.cA, n = new cb(o, this.chart, this.hA, this, this.SA, this.dh, this.xi, this.Ss);
    return s && this.chart.legend.add(n, s), this.iA.push(n), n;
  }
  IA(t) {
    this.iA.forEach(t);
  }
  PA(t) {
    return this.iA.map(t);
  }
  getHighlighters() {
    return this.iA;
  }
  setThickness(t) {
    return typeof t == "number" ? (this.LA = t, this.BA = t) : typeof t == "object" ? (this.LA = t.min, this.BA = t.max) : t === void 0 && (this.LA = void 0, this.BA = void 0), this.Yh = void 0, this.chart.yi.Rs(), this;
  }
  getThickness() {
    return { min: this.LA, max: this.BA };
  }
  DA() {
    return this.qf;
  }
  Wh(t) {
    return {};
  }
  Qh(t, e, i, s, o) {
    var n;
    const a = e.Lr;
    return { keyValue: t, tickLevel: e, labelText: i, labelPosition: this.dh.toPoint(t, 0), labelAlignment: this.dh.toPoint(a.getLabelAlignment(), (n = a.labelAlignmentOpposite) !== null && n !== void 0 ? n : -this.yA), labelOffset: { x: 0, y: 0 }, labelRotation: e.Lr.labelRotation };
  }
  tn(t, e, i) {
    if (!this.di) return { EA: 0, RA: 0, OA: 0, ticksInfo: e, updatedTicks: i };
    const s = this.qr && this.qr.an().length > 0 && this.getTitleFillStyle() !== Lt, o = this.dh.getHeight(s ? this.qr.Uh().Bc() : { x: 0, y: 0 }) + (s ? this.FA : 0);
    let n = 0;
    this.Er.forEach(((h, u) => {
      const c = u.Lr.tickLength < 0 || u.Lr.tickPadding < 0, d = u.Lr.tickLength + u.Lr.tickPadding;
      h.forEach(((f) => {
        if (!f.Gh.getVisible() || Qn(f.Gh.kh())) return void (c || (n = Math.max(n, d)));
        const p = d + this.dh.getHeight(f.Gh.Uh().Bc());
        c || (n = Math.max(n, p));
      }));
    }));
    const a = this.Kf.reduce(this.nA, 0);
    n = Math.max(n, a), n += this.TA;
    const l = Jt(o + n, this.LA !== void 0 ? this.LA : 0, this.BA !== void 0 ? this.BA : wt);
    return this.Qf = l, { EA: n, RA: o, OA: l, ticksInfo: e, updatedTicks: i };
  }
  hn(t, e) {
    return new e2(e, t, this.uA, this.SA, this.SA);
  }
  ih() {
    return this.SA;
  }
  Dh() {
    if (this.Zf) {
      for (const t of this.Zf) t[1].grid.dispose(), t[1].tick.dispose();
      this.Zf.clear();
    }
    super.Dh();
  }
  xn(t, e) {
    return this.Ah.type === "linear" || this.Ah.type === "linear-highPrecision" ? Sa(t, e, this.ai) : Eu(t, e, this.ai);
  }
  zA(t, e) {
    return e instanceof ts ? Sa : Eu;
  }
  wn(t, e, i) {
    if (this.Ah.type !== "logarithmic") {
      const a = this.ai.Jt(Math.abs(e - t));
      return { start: t + Math.sign(t - e) * i.start * a, end: e + Math.sign(e - t) * i.end * a };
    }
    const s = this.ai, o = { start: s.$, end: s.U };
    s.Z(t, e).hs();
    const n = { start: s.Qt(t, i.start * Math.sign(t - e)), end: s.Qt(e, i.end * Math.sign(e - t)) };
    return s.Z(o.start, o.end).hs(), n;
  }
  $h(t) {
    var e, i;
    const s = this.jh(), o = s.min, n = s.max, a = this.Er.size > 0, l = ((e = this.Yh) === null || e === void 0 ? void 0 : e.physicalAxisSize) !== t.physicalAxisSize;
    let h = ((i = this.Yh) === null || i === void 0 ? void 0 : i.min) !== o || this.Yh.max !== n;
    if (this.Yh && this.aA) {
      const u = this.aA.getPixelSize(), c = Math.abs(n - this.Yh.max), d = Math.abs(c / u), f = Math.abs(o - this.Yh.min), p = Math.abs(f / u);
      h = Math.max(d, p) >= 10;
    }
    return !(!a || l || h || t.anyPreviousAxisUpdated);
  }
  rr(t) {
    const e = this.getVisible() && t.VA > 0, i = this.ai.getInnerStart() < this.ai.getInnerEnd() ? this.ai.getInnerStart() : this.ai.getInnerEnd(), s = this.ai.getInnerEnd() > this.ai.getInnerStart() ? this.ai.getInnerEnd() : this.ai.getInnerStart();
    e || this.Dh();
    const o = this._A.po().getThickness() * this.yA / 2, n = this.mA.getInnerInterval(), a = this.vA / 100 * n, l = a + t.NA, h = n * this.yA, u = l + o;
    if (this.Dr !== "Empty" && e) {
      const A = this.ai.wt(), v = this.ai.kt(), b = Math.min(A, v), w = Math.max(A, v);
      for (const [k, R] of this.Er) {
        let L = this.Zf.get(k);
        if (!L) {
          if (k.br) L = { grid: this.lA[0].GA(this.SA).setPointerEvents(!1), tick: this.lA[0].GA(this.SA).setPointerEvents(!1) };
          else if ("$A" in k) {
            const E = Array.from(this.Er.keys()).filter(((I) => "$A" in I)).reverse().indexOf(k), T = this.lA[E];
            if (!T) throw new Error("Not enough tick layers. This is an internal LCJS error - if you see this, please contact LightningChart support.");
            L = { grid: T.GA(this.SA).setPointerEvents(!1), tick: T.GA(this.SA).setPointerEvents(!1) };
          }
        }
        if (!L) continue;
        L.grid.Vi(), L.tick.Vi();
        const x = k.Lr, M = a - h * x.getGridStrokeLength(), C = u + x.getTickLength() * this.yA, S = C + x.getTickPadding() * this.yA;
        for (const [E, T] of R) {
          const I = t.ticksInfo.get(T);
          if (!I) continue;
          const F = { start: this.dh.toPoint(T.M, l), end: this.dh.toPoint(T.M, M) }, D = { start: this.dh.toPoint(T.M, u), end: this.dh.toPoint(T.M, C) };
          let P = 0;
          if (this.rA) {
            const V = T.Gh.Bc(), _ = this.ai.Rt(I.keyValue) + this.dh.getWidth(I.labelOffset) + (-0.5 * this.dh.getWidth(I.labelAlignment) - 0.5) * this.dh.getWidth(V), O = _ + this.dh.getWidth(V);
            P = O > w ? w - O : _ < b ? b - _ : 0;
          }
          T.Gh.hr(this.dh.toPoint(this.ai.Qt(T.M, P), S)).ru(I.labelAlignment).Ph(I.labelRotation), L.grid.Qo().UA(F.start, F.end), L.tick.Qo().UA(D.start, D.end);
        }
        L.grid.gr(k.Lr.getGridStrokeStyle()), L.tick.gr(k.Lr.getTickStyle()), this.Zf.set(k, L);
      }
    }
    const c = u, d = c + this.yA * t.OA, f = { start: this.dh.toVec2(this.ai.getInnerStart(), c), end: this.dh.toVec2(this.ai.getInnerEnd(), d) }, p = xt(f.start, this.SA, this.bA), g = xt(f.end, this.SA, this.bA);
    this._A.pr(this.dh.toPoint(i, l)).yr(this.dh.toPoint(s, l)).setVisible(e);
    let y = this.jA;
    y || (y = "center-chart", ("pixels" in this.Rf || this.YA !== void 0 || this.HA !== void 0 || t.WA !== 1 || this.isY) && (y = "center"));
    const m = l + t.EA * this.yA;
    if (this.qr.hr(this.dh.toPoint(this.dh.getWidth(xt(y === "center-chart" ? { x: 0.5 * this.bA.x.getInnerInterval(), y: 0.5 * this.bA.y.getInnerInterval() } : y === "center" ? pe(qt(p, g), 0.5) : y === "start" ? p : g, this.bA, this.SA)), m)).ru(this.dh.toPoint(y === "center-chart" || y === "center" ? 0 : y === "start" ? -1 : 1, -1 * this.yA)).setVisible(e), this.Jf) {
      const A = this.vA / 100 * n + t.NA, v = -this.yA * n - t.NA, b = { start: this.dh.toVec2(this.Jf.min, u + this.yA * this.Qf), end: this.dh.toVec2(this.Jf.max, A + v) }, w = xt(b.start, this.SA, this.bA), k = xt(b.end, this.SA, this.bA);
      this.kA.hr(w).K(oi(k, w)).setVisible(!0);
    } else this.kA.setVisible(!1);
    this.wA.hr(p).K(oi(g, p)).setVisible(e);
    for (const A of this.Kf) if (A.update().plot(e, l, h, t.NA, u), this.AA.yi.Pc && A.getVisible() && A.getMarkerVisible() && A.fo.Kr === es.CursorTickMarker) {
      const v = nx(A.fo);
      this.AA.yi.Pc.XA({ ...v, blacklist: [es.CursorResultTable, es.CursorTickMarker] });
    }
    for (const A of this.iA) A.rr();
    return { width: Math.abs(g.x - p.x), height: Math.abs(g.y - p.y), left: Math.min(p.x, g.x), right: this.bA.x.getInnerEnd() - Math.max(p.x, g.x), bottom: Math.min(p.y, g.y), top: this.bA.y.getInnerEnd() - Math.max(p.y, g.y) };
  }
  setLength(t) {
    return this.Rf = t, this.Yh = void 0, this.chart.yi.Rs(), this;
  }
  getLength() {
    return this.Rf;
  }
  setMargins(t, e) {
    return this.YA = t, this.HA = e, this.Yh = void 0, this.chart.yi.Rs(), this;
  }
  getMargins() {
    var t, e;
    return { start: (t = this.YA) !== null && t !== void 0 ? t : 0, end: (e = this.HA) !== null && e !== void 0 ? e : 0 };
  }
  getStackIndex() {
    var t, e;
    return (e = (t = [...this.chart.ZA, ...this.chart.JA, ...this.chart.QA, ...this.chart.KA].find(((i) => i.axis === this))) === null || t === void 0 ? void 0 : t.iStack) !== null && e !== void 0 ? e : 0;
  }
  getParallelIndex() {
    var t, e;
    return (e = (t = [...this.chart.ZA, ...this.chart.JA, ...this.chart.QA, ...this.chart.KA].find(((i) => i.axis === this))) === null || t === void 0 ? void 0 : t.iParallel) !== null && e !== void 0 ? e : 0;
  }
  qA() {
    return this.Qf;
  }
  tg(t, e) {
    e = e || Yl.AxisTickMajor;
    const i = new Ab(this, t ? this.lA[0] : this.AA, this.AA, this.ai, this.MA, this.MA, this.dh, this.pA, this.oA, this.xi, e).setTextFormatter(this.formatValue);
    return this.Kf.push(i), this.Yh = void 0, i.fo.vo === "other" && (i.fo.Kr = es.CursorTickMarker), i;
  }
  ig(t, e) {
    const i = -this.dh.getWidth(e);
    this.pan(i);
  }
  pan(t, e) {
    var i, s;
    const o = this.mh, n = this.Sh, a = this.ai.Qt(o, t), l = this.ai.Qt(n, t);
    this.zh(a, l, { allowIntervalLengthChange: !1, skipIntervalRestriction: !1 });
    const h = this.Th();
    if (e?.releaseScrollingAxisIfLiveReached !== !1 && ((i = this.Vh) === null || i === void 0 ? void 0 : i.id) === Gl && this.Vr && h) {
      const u = this.Sr({ forStart: a, forEnd: l, allowIntervalLengthChange: !1 });
      u && (this.Sh > this.mh && this.Sh >= u.end || this.Sh < this.mh && this.mh >= u.start) && this.setStopped(!1);
    }
    if (e?.releaseScrollingAxisIfLiveReached !== !1 && ((s = this.Vh) === null || s === void 0 ? void 0 : s.id) === Aa && this.Vr && h) {
      const u = this.Sr({ forStart: a, forEnd: l, allowIntervalLengthChange: !1 });
      u && (this.Sh < this.mh && this.Sh <= u.end || this.Sh > this.mh && this.mh <= u.start) && this.setStopped(!1);
    }
  }
  zoom(t, e) {
    const i = this.ai.Rt(this.mh), s = this.ai.Rt(this.Sh), o = this.ai.Rt(t), n = Jt((o - i) / (s - i), 0, 1), a = 0.2 * this.ai.Ct(), l = n * a * -e, h = (1 - n) * a * e, u = this.ai.Qt(this.mh, l), c = this.ai.Qt(this.Sh, h), d = this._n();
    let f = u, p = c;
    if (d?.intervalMax !== void 0 && Math.abs(p - f) > d.intervalMax) {
      const g = d.intervalMax - Math.abs(p - f);
      f -= g * n, p += g * (1 - n);
    }
    if (d?.intervalMin !== void 0 && Math.abs(p - f) < d.intervalMin) {
      const g = d.intervalMin - Math.abs(p - f);
      f -= g * n, p += g * (1 - n);
    }
    this.zh(f, p, { allowIntervalLengthChange: !0, skipIntervalRestriction: !1 });
  }
  addCustomTick(t) {
    return this.tg(!0, t);
  }
  getCustomTicks() {
    return [...this.Kf];
  }
  setTitlePosition(t) {
    return this.jA = t, this.chart.yi.Rs(), this;
  }
  getTitlePosition() {
    var t;
    return (t = this.jA) !== null && t !== void 0 ? t : "center-chart";
  }
  getUiPosition() {
    return this.vA;
  }
  setStrokeStyle(t) {
    return this._A.gr(t), this.uA.Rs(), this;
  }
  getStrokeStyle() {
    return this._A.po();
  }
  getOverlayStyle() {
    return this.wA.kh();
  }
  setOverlayStyle(t) {
    return this.wA.sr(t), this.uA.Rs(), this;
  }
  setAnimationHighlight(t) {
    return this.chart.yi.ks.Us(this.wA, t), this;
  }
  getAnimationHighlight() {
    return this.chart.yi.ks.js(this.wA);
  }
  getMarginAfterTicks() {
    return this.TA;
  }
  setMarginAfterTicks(t) {
    return this.TA = t, this.Yh = void 0, this.uA.Rs(), this;
  }
  getMarginAfterTitle() {
    return this.FA;
  }
  setMarginAfterTitle(t) {
    return this.FA = t, this.Yh = void 0, this.uA.Rs(), this;
  }
  W() {
    return this.ai.W(), this;
  }
  X() {
    return this.ai.X(), this;
  }
  dispose() {
    var t;
    !((t = this.Vh) === null || t === void 0) && t.dispose && this.Vh.dispose({ axis: this }), this._A.dispose(), this.wA.dispose(), this.kA.dispose(), this.qr.dispose(), this.Nh(Eo);
    for (const e of this.Zf.values()) e.grid.dispose(), e.tick.dispose();
    return this.qf.slice().forEach(Eo), this.iA.slice().forEach(Eo), this.fA(this), this.D.R("dispose", {}), this;
  }
  setVisible(t) {
    this._A.setVisible(t), this.qr.setVisible(t), this.wA.setVisible(t), this.Nh(((e) => {
      e.Ls(t);
    }));
    for (const e of this.Zf.values()) e.grid.setVisible(t), e.tick.setVisible(t);
    return super.setVisible(t), this.Yh = void 0, this.chart.yi.Rs(), this;
  }
  setAnimationsEnabled(t) {
    return super.setAnimationsEnabled(t), this.setAnimationHighlight(this.zr), this;
  }
  setHighlightOnHover(t) {
    return this.gs = t ? Qi.onHover : Qi.noHighlighting, t === !1 && this.getHighlight() > 0 && this.setHighlight(!1), this;
  }
  getHighlightOnHover() {
    return this.gs !== Qi.noHighlighting;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
  set draggable(t) {
    this.D.draggable = t;
  }
  get draggable() {
    return this.D.draggable;
  }
  setUserInteractions(t) {
    return this.cr = t === void 0 ? { pan: !1, zoom: !1, rectangleZoom: !1, restoreDefault: !1, chartInteractions: { pan: !1, paginate: !1, zoom: !1, rectangleZoom: !1, restoreDefault: !1, restorePrevious: !1 } } : t, this;
  }
  getUserInteractions() {
    return this.cr;
  }
}
var vg;
(function(r) {
  r.Start = "start", r.Center = "center", r.End = "end", r.CenterChart = "center-chart";
})(vg || (vg = {}));
const i2 = (r) => r.curEnd > r.curStart ? { startMin: r.dataMin, endMax: r.dataMax } : { endMin: r.dataMin, startMax: r.dataMax }, jl = { getWidth: (r) => r.x, getHeight: (r) => r.y, toVec2: (r, t) => ({ x: r, y: t }), toPoint: (r, t) => j(r, t) }, ec = { getWidth: (r) => r.y, getHeight: (r) => r.x, toVec2: (r, t) => ({ x: t, y: r }), toPoint: (r, t) => j(t, r) }, na = (r) => !!(r && typeof r == "object" && "x" in r && r.x instanceof wu && "y" in r && r.y instanceof wu), s2 = De({ type: "tick-style", gridStrokeLength: 1, gridStrokeStyle: new $t(), tickLength: 7, tickStyle: new $t(), tickPadding: 0, labelFont: new qn(), labelFillStyle: new ot(), labelAlignment: 0, labelAlignmentOpposite: void 0, labelRotation: 0, labelShadow: void 0 });
class Hr extends s2 {
  constructor(t) {
    super(t);
  }
  setGridStrokeLength(t) {
    return this.set("gridStrokeLength", t);
  }
  getGridStrokeLength() {
    return this.get("gridStrokeLength");
  }
  setGridStrokeStyle(t) {
    return this.set("gridStrokeStyle", typeof t == "function" ? t(this.get("gridStrokeStyle")) : t);
  }
  getGridStrokeStyle() {
    return this.get("gridStrokeStyle");
  }
  setTickLength(t) {
    return this.set("tickLength", t);
  }
  getTickLength() {
    return this.get("tickLength");
  }
  setTickStyle(t) {
    return this.set("tickStyle", typeof t == "function" ? t(this.get("tickStyle")) : t);
  }
  getTickStyle() {
    return this.get("tickStyle");
  }
  setTickPadding(t) {
    return this.set("tickPadding", t);
  }
  getTickPadding() {
    return this.get("tickPadding");
  }
  setLabelFillStyle(t) {
    return this.set("labelFillStyle", typeof t == "function" ? t(this.get("labelFillStyle")) : t);
  }
  getLabelFillStyle() {
    return this.get("labelFillStyle");
  }
  setLabelShadow(t) {
    return this.set("labelShadow", t);
  }
  getLabelShadow() {
    return this.get("labelShadow");
  }
  setLabelFont(t) {
    return this.set("labelFont", typeof t == "function" ? t(this.get("labelFont")) : t);
  }
  getLabelFont() {
    return this.get("labelFont");
  }
  setLabelAlignment(t, e) {
    return this.withMutations(((i) => i.set("labelAlignment", t).set("labelAlignmentOpposite", e)));
  }
  getLabelAlignment() {
    return this.get("labelAlignment");
  }
  setLabelRotation(t) {
    return this.set("labelRotation", t);
  }
  getLabelRotation() {
    return this.get("labelRotation");
  }
}
const yx = (r) => !(!r || typeof r != "object" || !("type" in r) || r.type !== "tick-style"), Ad = new Hr({ labelFillStyle: Lt, gridStrokeStyle: Et, tickStyle: Et }), Tu = (r) => yx(r) && Qn(r.labelFillStyle) && U0(r.gridStrokeStyle) && U0(r.tickStyle), di = 1e6, r2 = De({ type: "time-ticks", cursorFormatter: void 0, timeOrigin: void 0, majorTickStyle: new Hr(), minorTickStyle: new Hr(), majorFormattingFunction: void 0, minorFormattingFunction: void 0, customTickPlacement: void 0 }), rn = 36e5, fo = 6e4, xo = 1e3, Rc = 1e-6, ao = (r, t) => {
  const e = t - r;
  return e >= 864e5 ? "MajorHours12" : e >= rn ? "MajorHours" : e >= 6e5 ? "MajorMinutes15" : e >= 9e4 ? "MajorMinutes" : e >= 10500 ? "MajorSeconds15" : e >= xo ? "MajorSeconds" : e >= 100 ? "MajorMilliseconds100" : e >= 10 ? "MajorMilliseconds10" : e >= 1 ? "MajorMilliseconds" : e >= 0.1 ? "MajorMicroseconds100" : e >= 0.01 ? "MajorMicroseconds10" : e >= 1e-3 ? "MajorMicroseconds" : e <= 1e-3 ? "MajorNanoseconds100" : "Unknown";
}, me = { hhmmss: (r) => {
  let t = Math.abs(r);
  const e = r >= 0 ? "" : "-", i = Math.floor(t / rn);
  t %= rn;
  const s = Math.floor(t / fo);
  t %= fo;
  const o = Math.floor(t / xo);
  return `${e}${ji(i, 2)}:${ji(s, 2)}:${ji(o, 2)}`;
}, hhmmssmmm: (r) => {
  let t = Math.abs(r);
  const e = r >= 0 ? "" : "-", i = Math.floor(t / rn);
  t %= rn;
  const s = Math.floor(t / fo);
  t %= fo;
  const o = Math.floor(t / xo);
  t %= xo;
  const n = Math.floor(t / 1);
  return `${e}${ji(i, 2)}:${ji(s, 2)}:${ji(o, 2)}.${ji(n, 3)}`;
}, hhmmssmmmuuu: (r) => {
  const t = Math.abs(r), e = r >= 0 ? "" : "-", i = Math.floor(t / rn), s = Math.floor(t / fo) % 60, o = Math.floor(t / xo) % 60, n = Math.floor(t / 1) % 1e3, a = r.toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 }).split(".")[1];
  return `${e}${ji(i, 2)}:${ji(s, 2)}:${ji(o, 2)}.${ji(n, 3)}${a}`;
}, hhmmssmmmuuunnn: (r) => {
  const t = Math.abs(r), e = r >= 0 ? "" : "-", i = Math.floor(t / rn), s = Math.floor(t / fo) % 60, o = Math.floor(t / xo) % 60, n = Math.floor(t / 1) % 1e3, a = r.toLocaleString("en-US", { minimumFractionDigits: 6, maximumFractionDigits: 6 }).split(".")[1];
  return `${e}${ji(i, 2)}:${ji(s, 2)}:${ji(o, 2)}.${ji(n, 3)}${a}`;
} }, lo = { MajorHours12: { major: { format: me.hhmmss, getKeyValues: (r, t, e, i) => (r = Math.floor(r / (4 * 432e5)) * 432e5 * 4, As(r, t, 432e5, void 0, di)), fitKeyValues: re({ ignore: "first" }, 2, 4) }, minor: { format: me.hhmmss, getKeyValues: (r, t, e, i) => Vs(r, t, 36e5, di), fitKeyValues: re({}, 2, 3, 4, 6) }, defaultValueFormatter: me.hhmmss }, MajorHours: { major: { format: me.hhmmss, getKeyValues: (r, t, e, i) => {
  const s = rn;
  return r = Math.floor(r / (12 * s)) * s * 12, As(r, t, s, void 0, di);
}, fitKeyValues: re({ ignore: "first" }, 2, 6, 12) }, minor: { format: me.hhmmss, getKeyValues: (r, t, e, i) => Vs(r, t, 3e5, di), fitKeyValues: re({}, 2, 4, 6) }, defaultValueFormatter: me.hhmmss }, MajorMinutes15: { major: { format: me.hhmmss, getKeyValues: (r, t, e, i) => (r = Math.floor(r / rn) * rn, As(r, t, 9e5, void 0, di)), fitKeyValues: re({ ignore: "first" }, 2) }, minor: { format: me.hhmmss, getKeyValues: (r, t, e, i) => Vs(r, t, 6e4, di), fitKeyValues: re({}, 3, 5) }, defaultValueFormatter: me.hhmmss }, MajorMinutes: { major: { format: me.hhmmss, getKeyValues: (r, t, e, i) => {
  const s = fo;
  return r = Math.floor(r / 6e5) * s * 10, As(r, t, s, void 0, di);
}, fitKeyValues: re({ ignore: "first" }, 2, 5) }, minor: { format: me.hhmmss, getKeyValues: (r, t, e, i) => Vs(r, t, 5e3, di), fitKeyValues: re({}, 2, 3, 4, 6) }, defaultValueFormatter: me.hhmmss }, MajorSeconds15: { major: { format: me.hhmmss, getKeyValues: (r, t, e, i) => (r = Math.floor(r / 6e4) * 15e3 * 4, As(r, t, 15e3, void 0, di)), fitKeyValues: re({ ignore: "first" }, 2, 4) }, minor: { format: me.hhmmss, getKeyValues: (r, t, e, i) => Vs(r, t, 1e3, di), fitKeyValues: re({}, 3, 5) }, defaultValueFormatter: me.hhmmss }, MajorSeconds: { major: { format: me.hhmmss, getKeyValues: (r, t, e, i) => {
  const s = xo;
  return r = Math.floor(r / 1e4) * s * 10, As(r, t, s, void 0, di);
}, fitKeyValues: re({ ignore: "first" }, 2, 5) }, minor: { format: me.hhmmssmmm, getKeyValues: (r, t, e, i) => Vs(r, t, 100, di), fitKeyValues: re({}, 2, 3, 5) }, defaultValueFormatter: me.hhmmssmmm }, MajorMilliseconds100: { major: { format: me.hhmmssmmm, getKeyValues: (r, t, e, i) => (r = 100 * Math.floor(r / 1e3) * 10, As(r, t, 100, void 0, di)), fitKeyValues: re({ ignore: "first" }, 2, 5) }, minor: { format: me.hhmmssmmm, getKeyValues: (r, t, e, i) => Vs(r, t, 10, di), fitKeyValues: re({}, 2, 3, 5) }, defaultValueFormatter: me.hhmmssmmm }, MajorMilliseconds10: { major: { format: me.hhmmssmmm, getKeyValues: (r, t, e, i) => (r = 10 * Math.floor(r / 100) * 10, As(r, t, 10, void 0, di)), fitKeyValues: re({ ignore: "first" }, 2, 5) }, minor: { format: me.hhmmssmmm, getKeyValues: (r, t, e, i) => Vs(r, t, 1, di), fitKeyValues: re({}, 2, 3, 5) }, defaultValueFormatter: me.hhmmssmmm }, MajorMilliseconds: { major: { format: me.hhmmssmmmuuu, getKeyValues: (r, t, e, i) => (r = 1 * Math.floor(r / 10) * 10, As(r, t, 1, void 0, di)), fitKeyValues: re({ ignore: "first" }, 2, 5) }, minor: { format: me.hhmmssmmmuuu, getKeyValues: (r, t, e, i) => Vs(r, t, 0.1, di), fitKeyValues: re({}, 2) }, defaultValueFormatter: me.hhmmssmmmuuu }, MajorMicroseconds100: { major: { format: me.hhmmssmmmuuu, getKeyValues: (r, t, e, i) => (r = 0.1 * Math.floor(r / 1) * 10, As(r, t, 0.1, void 0, di)), fitKeyValues: re({ ignore: "first" }, 2, 5) }, minor: { format: me.hhmmssmmmuuu, getKeyValues: (r, t, e, i) => Vs(r, t, 0.01, di), fitKeyValues: re({}, 2, 3, 5) }, defaultValueFormatter: me.hhmmssmmmuuu }, MajorMicroseconds10: { major: { format: me.hhmmssmmmuuu, getKeyValues: (r, t, e, i) => (r = Math.floor(r / 0.1) * 0.01 * 10, As(r, t, 0.01, void 0, di)), fitKeyValues: re({ ignore: "first" }, 2, 5) }, minor: { format: me.hhmmssmmmuuu, getKeyValues: (r, t, e, i) => Vs(r, t, 1e-3, di), fitKeyValues: re({}, 2, 3, 5) }, defaultValueFormatter: me.hhmmssmmmuuu }, MajorMicroseconds: { major: { format: me.hhmmssmmmuuunnn, getKeyValues: (r, t, e, i) => (r = Math.floor(r / 0.01) * 1e-3 * 10, As(r, t, 1e-3, void 0, di)), fitKeyValues: re({ ignore: "first" }, 2, 5) }, minor: { format: me.hhmmssmmmuuunnn, getKeyValues: (r, t, e, i) => Vs(r, t, 100 * Rc, di), fitKeyValues: re({}, 2, 3, 5) }, defaultValueFormatter: me.hhmmssmmmuuunnn }, MajorNanoseconds100: { major: { format: me.hhmmssmmmuuunnn, getKeyValues: (r, t, e, i) => {
  const s = 100 * Rc;
  return r = Math.floor(r / 1e-3) * s * 10, As(r, t, s, void 0, di);
}, fitKeyValues: re({ ignore: "first" }, 2, 5) }, minor: { format: me.hhmmssmmmuuunnn, getKeyValues: (r, t, e, i) => Vs(r, t, 10 * Rc, di), fitKeyValues: re({}, 2, 3, 5) }, defaultValueFormatter: me.hhmmssmmmuuunnn }, Unknown: { major: { format: (r, t, e) => "", getKeyValues: (r, t, e, i) => [], fitKeyValues: void 0 }, minor: { format: (r, t, e) => "", getKeyValues: (r, t, e, i) => [], fitKeyValues: void 0 }, defaultValueFormatter: (r, t, e) => "" } };
class n2 extends r2 {
  wr(t) {
    const e = this.timeOrigin || 0, i = [{ Gh: "Major ticks", $A: 0, Lr: this.majorTickStyle, Mr: this.majorFormattingFunction ? this.majorFormattingFunction : (s, o, n) => {
      const a = ao(Math.min(o.start, o.end), Math.max(o.start, o.end));
      return (0, lo[a].major.format)(s + e, o, n);
    }, Dn: (s, o, n, a, l) => {
      const h = ao(n, a);
      return (0, lo[h].major.getKeyValues)(s, o, n, a, l);
    }, hh: { un: (s, o, n, a, l, h) => {
      const u = ao(l, h), c = lo[u].major.fitKeyValues;
      if (c) return c(s, o, n, a, l, h);
    }, dn: "hide-label" }, En: void 0, ln: typeof this.customTickPlacement == "function" ? this.customTickPlacement : typeof this.customTickPlacement == "object" ? this.customTickPlacement.major : void 0 }];
    return yx(this.minorTickStyle) && i.push({ Gh: "Minor ticks", $A: 1, Lr: this.minorTickStyle, Mr: this.minorFormattingFunction ? this.minorFormattingFunction : (s, o, n) => {
      const a = ao(Math.min(o.start, o.end), Math.max(o.start, o.end));
      return (0, lo[a].minor.format)(s + e, o, n);
    }, Dn: (s, o, n, a, l) => {
      const h = ao(n, a);
      return (0, lo[h].minor.getKeyValues)(s, o, n, a, l);
    }, hh: { un: (s, o, n, a, l, h) => {
      const u = ao(l, h), c = lo[u].minor.fitKeyValues;
      if (c) return c(s, o, n, a, l, h);
    }, dn: "hide-tick" }, En: void 0, ln: typeof this.customTickPlacement == "function" ? () => [] : typeof this.customTickPlacement == "object" ? this.customTickPlacement.minor : void 0 }), { kr: [], Cr: i, Tr: this.cursorFormatter || ((s, o, n) => {
      const a = ao(Math.min(o.start, o.end), Math.max(o.start, o.end));
      return lo[a].defaultValueFormatter(s + e, o, n);
    }), Fr: 1e-4, Ir: 864e6 };
  }
  setTickStyle(t) {
    return this.setMajorTickStyle(t).setMinorTickStyle(t);
  }
  setMajorTickStyle(t) {
    return typeof t == "function" ? this.set("majorTickStyle", t(this.get("majorTickStyle"))) : this.set("majorTickStyle", t);
  }
  getMajorTickStyle() {
    return this.get("majorTickStyle");
  }
  setMinorTickStyle(t) {
    if (typeof t == "function") {
      const e = this.get("minorTickStyle");
      return this.set("minorTickStyle", t(e));
    }
    return this.set("minorTickStyle", t);
  }
  getMinorTickStyle() {
    return this.get("minorTickStyle");
  }
  setCursorFormatter(t) {
    return this.set("cursorFormatter", t);
  }
  getCursorFormatter() {
    return this.get("cursorFormatter");
  }
  setTimeOrigin(t) {
    return this.set("timeOrigin", t);
  }
  getTimeOrigin() {
    return this.get("timeOrigin");
  }
  setFormattingFunction(t) {
    return this.withMutations(((e) => e.set("majorFormattingFunction", t).set("minorFormattingFunction", t).set("cursorFormatter", t)));
  }
  getMajorFormattingFunction() {
    return this.get("majorFormattingFunction");
  }
  setMajorFormattingFunction(t) {
    return this.set("majorFormattingFunction", t);
  }
  getMinorFormattingFunction() {
    return this.get("minorFormattingFunction");
  }
  setMinorFormattingFunction(t) {
    return this.set("minorFormattingFunction", t);
  }
  setCustomTickPlacement(t) {
    return this.set("customTickPlacement", t);
  }
  getCustomTickPlacement() {
    return this.get("customTickPlacement");
  }
}
const ic = (r, t, e, i, s) => (o, n) => (a) => {
  const l = new Date(a + o), h = { year: n ? l.getUTCFullYear() : l.getFullYear(), monthIndex: n ? l.getUTCMonth() : l.getMonth(), day: n ? l.getUTCDate() : l.getDate(), hours: n ? l.getUTCHours() : l.getHours(), minutes: n ? l.getUTCMinutes() : l.getMinutes(), seconds: n ? l.getUTCSeconds() : l.getSeconds(), millis: n ? l.getUTCMilliseconds() : l.getMilliseconds() }, u = i ? i(h) : void 0;
  if (r === 0 && u === !0) return a;
  const c = h[t];
  s.includes("year") && (h.year = Math.floor(h.year / e) * e), s.includes("monthIndex") && (h.monthIndex = 0), s.includes("day") && (h.day = 1), s.includes("hours") && (h.hours = 0), s.includes("minutes") && (h.minutes = 0), s.includes("seconds") && (h.seconds = 0), s.includes("millis") && (h.millis = 0);
  let d = (r === 0 ? 1 : r) * e;
  return r === -1 && u === !1 && (d = 0), d !== 0 && (h[t] = e * (d > 0 ? Math.floor((c + d) / e) : Math.ceil((c + d) / e))), n ? Date.UTC(h.year, h.monthIndex, h.day, h.hours, h.minutes, h.seconds, h.millis) - o : new Date(h.year, h.monthIndex, h.day, h.hours, h.minutes, h.seconds, h.millis).getTime() - o;
}, ho = (r, t, e, ...i) => ic(-1, r, t, e, i), ll = (r, t, e, ...i) => ic(-1, r, t, e, i), hl = (r, t, e, ...i) => ic(0, r, t, e, i), ul = (r, t, ...e) => ic(1, r, t, void 0, e), Ic = (r) => (t, e) => (i) => {
  const s = new Date(i + t), o = e ? s.getUTCDay() : s.getDay(), n = o === 1 && (e ? s.getUTCHours() : s.getHours()) === 0 && (e ? s.getUTCMinutes() : s.getMinutes()) === 0 && s.getSeconds() === 0 && s.getMilliseconds() === 0;
  if (r === 0 && n === !0) return i;
  let a = e ? s.getUTCDate() : s.getDate();
  return r === -1 && o === 1 && n === !1 || (r === -1 ? a -= o >= 2 ? o - 1 : o + 6 : a += o > 0 ? 8 - o : 1), e ? Date.UTC(s.getUTCFullYear(), s.getUTCMonth(), a, 0, 0, 0, 0) - t : new Date(s.getFullYear(), s.getMonth(), a, 0, 0, 0, 0).getTime() - t;
}, Zs = [{ label: "NanoSecond10", unit: 1e-5, irregular: !1, greatTicks: void 0, majorTicks: { fitFunction: re({ offset: 0 }, 2, 5) }, minorTicks: { amount: 4, fitFunction: re(void 0, 2) } }, { label: "NanoSecond100", unit: 1e-4, irregular: !1, greatTicks: { getReferenceKeyValue: (r, t) => (e) => 1e-4 * Math.floor(e / 1e-4) }, majorTicks: { fitFunction: re({ offset: 0 }, 2, 5) }, minorTicks: { amount: 4, fitFunction: re(void 0, 2) } }, { label: "MicroSecond1", unit: 1e-3, irregular: !1, greatTicks: { getReferenceKeyValue: (r, t) => (e) => 1e-3 * Math.floor(e / 1e-3) }, majorTicks: { fitFunction: re({ offset: 0 }, 2, 5) }, minorTicks: { amount: 4, fitFunction: re(void 0, 2) } }, { label: "MicroSecond10", unit: 0.01, irregular: !1, greatTicks: { getReferenceKeyValue: (r, t) => (e) => 0.01 * Math.floor(e / 0.01) }, majorTicks: { fitFunction: re({ offset: 0 }, 2, 5) }, minorTicks: { amount: 4, fitFunction: re(void 0, 2) } }, { label: "MicroSecond100", unit: 0.1, irregular: !1, greatTicks: { getReferenceKeyValue: (r, t) => (e) => 0.1 * Math.floor(e / 0.1) }, majorTicks: { fitFunction: re({ offset: 0 }, 2, 5) }, minorTicks: { amount: 4, fitFunction: re(void 0, 2) } }, { label: "MilliSecond1", unit: 1, irregular: !1, greatTicks: { getReferenceKeyValue: ho("millis", 1, ((r) => r.millis % 1 == 0), "millis") }, majorTicks: { fitFunction: re({ offset: 0 }, 2, 5) }, minorTicks: { amount: 4, fitFunction: re(void 0, 2) } }, { label: "MilliSecond10", unit: 10, irregular: !1, greatTicks: { getReferenceKeyValue: ho("millis", 10, ((r) => r.millis % 10 == 0), "millis") }, majorTicks: { fitFunction: re({ offset: 0 }, 2, 5) }, minorTicks: { amount: 4, fitFunction: re(void 0, 2) } }, { label: "MilliSecond100", unit: 100, irregular: !1, greatTicks: { getReferenceKeyValue: ho("millis", 100, ((r) => r.millis % 100 == 0), "millis") }, majorTicks: { fitFunction: re({ offset: 0 }, 2, 5) }, minorTicks: { amount: 4, fitFunction: re(void 0, 2) } }, { label: "Second", unit: 1e3, irregular: !1, greatTicks: { getReferenceKeyValue: ho("seconds", 1, ((r) => r.millis === 0), "millis") }, majorTicks: { fitFunction: Lc(3, 5, 10, 15, 30) }, minorTicks: { amount: 4, fitFunction: re(void 0, 2) } }, { label: "Minute", unit: 6e4, irregular: !1, greatTicks: { getReferenceKeyValue: ho("minutes", 1, ((r) => r.seconds === 0 && r.millis === 0), "seconds", "millis") }, majorTicks: { fitFunction: Lc(3, 5, 10, 15, 30) }, minorTicks: { amount: 12, fitFunction: re(void 0, 3, 6) } }, { label: "Hour", unit: 36e5, irregular: !1, greatTicks: { getReferenceKeyValue: ho("hours", 1, ((r) => r.minutes === 0 && r.seconds === 0 && r.millis === 0), "minutes", "seconds", "millis") }, majorTicks: { fitFunction: Lc(3, 6, 12) }, minorTicks: { amount: 8, fitFunction: re(void 0, 2, 4) } }, { label: "Day", unit: 864e5, irregular: !1, greatTicks: { getReferenceKeyValue: ho("day", 1, ((r) => r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "hours", "minutes", "seconds", "millis") }, majorTicks: { fitFunction: re({ ignore: "last" }, 2, 4) }, minorTicks: { amount: 7, fitFunction: re({ ignore: "last" }, 2, 3) } }, { label: "Week", unit: 6048e5, irregular: !0, getPrevKeyValue: Ic(-1), getNextKeyValueIncludingRef: Ic(0), getNextKeyValue: Ic(1), greatTicks: !0, majorTicks: { fitFunction: re(void 0, 2) }, minorTicks: { fitFunction: void 0 } }, { label: "Month", unit: 2592e6, irregular: !0, getPrevKeyValue: ll("monthIndex", 1, ((r) => r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "day", "hours", "minutes", "seconds", "millis"), getNextKeyValueIncludingRef: hl("monthIndex", 1, ((r) => r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "day", "hours", "minutes", "seconds", "millis"), getNextKeyValue: ul("monthIndex", 1, "day", "hours", "minutes", "seconds", "millis"), greatTicks: !0, majorTicks: { fitFunction: re(void 0, 2, 3, 6) }, minorTicks: { fitFunction: re(void 0, 2, 4, 6) } }, { label: "Year", unit: 31536e6, irregular: !0, getPrevKeyValue: ll("year", 1, ((r) => r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "monthIndex", "day", "hours", "minutes", "seconds", "millis"), getNextKeyValueIncludingRef: hl("year", 1, ((r) => r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "monthIndex", "day", "hours", "minutes", "seconds", "millis"), getNextKeyValue: ul("year", 1, "monthIndex", "day", "hours", "minutes", "seconds", "millis"), greatTicks: !0, majorTicks: { fitFunction: re({ ignore: "first" }, 2, 5) }, minorTicks: { fitFunction: re(void 0, 2, 5) } }, { label: "Decade", unit: 31536e7, irregular: !0, getPrevKeyValue: ll("year", 10, ((r) => r.year % 10 == 0 && r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "year", "monthIndex", "day", "hours", "minutes", "seconds", "millis"), getNextKeyValueIncludingRef: hl("year", 10, ((r) => r.year % 10 == 0 && r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "year", "monthIndex", "day", "hours", "minutes", "seconds", "millis"), getNextKeyValue: ul("year", 10, "year", "monthIndex", "day", "hours", "minutes", "seconds", "millis"), greatTicks: !0, majorTicks: { fitFunction: re(void 0, 2, 4) }, minorTicks: { fitFunction: re(void 0, 2, 5) } }, { label: "Century", unit: 316224e7, irregular: !0, getPrevKeyValue: ll("year", 100, ((r) => r.year % 100 == 0 && r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "year", "monthIndex", "day", "hours", "minutes", "seconds", "millis"), getNextKeyValueIncludingRef: hl("year", 100, ((r) => r.year % 100 == 0 && r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "year", "monthIndex", "day", "hours", "minutes", "seconds", "millis"), getNextKeyValue: ul("year", 100, "year", "monthIndex", "day", "hours", "minutes", "seconds", "millis"), greatTicks: !0, majorTicks: { fitFunction: void 0 }, minorTicks: void 0 }, { label: "Millennium", unit: 316224e8, irregular: !0, getPrevKeyValue: ll("year", 1e3, ((r) => r.year % 1e3 == 0 && r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "year", "monthIndex", "day", "hours", "minutes", "seconds", "millis"), getNextKeyValueIncludingRef: hl("year", 1e3, ((r) => r.year % 1e3 == 0 && r.day === 1 && r.hours === 0 && r.minutes === 0 && r.seconds === 0 && r.millis === 0), "year", "monthIndex", "day", "hours", "minutes", "seconds", "millis"), getNextKeyValue: ul("year", 1e3, "year", "monthIndex", "day", "hours", "minutes", "seconds", "millis"), greatTicks: !0, majorTicks: { fitFunction: void 0 }, minorTicks: void 0 }], mx = (r, t, e, i, s) => {
  const o = t - r;
  let n;
  for (let a = 0; a < Zs.length; a += 1) {
    const l = o / Zs[a].unit;
    if (i === void 0 || l <= i) {
      n = Zs[a];
      break;
    }
  }
  return n;
}, $l = (r, t, e) => {
  let i = mx(t, e, void 0, 2);
  if (i !== void 0 && Zs.indexOf(i) === 0 && (i = Zs[1]), i === void 0) return;
  if (r === "great") return i;
  const s = r === "major" ? 1 : 2, o = Zs[Zs.indexOf(i) - s];
  return o === void 0 ? Zs[0] : o;
}, o2 = (r, t, e) => (i, s, o, n) => {
  const a = $l("great", i, s);
  if (a === void 0) return [];
  if (a.label === "Decade" || a.label === "Century" || a.label === "Millennium") return [];
  const l = n > o ? i : s, h = (i + s) / 2, u = n > o ? s : i;
  if (Zs.indexOf(a) <= Zs.findIndex(((f) => f.label === "Hour"))) return e === "left" ? [l] : [];
  let c;
  if (a.irregular === !0) c = sx(i, s, a.getPrevKeyValue(r, t), a.getNextKeyValue(r, t));
  else {
    const f = a.greatTicks.getReferenceKeyValue(r, t)(i);
    c = As(i, s, a.unit, f, void 0);
  }
  const d = ((f, p, g) => {
    for (const y of g) if (y >= f && y <= p) return y;
  })(i, s, c);
  return e === "left" ? d === void 0 || Ii(d, h, u) ? [l] : [d] : d !== void 0 && Ii(d, h, u) ? [d] : [u];
}, Vc = (r, t, e) => (i, s, o, n) => {
  const a = $l(r, o, n);
  let l;
  if (a === void 0) return [];
  if (r === "great" && a.greatTicks !== void 0) if (a.irregular === !0) l = sx(i, s, a.getPrevKeyValue(t, e), a.getNextKeyValue(t, e));
  else {
    const h = a.greatTicks.getReferenceKeyValue(t, e)(i);
    l = As(i, s, a.unit, h, void 0);
  }
  else if (r === "major" && a.majorTicks !== void 0) l = a.irregular === !0 ? ((h, u, c, d) => {
    const f = [];
    let p = c(h), g = 0;
    for (; p < u; ) if (f.push(p), p = d(p), g += 1, g > 1e3) throw new Error("Infinite loop in Axis tick key values logic.");
    return f.push(p), f;
  })(i, s, a.getPrevKeyValue(t, e), a.getNextKeyValue(t, e)) : ((h, u, c) => {
    const d = [];
    let f = h, p = 0;
    for (; (f - h) / (u - h) < 0.98; ) if (d.push(f), p += 1, f = h + p * c, p > 1e3) throw new Error("Infinite loop in Axis tick key values logic.");
    return d.push(f), d;
  })(i, s, a.unit);
  else {
    if (r !== "minor" || a.minorTicks === void 0) return [];
    if (a.irregular === !0) l = ((h, u, c, d) => {
      const f = [];
      let p = d(h), g = 0;
      for (; p < u; ) if (f.push(p), p = d(p), g += 1, g > 1e3) throw new Error("Infinite loop in Axis tick key values logic.");
      return f;
    })(i, s, a.getNextKeyValueIncludingRef(t, e), a.getNextKeyValue(t, e));
    else {
      const h = ((u) => {
        if (u !== void 0) return Zs[Zs.indexOf(u) + 1];
      })(a);
      if (h === void 0) return [];
      l = Vs(i, s, h.unit / a.minorTicks.amount, void 0);
    }
  }
  return l;
}, Sg = (r) => (t, e, i, s, o, n) => {
  const a = $l(r, o, n);
  if (a === void 0) return;
  let l;
  return r === "major" ? l = a.majorTicks.fitFunction : a.minorTicks && (l = a.minorTicks.fitFunction), l ? l(t, e, i, s, o, n) : void 0;
}, a2 = De({ utc: !1, customTickPlacement: void 0, locale: void 0, dateOrigin: void 0, cursorFormatter: void 0, greatTickStyle: new Hr(), majorTickStyle: new Hr(), minorTickStyle: new Hr(), formatOptionsMajorCentury: { year: "numeric", hour12: !1 }, formatOptionsMinorDecade: { year: "numeric", hour12: !1 }, formatOptionsMajorDecade: { year: "numeric", hour12: !1 }, formatOptionsMinorYear: { year: "numeric", hour12: !1 }, formatOptionsMajorYear: { year: "numeric", hour12: !1 }, formatOptionsMinorMonth: { month: "short", hour12: !1 }, formatOptionsGreatYear: { year: "numeric", hour12: !1 }, formatOptionsMajorMonth: { month: "long", hour12: !1 }, formatOptionsMinorWeek: { day: "numeric", hour12: !1 }, formatOptionsGreatMonth: { year: "numeric", month: "long", hour12: !1 }, formatOptionsMajorWeek: { day: "numeric", weekday: "short", hour12: !1 }, formatOptionsMinorDay: { day: "numeric", weekday: "short", hour12: !1 }, formatOptionsGreatWeek: (r, t, e) => {
  const i = new Date(r), s = ((o) => {
    const n = new Date(Date.UTC(o.getFullYear(), o.getMonth(), o.getDate()));
    n.setUTCDate(n.getUTCDate() + 4 - (n.getUTCDay() || 7));
    const a = new Date(Date.UTC(n.getUTCFullYear(), 0, 1));
    return Math.ceil(((n.getTime() - a.getTime()) / 864e5 + 1) / 7);
  })(i);
  return `${new Intl.DateTimeFormat(e, { year: "numeric", month: "long", hour12: !1 }).format(i)} Week ${s}`;
}, formatOptionsMajorDay: { weekday: "long", day: "numeric", hour12: !1 }, formatOptionsMinorHour: { hour: "2-digit", minute: "2-digit", hour12: !1 }, formatOptionsGreatDay: { year: "numeric", month: "long", day: "numeric", hour12: !1 }, formatOptionsMajorHour: { hour: "2-digit", minute: "2-digit", hour12: !1 }, formatOptionsMinorMinute: { hour: "2-digit", minute: "2-digit", hour12: !1 }, formatOptionsGreatHour: { year: "numeric", month: "long", day: "numeric", hour12: !1 }, formatOptionsMajorMinute: { hour: "2-digit", minute: "2-digit", hour12: !1 }, formatOptionsMinorSecond: { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: !1 }, formatOptionsGreatMinute: { year: "numeric", month: "long", day: "numeric", hour12: !1 }, formatOptionsMajorSecond: { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: !1 }, formatOptionsMinorMillisecond: (r) => {
  const t = new Date(r);
  return t.setHours(0, 0, 0, 0), me.hhmmssmmm(r - t.getTime());
}, formatMillisecondRange: (r) => {
  const t = new Date(r);
  return t.setHours(0, 0, 0, 0), me.hhmmssmmm(r - t.getTime());
}, formatMicrosecondRange: (r) => {
  const t = new Date(r);
  return t.setHours(0, 0, 0, 0), me.hhmmssmmmuuu(r - t.getTime());
}, formatNanosecondRange: (r, t, e, i) => {
  if (i) {
    const s = new Date(i.valueShifted);
    return s.setHours(0, 0, 0, 0), me.hhmmssmmmuuunnn(i.valueShifted - s.getTime());
  }
  {
    const s = new Date(r);
    return s.setHours(0, 0, 0, 0), me.hhmmssmmmuuunnn(r - s.getTime());
  }
}, formatOptionsGreatSecond: {}, formatOptionsMajorMilliSecond: {} });
class l2 extends a2 {
  wr(t) {
    const e = this.dateOrigin !== void 0 ? this.dateOrigin.getTime() : 0, i = (u) => Zs.map(((c) => {
      const d = ((f, p, g) => {
        switch (g.label) {
          case "NanoSecond10":
          case "NanoSecond100":
            return f.formatNanosecondRange;
          case "MicroSecond1":
          case "MicroSecond10":
          case "MicroSecond100":
            return f.formatMicrosecondRange;
          case "MilliSecond1":
          case "MilliSecond10":
          case "MilliSecond100":
            return p === "Great" ? f.formatOptionsGreatMinute : f.formatMillisecondRange;
          case "Second":
            return p === "Great" ? f.formatOptionsGreatMinute : p === "Major" ? f.formatOptionsMajorSecond : f.formatOptionsMinorSecond;
          case "Minute":
            return p === "Great" ? f.formatOptionsGreatMinute : p === "Major" ? f.formatOptionsMajorMinute : f.formatOptionsMinorMinute;
          default:
          case "Hour":
            return p === "Great" ? f.formatOptionsGreatHour : p === "Major" ? f.formatOptionsMajorHour : f.formatOptionsMinorHour;
          case "Day":
            return p === "Great" ? f.formatOptionsGreatDay : p === "Major" ? f.formatOptionsMajorDay : f.formatOptionsMinorDay;
          case "Week":
            return p === "Great" ? f.formatOptionsGreatWeek : p === "Major" ? f.formatOptionsMajorWeek : f.formatOptionsMinorWeek;
          case "Month":
            return p === "Great" ? f.formatOptionsGreatMonth : p === "Major" ? f.formatOptionsMajorMonth : f.formatOptionsMinorMonth;
          case "Year":
            return p === "Great" ? f.formatOptionsGreatYear : p === "Major" ? f.formatOptionsMajorYear : f.formatOptionsMinorYear;
          case "Decade":
            return p === "Great" ? void 0 : p === "Major" ? f.formatOptionsMajorDecade : f.formatOptionsMinorDecade;
          case "Century":
            return p === "Great" ? void 0 : p === "Major" ? f.formatOptionsMajorCentury : void 0;
          case "Millennium":
            return;
        }
      })(this, u, c);
      if (typeof d != "object") return d;
      try {
        return new Intl.DateTimeFormat(this.locale, d);
      } catch {
        let p = "";
        for (const g in d) p += ` ${g}: ${d[g]},`;
        H.console.error(`Invalid Intl.DateTimeFormat ( locale: ${this.locale}, formatOptions {${p}} )`);
      }
    })), s = /* @__PURE__ */ new Map();
    s.set("great", i("Great")), s.set("major", i("Major")), s.set("minor", i("Minor"));
    const o = (u) => String(u), n = (u, c) => (d, f) => {
      let p = d, g = d + e;
      const y = f.start, m = f.end, A = y > m, v = $l(u, A ? m : y, A ? y : m);
      if (v === void 0) return o(g);
      if (u === "great") {
        const k = Pi(d, c === "left" ? y : m);
        let R;
        if (R = k === !1 ? d : v.irregular === !1 ? c === "left" && A === !1 || c === "right" && A === !0 ? v.greatTicks.getReferenceKeyValue(e, this.utc)(d) : v.greatTicks.getReferenceKeyValue(e, this.utc)(d + 1 * v.unit) : c === "left" && A === !1 || c === "right" && A === !0 ? v.getPrevKeyValue(e, this.utc)(d) : v.getNextKeyValue(e, this.utc)(d), p = R, g = R + e, c === "right" && k === !0 || c === "right" && v.label === "Week") return "";
      }
      const b = s.get(u);
      if (b === void 0) return o(g, this.locale);
      const w = b[Zs.indexOf(v)];
      return w === void 0 ? "" : typeof w == "function" ? w(g, f, this.locale, { valueShifted: p, shiftOrigin: this.dateOrigin ? this.dateOrigin.getTime() : 0 }) : w.format(g);
    }, a = [], l = [{ Gh: "Great ticks (directive)", $A: 0, _r: !0, Dn: Vc("great", e, this.utc), En: void 0, ln: void 0 }, { Gh: "Major ticks", $A: 1, Lr: this.majorTickStyle, Mr: n("major"), Dn: Vc("major", e, this.utc), hh: { un: Sg("major"), dn: "hide-tick" }, En: void 0, ln: typeof this.customTickPlacement == "function" ? this.customTickPlacement : typeof this.customTickPlacement == "object" ? this.customTickPlacement.major : void 0 }];
    Tu(this.greatTickStyle) || a.push({ Gh: "Great ticks (left)", Lr: this.greatTickStyle.setLabelAlignment(-1), Mr: n("great", "left"), Dn: o2(e, this.utc, "left"), br: !0, An: !1 }), Tu(this.minorTickStyle) || l.push({ Gh: "Minor ticks", $A: 2, Lr: this.minorTickStyle, Mr: n("minor"), Dn: Vc("minor", e, this.utc), hh: { un: Sg("minor"), oh: (u, c, d, f, p, g) => {
      const y = $l("minor", p, g);
      return !y || y.label !== "Week";
    }, dn: "hide-tick" }, En: void 0, cn: 2, ln: typeof this.customTickPlacement == "function" ? () => [] : typeof this.customTickPlacement == "object" ? this.customTickPlacement.minor : void 0 });
    const h = this.cursorFormatter;
    return { kr: a, Cr: l, Tr: h ? (u, c, d) => h(e + u, c, d) : (u, c, d) => {
      const f = mx(Math.min(c.start, c.end), Math.max(c.start, c.end), void 0, 1), p = f && f.unit <= 0.1, g = f && f.unit <= 100, y = f && f.unit <= 6e4, m = new Date(e + u), A = new Date(e + u);
      A.setHours(0, 0, 0, 0);
      const v = p ? this.formatNanosecondRange : g ? this.formatMicrosecondRange : y ? this.formatMillisecondRange : me.hhmmss;
      return `${new Intl.DateTimeFormat(d, { year: "numeric", month: "numeric", day: "numeric" }).format(m)} ${v(m.getTime() - A.getTime(), c, this.locale, { valueShifted: u, shiftOrigin: e })}`;
    }, Fr: 10 ** -5, Ir: 31536e9 };
  }
  setCursorFormatter(t) {
    return this.set("cursorFormatter", t);
  }
  getCursorFormatter() {
    return this.get("cursorFormatter");
  }
  setTickStyle(t) {
    return this.setGreatTickStyle(t).setMajorTickStyle(t).setMinorTickStyle(t);
  }
  setGreatTickStyle(t) {
    if (typeof t == "function") {
      const e = this.get("greatTickStyle");
      return this.set("greatTickStyle", t(e));
    }
    return this.set("greatTickStyle", t);
  }
  getGreatTickStyle() {
    return this.get("greatTickStyle");
  }
  setMajorTickStyle(t) {
    return typeof t == "function" ? this.set("majorTickStyle", t(this.get("majorTickStyle"))) : this.set("majorTickStyle", t);
  }
  getMajorTickStyle() {
    return this.get("majorTickStyle");
  }
  setMinorTickStyle(t) {
    if (typeof t == "function") {
      const e = this.get("minorTickStyle");
      return this.set("minorTickStyle", t(e));
    }
    return this.set("minorTickStyle", t);
  }
  getMinorTickStyle() {
    return this.get("minorTickStyle");
  }
  setUTC(t) {
    return this.set("utc", t);
  }
  getUTC() {
    return this.get("utc");
  }
  setLocale(t) {
    return this.set("locale", t);
  }
  getLocale() {
    return this.get("locale");
  }
  setDateOrigin(t) {
    return this.set("dateOrigin", t);
  }
  getDateOrigin() {
    return this.get("dateOrigin");
  }
  setFormatting(t, e, i) {
    return this.withMutations(((s) => s.set("formatOptionsGreatYear", t || this.formatOptionsGreatYear).set("formatOptionsGreatMonth", t || this.formatOptionsGreatMonth).set("formatOptionsGreatWeek", t || this.formatOptionsGreatWeek).set("formatOptionsGreatDay", t || this.formatOptionsGreatDay).set("formatOptionsGreatHour", t || this.formatOptionsGreatHour).set("formatOptionsGreatMinute", t || this.formatOptionsGreatMinute).set("formatOptionsMajorCentury", e || this.formatOptionsMajorCentury).set("formatOptionsMajorDecade", e || this.formatOptionsMajorDecade).set("formatOptionsMajorYear", e || this.formatOptionsMajorYear).set("formatOptionsMajorMonth", e || this.formatOptionsMajorMonth).set("formatOptionsMajorWeek", e || this.formatOptionsMajorWeek).set("formatOptionsMajorDay", e || this.formatOptionsMajorDay).set("formatOptionsMajorHour", e || this.formatOptionsMajorHour).set("formatOptionsMajorMinute", e || this.formatOptionsMajorMinute).set("formatOptionsMajorSecond", e || this.formatOptionsMajorSecond).set("formatOptionsMinorDecade", i || this.formatOptionsMinorDecade).set("formatOptionsMinorYear", i || this.formatOptionsMinorYear).set("formatOptionsMinorMonth", i || this.formatOptionsMinorMonth).set("formatOptionsMinorWeek", i || this.formatOptionsMinorWeek).set("formatOptionsMinorDay", i || this.formatOptionsMinorDay).set("formatOptionsMinorHour", i || this.formatOptionsMinorHour).set("formatOptionsMinorMinute", i || this.formatOptionsMinorMinute).set("formatOptionsMinorSecond", i || this.formatOptionsMinorSecond)));
  }
  setFormattingDecade(t, e) {
    return this.withMutations(((i) => (t && (i = i.set("formatOptionsMajorDecade", t)), e && (i = i.set("formatOptionsMinorYear", e)), i)));
  }
  setFormattingYear(t, e) {
    return this.withMutations(((i) => (t && (i = i.set("formatOptionsMajorYear", t)), e && (i = i.set("formatOptionsMinorMonth", e)), i)));
  }
  setFormattingMonth(t, e, i) {
    return this.withMutations(((s) => (t && (s = s.set("formatOptionsGreatYear", t)), e && (s = s.set("formatOptionsMajorMonth", e)), i && (s = s.set("formatOptionsMinorWeek", i)), s)));
  }
  setFormattingWeek(t, e, i) {
    return this.withMutations(((s) => (t && (s = s.set("formatOptionsGreatMonth", t)), e && (s = s.set("formatOptionsMajorWeek", e)), i && (s = s.set("formatOptionsMinorDay", i)), s)));
  }
  setFormattingDay(t, e, i) {
    return this.withMutations(((s) => (t && (s = s.set("formatOptionsGreatWeek", t)), e && (s = s.set("formatOptionsMajorDay", e)), i && (s = s.set("formatOptionsMinorHour", i)), s)));
  }
  setFormattingHour(t, e, i) {
    return this.withMutations(((s) => (t && (s = s.set("formatOptionsGreatDay", t)), e && (s = s.set("formatOptionsMajorHour", e)), i && (s = s.set("formatOptionsMinorMinute", i)), s)));
  }
  setFormattingMinute(t, e, i) {
    return this.withMutations(((s) => (t && (s = s.set("formatOptionsGreatHour", t)), e && (s = s.set("formatOptionsMajorMinute", e)), i && (s = s.set("formatOptionsMinorSecond", i)), s)));
  }
  setFormattingSecond(t, e, i) {
    return this.withMutations(((s) => (t && (s = s.set("formatOptionsGreatMinute", t)), e && (s = s.set("formatOptionsMajorSecond", e)), i && (s = s.set("formatOptionsMinorMillisecond", i)), s)));
  }
  setFormattingMilliSecond(t, e) {
    return this.withMutations(((i) => (t && (i = i.set("formatOptionsGreatSecond", t)), e && (i = i.set("formatOptionsMajorMilliSecond", e)), i)));
  }
  setCustomTickPlacement(t) {
    return this.set("customTickPlacement", t);
  }
  getCustomTickPlacement() {
    return this.get("customTickPlacement");
  }
}
const Ag = (r, t) => (e, i, s, o, n) => {
  const a = i - e;
  if (t) {
    let u = 5;
    n <= 125 ? u = 2 : n <= 250 ? u = 3 : n <= 500 && (u = 4);
    const c = Math.log10(a / u), d = Math.floor(2 * c) / 2;
    let f;
    f = d % 1 == 0 ? 10 ** (d - r) : 10 ** Math.ceil(d) / 2;
    const p = 1 / f;
    f = Math.round(f * p) / p;
    const g = Math.round(Math.floor(e / (10 * f)) * f * 10 * p) / p;
    return As(g, i, f, void 0, p);
  }
  let l = a / 5;
  const h = 1 / l;
  return l = Math.round(l * h) / h, Vs(e, i, l, h);
}, h2 = (r, t, e, i, s, o) => t === 0 ? r.filter(((n, a) => a % 2 == 0)) : t === 1 ? r.filter(((n, a) => a % 5 == 0)) : t === 2 ? r.filter(((n, a) => a % 10 == 0)) : void 0, u2 = (r, t, e, i, s, o) => {
}, c2 = (r, t, e, i, s, o) => t === 0 ? r.filter(((n, a) => a % 2 == 0)) : t === 1 ? r.filter(((n, a) => a % 3 == 0)) : t === 2 ? r.filter(((n, a) => a % 4 == 0)) : t === 3 ? r.filter(((n, a) => a % 5 == 0)) : void 0, d2 = (r, t, e, i, s, o) => t === 0 ? [r[1], r[3], r[5]] : t === 1 ? [r[0], r[3]] : t === 2 ? [r[1]] : void 0, bg = (r, t) => {
  const e = bo(r), i = xa(r);
  if (t) return (o, n) => {
    const a = [], l = Math.floor(e(o)), h = Math.ceil(e(n));
    for (let u = l - 1; u <= h + 1; u += 1) {
      const c = i ** u;
      a.push(c);
    }
    return a;
  };
  const s = r === 10 ? 9 : 4;
  return (o, n) => {
    const a = Math.round(e(o)), l = Math.round(e(n)), h = [], u = i ** a, c = (i ** l - u) / s;
    for (let d = 1; d <= s; d += 1) {
      const f = u + c * d;
      f > o && f < n && h.push(f);
    }
    return h;
  };
}, f2 = De({ cursorFormatter: void 0, extremeTickStyle: new Hr(), majorTickStyle: new Hr(), minorTickStyle: new Hr(), formattingOffset: void 0, extremeFormattingFunction: void 0, majorFormattingFunction: void 0, minorFormattingFunction: void 0, fallBackToExtremeTicksAutomatically: !0, customTickPlacement: void 0 });
class g2 extends f2 {
  wr(t) {
    const e = this.formattingOffset, i = this.get("extremeFormattingFunction") || (t.type === "logarithmic" ? (u, c) => en.LogarithmicNoExponents(u, c, void 0, t.base) : en.Numeric), s = this.get("majorFormattingFunction") || (t.type === "logarithmic" ? (u, c) => en.LogarithmicNoExponents(u, c, void 0, t.base) : en.Numeric), o = this.get("minorFormattingFunction") || (t.type === "logarithmic" ? (u, c) => en.LogarithmicNoExponents(u, c, void 0, t.base) : en.Numeric), n = [], a = [];
    Tu(this.extremeTickStyle) || n.push({ Gh: "Extreme ticks", Lr: this.extremeTickStyle, Mr: e === void 0 ? i : (u, c, d) => i(e + u, c, d), Dn: fb, br: !0, An: !0 });
    const l = { Gh: "Major ticks", $A: 0, Lr: this.majorTickStyle, Mr: e === void 0 ? s : (u, c, d) => s(e + u, c, d), Dn: t.type === "logarithmic" ? bg(t.base, !0) : Ag(0, !0), hh: { dn: "hide-label", un: t.type === "logarithmic" ? c2 : h2 }, En: void 0, ln: typeof this.customTickPlacement == "function" ? this.customTickPlacement : typeof this.customTickPlacement == "object" ? this.customTickPlacement.major : void 0 };
    if (a.push(l), !Tu(this.minorTickStyle)) {
      const u = t.type === "logarithmic" ? bg(t.base, !1) : Ag(1, !1);
      a.push({ Gh: "Minor ticks", $A: 1, Lr: this.minorTickStyle, Mr: e === void 0 ? o : (c, d, f) => o(e + c, d, f), Dn: (c, d, f, p, g) => u(c, d, f, p, g), hh: { dn: "hide-tick", un: t.type === "logarithmic" ? d2 : u2 }, En: 80, ln: typeof this.customTickPlacement == "function" ? () => [] : typeof this.customTickPlacement == "object" ? this.customTickPlacement.minor : void 0 });
    }
    const h = this.cursorFormatter ? this.cursorFormatter : en.Numeric;
    return { kr: n, Cr: a, Tr: e === void 0 ? h : (u, c, d) => h(e + u, c, d), Fr: 1e-9, Ir: void 0, Jh: !this.customTickPlacement && this.fallBackToExtremeTicksAutomatically ? l : void 0 };
  }
  setCursorFormatter(t) {
    return this.set("cursorFormatter", t);
  }
  getCursorFormatter() {
    return this.get("cursorFormatter");
  }
  setExtremeTickStyle(t) {
    if (typeof t == "function") {
      const e = this.get("extremeTickStyle");
      return this.set("extremeTickStyle", t(e));
    }
    return this.set("extremeTickStyle", t);
  }
  getExtremeTickStyle() {
    return this.get("extremeTickStyle");
  }
  setFormattingOffset(t) {
    return this.set("formattingOffset", t);
  }
  getFormattingOffset() {
    return this.get("formattingOffset");
  }
  setTickStyle(t) {
    const e = this.setMajorTickStyle(t).setMinorTickStyle(t);
    return e.extremeTickStyle !== Ad ? e.setExtremeTickStyle(t) : e;
  }
  setMajorTickStyle(t) {
    return typeof t == "function" ? this.set("majorTickStyle", t(this.get("majorTickStyle"))) : this.set("majorTickStyle", t);
  }
  getMajorTickStyle() {
    return this.get("majorTickStyle");
  }
  setMinorTickStyle(t) {
    if (typeof t == "function") {
      const e = this.get("minorTickStyle");
      return this.set("minorTickStyle", t(e));
    }
    return this.set("minorTickStyle", t);
  }
  getMinorTickStyle() {
    return this.get("minorTickStyle");
  }
  setFormattingFunction(t) {
    return this.withMutations(((e) => e.set("extremeFormattingFunction", t).set("majorFormattingFunction", t).set("minorFormattingFunction", t).set("cursorFormatter", t)));
  }
  getExtremeFormattingFunction() {
    return this.get("extremeFormattingFunction");
  }
  setExtremeFormattingFunction(t) {
    return this.set("extremeFormattingFunction", t);
  }
  getMajorFormattingFunction() {
    return this.get("majorFormattingFunction");
  }
  setMajorFormattingFunction(t) {
    return this.set("majorFormattingFunction", t);
  }
  getMinorFormattingFunction() {
    return this.get("minorFormattingFunction");
  }
  setMinorFormattingFunction(t) {
    return this.set("minorFormattingFunction", t);
  }
  getFallBackToExtremeTicksAutomatically() {
    return this.get("fallBackToExtremeTicksAutomatically");
  }
  setFallBackToExtremeTicksAutomatically(t) {
    return this.set("fallBackToExtremeTicksAutomatically", t);
  }
  setCustomTickPlacement(t) {
    return this.set("customTickPlacement", t);
  }
  getCustomTickPlacement() {
    return this.get("customTickPlacement");
  }
}
const xx = (r, t, e = "image/png", i, s = 1) => {
  t += `.${e.slice(e.indexOf("image/") + 6)}`;
  const o = r.captureFrame(e, i, void 0, s);
  if (e !== "image/png" && o.type.includes("image/png")) throw new Error(`saveToFile | type not supported by browser: ${e}
Check support table for HTMLCanvasElement.toDataURL`);
  if (H.navigator.msSaveBlob) H.navigator.msSaveBlob(o, t);
  else {
    const n = H.document.createElement("a");
    H.document.body.appendChild(n);
    const a = H.URL.createObjectURL(o);
    n.href = a, n.download = t, n.click(), setTimeout((() => {
      H.URL.revokeObjectURL(a), H.document.body.removeChild(n);
    }), 0);
  }
}, vx = (r, t, e, i, s, o) => {
  const n = r.Ao(t, e, i, s, o, !0);
  return n.setDraggingMode(zr.draggable), n;
}, Do = (r, t) => {
  if (r === "relative") return t;
  if (r instanceof yr) return r;
  const e = r.x instanceof eo ? r.x.ai : r.x.x, i = r.y instanceof eo ? r.y.ai : r.y.y;
  return jm(e, i);
}, sc = (r, t, e, i, s) => {
  if (e) {
    const o = r, n = t, a = na(n) ? n : kr(n) ? i : void 0;
    if (a && Mo(e)) {
      const l = xt(o, a, s.ai);
      return s.cl({ engineX: l.x, engineY: l.y });
    }
    if (a && kr(e)) return xt(o, a, i);
    if (a && na(e)) return xt(o, a, e);
  } else {
    const o = r;
    if (kr(t)) {
      const n = s.ul(o);
      return xt({ x: n.engineX, y: n.engineY }, s.ai, i);
    }
    if (na(t)) {
      const n = t, a = s.ul(o);
      return xt({ x: a.engineX, y: a.engineY }, s.ai, n);
    }
  }
  throw new Error("translateCoordinate unexpected error. Input or target coordinate system not recognized.");
};
class Xi {
  constructor(t) {
    this.sg = [], this.eg = t;
  }
  rg() {
    return this.hg(), { add: () => this.ng(), finishPlot: () => {
      this.og();
    } };
  }
  ng() {
    let t = this.sg.find(((e) => e.isFree));
    return t || (t = { isFree: !1, shape: this.eg() }, this.sg.push(t)), t.isFree = !1, t.shape;
  }
  hg() {
    this.sg.forEach(((t) => {
      t.isFree = !0;
    }));
  }
  og() {
    this.sg.filter(((t) => t.isFree)).forEach(((t) => {
      t.shape.dispose(), this.sg.splice(this.sg.indexOf(t), 1);
    }));
  }
  ag() {
    this.sg.forEach(((t) => t.shape.dispose())), this.sg.length = 0;
  }
  Yn() {
    return this.sg.map(((t) => t.shape));
  }
}
const rc = (r) => {
  const t = r.layer, e = r.scale, i = r.panel, s = r.legend;
  let o;
  const n = i.yi.ks, a = /* @__PURE__ */ new Map(), l = (C, S, E, T) => {
    var I;
    a.has(C) || a.set(C, []), (I = a.get(C)) === null || I === void 0 || I.push({ eventType: S, callback: E }), C.addEventListener(S, E, T);
  }, h = () => {
    for (const [C, S] of a.entries()) for (const { eventType: E, callback: T } of S) C.removeEventListener(E, T);
    a.clear();
  }, u = [];
  let c = [], d = [];
  const f = new Xi((() => t.In(e).Tn(Me).Fn(Me))), p = new Xi((() => t.ef(e))), g = t.Od(e).sr(i.getTheme().uiBackgroundFillStyle).setVisible(!1), y = g.Qo().Nd({ extent: 8, c_x1_y1: !0, c_x1_y2: !0, c_x2_y1: !0, c_x2_y2: !0 }), m = i.getTheme().uiButtonFillStyle, A = i.getTheme().uiButtonFillStyleHidden, v = i.getTheme().uiTextFillStyle, b = i.getTheme().uiTextFillStyleHidden, w = i.getTheme().uiTextFont, k = i.getTheme().uiBackgroundFillStyle, R = i.getTheme().uiBackgroundStrokeStyle, L = i.getTheme().uiButtonStrokeStyle, x = () => {
    g.setVisible(!1), u.forEach(((C) => C.setVisible(!1).Uh())), c.forEach(((C) => C.setVisible(!1))), d.forEach(((C) => C.setVisible(!1)));
  }, M = (C) => {
    var S, E, T, I;
    h(), C.titleEvents.Vi(), C.backgroundEvents.Vi(), u.forEach(((st) => st.dispose())), u.length = 0;
    const F = f.rg(), D = p.rg(), P = (S = C.marginInner) !== null && S !== void 0 ? S : 0, V = C.marginOuter, _ = C.chartPadding, O = { left: V.left + _.left, right: V.right + _.right, top: V.top + _.top, bottom: V.bottom + _.bottom }, B = i.getSizePixels();
    let z, W = { x: -1, y: 1 };
    if (typeof C.position == "number") switch (C.position) {
      case zt.TopLeft:
      case zt.TopCenter:
      case zt.TopRight:
      case zt.BottomLeft:
      case zt.BottomCenter:
      case zt.BottomRight:
        z = { x: B.x - C.chartTitleSpace.left - C.chartTitleSpace.right - O.left - O.right, y: B.y - C.chartTitleSpace.top - C.chartTitleSpace.bottom - O.top - O.bottom };
        break;
      default:
        z = { x: B.x - O.left - O.right, y: B.y - O.top - O.bottom };
    }
    else C.position.origin && (W = C.position.origin), z = { x: B.x - C.position.x * (W.x + 1) / 2, y: C.position.y * (W.y + 1) / 2 };
    const G = C.orientation !== void 0 ? C.orientation === bd.Vertical : typeof C.position == "number" && C.position < 6, Y = (E = C.padding) !== null && E !== void 0 ? E : { left: 5, right: 5, top: 5, bottom: 5 }, U = Y.top + Y.bottom, $ = Y.left + Y.right, Z = (T = C.entryMargin) !== null && T !== void 0 ? T : 10, q = { left: Z, right: Z, top: Z, bottom: Z }, Q = r.panel.getTheme().uiButtonSize;
    let nt = 0, et = 0, it = 0, rt = 0;
    const tt = [], at = C.title ? F.add().ru({ x: -1, y: 0 }).rn(C.title).Ih(C.titleFont ? new qn(C.titleFont) : w.setWeight("bold")).sr((I = C.titleFillStyle) !== null && I !== void 0 ? I : v).Tn(q) : void 0;
    if (at) {
      const st = at.setVisible(!0).Uh().Bc();
      it = G ? st.y : st.x + Z, rt = G ? st.x : st.y, nt = st.x, et = st.y, C.titleEvents.zi(at);
    }
    const ut = C.entries.filter(((st) => st.options.show !== !1));
    return { entries: ut.map(((st, bt) => {
      var ct, Mt;
      const vt = st.options.text !== void 0 ? st.options.text : st.component && "getName" in st.component ? st.component.getName() : "", mt = st.component && st.component.getVisible ? st.component.getVisible() ? st.options.textFillStyle !== void 0 ? st.options.textFillStyle : v : b : st.options.textFillStyle !== void 0 ? st.options.textFillStyle : v, Xt = st.options.textFont ? new qn(st.options.textFont) : w, Rt = F.add().ru({ x: -1, y: 0 }).rn(vt).sr(mt).Ih(Xt).Tn(q), Dt = st.options.buttonShape !== void 0 ? st.options.buttonShape : st.component && st.component.Xs ? st.component.Xs() : Je.Circle, Kt = Pn(Dt);
      Kt && Dt.qs instanceof Image && l(Dt.qs, "load", (() => {
        s.Gs();
      }));
      const _t = st.component && st.component.getVisible ? st.component.getVisible() ? st.options.buttonFillStyle !== void 0 ? st.options.buttonFillStyle : st.component && st.component.nr ? Bl(i.getTheme(), st.options.matchStyleExactly || !1, st.component.nr()) : m : A : st.options.buttonFillStyle !== void 0 ? st.options.buttonFillStyle : st.component && st.component.nr ? Bl(i.getTheme(), st.options.matchStyleExactly || !1, st.component.nr()) : m, Ut = (ct = st.options.buttonStrokeStyle) !== null && ct !== void 0 ? ct : L, te = st.options.buttonSize !== void 0 ? st.options.buttonSize : Kt ? Math.max(Dt.Ft().x, Dt.Ft().y) : vt ? Q : 0, ye = st.options.buttonRotation !== void 0 ? st.options.buttonRotation : st.component && st.component.getPointRotation ? st.component.getPointRotation() : 0, ne = D.add().lg({ x: -1, y: 0 }).df(te).nf(ye);
      _t && ne.tf(_t), Dt !== void 0 && ne.rf(Dt), ne.uf(Ut);
      const ti = st.options.lut === null ? void 0 : st.options.lut ? st.options.lut : st.component && st.component.Ws ? (Mt = st.component.Ws()) === null || Mt === void 0 ? void 0 : Mt.lut : void 0;
      let fe;
      ti && (fe = new px(t, e, e, (() => {
      }), i.getTheme(), G ? "vertical" : "horizontal").Vf(ti), u.push(fe), fe.Vf(ti).setVisible(!0).ru(G ? "vertical" : "horizontal").setFillStyle(mt).setFont(Xt).setMargin(Z).zf(Me), st.options.lutLength && fe.Gf(st.options.lutLength), st.options.lutThickness && fe.Uf(st.options.lutThickness), st.options.lutDisplayProportionalSteps && fe.setLUTDisplayProportionalSteps(st.options.lutDisplayProportionalSteps), st.options.lutStepValueFormatter && fe.Wf(st.options.lutStepValueFormatter), ti.units && fe.Yf(ti.units)), n.ws(Rt, ((ft) => {
        Rt.Ii(ft);
      }), { animationEnabled: !0 }), n.ws(ne, ((ft) => {
        ne.Ii(ft);
      }), { animationEnabled: !0 });
      const ve = st.component && Fm(st.component) ? st.component : void 0;
      ve && l(ve, "highlightchange", ((ft) => {
        const Tt = ft.highlight;
        Rt.Ii(Tt), ne.Ii(Tt), i.yi.Rs();
      })), [Rt, ne].forEach(((ft) => {
        ft && (l(ft, "pointerenter", (() => {
          st.options.highlight !== !1 && (ve && ve.setHighlight(!0), Rt.Ii(1), ne.Ii(1));
        })), l(ft, "pointerleave", (() => {
          ve && ve.setHighlight(!1), Rt.Ii(0), ne.Ii(0);
        })));
      })), [Rt, ne, fe].forEach(((ft) => {
        ft && (l(ft, "pointerenter", (() => {
          i.engine.setMouseStyle(Gt.Point);
        })), l(ft, "pointerleave", (() => {
          i.engine.clearMouseStyle();
        })), st.options.events && Object.entries(st.options.events).forEach((([Tt, oe]) => {
          l(ft, Tt, ((vi) => oe(vi, { entry: st, allEntries: ut })));
        })), l(ft, "click", (() => {
          s.Gs(), i.yi.Rs();
        })));
      }));
      const ci = Rt.setVisible(!0).Uh().Bc();
      let At = { length: 0, thickness: 0 };
      if (fe) {
        const ft = fe.Uh().getSize();
        At = G ? { length: ft.y, thickness: ft.x } : { length: ft.x, thickness: ft.y };
      }
      const yt = G ? { width: (te ? Z + te : 0) + Math.max(ci.x, At.thickness), height: Math.max(te, ci.y) + At.length } : { width: (te ? Z + te : 0) + ci.x + At.length, height: Math.max(te, ci.y, At.thickness) };
      return nt = Math.max(yt.width, nt), et = Math.max(yt.height, et), (G ? it + yt.height < z.y - U : it + yt.width < z.x - $) ? (rt = Math.max(G ? yt.width : yt.height, rt), it += G ? yt.height : yt.width, bt === ut.length - 1 && tt.push(G ? { width: rt, height: tt.length === 0 ? it : z.y - U } : { width: tt.length === 0 ? it : z.x - $, height: rt })) : (tt.push(G ? { width: rt, height: z.y - U } : { width: z.x - $, height: rt }), it = G ? yt.height : yt.width, bt === ut.length - 1 && tt.push(G ? { width: yt.width, height: z.y - U } : { width: z.x - $, height: yt.height }), rt = G ? yt.width : yt.height), { text: vt ? Rt : void 0, button: vt && te !== 0 ? ne : void 0, buttonSize: te, lut: fe };
    })), sectionSizes: tt, legendTitle: at, isVertical: G, availableChartSize: z, horizontalLegendPadding: $, verticalLegendPadding: U, marginInner: P, totalMarginOuter: O, maxEntryWidth: nt, maxEntryHeight: et, chartSize: B, legendSpace: { left: 0, right: 0, top: 0, bottom: 0 }, origin: W, legendPadding: Y, entryMarginValue: Z, shapeProviderText: F, shapeProviderMarker: D };
  };
  return { update: (C) => {
    if (!C.visible || C.renderOnTop) return Me;
    const S = M(C);
    o = S;
    const { entries: E, sectionSizes: T, isVertical: I, availableChartSize: F, horizontalLegendPadding: D, verticalLegendPadding: P, marginInner: V, totalMarginOuter: _, maxEntryWidth: O, maxEntryHeight: B, legendSpace: z, shapeProviderText: W, shapeProviderMarker: G } = S;
    if (W.finishPlot(), G.finishPlot(), E.length === 0 && T.length === 0) return Me;
    const Y = Mg(I, T, D, P, F);
    if (C.autoHideThreshold && Eg(C.autoHideThreshold, Y, F, I, O, B)) return Me;
    const U = { ...z }, $ = C.chartPadding, Z = Math.max(0, _.left - $.left), q = Math.max(0, _.right - $.right), Q = Math.max(0, _.top - $.top), nt = Math.max(0, _.bottom - $.bottom);
    switch (C.position) {
      case zt.RightTop:
      case zt.RightCenter:
      case zt.RightBottom:
        U.right = Y.width + V + q;
        break;
      case zt.LeftTop:
      case zt.LeftCenter:
      case zt.LeftBottom:
        U.left = Y.width + V + Z;
        break;
      case zt.TopLeft:
      case zt.TopCenter:
      case zt.TopRight:
        U.top = Y.height + V + Q;
        break;
      case zt.BottomLeft:
      case zt.BottomCenter:
      case zt.BottomRight:
        U.bottom = Y.height + V + nt;
    }
    return U;
  }, plot: (C) => {
    var S;
    if (!C.visible) return void x();
    const E = o || M(C);
    o = void 0;
    const { entries: T, sectionSizes: I, legendTitle: F, isVertical: D, availableChartSize: P, horizontalLegendPadding: V, verticalLegendPadding: _, chartSize: O, maxEntryWidth: B, maxEntryHeight: z, origin: W, legendPadding: G, entryMarginValue: Y, shapeProviderText: U, shapeProviderMarker: $, totalMarginOuter: Z } = E;
    if (c = f.Yn(), d = p.Yn(), T.length === 0 && I.length === 0) return x(), U.finishPlot(), void $.finishPlot();
    const q = Mg(D, I, V, _, P);
    if (C.autoHideThreshold && Eg(C.autoHideThreshold, q, P, D, B, z)) return x(), U.finishPlot(), void $.finishPlot();
    const Q = (W.x + 1) * q.width / 2, nt = (W.y + 1) * q.height / 2;
    c.forEach(((ct) => ct.setVisible(!0))), d.forEach(((ct) => ct.setVisible(!0)));
    const et = C.chartTitleSpace;
    let it = { leftBottom: { x: 0, y: 0 }, leftTop: { x: 0, y: 0 }, rightTop: { x: 0 }, rightBottom: { x: 0 } };
    switch (C.position) {
      case zt.RightTop:
      case zt.RightCenter:
      case zt.RightBottom:
        it = { leftBottom: { x: O.x - q.width - Z.right, y: 0 + Z.bottom }, leftTop: { x: O.x - q.width - Z.right, y: O.y - Z.top }, rightTop: { x: O.x - Z.right, y: O.y - Z.top }, rightBottom: { x: O.x - Z.right, y: 0 + Z.bottom } };
        break;
      case zt.LeftTop:
      case zt.LeftCenter:
      case zt.LeftBottom:
        it = { leftBottom: { x: 0 + Z.left, y: 0 + Z.bottom }, leftTop: { x: 0 + Z.left, y: O.y - Z.top }, rightTop: { x: q.width + Z.left, y: O.y - Z.top }, rightBottom: { x: q.width + Z.left, y: 0 + Z.bottom } };
        break;
      case zt.TopLeft:
      case zt.TopCenter:
      case zt.TopRight:
        it = { leftBottom: { x: 0 + Z.left, y: O.y - q.height - Z.top - et.top }, leftTop: { x: 0 + Z.left, y: O.y - Z.top - et.top }, rightTop: { x: O.x - Z.right, y: O.y - Z.top - et.top }, rightBottom: { x: O.x - Z.right, y: O.y - q.height - Z.top - et.top } };
        break;
      case zt.BottomLeft:
      case zt.BottomCenter:
      case zt.BottomRight:
        it = { leftBottom: { x: 0 + Z.left, y: 0 + Z.bottom + et.bottom }, leftTop: { x: 0 + Z.left, y: q.height + Z.bottom + et.bottom }, rightTop: { x: O.x - Z.right, y: q.height + Z.bottom + et.bottom }, rightBottom: { x: O.x - Z.right, y: 0 + Z.bottom + et.bottom } };
        break;
      default:
        it = { leftBottom: { x: C.position.x - Q, y: C.position.y - nt }, leftTop: { x: C.position.x - Q, y: C.position.y - nt + q.height }, rightTop: { x: C.position.x - Q + q.width, y: C.position.y - nt + q.height }, rightBottom: { x: C.position.x - Q + q.width, y: C.position.y - nt } };
    }
    if (C.backgroundVisible) {
      let ct = { x: 0, y: 0 };
      const Mt = q.width, vt = q.height;
      switch (C.position) {
        case zt.RightTop:
          ct = { x: O.x - q.width - Z.right, y: O.y - q.height - Z.top };
          break;
        case zt.RightCenter:
          ct = { x: O.x - q.width - Z.right, y: O.y / 2 - q.height / 2 - Z.top / 2 + Z.bottom / 2 };
          break;
        case zt.RightBottom:
          ct = { x: O.x - q.width - Z.right, y: 0 + Z.bottom };
          break;
        case zt.LeftTop:
          ct = { x: 0 + Z.left, y: O.y - q.height - Z.top };
          break;
        case zt.LeftCenter:
          ct = { x: 0 + Z.left, y: O.y / 2 - q.height / 2 - Z.top / 2 + Z.bottom / 2 };
          break;
        case zt.LeftBottom:
          ct = { x: 0 + Z.left, y: 0 + Z.bottom };
          break;
        case zt.TopLeft:
          ct = { x: 0 + Z.left, y: O.y - q.height - Z.top - et.top };
          break;
        case zt.TopCenter:
          ct = { x: O.x / 2 - q.width / 2 + Z.left / 2 - Z.right / 2, y: O.y - q.height - Z.top - et.top };
          break;
        case zt.TopRight:
          ct = { x: O.x - q.width - Z.right, y: O.y - q.height - Z.top - et.top };
          break;
        case zt.BottomLeft:
          ct = { x: 0 + Z.left, y: 0 + Z.bottom + et.bottom };
          break;
        case zt.BottomCenter:
          ct = { x: O.x / 2 - q.width / 2 + Z.left / 2 - Z.right / 2, y: 0 + Z.bottom + et.bottom };
          break;
        case zt.BottomRight:
          ct = { x: O.x - q.width - Z.right, y: 0 + Z.bottom + et.bottom };
          break;
        default:
          ct = { x: C.position.x - Q, y: C.position.y - nt };
      }
      y.Gd(ct.x, ct.y, ct.x + Mt, ct.y + vt);
    }
    C.backgroundEvents.zi(g), g.setVisible((S = C.backgroundVisible) === null || S === void 0 || S), g.sr(C.backgroundFillStyle !== void 0 ? C.backgroundFillStyle : k), g.ir(C.backgroundStrokeStyle !== void 0 ? C.backgroundStrokeStyle : R);
    let rt = { x: 0, y: 0 };
    switch (C.position) {
      case zt.LeftTop:
      case zt.RightTop:
        rt = { x: it.leftTop.x, y: it.leftTop.y };
        break;
      case zt.LeftCenter:
      case zt.RightCenter:
        rt = { x: it.leftBottom.x, y: it.leftBottom.y + (it.leftTop.y - it.leftBottom.y) / 2 + q.height / 2 };
        break;
      case zt.LeftBottom:
      case zt.RightBottom:
        rt = { x: it.leftBottom.x, y: it.leftBottom.y + q.height };
        break;
      case zt.TopLeft:
      case zt.BottomLeft:
        rt = { x: it.leftTop.x, y: it.leftTop.y };
        break;
      case zt.TopCenter:
      case zt.BottomCenter:
        rt = { x: it.leftBottom.x + (it.rightBottom.x - it.leftBottom.x) / 2 - q.width / 2, y: it.leftTop.y };
        break;
      case zt.TopRight:
      case zt.BottomRight:
        rt = { x: it.rightTop.x - q.width, y: it.leftTop.y };
        break;
      default:
        rt = { x: it.leftTop.x, y: it.leftTop.y };
    }
    rt = { x: rt.x + G.left, y: rt.y - G.top };
    const tt = { ...rt };
    let at = 0, ut = 0;
    const ht = [];
    let st = [];
    if (F) {
      const ct = F.Bc();
      F.hr({ ...rt, y: rt.y - ct.y / 2 }), ut += D ? ct.y : ct.x + Y, rt = D ? { ...rt, y: rt.y - ct.y } : { ...rt, x: rt.x + ct.x + Y };
    }
    T.forEach(((ct) => {
      const Mt = ct.text ? ct.text.Bc() : { x: 0, y: 0 }, vt = ct.button ? ct.buttonSize : 0, mt = ct.lut || void 0, Xt = p2(Mt, vt, D, Y, ct.lut);
      ut + Xt >= (D ? I[at].height : I[at].width) && I.length - 1 > at && (ht.push(st), st = [], at += 1, ut = 0), st.push({ entry: ct, textSize: Mt, buttonSize: vt, lut: mt, entryLength: Xt }), ut += Xt;
    })), st.length > 0 && ht.push(st);
    const bt = ht.map(((ct, Mt) => {
      const vt = ct.reduce(((mt, Xt) => mt + Xt.entryLength), 0);
      if (Mt === 0 && F) {
        const mt = F.Bc();
        return vt + (D ? mt.y : mt.x + Y);
      }
      return vt;
    }));
    ht.forEach(((ct, Mt) => {
      let vt;
      const mt = bt[Mt], Xt = ht.length > 1;
      if (Mt === 0) if (Xt) if (D) {
        const Dt = I[Mt].height - mt;
        vt = { x: tt.x, y: tt.y - Dt / 2 };
      } else {
        const Dt = I[Mt].width - mt;
        vt = { x: tt.x + Dt / 2, y: tt.y };
      }
      else vt = { ...tt };
      else if (D) {
        const Dt = I.slice(0, Mt).reduce(((Ut, te) => Ut + te.width), 0), Kt = I[Mt].height;
        let _t;
        if (Xt) {
          const Ut = Kt - mt;
          let te;
          switch (C.position) {
            case zt.LeftTop:
            case zt.RightTop:
              te = it.leftTop.y - G.top;
              break;
            case zt.LeftCenter:
            case zt.RightCenter:
              te = it.leftBottom.y + (it.leftTop.y - it.leftBottom.y) / 2 + Kt / 2;
              break;
            case zt.LeftBottom:
            case zt.RightBottom:
              te = it.leftBottom.y + Kt + G.bottom;
              break;
            default:
              te = tt.y;
          }
          _t = te - Ut / 2;
        } else _t = tt.y;
        vt = { x: tt.x + Dt, y: _t };
      } else {
        const Dt = I.slice(0, Mt).reduce(((Ut, te) => Ut + te.height), 0), Kt = I[Mt].width;
        let _t;
        if (Xt) {
          const Ut = Kt - mt;
          let te;
          switch (C.position) {
            case zt.TopLeft:
            case zt.BottomLeft:
              te = it.leftTop.x + G.left;
              break;
            case zt.TopCenter:
            case zt.BottomCenter:
              te = it.leftBottom.x + (it.rightBottom.x - it.leftBottom.x) / 2 - Kt / 2;
              break;
            case zt.TopRight:
            case zt.BottomRight:
              te = it.rightTop.x - Kt - G.right;
              break;
            default:
              te = tt.x;
          }
          _t = te + Ut / 2;
        } else _t = tt.x;
        vt = { x: _t, y: tt.y - Dt };
      }
      if (Mt === 0 && F) {
        const Dt = F.Bc();
        D ? (F.hr({ x: vt.x, y: vt.y - Dt.y / 2 }), vt = { ...vt, y: vt.y - Dt.y }) : (F.hr({ x: vt.x, y: vt.y - Dt.y / 2 }), vt = { ...vt, x: vt.x + Dt.x + Y });
      }
      let Rt = { ...vt };
      ct.forEach(((Dt) => {
        y2(Rt, Dt.entry.button, Dt.entry.text, Dt.lut, Dt.textSize, Dt.buttonSize, D, Y), Rt = D ? { ...Rt, y: Rt.y - Dt.entryLength } : { ...Rt, x: Rt.x + Dt.entryLength };
      }));
    })), U.finishPlot(), $.finishPlot();
  }, dispose: () => {
    h(), f.ag(), p.ag(), g.dispose(), u.forEach(((C) => C.dispose()));
  } };
}, Eg = (r, t, e, i, s, o) => (i ? Math.ceil(t.width) >= Math.ceil(e.x * r) : Math.ceil(t.height) >= Math.ceil(e.y * r)) || s > e.x || o > e.y, Mg = (r, t, e, i, s) => r ? { width: t.reduce(((o, n) => o + n.width), 0) + e, height: t.length > 1 ? s.y : t[0].height + i } : { width: t.length > 1 ? s.x : t[0].width + e, height: t.reduce(((o, n) => o + n.height), 0) + i }, p2 = (r, t, e, i = 0, s) => {
  if (s) {
    const o = s.Uh().getSize(), n = e ? { length: o.y, thickness: o.x } : { length: o.x, thickness: o.y };
    return e ? Math.max(t, r.y) + n.length : (t ? i + t : 0) + r.x + n.length;
  }
  return e ? Math.max(t, r.y) : (t ? i + t : 0) + r.x;
}, y2 = (r, t, e, i, s, o, n, a = 0) => {
  let l, h;
  if (s.y > o ? (l = { x: r.x + (o ? a : 0), y: r.y - s.y / 2 }, h = { x: l.x + o, y: r.y - s.y / 2 }) : (l = { x: r.x + (o ? a : 0), y: r.y - o / 2 }, h = { x: l.x + o, y: r.y - o / 2 }), t && t.qd(new cr({ schema: { x: {}, y: {} } }).appendSample(l), { x: "x", y: "y" }), e && e.hr(h), i) {
    const u = i.Uh().getSize(), c = n ? { length: u.y, thickness: u.x } : { length: u.x, thickness: u.y }, d = n ? { x: h.x + c.thickness / 2, y: r.y - Math.max(o, s.y) - c.length / 2 } : { x: h.x + s.x + c.length / 2, y: r.y - c.thickness / 2 };
    i.setPosition(d), i.rr();
  }
}, bl = (r) => "Ws" in r;
var zt, bd;
(function(r) {
  r[r.RightTop = 0] = "RightTop", r[r.RightCenter = 1] = "RightCenter", r[r.RightBottom = 2] = "RightBottom", r[r.LeftTop = 3] = "LeftTop", r[r.LeftCenter = 4] = "LeftCenter", r[r.LeftBottom = 5] = "LeftBottom", r[r.TopLeft = 6] = "TopLeft", r[r.TopCenter = 7] = "TopCenter", r[r.TopRight = 8] = "TopRight", r[r.BottomLeft = 9] = "BottomLeft", r[r.BottomCenter = 10] = "BottomCenter", r[r.BottomRight = 11] = "BottomRight";
})(zt || (zt = {})), (function(r) {
  r[r.Horizontal = 0] = "Horizontal", r[r.Vertical = 1] = "Vertical";
})(bd || (bd = {}));
const Cg = { toggleIndividualVisibility: (r, t) => {
  if (!t.entry.component || !t.entry.component.getVisible || !t.entry.component.setVisible) return;
  const e = t.entry.component.getVisible();
  t.entry.component.setVisible(!e);
} };
class Uf {
  constructor(t, e, i, s, o, n) {
    var a;
    this.ug = [], this.cg = !0, this.Rn = zt.BottomCenter, this.Wr = void 0, this.dg = !1, this.Ag = !1, this.gg = !0, this.vg = !1, this.yg = { left: 0, right: 0, top: 0, bottom: 0 }, this.ci = !1, this.pg = 5, this.mg = { x: 0, y: 0 }, this.Sg = !0, this.bg = 0.5, this.xg = [], this.Mg = !1, this.title = new Nt(), this.background = new Nt(), this._g = e, this.wg = (a = e.getTheme().panelPadding) !== null && a !== void 0 ? a : 7, this.kg = { events: { click: Cg.toggleIndividualVisibility } }, t !== rc && (this.dg = !0);
    const l = this.dg ? { panel: e } : { panel: e, layer: i, scale: s, legend: this };
    this.Cg = t(l), o && (this.ug = o), n && this.setOptions(n), this._g.yi.Rs();
    const h = () => {
      H.setTimeout((() => {
        this.Gs(), this._g.yi.Rs();
      }), 0);
    };
    H.setTimeout((() => {
      this.ci || this._g.addEventListener("resize", h);
    }), 0), this.Tg = () => {
      this._g.removeEventListener("resize", h);
    };
  }
  Fg(t, e) {
    const i = t && typeof t == "number" ? { ...Me, top: t } : t && typeof t != "number" ? t : Me;
    let s = { visible: this.ug.length > 0 && this.cg, chartTitleSpace: i, marginOuter: this.yg, chartPadding: e, titleEvents: this.title, backgroundEvents: this.background, position: this.Rn, orientation: this.Ig, padding: this.Hn ? this.Hn : this.Ag ? { left: 5, right: 5, top: 5, bottom: 5 } : Me, entryMargin: this.pg, marginInner: this.wg, renderOnTop: this.vg, title: this.Wr, titleFont: this.Pg, titleFillStyle: this.Lg, backgroundVisible: this.Ag, backgroundFillStyle: this.Bg, backgroundStrokeStyle: this.Dg, autoHideThreshold: this.bg, entries: this.ug };
    if (this.dg) {
      const o = this._g.getTheme().uiTextFillStyle, n = this._g.getTheme().uiButtonFillStyle, a = this._g.getTheme().uiTextFont, l = this.ug.map(((h) => {
        var u, c, d, f, p;
        return { component: h.component, options: { ...h.options, show: (u = h.options.show) === null || u === void 0 || u, text: (c = h.options.text) !== null && c !== void 0 ? c : h.component && h.component.getName ? h.component.getName() : "", textFont: h.options.textFont ? h.options.textFont : a, textFillStyle: h.options.textFillStyle ? h.options.textFillStyle : o, buttonSize: (d = h.options.buttonSize) !== null && d !== void 0 ? d : 10, buttonShape: (f = h.options.buttonShape) !== null && f !== void 0 ? f : Je.Circle, buttonRotation: (p = h.options.buttonRotation) !== null && p !== void 0 ? p : 0, buttonFillStyle: h.component && h.component.nr ? Bl(this._g.getTheme(), h.options.matchStyleExactly || !1, h.component.nr()) : n, events: { click: Cg.toggleIndividualVisibility, ...h.options.events } } };
      }));
      s = { ...s, entries: l };
    }
    return s;
  }
  Eg() {
    let t = !1;
    const e = this._g.getSizePixels(), i = this._g.getMinimumSize(), s = i === void 0 || e.x > i.x && e.y > i.y;
    return e.x === this.mg.x && e.y === this.mg.y && s || (t = !0), this.mg = e, t;
  }
  Rg() {
    const t = this.ug.map(((i) => ({ entryText: i.component && i.component.getName ? i.component.getName() : void 0, buttonShape: i.component && i.component.Xs ? i.component.Xs() : void 0, legendStyle: i.component && i.component.nr ? i.component.nr() : void 0 })));
    if (this.xg.length !== t.length) return this.xg = t, !0;
    const e = t.some(((i, s) => {
      var o, n, a, l;
      const h = this.xg[s];
      if (i.entryText !== h.entryText || i.buttonShape !== h.buttonShape || i.legendStyle && h.legendStyle && (i.legendStyle.fill !== h.legendStyle.fill || i.legendStyle.fill2 !== h.legendStyle.fill2 || i.legendStyle.stroke !== h.legendStyle.stroke || i.legendStyle.point3D !== h.legendStyle.point3D || ((o = i.legendStyle.behavior) === null || o === void 0 ? void 0 : o.colorStep) !== ((n = h.legendStyle.behavior) === null || n === void 0 ? void 0 : n.colorStep) || ((a = i.legendStyle.behavior) === null || a === void 0 ? void 0 : a.priority) !== ((l = h.legendStyle.behavior) === null || l === void 0 ? void 0 : l.priority) || i.legendStyle.lutValue !== h.legendStyle.lutValue))
        return !0;
    }));
    return this.xg = t, e;
  }
  Og() {
    this.Mg || this.Rn === zt.RightCenter || this.ug.some(((t) => {
      var e;
      return !!(t.component && t.component.Ws && (!((e = t.component.Ws()) === null || e === void 0) && e.lut) || EA(t.component) || t.options.lut);
    })) && (this.Rn = zt.RightCenter, this.Sg = !0);
  }
  Uh(t, e) {
    var i;
    if (this.ci) return Me;
    if ((this.Eg() || this.Rg()) && (this.Sg = !0), this.Og(), !this.Sg && !this.dg) return (i = this.zg) !== null && i !== void 0 ? i : Me;
    const s = this.Fg(t, e), o = this.Cg.update(s);
    return this.zg = o || Me, this.zg;
  }
  rr(t, e) {
    if (!this.ci && this.Sg) {
      const i = this.Fg(t, e);
      this.Cg.plot(i), this.Sg = !1;
    }
  }
  Pu(t, e) {
    if (t === void 0 || !this.ug.some(((i) => i.component === t))) {
      if (this.ug.push({ component: t, options: { ...this.kg, ...e } }), t instanceof to) {
        const i = () => {
          this.Gs(), this._g.yi.Rs();
        }, s = () => {
          t.removeEventListener("dispose", s), t.removeEventListener("visiblechange", i), this.remove(t), this._g.yi.Rs();
        };
        t.addEventListener("visiblechange", i), t.addEventListener("dispose", s);
      }
      return this.Sg = !0, this;
    }
  }
  Vg() {
    return this.gg;
  }
  Gs() {
    return this.Sg = !0, this;
  }
  Ng(t) {
    const e = (t = Array.isArray(t) ? t : [t]).map(((s) => bl(s) ? this.ug.find(((o) => o.component === s)) : this.ug.find(((o) => {
      var n, a, l;
      return ((n = o.component) === null || n === void 0 ? void 0 : n.Ws) && ((l = (a = o.component) === null || a === void 0 ? void 0 : a.Ws()) === null || l === void 0 ? void 0 : l.lut) === s;
    })))).filter(((s) => s !== void 0)), i = this.ug.filter(((s) => !e.includes(s)));
    return this.ug = [...e, ...i], this.Sg = !0, this._g.yi.Rs(), this;
  }
  add(t, e) {
    return t === void 0 && e === void 0 || (t instanceof Rr ? t.Gg().forEach(((i) => this.Pu(i, e))) : t && !bl(t) ? this.Pu({ Ws: () => ({ lut: t }) }, e) : this.Pu(t, e), this.Sg = !0, this._g.yi.Rs()), this;
  }
  remove(t) {
    const e = this.ug.find(((i) => i.component === t));
    if (e) {
      const i = this.ug.indexOf(e);
      this.ug.splice(i, 1);
    }
    return this.Sg = !0, this._g.yi.Rs(), this;
  }
  clear() {
    return this.ug = [], this.Sg = !0, this._g.yi.Rs(), this;
  }
  dispose() {
    return this.ci || (this.ci = !0, this.Tg(), this.Cg.dispose && this.Cg.dispose(), this.Sg = !0, this._g.yi.Rs()), this;
  }
  setOptions(t) {
    var e, i, s, o, n, a, l, h;
    return t.addEntriesAutomatically !== void 0 && (this.gg = t.addEntriesAutomatically), t.position !== void 0 && (this.Rn = t.position, this.Mg = !0), t.orientation !== void 0 && (this.Ig = t.orientation), t.padding !== void 0 && (typeof t.padding == "number" ? this.Hn = { left: t.padding, right: t.padding, top: t.padding, bottom: t.padding } : this.Hn = { left: (e = t.padding.left) !== null && e !== void 0 ? e : 0, right: (i = t.padding.right) !== null && i !== void 0 ? i : 0, top: (s = t.padding.top) !== null && s !== void 0 ? s : 0, bottom: (o = t.padding.bottom) !== null && o !== void 0 ? o : 0 }), t.marginOuter !== void 0 && (typeof t.marginOuter == "number" ? this.yg = { left: t.marginOuter, right: t.marginOuter, top: t.marginOuter, bottom: t.marginOuter } : this.yg = { left: (n = t.marginOuter.left) !== null && n !== void 0 ? n : 0, right: (a = t.marginOuter.right) !== null && a !== void 0 ? a : 0, top: (l = t.marginOuter.top) !== null && l !== void 0 ? l : 0, bottom: (h = t.marginOuter.bottom) !== null && h !== void 0 ? h : 0 }), t.entryMargin !== void 0 && (this.pg = t.entryMargin), t.marginInner !== void 0 && (this.wg = t.marginInner), t.renderOnTop !== void 0 && (this.vg = t.renderOnTop), t.title !== void 0 && (this.Wr = t.title), t.titleFont !== void 0 && (this.Pg = t.titleFont), t.titleFillStyle !== void 0 && (this.Lg = t.titleFillStyle), t.visible !== void 0 && (this.cg = t.visible), t.backgroundVisible !== void 0 && (this.Ag = t.backgroundVisible), t.backgroundFillStyle !== void 0 && (this.Bg = t.backgroundFillStyle), t.backgroundStrokeStyle !== void 0 && (this.Dg = t.backgroundStrokeStyle), t.autoHideThreshold !== void 0 && (this.bg = t.autoHideThreshold), t.entries !== void 0 && (this.kg = { ...this.kg, ...t.entries }, this.ug.forEach(((u) => {
      u.options = { ...this.kg, ...u.options };
    }))), this.Sg = !0, this._g.yi.Rs(), this;
  }
  getOptions() {
    return { addEntriesAutomatically: this.gg, position: this.Rn, orientation: this.Ig, padding: this.Hn, marginOuter: this.yg, entryMargin: this.pg, marginInner: this.wg, renderOnTop: this.vg, title: this.Wr, titleFont: new qn(this.Pg), titleFillStyle: this.Lg, visible: this.cg, backgroundVisible: this.Ag, backgroundFillStyle: this.Bg, backgroundStrokeStyle: this.Dg, autoHideThreshold: this.bg, entries: this.kg };
  }
  setEntryOptions(t, e) {
    const i = bl(t) ? this.ug.find(((s) => s.component === t)) : this.ug.find(((s) => {
      var o, n, a;
      return ((o = s.component) === null || o === void 0 ? void 0 : o.Ws) && ((a = (n = s.component) === null || n === void 0 ? void 0 : n.Ws()) === null || a === void 0 ? void 0 : a.lut) === t;
    }));
    return i && (i.options = { ...i.options, ...e }), this.Sg = !0, this._g.yi.Rs(), this;
  }
  getEntryOptions(t) {
    const e = bl(t) ? this.ug.find(((i) => i.component === t)) : this.ug.find(((i) => {
      var s, o, n;
      return ((s = i.component) === null || s === void 0 ? void 0 : s.Ws) && ((n = (o = i.component) === null || o === void 0 ? void 0 : o.Ws()) === null || n === void 0 ? void 0 : n.lut) === t;
    }));
    if (e) return e.options;
  }
  getEntries() {
    return this.ug;
  }
}
class Sx {
  constructor(t, e, i, s, o, n, a, l, h) {
    this.coordsRelative = "relative", this.coordsClient = "client", this.$g = [], this.Ns = [], this.Ug = void 0, this.jg = void 0, this.Yg = void 0, this.dt = To(0, 0, 0, 0), this.Hg = !1, this.ci = !1, this.Wg = () => {
      this.Xg = !0, this.Zg.Rs();
    }, this.Jg = (d) => (f) => {
      const p = this.$g.indexOf(f);
      p !== -1 && this.$g.splice(p, 1), this.yi.Rs(), d.G();
    }, this.Xg = !0, this.background = new Nt(), this.Qg = t, this.Kg = i, this.Zg = s, this.removePanel = o, this.xi = e.yi.xi;
    const u = e.yi.Ft();
    this.uiScale = i.d2({ scaleXYConstructor: we }).ii(0, 100).si(0, 100).K(u), this.xA = i.d2({ scaleXYConstructor: we }).ii(0, this.uiScale.x.getCellSize()).si(0, this.uiScale.y.getCellSize()).K(u), this.engine = e.yi.qg, this.yi = e.yi.Dc, this.bs = this.yi.bs.xs(this, {}), this.tv = () => e.ev("unidentified ui"), this.rv = e.hv(), this.nv = this.Zg.er(this.uiScale).hr(j(0, 0)).K(j(100, 100)).sr(n).ir(a), this.background.zi(this.nv), l ? (l.addEventListener("resize", this.Wg), this.ov = () => l.removeEventListener("resize", this.Wg)) : (e.yi.O("resize", this.Wg), this.av = () => e.yi.N("resize", this.Wg));
    const c = (d) => {
      this.Hg = d.isInView, this.D.R("inviewchanged", { isInView: this.Hg });
    };
    e.yi.O("inviewchanged", c), this.lv = () => e.yi.N("inviewchanged", c), this.Ug = o, this.legend = new Uf(h ?? rc, this, this.rv, this.xA), this.Ns = [this.legend];
  }
  setPauseRendering(t, e) {
    return this.yi.uv(t, e), this;
  }
  getTheme() {
    return this.xi;
  }
  getSizePixels() {
    return this.xA.getInnerIntervalPixels();
  }
  setBackgroundFillStyle(t) {
    return this.nv.sr(t), this.Zg.Rs(), this;
  }
  getBackgroundFillStyle() {
    return this.nv.kh();
  }
  setBackgroundStrokeStyle(t) {
    return this.nv.ir(t), this.Zg.Rs(), this;
  }
  getBackgroundStrokeStyle() {
    return this.nv.hl();
  }
  translateCoordinate(t, e, i) {
    return sc(t, e, i, this.xA, this.yi);
  }
  cv(t) {
    return this.$g.push(t), this.yi.Rs(), t;
  }
  addUIElement(t = Gf, e = this.uiScale) {
    e = Do(e, this.xA);
    const i = this.tv();
    return this.cv(vx(t, i, this.uiScale, e, this.Jg(i), this.xi));
  }
  dispose() {
    return this.ci || (this.ci = !0, this.av && this.av(), this.ov && this.ov(), wa(this.uiScale), wa(this.xA), this.lv && this.lv(), this.jg && this.jg(), this.Zg.G(), this.rv.G(), this.$g.slice().forEach(((t) => {
      t.dispose();
    })), this.Ns.forEach(((t) => t.dispose())), this.yi.Rs(), this.Ug && this.Ug(this), this.D.R("dispose", {})), this;
  }
  isDisposed() {
    return this.ci;
  }
  saveToFile(t, e, i, s) {
    return xx(this.engine, t, e, i, s), this;
  }
  Tn(t) {
    this.dt = t, this.Wg();
  }
  W() {
    return this.xA.W(), this.uiScale.W(), this;
  }
  X() {
    return this.xA.X(), this.uiScale.X(), this;
  }
  rr(t) {
    if (this.Xg) {
      const e = this.Zg.yi.Ft(), i = e.x, s = e.y;
      this.uiScale.K(i, s), this.xA.K(i, s);
      const o = [this.dt.left, this.dt.right], n = [this.dt.bottom, this.dt.top];
      this.uiScale.qt(o), this.uiScale.ti(n);
      const a = this.uiScale.getInnerIntervalPixels();
      this.xA.ii(0, a.x).qt(o).si(0, a.y).ti(n), this.D.R("resize", { width: a.x, height: a.y, engineHeight: s, engineWidth: i });
    }
    this.Xg = !1;
  }
  dv() {
    for (let t = 0; t < this.$g.length; t += 1) this.$g[t].Uh().rr();
    this.Yg && this.Yg();
  }
  fv(t, e) {
    if (t) {
      const i = t(e);
      this.addEventListener("resize", i.Uh.bind(i)), this.jg = i.G.bind(i), this.Yg = i.Uh.bind(i);
    }
  }
  getIsInView() {
    return this.Hg;
  }
}
const wa = (r) => {
  r.Mt && r.Mt();
};
class Hf extends Sx {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, e.Av("uipanel bg", 0), s, e.yi.xi.uiPanelBackgroundFillStyle, e.yi.xi.uiPanelBackgroundStrokeStyle, n), this.D = new Nt(), this.legend.setOptions({ position: zt.LeftTop, ...a }), this.fv(o, this.xA);
  }
  setMinimumSize(t) {
    return this.vf = t, this.yi.Rs(), this;
  }
  getMinimumSize() {
    return this.vf;
  }
  rr(t) {
    this.Ns.forEach(((e) => e.Uh(0, Me))), super.rr(t), super.dv(), this.Ns.forEach(((e) => e.rr(0, Me)));
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Rr extends Sx {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    super(t, e, i, s, o, n, a, c, d), this.gv = {}, this.zr = !0, this.vv = { left: !1, top: !1, right: !1, bottom: !1 }, this.title = new Nt(), this.yv = e.pv("chart internal ui", 0), this.Hn = this.xi.panelPadding !== void 0 ? { left: this.xi.panelPadding, right: this.xi.panelPadding, top: this.xi.panelPadding, bottom: this.xi.panelPadding } : { left: 7, right: 7, top: 7, bottom: 7 }, this.Wr = this.yv.In(this.uiScale).rn("Chart").hr(j(50, 100)).ru(j(0, 1)).Ih(l).sr(h).setPointerEvents(!1).en(u), this.Wr.Kr = es.ChartTitle, this.title.zi(this.Wr), this.mv = this.bs.CA([this.Wr]).Es(this.xi.effectsText);
  }
  addLegend(t) {
    var e;
    let i;
    (t = { addEntriesAutomatically: !1, backgroundVisible: !0, ...t }).addEntriesAutomatically && this.legend && (i = this.legend.getEntries());
    const s = (e = t.customLegend) !== null && e !== void 0 ? e : rc, o = new Uf(s, this, this.rv, this.xA, i, t);
    return this.Ns.push(o), this.yi.Rs(), o;
  }
  setAnimationsEnabled(t) {
    return this.zr = t, this;
  }
  getAnimationsEnabled() {
    return this.zr;
  }
  setTitle(t) {
    return this.Wr.rn(t), this.yi.Rs(), this;
  }
  getTitle() {
    return this.Wr.an();
  }
  getTitleSize() {
    return this.Wr.Uh().Bc();
  }
  setTitleFillStyle(t) {
    return this.Wr.sr(t), this.Wg(), this;
  }
  getTitleFillStyle() {
    return this.Wr.kh();
  }
  setTitleShadow(t) {
    return this.Wr.en(t), this.yi.Rs(), this;
  }
  getTitleShadow() {
    return this.Wr.Jl();
  }
  setTitleFont(t) {
    return this.Wr.Ih(t), this.Wg(), this;
  }
  getTitleFont() {
    return this.Wr.Fh();
  }
  setTitleRotation(t) {
    return this.Wr.Ph(t), this.yi.Rs(), this;
  }
  getTitleRotation() {
    return this.Wr.Lh();
  }
  setTitleEffect(t) {
    return this.mv.Es(t), this.yi.Rs(), this;
  }
  getTitleEffect() {
    return this.mv.Os();
  }
  setTitleMargin(t) {
    var e, i;
    return this.gv = typeof t == "object" ? this.gv ? (e = this.gv, { left: (i = t).left !== void 0 ? i.left : e.left, top: i.top !== void 0 ? i.top : e.top, right: i.right !== void 0 ? i.right : e.right, bottom: i.bottom !== void 0 ? i.bottom : e.bottom }) : t : { left: t, top: t, right: t, bottom: t }, this.Wg(), this;
  }
  getTitleMargin() {
    return this.gv;
  }
  Fn(t, e) {
    const i = typeof t == "object" ? pa(this.Hn, t) : { left: t, top: t, right: t, bottom: t };
    return i.bottom === this.Hn.bottom && i.left === this.Hn.left && i.right === this.Hn.right && i.top === this.Hn.top || (Object.entries(t).forEach(((s) => {
      const o = s[0], n = s[1];
      n === void 0 || !e && this.vv[o] || (this.Hn[o] = n, this.vv[o] = e);
    })), this.Wg()), this;
  }
  setPadding(t) {
    return this.Fn(typeof t == "object" ? t : { left: t, top: t, right: t, bottom: t }, !0), this;
  }
  getPadding() {
    return this.Hn;
  }
  Sv(t) {
    const e = t.bv(), i = e?.height, s = e?.width;
    if (i !== void 0 && s !== void 0) return { x: i / 2, y: s / 2 };
  }
  dispose() {
    return super.dispose(), this.yv.G(), this;
  }
}
const ui = { xv(r, t) {
  var e, i;
  return r.kh() !== Lt && r.an().length !== 0 && r.getVisible() ? r.Uh().Bc().y + ((e = t.bottom) !== null && e !== void 0 ? e : 10) + ((i = t.top) !== null && i !== void 0 ? i : 10) : 0;
}, Mv(r, t, e, i, s) {
  var o;
  const n = s && s.left ? s.left : 0, a = s && s.right ? s.right : 0, l = { x: 50, y: 100 - e.y * (i.top + ((o = t.top) !== null && o !== void 0 ? o : 10)) };
  r.hr(l).ru({ x: 0, y: 1 }).Tn({ top: 0, bottom: 0, right: i.right + (t.right || 0) + a, left: i.left + (t.left || 0) + n });
} };
class Ya extends to {
  constructor(t, e, i, s, o) {
    super(t, e, s, o), this._v = Ba, this.wv = !0, this.kv = !0, this.Cv = !0, this.chart = t, this.Tv = i, this.ps = /* @__PURE__ */ new Map(), this.axisX = t.axisX, this.axisY = t.axisY, this.axisZ = t.axisZ, this.Fv(i.ai);
  }
  Qi(t, e, i) {
    const s = t?.dataPoint;
    if (s) return { cursorPosition: { resultTable: this.chart.translateCoordinate(e, this.chart.coordsRelative), resultTableScale: this.chart.xA, axisLocation: s }, ...s, series: this, axisX: this.chart.getDefaultAxisX(), axisY: this.chart.getDefaultAxisY(), axisZ: this.chart.getDefaultAxisZ() };
  }
  setCursorEnabled(t) {
    return this.wv = t, this;
  }
  getCursorEnabled() {
    return this.wv;
  }
  setCursorFormattingOverride(t) {
    return this.Iv = t, this;
  }
  getCursorFormattingOverride() {
    return this.Iv;
  }
  Pv() {
    return this.getCursorEnabled();
  }
  setAutoScrollingEnabled(t) {
    return this.kv = t, this.chart.yi.Rs(), this;
  }
  getAutoScrollingEnabled() {
    return this.kv;
  }
  setColorShadingStyle(t) {
    return this._v = t, this.ps.forEach(((e, i) => i.Lv(t))), this.Tv.Rs(), this;
  }
  getColorShadingStyle() {
    return this._v;
  }
  setDepthTestEnabled(t) {
    return this.Cv = t, this.ps.forEach(((e, i) => i.Bv(t))), this.Tv.Rs(), this;
  }
  getDepthTestEnabled() {
    return this.Cv;
  }
  Dv() {
  }
  rr() {
  }
  Ev() {
  }
  getXMax() {
    const t = this.zc;
    return t ? t.Wi() : 0;
  }
  getXMin() {
    const t = this.zc;
    return t ? t.Hi() : 0;
  }
  getYMax() {
    const t = this.zc;
    return t ? t.Zi() : 0;
  }
  getYMin() {
    const t = this.zc;
    return t ? t.Xi() : 0;
  }
  getZMax() {
    const t = this.zc;
    return t ? t.be() : 0;
  }
  getZMin() {
    const t = this.zc;
    return t ? t.Se() : 0;
  }
  Sn() {
    const t = this.zc;
    return t ? Ht(t.mu(), t.Su(), t.Rv()) : Ht(0, 0, 0);
  }
}
class m2 extends Ya {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, n), this.Vs = "Box Series 3D", this.Ov = 0.25, this.zv = !1, this.D = new Nt(), this.Ke = ue(this.xi.boxSeries3DFillStyle, o), this.zc = this.Tv.Nv().Bv(this.Cv).sr(this.Ke).Vv(this.Ov).Ii(this.getHighlight()), this.Ts(this.zc);
  }
  Fv(t) {
  }
  Gv() {
    return this.zv;
  }
  invalidateData(t) {
    const e = t.length;
    if (e === 0) return this;
    this.zv && this.chart.yi.Oa(Ot.Go);
    const i = t[0];
    if (!i) return this;
    let s;
    if ("xMin" in i || "yMin" in i || "zMin" in i || "xMax" in i || "yMax" in i || "zMax" in i) {
      s = [];
      for (let o = 0; o < e; o += 1) {
        const n = t[o], a = "xMin" in n && "xMax" in n, l = "yMin" in n && "yMax" in n, h = "zMin" in n && "zMax" in n;
        s[o] = { color: n.color, value: n.value, id: n.id, xCenter: a ? (n.xMin + n.xMax) / 2 : void 0, yCenter: l ? (n.yMin + n.yMax) / 2 : void 0, zCenter: h ? (n.zMin + n.zMax) / 2 : void 0, xSize: a ? n.xMax - n.xMin : void 0, ySize: l ? n.yMax - n.yMin : void 0, zSize: h ? n.zMax - n.zMin : void 0 };
      }
    } else s = t;
    return this.zc.$v(s.slice()), this.chart.yi.Rs(), this.zv = !0, this;
  }
  clear() {
    return this.zc.Vi(), this.zv = !1, this.chart.yi.Rs(), this;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.zc.sr(t), this.chart.yi.Rs(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setRoundedEdges(t) {
    return t !== void 0 && isNaN(t) && (console.error("'BoxSeries3D.setRoundedEdges | NaN was supplied.'"), t = void 0), this.Ov = t !== void 0 ? Jt(t, 0, 1) : void 0, this.zc.Vv(this.Ov), this.Tv.Rs(), this;
  }
  getRoundedEdges() {
    return this.Ov;
  }
  Uv() {
    return this.kv && this.getVisible();
  }
  ar(t, e) {
    t.Ii(e), this.chart.yi.Rs();
  }
  Ws() {
    return is(this.Ke, this.zc.wi());
  }
  rr() {
    super.rr(), this.zc.Uh(!1);
  }
  nr() {
    return { fill: this.Ke };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Ed = (r) => {
  if (Oi(r)) {
    const t = r.getThickness(), e = r.getFillStyle();
    if (de(e)) return t === 1 ? sg : new Rf({ size: t, fillStyle: e, shape: "sphere" });
  }
  return sg;
}, Ir = { UserSeries: { type: "ApplicationType", args: { type: "UserSeries" } }, InternalUI: { type: "ApplicationType", args: { type: "InternalUI" } } };
class Ax {
  constructor(t, e, i, s, o, n, a, l, h, u) {
    this.M = 0, this.di = !0, this.ci = !1, this.ui = !0, this.D = new Nt(), this.Rs = t, this.jv = e, this.Yv = i, this.Hv = s, this.Wv = o, this.Xv = n, this.If = a, this.Zv = l, this.Jv = h, this.yo = u;
  }
  setValue(t) {
    return t === this.M || (this.M = t, this.Rs(), this.D.R("valuechange", { value: this.M })), this;
  }
  getValue() {
    return this.M;
  }
  setTickStyle(t) {
    return this.Yv = typeof t == "function" ? t(this.Yv) : t, this.Rs(), this;
  }
  getTickStyle() {
    return this.Yv;
  }
  setTickLength(t) {
    return this.Hv = t, this.Rs(), this;
  }
  getTickLength() {
    return this.Hv;
  }
  setGridStrokeStyle(t) {
    return this.Wv = typeof t == "function" ? t(this.Wv) : t, this.Rs(), this;
  }
  getGridStrokeStyle() {
    return this.Wv;
  }
  setTextPadding(t) {
    return this.Xv = t, this.Rs(), this;
  }
  getTextPadding() {
    return this.Xv;
  }
  setTextRotation(t) {
    return this.If = t, this.Rs(), this;
  }
  getTextRotation() {
    return this.If;
  }
  setTextFillStyle(t) {
    return this.Zv = typeof t == "function" ? t(this.Zv) : t, this.Rs(), this;
  }
  getTextFillStyle() {
    return this.Zv;
  }
  setTextFont(t) {
    return this.Jv = typeof t == "function" ? t(this.Jv) : t, this.Rs(), this;
  }
  getTextFont() {
    return this.Jv;
  }
  setTextFormatter(t) {
    return this.yo = t, this.Rs(), this;
  }
  dispose() {
    return this.ci || (this.ci = !0, this.jv(), this.Rs(), this.D.R("dispose", {})), this;
  }
  isDisposed() {
    return this.ci;
  }
  setVisible(t) {
    const e = this.di !== t;
    return this.di = t, e && (this.D.R("visiblechange", { isVisible: this.di }), this.Rs()), this;
  }
  getVisible() {
    return this.di;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  setPointerEvents(t) {
    return this.ui = t, this.Rs(), this;
  }
  getPointerEvents() {
    return this.ui;
  }
}
class x2 extends Ax {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d, f) {
    super(t, e, i, s, o, n, a, l, h, u), this.Bg = c, this.Dg = d, this.Hn = f;
  }
  setBackgroundFillStyle(t) {
    return this.Bg = typeof t == "function" ? t(this.Bg) : t, this.Rs(), this;
  }
  getBackgroundFillStyle() {
    return this.Bg;
  }
  setBackgroundStrokeStyle(t) {
    return this.Dg = typeof t == "function" ? t(this.Dg) : t, this.Rs(), this;
  }
  getBackgroundStrokeStyle() {
    return this.Dg;
  }
  setPadding(t) {
    return this.Hn = typeof t == "number" ? { left: t, top: t, right: t, bottom: t } : { ...this.Hn, ...t }, this.Rs(), this;
  }
  getPadding() {
    return this.Hn;
  }
}
class Fr {
  constructor(t, e, i, s) {
    this.Qv = [], this.Kv = /* @__PURE__ */ new Map(), this.qv = t, this.ty = e, this.iy = i, this.Ev = s;
  }
  rg() {
    this.iy && this.iy();
    const t = [];
    return { add: (e, i) => {
      t.push({ instanceUniqueProperties: e, instanceSharedProperties: i });
    }, finishPlot: () => {
      const e = [];
      let i = [];
      t.forEach(((n) => {
        const a = e.find(((l) => ((h, u) => {
          const c = Object.keys(h);
          for (const d of c) if (h[d] !== u[d]) return !1;
          return !0;
        })(l.sharedProperties, n.instanceSharedProperties)));
        a ? a.instances.push(n.instanceUniqueProperties) : e.push({ sharedProperties: n.instanceSharedProperties, instances: [n.instanceUniqueProperties] });
      }));
      const s = this.Qv.slice(), o = [];
      e.forEach(((n) => {
        let a = s.shift();
        a || (a = this.qv(), this.Qv.push(a));
        const l = [], h = a.sy().slice();
        n.instances.forEach(((c) => {
          const d = h.shift();
          l.push({ ...c, existingMember: d });
        }));
        const u = this.ty(a, l, n.sharedProperties);
        i = us(i, u, { canReturnB: !0 });
        for (let c = 0; c < n.instances.length; c += 1) o.push({ Si: n.instances[c].Si, collection: a, member: u[c] });
        h.forEach(((c) => {
          a?.gf(c);
        }));
      })), s.forEach(((n) => {
        n.dispose();
        const a = this.Qv.indexOf(n);
        a < 0 ? Js(0, (() => {
        })) : this.Qv.splice(a, 1);
      })), o.forEach(((n) => {
        const a = this.Kv.get(n.Si);
        a && n.collection.yi.Ka({ entity: a.collection, collectionMember: a.member }, { entity: n.collection, collectionMember: n.member });
      })), this.Kv.clear(), o.forEach(((n) => {
        this.Kv.set(n.Si, n);
      })), this.Ev && this.Ev(this.Qv, i);
    } };
  }
  ag() {
    this.Qv.forEach(((t) => {
      t.dispose();
    })), this.Qv.length = 0;
  }
}
class _c extends eo {
  constructor(t, e, i, s, o, n, a, l, h) {
    super(t, e, i, s, l, { numeric: e.ey({ x: t.yi.xi.xAxis3DNumericTicks, y: t.yi.xi.yAxis3DNumericTicks, z: t.yi.xi.zAxis3DNumericTicks }), datetime: e.ey({ x: t.yi.xi.xAxis3DDateTimeTicks, y: t.yi.xi.yAxis3DDateTimeTicks, z: t.yi.xi.zAxis3DDateTimeTicks }), time: e.ey({ x: t.yi.xi.xAxis3DTimeTicks, y: t.yi.xi.yAxis3DTimeTicks, z: t.yi.xi.zAxis3DTimeTicks }) }, { type: "linear" }), this.Kf = [], this.D = new Nt(), this.chart = t, this.Tv = o, this.hy = n, this.ny = a, this.oy = this.Tv.ai;
    const u = this.dh.ey({ x: this.xi.xAxis3DStrokeStyle, y: this.xi.yAxis3DStrokeStyle, z: this.xi.zAxis3DStrokeStyle });
    this.ly = this.Tv.Ay([Ir.InternalUI], void 0).gr(u).uy(Ed(u)).setPointerEvents(!1), this.qr = this.hy.In(this.ny).setPointerEvents(!1).sr(e.ey({ x: t.yi.xi.xAxis3DTitleFillStyle, y: t.yi.xi.yAxis3DTitleFillStyle, z: t.yi.xi.zAxis3DTitleFillStyle })).Ih(e.ey({ x: t.yi.xi.xAxis3DTitleFont, y: t.yi.xi.yAxis3DTitleFont, z: t.yi.xi.zAxis3DTitleFont })).vl(3), this.gy = new Xi((() => this.hy.In(this.ny).vl(2).Fn(Me).Tn(Me))), this.vy = new Fr((() => this.hy.yy(this.ny).setPointerEvents(!1).vl(1)), ((c, d, f) => (c.sr(f.fillStyle).ir(f.strokeStyle), d.map((({ positions: p, existingMember: g }) => {
      const y = g || c.Qo();
      return y.yu(p), y;
    }))))), this.my = new Fr((() => this.Tv.GA().setPointerEvents(!1)), ((c, d, f) => (c.Vi().gr(f.lineStyle), d.map((({ positions: p, existingMember: g }) => g || c.Pu(p)))))), this.bs = h, this.Bh = this.bs.CA([this.qr]).Es(s.effectsText), i.gA = this;
  }
  setTickStrategy(t, e) {
    return super.ph(t, e);
  }
  getTickStrategy() {
    return this.Dr;
  }
  addCustomTick() {
    const t = new x2((() => this.chart.yi.Rs()), (() => {
      const e = this.Kf.indexOf(t);
      e >= 0 && this.Kf.splice(e, 1);
    }), this.xi.xAxis3DNumericTicks.majorTickStyle.tickStyle, this.xi.xAxis3DNumericTicks.majorTickStyle.tickLength, this.xi.xAxis3DNumericTicks.majorTickStyle.gridStrokeStyle, this.xi.xAxis3DNumericTicks.majorTickStyle.tickPadding, this.xi.xAxis3DNumericTicks.majorTickStyle.labelRotation, this.xi.xAxis3DNumericTicks.majorTickStyle.labelFillStyle, this.xi.xAxis3DNumericTicks.majorTickStyle.labelFont, ((e) => this.formatValue(e)), Lt, Et, { left: 4, right: 4, top: 4, bottom: 4 });
    return this.Kf.push(t), this.chart.yi.Rs(), t;
  }
  getCustomTicks() {
    return [...this.Kf];
  }
  setStrokeStyle(t) {
    return this.ly.gr(t).uy(Ed(this.ly.po())), this.chart.yi.Rs(), this;
  }
  getStrokeStyle() {
    return this.ly.po();
  }
  setVisible(t) {
    return super.setVisible(t), this.ly.setVisible(t), t === !1 && (this.my.ag(), this.gy.ag(), this.vy.ag()), this.Tv.Rs(), this;
  }
  DA() {
    return this.chart.getSeries();
  }
  wn(t, e, i) {
    const s = Math.abs(this.ai.q(Math.abs(e - t)) * this.Tv.Sy(1));
    return { start: t + i.start * s * Math.sign(t - e), end: e + i.end * s * Math.sign(e - t) };
  }
  Wh(t) {
    const e = this.oy, i = Ht(e.x.et(), e.y.et(), e.z.et()), { gridlinePositionA: s, gridlinePositionB: o, gridlinePositionC: n } = this.dh.by(t.cameraDirection), a = (y) => ({ x: y.x === -1 ? this.oy.x.getInnerStart() : y.x === 1 ? this.oy.x.getInnerEnd() : 0, y: y.y === -1 ? this.oy.y.getInnerStart() : y.y === 1 ? this.oy.y.getInnerEnd() : 0, z: y.z === -1 ? this.oy.z.getInnerStart() : y.z === 1 ? this.oy.z.getInnerEnd() : 0 }), l = a(s), h = a(o), u = a(n), c = this.dh.Mf, d = Cc(t.start, t.end, 0.5), f = gt.addVec(d, gt.multiplyVec(gt.multiply(c, -1), i)), p = this.Tv.xy(d) || j(0, 0), g = this.Tv.xy(f) || j(0, 0);
    return { center: d, wuSize: i, tickDirection3D: c, tickDirection2D: Os(oi(xt(p, this.chart.yi.ai, this.ny), xt(g, this.chart.yi.ai, this.ny))), gridlinePositionA: l, gridlinePositionB: h, gridlinePositionC: u };
  }
  Qh(t, e, i, s, o) {
    return { ...this.My(o, t, e.Lr.tickLength, e.Lr.tickPadding), keyValue: t, tickLevel: e, labelText: i, labelOffset: { x: 0, y: 0 }, labelRotation: e.Lr.labelRotation };
  }
  hn(t, e) {
    const i = new v2(e, t, this.hy, this.ny, this.Tv);
    return i.Gh.vl(0), i;
  }
  tn(t, e, i) {
    return { ticksInfo: e, updatedTicks: i };
  }
  ih() {
    return this.ny;
  }
  My(t, e, i, s) {
    const { wuSize: o, start: n, end: a, tickDirection3D: l, tickDirection2D: h } = t, u = (e - this.ai.getInnerStart()) / (this.ai.getInnerEnd() - this.ai.getInnerStart()), c = gt.addVec(Cc(n, a, u), gt.multiplyVec(gt.multiply(l, this.Tv.Sy(0.5 * this.ly.po().getThickness())), o)), d = gt.addVec(c, gt.multiplyVec(gt.multiply(l, this.Tv.Sy(i)), o)), f = this.Tv.xy(d) || j(0, 0);
    return { labelPosition: qt(xt(f, this.chart.yi.ai, this.ny), pe(h, s)), labelAlignment: { x: -h.x, y: -h.y }, posTickEnd3D: d, posTickStart3D: c, tickPositionRelative: u };
  }
  _y(t, e, i) {
    const { wuSize: s, start: o, end: n, tickDirection3D: a } = e, l = (t - this.ai.getInnerStart()) / (this.ai.getInnerEnd() - this.ai.getInnerStart()), h = gt.addVec(Cc(o, n, l), gt.multiplyVec(gt.multiply(a, this.Tv.Sy(0.5 * this.ly.po().getThickness())), s)), u = gt.addVec(h, gt.multiplyVec(gt.multiply(a, this.Tv.Sy(10)), s)), c = this.Tv.xy(h) || j(0, 0), d = this.Tv.xy(u) || j(0, 0);
    return this.hy.vr(this.ny).pr(c).yr(d).gr(new $t({ fillStyle: new ot({ color: PS(120 * i) }), thickness: 1 }));
  }
  xn(t, e) {
    return S2(t, e, this.ai);
  }
  wy(t) {
    const e = this.oy;
    let i, s;
    this.ky() ? (i = Ht(e.x.getInnerEnd(), e.y.getInnerStart(), e.z.getInnerStart()), s = Ht(e.x.getInnerEnd(), e.y.getInnerStart(), e.z.getInnerEnd())) : (i = Ht(e.x.getInnerStart(), e.y.getInnerStart(), e.z.getInnerStart()), s = this.dh.Cy(Ht(e.x.getInnerEnd(), e.y.getInnerEnd(), e.z.getInnerEnd()), i));
    const o = this.Tv.xy(i) || j(0, 0), n = this.Tv.xy(s) || j(0, 0);
    return { cameraDirection: t, physicalAxisSize: an(oi(o, n)), start: i, end: s, start2D: o, end2D: n };
  }
  rr(t) {
    if (!this.di) return;
    const e = Math.min(this.mh, this.Sh), i = Math.max(this.mh, this.Sh);
    this.ly.Vi().Pu([t.start, t.end]);
    const s = this.my.rg();
    for (const [f, p] of this.Er) for (const [, g] of p) {
      const y = t.ticksInfo.get(g);
      if (!y) continue;
      const m = this.Ty(t, y);
      s.add({ Si: 0, positions: [m.tickStroke.start, m.tickStroke.end] }, { lineStyle: f.Lr.tickStyle }), m.gridStroke && s.add({ Si: 0, positions: m.gridStroke }, { lineStyle: f.Lr.gridStrokeStyle }), g.Gh.hr(y.labelPosition).ru(y.labelAlignment).Ph(y.labelRotation).Ql(y.labelOffset.x, y.labelOffset.y);
    }
    const o = this.gy.rg(), n = this.vy.rg(), a = { x: 0, y: 0 };
    this.Kf.forEach(((f) => {
      if (!f.di || f.M < e || f.M > i) return;
      const p = this.My(t, f.M, f.Hv, f.Xv), g = this.Ty(t, p);
      if (f.Zv !== Lt) {
        const y = o.add().hr(p.labelPosition).ru(p.labelAlignment).sr(f.Zv).Ih(f.Jv).rn(f.yo(f.M)).Ph(f.If).setPointerEvents(f.ui);
        y.Kr = f.Kr;
        const m = y.Uh().Ft();
        if (a.x = Math.max(a.x, m.x), a.y = Math.max(a.y, m.y), f.Bg !== Lt) {
          const A = y.Ic(), v = [{ x: A.min.x - f.Hn.left, y: A.max.y + f.Hn.top }, { x: A.max.x + f.Hn.right, y: A.max.y + f.Hn.top }, { x: A.max.x + f.Hn.right, y: A.min.y - f.Hn.bottom }, { x: A.min.x - f.Hn.left, y: A.min.y - f.Hn.bottom }];
          n.add({ Si: 0, positions: v }, { fillStyle: f.Bg, strokeStyle: f.Dg }), this.hy.yi.Pc && f.Kr === es.CursorTickMarker && this.hy.yi.Pc.XA({ ...this.hy.yi.dl(A.min, A.max, y.ai, f.Hn), blacklist: [es.CursorTickMarker] });
        }
      }
      s.add({ Si: 0, positions: [g.tickStroke.start, g.tickStroke.end] }, { lineStyle: f.Yv }), g.gridStroke && s.add({ Si: 0, positions: g.gridStroke }, { lineStyle: f.Wv });
    })), o.finishPlot(), n.finishPlot(), s.finishPlot();
    const l = this.fn(((f, p) => {
      const g = p.Gh.Uh().Ft();
      return f.x = Math.max(f.x, g.x), f.y = Math.max(f.y, g.y), f;
    }), { x: a.x, y: a.y }), h = Math.atan((t.end2D.y - t.start2D.y) / (t.end2D.x - t.start2D.x));
    this.qr.ru({ x: 0, y: 0 }).Ph(180 * -h / Math.PI);
    const u = gt.addVec(t.center, gt.multiplyVec(gt.multiply(t.tickDirection3D, this.Tv.Sy(0.5 * this.ly.po().getThickness() + this.gn(((f, p) => Math.max(f, p.tickLength)), 0))), t.wuSize)), c = this.Tv.xy(u) || j(0, 0), d = qt(xt(c, this.chart.yi.ai, this.ny), qt(qt(ls(l, t.tickDirection2D), pe(t.tickDirection2D, this.gn(((f, p) => Math.max(f)), 0))), ls(pe(this.qr.Uh().Ft(), 0.5), t.tickDirection2D)));
    this.qr.hr(d);
  }
  Ty(t, e) {
    const { gridlinePositionA: i, gridlinePositionB: s, gridlinePositionC: o } = t, n = e.posTickStart3D, a = e.posTickEnd3D, l = e.tickPositionRelative;
    let h;
    return Pi(l, 0) || Pi(l, 1) || (h = [this.Fy() ? { ...i, x: n.x } : this.Iy() ? { ...i, y: n.y } : this.ky() ? { ...i, z: n.z } : { x: 0, y: 0, z: 0 }, this.Fy() ? { ...s, x: n.x } : this.Iy() ? { ...s, y: n.y } : this.ky() ? { ...s, z: n.z } : { x: 0, y: 0, z: 0 }, this.Fy() ? { ...o, x: n.x } : this.Iy() ? { ...o, y: n.y } : this.ky() ? { ...o, z: n.z } : { x: 0, y: 0, z: 0 }]), { gridStroke: h, tickStroke: { start: n, end: a } };
  }
  Py(t) {
    const e = this.mh, i = this.Sh, s = 0.01 * t * (i - e), o = e + s, n = i + s;
    this.zh(o, n, { allowIntervalLengthChange: !1, skipIntervalRestriction: !1 });
  }
  Ly(t, e, i) {
    if (e === 0) return;
    i < 0 && (e *= -1, i *= -1);
    const s = this.Sh - this.mh, o = s * (e >= 1 ? 1 + 0.02 * i : 1 - 0.02 * i) - s;
    t === "centered" ? this.zh(this.mh + o / 2, this.Sh - o / 2, { allowIntervalLengthChange: !0, skipIntervalRestriction: !1 }) : t === "keep-start" ? this.zh(this.mh, this.Sh - o / 2, { allowIntervalLengthChange: !0, skipIntervalRestriction: !1 }) : t === "keep-end" && this.zh(this.mh + o / 2, this.Sh, { allowIntervalLengthChange: !0, skipIntervalRestriction: !1 });
  }
  Dh() {
    super.Dh(), this.my.ag(), this.gy.ag(), this.vy.ag();
  }
  Fy() {
    return this.dh.Fy();
  }
  Iy() {
    return this.dh.Iy();
  }
  ky() {
    return this.dh.ky();
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
}
class v2 extends Wa {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, n), this.By = o;
  }
}
const S2 = (r, t, e) => Jt(r + 0.1 * (t - r) + Math.abs(e.et()) / 100 * Math.sign(t - r), Math.min(r, t), Math.max(r, t)), ja = (r, t, e, i) => ({ vn: (s) => {
  const o = r();
  let n;
  for (const a of o) {
    if (!a.Uv()) continue;
    const l = t(a, s);
    n = l === void 0 ? n : n !== void 0 ? Math.min(n, l) : l;
  }
  return n;
}, yn: (s) => {
  const o = r();
  let n;
  for (const a of o) {
    if (!a.Uv()) continue;
    const l = e(a, s);
    n = l === void 0 ? n : n !== void 0 ? Math.max(n, l) : l;
  }
  return n;
}, Sn: () => {
  const s = r();
  let o;
  for (const n of s) {
    if (!n.Uv()) continue;
    const a = i(n);
    o = a === void 0 ? o : o !== void 0 ? Math.max(o, a) : a;
  }
  return o;
} }), A2 = (r) => ({ ...ja(r, ((t) => t.getYMin()), ((t) => t.getYMax()), ((t) => t.Sn().y)), ey: (t) => t.y, Cy: (t, e) => ({ x: e.x, y: t.y, z: e.z }), Mf: Ht(-1, 0, 0), by: (t) => {
  const e = { x: t.x >= 0 ? 1 : -1, y: t.y >= 0 ? 1 : -1, z: t.z >= 0 ? 1 : -1 };
  return { gridlinePositionA: Ht(e.x, 0, e.z), gridlinePositionB: Ht(e.x, 0, -e.z), gridlinePositionC: Ht(-e.x, 0, -e.z) };
}, Fy: () => !1, Iy: () => !0, ky: () => !1 }), b2 = (r) => ({ ...ja(r, ((t) => t.getZMin()), ((t) => t.getZMax()), ((t) => t.Sn().z)), ey: (t) => t.z, Cy: (t, e) => ({ x: e.x, y: e.y, z: t.z }), Mf: Ht(1, 0, 0), by: (t) => {
  const e = { x: t.x >= 0 ? 1 : -1, y: t.y >= 0 ? 1 : -1, z: t.z >= 0 ? 1 : -1 };
  return { gridlinePositionA: Ht(e.x, -e.y, 0), gridlinePositionB: Ht(e.x, e.y, 0), gridlinePositionC: Ht(-e.x, e.y, 0) };
}, Fy: () => !1, Iy: () => !1, ky: () => !0 });
class bx extends Ya {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.zv = !1, this.D = new Nt();
  }
  Fv(t) {
  }
  Gv() {
    return this.getPointAmount() > 0;
  }
  setStrokeStyle(t) {
    this.vc = typeof t == "function" ? t(this.vc) : t;
    const e = this.vc;
    return this.zc.gr(e), this.Tv.Rs(), this;
  }
  getStrokeStyle() {
    return this.vc;
  }
  add(t) {
    return this.zv && this.chart.yi.Oa(Ot.Go), this.zv = !0, (t = Array.isArray(t) ? t : [t]) ? (this.zc.Pu(t.slice()), this.Tv.Rs(), this) : this;
  }
  clear() {
    return this.zc.Vi(), this;
  }
  getPointAmount() {
    const t = this.zc;
    return t.Ru() + t.Ou();
  }
  Uv() {
    return this.kv && this.getPointAmount() > 0 && this.getVisible();
  }
  ar(t, e) {
    t.Ii(e), this.Tv.Rs();
  }
  nr() {
    return { stroke: this.vc };
  }
  Ws() {
    return is(this.vc.getFillStyle(), this.zc.wi());
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class E2 extends bx {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, n), this.Vs = "Line Series 3D", this.vc = ue(s.lineSeries3DStrokeStyle, o), this.Dy = Hi.pointStyle3D, this.Ey(this.vc);
    const l = { individualLookupValuesEnabled: !1, ...a };
    this.zc = this.Tv.Ay([Ir.UserSeries], l).Bv(this.Cv).gr(this.vc).uy(this.Dy).Ii(this.getHighlight()), this.Ts(this.zc);
  }
  setStrokeStyle(t) {
    super.setStrokeStyle(t), this.Ey(this.vc);
    const e = this.Dy;
    return this.zc.uy(e), this;
  }
  Ey(t) {
    const e = new Mu.Triangulated({ shape: "sphere", fillStyle: t.getFillStyle(), size: t.getThickness() });
    this.Dy = e;
  }
}
class M2 extends bx {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, n), this.Vs = "Point Line Series 3D", this.Dy = ue(s.pointLineSeries3DPointStyle, o), this.vc = ue(s.lineSeries3DStrokeStyle, o), this.Ry();
    const l = { individualLookupValuesEnabled: !1, ...a };
    this.zc = this.Tv.Ay([Ir.UserSeries], l).Bv(this.Cv).gr(this.vc).uy(this.Dy).Ii(this.getHighlight()), this.Ts(this.zc);
  }
  setPointStyle(t) {
    return this.Dy = typeof t == "function" ? t(this.Dy) : t, this.Ry(), this.zc.uy(this.Dy), this.Tv.Rs(), this;
  }
  getPointStyle() {
    return this.Dy;
  }
  setStrokeStyle(t) {
    super.setStrokeStyle(t);
    const e = this.vc, i = Math.abs(e.getThickness()), s = this.Dy, o = s.getSize();
    i > (typeof o == "object" ? Math.max(o.x, o.y, o.z) : o) && (this.Dy = s.setSize(i)), this.Ry();
    const n = this.Dy;
    return this.zc.uy(n), this.Tv.Rs(), this;
  }
  Ws() {
    return is(this.vc.getFillStyle(), this.zc.wi()) || is(this.Dy.getFillStyle(), this.zc.wi());
  }
  Ry() {
    const t = this.Dy, e = t.getSize();
    this.Dy = t.setSize(e);
  }
  ar(t, e) {
    t.Ii(e), this.Tv.Rs();
  }
}
class C2 extends Ya {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o), this.zv = !1, this.D = new Nt(), (n?.individualPointSizeAxisEnabled || n?.individualPointSizeEnabled) && this.chart.yi.Oa(Ot.$o);
  }
  Fv(t) {
  }
  Gv() {
    return this.getPointAmount() > 0;
  }
  add(t) {
    return this.zv && this.chart.yi.Oa(Ot.Go), this.zv = !0, (t = Array.isArray(t) ? t : [t]) ? (this.zc.Pu(t.slice()), this.Tv.Rs(), this) : this;
  }
  clear() {
    return this.zc.Vi(), this;
  }
  getPointAmount() {
    const t = this.zc;
    return t.Ru() + t.Ou();
  }
  Uv() {
    return this.kv && this.getPointAmount() > 0 && this.getVisible();
  }
  ar(t, e) {
    t.Ii(e), this.Tv.Rs();
  }
  nr() {
    return { point3D: this.Oy };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class w2 extends C2 {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o, n), this.Vs = "Point Series 3D";
    const a = n?.automaticColorIndex !== void 0 ? n.automaticColorIndex : this.chart.getSeries().length;
    this.Oy = ue(s.pointSeries3DPointStyle, a);
    const l = { individualPointColorEnabled: !1, individualPointSizeEnabled: !1, individualLookupValuesEnabled: !1, individualPointSizeAxisEnabled: !1, ...n };
    this.zc = this.Tv.Vy(l).Bv(this.Cv).zy(this.Oy).Ii(this.getHighlight()), this.Ts(this.zc);
  }
  setPointStyle(t) {
    this.Oy = typeof t == "function" ? t(this.Oy) : t;
    const e = this.Oy;
    return this.zc.zy(e), this.Tv.Rs(), this;
  }
  getPointStyle() {
    return this.Oy;
  }
  Ws() {
    return is(this.Oy.getFillStyle(), this.zc.wi());
  }
}
class $a extends Rr {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    super(t, e, i, s, o, n, a, l, h, u, c, d), this.Ny = [], this.Gy = 0, this.$y = (f) => {
      const p = this.Ny.indexOf(f);
      p >= 0 && (this.Ny.splice(p, 1), this.D.R("seriesdispose", { series: f }));
    }, this.seriesBackground = new Nt(), this.Uy = this.bs.CA();
  }
  setAnimationsEnabled(t) {
    return super.setAnimationsEnabled(t), this.Ny.forEach(((e) => e.setAnimationHighlight(t))), this;
  }
  jy(t, e) {
    this.Uy.Fs([e]), this.seriesBackground.zi(t);
  }
  setSeriesBackgroundFillStyle(t) {
    return this.Yy.sr(t), this.yi.Rs(), this;
  }
  getSeriesBackgroundFillStyle() {
    return this.Yy.kh();
  }
  setSeriesBackgroundStrokeStyle(t) {
    return this.Hy.ir(t), this.yi.Rs(), this;
  }
  getSeriesBackgroundStrokeStyle() {
    return this.Hy.hl();
  }
  setSeriesBackgroundEffect(t) {
    return this.Uy.Es(t), this.yi.Rs(), this;
  }
  getSeriesBackgroundEffect() {
    return this.Uy.Os();
  }
  Wy(t, e) {
    this.Ny.push(t), this.Xy !== void 0 && t.setHighlightOnHover(this.Xy), this.D.R("seriesadd", { series: t }), this.Ns.forEach(((i) => {
      i.Vg() && e?.legend !== null && i.Pu(t, e?.legend);
    }));
  }
  Gg() {
    return this.Ny;
  }
  setSeriesHighlightOnHover(t) {
    return this.Xy = t, this.Ny.forEach(((e) => e.setHighlightOnHover(t))), this;
  }
  dispose() {
    return this.Ny.slice().forEach(Eo), super.dispose();
  }
}
const wg = gt.normalize({ x: -0.5610788649579117, y: -0.35242840511865414, z: -1.1349149375849081 });
class T2 {
  constructor(t, e, i, s) {
    this.Zy = !0, this.Jy = !0, this.Qy = 2 * -Math.PI / 2160, this.Ky = 2 * Math.PI / 2160, this.qy = 0.1, this.tp = 1 * Math.PI / 180, this.ip = t, this.ep = e, this.rp = i, this.xy = s;
  }
  getDefaultCameraConfiguration(t, e) {
    const i = { direction: wg, location: gt.multiply(wg, -1) };
    return this.cameraLocationChanged({ boundingBox: t, cameraDirection: i.direction, cameraLocation: i.location, projection: e }) || i;
  }
  applyCameraInteractions(t, e) {
    let i = { direction: t.cameraDirection, location: t.cameraLocation };
    return e.forEach(((s) => {
      s.type === "rotate" ? i = this.hp(i, s) : s.type === "wheel-zoom" ? i = this.np(i, s) : s.type === "rotate+zoom" ? i = this.op(i, s) : s.type === "fixed-rotate" ? i = this.ap(i, s) : s.type === "move" && (i = this.lp(i, s));
    })), this.Zy ? i = this.up(t.boundingBox, i) : this.Jy && (i = this.cp(t.boundingBox, t.projection, i)), i;
  }
  hp(t, e) {
    const { rotation: i } = e, s = t.location, o = gt.multiply(gt.normalize(t.location), -1), { Right: n, Up: a } = this.dp(o);
    let l = s;
    const h = this.fp(o), u = i.x * this.Qy * h;
    l = gt.rotateAroundAxis(l, a, u);
    const c = (i.y > 0 ? 1 : -1) * Math.min(Math.abs(i.y) * this.Ky, h - this.tp);
    return c !== 0 && (l = gt.rotateAroundAxis(l, n, c)), { location: l, direction: gt.multiply(gt.normalize(l), -1) };
  }
  np(t, e) {
    const { deltaY: i } = e;
    this.Zy && this.Ap(!1);
    const s = t.location, o = gt.multiply(gt.normalize(s), -1), n = i * this.qy, a = gt.length(s) * -n;
    return { direction: o, location: gt.addVec(s, gt.multiply(o, a)) };
  }
  op(t, e) {
    const { rotation: i, cameraDistance: s } = e;
    this.Zy && this.Ap(!1);
    let o = this.hp(t, { type: "rotate", rotation: i });
    const n = o.location, a = gt.multiply(gt.normalize(n), -1), l = gt.multiply(a, -s);
    return o = { direction: gt.multiply(gt.normalize(l), -1), location: l }, o;
  }
  ap(t, e) {
    this.Zy && this.Ap(!1);
    const { rotation: i } = e, s = t.location, o = t.direction, { Right: n, Up: a } = this.dp(o), l = i.x * this.Qy;
    let h = gt.normalize(gt.rotateAroundAxis(o, a, l));
    const u = i.y * this.Ky;
    return h = gt.normalize(gt.rotateAroundAxis(h, n, u)), { location: s, direction: h };
  }
  lp(t, e) {
    this.Zy && this.Ap(!1), this.Jy = !1;
    const { amountRight: i, amountForward: s } = e, o = t.location, n = t.direction, { Right: a } = this.dp(n);
    return { location: gt.addVec(o, gt.multiply(n, 0.01 * s), gt.multiply(a, 0.01 * i)), direction: n };
  }
  projectionChanged(t, e) {
    return this.viewportChanged(t);
  }
  boundingBoxChanged(t) {
    const e = { location: t.cameraLocation, direction: gt.multiply(gt.normalize(t.cameraLocation), -1) };
    return this.Zy ? this.up(t.boundingBox, e) : this.cp(t.boundingBox, t.projection, e);
  }
  cameraLocationChanged(t) {
    const e = { location: t.cameraLocation, direction: gt.multiply(gt.normalize(t.cameraLocation), -1) };
    return this.Zy ? this.up(t.boundingBox, e) : this.cp(t.boundingBox, t.projection, e);
  }
  viewportChanged(t) {
    const e = { location: t.cameraLocation, direction: gt.multiply(gt.normalize(t.cameraLocation), -1) };
    if (this.Zy) return this.up(t.boundingBox, e);
  }
  up(t, e, i) {
    let s = e;
    i = i !== void 0 ? i : 0, s = this.gp(t, s, 100, 20, 1, i, 5);
    const o = this.fp(s.direction);
    return s = this.vp(s, this.yp(t, s, 100, 1), o), s;
  }
  gp(t, e, i, s, o, n, a) {
    return k2(n, a, ((l) => ({ direction: e.direction, location: gt.multiply(e.direction, -l) })), ((l) => this.pp(t, l)), i, o, "linear", s);
  }
  yp(t, e, i, s) {
    const { Right: o, Left: n, Up: a, Down: l } = this.dp(e.direction), h = this.mp(t, !1, e);
    let u = e;
    const c = s, d = 0.1;
    return Math.abs(h.bottom - h.top) > c && (u = h.bottom < h.top ? Oh(0, d, ((f) => ({ location: u.location, direction: gt.normalize(gt.lerp(u.direction, l, f)) })), ((f) => this.Sp(t, f)), 0, c, !0, i) : Oh(0, d, ((f) => ({ location: u.location, direction: gt.normalize(gt.lerp(u.direction, a, f)) })), ((f) => this.Sp(t, f)), 0, c, !0, i)), Math.abs(h.left - h.right) > c && (u = h.left < h.right ? Oh(0, d, ((f) => ({ location: u.location, direction: gt.normalize(gt.lerp(u.direction, n, f)) })), ((f) => this.bp(t, f)), 0, c, !0, i) : Oh(0, d, ((f) => ({ location: u.location, direction: gt.normalize(gt.lerp(u.direction, o, f)) })), ((f) => this.bp(t, f)), 0, c, !0, i)), u;
  }
  pp(t, e) {
    const i = this.mp(t, !0, e);
    return Math.min(i.left + i.right, i.top + i.bottom);
  }
  bp(t, e) {
    const i = this.mp(t, !1, e);
    return Math.abs(i.left - i.right);
  }
  Sp(t, e) {
    const i = this.mp(t, !1, e);
    return Math.abs(i.top - i.bottom);
  }
  mp(t, e, i) {
    const s = Vi(this.xp(t, e, i).map(((o) => xt(o, this.ip, this.ep))));
    return { left: s.min.x, right: this.ep.x.getInnerEnd() - s.max.x, top: this.ep.y.getInnerEnd() - s.max.y, bottom: s.min.y };
  }
  xp(t, e, i) {
    const s = this.rp, o = Ht(s.x.getInnerStart(), s.y.getInnerStart(), s.z.getInnerStart()), n = Ht(s.x.getInnerEnd(), s.y.getInnerEnd(), s.z.getInnerEnd()), a = [], l = e ? 16 : 4, h = (o.x + n.x) / 2, u = (o.z + n.z) / 2, c = Math.sqrt(2) * (n.x - h), d = Math.sqrt(2) * (n.z - u);
    return [o.y, n.y].forEach(((f) => {
      for (let p = 0; p < l; p += 1) {
        const g = Math.PI / 4 + 2 * Math.PI * p / l, y = h + Math.cos(g) * c, m = u + Math.sin(g) * d;
        a.push({ x: y, y: f, z: m });
      }
    })), a.map(((f) => this.xy(f, i))).filter(((f) => f !== void 0));
  }
  cp(t, e, i) {
    const s = gt.length(i.location), o = this.Mp(t, e);
    return s < o.min ? { direction: i.direction, location: gt.multiply(i.direction, -o.min) } : s > o.max ? { direction: i.direction, location: gt.multiply(i.direction, -o.max) } : i;
  }
  Mp(t, e) {
    return { min: (e === "perspective" ? 0.8 : 0.5) * Math.sqrt(t.x ** 2 + t.y ** 2 + t.z ** 2), max: 3 * Math.sqrt(t.x ** 2 + t.y ** 2 + t.z ** 2) };
  }
  dp(t) {
    const e = Ht(0, 1, 0), i = gt.normalize(gt.cross(e, gt.multiply(t, -1)));
    let s = gt.cross(i, t);
    return s.y = Math.abs(s.y), s = gt.normalize(s), { Right: i, Up: s, Down: gt.multiply(s, -1), Left: gt.multiply(i, -1) };
  }
  fp(t) {
    const e = { x: 0, y: 1, z: 0 }, i = gt.angle(t, e), s = gt.angle(t, gt.multiply(e, -1));
    return Math.min(i, s);
  }
  vp(t, e, i) {
    return { location: gt.lerp(t.location, e.location, i), direction: gt.normalize(gt.lerp(t.direction, e.direction, i)) };
  }
  Ap(t) {
    return this.Zy = t, this;
  }
  _p() {
    return this.Zy;
  }
}
const k2 = (r, t, e, i, s, o, n, a) => {
  let l, h = 0, u = (t + r) / 2;
  do {
    const c = e(u);
    if (l = { value: u, result: c, score: i(c) }, Math.abs(l.score - s) <= o) break;
    const d = l.score > s;
    d && n === "linear" || !d && n === "reversed" ? (u = (l.value + r) / 2, t = l.value) : (u = (l.value + t) / 2, r = l.value), h += 1;
  } while (h < a);
  return l.result;
}, Oh = (r, t, e, i, s, o, n, a) => {
  let l, h = 0, u = r;
  do {
    const c = e(u), d = i(c);
    if (l === void 0 || Math.abs(d - s) < Math.abs(l.score - s)) {
      if (l = { value: u, result: c, score: i(c) }, Math.abs(l.score - s) <= o) break;
    } else break;
    h += 1, u += 1 / (a - 1) * (t - r);
  } while (h < a);
  return l.result;
};
class D2 extends Ya {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, o, n), this.Vs = "Surface Grid Series 3D", this.wp = {}, this.zv = !1, this.D = new Nt(), this._v = Na;
    const a = s?.automaticColorIndex !== void 0 ? s.automaticColorIndex : this.chart.getSeries().length;
    this.Ke = ue(this.xi.surfaceGridSeries3DFillStyle, a), this.kp = ue(this.xi.surfaceGridSeries3DWireframeStyle, a);
    const l = { heatmapDataType: "intensity", dataOrder: s.dataOrder || "columns", columns: s.columns, rows: s.rows };
    this.Ga = l, this.zc = this.Tv.Tp(l).sr(this.Ke).Cp(this.kp).Lv(this._v).Ii(this.getHighlight()), this.Ts(this.zc), this.setHighlightOnHover(!1);
  }
  Fv(t) {
  }
  Gv() {
    return this.zv;
  }
  Qi(t, e, i) {
    const s = t?.dataPoint;
    if (s) return { cursorPosition: { resultTable: this.chart.translateCoordinate(e, this.chart.coordsRelative), resultTableScale: this.chart.xA, axisLocation: s }, ...s, series: this, axisX: this.chart.getDefaultAxisX(), axisY: this.chart.getDefaultAxisY(), axisZ: this.chart.getDefaultAxisZ(), lut: Ve(this.Ke) ? this.Ke.lut : void 0 };
  }
  nr() {
    return { fill: this.Ke };
  }
  Fp() {
    const t = this.wp.start || { x: 0, z: 0 };
    let e;
    e = this.wp.end ? { x: (this.wp.end.x - t.x) / this.Ga.columns, z: (this.wp.end.z - t.z) / this.Ga.rows } : this.wp.step ? this.wp.step : { x: 1, z: 1 }, this.zc.Ip(t, e), this.chart.yi.Rs();
  }
  setStart(t) {
    return this.wp.start = t, this.Fp(), this;
  }
  getStart() {
    return this.zc.Pp().start;
  }
  setStep(t) {
    return this.wp.step = t, this.Fp(), this;
  }
  getStep() {
    return this.zc.Pp().step;
  }
  setEnd(t) {
    return this.wp.end = t, this.Fp(), this;
  }
  getEnd() {
    return this.zc.Pp().end;
  }
  setContours(t) {
    return this.zc.Lp(t ? { valueSource: t.valueSource, levels: t.levels.map(((e) => {
      var i, s;
      return { value: e.value, strokeStyle: (s = (i = e.strokeStyle) !== null && i !== void 0 ? i : this.xi.surfaceGridSeriesContourStrokeStyle) !== null && s !== void 0 ? s : new $t({ thickness: 1, fillStyle: new ot({ color: N(255, 0, 0) }) }) };
    })) } : void 0), this.Tv.Rs(), this;
  }
  getContours() {
    return this.zc.Bp();
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.zc.sr(this.Ke), this.Tv.Rs(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setWireframeStyle(t) {
    return this.kp = typeof t == "function" ? t(this.kp) : t, this.zc.Cp(this.kp), this.Tv.Rs(), this;
  }
  getWireframeStyle() {
    return this.zc.Dp();
  }
  setIntensityInterpolation(t) {
    return t = t || "disabled", this.zc.Ep(t), this.Tv.Rs(), this;
  }
  getIntensityInterpolation() {
    return this.zc.Rp();
  }
  invalidateIntensityValues(t) {
    if (this.zv && this.chart.yi.Oa(Ot.Go), Array.isArray(t)) {
      if (t.length === 0 || t[0].length === 0) return this;
      const e = { x: t.length, y: t[0].length, columns: this.Ga.dataOrder === "columns" ? t.length : t[0].length, rows: this.Ga.dataOrder === "rows" ? t.length : t[0].length }, i = this.Ga.dataOrder === "columns" ? this.Ga.columns : this.Ga.rows, s = this.Ga.dataOrder === "columns" ? this.Ga.rows : this.Ga.columns;
      if (e.x > i || e.y > s) {
        if (this.chart.Qg.$a === !0) {
          const n = `SurfaceGridSeries3D.invalidateIntensityValues intensity matrix overflow.
    Grid ${this.Ga.columns}x${this.Ga.rows}, input ${e.columns}x${e.rows}.
    Excess data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(n);
        }
        const o = [];
        for (let n = 0; n < i; n += 1) o[n] = t[n].slice(0, s);
        t = o;
      }
      this.zc.Op({ type: "intensity", lengthPrimary: t.length, lengthSecondary: t[0].length, startPrimary: 0, startSecondary: 0, values: t });
    } else if ("iColumn" in t && "iRow" in t && "values" in t) {
      if (t.values.length === 0 || t.values[0].length === 0) return this;
      const e = { primary: t.values.length, secondary: t.values[0].length, columns: this.Ga.dataOrder === "columns" ? t.values.length : t.values[0].length, rows: this.Ga.dataOrder === "rows" ? t.values.length : t.values[0].length };
      let i = this.Ga.dataOrder === "columns" ? t.iColumn : t.iRow;
      const s = i + e.primary - 1;
      let o = this.Ga.dataOrder === "columns" ? t.iRow : t.iColumn;
      const n = o + e.secondary - 1, a = (this.Ga.dataOrder === "columns" ? this.Ga.columns : this.Ga.rows) - 1, l = (this.Ga.dataOrder === "columns" ? this.Ga.rows : this.Ga.columns) - 1;
      if (i < 0 || o < 0 || s > a || n > l) {
        if (this.chart.Qg.$a === !0) {
          const g = `SurfaceGridSeries3D.invalidateIntensityValues intensity matrix overflow.
    Grid ${this.Ga.columns}x${this.Ga.rows}, input ${e.columns}x${e.rows} starting at [${t.iColumn},${t.iRow}].
    Out of bounds data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(g);
        }
        const h = Math.max(-i, 0), u = Math.max(-o, 0), c = Math.max(s - a, 0), d = Math.max(n - l, 0), f = e.primary - (h + c), p = [];
        if (u === 0 && d === 0) for (let g = 0; g < f; g += 1) p[g] = t.values[h + g];
        else for (let g = 0; g < f; g += 1) p[g] = t.values[h + g].slice(u, d === 0 ? void 0 : -d);
        if (p.length === 0 || p[0].length === 0) return this;
        t = { iColumn: t.iColumn, iRow: t.iRow, values: p }, i = Math.max(i, 0), o = Math.max(o, 0);
      }
      this.zc.Op({ type: "intensity", lengthPrimary: t.values.length, lengthSecondary: t.values[0].length, startPrimary: i, startSecondary: o, values: t.values });
    }
    return this.Tv.Rs(), this.zv = !0, this;
  }
  invalidateHeightMap(t) {
    if (this.zv && this.chart.yi.Oa(Ot.Go), Array.isArray(t)) {
      if (t.length === 0 || t[0].length === 0) return this;
      const e = { x: t.length, y: t[0].length, columns: this.Ga.dataOrder === "columns" ? t.length : t[0].length, rows: this.Ga.dataOrder === "rows" ? t.length : t[0].length }, i = this.Ga.dataOrder === "columns" ? this.Ga.columns : this.Ga.rows, s = this.Ga.dataOrder === "columns" ? this.Ga.rows : this.Ga.columns;
      if (e.x > i || e.y > s) {
        if (this.chart.Qg.$a === !0) {
          const n = `SurfaceGridSeries3D.invalidateHeightMap height matrix overflow.
    Grid ${this.Ga.columns}x${this.Ga.rows}, input ${e.columns}x${e.rows}.
    Excess data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(n);
        }
        const o = [];
        for (let n = 0; n < i; n += 1) o[n] = t[n].slice(0, s);
        t = o;
      }
      this.zc.zp({ type: "y", lengthPrimary: t.length, lengthSecondary: t[0].length, startPrimary: 0, startSecondary: 0, values: t });
    } else if ("iColumn" in t && "iRow" in t && "values" in t) {
      if (t.values.length === 0 || t.values[0].length === 0) return this;
      const e = { primary: t.values.length, secondary: t.values[0].length, columns: this.Ga.dataOrder === "columns" ? t.values.length : t.values[0].length, rows: this.Ga.dataOrder === "rows" ? t.values.length : t.values[0].length };
      let i = this.Ga.dataOrder === "columns" ? t.iColumn : t.iRow;
      const s = i + e.primary - 1;
      let o = this.Ga.dataOrder === "columns" ? t.iRow : t.iColumn;
      const n = o + e.secondary - 1, a = (this.Ga.dataOrder === "columns" ? this.Ga.columns : this.Ga.rows) - 1, l = (this.Ga.dataOrder === "columns" ? this.Ga.rows : this.Ga.columns) - 1;
      if (i < 0 || o < 0 || s > a || n > l) {
        if (this.chart.Qg.$a === !0) {
          const g = `SurfaceGridSeries3D.invalidateHeightMap height matrix overflow.
    Grid ${this.Ga.columns}x${this.Ga.rows}, input ${e.columns}x${e.rows} starting at [${t.iColumn},${t.iRow}].
    Out of bounds data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(g);
        }
        const h = Math.max(-i, 0), u = Math.max(-o, 0), c = Math.max(s - a, 0), d = Math.max(n - l, 0), f = e.primary - (h + c), p = [];
        if (u === 0 && d === 0) for (let g = 0; g < f; g += 1) p[g] = t.values[h + g];
        else for (let g = 0; g < f; g += 1) p[g] = t.values[h + g].slice(u, d === 0 ? void 0 : -d);
        if (p.length === 0 || p[0].length === 0) return this;
        t = { iColumn: t.iColumn, iRow: t.iRow, values: p }, i = Math.max(i, 0), o = Math.max(o, 0);
      }
      this.zc.zp({ type: "y", lengthPrimary: t.values.length, lengthSecondary: t.values[0].length, startPrimary: i, startSecondary: o, values: t.values });
    }
    return this.Tv.Rs(), this.zv = !0, this;
  }
  setCullMode(t) {
    return this.zc.Vp(typeof t == "boolean" ? t ? "cull-back" : "disabled" : t), this;
  }
  getCullMode() {
    return this.zc.Np();
  }
  Ws() {
    return is(this.Ke, this.zc.wi());
  }
  Dv() {
  }
  rr() {
  }
  Ev() {
  }
  Uv() {
    return this.kv && this.getVisible();
  }
  ar(t, e) {
    t.Ii(e), this.Tv.Rs();
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class F2 extends Ya {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, o, n), this.Vs = "Surface Grid Series 3D", this.zv = !1, this.wp = {}, this.D = new Nt(), this.chart.yi.Oa(Ot.Go), this._v = Na;
    const a = s?.automaticColorIndex !== void 0 ? s.automaticColorIndex : this.chart.getSeries().length;
    this.Ke = ue(this.xi.surfaceScrollingGridSeries3DFillStyle, a), this.kp = ue(this.xi.surfaceScrollingGridSeries3DWireframeStyle, a);
    const l = { heatmapDataType: "intensity", scrollDimension: s.scrollDimension || "columns", columns: s.columns, rows: s.rows };
    this.Ga = l, this.zc = this.Tv.Gp(l).sr(this.Ke).Cp(this.kp).Lv(this._v).Ii(this.getHighlight()), this.Ts(this.zc), this.setHighlightOnHover(!1);
  }
  Fv(t) {
  }
  Gv() {
    return this.zv;
  }
  Qi(t, e, i) {
    const s = t?.dataPoint;
    if (s) return { cursorPosition: { resultTable: this.chart.translateCoordinate(e, this.chart.coordsRelative), resultTableScale: this.chart.xA, axisLocation: s }, ...s, series: this, axisX: this.chart.getDefaultAxisX(), axisY: this.chart.getDefaultAxisY(), axisZ: this.chart.getDefaultAxisZ(), lut: Ve(this.Ke) ? this.Ke.lut : void 0 };
  }
  Fp() {
    const t = this.wp.start || { x: 0, z: 0 };
    let e;
    e = this.wp.step ? this.wp.step : { x: 1, z: 1 }, this.zc.Ip(t, e), this.chart.yi.Rs();
  }
  setStart(t) {
    return this.wp.start = t, this.Fp(), this;
  }
  getStart() {
    return this.zc.Pp().start;
  }
  setStep(t) {
    return this.wp.step = t, this.Fp(), this;
  }
  getStep() {
    return this.zc.Pp().step;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.zc.sr(this.Ke), this.Tv.Rs(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setWireframeStyle(t) {
    return this.kp = typeof t == "function" ? t(this.kp) : t, this.zc.Cp(this.kp), this.Tv.Rs(), this;
  }
  getWireframeStyle() {
    return this.zc.Dp();
  }
  setIntensityInterpolation(t) {
    return t = t || "disabled", this.zc.Ep(t), this.Tv.Rs(), this;
  }
  getIntensityInterpolation() {
    return this.zc.Rp();
  }
  clear() {
    return this.zc.Vi(), this.Tv.Rs(), this;
  }
  addValues(t) {
    if (!t) return this;
    let e = t.yValues, i = t.intensityValues;
    if (!e && !i) return this;
    if (e && e.length === 0 && (e = void 0), i && i.length === 0 && (i = void 0), this.zv = !0, e) {
      const n = e[0].length, a = 0 + n - 1, l = this.Ga.scrollDimension === "columns" ? this.Ga.rows : this.Ga.columns;
      if (a > l - 1) {
        if (this.chart.Qg.$a === !0) {
          const u = `SurfaceScrollingGridSeries3D.addValues input yValues overflow.
Grid was created with ${l} ${this.Ga.scrollDimension === "columns" ? "rows" : "columns"}, input yValues have ${n}.
Excess data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(u);
        }
        const h = [];
        for (let u = 0; u < e.length; u += 1) h[u] = e[u].slice(0, l + 1);
        e = h;
      }
    }
    if (i) {
      const n = i[0].length, a = 0 + n - 1, l = this.Ga.scrollDimension === "columns" ? this.Ga.rows : this.Ga.columns;
      if (a > l - 1) {
        if (this.chart.Qg.$a === !0) {
          const u = `SurfaceScrollingGridSeries3D.addValues intensityValues overflow.
Grid was created with ${l} ${this.Ga.scrollDimension === "columns" ? "rows" : "columns"}, input intensityValues have ${n}.
Excess data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(u);
        }
        const h = [];
        for (let u = 0; u < i.length; u += 1) h[u] = i[u].slice(0, l + 1);
        i = h;
      }
    }
    if (e && i) {
      const n = e.length, a = i.length;
      if (n !== a) {
        if (this.chart.Qg.$a === !0) {
          const l = `SurfaceScrollingGridSeries3D.addValues input yValues and intensityValues size does not match.
yValues: ${n}
intensityValues: ${a}
Data will be automatically clipped according to the smaller supplied sample. This can result in sub-optimal performance.`;
          H.console.warn(l);
        }
        n > a ? e = e.slice(0, a) : i = i.slice(0, n);
      }
    }
    const s = e ? e.length : i?.length, o = e ? e[0].length : i?.[0].length;
    return this.zc.$p({ startPrimary: 0, startSecondary: 0, lengthPrimary: s, lengthSecondary: o, heightMapValues: e, intensityValues: i }), this.Tv.Rs(), this;
  }
  invalidateValues(t) {
    return this.zc.Op(t), this.chart.yi.Rs(), this;
  }
  getSampleCount() {
    return this.zc.jp();
  }
  setCullMode(t) {
    return this.zc.Vp(typeof t == "boolean" ? t ? "cull-back" : "disabled" : t), this;
  }
  getCullMode() {
    return this.zc.Np();
  }
  Ws() {
    return is(this.Ke, this.zc.wi());
  }
  Dv() {
  }
  rr() {
  }
  Ev() {
  }
  Uv() {
    return this.kv && this.getVisible();
  }
  ar(t, e) {
    t.Ii(e), this.Tv.Rs();
  }
  nr() {
    return { fill: this.Ke };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Yo = (r) => !!(r && typeof r == "object" && "id" in r && "chart" in r && r.chart instanceof jf), Nh = (r) => !!(r && typeof r == "object" && "x" in r && typeof r.x == "number" && "y" in r && typeof r.y == "number" && "z" in r && typeof r.z == "number"), Bn = (r, t = /\s+/g) => Array.from(r.split(t).map(parseFloat)), Oc = (r) => {
  if (r.length <= 3) return r;
  const t = new Array();
  for (let e = 1; e < r.length - 1; e += 1) t.push(r[0]), t.push(r[e]), t.push(r[e + 1]);
  return t;
}, L2 = (r) => {
  const t = r.split(/\s+/g);
  let e = [], i = [], s = [];
  for (const o of t) {
    const n = Bn(o.trim(), "/");
    e.push(n[0]), n.length > 1 && !Number.isNaN(n[1]) && s.push(n[1]), n.length > 2 && !Number.isNaN(n[2]) && i.push(n[2]);
  }
  return e = Oc(e), s = Oc(s), i = Oc(i), { vertexIndex: e, textureIndex: s || void 0, normalIndex: i || void 0 };
}, ei = { id: "", ambient: N(0, 0, 0, 0), diffuse: N(254, 204, 0), emissive: N(0, 0, 0, 0), specular: N(255, 255, 255), specularCoeff: 1, opacity: 1 };
class P2 extends Ya {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, n), this.Vs = "Mesh Model 3D", this.Yp = new Float32Array(), this.Hp = new Float32Array(), this.Wp = new Uint16Array(), this.ai = { x: 1, y: 1, z: 1 }, this.Xp = { x: 0, y: 0, z: 0 }, this.Zp = { x: 0, y: 0, z: 0 }, this.Jp = { x: 0, y: 0, z: 0 }, this.Qp = { w: 1, x: 0, y: 0, z: 0 }, this.Kp = { x: 0, y: 0, z: 0 }, this.qp = new Array(), this.tm = [], this.gu = _s, this.D = new Nt();
    const a = o?.automaticColorIndex !== void 0 ? o.automaticColorIndex : this.chart.getSeries().length;
    this.zc = this.Tv.im().Bv(this.Cv).sr(ue(this.xi.meshModel3DFillStyle || this.xi.pointSeriesFillStyle, a)).Ii(this.getHighlight()), this.Ts(this.zc);
  }
  Fv(t) {
  }
  Gv() {
    return this.Yp.length > 0;
  }
  Qi(t, e, i) {
    const s = this.getFillStyle();
    return Pr({ series: this, axisX: this.chart.getDefaultAxisX(), axisY: this.chart.getDefaultAxisY(), axisZ: this.chart.getDefaultAxisZ(), lut: Ve(s) ? s.lut : void 0 }, { cursorPosition: 0, index: 0, x: 0, y: 0, z: 0, value: 0, coordAxis: 0, coordModel: 0 }, (() => {
      const o = this.zc.sm(t, e);
      if (o) return { cursorPosition: { resultTable: this.chart.translateCoordinate(e, this.chart.coordsRelative), resultTableScale: this.chart.xA, axisLocation: o.coordAxis }, ...o.coordAxis, index: o.index, value: o.value, coordAxis: o.coordAxis, coordModel: o.coordModel, series: this, axisX: this.chart.getDefaultAxisX(), axisY: this.chart.getDefaultAxisY(), axisZ: this.chart.getDefaultAxisZ(), lut: Ve(s) ? s.lut : void 0 };
    }));
  }
  setModelGeometry(t) {
    const { indices: e, vertices: i, normals: s } = t;
    let o = Pt, n = wt, a = Pt, l = wt, h = Pt, u = wt;
    for (let f = 0; f < i.length; f += 3) {
      const p = i[f], g = i[f + 1], y = i[f + 2];
      o = Math.max(o, p), n = Math.min(n, p), a = Math.max(a, g), l = Math.min(l, g), h = Math.max(h, y), u = Math.min(u, y);
    }
    this.gu = { min: { x: n, y: l, z: u }, max: { x: o, y: a, z: h } };
    for (let f = 0; f < i.length; f += 3) i[f] -= this.gu.min.x, i[f + 1] -= this.gu.min.y, i[f + 2] -= this.gu.min.z;
    this.Kp = { x: this.gu.max.x - this.gu.min.x, y: this.gu.max.y - this.gu.min.y, z: this.gu.max.z - this.gu.min.z }, this.Yp = i instanceof Float32Array ? i : new Float32Array(i), this.checkedNormals = s && !Number.isNaN(s[0]) ? s instanceof Float32Array ? s : new Float32Array(s) : void 0, this.checkedNormals || this.setColorShadingStyle(Na);
    const c = new Array(), d = { indexStart: 0, count: e.length, useIndexBuffer: !0, offset: 0, material: { id: ei.id, diffuse: ei.diffuse, specular: ei.specular, ambient: ei.ambient, emissive: ei.emissive, specularCoeff: ei.specularCoeff, opacity: 1 } };
    return c.push(d), this.tm = c, this.zc.rm({ vertices: this.Yp, normals: this.checkedNormals, indices: e instanceof Uint32Array || e instanceof Uint16Array ? e : new Uint16Array(e), modelSize: this.Kp, parts: this.tm }), this.chart.yi.Rs(), this;
  }
  hm(t) {
    if (!t) return this;
    this.qp = [];
    let e = { id: ei.id, diffuse: ei.diffuse, specular: ei.specular, ambient: ei.ambient, emissive: ei.emissive, specularCoeff: ei.specularCoeff, opacity: 1 };
    const i = t.split(`
`);
    for (let s of i) {
      if (s = s.trim(), s === "" || s.startsWith("#")) continue;
      const o = s.split(/\s+/g);
      switch (o[0].trim().toLowerCase()) {
        case "ka":
          {
            const n = Bn(s.substring(2).trim()).map(((a) => 255 * a));
            e.ambient = N(n[0], n[1], n[2]);
          }
          break;
        case "ke":
          {
            const n = Bn(s.substring(2).trim()).map(((a) => 255 * a));
            e.emissive = N(n[0], n[1], n[2]);
          }
          break;
        case "kd":
          {
            const n = Bn(s.substring(2).trim()).map(((a) => 255 * a));
            e.diffuse = N(n[0], n[1], n[2]);
          }
          break;
        case "ks":
          {
            const n = Bn(s.substring(2).trim()).map(((a) => 255 * a));
            e.specular = N(n[0], n[1], n[2]);
          }
          break;
        case "d":
          e.opacity = parseFloat(o[1].trim());
          break;
        case "tr":
          e.opacity = 1 - parseFloat(o[1].trim());
          break;
        case "newmtl":
          e.diffuse = N(255 * e.diffuse.r, 255 * e.diffuse.g, 255 * e.diffuse.b, 255 * e.opacity), e.specular = N(255 * e.specular.r, 255 * e.specular.g, 255 * e.specular.b, 255 * e.opacity), e.emissive = N(255 * e.emissive.r, 255 * e.emissive.g, 255 * e.emissive.b, 255 * e.opacity), e = { id: o[1], diffuse: ei.diffuse, specular: ei.specular, ambient: ei.ambient, emissive: ei.emissive, specularCoeff: ei.specularCoeff, opacity: ei.opacity }, this.qp.push(e);
      }
    }
    return this;
  }
  setModelMaterial(t) {
    return t ? (this.hm(t), this.setFillStyle(Lt), this.tm ? (this.tm.forEach(((e) => {
      const i = this.qp.find(((s) => s.id.toLowerCase() === e.material.id.toLowerCase()));
      i && (e.material = i);
    })), this.tm.sort(((e, i) => i.material.opacity - e.material.opacity)), this.chart.yi.Rs(), this) : this) : this;
  }
  setModelFromObj(t) {
    if (!t) return this;
    const e = new Array(), i = new Array(), s = new Array(), o = new Array(), n = new Array(), a = new Array(), l = new Array();
    let h = { indexStart: 0, count: 0, offset: 0, useIndexBuffer: !1, material: { id: ei.id, diffuse: ei.diffuse, specular: ei.specular, ambient: ei.ambient, emissive: ei.emissive, specularCoeff: ei.specularCoeff, opacity: ei.opacity } }, u = 0, c = 0, d = 0, f = 0, p = 0, g = 0, y = 0, m = Pt, A = wt, v = Pt, b = wt, w = Pt, k = wt;
    const R = t.replace(/\r/g, "").split(`
`);
    for (let L of R) {
      if (L = L.trim(), L === "" || L.startsWith("#")) continue;
      const x = L.split(/\s+/g);
      let M = 0;
      switch (x[0].trim().toLowerCase()) {
        case "v":
          {
            const C = Bn(L.substring(1).trim()), S = C[0], E = C[1], T = C[2];
            m = Math.max(m, S), A = Math.min(A, S), v = Math.max(v, E), b = Math.min(b, E), w = Math.max(w, T), k = Math.min(k, T), e.push(...C.slice(0, 3)), u += 1, f = u;
          }
          break;
        case "vt":
          {
            const C = Bn(L.substring(2).trim());
            i.push(...C), c += 1, p = c;
          }
          break;
        case "vn":
          {
            const C = Bn(L.substring(2).trim());
            s.push(...C), d += 1, g = d;
          }
          break;
        case "usemtl":
          {
            const C = this.qp.find(((S) => S.id.toLowerCase() === x[1].toLowerCase()));
            y += l.length > 0 ? h.count : 0, h = { indexStart: h !== void 0 ? 3 * y * 2 : 0, count: 0, offset: h !== void 0 ? 1 * y : 0, useIndexBuffer: !1, material: C || { id: x[1].toLowerCase(), diffuse: ei.diffuse, specular: ei.specular, ambient: ei.ambient, emissive: ei.emissive, specularCoeff: 1, opacity: 1 } }, l.push(h);
          }
          break;
        case "fo":
          M += 1;
        case "f":
          M += 1;
          {
            const C = L2(L.substring(M).trim());
            for (let S = 0; S < C.vertexIndex.length; S += 1) {
              let E = C.vertexIndex[S];
              E < 0 ? E += f : E -= 1, E *= 3, o.push(e[E]), o.push(e[E + 1]), o.push(e[E + 2]);
            }
            if (h.count += C.vertexIndex.length, C.textureIndex) for (let S = 0; S < C.textureIndex.length; S += 1) {
              let E = C.textureIndex[S];
              E < 0 ? E += p : E -= 1, E *= 3, a.push(i[E]), a.push(i[E + 1]), a.push(i[E + 2]);
            }
            if (C.normalIndex) for (let S = 0; S < C.normalIndex.length; S += 1) {
              let E = C.normalIndex[S];
              E < 0 ? E += g : E -= 1, E *= 3, n.push(s[E]), n.push(s[E + 1]), n.push(s[E + 2]);
            }
          }
      }
    }
    this.gu = { min: { x: A, y: b, z: k }, max: { x: m, y: v, z: w } };
    for (let L = 0; L < o.length; L += 3) o[L] -= this.gu.min.x, o[L + 1] -= this.gu.min.y, o[L + 2] -= this.gu.min.z;
    if (this.Kp = { x: this.gu.max.x - this.gu.min.x, y: this.gu.max.y - this.gu.min.y, z: this.gu.max.z - this.gu.min.z }, l.length < 1 && o.length > 0 && (h.count = o.length / 3, l.push(h)), this.tm = l, this.Yp = new Float32Array(o), n.length < 1) for (let L = 0; L < o.length / 9; L += 1) {
      const x = { x: o[9 * L], y: o[9 * L + 1], z: o[9 * L + 2] }, M = { x: o[9 * L + 3], y: o[9 * L + 4], z: o[9 * L + 5] }, C = { x: o[9 * L + 6], y: o[9 * L + 7], z: o[9 * L + 8] }, S = gt.normalize(gt.cross(gt.subtractVec(x, M), gt.subtractVec(x, C)));
      for (let E = 0; E < 3; E += 1) n.push(S.x), n.push(S.y), n.push(S.z);
    }
    return this.Hp = new Float32Array(n.map(((L, x) => n[x]))), this.checkedNormals = new Float32Array(), this.qp && this.tm.sort(((L, x) => x.material.opacity - L.material.opacity)), this.zc.rm({ vertices: this.Yp, normals: this.Hp, indices: this.Wp, modelSize: this.Kp, parts: this.tm }), this.chart.yi.Rs(), this;
  }
  setVertexValues(t) {
    return this.zc.nm(t), this.chart.yi.Rs(), this;
  }
  setScale(t) {
    const e = { x: typeof t == "number" ? t : t?.x || 1, y: typeof t == "number" ? t : t?.y || 1, z: typeof t == "number" ? t : t?.z || 1 };
    return this.ai = e, this.zc.om(e), this.chart.yi.Rs(), this;
  }
  getScale() {
    return this.ai;
  }
  setModelLocation(t) {
    return this.Zp = t, this.zc.am(t), this.chart.yi.Rs(), this;
  }
  getModelLocation() {
    return this.Zp;
  }
  setModelAlignment(t) {
    return this.Xp = t, this.zc.lm(t), this.chart.yi.Rs(), this;
  }
  getModelAlignment() {
    return this.Xp;
  }
  setModelRotation(t) {
    return this.setModelRotationEuler(t);
  }
  getModelRotation() {
    return this.Jp;
  }
  setModelRotationEuler(t) {
    const e = { x: $n(t.x), y: $n(t.y), z: $n(t.z) };
    return this.Jp = e, this.zc.um(this.Jp), this.chart.yi.Rs(), this;
  }
  getModelRotationEuler() {
    return this.Jp;
  }
  setModelRotationQuaternion(t) {
    return this.Qp = t, this.zc.dm(this.Qp), this.chart.yi.Rs(), this;
  }
  getModelRotationQuaternion() {
    return this.Qp;
  }
  setBackfaceCullingMode(t) {
    return this.zc.fm(t), this.chart.yi.Rs(), this;
  }
  getBackfaceCullingMode() {
    return this.zc.Am();
  }
  setFillStyle(t) {
    return this.zc.sr(t), this.chart.yi.Rs(), this;
  }
  getFillStyle() {
    return this.zc.kh();
  }
  setColorShadingStyle(t) {
    return this.checkedNormals || t !== Ba ? super.setColorShadingStyle(t) : (console.warn("Phong shading style is not supported without normals. Switching to Simple shading style."), super.setColorShadingStyle(new Zm.Simple()));
  }
  Uv() {
    return !1;
  }
  ar(t, e) {
    t.Ii(e), this.chart.yi.Rs();
  }
  Ws() {
    return is(this.getFillStyle(), this.zc.wi());
  }
  nr() {
    return { fill: this.getFillStyle() };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const R2 = { None: Eb };
class I2 extends Hb {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o, n), this.ho = this.xi.cursorResultTableTextFont, this.If = 0, this.Zv = this.xi.cursorResultTableTextFillStyle, this.Zn = 100, this.Kr = es.CursorResultTable;
  }
  setContent(t) {
    var e;
    let i;
    t === void 0 ? i = [] : Array.isArray(t) ? (i = [], t.forEach(((a) => {
      i.push(Array.isArray(a) ? a : [a]);
    }))) : i = [[t]];
    for (let a = 0; a < i.length; a += 1) {
      const l = i[a];
      let h = !1;
      for (let u = 0; u < l.length; u += 1) {
        const c = l[u], d = typeof c == "object" && "text" in c ? c.text : typeof c == "string" ? c : void 0, f = typeof c == "object" && "icon" in c ? c.icon : Pn(c) ? c : void 0, p = c instanceof to && c;
        if (!(d && d.length > 0 || f || p)) {
          h = !0;
          break;
        }
      }
      h || (l.unshift(""), l.push(""));
    }
    const s = i.length;
    let o = this.getMembers().length;
    for (let a = 0; a < Math.max(s, o); a += 1) {
      const l = this.getRow(a, !0);
      if (a >= s) this.getMembers()[a].dispose(), a -= 1, o -= 1;
      else {
        const h = i[a].length;
        let u = l.getMembers().length;
        for (let c = 0; c < Math.max(h, u); c += 1) {
          const d = i[a][c], f = typeof d == "object" && "font" in d ? d.font : void 0, p = typeof d == "object" && "fillStyle" in d ? d.fillStyle : void 0, g = typeof d == "object" && "text" in d ? d.text : typeof d == "string" ? d : void 0, y = typeof d == "object" && "icon" in d ? d.icon : Pn(d) ? d : void 0, m = d instanceof to && d || (typeof d == "object" && "component" in d ? d.component : void 0), A = typeof d == "object" && "componentColor" in d && d.componentColor, v = typeof d == "object" && "componentFillStyle" in d && d.componentFillStyle, b = typeof d == "object" && "rowFillStyle" in d ? d.rowFillStyle : void 0, w = l.getMembers();
          if (c >= h) l.getMembers()[c].dispose(), c -= 1, u -= 1;
          else if (g !== void 0 && g.length > 0 || y || m) {
            const k = f ? this.ho.withMutations(((x) => {
              for (const M of Object.keys(f)) {
                const C = f[M];
                C !== void 0 && x.set(M, C);
              }
              return x;
            })) : this.ho, R = p || this.Zv, L = w[c];
            if (g) {
              let x;
              L && L instanceof Sd ? x = L : (L && L.dispose(), x = l.addElement(Qu, c)), x.setText(g).setFont(k).setFillStyle(R).setTextRotation(this.If);
            } else if (y) {
              let x;
              L && L instanceof Ha ? x = L : (L && L.dispose(), x = l.addElement(Ub, c)), x.setFillStyle(R).setShape(y).setSize({ y: k.size, x: k.size }), x.setMargin((e = this.xi.uiTextPadding) !== null && e !== void 0 ? e : 5);
            } else if (m) {
              let x;
              L && "setTextFillStyleHidden" in (n = L) && "setText" in n ? x = L : (L && L.dispose(), x = l.addElement(fx.setBackground(R2.None), c).setOn(!0));
              const M = m.Xs();
              M !== void 0 && x.setButtonShape(M), x.setText(m.getName()).setTextFont(k).setTextFillStyle(R).setTextRotation(this.If), A ? x.setButtonOnFillStyle(new ot({ color: A })) : v ? x.setButtonOnFillStyle(v) : x.setButtonOnFillStyle(Bl(m.chart.getTheme(), !1, m.nr()));
            }
            b && l.setBackground(((x) => {
              x.setFillStyle(b);
              const M = this.getBackground();
              Xm(M) && x instanceof xn && x.setCornerRadius(M.getCornerRadius(), { topLeft: a === 0, topRight: a === 0, bottomLeft: a === s - 1, bottomRight: a === s - 1 });
            }));
          } else {
            const k = w[c];
            k && k instanceof Ma || (k && k.dispose(), l.addGap(void 0, c));
          }
        }
      }
    }
    var n;
    return this.Js.Rs(), this;
  }
  rr() {
    if (super.rr(), this.Js.yi.Pc && this.getVisible()) {
      const t = nx(this);
      this.Js.yi.Pc.XA({ ...t, blacklist: [es.CursorResultTable] });
    }
    return this;
  }
  setTextFillStyle(t) {
    this.Zv = typeof t == "function" ? t(this.Zv) : t;
    for (let e = 0; e < this.getMemberCount(); e += 1) {
      const i = this.getRow(e);
      for (let s = 0; s < i.getMembers().length; s += 1) {
        const o = i.getMembers()[s];
        o instanceof Sd && o.setFillStyle(this.Zv);
      }
    }
    return this.Js.Rs(), this;
  }
  getTextFillStyle() {
    return this.Zv;
  }
  setTextFont(t) {
    return sa(t) ? this.ho = t : this.ho = t(this.ho), this.Js.Rs(), this;
  }
  getTextFont() {
    return this.ho;
  }
  setTextRotation(t) {
    return this.If = t, this.Js.Rs(), this;
  }
  getTextRotation() {
    return this.If;
  }
  gm() {
    for (let t = 0; t < this.ff.length; t += 1) for (let e = 0; e < this.ff[t].getMembers().length; e += 1) this.ff[t].getMembers()[e].dispose();
  }
  Uh() {
    for (let t = 0; t < this.ff.length; t += 1) this.ff[t].setMinimumSize(void 0);
    super.Uh();
    for (let t = 0; t < this.ff.length; t += 1) this.ff[t].setMinimumSize(this.size.x);
    return super.Uh(), this;
  }
}
class Yf {
  constructor(t, e, i, s, o, n) {
    this.vm = [], this.ym = !0, this.pm = !0, this.Hg = !1, this.di = !0, this.ci = !1, this.Sm = [], this.bm = !0, this.D = new Nt(), this.Js = t, this.renderingScale = e, this.scale = i, this.xm = s, this.Mm = o, this.xi = n, this._m = new I2(this.Js, this.renderingScale, this.scale, this.Mm, ie, n).setPointerEvents(!1).setBackground(((a) => a.setFillStyle(n.cursorResultTableFillStyle).setStrokeStyle(n.cursorResultTableStrokeStyle))).setTextFillStyle(n.cursorResultTableTextFillStyle).setTextFont(n.cursorResultTableTextFont), this.wm = new Tg(((a) => this._m.setOrigin(a)), (() => this._m.getOrigin())), this.km = new Tg(((a) => this._m.setPosition(a)), (() => this._m.getPosition()));
  }
  isDisposed() {
    return this.ci;
  }
  setPointMarkerVisible(t) {
    return this.ym = t, this.vm.forEach(((e) => e.pointMarker.setVisible(e.targetVisible && t))), this.Js.Rs(), this;
  }
  getPointMarkerVisible() {
    return this.ym;
  }
  setPointMarker(t) {
    return this.vm.forEach(((e) => t(e.pointMarker))), this.Sm.push(t), this.Js.Rs(), this;
  }
  setResultTableVisible(t) {
    return this.pm = t, this.Js.Rs(), this;
  }
  getResultTableVisible() {
    return this.pm;
  }
  setResultTable(t) {
    return t(this._m), this.Js.Rs(), this;
  }
  setAutoFit(t) {
    return this.bm = t, this.wm.resetValue(), this.km.resetValue(), this.Js.Rs(), this;
  }
  getAutoFit() {
    return this.bm;
  }
  setVisible(t) {
    return this.di = t, this.Js.Rs(), this;
  }
  getVisible() {
    return this.di;
  }
  dispose() {
    return this.vm.forEach(((t) => t.pointMarker.dispose())), this._m.dispose(), this.Sm.length = 0, this.xm(this), this.D.R("dispose", {}), this;
  }
  Cm() {
    const t = this._m, e = this.Js.yi.ai, i = xt(t.getPosition(j(-1, -1), be.PaddedBackground), t.scale, e), s = xt(t.getPosition(j(1, 1), be.PaddedBackground), t.scale, e), o = i.x < e.x.getInnerStart() || s.x > e.x.getInnerEnd(), n = i.y < e.y.getInnerStart() || s.y > e.y.getInnerEnd();
    return { x: o, y: n, either: o || n, resultTableViewport: this._m.Js.yi.ai, resultTableViewportBounds: { x: { min: Math.min(e.x.getInnerStart(), e.x.getInnerEnd()), max: Math.max(e.x.getInnerStart(), e.x.getInnerEnd()) }, y: { min: Math.min(e.y.getInnerStart(), e.y.getInnerEnd()), max: Math.max(e.y.getInnerStart(), e.y.getInnerEnd()) } } };
  }
  rr() {
    if (this.di) {
      (this.wm.isAltered() || this.km.isAltered()) && (this.wm.resetValue(), this.km.resetValue(), this._m.Uh());
      let t = this.bm && this.Cm();
      if (t && t.either) {
        const e = t.resultTableViewport;
        let i = xt(this._m.getPosition(j(-1, -1), be.PaddedBackground), this._m.scale, e), s = xt(this._m.getPosition(j(1, 1), be.PaddedBackground), this._m.scale, e);
        const o = t.resultTableViewportBounds, n = this._m.getOrigin();
        let a = { x: 0, y: 0 }, l = { ...n };
        if (s.y > o.y.max ? a.y = o.y.max - s.y : i.y < o.y.min && (a.y = o.y.min - i.y), (s.x > o.x.max || i.x < o.x.min) && (l.x *= -1), a.x !== 0 || a.y !== 0 || l.x !== n.x || l.y !== n.y) {
          const h = this._m.getPosition(), u = xt(h, this._m.scale, e);
          let c = { x: u.x + a.x, y: u.y + a.y }, d = xt(c, e, this._m.scale);
          this.km.alter(d), this.wm.alter(l), this._m.Uh(), t = this.Cm(), t.x && (i = xt(this._m.getPosition(j(-1, -1), be.PaddedBackground), this._m.scale, e), s = xt(this._m.getPosition(j(1, 1), be.PaddedBackground), this._m.scale, e), s.x > o.x.max ? a.x = o.x.max - s.x : i.x < o.x.min && (a.x = o.x.min - i.x), c = { x: u.x + a.x, y: u.y + a.y }, d = xt(c, e, this._m.scale), this.km.alter(d), this._m.Uh());
        }
      }
    }
    return this.vm.forEach(((t) => t.pointMarker.setVisible(t.targetVisible && this.Hg && this.di && this.ym))), this.vm.forEach(((t) => t.pointMarker.rr())), this._m.rr(), this;
  }
  Uh() {
    return this._m.setVisible(this.Hg && this.di && this.pm), this.vm.forEach(((t) => t.pointMarker.Uh())), this._m.Uh(), this;
  }
  Tm(t, e) {
    const i = e === this.scale ? t : xt(t, e, this.scale);
    this._m.setPosition(i);
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const nc = (r, t) => r.setResultTable(((e) => e.setEffect(!0).setOrigin(j(-1, -1)).setMargin(0.5 * t.cursorPointMarkerSize.x + 2).setBackground(((i) => {
  t.cursorResultTableBorderRadius && Xm(i) && i.setCornerRadius(t.cursorResultTableBorderRadius);
}))));
class Tg {
  constructor(t, e) {
    this.Fm = t, this.Im = e;
  }
  alter(t) {
    this.Pm = this.Pm !== void 0 ? this.Pm : this.Im(), this.Lm = t, this.Fm(t);
  }
  resetValue() {
    this.Lm !== void 0 && (this.Pm !== void 0 && this.isAltered() && this.Fm(this.Pm), this.Pm = void 0, this.Lm = void 0);
  }
  getNormalValue() {
    return this.Pm !== void 0 ? this.Pm : this.Im();
  }
  isAltered() {
    return this.Lm !== void 0 && this.Im() === this.Lm;
  }
}
class V2 extends Yf {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, o, n), this.chart = a, this.Bm = this.chart.getDefaultAxisX().addCustomTick().setVisible(!1).setGridStrokeStyle(n.cursor3DGridStrokeStyleX).setTickStyle(n.cursor3DTickStrokeStyleX).setTextFillStyle(n.cursor3DTickLabelFillStyleX).setTextFont(n.cursor3DTickLabelFontX).setBackgroundFillStyle(n.cursor3DTickLabelBackgroundFillStyleX).setBackgroundStrokeStyle(n.cursor3DTickLabelBackgroundStrokeStyleX).setPadding(n.cursor3DTickLabelPaddingX), this.Dm = this.chart.getDefaultAxisY().addCustomTick().setVisible(!1).setGridStrokeStyle(n.cursor3DGridStrokeStyleY).setTickStyle(n.cursor3DTickStrokeStyleY).setTextFillStyle(n.cursor3DTickLabelFillStyleY).setTextFont(n.cursor3DTickLabelFontY).setBackgroundFillStyle(n.cursor3DTickLabelBackgroundFillStyleY).setBackgroundStrokeStyle(n.cursor3DTickLabelBackgroundStrokeStyleY).setPadding(n.cursor3DTickLabelPaddingY), this.Em = this.chart.getDefaultAxisZ().addCustomTick().setVisible(!1).setGridStrokeStyle(n.cursor3DGridStrokeStyleZ).setTickStyle(n.cursor3DTickStrokeStyleZ).setTextFillStyle(n.cursor3DTickLabelFillStyleZ).setTextFont(n.cursor3DTickLabelFontZ).setBackgroundFillStyle(n.cursor3DTickLabelBackgroundFillStyleZ).setBackgroundStrokeStyle(n.cursor3DTickLabelBackgroundStrokeStyleZ).setPadding(n.cursor3DTickLabelPaddingZ), this.Bm.Kr = es.CursorTickMarker, this.Dm.Kr = es.CursorTickMarker, this.Em.Kr = es.CursorTickMarker;
  }
  setTickX(t) {
    return t(this.Bm), this.chart.yi.Rs(), this;
  }
  setTickY(t) {
    return t(this.Dm), this.chart.yi.Rs(), this;
  }
  setTickZ(t) {
    return t(this.Em), this.chart.yi.Rs(), this;
  }
  setTicks(t) {
    return t(this.Bm), t(this.Dm), t(this.Em), this.chart.yi.Rs(), this;
  }
  dispose() {
    return super.dispose(), this.Bm.dispose(), this.Dm.dispose(), this.Em.dispose(), this;
  }
  rr() {
    return this.Bm.setVisible(this.di && this.Hg), this.Dm.setVisible(this.di && this.Hg), this.Em.setVisible(this.di && this.Hg), super.rr();
  }
  setPosition(...t) {
    if (t.length === 0) return this;
    const e = t[0];
    this.Hg = !0;
    const i = this.renderingScale, s = Do(e.resultTableScale, i), o = s === this.scale ? e.resultTable : xt(e.resultTable, s, this.scale);
    this._m.setPosition(o), this.Bm.setValue(e.axisLocation.x), this.Dm.setValue(e.axisLocation.y), this.Em.setValue(e.axisLocation.z);
    let n = this.vm[0];
    if (!n) {
      const a = new Ha(this.Js, this.renderingScale, this.scale, ie, this.xi).setPointerEvents(!1).setFillStyle(this.xi.cursorPointMarkerFillStyle).setStrokeStyle(this.xi.cursorPointMarkerStrokeStyle).setSize(this.xi.cursorPointMarkerSize).setShape(this.xi.cursorPointMarkerShape);
      n = { pointMarker: a, targetVisible: !0 }, this.vm.push(n), this.Sm.forEach(((l) => l(a)));
    }
    return e.pointMarkerShape && n.pointMarker.setShape(e.pointMarkerShape), e.pointMarkerSize && n.pointMarker.setSize(e.pointMarkerSize), e.pointMarkerFillStyle && n.pointMarker.setFillStyle(e.pointMarkerFillStyle), e.pointMarkerStrokeStyle && n.pointMarker.setStrokeStyle(e.pointMarkerStrokeStyle), n.pointMarker.setPosition(o), this.chart.yi.Rs(), this;
  }
}
class ku {
  constructor(t, e) {
    this.Rm = [], this.Om = (i, s) => (this.Rm.forEach(((o) => o(i, s))), i), this.addStyler = (i) => new ku(this.Mm, this.Rm.map(((s) => s)).concat(i)), this.setResultTableBackground = (i) => new ku(i, this.Rm.map(((s) => s))), this.zm = (i, s, o, n, a, l) => this.Om(new V2(i, s, o, n, this.Mm, a, l), a), this.Mm = t, this.Rm = e;
  }
}
const kg = new ku(xn, [(r, t) => {
  nc(r, t);
}]), _n = (r, t, e, i) => {
  r.background.addEventListener(t, e, i), r.seriesBackground.addEventListener(t, e, i), r.getSeries().forEach(((o) => o.addEventListener(t, e, i)));
  const s = (o) => o.series.addEventListener(t, e, i);
  return r.addEventListener("seriesadd", s), () => {
    r.background.removeEventListener(t, e), r.seriesBackground.removeEventListener(t, e), r.getSeries().forEach(((o) => o.removeEventListener(t, e))), r.removeEventListener("seriesadd", s);
  };
}, Bh = (r, t, e, i) => {
  var s, o, n, a, l, h;
  Wr(), t.camera && e.Vm(), t.x && r.axisX.fit((s = t.animationsEnabled) !== null && s !== void 0 ? s : void 0, (o = t.stopScroll) !== null && o !== void 0 ? o : void 0), t.y && r.axisY.fit((n = t.animationsEnabled) !== null && n !== void 0 ? n : void 0, (a = t.stopScroll) !== null && a !== void 0 ? a : void 0), t.z && r.axisZ.fit((l = t.animationsEnabled) !== null && l !== void 0 ? l : void 0, (h = t.stopScroll) !== null && h !== void 0 ? h : void 0);
  let u = t.cursor;
  if (u !== null) {
    u = u ?? Gt.ZoomOut;
    const d = r.engine.setMouseStyle(u);
    H.setTimeout((() => {
      r.engine.restoreMouseStyle(d);
    }), 500);
  }
  const c = t.on;
  c && H.requestAnimationFrame((() => c({ event: i })));
}, zh = (r, t, e, i) => {
  Wr(), r.restorePreviousZoomState();
  const s = t.on;
  s && H.requestAnimationFrame((() => s({ event: i })));
};
class jf extends $a {
  constructor(t, e, i, s, o, n, a) {
    var l, h, u, c, d;
    super(t, e, i, e.Av("chart3D bg", 0), s, e.yi.xi.chart3DBackgroundFillStyle, e.yi.xi.chart3DBackgroundStrokeStyle, e.yi.xi.chart3DTitleFont, e.yi.xi.chart3DTitleFillStyle, e.yi.xi.chart3DTitleShadow, n, (l = a?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.Nm = 1, this.Gm = [], this.$m = 2, this.Um = !0, this.jm = !0, this.Ym = !0, this.Hm = 0, this.coordsAxis = { id: "axes", chart: this }, this.coordsWorld = { id: "world", chart: this }, this.ga = [], this.Wm = [], this.Xm = !1, this.Zm = () => {
      if (this.ci) return;
      const y = /* @__PURE__ */ new Map();
      this.forEachAxis(((m) => {
        m.DA().find(((A) => A.Gv())) !== void 0 && y.set(m, { ...m.getInterval(), stopped: m.getStopped() });
      })), y.size <= 0 || (this.Wm.push(y), this.Wm.length > 100 && this.Wm.shift());
    }, this.ka = () => {
      const y = this.Tv.Jm();
      this.Km.Qm(y), this.qm.Qm(y);
      const m = this.tS.viewportChanged(this.iS());
      m && this.sS(m), this.yi.Rs();
    }, this.D = new Nt(), this.yi.Oa(Ot.Bo), this.Wr.rn("Chart3D"), this.eS = i.d3(), this.eS.x.Z(-1, 1), this.eS.y.Z(-1, 1), this.eS.z.Z(-1, 1), this.eS.x.Y = ((h = a?.defaultAxisX) === null || h === void 0 ? void 0 : h.type) === "linear-highPrecision", this.eS.y.Y = ((u = a?.defaultAxisY) === null || u === void 0 ? void 0 : u.type) === "linear-highPrecision", this.eS.z.Y = ((c = a?.defaultAxisZ) === null || c === void 0 ? void 0 : c.type) === "linear-highPrecision", this.Tv = e.rS("chart3D layer3D", 0, this.eS), this.Km = e.hS("chart3D series bg", 0), this.qm = e.nS("chart3D axis ui", 1), this.oS = { x: new _c(this, (d = () => this.Ny, { ...ja(d, ((y) => y.getXMin()), ((y) => y.getXMax()), ((y) => y.Sn().x)), ey: (y) => y.x, Cy: (y, m) => ({ x: y.x, y: m.y, z: m.z }), Mf: Ht(0, -1, 0), by: (y) => {
      const m = { x: y.x >= 0 ? 1 : -1, y: y.y >= 0 ? 1 : -1, z: y.z >= 0 ? 1 : -1 };
      return { gridlinePositionA: Ht(0, m.y, m.z), gridlinePositionB: Ht(0, m.y, -m.z), gridlinePositionC: Ht(0, -m.y, -m.z) };
    }, Fy: () => !0, Iy: () => !1, ky: () => !1 }), this.eS.x, this.xi, this.Tv, this.qm, this.xA, !1, this.bs), y: new _c(this, A2((() => this.Ny)), this.eS.y, this.xi, this.Tv, this.qm, this.xA, !1, this.bs), z: new _c(this, b2((() => this.Ny)), this.eS.z, this.xi, this.Tv, this.qm, this.xA, !1, this.bs) }, this.aS = this.Tv.Ay([Ir.InternalUI], void 0).setPointerEvents(!1), this.setBoundingBoxStrokeStyle(this.xi.chart3DBoundingBoxStrokeStyle), this.Yy = this.Km.Vc(this.yi.ai, fr.Simple).sr(this.xi.chart3DSeriesBackgroundFillStyle).ir(Et).setPointerEvents(!0), this.Hy = this.Km.Vc(this.yi.ai, fr.Simple).sr(Lt).ir(this.xi.chart3DSeriesBackgroundStrokeStyle).setPointerEvents(!1), super.jy(this.Yy, this.Hy), this.lS({ x: 1, y: 1, z: 1 }, !0), this.tS = new T2(this.yi.ai, this.xA, this.eS, ((y, m) => (m && this.sS(m), this.Tv.xy(y)))), this.uS = this.tS.getDefaultCameraConfiguration(this.cS(this.dS), this.getProjection()), this.sS(this.uS);
    const f = $e(a ? a.cursorBuilder : void 0, kg), p = e.fS();
    this.AS = Xr(this, p, f.zm(p, this.xA, this.xA, ie, this.xi, this), this, "show-pointed", _2, (() => 0)), this.setAnimationsEnabled(a?.animationsEnabled !== !1), this.addEventListener("resize", this.ka), this.ka(), this.fv(o, this.xA), this.gS = ((y) => {
      let m = !1, A = !1, v = !1;
      const b = ((I) => {
        let F = !0, D = I.getCameraLocation(), P = I.getCameraAutomaticFittingEnabled();
        return { vS: () => {
          F && (D = I.getCameraLocation(), P = I.getCameraAutomaticFittingEnabled()), F = !1;
        }, Vm: () => {
          I.setCameraLocation(D).setCameraAutomaticFittingEnabled(P), F = !0;
        } };
      })(y);
      let w = {};
      const k = () => Zi({ rotate: { drag: {}, ctrl: { drag: !1 }, shift: { drag: !1 }, alt: { drag: !1 } }, zoom: { wheel: {}, camera: !0, mode: "centered", pinch: { camera: !1, x: !0, y: !0, z: !0 } }, restoreDefault: { doubleClick: !0, camera: !0, x: !0, y: !0, z: !0 }, restorePrevious: !1 }, w), R = (I) => {
        const F = k();
        let D = !1, P = !1, V = !1;
        for (const B of Object.keys(F)) {
          const z = F[B];
          typeof z == "object" && (z.ctrl !== void 0 && (D = !0), z.shift !== void 0 && (P = !0), z.alt !== void 0 && (V = !0));
        }
        A = I.ctrlKey, m = I.shiftKey, v = I.altKey, (I.key === "Control" && D || I.key === "Shift" && P || I.key === "Alt" && V) && I.preventDefault();
        const _ = ge(F.restoreDefault, void 0, I, m, A, v);
        _ && _.code === I.code && (It(I), Bh(y, _, b, I));
        const O = ge(F.restorePrevious, void 0, I, m, A, v);
        O && O.code === I.code && (It(I), zh(y, O, 0, I));
      }, L = (I) => {
        A = I.ctrlKey, m = I.shiftKey, v = I.altKey;
      }, x = () => {
        A = !1, m = !1, v = !1;
      };
      H.addEventListener("keydown", R), H.addEventListener("keyup", L), H.addEventListener("blur", x), y.addEventListener("dispose", (() => {
        H.removeEventListener("keydown", R), H.removeEventListener("keyup", L), H.removeEventListener("blur", x);
      }));
      const M = (I) => {
      }, C = (I) => {
        const F = xr(y.yi.Ga.$a !== !1), D = k(), P = ge(D.rotate, "drag", I, m, A, v), V = ge(D.pan, "drag", I, m, A, v);
        V && F.push("drag pan", (() => ((W, G, Y, U) => {
          const $ = W.getCursorMode();
          W.setCursorMode(void 0);
          let Z = G;
          G.pointerType === "mouse" && G.preventDefault();
          const q = (et) => {
            var it, rt, tt;
            if (et.pointerId !== G.pointerId) return;
            It(et);
            const at = et.clientX - Z.clientX, ut = et.clientY - Z.clientY;
            if (Z = et, Y && Y.x) {
              const st = at + -ut;
              W.axisX.Py(-Math.sign(st) * ((it = Y.sensitivity) !== null && it !== void 0 ? it : 1)), Y.stopScroll !== !1 && W.axisX.setStopped(!0);
            }
            if (Y && Y.y) {
              const st = -at + ut;
              W.axisY.Py(Math.sign(st) * ((rt = Y.sensitivity) !== null && rt !== void 0 ? rt : 1)), Y.stopScroll !== !1 && W.axisY.setStopped(!0);
            }
            if (Y && Y.z) {
              const st = -at + ut;
              W.axisZ.Py(Math.sign(st) * ((tt = Y.sensitivity) !== null && tt !== void 0 ? tt : 1)), Y.stopScroll !== !1 && W.axisZ.setStopped(!0);
            }
            const ht = Y?.on;
            ht && H.requestAnimationFrame((() => ht({ event: et })));
          }, Q = (et) => {
            et.pointerId === G.pointerId && (It(et), W.setCursorMode($), H.removeEventListener("pointermove", q), H.removeEventListener("pointerup", Q), W.engine.container.removeEventListener("pointerdown", nt), U());
          }, nt = (et) => {
            et.pointerId !== G.pointerId && (W.setCursorMode($), H.removeEventListener("pointermove", q), H.removeEventListener("pointerup", Q), W.engine.container.removeEventListener("pointerdown", nt), U());
          };
          H.addEventListener("pointermove", q), H.addEventListener("pointerup", Q), W.engine.container.addEventListener("pointerdown", nt), Wr();
        })(y, I, V, S()))), P && F.push("drag rotate", (() => ((W, G, Y, U, $) => {
          const Z = W.getCursorMode();
          W.setCursorMode(void 0);
          let q = G, Q = !1, nt = 0;
          G.pointerType === "mouse" && G.preventDefault();
          const et = (tt) => {
            var at, ut;
            if (tt.pointerId !== G.pointerId) return;
            It(tt);
            const ht = { x: tt.clientX - q.clientX, y: tt.clientY - q.clientY };
            q = tt, nt += an(ht), $.vS(), W.yS({ x: ht.x * ((at = Y.sensitivity) !== null && at !== void 0 ? at : 1), y: -ht.y * ((ut = Y.sensitivity) !== null && ut !== void 0 ? ut : 1) }), Q || (sn(), Q = !0);
            const st = Y.on;
            st && H.requestAnimationFrame((() => st({ event: tt })));
          }, it = (tt) => {
            tt.pointerId === G.pointerId && (It(tt), W.setCursorMode(Z), H.removeEventListener("pointermove", et), H.removeEventListener("pointerup", it), W.engine.container.removeEventListener("pointerdown", rt), U(), nt >= 10 && Ao("click"));
          }, rt = (tt) => {
            tt.pointerId !== G.pointerId && (W.setCursorMode(Z), H.removeEventListener("pointermove", et), H.removeEventListener("pointerup", it), W.engine.container.removeEventListener("pointerdown", rt), U());
          };
          H.addEventListener("pointermove", et), H.addEventListener("pointerup", it), W.engine.container.addEventListener("pointerdown", rt), Wr();
        })(y, I, P, S(), b)));
        const _ = ge(D.zoom, "drag", I, m, A, v);
        _ && F.push("drag zoom", (() => ((W, G, Y, U, $) => {
          const Z = W.getCursorMode();
          W.setCursorMode(void 0);
          let q = G;
          G.pointerType === "mouse" && G.preventDefault();
          const Q = (it) => {
            var rt, tt, at, ut, ht, st, bt;
            if (it.pointerId !== G.pointerId) return;
            It(it);
            const ct = it.clientX - q.clientX, Mt = it.clientY - q.clientY;
            if (q = it, Y.x) {
              const mt = ct + -Mt;
              W.axisX.Ly((rt = Y.mode) !== null && rt !== void 0 ? rt : "centered", Math.sign(mt), (tt = Y.sensitivity) !== null && tt !== void 0 ? tt : 1), Y.stopScroll !== !1 && W.axisX.setStopped(!0);
            }
            if (Y.y) {
              const mt = -ct + Mt;
              W.axisY.Ly((at = Y.mode) !== null && at !== void 0 ? at : "centered", -Math.sign(mt), (ut = Y.sensitivity) !== null && ut !== void 0 ? ut : 1), Y.stopScroll !== !1 && W.axisY.setStopped(!0);
            }
            if (Y.z) {
              const mt = -ct + Mt;
              W.axisZ.Ly((ht = Y.mode) !== null && ht !== void 0 ? ht : "centered", -Math.sign(mt), (st = Y.sensitivity) !== null && st !== void 0 ? st : 1), Y.stopScroll !== !1 && W.axisZ.setStopped(!0);
            }
            if (Y.camera) {
              const mt = ct + -Mt;
              $.vS(), W.pS(-0.15 * Math.sign(mt) * ((bt = Y.sensitivity) !== null && bt !== void 0 ? bt : 1));
            }
            const vt = Y.on;
            vt && H.requestAnimationFrame((() => vt({ event: it })));
          }, nt = (it) => {
            it.pointerId === G.pointerId && (It(it), W.setCursorMode(Z), H.removeEventListener("pointermove", Q), H.removeEventListener("pointerup", nt), W.engine.container.removeEventListener("pointerdown", et), U());
          }, et = (it) => {
            W.setCursorMode(Z), H.removeEventListener("pointermove", Q), H.removeEventListener("pointerup", nt), W.engine.container.removeEventListener("pointerdown", et), U();
          };
          H.addEventListener("pointermove", Q), H.addEventListener("pointerup", nt), W.engine.container.addEventListener("pointerdown", et), Wr();
        })(y, I, _, S(), b))), F.end();
        const O = ge(D.rotate, "pinch", I, m, A, v), B = ge(D.pan, "pinch", I, m, A, v), z = ge(D.zoom, "pinch", I, m, A, v);
        (O || z || B) && ((W, G, Y, U, $, Z, q) => {
          if (!Y && !U && !$) return;
          const Q = (et) => {
            if (et.pointerId === G.pointerId) return;
            const it = Z();
            let rt;
            W.engine.container.removeEventListener("pointerdown", Q), H.removeEventListener("pointerup", nt);
            let tt, at = et;
            const ut = et, ht = W.getCursorMode();
            W.setCursorMode(void 0);
            const st = W.getCameraLocation();
            let bt, ct, Mt;
            const vt = [], mt = () => {
              var Kt, _t, Ut, te, ye, ne, ti, fe;
              Xt = void 0;
              const ve = rt, ci = at;
              if (vt.forEach(((J) => {
                J.pointerId === G.pointerId ? rt = J : J.pointerId === et.pointerId && (at = J);
              })), vt.length = 0, tt = tt || rt, rt === void 0 || ve === void 0 || tt === void 0) return;
              if (!ct || !Mt) {
                const J = (Le) => {
                  for (; Le < 0; ) Le += 360;
                  for (; Le > 360; ) Le -= 360;
                  return Le;
                }, pt = (Le, We) => {
                  const gi = W.Tv.xy(Le), Di = W.Tv.xy(We);
                  if (!gi || !Di) return { deg: -1, dir: { x: 0, y: 0 } };
                  const ns = W.yi.cl({ engineX: gi.x, engineY: gi.y }), Ni = W.yi.cl({ engineX: Di.x, engineY: Di.y });
                  return { deg: J(Wl(oi(Di, gi))), dir: Os(oi({ x: Ni.clientX, y: Ni.clientY }, { x: ns.clientX, y: ns.clientY })) };
                }, St = W.axisX.getInterval(), Ft = W.axisY.getInterval(), Qt = W.axisZ.getInterval(), Se = { x: pt({ x: St.start, y: Ft.start, z: Qt.start }, { x: St.end, y: Ft.start, z: Qt.start }), y: pt({ x: St.start, y: Ft.start, z: Qt.start }, { x: St.start, y: Ft.end, z: Qt.start }), z: pt({ x: St.end, y: Ft.start, z: Qt.start }, { x: St.end, y: Ft.start, z: Qt.end }) }, ce = W.yi.ul(tt), se = W.yi.ul(ut), Si = J(Wl(oi({ x: se.engineX, y: se.engineY }, { x: ce.engineX, y: ce.engineY })));
                ct = ["x", "y", "z"].reduce(((Le, We) => {
                  const gi = Math.abs(Se[We].deg - Si), Di = Math.abs(J(Se[We].deg + 180) - Si), ns = Math.min(gi, Di);
                  return Math.min(ns, Di) < Le.angleDiff ? { angleDiff: ns, axis: We } : Le;
                }), { axis: "x", angleDiff: 1e3 }).axis, Mt = Se[ct].dir;
              }
              const At = rt.clientX - ve.clientX, yt = rt.clientY - ve.clientY, ft = at.clientX - ci.clientX, Tt = at.clientY - ci.clientY, oe = Math.sqrt((tt.clientX - ut.clientX) ** 2 + (tt.clientY - ut.clientY) ** 2), vi = Math.sqrt((rt.clientX - at.clientX) ** 2 + (rt.clientY - at.clientY) ** 2), Te = gt.length(st), Ze = oe / vi * ((Kt = $?.sensitivity) !== null && Kt !== void 0 ? Kt : 1) * Te, ps = j(((_t = Y?.sensitivity) !== null && _t !== void 0 ? _t : 1) * (At + ft) / 2, ((Ut = Y?.sensitivity) !== null && Ut !== void 0 ? Ut : 1) * -(yt + Tt) / 2);
              q.vS(), (Y || $?.camera) && (W.Gm.push({ type: "rotate+zoom", rotation: Y ? ps : { x: 0, y: 0 }, cameraDistance: $?.camera ? Ze : Te }), W.yi.Rs());
              const Fe = bt === void 0 ? 0 : vi - an(bt) ? 1 : -1, qe = bt ? 0.25 * ((te = $?.sensitivity) !== null && te !== void 0 ? te : 1) * (vi - an(bt)) : 0;
              $ && $.x && (ct === "x" || $.y === void 0 && $.z === void 0) && (W.axisX.Ly((ye = $.mode) !== null && ye !== void 0 ? ye : "centered", Fe, qe), $.stopScroll !== !1 && W.axisX.setStopped(!0)), $ && $.y && (ct === "y" || $.x === void 0 && $.z === void 0) && (W.axisY.Ly((ne = $.mode) !== null && ne !== void 0 ? ne : "centered", Fe, qe), $.stopScroll !== !1 && W.axisY.setStopped(!0)), $ && $.z && (ct === "z" || $.x === void 0 && $.y === void 0) && (W.axisZ.Ly((ti = $.mode) !== null && ti !== void 0 ? ti : "centered", Fe, qe), $.stopScroll !== !1 && W.axisZ.setStopped(!0));
              const rs = (ve.clientX + ci.clientX) / 2, ii = (ve.clientY + ci.clientY) / 2, Ge = { x: (rt.clientX + at.clientX) / 2 - rs, y: (rt.clientY + at.clientY) / 2 - ii }, vn = nu(Os(Ge), Mt), Bt = an(Ge) * vn * 0.3 * ((fe = U?.sensitivity) !== null && fe !== void 0 ? fe : 1);
              U && U.x && (ct === "x" || U.y === void 0 && U.z === void 0) && (W.axisX.Py(-Bt), U.stopScroll !== !1 && W.axisX.setStopped(!0)), U && U.y && (ct === "y" || U.x === void 0 && U.z === void 0) && (W.axisY.Py(-Bt), U.stopScroll !== !1 && W.axisY.setStopped(!0)), U && U.z && (ct === "z" || U.x === void 0 && U.y === void 0) && (W.axisZ.Py(-Bt), U.stopScroll !== !1 && W.axisZ.setStopped(!0)), bt = { x: Math.abs(rt.clientX - at.clientX), y: Math.abs(rt.clientY - at.clientY) };
              const Wt = U?.on || Y?.on || $?.on;
              Wt && H.requestAnimationFrame((() => Wt({ event: void 0 })));
            };
            let Xt;
            const Rt = (Kt) => {
              Kt.pointerId !== G.pointerId && Kt.pointerId !== et.pointerId || (It(Kt), vt.push(Kt), Xt || (Xt = H.requestAnimationFrame(mt)));
            }, Dt = (Kt) => {
              Kt.pointerId !== G.pointerId && Kt.pointerId !== et.pointerId || (It(Kt), W.setCursorMode(ht), H.removeEventListener("pointermove", Rt), H.removeEventListener("pointerup", Dt), it(), Xt && H.cancelAnimationFrame(Xt));
            };
            H.addEventListener("pointermove", Rt), H.addEventListener("pointerup", Dt), Wr();
          }, nt = (et) => {
            et.pointerId === G.pointerId && (W.engine.container.removeEventListener("pointerdown", Q), H.removeEventListener("pointerup", nt));
          };
          W.engine.container.addEventListener("pointerdown", Q), H.addEventListener("pointerup", nt);
        })(y, I, O, B, z, S, b);
      };
      _n(y, "wheel", ((I) => {
        const F = xr(y.yi.Ga.$a !== !1), D = k(), P = ge(D.pan, "wheel", I, m, A, v);
        P && F.push("wheel pan", (() => ((_, O, B) => {
          var z, W, G;
          It(O), B.x && (_.axisX.Py(2 * Math.sign(O.deltaY) * ((z = B.sensitivity) !== null && z !== void 0 ? z : 1)), B.stopScroll !== !1 && _.axisX.setStopped(!0)), B.y && (_.axisY.Py(2 * Math.sign(O.deltaY) * ((W = B.sensitivity) !== null && W !== void 0 ? W : 1)), B.stopScroll !== !1 && _.axisY.setStopped(!0)), B.z && (_.axisZ.Py(2 * Math.sign(O.deltaY) * ((G = B.sensitivity) !== null && G !== void 0 ? G : 1)), B.stopScroll !== !1 && _.axisZ.setStopped(!0));
          const Y = B.on;
          Y && H.requestAnimationFrame((() => Y({ event: O })));
        })(y, I, P)));
        const V = ge(D.zoom, "wheel", I, m, A, v);
        V && F.push("wheel zoom", (() => ((_, O, B, z) => {
          var W, G, Y, U, $, Z, q;
          It(O), B.x && (_.axisX.Ly((W = B.mode) !== null && W !== void 0 ? W : "centered", -Math.sign(O.deltaY), 3 * ((G = B.sensitivity) !== null && G !== void 0 ? G : 1)), B.stopScroll !== !1 && _.axisX.setStopped(!0)), B.y && (_.axisY.Ly((Y = B.mode) !== null && Y !== void 0 ? Y : "centered", -Math.sign(O.deltaY), 3 * ((U = B.sensitivity) !== null && U !== void 0 ? U : 1)), B.stopScroll !== !1 && _.axisY.setStopped(!0)), B.z && (_.axisZ.Ly(($ = B.mode) !== null && $ !== void 0 ? $ : "centered", -Math.sign(O.deltaY), 3 * ((Z = B.sensitivity) !== null && Z !== void 0 ? Z : 1)), B.stopScroll !== !1 && _.axisZ.setStopped(!0)), B.camera && (z.vS(), _.pS(0.5 * Math.sign(O.deltaY) * ((q = B.sensitivity) !== null && q !== void 0 ? q : 1)));
          const Q = B.on;
          Q && H.requestAnimationFrame((() => Q({ event: O })));
        })(y, I, V, b))), F.end();
      })), _n(y, "dblclick", ((I) => {
        if (I.defaultPrevented) return;
        const F = xr(y.yi.Ga.$a !== !1), D = k(), P = ge(D.restoreDefault, void 0, I, m, A, v);
        P && P.doubleClick && (It(I), Bh(y, P, b, I));
        const V = ge(D.restorePrevious, void 0, I, m, A, v);
        V && V.doubleClick && (It(I), zh(y, V, 0, I)), F.end();
      })), _n(y, "click", ((I) => {
        if (I.defaultPrevented) return;
        const F = xr(y.yi.Ga.$a !== !1), D = k(), P = ge(D.restoreDefault, void 0, I, m, A, v);
        P && P.singleClick && (It(I), Bh(y, P, b, I));
        const V = ge(D.restorePrevious, void 0, I, m, A, v);
        V && V.singleClick && (It(I), zh(y, V, 0, I)), F.end();
      })), _n(y, "contextmenu", ((I) => {
        if (I.defaultPrevented) return;
        const F = xr(y.yi.Ga.$a !== !1), D = k(), P = ge(D.restoreDefault, "rmb", I, m, A, v);
        P && P.singleClick && (It(I), Bh(y, P, b, I));
        const V = ge(D.restorePrevious, "rmb", I, m, A, v);
        V && V.singleClick && (It(I), zh(y, V, 0, I)), F.end();
      }));
      const S = () => (E(), T(), () => {
        E = _n(y, "pointermove", M), T = _n(y, "pointerdown", C);
      });
      let E = _n(y, "pointermove", M), T = _n(y, "pointerdown", C);
      return { setUserInteractions: (I) => {
        if (I === void 0) w = { rotate: !1, zoom: !1, pan: !1, restoreDefault: !1, restorePrevious: !1 };
        else if (Object.keys(I).length === 0) w = {};
        else for (const F of Object.keys(I)) I[F] === !1 || typeof I[F] == "object" ? w[F] = I[F] : w[F] = {};
      }, getUserInteractions: k };
    })(this), this.mS(this.axisX), this.mS(this.axisY), this.mS(this.axisZ);
    const g = { position: zt.RightCenter, backgroundVisible: !0, ...a?.legend };
    this.legend.setOptions(g);
  }
  restorePreviousZoomState(t) {
    if (this.Wm.length <= 1) return this;
    this.Wm.pop();
    const e = this.Wm[this.Wm.length - 1];
    return e ? (this.Xm = !0, this.forEachAxis(((i) => {
      if (t?.whitelist && !t.whitelist.includes(i)) return;
      const s = e.get(i);
      s ? i.li(s.start, s.end, t?.animate, t?.stopAxisAfter !== void 0 ? t.stopAxisAfter : s.stopped, "userSetInterval") : i.fit(t?.animate, t?.stopAxisAfter);
    })), this.Xm = !1, this) : this;
  }
  clearPreviousZoomStateHistory() {
    if (this.SS !== void 0) this.Wm.length = 0;
    else for (; this.Wm.length > 1; ) this.Wm.unshift();
    return this;
  }
  mS(t) {
    const e = () => {
      this.Xm || (this.SS && H.clearTimeout(this.SS), this.SS = H.setTimeout((() => {
        this.Zm(), this.SS = void 0;
      }), 300));
    };
    H.requestAnimationFrame((() => {
      e();
    })), t.addEventListener("intervalchange", e), t.addEventListener("dispose", (() => {
      this.Wm.forEach(((i) => {
        i.delete(t);
      }));
    }));
  }
  setUserInteractions(t) {
    return this.gS.setUserInteractions(t), this;
  }
  getUserInteractions() {
    return this.gS.getUserInteractions();
  }
  setProjection(t) {
    this.Tv.bS(t);
    const e = this.tS.projectionChanged(this.iS(), t);
    return e && this.sS(e), this.yi.Rs(), this;
  }
  getProjection() {
    return this.Tv.xS();
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  addCursor(t = kg) {
    const e = this.tv(), i = t.zm(e, this.xA, this.xA, this.Jg(e), this.xi, this);
    return this.cv(i), i;
  }
  addPointSeries(t) {
    const e = new (t && t.type || w2)(this, this.$y, this.Tv, this.xi, this.yi.bs, t);
    return this.Wy(e, t), e;
  }
  addLineSeries(t) {
    const e = new E2(this, this.$y, this.Tv, this.xi, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, this.yi.bs, t);
    return this.Wy(e, t), e;
  }
  addPointLineSeries(t) {
    const e = new M2(this, this.$y, this.Tv, this.xi, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, this.yi.bs, t);
    return this.Wy(e, t), e;
  }
  addSurfaceGridSeries(t) {
    const e = new D2(this, this.$y, this.Tv, t, this.xi, this.yi.bs);
    return this.Wy(e, t), e;
  }
  addSurfaceScrollingGridSeries(t) {
    const e = new F2(this, this.$y, this.Tv, t, this.xi, this.yi.bs);
    return this.Wy(e, t), e;
  }
  addBoxSeries(t) {
    const e = new m2(this, this.$y, this.Tv, this.xi, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, this.yi.bs);
    return this.Wy(e, t), e;
  }
  addMeshModel(t) {
    const e = new P2(this, this.$y, this.Tv, this.xi, t, this.yi.bs);
    return this.Wy(e, t), e;
  }
  translateCoordinate(t, e, i) {
    if (Yo(e) || Yo(i) || Nh(t)) {
      if (Yo(e) && Yo(i) && Nh(t)) {
        if (e.id === "axes" && i.id === "world") return this.Tv._S(t);
        if (e.id === "world" && i.id === "axes") return this.Tv.wS(t);
        if (e.id === i.id) return t;
      }
      if (Yo(e) && Mo(i) && Nh(t)) {
        const s = this.Tv.xy(t);
        return s ? this.yi.cl({ engineX: s.x, engineY: s.y }) : { clientX: -1, clientY: -1 };
      }
      if (Yo(e) && kr(i) && Nh(t)) {
        const s = this.Tv.xy(t);
        return s ? xt(s, this.yi.ai, this.xA) : { clientX: -1, clientY: -1 };
      }
      throw new Error("translateCoordinate unexpected error. Input or target coordinate system not recognized.");
    }
    return sc(t, e, i, this.xA, this.yi);
  }
  getDefaultAxisX() {
    return this.oS.x;
  }
  getDefaultAxisY() {
    return this.oS.y;
  }
  getDefaultAxisZ() {
    return this.oS.z;
  }
  get axisX() {
    return this.getDefaultAxisX();
  }
  get xAxis() {
    return this.getDefaultAxisX();
  }
  get axisY() {
    return this.getDefaultAxisY();
  }
  get yAxis() {
    return this.getDefaultAxisY();
  }
  get axisZ() {
    return this.getDefaultAxisZ();
  }
  get zAxis() {
    return this.getDefaultAxisZ();
  }
  getDefaultAxes() {
    return [this.oS.x, this.oS.y, this.oS.z];
  }
  setCameraLocation(t) {
    let e = { location: t, direction: gt.normalize(gt.multiply(t, -1)) };
    const i = this.tS.cameraLocationChanged(this.iS(e));
    return i && (e = i), this.sS(e), this.yi.Rs(), this;
  }
  getCameraLocation() {
    return this.Tv.getCameraLocation();
  }
  getCameraDirection() {
    return this.Tv.getCameraDirection();
  }
  setCameraAutomaticFittingEnabled(t) {
    this.tS.Ap(t);
    const e = this.tS.cameraLocationChanged(this.iS());
    return e && this.sS(e), this;
  }
  getCameraAutomaticFittingEnabled() {
    return this.tS._p();
  }
  setBoundingBoxStrokeStyle(t) {
    return this.aS.gr(t).uy(Ed(this.aS.po())), this.Tv.Rs(), this;
  }
  getBoundingBoxStrokeStyle() {
    return this.aS.po();
  }
  setBoundingBox(t) {
    return this.lS(t, !1), this;
  }
  lS(t, e) {
    this.dS = t;
    const i = this.cS(t);
    if (this.eS.x.K(i.x), this.eS.y.K(i.y), this.eS.z.K(-i.z), !e) {
      const s = this.tS.boundingBoxChanged(this.iS());
      s && this.sS(s);
    }
    this.yi.Rs();
  }
  getBoundingBox() {
    return this.dS;
  }
  rr(t) {
    const e = ui.xv(this.Wr, this.gv);
    this.Ns.forEach(((y) => y.Uh(e, this.Hn)));
    const i = Me;
    if (ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, i), this.Hm !== 0) {
      const y = this.Hm * t * 6e-3;
      this.Gm.push({ type: "wheel-zoom", deltaY: y }), this.Hm = Math.sign(this.Hm) * Math.max(Math.abs(this.Hm) - 0.01 * t, 0), this.Hm !== 0 && this.yi.Rs(!0);
    }
    const s = this.getCameraDirection();
    if (this.Gm.length > 0) {
      const y = this.tS.applyCameraInteractions(this.iS(), this.Gm);
      y && this.sS(y), this.Gm.length = 0;
    }
    this.kS && gt.equals(this.kS.location, this.uS.location) && gt.equals(this.kS.direction, this.uS.direction) || this.D.R("camerachange", { cameraLocation: this.getCameraLocation() }), this.kS = this.uS, super.rr(t);
    for (let y = 0; y < this.Ny.length; y += 1) this.Ny[y].Dv();
    for (let y = 0; y < this.Ny.length; y += 1) this.Ny[y].rr();
    this.oS.x.bn(), this.oS.y.bn(), this.oS.z.bn();
    const o = this.oS.x.Uh(this.oS.x.wy(s)), n = this.oS.y.Uh(this.oS.y.wy(s)), a = this.oS.z.Uh(this.oS.z.wy(s));
    this.oS.x.rr(o), this.oS.y.rr(n), this.oS.z.rr(a), this.AS.rr(!1, this.Ny, void 0), super.dv();
    const l = this.eS, h = Ht(l.x.getInnerStart(), l.y.getInnerStart(), l.z.getInnerStart()), u = Ht(l.x.getInnerEnd(), l.y.getInnerEnd(), l.z.getInnerEnd());
    this.aS.Vi().Pu([Ht(u.x, h.y, h.z), Ht(u.x, u.y, h.z), Ht(u.x, u.y, u.z), Ht(u.x, h.y, u.z), Ht(h.x, h.y, u.z), Ht(h.x, u.y, u.z), Ht(u.x, u.y, u.z), Ht(u.x, u.y, h.z), Ht(h.x, u.y, h.z), Ht(h.x, u.y, u.z), Ht(h.x, h.y, u.z), Ht(h.x, h.y, h.z)]);
    const c = [Ht(h.x, h.y, h.z), Ht(u.x, h.y, h.z), Ht(h.x, u.y, h.z), Ht(u.x, u.y, h.z), Ht(h.x, h.y, u.z), Ht(u.x, h.y, u.z), Ht(h.x, u.y, u.z), Ht(u.x, u.y, u.z)].map(((y) => this.Tv.xy(y))), d = this.Tv.xy(Ht((h.x + u.x) / 2, (h.y + u.y) / 2, (h.z + u.z) / 2)), f = Z0(c, d), p = [];
    for (let y = 0; y < f.length; y += 1) {
      const m = f[y];
      xA(m, d, f[y > 0 ? y - 1 : f.length - 1], f[y < f.length - 1 ? y + 1 : 0]) || p.push(m);
    }
    const g = Z0(p, d);
    this.Yy.yu(g), this.Hy.yu(g);
    for (let y = 0; y < this.Ny.length; y += 1) this.Ny[y].Ev();
    this.Ns.forEach(((y) => y.rr(e, this.Hn)));
  }
  dispose() {
    return this.ga.forEach(((t) => {
      t();
    })), this.ga.length = 0, this.eS.G(), this.Tv.G(), this.qm.G(), this.Km.G(), this.AS.G(), super.dispose();
  }
  W() {
    return this.eS.x.W(), this.eS.y.W(), this.eS.z.W(), super.W();
  }
  X() {
    return super.X();
  }
  sS(t) {
    this.Tv.setCameraLocation(t.location).setCameraDirection(t.direction).setLightLocation(gt.addVec(t.location, gt.multiply(t.direction, -this.$m))), this.uS = t, this.yi.Rs();
  }
  cS(t) {
    return gt.divide(t, gt.length(t) / this.Nm);
  }
  iS(t = this.uS) {
    return { boundingBox: this.cS(this.dS), cameraLocation: t.location, cameraDirection: t.direction, projection: this.getProjection() };
  }
  forEachAxis(t) {
    return t(this.oS.x), t(this.oS.y), t(this.oS.z), this;
  }
  getSeries() {
    return this.Ny.slice();
  }
  getMinimumSize() {
  }
  setAnimationsEnabled(t) {
    return super.setAnimationsEnabled(t), this.setAnimationZoom(t), this.forEachAxis(((e) => e.setAnimationsEnabled(t))), this;
  }
  setAnimationZoom(t) {
    return this.Um = !!t, this;
  }
  getAnimationZoom() {
    return this.Um;
  }
  yS(t) {
    this.Gm.push({ type: "rotate", rotation: t }), this.yi.Rs();
  }
  pS(t) {
    this.Um ? Math.sign(this.Hm) !== Math.sign(t) ? this.Hm = t : this.Hm += t : this.Gm.push({ type: "wheel-zoom", deltaY: t }), this.yi.Rs();
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const _2 = (r, t, e) => {
  var i, s;
  const o = r.axisX.getTitle() || void 0, n = r.axisY.getTitle() || void 0, a = r.axisZ.getTitle() || void 0;
  return zS(t) ? Gr(t, [[{ component: t.series, componentColor: un(t), rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [...o ? [o, ""] : [], { text: Ai(t.axisX.formatValue(t.x), t.axisX), font: { weight: "bold" } }], [...n ? [n, ""] : [], { text: Ai(t.axisY.formatValue(t.y), t.axisY), font: { weight: "bold" } }], [...a ? [a, ""] : [], { text: Ai(t.axisZ.formatValue(t.z), t.axisZ), font: { weight: "bold" } }], t.intensity !== void 0 ? ["Value", "", { text: Ai(t.lut ? va(t.lut, t.intensity) : t.intensity.toFixed(2), (i = t.lut) === null || i === void 0 ? void 0 : i.units), font: { weight: "bold" } }] : []]) : GS(t) ? Gr(t, [[{ component: t.series, componentColor: un(t), rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], t.value !== void 0 ? ["Value", "", { text: Ai(t.lut ? va(t.lut, t.value) : t.value.toFixed(2), (s = t.lut) === null || s === void 0 ? void 0 : s.units), font: { weight: "bold" } }] : []]) : Gr(t, [[{ component: t.series, componentColor: un(t), rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [...o ? [o, ""] : [], { text: Ai(t.axisX.formatValue(t.x), t.axisX), font: { weight: "bold" } }], [...n ? [n, ""] : [], { text: Ai(t.axisY.formatValue(t.y), t.axisY), font: { weight: "bold" } }], [...a ? [a, ""] : [], { text: Ai(t.axisZ.formatValue(t.z), t.axisZ), font: { weight: "bold" } }]]);
};
class O2 extends Yf {
  setPosition(...t) {
    const e = this.renderingScale;
    if (t.length > 0) {
      const i = Do(t[0].resultTableScale, e), s = i === this.scale ? t[0].resultTable : xt(t[0].resultTable, i, this.scale);
      this._m.setPosition(s);
    }
    return this.Hg = !1, this.vm.forEach(((i) => {
      i.targetVisible = !1;
    })), t.forEach(((i, s) => {
      const o = Do(i.pointMarkerScale, e), n = o === this.scale ? i.pointMarker : xt(i.pointMarker, o, this.scale);
      let a = this.vm[s];
      if (!a) {
        const l = new Ha(this.Js, this.renderingScale, this.scale, ie, this.xi).setPointerEvents(!1).setFillStyle(this.xi.cursorPointMarkerFillStyle).setStrokeStyle(this.xi.cursorPointMarkerStrokeStyle).setSize(this.xi.cursorPointMarkerSize).setShape(this.xi.cursorPointMarkerShape);
        a = { pointMarker: l, targetVisible: !0 }, this.vm.push(a), this.Sm.forEach(((h) => h(l)));
      }
      i.pointMarkerShape && a.pointMarker.setShape(i.pointMarkerShape), i.pointMarkerSize && a.pointMarker.setSize(i.pointMarkerSize), i.pointMarkerFillStyle && a.pointMarker.setFillStyle(i.pointMarkerFillStyle), i.pointMarkerStrokeStyle && a.pointMarker.setStrokeStyle(i.pointMarkerStrokeStyle), a.pointMarker.setPosition(n), a.targetVisible = ((l, h, u = h) => {
        const c = h !== u ? xt(l, h, u) : l;
        return c.x >= u.x.getInnerStart() && c.x <= u.x.getInnerEnd() && c.y >= u.y.getInnerStart() && c.y <= u.y.getInnerEnd();
      })(i.pointMarker, o), a.targetVisible && (this.Hg = !0);
    })), this.Js.Rs(), this;
  }
}
class Xl {
  constructor(t, e = []) {
    this.Rm = [], this.Om = (i, s) => (this.Rm.forEach(((o) => o(i, s))), i), this.addStyler = (i) => new Xl(this.Mm, this.Rm.map(((s) => s)).concat(i)), this.setResultTableBackground = (i) => new Xl(i, this.Rm.map(((s) => s))), this.zm = (i, s, o, n, a) => this.Om(new O2(i, s, o, n, this.Mm, a), a), this.Mm = t, this.Rm = e;
  }
}
const fh = new Xl(xn, [nc]), Md = fh, Dg = fh, Ta = fh, Fg = fh, Lg = Md, Pg = new Xl(xn, [nc, (r) => r.setPointMarkerVisible(!1).setResultTable(((t) => t.setOrigin(Sl.LeftBottom)))]), Rg = fh, Yi = { World: "World", USA: "USA", NorthAmerica: "NorthAmerica", SouthAmerica: "SouthAmerica", Canada: "Canada", Europe: "Europe", Nordics: "Nordics", Asia: "Asia", SouthEastAsia: "SouthEastAsia", Africa: "Africa", MiddleEast: "MiddleEast", Australia: "Australia" }, N2 = (r, t) => !(!t.name || r.name.toLowerCase() !== t.name.toLowerCase()) || "ISO_A3" in r && "ISO_A3" in t && r.ISO_A3.toLowerCase() === t.ISO_A3.toLowerCase(), B2 = (r, t) => {
  let e = t.geometry;
  return e = z2(r, t, e), e = W2(r, t, e), e;
}, z2 = (r, t, e) => {
  if (r === Yi.Asia) {
    const i = [];
    for (let s = 0; s < e.length; s += 1) {
      i[s] = [];
      const o = e[s], n = i[s];
      for (let a = 0; a < o.length; a += 1) {
        const l = o[a];
        l.x < -100 ? n[a] = { x: l.x + 360, y: l.y } : n[a] = l;
      }
    }
    return i;
  }
  return e;
}, W2 = (r, t, e) => {
  const i = t.name.toLowerCase();
  let s;
  if (r === Yi.USA && (i === "alaska" ? s = { translate: { x: 55, y: -25 }, scale: { x: 0.16, y: 0.16 } } : i === "hawaii" && (s = { translate: { x: 48, y: 7 }, scale: { x: 1, y: 1 } })), r === Yi.Nordics && i === "iceland" && (s = { translate: { x: 24, y: 4 }, scale: { x: 0.6, y: 0.6 } }), s) {
    const { translate: o, scale: n } = s, a = Vi(vu(e)), l = [];
    for (let h = 0; h < e.length; h += 1) {
      l[h] = [];
      const u = e[h], c = l[h];
      for (let d = 0; d < u.length; d += 1) {
        const f = u[d];
        let p = f.x;
        i === "alaska" && Math.sign(p) === 1 && (p = -180 - (180 - p)), c[d] = { x: o.x + (p - a.min.x) * n.x + a.min.x, y: o.y + (f.y - a.min.y) * n.y + a.min.y };
      }
    }
    return t.outlier = !0, t.transform = { ...s, vertexBoundaries: a }, l;
  }
  return e;
}, G2 = { World: { min: { x: -180, y: -90 }, max: { x: 180.0000000000002, y: 83.63410065300012 } }, Europe: { min: { x: -25.75, y: 34.5 }, max: { x: 40.75, y: 71.25 } }, Nordics: { min: { x: -5, y: 53.75 }, max: { x: 35.25, y: 71.5 } }, Africa: { min: { x: -17, y: -40 }, max: { x: 52, y: 37.37549753800012 } }, MiddleEast: { min: { x: 23, y: 11 }, max: { x: 67, y: 44 } }, Asia: { min: { x: 30, y: -10.922621351999808 }, max: { x: 180.0000000000002, y: 81.85871002800009 } }, SouthEastAsia: { min: { x: 92, y: -13.922621351999808 }, max: { x: 150, y: 30.0774 } }, NorthAmerica: { min: { x: -179.1435033839999, y: 5.515082098000121 }, max: { x: -50, y: 83.11652252800009 } }, SouthAmerica: { min: { x: -85, y: -55.9185042229998 }, max: { x: -35, y: 15 } }, USA: { min: { x: -125, y: 24 }, max: { x: -68, y: 50 } }, Canada: { min: { x: -141.0181, y: 41.7297 }, max: { x: -52.6194, y: 75 } }, Australia: { min: { x: 111, y: -43.6586 }, max: { x: 155, y: -9.2199 } } }, U2 = { World: 0.6, Europe: 1 / 1.4, Nordics: 0.8, Africa: 1.3, MiddleEast: 0.8, Asia: 0.8, SouthEastAsia: 0.8, NorthAmerica: 0.9, SouthAmerica: 1.5, USA: 3 / 4, Canada: 6 / 8, Australia: 11 / 12 };
class Ex extends Rr {
  constructor(t, e, i, s, o, n, a) {
    var l;
    super(t, e, i, e.Av("mapChart bg", 0), s, e.yi.xi.mapChartBackgroundFillStyle, e.yi.xi.mapChartBackgroundStrokeStyle, e.yi.xi.mapChartTitleFont, e.yi.xi.mapChartTitleFillStyle, e.yi.xi.mapChartTitleShadow, a, (l = n?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.CS = [], this.ai = this.Kg.d2({ scaleXYConstructor: we }), this.TS = !0, this.FS = this.xi.mapChartSeparateRegionFillStyle, this.IS = this.xi.mapChartSeparateRegionStrokeStyle, this.zr = !0, this.PS = 0, this.LS = !0, this.BS = /* @__PURE__ */ new Map(), this.regions = new Nt(), this.DS = (f) => {
      this.ai.x.K(f.engineWidth)._t([this.dt.left + this.Hn.left, this.dt.right + this.Hn.right]), this.ai.y.K(f.engineHeight)._t([this.dt.bottom + this.Hn.bottom, this.dt.top + this.Hn.top + ui.xv(this.Wr, this.gv)]), this.ES && this.RS(this.OS, this.ai, this.ES);
    }, this.D = new Nt(), this.yi.Oa(Ot.Eo), this.zr = n?.animationsEnabled !== !1, this.zS = e.nS("mapChart plotting", 0), this.addEventListener("resize", this.DS), this.Wr.rn("Map Chart");
    const h = e.fS(), u = $e(n ? n.cursorBuilder : void 0, Pg);
    this.AS = Xr(this, h, u.zm(h, this.uiScale, this.uiScale, ie, this.xi), void 0, "show-pointed", Y2, (() => 0)), this.VS = this.bs.CA(), this.fv(o, this.uiScale), this.NS = this.zS.yy(this.ai).setPointerEvents(this.TS).sr(this.xi.mapChartFillStyle).ir(this.xi.mapChartStrokeStyle), this.regions.Ni(this.NS, ((f) => {
      if (!this.GS) return;
      const p = this.$S(this.GS, f);
      return p ? p.region : void 0;
    })), this.NS.addEventListener("pointermove", ((f, p) => {
      const g = p.collectionMember;
      if (!this.GS || !g) return;
      const y = this.$S(this.GS, g);
      this.US(y), this.LS && y && this.yi.ks.$s(y.region, !0);
    })), this.NS.addEventListener("pointerleave", ((f, p) => {
      const g = p.collectionMember;
      if (!this.GS || !g) return;
      const y = this.$S(this.GS, g);
      this.jS(), this.LS && y && this.yi.ks.$s(y.region, !1);
    })), this.YS = this.zS.yy(this.ai).setPointerEvents(this.TS).sr(this.xi.mapChartOutlierRegionFillStyle).ir(this.xi.mapChartOutlierRegionStrokeStyle);
    const c = $e(n && n.type, Yi.World);
    this.OS = c, this.HS(c).then((() => {
      this.D.R("ready", {});
    }));
    const d = { renderOnTop: !0, backgroundVisible: !0, ...n?.legend };
    this.legend.setOptions(d);
  }
  setFillStyle(t) {
    return this.NS.sr(t), this.Ns.forEach(((e) => {
      e.Vg() && e.add(this);
    })), this.Ns.forEach(((e) => e.Gs())), this.yi.Rs(), this;
  }
  getFillStyle() {
    return this.NS.kh();
  }
  setStrokeStyle(t) {
    return this.NS.ir(t), this.yi.Rs(), this;
  }
  getStrokeStyle() {
    return this.NS.hl();
  }
  setEffect(t) {
    return this.VS.Es(t), this.yi.Rs(), this;
  }
  getEffect() {
    return this.VS.Os();
  }
  setOutlierRegionFillStyle(t) {
    return this.YS.sr(t), this.yi.Rs(), this;
  }
  getOutlierRegionFillStyle() {
    return this.YS.kh();
  }
  setOutlierRegionStrokeStyle(t) {
    return this.YS.ir(t), this.yi.Rs(), this;
  }
  getOutlierRegionStrokeStyle() {
    return this.YS.hl();
  }
  setSeparateRegionFillStyle(t) {
    return this.FS = typeof t == "function" ? t(this.FS) : t, this.CS.forEach(((e) => e.sr(this.FS))), this.yi.Rs(), this;
  }
  getSeparateRegionFillStyle() {
    return this.FS;
  }
  setSeparateRegionStrokeStyle(t) {
    return this.IS = typeof t == "function" ? t(this.IS) : t, this.CS.forEach(((e) => e.ir(this.IS))), this.yi.Rs(), this;
  }
  getSeparateRegionStrokeStyle() {
    return this.IS;
  }
  invalidateRegionValues(t) {
    if (!this.GS || !this.WS) return this.XS = this.XS || [], this.XS.push(t), this;
    if (typeof t == "function") for (let e = 0; e < this.GS.regions.length; e += 1) {
      const i = this.GS.regions[e], s = this.WS[e], o = t({ ...i, geometry: void 0 }, s);
      if (o !== void 0 && o !== s) {
        this.WS[e] = o;
        const n = this.BS.get(i);
        n?.forEach(((a) => {
          a.ZS(o);
        }));
      }
    }
    else for (const e of t) if (e) for (let i = 0; i < this.GS.regions.length; i += 1) {
      const s = this.GS.regions[i], o = this.WS[i];
      if (e.value !== void 0 && e.value !== o && N2(s, e)) {
        this.WS[i] = e.value;
        const n = this.BS.get(s);
        n?.forEach(((a) => {
          a.ZS(e.value);
        }));
      }
    }
    return this.Ns.forEach(((e) => {
      e.Vg() && e.add(this);
    })), this.yi.Rs(), this;
  }
  setPointerEvents(t) {
    return this.TS = t, this.NS.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.TS;
  }
  setHighlight(t) {
    var e;
    return t = dn(t), this.PS = t, (e = this.GS) === null || e === void 0 || e.regions.forEach(((i) => {
      this.yi.ks.$s(i, t);
    })), this.D.R("highlightchange", { highlight: t }), this;
  }
  getHighlight() {
    return this.PS;
  }
  setAnimationHighlight(t) {
    var e;
    return (e = this.GS) === null || e === void 0 || e.regions.forEach(((i) => {
      this.yi.ks.Us(i, t);
    })), this;
  }
  getAnimationHighlight() {
    var t;
    return this.yi.ks.js((t = this.GS) === null || t === void 0 ? void 0 : t.regions[0]);
  }
  setHighlightOnHover(t) {
    return this.LS = t, t === !1 && this.getHighlight() > 0 && this.setHighlight(!1), this;
  }
  getHighlightOnHover() {
    return this.LS;
  }
  async HS(t) {
    const e = await ((o, n) => {
      let a;
      if (o === Yi.World) a = "countries_world.json";
      else if (o === Yi.NorthAmerica) a = "countries_northAmerica.json";
      else if (o === Yi.SouthAmerica) a = "countries_southAmerica.json";
      else if (o === Yi.Africa) a = "countries_africa.json";
      else if (o === Yi.MiddleEast) a = "countries_asia.json";
      else if (o === Yi.Europe) a = "countries_europe.json";
      else if (o === Yi.Nordics) a = "countries_europe.json";
      else if (o === Yi.Asia) a = "countries_asia.json";
      else if (o === Yi.SouthEastAsia) a = "countries_asia.json";
      else if (o === Yi.USA) a = "states_usa.json";
      else if (o === Yi.Canada) a = "territoriesProvinces_canada.json";
      else {
        if (o !== Yi.Australia) {
          const l = `LCJS MapChart unidentified \`type\`: ${o}`;
          throw H.alert(l), new Error(l);
        }
        a = "territories_australia.json";
      }
      return new Promise(((l, h) => {
        ((u) => {
          if (u.resourcesBaseUrl) {
            const d = `${u.resourcesBaseUrl}${u.fileName}`;
            return void H.fetch(d).then(((f) => {
              u.success(f);
            })).catch((() => {
              u.error({ url: d });
            }));
          }
          const c = `${H.location.origin}/resources${u.fileName}`;
          H.fetch(c).then(((d) => {
            if (!d.ok) throw new Error();
            u.success(d);
          })).catch((() => {
            const d = `https://lcjs-resources.lightningchart.com/v1${u.fileName}`;
            H.fetch(d).then(((f) => {
              H.console.warn(`LightningChart JS warning | fallbacking publicly hosted asset resources.
For more information, please see https://lightningchart.com/js-charts/docs/troubleshooting/warning-using-publicly-hosted-resources/`), u.success(f);
            })).catch((() => {
              u.error({ url: c });
            }));
          }));
        })({ fileName: `/maps/${a}`, resourcesBaseUrl: n, success: (u) => u.json().then(l), error: ({ url: u }) => gd(n, u, "Map Chart", { shouldCrash: !0 }) });
      }));
    })(t, this.Qg.xe);
    if (t == "Nordics") {
      const o = /* @__PURE__ */ new Set(["Denmark", "Finland", "Aland", "Iceland", "Norway", "Sweden", "Faroe Islands"]), n = [];
      for (const a of e.regions) o.has(a.name) || n.push(a);
      e.regions = e.regions.filter(((a) => o.has(a.name))), e.outliers.push(...n);
    }
    if (t == "MiddleEast") {
      const o = /* @__PURE__ */ new Set(["Egypt", "Turkey"]), n = [];
      for (const h of e.outliers) o.has(h.name) && n.push(h);
      const a = /* @__PURE__ */ new Set(["Saudi Arabia", "Yemen", "Oman", "United Arab Emirates", "Qatar", "Bahrain", "Kuwait", "Iran", "Iraq", "Jordan", "Lebanon", "Syria", "Israel", "Palestine"]), l = [];
      for (const h of e.regions) a.has(h.name) || l.push(h);
      e.regions = e.regions.filter(((h) => a.has(h.name))), e.regions.push(...n), e.outliers.push(...l);
    }
    if (t == "SouthEastAsia") {
      const o = /* @__PURE__ */ new Set(["Brunei", "Cambodia", "East Timor", "Indonesia", "Laos", "Malaysia", "Myanmar", "Philippines", "Singapore", "Thailand", "Vietnam", "Thailand", "Vietnam"]), n = [];
      for (const a of e.regions) o.has(a.name) || n.push(a);
      e.regions = e.regions.filter(((a) => o.has(a.name))), e.outliers.push(...n);
    }
    this.WS = new Array(e.regions.length).map(((o) => {
    })).fill(void 0);
    const i = G2[t];
    if (!i) throw new Error("Unidentified map type.");
    for (const o of e.outliers) {
      const n = [];
      for (const a of o.geometry) {
        const l = this.YS.Qo().yu(a);
        n.push(l);
      }
      t === Yi.Nordics && o.name == "Greenland" && n.forEach(((a) => {
        a.Ls(!1);
      }));
    }
    t === Yi.USA && this.CS.push(this.Zg.er(this.ai).setPointerEvents(!1).sr(this.FS).ir(this.IS).hr({ x: -126, y: 25.8 }).K({ x: 10, y: 29.7 - 25.8 }), this.Zg.er(this.ai).setPointerEvents(!1).sr(this.FS).ir(this.IS).hr({ x: -113, y: 25.8 }).K({ x: 7, y: 29.7 - 25.8 })), t === Yi.Nordics && this.CS.push(this.Zg.er(this.ai).setPointerEvents(!1).sr(this.FS).ir(this.IS).hr({ x: 6.75, y: 67 }).K({ x: -7.75, y: 69.75 - 67 }));
    const s = this.yi.ks.Jo(this.NS, { animationEnabled: this.zr });
    for (let o = 0; o < e.regions.length; o += 1) {
      const n = e.regions[o], a = B2(t, n), l = [];
      for (const h of a) h.length < 3 || l.push(this.NS.Qo().yu(h));
      this.BS.set(n, l), s.Qo(n, ((h) => {
        l.forEach(((u) => u.Ii(h)));
      }));
    }
    if (this.VS.Fs([this.NS]), this.ES = i, this.RS(t, this.ai, i), this.GS = e, this.XS) {
      for (const o of this.XS) this.invalidateRegionValues(o);
      this.XS = void 0;
    }
    this.yi.Rs();
  }
  RS(t, e, i) {
    const s = U2[t], o = e.x.getCellSize(), n = e.y.getCellSize() / o, a = { min: { x: i.min.x, y: i.min.y }, max: { x: i.max.x, y: i.max.y } };
    if (n < s) {
      const u = (a.max.x - a.min.x) * (s / n - 1);
      a.min.x -= u / 2, a.max.x += u / 2;
    } else if (n > s) {
      const u = (a.max.y - a.min.y) * (n / s - 1);
      a.min.y -= u / 2, a.max.y += u / 2;
    }
    e.x.Z(a.min.x, a.max.x), e.y.Z(a.min.y, a.max.y);
    const l = this.ai.x.Pt(), h = this.ai.y.Pt();
    this.D.R("viewchange", { latitudeRange: { start: a.min.y, end: a.max.y }, longitudeRange: { start: a.min.x, end: a.max.x }, margin: { top: h[1], bottom: h[0], left: l[0], right: l[1] } });
  }
  US(t) {
    this.JS = t, this.yi.Rs();
  }
  jS() {
    this.JS = void 0, this.yi.Rs();
  }
  $S(t, e) {
    const i = Array.from(this.BS.entries()).findIndex((([f, p]) => p.includes(e))), s = t?.regions[i], o = this.yi.Ra();
    if (!o) return;
    const n = this.yi.ul(o), a = this.WS && this.WS[i];
    let l = xt({ x: n.engineX, y: n.engineY }, this.yi.ai, this.ai);
    l = { x: Jt(l.x, this.ai.x.getInnerStart(), this.ai.x.getInnerEnd()), y: Jt(l.y, this.ai.y.getInnerStart(), this.ai.y.getInnerEnd()) };
    let h = l.x, u = l.y;
    const c = s.transform;
    s.outlier && c && (h = (h - c.translate.x - c.vertexBoundaries.min.x) / c.scale.x + c.vertexBoundaries.min.x, u = (u - c.translate.y - c.vertexBoundaries.min.y) / c.scale.y + c.vertexBoundaries.min.y);
    const d = this.getFillStyle();
    return { cursorPosition: { pointMarker: { x: n.engineX, y: n.engineY }, pointMarkerScale: this.yi.ai, resultTable: { x: n.engineX, y: n.engineY }, resultTableScale: this.yi.ai }, region: s, value: a, longitude: h, latitude: u, lut: Ve(d) ? d.lut : void 0 };
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  addCursor(t = Pg) {
    const e = this.tv(), i = t.zm(e, this.uiScale, this.uiScale, this.Jg(e), this.xi);
    return this.cv(i), i;
  }
  setAnimationsEnabled(t) {
    return this.zr = !t, this;
  }
  getAnimationsEnabled() {
    return this.zr;
  }
  getMinimumSize() {
  }
  Gg() {
    return [this];
  }
  rr(t) {
    super.rr(t), super.dv();
    const e = ui.xv(this.Wr, this.gv), i = this.Ns.reduce(((o, n) => {
      const a = n.Uh(e, this.Hn);
      return { top: Math.max(o.top, a.top), bottom: Math.max(o.bottom, a.bottom), left: Math.max(o.left, a.left), right: Math.max(o.right, a.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, i);
    const s = Af(this.ai.x.wt() + i.left, this.ai.y.wt() + i.bottom, this.ai.x.Ct() - i.right, this.ai.y.Ct() - i.top);
    return this.zS.Qm(s), this.AS.rr(!1, [], void 0, { explicitTarget: this.JS }), this.Ns.forEach(((o) => o.rr(e, this.Hn))), this;
  }
  dispose() {
    return this.zS.G(), this.AS.G(), wa(this.ai), super.dispose();
  }
  W() {
    return super.W(), this.ai.W(), this;
  }
  X() {
    return super.X(), this.ai.X(), this;
  }
  Ws() {
    return is(this.getFillStyle(), this.NS.wi());
  }
  nr() {
    return { fill: this.getFillStyle() };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const H2 = (r, t) => {
  const e = r > 0, i = [ji(Math.abs(0 | r), 2), "° ", ji(Math.abs(0 | (r < 0 ? r = -r : r) % 1 * 60), 2), "' "].join("") + (e ? "E" : "W"), s = t > 0;
  return `${[ji(Math.abs(0 | t), 2), "° ", ji(Math.abs(0 | (t < 0 ? t = -t : t) % 1 * 60), 2), "' "].join("") + (s ? "N" : "S")}, ${i}`;
}, Y2 = (r, t, e) => {
  var i;
  const s = [[{ text: t.region.name, rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [H2(t.longitude, t.latitude)]];
  return t.value !== void 0 && s.push({ text: Ai(t.lut ? va(t.lut, t.value) : t.value.toFixed(2), (i = t.lut) === null || i === void 0 ? void 0 : i.units), font: { weight: "bold" } }), s;
};
class Mx extends eo {
  constructor(t, e, i, s, o, n, a, l, h) {
    super(t, e, e.QS(i), s, o, { numeric: e.KS({ amplitude: s.polarAmplitudeAxisNumericTicks, radial: s.polarAmplitudeAxisNumericTicks }), datetime: e.KS({ amplitude: s.polarAmplitudeAxisDateTimeTicks, radial: s.polarAmplitudeAxisDateTimeTicks }), time: e.KS({ amplitude: s.polarAmplitudeAxisTimeTicks, radial: s.polarAmplitudeAxisTimeTicks }) }, { type: "linear" }), this.D = new Nt(), this.qS = n, this.tb = a, this.ib = l, this.bs = h, this.sb = i, this.eb = e.KS({ amplitude: s.polarAmplitudeAxisStrokeStyle, radial: s.polarRadialAxisStrokeStyle }), this.qr = l.In(i).setPointerEvents(!1).Ih(e.KS({ amplitude: s.polarAmplitudeAxisTitleFont, radial: s.polarRadialAxisTitleFont })).sr(e.KS({ amplitude: s.polarAmplitudeAxisTitleFillStyle, radial: s.polarRadialAxisTitleFillStyle })), this.Bh = this.bs.CA([this.qr]).Es(s.effectsText);
  }
  setTickStrategy(t, e) {
    return super.ph(t, e);
  }
  setStrokeStyle(t) {
    return this.eb = typeof t == "function" ? t(this.eb) : t, this.tb.Rs(), this;
  }
  getStrokeStyle() {
    return this.eb;
  }
  Wh(t) {
    return {};
  }
  Qh(t, e, i, s) {
    const o = this.rb(this.sb, t, e.Lr);
    return { keyValue: t, tickLevel: e, labelText: i, labelPosition: qt(this.hb(this.sb, t), o.padding), labelAlignment: o.alignment, labelRotation: o.rotation, labelOffset: o.offset };
  }
  hn(t, e, i, s) {
    return new j2(e, t, this.sb, this.ib, this.nb(this.qS, this.sb), this.ib.vr(this.sb).setPointerEvents(!1));
  }
  ih() {
    return this.sb;
  }
  rr(t) {
    this.ob(this.sb, this.eb, t.OA), this.ab(this.sb, this.qr, t.OA), t.ticksInfo.forEach(((e, i) => {
      i.Gh.hr(e.labelPosition).ru(e.labelAlignment).Ph(e.labelRotation).Ql(e.labelOffset.x, e.labelOffset.y), this.lb && this.lb(i) === !1 && i.Gh.setVisible(!1), this.ub(this.sb, i.fb, i.Ab, i);
    }));
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
}
class j2 extends Wa {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, s, i, a), this.fb = o, this.Ab = n, o.setPointerEvents(!1), this.ps.push(o, n);
  }
}
class $2 extends Mx {
  constructor(t, e, i, s, o, n, a, l, h) {
    super(t, X2((() => this.DA())), e, i, s, o, n, a, l), this.ly = this.tb.vr(this.sb).setPointerEvents(!1), this.gb = h, this.setScrollStrategy(za.expansion), this.setTickStrategy(jr.Numeric), this.setTitle("Amplitude"), this.qr.en(i.polarAmplitudeAxisTitleShadow);
  }
  DA() {
    return this.gb();
  }
  tn(t, e, i) {
    return { ticksInfo: e, OA: this.fn(((s, o) => {
      const n = o.Pn.Lr, a = 0.5 * this.eb.getThickness() + n.tickLength + n.tickPadding + Math.abs(o.Gh.Uh().Bc().y);
      return Math.max(s, a);
    }), 0), updatedTicks: i };
  }
  xn(t, e) {
    return Sa(t, e, this.sb.y);
  }
  wn(t, e, i) {
    const s = 2 * Math.abs(e - t), o = this.sb.x.Jt(s);
    return { start: t + i.start * o * Math.sign(t - e), end: e + i.end * o * Math.sign(e - t) };
  }
  hb(t, e) {
    return { x: t.fe() ? e - t.de().start : t.de().start - e, y: 0 };
  }
  nb(t, e) {
    return t.Ud(e);
  }
  ub(t, e, i, s) {
    const o = s.Pn.Lr, n = t.fe() ? s.M - t.de().start : t.de().start - s.M;
    Pi(s.M, t.de().start) || Pi(s.M, t.de().end) ? e.setVisible(!1) : e.setVisible(!0).lc(0).yr(360).gc(void 0).Ac(0).uc(n).gc(60).sr(Lt).ir(o.gridStrokeStyle);
    const a = 0.5 * this.eb.getThickness();
    i.pr({ x: n, y: -a * t.ni().y }).yr({ x: n, y: -(a + o.tickLength) * t.ni().y }).gr(o.tickStyle);
  }
  rb(t, e, i) {
    return { alignment: { x: 0, y: 1 }, padding: { x: 0, y: t.ni().y * -(0.5 * this.eb.getThickness() + i.tickLength + i.tickPadding) }, rotation: 0, offset: { x: 0, y: 0 } };
  }
  ob(t, e, i) {
    const s = t.fe() ? t.de().end - t.de().start : t.de().start - t.de().end;
    this.ly.pr({ x: 0, y: 0 }).yr({ x: s, y: 0 }).gr(e);
  }
  ab(t, e, i) {
    const s = t.fe() ? (t.de().start + t.de().end) / 2 - t.de().start : t.de().start - (t.de().start + t.de().end) / 2;
    e.ru({ x: 0, y: 1 }).hr({ x: s, y: -i * t.ni().y });
  }
}
const X2 = (r) => ({ ...ja(r, ((t) => t.getAmplitudeMin()), ((t) => t.getAmplitudeMax()), ((t) => {
})), QS: (t) => ({ getInnerStart: () => t.de().start, getInnerEnd: () => t.de().end, Z: (e, i) => t.ue(e, i), nt: (e, i, s, o, n) => t.y.nt(e, i, s, o, n), H: () => t.Et() }), KS: (t) => t.amplitude });
class Z2 {
  constructor(t, e, i, s) {
    this.yb = !1, this.D = new Nt(), this.Ie = t, this.pb = e, this.Ny = i, this.zc = s;
  }
  setGeometry(t) {
    return this.mb = t, this.yb = !0, this.Ie.yi.Rs(), this;
  }
  getGeometry() {
    return this.mb;
  }
  setPointerEvents(t) {
    return this.zc.setPointerEvents(t), this;
  }
  dispose() {
    return this.zc.dispose(), this.pb(this), this.D.R("dispose", {}), this;
  }
  setVisible(t) {
    const e = this.zc.getVisible() !== t;
    return this.zc.setVisible(t), e && this.D.R("visiblechange", { isVisible: t }), this.Ie.yi.Rs(), this;
  }
  getVisible() {
    return this.zc.getVisible();
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class gh extends to {
  constructor() {
    super(...arguments), this.kv = !0, this.wv = !0;
  }
  setAutoScrollingEnabled(t) {
    return this.kv = t, this.chart.yi.Rs(), this;
  }
  getAutoScrollingEnabled() {
    return this.kv;
  }
  Dv() {
  }
  rr() {
  }
  Ev() {
  }
  setCursorEnabled(t) {
    return this.wv = t, this;
  }
  getCursorEnabled() {
    return this.wv;
  }
  Pv() {
    return this.getVisible() && this.getCursorEnabled();
  }
  setCursorFormattingOverride(t) {
    return this.Iv = t, this;
  }
  getCursorFormattingOverride() {
    return this.Iv;
  }
}
class Xa extends gh {
  constructor(t, e, i, s, o, n) {
    super(e, i, o, n), this.Js = t, this.chart = e, this.scale = s;
  }
  getAmplitudeMin() {
    return this.Sb ? this.Sb.min : void 0;
  }
  getAmplitudeMax() {
    return this.Sb ? this.Sb.max : void 0;
  }
}
const fn = (r, t) => {
  const e = [], i = t.de().start, s = t.de().end, o = t.fe(), n = t.ge() ? 1 : -1, a = t.ye(), l = Math.abs(s - i), h = Math.min(i, s) + 1e-3 * l, u = Math.max(i, s) - 1e-3 * l;
  for (const c of r) {
    const d = Jt(c.amplitude, h, u), f = c.angle * Math.PI / 180 - a, p = Math.cos(f * n) * (o ? d - i : i - d), g = Math.sin(f * n) * (o ? d - i : i - d), y = c.color;
    e.push({ x: p, y: g, color: y });
  }
  return e;
}, ph = (r) => {
  const t = { min: wt, max: Pt };
  for (const e of r) t.min = Math.min(t.min, e.amplitude), t.max = Math.max(t.max, e.amplitude);
  return t;
}, oc = (r) => r.slice().map(((t) => t.angle >= 0 && t.angle <= 360 ? t : { ...t, angle: t.angle % 360 })), io = (r, t) => {
  let e = Wl(r);
  for (t.ge() || (e *= -1), e += 180 * t.ye() / Math.PI; e < 0; ) e += 360;
  e %= 360;
  const i = an(r), s = t.de(), o = Math.abs(s.end - s.start);
  return { angle: e, amplitude: tr(s.start, s.end, i / o), color: r.color ? Em(r.color) : void 0 };
};
class K2 extends Xa {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, o, a), this.Vs = "Polygon Series", this.bb = [], this.xb = [], this.Mb = (l) => {
      const h = this.xb.indexOf(l);
      h >= 0 && this.xb.splice(h, 1);
      const u = this.bb.findIndex(((c) => c === l.zc));
      u >= 0 && this.bb.splice(u, 1), this.Js.Rs();
    }, this.D = new Nt(), this.Ke = ue(this.xi.polarPolygonSeriesFillStyle, n), this.qe = ue(this.xi.polarPolygonSeriesStrokeStyle, n);
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY }, o = _o(s, this.bb, ((l, h) => {
      const u = l.Rd(h);
      if (u) return xt(u, this.scale, l.yi.ai);
    }), ws);
    if (!o) return;
    const n = xt(o[0], o[1].yi.ai, this.scale);
    if (!this._b(o[1])) return;
    const a = io(n, this.scale);
    return { cursorPosition: { pointMarker: n, pointMarkerScale: this.scale, resultTable: n, resultTableScale: this.scale }, series: this, ...a };
  }
  Qi(t, e, i) {
    return Pr({ series: this }, { cursorPosition: 0, amplitude: 0, angle: 0, color: 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  addPolygon() {
    const t = new Z2(this.chart, this.Mb, this, this.wb());
    return this.xb.push(t), t;
  }
  setFillStyle(t) {
    this.Ke = typeof t == "function" ? t(this.Ke) : t;
    const e = this.Ke;
    for (const i of this.bb) i.sr(e);
    return this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setStrokeStyle(t) {
    this.qe = typeof t == "function" ? t(this.qe) : t;
    const e = this.qe;
    for (const i of this.bb) i.ir(e);
    return this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  Uv() {
    return this.kv && this.xb.find(((t) => t.kb !== void 0)) !== void 0 && this.getVisible();
  }
  rr() {
    this.xb.forEach(((t) => {
      (t.yb || this.scale.pe()) && t.Cb && (t.zc.yu(fn(t.Cb, this.scale)), t.yb = !1, t.zc.Uh());
    }));
  }
  Dv() {
    super.Dv();
    const t = Ee(wt, Pt);
    this.xb.forEach(((e) => {
      if (!e.mb) return;
      const i = !e.yb && e.Cb ? e.Cb : oc(e.mb);
      e.Cb = i;
      const s = !e.yb && e.kb ? e.kb : ph(i);
      e.kb = s, t.min = Math.min(t.min, s.min), t.max = Math.max(t.max, s.max);
    })), this.Sb = t;
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  nr() {
    return { fill: this.Ke, stroke: this.qe };
  }
  wb() {
    const t = this.Js.Vc(this.scale, fr.Simple).sr(this.Ke).ir(this.qe).Ii(this.getHighlight());
    return this.bb.push(t), this.Ts(t), t;
  }
  _b(t) {
    return this.xb.find(((e) => e.zc === t));
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class q2 extends Xa {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, o, a), this.Vs = "Area Series", this.Tb = [], this.Fb = !1, this.Ib = !1, this.Pb = !1, this.D = new Nt(), this.Ke = ue(this.xi.polarAreaSeriesFillStyle, n), this.qe = ue(this.xi.polarAreaSeriesStrokeStyle, n);
  }
  setData(t) {
    this.Tb.length !== 0 && this.chart.yi.Oa(Ot.Go);
    const e = ((i) => {
      const s = [];
      let o, n, a = !1;
      for (let l = 0; l < i.length; l += 1) {
        const h = i[l];
        let u = !0;
        if (o) {
          u = !1;
          const c = h.angle - o.angle;
          if (Pi(c, 0)) u = !0;
          else {
            const d = Math.sign(c);
            n === void 0 ? (n = d, u = !0) : n === d && (u = !0);
          }
        }
        u ? s.push(h) : a = !0, o = h;
      }
      return { progressivePoints: s, userDataModified: a };
    })(t);
    return e.userDataModified && this.Pb === !1 && (console.warn(`${this.Vs} setData data format is faulty. Consecutive 'angle' values should progress in the same direction! Invalid data points have been removed.`), this.Pb = !0), this.Tb = e.progressivePoints, this.Fb = !0, this.Sb = ph(this.Tb), this.Js.Rs(), this;
  }
  getData() {
    return this.Tb;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setStrokeStyle(t) {
    return this.qe = typeof t == "function" ? t(this.qe) : t, this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  setConnectDataAutomaticallyEnabled(t) {
    return this.Ib = t, this.Js.Rs(), this;
  }
  getConnectDataAutomaticallyEnabled() {
    return this.Ib;
  }
  Uv() {
    return this.kv && this.Tb.length > 0 && this.getVisible();
  }
  nr() {
    return { fill: this.Ke, stroke: this.qe };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class J2 extends q2 {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, o, n, a), this.Lb = this.Js.Vc(this.scale, fr.Simple).Ii(this.getHighlight()), this.Ts(this.Lb);
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY }, o = this.Lb.Rd(s);
    if (!o) return;
    const n = io(o, this.scale);
    return { cursorPosition: { pointMarker: o, pointMarkerScale: this.scale, resultTable: o, resultTableScale: this.scale }, series: this, ...n };
  }
  Qi(t, e, i) {
    return Pr({ series: this }, { cursorPosition: 0, amplitude: 0, angle: 0, color: 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  rr() {
    if (this.Fb || this.scale.pe()) {
      const t = this.Tb, e = this.Ib === !0 ? fn(t, this.scale) : [...fn(t, this.scale), { x: 0, y: 0 }];
      this.Lb.yu(e).sr(this.Ke).ir(this.qe), this.Fb = !1, this.Lb.Uh();
    }
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
}
class Q2 extends Xa {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, o, a), this.Vs = "Line Series", this.Tb = [], this.Fb = !1, this.Ib = !1, this.D = new Nt(), this.vc = ue(this.xi.polarLineSeriesStrokeStyle, n), this.Bb = t.Ay(s, void 0, [Ir.UserSeries]).gr(this.vc).Ii(this.getHighlight()), this.Ts(this.Bb);
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY }, o = this.Bb.Db(s);
    if (!o) return;
    const n = io(o, this.scale);
    return { cursorPosition: { pointMarker: o, pointMarkerScale: this.scale, resultTable: o, resultTableScale: this.scale }, series: this, ...n };
  }
  Qi(t, e, i) {
    return Pr({ series: this }, { cursorPosition: 0, amplitude: 0, angle: 0, color: 0 }, (() => this.solveNearest(e, "show-nearest")));
  }
  setData(t) {
    return this.Tb.length !== 0 && this.chart.yi.Oa(Ot.Go), this.Tb = oc(t), this.Fb = !0, this.Sb = ph(this.Tb), this.Js.Rs(), this;
  }
  getData() {
    return this.Tb;
  }
  setStrokeStyle(t) {
    this.vc = typeof t == "function" ? t(this.vc) : t;
    const e = this.vc;
    return this.Bb.gr(e), this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.vc;
  }
  setConnectDataAutomaticallyEnabled(t) {
    return this.Ib = t, this.Js.Rs(), this;
  }
  getConnectDataAutomaticallyEnabled() {
    return this.Ib;
  }
  Uv() {
    return this.kv && this.Tb.length > 0 && this.getVisible();
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  rr() {
    if (this.Fb || this.scale.pe()) {
      const t = fn(this.Tb, this.scale), e = Vi(t);
      this.Ib ? (t.push({ ...t[0] }), this.Bb.Nu(!0)) : this.Bb.Nu(!1), this.Bb.Vi().Pu(t).Ti(e), this.Fb = !1, this.Bb.Uh();
    }
  }
  nr() {
    return { stroke: this.vc };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Za extends Vf {
  constructor(t, e, i, s, o, n, a, l, h) {
    super(), this.Si = zm(), this.ci = !1, this.D = new Nt(), this.Eb = s, this.Rb = o, this.Ob = n, this.zb = a, this.Vb = l, this.Js = t, this.scale = e, this.Nb = i, this.xi = h;
  }
  Gb(t) {
    this.$b = t;
  }
  setHighlight(t) {
    const e = dn(t);
    return this.$b && this.$b.Ii(e), this.D.R("highlightchange", { highlight: e }), this;
  }
  dispose() {
    return this.Nb && this.Nb(this), this.Js.yi.Rs(), this.D.R("dispose", {}), this.ci = !0, this;
  }
  setVisible(t) {
    return super.setVisible(t), this.Ob(), this.Js.yi.Rs(), this;
  }
  isDisposed() {
    return this.ci;
  }
  setPointerEvents(t) {
    return this.zb(this, t), this;
  }
  getPointerEvents() {
    return this.Vb(this);
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Ig extends Za {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d, f, p, g, y, m, A) {
    super(e, i, s, o, n, a, l, h, A), this.Ub = 1, this.jb = 1, this.Ny = t, this.Js = e, this.scale = i, this.dimensionStrategy = u, this.start = c, this.end = d, this.lowerExtreme = f, this.lowerQuartile = p, this.median = g, this.upperQuartile = y, this.upperExtreme = m, this.boundaries = Ee(this.dimensionStrategy.toPoint(c, f), this.dimensionStrategy.toPoint(d, m)), this.Yb = this.xi.boxSeriesBodyFillStyle, this.Hb = this.xi.boxSeriesBodyStrokeStyle, this.vc = this.xi.boxSeriesStrokeStyle, this.Wb = this.xi.boxSeriesMedianStrokeStyle, this.Uh();
  }
  Qi(t, e) {
    const i = this.Ny.Qs.toPoint((this.start + this.end) / 2, this.median);
    return { cursorPosition: { resultTable: i, resultTableScale: this.scale, pointMarker: i, pointMarkerScale: { x: this.Ny.axisX, y: this.Ny.axisY } }, ...i, figure: this, start: this.start, end: this.end, lowerExtreme: this.lowerExtreme, lowerQuartile: this.lowerQuartile, median: this.median, upperQuartile: this.upperQuartile, upperExtreme: this.upperExtreme, series: this.Ny, axisX: this.Ny.axisX, axisY: this.Ny.axisY };
  }
  Xb() {
    return this.boundaries;
  }
  setBodyWidth(t) {
    return this.Ub = t, this.Uh(), this;
  }
  getBodyWidth() {
    return this.Ub;
  }
  setBodyFillStyle(t) {
    return this.Yb = typeof t == "function" ? t(this.Yb) : t, this.Rb(), this;
  }
  getBodyFillStyle() {
    return this.Yb;
  }
  setBodyStrokeStyle(t) {
    return this.Hb = typeof t == "function" ? t(this.Hb) : t, this.Rb(), this;
  }
  getBodyStrokeStyle() {
    return this.Hb;
  }
  setTailWidth(t) {
    return this.jb = t, this.Uh(), this;
  }
  getTailWidth() {
    return this.jb;
  }
  setStrokeStyle(t) {
    return this.vc = typeof t == "function" ? t(this.vc) : t, this.Rb(), this;
  }
  getStrokeStyle() {
    return this.vc;
  }
  setMedianStrokeStyle(t) {
    return this.Wb = typeof t == "function" ? t(this.Wb) : t, this.Rb(), this;
  }
  getMedianStrokeStyle() {
    return this.Wb;
  }
  Uh() {
    this.Eb();
  }
  getDominantStyle() {
    return this.getBodyFillStyle();
  }
}
class No extends gh {
  constructor(t, e, i, s, o, n, a, l, h, u) {
    super(t, e, h, u), this.Zs = !0, this.ps = /* @__PURE__ */ new Map(), this.chart = t, this.Js = i, this.axisX = s, this.axisY = o, this.axisXAttachHandler = n, this.axisYAttachHandler = a, this.scale = jm(s.ai, o.ai), this.Zb = t.Jb, t.Jb += 1, this.Fv(this.scale), this.attacheAxis();
  }
  get xAxis() {
    return this.axisX;
  }
  get yAxis() {
    return this.axisY;
  }
  Al() {
    const t = Array.from(this.ps.keys());
    for (const e of t) {
      const i = e.Al();
      if (i) return i;
    }
  }
  setClipping(t) {
    return this.Zs = t, this.Js.Rs(), this;
  }
  getClipping() {
    return this.Zs;
  }
  attacheAxis() {
    this.Qb = this.axisXAttachHandler(this), this.Kb = this.axisYAttachHandler(this);
  }
  Ts(t, e) {
    super.Ts(t, e), t.vl(this.Zb);
  }
  getName() {
    const t = this.Cs(), e = t === "ProgressiveY" || t === "RegressiveY" ? this.axisX.getTitle() : this.axisY.getTitle();
    return this.Vs || e.length > 0 && e || "Series";
  }
  setDrawOrder(t) {
    return this.Zb = t.seriesDrawOrderIndex, this.ps.forEach(((e, i) => {
      i.vl(this.Zb);
    })), this.chart.yi.Rs(), this;
  }
  dispose() {
    return super.dispose(), this.Qb(this), this.Kb(this), this.chart.legend.remove(this), this;
  }
  Ev() {
    super.Ev(), Ff(this.Zs, Array.from(this.ps.keys()), this.scale);
  }
  getXMax() {
    var t;
    return (t = this.qb(!1)) !== null && t !== void 0 ? t : 0;
  }
  getXMin() {
    var t;
    return (t = this.tx(!1)) !== null && t !== void 0 ? t : 0;
  }
  getYMax() {
    var t;
    return (t = this.ix(!1)) !== null && t !== void 0 ? t : 0;
  }
  getYMin() {
    var t;
    return (t = this.sx(!1)) !== null && t !== void 0 ? t : 0;
  }
  getBoundaries() {
    return Ee(j(this.getXMin() || 0, this.getYMin() || 0), j(this.getXMax() || 0, this.getYMax() || 0));
  }
  setCursorEnabled(t) {
    return super.setCursorEnabled(t);
  }
}
const Wh = (r, t, e, i) => {
  const s = r.length;
  let o = 0;
  if (t !== void 0) {
    const n = e - t;
    if (n > 0) {
      const a = r.slice(o, n);
      o += n, i(a, !0);
    }
  }
  for (; o < s; ) {
    const n = r.slice(o, o + e);
    o += e, i(n, !1);
  }
};
class Ka extends No {
  constructor(t, e, i, s, o, n, a, l, h, u) {
    super(t, e, i, s, o, n, a, l, h, u), this.hx = [], this.nx = void 0, this.ox = !1, this.Nb = (c) => {
      const d = this.hx.findIndex(((f) => f === c));
      d >= 0 && this.hx.splice(d, 1), this.ox = !0, this.nx = void 0, this.Js.Rs();
    }, this.Eb = () => {
      this.nx = void 0, this.ox = !0, this.chart.yi.Rs();
    }, this.Rb = () => {
      this.ox = !0, this.chart.yi.Rs();
    }, this.Ob = () => {
      this.nx = void 0, this.ox = !0, this.chart.yi.Rs();
    }, this.zb = (c, d) => {
      this.setPointerEvents(d);
    }, this.lx = (c) => this.getPointerEvents(), this.gs = Qi.onHoverIndividual;
  }
  getFigures() {
    return this.hx.slice();
  }
  setPointerEvents(t) {
    return super.setPointerEvents(t), this.ps.forEach(((e, i) => i.setPointerEvents(t))), this;
  }
  Gv() {
    return this.hx.length > 0;
  }
  rr() {
    super.rr(), this.ox && (this.ux(this.hx), this.ox = !1);
  }
  clear() {
    return this.hx.slice().forEach(Eo), this.hx.length = 0, this.ox = !0, this.nx = void 0, this.Js.Rs(), this;
  }
  Ax(t, e) {
    e !== void 0 ? this.hx.splice(e, 0, t) : this.hx.push(t), this.ox = !0, this.gx && this.gx(t), this.D.Gi(t), this.Js.Rs(), t.addEventListener("pointerenter", (() => {
      this.gs === Qi.onHoverIndividual && t.setHighlight(!0);
    })), t.addEventListener("pointerleave", (() => {
      this.gs === Qi.onHoverIndividual && t.setHighlight(!1);
    }));
  }
  Uv() {
    return this.kv && this.hx.length > 0 && this.getVisible();
  }
  setDefaultStyle(t) {
    return this.gx = t, this.hx.forEach(t), t(this.vx), this.ox = !0, this.chart.yi.Rs(), this;
  }
  setVisible(t) {
    return super.setVisible(t), t !== this.getVisible() && this.hx.forEach(((e) => e.setVisible(t))), this;
  }
  qb() {
    return this.nx || (this.nx = this.yx()), this.nx.max.x;
  }
  tx() {
    return this.nx || (this.nx = this.yx()), this.nx.min.x;
  }
  ix() {
    return this.nx || (this.nx = this.yx()), this.nx.max.y;
  }
  sx() {
    return this.nx || (this.nx = this.yx()), this.nx.min.y;
  }
  Sn() {
    return j(0, 0);
  }
  yx() {
    const t = Ee(Kn(wt, wt), Kn(Pt, Pt));
    for (let e = 0; e < this.hx.length; e += 1) if (this.hx[e].getVisible()) {
      const i = this.hx[e].Xb();
      t.min.x = Math.min(t.min.x, i.min.x), t.min.y = Math.min(t.min.y, i.min.y), t.max.x = Math.max(t.max.x, i.max.x), t.max.y = Math.max(t.max.y, i.max.y);
    }
    return t;
  }
  nr() {
    return { fill: this.hx.length > 0 ? this.hx[0].getDominantStyle() : this.vx.getDominantStyle() };
  }
}
class t5 extends Ka {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    super(t, e, i, s, o, n, a, l, u, c), this.Vs = "Box Series", this.mx = Vo(), this.Sx = (f) => xt(this.Qs.toPoint((f.start + f.end) / 2, f.median), this.scale, this.Js.yi.ai), this.D = new Nt(), this.chart.yi.Oa(Ot.Vo), this.Qs = h, this.vx = new Ig(this, this.Js, this.scale, this.Nb, ie, ie, ie, ie, ((f) => !1), this.Qs, 0, 0, 0, 0, 0, 0, 0, this.xi).dispose(), this.bx = new Fr((() => {
      const f = this.Js.GA(this.scale);
      return this.Ts(f, { setEventHandlers: !1, pointerEventsDisabled: !0 }), f;
    }), ((f, p, g) => (f.gr(g.strokeStyle), p.map(((y) => {
      const m = y.existingMember || f.Qo();
      return m.UA(y.start, y.end), m;
    }))))), this.xx = new Fr((() => {
      const f = this.mx.Ji(this.Js.yy(this.scale));
      return this.Ts(f, { setEventHandlers: !1 }), f;
    }), ((f, p, g) => (f.sr(g.fillStyle).ir(g.strokeStyle), p.map(((y) => {
      const m = y.existingMember || f.Qo();
      return m.yu(y.vertices), this.mx.Ki(m, y.figure), y.figure.Gb(m), m;
    })))), (() => {
      this.mx.Vi();
    }), ((f, p) => {
      this.Ps(p);
    }));
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY };
    if (this.hx.length === 0) return;
    const o = _o(s, this.hx.filter(((a) => a.getVisible())), this.Sx, ws);
    if (!o) return;
    const n = xt(o[0], this.Js.yi.ai, this.scale);
    return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...n, figure: o[1], start: o[1].start, end: o[1].end, lowerExtreme: o[1].lowerExtreme, lowerQuartile: o[1].lowerQuartile, median: o[1].median, upperQuartile: o[1].upperQuartile, upperExtreme: o[1].upperExtreme, series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Qi(t, e, i) {
    if (!i) return;
    const s = this.hx.find(((n) => n.$b === i));
    if (!s) return;
    const o = this.Qs.toPoint((s.start + s.end) / 2, s.median);
    return { cursorPosition: { resultTable: o, resultTableScale: this.scale, pointMarker: o, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...o, start: s.start, end: s.end, lowerExtreme: s.lowerExtreme, lowerQuartile: s.lowerQuartile, median: s.median, upperQuartile: s.upperQuartile, upperExtreme: s.upperExtreme, figure: s, series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Fv(t) {
    if (!(t instanceof we || t instanceof Ti)) throw new Error("BoxSeries only supports Linear Axes");
  }
  ux(t) {
    const e = this.xx.rg(), i = this.bx.rg();
    t.forEach(((s) => {
      if (!s.getVisible()) return;
      const o = this.Qs.toPoint((s.start + s.end - s.Ub * (s.end - s.start)) / 2, s.lowerQuartile), n = this.Qs.toPoint((s.end - s.start) * s.Ub, s.upperQuartile - s.lowerQuartile), a = this.Qs.toPoint((s.start + s.end) / 2, s.lowerQuartile), l = this.Qs.toPoint((s.start + s.end) / 2, s.lowerExtreme), h = this.Qs.toPoint((s.start + s.end) / 2, s.upperQuartile), u = this.Qs.toPoint((s.start + s.end) / 2, s.upperExtreme), c = this.Qs.toPoint((s.start + s.end - s.jb * (s.end - s.start)) / 2, s.lowerExtreme), d = this.Qs.toPoint((s.start + s.end + s.jb * (s.end - s.start)) / 2, s.lowerExtreme), f = this.Qs.toPoint((s.start + s.end - s.jb * (s.end - s.start)) / 2, s.upperExtreme), p = this.Qs.toPoint((s.start + s.end + s.jb * (s.end - s.start)) / 2, s.upperExtreme), g = this.Qs.toPoint((s.start + s.end - s.Ub * (s.end - s.start)) / 2, s.median), y = this.Qs.toPoint((s.start + s.end + s.Ub * (s.end - s.start)) / 2, s.median);
      e.add({ Si: s.Si, vertices: [{ x: o.x, y: o.y }, { x: o.x, y: o.y + n.y }, { x: o.x + n.x, y: o.y + n.y }, { x: o.x + n.x, y: o.y }], figure: s }, { fillStyle: s.Yb, strokeStyle: s.Hb }), i.add({ Si: 0, start: a, end: l, figure: s }, { strokeStyle: s.vc }), i.add({ Si: 0, start: h, end: u, figure: s }, { strokeStyle: s.vc }), i.add({ Si: 0, start: c, end: d, figure: s }, { strokeStyle: s.vc }), i.add({ Si: 0, start: f, end: p, figure: s }, { strokeStyle: s.vc }), i.add({ Si: 0, start: g, end: y, figure: s }, { strokeStyle: s.Wb });
    })), e.finishPlot(), i.finishPlot();
  }
  add(t) {
    const e = new Ig(this, this.Js, this.scale, this.Nb, this.Eb, this.Rb, this.Ob, this.zb, this.lx, this.Qs, t.start, t.end, t.lowerExtreme, t.lowerQuartile, t.median, t.upperQuartile, t.upperExtreme, this.xi);
    return this.Ax(e), this.ox = !0, this.chart.yi.Rs(), e;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Vg extends Za {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(e, i, s, o, n, a, l, h, u), this.dimensions = { x: 0, y: 0, radiusX: 0, radiusY: 0 }, this.gu = Ee(j(0, 0), j(0, 0)), this.Ny = t, this.Js = e, this.scale = i, this.Ke = ue(u.ellipseSeriesFillStyle, c), this.qe = ue(u.ellipseSeriesStrokeStyle, c);
  }
  Qi(t, e) {
    const i = this.getDimensions(), s = j(i.x, i.y);
    return { cursorPosition: { resultTable: s, resultTableScale: this.scale, pointMarker: s, pointMarkerScale: { x: this.Ny.axisX, y: this.Ny.axisY } }, ...s, figure: this, ...this.getDimensions(), series: this.Ny, axisX: this.Ny.axisX, axisY: this.Ny.axisY };
  }
  Xb() {
    return this.gu;
  }
  setDimensions(t) {
    return this.dimensions = t, this.gu = Ee(j(t.x - t.radiusX, t.y - t.radiusY), j(t.x + t.radiusX, t.y + t.radiusY)), this.Eb(), this.Js.Rs(), this;
  }
  getDimensions() {
    return this.dimensions;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.Rb(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setStrokeStyle(t) {
    return this.qe = typeof t == "function" ? t(this.qe) : t, this.Rb(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  getDominantStyle() {
    return this.Ke;
  }
}
class e5 extends Ka {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(t, e, i, s, o, n, a, l, h, u), this.Vs = "Ellipse Series", this.mx = Vo(), this.Sx = (d) => {
      const f = d.getDimensions(), p = j(f.x, f.y);
      return xt(p, this.scale, this.Js.yi.ai);
    }, this.D = new Nt(), this.chart.yi.Oa(Ot.Vo), this.Mx = c, this.vx = new Vg(this, this.Js, this.scale, ie, ie, ie, ie, ie, ((d) => !1), this.xi, this.Mx).dispose(), this.xx = new Fr((() => {
      const d = this.mx.Ji(this.Js.yy(this.scale));
      return this.Ts(d, { setEventHandlers: !1 }), d;
    }), ((d, f, p) => (d.sr(p.fillStyle).ir(p.strokeStyle), f.map(((g) => {
      const y = g.existingMember || d.Qo();
      return y.yu(g.vertices), this.mx.Ki(y, g.figure), g.figure.Gb(y), y;
    })))), (() => {
      this.mx.Vi();
    }), ((d, f) => {
      this.Ps(f);
    }));
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY };
    if (this.hx.length === 0) return;
    const o = _o(s, this.hx.filter(((a) => a.getVisible())), this.Sx, ws);
    if (!o) return;
    const n = xt(o[0], this.Js.yi.ai, this.scale);
    return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...n, figure: o[1], ...o[1].getDimensions(), series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Qi(t, e, i) {
    if (!i) return;
    const s = this.hx.find(((n) => n.$b === i));
    if (!s) return;
    const o = s.getDimensions();
    return { cursorPosition: { resultTable: o, resultTableScale: this.scale, pointMarker: o, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...o, figure: s, series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Fv(t) {
    if (!(t instanceof we || t instanceof Ti)) throw new Error("EllipseSeries only supports Linear Axes");
  }
  ux(t) {
    const e = this.xx.rg();
    t.forEach(((i) => {
      if (!i.getVisible()) return;
      const s = i.getDimensions(), o = [], n = s.drawSteps !== void 0 ? s.drawSteps : 72;
      for (let h = 0; h <= n; h += 1) {
        const u = h / n * 2 * Math.PI, c = s.x + s.radiusX * Math.cos(u), d = s.y + s.radiusY * Math.sin(u);
        o.push({ x: c, y: d });
      }
      const a = i.getFillStyle(), l = i.getStrokeStyle();
      e.add({ Si: i.Si, vertices: o, figure: i }, { fillStyle: a, strokeStyle: l });
    })), e.finishPlot();
  }
  add(t) {
    const e = new Vg(this, this.Js, this.scale, this.Nb, this.Eb, this.Rb, this.Ob, this.zb, this.lx, this.xi, this.Mx).setDimensions(t);
    return this.Ax(e), this.ox = !0, this.chart.yi.Rs(), e;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class _g extends Za {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(e, i, s, o, n, a, l, h, u), this._x = [], this.gu = Ie, this.Ny = t, this.Js = e, this.scale = i, this.Ke = ue(u.polygonSeriesFillStyle, c), this.qe = ue(u.polygonSeriesStrokeStyle, c);
  }
  Qi(t, e) {
    const i = this.Xb(), s = j((i.min.x + i.max.x) / 2, (i.min.y + i.max.y) / 2);
    return { cursorPosition: { resultTable: s, resultTableScale: this.scale, pointMarker: s, pointMarkerScale: { x: this.Ny.axisX, y: this.Ny.axisY } }, ...s, figure: this, coordinates: this.getDimensions(), series: this.Ny, axisX: this.Ny.axisX, axisY: this.Ny.axisY };
  }
  Xb() {
    return this.gu;
  }
  setDimensions(t) {
    return this._x = t, this.gu = Vi(this._x), this.Eb(), this.Js.Rs(), this;
  }
  getDimensions() {
    return this._x;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.Rb(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setStrokeStyle(t) {
    return this.qe = typeof t == "function" ? t(this.qe) : t, this.Rb(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  getDominantStyle() {
    return this.Ke;
  }
}
class i5 extends Ka {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(t, e, i, s, o, n, a, l, h, u), this.Vs = "Polygon Series", this.mx = Vo(), this.Sx = (d) => {
      const f = d.Xb(), p = j((f.min.x + f.max.x) / 2, (f.min.y + f.max.y) / 2);
      return xt(p, this.scale, this.Js.yi.ai);
    }, this.D = new Nt(), this.chart.yi.Oa(Ot.Vo), this.Mx = c, this.vx = new _g(this, this.Js, this.scale, ie, ie, ie, ie, ie, ((d) => !1), this.xi, this.Mx).dispose(), this.xx = new Fr((() => {
      const d = this.mx.Ji(this.Js.yy(this.scale));
      return this.Ts(d, { setEventHandlers: !1 }), d;
    }), ((d, f, p) => (d.sr(p.fillStyle).ir(p.strokeStyle), f.map(((g) => {
      const y = g.existingMember || d.Qo();
      return y.yu(g.vertices), this.mx.Ki(y, g.figure), g.figure.Gb(y), y;
    })))), (() => {
      this.mx.Vi();
    }), ((d, f) => {
      this.Ps(f);
    }));
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY };
    if (this.hx.length === 0) return;
    const o = _o(s, this.hx.filter(((a) => a.getVisible())), this.Sx, ws);
    if (!o) return;
    const n = xt(o[0], this.Js.yi.ai, this.scale);
    return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...n, figure: o[1], coordinates: o[1].getDimensions(), series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Qi(t, e, i) {
    if (!i) return;
    const s = this.hx.find(((a) => a.$b === i));
    if (!s) return;
    const o = s.Xb(), n = j((o.min.x + o.max.x) / 2, (o.min.y + o.max.y) / 2);
    return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...n, coordinates: s.getDimensions(), figure: s, series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Fv(t) {
  }
  ux(t) {
    const e = this.xx.rg();
    t.forEach(((i) => {
      if (!i.getVisible()) return;
      const s = i.getDimensions(), o = i.getFillStyle(), n = i.getStrokeStyle();
      e.add({ Si: i.Si, vertices: s, figure: i }, { fillStyle: o, strokeStyle: n });
    })), e.finishPlot();
  }
  add(t) {
    const e = new _g(this, this.Js, this.scale, this.Nb, this.Eb, this.Rb, this.Ob, this.zb, this.lx, this.xi, this.Mx).setDimensions(t);
    return this.Ax(e), this.ox = !0, this.chart.yi.Rs(), e;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Og extends Za {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(e, i, s, o, n, a, l, h, u), this.wx = { x: 0, y: 0, width: 0, height: 0 }, this.kx = { x1: 0, y1: 0, x2: 0, y2: 0 }, this.gu = Ee(j(0, 0), j(0, 0)), this.Ny = t, this.Ke = ue(u.rectangleSeriesFillStyle, c), this.Js = e, this.scale = i, this.qe = ue(u.rectangleSeriesStrokeStyle, c);
  }
  setCornerRadius(t) {
    return this.Cx = t, this.Eb(), this;
  }
  getCornerRadius() {
    return this.Cx;
  }
  Qi(t, e) {
    const i = this.getDimensionsPositionAndSize(), s = j(i.x + i.width / 2, i.y + i.height / 2);
    return { cursorPosition: { resultTable: s, resultTableScale: this.scale, pointMarker: s, pointMarkerScale: { x: this.Ny.axisX, y: this.Ny.axisY } }, ...s, figure: this, positionAndSize: this.getDimensionsPositionAndSize(), ...this.getDimensionsTwoPoints(), series: this.Ny, axisX: this.Ny.axisX, axisY: this.Ny.axisY };
  }
  Xb() {
    return this.gu;
  }
  setDimensions(t) {
    return "x" in t ? (this.wx = t, this.kx = { x1: t.x, y1: t.y, x2: t.x + t.width, y2: t.y + t.height }) : (this.kx = t, this.wx = { x: t.x1, y: t.y1, width: t.x2 - t.x1, height: t.y2 - t.y1 }), this.gu = Vi([this.wx, j(this.wx.x + this.wx.width, this.wx.y + this.wx.height)]), this.Eb(), this.Js.Rs(), this;
  }
  getDimensionsPositionAndSize() {
    return this.wx;
  }
  getDimensionsTwoPoints() {
    return this.kx;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.Rb(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setStrokeStyle(t) {
    return this.qe = typeof t == "function" ? t(this.qe) : t, this.Rb(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  getDominantStyle() {
    return this.Ke;
  }
}
class s5 extends Ka {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    super(t, e, i, s, o, n, a, l, h, u), this.Vs = "Rectangle Series", this.Tx = Vo(), this.Fx = "xy", this.Sx = (f) => {
      const p = f.getDimensionsPositionAndSize(), g = j(p.x + p.width / 2, p.y + p.height / 2);
      return xt(g, this.scale, this.Js.yi.ai);
    }, this.D = new Nt(), this.chart.yi.Oa(Ot.Vo), this.Mx = c, this.Ga = d, this.vx = new Og(this, this.Js, this.scale, ie, ie, ie, ie, ie, ((f) => !1), this.xi, this.Mx).dispose(), this.Ix = new Fr((() => {
      const f = this.Tx.Ji(this.Js.Od(this.scale));
      return this.Ts(f, { setEventHandlers: !1 }), f;
    }), ((f, p, g) => (f.sr(g.fillStyle).ir(g.strokeStyle), p.map(((y) => {
      const m = y.existingMember || f.Qo();
      return m.Gd(y.x1, y.y1, y.x2, y.y2).Nd(y.roundedCorners ? { extent: y.roundedCorners, c_x1_y1: !0, c_x1_y2: !0, c_x2_y1: !0, c_x2_y2: !0 } : void 0), this.Tx.Ki(m, y.figure), y.figure.Gb(m), m;
    })))), (() => {
      this.Tx.Vi();
    }), ((f, p) => {
      this.Ps(p);
    }));
  }
  Px() {
    var t, e, i;
    let s, o;
    if (!(!((t = this.Ga) === null || t === void 0) && t.solvePlane) && this.hx.length >= 3) {
      let a;
      for (const l of this.hx) {
        const h = l.getDimensionsPositionAndSize(), u = { x: h.x + h.width / 2, y: h.y + h.height / 2 };
        if (a) {
          const c = u.x - a.x, d = c === 0 ? s : c > 0 ? "progressive" : "regressive";
          s = s === null ? null : s === void 0 ? d : d !== s ? null : s;
          const f = u.y - a.y, p = f === 0 ? o : f > 0 ? "progressive" : "regressive";
          o = o === null ? null : o === void 0 ? p : p !== o ? null : o;
        }
        a = u;
      }
    }
    const n = (i = (e = this.Ga) === null || e === void 0 ? void 0 : e.solvePlane) !== null && i !== void 0 ? i : s ? "x" : o ? "y" : "xy";
    this.Fx = n;
  }
  Cs() {
    return this.Fx === "x" ? "ProgressiveX" : this.Fx === "y" ? "ProgressiveY" : void 0;
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY };
    if (this.hx.length === 0) return;
    const o = this.Fx === "x" ? (h, u) => Math.abs(h.x - u.x) : this.Fx === "y" ? (h, u) => Math.abs(h.y - u.y) : ws, n = _o(s, this.hx.filter(((h) => h.getVisible())), this.Sx, o);
    if (!n) return;
    const a = xt(s, this.Js.yi.ai, this.scale);
    if (this.Fx === "x" && !Ii(a.x, this.getXMin(), this.getXMax()) || this.Fx === "y" && !Ii(a.y, this.getYMin(), this.getYMax())) return;
    const l = xt(n[0], this.Js.yi.ai, this.scale);
    return { cursorPosition: { resultTable: l, resultTableScale: this.scale, pointMarker: l, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...l, figure: n[1], positionAndSize: n[1].getDimensionsPositionAndSize(), ...n[1].getDimensionsTwoPoints(), series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Qi(t, e, i) {
    if (!i) return;
    const s = this.hx.find(((a) => a.$b === i));
    if (!s) return;
    const o = s.getDimensionsPositionAndSize(), n = j(o.x + o.width / 2, o.y + o.height / 2);
    return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...n, positionAndSize: s.getDimensionsPositionAndSize(), ...s.getDimensionsTwoPoints(), figure: s, series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Fv(t) {
  }
  ux(t) {
    const e = this.Ix.rg();
    t.forEach(((i) => {
      if (!i.getVisible()) return;
      const s = i.getDimensionsTwoPoints(), o = i.getFillStyle(), n = i.getStrokeStyle();
      e.add({ Si: i.Si, figure: i, roundedCorners: i.Cx, ...s }, { fillStyle: o, strokeStyle: n });
    })), e.finishPlot(), this.Px();
  }
  add(t) {
    const e = new Og(this, this.Js, this.scale, this.Nb, this.Eb, this.Rb, this.Ob, this.zb, this.lx, this.xi, this.Mx).setDimensions(t);
    return this.Ax(e), this.ox = !0, this.chart.yi.Rs(), e;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Ng extends Za {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(e, i, s, o, n, a, l, h, u), this.dimensions = { startX: 0, startY: 0, endX: 0, endY: 0 }, this.gu = Ee(j(0, 0), j(0, 0)), this.Ny = t, this.xi = u, this.Js = e, this.scale = i, this.qe = ue(u.segmentSeriesStrokeStyle, c);
  }
  Qi(t, e) {
    const i = this.getDimensions(), s = j((i.startX + i.endX) / 2, (i.startY + i.endY) / 2);
    return { cursorPosition: { resultTable: s, resultTableScale: this.scale, pointMarker: s, pointMarkerScale: { x: this.Ny.axisX, y: this.Ny.axisY } }, ...s, figure: this, ...this.getDimensions(), series: this.Ny, axisX: this.Ny.axisX, axisY: this.Ny.axisY };
  }
  Xb() {
    return this.gu;
  }
  setDimensions(t) {
    return this.dimensions = t, this.gu = Ee(j(Math.min(t.startX, t.endX), Math.min(t.startY, t.endY)), j(Math.max(t.startX, t.endX), Math.max(t.startY, t.endY))), this.Eb(), this.Js.Rs(), this;
  }
  getDimensions() {
    return this.dimensions;
  }
  setStrokeStyle(t) {
    return this.qe = typeof t == "function" ? t(this.qe) : t, this.Rb(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  getDominantStyle() {
    const t = this.qe;
    return t !== Et ? t.getFillStyle() : Lt;
  }
}
class r5 extends Ka {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(t, e, i, s, o, n, a, l, h, u), this.Vs = "Segment Series", this.Lx = Vo(), this.Sx = (d) => {
      const f = d.getDimensions(), p = j((f.startX + f.endX) / 2, (f.startY + f.endY) / 2);
      return xt(p, this.scale, this.Js.yi.ai);
    }, this.D = new Nt(), this.chart.yi.Oa(Ot.Vo), this.Mx = c, this.vx = new Ng(this, this.Js, this.scale, ie, ie, ie, ie, ie, ((d) => !1), this.xi, this.Mx).dispose(), this.bx = new Fr((() => {
      const d = this.Lx.Ji(this.Js.GA(this.scale));
      return this.Ts(d, { setEventHandlers: !1 }), d;
    }), ((d, f, p) => (d.gr(p.strokeStyle), f.map(((g) => {
      const y = g.existingMember || d.Qo();
      return y.UA(g.start, g.end), this.Lx.Ki(y, g.figure), g.figure.Gb(y), y;
    })))), (() => {
      this.Lx.Vi();
    }), ((d, f) => {
      this.Ps(f);
    }));
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY };
    if (this.hx.length === 0) return;
    const o = _o(s, this.hx.filter(((a) => a.getVisible())), this.Sx, ws);
    if (!o) return;
    const n = xt(o[0], this.Js.yi.ai, this.scale);
    return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...n, figure: o[1], ...o[1].getDimensions(), series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Qi(t, e, i) {
    if (!i) return;
    const s = this.hx.find(((a) => a.$b === i));
    if (!s) return;
    const o = s.getDimensions(), n = j((o.startX + o.endX) / 2, (o.startY + o.endY) / 2);
    return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...n, ...o, figure: s, series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Fv(t) {
  }
  ux(t) {
    const e = this.bx.rg();
    t.forEach(((i) => {
      if (!i.getVisible()) return;
      const s = i.getDimensions(), o = { x: s.startX, y: s.startY }, n = { x: s.endX, y: s.endY }, a = i.getStrokeStyle();
      e.add({ Si: i.Si, start: o, end: n, figure: i }, { strokeStyle: a });
    })), e.finishPlot();
  }
  add(t) {
    const e = new Ng(this, this.Js, this.scale, this.Nb, this.Eb, this.Rb, this.Ob, this.zb, this.lx, this.xi, this.Mx).setDimensions(t);
    return this.Ax(e), this.ox = !0, this.chart.yi.Rs(), e;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Bg = { x: 0, y: 0 };
class zg extends Za {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    var d;
    super(e, i, s, o, n, a, l, h, u), this.Tl = "Text", this.ca = Bg, this.wf = Bg, this.Dl = 0, this.dt = Me, this.Ny = t, this.Ke = u.textSeriesFillStyle ? ue(u.textSeriesFillStyle, c) : u.uiTextFillStyle, this.ho = (d = u.textSeriesFont) !== null && d !== void 0 ? d : u.uiTextFont, this.zc = this.Js.In(i, !1).en(u.textSeriesShadow), this.zc.Fl = !0, this.D.zi(this.zc, { getExtraData: (f, p, g) => this.Qi(g, f) }), this.addEventListener("dispose", (() => this.zc.dispose()));
  }
  Qi(t, e) {
    const i = this.ca;
    return { cursorPosition: { resultTable: i, resultTableScale: this.scale, pointMarker: i, pointMarkerScale: { x: this.Ny.axisX, y: this.Ny.axisY } }, ...i, figure: this, series: this.Ny, axisX: this.Ny.axisX, axisY: this.Ny.axisY };
  }
  Xb() {
    return { min: { x: this.ca.x, y: this.ca.y }, max: { x: this.ca.x, y: this.ca.y } };
  }
  Bx() {
    this.zc.rn(this.Tl).hr(this.ca).ru(this.wf).Ph(this.Dl).Tn(this.dt).sr(this.Ke).Ih(this.ho);
  }
  getSizePixels() {
    return this.Bx(), this.zc.Uh().Bc();
  }
  getBoundingBox() {
    return this.Bx(), this.zc.Uh().Ic();
  }
  setText(t) {
    return this.Tl = t, this.Eb(), this;
  }
  getText() {
    return this.Tl;
  }
  setLocation(t) {
    return this.ca = t, this.Eb(), this;
  }
  getLocation() {
    return this.ca;
  }
  setAlignment(t) {
    return this.wf = t, this.Eb(), this;
  }
  getAlignment() {
    return this.wf;
  }
  setRotation(t) {
    return this.Dl = t, this.Eb(), this;
  }
  getRotation() {
    return this.Dl;
  }
  setMargin(t) {
    return this.dt = pa(this.dt, t), this.Eb(), this;
  }
  getMargin() {
    return this.dt;
  }
  setLabelShadow(t) {
    return this.zc.en(t), this.Js.Rs(), this;
  }
  getLabelShadow() {
    return this.zc.Jl();
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.Rb(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setFont(t) {
    return this.ho = typeof t == "function" ? t(this.ho) : t, this.Rb(), this;
  }
  getFont() {
    return this.ho;
  }
  getDominantStyle() {
    return this.Ke;
  }
}
class n5 extends Ka {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(t, e, i, s, o, n, a, l, h, u), this.Vs = "Text Series", this.Sx = (d) => xt(d.getLocation(), this.scale, this.Js.yi.ai), this.D = new Nt(), this.Mx = c, this.vx = new zg(this, this.Js, this.scale, ie, ie, ie, ie, ie, ((d) => !1), this.xi, this.Mx).dispose();
  }
  Fv(t) {
  }
  ux(t) {
    t.forEach(((e) => {
      e.Bx(), e.zc.setVisible(e.getVisible());
    }));
  }
  add(t) {
    const e = new zg(this, this.Js, this.scale, this.Nb, this.Eb, this.Rb, this.Ob, this.zb, this.lx, this.xi, this.Mx);
    return t?.alignment && e.setAlignment(t.alignment), t?.fillStyle && e.setFillStyle(t.fillStyle), t?.font && e.setFont(t.font), t?.location && e.setLocation(t.location), t?.margin && e.setMargin(t.margin), t?.rotation !== void 0 && e.setRotation(t.rotation), t?.text && e.setText(t.text), this.Ax(e), this.ox = !0, this.Ts(e.zc, { setEventHandlers: !1, isText: !0 }), this.chart.yi.Rs(), this.D.zi(e.zc, { getExtraData: (i, s, o) => e.Qi(o, i) }), e;
  }
  Qi(t, e, i) {
    return Pr({ series: this, axisX: this.axisX, axisY: this.axisY }, { cursorPosition: 0, x: 0, y: 0, multiHit: 0, figure: 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY };
    if (this.hx.length === 0) return;
    const o = _o(s, this.hx.filter(((a) => a.getVisible())), this.Sx, ws);
    if (!o) return;
    const n = xt(o[0], this.Js.yi.ai, this.scale);
    return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...n, figure: o[1], series: this, axisX: this.axisX, axisY: this.axisY };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const o5 = (r, t) => {
  let e = 0;
  const i = [];
  for (; e < r; ) {
    const s = e;
    let o = t;
    const n = e > 0;
    o -= n ? 1 : 0, o -= e + o < r ? 1 : 0;
    const a = Math.min(o, r - s), l = e - (n ? 1 : 0), h = { start: l, startUnique: s, sizeData: Math.min(t, r - l), sizeUniqueData: a };
    i.push(h), e += a;
  }
  return i;
}, a5 = (r, t) => {
  let e = 0;
  const i = [];
  for (; e < r; ) {
    const s = e;
    let o = t;
    const n = e > 0;
    o -= n ? 1 : 0, o -= 0;
    const a = Math.min(o, r - s), l = e - (n ? 1 : 0), h = { start: l, startUnique: s, sizeData: Math.min(t, r - l), sizeUniqueData: a };
    i.push(h), e += a;
  }
  return i;
}, Cx = (r, t, e, i) => {
  if (e) {
    const o = /* @__PURE__ */ new Map();
    return t.gridTiles.forEach(((n) => {
      o.set(n, { type: e, dataInvalidationRanges: [{ tileInvalidationOffset: { primary: 0, secondary: 0 }, tileInvalidationLength: n.sizeHeatmapDataVectors }] });
    })), o;
  }
  const s = /* @__PURE__ */ new Map();
  for (let o = 0; o < r.length; o += 1) {
    const n = r[o], a = { x: n.startPrimary, y: n.startSecondary }, l = { x: a.x + n.lengthPrimary - 1, y: a.y + n.lengthSecondary - 1 }, h = [a, { x: l.x, y: a.y }, l, { x: a.x, y: l.y }];
    t.gridTiles.forEach(((u) => {
      const c = u.iFirstVector, d = i(u), f = { x: c.primary + d.primary - 1, y: c.secondary + d.secondary - 1 }, p = [{ x: c.primary, y: c.secondary }, { x: f.x, y: c.secondary }, f, { x: c.primary, y: f.y }];
      if (!yd(h, p)) return;
      let g = s.get(u);
      g || (g = { type: n.type, dataInvalidationRanges: [] }, s.set(u, g));
      const y = (m = h, A = p, Ee(j(Math.max(Math.min(m[0].x, m[2].x), Math.min(A[0].x, A[2].x)), Math.max(Math.min(m[0].y, m[2].y), Math.min(A[0].y, A[2].y))), j(Math.min(Math.max(m[0].x, m[2].x), Math.max(A[0].x, A[2].x)), Math.min(Math.max(m[0].y, m[2].y), Math.max(A[0].y, A[2].y)))));
      var m, A;
      const v = { primary: y.min.x - c.primary, secondary: y.min.y - c.secondary }, b = { primary: 1 + y.max.x - y.min.x, secondary: 1 + y.max.y - y.min.y };
      let w = !1;
      const k = [{ x: v.primary, y: v.secondary }, { x: v.primary + b.primary, y: v.secondary }, { x: v.primary + b.primary, y: v.secondary + b.secondary }, { x: v.primary, y: v.secondary + b.secondary }];
      for (let R = 0; R < g.dataInvalidationRanges.length; R += 1) if (!w) {
        const L = g.dataInvalidationRanges[R], x = [{ x: L.tileInvalidationOffset.primary, y: L.tileInvalidationOffset.secondary }, { x: L.tileInvalidationOffset.primary + L.tileInvalidationLength.primary, y: L.tileInvalidationOffset.secondary }, { x: L.tileInvalidationOffset.primary + L.tileInvalidationLength.primary, y: L.tileInvalidationOffset.secondary + L.tileInvalidationLength.secondary }, { x: L.tileInvalidationOffset.primary, y: L.tileInvalidationOffset.secondary + L.tileInvalidationLength.secondary }];
        if (yd(k, x)) {
          const M = pA(k, x);
          L.tileInvalidationOffset.primary = M.min.x, L.tileInvalidationOffset.secondary = M.min.y, L.tileInvalidationLength.primary = M.max.x - M.min.x, L.tileInvalidationLength.secondary = M.max.y - M.min.y, w = !0;
        }
      }
      w || g.dataInvalidationRanges.push({ tileInvalidationLength: b, tileInvalidationOffset: v });
    }));
  }
  return s;
}, wx = (r) => Xs(r) || Array.isArray(r) && typeof r[0] == "number", Cd = (r) => !wx(r) && Array.isArray(r), Tx = (r, t, e, i) => {
  if (r.length !== 1 || t.startPrimary !== 0 || t.startSecondary !== 0 || t.lengthPrimary !== r[0].sizeHeatmapDataVectors.primary || t.lengthSecondary !== r[0].sizeHeatmapDataVectors.secondary) r.forEach(((s) => {
    const o = e(s), n = Math.max(t.startPrimary, s.iFirstVector.primary), a = Math.min(t.startPrimary + t.lengthPrimary - 1, s.iFirstVector.primary + s.sizeHeatmapDataVectors.primary - 1), l = Math.max(t.startSecondary, s.iFirstVector.secondary), h = Math.min(t.startSecondary + t.lengthSecondary - 1, s.iFirstVector.secondary + s.sizeHeatmapDataVectors.secondary - 1);
    if (Cd(t.values)) for (let u = n; u <= a; u += 1) {
      const c = u - t.startPrimary, d = t.values[c], f = (u - s.iFirstVector.primary) * s.sizeHeatmapDataVectors.secondary;
      for (let p = l; p <= h; p += 1) {
        const g = p - t.startSecondary, y = p - s.iFirstVector.secondary, m = d[g];
        o[f + y] = m;
      }
    }
    else for (let u = n; u <= a; u += 1) {
      const c = u - t.startPrimary, d = (u - s.iFirstVector.primary) * s.sizeHeatmapDataVectors.secondary;
      for (let f = l; f <= h; f += 1) {
        const p = f - t.startSecondary, g = f - s.iFirstVector.secondary, y = c * t.lengthSecondary + p, m = t.values[y];
        o[d + g] = m;
      }
    }
  }));
  else {
    const s = r[0], o = e(s);
    if (Cd(t.values)) for (let n = 0; n < t.lengthPrimary; n += 1) {
      const a = n * s.sizeHeatmapDataVectors.secondary;
      o.set(t.values[n], a);
    }
    else i(s, ou(t.values) === Float32Array ? t.values : new Float32Array(t.values));
  }
}, kx = (r, t, e) => {
  var i, s;
  const o = (i = r.gl2) === null || i === void 0 ? void 0 : i.ctx;
  if (o) return r.Dx(null, o.RED, !1, !0, { x: t, y: e }, !1, o.FLOAT, o.R32F);
  const n = r.gl;
  return !((s = r.gl1) === null || s === void 0) && s.optional.OES_texture_float ? r.Dx(null, n.LUMINANCE, !1, !0, { x: t, y: e }, !1, n.FLOAT) : r.Dx(null, n.RGBA, !1, !0, { x: t, y: e }, !1, n.UNSIGNED_BYTE);
}, Dx = (r, t, e, i) => {
  t.forEach(((s, o) => {
    var n, a;
    const l = e(o), h = i(o), u = r.gl;
    u.bindTexture(u.TEXTURE_2D, h), u.pixelStorei(u.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1);
    const c = (n = r.gl2) === null || n === void 0 ? void 0 : n.ctx, d = s.dataInvalidationRanges.length, f = s.dataInvalidationRanges.reduce(((p, g) => p + g.tileInvalidationLength.primary), 0) / o.sizeHeatmapDataVectors.primary;
    d === 1 && f < 1 || f < 0.5 && d < 10 ? s.dataInvalidationRanges.forEach(((p) => {
      var g;
      const y = p.tileInvalidationOffset.primary * o.sizeHeatmapDataVectors.secondary, m = y + p.tileInvalidationLength.primary * o.sizeHeatmapDataVectors.secondary;
      if (c) c.texSubImage2D(u.TEXTURE_2D, 0, 0, p.tileInvalidationOffset.primary, o.sizeHeatmapDataVectors.secondary, p.tileInvalidationLength.primary, c.RED, c.FLOAT, l.subarray(y, m));
      else if (!((g = r.gl1) === null || g === void 0) && g.optional.OES_texture_float) u.texSubImage2D(u.TEXTURE_2D, 0, 0, p.tileInvalidationOffset.primary, o.sizeHeatmapDataVectors.secondary, p.tileInvalidationLength.primary, u.LUMINANCE, u.FLOAT, l.subarray(y, m));
      else {
        const A = new Uint8Array(l.buffer).subarray(4 * y, 4 * m);
        u.texSubImage2D(u.TEXTURE_2D, 0, 0, p.tileInvalidationOffset.primary, o.sizeHeatmapDataVectors.secondary, p.tileInvalidationLength.primary, u.RGBA, u.UNSIGNED_BYTE, A);
      }
    })) : c ? c.texImage2D(u.TEXTURE_2D, 0, c.R32F, o.sizeHeatmapDataVectors.secondary, o.sizeHeatmapDataVectors.primary, 0, c.RED, c.FLOAT, l) : !((a = r.gl1) === null || a === void 0) && a.optional.OES_texture_float ? u.texImage2D(u.TEXTURE_2D, 0, u.LUMINANCE, o.sizeHeatmapDataVectors.secondary, o.sizeHeatmapDataVectors.primary, 0, u.LUMINANCE, u.FLOAT, l) : u.texImage2D(u.TEXTURE_2D, 0, u.RGBA, o.sizeHeatmapDataVectors.secondary, o.sizeHeatmapDataVectors.primary, 0, u.RGBA, u.UNSIGNED_BYTE, new Uint8Array(l.buffer)), u.bindTexture(u.TEXTURE_2D, null);
  }));
};
class Fx extends No {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    super(t, e, i, s, o, n, a, l, u, c), this.Vs = "Heatmap Grid Series", this.Ex = !0, this.wp = {}, this.chart.yi.Oa(Ot.zo), this.Rx = h, this.xi = u;
    const f = d;
    this.Ke = ue(u.heatmapGridSeriesFillStyle, f), this.kp = ue(this.xi.heatmapGridSeriesWireframeStyle, f);
    const p = { heatmapDataType: "intensity", dataOrder: h.dataOrder || "columns", columns: h.columns, rows: h.rows, Ox: h.maxTileSize };
    this.Ga = p, this.zx = this.Js.Vx(this.scale, [], p).sr(this.Ke).Cp(this.kp).Ii(this.getHighlight()), this.Ts(this.zx), this.Ex = !0, this.setHighlightOnHover(!1);
  }
  solveNearest(t, e = "show-nearest") {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY }, o = xt(s, this.Js.yi.ai, this.scale), n = qa(e) ? this.zx.Nx(o) : this.zx.Rd(o);
    if (n) return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, x: n.x, y: n.y, column: n.column, row: n.row, intensity: n.cellValue, series: this, axisX: this.axisX, axisY: this.axisY, lut: Ve(this.Ke) ? this.Ke.lut : void 0 };
  }
  Qi(t, e, i) {
    return Pr({ series: this, axisX: this.axisX, axisY: this.axisY }, { cursorPosition: 0, x: 0, y: 0, multiHit: 0, intensity: 0, column: 0, row: 0, lut: Ve(this.Ke) ? this.Ke.lut : void 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  Fp() {
    const t = this.wp.start || { x: 0, y: 0 };
    let e;
    e = this.wp.end ? { x: (this.wp.end.x - t.x) / this.Ga.columns, y: (this.wp.end.y - t.y) / this.Ga.rows } : this.wp.step ? this.wp.step : { x: 1, y: 1 }, this.zx.Ip(t, e), this.chart.yi.Rs();
  }
  setStart(t) {
    return this.wp.start = t, this.Fp(), this;
  }
  getStart() {
    return this.zx.Pp().start;
  }
  setStep(t) {
    return this.wp.step = t, this.Fp(), this;
  }
  getStep() {
    return this.zx.Pp().step;
  }
  setEnd(t) {
    return this.wp.end = t, this.Fp(), this;
  }
  getEnd() {
    return this.zx.Pp().end;
  }
  setContours(t) {
    var e, i, s;
    return this.zx.Lp(t ? { showLabels: (e = t.showLabels) === null || e === void 0 || e, levels: t.levels.map(((o) => {
      var n, a, l, h, u, c;
      return { value: o.value, strokeStyle: (a = (n = o.strokeStyle) !== null && n !== void 0 ? n : this.xi.heatmapGridSeriesContourStrokeStyle) !== null && a !== void 0 ? a : new $t({ thickness: 1, fillStyle: new ot({ color: N(0, 0, 0) }) }), labelFillStyle: new ot({ color: (l = o.labelColor) !== null && l !== void 0 ? l : this.xi.heatmapGridSeriesContourLabelColor }), labelFont: (u = o.labelFont, c = (h = this.xi.heatmapGridSeriesContourLabelFont) !== null && h !== void 0 ? h : this.xi.uiTextFont, u === void 0 ? c : sa(u) ? u : new qn({ size: c.size, family: c.family, variant: c.variant, type: c.type, style: c.style, weight: c.weight, ...u })), label: o.label };
    })), shadows: (s = (i = t.shadows) !== null && i !== void 0 ? i : this.xi.heatmapGridSeriesContourLabelShadow) !== null && s !== void 0 ? s : null } : void 0), this.Js.Rs(), this;
  }
  getContours() {
    return this.zx.Bp();
  }
  Uv() {
    return this.kv && this.getVisible();
  }
  Ws() {
    return is(this.Ke, this.zx.wi());
  }
  nr() {
    return { fill: this.Ke };
  }
  Gx(t) {
    this.zx.Gx().forEach(((e) => {
      t.zx.Op(e);
    }));
  }
  qb() {
    const t = this.zx;
    return t ? t.Wi() : void 0;
  }
  tx() {
    const t = this.zx;
    return t ? t.Hi() : void 0;
  }
  ix() {
    const t = this.zx;
    return t ? t.Zi() : void 0;
  }
  sx() {
    const t = this.zx;
    return t ? t.Xi() : void 0;
  }
  Sn() {
    const t = j(0, 0);
    return t.x = Math.max(t.x, this.zx.mu()), t.y = Math.max(t.y, this.zx.Su()), t;
  }
  Fv(t) {
    if (!(t instanceof we)) throw new Error("HeatmapGridSeries can only be attached to a pair of Linear Axes.");
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  rr() {
    return super.rr(), this.zx.Ti(this.getBoundaries()), this;
  }
}
class l5 extends Fx {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    super(t, e, i, s, o, n, a, l, h, u, c, d), this.zv = !1, this.D = new Nt();
  }
  Gv() {
    return this.zv;
  }
  invalidateIntensityValues(t) {
    if (this.zv && this.chart.yi.Oa(Ot.Go), Xs(t) || Array.isArray(t) && typeof t[0] == "number") {
      const e = this.Ga.columns * this.Ga.rows, i = t.length;
      if (e !== i) throw new Error(`LightningChart JS input error | Heatmap invalidateIntensityValues received typed array whose length does not match heatmap columns x rows (received ${i}, expected ${e})`);
      this.zx.Op({ type: "intensity", lengthPrimary: this.Ga.dataOrder === "columns" ? this.Ga.columns : this.Ga.rows, lengthSecondary: this.Ga.dataOrder === "columns" ? this.Ga.rows : this.Ga.columns, startPrimary: 0, startSecondary: 0, values: t });
    } else if (Array.isArray(t)) {
      let e = t;
      if (t.length === 0) return this;
      const i = { x: e.length, y: e[0].length, columns: this.Ga.dataOrder === "columns" ? e.length : e[0].length, rows: this.Ga.dataOrder === "rows" ? e.length : e[0].length }, s = this.Ga.dataOrder === "columns" ? this.Ga.columns : this.Ga.rows, o = this.Ga.dataOrder === "columns" ? this.Ga.rows : this.Ga.columns;
      if (i.x > s || i.y > o) {
        if (this.chart.Qg.$a === !0) {
          const a = `HeatmapGridSeries.invalidateIntensityValues intensity matrix overflow.
Grid ${this.Ga.columns}x${this.Ga.rows}, input ${i.columns}x${i.rows}.
Excess data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(a);
        }
        const n = [];
        for (let a = 0; a < s; a += 1) n[a] = e[a].slice(0, o);
        e = n;
      }
      this.zx.Op({ type: "intensity", lengthPrimary: i.x, lengthSecondary: i.y, startPrimary: 0, startSecondary: 0, values: e });
    } else if ("iColumn" in t && "iRow" in t && "values" in t && Cd(t.values)) {
      const e = t.values;
      if (t.values.length === 0) return this;
      const i = { primary: e.length, secondary: e[0].length, columns: this.Ga.dataOrder === "columns" ? e.length : e[0].length, rows: this.Ga.dataOrder === "rows" ? e.length : e[0].length }, s = this.Ga.dataOrder === "columns" ? t.iColumn : t.iRow, o = s + i.primary - 1, n = this.Ga.dataOrder === "columns" ? t.iRow : t.iColumn, a = n + i.secondary - 1, l = (this.Ga.dataOrder === "columns" ? this.Ga.columns : this.Ga.rows) - 1, h = (this.Ga.dataOrder === "columns" ? this.Ga.rows : this.Ga.columns) - 1;
      if (s < 0 || n < 0) {
        if (this.chart.Qg.$a === !0) {
          const u = `HeatmapGridSeries.invalidateIntensityValues invalidation start below 0 not permitted.
iColumn: ${t.iColumn}, iRow: ${t.iRow}.
No intensity values will be invalidated.`;
          H.console.warn(u);
        }
        return this;
      }
      if (o > l || a > h) {
        if (this.chart.Qg.$a === !0) {
          const p = `HeatmapGridSeries.invalidateIntensityValues intensity matrix overflow.
Grid ${this.Ga.columns}x${this.Ga.rows}, input ${i.columns}x${i.rows} starting at [${t.iColumn},${t.iRow}].
Out of bounds data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(p);
        }
        const u = Math.max(o - l, 0), c = i.primary - u, d = Math.max(a - h, 0), f = [];
        for (let p = 0; p < c; p += 1) f[p] = e[p].slice(0, d > 0 ? -d : void 0);
        t = { iColumn: t.iColumn, iRow: t.iRow, values: f };
      }
      this.zx.Op({ type: "intensity", lengthPrimary: e.length, lengthSecondary: e[0].length, startPrimary: s, startSecondary: n, values: e });
    } else if ("iColumn" in t && "iRow" in t && "columns" in t && "rows" in t && "values" in t && wx(t.values)) {
      const e = t.values;
      if (t.values.length === 0) return this;
      const i = { primary: this.Ga.dataOrder === "columns" ? t.columns : t.rows, secondary: this.Ga.dataOrder === "columns" ? t.rows : t.columns, columns: t.columns, rows: t.rows }, s = this.Ga.dataOrder === "columns" ? t.iColumn : t.iRow, o = s + i.primary - 1, n = this.Ga.dataOrder === "columns" ? t.iRow : t.iColumn, a = n + i.secondary - 1, l = (this.Ga.dataOrder === "columns" ? this.Ga.columns : this.Ga.rows) - 1, h = (this.Ga.dataOrder === "columns" ? this.Ga.rows : this.Ga.columns) - 1;
      if (s < 0 || n < 0) {
        if (this.chart.Qg.$a === !0) {
          const c = `HeatmapGridSeries.invalidateIntensityValues invalidation start below 0 not permitted.
iColumn: ${t.iColumn}, iRow: ${t.iRow}.
No intensity values will be invalidated.`;
          H.console.warn(c);
        }
        return this;
      }
      if (o > l || a > h) {
        if (this.chart.Qg.$a === !0) {
          const c = `HeatmapGridSeries.invalidateIntensityValues intensity matrix overflow.
Grid ${this.Ga.columns}x${this.Ga.rows}, input ${i.columns}x${i.rows} starting at [${t.iColumn},${t.iRow}].
With flat array input, this operation is not permitted. No intensity values will be invalidated.`;
          H.console.warn(c);
        }
        return this;
      }
      const u = i.columns * i.rows;
      if (e.length !== u) {
        if (this.chart.Qg.$a === !0) {
          const c = `HeatmapGridSeries.invalidateIntensityValues invalid flat data input.
columns=${t.columns} rows=${t.rows}, array length must be ${u}, received ${e.length}
No intensity values will be invalidated.`;
          H.console.warn(c);
        }
        return this;
      }
      this.zx.Op({ type: "intensity", lengthPrimary: i.primary, lengthSecondary: i.secondary, startPrimary: s, startSecondary: n, values: e });
    }
    return this.D.R("invalidateintensity", { value: t }), this.Js.Rs(), this.zv = !0, this;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.zx.sr(this.Ke), this.D.R("stylechange", {}), this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setIntensityInterpolation(t) {
    return t = t || "disabled", this.zx.Ep(t), this.Js.Rs(), this.D.R("stylechange", {}), this;
  }
  getIntensityInterpolation() {
    return this.zx.Rp();
  }
  setAggregation(t) {
    return this.zx.$x(t), this.Js.Rs(), this;
  }
  getAggregation() {
    return this.zx.Ux();
  }
  clear() {
    return this.zx.Vi(), this.Js.Rs(), this.D.R("dataclear", {}), this;
  }
  setWireframeStyle(t) {
    return this.kp = typeof t == "function" ? t(this.kp) : t, this.zx.Cp(this.kp), this.Js.Rs(), this.D.R("stylechange", {}), this;
  }
  getWireframeStyle() {
    return this.kp;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class h5 extends No {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    super(t, e, i, s, o, n, a, l, u, c), this.Vs = "Scrolling Heatmap Grid Series", this.wp = {}, this.chart.yi.Oa(Ot.zo), this.chart.yi.Oa(Ot.Go);
    const f = d;
    this.Ke = ue(u.heatmapScrollingGridSeriesFillStyle, f), this.kp = ue(this.xi.heatmapScrollingGridSeriesWireframeStyle, f);
    const p = { scrollDimension: "columns", heatmapDataType: "intensity", ...h };
    this.Ga = p, this.jx = this.Js.Yx(this.scale, [], p).sr(this.Ke).Cp(this.kp).Ii(this.getHighlight()), this.Ts(this.jx), this.setHighlightOnHover(!1);
  }
  Gv() {
    return this.jx.jp() > 0;
  }
  solveNearest(t, e = "show-nearest") {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY }, o = xt(s, this.Js.yi.ai, this.scale), n = qa(e) ? this.jx.Nx(o) : this.jx.Rd(o);
    if (n) return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, x: n.x, y: n.y, column: n.column, row: n.row, intensity: n.cellValue, series: this, axisX: this.axisX, axisY: this.axisY, lut: Ve(this.Ke) ? this.Ke.lut : void 0 };
  }
  Qi(t, e, i) {
    return Pr({ series: this, axisX: this.axisX, axisY: this.axisY }, { cursorPosition: 0, x: 0, y: 0, intensity: 0, multiHit: 0, column: 0, row: 0, lut: Ve(this.Ke) ? this.Ke.lut : void 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  Fp() {
    const t = this.wp.start || { x: 0, y: 0 };
    let e;
    e = this.wp.step ? this.wp.step : { x: 1, y: 1 }, this.jx.Ip(t, e), this.chart.yi.Rs();
  }
  setStart(t) {
    return this.wp.start = t, this.Fp(), this;
  }
  getStart() {
    return this.jx.Pp().start;
  }
  setStep(t) {
    return this.wp.step = t, this.Fp(), this;
  }
  getStep() {
    return this.jx.Pp().step;
  }
  clear() {
    return this.jx.Vi(), this.Js.Rs(), this;
  }
  setAggregation(t) {
    return this.jx.$x(t), this.Js.Rs(), this;
  }
  getAggregation() {
    return this.jx.Ux();
  }
  setWireframeStyle(t) {
    return this.kp = typeof t == "function" ? t(this.kp) : t, this.jx.Cp(this.kp), this.Js.Rs(), this;
  }
  getWireframeStyle() {
    return this.kp;
  }
  setIntensityInterpolation(t) {
    return t = t || "disabled", this.jx.Ep(t), this.Js.Rs(), this;
  }
  getIntensityInterpolation() {
    return this.jx.Rp();
  }
  setPixelInterpolationMode(t) {
    return this.setIntensityInterpolation(t), this;
  }
  getPixelInterpolationMode() {
    return this.getIntensityInterpolation();
  }
  setDataCleaning(t) {
    return this.jx.Hx(t), this.Js.Rs(), this;
  }
  Uv() {
    return this.kv && this.getVisible();
  }
  Ws() {
    return is(this.Ke, this.jx.wi());
  }
  nr() {
    return { fill: this.Ke };
  }
  sr(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.jx.sr(this.Ke), this.Js.Rs(), this;
  }
  Fv(t) {
    if (!(t instanceof we)) throw new Error("HeatmapScrollingGridSeries can only be attached to a pair of Linear Axes.");
  }
  qb() {
    return this.jx.Wi() || 0;
  }
  tx() {
    return this.jx.Hi() || 0;
  }
  ix() {
    return this.jx.Zi() || 0;
  }
  sx() {
    return this.jx.Xi() || 0;
  }
  Sn() {
    const t = j(0, 0);
    return t.x = Math.max(t.x, this.jx.mu()), t.y = Math.max(t.y, this.jx.Su()), t;
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
}
class u5 extends h5 {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    super(t, e, i, s, o, n, a, l, h, u, c, d), this.D = new Nt();
  }
  addIntensityValues(t) {
    if (t.length === 0 || t[0].length === 0) return this;
    const e = t.length, i = t[0].length, s = (this.Ga.scrollDimension === "columns" ? t.length : t[0].length, this.Ga.scrollDimension === "rows" ? t.length : t[0].length, 0 + i - 1), o = this.Ga.resolution - 1;
    if (s > o) {
      if (this.chart.Qg.$a === !0) {
        const a = `HeatmapScrollingGridSeries.addIntensityValues intensity matrix overflow.
Grid resolution: ${this.Ga.resolution}, input ${e}x${i}.
Excess data will be automatically clipped. This can result in sub-optimal performance.`;
        H.console.warn(a);
      }
      const n = [];
      for (let a = 0; a < e; a += 1) n[a] = t[a].slice(0, o + 1);
      t = n;
    }
    return this.jx.$p(t), this.Js.Rs(), this;
  }
  invalidateIntensityValues(t) {
    return this.jx.Op(t.iSample, t.values), this.Js.Rs(), this;
  }
  getSampleCount() {
    return this.jx.jp();
  }
  setFillStyle(t) {
    return this.sr(t), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class c5 extends No {
  constructor() {
    super(...arguments), this.Wx = [], this.wc = [], this.Xx = [], this.Zx = [], this.Jx = 1e3, this.Qx = 0, this.gs = Qi.onHover, this.Kx = [], this.qx = [], this.tM = !1, this.iM = (t, e) => {
      const i = t.Db(e);
      if (i) return [xt(i[0], this.scale, this.Js.yi.ai), xt(i[1], this.scale, this.Js.yi.ai)];
    }, this.sM = (t, e) => {
      const i = t.eM(e);
      if (i) return [xt(i[0], this.scale, this.Js.yi.ai), xt(i[1], this.scale, this.Js.yi.ai)];
    }, this.rM = (t) => {
      const e = t.length;
      if (this.Wx.length > 0) {
        const i = this.Wx.length - 1, s = this.Wx[i];
        if (e > 0) {
          const [o, n] = s.Lu(), [a, l] = s.Bu();
          if ((a ? o.length + a.length : o.length) >= this.Jx) {
            const h = a && a.length > 0 ? a[a.length - 1] : o[o.length - 1], u = l && l.length > 0 ? l[l.length - 1] : n[o.length - 1], c = (h.x + t[0].position) / 2, d = Rh(c, h, j(t[0].position, t[0].high)).y, f = Rh(c, u, j(t[0].position, t[0].low)).y, p = Am(c, d, f);
            s.Pu(p, Ee(j(c, f), j(c, d))).Nu(!0), this.hM([p].concat(t)).zu(!0);
          } else s.Pu(t);
        }
      } else e > 0 && this.hM(t);
    }, this.nM = (t) => {
      const e = this.Kx, i = t.length;
      if (this.Kx.length > 0) {
        if (i > 0) {
          const s = e[e.length - 1], o = s.Lu(), n = s.Bu();
          if (o.length + n.length >= this.Jx) {
            const a = n.length > 0 ? n[n.length - 1] : o[o.length - 1], l = (a.x + t[0].x) / 2, h = Rh(l, a, j(t[0].x, t[0].y)).y, u = j(l, h);
            s.Pu(u, Ee(j(l, h), j(l, h))).Nu(!0), e.push(this.oM([u].concat(t), this.aM).zu(!0));
          } else s.Pu(t);
        }
      } else i > 0 && e.push(this.oM(t));
    }, this.lM = (t) => {
      const e = this.qx, i = t.length;
      if (this.qx.length > 0) {
        if (i > 0) {
          const s = e[e.length - 1], o = s.Lu(), n = s.Bu();
          if (o.length + n.length >= this.Jx) {
            const a = n.length > 0 ? n[n.length - 1] : o[o.length - 1], l = (a.x + t[0].x) / 2, h = Rh(l, a, j(t[0].x, t[0].y)).y, u = j(l, h);
            s.Pu(u, Ee(j(l, h), j(l, h))).Nu(!0), e.push(this.uM([u].concat(t)).zu(!0));
          } else s.Pu(t);
        }
      } else i > 0 && e.push(this.uM(t));
    };
  }
  Cs() {
    return "ProgressiveX";
  }
  Gv() {
    return this.getPointAmount() > 0;
  }
  setDataCleaning(t) {
    const e = t && t.minDataPointCount;
    return this.Qx = e !== void 0 && e > 0 ? e : 0, this.Js.Rs(), this;
  }
  clear() {
    for (let t = 0; t < this.Wx.length; t += 1) this.Wx[t].dispose();
    for (let t = 0; t < this.Kx.length; t += 1) this.Kx[t].dispose();
    for (let t = 0; t < this.qx.length; t += 1) this.qx[t].dispose();
    return this.wc.length = 0, this.Xx.length = 0, this.Zx.length = 0, this.aM = void 0, this.Wx.length = 0, this.Kx.length = 0, this.qx.length = 0, this.Js.Rs(), this.D.R("dataclear", {}), this;
  }
  getPointAmount() {
    return this.Wx.reduce(((t, e) => t + e.Ru() + e.Ou()), this.wc.length);
  }
  qb() {
    return Ph(this.Wx, qS, Math.max, eA, this.aM) || 0;
  }
  tx() {
    return Ph(this.Wx, KS, Math.min, tA, this.aM) || 0;
  }
  ix() {
    return Ph(this.Wx, QS, Math.max, sA, this.aM) || 0;
  }
  sx() {
    return Ph(this.Wx, JS, Math.min, iA, this.aM) || 0;
  }
  Sn() {
    const t = j(0, 0);
    for (const e of this.Wx) t.x = Math.max(t.x, e.mu()), t.y = Math.max(t.y, e.Su());
    return t;
  }
  Ws() {
    return is(this.cM, void 0) || is(this.dM, void 0);
  }
  Uv() {
    return this.kv && this.getPointAmount() > 0 && this.getVisible();
  }
  Fv(t) {
  }
  fM(t, e, i) {
    this.wc = us(this.wc, t, { canReturnB: !1 }), this.Xx = us(this.Xx, e, { canReturnB: !1 }), this.Zx = us(this.Zx, i, { canReturnB: !1 }), this.Js.Rs();
  }
  AM(t, e, i, s) {
    this.gM(e, i, s), this.fM(Array.isArray(t) ? t : [t], e, i);
  }
  gM(t, e, i) {
    const s = Qs(Vi(t), Vi(e));
    this.aM ? this.aM = Qs(this.aM, s) : this.aM = s, i && (this.aM = Qs(this.aM, i));
  }
  vM() {
    const t = this.Wx.length, e = Math.min(this.scale.x.getInnerStart(), this.scale.x.getInnerEnd());
    let i = 0;
    if (t > 1) for (let s = 0; s < t - 1; s += 1) this.scale.x.Qt(this.Wx[s].Wi(), this.Wx[s].mu()) < e && (i += 1);
    return i;
  }
  yM(t, e, i, s) {
    if (i > 0) {
      const o = Math.ceil(i / e), n = t.length - o;
      if (n > 0 && s > 0) {
        const a = n - s > 0 ? s : n;
        if (a > 0) {
          for (let l = 0; l < a; l += 1) t[l].dispose();
          t.splice(0, a);
        }
      }
    }
  }
  pM(t) {
    const e = this.Wx.length > 0 ? this.Wx[this.Wx.length - 1] : void 0, i = e ? e.Lu()[0].length + (e.Bu()[0] ? e.Bu()[0].length : 0) : void 0;
    Wh(t, i, this.Jx, this.rM);
  }
  mM(t) {
    const e = this.Kx.length > 0 ? this.Kx[this.Kx.length - 1].Lu().length + this.Kx[this.Kx.length - 1].Bu().length : void 0;
    Wh(t, e, this.Jx, this.nM);
  }
  SM(t, e) {
    const i = this.Kx.length > 0 ? this.Kx[this.Kx.length - 1].Lu().length + this.Kx[this.Kx.length - 1].Bu().length : void 0;
    Wh(t, i, this.Jx, this.nM), Wh(e, i, this.Jx, this.lM);
  }
  hM(t, e) {
    const i = this.Js.bM(this.scale).Pu(t, e).sr(this.cM).Du(this.dM).Ii(this.getHighlight());
    return this.Wx.push(i), this.Ts(i), i;
  }
  xM(t, e, i) {
    const s = this.Js.Ay(this.scale, void 0, [Ir.UserSeries]).Pu(t, i).setPointerEvents(!1).gr(e).Ii(this.getHighlight());
    return this.Ts(s), s;
  }
  oM(t, e) {
    return this.xM(t, this.MM, e);
  }
  uM(t, e) {
    return this.xM(t, this._M, e);
  }
  wM(t) {
    this.cM = typeof t == "function" ? t(this.cM) : t;
    const e = this.cM;
    for (let i = 0; i < this.Wx.length; i += 1) this.Wx[i].sr(e);
    this.Js.Rs();
  }
  kM(t) {
    this.dM = typeof t == "function" ? t(this.dM) : t;
    const e = this.dM;
    for (let i = 0; i < this.Wx.length; i += 1) this.Wx[i].Du(e);
    this.Js.Rs();
  }
  CM() {
    return this.cM;
  }
  Eu() {
    return this.dM;
  }
  TM(t) {
    this.MM = typeof t == "function" ? t(this.MM) : t;
    const e = this.MM;
    for (let i = 0; i < this.Kx.length; i += 1) this.Kx[i].gr(e);
    this.Js.Rs();
  }
  FM(t) {
    this._M = typeof t == "function" ? t(this._M) : t;
    const e = this._M;
    for (let i = 0; i < this.qx.length; i += 1) this.qx[i].gr(e);
    this.Js.Rs();
  }
  IM() {
    return this.MM;
  }
  PM() {
    return this._M;
  }
  ar(t, e) {
    t.Ii(e), this.LM(e), this.Js.Rs();
  }
  LM(t) {
    for (let e = 0; e < this.Kx.length; e += 1) this.Kx[e].Ii(t);
    for (let e = 0; e < this.qx.length; e += 1) this.qx[e].Ii(t);
  }
  Dv() {
    if (super.Dv(), this.tM = !1, this.Qx > 0) {
      const t = this.vM();
      this.yM(this.Wx, this.Jx, this.Qx, t), this.Kx.length > 0 && this.yM(this.Kx, this.Jx, this.Qx, t), this.qx.length > 0 && this.yM(this.qx, this.Jx, this.Qx, t), this.tM = !0;
    }
  }
  rr() {
    if (super.rr(), this.wc.length > 0 && (this.pM(this.wc), this.BM(this.Xx, this.Zx), this.tM = !0), this.tM) {
      const t = this.getBoundaries();
      for (const e of this.Wx) e.Ti(t);
      for (const e of this.Kx) e.Ti(t);
      for (const e of this.qx) e.Ti(t);
    }
  }
  Ev() {
    super.Ev(), this.aM = void 0, this.wc.length = 0, this.Xx.length = 0, this.Zx.length = 0;
  }
}
class Lx extends c5 {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(t, e, i, s, o, n, a, l, h, u), this.D = new Nt(), this.chart.yi.Oa(Ot.Oo);
    const d = c;
    this.cM = ue(this.xi.areaRangeSeriesFillStyle, d), this.MM = ue(this.xi.areaRangeSeriesStrokeStyle, d), this.dM = ue(this.xi.areaRangeSeriesFillStyleInverted, d), this._M = ue(this.xi.areaRangeSeriesStrokeStyleInverted, d);
  }
  solveNearest(t, e = this.chart.getCursorMode() || "show-nearest") {
    const i = this.chart.yi.ul(t), s = ((o, n, a) => {
      let l, h, u = Number.MAX_VALUE;
      for (let c = 0; c < n.length; c += 1) {
        const d = n[c], f = a(d, o);
        if (f) {
          const p = ws(o, f[0]), g = ws(o, f[1]);
          (l === void 0 || p < u || g < u) && (l = f, h = d, p < u ? u = p : g < u && (u = g));
        }
      }
      return l && h ? [l, h] : void 0;
    })({ x: i.engineX, y: i.engineY }, this.Wx, qa(e) ? this.sM : this.iM);
    if (s !== void 0 && s[0] !== void 0) {
      const o = xt(s[0][0], this.Js.yi.ai, this.scale), n = xt(s[0][1], this.Js.yi.ai, this.scale);
      return { cursorPosition: { resultTable: o, resultTableScale: this.scale, pointMarker: o, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...o, series: this, axisX: this.axisX, axisY: this.axisY, multiHit: [o, n] };
    }
  }
  add(t) {
    const e = Array.isArray(t) ? t : [t], [i, s] = bm(e);
    this.AM(t, i, s);
    const o = this.wc[this.wc.length - 1];
    return this.DM = o ? { position: o.position, high: o.high, low: o.low } : void 0, this.D.R("dataadd", { data: e, boundaries: this.aM }), this;
  }
  addArraysHighLow(t, e, i = 1, s = 0) {
    if (t.length !== e.length) throw new Error("arrayHigh and arrayLow lengths are not equal");
    {
      let o = s;
      o || (o = this.DM ? this.DM.position + i : 0), this.add(((n, a, l = 1, h) => {
        const u = h !== void 0 ? h : 0, c = new Array(n.length);
        for (let d = 0; d < n.length; d += 1) c[d] = { position: u + l * d, high: n[d], low: a[d] };
        return c;
      })(t, e, i, o));
    }
    return this;
  }
  BM(t, e) {
    this.SM(t, e);
  }
  setHighFillStyle(t) {
    return this.wM(t), this;
  }
  setLowFillStyle(t) {
    return this.kM(t), this;
  }
  setHighStrokeStyle(t) {
    return this.TM(t), this;
  }
  setLowStrokeStyle(t) {
    return this.FM(t), this;
  }
  getHighFillStyle() {
    return this.CM();
  }
  getLowFillStyle() {
    return this.Eu();
  }
  getHighStrokeStyle() {
    return this.IM();
  }
  getLowStrokeStyle() {
    return this.PM();
  }
  EM() {
    return ((t, e = (i) => i) => {
      const i = [];
      let s;
      for (let o = 0; o < t.length; o += 1) {
        s = t[o];
        const n = e(s.Lu()), a = s.Bu(), l = a ? e(a) : [];
        let h = !1, u = !1;
        "Vu" in s && (h = s.Vu(), u = s.Gu()), i.push.apply(i, n.slice(h ? 1 : 0, n.length - (u && l.length === 0 ? 1 : 0))), i.push.apply(i, l.slice(h && n.length === 0 ? 1 : 0, l.length - (u ? 1 : 0)));
      }
      return i;
    })(this.Wx, ((t) => {
      const e = t[0], i = t[1];
      if (!e || !i) return [];
      const s = [], o = e.length;
      for (let n = 0; n < o; n += 1) s[n] = { position: e[n].x, high: e[n].y, low: i[n].y };
      return s;
    }));
  }
  nr() {
    return { fill: this.cM, fill2: this.dM, behavior: { colorStep: !0 } };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Px extends No {
  constructor(t, e, i, s, o, n, a, l, h, u) {
    super(t, e, i, s, o, n, a, l, h, u), this.RM = (c) => c[4] >= c[1], this.nx = Ee(Kn(wt, wt), Kn(Pt, Pt)), this.OM = [], this.zM = !1, this.VM = -1, this.NM = [], this.GM = !0, this.$M = !1, this.UM = 4, this.jM = [1e-7, 1e-6, 1e-5, 1e-4, 1e-3, 0.01, 0.1, 1, 5, 10, 30, 60, 300, 600, 1800, 3600, 7200, 14400, 28800, 36e3, 43200, 50400, 57600, 64800, 72e3, 86400, 172800, 259200, 345600, 432e3, 604800, 1209600, 2592e3, 7776e3, 10368e3, 15552e3, 31536e3, 15768e4, 31536e4, 63072e4, 7884e5, 15768e5, 31536e5, 3942e6, 47304e5, 63072e5, 7884e6, 15768e6, 31536e6, 3942e7, 47304e6, 63072e6, 7884e7, 15768e7, 31536e7, 63072e7, 7884e8, 15768e8, 31536e8, 47304e8, 63072e8], this.D = new Nt(), this.chart.yi.Oa(Ot.Co);
  }
  Gv() {
    return this.NM.length > 0;
  }
  Cs() {
    return "ProgressiveX";
  }
  EM() {
    return this.NM;
  }
  Uv() {
    return this.kv && this.NM.length > 0 && this.getVisible();
  }
  YM(t) {
    if (!(this.NM.length < 1)) return [this.NM[t][0], this.NM[t][1], this.NM[t][2], this.NM[t][3], this.NM[t][4]];
  }
  solveNearest(t, e) {
    if (this.NM.length === 0) return;
    const i = this.chart.translateCoordinate(t, { x: this.axisX, y: this.axisY }).x, s = this.getPackDataState() !== void 0;
    let o, n, a, l, h;
    if (s) {
      const u = this.HM;
      if (!u) return;
      const c = Mc(i, u.length - 1, ((f) => u[f][0])), d = c !== void 0 && u[c];
      if (!d) return;
      l = d[3], a = d[2], n = d[1], h = d[4], o = d[0];
    } else {
      const u = Mc(i, this.NM.length - 1, ((d) => this.NM[d][0])), c = u !== void 0 && this.NM[u];
      if (!c) return;
      o = c[0], n = c[1], a = c[2], l = c[3], h = c[4];
    }
    return { cursorPosition: { resultTable: j(o, h), resultTableScale: this.scale, pointMarker: j(o, h), pointMarkerScale: { x: this.axisX, y: this.axisY } }, x: o, y: h, open: n, high: a, low: l, close: h, position: o, isPacked: s, series: this, axisX: this.axisX, axisY: this.axisY };
  }
  Qi(t, e, i) {
    return Pr({ series: this, axisX: this.axisX, axisY: this.axisY }, { cursorPosition: 0, x: 0, y: 0, multiHit: 0, open: 0, high: 0, low: 0, close: 0, position: 0, isPacked: 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  Fv(t) {
    if (!(t.x instanceof ts)) throw new Error("OHLCSeries must be attached to a Linear X Axis.");
    this.WM = t.x;
  }
  Sn() {
    return j(5, 5);
  }
  tM(t) {
    const e = t.length - 1;
    if (e < 0) return this;
    for (let i = 0; i <= e; i += 1) t[i][3] < this.nx.min.y && (this.nx.min.y = t[i][3]), this.nx.max.y < t[i][2] && (this.nx.max.y = t[i][2]);
    return this.nx.min.x = Math.min(this.nx.min.x, t[0][0]), this.nx.max.x = Math.max(this.nx.max.x, t[e][0]), this;
  }
  qb() {
    return this.nx.max.x;
  }
  tx() {
    return this.nx.min.x;
  }
  ix() {
    return this.nx.max.y;
  }
  sx() {
    return this.nx.min.y;
  }
  add(t) {
    this.NM.length > 0 && this.chart.yi.Oa(Ot.Go);
    const e = Array.isArray(t[0]) ? t : [t[0]];
    if (e.length > 0) {
      this.zM = !0;
      const i = this.NM.length, s = this.OM.length, o = e.length;
      this.NM.length = i + o, this.OM.length = s + o;
      for (let n = 0; n < o; n += 1) this.NM[i + n] = e[n], this.OM[s + n] = this.NM[i + n];
      this.tM(e), this.D.R("dataadd", { data: e }), this.Js.Rs();
    }
    return this;
  }
  setPackData(t) {
    return t !== this.GM && (this.$M = !0, this.GM = t, this.chart.yi.Rs()), this;
  }
  getPackData() {
    return this.GM;
  }
  getPackDataState() {
    const t = this.VM;
    if (!(t < 0 || this.HM === void 0 || this.HM.length === this.NM.length)) return { figureAxisInterval: t };
  }
  setFigureWidth(t) {
    return this.XM = t, this.chart.yi.Rs(), this;
  }
  getFigureWidth() {
    return this.XM;
  }
  setFigureMinimumGap(t) {
    return this.UM = t, this.chart.yi.Rs(), this;
  }
  getFigureMinimumGap() {
    return this.UM;
  }
  clear() {
    return this.NM = [], this.OM = [], this.HM = void 0, this.ZM(), this.nx.min.x = wt, this.nx.min.y = wt, this.nx.max.x = Pt, this.nx.max.y = Pt, this.D.R("dataclear", {}), this;
  }
  JM(t) {
    return this.WM.getPixelSize() * t / 1e3;
  }
  QM() {
    const t = this.jM.length - 1, e = this.JM(this.XM + this.UM);
    let i = Mc(e, t, ((s) => this.jM[s]));
    return i === void 0 ? i = e < this.jM[0] ? 0 : this.jM[t] < e ? t : this.jM.length / 2 : this.jM[i] < e && (i += 1), this.jM.length <= i && (i = t), 1e3 * this.jM[i];
  }
  rr() {
    if (super.rr(), !this.GM) {
      this.HM = void 0;
      let t = null;
      if (this.$M ? (this.$M = !1, t = this.NM, this.ZM()) : t = this.OM, t.length >= 1) {
        for (let e = 0; e < t.length; e += 1) {
          const i = t[e], s = i[0];
          this.RM(i) ? this.KM(s, i) : this.qM(s, i);
        }
        this.OM.length = 0, this.zM = !1, this.VM = -1;
      }
    }
  }
  Ev() {
    super.Ev();
    const t = this.QM();
    if (this.GM && this.NM.length >= 1 && (t !== this.VM || this.zM || this.$M)) {
      this.$M = !1, this.VM = t, this.zM = !1, this.ZM(), this.HM = [];
      const e = this.NM.length;
      let i = this.NM[0][0] - this.NM[0][0] % (t / 2) + t, s = 0;
      for (; s < e; ) {
        let o = this.YM(s);
        if (o === void 0) break;
        let n = o[3], a = o[2];
        const l = s;
        for (s += 1; s < e && this.NM[s][0] < i; ) o = this.NM[s], this.NM[s][3] < n && (n = this.NM[s][3]), a < this.NM[s][2] && (a = this.NM[s][2]), s += 1;
        const h = s - 1;
        let u = o[0];
        l < h && (u = this.NM[h][0], o = [u, this.NM[l][1], a, n, this.NM[h][4]]), o[1] < o[4] ? this.KM(u, o) : this.qM(u, o), this.HM.push(o), i += t;
      }
    }
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class d5 extends Px {
  constructor(t, e, i, s, o, n, a, l, h, u) {
    super(t, e, i, s, o, n, a, l, h, u), this.t_ = 1175494351e-14, this.XM = this.xi.ohlcCandleThicknessPixels || 5, this.i_ = this.xi.ohlcCandleTailStrokeStylePositive, this.s_ = this.xi.ohlcCandleTailStrokeStyleNegative, this.e_ = this.xi.ohlcCandleBodyFillStylePositive, this.r_ = this.xi.ohlcCandleBodyFillStyleNegative, this.h_ = i.GA(this.scale).gr(new $t({ thickness: this.XM, fillStyle: this.e_ })), this.h_.Mc = { x: 0, y: 1 }, this.n_ = i.GA(this.scale).gr(new $t({ thickness: this.XM, fillStyle: this.r_ })), this.n_.Mc = { x: 0, y: -1 }, this.o_ = i.GA(this.scale).gr(this.i_), this.a_ = i.GA(this.scale).gr(this.s_), this.Ts(this.h_), this.Ts(this.n_), this.Ts(this.o_), this.Ts(this.a_);
  }
  setBodyThickness(t) {
    return this.XM = t, this.h_.gr(new $t({ thickness: this.XM, fillStyle: this.e_ })), this.n_.gr(new $t({ thickness: this.XM, fillStyle: this.r_ })), this.chart.yi.Rs(), this;
  }
  getBodyThickness() {
    return this.XM;
  }
  setBodyFillStylePositive(t) {
    return this.e_ = typeof t == "function" ? t(this.e_) : t, this.h_.gr(new $t({ thickness: this.XM, fillStyle: this.e_ })), this.chart.yi.Rs(), this;
  }
  getBodyFillStylePositive() {
    return this.e_;
  }
  setBodyFillStyleNegative(t) {
    return this.r_ = typeof t == "function" ? t(this.r_) : t, this.n_.gr(new $t({ thickness: this.XM, fillStyle: this.r_ })), this.chart.yi.Rs(), this;
  }
  getBodyFillStyleNegative() {
    return this.r_;
  }
  setTailStrokeStylePositive(t) {
    return this.i_ = typeof t == "function" ? t(this.i_) : t, this.o_.gr(this.i_), this.chart.yi.Rs(), this;
  }
  getTailStrokeStylePositive() {
    return this.i_;
  }
  setTailStrokeStyleNegative(t) {
    return this.s_ = typeof t == "function" ? t(this.s_) : t, this.a_.gr(this.s_), this.chart.yi.Rs(), this;
  }
  getTailStrokeStyleNegative() {
    return this.s_;
  }
  nr() {
    return { fill: this.e_, fill2: this.r_, behavior: { colorStep: !0 } };
  }
  ZM() {
    return this.o_.Vi(), this.a_.Vi(), this.h_.Vi(), this.n_.Vi(), this;
  }
  KM(t, e) {
    return Math.abs(e[1] - e[4]) < this.t_ ? this.h_.Qo().UA({ x: t, y: e[1] - this.t_ }, { x: t, y: e[1] + this.t_ }) : this.h_.Qo().UA({ x: t, y: e[1] }, { x: t, y: e[4] }), e[4] < e[2] && this.o_.Qo().UA({ x: t, y: e[4] }, { x: t, y: e[2] }), e[3] < e[1] && this.o_.Qo().UA({ x: t, y: e[3] }, { x: t, y: e[1] }), this;
  }
  qM(t, e) {
    return Math.abs(e[1] - e[4]) < this.t_ ? this.n_.Qo().UA({ x: t, y: e[1] - this.t_ }, { x: t, y: e[1] + this.t_ }) : this.n_.Qo().UA({ x: t, y: e[1] }, { x: t, y: e[4] }), e[3] < e[4] && this.a_.Qo().UA({ x: t, y: e[3] }, { x: t, y: e[4] }), e[1] < e[2] && this.a_.Qo().UA({ x: t, y: e[1] }, { x: t, y: e[2] }), this;
  }
}
const f5 = { Candlesticks: d5 }, g5 = (r) => ({ defaultDragMouseStyle: Gt.Horizontal, getTitleTextRotation: () => 0, ...ja(r, ((t, e) => t.tx(e)), ((t, e) => t.qb(e)), ((t) => t.Sn().x)) }), p5 = (r) => ({ defaultDragMouseStyle: Gt.Vertical, getTitleTextRotation: (t) => 90 * t, ...ja(r, ((t, e) => t.sx(e)), ((t, e) => t.ix(e)), ((t) => t.Sn().y)) });
class y5 extends Yf {
  constructor(t, e, i, s, o, n, a, l) {
    super(t, e, i, s, o, l), this.y_ = !1, this.p_ = !1, this.m_ = !1, this.S_ = !1, this.b_ = !1, this.x_ = /* @__PURE__ */ new Map(), this.M_ = /* @__PURE__ */ new Map(), this.__ = [], this.w_ = [], this.k_ = !0, this.C_ = !0, this.T_ = !1, this.F_ = [], this.I_ = /* @__PURE__ */ new Set(), this.P_ = !1, this.Mm = o, this.L_ = n, this.B_ = a, this.D_ = l.cursorGridStrokeStyleX, this.E_ = l.cursorGridStrokeStyleY;
  }
  setKeepWithinAxisBoundaries(t) {
    return this.y_ = t, this.Js.Rs(), this;
  }
  getKeepWithinAxisBoundaries() {
    return this.y_;
  }
  dispose() {
    return super.dispose(), this.x_.forEach(((t) => t.forEach(((e) => e.dispose())))), this.M_.forEach(((t) => t.forEach(((e) => e.dispose())))), this.__.length = 0, this.w_.length = 0, this.Sm.length = 0, this;
  }
  rr() {
    return this.T_ && this.di && this.setPosition(...this.F_), this.x_.forEach(((t) => {
      t.forEach(((e) => e.setVisible(!1).setMarkerVisible(!1)));
    })), this.M_.forEach(((t) => {
      t.forEach(((e) => e.setVisible(!1).setMarkerVisible(!1)));
    })), this.__.forEach(((t) => t.setVisible(this.di && this.Hg).setMarkerVisible(this.di && this.Hg && this.k_))), this.w_.forEach(((t) => t.setVisible(this.di && this.Hg).setMarkerVisible(this.di && this.Hg && this.C_))), super.rr();
  }
  Cm() {
    if (!this.y_) return super.Cm();
    const t = this._m, e = t.getPosition(j(-1, -1), be.PaddedBackground), i = t.getPosition(j(1, 1), be.PaddedBackground), s = this.F_.map(((l) => {
      const h = l.pointMarkerScale.x, u = l.pointMarkerScale.y, c = xt({ x: h.ai.$, y: u.ai.$ }, { x: h, y: u }, t.scale), d = xt({ x: h.ai.U, y: u.ai.U }, { x: h, y: u }, t.scale), f = { x: Jt(e.x, c.x, d.x), y: Jt(e.y, c.y, d.y) }, p = { x: Jt(i.x, c.x, d.x), y: Jt(i.y, c.y, d.y) };
      return { axisX: h, axisY: u, a: c, b: d, visibleArea: Math.abs(p.x - f.x) * Math.abs(p.y - f.y), clampMin: f, clampMax: p, tableMin: e, tableMax: i };
    }));
    s.sort(((l, h) => h.visibleArea - l.visibleArea));
    const o = s[0];
    if (!o) return super.Cm();
    const n = Ii(o.tableMin.x, o.a.x, o.b.x) && Ii(o.tableMax.x, o.a.x, o.b.x), a = Ii(o.tableMin.y, o.a.y, o.b.y) && Ii(o.tableMax.y, o.a.y, o.b.y);
    return { x: !n, y: !a, either: !n || !a, resultTableViewport: { x: o.axisX, y: o.axisY }, resultTableViewportBounds: { x: { min: Math.min(o.axisX.ai.$, o.axisX.ai.U), max: Math.max(o.axisX.ai.$, o.axisX.ai.U) }, y: { min: Math.min(o.axisY.ai.$, o.axisY.ai.U), max: Math.max(o.axisY.ai.$, o.axisY.ai.U) } } };
  }
  setPosition(...t) {
    t = t.filter(((s) => !Number.isNaN(s.pointMarker.x) && !Number.isNaN(s.pointMarker.y))), this.F_ = t, this.__.length = 0, this.w_.length = 0;
    const e = this.renderingScale;
    if (t.length > 0) {
      const s = t[0].resultTable, o = Do(t[0].resultTableScale, e), n = o === this.scale ? s : xt(s, o, this.scale);
      this._m.setPosition(n);
    }
    this.Hg = !1, this.vm.forEach(((s) => {
      s.targetVisible = !1;
    }));
    const i = /* @__PURE__ */ new Map();
    t.forEach(((s, o) => {
      const n = s.pointMarkerScale.x, a = s.pointMarkerScale.y, l = i.get(n) || [], h = i.get(a) || [], u = !l.includes(s.pointMarker.x), c = !h.includes(s.pointMarker.y);
      l.push(s.pointMarker.x), h.push(s.pointMarker.y), i.set(n, l), i.set(a, h);
      const d = s.pointMarker, f = m5(j(d.x, d.y), n, a);
      if (u) {
        const R = this.R_(n, !0);
        R.setValue(d.x), R.setGridStrokeLength(this.p_ ? f.x : 1).setAllocatesAxisSpace(this.P_), this.__.push(R);
      }
      if (c) {
        const R = this.R_(a, !1);
        R.setValue(d.y), R.setGridStrokeLength(this.m_ ? f.y : 1).setAllocatesAxisSpace(this.P_), this.w_.push(R);
      }
      let p = this.vm[o];
      if (!p) {
        const R = new Ha(this.Js, this.renderingScale, this.scale, ie, this.xi).setPointerEvents(!1).setFillStyle(this.xi.cursorPointMarkerFillStyle).setStrokeStyle(this.xi.cursorPointMarkerStrokeStyle).setSize(this.xi.cursorPointMarkerSize).setShape(this.xi.cursorPointMarkerShape);
        p = { pointMarker: R, targetVisible: !0 }, this.vm.push(p), this.Sm.forEach(((L) => L(R)));
      }
      s.pointMarkerShape !== void 0 && p.pointMarker.setShape(s.pointMarkerShape), s.pointMarkerSize !== void 0 && p.pointMarker.setSize(s.pointMarkerSize), s.pointMarkerFillStyle && p.pointMarker.setFillStyle(s.pointMarkerFillStyle), s.pointMarkerStrokeStyle && p.pointMarker.setStrokeStyle(s.pointMarkerStrokeStyle);
      const g = Do(s.pointMarkerScale, e), y = g === this.scale ? s.pointMarker : xt(s.pointMarker, g, this.scale);
      p.pointMarker.setPosition(y), p.targetVisible = !0;
      const m = n.getInterval(), A = a.getInterval(), v = Math.min(m.start, m.end), b = Math.max(m.start, m.end), w = Math.min(A.start, A.end), k = Math.max(A.start, A.end);
      d.x >= v && d.x <= b && d.y >= w && d.y <= k && (this.Hg = !0);
    }));
    for (const s of this.vm) s.targetVisible || (s.pointMarker.dispose(), this.vm.splice(this.vm.indexOf(s), 1));
    return this;
  }
  setTickMarkersAllocateAxisSpace(t) {
    return this.P_ = t, this.Js.Rs(), this;
  }
  getTickMarkersAllocateAxisSpace() {
    return this.P_;
  }
  R_(t, e) {
    this.I_.has(t) || (t.addEventListener("dispose", (() => {
      var a;
      (a = i.get(t)) === null || a === void 0 || a.forEach(((l) => l.dispose())), i.delete(t);
    })), this.I_.add(t));
    const i = e ? this.x_ : this.M_, s = e ? this.__ : this.w_, o = i.get(t) || [];
    i.set(t, o);
    let n = o.find(((a) => !s.includes(a)));
    return n || (n = e ? t.tg(!1, this.L_) : t.tg(!1, this.B_), o.push(n), this.sn(n, e), n.setPointerEvents(!1)), n;
  }
  sn(t, e) {
    const i = e ? this.D_ : this.E_;
    return t.setGridStrokeStyle(i), t.setPointerEvents(!1), (e ? this.k_ : this.C_) ? t.setMarkerVisible(!0) : t.setMarkerVisible(!1), t;
  }
  setGridStrokeXCut(t) {
    return this.p_ = t, this.Js.Rs(), this;
  }
  getGridStrokeXCut() {
    return this.p_;
  }
  setGridStrokeYCut(t) {
    return this.m_ = t, this.Js.Rs(), this;
  }
  getGridStrokeYCut() {
    return this.m_;
  }
  setGridStrokeXStyle(t) {
    return this.D_ = t instanceof Function ? t(this.getGridStrokeXStyle()) : t, this.x_.forEach(((e) => e.forEach(((i) => i.setGridStrokeStyle(this.D_))))), this;
  }
  getGridStrokeXStyle() {
    return this.D_;
  }
  setGridStrokeYStyle(t) {
    return this.E_ = t instanceof Function ? t(this.getGridStrokeYStyle()) : t, this.M_.forEach(((e) => e.forEach(((i) => i.setGridStrokeStyle(this.E_))))), this;
  }
  getGridStrokeYStyle() {
    return this.E_;
  }
  setTickMarkerXVisible(t) {
    return this.k_ = t, this.Js.Rs(), this;
  }
  getTickMarkerXVisible() {
    return this.k_;
  }
  setTickMarkerYVisible(t) {
    return this.C_ = t, this.Js.Rs(), this;
  }
  getTickMarkerYVisible() {
    return this.C_;
  }
  setTickMarkerX(t) {
    return this.x_.forEach(((e) => e.forEach(((i) => i.setMarker(t))))), this.L_ = this.L_.addStyler(t), this.Js.Rs(), this;
  }
  setTickMarkerY(t) {
    return this.M_.forEach(((e) => e.forEach(((i) => i.setMarker(t))))), this.B_ = this.B_.addStyler(t), this.Js.Rs(), this;
  }
}
class Du {
  constructor(t, e, i, s) {
    this.Rm = [], this.Om = (o, n) => (this.Rm.forEach(((a) => a(o, n))), o), this.addStyler = (o) => new Du(this.Mm, this.L_, this.B_, this.Rm.map(((n) => n)).concat(o)), this.setResultTableBackground = (o) => new Du(o, this.L_, this.B_, this.Rm.map(((n) => n))), this.zm = (o, n, a, l, h) => this.Om(new y5(o, n, a, l, this.Mm, this.L_, this.B_, h), h), this.Mm = t, this.Rm = s, this.L_ = e, this.B_ = i;
  }
}
const Wg = new Du(xn, Yl.PointableTextBox, Yl.PointableTextBox, [(r, t) => {
  nc(r, t), r.setTickMarkerX(((e) => {
    e.setEffect(!0).setTextFont(t.cursorTickMarkerXTextFont).setTextFillStyle(t.cursorTickMarkerXTextFillStyle), vd(e) && e.setBackground(((i) => i.setFillStyle(t.cursorTickMarkerXBackgroundFillStyle).setStrokeStyle(t.cursorTickMarkerXBackgroundStrokeStyle)));
  })), r.setTickMarkerY(((e) => {
    e.setEffect(!0).setTextFont(t.cursorTickMarkerYTextFont).setTextFillStyle(t.cursorTickMarkerYTextFillStyle), vd(e) && e.setBackground(((i) => i.setFillStyle(t.cursorTickMarkerYBackgroundFillStyle).setStrokeStyle(t.cursorTickMarkerYBackgroundStrokeStyle)));
  }));
}]), m5 = (r, t, e) => {
  const i = t.ai, s = e.ai;
  let o = (r.x - i.getInnerStart()) / (i.getInnerEnd() - i.getInnerStart()), n = (r.y - s.getInnerStart()) / (s.getInnerEnd() - s.getInnerStart());
  return e.yA === 1 && (o = 1 - o), t.yA === 1 && (n = 1 - n), j(n, o);
};
class x5 {
  constructor(t, e, i, s) {
    this.O_ = !1, this.D = new Nt(), this.chart = i, this.z_ = s, this.xe = t.xe, this.Fe = s || ex, this.V_ = H.document.createElement("div"), this.V_.style.position = "absolute", this.V_.style.pointerEvents = "none", H.document.body.append(this.V_);
    const o = () => {
      const n = i.engine.container.getBoundingClientRect();
      this.V_.style.left = `${n.left}px`, this.V_.style.top = `${n.top}px`, this.V_.style.width = `${n.width}px`, this.V_.style.height = `${n.height}px`;
    };
    o(), i.addEventListener("resize", o), this.N_(this.V_), this.G_(), this.U_(), this.j_(), this.Y_(e), this.chart.H_().push(this);
  }
  N_(t) {
    this.W_ = H.document.createElement("div"), this.W_.style.pointerEvents = "all", t.append(this.W_), this.X_ = H.document.createElement("div"), this.Z_ = new ob(this.xe, this.Fe, this.chart, this.X_), this.J_ = H.document.createElement("table"), this.J_.style.borderSpacing = "0", this.W_.appendChild(this.Z_.ze()), this.W_.appendChild(this.X_), this.X_.appendChild(this.J_);
  }
  U_() {
    let t = 0, e = 0, i = 0, s = 0, o = !1;
    this.O_ = !1, this.W_.onmousedown = (n) => {
      n = n || H.event, i = n.clientX, s = n.clientY, o = !0, H.document.onmouseup = (a) => {
        this.O_ ? this.W_.addEventListener("click", It, !0) : this.W_.removeEventListener("click", It, !0), o = !1, this.O_ = !1, H.document.onmouseup = null, H.document.onmousemove = null;
      }, H.document.onmousemove = (a) => {
        a = a || H.event, o && (t = i - a.clientX, e = s - a.clientY, i = a.clientX, s = a.clientY, this.O_ = !0, this.W_.style.top = this.W_.offsetTop - e + "px", this.W_.style.left = this.W_.offsetLeft - t + "px", this.W_.style.removeProperty("right"), this.W_.style.removeProperty("bottom"));
      };
    };
  }
  j_() {
    let t = 0, e = 0, i = 0, s = 0, o = !1;
    this.W_.ontouchstart = (n) => {
      n = n || H.event, i = n.touches[0].clientX, s = n.touches[0].clientY, o = !0, this.W_.ontouchend = () => {
        o = !1, H.document.ontouchend = null, H.document.ontouchmove = null;
      }, this.W_.ontouchmove = (a) => {
        o && (It(a), a = a || H.event, t = i - a.touches[0].clientX, e = s - a.touches[0].clientY, i = a.touches[0].clientX, s = a.touches[0].clientY, this.W_.style.top = this.W_.offsetTop - e + "px", this.W_.style.left = this.W_.offsetLeft - t + "px", this.W_.style.removeProperty("right"), this.W_.style.removeProperty("bottom"));
      };
    };
  }
  G_() {
    this.W_.style.setProperty("top", "10px"), this.W_.style.setProperty("left", "10px"), this.W_.style.position = "absolute", this.W_.style.display = "flex", this.W_.style.alignItems = "flex-start", this.X_.style.setProperty("display", "none");
  }
  removePositionProperty() {
    this.W_.style.removeProperty("top"), this.W_.style.removeProperty("left"), this.W_.style.removeProperty("bottom"), this.W_.style.removeProperty("right");
  }
  setPositionProperty(t) {
    switch (this.removePositionProperty(), t) {
      case Qo.BottomLeft:
        this.W_.style.setProperty("bottom", "10px"), this.W_.style.setProperty("left", "10px");
        break;
      case Qo.TopLeft:
        this.W_.style.setProperty("top", "10px"), this.W_.style.setProperty("left", "10px");
        break;
      case Qo.BottomRight:
        this.W_.style.setProperty("bottom", "10px"), this.W_.style.setProperty("right", "10px");
        break;
      case Qo.TopRight:
      default:
        this.W_.style.setProperty("top", "10px"), this.W_.style.setProperty("right", "10px");
    }
  }
  Y_(t) {
    for (let e = 0; e < t.length; e += 1) {
      const i = this.J_.insertRow();
      for (let s = 0; s < t[e].length; s += 1) {
        const o = i.insertCell(), n = t[e][s];
        typeof n != "object" ? this.Q_(n, o) : this.addCustomButton(n, o);
      }
    }
  }
  Q_(t, e) {
    switch (t) {
      case Nr.ZoomIn:
        this.K_(new qA(this.xe, this.chart, this.Fe), e);
        break;
      case Nr.ZoomInX:
        this.K_(new JA(this.xe, this.chart, this.Fe), e);
        break;
      case Nr.ZoomInY:
        this.K_(new QA(this.xe, this.chart, this.Fe), e);
        break;
      case Nr.ZoomOut:
        this.K_(new tb(this.xe, this.chart, this.Fe), e);
        break;
      case Nr.ZoomOutX:
        this.K_(new eb(this.xe, this.chart, this.Fe), e);
        break;
      case Nr.ZoomOutY:
        this.K_(new ib(this.xe, this.chart, this.Fe), e);
        break;
      case Nr.ZoomToFit:
        this.K_(new rb(this.xe, this.chart, this.Fe), e);
        break;
      case Nr.ToggleAnimations:
        this.K_(new sb(this.xe, this.chart, this.Fe), e);
        break;
      default:
        console.error(`No predefined button like "${Nr[t]}" exists.`);
    }
  }
  K_(t, e) {
    e.rowSpan = t.Me.rows, e.colSpan = t.Me.columns, t.Oe(e);
  }
  addCustomButton(t, e) {
    const i = new nb(this.xe, t, this.chart);
    return this.K_(i, e), this;
  }
  dispose() {
    this.V_.remove(), this.D.R("dispose", {});
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Co extends No {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    var f;
    super(t, e, i, s, o, n, a, l, h, u), this.q_ = (p) => {
      this.D.R(p.type, p);
    }, this.tw = 0, this.D = new Nt(), this.Ga = d, this.zc = this.Js.ef(this.scale).gr(ue(this.xi.lineSeriesStrokeStyle, c)).tf(ue(this.xi.pointSeriesFillStyle, c)).uf(ue(this.xi.pointSeriesStrokeStyle, c)).sf(ue(this.xi.areaSeriesPositiveFillStyle, c)).iw(void 0).df(7), this.zc.sw = ((f = this.Ga) === null || f === void 0 ? void 0 : f.allowDataGrouping) !== !1, this.Ts(this.zc);
  }
  setRenderTransform(t) {
    return this.zc.ew(t), this.Js.Rs(), this;
  }
  getRenderTransform() {
    return this.zc.rw();
  }
  Gv() {
    return this.hw().getSampleCount() > 0;
  }
  Cs() {
    return this.getDataSet().yd(this.nw);
  }
  setDataSet(t, e) {
    var i;
    const s = (i = this.Kd) === null || i === void 0 ? void 0 : i.ts;
    if (t === s && e && this.nw && dg(e, this.nw)) return this;
    const o = ["change", "clear", "loop", "maxsamplecountexceed"];
    return s && o.forEach(((n) => s.removeEventListener(n, this.q_))), t ? (o.forEach(((n) => t.addEventListener(n, this.q_))), !e && t.sd && (e = this.ow(t.sd)), e && t.Fd(e), this.nw = e, this.aw = !1, e?.color && this.chart.yi.Oa(Ot.Uo), e?.size && this.chart.yi.Oa(Ot.$o), this.Kd = Wm(t, this.Kd, (() => ({ change: () => {
      this.tw += 1, this.tw > 1 && this.chart.yi.Oa(Ot.Go), this.chart.yi.Rs();
    }, clear: () => {
      this.chart.yi.Rs();
    } }))), e && this.zc.qd(t, e), this.chart.yi.Rs(), this) : (this.zc.qd(), this);
  }
  getDataSet() {
    return this.hw();
  }
  setDataMapping(t) {
    var e;
    return !((e = this.Kd) === null || e === void 0) && e.ts ? this.setDataSet(this.getDataSet(), t) : this.nw = t, this.aw = !1, this;
  }
  getDataMapping() {
    return this.nw;
  }
  setStrokeStyle(t) {
    return this.zc.gr(t), this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.zc.po();
  }
  setAreaFillStyle(t) {
    return this.zc.sf(t), this.Js.Rs(), this;
  }
  getAreaFillStyle() {
    return this.zc.lw();
  }
  setPointFillStyle(t) {
    return this.zc.tf(t), this.Js.Rs(), this;
  }
  getPointFillStyle() {
    return this.zc.lf();
  }
  setPointStrokeStyle(t) {
    return this.zc.uf(t), this.Js.Rs(), this;
  }
  getPointStrokeStyle() {
    return this.zc.cf();
  }
  setPointSize(t) {
    return this.zc.df(t), this.Js.Rs(), this;
  }
  getPointSize() {
    return this.zc.uw();
  }
  setPointShape(t) {
    return this.zc.rf(t), this.Js.Rs(), this;
  }
  getPointShape() {
    return this.zc.hf();
  }
  setPointRotation(t) {
    return this.zc.nf(t), this.Js.Rs(), this;
  }
  getPointRotation() {
    return this.zc.af();
  }
  setPointAlignment(t) {
    return this.zc.lg(t), this.chart.yi.Rs(), this;
  }
  getPointAlignment() {
    return this.zc.cw();
  }
  setPointDisplayBehavior(t) {
    return this.zc.dw(t), this.Js.Rs(), this;
  }
  getPointDisplayBehavior() {
    return this.zc.fw();
  }
  setCurvePreprocessing(t) {
    return this.zc.iw(t), this.Js.Rs(), this;
  }
  getCurvePreprocessing() {
    return this.zc.Aw();
  }
  appendJSON(t, e, i) {
    return this.hw().appendJSON(t, e, i), this.Js.yi.Rs(), this;
  }
  appendSample(t, e) {
    return this.hw().appendSample(t, e), this.Js.yi.Rs(), this;
  }
  appendSamples(t, e) {
    return this.hw().appendSamples(t, e), this.Js.yi.Rs(), this;
  }
  fill(t) {
    return this.hw().fill(t), this.Js.Rs(), this;
  }
  setSamples(t, e) {
    return this.hw().setSamples(t, e), this.Js.Rs(), this;
  }
  alterSamplesStartingFrom(t, e, i) {
    return this.hw().alterSamplesStartingFrom(t, e, i), this.Js.Rs(), this;
  }
  alterSamplesByIndex(t, e) {
    return this.hw().alterSamplesByIndex(t, e), this.Js.Rs(), this;
  }
  alterSamplesByMatch(t, e, i) {
    return this.hw().alterSamplesByMatch(t, e, i), this.Js.Rs(), this;
  }
  getSampleCount() {
    return this.hw().getSampleCount();
  }
  getNextSampleIndex() {
    return this.hw().getNextSampleIndex();
  }
  setMaxSampleCount(t) {
    return this.hw().setMaxSampleCount(t), this.Js.Rs(), this;
  }
  getMaxSampleCount() {
    return this.hw().getMaxSampleCount();
  }
  clear() {
    return this.hw().clear(), this.Js.Rs(), this;
  }
  readBack(t) {
    if (this.nw || this.gw(), !this.nw) return { xValues: new Float64Array(), yValues: new Float64Array(), iSampleFirst: 0 };
    const e = this.hw();
    if (t?.onlyInRange) {
      const i = e.yd(this.nw), s = i && js(i);
      if (!s) throw new Error("LightningChart JS - attempted to use `PointLineAreaSeries.readBack` with `onlyInRange` without a data pattern.\nThis operation is only supported for progressive data");
      const o = this.nw[s];
      return e.Td(this.nw, { onlyInRange: { key: o, start: t.onlyInRange.start, end: t.onlyInRange.end } });
    }
    return e.Td(this.nw);
  }
  solveNearest(t, e = this.chart.getCursorMode() || "show-nearest") {
    this.nw || this.gw();
    let i = qa(e);
    this.getCurvePreprocessing() !== void 0 && (i = !1);
    const s = this.yw(), o = Df(t) ? this.chart.translateCoordinate(t, { x: this.axisX, y: this.axisY }) : t, n = s.Rd(this.nw, o, i, this.scale, this.chart.xA);
    if (n !== void 0) return { cursorPosition: { resultTable: n, resultTableScale: this.scale, pointMarker: n, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...n, series: this, axisX: this.axisX, axisY: this.axisY, pointShape: this.getPointShape() };
  }
  Qi(t, e, i) {
    const s = this.getDataSet(), o = t?.dataPoint;
    return s.yd(this.nw) === void 0 || o ? o ? { cursorPosition: { resultTable: o, resultTableScale: this.scale, pointMarker: o, pointMarkerScale: { x: this.axisX, y: this.axisY } }, ...o, series: this, axisX: this.axisX, axisY: this.axisY, pointShape: this.getPointShape() } : void 0 : Pr({ series: this, axisX: this.axisX, axisY: this.axisY }, { x: 0, y: 0, cursorPosition: 0, rotation: 0, size: 0, color: 0, lookupValue: 0, multiHit: 0, iSample: 0, sample: 0, pointShape: 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  yw() {
    return this.hw();
  }
  Ws() {
    return is(this.getPointFillStyle(), this.zc.wi()) || is(this.getStrokeStyle().getFillStyle(), this.zc.wi()) || is(this.getAreaFillStyle(), this.zc.wi());
  }
  Uv() {
    var t;
    const e = (t = this.Kd) === null || t === void 0 ? void 0 : t.ts;
    return this.getVisible() && this.getAutoScrollingEnabled() && e !== void 0 && e.jc > 0;
  }
  Fv(t) {
  }
  qb(t) {
    this.nw || this.gw();
    const e = this.zc.Al();
    return e && e.pw === "y" && t && e.mw(), this.zc.Wi(t);
  }
  tx(t) {
    this.nw || this.gw();
    const e = this.zc.Al();
    return e && e.pw === "y" && t && e.mw(), this.zc.Hi(t);
  }
  ix(t) {
    this.nw || this.gw();
    const e = this.zc.Al();
    return e && e.pw === "x" && !t && e.mw(), this.zc.Zi(t);
  }
  sx(t) {
    this.nw || this.gw();
    const e = this.zc.Al();
    return e && e.pw === "x" && t && e.mw(), this.zc.Xi(t);
  }
  Sn() {
    return { x: this.zc.mu(), y: this.zc.Su() };
  }
  gw() {
    var t;
    const e = (t = this.Kd) === null || t === void 0 ? void 0 : t.ts;
    if ((!this.nw || this.aw) && e && e.sd) {
      const i = e.sd, s = this.Sw;
      let o = !1;
      if (this.nw && this.aw && s) {
        const n = Object.keys(i).length !== Object.keys(s).length, a = Object.entries(i).find((([l, h]) => {
          var u;
          return l in s && s[l] !== ((u = h.td) === null || u === void 0 ? void 0 : u.effective);
        }));
        o = !n && a === void 0;
      }
      if (!o) {
        const n = this.ow(e.sd);
        !n || this.nw && dg(this.nw, n) || (this.nw = n, this.aw = !0, n.color && this.chart.yi.Oa(Ot.Uo), n.size && this.chart.yi.Oa(Ot.$o), this.zc.qd(e, n)), this.Sw = Object.fromEntries(Object.entries(e.sd).map((([a, l]) => {
          var h;
          return [a, (h = l.td) === null || h === void 0 ? void 0 : h.effective];
        })));
      }
    }
  }
  Dv() {
    var t, e, i, s;
    if (super.Dv(), this.gw(), (((t = this.Ga) === null || t === void 0 ? void 0 : t.strictMode) || ((e = this.Kd) === null || e === void 0 ? void 0 : e.ts.Kc)) && this.nw && ((i = this.Kd) === null || i === void 0 ? void 0 : i.ts)) {
      const n = this.Kd.ts.sd;
      n && Object.values(this.nw).forEach(((a) => {
        if (!(a in n)) throw new Error(`LightningChart JS error - PointLineAreaSeries data mapping is referencing a data property ('${a}') that doesn't exist in the connected data set. This is not allowed when strict mode is enabled.`);
      }));
    }
    const o = js((s = this.Cs()) !== null && s !== void 0 ? s : "ProgressiveX");
    this.zc.bw(o === "x" ? this.xAxis.vA === 0 ? "bottom" : "top" : this.yAxis.vA === 0 ? "left" : "right");
  }
  hw() {
    var t;
    if (!this.Kd) {
      const e = new cr(this.Ga);
      return this.setDataSet(e, this.aw !== !0 ? this.nw : void 0), e;
    }
    return (t = this.Kd) === null || t === void 0 ? void 0 : t.ts;
  }
  ow(t) {
    var e, i;
    if (!((e = this.Ga) === null || e === void 0) && e.strictMode || !((i = this.Kd) === null || i === void 0) && i.ts.Kc) throw new Error("LightningChart JS error - PointLineAreaSeries data mapping is not explicitly defined. This is not allowed when strict mode is enabled.");
    const s = Object.entries(t).filter(((p) => p[1].nonNumeric !== !0)), o = s.find(((p) => p[0].toLowerCase().includes("x"))), n = s.find(((p) => p[0].toLowerCase().includes("y"))), a = s.find(((p) => p[0].toLowerCase().includes("size"))), l = s.find(((p) => p[0].toLowerCase().includes("rot"))), h = s.find(((p) => p[0].toLowerCase().includes("lookup") || p[0].toLowerCase().includes("value") && !p[0].toLowerCase().includes("y") && !p[0].toLowerCase().includes("x"))), u = s.find(((p) => p[0].toLowerCase().includes("color"))), c = {};
    a && (c.size = a[0]), l && (c.rotation = l[0]), h && (c.lookupValue = h[0]), u && (c.color = u[0]);
    const d = s.find(((p) => {
      var g;
      return !!(!((g = p[1].td) === null || g === void 0) && g.effective);
    })), f = (p, ...g) => {
      for (const y of g) if (y !== p) return y[0];
      for (const y of s) if (y !== p && !Object.keys(c).includes(y[0])) return y[0];
    };
    if ("xValues" in t && "yValues" in t) return { ...c, x: "xValues", y: "yValues" };
    if ("yValues" in t) {
      const p = f(s.find(((g) => g[0] === "yValues")));
      if (p) return { ...c, x: p, y: "yValues" };
    }
    if ("xValues" in t) {
      const p = f(s.find(((g) => g[0] === "xValues")));
      if (p) return { ...c, y: p, x: "xValues" };
    }
    if (o && n) return { ...c, x: o[0], y: n[0] };
    if (d) {
      const y = f(d);
      if (y) return { ...c, x: d[0], y };
    }
    return s.length >= 2 ? { ...c, x: s[0][0], y: s[1][0] } : void 0;
  }
  nr() {
    const t = this.getPointFillStyle(), e = this.getAreaFillStyle();
    return { stroke: this.getStrokeStyle(), fill: t !== Lt ? t : e, behavior: { priority: "stroke" } };
  }
  Xs() {
    return this.zs || this.getPointShape();
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Gg = { pan: !1, zoom: !1, rectangleZoom: !1, restoreDefault: !1, chartInteractions: void 0 }, On = (r, t, e, i) => {
  r.seriesBackground.addEventListener(t, e, i), r.getSeries().forEach(((o) => o.addEventListener(t, e, i)));
  const s = (o) => o.series.addEventListener(t, e, i);
  return r.addEventListener("seriesadd", s), () => {
    r.seriesBackground.removeEventListener(t, e), r.getSeries().forEach(((o) => o.removeEventListener(t, e))), r.removeEventListener("seriesadd", s);
  };
}, jo = (r, t, e, i) => {
  const s = [];
  r.forEachAxis(((n) => {
    const a = (l) => e(n, l);
    n.addEventListener(t, a, i), s.push((() => n.removeEventListener(t, a)));
  }));
  const o = (n) => {
    const a = (l) => e(n.axis, l);
    n.axis.addEventListener(t, a, i), s.push((() => n.axis.removeEventListener(t, a)));
  };
  return r.addEventListener("axisadd", o), s.push((() => r.removeEventListener("axisadd", o))), () => {
    s.forEach(((n) => n()));
  };
}, Gh = (r, t, e) => {
  Wr();
  const i = /* @__PURE__ */ new Map();
  r.forEachAxis(((n) => {
    var a, l;
    const h = n.cr.chartInteractions;
    h === !1 || typeof h == "object" && h.restoreDefault === !1 || i.set(n, { animate: (a = t.animationsEnabled) !== null && a !== void 0 ? a : void 0, stopAxisAfter: (l = t.stopScroll) !== null && l !== void 0 ? l : void 0 });
  })), r.xw(i);
  let s = t.cursor;
  if (s !== null) {
    s = s ?? Gt.ZoomOut;
    const n = r.engine.setMouseStyle(s);
    H.setTimeout((() => {
      r.engine.restoreMouseStyle(n);
    }), 500);
  }
  const o = t.on;
  o && H.requestAnimationFrame((() => o({ event: e })));
}, Ug = (...r) => (t, e) => r.forEach(((i) => i.forEach(((s) => {
  s.axis.ai.K(t), s.axis.mA.K(e);
})))), Hg = j(10, 10);
var hn;
(function(r) {
  r[r.Top = 0] = "Top", r[r.Bottom = 1] = "Bottom", r[r.Left = 2] = "Left", r[r.Right = 3] = "Right";
})(hn || (hn = {}));
const v5 = /* @__PURE__ */ new Set([hn.Top, hn.Bottom, hn.Left, hn.Right]), S5 = (r) => r.setStopped(!0), Nn = (r, t) => {
  if (!r || !t) throw new Error("LightningChart JS error | either X or Y axis didn't exist when creating a series.");
  const e = r.Ah.type === "linear-highPrecision" || t.Ah.type === "linear-highPrecision", i = r.Ah.type === "logarithmic" || t.Ah.type === "logarithmic";
  if (e && i) {
    const s = `Invalid Axis combination | 'logarithmic' can't be combined with 'linear-highPrecision' (x: ${r.Ah.type}, y: ${t.Ah.type})`;
    throw new Error(s);
  }
};
var vo, Tl, wd;
(function(r) {
  r[r.seriesBackground = 0] = "seriesBackground", r[r.gridLine0 = 1] = "gridLine0", r[r.gridLine1 = 2] = "gridLine1", r[r.gridLine2 = 3] = "gridLine2", r[r.highlightersBelow = 4] = "highlightersBelow";
})(vo || (vo = {})), (function(r) {
  r[r.plotting = 0] = "plotting", r[r.highlightersAbove = 1] = "highlightersAbove", r[r.fg = 2] = "fg";
})(Tl || (Tl = {}));
class $f extends $a {
  constructor(t, e, i, s, o, n, a) {
    var l, h, u, c, d;
    super(t, e, i, e.Av("chartXY bg", 0), s, e.yi.xi.chartXYBackgroundFillStyle, e.yi.xi.chartXYBackgroundStrokeStyle, e.yi.xi.chartXYTitleFont, e.yi.xi.chartXYTitleFillStyle, e.yi.xi.chartXYTitleShadow, a, (l = n?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.Mw = this.Kg.d2({ scaleXYConstructor: we }), this.ZA = [], this.JA = [], this.KA = [], this.QA = [], this._w = /* @__PURE__ */ new Map(), this.ww = !0, this.kw = [], this.Cw = this.xi.chartXYZoomingRectangleFillStyle, this.Tw = this.xi.chartXYZoomingRectangleStrokeStyle, this.jA = Yg, this.Jb = 0, this.Wm = [], this.Zm = () => {
      if (this.ci) return;
      const y = /* @__PURE__ */ new Map();
      this.forEachAxis(((m) => {
        m.DA().find(((A) => A.Gv())) !== void 0 && y.set(m, { ...m.getInterval(), stopped: m.getStopped() });
      })), y.size <= 0 || (this.Wm.push(y), this.Wm.length > 100 && this.Wm.shift());
    }, this.Fw = (y, m, A) => {
      const v = y.solveNearest(m, A);
      return v && Ii(v.cursorPosition.pointMarker.x, v.axisX.getInterval().start, v.axisX.getInterval().end) && Ii(v.cursorPosition.pointMarker.y, v.axisY.getInterval().start, v.axisY.getInterval().end) ? v : void 0;
    }, this.Iw = Ug(this.JA, this.ZA), this.Pw = Ug(this.KA, this.QA), this.Lw = (y) => {
      this.Iw(y.engineWidth, y.engineHeight), this.Pw(y.engineHeight, y.engineWidth), this.Mw.K(y.engineWidth, y.engineHeight), this.yi.Rs();
    }, this.Bw = (y, m) => {
      this._w.set(y, m);
    }, this.fA = (y) => {
      const m = this.JA.findIndex(((w) => w.axis === y)), A = this.ZA.findIndex(((w) => w.axis === y)), v = this.KA.findIndex(((w) => w.axis === y)), b = this.QA.findIndex(((w) => w.axis === y));
      m >= 0 && this.JA.splice(m, 1), A >= 0 && this.ZA.splice(A, 1), v >= 0 && this.KA.splice(v, 1), b >= 0 && this.QA.splice(b, 1), this._w.delete(y), this.yi.Rs();
    }, this.addAreaRangeSeries = (y) => {
      const m = y?.axisX || y?.xAxis || this.getDefaultAxisX(), A = y?.axisY || y?.yAxis || this.getDefaultAxisY();
      Nn(m, A);
      const v = new Lx(this, this.$y, this.zS, m, A, this.Dw(m), this.Dw(A), this.tv, this.xi, this.yi.bs, y?.automaticColorIndex !== void 0 ? y.automaticColorIndex : this.Ny.length);
      return this.Wy(v, y), v;
    }, this.D = new Nt(), this.yi.Oa(Ot.Ro), this.Fn({ left: (h = this.xi.panelPadding) !== null && h !== void 0 ? h : 7, right: (u = this.xi.panelPadding) !== null && u !== void 0 ? u : 7, top: (c = this.xi.panelPadding) !== null && c !== void 0 ? c : 7, bottom: (d = this.xi.panelPadding) !== null && d !== void 0 ? d : 7 }, !1), this.Ew = e.hS("chartXY series bg", vo.seriesBackground), this.Rw = [vo.gridLine0, vo.gridLine1, vo.gridLine2].map(((y) => e.Ow(`chartXY gridline #${y}`, y))), this.cA = e.Ow("chartXY highlighters below", vo.highlightersBelow), this.zS = e.nS("chartXY plotting", Tl.plotting), this.dA = e.nS("chartXY highlighters above", Tl.highlightersAbove), this.uA = e.nS("chartXY fg", Tl.fg), this.Mw.x.Z(0, this.uiScale.x.getCellSize() - (this.dt.left + this.dt.right + this.Hn.left + this.Hn.right)), this.Mw.y.Z(0, this.uiScale.y.getCellSize() - (this.dt.bottom + this.dt.top + this.Hn.bottom + this.Hn.top)), this.Mw.K(this.uiScale.Ft().x, this.uiScale.Ft().y), this.Yy = this.Ew.er(this.Mw).sr(this.xi.chartXYSeriesBackgroundFillStyle).ir(Et), this.Hy = this.Ew.er(this.Mw).sr(Lt).ir(this.xi.chartXYSeriesBackgroundStrokeStyle).setPointerEvents(!1), super.jy(this.Yy, this.Hy), this.setSeriesBackgroundEffect(!1);
    const f = $e(n ? n.cursorBuilder : void 0, Wg), p = e.fS();
    this.AS = Xr(this, p, f.zm(p, this.Mw, this.Mw, ie, this.xi), this, "show-all", M5, ((y, m) => {
      const A = this.translateCoordinate(y, { x: y.axisX, y: y.axisY }, this.coordsClient);
      return Math.sqrt((A.clientX - m.clientX) ** 2 + (A.clientY - m.clientY) ** 2);
    })), this.addAxisX(n && n.defaultAxisX), this.addAxisY(n && n.defaultAxisY), this.addEventListener("resize", this.Lw), this.Wr.rn("ChartXY"), this.setAnimationsEnabled(n?.animationsEnabled !== !1), this.fv(o, this.Mw), this.gS = ((y) => {
      let m = {}, A = !1, v = !1, b = !1;
      const w = () => {
        var D;
        const P = y.getAxes().find(((B) => {
          var z, W;
          return ((z = B.getScrollStrategy()) === null || z === void 0 ? void 0 : z.id) === Gl || ((W = B.getScrollStrategy()) === null || W === void 0 ? void 0 : W.id) === Aa;
        })), V = y.getSeries().map(((B) => B.Cs())).find(((B) => B)), _ = y.getSeries().find(((B) => B instanceof Co && !Qn(B.getAreaFillStyle()) && B.Cs())), O = P ? { type: "scrolling", scrollingAxis: P, x: P.isX, y: P.isY } : V ? { type: "progressive", x: V === "ProgressiveX" || V === "RegressiveX", y: V === "ProgressiveY" || V === "RegressiveY" } : { type: "freeform" };
        if (O.type === "progressive") {
          const B = { zoom: { wheel: {}, stopScroll: !0 }, pan: { lmb: !1, rmb: { drag: {} } }, restoreDefault: { doubleClick: !0 }, rectangleZoom: { lmb: { drag: {} }, rmb: !1 } }, z = { pan: { lmb: !1, rmb: { drag: {} } }, zoom: { wheel: {}, mode: _ ? "keep-start" : "centered" }, restoreDefault: { doubleClick: !0 }, rectangleZoom: { lmb: { drag: {} }, rmb: !1 } };
          return Zi({ rectangleZoom: { x: O.x, y: O.y, rmb: !1 }, pan: { x: O.x, y: O.y, pinch: {}, lmb: !1, rmb: { drag: {} } }, paginate: !1, zoom: { x: O.x, y: O.y, wheel: {}, pinch: {}, stopScroll: !0 }, restoreDefault: { doubleClick: !0 }, restorePrevious: { ctrl: { code: "KeyZ" } }, xAxis: O.x ? B : z, yAxis: O.y ? B : z }, m);
        }
        if (O.type === "scrolling") {
          const B = (((D = O.scrollingAxis.Vh) === null || D === void 0 ? void 0 : D.id) === Aa ? -1 : 1) * (O.scrollingAxis.getInterval().end > O.scrollingAxis.getInterval().start ? 1 : -1) > 0 ? "keep-end" : "keep-start", z = { zoom: { wheel: {}, stopScroll: !1, mode: B }, pan: { drag: {} }, restoreDefault: { doubleClick: !0 } }, W = { rectangleZoom: { lmb: {}, rmb: !1, mmb: !1 }, pan: { lmb: !1, rmb: { drag: {} }, mmb: !1 }, zoom: { drag: !1, wheel: {}, mode: _ ? "keep-start" : "centered" }, restoreDefault: { doubleClick: !0 } };
          return Zi({ rectangleZoom: !1, pan: { x: O.x, y: O.y, pinch: {}, drag: {} }, paginate: !1, zoom: { x: O.x, y: O.y, wheel: {}, pinch: { stopScroll: !0 }, stopScroll: !1, mode: B }, restoreDefault: { doubleClick: !0 }, restorePrevious: !1, xAxis: O.x ? z : W, yAxis: O.y ? z : W }, m);
        }
        return Zi({ pan: { x: !0, y: !0, pinch: {}, lmb: !1, rmb: { drag: {} } }, zoom: { x: !0, y: !0, pinch: {}, wheel: {}, mode: "toward-pointer" }, rectangleZoom: { x: !0, y: !0, lmb: !0, rmb: !1 }, restoreDefault: { doubleClick: !0 }, restorePrevious: { ctrl: { code: "KeyZ" } }, axes: { pan: { rmb: { drag: {} }, lmb: !1 }, rectangleZoom: { lmb: { drag: {} }, rmb: !1 }, zoom: { wheel: {} }, restoreDefault: { doubleClick: !0 } } }, m);
      }, k = (D) => {
        const P = w(), V = D.getUserInteractions();
        let _ = D.isX ? P.xAxis : P.yAxis, O = P.axes;
        return _ = _ !== !1 ? _ : Gg, O = O !== !1 ? O : Gg, Zi(O ?? {}, _ ?? {}, V);
      }, R = (D) => {
      }, L = (D) => {
        if (!y.axisX || !y.axisY) return;
        const P = xr(y.yi.Ga.$a !== !1), V = w(), _ = ge(V.pan, "drag", D, A, v, b);
        _ && P.push("drag pan", (() => ((G, Y, U, $) => {
          let Z;
          const q = G.getCursorMode();
          let Q = !1, nt = Y;
          Y.pointerType === "mouse" && Y.preventDefault();
          const et = (tt) => {
            if (tt.pointerId !== Y.pointerId) return;
            const at = tt.clientX - nt.clientX, ut = tt.clientY - nt.clientY;
            if (nt = tt, !Q) {
              if (!(tt.pointerType === "mouse" || Math.max(Math.abs(tt.clientX - Y.clientX), Math.abs(tt.clientY - Y.clientY)) >= 10)) return;
              {
                Q = !0;
                let st = U.cursor;
                st !== null && (st = st ?? (U.x === !1 ? Gt.Vertical : U.y === !1 ? Gt.Horizontal : Gt.Move), Z = G.engine.setMouseStyle(st)), G.setCursorMode(void 0), sn();
              }
            }
            It(tt), U.x && G.forEachAxisX(((st) => {
              var bt;
              const ct = st.cr.chartInteractions;
              ct === !1 || typeof ct == "object" && ct.pan === !1 || (U.stopScroll !== !1 && st.setStopped(!0), st.pan(-at * ((bt = U.sensitivity) !== null && bt !== void 0 ? bt : 1)));
            })), U.y && G.forEachAxisY(((st) => {
              var bt;
              const ct = st.cr.chartInteractions;
              ct === !1 || typeof ct == "object" && ct.pan === !1 || (U.stopScroll !== !1 && st.setStopped(!0), st.pan(ut * ((bt = U.sensitivity) !== null && bt !== void 0 ? bt : 1)));
            }));
            const ht = U.on;
            ht && H.requestAnimationFrame((() => ht({ event: tt })));
          }, it = (tt) => {
            tt.pointerId === Y.pointerId && (H.removeEventListener("pointermove", et), H.removeEventListener("pointerup", it), G.engine.container.removeEventListener("pointerdown", rt), Z = G.engine.restoreMouseStyle(Z), $(), G.setCursorMode(q), Q && (Ao("click"), Ao("contextmenu")));
          }, rt = (tt) => {
            tt.pointerId !== Y.pointerId && (H.removeEventListener("pointermove", et), H.removeEventListener("pointerup", it), G.engine.container.removeEventListener("pointerdown", rt), Z = G.engine.restoreMouseStyle(Z), $(), G.setCursorMode(q));
          };
          H.addEventListener("pointermove", et), H.addEventListener("pointerup", it), G.engine.container.addEventListener("pointerdown", rt), Wr();
        })(y, D, _, E())));
        const O = ge(V.zoom, "drag", D, A, v, b);
        O && P.push("drag zoom", (() => ((G, Y, U, $) => {
          let Z;
          const q = U.cursor;
          if (q !== null) {
            let at = typeof q == "function" ? q("in") : q;
            at !== null && (at = at ?? Gt.ZoomIn, Z = G.engine.setMouseStyle(at));
          }
          const Q = G.getCursorMode();
          G.setCursorMode(void 0);
          let nt = !1, et = Y;
          Y.pointerType === "mouse" && Y.preventDefault();
          const it = (at) => {
            if (at.pointerId !== Y.pointerId) return;
            It(at);
            const ut = { x: at.clientX - et.clientX, y: at.clientY - et.clientY };
            et = at, U.x && G.forEachAxisX(((st) => {
              var bt;
              const ct = st.cr.chartInteractions;
              if (ct === !1 || typeof ct == "object" && ct.zoom === !1) return;
              let Mt;
              Mt = U.mode === "keep-start" ? st.getInterval().start : U.mode === "keep-end" ? st.getInterval().end : U.mode === "centered" ? st.ai.Ot((st.ai.wt() + st.ai.kt()) / 2) : G.translateCoordinate(Y, { x: st, y: st }).x;
              const vt = 0.05 * st.dh.getWidth({ x: -ut.x, y: ut.y }) * ((bt = U.sensitivity) !== null && bt !== void 0 ? bt : 1);
              if (st.zoom(Mt, vt), U.stopScroll !== !1 && st.setStopped(!0), q !== null) {
                let mt = typeof q == "function" ? q(vt < 0 ? "in" : "out") : q;
                mt !== null && (mt = mt ?? (vt < 0 ? Gt.ZoomIn : Gt.ZoomOut), Z = G.engine.setMouseStyle(mt, Z));
              }
            })), U.y && G.forEachAxisY(((st) => {
              var bt;
              const ct = st.cr.chartInteractions;
              if (ct === !1 || typeof ct == "object" && ct.zoom === !1) return;
              let Mt;
              Mt = U.mode === "keep-start" ? st.getInterval().start : U.mode === "keep-end" ? st.getInterval().end : U.mode === "centered" ? st.ai.Ot((st.ai.wt() + st.ai.kt()) / 2) : G.translateCoordinate(Y, { x: st, y: st }).y;
              const vt = 0.05 * st.dh.getWidth({ x: -ut.x, y: ut.y }) * ((bt = U.sensitivity) !== null && bt !== void 0 ? bt : 1);
              if (st.zoom(Mt, vt), U.stopScroll !== !1 && st.setStopped(!0), q !== null) {
                let mt = typeof q == "function" ? q(vt < 0 ? "in" : "out") : q;
                mt !== null && (mt = mt ?? (vt < 0 ? Gt.ZoomIn : Gt.ZoomOut), Z = G.engine.setMouseStyle(mt, Z));
              }
            })), nt || (sn(), nt = !0);
            const ht = U.on;
            ht && H.requestAnimationFrame((() => ht({ event: at })));
          }, rt = (at) => {
            at.pointerId === Y.pointerId && (H.removeEventListener("pointermove", it), H.removeEventListener("pointerup", rt), G.engine.container.removeEventListener("pointerdown", tt), Z = G.engine.restoreMouseStyle(Z), $(), G.setCursorMode(Q));
          }, tt = (at) => {
            at.pointerId !== Y.pointerId && (H.removeEventListener("pointermove", it), H.removeEventListener("pointerup", rt), G.engine.container.removeEventListener("pointerdown", tt), Z = G.engine.restoreMouseStyle(Z), $(), G.setCursorMode(Q));
          };
          H.addEventListener("pointermove", it), H.addEventListener("pointerup", rt), G.engine.container.addEventListener("pointerdown", tt), Wr();
        })(y, D, O, E())));
        const B = ge(V.rectangleZoom, void 0, D, A, v, b);
        if (B && P.push("rectangle zoom", (() => ((G, Y, U, $) => {
          let Z;
          const q = G.getCursorMode(), Q = G.addRectangleSeries({ legend: null }).setDrawOrder({ seriesDrawOrderIndex: 1e3 }).setPointerEvents(!1).setCursorEnabled(!1).setAutoScrollingEnabled(!1).setClipping(!1), nt = Q.add({ x1: 0, x2: 0, y1: 0, y2: 0 });
          let et = !1, it = !1;
          Y.pointerType === "mouse" && Y.preventDefault();
          const rt = (ut) => {
            if (ut.pointerId !== Y.pointerId) return;
            It(ut), U.x && G.forEachAxisX(((mt) => {
              const Xt = mt.cr.chartInteractions;
              Xt === !1 || typeof Xt == "object" && Xt.rectangleZoom === !1 || mt.setStopped(!0);
            })), U.y && G.forEachAxisY(((mt) => {
              const Xt = mt.cr.chartInteractions;
              Xt === !1 || typeof Xt == "object" && Xt.rectangleZoom === !1 || mt.setStopped(!0);
            }));
            const ht = G.translateCoordinate(Y, G.coordsAxis), st = G.translateCoordinate(ut, G.coordsAxis), bt = xt({ x: 0, y: 0 }, G.Mw, G.coordsAxis), ct = xt({ x: G.Mw.x.getInnerEnd(), y: G.Mw.y.getInnerEnd() }, G.Mw, G.coordsAxis);
            U.x === !1 ? nt.setDimensions({ y1: ht.y, x1: bt.x, y2: st.y, x2: ct.x }) : U.y === !1 ? nt.setDimensions({ x1: ht.x, y1: bt.y, x2: st.x, y2: ct.y }) : nt.setDimensions({ x1: ht.x, y1: ht.y, x2: st.x, y2: st.y });
            const Mt = ws({ x: ut.clientX, y: ut.clientY }, { x: U.x ? Y.clientX : ut.clientX, y: U.y ? Y.clientY : ut.clientY }) >= 20, vt = Ii(st.x, bt.x, ct.x) && Ii(st.y, bt.y, ct.y);
            if (nt.setFillStyle(Mt && vt ? G.getZoomingRectangleFillStyle() : Lt).setStrokeStyle(Mt && vt ? G.getZoomingRectangleStrokeStyle() : Et), et || (sn(), et = !0), G.setCursorMode(Mt ? void 0 : q), Mt) {
              let mt = U.cursor;
              if (mt !== null && (mt = mt ?? Gt.ZoomIn, Z = G.engine.setMouseStyle(mt, Z)), !it) {
                const Xt = U.start;
                Xt && Xt({ event: ut });
              }
            } else Z = G.engine.restoreMouseStyle(Z);
            it = Mt;
          }, tt = (ut) => {
            if (ut.pointerId !== Y.pointerId) return;
            const ht = ws({ x: ut.clientX, y: ut.clientY }, { x: U.x ? Y.clientX : ut.clientX, y: U.y ? Y.clientY : ut.clientY }) >= 20, st = G.translateCoordinate(ut, G.coordsAxis), bt = xt({ x: 0, y: 0 }, G.Mw, G.coordsAxis), ct = xt({ x: G.Mw.x.getInnerEnd(), y: G.Mw.y.getInnerEnd() }, G.Mw, G.coordsAxis), Mt = Ii(st.x, bt.x, ct.x) && Ii(st.y, bt.y, ct.y);
            ht && Mt && G.forEachAxis(((mt) => {
              var Xt, Rt;
              if (mt.isX && !U.x || mt.isY && !U.y) return;
              const Dt = mt.cr.chartInteractions;
              if (Dt === !1 || typeof Dt == "object" && Dt.rectangleZoom === !1) return;
              const Kt = G.translateCoordinate(Y, { x: mt, y: mt }), _t = G.translateCoordinate(ut, { x: mt, y: mt }), Ut = mt.dh.getWidth(Kt), te = mt.dh.getWidth(_t), ye = Math.sign(te - Ut), ne = Math.sign(mt.getInterval().end - mt.getInterval().start), ti = ye === ne ? Ut : te, fe = ye === ne ? te : Ut;
              mt.li(ti, fe, (Xt = U.animationsEnabled) !== null && Xt !== void 0 ? Xt : void 0, (Rt = U.stopScroll) !== null && Rt !== void 0 ? Rt : void 0, "interactionSetInterval");
            })), ht && (Ao("click"), Ao("contextmenu")), G.setCursorMode(q), Q.dispose(), H.removeEventListener("pointermove", rt), H.removeEventListener("pointerup", tt), G.engine.container.removeEventListener("pointerdown", at), Z = G.engine.restoreMouseStyle(Z), $();
            const vt = ht && Mt && U.on;
            vt && H.requestAnimationFrame((() => vt({ event: ut })));
          }, at = (ut) => {
            ut.pointerId !== Y.pointerId && (G.setCursorMode(q), Q.dispose(), H.removeEventListener("pointermove", rt), H.removeEventListener("pointerup", tt), G.engine.container.removeEventListener("pointerdown", at), Z = G.engine.restoreMouseStyle(Z), $());
          };
          H.addEventListener("pointermove", rt), H.addEventListener("pointerup", tt), G.engine.container.addEventListener("pointerdown", at), Wr();
        })(y, D, B, E()))), D instanceof PointerEvent && D.pointerType === "mouse" && D.button === 1) {
          const G = ge(V.restoreDefault, "mmb", D, A, v, b);
          G && G.singleClick && P.push("mmb restore default", (() => {
            It(D), Gh(y, G, D);
          }));
          const Y = ge(V.restorePrevious, "mmb", D, A, v, b);
          Y && Y.singleClick && P.push("mmb restore previous", (() => {
            It(D);
            const U = y.getAxes().filter(((q) => {
              const Q = q.cr.chartInteractions;
              return !(Q === !1 || typeof Q == "object" && Q.restorePrevious === !1);
            }));
            y.restorePreviousZoomState({ whitelist: U });
            const $ = y.engine.setMouseStyle(Gt.ZoomOut);
            H.setTimeout((() => {
              y.engine.restoreMouseStyle($);
            }), 500);
            const Z = Y.on;
            Z && H.requestAnimationFrame((() => Z({ event: D })));
          }));
        }
        P.end();
        const z = ge(V.pan, "pinch", D, A, v, b), W = ge(V.zoom, "pinch", D, A, v, b);
        (W || z) && ((G, Y, U, $, Z) => {
          if (!U && !$) return;
          const q = (nt) => {
            if (nt.pointerId === Y.pointerId) return;
            const et = Z();
            let it;
            G.engine.container.removeEventListener("pointerdown", q), H.removeEventListener("pointerup", Q);
            let rt = nt;
            const tt = G.getCursorMode();
            G.setCursorMode(void 0);
            const at = (ht) => {
              var st, bt, ct, Mt;
              const vt = it, mt = rt;
              if (ht.pointerId === Y.pointerId) it = ht;
              else {
                if (ht.pointerId !== nt.pointerId) return;
                rt = ht;
              }
              if (It(ht), it === void 0 || vt === void 0) return;
              const Xt = { x: (it.clientX - vt.clientX + (rt.clientX - mt.clientX)) / 2 * ((st = U?.sensitivity) !== null && st !== void 0 ? st : 1), y: (it.clientY - vt.clientY + (rt.clientY - mt.clientY)) / -2 * ((bt = U?.sensitivity) !== null && bt !== void 0 ? bt : 1) };
              let Rt = !1;
              if (U && U.x && (Rt = !0, G.forEachAxisX(((_t) => {
                const Ut = _t.cr.chartInteractions;
                Ut === !1 || typeof Ut == "object" && Ut.pan === !1 || _t.ig({}, Xt);
              }))), U && U.y && (Rt = !0, G.forEachAxisY(((_t) => {
                const Ut = _t.cr.chartInteractions;
                Ut === !1 || typeof Ut == "object" && Ut.pan === !1 || _t.ig({}, Xt);
              }))), Rt) {
                const _t = U?.on;
                _t && H.requestAnimationFrame((() => _t({ event: ht })));
              }
              const Dt = ls(oi({ x: Math.abs(vt.clientX - mt.clientX), y: Math.abs(vt.clientY - mt.clientY) }, { x: Math.abs(it.clientX - rt.clientX), y: Math.abs(it.clientY - rt.clientY) }), { x: (ct = $?.sensitivity) !== null && ct !== void 0 ? ct : 1, y: (Mt = $?.sensitivity) !== null && Mt !== void 0 ? Mt : 1 });
              let Kt = !1;
              if ($ && $.x && (Kt = !0, G.forEachAxisX(((_t) => {
                var Ut;
                const te = _t.cr.chartInteractions;
                te === !1 || typeof te == "object" && te.zoom === !1 || _t.li(_t.ai.Qt(_t.getInterval().start, -_t.dh.getWidth(Dt)), _t.ai.Qt(_t.getInterval().end, _t.dh.getWidth(Dt)), !1, (Ut = $.stopScroll) !== null && Ut !== void 0 ? Ut : void 0, "interactionZoom");
              }))), $ && $.y && (Kt = !0, G.forEachAxisY(((_t) => {
                var Ut;
                const te = _t.cr.chartInteractions;
                te === !1 || typeof te == "object" && te.zoom === !1 || _t.li(_t.ai.Qt(_t.getInterval().start, -_t.dh.getWidth(Dt)), _t.ai.Qt(_t.getInterval().end, _t.dh.getWidth(Dt)), !1, (Ut = $.stopScroll) !== null && Ut !== void 0 ? Ut : void 0, "interactionZoom");
              }))), Kt) {
                const _t = $?.on;
                _t && H.requestAnimationFrame((() => _t({ event: ht })));
              }
            }, ut = (ht) => {
              ht.pointerId !== Y.pointerId && ht.pointerId !== nt.pointerId || (It(ht), G.setCursorMode(tt), H.removeEventListener("pointermove", at), H.removeEventListener("pointerup", ut), et());
            };
            H.addEventListener("pointermove", at), H.addEventListener("pointerup", ut), Wr();
          }, Q = (nt) => {
            nt.pointerId === Y.pointerId && (G.engine.container.removeEventListener("pointerdown", q), H.removeEventListener("pointerup", Q));
          };
          G.engine.container.addEventListener("pointerdown", q), H.addEventListener("pointerup", Q);
        })(y, D, z, W, E);
      };
      On(y, "wheel", ((D) => {
        const P = xr(y.yi.Ga.$a !== !1), V = w(), _ = ge(V.pan, "wheel", D, A, v, b);
        _ && P.push("wheel pan", (() => ((B, z, W) => {
          if (It(z), B.forEachAxisX(((G) => {
            var Y;
            const U = G.cr.chartInteractions;
            U === !1 || typeof U == "object" && U.pan === !1 || W.x && (W.stopScroll !== !1 && G.setStopped(!0), G.pan(-30 * Math.sign(z.deltaY) * ((Y = W.sensitivity) !== null && Y !== void 0 ? Y : 1)));
          })), B.forEachAxisY(((G) => {
            var Y;
            const U = G.cr.chartInteractions;
            U === !1 || typeof U == "object" && U.pan === !1 || W.y && (W.stopScroll !== !1 && G.setStopped(!0), G.pan(-30 * Math.sign(z.deltaY) * ((Y = W.sensitivity) !== null && Y !== void 0 ? Y : 1)));
          })), W.x || W.y) {
            let G = W.cursor;
            if (G !== null) {
              G = G ?? (!W.x && W.y ? Gt.Vertical : W.x && !W.y ? Gt.Horizontal : Gt.Move);
              const U = B.engine.setMouseStyle(G);
              H.setTimeout((() => {
                B.engine.restoreMouseStyle(U);
              }), 500);
            }
            const Y = W.on;
            Y && H.requestAnimationFrame((() => Y({ event: z })));
          }
        })(y, D, _)));
        const O = ge(V.zoom, "wheel", D, A, v, b);
        O && P.push("wheel zoom", (() => ((B, z, W) => {
          It(z), B.forEachAxisX(((U) => {
            var $;
            const Z = U.cr.chartInteractions;
            if (Z === !1 || typeof Z == "object" && Z.zoom === !1 || !W.x) return;
            let q;
            q = W.mode === "keep-start" ? U.getInterval().start : W.mode === "keep-end" ? U.getInterval().end : W.mode === "centered" ? U.ai.Ot((U.ai.wt() + U.ai.kt()) / 2) : B.translateCoordinate(z, { x: U, y: U }).x, U.zoom(q, Math.sign(z.deltaY) * (($ = W.sensitivity) !== null && $ !== void 0 ? $ : 1)), W.stopScroll !== !1 && U.setStopped(!0);
          })), B.forEachAxisY(((U) => {
            var $;
            const Z = U.cr.chartInteractions;
            if (Z === !1 || typeof Z == "object" && Z.zoom === !1 || !W.y) return;
            let q;
            q = W.mode === "keep-start" ? U.getInterval().start : W.mode === "keep-end" ? U.getInterval().end : W.mode === "centered" ? U.ai.Ot((U.ai.wt() + U.ai.kt()) / 2) : B.translateCoordinate(z, { x: U, y: U }).y, U.zoom(q, Math.sign(z.deltaY) * (($ = W.sensitivity) !== null && $ !== void 0 ? $ : 1)), W.stopScroll !== !1 && U.setStopped(!0);
          }));
          const G = W.cursor;
          if (G !== null) {
            let U = typeof G == "function" ? G(z.deltaY < 0 ? "in" : "out") : G;
            if (U !== null) {
              U = U ?? (z.deltaY < 0 ? Gt.ZoomIn : Gt.ZoomOut);
              const $ = B.engine.setMouseStyle(U);
              H.setTimeout((() => {
                B.engine.restoreMouseStyle($);
              }), 500);
            }
          }
          const Y = W.on;
          Y && H.requestAnimationFrame((() => Y({ event: z })));
        })(y, D, O))), P.end();
      })), On(y, "click", ((D) => {
        if (D.defaultPrevented) return;
        const P = xr(y.yi.Ga.$a !== !1), V = w(), _ = ge(V.restoreDefault, void 0, D, A, v, b);
        _ && _.singleClick && P.push("restoreDefault", (() => {
          It(D), Gh(y, _, D);
        }));
        const O = ge(V.restorePrevious, void 0, D, A, v, b);
        O && O.singleClick && P.push("restorePrevious", (() => {
          It(D);
          const B = y.getAxes().filter(((G) => {
            const Y = G.cr.chartInteractions;
            return !(Y === !1 || typeof Y == "object" && Y.restorePrevious === !1);
          }));
          y.restorePreviousZoomState({ whitelist: B });
          let z = O.cursor;
          if (z !== null) {
            z = z ?? Gt.ZoomOut;
            const G = y.engine.setMouseStyle(z);
            H.setTimeout((() => {
              y.engine.restoreMouseStyle(G);
            }), 500);
          }
          const W = O.on;
          W && H.requestAnimationFrame((() => W({ event: D })));
        })), P.end();
      })), On(y, "contextmenu", ((D) => {
        if (D.defaultPrevented) return;
        const P = xr(y.yi.Ga.$a !== !1), V = w(), _ = ge(V.restoreDefault, "rmb", D, A, v, b);
        _ && _.singleClick && P.push("rmb restore default", (() => {
          It(D), Gh(y, _, D);
        }));
        const O = ge(V.restorePrevious, "rmb", D, A, v, b);
        O && O.singleClick && P.push("rmb restore previous", (() => {
          It(D);
          const B = y.getAxes().filter(((G) => {
            const Y = G.cr.chartInteractions;
            return !(Y === !1 || typeof Y == "object" && Y.restorePrevious === !1);
          }));
          y.restorePreviousZoomState({ whitelist: B });
          let z = O.cursor;
          if (z !== null) {
            z = z ?? Gt.ZoomOut;
            const G = y.engine.setMouseStyle(z);
            H.setTimeout((() => {
              y.engine.restoreMouseStyle(G);
            }), 500);
          }
          const W = O.on;
          W && H.requestAnimationFrame((() => W({ event: D })));
        })), P.end();
      })), On(y, "dblclick", ((D) => {
        if (D.defaultPrevented) return;
        const P = xr(y.yi.Ga.$a !== !1), V = w(), _ = ge(V.restoreDefault, void 0, D, A, v, b);
        _ && _.doubleClick && P.push("restoreDefault", (() => {
          It(D), Gh(y, _, D);
        }));
        const O = ge(V.restorePrevious, void 0, D, A, v, b);
        O && O.doubleClick && P.push("restorePrevious", (() => {
          It(D);
          const B = y.getAxes().filter(((G) => {
            const Y = G.cr.chartInteractions;
            return !(Y === !1 || typeof Y == "object" && Y.restorePrevious === !1);
          }));
          y.restorePreviousZoomState({ whitelist: B });
          let z = O.cursor;
          if (z !== null) {
            z = z ?? Gt.ZoomOut;
            const G = y.engine.setMouseStyle(z);
            H.setTimeout((() => {
              y.engine.restoreMouseStyle(G);
            }), 500);
          }
          const W = O.on;
          W && H.requestAnimationFrame((() => W({ event: D })));
        })), P.end();
      }));
      const x = (D, P) => {
        const V = xr(y.yi.Ga.$a !== !1), _ = k(D), O = ge(_.pan, "drag", P, A, v, b);
        O && V.push("axis drag pan", (() => ((W, G, Y, U) => {
          const $ = W.chart, Z = $.getCursorMode();
          let q;
          $.setCursorMode(void 0);
          let Q = Y.cursor;
          Q !== null && (Q = Q ?? (W.isY ? Gt.Vertical : Gt.Horizontal), q = $.engine.setMouseStyle(Q));
          let nt = !1, et = G;
          G.pointerType === "mouse" && G.preventDefault();
          const it = (tt) => {
            var at;
            if (tt.pointerId !== G.pointerId) return;
            It(tt);
            const ut = tt.clientX - et.clientX, ht = tt.clientY - et.clientY;
            et = tt, Y.stopScroll !== !1 && W.setStopped(!0), W.pan((W.isX ? -ut : ht) * ((at = Y.sensitivity) !== null && at !== void 0 ? at : 1)), nt || (sn(), nt = !0);
            const st = Y.on;
            st && H.requestAnimationFrame((() => st({ event: tt })));
          }, rt = (tt) => {
            tt.pointerId === G.pointerId && (It(tt), H.removeEventListener("pointermove", it), H.removeEventListener("pointerup", rt), q = W.chart.engine.restoreMouseStyle(q), U(), W.chart.setCursorMode(Z));
          };
          H.addEventListener("pointermove", it), H.addEventListener("pointerup", rt);
        })(D, P, O, E())));
        const B = ge(_.zoom, "drag", P, A, v, b);
        B && V.push("axis drag zoom", (() => ((W, G, Y, U) => {
          const $ = W.chart;
          let Z;
          const q = Y.cursor;
          if (q !== null) {
            let tt = typeof q == "function" ? q("in") : q;
            tt !== null && (tt = tt ?? Gt.ZoomIn, Z = $.engine.setMouseStyle(tt));
          }
          const Q = $.getCursorMode();
          $.setCursorMode(void 0);
          let nt = !1, et = G;
          G.pointerType === "mouse" && G.preventDefault();
          const it = (tt) => {
            var at;
            if (tt.pointerId !== G.pointerId) return;
            It(tt);
            const ut = { x: tt.clientX - et.clientX, y: tt.clientY - et.clientY };
            let ht;
            et = tt, ht = Y.mode === "keep-start" ? W.getInterval().start : Y.mode === "keep-end" ? W.getInterval().end : W.ai.Ot((W.ai.wt() + W.ai.kt()) / 2);
            const st = 0.05 * W.dh.getWidth({ x: -ut.x, y: ut.y }) * ((at = Y.sensitivity) !== null && at !== void 0 ? at : 1);
            if (W.zoom(ht, st), Y.stopScroll !== !1 && W.setStopped(!0), q !== null) {
              let ct = typeof q == "function" ? q("in") : q;
              ct !== null && (ct = ct ?? (st < 0 ? Gt.ZoomIn : Gt.ZoomOut), Z = $.engine.setMouseStyle(ct, Z));
            }
            nt || (sn(), nt = !0);
            const bt = Y.on;
            bt && H.requestAnimationFrame((() => bt({ event: tt })));
          }, rt = (tt) => {
            tt.pointerId === G.pointerId && (It(tt), H.removeEventListener("pointermove", it), H.removeEventListener("pointerup", rt), Z = $.engine.restoreMouseStyle(Z), $.setCursorMode(Q), U());
          };
          H.addEventListener("pointermove", it), H.addEventListener("pointerup", rt);
        })(D, P, B, E())));
        const z = ge(_.rectangleZoom, void 0, P, A, v, b);
        z && V.push("axis rectangle zoom", (() => ((W, G, Y, U) => {
          const $ = W.chart, Z = $.getCursorMode();
          let q;
          $.setCursorMode(void 0);
          let Q = Y.cursor;
          Q !== null && (Q = Q ?? Gt.ZoomIn, q = $.engine.setMouseStyle(Q));
          const nt = W.addBand({ onTop: !0 }).setPointerEvents(!1).setValueStart(W.dh.getWidth($.translateCoordinate(G, { x: W, y: W }))).setValueEnd(W.dh.getWidth($.translateCoordinate(G, { x: W, y: W }))).setVisible(!1).setFillStyle($.getZoomingRectangleFillStyle()).setStrokeStyle($.getZoomingRectangleStrokeStyle());
          let et = !1, it = !1;
          G.pointerType === "mouse" && G.preventDefault();
          const rt = (at) => {
            if (at.pointerId !== G.pointerId) return;
            It(at), W.setStopped(!0);
            const ut = $.translateCoordinate(at, { x: W, y: W });
            nt.setValueEnd(W.dh.getWidth(ut));
            const ht = ws({ x: at.clientX, y: at.clientY }, { x: W.isX ? G.clientX : at.clientX, y: W.isY ? G.clientY : at.clientY }) >= 20;
            if (nt.setVisible(ht), et || (sn(), et = !0), ht && !it) {
              const st = ht && Y.start;
              st && st({ event: at });
            }
            it = ht;
          }, tt = (at) => {
            var ut, ht;
            if (at.pointerId !== G.pointerId) return;
            It(at);
            const st = ws({ x: at.clientX, y: at.clientY }, { x: W.isX ? G.clientX : at.clientX, y: W.isY ? G.clientY : at.clientY }) >= 20;
            if (st) {
              const ct = W.dh.getWidth($.translateCoordinate(G, { x: W, y: W })), Mt = W.dh.getWidth($.translateCoordinate(at, { x: W, y: W })), vt = Math.sign(Mt - ct), mt = Math.sign(W.getInterval().end - W.getInterval().start), Xt = vt === mt ? ct : Mt, Rt = vt === mt ? Mt : ct;
              W.li(Xt, Rt, (ut = Y.animationsEnabled) !== null && ut !== void 0 ? ut : void 0, (ht = Y.stopScroll) !== null && ht !== void 0 ? ht : void 0, "interactionSetInterval");
            }
            nt.dispose(), H.removeEventListener("pointermove", rt), H.removeEventListener("pointerup", tt), q = $.engine.restoreMouseStyle(q), U(), $.setCursorMode(Z);
            const bt = st && Y.on;
            bt && H.requestAnimationFrame((() => bt({ event: at })));
          };
          H.addEventListener("pointermove", rt), H.addEventListener("pointerup", tt);
        })(D, P, z, E()))), V.end();
      };
      jo(y, "pointerenter", ((D, P) => {
        const V = k(D);
        D.getHighlightOnHover() && (V.pan || V.rectangleZoom || V.restoreDefault || V.zoom) && D.setHighlight(!0);
      })), jo(y, "pointerleave", ((D, P) => {
        D.getHighlightOnHover() && D.setHighlight(!1);
      })), jo(y, "wheel", ((D, P) => {
        const V = xr(y.yi.Ga.$a !== !1), _ = k(D), O = ge(_.zoom, "wheel", P, A, v, b);
        O && V.push("axis wheel zoom", (() => ((z, W, G) => {
          var Y;
          let U;
          It(W), U = G.mode === "keep-start" ? z.getInterval().start : G.mode === "keep-end" ? z.getInterval().end : G.mode === "centered" ? z.ai.Ot((z.ai.wt() + z.ai.kt()) / 2) : z.dh.getWidth(z.chart.translateCoordinate(W, { x: z, y: z })), z.zoom(U, Math.sign(W.deltaY) * ((Y = G.sensitivity) !== null && Y !== void 0 ? Y : 1)), G.stopScroll !== !1 && z.setStopped(!0);
          const $ = G.cursor;
          if ($ !== null) {
            let q = typeof $ == "function" ? $(W.deltaY < 0 ? "in" : "out") : $;
            if (q !== null) {
              q = q ?? (W.deltaY < 0 ? Gt.ZoomIn : Gt.ZoomOut);
              const Q = z.chart.engine.setMouseStyle(q);
              H.setTimeout((() => {
                z.chart.engine.restoreMouseStyle(Q);
              }), 500);
            }
          }
          const Z = G.on;
          Z && H.requestAnimationFrame((() => Z({ event: W })));
        })(D, P, O)));
        const B = ge(_.pan, "wheel", P, A, v, b);
        B && V.push("axis wheel pan", (() => ((z, W, G) => {
          var Y;
          It(W);
          const U = z.chart;
          G.stopScroll !== !1 && z.setStopped(!0), z.pan(30 * Math.sign(W.deltaY) * z.dh.getWidth({ x: -1, y: 1 }) * ((Y = G.sensitivity) !== null && Y !== void 0 ? Y : 1));
          let $ = G.cursor;
          if ($ !== null) {
            $ = $ ?? (z.isY ? Gt.Vertical : Gt.Horizontal);
            const q = U.engine.setMouseStyle($);
            H.setTimeout((() => {
              z.chart.engine.restoreMouseStyle(q);
            }), 500);
          }
          const Z = G.on;
          Z && H.requestAnimationFrame((() => Z({ event: W })));
        })(D, P, B))), V.end();
      })), jo(y, "dblclick", ((D, P) => {
        var V, _;
        if (P.defaultPrevented) return;
        const O = k(D), B = ge(O.restoreDefault, void 0, P, A, v, b);
        if (B && B.doubleClick) {
          It(P), D.fit((V = B.animationsEnabled) !== null && V !== void 0 ? V : void 0, (_ = B.stopScroll) !== null && _ !== void 0 ? _ : void 0);
          let z = B.cursor;
          if (z !== null) {
            z = z ?? Gt.ZoomOut;
            const G = y.engine.setMouseStyle(z);
            H.setTimeout((() => {
              y.engine.restoreMouseStyle(G);
            }), 500);
          }
          const W = B.on;
          W && H.requestAnimationFrame((() => W({ event: P })));
        }
      }));
      const M = (D) => {
        const P = w();
        let V = !1, _ = !1, O = !1;
        for (const G of Object.keys(P)) {
          const Y = P[G];
          if (typeof Y == "object") if (G === "axes" || G === "xAxis" || G === "yAxis") {
            const U = Y;
            if (typeof U != "object") continue;
            for (const $ of Object.keys(U)) {
              const Z = U[$];
              typeof Z == "object" && ("ctrl" in Z && Z.ctrl !== void 0 && (V = !0), "shift" in Z && Z.shift !== void 0 && (_ = !0), "alt" in Z && Z.alt !== void 0 && (O = !0));
            }
          } else "ctrl" in Y && Y.ctrl !== void 0 && (V = !0), "shift" in Y && Y.shift !== void 0 && (_ = !0), "alt" in Y && Y.alt !== void 0 && (O = !0);
        }
        v = D.ctrlKey, A = D.shiftKey, b = D.altKey, (D.key === "Control" && V || D.key === "Shift" && _ || D.key === "Alt" && O) && D.preventDefault();
        const B = ge(P.restorePrevious, void 0, D, A, v, b);
        if (B && B.code === D.code) {
          It(D);
          const G = y.getAxes().filter(((U) => {
            const $ = U.cr.chartInteractions;
            return !($ === !1 || typeof $ == "object" && $.restorePrevious === !1);
          }));
          y.restorePreviousZoomState({ whitelist: G });
          const Y = B.on;
          Y && H.requestAnimationFrame((() => Y({ event: D })));
        }
        const z = ge(P.paginate, void 0, D, A, v, b);
        z && ((G, Y, U) => {
          var $, Z, q, Q;
          const nt = (Z = ($ = U.forward) === null || $ === void 0 ? void 0 : $.code) !== null && Z !== void 0 ? Z : "ArrowLeft", et = (Q = (q = U.backward) === null || q === void 0 ? void 0 : q.code) !== null && Q !== void 0 ? Q : "ArrowRight", it = Y.code === nt ? 1 : Y.code === et ? -1 : 0;
          if (it === 0) return;
          let rt = !1;
          if (G.forEachAxis(((tt) => {
            var at;
            const ut = tt.cr.chartInteractions;
            ut === !1 || typeof ut == "object" && ut.paginate === !1 || tt.isX && !U.x || tt.isY && !U.y || (rt = !0, U.stopScroll !== !1 && tt.setStopped(!0), tt.pan(-it * (tt.Sh > tt.mh ? 1 : -1) * 0.5 * tt.ai.Ct() * ((at = U.sensitivity) !== null && at !== void 0 ? at : 1)));
          })), rt) {
            It(Y);
            let tt = U.cursor;
            if (tt !== null) {
              tt = tt ?? (!U.x && U.y ? Gt.Vertical : U.x && !U.y ? Gt.Horizontal : Gt.Move);
              const ut = G.engine.setMouseStyle(tt);
              H.setTimeout((() => {
                G.engine.restoreMouseStyle(ut);
              }), 500);
            }
            const at = U.on;
            at && H.requestAnimationFrame((() => at({ event: Y })));
          }
        })(y, D, z);
        const W = ge(P.restoreDefault, void 0, D, A, v, b);
        if (W && W.code === D.code) {
          It(D), y.getAxes().forEach(((Y) => {
            var U, $;
            const Z = Y.cr.chartInteractions;
            Z === !1 || typeof Z == "object" && Z.restoreDefault === !1 || Y.fit((U = W.animationsEnabled) !== null && U !== void 0 ? U : void 0, ($ = W.stopScroll) !== null && $ !== void 0 ? $ : void 0);
          }));
          const G = W.on;
          G && H.requestAnimationFrame((() => G({ event: D })));
        }
      }, C = (D) => {
        v = D.ctrlKey, A = D.shiftKey, b = D.altKey;
      }, S = () => {
        v = !1, A = !1, b = !1;
      };
      H.addEventListener("keydown", M), H.addEventListener("keyup", C), H.addEventListener("blur", S), y.addEventListener("dispose", (() => {
        H.removeEventListener("keydown", M), H.removeEventListener("keyup", C), H.removeEventListener("blur", S);
      }));
      const E = () => (T(), I(), F(), () => {
        T = On(y, "pointermove", R), I = On(y, "pointerdown", L), F = jo(y, "pointerdown", x);
      });
      let T = On(y, "pointermove", R), I = On(y, "pointerdown", L), F = jo(y, "pointerdown", x);
      return { setUserInteractions: (D) => {
        if (D === void 0) m = { pan: !1, zoom: !1, rectangleZoom: !1, restoreDefault: !1, restorePrevious: !1, axes: !1, xAxis: !1, yAxis: !1 };
        else if (Object.keys(D).length === 0) m = {};
        else for (const P of Object.keys(D)) D[P] === !1 || typeof D[P] == "object" ? m[P] = D[P] : m[P] = {};
      }, getUserInteractions: w };
    })(this);
    const g = { ...n?.legend };
    this.legend.setOptions(g);
  }
  get coordsAxis() {
    return { x: this.getDefaultAxisX(), y: this.getDefaultAxisY() };
  }
  getSeries() {
    return this.Ny.slice();
  }
  restorePreviousZoomState(t) {
    if (this.Wm.length <= 1) return this;
    this.Wm.pop();
    const e = this.Wm[this.Wm.length - 1];
    return e ? (this.zw = H.performance.now(), this.forEachAxis(((i) => {
      if (t?.whitelist && !t.whitelist.includes(i)) return;
      const s = e.get(i);
      s ? i.li(s.start, s.end, t?.animate, t?.stopAxisAfter !== void 0 ? t.stopAxisAfter : s.stopped, "userSetInterval") : i.fit(t?.animate, t?.stopAxisAfter);
    })), this) : this;
  }
  clearPreviousZoomStateHistory() {
    if (this.SS !== void 0) this.Wm.length = 0;
    else for (; this.Wm.length > 1; ) this.Wm.unshift();
    return this;
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  solveNearest(t, e = this.getCursorMode() || "show-nearest") {
    return this.AS.solveNearest(t, e, this.Ny, this.Fw);
  }
  addCursor(t = Wg) {
    const e = this.tv(), i = t.zm(e, this.Mw, this.Mw, this.Jg(e), this.xi);
    return i.T_ = !0, this.cv(i), i;
  }
  getMinimumSize() {
    var t;
    const e = { x: 0, y: 0 };
    e.x += this.dt.left + this.dt.right + this.Hn.left + this.Hn.right, e.y += this.dt.top + this.dt.bottom + this.Hn.top + this.Hn.bottom;
    const i = this.Wr.Uh().Bc(), s = pa(jg(this.jA || Yg, (t = this.xi.chartXYTitleMargin) !== null && t !== void 0 ? t : 5), this.gv);
    return e.x += i.x + s.left + s.right, e.y += i.y + s.top + s.bottom, this.Vw && (e.x += this.Vw.left, e.x += this.Vw.right, e.y += this.Vw.top, e.y += this.Vw.bottom), e.x += Hg.x, e.y += Hg.y, e;
  }
  getLayout() {
    const t = this.Nw;
    return this.yi.Gw() || !t ? new Promise(((e) => {
      this.addEventListener("layoutchange", e, { once: !0 }), this.Nw = void 0;
    })) : new Promise(((e) => {
      e(t);
    }));
  }
  addAxisX(t) {
    var e, i;
    const { opposite: s, type: o } = xd(t);
    let n;
    n = o.type === "linear" ? this.Kg.d1({ dimension: "x", scale1DConstructor: ts }) : o.type === "linear-highPrecision" ? this.Kg.d1({ dimension: "x", scale1DConstructor: ts }).Vt() : this.Kg.d1({ dimension: "x", scale1DConstructor: Jn }).ns(o.base), n.K(this.Mw.x.Ft());
    const a = s ? this.ZA : this.JA, l = new wu(this.Rw, this.uA, this.yv, this.cA, this.dA, this.yi.bs, n, this.Mw.y, (h = () => l.DA(), { ...jl, ...g5(h) }), this, s ? 100 : 0, this.fA, this.Bw, this.xi, this.zr, o);
    var h;
    let u, c;
    return t?.iParallel === void 0 && t?.iStack === void 0 ? (u = a.reduce(((d, f) => Math.max(d, f.iParallel + 1)), 0), c = 0) : (u = (e = t.iParallel) !== null && e !== void 0 ? e : 0, c = (i = t.iStack) !== null && i !== void 0 ? i : 0), a.push({ axis: l, iStack: c, iParallel: u }), this.yi.Rs(), this.D.R("axisadd", { axis: l }), this.mS(l), l;
  }
  addAxisY(t) {
    var e, i;
    const { opposite: s, type: o } = xd(t);
    let n;
    n = o.type === "linear" ? this.Kg.d1({ dimension: "y", scale1DConstructor: ts }) : o.type === "linear-highPrecision" ? this.Kg.d1({ dimension: "y", scale1DConstructor: ts }).Vt() : this.Kg.d1({ dimension: "y", scale1DConstructor: Jn }).ns(o.base), n.K(this.Mw.y.Ft());
    const a = s ? this.QA : this.KA, l = new wu(this.Rw, this.uA, this.yv, this.cA, this.dA, this.yi.bs, n, this.Mw.x, (h = () => l.DA(), { ...ec, ...p5(h) }), this, s ? 100 : 0, this.fA, this.Bw, this.xi, this.zr, o);
    var h;
    let u, c;
    return t?.iParallel === void 0 && t?.iStack === void 0 ? (u = a.reduce(((d, f) => Math.max(d, f.iParallel + 1)), 0), c = 0) : (u = (e = t.iParallel) !== null && e !== void 0 ? e : 0, c = (i = t.iStack) !== null && i !== void 0 ? i : 0), a.push({ axis: l, iParallel: u, iStack: c }), this.yi.Rs(), this.D.R("axisadd", { axis: l }), this.mS(l), l;
  }
  mS(t) {
    const e = () => {
      const i = H.performance.now();
      this.zw !== void 0 && i - this.zw <= 1e3 || t.getVisible() && (this.$w = i + 300);
    };
    H.requestAnimationFrame((() => {
      e();
    })), t.addEventListener("intervalchange", e), t.addEventListener("dispose", (() => {
      this.Wm.forEach(((i) => {
        i.delete(t);
      }));
    }));
  }
  swapAxes(t, e) {
    const i = [this.JA, this.KA, this.QA, this.ZA], s = i.find(((d) => d.find(((f) => f.axis === t)) !== void 0)), o = i.find(((d) => d.find(((f) => f.axis === e)) !== void 0));
    if (!s || !o) return this;
    if (s !== o) throw new Error("LightningChart JS ChartXY.swapAxes does not support swapping Axes that are on different sides.");
    const n = s.find(((d) => d.axis === t)), a = s.find(((d) => d.axis === e));
    if (!n || !a) return this;
    const l = n.iParallel, h = n.iStack;
    n.iParallel = a.iParallel, n.iStack = a.iStack, a.iParallel = l, a.iStack = h, this.Nw = void 0;
    const u = [];
    this.legend.getEntries().forEach(((d) => {
      if (d.component && d.component instanceof No) {
        const f = d.component.axisX, p = d.component.axisY, g = s.find(((y) => y.axis === f || y.axis === p));
        g && u.push({ iStack: g.iStack, entry: d.component });
      }
    }));
    const c = u.sort(((d, f) => f.iStack - d.iStack)).map(((d) => d.entry));
    return this.Ns.forEach(((d) => d.Ng(c))), this.yi.Rs(), this;
  }
  dispose() {
    return this.AS.G(), this.Ew.G(), this.zS.G(), this.uA.G(), this.Rw.forEach(((t) => t.G())), this.dA.G(), this.cA.G(), this.H_().forEach(((t) => t.dispose())), wa(this.Mw), this.JA.slice().forEach(((t) => t.axis.dispose())), this.KA.slice().forEach(((t) => t.axis.dispose())), this.QA.slice().forEach(((t) => t.axis.dispose())), this.ZA.slice().forEach(((t) => t.axis.dispose())), this.Ny.slice().forEach(((t) => {
      t.dispose();
    })), super.dispose();
  }
  getDefaultAxisX() {
    var t;
    return (t = [...this.JA, ...this.ZA].find(((e) => e.axis.getVisible()))) === null || t === void 0 ? void 0 : t.axis;
  }
  get axisX() {
    return this.getDefaultAxisX();
  }
  get xAxis() {
    return this.getDefaultAxisX();
  }
  getDefaultAxisY() {
    var t;
    return (t = [...this.KA, ...this.QA].find(((e) => e.axis.getVisible()))) === null || t === void 0 ? void 0 : t.axis;
  }
  get axisY() {
    return this.getDefaultAxisY();
  }
  get yAxis() {
    return this.getDefaultAxisY();
  }
  getDefaultAxes() {
    return [this.getDefaultAxisX(), this.getDefaultAxisY()];
  }
  getAxes(...t) {
    const e = t && t.length > 0 ? new Set(t) : v5;
    return vu(Array.from(e).map(((i) => {
      switch (i) {
        default:
        case hn.Top:
          return this.ZA.slice().sort(((s, o) => s.iStack - o.iStack)).map(((s) => s.axis));
        case hn.Bottom:
          return this.JA.slice().sort(((s, o) => s.iStack - o.iStack)).map(((s) => s.axis));
        case hn.Left:
          return this.KA.slice().sort(((s, o) => s.iStack - o.iStack)).map(((s) => s.axis));
        case hn.Right:
          return this.QA.slice().sort(((s, o) => s.iStack - o.iStack)).map(((s) => s.axis));
      }
    })));
  }
  Uw(t) {
    let e;
    return this.forEachAxisX(((i) => {
      e = t === i ? "x" : e;
    })), this.forEachAxisY(((i) => {
      e = t === i ? "y" : e;
    })), e;
  }
  forEachAxisX(t) {
    this.JA.forEach(((e, i, s) => t(e.axis, i, s.map(((o) => o.axis))))), this.ZA.forEach(((e, i, s) => t(e.axis, i, s.map(((o) => o.axis)))));
  }
  forEachAxisY(t) {
    this.KA.forEach(((e, i, s) => t(e.axis, i, s.map(((o) => o.axis))))), this.QA.forEach(((e, i, s) => t(e.axis, i, s.map(((o) => o.axis)))));
  }
  setTitlePosition(t) {
    return this.jA = t, this.Ns.forEach(((e) => e.Gs())), this.yi.Rs(), this;
  }
  getTitlePosition() {
    return this.jA;
  }
  rr(t, e = !1) {
    var i;
    super.rr(t);
    const s = H.performance.now();
    this.$w !== void 0 && this.$w <= s && (this.Zm(), this.$w = void 0);
    for (const _ of this.Ny) _.Dv();
    for (const _ of this.Ny) _.rr();
    const o = Mr(this.Ny.map(((_) => _.Al()))), n = new Set(o.map(((_) => _.pw)));
    if (n.size === 1) {
      const _ = Array.from(n)[0], O = _ === "x" ? [this.JA, this.ZA] : [this.KA, this.QA], B = _ === "y" ? [this.JA, this.ZA] : [this.KA, this.QA];
      O.forEach(((z) => z.forEach(((W) => W.axis.bn())))), B.forEach(((z) => z.forEach(((W) => W.axis.bn()))));
    } else this.KA.forEach(((_) => _.axis.bn())), this.JA.forEach(((_) => _.axis.bn())), this.ZA.forEach(((_) => _.axis.bn())), this.QA.forEach(((_) => _.axis.bn()));
    let a = !1;
    this.forEachAxis(((_) => {
      (_.kn() || _.Cn()) && (a = !0);
    }));
    const l = !this.ww && a, h = new Set(this.getAxes().map(((_) => _.getStackIndex()))).size > 1;
    this.AS.rr(l, h ? this.Ny.sort(((_, O) => O.axisY.getStackIndex() - _.axisY.getStackIndex())) : this.Ny, this.Fw, { afterCursorPointedAt: (_) => {
      const O = this.yi.Ra();
      if (_.length > 1 && O) {
        const B = this.yi.ul(O);
        this.AS.jw.Tm({ x: B.engineX, y: B.engineY }, this.yi.ai);
      }
    }, overrideCursorPositions: (_, O) => _.map(((B) => B.multiHit ? B.multiHit.map(((z) => ({ ...B.cursorPosition, pointMarker: z }))) : [B.cursorPosition])).flat() });
    const u = (_, O, B, z, W = {}) => {
      const G = E5(_);
      let Y = 0;
      const U = [];
      return { parallels: G.parallels.map(((Z) => {
        const q = Z.stacks.reduce(((at, ut) => {
          var ht, st;
          return at + (ut.axis.getVisible() ? ((ht = ut.axis.YA) !== null && ht !== void 0 ? ht : 0) + ((st = ut.axis.HA) !== null && st !== void 0 ? st : 0) : 0);
        }), 0), Q = Z.stacks.reduce(((at, ut) => at + (ut.axis.getVisible() && "pixels" in ut.axis.Rf ? ut.axis.Rf.pixels : 0)), 0), nt = O - q - Q;
        let et = 0;
        const it = Z.stacks.map(((at) => {
          var ut, ht;
          const st = at.axis, bt = st.getVisible(), ct = Math.max(O - et, 0), Mt = Math.min(bt ? "pixels" in st.Rf ? st.Rf.pixels : st.Rf.relative / Z.sumRelativeSize * nt : 0, ct), vt = Z.stacks.length, mt = { ...W, availableSpace: O, stack: at, axisLength: Mt, axisLengthOffset: et, axisThicknessOffset: Y, stackAxisCount: vt }, Xt = z(mt, U);
          return U.push({ ...mt, ...Xt }), bt && (et += Mt + ((ut = st.YA) !== null && ut !== void 0 ? ut : 0) + ((ht = st.HA) !== null && ht !== void 0 ? ht : 0)), { ...Xt, stack: at, axis: st };
        })), rt = it.reduce(((at, ut) => ut.axis.getVisible() ? Math.max(at, ut.OA) : at), 0), tt = it.reduce(((at, ut) => Math.max(at, ut.EA)), 0);
        return it.forEach(((at) => {
          at.EA = tt;
        })), Y += rt * B, { ...Z, stacks: it };
      })), thicknessTotal: Math.abs(Y) };
    }, c = this.getTitleFillStyle() !== Lt && this.getTitle().length > 0, d = c ? this.Wr.Uh().Bc() : { y: 0 }, f = pa(jg(this.jA, (i = this.xi.chartXYTitleMargin) !== null && i !== void 0 ? i : 5), this.gv), p = c ? A5(this.jA, d, f) : Me, g = this.Ns.reduce(((_, O) => {
      const B = O.Uh(p, this.Hn);
      return { top: Math.max(_.top, B.top), bottom: Math.max(_.bottom, B.bottom), left: Math.max(_.left, B.left), right: Math.max(_.right, B.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 }), y = this.Mw.x.getCellSize() - (this.Hn.left + this.Hn.right + p.left + p.right) - g.left - g.right, m = this.Mw.y.getCellSize() - (this.Hn.top + this.Hn.bottom + p.bottom + p.top) - g.top - g.bottom, A = /* @__PURE__ */ new Map(), v = (_, O) => {
      const B = !!O.find(((W) => W.updatedTicks === !0)), z = { physicalAxisSize: _.axisLength, VA: _.axisLength, Yw: _.axisLengthOffset, NA: _.axisThicknessOffset, anyPreviousAxisUpdated: B, WA: _.stackAxisCount };
      return _.stack.axis.Uh(z);
    }, b = u(this.KA, m, -1, v), w = u(this.QA, m, 1, v), k = u(this.JA, y, -1, v), R = u(this.ZA, y, 1, v), L = [this.Hn.left + p.left + b.thicknessTotal + g.left, this.Hn.right + p.right + w.thicknessTotal + g.right], x = [this.Hn.bottom + k.thicknessTotal + p.bottom + g.bottom, this.Hn.top + p.top + R.thicknessTotal + g.top], M = this.Mw.x.getCellSize() - (L[0] + L[1]), C = this.Mw.y.getCellSize() - (x[0] + x[1]);
    this.Mw.x.Z(0, M), this.Mw.y.Z(0, C), this.Mw.x._t(L), this.Mw.y._t(x), super.dv();
    const S = [...b.parallels, ...k.parallels, ...w.parallels, ...R.parallels].map(((_) => _.stacks)).flat(), E = (_) => {
      var O, B;
      const z = _.stack.axis, W = S.find((($) => $.axis === z));
      if (!W) throw new Error("LightningChart JS unexpected runtime error");
      const G = z.getVisible() ? _.margins[0] + _.axisLengthOffset + ((O = z.YA) !== null && O !== void 0 ? O : 0) : 0, Y = z.getVisible() ? _.margins[1] + (_.availableSpace - _.axisLengthOffset) - _.axisLength - ((B = z.YA) !== null && B !== void 0 ? B : 0) : 0;
      z.ai._t([G, Y]);
      const U = _.stack.axis.rr(W);
      return A.set(_.stack.axis, U), W;
    }, T = y - (b.thicknessTotal + w.thicknessTotal), I = m - (k.thicknessTotal + R.thicknessTotal);
    u(this.KA, I, -1, E, { margins: x }), u(this.QA, I, 1, E, { margins: x }), u(this.JA, T, -1, E, { margins: L }), u(this.ZA, T, 1, E, { margins: L }), this.Vw = { left: b.thicknessTotal, top: R.thicknessTotal, right: w.thicknessTotal, bottom: k.thicknessTotal };
    const F = { chartWidth: this.Mw.x.getCellSize(), chartHeight: this.Mw.y.getCellSize(), viewportWidth: M, viewportHeight: C, margins: { left: L[0], right: L[1], bottom: x[0], top: x[1] }, axes: A }, D = this.Nw;
    if (e) this.D.R("layoutchange", { ...F, userChangedLayout: () => {
    } });
    else if (!D || Math.abs(D.chartWidth - F.chartWidth) >= 1 || Math.abs(D.chartHeight - F.chartHeight) >= 1 || Math.abs(D.viewportWidth - F.viewportWidth) >= 1 || Math.abs(D.viewportHeight - F.viewportHeight) >= 1 || this.getAxes().find(((_) => {
      var O, B, z, W, G, Y, U, $, Z, q, Q, nt;
      const et = D.axes.get(_), it = F.axes.get(_);
      if (Math.abs(((O = et?.width) !== null && O !== void 0 ? O : 0) - ((B = it?.width) !== null && B !== void 0 ? B : 0)) >= 1 || Math.abs(((z = et?.height) !== null && z !== void 0 ? z : 0) - ((W = it?.height) !== null && W !== void 0 ? W : 0)) >= 1 || Math.abs(((G = et?.left) !== null && G !== void 0 ? G : 0) - ((Y = it?.left) !== null && Y !== void 0 ? Y : 0)) >= 1 || Math.abs(((U = et?.right) !== null && U !== void 0 ? U : 0) - (($ = it?.right) !== null && $ !== void 0 ? $ : 0)) >= 1 || Math.abs(((Z = et?.bottom) !== null && Z !== void 0 ? Z : 0) - ((q = it?.bottom) !== null && q !== void 0 ? q : 0)) >= 1 || Math.abs(((Q = et?.top) !== null && Q !== void 0 ? Q : 0) - ((nt = it?.top) !== null && nt !== void 0 ? nt : 0)) >= 1) return _;
    }))) {
      let _ = !1;
      const O = () => {
        _ = !0;
      };
      if (this.D.R("layoutchange", { ...F, userChangedLayout: O }), this.Xg || _) return this.engine.layout(), this.Lw({ width: this.uiScale.Ft().x, height: this.uiScale.Ft().y, engineWidth: this.yi.ai.Ft().x, engineHeight: this.yi.ai.Ft().y }), this.Xg = !0, void this.rr(t, !0);
    }
    this.Nw = F, this.Yy.hr(j(0, 0)).K(j(M, C)), this.Hy.hr(j(0, 0)).K(j(M, C));
    const P = b5(this.jA, d, f, this.uiScale.ni(), this.Hn, L, x, g);
    this.Wr.hr(P.position).Tn(P.margin).ql(P.horizontalAlignment).su(P.verticalAlignment), this.Ns.forEach(((_) => _.rr(p, this.Hn)));
    const V = Af(this.Mw.x.wt(), this.Mw.y.wt(), this.Mw.x.Ct(), this.Mw.y.Ct());
    this.zS.Qm(V), this.cA.Qm(V), this.dA.Qm(V), this.Yg && this.Yg();
    for (const _ of this.Ny) _.Ev();
  }
  xw(t) {
    const e = Mr(this.Ny.map(((s) => s.Al()))), i = new Set(e.map(((s) => s.pw)));
    if (i.size === 1) {
      const s = Array.from(i)[0], o = s === "x" ? [this.JA, this.ZA] : [this.KA, this.QA], n = s === "y" ? [this.JA, this.ZA] : [this.KA, this.QA];
      o.forEach(((a) => a.forEach(((l) => {
        const h = t.get(l.axis);
        h && l.axis.fit(h.animate, h.stopAxisAfter);
      })))), e.forEach(((a) => a.mw())), n.forEach(((a) => a.forEach(((l) => {
        const h = t.get(l.axis);
        h && (l.axis.getScrollStrategy() && l.axis.getDefaultInterval() === void 0 ? l.axis.setStopped(!1) : l.axis.fit(h.animate, h.stopAxisAfter));
      }))));
    } else t.forEach(((s, o) => o.fit(s?.animate, s?.stopAxisAfter)));
  }
  W() {
    for (let t = 0; t < this.JA.length; t += 1) this.JA[t].axis.W();
    for (let t = 0; t < this.ZA.length; t += 1) this.ZA[t].axis.W();
    for (let t = 0; t < this.KA.length; t += 1) this.KA[t].axis.W();
    for (let t = 0; t < this.QA.length; t += 1) this.QA[t].axis.W();
    return super.W();
  }
  Dw(t) {
    if (this._w.has(t)) return this._w.get(t);
    throw new Error("No attach handler for axis Make sure that passed axes definitely belong to this chart and that they haven't been disposed of.");
  }
  addPointLineAreaSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY();
    Nn(e, i);
    const s = new Co(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, this.xi, this.yi.bs, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, t);
    return this.Wy(s, t), s;
  }
  addLineSeries(t) {
    return this.addPointLineAreaSeries(t).setAreaFillStyle(Lt).setPointFillStyle(Lt);
  }
  addPointSeries(t) {
    return this.addPointLineAreaSeries(t).setAreaFillStyle(Lt).setStrokeStyle(Et);
  }
  addPointLineSeries(t) {
    return this.addPointLineAreaSeries(t).setAreaFillStyle(Lt);
  }
  addStepSeries(t) {
    return this.addPointLineAreaSeries(t).setAreaFillStyle(Lt).setCurvePreprocessing({ type: "step" });
  }
  addSplineSeries(t) {
    return this.addPointLineAreaSeries(t).setAreaFillStyle(Lt).setCurvePreprocessing({ type: "spline" });
  }
  addAreaSeries(t) {
    return this.addPointLineAreaSeries(t).setPointFillStyle(Lt);
  }
  addRectangleSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY();
    Nn(e, i);
    const s = new s5(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, this.xi, this.yi.bs, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, t);
    return this.Wy(s, t), s;
  }
  addPolygonSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY(), s = new i5(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, this.xi, this.yi.bs, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length);
    return this.Wy(s, t), s;
  }
  addSegmentSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY();
    Nn(e, i);
    const s = new r5(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, this.xi, this.yi.bs, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length);
    return this.Wy(s, t), s;
  }
  addEllipseSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY();
    Nn(e, i);
    const s = new e5(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, this.xi, this.yi.bs, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length);
    return this.Wy(s, t), s;
  }
  addBoxSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY();
    Nn(e, i);
    const s = t && t.dimensionStrategy ? t.dimensionStrategy : jl, o = new t5(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, s, this.xi, this.yi.bs, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length);
    return this.Wy(o, t), o;
  }
  addTextSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY();
    Nn(e, i);
    const s = new n5(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, this.xi, this.yi.bs, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length);
    return this.Wy(s, t), s;
  }
  addHeatmapGridSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY();
    let s;
    if (t.heatmapDataType !== void 0 && t.heatmapDataType !== "intensity") throw new Error(`Unsupported Heatmap Grid heatmapDataType: '${t.heatmapDataType}'`);
    return s = new l5(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, t, this.xi, this.yi.bs, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length), this.Wy(s, t), s;
  }
  addHeatmapScrollingGridSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY();
    let s;
    if (t.heatmapDataType !== void 0 && t.heatmapDataType !== "intensity") throw new Error(`Unsupported Heatmap Grid heatmapDataType: '${t.heatmapDataType}'`);
    return s = new u5(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, t, this.xi, this.yi.bs, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length), this.Wy(s, t), s;
  }
  addOHLCSeries(t) {
    const e = t?.axisX || t?.xAxis || this.getDefaultAxisX(), i = t?.axisY || t?.yAxis || this.getDefaultAxisY();
    Nn(e, i);
    const s = new (t && t.type ? t.type : f5.Candlesticks)(this, this.$y, this.zS, e, i, this.Dw(e), this.Dw(i), this.tv, this.xi, this.yi.bs);
    return this.Wy(s, t), s;
  }
  addOnScreenMenu(t, e) {
    return new x5(this.Qg, t, this, e);
  }
  setZoomingRectangleFillStyle(t) {
    return this.Cw = typeof t == "function" ? t(this.Cw) : t, this.yi.Rs(), this;
  }
  getZoomingRectangleFillStyle() {
    return this.Cw;
  }
  setZoomingRectangleStrokeStyle(t) {
    return this.Tw = typeof t == "function" ? t(this.Tw) : t, this.yi.Rs(), this;
  }
  getZoomingRectangleStrokeStyle() {
    return this.Tw;
  }
  pan(t) {
    this.forEachAxisX(((e) => {
      e.setStopped(!0).pan(t.x);
    })), this.forEachAxisY(((e) => {
      e.setStopped(!0).pan(t.y);
    }));
  }
  zoom(t, e) {
    this.forEachAxis(S5), this.forEachAxisX(((i) => {
      i.zoom(i.ai.Ot(t.x), e.x);
    })), this.forEachAxisY(((i) => {
      i.zoom(i.ai.Ot(t.y), e.y);
    }));
  }
  setAnimationsEnabled(t) {
    return super.setAnimationsEnabled(t), this.forEachAxis(((e) => e.setAnimationsEnabled(t))), this;
  }
  Gg() {
    const t = [];
    return this.forEachAxis(((e) => e.IA(((i) => t.push(i))))), super.Gg().concat(t);
  }
  H_() {
    return this.kw;
  }
  We() {
    return this.Sv(this.zS);
  }
  setCursorEnabledDuringAxisAnimation(t) {
    return this.ww = t, this;
  }
  getCursorEnabledDuringAxisAnimation() {
    return this.ww;
  }
  forEachAxis(t) {
    return this.forEachAxisX(t), this.forEachAxisY(t), this;
  }
  translateCoordinate(t, e, i) {
    if (i) {
      const s = t, o = e, n = na(o) ? o : kr(o) ? this.xA : void 0;
      if (n && Mo(i)) {
        const a = xt(s, n, this.yi.ai);
        return this.yi.cl({ engineX: a.x, engineY: a.y });
      }
      if (n && kr(i)) return xt(s, n, this.xA);
      if (n && na(i)) return xt(s, n, i);
    } else {
      const s = t;
      if (kr(e)) {
        const o = this.yi.ul(s);
        return xt({ x: o.engineX, y: o.engineY }, this.yi.ai, this.xA);
      }
      if (na(e)) {
        const o = e, n = this.yi.ul(s);
        return xt({ x: n.engineX, y: n.engineY }, this.yi.ai, o);
      }
    }
    throw new Error("translateCoordinate unexpected error. Input or target coordinate system not recognized.");
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i), t === "layoutchange" && this.Nw && e({ ...this.Nw, userChangedLayout: () => {
    } });
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  setUserInteractions(t) {
    return this.gS.setUserInteractions(t), this;
  }
  getUserInteractions() {
    return this.gS.getUserInteractions();
  }
}
(function(r) {
  r.CenterTop = "center-top", r.RightTop = "right-top", r.LeftTop = "left-top", r.CenterBottom = "center-bottom", r.RightBottom = "right-bottom", r.LeftBottom = "left-bottom", r.SeriesCenterTop = "series-center-top", r.SeriesRightTop = "series-right-top", r.SeriesLeftTop = "series-left-top", r.SeriesCenterBottom = "series-center-bottom", r.SeriesRightBottom = "series-right-bottom", r.SeriesLeftBottom = "series-left-bottom";
})(wd || (wd = {}));
const Yg = wd.CenterTop, jg = (r, t) => {
  switch (r) {
    case "center-top":
    case "series-center-bottom":
      return { left: 0, right: 0, top: 0, bottom: t };
    case "left-top":
      return { left: 20, right: 0, top: 0, bottom: t };
    case "right-top":
      return { left: 0, right: 20, top: 0, bottom: t };
    case "center-bottom":
      return { left: 0, right: 0, top: 0, bottom: 0 };
    case "left-bottom":
      return { left: 20, right: 0, top: 0, bottom: 0 };
    case "right-bottom":
      return { left: 0, right: 20, top: 0, bottom: 0 };
    case "series-center-top":
      return { left: 0, right: 0, top: t, bottom: 0 };
    case "series-left-top":
      return { left: t, right: 0, top: t, bottom: 0 };
    case "series-right-top":
      return { left: 0, right: t, top: t, bottom: 0 };
    case "series-left-bottom":
      return { left: t, right: 0, top: 0, bottom: t };
    case "series-right-bottom":
      return { left: 0, right: t, top: 0, bottom: t };
  }
  return Oa(0, `Unexpected ChartXY title position selection ${r}`);
}, A5 = (r, t, e) => {
  switch (r) {
    case "center-top":
    case "left-top":
    case "right-top":
      return { top: t.y + e.top + e.bottom, right: 0, bottom: 0, left: 0 };
    case "center-bottom":
    case "left-bottom":
    case "right-bottom":
      return { bottom: t.y + e.top + e.bottom, right: 0, left: 0, top: 0 };
    default:
      return Me;
  }
}, b5 = (r, t, e, i, s, o, n, a) => {
  const l = (e.left - e.right) * i.x, h = (e.bottom - e.top) * i.y, u = { top: 0, left: a.left + s.left, right: a.right + s.right, bottom: 0 };
  switch (r) {
    case "center-top":
      return { horizontalAlignment: 0, verticalAlignment: 1, position: { x: 50 + l, y: 100 - (s.top + e.top) * i.y }, margin: u };
    case "left-top":
      return { horizontalAlignment: -1, verticalAlignment: 1, position: { x: l, y: 100 - (s.top - e.top) * i.y }, margin: u };
    case "right-top":
      return { horizontalAlignment: 1, verticalAlignment: 1, position: { x: 100 + l, y: 100 - (s.top - e.top) * i.y }, margin: u };
    case "center-bottom":
      return { horizontalAlignment: 0, verticalAlignment: -1, position: { x: 50 + l, y: (s.bottom + e.bottom) * i.y }, margin: u };
    case "left-bottom":
      return { horizontalAlignment: -1, verticalAlignment: -1, position: { x: l, y: (s.bottom + e.bottom) * i.y }, margin: u };
    case "right-bottom":
      return { horizontalAlignment: 1, verticalAlignment: -1, position: { x: 100 + l, y: (s.bottom + e.bottom) * i.y }, margin: u };
    case "series-center-top":
      return { horizontalAlignment: 0, verticalAlignment: 1, position: { x: 50 + l, y: 100 - n[1] * i.y + h }, margin: u };
    case "series-left-top":
      return { horizontalAlignment: -1, verticalAlignment: 1, position: { x: o[0] * i.x + l, y: 100 - n[1] * i.y + h }, margin: Me };
    case "series-right-top":
      return { horizontalAlignment: 1, verticalAlignment: 1, position: { x: 100 - o[1] * i.x + l, y: 100 - n[1] * i.y + h }, margin: Me };
    case "series-center-bottom":
      return { horizontalAlignment: 0, verticalAlignment: -1, position: { x: 50, y: n[0] * i.y + h }, margin: u };
    case "series-left-bottom":
      return { horizontalAlignment: -1, verticalAlignment: -1, position: { x: o[0] * i.x + l, y: n[0] * i.y + h }, margin: Me };
    case "series-right-bottom":
      return { horizontalAlignment: 1, verticalAlignment: -1, position: { x: 100 - o[1] * i.x + l, y: n[0] * i.y + h }, margin: Me };
  }
  return Oa(0, `Unexpected ChartXY title position selection ${r}`);
}, E5 = (r) => {
  const t = [];
  r.forEach(((i, s) => {
    const o = t.find(((n) => n.iParallel === i.iParallel));
    o ? (o.stacks.push({ ...i }), o.stacks.sort(((n, a) => n.iStack - a.iStack))) : t.push({ iParallel: i.iParallel, stacks: [{ ...i }] });
  }));
  const e = t.map(((i) => {
    const s = i.stacks.reduce(((o, n) => o + (n.axis.getVisible() && "relative" in n.axis.Rf ? n.axis.Rf.relative : 0)), 0);
    return { ...i, sumRelativeSize: s };
  }));
  return e.sort(((i, s) => i.iParallel - s.iParallel)), { parallels: e };
}, M5 = (r, t, e) => {
  var i;
  const s = Array.from(new Set(e.map(((a) => a.series.Cs())))), o = s.length === 1 && s[0] !== void 0 ? s[0] : void 0, n = o === "ProgressiveY" || o === "RegressiveY" ? { progressiveDimension: t.axisY.getTitle() || void 0, progressiveAxis: t.axisY, valueDimension: t.axisX.getTitle() || void 0, hitValueAxis: (a) => a.axisX, value: (a) => a.x, position: (a) => a.y } : { progressiveDimension: t.axisX.getTitle() || void 0, progressiveAxis: t.axisX, valueDimension: t.axisY.getTitle() || void 0, hitValueAxis: (a) => a.axisY, value: (a) => a.y, position: (a) => a.x };
  return BS(t) ? Gr(t, [[{ component: t.series, componentColor: un(t), rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [r.getDefaultAxisX().getTitle() || "X", "", { text: Ai(t.axisX.formatValue(t.x), t.axisX), font: { weight: "bold" } }], [r.getDefaultAxisY().getTitle() || "Y", "", { text: Ai(t.axisY.formatValue(t.y), t.axisY), font: { weight: "bold" } }], t.intensity !== void 0 ? ["Value", "", { text: Ai(t.lut ? va(t.lut, t.intensity) : t.intensity.toFixed(2), (i = t.lut) === null || i === void 0 ? void 0 : i.units), font: { weight: "bold" } }] : []]) : o ? [[{ text: Ai(n.progressiveAxis.formatValue(n.position(t)), n.progressiveAxis), rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], ...e.map(((a) => a.multiHit ? Gr(a, [[{ component: a.series, componentColor: un(a) }, ""], [...n.valueDimension ? [`${n.valueDimension}1`, ""] : [], { text: Ai(n.hitValueAxis(a).formatValue(n.value(a.multiHit[0])), n.hitValueAxis(a)), font: { weight: "bold" } }], [...n.valueDimension ? [`${n.valueDimension}2`, ""] : [], { text: Ai(n.hitValueAxis(a).formatValue(n.value(a.multiHit[1])), n.hitValueAxis(a)), font: { weight: "bold" } }]]) : Gr(a, [[{ component: a.series, componentColor: un(a) }, "", { text: Ai(n.hitValueAxis(a).formatValue(n.value(a)), n.hitValueAxis(a)), font: { weight: "bold" } }]]))).flat()] : e.map(((a) => Gr(a, [[{ component: a.series, componentColor: un(a), rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [...n.progressiveDimension ? [`${n.progressiveDimension}`, ""] : [], { text: Ai(n.progressiveAxis.formatValue(n.position(a)), n.progressiveAxis), font: { weight: "bold" } }], [...n.valueDimension ? [`${n.valueDimension}`, ""] : [], { text: Ai(n.hitValueAxis(a).formatValue(n.value(a)), n.hitValueAxis(a)), font: { weight: "bold" } }]]))).flat();
};
class Rx {
  constructor(t, e, i, s, o, n, a) {
    var l;
    this.coordsRelative = "relative", this.coordsClient = "client", this.Hw = [], this.Ww = /* @__PURE__ */ new Map(), this.Ny = /* @__PURE__ */ new Map(), this.Xw = !0, this.Zw = /* @__PURE__ */ new Set(), this.Jw = () => {
      this.Qw.yi.Rs();
    }, this.Kw = (y, m, A) => {
      this.Ny.size !== 0 && [...this.Ny.values()].find((({ series: v }) => v.getVisible() === !0)) !== void 0 || this.qw.li(m, A, !1, !1, "zoomBandChartOther"), this.Qw.yi.Rs();
    }, this.tk = !0, this.D = new Nt(), e.yi.Oa(Ot.Do), this.Qg = t, this.Ig = n?.orientation || "x", this.ik = n?.useSharedValueAxis !== void 0 && n.useSharedValueAxis, this.sk = s, this.oo = this.Ig === "x" ? jl : ec;
    const h = { ...n, defaultAxisX: this.oo.getWidth({ x: n?.defaultAxis, y: void 0 }), defaultAxisY: this.oo.getHeight({ x: n?.defaultAxis, y: void 0 }), legend: (l = n?.legend) !== null && l !== void 0 ? l : { addEntriesAutomatically: !1 } };
    this.Qw = new $f(t, e, i, ie, o, h, a).setTitle("Zoom Band Chart").setUserInteractions(void 0).setCursorMode(void 0), this.engine = this.Qw.engine;
    const u = this.Qw.getDefaultAxisX().setPointerEvents(!1), c = this.Qw.getDefaultAxisY().setPointerEvents(!1);
    this.qw = this.oo.getWidth({ x: u, y: c }).setScrollStrategy(za.fitting()).setAnimationScroll(!1).setStrokeStyle(Et).setTickStrategy(jr.Empty), n?.useSharedValueAxis ? this.ek = this.oo.getHeight({ x: u, y: c }) : this.oo.getHeight({ x: u, y: c }).dispose();
    const d = this.getTheme().zoomBandChartDefocusOverlayFillStyle || new ot({ color: this.getTheme().isDark ? N(0, 0, 0, 180) : N(255, 255, 255, 180) });
    this.rk = [this.Qw.uA.er(this.qw.SA).sr(d).ir(Et), this.Qw.uA.er(this.qw.SA).sr(d).ir(Et)];
    const f = this.Qw.uA.GA(this.qw.SA).gr(this.getTheme().zoomBandChartSplitterStrokeStyle || this.getTheme().chartXYSeriesBackgroundStrokeStyle);
    this.hk = { collection: f, members: new Array(5).fill(0).map(((y) => f.Qo())) };
    const p = this.getTheme(), g = typeof p.zoomBandChartKnobFillStyle == "function" ? Pm({ resourcesBaseUrl: this.Qg.xe, styleFactory: p.zoomBandChartKnobFillStyle, apply: (y) => this.setKnobFillStyle(y) }) : p.zoomBandChartKnobFillStyle || Lt;
    this.nk = [this.Qw.uA.er(this.Qw.xA).sr(g).ir(Et), this.Qw.uA.er(this.Qw.xA).sr(g).ir(Et)], this.ak = this.getTheme().zoomBandChartKnobSize || { x: 0, y: 0 }, this.lk();
  }
  setPauseRendering(t, e) {
    return this.chart.setPauseRendering(t, e), this;
  }
  get chart() {
    return this.Qw;
  }
  setUserInteractions(t) {
    return this.cr = t === void 0 ? { pan: { drag: !1, click: !1 }, zoom: { wheel: void 0, dragKnob: !1 } } : t, this;
  }
  getUserInteractions() {
    return Zi({ pan: { drag: !0, click: !0 }, zoom: { wheel: {}, dragKnob: !0 } }, this.cr);
  }
  add(t) {
    this.Zw.has(t.chart) || (this.Zw.add(t.chart), t.chart.addEventListener("layoutchange", this.Jw));
    const e = this.Hw.map(((f) => f.axis)), i = this.Ig === "x" ? t.axisX : t.axisY;
    if (!e.includes(i)) {
      const f = (p) => {
        this.Kw(i, p.start, p.end);
      };
      i.addEventListener("intervalchange", f), this.Hw.push({ axis: i, deattach: () => {
        i.removeEventListener("intervalchange", f);
      } }), this.qw.Rh(i.Eh(), i.getTickStrategy()), this.uk && this.uk.remove(), this.uk = NS(...this.Hw.map(((p) => p.axis)));
    }
    const s = this.oo.getHeight({ x: t.axisX, y: t.axisY });
    let o;
    if (this.ik) o = this.ek;
    else {
      const f = this.Ww.get(s);
      f ? o = f : (o = this.oo.getHeight({ x: this.Qw.addAxisX.bind(this.Qw), y: this.Qw.addAxisY.bind(this.Qw) })({ type: s.Ah.type }), this.ck(o)), this.Ww.set(s, o);
    }
    const n = this.oo.getWidth({ x: this.qw, y: o }), a = this.oo.getHeight({ x: this.qw, y: o });
    let l;
    const h = [];
    if (t instanceof Co) l = this.Qw.addPointLineAreaSeries({ ...t.Ga, axisX: n, axisY: a, xAxis: n, yAxis: a }).setStrokeStyle(t.getStrokeStyle()).setAreaFillStyle(t.getAreaFillStyle()).setPointFillStyle(t.getPointFillStyle()).setPointAlignment(t.getPointAlignment()).setPointRotation(t.getPointRotation()).setPointShape(t.getPointShape()).setPointSize(t.getPointSize()).setCurvePreprocessing(t.getCurvePreprocessing()), l.setDataSet(t.yw(), t.getDataMapping());
    else if (t instanceof Px) {
      const f = this.Qw.addPointLineAreaSeries({ schema: { x: { pattern: "progressive" }, y: { pattern: null } }, axisX: n, axisY: a, xAxis: n, yAxis: a });
      ((p, g) => {
        const y = (b) => {
          if (b.length !== 0) if ("x" in b[0]) {
            const w = b;
            g.appendJSON(w);
          } else {
            const w = b, k = [];
            for (let R = 0; R < w.length; R += 1) {
              const L = w[R];
              k.push({ x: L[0], y: L[4] });
            }
            g.appendJSON(k);
          }
        }, m = p.EM();
        y(m);
        const A = (b) => {
          y(b.data);
        }, v = () => {
          g.clear();
        };
        p.addEventListener("dataadd", A), p.addEventListener("dataclear", v), h.push((() => {
          p.removeEventListener("dataadd", A), p.removeEventListener("dataclear", v);
        }));
      })(t, f), l = f;
    } else if (t instanceof Lx) {
      const f = this.Qw.addAreaRangeSeries({ axisX: n, axisY: a, xAxis: n, yAxis: a }).setLowFillStyle(t.getLowFillStyle()).setHighFillStyle(t.getHighFillStyle()).setLowStrokeStyle(t.getLowStrokeStyle()).setHighStrokeStyle(t.getHighStrokeStyle()).add(t.EM()), p = (y) => f.add(y.data);
      t.addEventListener("dataadd", p), h.push((() => t.removeEventListener("dataadd", p))), l = f;
      const g = (y) => f.clear();
      t.addEventListener("dataclear", g), h.push((() => {
        t.removeEventListener("dataclear", g);
      }));
    } else {
      if (!(t instanceof Fx)) throw new Error("LightningChart JS Zoom Band Chart unsupported series type");
      {
        const f = this.Qw.addHeatmapGridSeries({ ...t.Rx, axisX: n, axisY: a, xAxis: n, yAxis: a }), p = () => {
          f.setWireframeStyle(t.getWireframeStyle()).setIntensityInterpolation(t.getIntensityInterpolation()).setFillStyle(t.getFillStyle()).setContours(t.getContours());
        };
        p(), l = f, t.Gx(l);
        const g = (m) => f.invalidateIntensityValues(m.value);
        t.addEventListener("stylechange", p), h.push((() => {
          t.removeEventListener("invalidateintensity", g), t.removeEventListener("stylechange", p);
        }));
        const y = () => {
          f.clear();
        };
        t.addEventListener("dataclear", y), h.push((() => {
          t.removeEventListener("dataclear", y);
        }));
      }
    }
    l.setPointerEvents(!1);
    const u = (f) => {
      l.setVisible(f.isVisible);
    };
    t.addEventListener("visiblechange", u), h.push((() => {
      t.removeEventListener("visiblechange", u);
    }));
    const c = (f) => {
      l.setHighlight(f.highlight);
    };
    h.push((() => {
      t.addEventListener("highlightchange", c), t.removeEventListener("highlightchange", c);
    }));
    const d = () => {
      this.disposeSeries(t);
    };
    return t.addEventListener("dispose", d), h.push((() => {
      t.removeEventListener("dispose", d);
    })), this.Ny.set(t, { series: l, clearReferences: () => h.forEach(((f) => f())) }), l;
  }
  disposeSeries(t) {
    const e = this.Ny.get(t);
    if (e) {
      const { clearReferences: o } = e;
      o(), this.Ny.delete(t), e.series.dispose();
      const n = this.oo.getHeight({ x: t.axisX, y: t.axisY }), a = this.Ww.get(n);
      a && a.DA().length === 0 && (this.Ww.delete(n), a.dispose());
    }
    const i = this.Ig === "x" ? t.axisX : t.axisY;
    if (!Array.from(this.Ny.keys()).find(((o) => i === (this.Ig === "x" ? o.axisX : o.axisY)))) {
      const o = this.Hw.findIndex(((n) => n.axis === i));
      o >= 0 && (this.Hw[o].deattach(), this.Hw.splice(o, 1));
    }
    return Array.from(this.Ny.keys()).find(((o) => o.chart == o.chart)) || (t.chart.removeEventListener("layoutchange", this.Jw), this.Zw.delete(t.chart)), this;
  }
  setDefocusOverlayFillStyle(t) {
    return this.rk.forEach(((e) => e.sr(t))), this.Qw.yi.Rs(), this;
  }
  getDefocusOverlayFillStyle() {
    return this.rk[0].kh();
  }
  setSplitterStrokeStyle(t) {
    return this.hk.collection.gr(t), this.Qw.yi.Rs(), this;
  }
  getSplitterStrokeStyle() {
    return this.hk.collection.po();
  }
  setKnobFillStyle(t) {
    return this.nk.forEach(((e) => e.sr(t))), this.Qw.yi.Rs(), this;
  }
  getKnobFillStyle() {
    return this.nk[0].kh();
  }
  setKnobStrokeStyle(t) {
    return this.nk.forEach(((e) => e.ir(t))), this.Qw.yi.Rs(), this;
  }
  getKnobStrokeStyle() {
    return this.nk[0].hl();
  }
  setKnobSize(t) {
    return this.ak = t, this.Qw.yi.Rs(), this;
  }
  getKnobSize() {
    return this.ak;
  }
  getDefaultAxisX() {
    return this.Qw.getDefaultAxisX();
  }
  getDefaultAxisY() {
    return this.Qw.getDefaultAxisY();
  }
  get axisX() {
    return this.getDefaultAxisX();
  }
  get xAxis() {
    return this.getDefaultAxisX();
  }
  get axisY() {
    return this.getDefaultAxisY();
  }
  get yAxis() {
    return this.getDefaultAxisY();
  }
  ck(t) {
    t.setTickStrategy(jr.Empty).setPointerEvents(!1).setStrokeStyle(Et);
  }
  setStopAxisOnInteraction(t) {
    return this.Xw = t, this;
  }
  getStopAxisOnInteraction() {
    return this.Xw;
  }
  lk() {
    let t;
    const e = (s, o, n, a) => {
      var l, h;
      const u = this.Ig === "x" ? (l = Array.from(this.Ny.keys())[0]) === null || l === void 0 ? void 0 : l.axisX : (h = Array.from(this.Ny.keys())[0]) === null || h === void 0 ? void 0 : h.axisY;
      if (!u) return;
      const c = u.getInterval(), d = this.qw.getInterval(), f = Math.abs(this.qw.ai.Rt(s) - this.qw.ai.Rt(o));
      n.preventTooSmall && f < 10 || Math.sign(o - s) !== Math.sign(c.end - c.start) || Math.min(s, o) < Math.min(d.start, d.end) || Math.max(s, o) > Math.max(d.start, d.end) && Math.max(c.start, c.end) < Math.max(s, o) || u.li(s, o, n.animated, this.Xw, a);
    };
    this.nk.forEach(((s, o) => {
      s.addEventListener("pointerenter", (() => {
        var n;
        !((n = this.getUserInteractions().zoom) === null || n === void 0) && n.dragKnob && (t = this.engine.setMouseStyle(this.oo.getWidth({ x: Gt.Horizontal, y: Gt.Vertical }), t));
      })), s.addEventListener("pointerleave", (() => {
        t = this.engine.restoreMouseStyle(t);
      })), s.addEventListener("pointerdown", ((n) => {
        var a, l, h;
        if (!(!((a = this.getUserInteractions().zoom) === null || a === void 0) && a.dragKnob)) return;
        const u = this.Ig === "x" ? (l = Array.from(this.Ny.keys())[0]) === null || l === void 0 ? void 0 : l.axisX : (h = Array.from(this.Ny.keys())[0]) === null || h === void 0 ? void 0 : h.axisY;
        if (!u) return;
        It(n);
        const c = (f) => {
          if (f.pointerId !== n.pointerId) return;
          It(f);
          const p = this.oo.getWidth(this.Qw.translateCoordinate(f, this.Qw.coordsAxis)), g = u.getInterval(), y = o === 0 ? p : g.start, m = o === 1 ? p : g.end;
          e(y, m, { animated: !1, preventTooSmall: !0 }, "zoomBandChartOther");
        }, d = (f) => {
          f.pointerId === n.pointerId && (It(f), Ao("click"), H.removeEventListener("pointermove", c), H.removeEventListener("pointerup", d));
        };
        H.addEventListener("pointermove", c), H.addEventListener("pointerup", d);
      }));
    })), this.Qw.seriesBackground.addEventListener("pointerenter", (() => {
      var s;
      !((s = this.getUserInteractions().pan) === null || s === void 0) && s.drag && (t = this.engine.setMouseStyle(Gt.Move, t));
    })), this.Qw.seriesBackground.addEventListener("pointerleave", (() => {
      t = this.engine.restoreMouseStyle(t);
    }));
    const i = (s, o) => {
      var n, a, l;
      if (!(!((n = this.getUserInteractions().pan) === null || n === void 0) && n.drag)) return;
      const h = this.Ig === "x" ? (a = Array.from(this.Ny.keys())[0]) === null || a === void 0 ? void 0 : a.axisX : (l = Array.from(this.Ny.keys())[0]) === null || l === void 0 ? void 0 : l.axisY;
      if (!h) return;
      const u = h.getInterval(), c = this.qw.ai.Qt(u.start, this.oo.getWidth(s)), d = this.qw.ai.Qt(u.end, this.oo.getWidth(s));
      e(c, d, { animated: !1, preventTooSmall: !0 }, "zoomBandChartOther"), It(o);
    };
    this.Qw.seriesBackground.addEventListener("pointerdown", ((s) => {
      var o, n;
      if (!(this.Ig === "x" ? !((o = Array.from(this.Ny.keys())[0]) === null || o === void 0) && o.axisX : !((n = Array.from(this.Ny.keys())[0]) === null || n === void 0) && n.axisY)) return;
      It(s);
      let a = s;
      const l = (u) => {
        if (u.pointerId !== s.pointerId) return;
        const c = { x: u.clientX - a.clientX, y: a.clientY - u.clientY };
        a = u, i(c, u);
      }, h = (u) => {
        u.pointerId === s.pointerId && (It(u), sn(), Ao("click"), H.removeEventListener("pointermove", l), H.removeEventListener("pointerup", h));
      };
      H.addEventListener("pointermove", l), H.addEventListener("pointerup", h);
    })), this.Qw.seriesBackground.addEventListener("wheel", ((s) => {
      var o, n, a, l;
      const h = this.getUserInteractions();
      if (!(!((o = h.zoom) === null || o === void 0) && o.wheel)) return;
      const u = this.Ig === "x" ? (n = Array.from(this.Ny.keys())[0]) === null || n === void 0 ? void 0 : n.axisX : (a = Array.from(this.Ny.keys())[0]) === null || a === void 0 ? void 0 : a.axisY;
      if (!u) return;
      const c = u.getInterval(), d = this.qw.getInterval(), f = this.oo.getWidth(this.Qw.translateCoordinate(s, this.Qw.coordsAxis)), p = this.qw.ai.Rt(c.start), g = this.qw.ai.Rt(c.end), y = this.qw.ai.Rt(f), m = Jt((y - p) / (g - p), 0, 1), A = 0.2 * Math.abs(g - p) * ((l = h.zoom.wheel.sensitivity) !== null && l !== void 0 ? l : 1), v = m * A * -Math.sign(s.deltaY), b = (1 - m) * A * Math.sign(s.deltaY), w = Jt(this.qw.ai.Qt(c.start, v), d.start, d.end), k = Jt(this.qw.ai.Qt(c.end, b), d.start, d.end);
      e(w, k, { animated: !1, preventTooSmall: !0 }, "zoomBandChartOther"), It(s);
    })), this.rk.forEach(((s, o) => {
      s.addEventListener("pointerenter", (() => {
        var n;
        !((n = this.getUserInteractions().pan) === null || n === void 0) && n.click && (t = this.engine.setMouseStyle(Gt.Point, t));
      })), s.addEventListener("pointerleave", (() => {
        t = this.engine.restoreMouseStyle(t);
      })), s.addEventListener("click", ((n) => {
        var a, l, h;
        if (n.defaultPrevented || !(!((a = this.getUserInteractions().pan) === null || a === void 0) && a.click)) return;
        const u = this.Ig === "x" ? (l = Array.from(this.Ny.keys())[0]) === null || l === void 0 ? void 0 : l.axisX : (h = Array.from(this.Ny.keys())[0]) === null || h === void 0 ? void 0 : h.axisY;
        if (!u) return;
        const c = this.oo.getWidth(this.Qw.translateCoordinate(n, this.Qw.coordsAxis)), d = u.getInterval(), f = this.qw.getInterval(), p = Jt(c - (d.end - d.start) / 2, Math.min(f.start, f.end), Math.max(f.start, f.end) - Math.abs(d.end - d.start)), g = p + (d.end - d.start);
        e(p, g, { animated: !0, preventTooSmall: !1 }, "zoomBandChartClick"), It(n);
      }));
    }));
  }
  getSizePixels() {
    return this.Qw.getSizePixels();
  }
  Tn(t) {
    this.Qw.Tn(t);
  }
  getMinimumSize() {
    return this.Qw.getMinimumSize();
  }
  W() {
    return this.Qw.W();
  }
  X() {
    return this.Qw.X();
  }
  rr(t) {
    var e, i, s, o;
    const n = Cn(Array.from(this.Ny.keys()).map(((A) => A.chart))), a = this.Ig === "x" ? (e = Array.from(this.Ny.keys())[0]) === null || e === void 0 ? void 0 : e.axisX : (i = Array.from(this.Ny.keys())[0]) === null || i === void 0 ? void 0 : i.axisY, l = (() => {
      var A;
      const v = (A = this.Hw.find(((b) => b.axis.getVisible()))) === null || A === void 0 ? void 0 : A.axis;
      return !!v && Math.sign(v.getInterval().end - v.getInterval().start);
    })(), h = Math.sign(this.qw.getInterval().end - this.qw.getInterval().start);
    if (h !== l && h !== 0 && l !== 0 && this.qw.li(this.qw.getInterval().end, this.qw.getInterval().start, !1, this.qw.getStopped(), "zoomBandChartOther"), this.Ny.forEach(((A, v) => {
      const b = A.series;
      v instanceof Co && b instanceof Co && b.setDataSet(v.getDataSet(), v.getDataMapping());
    })), this.tk) if (this.Ig === "x") {
      const A = n.reduce(((k, R) => {
        const L = [];
        R.forEachAxisY(((M) => {
          if (!M.getVisible() || M.vA !== 0) return;
          let C = L.find(((S) => S.iParallel === M.getParallelIndex()));
          C || (C = { iParallel: M.getParallelIndex(), maxHeight: 0 }, L.push(C)), C.maxHeight = Math.max(C.maxHeight, M.qA());
        }));
        const x = L.reduce(((M, C) => M + C.maxHeight), 0);
        return Math.max(k, x);
      }), 0), v = n.reduce(((k, R) => {
        const L = [];
        R.forEachAxisY(((M) => {
          if (!M.getVisible() || M.vA !== 100) return;
          let C = L.find(((S) => S.iParallel === M.getParallelIndex()));
          C || (C = { iParallel: M.getParallelIndex(), maxHeight: 0 }, L.push(C)), C.maxHeight = Math.max(C.maxHeight, M.qA());
        }));
        const x = L.reduce(((M, C) => M + C.maxHeight), 0);
        return Math.max(k, x);
      }), 0), b = n.reduce(((k, R) => Math.max(k, R.getPadding().left)), 0), w = n.reduce(((k, R) => Math.max(k, R.getPadding().right)), 0);
      this.Qw.forEachAxisY(((k) => k.setThickness(0))), (s = this.getDefaultAxisY()) === null || s === void 0 || s.setThickness(A), this.Qw.setPadding({ left: b + (n.length === 0 ? 10 : 0), right: w + v + (n.length === 0 ? 10 : 0) });
    } else {
      const A = n.reduce(((k, R) => {
        const L = [];
        R.forEachAxisX(((M) => {
          if (!M.getVisible() || M.vA !== 0) return;
          let C = L.find(((S) => S.iParallel === M.getParallelIndex()));
          C || (C = { iParallel: M.getParallelIndex(), maxHeight: 0 }, L.push(C)), C.maxHeight = Math.max(C.maxHeight, M.qA());
        }));
        const x = L.reduce(((M, C) => M + C.maxHeight), 0);
        return Math.max(k, x);
      }), 0), v = n.reduce(((k, R) => {
        const L = [];
        R.forEachAxisX(((M) => {
          if (!M.getVisible() || M.vA !== 100) return;
          let C = L.find(((S) => S.iParallel === M.getParallelIndex()));
          C || (C = { iParallel: M.getParallelIndex(), maxHeight: 0 }, L.push(C)), C.maxHeight = Math.max(C.maxHeight, M.qA());
        }));
        const x = L.reduce(((M, C) => M + C.maxHeight), 0);
        return Math.max(k, x);
      }), 0), b = n.reduce(((k, R) => Math.max(k, R.getPadding().bottom)), 0), w = n.reduce(((k, R) => Math.max(k, R.getPadding().top)), 0);
      this.Qw.forEachAxisX(((k) => k.setThickness(0))), (o = this.getDefaultAxisX()) === null || o === void 0 || o.setThickness(A), this.Qw.setPadding({ bottom: b + (n.length === 0 ? 10 : 0), top: w + v + (n.length === 0 ? 10 : 0) });
    }
    this.Qw.rr(t);
    const u = this.qw.getInterval().start, c = this.qw.getInterval().end, d = Jt(a ? a.getInterval().start : u, u, c), f = Jt(a ? a.getInterval().end : c, u, c), p = this.oo.getHeight(this.Qw.Mw.getInnerIntervalPixels());
    this.rk[0].hr(this.oo.toPoint(u, 0)).K(this.oo.toPoint(d - u, p)), this.rk[1].hr(this.oo.toPoint(f, 0)).K(this.oo.toPoint(c - f, p)), this.hk.members[0].UA(this.oo.toPoint(u, p), this.oo.toPoint(d, p)), this.hk.members[1].UA(this.oo.toPoint(d, p), this.oo.toPoint(d, 0)), this.hk.members[2].UA(this.oo.toPoint(d, 0), this.oo.toPoint(f, 0)), this.hk.members[3].UA(this.oo.toPoint(f, 0), this.oo.toPoint(f, p)), this.hk.members[4].UA(this.oo.toPoint(f, p), this.oo.toPoint(c, p));
    const g = xt(this.oo.toPoint(d, p / 2), this.qw.SA, this.Qw.xA), y = xt(this.oo.toPoint(f, p / 2), this.qw.SA, this.Qw.xA), m = this.ak;
    this.nk[0].hr({ x: g.x - m.x / 2, y: g.y - m.y / 2 }).K({ x: m.x, y: m.y }).Ph(this.oo.getWidth({ x: 0, y: 90 })), this.nk[1].hr({ x: y.x - m.x / 2, y: y.y - m.y / 2 }).K({ x: m.x, y: m.y }).Ph(this.oo.getWidth({ x: 0, y: 90 }));
  }
  setSeriesBackgroundFillStyle(t) {
    return this.Qw.setSeriesBackgroundFillStyle(t), this.Qw.yi.Rs(), this;
  }
  getSeriesBackgroundFillStyle() {
    return this.Qw.getSeriesBackgroundFillStyle();
  }
  setSeriesBackgroundStrokeStyle(t) {
    return this.Qw.setSeriesBackgroundStrokeStyle(t), this.Qw.yi.Rs(), this;
  }
  getSeriesBackgroundStrokeStyle() {
    return this.Qw.getSeriesBackgroundStrokeStyle();
  }
  setSeriesBackgroundEffect(t) {
    return this.Qw.setSeriesBackgroundEffect(t), this.Qw.yi.Rs(), this;
  }
  getSeriesBackgroundEffect() {
    return this.Qw.getSeriesBackgroundEffect();
  }
  getTheme() {
    return this.Qw.getTheme();
  }
  setTitle(t) {
    return this.Qw.setTitle(t), this;
  }
  getTitle() {
    return this.Qw.getTitle();
  }
  setTitleFillStyle(t) {
    return this.Qw.setTitleFillStyle(t), this;
  }
  getTitleFillStyle() {
    return this.Qw.getTitleFillStyle();
  }
  setTitleFont(t) {
    return this.Qw.setTitleFont(t), this;
  }
  getTitleFont() {
    return this.Qw.getTitleFont();
  }
  setTitleMargin(t) {
    return this.Qw.setTitleMargin(t), this;
  }
  getTitleMargin() {
    return this.Qw.getTitleMargin();
  }
  setPadding(t) {
    return t === void 0 ? this.tk = !0 : (this.tk = !1, this.Qw.setPadding(t), this.Qw.forEachAxis(((e) => e.setThickness(void 0)))), this.Qw.yi.Rs(), this;
  }
  getPadding() {
    return this.Qw.getPadding();
  }
  setBackgroundFillStyle(t) {
    return this.Qw.setBackgroundFillStyle(t), this;
  }
  getBackgroundFillStyle() {
    return this.Qw.getBackgroundFillStyle();
  }
  setBackgroundStrokeStyle(t) {
    return this.Qw.setBackgroundStrokeStyle(t), this;
  }
  getBackgroundStrokeStyle() {
    return this.Qw.getBackgroundStrokeStyle();
  }
  translateCoordinate(t, e, i) {
    return sc(t, e, i, this.Qw.xA, this.Qw.yi);
  }
  addUIElement(t, e) {
    return this.Qw.addUIElement(t, e);
  }
  saveToFile(t, e, i) {
    return this.Qw.saveToFile(t, e, i), this;
  }
  dispose() {
    return this.Qw.dispose(), this.Ww.clear(), this.Ny.clear(), this.sk(this), this;
  }
  isDisposed() {
    return this.Qw.isDisposed();
  }
  getLayout() {
    return this.Qw.getLayout();
  }
  addEventListener(t, e, i) {
    this.Qw.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.Qw.removeEventListener(t, e);
  }
}
class C5 extends Xa {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, o, a), this.Vs = "Point Line Series", this.Tb = [], this.Fb = !1, this.Ib = !1, this.dk = 3, this.Dl = 0, this.fk = Je.Circle, this.D = new Nt(), this.Ke = ue(this.xi.polarPointLineSeriesFillStyle, n), this.vc = ue(this.xi.polarPointLineSeriesStrokeStyle, n), this.Kd = new cr({ schema: { x: { pattern: null }, y: { pattern: null }, color: { pattern: null, storage: Uint32Array } } }), this.Bb = t.Ay(s, void 0, [Ir.UserSeries]).gr(this.vc).Ii(this.getHighlight()), this.Ts(this.Bb), this.Ak = t.ef(s).sf(Lt).gr(Et).tf(this.Ke).rf(this.fk).df(this.dk).Ii(this.getHighlight()).qd(this.Kd, { x: "x", y: "y", color: "color" }), this.Ts(this.Ak);
  }
  solveNearest(t, e) {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY }, o = this.Bb.Db(s);
    if (!o) return;
    const n = io(o, this.scale);
    return { cursorPosition: { pointMarker: o, pointMarkerScale: this.scale, resultTable: o, resultTableScale: this.scale }, series: this, ...n };
  }
  Qi(t, e, i) {
    return Pr({ series: this }, { cursorPosition: 0, amplitude: 0, angle: 0, color: 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  setData(t) {
    return this.Tb.length !== 0 && this.chart.yi.Oa(Ot.Go), this.Tb = oc(t), this.Fb = !0, this.Sb = ph(this.Tb), this.Js.Rs(), this;
  }
  getData() {
    return this.Tb;
  }
  setStrokeStyle(t) {
    this.vc = typeof t == "function" ? t(this.vc) : t;
    const e = this.vc;
    return this.Bb.gr(e), this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.vc;
  }
  setPointFillStyle(t) {
    this.Ke = typeof t == "function" ? t(this.Ke) : t;
    const e = this.Ke;
    return this.Ak.tf(e), this.Js.Rs(), this;
  }
  getPointFillStyle() {
    return this.Ke;
  }
  setPointSize(t) {
    return this.dk = t, this.Ak.df(t), this.Js.Rs(), this;
  }
  getPointSize() {
    return this.dk;
  }
  setPointShape(t) {
    return this.fk = t, this.Ak.rf(this.fk), this;
  }
  getPointShape() {
    return this.fk;
  }
  setPointRotation(t) {
    return this.Dl = t, this.Ak.nf(t), this.Js.Rs(), this;
  }
  getPointRotation() {
    return this.Dl;
  }
  nr() {
    return { fill: this.Ke, stroke: this.vc };
  }
  setConnectDataAutomaticallyEnabled(t) {
    return this.Ib = t, this.Js.Rs(), this;
  }
  getConnectDataAutomaticallyEnabled() {
    return this.Ib;
  }
  Uv() {
    return this.kv && this.Tb.length > 0 && this.getVisible();
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  rr() {
    if (this.Fb || this.scale.pe()) {
      const t = fn(this.Tb, this.scale), e = Vi(t);
      this.Ib ? (t.push({ ...t[0] }), this.Bb.Nu(!0)) : this.Bb.Nu(!1), this.Bb.Vi().Pu(t).Ti(e), this.Kd.clear().appendJSON(t), this.Ak.Ti(e), this.Fb = !1, this.Bb.Uh(), this.Ak.Uh();
    }
  }
  Xs() {
    return this.zs || this.fk;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class w5 extends Xa {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, o, a), this.Vs = "Point Series", this.Tb = [], this.Fb = !1, this.dk = 3, this.Dl = 0, this.D = new Nt(), this.Ke = ue(this.xi.polarPointSeriesFillStyle, n), this.qe = ue(this.xi.polarPointSeriesStrokeStyle, n), this.Kd = new cr({ schema: { x: { pattern: null }, y: { pattern: null }, color: { pattern: null, storage: Uint32Array } } }), this.zc = t.ef(s).gr(Et).sf(Lt).tf(this.Ke).uf(this.qe).rf(Je.Circle).df(this.dk).Ii(this.getHighlight()).qd(this.Kd, { x: "x", y: "y", color: "color" }), this.Ts(this.zc);
  }
  solveNearest(t, e = "show-nearest") {
    const i = this.chart.translateCoordinate(t, this.chart.coordsAxis), s = fn([i], this.scale)[0], o = this.Kd.Rd({ x: "x", y: "y", color: "color" }, s, qa(e), this.scale, this.chart.xA);
    if (!o) return;
    const n = io(o, this.scale);
    return { cursorPosition: { pointMarker: o, pointMarkerScale: this.scale, resultTable: o, resultTableScale: this.scale }, series: this, ...n };
  }
  Qi(t, e, i) {
    return Pr({ series: this }, { cursorPosition: 0, amplitude: 0, angle: 0, color: 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  setData(t) {
    return this.Tb.length !== 0 && this.chart.yi.Oa(Ot.Go), this.Tb = oc(t), this.Fb = !0, this.Sb = ph(this.Tb), this.Js.Rs(), this;
  }
  getData() {
    return this.Tb;
  }
  setPointAlignment(t) {
    return this.zc.lg(t), this.chart.yi.Rs(), this;
  }
  getPointAlignment() {
    return this.zc.cw();
  }
  setPointFillStyle(t) {
    this.Ke = typeof t == "function" ? t(this.Ke) : t;
    const e = this.Ke;
    return this.zc.tf(e), this.Js.Rs(), this;
  }
  getPointFillStyle() {
    return this.Ke;
  }
  setPointStrokeStyle(t) {
    return this.qe = typeof t == "function" ? t(this.qe) : t, this.zc.uf(this.qe), this.Js.Rs(), this;
  }
  getPointStrokeStyle() {
    return this.qe;
  }
  setPointSize(t) {
    return this.dk = t, this.zc.df(t), this.Js.Rs(), this;
  }
  getPointSize() {
    return this.dk;
  }
  setPointShape(t) {
    return this.zc.rf(t), this.chart.yi.Rs(), this;
  }
  getPointShape() {
    return this.zc.hf();
  }
  setPointRotation(t) {
    return this.Dl = t, this.zc.nf(t), this.Js.Rs(), this;
  }
  getPointRotation() {
    return this.Dl;
  }
  Uv() {
    return this.kv && this.Tb.length > 0 && this.getVisible();
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  rr() {
    if (this.Fb || this.scale.pe()) {
      const t = fn(this.Tb, this.scale), e = Vi(t);
      this.Kd.clear().appendJSON(t), this.zc.Ti(e), this.Fb = !1, this.zc.Uh();
    }
  }
  nr() {
    return { fill: this.Ke };
  }
  Xs() {
    return this.zs || this.getPointShape();
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class T5 extends Xa {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, o, n), this.Vs = "Heatmap Series", this.gk = !0, this.zv = !1, this.D = new Nt();
    const l = this.chart.getSeries().length;
    this.Ke = ue(this.xi.polarHeatmapSeriesFillStyle || this.xi.heatmapGridSeriesFillStyle, l);
    const h = a.amplitudeStart || 0, u = a.amplitudeEnd ? (a.amplitudeEnd - h) / (a.annuli - 1) : a.amplitudeStep || 1, c = { sectors: a.sectors, annuli: a.annuli, amplitudeStart: h, amplitudeStep: u, heatmapDataType: "intensity", dataOrder: a.dataOrder || "annuli" };
    this.Ga = c, this.vk = t.yk(s, [], c).sr(this.Ke).Ii(this.getHighlight()), this.Ts(this.vk);
    const d = Math.min(c.amplitudeStart, c.amplitudeStart + (c.annuli - 1) * c.amplitudeStep), f = Math.max(c.amplitudeStart, c.amplitudeStart + (c.annuli - 1) * c.amplitudeStep);
    this.Sb = { min: d, max: f }, this.setHighlightOnHover(!1);
  }
  solveNearest(t, e = "show-nearest") {
    const i = this.chart.yi.ul(t), s = { x: i.engineX, y: i.engineY }, o = xt(s, this.chart.yi.ai, this.scale), n = io(o, this.scale), a = qa(e) ? this.vk.Nx(n) : this.vk.Rd(n);
    if (!a) return;
    const l = fn([a], this.scale)[0];
    return { cursorPosition: { pointMarker: l, pointMarkerScale: this.scale, resultTable: l, resultTableScale: this.scale }, series: this, angle: a.angle, amplitude: a.amplitude, intensity: a.cellValue, annulus: a.iAnnulus, sector: a.iSector, lut: Ve(this.Ke) ? this.Ke.lut : void 0 };
  }
  Qi(t, e, i) {
    return Pr({ series: this }, { cursorPosition: 0, amplitude: 0, angle: 0, color: 0, intensity: 0, sector: 0, annulus: 0, lut: Ve(this.Ke) ? this.Ke.lut : void 0 }, (() => this.solveNearest(e, this.chart.getCursorMode())));
  }
  invalidateIntensityValues(t) {
    if (this.zv && this.chart.yi.Oa(Ot.Go), Array.isArray(t)) {
      if (t.length === 0 || t[0].length === 0) return this;
      const e = { x: t.length, y: t[0].length, sectors: this.Ga.dataOrder === "annuli" ? t[0].length : t.length, annuli: this.Ga.dataOrder === "annuli" ? t.length : t[0].length }, i = this.Ga.dataOrder === "annuli" ? this.Ga.annuli : this.Ga.sectors, s = this.Ga.dataOrder === "annuli" ? this.Ga.sectors : this.Ga.annuli;
      if (e.x > i || e.y > s) {
        if (this.chart.Qg.$a === !0) {
          const n = `PolarHeatmapSeries.invalidateIntensityValues intensity matrix overflow.
Heatmap ${i}x${s}, input ${e.x}x${e.y}.
Excess data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(n);
        }
        const o = [];
        for (let n = 0; n < i; n += 1) o[n] = t[n].slice(0, s);
        if ((t = o).length === 0 || t[0].length === 0) return this;
      }
      this.vk.Op({ type: "intensity", lengthPrimary: e.x, lengthSecondary: e.y, startPrimary: 0, startSecondary: 0, values: t });
    } else if ("iSector" in t && "iAnnulus" in t && "values" in t) {
      if (t.values.length === 0 || t.values[0].length === 0) return this;
      const e = { primary: t.values.length, secondary: t.values[0].length, sectors: this.Ga.dataOrder === "annuli" ? t.values[0].length : t.values.length, annuli: this.Ga.dataOrder === "annuli" ? t.values.length : t.values[0].length }, i = this.Ga.dataOrder === "annuli" ? t.iAnnulus : t.iSector, s = i + e.primary - 1, o = this.Ga.dataOrder === "annuli" ? t.iSector : t.iAnnulus, n = o + e.secondary - 1, a = this.Ga.dataOrder === "annuli" ? this.Ga.annuli - 1 : this.Ga.sectors - 1, l = this.Ga.dataOrder === "annuli" ? this.Ga.sectors - 1 : this.Ga.annuli - 1;
      if (i < 0 || o < 0) {
        if (this.chart.Qg.$a === !0) {
          const h = `PolarHeatmapSeries.invalidateIntensityValues invalidation start below 0 not permitted.
iSector: ${t.iSector}, iAnnuli: ${t.iAnnulus}.
No intensity values will be invalidated.`;
          H.console.warn(h);
        }
        return this;
      }
      if (s > a || n > l) {
        if (this.chart.Qg.$a === !0) {
          const f = `PolarHeatmapSeries.invalidateIntensityValues intensity matrix overflow.
Max indexes ${a}x${l}, input ${e.primary}x${e.secondary} starting at [${i},${o}].
Out of bounds data will be automatically clipped. This can result in sub-optimal performance.`;
          H.console.warn(f);
        }
        const h = Math.max(s - a, 0), u = e.primary - h, c = Math.max(n - l, 0), d = [];
        for (let f = 0; f < u; f += 1) d[f] = t.values[f].slice(0, c > 0 ? -c : void 0);
        if ((t = { iSector: t.iSector, iAnnulus: t.iAnnulus, values: d }).values.length === 0 || t.values[0].length === 0) return this;
      }
      this.vk.Op({ type: "intensity", lengthPrimary: t.values.length, lengthSecondary: t.values[0].length, startPrimary: i, startSecondary: o, values: t.values });
    }
    return this.Js.Rs(), this.zv = !0, this;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.vk.sr(this.Ke), this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  clear() {
    return this.vk.Vi(), this.Js.Rs(), this;
  }
  setIntensityInterpolation(t) {
    return t = t || "disabled", this.vk.Ep(t), this.Js.Rs(), this;
  }
  getIntensityInterpolation() {
    return this.vk.Rp();
  }
  Ws() {
    return is(this.Ke, this.vk.wi());
  }
  Uv() {
    return this.kv && this.getVisible();
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  rr() {
  }
  nr() {
    return { fill: this.Ke };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class k5 extends Mx {
  constructor(t, e, i, s, o, n, a, l) {
    var h;
    super(t, D5, e, i, s, o, n, a, l), this.pk = 90, this.mk = 12, this.Sk = $g, this.ly = this.tb.Ud(this.sb).setPointerEvents(!1), this.lb = (u) => {
      if (this.getTitle().length === 0 || Qn(this.getTitleFillStyle())) return;
      let c = 180 * (u.M - this.sb.ye()) / Math.PI % 360;
      for (; c < 0; ) c += 360;
      for (; c > 360; ) c -= 360;
      return !(c >= 0 && c <= 20 || c >= 340 && c <= 360) && void 0;
    }, this.Vh = void 0, this.setTickStyle(i.polarRadialAxisTickStyle), this.setTitle("Degrees"), this.setNorth(this.pk), this.bk = (h = this.xi.polarRadialAxisMarginAfterTicks) !== null && h !== void 0 ? h : 7;
  }
  setTickStyle(t) {
    return this.xk = typeof t == "function" ? t(this.xk) : t, this.Mk(), this.tb.Rs(), this;
  }
  getTickStyle() {
    return this.xk;
  }
  setTickFormattingFunction(t) {
    return this.Sk = t, this.Mk(), this.tb.Rs(), this;
  }
  getTickFormattingFunction() {
    return this.Sk;
  }
  setClockwise(t) {
    this.sb.Ae(t);
    const e = this.pk * Math.PI / 180;
    return t ? this.sb.ve(e + Math.PI / 2) : this.sb.ve(e - Math.PI / 2), this.tb.Rs(), this;
  }
  getClockwise() {
    return !this.sb.ge();
  }
  setNorth(t) {
    for (; t < 0; ) t += 360;
    t %= 360, this.pk = t;
    const e = t * Math.PI / 180;
    return this.getClockwise() ? this.sb.ve(e + Math.PI / 2) : this.sb.ve(e - Math.PI / 2), this.tb.Rs(), this;
  }
  getNorth() {
    return 180 * this.sb.ye() / Math.PI;
  }
  setDivision(t) {
    return this.mk = t, this.Mk(), this.tb.Rs(), this;
  }
  getDivision() {
    return this.mk;
  }
  getMarginAfterTicks() {
    return this.bk;
  }
  setMarginAfterTicks(t) {
    return this.bk = t, this.chart.yi.Rs(), this;
  }
  DA() {
    return [];
  }
  tn(t, e, i) {
    return { ticksInfo: e, OA: this.fn(((s, o) => {
      const n = o.Pn.Lr, a = 0.5 * this.eb.getThickness() + n.tickLength + n.tickPadding + Math.abs(o.Gh.Uh().Bc().y);
      return Math.max(s, a);
    }), 0) + this.bk, updatedTicks: i };
  }
  xn(t, e) {
    return e;
  }
  wn(t, e, i) {
    return { start: t, end: e };
  }
  hb(t, e) {
    const i = t.ge() ? 1 : -1, s = t.ye(), o = t.fe() ? t.de().end - t.de().start : t.de().start - t.de().end;
    return { x: Math.cos((e - s) * i) * o, y: Math.sin((e - s) * i) * o };
  }
  nb(t, e) {
    return t.vr(e);
  }
  ub(t, e, i, s) {
    const o = this.xk, n = t.ge() ? 1 : -1, a = t.ye(), l = (s.M - a) * n, h = Math.cos(l), u = Math.sin(l), c = t.fe() ? t.de().end - t.de().start : t.de().start - t.de().end, d = { x: h * c, y: u * c };
    e.pr({ x: 0, y: 0 }).yr(d);
    const f = { x: d.x + h * o.tickLength * t.ni().x, y: d.y + u * o.tickLength * t.ni().y };
    i.pr(d).yr(f), e.gr(o.gridStrokeStyle), i.gr(o.tickStyle);
  }
  rb(t, e, i) {
    const s = t.ge() ? 1 : -1;
    let o, n = (e - t.ye()) * s;
    for (; n < 0; ) n += 2 * Math.PI;
    for (; n >= 2 * Math.PI; ) n -= 2 * Math.PI;
    o = n > 0 && n <= Math.PI ? -n + Math.PI / 2 : -n - Math.PI / 2;
    const a = Math.cos(n), l = Math.sin(n), h = i.tickLength + i.tickPadding;
    return { alignment: { x: 0, y: 0 }, padding: { x: a * h * t.ni().x, y: l * h * t.ni().y }, rotation: 180 * o / Math.PI, offset: { x: 0, y: 0 } };
  }
  ob(t, e, i) {
    const s = t.fe() ? t.de().end - t.de().start : t.de().start - t.de().end;
    this.ly.lc(0).yr(360).Ac(0).uc(s + 0.5 * e.getThickness() * t.ni().x).gc(360).sr(Lt).ir(e);
  }
  ab(t, e, i) {
    const s = t.ye(), o = this.rb(t, 0 + s, this.xk), n = t.fe() ? t.de().end - t.de().start : t.de().start - t.de().end;
    e.ru(o.alignment).Ph(o.rotation).Ql(o.offset.x, o.offset.y).hr(qt({ x: n, y: 0 }, o.padding));
  }
  Mk() {
    this.Rh({ kr: [], Cr: [{ Gh: "Radial ticks", $A: 0, Lr: this.xk, Mr: this.Sk, Dn: (t, e, i, s) => {
      const o = [], n = 2 * Math.PI / this.mk;
      for (let a = 0; a < 2 * Math.PI; a += n) o.push(a);
      return o;
    }, hh: { un: () => {
    }, oh: () => !1, dn: "hide-label" }, En: void 0, ln: void 0 }], Tr: $g, Fr: void 0, Ir: void 0 }, "Numeric");
  }
}
const $g = (r, t, e) => (180 * r / Math.PI).toFixed(0), D5 = { vn: () => {
}, yn: () => {
}, Sn: () => {
}, QS: (r) => ({ getInnerStart: () => 0, getInnerEnd: () => 2 * Math.PI, Z: (t, e) => {
}, nt: (t, e, i, s, o) => r.x.nt(t, e, i, s, o), H: () => r.Et() }), KS: (r) => r.radial }, Nc = (r) => !!(r && typeof r == "object" && "axisAmplitude" in r && "axisRadial" in r), F5 = (r) => !!(r && typeof r == "object" && "angle" in r && typeof r.angle == "number" && "amplitude" in r && typeof r.amplitude == "number");
class L5 extends to {
  constructor(t, e, i, s, o, n) {
    super(e, i, o, n), this.Vs = "Sector", this._k = 0, this.wk = 1 * Math.PI / 2, this.kk = void 0, this.Ck = void 0, this.D = new Nt(), this.Js = t, this.sb = s, this.Lb = this.Js.Vc(this.sb).Ii(this.getHighlight()), this.Ts(this.Lb), this.Ke = o.polarSectorFillStyle, this.qe = o.polarSectorStrokeStyle, this.setPointerEvents(!1);
  }
  setAngleStart(t) {
    return this._k = t, this.Js.Rs(), this;
  }
  getAngleStart() {
    return this._k;
  }
  setAngleEnd(t) {
    return this.wk = t, this.Js.Rs(), this;
  }
  getAngleEnd() {
    return this.wk;
  }
  setAmplitudeStart(t) {
    return this.kk = t, this.Js.Rs(), this;
  }
  getAmplitudeStart() {
    return this.kk;
  }
  setAmplitudeEnd(t) {
    return this.Ck = t, this.Js.Rs(), this;
  }
  getAmplitudeEnd() {
    return this.Ck;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.Js.Rs(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setStrokeStyle(t) {
    return this.qe = typeof t == "function" ? t(this.qe) : t, this.Js.Rs(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  rr() {
    const t = this.sb.de(), e = this.kk !== void 0 ? Jt(this.kk, t.start, t.end) : t.start, i = this.Ck !== void 0 ? Jt(this.Ck, t.start, t.end) : t.end, s = [], o = Math.min(this._k, this.wk), n = Math.max(this._k, this.wk);
    for (let l = o; l <= n; l += 1) s.push({ angle: l, amplitude: e });
    for (let l = n; l >= o; l -= 1) s.push({ angle: l, amplitude: i });
    const a = fn(s, this.sb);
    this.Lb.yu(a).sr(this.Ke).ir(this.qe);
  }
  ar(t, e) {
    t.Ii(e), this.Js.Rs();
  }
  nr() {
    return { fill: this.Ke, stroke: this.qe };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Ix extends $a {
  constructor(t, e, i, s, o, n, a) {
    var l;
    super(t, e, i, e.Av("polarChart bg", 0), s, e.yi.xi.polarChartBackgroundFillStyle, e.yi.xi.polarChartBackgroundStrokeStyle, e.yi.xi.polarChartTitleFont, e.yi.xi.polarChartTitleFillStyle, e.yi.xi.polarChartTitleShadow, a, (l = n?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.coordsClient = "client", this.iA = [], this.Tk = (d) => {
      this.sb.K(d.engineWidth, d.engineHeight);
    }, this.hA = _m(this.iA), this.Fk = (d) => {
      this.iA.push(d);
    }, this.Ik = () => this.Ny, this.D = new Nt(), this.yi.Oa(Ot.Lo), this.Ew = e.hS("polarChart series bg", 0), this.Pk = e.nS("polarChart axis gridlines", 0), this.Lk = e.nS("polarChart series", 1), this.Bk = e.nS("polarChart axis lines", 2), this.Dk = e.nS("polarChart axis ticks", 3), this.sb = i.d2({ scaleXYConstructor: zs }), this.addEventListener("resize", this.Tk), this.Wr.rn("Polar Chart"), this.Yy = this.Ew.Ud(this.sb).sr(this.xi.polarChartSeriesBackgroundFillStyle).ir(Et).lc(0).yr(360).Ac(0), this.Hy = this.Ew.Ud(this.sb).sr(Lt).ir(this.xi.polarChartSeriesBackgroundStrokeStyle).lc(0).yr(360).Ac(0), super.jy(this.Yy, this.Hy), this.fv(o, this.xA), this.Ek = new $2(this, this.sb, this.xi, n?.animationsEnabled !== !1, this.Pk, this.Bk, this.Dk, this.bs, this.Ik), this.Rk = new k5(this, this.sb, this.xi, n?.animationsEnabled !== !1, this.Pk, this.Bk, this.Dk, this.bs), this.coordsAxis = { axisAmplitude: this.Ek, axisRadial: this.Rk };
    const h = e.fS(), u = $e(n ? n.cursorBuilder : void 0, Lg);
    this.AS = Xr(this, h, u.zm(h, this.uiScale, this.uiScale, ie, this.xi), this, "show-nearest", P5, ((d, f) => {
      const p = this.translateCoordinate(d, this.coordsClient);
      return Math.sqrt((p.clientX - f.clientX) ** 2 + (p.clientY - f.clientY) ** 2);
    })), this.setAnimationsEnabled(n?.animationsEnabled !== !1);
    const c = { backgroundVisible: !0, ...n?.legend };
    this.legend.setOptions(c);
  }
  getSeries() {
    return this.Ny.slice();
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  solveNearest(t, e = this.getCursorMode() || "show-nearest") {
    return this.AS.solveNearest(t, e, this.Ny, ((i, s, o) => i.solveNearest(s, o)));
  }
  addCursor(t = Lg) {
    const e = this.tv(), i = t.zm(e, this.uiScale, this.uiScale, this.Jg(e), this.xi);
    return this.cv(i), i;
  }
  translateCoordinate(t, e, i) {
    if (i) {
      const s = t, o = this.xA, n = i;
      if (Mo(n)) {
        const a = xt(s, o, this.yi.ai);
        return this.yi.cl({ engineX: a.x, engineY: a.y });
      }
      if (kr(n)) return s;
      if (Nc(n)) {
        const a = xt(s, o, this.sb);
        return io(a, this.sb);
      }
    } else {
      const s = t, o = e;
      if (Df(s)) {
        if (Nc(o)) {
          const n = this.yi.ul(s), a = xt({ x: n.engineX, y: n.engineY }, this.yi.ai, this.sb);
          return io(a, this.sb);
        }
        if (Mo(o)) return s;
        if (kr(o)) {
          const n = this.yi.ul(s);
          return xt({ x: n.engineX, y: n.engineY }, this.yi.ai, this.xA);
        }
      } else if (F5(s)) {
        if (Nc(o)) return s;
        const n = fn([s], this.sb)[0];
        if (Mo(o)) {
          const a = xt(n, this.sb, this.yi.ai), l = { engineX: a.x, engineY: a.y };
          return this.yi.cl(l);
        }
        if (kr(o)) return xt(n, this.sb, this.xA);
      }
    }
    throw new Error("translateCoordinate unexpected error. Input or target coordinate system not recognized.");
  }
  addLineSeries(t) {
    const e = new Q2(this.Lk, this, this.$y, this.sb, this.xi, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, this.yi.bs);
    return this.Wy(e, t), e;
  }
  addPointSeries(t) {
    const e = new w5(this.Lk, this, this.$y, this.sb, this.xi, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, this.yi.bs);
    return this.Wy(e, t), e;
  }
  addPointLineSeries(t) {
    const e = new C5(this.Lk, this, this.$y, this.sb, this.xi, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, this.yi.bs);
    return this.Wy(e, t), e;
  }
  addAreaSeries(t) {
    const e = new J2(this.Lk, this, this.$y, this.sb, this.xi, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, this.yi.bs);
    return this.Wy(e, t), e;
  }
  addPolygonSeries(t) {
    const e = new K2(this.Lk, this, this.$y, this.sb, this.xi, t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, this.yi.bs);
    return this.Wy(e, t), e;
  }
  addHeatmapSeries(t) {
    const e = new T5(this.Lk, this, this.$y, this.sb, this.xi, this.yi.bs, t);
    return this.Wy(e, t), e;
  }
  addSector(t) {
    const e = new L5(this.Lk, this, this.hA, this.sb, this.xi, this.yi.bs);
    return this.Fk(e), this.Ns.forEach(((i) => {
      i.Vg() && t !== null && i.Pu(e, t);
    })), e;
  }
  getAmplitudeAxis() {
    return this.Ek;
  }
  get amplitudeAxis() {
    return this.Ek;
  }
  get axisAmplitude() {
    return this.Ek;
  }
  getRadialAxis() {
    return this.Rk;
  }
  get radialAxis() {
    return this.Rk;
  }
  get axisRadial() {
    return this.Rk;
  }
  rr(t) {
    super.rr(t);
    const e = ui.xv(this.Wr, this.gv), i = this.Ns.reduce(((d, f) => {
      const p = f.Uh(e, this.Hn);
      return { top: Math.max(d.top, p.top), bottom: Math.max(d.bottom, p.bottom), left: Math.max(d.left, p.left), right: Math.max(d.right, p.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, i);
    for (const d of this.Ny) d.Dv();
    this.Ek.bn(), this.Rk.bn();
    for (const d of this.Ny) d.rr();
    const s = this.sb.getInnerIntervalPixels().x / 2, o = this.Ek.Uh({ physicalAxisSize: s }), n = this.Rk.Uh({ physicalAxisSize: 2 * Math.PI * s });
    this.Ek.rr(o), this.Rk.rr(n);
    const a = [this.Hn.left + n.OA + i.left, this.Hn.right + n.OA + i.right], l = [this.Hn.bottom + n.OA + i.bottom, this.Hn.top + n.OA + e + i.top];
    this.sb.qt(a).ti(l);
    const h = this.sb.de().start, u = this.sb.de().end, c = this.sb.fe() ? (n.OA || 0) * this.sb.x.getPixelSize() + u - h : (n.OA || 0) * this.sb.x.getPixelSize() + h - u;
    this.Yy.uc(c).gc(360), this.Hy.uc(c).gc(360);
    for (const d of this.iA) d.rr();
    this.AS.rr(!1, this.Ny, ((d, f, p) => d.solveNearest(f, p)));
    for (const d of this.Ny) d.Ev();
    return super.dv(), this.Ns.forEach(((d) => d.rr(e, this.Hn))), this.Ok(), this;
  }
  setAnimationsEnabled(t) {
    return super.setAnimationsEnabled(t), this.Ek.setAnimationsEnabled(t), this.Rk.setAnimationsEnabled(t), this;
  }
  getMinimumSize() {
    return j(Xg, Xg);
  }
  Ok() {
  }
  forEachAxis(t) {
    return t(this.Ek), t(this.Rk), this;
  }
  dispose() {
    return this.iA.slice().forEach(((t) => t.dispose())), this.AS.G(), this.Ew.G(), this.Pk.G(), this.Lk.G(), this.Bk.G(), this.Dk.G(), super.dispose();
  }
  Gg() {
    return [...this.Ny, ...this.iA];
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Xg = 300, P5 = (r, t, e) => {
  var i;
  return WS(t) ? Gr(t, [[{ component: t.series, componentColor: un(t), rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], ["Angle", "", { text: t.angle.toFixed(0), font: { weight: "bold" } }], ["Amplitude", "", { text: Ai(r.getAmplitudeAxis().formatValue(t.amplitude), r.amplitudeAxis), font: { weight: "bold" } }], ["Intensity", "", { text: Ai(t.lut ? va(t.lut, t.intensity) : t.intensity.toFixed(2), (i = t.lut) === null || i === void 0 ? void 0 : i.units), font: { weight: "bold" } }]]) : Gr(t, [[{ component: t.series, componentColor: un(t), rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], ["Angle", "", { text: t.angle.toFixed(0), font: { weight: "bold" } }], ["Amplitude", "", { text: Ai(r.getAmplitudeAxis().formatValue(t.amplitude), r.amplitudeAxis), font: { weight: "bold" } }]]);
};
class Xf extends to {
  constructor(t, e, i, s) {
    super(t, e, i, s), this.Vs = "Slice", this.M = 0, H.requestAnimationFrame((() => {
      this.addEventListener("pointermove", (() => {
        this.chart.yi.Rs();
      }));
    }));
  }
}
class R5 extends Xf {
}
class I5 extends R5 {
  constructor(t, e, i, s, o, n, a, l) {
    super(s, n, a, l), this.Vs = "Slice", this.M = 0, this.zk = !1, this.Vk = Lt, this.Nk = Lt, this.Gk = this.M, this.$k = Fn((() => this.chart.yi.Rs())), this.Uk = () => {
      this.jk = void 0;
    }, this.D = new Nt(), this.index = t, this.chart = s, this.scale = o, this.ys = n, this.Lb = e.Vc(o, fr.Simple).Ii(this.getHighlight()), this.Ts(this.Lb), this.Gh = i.In(o).Ii(this.getHighlight()), this.Ts(this.Gh, { isText: !0 });
  }
  setValue(t) {
    return this.chart.getAnimationsEnabled() ? this.getVisible() && this.Yk(this.Gk, t, (() => this.chart.Ns.forEach(((e) => e.Gs())))) : this.Gk = t, this.M = t, this.chart.Ns.forEach(((e) => e.Gs())), this.chart.yi.Rs(), this;
  }
  getValue() {
    return this.M;
  }
  setVisible(t) {
    return t === !1 ? this.chart.getAnimationsEnabled() && Math.abs(this.Gk) > 0 ? (this.jk && (this.jk.finish(!1), this.jk = void 0), this.Yk(this.Gk, 0, (() => super.setVisible(!1)))) : (this.Gk = 0, super.setVisible(!1)) : this.chart.getAnimationsEnabled() ? (this.jk && (this.jk.finish(!1), this.jk = void 0), super.setVisible(!0), this.Yk(this.Gk, this.M)) : (this.Gk = this.M, super.setVisible(!0)), this;
  }
  Yk(t, e, i) {
    this.jk = this.$k(300, Cr.ease)([[t, e]], (([s]) => {
      this.Gk = s, this.chart.yi.Rs();
    })), this.jk.addEventListener("everyAnimationEnd", this.Uk), i && this.jk.addEventListener("end", i);
  }
  setStyle(t, e, i, s, o) {
    this.Vk = t, this.Nk = i, this.Lb.sr(this.Vk).ir(e), this.Gh.sr(this.Nk).Ih(s).en(o);
  }
  getAnimatedValue() {
    return this.Gk;
  }
  ar(t, e) {
    return t.Ii(e), this.chart.yi.Rs(), this;
  }
  nr() {
    return { fill: this.Vk, stroke: this.Lb.hl() };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
var Td;
(function(r) {
  r[r.LabelsInsideSlices = 0] = "LabelsInsideSlices", r[r.LabelsOnSides = 1] = "LabelsOnSides";
})(Td || (Td = {}));
const Zf = { SortByName: (r, t) => r.getName().localeCompare(t.getName(), void 0, { numeric: !0 }), None: () => 0 }, Kf = { NamePlusValue: (r) => `${r.getName()}: ${Math.round(r.getAnimatedValue())}` };
var Sr;
(function(r) {
  r[r.VariableHeight = 0] = "VariableHeight", r[r.VariableWidth = 1] = "VariableWidth";
})(Sr || (Sr = {}));
const Zg = (r, t) => {
  let e = 100;
  return r <= 0 ? r = 0 : (e = r >= 100 ? 100 : r, r = t * (e / 100)), r;
}, V5 = (r, t, e, i, s, o = 0, n = Sr.VariableHeight, a, l) => {
  t = Zg(t, i.x), e = Zg(e, i.x);
  const h = r.length;
  let u = 0, c = 0;
  u = r.reduce(((v, b) => v + Math.abs(b.getAnimatedValue())), 0);
  let d = { x: a - t / 2 + l.left, y: i.y + s.bottom + l.bottom }, f = { x: a + t / 2 + l.left, y: i.y + s.bottom + l.bottom }, p = { x: 0, y: s.bottom }, g = { x: 0, y: s.bottom }, y = 0, m = 0;
  if (o) for (let v = 0; v < r.length; v += 1) {
    const b = r[v], w = 10;
    m += Math.abs(b.getAnimatedValue());
    const k = n === Sr.VariableWidth ? (i.y - o * h) / h : i.y + s.bottom - m / u * i.y;
    if (n === Sr.VariableWidth) {
      o = k - o < w ? Math.max(20, k - w) : o;
      break;
    }
    y !== 0 && y - k - o < w && (o = Math.max(0, y - k - w)), y = k;
  }
  const A = (t - e) / 2 / i.y;
  for (let v = 0; v < h; v += 1) {
    const b = r[v];
    c += Math.abs(b.getAnimatedValue());
    const w = n === Sr.VariableWidth ? (i.y - o * h) / h : i.y + s.bottom - c / u * i.y;
    let k = 0;
    v > 0 && (d = { x: p.x + A * o, y: p.y - o }, f = { x: g.x - A * o, y: g.y - o }), k = (t + c / u * (e - t)) / 2, p = { x: a - k + l.left, y: n === Sr.VariableWidth ? d.y - w : w + l.bottom }, g = { x: a + k + l.left, y: n === Sr.VariableWidth ? f.y - w : w + l.bottom }, f.x >= d.x && g.x > p.x && b.Lb.yu([p, d, f, g]);
  }
};
class _5 extends Rr {
  constructor(t, e, i, s, o, n, a) {
    var l;
    super(t, e, i, e.Av("funnelChart bg", 0), s, e.yi.xi.funnelChartBackgroundFillStyle, e.yi.xi.funnelChartBackgroundStrokeStyle, e.yi.xi.funnelChartTitleFont, e.yi.xi.funnelChartTitleFillStyle, e.yi.xi.funnelChartTitleShadow, n, (l = a?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.Hk = [], this.Wk = Zf.None, this.Xk = !0, this.Zk = this.xi.funnelChartSliceLabelShadow, this.Jk = 0, this.Qk = 20, this.Kk = 5, this.qk = Sr.VariableHeight, this.tC = !0, this.iC = (d) => {
      const f = this.Hk.indexOf(d);
      f >= 0 && (this.Hk.splice(f, 1), this.sC());
    }, this.D = new Nt(), this.yi.Oa(Ot.Fo), this.eC = this.xi.effectsText, this.rC = e.nS("funnelChart bottom", 0), this.hC = e.nS("funnelChart top", 1), this.Wr.rn("Funnel Chart"), this.nC = this.xi.funnelChartSliceFillStylePalette, this.oC = this.xi.funnelChartSliceStrokeStyle, this.aC = this.xi.funnelChartSliceLabelFont, this.lC = this.xi.funnelChartSliceLabelFillStyle;
    const h = e.fS(), u = $e(a ? a.cursorBuilder : void 0, Ta);
    this.AS = Xr(this, h, u.zm(h, this.uiScale, this.uiScale, ie, this.xi), void 0, "show-pointed", O5, (() => 0)), this.setAnimationsEnabled(a?.animationsEnabled !== !1), this.fv(o, this.xA);
    const c = { backgroundVisible: !0, ...a?.legend };
    this.legend.setOptions(c);
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  addCursor(t = Ta) {
    const e = this.tv(), i = t.zm(e, this.uiScale, this.uiScale, this.Jg(e), this.xi);
    return this.cv(i), i;
  }
  addSlice(t, e) {
    const i = new I5(this.Jk, this.rC, this.hC, this, this.xA, this.iC, this.xi, this.yi.bs);
    return this.Jk += 1, i.setName(t), i.setValue(e), i.bs.Ms.Es(this.eC), i.bs._s.Es(this.tC), this.Hk.push(i), this.yi.Rs(), i.setHighlightOnHover(this.Xk), this.Ns.forEach(((s) => {
      s.Vg() && s.Pu(i);
    })), i;
  }
  addSlices(t) {
    const e = [];
    for (let i = 0; i < t.length; i += 1) e.push(this.addSlice(t[i].name, t[i].value));
    return e;
  }
  getSlices() {
    return this.Hk;
  }
  setNeckWidth(t) {
    return this.Qk = Jt(t, 1, 99), this.yi.Rs(), this;
  }
  getNeckWidth() {
    return this.Qk;
  }
  setSliceGap(t) {
    return this.Kk = Math.min(Math.max(t, 0), 20), this.yi.Rs(), this;
  }
  setSliceMode(t) {
    return this.qk = t, this.yi.Rs(), this;
  }
  getFunnelSliceMode() {
    return this.qk;
  }
  setLUT(t) {
    return this.Nf = t, this.yi.Rs(), this;
  }
  setSliceFillStyle(t) {
    return this.nC = t, this.yi.Rs(), this;
  }
  getSliceFillStyle() {
    return this.nC;
  }
  setSliceStrokeStyle(t) {
    return this.oC = typeof t == "function" ? t(this.oC) : t, this.yi.Rs(), this;
  }
  getSliceStrokeStyle() {
    return this.oC;
  }
  setSliceEffect(t) {
    return this.tC = t, this.Hk.forEach(((e) => e.bs._s.Es(t))), this.yi.Rs(), this;
  }
  getSliceEffect() {
    return this.tC;
  }
  setSliceSorter(t) {
    return this.Wk = t, this.Hk = this.Hk.sort(this.Wk), this.yi.Rs(), this;
  }
  getSliceSorter() {
    return this.Wk;
  }
  setLabelFillStyle(t) {
    return this.lC = typeof t == "function" ? t(this.lC) : t, this.yi.Rs(), this;
  }
  getLabelFillStyle() {
    return this.lC;
  }
  setLabelShadow(t) {
    return this.Zk = t, this.yi.Rs(), this;
  }
  getLabelShadow() {
    return this.Zk;
  }
  setLabelFont(t) {
    return this.aC = typeof t == "function" ? t(this.aC) : t, this.yi.Rs(), this;
  }
  getLabelFont() {
    return this.aC;
  }
  setLabelEffect(t) {
    return this.eC = t, this.Hk.forEach(((e) => e.bs.Ms.Es(t))), this.yi.Rs(), this;
  }
  getLabelEffect() {
    return this.eC;
  }
  setLabelFormatter(t) {
    return this.uC = t, this.yi.Rs(), this;
  }
  getLabelFormatter() {
    return this.uC;
  }
  setSliceHighlightOnHover(t) {
    return this.Xk = t, this.Hk.forEach(((e) => e.setHighlightOnHover(t))), this;
  }
  rr(t) {
    super.rr(t), super.dv(), this.Hk = this.Hk.sort(this.Wk);
    for (let c = 0, { length: d } = this.Hk; c < d; c += 1) this.cC(this.Hk[c], c);
    const e = this.Hk.filter(((c) => Math.abs(c.getAnimatedValue()) > 0)), i = ui.xv(this.Wr, this.gv), s = this.Ns.reduce(((c, d) => {
      const f = d.Uh(i, this.Hn);
      return { top: Math.max(c.top, f.top), bottom: Math.max(c.bottom, f.bottom), left: Math.max(c.left, f.left), right: Math.max(c.right, f.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, s);
    const o = j(this.xA.x.getInnerInterval() - (this.Hn.left + this.Hn.right), this.xA.y.getInnerInterval() - (this.Hn.bottom + this.Hn.top + i)), n = j(o.x - s.left - s.right, o.y - s.top - s.bottom), a = j(this.Hn.left + (o.x + s.left - s.right) / 2, this.Hn.bottom + (o.y + s.bottom - s.top) / 2);
    let l = 0;
    for (let c = 0; c < e.length; c += 1) l += Math.abs(e[c].getAnimatedValue());
    const h = [];
    for (let c = 0; c < e.length; c += 1) h.push((u = Math.abs(e[c].getAnimatedValue())) > 0 ? u / l : 0);
    var u;
    for (let c = 0; c < e.length; c += 1) {
      const d = e[c];
      d.Gh.rn(this.uC(d, h[c])).Uh();
    }
    h.push(l), this.AS.rr(!1, this.Hk, ((c, d, f) => {
      const p = h[e.indexOf(c)] || 0, g = this.yi.ul(d);
      return { cursorPosition: { pointMarker: { x: g.engineX, y: g.engineY }, pointMarkerScale: this.yi.ai, resultTable: { x: g.engineX, y: g.engineY }, resultTableScale: this.yi.ai }, slice: c, category: c.getName(), value: c.getValue(), relativeValue: p };
    })), this.Ns.forEach(((c) => c.rr(i, this.Hn))), this.dC(e, h, a, n, s);
  }
  cC(t, e) {
    t.setStyle(this.Nf ? new ot({ color: this.Nf.getColors(t.getAnimatedValue(), void 0) }) : this.nC(e, t), this.oC, this.lC, this.aC, this.Zk);
  }
  sC() {
    this.Hk = this.Hk.sort(this.Wk), this.yi.Rs();
  }
  Gg() {
    return this.Hk;
  }
  dispose() {
    return this.Hk.slice().forEach(((t) => t.dispose())), this.AS.G(), this.rC.G(), this.hC.G(), super.dispose();
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const O5 = (r, t, e) => [[{ component: t.slice, rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [{ text: t.value.toString(), font: { weight: "bold" } }]], N5 = (r, t, e) => {
  const i = r.pu();
  if (i.length === 0) return { x: 0, y: 0 };
  let s;
  const o = (i[1].y - i[0].y) / 2 + i[0].y;
  return s = t === nr.Left ? (i[0].x - i[1].x) / 2 + i[1].x - e : (i[2].x - (i.length === 4 ? i[3].x : i[1].x)) / 2 + (i.length === 4 ? i[3].x : i[1].x) + e, { x: s, y: o };
};
class Vx extends _5 {
  constructor() {
    super(...arguments), this.uC = Kf.NamePlusValue, this.fC = 0, this.AC = 10, this.gC = 30, this.vC = 10, this.yC = nr.Left, this.pC = [], this.mC = this.xi.funnelChartConnectorStrokeStyle;
  }
  setLabelConnectorStyle(t) {
    this.mC = t;
    for (let e = 0; e < this.pC.length; e += 1) this.pC[e].gr(this.mC);
    return this.yi.Rs(), this;
  }
  getLabelConnectorStyle() {
    return this.mC;
  }
  setLabelConnectorGapBeforeLabel(t) {
    return this.AC = t, this.yi.Rs(), this;
  }
  getLabelConnectorGapBeforeLabel() {
    return this.AC;
  }
  setLabelConnectorGapBeforeSlice(t) {
    return this.fC = t, this.yi.Rs(), this;
  }
  getLabelConnectorGapBeforeSlice() {
    return this.fC;
  }
  setLabelConnectorLengthAfterSlice(t) {
    return this.gC = t, this.yi.Rs(), this;
  }
  getLabelConnectorLengthAfterSlice() {
    return this.gC;
  }
  setLabelConnectorMinLengthBeforeSlice(t) {
    return this.vC = t, this.yi.Rs(), this;
  }
  getLabelConnectorMinLengthBeforeSlice() {
    return this.vC;
  }
  setLabelSide(t) {
    return this.yC = t, this.yi.Rs(), this;
  }
  getLabelSide() {
    return this.yC;
  }
  dC(t, e, i, s, o) {
    let n = 0, a = 0;
    for (let M = 0; M < t.length; M += 1) {
      const C = t[M].Gh.setVisible(!0).Uh().Bc();
      n = Math.max(n, C.x), a += C.y;
    }
    const l = 0.4 * s.x, h = s.x - l - (this.fC + this.gC + this.vC + this.AC);
    let u = !0;
    h < 50 ? u = !1 : n > h && (t.forEach(((M) => {
      const C = M.Gh.an(), S = M.Gh.Bc().x / C.length, E = Math.floor(h / S);
      if (E < C.length) {
        const T = C.slice(0, E - 3) + "...";
        M.Gh.rn(T).Uh();
      }
    })), a = 0, n = t.reduce(((M, C) => {
      const S = C.Gh.Bc();
      return a += S.y, Math.max(M, S.x);
    }), 0));
    const c = this.yC === nr.Left ? this.Hn.left + o.left : this.Hn.left + s.x, d = this.yC === nr.Left ? -1 : 1, f = s.y - a;
    f < 0 && (u = !1);
    const p = u ? n + this.AC + this.vC + this.gC + this.fC : 0, g = s.x - p, y = this.yC === nr.Left ? this.Hn.left + p : this.Hn.left, m = this.yC === nr.Left ? y + g : this.Hn.left + g, A = (y + m) / 2;
    V5(t, 100, this.Qk, { x: g, y: s.y }, this.Hn, this.Kk, this.qk, A, o);
    const v = t.filter(((M) => u && M.Lb.pu().length !== 0 ? (M.Gh.setVisible(!0), !0) : (M.Gh.setVisible(!1), !1))), b = f / (v.length + 1);
    let w = this.Hn.bottom + s.y - (this.qk == Sr.VariableHeight ? b : 0) + o.bottom;
    this.qk == Sr.VariableWidth && (w -= a / t.length / 2);
    const k = this.yC === nr.Left ? y : m, R = this.yC === nr.Left ? A - 0.5 * this.Qk / 100 * g : A + 0.5 * this.Qk / 100 * g, L = this.Hn.bottom + s.y + o.bottom, x = this.Hn.bottom + o.bottom;
    for (let M = 0; M < this.pC.length; M += 1) this.pC[M].setVisible(!1);
    for (let M = 0; M < v.length; M += 1) {
      const C = v[M], S = C.Lb, E = C.Gh, T = E.Bc(), I = N5(S, this.yC, this.fC);
      if (this.qk == Sr.VariableHeight) {
        C.Gh.hr({ x: c, y: w }).ru({ x: d, y: 1 });
        const F = w - 0.5 * T.y, D = { x: this.yC === nr.Left ? Math.min(tr(k, R, (F - L) / (x - L)) - this.gC, I.x) : Math.max(tr(k, R, (F - L) / (x - L)) + this.gC, I.x), y: F }, P = { x: this.yC === nr.Left ? E.Xl().x + T.x + this.AC : E.Xl().x - T.x - this.AC, y: F };
        this.SC([I, D, P]), w -= T.y + b;
      } else {
        const F = this.yC === nr.Left ? c + T.x + this.AC : c - T.x - this.AC;
        C.Gh.hr({ x: c, y: I.y }).ru({ x: d, y: 0 }), this.SC([I, { x: F, y: I.y }]);
      }
    }
  }
  getMinimumSize() {
    return j(500, 300);
  }
  SC(t) {
    if (t) {
      let e;
      for (let i = 0; i < this.pC.length; i += 1) if (!this.pC[i].getVisible()) {
        e = this.pC[i].setVisible(!0);
        break;
      }
      e === void 0 && (e = this.hC.Ay(this.xA, void 0, [Ir.InternalUI]).gr(this.mC), this.pC.push(e)), e.Vi().Pu(t);
    }
  }
}
var nr, Ar;
(function(r) {
  r[r.Right = 0] = "Right", r[r.Left = 1] = "Left";
})(nr || (nr = {}));
class B5 extends Xf {
}
class z5 extends B5 {
  constructor(t, e, i, s, o, n, a, l) {
    super(s, n, a, l), this.zk = !1, this.bC = Lt, this.Nk = Lt, this.Gk = this.M, this.xC = this.zk ? 1 : 0, this.MC = this.getVisible(), this.$k = Fn((() => this.chart.yi.Rs())), this._C = Fn((() => this.chart.yi.Rs())), this.Uk = () => {
      this.jk = void 0;
    }, this.wC = () => {
      this.kC = void 0;
    }, this.D = new Nt(), this.index = t, this.chart = s, this.scale = o, this.ys = n, this.CC = e.Ud(o).Ii(this.getHighlight()), this.Ts(this.CC), this.Gh = i.In(o).Ii(this.getHighlight()), this.Ts(this.Gh, { isText: !0 }), this.addEventListener("click", ((h) => {
      h.defaultPrevented || ((u, c) => {
        It(c), u.setExploded(!u.getExploded());
      })(this, h);
    }));
  }
  setValue(t) {
    return this.chart.getAnimationsEnabled() ? this.MC && this.Yk(this.Gk, t, (() => this.chart.Ns.forEach(((e) => e.Gs())))) : this.Gk = t, this.M = t, this.chart.Ns.forEach(((e) => e.Gs())), this.chart.yi.Rs(), this;
  }
  getValue() {
    return this.M;
  }
  setExploded(t) {
    if (t && this.chart.getMultipleSliceExplosion() === !1) {
      const e = this.chart.getSlices();
      for (let i = 0; i < e.length; i += 1) e[i] !== this && e[i].getExploded() && e[i].setExploded(!1);
    }
    return this.chart.getAnimationsEnabled() ? (this.kC && this.kC.finish(), this.kC = this._C(300, Cr.ease)([[this.xC, t ? 1 : 0]], (([e]) => {
      this.xC = e, this.chart.yi.Rs();
    })), this.kC.addEventListener("everyAnimationEnd", this.wC), this.zk = !this.zk) : this.chart.getMultipleSliceExplosion() !== !1 || t ? (this.xC = this.zk ? 0 : 1, this.zk = !this.zk) : (this.xC = 0, this.zk = !this.zk), this.chart.yi.Rs(), this;
  }
  getExploded() {
    return this.zk;
  }
  setVisible(t) {
    return this.MC = t, t === !1 ? this.chart.getAnimationsEnabled() && Math.abs(this.Gk) > 0 ? (this.jk && (this.jk.finish(!1), this.jk = void 0), this.Yk(this.Gk, 0, (() => super.setVisible(!1)))) : (this.Gk = 0, super.setVisible(!1)) : this.chart.getAnimationsEnabled() ? (this.jk && (this.jk.finish(!1), this.jk = void 0), super.setVisible(!0), this.Yk(this.Gk, this.M)) : (this.Gk = this.M, super.setVisible(!0)), this;
  }
  Yk(t, e, i) {
    this.jk = this.$k(300, Cr.ease)([[t, e]], (([s]) => {
      this.Gk = s, this.chart.yi.Rs();
    })), this.jk.addEventListener("everyAnimationEnd", this.Uk), i && this.jk.addEventListener("end", i);
  }
  setStyle(t, e, i, s, o) {
    this.bC = t, this.Nk = i, this.CC.sr(this.bC).ir(e), this.Gh.sr(this.Nk).Ih(s).en(o);
  }
  getAnimatedValue() {
    return this.Gk;
  }
  getAnimatedExplosion() {
    return this.xC;
  }
  nr() {
    return { fill: this.bC, stroke: this.CC.hl() };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class W5 extends Xf {
}
class G5 extends W5 {
  constructor(t, e, i, s, o, n, a, l) {
    super(s, n, a, l), this.Vs = "Slice", this.M = 0, this.zk = !1, this.Vk = Lt, this.Nk = Lt, this.Gk = this.M, this.$k = Fn((() => this.chart.yi.Rs())), this.Uk = () => {
      this.jk = void 0;
    }, this.D = new Nt(), this.index = t, this.chart = s, this.scale = o, this.ys = n, this.Lb = e.Vc(o, fr.Simple).Ii(this.getHighlight()), this.Ts(this.Lb), this.Gh = i.In(o).Ii(this.getHighlight()), this.Ts(this.Gh, { isText: !0 });
  }
  setValue(t) {
    return this.chart.getAnimationsEnabled() ? this.getVisible() && this.Yk(this.Gk, t, (() => this.chart.Ns.forEach(((e) => e.Gs())))) : this.Gk = t, this.M = t, this.chart.Ns.forEach(((e) => e.Gs())), this.chart.yi.Rs(), this;
  }
  getValue() {
    return this.M;
  }
  setVisible(t) {
    return t === !1 ? this.chart.getAnimationsEnabled() && Math.abs(this.Gk) > 0 ? (this.jk && (this.jk.finish(!1), this.jk = void 0), this.Yk(this.Gk, 0, (() => super.setVisible(!1)))) : (this.Gk = 0, super.setVisible(!1)) : this.chart.getAnimationsEnabled() ? (this.jk && (this.jk.finish(!1), this.jk = void 0), super.setVisible(!0), this.Yk(this.Gk, this.M)) : (this.Gk = this.M, super.setVisible(!0)), this;
  }
  Yk(t, e, i) {
    this.jk = this.$k(300, Cr.ease)([[t, e]], (([s]) => {
      this.Gk = s, this.chart.yi.Rs();
    })), this.jk.addEventListener("everyAnimationEnd", this.Uk), i && this.jk.addEventListener("end", i);
  }
  setStyle(t, e, i, s, o) {
    this.Vk = t, this.Nk = i, this.Lb.sr(this.Vk).ir(e), this.Gh.sr(this.Nk).Ih(s).en(o);
  }
  getAnimatedValue() {
    return this.Gk;
  }
  nr() {
    return { fill: this.Vk, stroke: this.Lb.hl() };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
(function(r) {
  r[r.VariableHeight = 0] = "VariableHeight", r[r.VariableWidth = 1] = "VariableWidth";
})(Ar || (Ar = {}));
const Kg = (r, t) => {
  let e = 100;
  return r <= 0 ? r = 0 : (e = r >= 100 ? 100 : r, r = t * (e / 100)), r;
}, U5 = (r, t, e, i, s, o = 0, n = Ar.VariableHeight, a, l = Me) => {
  t = Kg(t, i.x), e = Kg(e, i.x);
  const h = r.length;
  let u = 0, c = 0;
  u = r.reduce(((v, b) => v + Math.abs(b.getAnimatedValue())), 0);
  let d = { x: a - t / 2 + l.left, y: i.y + s.bottom + l.bottom }, f = { x: a + t / 2 + l.left, y: i.y + s.bottom + l.bottom }, p = { x: 0, y: s.bottom }, g = { x: 0, y: s.bottom }, y = 0, m = 0;
  if (o) for (let v = 0; v < r.length; v += 1) {
    m += Math.abs(r[v].getAnimatedValue());
    const w = n === Ar.VariableWidth ? (i.y - o * h) / h : i.y + s.bottom - m / u * i.y;
    if (n === Ar.VariableWidth) {
      o = w - o < 10 ? Math.max(20, w - 10) : o;
      break;
    }
    y !== 0 && y - w - o < 10 && (o = Math.max(0, y - w - 10)), y = w;
  }
  const A = (t - e) / 2 / i.y;
  for (let v = 0; v < h; v += 1) {
    const b = r[v];
    c += Math.abs(b.getAnimatedValue());
    const w = n === Ar.VariableWidth ? (i.y - o * h) / h : i.y + s.bottom - c / u * i.y;
    let k = 0;
    v > 0 && (d = { x: p.x + A * o, y: p.y - o }, f = { x: g.x - A * o, y: g.y - o }), k = (t + c / u * (e - t)) / 2, p = { x: a - k + l.left, y: n === Ar.VariableWidth ? d.y - w : w + l.bottom }, g = { x: a + k + l.left, y: n === Ar.VariableWidth ? f.y - w : w + l.bottom }, f.x >= d.x && g.x >= p.x && b.Lb.yu([p, d, f, g]);
  }
};
class H5 extends Rr {
  constructor(t, e, i, s, o, n, a) {
    var l;
    super(t, e, i, e.Av("pyramidChart bg", 0), s, e.yi.xi.pyramidChartBackgroundFillStyle, e.yi.xi.pyramidChartBackgroundStrokeStyle, e.yi.xi.pyramidChartTitleFont, e.yi.xi.pyramidChartTitleFillStyle, e.yi.xi.pyramidChartTitleShadow, n, (l = a?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.Hk = [], this.Wk = Zf.None, this.nC = this.xi.pyramidChartSliceFillStylePalette, this.oC = this.xi.pyramidChartSliceStrokeStyle, this.Xk = !0, this.aC = this.xi.pyramidChartSliceLabelFont, this.lC = this.xi.pyramidChartSliceLabelFillStyle, this.Zk = this.xi.pyramidChartSliceLabelShadow, this.Jk = 0, this.Qk = 100, this.Kk = 5, this.qk = Ar.VariableHeight, this.tC = !0, this.iC = (d) => {
      const f = this.Hk.indexOf(d);
      f >= 0 && (this.Hk.splice(f, 1), this.sC());
    }, this.D = new Nt(), this.yi.Oa(Ot.Fo), this.eC = this.xi.effectsText, this.rC = e.nS("pyramidChart bottom", 0), this.hC = e.nS("pyramidChart top", 1), this.Wr.rn("Pyramid Chart");
    const h = e.fS(), u = $e(a ? a.cursorBuilder : void 0, Ta);
    this.AS = Xr(this, h, u.zm(h, this.uiScale, this.uiScale, ie, this.xi), void 0, "show-pointed", Y5, (() => 0)), this.fv(o, this.xA), this.setAnimationsEnabled(a?.animationsEnabled !== !1);
    const c = { backgroundVisible: !0, ...a?.legend };
    this.legend.setOptions(c);
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  addCursor(t = Ta) {
    const e = this.tv(), i = t.zm(e, this.uiScale, this.uiScale, this.Jg(e), this.xi);
    return this.cv(i), i;
  }
  addSlice(t, e) {
    const i = new G5(this.Jk, this.rC, this.hC, this, this.xA, this.iC, this.xi, this.yi.bs);
    return this.Jk += 1, i.setName(t), i.setValue(e), i.bs.Ms.Es(this.eC), i.bs._s.Es(this.tC), this.Hk.push(i), this.yi.Rs(), this.Ns.forEach(((s) => {
      s.Vg() && s.Pu(i);
    })), i;
  }
  addSlices(t) {
    const e = [];
    for (let i = 0; i < t.length; i += 1) e.push(this.addSlice(t[i].name, t[i].value));
    return e;
  }
  getSlices() {
    return this.Hk;
  }
  setNeckWidth(t) {
    return this.Qk = Jt(t, 1, 100), this.yi.Rs(), this;
  }
  getNeckWidth() {
    return this.Qk;
  }
  setSliceGap(t) {
    return this.Kk = Math.min(Math.max(t, 0), 20), this.yi.Rs(), this;
  }
  setSliceMode(t) {
    return this.qk = t, this.yi.Rs(), this;
  }
  getPyramidSliceMode() {
    return this.qk;
  }
  setLUT(t) {
    return this.Nf = t, this.yi.Rs(), this;
  }
  setSliceFillStyle(t) {
    return this.nC = t, this.yi.Rs(), this;
  }
  getSliceFillStyle() {
    return this.nC;
  }
  setSliceStrokeStyle(t) {
    return this.oC = typeof t == "function" ? t(this.oC) : t, this.yi.Rs(), this;
  }
  getSliceStrokeStyle() {
    return this.oC;
  }
  setSliceEffect(t) {
    return this.tC = t, this.Hk.forEach(((e) => e.bs._s.Es(t))), this.yi.Rs(), this;
  }
  getSliceEffect() {
    return this.tC;
  }
  setSliceSorter(t) {
    return this.Wk = t, this.Hk = this.Hk.sort(this.Wk), this.yi.Rs(), this;
  }
  getSliceSorter() {
    return this.Wk;
  }
  setLabelFillStyle(t) {
    return this.lC = typeof t == "function" ? t(this.lC) : t, this.yi.Rs(), this;
  }
  getLabelFillStyle() {
    return this.lC;
  }
  setLabelShadow(t) {
    return this.Zk = t, this.yi.Rs(), this;
  }
  getLabelShadow() {
    return this.Zk;
  }
  setLabelFont(t) {
    return this.aC = typeof t == "function" ? t(this.aC) : t, this.yi.Rs(), this;
  }
  getLabelFont() {
    return this.aC;
  }
  setLabelEffect(t) {
    return this.eC = t, this.Hk.forEach(((e) => e.bs.Ms.Es(t))), this.yi.Rs(), this;
  }
  getLabelEffect() {
    return this.eC;
  }
  setLabelFormatter(t) {
    return this.uC = t, this.yi.Rs(), this;
  }
  getLabelFormatter() {
    return this.uC;
  }
  setSliceHighlightOnHover(t) {
    return this.Xk = t, this.Hk.forEach(((e) => e.setHighlightOnHover(t))), this;
  }
  rr(t) {
    super.rr(t), super.dv(), this.Hk = this.Hk.sort(this.Wk);
    for (let c = 0, { length: d } = this.Hk; c < d; c += 1) this.cC(this.Hk[c], c);
    const e = this.Hk.filter(((c) => Math.abs(c.getAnimatedValue()) > 0)), i = ui.xv(this.Wr, this.gv), s = this.Ns.reduce(((c, d) => {
      const f = d.Uh(i, this.Hn);
      return { top: Math.max(c.top, f.top), bottom: Math.max(c.bottom, f.bottom), left: Math.max(c.left, f.left), right: Math.max(c.right, f.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, s);
    const o = j(this.xA.x.getInnerInterval() - (this.Hn.left + this.Hn.right), this.xA.y.getInnerInterval() - (this.Hn.bottom + this.Hn.top + i)), n = j(o.x - s.left - s.right, o.y - s.top - s.bottom), a = j(this.Hn.left + (o.x + s.left - s.right) / 2, this.Hn.bottom + (o.y + s.bottom - s.top) / 2);
    let l = 0;
    for (let c = 0; c < e.length; c += 1) l += Math.abs(e[c].getAnimatedValue());
    const h = [];
    for (let c = 0; c < e.length; c += 1) h.push((u = Math.abs(e[c].getAnimatedValue())) > 0 ? u / l : 0);
    var u;
    for (let c = 0; c < e.length; c += 1) {
      const d = e[c];
      d.Gh.rn(this.uC(d, h[c])).Uh();
    }
    h.push(l), this.AS.rr(!1, this.Hk, ((c, d, f) => {
      const p = h[e.indexOf(c)] || 0, g = this.yi.ul(d);
      return { cursorPosition: { pointMarker: { x: g.engineX, y: g.engineY }, pointMarkerScale: this.yi.ai, resultTable: { x: g.engineX, y: g.engineY }, resultTableScale: this.yi.ai }, slice: c, category: c.getName(), value: c.getValue(), relativeValue: p };
    })), this.Ns.forEach(((c) => c.rr(i, this.Hn))), this.dC(e, h, a, n, s);
  }
  cC(t, e) {
    t.setStyle(this.Nf ? new ot({ color: this.Nf.getColors(t.getAnimatedValue(), void 0) }) : this.nC(e, t), this.oC, this.lC, this.aC, this.Zk);
  }
  sC() {
    this.Hk = this.Hk.sort(this.Wk), this.yi.Rs();
  }
  Gg() {
    return this.Hk;
  }
  dispose() {
    return this.Hk.slice().forEach(((t) => t.dispose())), this.AS.G(), this.rC.G(), this.hC.G(), super.dispose();
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Y5 = (r, t, e) => [[{ component: t.slice, rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [{ text: t.value.toString(), font: { weight: "bold" } }]], j5 = (r, t, e) => {
  const i = r.pu();
  if (i.length === 0) return { x: 0, y: 0 };
  let s;
  const o = (i[1].y - i[0].y) / 2 + i[0].y;
  return s = t === pr.Left ? (i[0].x - i[1].x) / 2 + i[1].x - e : (i[2].x - (i.length === 4 ? i[3].x : i[1].x)) / 2 + (i.length === 4 ? i[3].x : i[1].x) + e, { x: s, y: o };
};
class _x extends H5 {
  constructor() {
    super(...arguments), this.uC = Kf.NamePlusValue, this.fC = 0, this.AC = 10, this.gC = 30, this.vC = 10, this.yC = pr.Left, this.TC = Td.LabelsOnSides, this.pC = [], this.mC = this.xi.pyramidChartConnectorStrokeStyle;
  }
  setLabelConnectorStyle(t) {
    this.mC = t;
    for (let e = 0; e < this.pC.length; e += 1) this.pC[e].gr(this.mC);
    return this.yi.Rs(), this;
  }
  getLabelConnectorStyle() {
    return this.mC;
  }
  setLabelConnectorGapBeforeLabel(t) {
    return this.AC = t, this.yi.Rs(), this;
  }
  getLabelConnectorGapBeforeLabel() {
    return this.AC;
  }
  setLabelConnectorGapBeforeSlice(t) {
    return this.fC = t, this.yi.Rs(), this;
  }
  getLabelConnectorGapBeforeSlice() {
    return this.fC;
  }
  setLabelConnectorLengthAfterSlice(t) {
    return this.gC = t, this.yi.Rs(), this;
  }
  getLabelConnectorLengthAfterSlice() {
    return this.gC;
  }
  setLabelConnectorMinLengthBeforeSlice(t) {
    return this.vC = t, this.yi.Rs(), this;
  }
  getLabelConnectorMinLengthBeforeSlice() {
    return this.vC;
  }
  setLabelSide(t) {
    return this.yC = t, this.yi.Rs(), this;
  }
  getLabelSide() {
    return this.yC;
  }
  dC(t, e, i, s, o) {
    let n = 0, a = 0;
    for (let M = 0; M < t.length; M += 1) {
      const C = t[M].Gh.Bc();
      n = Math.max(n, C.x), a += C.y;
    }
    const l = 0.4 * s.x, h = s.x - l - (this.fC + this.gC + this.vC + this.AC);
    let u = !0;
    h < 50 ? u = !1 : n > h && (t.forEach(((M) => {
      const C = M.Gh.an(), S = M.Gh.Bc().x / C.length, E = Math.floor(h / S);
      if (E < C.length) {
        const T = C.slice(0, E - 3) + "...";
        M.Gh.rn(T).Uh();
      }
    })), a = 0, n = t.reduce(((M, C) => {
      const S = C.Gh.Bc();
      return a += S.y, Math.max(M, S.x);
    }), 0));
    const c = this.yC === pr.Left ? this.Hn.left + o.left : this.Hn.left + s.x, d = this.yC === pr.Left ? -1 : 1, f = s.y - a;
    f < 0 && (u = !1);
    const p = u ? n + this.AC + this.vC + this.gC + this.fC : 0, g = s.x - p, y = this.yC === pr.Left ? this.Hn.left + p : this.Hn.left, m = this.yC === pr.Left ? y + g : this.Hn.left + g, A = (y + m) / 2;
    U5(t, 1e-3, this.Qk, { x: g, y: s.y }, this.Hn, this.Kk, this.qk, A, o);
    const v = t.filter(((M) => u && M.Lb.pu().length !== 0 ? (M.Gh.setVisible(!0), !0) : (M.Gh.setVisible(!1), !1))), b = f / (v.length + 1);
    let w = this.Hn.bottom + s.y - (this.qk == Ar.VariableHeight ? b : 0) + o.bottom;
    this.qk == Ar.VariableWidth && (w -= a / t.length / 2);
    const k = A, R = this.yC === pr.Left ? y : m, L = this.Hn.bottom + s.y + o.bottom, x = this.Hn.bottom + o.bottom;
    for (let M = 0; M < this.pC.length; M += 1) this.pC[M].setVisible(!1);
    for (let M = 0; M < v.length; M += 1) {
      const C = v[M], S = C.Lb, E = C.Gh, T = E.Bc(), I = j5(S, this.yC, this.fC);
      if (this.qk == Ar.VariableHeight) {
        C.Gh.hr({ x: c, y: w }).ru({ x: d, y: 1 });
        const F = w - 0.5 * T.y, D = { x: this.yC === pr.Left ? Math.min(tr(k, R, (F - L) / (x - L)) - this.gC, I.x) : Math.max(tr(k, R, (F - L) / (x - L)) + this.gC, I.x), y: F }, P = { x: this.yC === pr.Left ? E.Xl().x + T.x + this.AC : E.Xl().x - T.x - this.AC, y: F };
        this.SC([I, D, P]), w -= T.y + b;
      } else {
        const F = this.yC === pr.Left ? c + T.x + this.AC : c - T.x - this.AC;
        C.Gh.hr({ x: c, y: I.y }).ru({ x: d, y: 0 }), this.SC([I, { x: F, y: I.y }]);
      }
    }
  }
  getMinimumSize() {
    return j(500, 300);
  }
  SC(t) {
    let e;
    for (let i = 0; i < this.pC.length; i += 1) if (!this.pC[i].getVisible()) {
      e = this.pC[i].setVisible(!0);
      break;
    }
    e === void 0 && (e = this.hC.Ay(this.xA, void 0, [Ir.InternalUI]).gr(this.mC), this.pC.push(e)), e.Vi().Pu(t);
  }
}
var pr, Zl;
(function(r) {
  r[r.Right = 0] = "Right", r[r.Left = 1] = "Left";
})(pr || (pr = {})), (function(r) {
  r[r.Normal = 0] = "Normal", r[r.Circle = 1] = "Circle";
})(Zl || (Zl = {}));
class $5 {
  constructor(t, e, i, s, o, n, a, l, h) {
    this.Vr = !1, this.FC = za.fitting({ start: !1 }), this.IC = (u) => this.axisScale.Xt(u, en.Numeric), this.formatValue = (u) => this.IC(u, { start: this.axisScale.$, end: this.axisScale.U }), this.PC = t, this.Ln = e, this.scale = i, this.chart = s, this.tag = o, this.axisScale = ki.d1({ scale1DConstructor: ts, dimension: "x" }).Z(0, 1), this.LC = n, this.FC = l, h && (this.IC = h), a && this.setInterval(a), this.BC = this.PC.vr(this.scale).setPointerEvents(!1), this.DC = this.Ln.In(this.scale).rn(this.tag).setPointerEvents(!1), this.EC = this.PC.Ay(this.scale, void 0, [Ir.InternalUI]).gr(this.chart.getNibStyle()), this.LC.Fs([this.DC]);
  }
  dC(t, e, i, s, o, n, a) {
    const l = e.length, h = e[i > 0 ? i - 1 : l - 1], u = e[i], c = e[i < l - 1 ? i + 1 : 0], d = this.chart.getNibLength();
    this.BC.pr(t).yr(u).gr(this.chart.getAxisStyle()), this.EC.Vi().Pu(n === Zl.Normal ? [Ln(u, h, Jt(0.5 * d / an(oi(h, u)), 0, 1)), u, Ln(u, c, Jt(0.5 * d / an(oi(c, u)), 0, 1))] : ((f, p, g, y, m = 2) => {
      const A = y / g, v = [];
      for (let b = -y / 2; b <= y / 2; b += m) {
        const w = A * (b / y) + p, k = j(f.x + Math.cos(w) * g, f.y + Math.sin(w) * g);
        v.push(k);
      }
      return v;
    })(t, s, o, d)), a ? this.DC.setVisible(!0).hr(qt(u, j(a.paddingX, a.paddingY))).ql(a.alignmentX).su(a.alignmentY) : this.DC.setVisible(!1);
  }
  bn(t) {
    if (this.FC && !this.Vr) {
      const e = this.FC.apply({ axis: this, curStart: this.axisScale.getInnerStart(), curEnd: this.axisScale.getInnerEnd(), seriesDataRange: t });
      e && this.axisScale.Z(e.start, e.end);
    }
  }
  getLabelSize() {
    return this.DC.Ih(this.chart.getAxisLabelFont()).sr(this.chart.getAxisLabelStyle()).Uh().Ft();
  }
  dispose() {
    this.BC && this.BC.dispose(), this.DC && this.DC.dispose(), this.EC && this.EC.dispose();
  }
  getTag() {
    return this.tag;
  }
  setInterval(t) {
    const { start: e, end: i, stopAxisAfter: s } = t;
    return s !== void 0 && (this.Vr = s), this.axisScale.Z(e ?? this.axisScale.getInnerStart(), i ?? this.axisScale.getInnerEnd()), this.chart.yi.Rs(), this;
  }
  getInterval() {
    return { start: this.axisScale.getInnerStart(), end: this.axisScale.getInnerEnd() };
  }
  setScaleLabelFormatter(t) {
    return this.IC = t, this.chart.yi.Rs(), this;
  }
  setScrollStrategy(t) {
    return this.FC = If(t), this.chart.yi.Rs(), this;
  }
  getScrollStrategy() {
    return this.FC;
  }
}
const X5 = (r, t, e, i, s, o) => (r.alignmentX = (s + Math.PI / 2) % (2 * Math.PI) <= Math.PI ? -1 : 1, r.alignmentY = s % (2 * Math.PI) <= Math.PI ? -1 : 1, r.paddingX = Math.cos(s) * o, r.paddingY = Math.sin(s) * o, r), Z5 = (r) => {
  if (r.axisIndex === 0) return r.paddingX = r.labelPadding, r.alignmentX = -1, r;
  let t = !1;
  const e = r.chart.getAxes();
  if (e.length > 1) {
    const i = e[0].getInterval();
    t = e.some(((s) => {
      const o = s.getInterval();
      return o.start !== i.start || o.end !== i.end;
    }));
  }
  return t ? (r.paddingX = r.labelPadding, r.alignmentX = -1, r) : void 0;
};
class K5 extends gh {
  constructor(t, e, i, s, o, n, a, l, h, u, c, d) {
    super(t, h, u, d), this.Vs = "Spider Series", this.RC = /* @__PURE__ */ new Map(), this.OC = /* @__PURE__ */ new Map(), this.gs = Qi.onHover, this.dk = 8, this.Dl = 0, this.zC = (() => {
      const f = Fn((() => {
      }));
      let p;
      return (g, y, m, A) => {
        const v = A?.onStart, b = A?.onCompleted, w = A?.easing || Cr.ease, k = A?.durationMs || 1e3;
        let R;
        if (p) if (p.nextAnimations.length === 0) {
          const L = p.NextAnimation([[g, y]], (([x]) => {
            p = L, m(x);
          }), k, w);
          R = L;
        } else {
          g = p.nextAnimations.pop().values[0][0];
          const L = p.NextAnimation([[g, y]], (([x]) => {
            p = L, m(x);
          }), k, w);
          R = L;
        }
        else R = f(k, w)([[g, y]], (([L]) => {
          m(L);
        })), p = R;
        R.addEventListener("end", (() => {
          p = void 0;
        })), v && R.addEventListener("start", v), b && R.addEventListener("end", b);
      };
    })(), this.VC = {}, this.NC = {}, this.MC = this.getVisible(), this.GC = 1, this.$C = ((f, p) => {
      const g = Fn((() => {
      }));
      let y, m, A = 1;
      return (v, b, w) => {
        if (v === m) return;
        m = v;
        const k = w?.easing || Cr.ease, R = w?.durationMs || 1e3;
        y && (y.finish(!1), y = void 0), v === !1 ? b && A && (y = g(R, k)([[A, 0]], (([L]) => {
          A = L, f(A);
        })), y.addEventListener("end", (() => {
          y = void 0, p(!1);
        })), A = 0, p(!1)) : b ? (p(!0), y = g(R, k)([[A, 1]], (([L]) => {
          A = L, f(A);
        })), y.addEventListener("end", (() => {
          y = void 0;
        }))) : (A = 1, p(!0));
      };
    })(((f) => {
      this.GC = f, this.Js.yi.Rs();
    }), ((f) => {
      super.setVisible(f);
    })), this.UC = !1, this.D = new Nt(), this.chart = t, this.Js = e, this.fk = s, this.jC = o, this.oS = n, this.YC = a, this.HC = l, this.scale = i, this.WC = ue(u.spiderSeriesFillStyle, c), this.XC = ue(u.spiderSeriesStrokeStyle, c), this.ZC = ue(u.spiderSeriesPointFillStyle, c);
  }
  JC() {
    return this.UC;
  }
  Qi(t, e, i) {
    const s = this.HC(e);
    if (s !== void 0 && this.RC.has(s.tag)) {
      const o = this.RC.get(s.tag), n = this.YC(s.tag, o);
      return { cursorPosition: { pointMarker: n, pointMarkerScale: this.scale, resultTable: n, resultTableScale: this.scale }, series: this, axis: s.tag, value: o };
    }
  }
  Uv() {
    return this.kv && this.RC.size > 0 && this.getVisible();
  }
  addPoints(...t) {
    const e = this.RC.size === 0;
    e || this.chart.yi.Oa(Ot.Go), t = t.filter(((i) => i.axis !== void 0));
    for (let i = 0; i < t.length; i += 1) {
      const s = t[i].axis;
      this.jC(s);
    }
    if (this.chart.getAnimationsEnabled() && this.VC !== void 0) {
      let i;
      t.forEach(((s) => this.OC.set(s.axis, s.value))), this.zC(0, 1, ((s) => {
        this.OC.forEach(((o, n) => {
          const a = i?.get(n) || 0;
          this.RC.set(n, a + s * (o - a)), this.Js.yi.Rs();
        }));
      }), { easing: this.VC.easing, durationMs: this.VC.durationMs, onStart: () => {
        this.UC = e, i = new Map(this.RC);
      }, onCompleted: () => {
        this.UC = !1;
      } });
    } else for (let i = 0; i < t.length; i += 1) {
      const s = t[i].axis;
      this.RC.set(s, t[i].value), this.OC.set(s, t[i].value);
    }
    return this.Js.Rs(), this;
  }
  getValue(t, e = !1) {
    if (this.chart.getAxis(t)) return e ? this.RC.get(t) : this.OC.get(t);
  }
  setAnimationAddPoints(t, e) {
    return this.VC = t ? { easing: t, durationMs: e } : void 0, this.Js.Rs(), this;
  }
  setVisibleStateChangedAnimation(t, e) {
    return this.NC = t ? { easing: t, durationMs: e } : void 0, this.Js.Rs(), this;
  }
  setFillStyle(t) {
    return this.WC = typeof t == "function" ? t(this.WC) : t, this.Lb && (this.Lb.sr(this.WC), this.Js.Rs()), this;
  }
  getFillStyle() {
    return this.WC;
  }
  setStrokeStyle(t) {
    return this.XC = typeof t == "function" ? t(this.XC) : t, this.Lb && (this.Lb.ir(this.XC), this.Js.Rs()), this;
  }
  getStrokeStyle() {
    return this.XC;
  }
  setPointFillStyle(t) {
    return this.ZC = typeof t == "function" ? t(this.ZC) : t, this.Ak && (this.Ak.tf(this.ZC), this.Js.Rs()), this;
  }
  getPointFillStyle() {
    return this.ZC;
  }
  setPointSize(t) {
    return this.dk = t, this.Ak && this.Ak.df(t), this;
  }
  getPointSize() {
    return this.dk;
  }
  getPointShape() {
    return this.fk;
  }
  setPointRotation(t) {
    return this.Dl = t, this.Ak && this.Ak.nf(t), this.Js.Rs(), this;
  }
  getPointRotation() {
    return this.Dl;
  }
  rr() {
    if (super.rr(), !this.ci) {
      const t = new Array(this.oS.length);
      for (let e = 0; e < this.oS.length; e += 1) {
        const i = this.oS[e].getInterval().start, s = this.RC.get(this.oS[e].tag);
        t[e] = s !== void 0 ? this.YC(this.oS[e].tag, i + this.GC * (s - i)) : this.YC(this.oS[e].tag, i);
      }
      Om(t), t.length >= 3 && (this.Lb || (this.Lb = this.Js.Vc(this.scale, fr.Simple).ir(this.XC).sr(this.WC).Ii(this.getHighlight()), this.Ts(this.Lb)), this.Lb.yu(t), this.Ak || (this.Ak = this.Js.ef(this.scale).sf(Lt).gr(Et).df(this.dk).rf(this.fk).nf(this.Dl).tf(this.ZC).Ii(this.getHighlight()), this.Ts(this.Ak)), this.Ak.qd(new cr({ schema: { x: { pattern: null }, y: { pattern: null } } }).appendJSON(t), { x: "x", y: "y" }));
    }
  }
  nr() {
    return { fill: this.WC, stroke: this.XC };
  }
  Xs() {
    return this.zs || this.fk;
  }
  ar(t, e) {
    return t.Ii(e), this.Js.Rs(), this;
  }
  setVisible(t) {
    var e, i;
    return this.MC = t, this.$C(t, this.chart.getAnimationsEnabled() && this.NC !== void 0, { easing: (e = this.NC) === null || e === void 0 ? void 0 : e.easing, durationMs: (i = this.NC) === null || i === void 0 ? void 0 : i.durationMs }), this;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Uh = (r, t) => {
  const e = Math.PI / 2 - 2 * r * Math.PI / t;
  return e >= 0 ? e : e + 2 * Math.PI;
}, q5 = (r) => r.DC.Ic(), J5 = (r) => r.Ic(), Bc = (r, t, e, i) => r.Ac(0).hr(e).lc(90).yr(-270).gc(t === Zl.Circle ? void 0 : i.length), cl = { alignmentX: 0, alignmentY: 0, paddingX: 0, paddingY: 0 }, ta = { alignmentX: 0, alignmentY: 0, paddingX: 0, paddingY: 0 }, qg = () => {
  ta.alignmentX = 0, ta.alignmentY = 0, ta.paddingX = 0, ta.paddingY = 0;
};
class Ox extends $a {
  constructor(t, e, i, s, o, n, a) {
    var l;
    super(t, e, i, e.Av("spiderChart bg", 0), s, e.yi.xi.spiderChartBackgroundFillStyle, e.yi.xi.spiderChartBackgroundStrokeStyle, e.yi.xi.spiderChartTitleFont, e.yi.xi.spiderChartTitleFillStyle, e.yi.xi.spiderChartTitleShadow, a, (l = n?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.oS = [], this.QC = [], this.KC = [], this.FC = za.fitting({ start: !1 }), this.qC = !0, this.tT = Z5, this.iT = X5, this.sT = Zl.Normal, this.eT = 4, this.rT = this.xi.spiderChartWebStyle, this.hT = this.xi.spiderChartScaleLabelFillStyle, this.nT = this.xi.spiderChartScaleLabelShadow, this.oT = this.xi.spiderChartScaleLabelFont, this.aT = 5, this.lT = this.xi.spiderChartAxisLabelFillStyle, this.uT = this.xi.spiderChartAxisLabelFont, this.cT = 5, this.dT = this.xi.spiderChartAxisStrokeStyle, this.fT = this.xi.spiderChartAxisNibStrokeStyle, this.AT = 10, this.gT = To(), this.hasAxis = (d) => this.oS.reduce(((f, p) => f || p.tag === d), !1), this.vT = () => {
      const d = this.oS.map(q5).concat(this.KC.map(J5));
      return Gm(d);
    }, this.yT = () => this.pT.Ud(this.xA).setPointerEvents(!1), this.mT = (d) => d.dispose(), this.ST = () => this.uA.In(this.xA).setPointerEvents(!1), this.bT = (d) => d.dispose(), this.xT = (d) => {
      this.qC && !this.hasAxis(d) && this.addAxis(d);
    }, this.YC = (d, f) => {
      for (const p of this.oS) if (p.tag === d) {
        const g = Math.max(Math.min((f - p.axisScale.getInnerStart()) / (p.axisScale.getInnerEnd() - p.axisScale.getInnerStart()), 1), 0);
        return Ln(p.BC.Ht(), p.BC.jt(), g);
      }
    }, this.HC = (d) => {
      if (this.oS.length === 0) return;
      const f = oi(this.translateCoordinate(d, this.coordsRelative), this.oS[0].BC.Ht()), p = Math.atan2(f.y, f.x);
      let g, y = wt;
      for (const m of this.oS) {
        const A = oi(m.BC.jt(), m.BC.Ht()), v = Math.atan2(A.y, A.x), b = Math.abs(p - v);
        b < y && (g = m, y = b);
      }
      return g;
    }, this.D = new Nt(), this.yi.Oa(Ot.Po), this.Ew = e.hS("spiderChart series bg", 0), this.pT = e.nS("spiderChart web shapes", 0), this.MT = e.nS("spiderChart axis bg", 1), this.zS = e.nS("spiderChart plotting", 2), this.uA = e.nS("spiderChart fg", 3), this.LC = this.bs.CA().Es(this.xi.effectsText), this.Wr.rn("Spider Chart"), this.Yy = this.Ew.Ud(this.xA).sr(this.xi.spiderChartSeriesBackgroundFillStyle).ir(Et).lc(90).yr(-270).Ac(0), this.Hy = this.Ew.Ud(this.xA).sr(Lt).ir(this.xi.spiderChartSeriesBackgroundStrokeStyle).lc(90).yr(-270).Ac(0), super.jy(this.Yy, this.Hy);
    const h = e.fS(), u = $e(n ? n.cursorBuilder : void 0, Md);
    this.AS = Xr(this, h, u.zm(h, this.uiScale, this.uiScale, ie, this.xi), this, "show-pointed", Q5, (() => 0)), this.setAnimationsEnabled(n?.animationsEnabled !== !1), this.fv(o, this.xA);
    const c = { backgroundVisible: !0, ...n?.legend };
    this.legend.setOptions(c);
  }
  getSeries() {
    return this.Ny.slice();
  }
  getAxes() {
    return this.oS;
  }
  getAxis(t) {
    const e = this.oS.find(((i) => i.getTag() === t));
    if (!e) throw new Error(`Axis with tag "${t}" was not found.`);
    return e;
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  addCursor(t = Md) {
    const e = this.tv(), i = t.zm(e, this.uiScale, this.uiScale, this.Jg(e), this.xi);
    return this.cv(i), i;
  }
  addAxis(t) {
    const e = this.oS.find(((s) => s.tag === t));
    if (e) return e;
    const i = new $5(this.MT, this.uA, this.xA, this, t, this.LC, this._T, this.FC, this.scaleLabelFormatter);
    return this.oS.push(i), this.LC.Fs(this.oS.map(((s) => s.DC))), this.yi.Rs(), i;
  }
  addSeries(t) {
    const e = t?.pointShape !== void 0 ? t.pointShape : Je.Circle, i = t?.automaticColorIndex !== void 0 ? t.automaticColorIndex : this.Ny.length, s = new K5(this, this.zS, this.xA, e, this.xT, this.oS, this.YC, this.HC, this.$y, this.xi, i, this.yi.bs);
    return this.Wy(s, t), s;
  }
  getSeriesCount() {
    return this.Ny.length;
  }
  setWebMode(t) {
    return this.sT = t, this.yi.Rs(), this;
  }
  getWebMode() {
    return this.sT;
  }
  setWebCount(t) {
    return this.eT = t, this.yi.Rs(), this;
  }
  getWebCount() {
    return this.eT;
  }
  setWebStyle(t) {
    return this.rT = typeof t == "function" ? t(this.rT) : t, this.yi.Rs(), this;
  }
  getWebStyle() {
    return this.rT;
  }
  setScaleLabelStyle(t) {
    return this.hT = typeof t == "function" ? t(this.hT) : t, this.yi.Rs(), this;
  }
  getScaleLabelStyle() {
    return this.hT;
  }
  setScaleLabelShadow(t) {
    return this.nT = t, this.yi.Rs(), this;
  }
  getScaleLabelShadow() {
    return this.nT;
  }
  setScaleLabelFont(t) {
    return this.oT = typeof t == "function" ? t(this.oT) : t, this.yi.Rs(), this;
  }
  getScaleLabelFont() {
    return this.oT;
  }
  setScaleLabelPadding(t) {
    return this.aT = t, this.yi.Rs(), this;
  }
  getScaleLabelPadding() {
    return this.aT;
  }
  setScaleLabelStrategy(t) {
    return this.tT = t, this.yi.Rs(), this;
  }
  setScaleLabelFormatter(t) {
    return this.scaleLabelFormatter = t, this.oS.forEach(((e) => {
      e.setScaleLabelFormatter(t);
    })), this.yi.Rs(), this;
  }
  setAxisLabelStyle(t) {
    return this.lT = typeof t == "function" ? t(this.lT) : t, this.yi.Rs(), this;
  }
  getAxisLabelStyle() {
    return this.lT;
  }
  setAxisLabelFont(t) {
    return this.uT = typeof t == "function" ? t(this.uT) : t, this.yi.Rs(), this;
  }
  getAxisLabelFont() {
    return this.uT;
  }
  setAxisLabelEffect(t) {
    return this.LC.Es(t), this.yi.Rs(), this;
  }
  getAxisLabelEffect() {
    return this.LC.Os();
  }
  setAxisLabelPadding(t) {
    return this.cT = t, this.yi.Rs(), this;
  }
  getAxisLabelPadding() {
    return this.cT;
  }
  setAxisLabelStrategy(t) {
    return this.iT = t, this.yi.Rs(), this;
  }
  setAxisStyle(t) {
    return this.dT = typeof t == "function" ? t(this.dT) : t, this.yi.Rs(), this;
  }
  getAxisStyle() {
    return this.dT;
  }
  setNibStyle(t) {
    return this.fT = typeof t == "function" ? t(this.fT) : t, this.yi.Rs(), this;
  }
  getNibStyle() {
    return this.fT;
  }
  setNibLength(t) {
    return this.AT = t, this.yi.Rs(), this;
  }
  getNibLength() {
    return this.AT;
  }
  setAutoAxis(t) {
    return this.qC = t, this;
  }
  getAutoAxis() {
    return this.qC;
  }
  setScrollStrategy(t) {
    return this.FC = If(t), this.oS.forEach(((e) => e.setScrollStrategy(t))), this.yi.Rs(), this;
  }
  setAxisInterval(t) {
    return this._T = t, this.oS.forEach(((e) => e.setInterval(t))), this;
  }
  rr(t) {
    super.rr(t);
    const e = this.oS.length, i = ui.xv(this.Wr, this.gv), s = this.Ns.reduce(((u, c) => {
      const d = c.Uh(i, this.Hn);
      return { top: Math.max(u.top, d.top), bottom: Math.max(u.bottom, d.bottom), left: Math.max(u.left, d.left), right: Math.max(u.right, d.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, s);
    const o = j(this.xA.x.getInnerInterval() - (this.Hn.left + this.Hn.right), this.xA.y.getInnerInterval() - (this.Hn.bottom + this.Hn.top + i)), n = j(o.x - s.left - s.right, o.y - s.top - s.bottom), a = /* @__PURE__ */ ((u = 0, c = 0, d = 0, f = 0) => ({ left: u, top: c, right: d, bottom: f }))(0, 0, 0, 0);
    if (this.iT !== void 0) {
      const u = Math.min(n.x, n.y) / 2;
      for (let c = 0; c < e; c += 1) {
        const d = Uh(c, e), f = Math.cos(d), p = Math.sin(d), g = this.oS[c].getLabelSize();
        qg();
        const y = this.iT(ta, c, e, this.oS[c].tag, d, this.cT), m = j(f * u + y.paddingX, p * u + y.paddingY);
        f > 0 ? a.right = Math.max(a.right, m.x + 0.5 * (1 - y.alignmentX) * g.x - u) : a.left = Math.max(a.left, -m.x + 0.5 * (y.alignmentX + 1) * g.x - u), p > 0 ? a.top = Math.max(a.top, m.y + 0.5 * (1 - y.alignmentY) * g.y - u) : a.bottom = Math.max(a.bottom, -m.y + 0.5 * (y.alignmentY + 1) * g.y - u);
      }
    }
    this.oS.forEach(((u) => {
      const c = !this.getSeries().some(((f) => f.JC())) && this.getSeriesCount() > 1, d = this.wT(u.tag, c);
      d && u.bn(d);
    }));
    const l = j(this.xA.x.getInnerStart() + this.Hn.left + s.left + n.x / 2, this.xA.y.getInnerStart() + this.Hn.bottom + s.bottom + n.y / 2), h = Math.min(n.x / 2 - (a.left + a.right) / 2, n.y / 2 - (a.bottom + a.top) / 2);
    this.gT = To(this.dt.left + this.Hn.left + a.left, this.dt.top + this.Hn.top + i + a.top, this.dt.right + this.Hn.right + a.right, this.dt.bottom + this.Hn.bottom + a.bottom), this.dC(l, h);
    for (const u of this.Ny) u.Dv();
    for (const u of this.Ny) u.rr();
    this.AS.rr(!1, this.Ny, void 0), super.dv(), this.Ns.forEach(((u) => u.rr(i, this.Hn)));
    for (const u of this.Ny) u.Ev();
  }
  dispose() {
    return this.Ew.G(), this.pT.G(), this.MT.G(), this.zS.G(), this.uA.G(), this.AS.G(), super.dispose();
  }
  getMinimumSize() {
    return j(this.gT.left + this.gT.right + 100, this.gT.bottom + this.gT.top + 100);
  }
  dC(t, e) {
    const i = this.oS.length, s = [];
    for (let o = 0; o < i; o += 1) {
      const n = Uh(o, i), a = j(t.x + Math.cos(n) * e, t.y + Math.sin(n) * e);
      s.push(a);
    }
    Bc(this.Yy, this.sT, t, s), Bc(this.Hy, this.sT, t, s), this.Yy.uc(e), this.Hy.uc(e), ((o, n, a, l, h, u, c, d) => {
      const f = o.length, p = u.length, g = n > 0 && p > 1;
      for (let y = 0; y < Math.max(n, f); y += 1) if (g && y < n) {
        y >= f && o.push(c());
        const m = o[y];
        Bc(m, a, l, u);
        const A = h * ((y + 1) / n);
        m.uc(A);
      } else y < o.length && d(o[y]);
      o.length = g ? n : 0;
    })(this.QC, this.eT, this.sT, t, e, s, this.yT, this.mT);
    for (const o of this.QC) o.sr(Lt).ir(this.rT);
    for (let o = 0; o < i; o += 1) {
      const n = this.oS[o], a = Uh(o, i);
      qg();
      const l = this.iT !== void 0 ? this.iT(ta, o, i, this.oS[o].tag, a, this.cT) : void 0;
      n.dC(t, s, o, a, e, this.sT, l);
    }
    ((o, n, a, l, h, u, c, d, f) => {
      const p = h.length, g = o.length;
      let y = 0;
      n !== void 0 && h.forEach(((m, A) => {
        var v, b, w, k;
        const R = m.tag, L = Uh(A, p);
        for (let x = 0; x < a; x += 1) {
          cl.alignmentX = 0, cl.alignmentY = 0, cl.paddingX = 0, cl.paddingY = 0;
          const M = n({ ...cl, chart: m.chart, axis: m, axisIndex: A, axisCount: p, axisTag: R, axisAngle: L, webIndex: x, webCount: a, labelPadding: l });
          if (M !== void 0) {
            y >= g && o.push(d());
            const C = o[y];
            y += 1;
            const S = (a - x) / a, E = m.formatValue(m.axisScale.getInnerStart() + S * (m.axisScale.getInnerEnd() - m.axisScale.getInnerStart())), T = Ln(u, c[A], S);
            C.hr(qt(T, j((v = M.paddingX) !== null && v !== void 0 ? v : 0, (b = M.paddingY) !== null && b !== void 0 ? b : 0))).ql((w = M.alignmentX) !== null && w !== void 0 ? w : 0).su((k = M.alignmentY) !== null && k !== void 0 ? k : 0).rn(E);
          }
        }
      }));
      for (let m = y; m < g; m += 1) f(o[m]);
      o.length = y;
    })(this.KC, this.tT, this.eT, this.aT, this.oS, t, s, this.ST, this.bT);
    for (const o of this.KC) o.sr(this.hT).Ih(this.oT).en(this.nT);
  }
  wT(t, e) {
    let i, s;
    const o = this.getAxis(t);
    for (const n of this.Ny) {
      const a = n.getValue(o.tag, e);
      a !== void 0 && (i = i === void 0 ? a : Math.min(i, a), s = s === void 0 ? a : Math.max(s, a));
    }
    if (i !== void 0 && s !== void 0) return Ee(i, s);
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Q5 = (r, t, e) => Gr(t, [[{ component: t.series, rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [t.axis], [{ text: r.getAxis(t.axis).formatValue(t.value), font: { weight: "bold" } }]]), tE = { Vr: !1, Nr: 0, Gr: !1, Ur: 0, $r: !1, jr: 0, Yr: 0, Vh: za.fitting({}) }, eE = (r) => {
  if (!r || typeof r != "object" || r === null) return !1;
  const t = r.type;
  return !(!t || !["spark-line", "spark-bar", "spark-win-loss", "spark-area", "spark-pie"].includes(t));
}, iE = (r, t, e, i, s, o, n, a) => {
  const { type: l, data: h } = r;
  if (h.length === 0) return;
  const u = [i, s];
  l === "spark-line" && aE(r, t, u, o, n, a), l === "spark-bar" && Jg({ ...r, winLoss: !1 }, t, u, o, n, a), l === "spark-win-loss" && Jg({ ...r, winLoss: !0 }, t, u, o, n, a), l === "spark-area" && lE(r, t, u, o, n, a), l === "spark-pie" && hE(r, t, u, o, n, a);
}, Ks = (r, t, e, i) => ({ x: Nx(r.x, t.x, e.x, i), y: kd(r.y, t.y, e.y, i) }), sE = (r, t, e, i) => ({ position: Nx(r.position, t.x, e.x, i), high: kd(r.high, t.y, e.y, i), low: kd(r.low, t.y, e.y, i) }), Nx = (r, t, e, i) => {
  const s = Jt(r, t, t + e);
  return i[0].x + i[1].x * (s - t) / e;
}, kd = (r, t, e, i) => {
  const s = Jt(r, t, t + e);
  return i[0].y + i[1].y * (s - t) / e;
}, Bx = (r, t, e, i, s, o, n, a) => {
  for (const l of r) l.type === "point" && rE(l, t, e, s, o, n, a), l.type === "axis-band" && nE(l, e, s, o, n, a), l.type === "constant-line" && oE(l, e, i, s, o, n, a);
}, rE = (r, t, e, i, s, o, n) => {
  const { value: a, fillStyle: l, shape: h, size: u, rotation: c } = r;
  let d = { x: NaN, y: NaN };
  if (a === "start" && (d = t[0]), a === "end" && (d = t[t.length - 1]), a === "min") {
    d = t[0];
    for (const f of t) d = d.y < f.y ? d : f;
  }
  if (a === "max") {
    d = t[0];
    for (const f of t) d = d.y > f.y ? d : f;
  }
  (typeof a != "object" || (d = Ks(a, e, i, s), ((f, p) => {
    const g = p[0], y = p[1], m = f.x, A = f.y;
    return g.x <= m && m <= g.x + y.x && g.y <= A && A <= g.y + y.y;
  })(d, s))) && o.pointSet.add().rf(h !== void 0 ? h : Je.Circle).nf(c || 0).df(u || 5).tf(l || n.sparkPointChartFillStyle).qd(new cr().appendSample(d), { x: "x", y: "y" });
}, nE = (r, t, e, i, s, o) => {
  const { axis: n, start: a, end: l, fillStyle: h, strokeStyle: u } = r;
  let c = j(Pt, wt), d = j(Pt, wt);
  n === "x" && (c = Ks({ x: a, y: Pt }, t, e, i), d = Ks({ x: l, y: wt }, t, e, i)), n === "y" && (c = Ks({ x: Pt, y: a }, t, e, i), d = Ks({ x: wt, y: l }, t, e, i));
  const f = i[0], p = i[1], g = Jt(c.x, f.x, f.x + p.x), y = Jt(c.y, f.y, f.y + p.y), m = Jt(d.x, f.x, f.x + p.x), A = Jt(d.y, f.y, f.y + p.y);
  s.rect.add().lu(g).uu(y).K(j(m - g, A - y)).sr(h || o.sparkChartBandFillStyle).ir(u || o.sparkChartBandStrokeStyle).ir(Et);
}, oE = (r, t, e, i, s, o, n) => {
  const { axis: a, value: l, strokeStyle: h } = r, u = l || 0, c = t.y, d = e.y, f = t.x, p = e.x, g = [];
  if (a === "y" && c <= u && u <= d) {
    const y = Ks(j(f, u), { x: f, y: c }, i, s), m = Ks(j(p, u), { x: f, y: c }, i, s);
    g.push([y, m]);
  }
  if (a === "x" && f <= u && u <= p) {
    const y = Ks(j(u, c), { x: f, y: c }, i, s), m = Ks(j(u, d), { x: f, y: c }, i, s);
    g.push([y, m]);
  }
  g.length > 0 && o.line.add().gr(h || n.sparkChartConstantLineStrokeStyle).pr(g[0][0]).yr(g[0][1]);
}, aE = (r, t, e, i, s, o) => {
  const { strokeStyle: n, data: a, markers: l } = r, h = a.length;
  h > 1e4 && s.$a && H.console.warn("LightningChart JS warning: SparkLineChart has over 10000 data points. This feature is not designed for large data sets which might show as performance drop. If you want to request improvements to this, contact https://lightningchart.com/js-charts/docs/contact. To disable this warning, use LightningChartOptions.warning property (refer to API documentation for more detail).");
  let u = wt, c = Pt, d = wt, f = Pt;
  for (let y = 0; y < h; y += 1) {
    const m = a[y];
    u = Math.min(u, m.x), c = Math.max(c, m.x), d = Math.min(d, m.y), f = Math.max(f, m.y);
  }
  const p = { x: c - u, y: f - d }, g = a.map(((y) => Ks(y, { x: u, y: d }, p, e)));
  t.lineSet.add().Ii(o).gr(n || i.sparkLineChartStrokeStyle).Vi().Pu(g), l && Bx(l, g, { x: u, y: d }, { x: c, y: f }, p, e, t, i);
}, Jg = (r, t, e, i, s, o) => {
  const { data: n, fillStyle: a, strokeStyle: l, threshold: h, winFillStyle: u, lossFillStyle: c } = r, d = r.barSize || 1, f = r.gap || 1, p = r.winLoss, g = h || 0, y = f / d * 1;
  let m = wt, A = Pt;
  if (p) m = -1, A = 1;
  else for (const w of n) m = Math.min(m, w), A = Math.max(A, w);
  const v = { x: 0, y: p ? -1 : Math.min(0, m) }, b = { x: 1 * n.length + (n.length - 1) * y, y: p ? 2 : Math.max(A, 1e-5) };
  n.map(((w, k) => {
    const R = { x: 1 * (k + 1) + k * y, y: p ? w >= g ? 1 : 0 : w }, L = Ks({ x: 1 * k + k * y, y: p ? w >= g ? 0 : -1 : 0 }, v, b, e), x = Ks(R, v, b, e);
    return { value: w, position: L, width: x.x - L.x, height: x.y - L.y };
  })).forEach(((w) => {
    var k;
    t.rect.add().Ii(o).hr(w.position).du(w.height).cu(w.width).sr((k = w.value, p ? (k >= g ? u : c) || i.sparkBarChartFillStyle : a || i.sparkBarChartFillStyle)).ir(l || i.sparkBarChartStrokeStyle);
  }));
}, lE = (r, t, e, i, s, o) => {
  const { data: n, fillStyle: a, strokeStyle: l, markers: h } = r, u = n.length;
  u > 1e4 && s.$a && H.console.warn("LightningChart JS warning: SparkAreaChart has over 10000 data points. This feature is not designed for large data sets which might show as performance drop. If you want to request improvements to this, contact https://lightningchart.com/js-charts/docs/contact. To disable this warning, use LightningChartOptions.warning property (refer to API documentation for more detail).");
  let c = wt, d = Pt, f = wt, p = Pt;
  for (let A = 0; A < u; A += 1) {
    const v = n[A];
    c = Math.min(c, v.x), d = Math.max(d, v.x), f = Math.min(f, v.y), p = Math.max(p, v.y);
  }
  const g = { x: d - c, y: p - f }, y = [], m = [];
  for (const A of n) {
    const v = Am(A.x, A.y, f);
    y.push(sE(v, { x: c, y: f }, g, e)), m.push(Ks(A, { x: c, y: f }, g, e));
  }
  t.junction.add().Ii(o).Vi().Pu(y).sr(a || i.sparkAreaChartFillStyle), t.lineSet.add().Ii(o).Vi().Pu(m).gr(l || i.sparkAreaChartStrokeStyle), h && Bx(h, m, { x: c, y: f }, { x: d, y: p }, g, e, t, i);
}, hE = (r, t, e, i, s, o) => {
  const { data: n, strokeStyle: a } = r, l = n.map(((g) => typeof g == "number" ? g : g.value)), h = n.map(((g) => typeof g == "object" ? g.fillStyle : void 0)), u = l.reduce(((g, y) => g + y), 0), c = Ks(j(50, 50), { x: 0, y: 0 }, { x: 100, y: 100 }, e), d = e[1], f = d.x <= d.y ? d.x / 2 : d.y / 2;
  let p = 90;
  l.forEach(((g, y) => {
    const m = g / u * 360;
    t.arc.add().Ii(o).hr(c).uc(f).Ac(0).lc(p).yr(p + m).sr(h[y] || ue(i.sparkPieChartFillStyle, y)).ir(a || i.sparkPieChartStrokeStyle), p += m;
  }));
}, yh = (r, t) => {
  const e = ((s) => {
    const o = N(0, 0, 0), n = N(255, 255, 255), a = new ot({ color: o }), l = new ot({ color: n }), h = new ot({ color: s.uiStrokeColorContrastHigh }), u = new ot({ color: s.uiStrokeColorContrastMedium }), c = new ot({ color: s.uiStrokeColorContrastLow }), d = new qn({ family: s.fontFamily, weight: "normal", style: "normal" }), f = s.isDark ? N(0, 0, 0, 255) : void 0, p = d.setSize(18 * s.fontScaler), g = d.setSize(16 * s.fontScaler), y = d.setSize(14 * s.fontScaler), m = d.setSize(10 * s.fontScaler), A = d.withMutations(((ft) => ft.set("size", 14 * s.fontScaler).set("weight", "bold"))), v = d.setSize(13 * s.fontScaler), b = new $t({ thickness: 2, fillStyle: c }), w = new ot({ color: s.dataHighlightOverlayColor }), k = new $t({ thickness: 2, fillStyle: s.legendBackgroundBorderFillStyle }), R = s.dataColorPalette.map(((ft) => new ot({ color: ft.stroke }))), L = (ft) => R[ft % R.length], x = R.map(((ft) => new $t({ thickness: 2, fillStyle: ft }))), M = (ft) => x[ft % x.length], C = s.dataColorPalette.map(((ft) => new ot({ color: ft.border }))).map(((ft) => new $t({ thickness: 2, fillStyle: ft }))), S = (ft) => C[ft % C.length], E = s.dataColorPalette.map(((ft) => {
      const Tt = ft.area;
      return new Ci({ angle: 0, stops: [{ offset: 0, color: Tt.setA(0) }, { offset: 0.8, color: Tt }] });
    })), T = (ft) => E[ft % E.length], I = s.dataColorPaletteInverted.map(((ft) => {
      const Tt = ft.area;
      return new Ci({ angle: 180, stops: [{ offset: 0, color: Tt.setA(0) }, { offset: 0.8, color: Tt }] });
    })), F = (ft) => I[ft % I.length], D = s.dataColorPalette.map(((ft) => {
      const Tt = ft.area;
      return new Ci({ angle: 180, stops: [{ color: Ki(Tt, N(255, 255, 255, Tt.getA()), 0.3), offset: 0 }, { color: Tt, offset: 0.5 }, { color: Ki(Tt, N(0, 0, 0, Tt.getA()), 0.3), offset: 1 }] });
    })), P = (ft) => D[ft % D.length], V = s.dataColorPaletteInverted.map(((ft) => new ot({ color: ft.border }))).map(((ft) => new $t({ thickness: 2, fillStyle: ft }))), _ = (ft) => V[ft % V.length], O = new ot({ color: s.dataColorPositive }), B = new ot({ color: s.dataColorNegative }), z = new $t({ thickness: 1, fillStyle: new ot({ color: s.dataStrokeColorContrastHigh.setA(50) }) }), W = new $t({ thickness: 2, fillStyle: s.axisLineFillStyle }), G = new ot({ color: N(0, 0, 0, 1) }), Y = new $t({ thickness: 1, fillStyle: s.axisGridMajorFillStyle }), U = new $t({ thickness: 1, fillStyle: s.axisTickMajorFillStyle }), $ = y, Z = s.axisLabelMajorFillStyle, q = new $t({ thickness: 1, fillStyle: s.axisGridMinorFillStyle }), Q = new $t({ thickness: 1, fillStyle: s.axisTickMinorFillStyle }), nt = m, et = Z, it = Ad, rt = new Hr({ gridStrokeStyle: Y, tickStyle: U, tickLength: 7, tickPadding: 5, labelFont: $, labelFillStyle: Z, labelShadow: f }), tt = new Hr({ gridStrokeStyle: q, tickStyle: Q, tickLength: 4, tickPadding: 10, labelFont: nt, labelFillStyle: et, labelShadow: f }), at = new g2({ extremeTickStyle: it, majorTickStyle: rt, minorTickStyle: tt.setLabelFillStyle(Lt) }), ut = new l2({ greatTickStyle: Ad, majorTickStyle: rt, minorTickStyle: tt }), ht = ut, st = ut, bt = new n2({ majorTickStyle: rt, minorTickStyle: tt }), ct = new ot({ color: s.dataHighlightOverlayColor }), Mt = new $t({ thickness: 1, fillStyle: u }), vt = new $t({ thickness: 2, fillStyle: u }), mt = (ft) => new Mu.Triangulated({ shape: "sphere", size: 10, fillStyle: R[ft % R.length] }), Xt = R[0], Rt = s.uiTextFillStyle, Dt = s.legendBackgroundFillStyle, Kt = new $t({ thickness: 1, fillStyle: s.legendBackgroundBorderFillStyle }), _t = Su(s.legendButtonDefaultColor), Ut = Su(s.isDark ? N(70, 70, 70, 255) : N(170, 170, 170, 255)), te = new ot({ color: s.isDark ? N(70, 70, 70, 255) : N(170, 170, 170, 255) }), ye = new $t({ thickness: 1, fillStyle: h }), ne = new Xu({ thickness: 1, fillStyle: s.cursorGridFillStyle, pattern: uh.DashedEqual, patternScale: 3 }), ti = new $t({ thickness: 1, fillStyle: s.cursorGridFillStyle }), fe = s.zoomBandChartDefocusOverlayFillStyle, ve = new $t({ thickness: 2, fillStyle: new ot({ color: s.zoomBandChartSplitterColor }) }), ci = new ot({ color: s.uiBackgroundColor }), At = new $t({ thickness: 1, fillStyle: new ot({ color: s.isDark ? n : o }) });
    let yt = { isDark: s.isDark, effect: s.effect, effectsText: s.effectsText, effectsDashboardSplitters: s.effectsDashboardSplitters, lcjsBackgroundFillStyle: s.lcjsBackgroundFillStyle, lcjsBackgroundStrokeStyle: Et, highlightColorOffset: s.highlightColorOffset, highlightColorOffsetAxisOverlay: s.highlightColorOffsetAxisOverlay, dashboardSplitterStyle: new $t({ thickness: 4, fillStyle: s.dashboardSplitterFillStyle }), panelPadding: 7, chartXYBackgroundFillStyle: s.panelBackgroundFillStyle, chartXYBackgroundStrokeStyle: Et, chartXYTitleFont: p, chartXYTitleFillStyle: s.titleFillStyle, chartXYTitleShadow: f, chartXYTitleMargin: 5, chartXYSeriesBackgroundFillStyle: s.seriesBackgroundFillStyle, chartXYSeriesBackgroundStrokeStyle: b, chartXYZoomingRectangleFillStyle: w, chartXYZoomingRectangleStrokeStyle: k, lineSeriesStrokeStyle: M, pointLineSeriesStrokeStyle: M, pointLineSeriesFillStyle: L, pointSeriesFillStyle: L, pointSeriesStrokeStyle: At, ellipseSeriesFillStyle: L, ellipseSeriesStrokeStyle: M, polygonSeriesFillStyle: L, polygonSeriesStrokeStyle: M, rectangleSeriesFillStyle: L, rectangleSeriesStrokeStyle: Et, segmentSeriesStrokeStyle: M, boxSeriesBodyFillStyle: L(0), boxSeriesBodyStrokeStyle: Et, boxSeriesStrokeStyle: new $t({ thickness: 1, fillStyle: R[0] }), boxSeriesMedianStrokeStyle: new $t({ thickness: 1, fillStyle: new ot({ color: o }) }), ohlcCandleThicknessPixels: 5, ohlcCandleBodyFillStylePositive: O, ohlcCandleBodyFillStyleNegative: B, ohlcCandleTailStrokeStylePositive: new $t({ thickness: 1, fillStyle: new ot({ color: s.uiStrokeColorContrastHigh }) }), ohlcCandleTailStrokeStyleNegative: new $t({ thickness: 1, fillStyle: new ot({ color: s.uiStrokeColorContrastHigh }) }), ohlcBarThicknessPixels: 10, ohlcBarStrokeStylePositive: new $t({ thickness: 2, fillStyle: O }), ohlcBarStrokeStyleNegative: new $t({ thickness: 2, fillStyle: B }), heatmapGridSeriesFillStyle: L, heatmapGridSeriesWireframeStyle: z, heatmapScrollingGridSeriesFillStyle: L, heatmapScrollingGridSeriesWireframeStyle: z, heatmapGridSeriesContourStrokeStyle: new $t({ thickness: 1, fillStyle: new ot({ color: N(0, 0, 0) }) }), heatmapGridSeriesContourLabelColor: de(Rt) ? Rt.getColor() : Xt.getColor(), heatmapGridSeriesContourLabelFont: v, heatmapGridSeriesContourLabelShadow: f, areaRangeSeriesFillStyle: T, areaRangeSeriesStrokeStyle: S, areaRangeSeriesFillStyleInverted: F, areaRangeSeriesStrokeStyleInverted: _, areaSeriesBipolarHighFillStyle: T, areaSeriesBipolarHighStrokeStyle: S, areaSeriesBipolarLowFillStyle: F, areaSeriesBipolarLowStrokeStyle: _, areaSeriesPositiveFillStyle: T, areaSeriesPositiveStrokeStyle: S, areaSeriesNegativeFillStyle: F, areaSeriesNegativeStrokeStyle: _, xAxisTitleFont: g, xAxisTitleFillStyle: s.axisTitleFillStyle, xAxisStrokeStyle: W, xAxisOverlayStyle: G, xAxisZoomingBandFillStyle: w, xAxisZoomingBandStrokeStyle: Et, xAxisNumericTicks: at, xAxisDateTimeTicks: ht, xAxisTimeTicks: bt, yAxisTitleFont: g, yAxisTitleFillStyle: s.axisTitleFillStyle, yAxisStrokeStyle: W, yAxisOverlayStyle: G, yAxisZoomingBandFillStyle: w, yAxisZoomingBandStrokeStyle: Et, yAxisNumericTicks: at, yAxisDateTimeTicks: st, yAxisTimeTicks: bt, bandFillStyle: ct, bandStrokeStyle: Mt, constantLineStrokeStyle: vt, barChartBackgroundFillStyle: s.panelBackgroundFillStyle, barChartBackgroundStrokeStyle: Et, barChartTitleFont: p, barChartTitleFillStyle: s.titleFillStyle, barChartTitleShadow: f, barChartSeriesBackgroundFillStyle: Lt, barChartSeriesBackgroundStrokeStyle: Et, barChartBarFillStyle: L, barChartBarStrokeStyle: new $t({ thickness: 1, fillStyle: c }), barChartValueAxisTitleFont: g, barChartValueAxisTitleFillStyle: s.axisTitleFillStyle, barChartValueAxisStrokeStyle: W, barChartValueAxisTicks: at.setMajorTickStyle(((ft) => ft.setGridStrokeStyle(Et))).setMinorTickStyle(((ft) => ft.setGridStrokeStyle(Et))), barChartCategoryAxisTitleFont: g, barChartCategoryAxisTitleFillStyle: s.axisTitleFillStyle, barChartCategoryAxisStrokeStyle: W, barChartCategoryLabels: { formatter: (ft, Tt) => ft, labelFillStyle: at.majorTickStyle.labelFillStyle, labelFont: at.majorTickStyle.labelFont, labelMargin: 8, labelRotation: 0, labelAlignment: 0, tickStyle: at.majorTickStyle.tickStyle, tickLength: 0, labelShadow: f }, barChartValueLabelsAfterBars: { position: "after-bar", formatter: (ft) => ft.chart.valueAxis.formatValue(ft.value), labelFillStyle: at.majorTickStyle.labelFillStyle, labelFont: at.majorTickStyle.labelFont, labelMargin: 8, labelRotation: 0, labelAlignment: 0, displayStackedIndividuals: !1, displayStackedSum: !0, labelShadow: f }, barChartValueLabelsInsideBars: { position: "inside-bar", formatter: (ft) => ft.chart.valueAxis.formatValue(ft.value), labelFillStyle: at.majorTickStyle.labelFillStyle, labelFont: at.majorTickStyle.labelFont, labelMargin: 8, labelRotation: 0, labelAlignment: 0, displayStackedIndividuals: !1, displayStackedSum: !0, labelShadow: f }, barChartCornerRadius: 10, chart3DBackgroundFillStyle: s.panelBackgroundFillStyle, chart3DBackgroundStrokeStyle: Et, chart3DTitleFont: p, chart3DTitleFillStyle: s.titleFillStyle, chart3DTitleShadow: f, chart3DSeriesBackgroundFillStyle: s.seriesBackgroundFillStyle, chart3DSeriesBackgroundStrokeStyle: b, chart3DBoundingBoxStrokeStyle: Et, xAxis3DTitleFont: g, xAxis3DTitleFillStyle: s.axisTitleFillStyle, xAxis3DStrokeStyle: W, xAxis3DNumericTicks: at, xAxis3DDateTimeTicks: ut, xAxis3DTimeTicks: bt, yAxis3DTitleFont: g, yAxis3DTitleFillStyle: s.axisTitleFillStyle, yAxis3DStrokeStyle: W, yAxis3DNumericTicks: at, yAxis3DDateTimeTicks: ut, yAxis3DTimeTicks: bt, zAxis3DTitleFont: g, zAxis3DTitleFillStyle: s.axisTitleFillStyle, zAxis3DStrokeStyle: W, zAxis3DNumericTicks: at, zAxis3DDateTimeTicks: ut, zAxis3DTimeTicks: bt, lineSeries3DStrokeStyle: M, pointLineSeries3DStrokeStyle: M, pointLineSeries3DPointStyle: mt, pointSeries3DPointStyle: mt, pointCloudSeries3DPointStyle: (ft) => new Mu.Pixelated({ size: 5, fillStyle: R[ft % R.length] }), surfaceGridSeries3DFillStyle: L, surfaceGridSeries3DWireframeStyle: z, surfaceGridSeriesContourStrokeStyle: x[0], surfaceScrollingGridSeries3DFillStyle: L, surfaceScrollingGridSeries3DWireframeStyle: z, boxSeries3DFillStyle: L, meshModel3DFillStyle: L(0), polarChartBackgroundFillStyle: s.panelBackgroundFillStyle, polarChartBackgroundStrokeStyle: Et, polarChartTitleFont: p, polarChartTitleFillStyle: s.titleFillStyle, polarChartTitleShadow: f, polarChartSeriesBackgroundFillStyle: s.seriesBackgroundFillStyle, polarChartSeriesBackgroundStrokeStyle: b, polarSectorFillStyle: ct, polarSectorStrokeStyle: Mt, polarAmplitudeAxisTitleFont: g, polarAmplitudeAxisTitleFillStyle: s.axisTitleFillStyle, polarAmplitudeAxisTitleShadow: f, polarAmplitudeAxisStrokeStyle: W, polarAmplitudeAxisNumericTicks: at, polarAmplitudeAxisDateTimeTicks: ut, polarAmplitudeAxisTimeTicks: bt, polarRadialAxisTitleFont: g, polarRadialAxisTitleFillStyle: s.axisTitleFillStyle, polarRadialAxisStrokeStyle: W, polarRadialAxisTickStyle: rt.setTickPadding(10), polarRadialAxisMarginAfterTicks: 0, polarLineSeriesStrokeStyle: M, polarPointLineSeriesFillStyle: L, polarPointLineSeriesStrokeStyle: M, polarPointSeriesFillStyle: L, polarPointSeriesStrokeStyle: At, polarPolygonSeriesFillStyle: P, polarPolygonSeriesStrokeStyle: S, polarAreaSeriesFillStyle: P, polarAreaSeriesStrokeStyle: S, polarHeatmapSeriesFillStyle: L, mapChartBackgroundFillStyle: s.panelBackgroundFillStyle, mapChartBackgroundStrokeStyle: Et, mapChartTitleFont: p, mapChartTitleFillStyle: s.titleFillStyle, mapChartTitleShadow: f, mapChartFillStyle: Xt, mapChartStrokeStyle: new $t({ thickness: 1, fillStyle: new ot({ color: s.dataStrokeColorContrastMedium }) }), mapChartOutlierRegionFillStyle: Lt, mapChartOutlierRegionStrokeStyle: new $t({ thickness: 1, fillStyle: c }), mapChartSeparateRegionFillStyle: Dt, mapChartSeparateRegionStrokeStyle: Kt, dataGridBackgroundFillStyle: s.panelBackgroundFillStyle, dataGridBackgroundStrokeStyle: Et, dataGridTitleFont: p, dataGridTitleFillStyle: s.titleFillStyle, dataGridTitleShadow: f, dataGridTextFont: y, dataGridTextFillStyle: Xt, dataGridCellBackgroundFillStyle: new ot({ color: s.uiBackgroundColor }), dataGridBorderStrokeStyle: new $t({ thickness: 0.4, fillStyle: new ot({ color: s.uiBackgroundBorderColor }) }), dataGridScrollBarBackgroundFillStyle: s.seriesBackgroundFillStyle, dataGridScrollBarBackgroundStrokeStyle: Et, dataGridScrollBarFillStyle: s.seriesBackgroundFillStyle, dataGridScrollBarStrokeStyle: Kt, dataGridScrollBarButtonFillStyle: s.seriesBackgroundFillStyle, dataGridScrollBarButtonStrokeStyle: Kt, dataGridScrollBarButtonArrowFillStyle: new ot({ color: s.legendButtonDefaultColor }), dataGridScrollBarThickness: 20, dataGridCellPadding: 5, sparkLineChartStrokeStyle: M(0), sparkPointChartFillStyle: L(0), sparkBarChartFillStyle: L(0), sparkBarChartStrokeStyle: S(0), sparkAreaChartFillStyle: T(0), sparkAreaChartStrokeStyle: S(0), sparkPieChartFillStyle: L, sparkPieChartStrokeStyle: Kt, sparkChartBandFillStyle: ct, sparkChartBandStrokeStyle: Mt, sparkChartConstantLineStrokeStyle: vt, dataGridTextShadow: f, textSeriesShadow: f, spiderChartBackgroundFillStyle: s.panelBackgroundFillStyle, spiderChartBackgroundStrokeStyle: Et, spiderChartTitleFont: p, spiderChartTitleFillStyle: s.titleFillStyle, spiderChartTitleShadow: f, spiderChartSeriesBackgroundFillStyle: s.seriesBackgroundFillStyle, spiderChartSeriesBackgroundStrokeStyle: b, spiderChartWebStyle: new $t({ thickness: 2, fillStyle: c }), spiderChartScaleLabelFillStyle: s.axisLabelMajorFillStyle, spiderChartScaleLabelFont: y, spiderChartAxisLabelFillStyle: s.axisTitleFillStyle, spiderChartAxisLabelFont: g, spiderChartAxisStrokeStyle: new $t({ thickness: 2, fillStyle: u }), spiderChartAxisNibStrokeStyle: new $t({ thickness: 2, fillStyle: h }), spiderSeriesFillStyle: P, spiderSeriesStrokeStyle: S, spiderSeriesPointFillStyle: L, spiderChartScaleLabelShadow: f, pieChartBackgroundFillStyle: s.panelBackgroundFillStyle, pieChartBackgroundStrokeStyle: Et, pieChartTitleFont: p, pieChartTitleFillStyle: s.titleFillStyle, pieChartTitleShadow: f, pieChartSliceFillStylePalette: L, pieChartSliceStrokeStyle: Kt, pieChartSliceLabelFont: v, pieChartSliceLabelFillStyle: s.uiTextFillStyle, pieChartConnectorStrokeStyle: ye, pieChartSliceLabelShadow: f, funnelChartBackgroundFillStyle: s.panelBackgroundFillStyle, funnelChartBackgroundStrokeStyle: Et, funnelChartTitleFont: p, funnelChartTitleFillStyle: s.titleFillStyle, funnelChartTitleShadow: f, funnelChartSliceFillStylePalette: L, funnelChartSliceStrokeStyle: Kt, funnelChartSliceLabelFont: v, funnelChartSliceLabelFillStyle: s.uiTextFillStyle, funnelChartConnectorStrokeStyle: ye, funnelChartSliceLabelShadow: f, pyramidChartBackgroundFillStyle: s.panelBackgroundFillStyle, pyramidChartBackgroundStrokeStyle: Et, pyramidChartTitleFont: p, pyramidChartTitleFillStyle: s.titleFillStyle, pyramidChartTitleShadow: f, pyramidChartSliceFillStylePalette: L, pyramidChartSliceStrokeStyle: Kt, pyramidChartSliceLabelFont: v, pyramidChartSliceLabelFillStyle: s.uiTextFillStyle, pyramidChartConnectorStrokeStyle: ye, gaugeChartValueLabelFont: v.setSize(60), gaugeChartUnitLabelFont: v.setSize(40), gaugeChartTickFont: v.setSize(30), gaugeChartBarThickness: 40, gaugeChartValueIndicatorThickness: 10, gaugeChartRoundedEdges: !0, gaugeChartNeedleLength: 40, gaugeChartStartAngle: 225, gaugeChartEndAngle: -45, gaugeChartNeedleAlignment: 0, gaugeChartGapBetweenBarAndValueIndicators: 10, gaugeChartTickFillStyle: s.uiTextFillStyle, gaugeChartBarGradient: !0, gaugeChartBarStrokeStyle: Et, gaugeChartUnitLabelFillStyle: s.uiTextFillStyle, gaugeChartValueLabelFillStyle: s.uiTextFillStyle, gaugeChartBarColor: n, gaugeChartGlowColor: N(255, 255, 64), gaugeChartNeedleFillStyle: new ot({ color: n }), gaugeChartNeedleThickness: 10, gaugeChartNeedleStrokeStyle: new $t({ thickness: 2, fillStyle: new ot({ color: o }) }), pyramidChartSliceLabelShadow: f, gaugeChartBackgroundFillStyle: s.panelBackgroundFillStyle, gaugeChartBackgroundStrokeStyle: Et, gaugeChartTitleFont: p, gaugeChartTitleFillStyle: s.titleFillStyle, gaugeChartTitleShadow: f, linearGaugeChartRoundedEdges: !0, linearGaugeChartColorInterpolation: !1, linearGaugeChartGradients: !0, linearGaugeChartBackgroundFillStyle: s.panelBackgroundFillStyle, linearGaugeChartBackgroundStrokeStyle: Et, linearGaugeChartTitleFont: p, linearGaugeChartTitleFillStyle: s.titleFillStyle, linearGaugeChartTitleShadow: f, linearGaugeChartTickMargin: 5, linearGaugeChartValueLabelFont: v.setSize(28), linearGaugeChartValueLabelFillStyle: s.uiTextFillStyle, linearGaugeChartValueLabelShadow: f, linearGaugeChartTickFont: v.setSize(20), linearGaugeChartTickFillStyle: s.uiTextFillStyle, linearGaugeChartTickShadow: f, linearGaugeChartValueLabelAlignment: 1.5, linearGaugeChartBarThickness: 50, linearGaugeChartBarStrokeStyle: new $t({ thickness: 1, fillStyle: s.isDark ? l : a }), linearGaugeChartValueMarkerAlignment: 1, linearGaugeChartValueMarkerShape: Je.Minus, linearGaugeChartValueMarkerSize: 15, linearGaugeChartValueMarkerRotationVertical: 0, linearGaugeChartValueMarkerRotationHorizontal: 90, linearGaugeChartValueMarkerFillStyle: s.uiTextFillStyle, linearGaugeChartValueMarkerStrokeStyle: new $t({ thickness: 1, fillStyle: a }), linearGaugeChartDefaultRangeColor: s.dataColorPalette[0].stroke, treeMapChartBackgroundFillStyle: s.panelBackgroundFillStyle, treeMapChartBackgroundStrokeStyle: Et, treeMapChartParentColor: s.treeMapChartParentColor, treeMapChartNodeColors: s.treeMapChartNodeColors, treeMapChartNodeStrokeStyle: new $t({ thickness: 1, fillStyle: new ot({ color: Xe("000") }) }), treeMapChartTitleFillStyle: s.titleFillStyle, treeMapChartTitleShadow: f, treeMapChartTitleFont: p, treeMapChartPathLabelFillStyle: Rt, treeMapChartPathLabelFont: v, treeMapChartLabelHeaderFillStyle: s.treeMapChartLabelHeaderFillStyle, treeMapChartLabelHeaderFont: p, treeMapChartLabelFillStyle: s.treeMapChartLabelFillStyle, treeMapChartLabelFont: v, treeMapChartCornerRadius: 8, uiPanelBackgroundFillStyle: s.panelBackgroundFillStyle, uiPanelBackgroundStrokeStyle: Et, zoomBandChartDefocusOverlayFillStyle: fe, zoomBandChartSplitterStrokeStyle: ve, zoomBandChartKnobFillStyle: s.zoomBandChartKnobFillStyle, zoomBandChartKnobSize: s.zoomBandChartKnobSize, onScreenMenuBackgroundColor: N(254, 204, 0, 0.7), parallelCoordinateChartBackgroundFillStyle: s.panelBackgroundFillStyle, parallelCoordinateChartBackgroundStrokeStyle: Et, parallelCoordinateChartTitleFont: p, parallelCoordinateChartTitleFillStyle: s.titleFillStyle, parallelCoordinateChartTitleShadow: f, parallelCoordinateChartSeriesBackgroundFillStyle: s.seriesBackgroundFillStyle, parallelCoordinateChartSeriesBackgroundStrokeStyle: b, parallelCoordinateChartSeriesColor: (ft) => s.dataColorPalette[ft % s.dataColorPalette.length].stroke, parallelCoordinateChartSeriesColorUnselected: s.dataColorUnselected, parallelCoordinateChartSeriesLineThickness: 2, parallelCoordinateChartPointedSeriesLineStyle: x[0], parallelCoordinateAxisTitleFont: g, parallelCoordinateAxisTitleFillStyle: s.axisTitleFillStyle, parallelCoordinateAxisNumericTicks: at, parallelCoordinateAxisDateTimeTicks: ut, parallelCoordinateAxisTimeTicks: bt, parallelCoordinateAxisStrokeStyle: W, parallelCoordinateAxisRangeSelectorFillStyle: s.seriesBackgroundFillStyle, parallelCoordinateAxisRangeSelectorStrokeStyle: Kt, parallelCoordinateAxisBackgroundFillStyle: new Ci({ angle: 90, stops: [{ offset: 0, color: s.isDark ? N(0, 0, 0, 0) : N(255, 255, 255, 0) }, { offset: 1, color: s.isDark ? N(0, 0, 0, 255) : N(255, 255, 255, 180) }] }), uiButtonFillStyle: _t, uiButtonFillStyleHidden: Ut, uiButtonStrokeStyle: s.isDark ? Et : new $t({ thickness: 1, fillStyle: new ot({ color: o }) }), uiButtonSize: 10, uiBackgroundFillStyle: Dt, uiBackgroundStrokeStyle: Kt, uiTextFillStyle: Rt, uiTextFillStyleHidden: te, uiTextFont: v, uiTextPadding: 5, legendTitleFillStyle: Rt, legendTitleFont: A, legendBorderRadius: 5, legendPadding: 5, legendLUTLabelMargin: 7, legendLUTUnitLabelMargin: 7, legendLUTCornerRadius: 5, legendLUTLengthHorizontal: 160, legendLUTThicknessHorizontal: 15, legendLUTLengthVertical: 140, legendLUTThicknessVertical: 25, cursorTickMarkerXBackgroundFillStyle: Dt, cursorTickMarkerXBackgroundStrokeStyle: Kt, cursorTickMarkerXTextFillStyle: Rt, cursorTickMarkerXTextFont: v, cursorTickMarkerYBackgroundFillStyle: Dt, cursorTickMarkerYBackgroundStrokeStyle: Kt, cursorTickMarkerYTextFillStyle: Rt, cursorTickMarkerYTextFont: v, cursorPointMarkerSize: { x: 9, y: 9 }, cursorPointMarkerShape: Je.Circle, cursorPointMarkerFillStyle: ne.getFillStyle(), cursorPointMarkerStrokeStyle: Et, cursorDynamicBehavior: { pointMarkerFill: (ft) => new ot({ color: Ki(ft, s.isDark ? o : n, 0.2, 230) }), pointMarkerStroke: (ft) => new $t({ thickness: 2, fillStyle: new ot({ color: Ki(ft, s.isDark ? n : o, s.isDark ? 0.8 : 0.6, 204) }) }), pointMarkerSize: (ft) => ({ x: ft + 3, y: ft + 3 }) }, cursorResultTableFillStyle: s.resultTableBackgroundFillStyle, cursorResultTableStrokeStyle: new $t({ thickness: 1, fillStyle: s.resultTableBackgroundBorderFillStyle }), cursorResultTableTextFillStyle: Rt, cursorResultTableTextFont: v, cursorResultTableHeaderBackgroundFillStyle: s.resultTableHeaderBackgroundFillStyle, cursorResultTableBorderRadius: 5, cursorGridStrokeStyleX: ne, cursorGridStrokeStyleY: ne, cursor3DGridStrokeStyleX: ti, cursor3DGridStrokeStyleY: ti, cursor3DGridStrokeStyleZ: ti, cursor3DTickStrokeStyleX: rt.tickStyle, cursor3DTickStrokeStyleY: rt.tickStyle, cursor3DTickStrokeStyleZ: rt.tickStyle, cursor3DTickLabelFillStyleX: Rt, cursor3DTickLabelFillStyleY: Rt, cursor3DTickLabelFillStyleZ: Rt, cursor3DTickLabelFontX: v, cursor3DTickLabelFontY: v, cursor3DTickLabelFontZ: v, cursor3DTickLabelBackgroundFillStyleX: ci, cursor3DTickLabelBackgroundFillStyleY: ci, cursor3DTickLabelBackgroundFillStyleZ: ci, cursor3DTickLabelBackgroundStrokeStyleX: Kt, cursor3DTickLabelBackgroundStrokeStyleY: Kt, cursor3DTickLabelBackgroundStrokeStyleZ: Kt, cursor3DTickLabelPaddingX: { left: 4, right: 4, top: 4, bottom: 4 }, cursor3DTickLabelPaddingY: { left: 4, right: 4, top: 4, bottom: 4 }, cursor3DTickLabelPaddingZ: { left: 4, right: 4, top: 4, bottom: 4 } };
    return s.overrideThemeProperties && (yt = { ...yt, ...s.overrideThemeProperties }), yt;
  })(r), i = { ...t, header1Font: e.xAxisTitleFont, header2Font: e.xAxisNumericTicks.getMajorTickStyle().labelFont, header3Font: e.uiTextFont, mainDataColor: r.dataColorPalette[0].stroke };
  return { ...e, examples: i };
}, mh = "Segoe UI, -apple-system, Verdana, Helvetica", Fo = (r, t) => {
  const e = new Image();
  e.crossOrigin = "*";
  const i = `${r}/${t}`;
  return e.src = i, e;
}, xh = (r, t, e) => (i) => {
  const s = r === !0 ? t[i % t.length].stroke : Ki(t[i % t.length].stroke, N(255, 255, 255), 0.5);
  return new Gi({ stops: [{ color: Ki(s, N(255, 255, 255), 0.5 * e).setA(100), offset: 0 }, { color: s.setA(100), offset: 0.5 }, { color: Ki(s, N(30, 30, 30), 0.5 * e).setA(100), offset: 1 }] });
}, vh = (r, t, e) => (i) => {
  const s = r === !0 ? t[i % t.length].stroke : Ki(t[i % t.length].stroke, N(255, 255, 255), 0.2);
  return new Gi({ stops: [{ color: Ki(s, N(255, 255, 255), 0.2 * e), offset: 0 }, { color: s, offset: 0.5 }, { color: Ki(s, N(0, 0, 0), 0.2 * e), offset: 1 }] });
}, gn = (r, t, e) => (i) => {
  const s = r === !0 ? t[i % t.length].stroke : Ki(t[i % t.length].stroke, N(255, 255, 255), 0.2);
  return new Ci({ angle: 90, stops: [{ color: Ki(s, N(255, 255, 255), 0.5 * e), offset: 0 }, { color: s, offset: 0.35 }, { color: Ki(s, N(30, 30, 30), 0.5 * e), offset: 1 }] });
}, Sh = (r, t, e) => /* @__PURE__ */ (() => {
  const i = /* @__PURE__ */ new Map();
  return (s) => {
    const o = i.get(s);
    if (o) return o;
    const n = ((a) => {
      const l = r === !0 ? t[a % t.length].stroke : Ki(t[a % t.length].stroke, N(255, 255, 255), 0.3);
      return new Ci({ angle: 90, stops: [{ color: Ki(l, N(255, 255, 255), 0.5), offset: 0 }, { color: l, offset: 0.35 }, { color: Ki(l, N(30, 30, 30), 0.5), offset: 1 }] });
    })(s);
    return i.set(s, n), n;
  };
})(), uE = hh((() => {
  const r = N(255, 255, 255), t = new ot({ color: r }), e = !0, i = new Zu({ spread: 1, blur: 9, offset: { x: 0, y: 0 }, color: N(0, 0, 0, 150) }), s = new Gi({ position: { x: 0.8, y: 0.8 }, extent: hs.farthestCorner, shape: Cs.ellipse, stops: [{ offset: 0, color: N(50, 51, 52) }, { offset: 0.5, color: N(14, 15, 16) }, { offset: 1, color: N(0, 0, 0) }] }), o = new ot({ color: N(45, 45, 45) }), n = new Gi({ position: { x: 0.5, y: 0.5 }, extent: hs.farthestCorner, shape: Cs.circle, stops: [{ offset: 0, color: N(120, 120, 120, 100) }, { offset: 1, color: N(0, 0, 0, 50) }] }), a = new Gi({ position: { x: 0.5, y: 0.5 }, extent: hs.farthestCorner, shape: Cs.circle, stops: [{ offset: 0, color: N(30, 30, 30, 200) }, { offset: 1, color: N(0, 0, 0, 255) }] }), l = mh, h = new ot({ color: N(255, 255, 220) }), u = new ot({ color: N(255, 255, 166) }), c = new ot({ color: N(255, 255, 220) }), d = new ot({ color: N(255, 255, 200) }), f = d, p = new Ci({ angle: 45, stops: [{ offset: 0, color: N(230, 230, 230) }, { offset: 1, color: N(150, 150, 150) }] }), g = new ot({ color: N(220, 220, 220) }), y = new ot({ color: N(200, 200, 200, 50) }), m = new ot({ color: N(200, 200, 200, 150) }), A = new ot({ color: N(200, 200, 200, 20) }), v = new ot({ color: N(220, 220, 220) }), b = new Ci({ angle: 0, stops: [{ offset: 0, color: N(10, 10, 10, 220) }, { offset: 1, color: N(30, 30, 30, 220) }] }), w = t, k = N(255, 255, 200), R = new ot({ color: N(0, 0, 0, 224) }), L = new ot({ color: N(166, 166, 166) }), x = new ot({ color: N(49, 53, 58) }), M = N(20, 20, 20), C = N(0, 0, 0), S = r, E = N(150, 150, 150), T = N(50, 50, 50), I = N(50, 50, 50), F = N(100, 100, 100);
  N(200, 200, 200);
  const D = [N(255, 255, 91, 255), N(255, 205, 91, 255), N(255, 155, 91, 255), N(255, 196, 188, 255), N(255, 148, 184, 255), N(219, 148, 198, 255), N(235, 196, 224, 255), N(169, 148, 198, 255), N(148, 226, 198, 255), N(148, 255, 176, 255), N(180, 255, 165, 255)].map(((ht) => ({ stroke: ht, border: ht, area: ht.setA(180) }))), P = r.setA(20), V = N(176, 255, 157, 255), _ = N(255, 112, 76, 255), O = { mapChartFillStyle: new Ci({ angle: 135, stops: [{ color: N(255, 255, 91, 255), offset: 0 }, { color: N(255, 155, 91, 255), offset: 1 }] }), spiderSeriesFillStyle: xh(e, D, 0.5), pieChartSliceFillStylePalette: vh(e, D, 1), funnelChartSliceFillStylePalette: gn(e, D, 1), pyramidChartSliceFillStylePalette: gn(e, D, 1), rectangleSeriesFillStyle: Sh(e, D), gaugeChartBarColor: N(255, 255, 91, 255), gaugeChartGlowColor: N(255, 255, 91, 64) }, B = new ot({ color: N(176, 255, 157, 255) }), z = new ot({ color: N(255, 146, 146, 255) }), W = new ot({ color: N(176, 255, 157, 255) }), G = new ot({ color: N(230, 63, 63, 255) }), Y = new ot({ color: N(176, 255, 157, 120) }), U = new ot({ color: N(229, 63, 63, 180) }), $ = new ot({ color: N(27, 37, 36, 255) }), Z = new ot({ color: N(62, 27, 27, 255) }), q = [N(255, 0, 0), N(255, 255, 0), N(0, 255, 0)], Q = [N(10, 10, 255), N(10, 190, 255), N(251, 255, 0), N(255, 38, 0)], nt = [N(255, 255, 0), N(255, 204, 0), N(255, 128, 0), N(255, 0, 0)], et = [N(0, 0, 0), N(167, 4, 69, 255), N(255, 0, 0), N(252, 252, 168, 255)], it = new Gi({ stops: [{ color: N(61, 61, 80, 100), offset: 0 }, { color: N(44, 44, 55, 30), offset: 1 }] }), rt = new ot({ color: N(148, 148, 198, 255) }), tt = Y.getColor().setA(255), at = N(100, 100, 100), ut = [N(255, 241, 149, 200), N(255, 230, 65, 200), N(238, 211, 32, 200), N(238, 176, 32, 200), N(255, 159, 13, 200), N(254, 120, 37, 200), N(253, 91, 56, 200), N(253, 75, 84, 200), N(254, 95, 124, 200), N(227, 56, 160, 200), N(226, 53, 134, 200), N(216, 90, 166, 200), N(254, 151, 206, 200), N(237, 151, 254, 200), N(243, 177, 255, 200), N(233, 133, 252, 200), N(210, 101, 230, 200), N(178, 61, 200, 200), N(193, 81, 156, 200), N(217, 95, 145, 200)];
  return yh({ isDark: e, highlightColorOffset: N(60, 60, 60, 60), highlightColorOffsetAxisOverlay: N(255, 255, 255, 40), effect: i, effectsText: !0, effectsDashboardSplitters: !0, lcjsBackgroundFillStyle: s, dashboardSplitterFillStyle: o, panelBackgroundFillStyle: n, seriesBackgroundFillStyle: a, fontFamily: l, fontScaler: 1, titleFillStyle: h, axisTitleFillStyle: u, axisLabelMajorFillStyle: c, uiTextFillStyle: f, axisLineFillStyle: p, axisTickMajorFillStyle: g, axisGridMajorFillStyle: y, axisTickMinorFillStyle: m, axisGridMinorFillStyle: A, cursorGridFillStyle: v, legendBackgroundFillStyle: b, legendBackgroundBorderFillStyle: w, legendButtonDefaultColor: k, resultTableBackgroundFillStyle: R, resultTableBackgroundBorderFillStyle: L, resultTableHeaderBackgroundFillStyle: x, uiBackgroundColor: M, uiBackgroundBorderColor: C, uiStrokeColorContrastHigh: S, uiStrokeColorContrastMedium: E, uiStrokeColorContrastLow: T, dataStrokeColorContrastHigh: I, dataStrokeColorContrastMedium: F, dataColorPalette: D, dataColorPaletteInverted: [{ area: N(190, 50, 50, 100), border: N(210, 80, 80) }], dataHighlightOverlayColor: P, dataColorPositive: V, dataColorNegative: _, zoomBandChartDefocusOverlayFillStyle: new ot({ color: N(0, 0, 0, 180) }), zoomBandChartSplitterColor: N(251, 251, 90), zoomBandChartKnobFillStyle: (ht) => new wr({ source: Fo(ht, "zoomBandChart/darkgold-selector.png"), fitMode: Li.Fill }), zoomBandChartKnobSize: { x: 14, y: 30 }, dataColorUnselected: N(255, 255, 255, 24), overrideThemeProperties: O, treeMapChartParentColor: N(24, 30, 33), treeMapChartNodeColors: ut, treeMapChartLabelFillStyle: new ot({ color: N(33, 33, 33) }), treeMapChartLabelHeaderFillStyle: new ot({ color: N(250, 250, 250) }) }, { positiveTextFillStyle: B, negativeTextFillStyle: z, positiveFillStyle: W, negativeFillStyle: G, positiveAreaFillStyle: Y, negativeAreaFillStyle: U, positiveBackgroundFillStyle: $, negativeBackgroundFillStyle: Z, badGoodColorPalette: q, coldHotColorPalette: Q, intensityColorPalette: nt, spectrogramColorPalette: et, bollingerFillStyle: it, bollingerBorderFillStyle: rt, highlightPointColor: r, highlightDataGridColor: tt, unfocusedDataColor: at });
})), cE = hh((() => {
  const r = N(255, 255, 255), t = new ot({ color: r }), e = !0, i = new Zu({ spread: 0, blur: 9, offset: { x: 0, y: 0 }, color: N(105, 255, 236, 40) }), s = new ot({ color: N(2, 21, 30) }), o = new Gi({ stops: [{ color: N(19, 40, 66, 150), offset: 0 }, { color: N(0, 0, 0, 150), offset: 1 }] }), n = new ot({ color: N(0, 5, 8, 150) }), a = mh, l = t, h = t, u = t, c = t, d = new ot({ color: N(20, 224, 250, 255) }), f = t, p = new ot({ color: N(61, 94, 110, 100) }), g = new ot({ color: N(61, 94, 110, 255) }), y = new ot({ color: N(61, 94, 110, 40) }), m = t, A = new ot({ color: N(0, 18, 23, 255) }), v = t, b = r, w = new ot({ color: N(0, 0, 0, 225) }), k = t, R = new ot({ color: N(18, 66, 75) }), L = N(0, 38, 48, 220), x = N(0, 0, 0), M = r, C = N(150, 150, 150), S = N(19, 78, 93), E = N(50, 50, 50), T = N(0, 36, 48);
  N(200, 200, 200);
  const I = [N(45, 253, 253, 255), N(44, 172, 247, 255), N(46, 100, 248, 255), N(96, 84, 199, 255), N(184, 104, 245, 255), N(98, 160, 218, 255), N(43, 238, 245, 255), N(38, 140, 206, 255), N(112, 96, 224, 255), N(206, 157, 255, 255)].map(((at) => ({ stroke: at, border: at, area: at.setA(180) }))), F = r.setA(50), D = N(3, 217, 194, 255), P = N(230, 63, 63, 255), V = { mapChartFillStyle: new Ci({ angle: 135, stops: [{ color: N(118, 248, 231, 255), offset: 0 }, { color: N(45, 177, 255, 255), offset: 1 }] }), spiderSeriesFillStyle: xh(e, I, 1), pieChartSliceFillStylePalette: vh(e, I, 1), funnelChartSliceFillStylePalette: gn(e, I, 1), pyramidChartSliceFillStylePalette: gn(e, I, 1), rectangleSeriesFillStyle: Sh(e, I), gaugeChartBarColor: N(3, 217, 194, 255), gaugeChartGlowColor: N(3, 217, 194, 120) }, _ = new ot({ color: N(45, 253, 253, 255) }), O = new ot({ color: N(255, 146, 146, 255) }), B = new ot({ color: N(45, 253, 253, 255) }), z = new ot({ color: N(230, 63, 63, 255) }), W = new ot({ color: N(1, 190, 164, 120) }), G = new ot({ color: N(229, 63, 63, 180) }), Y = new ot({ color: N(1, 53, 57, 255) }), U = new ot({ color: N(62, 27, 27, 255) }), $ = [N(1, 104, 119, 255), N(0, 165, 144, 255), N(0, 246, 214, 255)], Z = [N(0, 87, 95, 255), N(0, 125, 124, 255), N(1, 209, 182, 255), N(0, 255, 221, 255), N(218, 112, 112, 255), N(172, 47, 47, 255)], q = [N(126, 255, 253, 255), N(50, 233, 230, 255), N(0, 196, 193, 255), N(62, 138, 178, 255), N(139, 88, 191, 255), N(162, 55, 143, 255)], Q = [N(13, 31, 52, 255), N(101, 50, 118, 255), N(1, 142, 172, 255), N(2, 196, 170, 255), N(0, 255, 221, 255)], nt = new Gi({ stops: [{ color: N(122, 103, 254, 70), offset: 0 }, { color: N(178, 168, 255, 10), offset: 1 }] }), et = new ot({ color: N(122, 103, 254, 255) }), it = W.getColor().setA(255), rt = N(15, 83, 83), tt = [N(139, 252, 252, 150), N(60, 239, 239, 150), N(2, 201, 201, 150), N(26, 159, 159, 150), N(15, 146, 187, 150), N(65, 168, 200, 150), N(67, 146, 207, 150), N(64, 108, 209, 150), N(189, 64, 233, 150), N(219, 84, 238, 150), N(192, 55, 212, 150), N(212, 98, 229, 150), N(248, 110, 211, 150), N(251, 154, 225, 150), N(251, 154, 184, 150), N(233, 105, 144, 150), N(255, 133, 170, 150), N(249, 110, 135, 150), N(245, 72, 101, 150), N(210, 57, 84, 150)];
  return yh({ isDark: e, highlightColorOffset: N(60, 60, 60, 60), highlightColorOffsetAxisOverlay: N(255, 255, 255, 40), effect: i, effectsText: !1, effectsDashboardSplitters: !0, lcjsBackgroundFillStyle: (at) => new wr({ source: Fo(at, "themes/turquoiseHexagon.jpg"), fitMode: Li.Fill }), dashboardSplitterFillStyle: s, panelBackgroundFillStyle: o, seriesBackgroundFillStyle: n, fontFamily: a, fontScaler: 1, titleFillStyle: l, axisTitleFillStyle: h, axisLabelMajorFillStyle: u, uiTextFillStyle: c, axisLineFillStyle: d, axisTickMajorFillStyle: f, axisGridMajorFillStyle: p, axisTickMinorFillStyle: g, axisGridMinorFillStyle: y, cursorGridFillStyle: m, legendBackgroundFillStyle: A, legendBackgroundBorderFillStyle: v, legendButtonDefaultColor: b, resultTableBackgroundFillStyle: w, resultTableBackgroundBorderFillStyle: k, resultTableHeaderBackgroundFillStyle: R, uiBackgroundColor: L, uiBackgroundBorderColor: x, uiStrokeColorContrastHigh: M, uiStrokeColorContrastMedium: C, uiStrokeColorContrastLow: S, dataStrokeColorContrastHigh: E, dataStrokeColorContrastMedium: T, dataColorPalette: I, dataColorPaletteInverted: [{ area: N(170, 60, 210, 100), border: N(210, 100, 250) }], dataHighlightOverlayColor: F, dataColorPositive: D, dataColorNegative: P, zoomBandChartDefocusOverlayFillStyle: new ot({ color: N(0, 0, 0, 180) }), zoomBandChartSplitterColor: N(43, 244, 244), zoomBandChartKnobFillStyle: (at) => new wr({ source: Fo(at, "zoomBandChart/turquoise-selector.png"), fitMode: Li.Fill }), zoomBandChartKnobSize: { x: 14, y: 30 }, dataColorUnselected: N(255, 255, 255, 24), overrideThemeProperties: V, treeMapChartParentColor: N(0, 35, 41), treeMapChartNodeColors: tt, treeMapChartLabelFillStyle: new ot({ color: N(33, 33, 33) }), treeMapChartLabelHeaderFillStyle: new ot({ color: N(250, 250, 250) }) }, { positiveTextFillStyle: _, negativeTextFillStyle: O, positiveFillStyle: B, negativeFillStyle: z, positiveAreaFillStyle: W, negativeAreaFillStyle: G, positiveBackgroundFillStyle: Y, negativeBackgroundFillStyle: U, badGoodColorPalette: $, coldHotColorPalette: Z, intensityColorPalette: q, spectrogramColorPalette: Q, bollingerFillStyle: nt, bollingerBorderFillStyle: et, highlightPointColor: r, highlightDataGridColor: it, unfocusedDataColor: rt });
})), dE = hh((() => {
  const t = new Zu({ spread: 0, blur: 6, offset: { x: 2, y: -2 }, color: N(0, 0, 0, 30) }), e = new Gi({ position: { x: 0.8, y: 0.8 }, extent: hs.farthestCorner, shape: Cs.ellipse, stops: [{ offset: 0, color: N(255, 255, 255) }, { offset: 1, color: N(255, 255, 255) }] }), i = new ot({ color: N(219, 227, 233, 255) }), s = new Gi({ position: { x: 0.5, y: 0.5 }, extent: hs.farthestCorner, shape: Cs.circle, stops: [{ offset: 0, color: N(255, 255, 255, 200) }, { offset: 1, color: N(240, 244, 246, 200) }] }), o = new Gi({ position: { x: 0.5, y: 0.5 }, extent: hs.farthestCorner, shape: Cs.circle, stops: [{ offset: 0, color: N(255, 255, 255, 255) }, { offset: 1, color: N(255, 255, 255, 255) }] }), n = mh, a = new ot({ color: N(33, 43, 49) }), l = new ot({ color: N(33, 43, 49) }), h = new ot({ color: N(33, 43, 49) }), u = new ot({ color: N(33, 43, 49) }), c = u, d = new Ci({ angle: 45, stops: [{ offset: 0, color: N(225, 225, 225) }, { offset: 1, color: N(225, 225, 225) }] }), f = new ot({ color: N(150, 150, 150, 255) }), p = new ot({ color: N(150, 150, 150, 170) }), g = new ot({ color: N(150, 150, 150, 150) }), y = new ot({ color: N(150, 150, 150, 100) }), m = new ot({ color: N(60, 70, 80) }), A = new Ci({ angle: 0, stops: [{ offset: 0, color: N(255, 255, 255, 240) }, { offset: 1, color: N(255, 255, 255, 240) }] }), v = new ot({ color: N(168, 186, 199) }), b = N(150, 150, 150), w = new ot({ color: N(255, 255, 255, 230) }), k = new ot({ color: N(168, 186, 199) }), R = new ot({ color: N(228, 235, 243) }), L = N(255, 255, 255, 255), x = N(168, 168, 199, 255), M = N(168, 186, 199, 255), C = N(168, 186, 199, 255), S = N(168, 186, 199, 255), E = N(168, 186, 199, 255), T = N(100, 100, 100);
  N(200, 200, 200);
  const I = [N(28, 181, 140, 255), N(255, 132, 0, 255), N(240, 39, 39, 255), N(86, 121, 251, 255), N(2, 181, 213, 255), N(13, 212, 158, 255), N(22, 167, 3, 255), N(234, 103, 232, 255), N(62, 183, 179, 255), N(140, 93, 3, 255), N(155, 158, 186, 255)].map(((ut) => ({ stroke: ut, border: ut, area: ut.setA(180) }))), F = N(150, 150, 150, 80), D = N(46, 182, 120, 255), P = N(255, 66, 66, 255), V = new $t({ thickness: 2, fillStyle: new ot({ color: N(168, 186, 199, 255) }) }), _ = { mapChartFillStyle: new Ci({ angle: -45, stops: [{ color: N(2, 181, 213, 255), offset: 0 }, { color: N(175, 243, 255, 255), offset: 1 }] }), spiderSeriesFillStyle: xh(!1, I, 0.8), pieChartSliceFillStylePalette: vh(!1, I, 0.8), funnelChartSliceFillStylePalette: gn(!1, I, 0.5), pyramidChartSliceFillStylePalette: gn(!1, I, 0.5), rectangleSeriesFillStyle: Sh(!1, I), gaugeChartBarColor: N(46, 182, 120, 255), gaugeChartGlowColor: N(46, 182, 120, 120), chartXYSeriesBackgroundStrokeStyle: V, chart3DSeriesBackgroundStrokeStyle: V, polarChartSeriesBackgroundStrokeStyle: V, spiderChartSeriesBackgroundStrokeStyle: V, dataGridTextFillStyle: new ot({ color: N(0, 88, 64, 255) }) }, O = new ot({ color: N(4, 146, 108, 255) }), B = new ot({ color: N(240, 39, 39, 255) }), z = new ot({ color: N(28, 181, 140, 255) }), W = new ot({ color: N(230, 88, 88, 255) }), G = new ot({ color: N(28, 181, 140, 180) }), Y = new ot({ color: N(230, 88, 88, 180) }), U = new ot({ color: N(229, 243, 228) }), $ = new ot({ color: N(232, 225, 216) }), Z = [N(193, 48, 48, 255), N(240, 234, 60, 255), N(45, 191, 55, 255)], q = [N(10, 19, 255, 255), N(15, 191, 250, 255), N(249, 255, 2, 255), N(253, 133, 0, 255), N(255, 24, 0, 255)], Q = [N(50, 99, 213), N(8, 179, 77), N(255, 246, 0), N(255, 126, 0), N(189, 36, 30)], nt = [N(16, 64, 176), N(8, 179, 77), N(255, 246, 0), N(255, 126, 0), N(168, 6, 0)], et = new ot({ color: N(185, 198, 207, 255) }), it = new Gi({ stops: [{ color: N(151, 190, 220, 10), offset: 0 }, { color: N(151, 190, 220, 50), offset: 1 }] }), rt = G.getColor().setA(255), tt = N(150, 150, 150), at = [N(255, 243, 136, 125), N(254, 237, 99, 125), N(255, 216, 109, 125), N(255, 172, 100, 125), N(255, 133, 101, 125), N(255, 113, 142, 125), N(230, 103, 129, 125), N(242, 126, 219, 125), N(255, 155, 235, 125), N(255, 181, 240, 125), N(203, 143, 255, 125), N(208, 154, 255, 125), N(171, 188, 255, 125), N(197, 209, 255, 125), N(171, 187, 255, 125), N(84, 167, 239, 125), N(38, 196, 214, 125), N(38, 214, 196, 125), N(69, 225, 141, 125), N(36, 191, 88, 125)];
  return yh({ isDark: !1, highlightColorOffset: N(-60, -60, -60, 60), highlightColorOffsetAxisOverlay: N(0, 0, 0, 40), effect: t, effectsText: !1, effectsDashboardSplitters: !0, lcjsBackgroundFillStyle: e, dashboardSplitterFillStyle: i, panelBackgroundFillStyle: s, seriesBackgroundFillStyle: o, fontFamily: n, fontScaler: 1, titleFillStyle: a, axisTitleFillStyle: l, axisLabelMajorFillStyle: h, uiTextFillStyle: c, axisLineFillStyle: d, axisTickMajorFillStyle: f, axisGridMajorFillStyle: p, axisTickMinorFillStyle: g, axisGridMinorFillStyle: y, cursorGridFillStyle: m, legendBackgroundFillStyle: A, legendBackgroundBorderFillStyle: v, legendButtonDefaultColor: b, resultTableBackgroundFillStyle: w, resultTableBackgroundBorderFillStyle: k, resultTableHeaderBackgroundFillStyle: R, uiBackgroundColor: L, uiBackgroundBorderColor: x, uiStrokeColorContrastHigh: M, uiStrokeColorContrastMedium: C, uiStrokeColorContrastLow: S, dataStrokeColorContrastHigh: E, dataStrokeColorContrastMedium: T, dataColorPalette: I, dataColorPaletteInverted: [{ area: N(190, 50, 50, 100), border: N(210, 80, 80) }], dataHighlightOverlayColor: F, dataColorPositive: D, dataColorNegative: P, zoomBandChartDefocusOverlayFillStyle: new ot({ color: N(255, 255, 255, 180) }), zoomBandChartSplitterColor: N(80, 93, 101), zoomBandChartKnobFillStyle: (ut) => new wr({ source: Fo(ut, "zoomBandChart/light-selector.png"), fitMode: Li.Fill }), zoomBandChartKnobSize: { x: 14, y: 30 }, dataColorUnselected: N(0, 0, 0, 24), overrideThemeProperties: _, treeMapChartParentColor: N(217, 217, 217), treeMapChartNodeColors: at, treeMapChartLabelFillStyle: new ot({ color: N(0, 0, 0) }), treeMapChartLabelHeaderFillStyle: new ot({ color: N(33, 33, 33) }) }, { positiveTextFillStyle: O, negativeTextFillStyle: B, positiveFillStyle: z, negativeFillStyle: W, positiveAreaFillStyle: G, negativeAreaFillStyle: Y, positiveBackgroundFillStyle: U, negativeBackgroundFillStyle: $, badGoodColorPalette: Z, coldHotColorPalette: q, intensityColorPalette: Q, spectrogramColorPalette: nt, bollingerFillStyle: it, bollingerBorderFillStyle: et, highlightPointColor: N(0, 0, 0), highlightDataGridColor: rt, unfocusedDataColor: tt });
})), fE = hh((() => {
  const t = new Gi({ position: { x: 0.8, y: 0.8 }, extent: hs.farthestCorner, shape: Cs.ellipse, stops: [{ offset: 0, color: N(255, 255, 255) }, { offset: 1, color: N(255, 255, 255) }] }), e = new ot({ color: N(214, 236, 216, 255) }), i = new Gi({ position: { x: 0.5, y: 0.5 }, extent: hs.farthestCorner, shape: Cs.circle, stops: [{ offset: 0, color: N(233, 244, 231, 70) }, { offset: 1, color: N(233, 244, 231, 200) }] }), s = new Gi({ position: { x: 0.5, y: 0.5 }, extent: hs.farthestCorner, shape: Cs.circle, stops: [{ offset: 0, color: N(255, 255, 255, 255) }, { offset: 1, color: N(255, 255, 255, 255) }] }), o = mh, n = new ot({ color: N(1, 61, 53) }), a = new ot({ color: N(1, 61, 53) }), l = new ot({ color: N(1, 61, 53) }), h = new ot({ color: N(1, 61, 53) }), u = h, c = new Ci({ angle: 45, stops: [{ offset: 0, color: N(225, 225, 225) }, { offset: 1, color: N(225, 225, 225) }] }), d = new ot({ color: N(188, 211, 186, 255) }), f = new ot({ color: N(188, 211, 186, 150) }), p = new ot({ color: N(188, 211, 186, 50) }), g = new ot({ color: N(188, 211, 186, 50) }), y = new ot({ color: N(104, 148, 111, 255) }), m = new Ci({ angle: 0, stops: [{ offset: 0, color: N(255, 255, 255, 240) }, { offset: 1, color: N(255, 255, 255, 240) }] }), A = new ot({ color: N(104, 148, 111) }), v = N(150, 150, 150), b = new ot({ color: N(255, 255, 255, 230) }), w = new ot({ color: N(104, 148, 111) }), k = new ot({ color: N(226, 236, 224) }), R = N(255, 255, 255, 255), L = N(179, 201, 183, 255), x = N(188, 211, 186, 255), M = N(188, 211, 186, 255), C = N(188, 211, 186, 255), S = N(188, 211, 186, 255), E = N(100, 100, 100);
  N(200, 200, 200);
  const T = [N(138, 195, 142, 255), N(193, 161, 114, 255), N(178, 99, 99, 255), N(142, 156, 210, 255), N(154, 209, 219, 255), N(164, 212, 199, 255), N(104, 156, 97, 255), N(196, 147, 195, 255), N(92, 190, 187, 255), N(126, 100, 51, 255), N(136, 138, 157, 255)].map(((at) => ({ stroke: at, border: at, area: at.setA(180) }))), I = N(150, 150, 150, 80), F = N(46, 182, 84, 255), D = N(232, 96, 96, 255), P = new $t({ thickness: 2, fillStyle: new ot({ color: N(188, 211, 186, 255) }) }), V = { mapChartFillStyle: new Ci({ angle: -45, stops: [{ color: N(118, 160, 121, 255), offset: 0 }, { color: N(174, 227, 178, 255), offset: 1 }] }), spiderSeriesFillStyle: xh(!1, T, 0.8), pieChartSliceFillStylePalette: vh(!1, T, 0.8), pyramidChartSliceFillStylePalette: gn(!1, T, 0.5), funnelChartSliceFillStylePalette: gn(!1, T, 0.5), rectangleSeriesFillStyle: Sh(!1, T), gaugeChartBarColor: N(46, 182, 84, 255), gaugeChartGlowColor: N(46, 182, 84, 120), chartXYSeriesBackgroundStrokeStyle: P, chart3DSeriesBackgroundStrokeStyle: P, polarChartSeriesBackgroundStrokeStyle: P, spiderChartSeriesBackgroundStrokeStyle: P, dataGridTextFillStyle: new ot({ color: N(77, 66, 21, 255) }) }, _ = new ot({ color: N(93, 151, 97, 255) }), O = new ot({ color: N(178, 99, 99, 255) }), B = new ot({ color: N(138, 195, 142, 255) }), z = new ot({ color: N(178, 99, 99, 255) }), W = new ot({ color: N(138, 195, 142, 180) }), G = new ot({ color: N(178, 99, 99, 180) }), Y = new ot({ color: N(224, 240, 237) }), U = new ot({ color: N(251, 227, 227) }), $ = [N(178, 99, 99, 255), N(215, 224, 111, 255), N(80, 186, 88, 255)], Z = [N(62, 64, 142, 255), N(66, 131, 77, 255), N(250, 250, 135, 255), N(202, 161, 78, 255), N(179, 53, 53, 255)], q = [N(64, 86, 138), N(123, 192, 205), N(255, 252, 149), N(220, 155, 92), N(184, 78, 74)], Q = [N(64, 86, 138), N(123, 192, 205), N(255, 252, 149), N(220, 155, 92), N(132, 60, 57)], nt = new ot({ color: N(185, 198, 207, 255) }), et = new Gi({ stops: [{ color: N(151, 190, 220, 10), offset: 0 }, { color: N(151, 190, 220, 50), offset: 1 }] }), it = W.getColor().setA(255), rt = N(150, 150, 150), tt = [N(242, 239, 210, 150), N(243, 238, 183, 150), N(210, 222, 136, 150), N(204, 217, 148, 150), N(157, 190, 124, 150), N(143, 178, 72, 150), N(198, 147, 88, 150), N(216, 148, 71, 150), N(229, 142, 103, 150), N(225, 174, 152, 150), N(219, 149, 203, 150), N(216, 188, 209, 150), N(109, 198, 189, 150), N(172, 206, 202, 150), N(164, 223, 217, 150), N(174, 215, 233, 150), N(203, 225, 235, 150), N(220, 227, 243, 150), N(207, 213, 227, 150), N(171, 182, 209, 150)];
  return yh({ isDark: !1, highlightColorOffset: N(-60, -60, -60, 60), highlightColorOffsetAxisOverlay: N(0, 0, 0, 40), effect: void 0, effectsText: !1, effectsDashboardSplitters: !1, lcjsBackgroundFillStyle: t, dashboardSplitterFillStyle: e, panelBackgroundFillStyle: i, seriesBackgroundFillStyle: s, fontFamily: o, fontScaler: 1, titleFillStyle: n, axisTitleFillStyle: a, axisLabelMajorFillStyle: l, uiTextFillStyle: u, axisLineFillStyle: c, axisTickMajorFillStyle: d, axisGridMajorFillStyle: f, axisTickMinorFillStyle: p, axisGridMinorFillStyle: g, cursorGridFillStyle: y, legendBackgroundFillStyle: m, legendBackgroundBorderFillStyle: A, legendButtonDefaultColor: v, resultTableBackgroundFillStyle: b, resultTableBackgroundBorderFillStyle: w, resultTableHeaderBackgroundFillStyle: k, uiBackgroundColor: R, uiBackgroundBorderColor: L, uiStrokeColorContrastHigh: x, uiStrokeColorContrastMedium: M, uiStrokeColorContrastLow: C, dataStrokeColorContrastHigh: S, dataStrokeColorContrastMedium: E, dataColorPalette: T, dataColorPaletteInverted: [{ area: N(210, 70, 70, 100), border: N(200, 110, 110) }], dataHighlightOverlayColor: I, dataColorPositive: F, dataColorNegative: D, zoomBandChartDefocusOverlayFillStyle: new ot({ color: N(255, 255, 255, 180) }), zoomBandChartSplitterColor: N(68, 106, 64), zoomBandChartKnobFillStyle: (at) => new wr({ source: Fo(at, "zoomBandChart/lightnature-selector.png"), fitMode: Li.Fill }), zoomBandChartKnobSize: { x: 14, y: 30 }, dataColorUnselected: N(0, 0, 0, 24), overrideThemeProperties: V, treeMapChartParentColor: N(239, 247, 238), treeMapChartNodeColors: tt, treeMapChartLabelFillStyle: new ot({ color: N(0, 0, 0) }), treeMapChartLabelHeaderFillStyle: new ot({ color: N(33, 33, 33) }) }, { positiveTextFillStyle: _, negativeTextFillStyle: O, positiveFillStyle: B, negativeFillStyle: z, positiveAreaFillStyle: W, negativeAreaFillStyle: G, positiveBackgroundFillStyle: Y, negativeBackgroundFillStyle: U, badGoodColorPalette: $, coldHotColorPalette: Z, intensityColorPalette: q, spectrogramColorPalette: Q, bollingerFillStyle: et, bollingerBorderFillStyle: nt, highlightPointColor: N(0, 0, 0), highlightDataGridColor: it, unfocusedDataColor: rt });
})), gE = hh((() => {
  const r = N(255, 255, 255), t = new ot({ color: r }), e = !0, i = new Zu({ spread: 1, blur: 9, offset: { x: 0, y: 0 }, color: N(255, 255, 255, 30) }), s = new ot({ color: N(6, 15, 36) }), o = new Gi({ stops: [{ color: N(46, 13, 87, 50), offset: 0 }, { color: N(0, 0, 0, 150), offset: 1 }] }), n = new ot({ color: N(0, 5, 8, 150) }), a = mh, l = t, h = t, u = t, c = t, d = new Ci({ angle: 45, stops: [{ offset: 0, color: N(241, 133, 255, 255) }, { offset: 1, color: N(115, 207, 238, 255) }] }), f = t, p = new ot({ color: N(61, 94, 110, 100) }), g = new ot({ color: N(61, 94, 110, 255) }), y = new ot({ color: N(61, 94, 110, 40) }), m = t, A = new ot({ color: N(0, 18, 23, 255) }), v = t, b = N(115, 207, 238, 255), w = new ot({ color: N(0, 0, 0, 224) }), k = t, R = new ot({ color: N(68, 31, 78) }), L = N(0, 38, 48, 255), x = N(0, 0, 0), M = r, C = N(150, 150, 150), S = N(19, 57, 93), E = N(50, 50, 50), T = N(0, 17, 48);
  N(200, 200, 200);
  const I = [N(20, 211, 237, 255), N(98, 147, 252, 255), N(164, 73, 250, 255), N(129, 117, 253, 255), N(95, 134, 252, 255), N(22, 133, 212, 255), N(35, 200, 242, 255), N(104, 121, 233, 255), N(137, 69, 232, 255), N(70, 72, 241, 255)].map(((at) => ({ stroke: at, border: at, area: at.setA(180) }))), F = r.setA(50), D = N(3, 217, 194, 255), P = N(243, 21, 110, 255), V = { mapChartFillStyle: new Ci({ angle: 135, stops: [{ color: N(118, 248, 231, 255), offset: 0 }, { color: N(45, 177, 255, 255), offset: 1 }] }), spiderSeriesFillStyle: xh(e, I, 0.5), pieChartSliceFillStylePalette: vh(e, I, 2), funnelChartSliceFillStylePalette: gn(e, I, 1), pyramidChartSliceFillStylePalette: gn(e, I, 1), rectangleSeriesFillStyle: Sh(e, I), gaugeChartBarColor: N(3, 217, 194, 255), gaugeChartGlowColor: N(3, 217, 194, 150) }, _ = new ot({ color: N(20, 211, 237, 255) }), O = new ot({ color: N(253, 145, 178, 255) }), B = new ot({ color: N(20, 211, 237, 255) }), z = new ot({ color: N(239, 68, 121, 255) }), W = new ot({ color: N(20, 211, 237, 120) }), G = new ot({ color: N(239, 68, 121, 180) }), Y = new ot({ color: N(1, 53, 57, 255) }), U = new ot({ color: N(94, 19, 42, 255) }), $ = [N(174, 51, 132, 255), N(204, 107, 218, 255), N(189, 215, 253, 255)], Z = [N(0, 63, 95, 255), N(0, 149, 255, 255), N(0, 225, 255, 255), N(255, 154, 254, 255), N(204, 98, 170, 255), N(139, 39, 84, 255)], q = [N(197, 241, 255, 255), N(70, 210, 255, 255), N(0, 164, 217, 255), N(90, 99, 222, 255), N(138, 75, 192, 255), N(151, 27, 162, 255)], Q = [N(13, 31, 52, 255), N(129, 54, 130, 255), N(131, 108, 176, 255), N(7, 162, 213, 255), N(26, 247, 255, 255)], nt = new Gi({ stops: [{ color: N(219, 42, 235, 60), offset: 0 }, { color: N(237, 73, 252, 10), offset: 1 }] }), et = new ot({ color: N(237, 73, 252, 255) }), it = W.getColor().setA(255), rt = N(8, 70, 100), tt = [N(149, 230, 255, 150), N(93, 213, 243, 150), N(20, 189, 223, 150), N(5, 151, 181, 150), N(2, 138, 198, 150), N(2, 113, 198, 150), N(97, 148, 236, 150), N(93, 111, 230, 150), N(151, 120, 223, 150), N(128, 87, 227, 150), N(153, 52, 230, 150), N(179, 92, 245, 150), N(248, 110, 211, 150), N(255, 155, 228, 150), N(251, 88, 207, 150), N(255, 0, 162, 150), N(214, 73, 177, 150), N(209, 71, 159, 150), N(238, 101, 169, 150), N(210, 57, 134, 150)];
  return yh({ isDark: e, highlightColorOffset: N(60, 60, 60, 60), highlightColorOffsetAxisOverlay: N(255, 255, 255, 40), effect: i, effectsText: !0, effectsDashboardSplitters: !0, lcjsBackgroundFillStyle: (at) => new wr({ source: Fo(at, "themes/cyberSpace.jpg"), fitMode: Li.Fill }), dashboardSplitterFillStyle: s, panelBackgroundFillStyle: o, seriesBackgroundFillStyle: n, fontFamily: a, fontScaler: 1, titleFillStyle: l, axisTitleFillStyle: h, axisLabelMajorFillStyle: u, uiTextFillStyle: c, axisLineFillStyle: d, axisTickMajorFillStyle: f, axisGridMajorFillStyle: p, axisTickMinorFillStyle: g, axisGridMinorFillStyle: y, cursorGridFillStyle: m, legendBackgroundFillStyle: A, legendBackgroundBorderFillStyle: v, legendButtonDefaultColor: b, resultTableBackgroundFillStyle: w, resultTableBackgroundBorderFillStyle: k, resultTableHeaderBackgroundFillStyle: R, uiBackgroundColor: L, uiBackgroundBorderColor: x, uiStrokeColorContrastHigh: M, uiStrokeColorContrastMedium: C, uiStrokeColorContrastLow: S, dataStrokeColorContrastHigh: E, dataStrokeColorContrastMedium: T, dataColorPalette: I, dataColorPaletteInverted: [{ area: N(41, 130, 255, 100), border: N(45, 110, 240) }], dataHighlightOverlayColor: F, dataColorPositive: D, dataColorNegative: P, zoomBandChartDefocusOverlayFillStyle: new ot({ color: N(0, 0, 0, 180) }), zoomBandChartSplitterColor: N(219, 119, 255), zoomBandChartKnobFillStyle: (at) => new wr({ source: Fo(at, "zoomBandChart/cyberspace-selector.png"), fitMode: Li.Fill }), zoomBandChartKnobSize: { x: 14, y: 30 }, dataColorUnselected: N(255, 255, 255, 24), overrideThemeProperties: V, treeMapChartParentColor: N(30, 30, 59), treeMapChartNodeColors: tt, treeMapChartLabelFillStyle: new ot({ color: N(33, 33, 33) }), treeMapChartLabelHeaderFillStyle: new ot({ color: N(250, 250, 250) }) }, { positiveTextFillStyle: _, negativeTextFillStyle: O, positiveFillStyle: B, negativeFillStyle: z, positiveAreaFillStyle: W, negativeAreaFillStyle: G, positiveBackgroundFillStyle: Y, negativeBackgroundFillStyle: U, badGoodColorPalette: $, coldHotColorPalette: Z, intensityColorPalette: q, spectrogramColorPalette: Q, bollingerFillStyle: nt, bollingerBorderFillStyle: et, highlightPointColor: r, highlightDataGridColor: it, unfocusedDataColor: rt });
})), Jo = {};
Object.defineProperty(Jo, "darkGold", { get: uE, enumerable: !0 }), Object.defineProperty(Jo, "turquoiseHexagon", { get: cE, enumerable: !0 }), Object.defineProperty(Jo, "light", { get: dE, enumerable: !0 }), Object.defineProperty(Jo, "lightNature", { get: fE, enumerable: !0 }), Object.defineProperty(Jo, "cyberSpace", { get: gE, enumerable: !0 });
const zx = Jo, ds = zx.darkGold, pE = (r) => ({ ...r, effect: void 0 });
class Wx extends Rr {
  constructor(t, e, i, s, o, n) {
    var a, l, h, u;
    let c;
    super(t, e, i, e.Av("dataGrid bg", 0), s, e.yi.xi.dataGridBackgroundFillStyle, e.yi.xi.dataGridBackgroundStrokeStyle, e.yi.xi.dataGridTitleFont, e.yi.xi.dataGridTitleFillStyle, e.yi.xi.dataGridTitleShadow, n), this.kT = [], this.CT = [], this.TT = [], this.FT = /* @__PURE__ */ new Map(), this.IT = !0, this.PT = !0, this.LT = !0, this.BT = !0, this.DT = !0, this.ET = !0, this.RT = !0, this.OT = !0, this.zT = !0, this.VT = !0, this.NT = !0, this.GT = !0, this.$T = !0, this.UT = !0, this.jT = !0, this.YT = !0, this.HT = /* @__PURE__ */ new Set(), this.WT = /* @__PURE__ */ new Set(), this.XT = !0, this.ZT = !0, this.JT = (d, f) => {
      d.borders = f === void 0 ? ep : { ...d.borders, ...f }, this.QT(d), this.GT = !0, this.yi.Rs();
    }, this.QT = (d) => {
      d.borders && (d.borders.top === !1 && this.KT(d.column, d.row - 1, ((f) => {
        f.borders = f.borders ? { ...f?.borders, bottom: !1 } : { ...this.qT, bottom: !1 };
      })), d.borders.bottom === !1 && this.KT(d.column, d.row + 1, ((f) => {
        f.borders = f.borders ? { ...f.borders, top: !1 } : { ...this.qT, top: !1 };
      })), d.borders.left === !1 && this.KT(d.column - 1, d.row, ((f) => {
        f.borders = f.borders ? { ...f.borders, right: !1 } : { ...this.qT, right: !1 };
      })), d.borders.right === !1 && this.KT(d.column + 1, d.row, ((f) => {
        f.borders = f.borders ? { ...f.borders, left: !1 } : { ...this.qT, left: !1 };
      })), d.borders.top === !0 && this.KT(d.column, d.row - 1, ((f) => {
        f.borders = f.borders ? { ...f?.borders, bottom: !0 } : { ...this.qT, bottom: !0 };
      })), d.borders.bottom === !0 && this.KT(d.column, d.row + 1, ((f) => {
        f.borders = f.borders ? { ...f.borders, top: !0 } : { ...this.qT, top: !0 };
      })), d.borders.left === !0 && this.KT(d.column - 1, d.row, ((f) => {
        f.borders = f.borders ? { ...f.borders, right: !0 } : { ...this.qT, right: !0 };
      })), d.borders.right === !0 && this.KT(d.column + 1, d.row, ((f) => {
        f.borders = f.borders ? { ...f.borders, left: !0 } : { ...this.qT, left: !0 };
      })));
    }, this.tF = { x: 0, y: 0 }, this.cells = new Nt(), this.D = new Nt(), this.yi.Oa(Ot.Mo), this.Wr.rn("Data Grid"), this.iF = i.d2({ scaleXYConstructor: we }), this.iF.x.gA = tE, this.sF = i.d2({ scaleXYConstructor: we }), this.eF = { x: 0, y: 0 }, this.rF = this.xi.dataGridTextFont, this.hF = this.xi.dataGridTextFillStyle, this.qT = { top: !0, bottom: !0, left: !0, right: !0 }, this.nF = this.xi.dataGridCellBackgroundFillStyle, this.oF = this.xi.dataGridBorderStrokeStyle, this.aF = "left-center", this.lF = { left: (a = this.xi.dataGridCellPadding) !== null && a !== void 0 ? a : 5, right: (l = this.xi.dataGridCellPadding) !== null && l !== void 0 ? l : 5, bottom: (h = this.xi.dataGridCellPadding) !== null && h !== void 0 ? h : 5, top: (u = this.xi.dataGridCellPadding) !== null && u !== void 0 ? u : 5 }, this.uF = e.hS("dataGrid grid bg", 0), this.cF = e.hS("dataGrid cell bg", 1), this.dF = e.nS("dataGrid cell content", 0), this.fF = e.nS("dataGrid scrollbar bg", 1), this.AF = e.nS("dataGrid scrollbar fg", 2), this.gF = this.uF.Vc(this.sF).sr(this.xi.dataGridBackgroundFillStyle).ir(Et).setPointerEvents(!1), this.vF = this.dF.GA(this.iF).setPointerEvents(!1), this.yF = new Xi((() => {
      const d = this.cF.er(this.iF).setPointerEvents(!0);
      return this.cells.zi(d, { getExtraData: () => this.FT.get(d), continueIfNotPrevented: (f, p, g) => {
        const y = ge(this.getUserInteractions().scroll, "wheel", p, p.shiftKey, p.ctrlKey, p.altKey);
        if (y && f === "wheel" && p instanceof WheelEvent) {
          It(p), this.pF({ x: y.x === !0 ? Math.sign(p.deltaY) : 0, y: y.y === !0 ? Math.sign(p.deltaY) : 0 });
          const m = y.on;
          m && m({ event: p });
        }
      } }), d;
    })), this.mF = new Xi((() => this.dF.er(this.iF).setPointerEvents(!1))), this.SF = new Xi((() => this.dF.In(this.iF, !1).setPointerEvents(!1))), this.bF = new Xi((() => this.dF.Ay(this.iF, {}, [Ir.InternalUI, { type: "DataPattern", args: { pattern: "ProgressiveX" } }]).setPointerEvents(!1))), this.xF = new Xi((() => this.dF.vr(this.iF).setPointerEvents(!1))), this.MF = new Xi((() => this.dF.ef(this.iF).sf(Lt).gr(Et).setPointerEvents(!1))), this._F = new Xi((() => this.dF.er(this.iF).setPointerEvents(!1))), this.wF = new Xi((() => this.dF.bM(this.iF).setPointerEvents(!1))), this.kF = new Xi((() => this.dF.Ud(this.iF).setPointerEvents(!1))), this.CF = { background: this.fF.er(this.sF).setPointerEvents(!0).sr(this.xi.dataGridScrollBarBackgroundFillStyle).ir(this.xi.dataGridScrollBarBackgroundStrokeStyle), scrollbar: this.AF.er(this.sF).setPointerEvents(!0).sr(this.xi.dataGridScrollBarFillStyle).ir(this.xi.dataGridScrollBarStrokeStyle), button1: this.fF.er(this.sF).setPointerEvents(!0).sr(this.xi.dataGridScrollBarButtonFillStyle).ir(this.xi.dataGridScrollBarButtonStrokeStyle), button2: this.fF.er(this.sF).setPointerEvents(!0).sr(this.xi.dataGridScrollBarButtonFillStyle).ir(this.xi.dataGridScrollBarButtonStrokeStyle), buttonIcon1: this.AF.ef(this.sF).setPointerEvents(!1).gr(Et).tf(this.xi.dataGridScrollBarButtonArrowFillStyle).rf(Je.Triangle), buttonIcon2: this.AF.ef(this.sF).setPointerEvents(!1).gr(Et).tf(this.xi.dataGridScrollBarButtonArrowFillStyle).rf(Je.Triangle) }, this.TF = { background: this.fF.er(this.sF).setPointerEvents(!0).sr(this.xi.dataGridScrollBarBackgroundFillStyle).ir(this.xi.dataGridScrollBarBackgroundStrokeStyle), scrollbar: this.AF.er(this.sF).setPointerEvents(!0).sr(this.xi.dataGridScrollBarFillStyle).ir(this.xi.dataGridScrollBarStrokeStyle), button1: this.fF.er(this.sF).setPointerEvents(!0).sr(this.xi.dataGridScrollBarButtonFillStyle).ir(this.xi.dataGridScrollBarButtonStrokeStyle), button2: this.fF.er(this.sF).setPointerEvents(!0).sr(this.xi.dataGridScrollBarButtonFillStyle).ir(this.xi.dataGridScrollBarButtonStrokeStyle), buttonIcon1: this.AF.ef(this.sF).setPointerEvents(!1).gr(Et).tf(this.xi.dataGridScrollBarButtonArrowFillStyle).rf(Je.Triangle), buttonIcon2: this.AF.ef(this.sF).setPointerEvents(!1).gr(Et).tf(this.xi.dataGridScrollBarButtonArrowFillStyle).rf(Je.Triangle) }, this.CF.scrollbar.addEventListener("pointerenter", ((d) => {
      c = this.engine.setMouseStyle(Gt.Vertical, c);
    })), this.CF.scrollbar.addEventListener("pointerleave", ((d) => {
      c = this.engine.restoreMouseStyle(c);
    })), this.CF.scrollbar.addEventListener("pointerdown", ((d) => {
      It(d);
      let f = d;
      const p = (y) => {
        const m = y.clientY - f.clientY;
        f = y, this.FF({ x: 0, y: -m });
      }, g = (y) => {
        y.pointerId === d.pointerId && (H.removeEventListener("pointermove", p), H.removeEventListener("pointerup", g));
      };
      H.addEventListener("pointermove", p), H.addEventListener("pointerup", g);
    })), this.CF.scrollbar.addEventListener("wheel", ((d) => {
      It(d), this.pF({ x: 0, y: Math.sign(d.deltaY) });
    })), this.CF.background.addEventListener("pointerenter", ((d) => {
      c = this.engine.setMouseStyle(Gt.Vertical, c);
    })), this.CF.background.addEventListener("pointerleave", ((d) => {
      c = this.engine.restoreMouseStyle(c);
    })), this.CF.background.addEventListener("click", ((d) => {
      It(d);
      const f = this.yi.ul(d), p = xt({ x: f.engineX, y: f.engineY }, this.yi.ai, this.sF);
      this.pF({ x: 0, y: p.y > this.CF.scrollbar.Xl().y ? -1 : 1 });
    })), this.CF.background.addEventListener("wheel", ((d) => {
      It(d), this.pF({ x: 0, y: Math.sign(d.deltaY) });
    })), this.CF.button1.addEventListener("pointerenter", ((d) => {
      c = this.engine.setMouseStyle(Gt.Point, c);
    })), this.CF.button1.addEventListener("pointerleave", ((d) => {
      c = this.engine.restoreMouseStyle(c);
    })), this.CF.button1.addEventListener("click", ((d) => {
      It(d), this.pF({ x: 0, y: 1 });
    })), this.CF.button2.addEventListener("click", ((d) => {
      It(d), this.pF({ x: 0, y: -1 });
    })), this.CF.button2.addEventListener("pointerenter", ((d) => {
      c = this.engine.setMouseStyle(Gt.Point, c);
    })), this.CF.button2.addEventListener("pointerleave", ((d) => {
      c = this.engine.restoreMouseStyle(c);
    })), this.TF.scrollbar.addEventListener("pointerenter", ((d) => {
      c = this.engine.setMouseStyle(Gt.Horizontal, c);
    })), this.TF.scrollbar.addEventListener("pointerleave", ((d) => {
      c = this.engine.restoreMouseStyle(c);
    })), this.TF.scrollbar.addEventListener("pointerdown", ((d) => {
      It(d);
      let f = d;
      const p = (y) => {
        const m = y.clientX - f.clientX;
        f = y, this.FF({ x: m, y: 0 });
      }, g = (y) => {
        y.pointerId === d.pointerId && (H.removeEventListener("pointermove", p), H.removeEventListener("pointerup", g));
      };
      H.addEventListener("pointermove", p), H.addEventListener("pointerup", g);
    })), this.TF.scrollbar.addEventListener("wheel", ((d) => {
      It(d), this.pF({ x: Math.sign(d.deltaY), y: 0 });
    })), this.TF.background.addEventListener("pointerenter", ((d) => {
      c = this.engine.setMouseStyle(Gt.Horizontal, c);
    })), this.TF.background.addEventListener("pointerleave", ((d) => {
      c = this.engine.restoreMouseStyle(c);
    })), this.TF.background.addEventListener("click", ((d) => {
      It(d);
      const f = this.yi.ul(d), p = xt({ x: f.engineX, y: f.engineY }, this.yi.ai, this.sF);
      this.pF({ x: p.x < this.TF.scrollbar.Xl().x ? -1 : 1, y: 0 });
    })), this.TF.background.addEventListener("wheel", ((d) => {
      It(d), this.pF({ x: Math.sign(d.deltaY), y: 0 });
    })), this.TF.button1.addEventListener("pointerenter", ((d) => {
      c = this.engine.setMouseStyle(Gt.Point, c);
    })), this.TF.button1.addEventListener("pointerleave", ((d) => {
      c = this.engine.restoreMouseStyle(c);
    })), this.TF.button1.addEventListener("click", ((d) => {
      It(d), this.pF({ x: -1, y: 0 });
    })), this.TF.button2.addEventListener("click", ((d) => {
      It(d), this.pF({ x: 1, y: 0 });
    })), this.TF.button2.addEventListener("pointerenter", ((d) => {
      c = this.engine.setMouseStyle(Gt.Point, c);
    })), this.TF.button2.addEventListener("pointerleave", ((d) => {
      c = this.engine.restoreMouseStyle(c);
    })), this.fv(o, this.uiScale), this.addEventListener("resize", (() => {
      this.IT = !0, this.yi.Rs(), this.iF.K(this.xA.Ft()), this.sF.K(this.xA.Ft());
    })), this.IF = this.bs.CA([this.gF]);
  }
  getMinimumSize() {
    return { x: 200, y: 200 };
  }
  setAnimationsEnabled(t) {
    return this;
  }
  Gg() {
    return [];
  }
  dispose() {
    return super.dispose(), this.uF.G(), this.cF.G(), this.dF.G(), this.fF.G(), this.AF.G(), wa(this.iF), wa(this.sF), this.SF.ag(), this.yF.ag(), this.mF.ag(), this.bF.ag(), this.xF.ag(), this.MF.ag(), this._F.ag(), this.wF.ag(), this.kF.ag(), this;
  }
  W() {
    return super.W(), this.iF.W(), this.sF.W(), this;
  }
  X() {
    return super.X(), this.iF.X(), this.sF.X(), this;
  }
  setBackgroundEffect(t) {
    return this.IF.Es(t), this.yi.Rs(), this;
  }
  getBackgroundEffect() {
    return this.IF.Os();
  }
  setUserInteractions(t) {
    return this.cr = t === void 0 ? { scroll: !1 } : t, this;
  }
  getUserInteractions() {
    return Zi({ scroll: { wheel: { x: !1, y: !0 }, ctrl: { wheel: { x: !0, y: !1 } } } }, this.cr);
  }
  setGridBackgroundFillStyle(t) {
    return this.gF.sr(t), this.yi.Rs(), this;
  }
  getGridBackgroundFillStyle() {
    return this.gF.kh();
  }
  setCellContent(t, e, i, s, o) {
    if (typeof i == "number" && s !== void 0 && o !== void 0) {
      const n = i, a = s, l = o;
      let h = [];
      for (let d = t; d < t + n; d += 1) for (let f = e; f < e + a; f += 1) {
        const p = this.KT(d, f);
        p && h.push(p);
      }
      h = Cn(h);
      let u = { highlight: 0 };
      for (const d of h) {
        const f = this.kT.indexOf(d);
        f < 0 || (u = { ...u, highlight: d.highlight, textFont: d.textFont, textFillStyle: d.textFillStyle, contentAlignment: d.contentAlignment, borders: d.borders, padding: d.padding, backgroundFillStyle: d.backgroundFillStyle }, this.kT.splice(f, 1));
      }
      const c = { ...u, column: t, row: e, columnSpan: n, rowSpan: a, content: l };
      this.kT.push(c), this.BT = !0, typeof c.content == "string" || typeof c.content == "number" ? this.PT = !0 : this.LT = !0, this.yi.Rs();
    } else this.PF(t, e, i);
    return this;
  }
  setColumnContent(t, e) {
    const i = e.length;
    if (i === 0) return this;
    for (let s = 0; s < i; s += 1) {
      const o = e[s];
      this.PF(t, s, o);
    }
    return this;
  }
  setRowContent(t, e) {
    const i = e.length;
    if (i === 0) return this;
    for (let s = 0; s < i; s += 1) {
      const o = e[s];
      this.PF(s, t, o);
    }
    return this;
  }
  setTableContent(t) {
    const e = t.length;
    if (e === 0) return this;
    const i = t[0].length;
    if (i === 0) return this;
    for (let s = 0; s < i; s += 1) for (let o = 0; o < e; o += 1) {
      const n = t[o][s];
      this.PF(s, o, n);
    }
    return this;
  }
  setColumnWidth(t, e) {
    let i = this.CT.find(((s) => s.column === t));
    return i || (i = { column: t, min: void 0, max: void 0 }, this.CT.push(i)), typeof e == "object" ? (i.min = e.min, i.max = e.max) : e === void 0 ? this.CT.splice(this.CT.indexOf(i), 1) : (i.min = e, i.max = e), this.ET = !0, this.yi.Rs(), this;
  }
  setRowHeight(t, e) {
    let i = this.TT.find(((s) => s.row === t));
    return i || (i = { row: t, min: void 0, max: void 0 }, this.TT.push(i)), typeof e == "object" ? (i.min = e.min, i.max = e.max) : e === void 0 ? this.TT.splice(this.TT.indexOf(i), 1) : (i.min = e, i.max = e), this.ET = !0, this.yi.Rs(), this;
  }
  setColumnPaddings(t, e) {
    return typeof e == "number" && (e = vl(e, e, e, e)), this.LF(t, ((i) => this.BF(i, e))), this;
  }
  setRowPaddings(t, e) {
    return typeof e == "number" && (e = vl(e, e, e, e)), this.DF(t, ((i) => this.BF(i, e))), this;
  }
  setCellPadding(t, e, i) {
    return typeof i == "number" && (i = vl(i, i, i, i)), this.KT(t, e, ((s) => this.BF(s, i))), this;
  }
  setCellsPaddings(t) {
    return typeof t == "number" && (t = vl(t, t, t, t)), this.lF = { ...this.lF, ...t }, this.EF(((e) => this.BF(e, this.lF))), this;
  }
  setCellBorders(t, e, i) {
    return this.KT(t, e, ((s) => this.JT(s, i))), this;
  }
  setRowBorders(t, e) {
    return this.DF(t, ((i) => this.JT(i, e))), this;
  }
  setColumnBorders(t, e) {
    return this.LF(t, ((i) => this.JT(i, e))), this;
  }
  setCellsBorders(t) {
    return this.qT = t === void 0 ? ep : t, this.EF(((e) => this.JT(e, this.qT))), this;
  }
  setCellsBorderStrokeStyle(t) {
    return this.oF = typeof t == "function" ? t(this.oF) : t, this.UT = !0, this.yi.Rs(), this;
  }
  setColumnTextFillStyle(t, e) {
    return this.LF(t, ((i) => this.RF(i, e))), this;
  }
  setRowTextFillStyle(t, e) {
    return this.DF(t, ((i) => this.RF(i, e))), this;
  }
  setCellTextFillStyle(t, e, i) {
    return this.KT(t, e, ((s) => this.RF(s, i))), this;
  }
  setCellsTextFillStyle(t) {
    return this.hF = typeof t == "function" ? t(this.hF) : t, this.EF(((e) => this.RF(e, this.hF))), this;
  }
  setColumnTextFont(t, e) {
    return this.LF(t, ((i) => this.OF(i, e))), this;
  }
  setRowTextFont(t, e) {
    return this.DF(t, ((i) => this.OF(i, e))), this;
  }
  setCellTextFont(t, e, i) {
    return this.KT(t, e, ((s) => this.OF(s, i))), this;
  }
  setCellsTextFont(t) {
    return this.rF = typeof t == "function" ? t(this.rF) : t, this.EF(((e) => this.OF(e, this.rF))), this;
  }
  setColumnContentAlignment(t, e) {
    return this.LF(t, ((i) => this.zF(i, e))), this;
  }
  setRowContentAlignment(t, e) {
    return this.DF(t, ((i) => this.zF(i, e))), this;
  }
  setCellContentAlignment(t, e, i) {
    return this.KT(t, e, ((s) => this.zF(s, i))), this;
  }
  setCellsContentAlignment(t) {
    return this.aF = t, this.EF(((e) => this.zF(e, this.aF))), this;
  }
  setCellBackgroundFillStyle(t, e, i) {
    return this.KT(t, e, ((s) => this.VF(s, i))), this;
  }
  setColumnBackgroundFillStyle(t, e) {
    return this.LF(t, ((i) => this.VF(i, e))), this;
  }
  setRowBackgroundFillStyle(t, e) {
    return this.DF(t, ((i) => this.VF(i, e))), this;
  }
  setCellsBackgroundFillStyle(t) {
    return this.nF = typeof t == "function" ? t(this.nF) : t, this.EF(((e) => this.VF(e, this.nF))), this;
  }
  setCellHighlight(t, e, i) {
    return this.KT(t, e, ((s) => {
      s.highlight = dn(i);
    })), this.$T = !0, this.yi.Rs(), this;
  }
  setColumnHighlight(t, e) {
    const i = dn(e);
    return this.LF(t, ((s) => {
      s.highlight = i;
    })), this.$T = !0, this.yi.Rs(), this;
  }
  setRowHighlight(t, e) {
    const i = dn(e);
    return this.DF(t, ((s) => {
      s.highlight = i;
    })), this.$T = !0, this.yi.Rs(), this;
  }
  removeCell(t, e) {
    return this.KT(t, e, ((i) => this.kT.splice(this.kT.indexOf(i), 1))), this.DT = !0, this.yi.Rs(), this;
  }
  removeRow(t) {
    return this.DF(t, ((e) => this.kT.splice(this.kT.indexOf(e), 1))), this.kT.filter(((e) => e.row > t)).forEach(((e) => {
      e.row -= 1;
    })), this.DT = !0, this.yi.Rs(), this;
  }
  removeColumn(t) {
    return this.LF(t, ((e) => this.kT.splice(this.kT.indexOf(e), 1))), this.kT.filter(((e) => e.column > t)).forEach(((e) => {
      e.column -= 1;
    })), this.DT = !0, this.yi.Rs(), this;
  }
  removeCells() {
    return this.kT.splice(0), this.DT = !0, this.yi.Rs(), this;
  }
  getColumnMax() {
    return this.kT.length === 0 ? 0 : this.kT.reduce(((t, e) => Math.max(t, e.column + e.columnSpan - 1)), 0);
  }
  getRowMax() {
    return this.kT.length === 0 ? 0 : this.kT.reduce(((t, e) => Math.max(t, e.row + e.rowSpan - 1)), 0);
  }
  rr(t) {
    var e;
    super.rr(t), ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn), super.dv();
    const i = Math.round(this.oF.Yi()), s = i / 2;
    let o = this.PT || this.LT || this.BT || this.DT || this.ET || this.RT || this.NT || this.GT || this.UT || this.YT;
    if (o) {
      this.kT.forEach(((g) => {
        this.WT.add(g.column);
      })), this.kT.forEach(((g) => {
        this.HT.add(g.row);
      }));
      const a = this.SF.rg(), l = this.NF(s, a);
      a.finishPlot();
      const h = this.GF(this.WT.size, l), u = this.$F(this.HT.size, l), c = h.reduce(zl, 0) + i, d = u.reduce(zl, 0) + i, f = new Array(h.length + 1).fill(0).map(((g, y) => h.reduce(((m, A, v) => m + (v < y ? A : 0)), 0))), p = new Array(u.length + 1).fill(0).map(((g, y) => u.reduce(((m, A, v) => m + (v < y ? A : 0)), 0)));
      if (this.UF) {
        const g = this.UF.columnWidths.every(((m, A) => m === h[A])), y = this.UF.rowHeights.every(((m, A) => m === u[A]));
        g && y && (o = !1);
      }
      this.UF = { columnWidths: h, rowHeights: u, dataGridWidth: c, dataGridHeight: d, columnWidthsCumulative: f, rowHeightsCumulative: p, cellsContentSizes: l };
    }
    const n = o || this.LT || this.BT || this.DT || this.OT || this.zT || this.VT || this.GT || this.$T || this.UT || this.IT || this.YT;
    if ((n || this.jT) && this.UF) {
      const a = this.xA.getInnerIntervalPixels(), l = ui.xv(this.Wr, this.gv), h = [this.Hn.left + s, this.Hn.right + s], u = [this.Hn.bottom + s, this.Hn.top + l + s], c = { x: a.x - h[0] - h[1], y: a.y - u[0] - u[1] }, d = [this.Hn.left, this.Hn.right], f = [this.Hn.bottom, this.Hn.top + l], p = { x: Math.round(a.x - d[0] - d[1]), y: Math.round(a.y - f[0] - f[1]) }, g = { x: Math.ceil(s), y: Math.floor(p.y - s) };
      this.sF.qt(h).ti(u).ii(0, c.x).si(0, c.y);
      const y = (e = this.xi.dataGridScrollBarThickness) !== null && e !== void 0 ? e : 20, m = { x: Math.min(c.x, this.UF.dataGridWidth + y) - y, y: Math.min(c.y, this.UF.dataGridHeight + y) - y };
      this.tF.x === 0 && this.tF.y === 0 || (this.eF.y += this.UF.dataGridHeight * this.tF.y / m.y, this.eF.x += this.UF.dataGridWidth * this.tF.x / m.x, this.tF.x = 0, this.tF.y = 0), this.eF.y = Jt(this.eF.y, c.y - this.UF.dataGridHeight - y, 0), this.eF.x = Jt(this.eF.x, 0, this.UF.dataGridWidth - c.x + y);
      const A = this.eF;
      this.iF.qt(d).ti(f).ii(A.x, p.x + A.x).si(A.y, p.y + A.y);
      const v = { x: this.iF.x.wt(), y: this.iF.y.wt() + y, width: this.iF.x.Ct() + i - y, height: this.iF.y.Ct() + i - y };
      this.dF.Qm(v), this.cF.Qm(v);
      const b = this.UF, w = [{ x: this.iF.x.getInnerStart(), y: this.iF.y.getInnerStart() }, { x: this.iF.x.getInnerEnd(), y: this.iF.y.getInnerStart() }, { x: this.iF.x.getInnerEnd(), y: this.iF.y.getInnerEnd() }, { x: this.iF.x.getInnerStart(), y: this.iF.y.getInnerEnd() }];
      b.cellsContentSizes.forEach(((x) => {
        var M;
        const C = { x: g.x + b.columnWidthsCumulative[x.cell.column], y: g.y - b.rowHeightsCumulative[x.cell.row + x.cell.rowSpan] }, S = { x: C.x + b.columnWidths[x.cell.column], y: C.y + b.rowHeights[x.cell.row] }, E = yd([C, { x: S.x, y: C.y }, S, { x: C.x, y: S.y }], w);
        (M = x.text) === null || M === void 0 || M.setVisible(E);
      })), n && this.jF(g, this.UF, i);
      const k = c.y - y < this.UF.dataGridHeight;
      this.CF.background.setVisible(k).hr({ x: m.x, y }).K({ x: y, y: m.y }), this.CF.scrollbar.setVisible(k).hr({ x: m.x, y: y + m.y - y + -(m.y - 2 * y) * (-this.eF.y / this.UF.dataGridHeight) }).K({ x: y, y: -(m.y - 2 * y) * (m.y / this.UF.dataGridHeight) }), this.CF.button1.setVisible(k).hr({ x: m.x, y }).K({ x: y, y }), this.CF.buttonIcon1.setVisible(k).df(0.5 * y).nf(0).qd(new cr().appendSample({ x: m.x + y / 2, y: 1.5 * y }), { x: "x", y: "y" }), this.CF.button2.setVisible(k).hr({ x: m.x, y: m.y }).K({ x: y, y }), this.CF.buttonIcon2.setVisible(k).df(0.5 * y).nf(180).qd(new cr().appendSample({ x: m.x + y / 2, y: m.y + y / 2 }), { x: "x", y: "y" });
      const R = c.x - y < this.UF.dataGridWidth, L = Math.max(c.y - this.UF.dataGridHeight - y, 0);
      this.TF.background.setVisible(R).hr({ x: 0, y: L }).K({ x: m.x, y }), this.TF.scrollbar.setVisible(R).hr({ x: y + (m.x - 2 * y) * (this.eF.x / this.UF.dataGridWidth), y: L }).K({ x: (m.x - 2 * y) * (m.x / this.UF.dataGridWidth), y }), this.TF.button1.setVisible(R).hr({ x: 0, y: L }).K({ x: y, y }), this.TF.buttonIcon1.setVisible(R).df(0.5 * y).nf(90).qd(new cr().appendSample({ x: y / 2, y: L + y / 2 }), { x: "x", y: "y" }), this.TF.button2.setVisible(R).hr({ x: m.x - y, y: L }).K({ x: y, y }), this.TF.buttonIcon2.setVisible(R).df(0.5 * y).nf(270).qd(new cr().appendSample({ x: m.x - y / 2, y: L + y / 2 }), { x: "x", y: "y" }), this.gF.yu([g, { x: g.x + m.x + (k ? y : 0), y: g.y }, { x: g.x + m.x + (k ? y : 0), y: g.y - m.y }, { x: g.x + m.x, y: g.y - m.y }, { x: g.x + m.x, y: g.y - m.y - (R ? y : 0) }, { x: g.x, y: g.y - m.y - (R ? y : 0) }]);
    }
    this.IT = !1, this.PT = !1, this.LT = !1, this.BT = !1, this.DT = !1, this.ET = !1, this.RT = !1, this.OT = !1, this.zT = !1, this.VT = !1, this.NT = !1, this.GT = !1, this.$T = !1, this.UT = !1, this.jT = !1, this.YT = !1;
  }
  NF(t, e) {
    const i = [], s = { left: Math.ceil(t), right: Math.ceil(t), top: Math.ceil(t), bottom: Math.ceil(t) };
    for (const o of this.kT) {
      const { content: n } = o, a = { ...this.lF, ...o.padding };
      let l, h, u, c = { x: 0, y: 0 };
      if (typeof n == "string" || typeof n == "number") {
        const d = String(n);
        l = e.add(), c = l.rn(d).Ih(o.textFont || this.rF).Uh().Bc();
      }
      if (eE(n) && (h = n, c = { x: 200, y: 50 }), Pn(n)) {
        const d = this.yi.YF(n);
        d.HF() ? (u = n, c = u.Ft()) : d.WF((() => {
          this.YT = !0, this.yi.Rs();
        }));
      }
      if (l || h || u) {
        a.top = Math.round(a.top), a.left = Math.round(a.left), a.right = Math.round(a.right), a.bottom = Math.round(a.bottom);
        const d = { x: Math.round(c.x + a.left + a.right + s.left + s.right), y: Math.round(c.y + a.top + a.bottom + s.top + s.bottom) };
        i.push({ cell: o, contentSize: d, text: l, sparkChart: h, icon: u, cellPadding: a, cellMargin: s });
      }
    }
    return i;
  }
  jF(t, e, i) {
    const { cellsContentSizes: s, columnWidths: o, columnWidthsCumulative: n, rowHeights: a, rowHeightsCumulative: l } = e;
    this.vF.gr(this.oF), this.FT.clear();
    const h = { cellBackground: this.yF.rg(), cellIconRect: this.mF.rg(), lineSet: this.bF.rg(), line: this.xF.rg(), pointSet: this.MF.rg(), rect: this._F.rg(), junction: this.wF.rg(), arc: this.kF.rg() }, u = [];
    for (const c of s) {
      const { cell: d, text: f, sparkChart: p, icon: g, cellPadding: y, cellMargin: m } = c, A = { column: d.column, row: d.row }, v = { x: t.x + n[d.column], y: t.y - l[d.row + d.rowSpan] }, b = { x: v.x + m.left, y: v.y + m.bottom }, w = { x: b.x + y.left, y: b.y + y.bottom }, k = { x: new Array(d.columnSpan).fill(0).reduce(((C, S, E) => C + o[d.column + E]), 0), y: new Array(d.rowSpan).fill(0).reduce(((C, S, E) => C + a[d.row + E]), 0) }, R = { x: k.x - m.left - m.right, y: k.y - m.top - m.bottom }, L = { x: R.x - y.left - y.right, y: R.y - y.top - y.bottom };
      if (f) {
        const C = tp(w, L, d.contentAlignment || this.aF);
        f.hr(C[0]).ru({ x: C[1], y: C[2] }).sr(this.XF(d.textFillStyle || this.hF, d.content, this.hF)).Ii(d.highlight).en(this.xi.dataGridTextShadow);
      }
      const x = this.XF(d.backgroundFillStyle || this.nF, d.content);
      if (x !== Lt) {
        const C = h.cellBackground.add();
        C.hr(v).K(k).sr(x).ir(Et).Ii(d.highlight), this.FT.set(C, A);
      }
      const M = d.borders || this.qT;
      if (M && yE(v, k, M, i, u), p) {
        const C = w, S = L;
        iE(p, h, this.iF, C, S, this.xi, this.Qg, d.highlight);
      }
      if (g) {
        const C = g.Ft(), S = tp(w, L, d.contentAlignment || this.aF);
        h.cellIconRect.add().hr({ x: S[0].x + C.x * (-0.5 - S[1] / 2), y: S[0].y + C.y * (-0.5 - S[2] / 2) }).K(C).sr(new wr({ source: g.qs, fitMode: Li.Stretch })).ir(Et).Ii(d.highlight);
      }
    }
    this.vF.Vi();
    for (const c of u) this.vF.Qo().UA(c[0], c[1]);
    h.cellBackground.finishPlot(), h.cellIconRect.finishPlot(), h.lineSet.finishPlot(), h.line.finishPlot(), h.pointSet.finishPlot(), h.rect.finishPlot(), h.junction.finishPlot(), h.arc.finishPlot();
  }
  GF(t, e) {
    const i = new Array(t).fill(0);
    for (const s of this.WT.values()) {
      const o = e.filter(((l) => s >= l.cell.column && s + 1 <= l.cell.column + l.cell.columnSpan)).reduce(((l, h) => {
        const u = h.contentSize.x / h.cell.columnSpan;
        return Math.max(l, u);
      }), 0), n = this.CT.find(((l) => l.column === s)), a = n ? Jt(o, n.min !== void 0 ? n.min : Pt, n.max !== void 0 ? n.max : wt) : o;
      i[s] = a;
    }
    return i;
  }
  $F(t, e) {
    const i = new Array(t).fill(0);
    for (const s of this.HT.values()) {
      const o = e.filter(((l) => s >= l.cell.row && s + 1 <= l.cell.row + l.cell.rowSpan)).reduce(((l, h) => {
        const u = h.contentSize.y / h.cell.rowSpan;
        return Math.max(l, u);
      }), 0), n = this.TT.find(((l) => l.row === s)), a = n ? Jt(o, n.min !== void 0 ? n.min : Pt, n.max !== void 0 ? n.max : wt) : o;
      i[s] = a;
    }
    return i;
  }
  XF(t, e, i) {
    if (Ve(t)) {
      try {
        const s = Number(e);
        return new ot({ color: t.getPalette().getColors(s, void 0) });
      } catch {
      }
      return i || Lt;
    }
    return t;
  }
  RF(t, e) {
    t.textFillStyle = typeof e == "function" ? e(t.textFillStyle || this.hF) : e, this.VT = !0, this.yi.Rs();
  }
  OF(t, e) {
    t.textFont = typeof e == "function" ? e(t.textFont || this.rF) : e, this.NT = !0, this.yi.Rs();
  }
  VF(t, e) {
    t.backgroundFillStyle = typeof e == "function" ? e(t.backgroundFillStyle || this.nF) : e, this.zT = !0, this.yi.Rs();
  }
  zF(t, e) {
    t.contentAlignment = e, this.OT = !0, this.yi.Rs();
  }
  BF(t, e) {
    t.padding = { ...t.padding, ...e }, this.RT = !0, this.yi.Rs();
  }
  PF(t, e, i) {
    let s = this.KT(t, e);
    s ? s.content = i : (s = { column: t, row: e, columnSpan: 1, rowSpan: 1, content: i, highlight: 0 }, this.kT.push(s), this.BT = !0), typeof s.content == "string" || typeof s.content == "number" ? this.PT = !0 : this.LT = !0, this.yi.Rs();
  }
  EF(t) {
    this.kT.forEach(((e) => t(e)));
  }
  KT(t, e, i) {
    const s = this.kT.find(((o) => t >= o.column && t + 1 <= o.column + o.columnSpan && e >= o.row && e + 1 <= o.row + o.rowSpan));
    return s && i && i(s), s;
  }
  LF(t, e) {
    const i = this.kT.filter(((s) => t >= s.column && t + 1 <= s.column + s.columnSpan));
    for (const s of i) s && e(s);
  }
  DF(t, e) {
    const i = this.kT.filter(((s) => t >= s.row && t + 1 <= s.row + s.rowSpan));
    for (const s of i) s && e(s);
  }
  pF(t) {
    var e, i, s, o, n, a;
    if (this.UF) {
      if (t.y !== 0) {
        const l = (i = (e = this.UF.rowHeightsCumulative.map(((u, c) => ({ value: u, index: c }))).reverse().find(((u) => -this.eF.y + (t.y > 0 ? 1 : 0) >= u.value))) === null || e === void 0 ? void 0 : e.index) !== null && i !== void 0 ? i : 0, h = (s = this.UF.rowHeightsCumulative[l + t.y]) !== null && s !== void 0 ? s : 0;
        this.eF.y = -h, this.jT = !0, this.yi.Rs();
      }
      if (t.x !== 0) {
        const l = (n = (o = this.UF.columnWidthsCumulative.map(((u, c) => ({ value: u, index: c }))).reverse().find(((u) => this.eF.x + (t.x > 0 ? 1 : 0) >= u.value))) === null || o === void 0 ? void 0 : o.index) !== null && n !== void 0 ? n : 0, h = (a = this.UF.columnWidthsCumulative[l + t.x]) !== null && a !== void 0 ? a : 0;
        this.eF.x = h, this.jT = !0, this.yi.Rs();
      }
    }
  }
  FF(t) {
    this.UF && (this.tF.x += t.x, this.tF.y += t.y, this.jT = !0, this.yi.Rs());
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
var Qg;
(function(r) {
  r.Center = "center", r.RightCenter = "right-center", r.LeftCenter = "left-center", r.RightTop = "right-top", r.LeftTop = "left-top", r.RightBottom = "right-bottom", r.LeftBottom = "left-bottom", r.CenterTop = "center-top", r.CenterBottom = "center-bottom";
})(Qg || (Qg = {}));
const yE = (r, t, e, i, s) => {
  const o = { x: r.x, y: r.y }, n = { x: r.x, y: r.y + t.y }, a = { x: r.x + t.x, y: r.y }, l = { x: r.x + t.x, y: r.y + t.y };
  e.top && s.push([n, l]), e.bottom && s.push([o, a]), e.left && s.push([o, n]), e.right && s.push([a, l]);
}, tp = (r, t, e) => {
  const i = r.x, s = r.x + t.x, o = r.x + t.x / 2, n = r.y + t.y, a = r.y, l = r.y + t.y / 2;
  switch (e) {
    case "left-center":
      return [j(i, l), -1, 0];
    case "right-center":
      return [j(s, l), 1, 0];
    case "center":
      return [j(o, l), 0, 0];
    case "left-bottom":
      return [j(i, a), -1, -1];
    case "right-bottom":
      return [j(s, a), 1, -1];
    case "center-bottom":
      return [j(o, a), 0, -1];
    case "left-top":
      return [j(i, n), -1, 1];
    case "right-top":
      return [j(s, n), 1, 1];
    case "center-top":
      return [j(o, n), 0, 1];
  }
  return Oa(0, `Unidentified DataGrid cell content alignment option: ${e}`);
}, ep = { top: !1, bottom: !1, left: !1, right: !1 };
class mE extends eo {
  constructor(t, e, i, s, o, n) {
    super(t, { yn() {
    }, vn() {
    }, Sn() {
    } }, s, e, i, { numeric: e.xAxisNumericTicks.setFallBackToExtremeTicksAutomatically(!1), datetime: e.xAxisDateTimeTicks, time: e.xAxisTimeTicks }, { type: "linear" }), this.D = new Nt(), this.chart = t, this.bs = n, this.Js = o, this.qr = o.In(t.ZF).Ih(this.xi.barChartCategoryAxisTitleFont || this.xi.xAxisTitleFont).sr(this.xi.barChartCategoryAxisTitleFillStyle || this.xi.xAxisTitleFillStyle), this.setTitleRotation(this.chart.Qs.getWidth({ x: 0, y: -90 })), this.Bh = this.bs.CA([this.qr]).Es(e.effectsText), this.JF = o.vr(t.ZF).gr(e.barChartCategoryAxisStrokeStyle || e.xAxisStrokeStyle);
  }
  setThickness(t) {
    return typeof t == "number" ? (this.LA = t, this.BA = t) : typeof t == "object" && (this.LA = t.min, this.BA = t.max), this.chart.yi.Rs(), this;
  }
  getThickness() {
    return { min: this.LA, max: this.BA };
  }
  setStrokeStyle(t) {
    return this.JF.gr(t), this.chart.yi.Rs(), this;
  }
  getStrokeStyle() {
    return this.JF.po();
  }
  rr(t) {
    const e = this.getInterval(), i = this.chart.valueAxis.getInterval();
    this.JF.pr(this.chart.Qs.toPoint(e.start, i.start)).yr(this.chart.Qs.toPoint(e.end, i.start)).setVisible(this.di), this.qr.hr(this.chart.Qs.toPoint(0.5 * (e.start + e.end), this.chart.valueAxis.ai.Qt(i.start, -t.EA))).ru(this.chart.Qs.toPoint(0, 1)).setVisible(this.di), t.ticksInfo.forEach(((s, o) => {
      o.Gh.hr(s.labelPosition).ru(s.labelAlignment).Ph(s.labelRotation).Ql(s.labelOffset.x, s.labelOffset.y);
    }));
  }
  Wh(t) {
    return {};
  }
  Qh(t, e, i, s) {
    return { keyValue: t, tickLevel: e, labelText: i, labelAlignment: { x: 0, y: 0 }, labelPosition: { x: 0, y: 0 }, labelOffset: { x: 0, y: 0 }, labelRotation: 0 };
  }
  hn(t, e) {
    return new Wa(e, t, this.Js, this.chart.ZF);
  }
  tn(t, e, i) {
    const s = t.EA, o = this.chart.Qs.getHeight(this.qr.Uh().Bc());
    return { RA: o, Of: Jt(this.JF.po().Yi() / 2 + s + o, this.LA !== void 0 ? this.LA : 0, this.BA !== void 0 ? this.BA : wt), ticksInfo: e, updatedTicks: i };
  }
  ih() {
    return this.chart.uiScale;
  }
  xn(t, e) {
    return e;
  }
  wn(t, e, i) {
    return { start: t, end: e };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
}
class xE extends eo {
  constructor(t, e, i, s, o, n, a) {
    super(t, { yn: () => {
      var l;
      if (t.QF) {
        if (t.KF === "positive" || t.KF === "bipolar") {
          if (((l = t.qF) === null || l === void 0 ? void 0 : l.position) === "after-bar") {
            const h = this.ai.Ct();
            return this.ai.Qt(t.QF.max, Math.min(this.chart.Qs.getHeight(this.chart.tI()) + t.qF.labelMargin, 0.3 * h));
          }
          return t.QF.max;
        }
        return t.iI ? Jt(-1, -1e-6, t.QF.max) : 0;
      }
    }, vn: () => {
      var l;
      if (t.QF) {
        if (t.KF === "negative" || t.KF === "bipolar") {
          if (((l = t.qF) === null || l === void 0 ? void 0 : l.position) === "after-bar") {
            const h = this.ai.Ct();
            return this.ai.Qt(t.QF.min, -Math.min(this.chart.Qs.getHeight(this.chart.tI()) + t.qF.labelMargin, 0.3 * h));
          }
          return t.QF.min;
        }
        return t.iI ? Jt(1, 1e-6, t.QF.min) : 0;
      }
    }, Sn: () => {
    } }, s, e, i, { numeric: e.barChartValueAxisTicks || e.yAxisNumericTicks, datetime: e.yAxisDateTimeTicks, time: e.yAxisTimeTicks }, a), this.D = new Nt(), this.chart = t, this.bs = n, this.Js = o, this.qr = o.In(t.ZF).Ih(this.xi.barChartValueAxisTitleFont || this.xi.yAxisTitleFont).sr(this.xi.barChartValueAxisTitleFillStyle || this.xi.yAxisTitleFillStyle), this.setTitleRotation(this.chart.Qs.getHeight({ x: 0, y: -90 })), this.Bh = this.bs.CA([this.qr]).Es(e.effectsText), this.JF = o.vr(t.ZF).gr(e.barChartValueAxisStrokeStyle || this.xi.yAxisStrokeStyle);
  }
  setThickness(t) {
    return typeof t == "number" ? (this.LA = t, this.BA = t) : typeof t == "object" && (this.LA = t.min, this.BA = t.max), this.chart.yi.Rs(), this;
  }
  getThickness() {
    return { min: this.LA, max: this.BA };
  }
  setStrokeStyle(t) {
    return this.JF.gr(t), this.chart.yi.Rs(), this;
  }
  getStrokeStyle() {
    return this.JF.po();
  }
  setTickStrategy(t, e) {
    return super.ph(t, e);
  }
  rr(t) {
    const e = this.getInterval();
    this.JF.pr(this.chart.Qs.toPoint(-0.5, this.mh)).yr(this.chart.Qs.toPoint(-0.5, this.Sh)).setVisible(this.di);
    const i = this.Ah.type === "logarithmic" ? Math.sqrt(e.start * e.end) : 0.5 * (e.start + e.end), s = this.chart.Qs.toPoint(this.chart.categoryAxis.ai.Qt(-0.5, t.EA * this.chart.Qs.sI), i), o = this.chart.Qs.toPoint(this.chart.Qs.eI, 0);
    this.qr.hr(s).ru(o).setVisible(this.di), t.ticksInfo.forEach(((n, a) => {
      a.Gh.hr(n.labelPosition).ru(n.labelAlignment).Ph(n.labelRotation).Ql(n.labelOffset.x, n.labelOffset.y);
      const l = a.Pn.Lr;
      l.tickStyle !== Et && l.tickLength !== 0 && t.plotLines.add({ positions: [n.positionTicklineStart, n.positionTicklineEnd] }, { lineStyle: l.tickStyle }), l.gridStrokeStyle !== Et && l.gridStrokeLength > 0 && t.plotLines.add({ positions: [n.positionTicklineStart, n.positionGridlineEnd] }, { lineStyle: l.gridStrokeStyle });
    }));
  }
  Wh(t) {
    return {};
  }
  Qh(t, e, i, s, o) {
    const n = e.Lr, a = this.chart.Qs.toPoint(-0.5, t), l = this.chart.ZF.Qt(a, this.chart.Qs.toPoint(n.getTickLength() * this.chart.Qs.sI, 0)), h = this.chart.ZF.Qt(a, this.chart.Qs.toPoint(n.gridStrokeLength * s.oppositeAxisSize * -this.chart.Qs.sI, 0));
    return { keyValue: t, tickLevel: e, labelText: i, labelPosition: this.chart.ZF.Qt(l, this.chart.Qs.toPoint(n.getTickPadding() * this.chart.Qs.sI, 0)), labelAlignment: this.chart.Qs.toPoint(this.chart.Qs.eI, n.getLabelAlignment()), labelOffset: { x: 0, y: 0 }, labelRotation: e.Lr.labelRotation, positionTicklineStart: a, positionTicklineEnd: l, positionGridlineEnd: h };
  }
  hn(t, e) {
    return new Wa(e, t, this.Js, this.chart.ZF);
  }
  tn(t, e, i) {
    let s = 0;
    for (const a of this.Er.values()) for (const l of a.values()) {
      const h = l.Pn.Lr, u = this.chart.Qs.getWidth(l.Gh.Uh().Bc()), c = h.getTickLength() + h.getTickPadding() + u;
      s = Math.max(s, c);
    }
    const o = s + this.JF.po().Yi() / 2, n = this.chart.Qs.getWidth(this.qr.Uh().Bc());
    return { EA: o, RA: n, Of: Jt(o + n, this.LA !== void 0 ? this.LA : 0, this.BA !== void 0 ? this.BA : wt), ticksInfo: e, updatedTicks: i };
  }
  ih() {
    return this.chart.ZF;
  }
  xn(t, e) {
    return this.Ah.type === "linear" ? Sa(t, e, this.ai) : Eu(t, e, this.ai);
  }
  wn(t, e, i) {
    return { start: t, end: e };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
}
class vE extends gh {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s), this.Si = zm(), this.M = 0, this.rI = !1, this.D = new Nt(), this.chart = t, this.chart = t, this.category = o, this.subCategory = n, this.Vs = o, this.Ke = ue(i.barChartBarFillStyle || i.rectangleSeriesFillStyle, a), this.qe = ue(i.barChartBarStrokeStyle || i.rectangleSeriesStrokeStyle, a), this.addEventListener("visiblechange", (() => this.chart.hI())), this.addEventListener("dispose", (() => {
      this.chart.hI(), this.chart.nI.delete(this.category), this.chart.oI.delete(this);
    }));
  }
  Qi(t, e, i) {
    const s = this.chart.yi.ul(e);
    return { cursorPosition: { pointMarker: { x: s.engineX, y: s.engineY }, pointMarkerScale: this.chart.yi.ai, resultTable: { x: s.engineX, y: s.engineY }, resultTableScale: this.chart.yi.ai }, category: this.category, subCategory: this.subCategory, bar: this, value: this.getValue() };
  }
  setValue(t) {
    return this.rI = !0, this.M = t, this.chart.hI(), this.chart.yi.Rs(), this.chart.nI.delete(this.category), this.chart.oI.delete(this), this;
  }
  getValue() {
    return this.M;
  }
  get value() {
    return this.M;
  }
  setFillStyle(t) {
    return this.Ke = typeof t == "function" ? t(this.Ke) : t, this.chart.hI(), this;
  }
  getFillStyle() {
    return this.Ke;
  }
  setStrokeStyle(t) {
    return this.qe = typeof t == "function" ? t(this.qe) : t, this.chart.hI(), this;
  }
  getStrokeStyle() {
    return this.qe;
  }
  Uv() {
    return this.kv;
  }
  setEffect(t) {
    return this.chart.setBarsEffect(t), this;
  }
  nr() {
    return { fill: this.Ke, lutValue: this.value };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const SE = (r) => !!(r && typeof r == "object" && "iCategory" in r && typeof r.iCategory == "number" && "value" in r && typeof r.value == "number");
class Gx extends $a {
  constructor(t, e, i, s, o, n, a) {
    var l, h;
    let u;
    super(t, e, i, e.Av("barChart bg", 0), s, e.yi.xi.barChartBackgroundFillStyle || e.yi.xi.chartXYBackgroundFillStyle, e.yi.xi.barChartBackgroundStrokeStyle || e.yi.xi.chartXYBackgroundStrokeStyle, e.yi.xi.barChartTitleFont || e.yi.xi.chartXYTitleFont, e.yi.xi.barChartTitleFillStyle || e.yi.xi.chartXYTitleFillStyle, e.yi.xi.barChartTitleShadow || e.yi.xi.chartXYTitleShadow, n, (l = a?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.coordsBars = "barChart", this.aI = AE.Descending, this.lI = this.xi.barChartCategoryLabels, this.qF = this.xi.barChartValueLabelsAfterBars, this.uI = !0, this.Tx = Vo(), this.nI = /* @__PURE__ */ new Map(), this.oI = /* @__PURE__ */ new Map(), this.KF = "positive", this.cI = "columns", this.dI = !0, this.fI = /* @__PURE__ */ new Map(), this.AI = { speed: 1 }, this.jk = { speed: 1 }, this.gI = 0.08, this.vI = [], this.yI = /* @__PURE__ */ new Map(), this.pI = !1, this.mI = { left: 2, right: 2, top: 2, bottom: 2 }, this.SI = [], this.ka = (p) => {
      this.ZF.K(p.engineWidth, p.engineHeight), this.pI = !0;
    }, this.D = new Nt(), this.yi.Oa(Ot.To), this.bI = this.xi.barChartCornerRadius, this.Qs = a?.type === "horizontal" ? EE : bE, this.Wr.rn("Bar Chart"), this.xI = e.nS("barChart plotting 1", 0), this.MI = e.nS("barChart plotting 2", 1), this.iI = ((h = a?.valueAxis) === null || h === void 0 ? void 0 : h.type) === "logarithmic", this.iI ? this.Qs._I === "horizontal" ? (u = i.d1({ scale1DConstructor: ts, dimension: "y" }), this.ZF = new Ti().Kt(i.d1({ scale1DConstructor: Jn, dimension: "x" }), u)) : (u = i.d1({ scale1DConstructor: ts, dimension: "x" }), this.ZF = new Ti().Kt(u, i.d1({ scale1DConstructor: Jn, dimension: "y" }))) : (this.ZF = i.d2({ scaleXYConstructor: we }), u = this.Qs.getWidth(this.ZF)), this.wI = this.bs.CA(), this.Ix = new Fr((() => this.Tx.Ji(this.xI.Od(this.ZF).vl(0))), ((p, g, y) => (p.sr(y.fillStyle).ir(y.strokeStyle), g.map(((m) => {
      const A = m.existingMember || p.Qo();
      return A.Gd(m.x1, m.y1, m.x2, m.y2).Nd(m.rounding), this.Tx.Ki(A, m.bar), m.bar.Ps([A]), A;
    })))), (() => {
      this.Tx.Vi();
    }), ((p) => {
      this.wI.Fs(p);
    })), this.Yy = this.Zg.er(this.ZF).sr(this.xi.barChartSeriesBackgroundFillStyle || Lt).ir(Et), this.Hy = this.Zg.er(this.ZF).sr(Lt).ir(this.xi.barChartSeriesBackgroundStrokeStyle || Et).setPointerEvents(!1), super.jy(this.Yy, this.Hy), this.categoryAxis = new mE(this, this.xi, a?.animationsEnabled !== !1, u, this.MI, this.bs), this.categoryAxis.setInterval(this.Qs.getWidth({ x: { start: -0.5, end: 0.5 }, y: { start: 0.5, end: -0.5 } }));
    const c = xd(a?.valueAxis);
    this.valueAxis = new xE(this, this.xi, a?.animationsEnabled !== !1, this.Qs.getHeight(this.ZF), this.MI, this.bs, c.type), this.kI = new Xi((() => this.MI.In(this.ZF).Fn(Me).Tn(Me).vl(1))), this.CI = new Fr((() => this.Zg.GA(this.ZF).setPointerEvents(!1)), ((p, g, y) => (p.gr(y.lineStyle), g.map((({ positions: m, existingMember: A }) => (A || p.Qo()).UA(m[0], m[1]))))));
    const d = e.fS(), f = $e(a ? a.cursorBuilder : void 0, Dg);
    this.AS = Xr(this, d, f.zm(d, this.uiScale, this.uiScale, ie, this.xi), this, "show-pointed", ME, (() => 0)), this.addEventListener("resize", this.ka), this.fv(o, this.ZF), this.setAnimationsEnabled(a?.animationsEnabled !== !1), a?.legend !== void 0 && this.legend.setOptions(a.legend);
  }
  getSeries() {
    return this.Ny.slice();
  }
  setCornerRadius(t) {
    return this.bI = t, this.uI = !0, this.yi.Rs(), this;
  }
  getCornerRadius() {
    return this.bI;
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  addCursor(t = Dg) {
    const e = this.tv(), i = t.zm(e, this.uiScale, this.uiScale, this.Jg(e), this.xi);
    return this.cv(i), i;
  }
  setBarsMargin(t) {
    return this.gI = Jt(t, 0, 0.49), this.uI = !0, this.yi.Rs(), this;
  }
  getBarsMargin() {
    return this.gI;
  }
  setBarsEffect(t) {
    return this.wI.Es(t), this.yi.Rs(), this;
  }
  getBarsEffect() {
    return this.wI.Os();
  }
  setData(t) {
    let e;
    if (Array.isArray(t)) e = [], t.forEach(((i, s) => {
      typeof i == "string" ? e.push({ category: i }) : typeof i == "number" ? e.push({ category: `Category ${s + 1}`, value: i }) : typeof i == "object" && e.push(i);
    }));
    else {
      e = [];
      const i = Object.keys(t);
      for (const s of i) {
        const o = t[s];
        e.push({ category: s, value: typeof o == "number" ? o : void 0 });
      }
    }
    return this.TI("columns", e), this;
  }
  setDataStacked(t, e) {
    const i = [];
    return e.forEach(((s) => {
      const { subCategory: o, values: n } = s;
      n.forEach(((a, l) => {
        const h = t[l];
        i.push({ category: h, subCategory: o, value: a });
      }));
    })), this.TI("stacks", i), this;
  }
  setDataGrouped(t, e) {
    const i = [];
    return e.forEach(((s) => {
      const { subCategory: o, values: n } = s;
      n.forEach(((a, l) => {
        const h = t[l];
        i.push({ category: h, subCategory: o, value: a });
      }));
    })), this.TI("groups", i), this;
  }
  TI(t, e) {
    this.Ny.length > 0 && this.yi.Oa(Ot.Go), this.cI = t, this.SI = e.map(((a) => ({ category: a.category, subCategory: a.subCategory }))), this.FI(e);
    const i = Cn(e.map(((a) => a.category))), s = i.length, o = Cn(e.map(((a) => a.subCategory))).filter(((a) => a !== void 0));
    if (e.forEach(((a) => {
      let l = this.Ny.find(((h) => h.category === a.category && h.subCategory === a.subCategory));
      if (!l) {
        const h = i.indexOf(a.category), u = a.subCategory !== void 0 && o.includes(a.subCategory) ? o.indexOf(a.subCategory) : void 0;
        l = new vE(this, this.$y, this.xi, this.yi.bs, a.category, a.subCategory, $e(u, h)), this.Wy(l, t === "groups" || t === "stacks" ? { legend: null } : void 0), this.fI.set(l, { category: h, valueStart: this.iI ? 1e-6 : 0, valueEnd: a.value !== void 0 ? a.value : 0 });
      }
      a.value !== void 0 && l.setValue(a.value);
    })), this.Ny.slice().forEach(((a) => {
      e.find(((l) => l.category === a.category && l.subCategory === a.subCategory)) === void 0 && (a.dispose(), this.fI.delete(a));
    })), this.categoryAxis.setInterval(this.Qs.getWidth({ x: { start: -0.5, end: Math.max(s, 1) - 0.5 }, y: { start: Math.max(s, 1) - 0.5, end: -0.5 } })), this.QF = this.Ny.length === 0 ? void 0 : t !== "stacks" ? this.Ny.reduce(((a, l) => ({ min: Math.min(a.min, l.getValue()), max: Math.max(a.max, l.getValue()) })), { min: wt, max: Pt }) : { min: 0, max: i.reduce(((a, l) => Math.max(a, e.reduce(((h, u) => u.category !== l ? h : u.value !== void 0 ? h + u.value : h), 0))), 0) }, this.QF && (this.KF = this.QF.min >= 0 ? "positive" : this.QF.max <= 0 ? "negative" : "bipolar", (this.KF === "bipolar" || this.KF === "negative") && this.iI)) throw new Error("LightningChart JS BarChart bipolar/negative data + logarithmic value axis combination not supported.");
    if (this.II && this.II(), t === "groups" || t === "stacks") {
      const a = o.map(((l) => ((h) => {
        let u = !1;
        const c = new Array();
        return h.forEach(((d) => {
          const f = (p) => {
            u || (u = !0, h.forEach(((g) => d !== g ? g.setHighlight(p.highlight) : void 0)), u = !1);
          };
          d.addEventListener("highlightchange", f), c.push((() => d.removeEventListener("highlightchange", f)));
        })), h.forEach(((d) => {
          const f = () => {
            const p = h.indexOf(d);
            p >= 0 && h.splice(p, 1);
          };
          d.addEventListener("dispose", f), c.push((() => d.removeEventListener("dispose", f)));
        })), () => {
          c.forEach(((d) => d()));
        };
      })(this.Ny.filter(((h) => h.subCategory === l)))));
      this.II = () => a.forEach(((l) => l()));
    }
    const n = new Set(o);
    for (const a of this.yI.keys()) n.has(a) || (this.Ns.forEach(((l) => {
      if (l.Vg()) {
        const h = l.getEntries(), u = this.yI.get(a), c = h.find(((d) => d.component === u));
        u && c && l.remove(u);
      }
    })), this.yI.delete(a));
    this.Ns.forEach(((a) => {
      a.Vg() && a.add(this);
    })), this.FI(this.Ny), this.nI.clear(), this.oI.clear(), this.uI = !0, this.yi.Rs();
  }
  setCategoryLabels(t) {
    const e = typeof t == "function" ? this.lI ? t(this.lI) : this.lI : t;
    return this.lI = e ? { ...this.xi.barChartCategoryLabels, ...e } : void 0, this.nI.clear(), this.yi.Rs(), this.pI = !0, this;
  }
  getCategoryLabels() {
    return this.lI;
  }
  setValueLabels(t) {
    var e;
    const i = typeof t == "function" ? this.qF ? t(this.qF) : this.qF : t, s = i?.position || ((e = this.qF) === null || e === void 0 ? void 0 : e.position);
    return i && s ? s === "after-bar" ? this.qF = { ...this.xi.barChartValueLabelsAfterBars, ...i } : s !== "inside-bar" && s !== "inside-bar-start" && s !== "inside-bar-centered" && s !== "inside-bar-end" || (this.qF = { ...this.xi.barChartValueLabelsInsideBars, ...i }) : this.qF = void 0, this.oI.clear(), this.yi.Rs(), this.pI = !0, this;
  }
  getValueLabels() {
    return this.qF;
  }
  setLabelFittingEnabled(t) {
    return this.dI = t, this.yi.Rs(), this;
  }
  getLabelFittingEnabled() {
    return this.dI;
  }
  setLabelFittingMargins(t) {
    return this.mI = typeof t == "object" ? t : typeof t == "number" ? { left: t, right: t, top: t, bottom: t } : Me, this.pI = !0, this.yi.Rs(), this;
  }
  getLabelFittingMargins() {
    return this.mI;
  }
  getBar(t, e) {
    if ((this.cI === "groups" || this.cI === "stacks") && e === void 0) throw new Error("LightningChart JS BarChart.getBar() | `subCategory` parameter is required for grouped and stacked bar charts!");
    const i = this.Ny.find(((s) => s.category === t && (e === void 0 || e === s.subCategory)));
    if (!i) throw new Error(`BarChart.getBar() no such bar: "${t}" ${e ? `"${e}"` : ""}`);
    return i;
  }
  getBars() {
    return this.Ny;
  }
  setSorting(t) {
    this.aI = t;
    const e = this.Ny.slice();
    return this.Ny.length = 0, this.Ny.push(...Mr(this.SI.map(((i) => e.find(((s) => s.category === i.category && (i.subCategory === void 0 || i.subCategory === s.subCategory))))))), this.FI(this.Ny), this.yi.Rs(), this.uI = !0, this;
  }
  getSorting() {
    return this.aI;
  }
  setAnimationCategoryPosition(t, e = 1) {
    return this.AI = t ? { speed: e } : void 0, this.yi.Rs(), this;
  }
  setAnimationValues(t, e = 1) {
    return this.jk = t ? { speed: e } : void 0, this.yi.Rs(), this;
  }
  translateCoordinate(t, e, i) {
    if (i && ig(t) && kr(e)) return super.translateCoordinate(t, e, i);
    const s = e;
    let o;
    if (Df(t)) o = this.yi.ul(t);
    else if (ig(t)) {
      const n = xt(t, this.xA, this.yi.ai);
      o = { engineX: n.x, engineY: n.y };
    } else {
      if (!SE(t)) throw new Error("LightningChart JS BarChart.translateCoordinate unexpected error. Input coordinate system not recognized.");
      {
        const n = xt(this.Qs.toPoint(t.iCategory, t.value), this.ZF, this.yi.ai);
        o = { engineX: n.x, engineY: n.y };
      }
    }
    if (Mo(s)) return this.yi.cl(o);
    if (s === "barChart") {
      const n = xt({ x: o.engineX, y: o.engineY }, this.yi.ai, this.ZF);
      return { iCategory: this.Qs.getWidth(n), value: this.Qs.getHeight(n) };
    }
    if (kr(s)) return xt({ x: o.engineX, y: o.engineY }, this.yi.ai, this.xA);
    throw new Error("LightningChart JS BarChart.translateCoordinate unexpected error. Target coordinate system not recognized.");
  }
  Gg() {
    if (this.cI === "columns") return this.Ny;
    const t = Cn(Mr(this.Ny.map(((e) => e.subCategory))));
    return Mr(t.map(((e) => {
      if (this.yI.has(e)) return this.yI.get(e);
      const i = this.Ny.filter(((n) => n.subCategory === e)), s = i[0];
      if (!s) return;
      const o = { Ws: () => {
      }, getVisible: () => s.getVisible(), setVisible: (n) => {
        i.forEach(((a) => a.setVisible(n)));
      }, getName: () => e, nr: () => s.nr() };
      return this.yI.set(e, o), o;
    })));
  }
  rr(t) {
    var e, i, s;
    super.rr(t);
    const o = this.kI.rg(), n = this.CI.rg(), a = this.Ny.filter(((S) => S.getVisible() && S.rI)), l = Cn(a.map(((S) => S.category))), h = Cn(Mr(a.map(((S) => S.subCategory)))), u = 5e-4 * t * (((e = this.AI) === null || e === void 0 ? void 0 : e.speed) || 0), c = 3e-3 * t * (((i = this.AI) === null || i === void 0 ? void 0 : i.speed) || 0), d = this.valueAxis.ai, f = d instanceof ts ? (S, E) => {
      var T;
      return Sa(S, E, d, ((T = this.jk) === null || T === void 0 ? void 0 : T.speed) || 0);
    } : (S, E) => {
      var T;
      return Eu(S, E, d, ((T = this.jk) === null || T === void 0 ? void 0 : T.speed) || 0);
    };
    let p;
    const g = (s = this.KF === "positive" && this.QF ? Math.min(this.QF.min, this.valueAxis.getInterval().start, this.valueAxis.getInterval().end) - (this.QF.max - this.QF.min) : this.KF === "negative" && this.QF ? Math.max(this.QF.max, this.valueAxis.getInterval().start, this.valueAxis.getInterval().end) + (this.QF.max - this.QF.min) : void 0) !== null && s !== void 0 ? s : 0;
    this.cI === "columns" ? p = a.map(((S) => ({ bar: S, position: { category: l.indexOf(S.category), valueStart: this.iI ? 1e-6 : g, valueEnd: S.value } }))) : this.cI === "groups" ? p = a.map(((S) => {
      const E = l.indexOf(S.category), T = h.indexOf(S.subCategory), I = 1 / (h.length + 2 * (h.length + 1) * this.gI), F = this.gI * I;
      return { bar: S, position: { category: E + (T - (h.length - 1) / 2) * (I + F), valueStart: this.iI ? 1e-6 : g, valueEnd: S.value } };
    })) : (p = [], l.forEach(((S) => {
      const E = a.filter(((I) => I.category === S));
      let T = this.iI ? 1e-6 : 0;
      E.forEach(((I) => {
        p.push({ bar: I, position: { category: l.indexOf(S), valueStart: T, valueEnd: T + I.value } }), T += I.value;
      }));
    }))), p.forEach(((S) => {
      const { bar: E, position: T } = S;
      let I, F, D = this.fI.get(E);
      D === void 0 && (D = T);
      const P = T.valueStart;
      if (this.AI && D.category !== T.category) {
        const V = Math.sign(T.category - D.category);
        I = D.category + u * V + c * (T.category - D.category), V !== Math.sign(T.category - I) && (I = T.category);
      } else I = T.category;
      if (this.jk && D.valueEnd !== T.valueEnd) {
        const V = Math.sign(T.valueEnd - D.valueEnd);
        F = f(D.valueEnd, T.valueEnd), V !== Math.sign(T.valueEnd - F) && (F = T.valueEnd);
      } else F = T.valueEnd;
      this.fI.set(E, { category: I, valueStart: P, valueEnd: F }), I === T.category && F === T.valueEnd || this.yi.Rs(!0), I === D.category && F === D.valueEnd || (this.uI = !0);
    }));
    const y = [...this.Ny];
    (this.vI.length !== y.length || this.vI.some(((S, E) => S !== y[E]))) && (this.Ns.forEach(((S) => S.Ng(this.Ny))), this.vI = y);
    const m = ui.xv(this.Wr, this.gv), A = this.Ns.reduce(((S, E) => {
      const T = E.Uh(m, this.Hn);
      return { top: Math.max(S.top, T.top), bottom: Math.max(S.bottom, T.bottom), left: Math.max(S.left, T.left), right: Math.max(S.right, T.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, A);
    const v = a.length > 0;
    this.categoryAxis.bn(), this.valueAxis.bn();
    const { labelMarginBeforeCategoryAxisPixels: b, labels: w } = v ? this.LI(l, h, a, o, n) : { labelMarginBeforeCategoryAxisPixels: 0, labels: [] }, k = this.categoryAxis.Uh({ physicalAxisSize: this.categoryAxis.ai.Ct(), EA: b }), R = this.valueAxis.Uh({ plotLines: n, physicalAxisSize: this.valueAxis.ai.Ct(), oppositeAxisSize: this.Qs.getWidth(this.ZF).Ct() });
    this.ZF.ti([this.dt.bottom + this.Hn.bottom + A.bottom + (this.Qs._I === "vertical" ? k.Of : 0), this.dt.top + this.Hn.top + m + A.top + (this.Qs._I === "horizontal" ? R.Of : 0)]), this.ZF.qt([this.dt.left + this.Hn.left + A.left + this.Qs.getHeight({ x: k.Of, y: R.Of }), this.dt.right + this.Hn.right + A.right]), this.xI.Qm({ x: this.ZF.x.wt(), y: this.ZF.y.wt(), width: this.ZF.x.Ct(), height: this.ZF.y.Ct() }), this.Yg && this.Yg();
    const L = { x: Math.min(this.ZF.x.getInnerStart(), this.ZF.x.getInnerEnd()), y: Math.min(this.ZF.y.getInnerStart(), this.ZF.y.getInnerEnd()) }, x = Math.max(this.ZF.x.getInnerStart(), this.ZF.x.getInnerEnd()), M = Math.max(this.ZF.y.getInnerStart(), this.ZF.y.getInnerEnd()), C = { x: x - L.x, y: M - L.y };
    if (this.Yy.hr(L), this.Yy.K(C), this.Hy.hr(L), this.Hy.K(C), this.categoryAxis.rr(k), this.valueAxis.rr(R), super.dv(), this.AS.rr(!1, this.Ny, void 0), (this.uI || this.pI) && this.dI) {
      const S = w.map(((E) => {
        const T = E.setVisible(!0).Uh().Ic();
        if (this.mI.bottom !== 0 || this.mI.left !== 0 || this.mI.right !== 0 || this.mI.top !== 0) {
          const I = Math.sign(this.ZF.x.U - this.ZF.x.$), F = Math.sign(this.ZF.y.U - this.ZF.y.$), D = F > 0 ? T.min.y : T.max.y, P = F > 0 ? T.max.y : T.min.y, V = I > 0 ? T.min.x : T.max.x, _ = I > 0 ? T.max.x : T.min.x, O = E.ai.Qt({ x: V, y: D }, { x: -this.mI.left, y: -this.mI.bottom }), B = E.ai.Qt({ x: _, y: P }, { x: this.mI.right, y: this.mI.top });
          return { min: { x: Math.min(O.x, B.x), y: Math.min(O.y, B.y) }, max: { x: Math.max(O.x, B.x), y: Math.max(O.y, B.y) } };
        }
        return T;
      }));
      for (let E = 0; E < w.length; E += 1) {
        if (!w[E].getVisible()) continue;
        const T = S[E];
        let I;
        do
          I = w.findIndex(((F, D) => D !== E && w[D].getVisible() && ma(T, S[D]))), I >= 0 && w[I].setVisible(!1);
        while (I >= 0);
      }
    }
    if (this.uI) {
      const S = this.Ix.rg(), E = this.cI === "groups" ? 1 / (h.length + 2 * (h.length + 1) * this.gI) : 1 - 2 * this.gI;
      a.forEach(((T) => {
        const I = this.fI.get(T);
        if (I === void 0) return;
        const F = I.category - 0.5 * E, D = I.category + 0.5 * E, P = this.Qs.toPoint(F, I.valueStart), V = this.Qs.toPoint(D, I.valueEnd);
        let _;
        this.bI && (_ = { extent: this.bI, c_x1_y2: this.Qs._I === "vertical", c_x2_y2: this.Qs._I === "vertical" || this.Qs._I === "horizontal", c_x1_y1: !1, c_x2_y1: this.Qs._I === "horizontal" }, this.cI === "stacks" && T.subCategory && h.indexOf(T.subCategory) !== h.length - 1 && (_ = void 0)), S.add({ Si: T.Si, bar: T, x1: P.x, y1: P.y, x2: V.x, y2: V.y, rounding: _ }, { fillStyle: T.Ke, strokeStyle: T.qe });
      })), S.finishPlot();
    }
    o.finishPlot(), n.finishPlot(), this.uI = !1, this.pI = !1, this.Ns.forEach(((S) => S.rr(m, this.Hn)));
  }
  setAnimationsEnabled(t) {
    return super.setAnimationsEnabled(t), this.setAnimationCategoryPosition(t), this.setAnimationValues(t), this.valueAxis.setAnimationsEnabled(t), this.categoryAxis.setAnimationsEnabled(t), this;
  }
  dispose() {
    return this.MI.G(), this.xI.G(), this.AS.G(), super.dispose();
  }
  FI(t) {
    const e = this.aI;
    e && t.sort(((i, s) => e({ category: i.category, value: t.reduce(((o, n) => o + (n.category === i.category && n.value || 0)), 0) }, { category: s.category, value: t.reduce(((o, n) => o + (n.category === s.category && n.value || 0)), 0) })));
  }
  LI(t, e, i, s, o) {
    let n = 0;
    const a = this.lI, l = this.qF, h = this.valueAxis.getInterval(), u = [];
    if (a && a.labelFillStyle !== Lt) {
      const c = a.tickLength + a.labelMargin, d = this.Qs.toPoint(a.labelAlignment, 1), f = { Cf: t.map(((p, g) => {
        const y = i.reduce(((v, b) => b.category !== p ? v : v + b.value), 0), m = a.formatter(p, y);
        if (!m) return;
        const A = g;
        return A !== void 0 ? { text: m, position: this.Qs.toPoint(A, this.valueAxis.ai.Qt(h.start, -c)), alignment: d, rotation: a.labelRotation, sizePixels: this.BI(p, y) } : void 0;
      })), ho: a.labelFont, ai: this.ZF };
      f.Cf.forEach(((p) => {
        p && u.push(s.add().rn(p.text).hr(p.position).ru(p.alignment).Ph(p.rotation).sr(a.labelFillStyle).Ih(a.labelFont).en(a.labelShadow));
      })), a.tickStyle !== Et && a.tickLength !== 0 && f.Cf.forEach(((p) => {
        if (!p) return;
        const g = this.Qs.getWidth(p.position);
        o.add({ positions: [this.Qs.toPoint(g, this.valueAxis.ai.getInnerStart()), this.Qs.toPoint(g, this.valueAxis.ai.Qt(h.start, -a.tickLength))] }, { lineStyle: a.tickStyle });
      })), n = f.Cf.reduce(((p, g) => g ? Math.max(p, this.Qs.getHeight(g.sizePixels)) : p), 0) + a.tickLength + a.labelMargin;
    }
    if (l && l.labelFillStyle !== Lt) {
      const c = { Cf: [], ho: l.labelFont, ai: this.ZF };
      this.cI === "stacks" && l.displayStackedSum && c.Cf.push(...t.map(((d, f) => {
        const p = i.reduce(((v, b) => v + (b.category === d ? b.value : 0)), 0), g = l.formatter({ chart: this, bar: void 0, category: d, value: p, subCategory: void 0 });
        if (!g) return;
        const y = i.filter(((v) => v.category === d)).sort(((v, b) => {
          var w, k;
          return e.indexOf((w = v.subCategory) !== null && w !== void 0 ? w : "") - e.indexOf((k = b.subCategory) !== null && k !== void 0 ? k : "");
        })), m = y[y.length - 1], A = this.fI.get(m);
        return A !== void 0 ? { text: g, position: this.Qs.toPoint(A.category, this.valueAxis.ai.Qt(A.valueEnd, l.labelMargin * Math.sign(A.valueEnd))), alignment: this.Qs.toPoint(0, -1 * Math.sign(A.valueEnd)), rotation: l.labelRotation, sizePixels: this.yi.rh.Pr(g, l.labelFont, l.labelRotation) } : void 0;
      }))), l.position !== "after-bar" || this.cI === "stacks" && !l.displayStackedIndividuals ? l.position !== "inside-bar" && l.position !== "inside-bar-start" && l.position !== "inside-bar-centered" && l.position !== "inside-bar-end" || c.Cf.push(...i.map(((d, f) => {
        const p = l.formatter({ chart: this, bar: d, category: d.category, value: d.value, subCategory: d.subCategory });
        if (!p) return;
        const g = this.fI.get(d);
        if (g === void 0) return;
        const y = this.KF === "bipolar" ? Math.sign(g.valueEnd) : this.KF === "negative" ? -1 : 1, m = this.Qs.toPoint(0, l.position === "inside-bar" || l.position === "inside-bar-end" ? 1 * y : l.position === "inside-bar-centered" ? 0 : -1 * y);
        return { text: p, position: this.Qs.toPoint(g.category, l.position === "inside-bar" || l.position === "inside-bar-end" ? this.valueAxis.ai.Qt(g.valueEnd, -l.labelMargin * y) : l.position === "inside-bar-centered" ? (g.valueStart + g.valueEnd) / 2 : this.valueAxis.ai.Qt(g.valueStart, l.labelMargin * y)), alignment: m, rotation: l.labelRotation, sizePixels: this.DI(d) };
      }))) : c.Cf.push(...i.map(((d, f) => {
        const p = l.formatter({ chart: this, bar: d, category: d.category, value: d.value, subCategory: d.subCategory });
        if (!p) return;
        const g = this.fI.get(d);
        return g !== void 0 ? { text: p, position: this.Qs.toPoint(g.category, this.valueAxis.ai.Qt(g.valueEnd, l.labelMargin * Math.sign(g.valueEnd))), alignment: this.Qs.toPoint(l.labelAlignment, -1 * Math.sign(g.valueEnd)), rotation: l.labelRotation, sizePixels: this.DI(d) } : void 0;
      }))), c && c.Cf.forEach(((d) => {
        d && u.push(s.add().rn(d.text).hr(d.position).ru(d.alignment).Ph(d.rotation).sr(l.labelFillStyle).Ih(l.labelFont).en(l.labelShadow).setPointerEvents(!1));
      }));
    }
    return { labelMarginBeforeCategoryAxisPixels: n, labels: u };
  }
  BI(t, e) {
    if (!this.lI || this.lI.labelFillStyle === Lt) return { x: 0, y: 0 };
    const i = this.nI.get(t);
    if (i) return i;
    const s = this.lI.formatter(t, e), o = this.yi.rh.Pr(s, this.lI.labelFont, this.lI.labelRotation);
    return o.isEstimate ? this.yi.Rs(!0) : this.nI.set(t, o), o;
  }
  DI(t) {
    if (!this.qF || this.qF.labelFillStyle === Lt) return { x: 0, y: 0 };
    const e = this.oI.get(t);
    if (e) return e;
    const i = this.yi.rh.Pr(this.qF.formatter({ chart: this, bar: t, category: t.category, value: t.value, subCategory: t.subCategory }), this.qF.labelFont, this.qF.labelRotation);
    return i.isEstimate ? this.yi.Rs(!0) : this.oI.set(t, i), i;
  }
  tI() {
    return this.Ny.reduce(((t, e) => {
      const i = this.DI(e);
      return { x: Math.max(t.x, i.x), y: Math.max(t.y, i.y) };
    }), { x: 0, y: 0 });
  }
  hI() {
    this.uI = !0, this.yi.Rs();
  }
  W() {
    return super.W(), this.ZF.W(), this;
  }
  X() {
    return super.X(), this.ZF.X(), this;
  }
  getMinimumSize() {
    return { x: 200, y: 200 };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const AE = { Descending: (r, t) => t.value - r.value }, bE = { ...jl, _I: "vertical", sI: -1, eI: 1 }, EE = { ...ec, _I: "horizontal", sI: 1, eI: -1 }, ME = (r, t, e) => {
  const i = [[{ component: t.bar, rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }]], s = r.valueAxis.getTitle();
  return s && i.push([s]), t.subCategory ? i.push([t.subCategory, "", { text: Ai(r.valueAxis.formatValue(t.bar.getValue()), r.valueAxis), font: { weight: "bold" } }]) : i.push({ text: Ai(r.valueAxis.formatValue(t.bar.getValue()), r.valueAxis), font: { weight: "bold" } }), i;
}, Fu = (r, t) => Math.abs(r) + Math.abs(t);
function ip(r, t) {
  const e = r.reduce(Fu, 0), i = (s = r, Math.max(...s.map(((n) => n))));
  var s;
  const o = ((n) => Math.min(...n.map(((a) => a))))(r);
  return Math.max(t ** 2 * i / e ** 2, e ** 2 / (t ** 2 * o));
}
const au = ({ height: r, width: t }) => r > t ? { value: t, vertical: !1 } : { value: r, vertical: !0 }, sp = ({ data: r, dimensions: t }) => {
  const { x: e, y: i, width: s, height: o } = t;
  r.map(((d) => d.value)).reduce(Fu, 0);
  const n = r.map(((d) => d.animatedValue)).reduce(Fu, 0), a = r.map(((d) => d.animatedValue * o * s / n)), l = a.reduce(((d, f) => d + f), 0), h = a.map(((d) => d / l * 100)), u = a.filter(((d, f) => h[f])), c = { children: [], x: e, y: i, width: s, height: o };
  if (r.length === 1) {
    const d = { ...r[0], x: t.x, y: t.y, width: t.width, height: t.height, userNode: { ...r[0].userNode, value: r[0].value } };
    c.children.push(d);
  } else CE(u, au(c).value, r, c);
  return c.children;
}, rp = (r, t, e, i, s) => {
  const o = r.reduce(Fu, 0) / t;
  r.forEach(((n, a) => {
    const l = Math.abs(n) / o, { x: h, y: u, children: c } = s, d = i[c.length], f = { ...d, x: h, y: u, width: e ? o : l, height: e ? l : o, userNode: { ...d.userNode, value: d.value } };
    e ? s.y -= l : s.x += l, c.push(f);
  })), e ? (s.x += o, s.y += t, s.width -= o) : (s.x -= t, s.y -= o, s.height -= o);
}, CE = (r, t, e, i) => {
  const s = [{ children: r, width: t, row: [] }];
  for (; s.length > 0; ) {
    const o = s.pop();
    if (!o) continue;
    const { children: n, width: a, row: l } = o;
    let h = 0;
    const u = [...l];
    for (; h < n.length; ) {
      const c = [...u, n[h]], d = ip(u, a), f = ip(c, a);
      if (!(u.length === 0 || d > f)) {
        rp(u, a, au(i).vertical, e, i), s.push({ children: n.slice(h), width: au(i).value, row: [] });
        break;
      }
      u.push(n[h]), h += 1;
    }
    h === n.length && rp(u, a, au(i).vertical, e, i);
  }
};
class wE extends Rr {
  constructor(t, e, i, s, o, n, a) {
    var l;
    if (super(t, e, i, e.Av("treeMapChart bg", 0), s, e.yi.xi.treeMapChartBackgroundFillStyle || e.yi.xi.chartXYSeriesBackgroundFillStyle, e.yi.xi.treeMapChartBackgroundStrokeStyle || e.yi.xi.chartXYBackgroundStrokeStyle, e.yi.xi.treeMapChartTitleFont || e.yi.xi.chartXYTitleFont, e.yi.xi.treeMapChartTitleFillStyle || e.yi.xi.chartXYTitleFillStyle, e.yi.xi.treeMapChartTitleShadow || e.yi.xi.chartXYTitleShadow, a, (l = n?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.EI = /* @__PURE__ */ new Map(), this.RI = [], this.OI = {}, this.zI = le([]), this.jk = { speed: 1 }, this.VI = wt, this.NI = "Go Back", this.GI = [], this.$I = this.xi.treeMapChartPathLabelFillStyle || this.xi.uiTextFillStyle, this.UI = this.xi.treeMapChartPathLabelFont || this.xi.uiTextFont, this.jI = this.xi.treeMapChartLabelHeaderFillStyle || this.xi.uiTextFillStyle, this.YI = this.xi.treeMapChartLabelHeaderFont || this.xi.uiTextFont, this.HI = this.xi.treeMapChartLabelFillStyle || this.xi.uiTextFillStyle, this.WI = this.xi.treeMapChartLabelFont || this.xi.uiTextFont, this.LS = !0, this.Sg = !1, this.XI = this.xi.treeMapChartParentColor || Qe, this.ZI = this.xi.treeMapChartNodeStrokeStyle || this.xi.uiBackgroundStrokeStyle, this.JI = Me, this.Cx = this.xi.treeMapChartCornerRadius, this.DS = () => {
      this.yi.Rs(), this.Sg = !0;
    }, this.QI = (c, d) => {
      var f;
      const { collectionMember: p } = d, g = this.KI(p);
      g && (this.JS = this.qI(g, c), this.LS && this.yi.ks.$s(p, !0), !((f = this.getUserInteractions().drillDown) === null || f === void 0) && f.click && this.engine.setMouseStyle(Gt.Point), this.yi.Rs());
    }, this.tP = (c, d) => {
      const { collectionMember: f } = d;
      this.KI(f) && (this.JS = void 0, this.LS && this.yi.ks.$s(f, !1), this.engine.setMouseStyle(Gt.Default), this.yi.Rs());
    }, this.iP = (c, d) => {
      var f;
      const { collectionMember: p } = d, g = this.KI(p);
      g && (this.JS = this.qI(g, c), this.LS && this.yi.ks.$s(p, !0), !((f = this.getUserInteractions().drillDown) === null || f === void 0) && f.click && this.engine.setMouseStyle(Gt.Point), this.yi.Rs());
    }, this.sP = (c, d) => {
      var f;
      if (c.defaultPrevented) return;
      const { collectionMember: p } = d, g = this.KI(p);
      if (g) {
        if (!((f = this.getUserInteractions().drillDown) === null || f === void 0) && f.click) {
          const y = g?.children.length ? g : g.parentID ? this.OI[g.parentID] : void 0;
          y && (this.zI.C([y]), this.JS = void 0, this.D.R("viewchange", { nodes: this.zI.T().map(((m) => m.userNode)) }), this.Sg = !0), c && It(c);
        }
        this.yi.Rs();
      }
    }, this.eP = (c) => {
      const d = this.OI[this.GI[c].id] ? [this.OI[this.GI[c].id]] : this.RI;
      this.zI.C(d), this.D.R("viewchange", { nodes: d.map(((f) => f.userNode)) }), this.Sg = !0, this.yi.Rs();
    }, this.nodes = new Nt(), this.D = new Nt(), this.xi.treeMapChartNodeColors) this.rP = this.xi.treeMapChartNodeColors;
    else {
      const c = this.xi.pointSeriesFillStyle, d = (f) => de(f) ? f.getColor() : Qe;
      this.rP = typeof c == "function" ? new Array(5).fill(0).map(((f, p) => d(c(p)))) : [d(c)];
    }
    this.yi.Oa(Ot.jo), this.rC = e.hS("TreeMapChart plotting", 0), this.hC = e.hS("TreeMap UI plotting", 1), this.addEventListener("resize", this.DS), this.Wr.rn("TreeMap Chart");
    const h = e.fS(), u = $e(n ? n.cursorBuilder : void 0, Fg);
    this.AS = Xr(this, h, u.zm(h, this.uiScale, this.uiScale, ie, this.xi), void 0, "show-pointed", TE, (() => 0)), this.hP = this.bs.CA(), this.fv(o, this.uiScale), this.Lf = this.rC.Od(this.xA).sr(new md()).ir(this.ZI), this.nP = this.yi.ks.Jo(this, { animationEnabled: n?.animationsEnabled !== !1 }), this.oP = new Xi((() => this.hC.In(this.xA).setPointerEvents(!1))), this.aP = new Xi((() => this.hC.In(this.uiScale))), this.Lf.setPointerEvents(!0), this.nodes.Ni(this.Lf, ((c) => {
      const d = this.KI(c);
      if (d) return d.userNode;
    })), this.setAnimationsEnabled(n?.animationsEnabled !== !1), this.Lf.addEventListener("pointerenter", this.QI), this.Lf.addEventListener("pointerleave", this.tP), this.Lf.addEventListener("click", this.sP), this.Lf.addEventListener("pointermove", this.iP), n?.legend !== void 0 && this.legend.setOptions(n.legend);
  }
  setCornerRadius(t) {
    return this.Cx = t, this.Sg = !0, this.yi.Rs(), this;
  }
  getCornerRadius() {
    return this.Cx;
  }
  setData(t) {
    t = Array.isArray(t) ? t.slice() : [t];
    const { lP: e } = /* @__PURE__ */ (() => {
      let s = 0;
      return { lP: (o) => {
        var n;
        const a = o.map(((c, d) => ({ node: c, parent: null }))), l = [];
        for (; a.length > 0; ) {
          const c = a.pop();
          if (!c) continue;
          const { node: d, parent: f } = c;
          s += 1;
          const p = { id: s, parentID: f?.id, name: d.name, value: Number(d.value) || 0, animatedValue: Number(d.value) || 0, children: [], nodeIndex: f ? f.nodeIndex : -1, userNode: d };
          f ? f.children.push(p) : l.push(p), (n = d.children) === null || n === void 0 || n.forEach(((g) => {
            a.push({ node: g, parent: p });
          }));
        }
        const h = (c) => {
          c.children.forEach(h), c.children.length > 0 && (c.value += c.children.reduce(((d, f) => d + f.value), 0), c.animatedValue += c.children.reduce(((d, f) => d + f.animatedValue), 0), c.children.sort(((d, f) => f.animatedValue - d.animatedValue)));
        };
        l.forEach(h);
        const u = o.length === 1 ? l[0].children : l;
        return u.sort(((c, d) => d.animatedValue - c.animatedValue)), u.forEach(((c, d) => {
          c.nodeIndex = d;
          const f = (p) => {
            p.children.forEach(((g) => {
              g.nodeIndex = c.nodeIndex, f(g);
            }));
          };
          f(c);
        })), l;
      } };
    })(), i = e(t);
    return i.forEach(((s) => {
      const o = this.OI[s.id];
      o && this.uP(s, o);
    })), this.JS = void 0, this.zI.C(i), this.RI = i, this.OI = this.cP(i), this.Sg = !0, this.yi.Rs(), this;
  }
  setAnimationValues(t, e = 1) {
    return this.jk = t ? { speed: e } : void 0, this.yi.Rs(), this;
  }
  setInitPathButtonText(t) {
    return this.NI = t, this.Sg = !0, this.yi.Rs(), this;
  }
  setDisplayedLevelsCount(t) {
    return this.VI = t, this.Sg = !0, this.yi.Rs(), this;
  }
  setDrillDownNode(t) {
    var e, i;
    if (this.JS = void 0, t === void 0) this.zI.C(this.RI);
    else {
      const s = [...this.RI];
      for (; s.length > 0; ) {
        const o = s.pop();
        if (o) {
          if (o.value !== void 0 && o.userNode === t || o.parentID && Array.isArray(t) && ((i = (e = this.OI[o.parentID]) === null || e === void 0 ? void 0 : e.userNode) === null || i === void 0 ? void 0 : i.children) === t) {
            const n = o.children.length ? o : o.parentID ? this.OI[o.parentID] : this.RI[0];
            this.zI.C([n]);
            break;
          }
          if (o.children) for (let n = o.children.length - 1; n >= 0; n -= 1) s.push(o.children[n]);
        }
      }
    }
    return this.D.R("viewchange", { nodes: this.zI.T().map(((s) => s.userNode)) }), this.Sg = !0, this.yi.Rs(), this;
  }
  setNodeColoring(t) {
    return t instanceof Array ? (this.Lf.sr(new md()), this.rP = t) : (this.Lf.sr(t), this.Ns.forEach(((e) => {
      e.Vg() && e.add(this);
    }))), this.Ns.forEach(((e) => e.Gs())), this.Sg = !0, this.yi.Rs(), this;
  }
  setParentNodeColor(t) {
    return this.XI = t, this.Sg = !0, this.yi.Rs(), this;
  }
  setPathLabelFillStyle(t) {
    return this.$I = typeof t == "function" ? t(this.$I) : t, this.Sg = !0, this.yi.Rs(), this;
  }
  getPathLabelFillStyle() {
    return this.$I;
  }
  setPathLabelFont(t) {
    return sa(t) ? this.UI = t : this.UI = t(this.UI), this.Sg = !0, this.yi.Rs(), this;
  }
  getPathLabelFont() {
    return this.UI;
  }
  setHeaderFont(t) {
    return sa(t) ? this.YI = t : this.YI = t(this.YI), this.Sg = !0, this.yi.Rs(), this;
  }
  getHeaderFont() {
    return this.YI;
  }
  setHeaderFillStyle(t) {
    return this.jI = typeof t == "function" ? t(this.jI) : t, this.Sg = !0, this.yi.Rs(), this;
  }
  getHeaderFillStyle() {
    return this.jI;
  }
  setLabelFont(t) {
    return sa(t) ? this.WI = t : this.WI = t(this.WI), this.Sg = !0, this.yi.Rs(), this;
  }
  getLabelFont() {
    return this.WI;
  }
  setLabelFillStyle(t) {
    return this.HI = typeof t == "function" ? t(this.HI) : t, this.Sg = !0, this.yi.Rs(), this;
  }
  getLabelFillStyle() {
    return this.HI;
  }
  setNodeBorderStyle(t) {
    return this.Lf.ir(t), this.Sg = !0, this.yi.Rs(), this;
  }
  getNodeBorderStyle() {
    return this.Lf.hl();
  }
  setNodeEffect(t) {
    return this.hP.Es(t), this.yi.Rs(), this;
  }
  getNodeEffect() {
    return this.hP.Os();
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  addCursor(t = Fg) {
    const e = this.tv(), i = t.zm(e, this.uiScale, this.uiScale, this.Jg(e), this.xi);
    return this.cv(i), i;
  }
  setAnimationHighlight(t) {
    return this.nP.qo(t), this;
  }
  getAnimationHighlight() {
    return this.nP.ta();
  }
  setHighlightOnHover(t) {
    return this.LS = t, this;
  }
  getHighlightOnHover() {
    return this.LS;
  }
  qI(t, e) {
    const i = this.yi.ul(e);
    return { cursorPosition: { pointMarker: { x: i.engineX, y: i.engineY }, pointMarkerScale: this.yi.ai, resultTable: { x: i.engineX, y: i.engineY }, resultTableScale: this.yi.ai }, name: t.name, value: t.value, node: t.userNode };
  }
  getMinimumSize() {
  }
  Gg() {
    return [this];
  }
  rr(t) {
    super.rr(t), super.dv();
    const e = ui.xv(this.Wr, this.gv), i = this.Ns.reduce(((s, o) => {
      const n = o.Uh(e, this.Hn);
      return { top: Math.max(s.top, n.top), bottom: Math.max(s.bottom, n.bottom), left: Math.max(s.left, n.left), right: Math.max(s.right, n.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    if (i.bottom === this.JI.bottom && i.right === this.JI.right && i.top === this.JI.top && i.left === this.JI.left || (this.Sg = !0, this.JI = i), ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, i), this.Sg && this.zI.T().length) {
      this.Lf.Vi(), this.EI.clear(), this.nP.Ko(), this.zr && this.dP(t);
      const s = sp({ data: this.zI.T(), dimensions: { x: 0 + this.Hn.left + i.left, y: this.xA.y.getInnerEnd() - e - this.Hn.top - i.top, width: this.xA.x.getInnerEnd() - this.Hn.right - this.Hn.left - i.right - i.left, height: this.xA.y.getInnerEnd() - e - this.Hn.top - this.Hn.bottom - i.top - i.bottom } }), o = this.oP.rg();
      this.fP(s, o), o.finishPlot(), this.AP(), this.RI !== this.zI.T() && this.RI.length > 1 && this.GI.unshift({ name: this.NI, id: 0 });
      let n = 0;
      const a = this.aP.rg(), l = this.UI;
      this.GI.forEach(((h, u) => {
        const c = a.add(), d = this.yi.rh.Pr(h.name, l, 0);
        let f;
        c.rn(`← ${h.name}`).Ih(l).hr({ x: 0, y: 100 }).ru({ x: -1, y: 1 }).Tn({ left: this.Hn.left + n, top: this.Hn.top, right: 0, bottom: 0 }).sr(this.$I), c.addEventListener("click", (() => this.eP(u))), c.addEventListener("pointerenter", (() => {
          f = this.engine.setMouseStyle(Gt.Point, f);
        })), c.addEventListener("pointerleave", (() => {
          this.engine.restoreMouseStyle(f);
        })), n += d.x + 25;
      })), a.finishPlot(), this.zI.T().every(((h) => h.value === h.animatedValue)) ? this.Sg = !1 : this.yi.Rs(!0);
    }
    return this.AS.rr(!1, [], void 0, { explicitTarget: this.JS }), this.Ns.forEach(((s) => s.rr(e, this.Hn))), this;
  }
  dispose() {
    return this.hC.G(), this.rC.G(), this.AS.G(), this.Lf.dispose(), this.EI.clear(), this.oP.ag(), this.aP.ag(), super.dispose();
  }
  W() {
    return super.W(), this;
  }
  X() {
    return super.X(), this;
  }
  Ws() {
    return is(this.Lf.kh(), this.Lf.wi());
  }
  fP(t, e, i = !1, s = 0) {
    const o = t.map(((a, l) => ({ node: a, isChild: i, visibleDepth: s }))), n = this.Cx ? { extent: this.Cx, c_x1_y1: !0, c_x1_y2: !0, c_x2_y1: !0, c_x2_y2: !0 } : void 0;
    for (; o.length > 0; ) {
      const a = o.pop();
      if (!a) continue;
      const { node: l, visibleDepth: h, opacity: u } = a, { x: c, y: d, height: f, width: p, children: g, animatedValue: y, name: m, nodeIndex: A } = l, v = this.rP, b = h === 0 && this.zI.T().length === 1 ? this.XI : v[A % v.length], w = this.Lf.Qo().Gd(c, d, c + p, d - f).gP(b.setA(b.getA() * ((u ?? 255) / 255))).ZS(y).Nd(n);
      this.EI.set(w, l), this.nP.Qo(w, ((I) => w.Ii(I)));
      const k = c + 5, R = d + 25 + 5, L = Math.max(f - 25 - 5, 0), x = Math.max(p - 5 - 5, 0);
      if (g && g.length && h < this.VI && x > 15 && L > 15) {
        const I = sp({ data: g, dimensions: { x: x > 0 ? k : c, y: L > 0 ? d - 25 : R, width: x, height: L } });
        for (let F = 0; F < I.length; F += 1) {
          const D = (255 - (g.length > 7 ? 50 : 150)) / (g.length - 1), P = l.id === 1 && this.RI.length === 1 || this.RI === this.zI.T() ? 255 : u ? u / (h + 1) : 255 - F * D;
          o.push({ node: I[F], isChild: !0, visibleDepth: h + 1, opacity: P });
        }
      }
      const M = h === 0 && this.zI.T().length === 1 ? this.jI : this.HI, C = h === 0 ? this.YI : this.WI, S = this.vP(m, p - 25, C), E = this.yi.rh.Pr(S, C, 0), T = e.add();
      p - 25 > E.x && f > 25 ? T.rn(S).hr({ x: c + 5, y: d - 2.5 }).ru({ x: -1, y: 1 }).sr(M).Ih(C) : T.rn("");
    }
  }
  cP(t) {
    const e = {}, i = [...t];
    for (; i.length > 0; ) {
      const s = i.pop();
      s && (e[s.id] = s, s.children && i.push(...s.children));
    }
    return e;
  }
  KI(t) {
    if (!this.Sg && t) return this.EI.get(t);
  }
  AP() {
    this.GI = [];
    const t = this.zI.T()[0].id;
    let e = this.OI[t].parentID;
    for (; e; ) this.GI.push({ name: this.OI[e].name, id: e }), e = this.OI[e].parentID;
    return this.GI.reverse();
  }
  vP(t, e, i) {
    let s = this.yi.rh.Pr(t, i, 0).x;
    if (s <= e) return t;
    const o = t.split(" ");
    let n = t;
    for (; o.length > 1 && s > e; ) o.pop(), n = `${o.join(" ")}...`, s = this.yi.rh.Pr(n, i, 0).x;
    if (s > e) for (n = `${o[0]}...`, s = this.yi.rh.Pr(n, i, 0).x; n.length > 3 && s > e; ) n = `${n.substring(0, n.length - 4)}...`, s = this.yi.rh.Pr(n, i, 0).x;
    return n.length <= 3 && s > e ? "" : n;
  }
  dP(t) {
    var e;
    const i = [...this.RI];
    for (; i.length > 0; ) {
      const s = i.pop();
      if (!s) continue;
      const o = s.value - s.animatedValue;
      if (Math.abs(o) < 15e-4 * s.value || this.jk === void 0) s.animatedValue = s.value;
      else {
        const n = o / 255 * (((e = this.jk) === null || e === void 0 ? void 0 : e.speed) || 1) * t;
        s.animatedValue += n, (o > 0 && s.animatedValue > s.value || o < 0 && s.animatedValue < s.value) && (s.animatedValue = s.value);
      }
      s.children && s.children.length > 0 && i.push(...s.children);
    }
  }
  uP(t, e) {
    const i = [{ current: t, previous: e }];
    for (; i.length > 0; ) {
      const s = i.pop();
      if (!s) continue;
      const { current: o, previous: n } = s;
      o.animatedValue = this.zr ? n.animatedValue : o.value, n.nodeIndex < 0 ? o.nodeIndex = 0 : o.nodeIndex = n.nodeIndex;
      const a = new Map(n.children.map(((l) => [l.id, l])));
      o.children.forEach(((l, h) => {
        const u = a.get(l.id);
        i.push({ current: l, previous: u || n });
      }));
    }
  }
  setUserInteractions(t) {
    return this.cr = t === void 0 ? { drillDown: { click: !1 } } : t, this;
  }
  getUserInteractions() {
    return Zi({ drillDown: { click: !0 } }, this.cr);
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const TE = (r, t, e) => [[{ text: t.name, rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [{ text: t.value.toString(), font: { weight: "bold" } }]];
class Ux extends Rr {
  constructor(t, e, i, s, o, n, a) {
    var l;
    super(t, e, i, e.Av("gaugeChart bg", 0), s, e.yi.xi.gaugeChartBackgroundFillStyle, e.yi.xi.gaugeChartBackgroundStrokeStyle, e.yi.xi.gaugeChartTitleFont, e.yi.xi.gaugeChartTitleFillStyle, e.yi.xi.gaugeChartTitleShadow, n, (l = a?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.Ju = this.xi.gaugeChartStartAngle, this.Qu = this.xi.gaugeChartEndAngle, this.yP = { start: 0, end: 100 }, this.M = 0, this.pP = [], this.mP = this.xi.gaugeChartBarThickness, this.SP = this.xi.gaugeChartValueIndicatorThickness, this.bP = this.xi.gaugeChartNeedleLength, this.xP = this.xi.gaugeChartNeedleThickness, this.MP = this.xi.gaugeChartNeedleFillStyle, this._P = this.xi.gaugeChartNeedleStrokeStyle, this.Vd = this.xi.gaugeChartRoundedEdges, this.wP = !0, this.kP = !0, this.CP = !0, this.TP = [], this.FP = [], this.IP = !0, this.PP = !0, this.Gk = this.M, this.LP = (u) => Number.isInteger(u) ? u.toString() : u.toFixed(2), this.BP = this.xi.gaugeChartBarGradient, this.DP = (u) => Number.isInteger(u) ? u.toString() : u.toFixed(2), this.EP = this.xi.gaugeChartTickFont, this.RP = this.xi.gaugeChartValueLabelFont, this.OP = this.xi.gaugeChartValueLabelFillStyle, this.zP = this.xi.gaugeChartUnitLabelFont, this.VP = this.xi.gaugeChartUnitLabelFillStyle, this.NP = this.xi.gaugeChartTickFillStyle, this.GP = this.xi.gaugeChartBarColor, this.$P = this.xi.gaugeChartGlowColor, this.UP = this.xi.gaugeChartGlowColor.getA(), this.jP = 1, this.YP = 1, this.HP = this.xi.gaugeChartNeedleAlignment, this.WP = !1, this.XP = this.xi.gaugeChartGapBetweenBarAndValueIndicators, this.ZP = this.xi.gaugeChartBarStrokeStyle, this.JI = Me, this.JP = !1, this.D = new Nt(), this.yi.Oa(Ot.Io), this.Wr.rn("Gauge Chart"), this.fv(o, this.xA), this.setAnimationsEnabled(a?.animationsEnabled !== !1), this.QP = this.GP, this.KP = this.$P, this.qP = N(0, 0, 0, 0), this.tL = this.bs.CA(), this.iL = this.bs.CA().Es(this.xi.effectsText), this.sL = this.Zg.Vc(this.xA).ir(this.ZP).setPointerEvents(!1), this.eL = this.Zg.Ud(this.xA).lc(0).yr(360).Ac(0).ir(Et).setPointerEvents(!1), this.rL = this.yv.vr(this.xA).gr(this.xi.gaugeChartNeedleStrokeStyle).setPointerEvents(!1), this.hL = this.yv.vr(this.xA).gr(new $t({ thickness: this.xP, fillStyle: this.MP })).setPointerEvents(!1), this.nL = this.yv.In(this.xA).Ih(this.RP).sr(this.OP).setPointerEvents(!1), this.Bf = this.yv.In(this.xA).Ih(this.zP).sr(this.VP).rn("").setPointerEvents(!1), this.oL = this.Zg.In(this.xA).Ih(this.EP).sr(this.NP).setPointerEvents(!1), this.aL = this.Zg.In(this.xA).Ih(this.EP).sr(this.NP).setPointerEvents(!1), this.tL.Fs([this.sL]), this.iL.Fs([this.nL, this.Bf, this.oL, this.aL]), this.lL(), this.addEventListener("resize", (() => {
      this.WP = !0;
    }));
    const h = { backgroundVisible: !0, ...a?.legend };
    this.legend.setOptions(h);
  }
  lL() {
    this.hL.gr(((t) => t.setThickness(this.xP))), this.rL.gr(((t) => t.setThickness(2 * this._P.getThickness() + this.xP)));
  }
  setAnimationsEnabled(t) {
    return this.zr = t, this.PP = t, this.IP = t, this;
  }
  setInterval(t, e) {
    return this.yP = { start: t, end: e }, this.WP = !0, this.yi.Rs(), this;
  }
  getInterval() {
    return this.yP;
  }
  setTickFillStyle(t) {
    return this.NP = typeof t == "function" ? t(this.NP) : t, this.FP.forEach(((e) => {
      e.start.sr(t), e.end.sr(t);
    })), this.oL.sr(t), this.aL.sr(t), this.WP = !0, this.yi.Rs(), this;
  }
  getTickFillStyle() {
    return this.NP;
  }
  setTickFont(t) {
    return this.EP = typeof t == "function" ? t(this.EP) : t, this.FP.forEach(((e) => {
      e.start.Ih(t), e.end.Ih(t);
    })), this.oL.Ih(t), this.aL.Ih(t), this.WP = !0, this.yi.Rs(), this;
  }
  getTickFont() {
    return this.EP;
  }
  setTickFormatter(t) {
    return this.LP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getTickFormatter() {
    return this.LP;
  }
  setValueLabelFillStyle(t) {
    return this.OP = typeof t == "function" ? t(this.OP) : t, this.nL.sr(t), this.WP = !0, this.yi.Rs(), this;
  }
  getValueLabelFillStyle() {
    return this.nL.kh();
  }
  setValueLabelFont(t) {
    return this.RP = typeof t == "function" ? t(this.RP) : t, this.nL.Ih(t), this.WP = !0, this.yi.Rs(), this;
  }
  getValueLabelFont() {
    return this.nL.Fh();
  }
  setValueFormatter(t) {
    return this.DP = typeof t == "string" ? (e) => t : t, this.WP = !0, this.yi.Rs(), this;
  }
  getValueLabel() {
    return this.nL.an() || this.DP;
  }
  setUnitLabelFillStyle(t) {
    return this.VP = typeof t == "function" ? t(this.VP) : t, this.Bf.sr(t), this.WP = !0, this.yi.Rs(), this;
  }
  getUnitLabelFillStyle() {
    return this.Bf.kh();
  }
  setUnitLabelFont(t) {
    return this.zP = typeof t == "function" ? t(this.zP) : t, this.Bf.Ih(t), this.WP = !0, this.yi.Rs(), this;
  }
  getUnitLabelFont() {
    return this.Bf.Fh();
  }
  setUnitLabel(t) {
    return this.Bf.rn(t), this.WP = !0, this.yi.Rs(), this;
  }
  getUnitLabel() {
    return this.Bf.an();
  }
  setNeedleFillStyle(t) {
    return this.MP = typeof t == "function" ? t(this.MP) : t, this.hL.gr(((e) => e.setFillStyle(t))), this.WP = !0, this.yi.Rs(), this;
  }
  getNeedleFillStyle() {
    return this.hL.po().getFillStyle();
  }
  setNeedleThickness(t) {
    return this.xP = t, this.lL(), this.WP = !0, this.yi.Rs(), this;
  }
  getNeedleThickness() {
    return this.xP;
  }
  setNeedleStrokeStyle(t) {
    return this._P = typeof t == "function" ? t(this._P) : t, this.rL.gr(t), this.lL(), this.WP = !0, this.yi.Rs(), this;
  }
  getNeedleStrokeStyle() {
    return this.rL.po();
  }
  setNeedleLength(t) {
    return this.bP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getNeedleLength() {
    return this.bP;
  }
  setBarColor(t) {
    return this.GP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getBarColor() {
    return this.QP;
  }
  setBarGradient(t) {
    return this.BP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getBarGradient() {
    return this.BP;
  }
  setBarStrokeStyle(t) {
    return this.ZP = typeof t == "function" ? t(this.ZP) : t, this.sL.ir(t), this.WP = !0, this.yi.Rs(), this;
  }
  getBarStrokeStyle() {
    return this.sL.hl();
  }
  setBarThickness(t) {
    return this.mP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getBarThickness() {
    return this.mP;
  }
  setAngleInterval(t, e) {
    return Math.abs(t - e) > 360 && (e = t < e ? t + 360 : t - 360), this.Ju = t, this.Qu = e, this.WP = !0, this.yi.Rs(), this;
  }
  getAngleInterval() {
    return { start: this.Ju, end: this.Qu };
  }
  setValue(t) {
    return this.JP && this.yi.Oa(Ot.Go), this.JP = !0, this.M = t, this.IP || (this.Gk = this.M), this.WP = !0, this.yi.Rs(), this;
  }
  getValue() {
    return this.M;
  }
  setValueAnimation(t, e = 1) {
    return this.IP = t, this.jP = Math.max(0, e), this.WP = !0, this.yi.Rs(), this;
  }
  setColorAnimation(t, e = 1) {
    return this.PP = t, this.YP = Math.max(0, e), this.WP = !0, this.yi.Rs(), this;
  }
  setRoundedEdges(t) {
    return this.Vd = t, this.WP = !0, this.yi.Rs(), this;
  }
  getRoundedEdges() {
    return this.Vd;
  }
  setValueIndicators(t) {
    return this.pP = t, this.TP.forEach(((e) => {
      e.dispose();
    })), this.TP.length = 0, this.FP.forEach(((e) => {
      e.start.dispose(), e.end.dispose();
    })), this.FP.length = 0, this.pP.forEach(((e) => {
      const i = new ot({ color: e.color }), s = this.Zg.Vc(this.xA).ir(Et).sr(i).setPointerEvents(!1);
      this.TP.push(s);
      const o = this.Zg.In(this.xA).Ih(this.EP).sr(this.NP).setPointerEvents(!1), n = this.Zg.In(this.xA).Ih(this.EP).sr(this.NP).setPointerEvents(!1);
      this.FP.push({ start: o, end: n });
    })), this.tL.Fs([this.sL, ...this.TP]), this.iL.Fs([this.nL, this.Bf, this.oL, this.aL, ...this.FP.map(((e) => [e.start, e.end])).flat()]), this.WP = !0, this.yi.Rs(), this;
  }
  getValueIndicators() {
    return this.pP;
  }
  setValueIndicatorThickness(t) {
    return this.SP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getValueIndicatorThickness() {
    return this.SP;
  }
  setAutomaticBarColoring(t) {
    return this.CP = !!t, this.WP = !0, this.yi.Rs(), this;
  }
  getAutomaticBarColoring() {
    return this.CP;
  }
  setGlowColor(t) {
    return t === void 0 ? (this.wP = !1, this.KP = void 0) : typeof t == "object" && "auto" in t ? (this.kP = t.auto, t.auto && (this.KP = void 0), t.alpha !== void 0 && (this.UP = t.alpha), this.wP = !0) : (this.KP = t, this.UP = t.getA(), this.kP = !1, this.wP = !0), this.WP = !0, this.yi.Rs(), this;
  }
  getAutomaticGlowColoring() {
    return this.kP;
  }
  setNeedleAlignment(t) {
    return this.HP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getNeedleAlignment() {
    return this.HP;
  }
  setGapBetweenBarAndValueIndicators(t) {
    return this.XP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getGapBetweenBarAndValueIndicators() {
    return this.XP;
  }
  setBarEffect(t) {
    return this.tL.Es(t), this.yi.Rs(), this;
  }
  getBarEffect() {
    return this.tL.Os();
  }
  setLabelEffect(t) {
    return this.iL.Es(t), this.yi.Rs(), this;
  }
  getLabelEffect() {
    return this.iL.Os();
  }
  rr(t) {
    var e;
    if (super.rr(t), super.dv(), this.Gk !== this.M) {
      if (this.IP) {
        const n = 5e-4 * t, a = 3e-3 * t, l = Math.sign(this.M - this.Gk);
        this.Gk = this.Gk + n * l + a * this.jP * (this.M - this.Gk), l !== Math.sign(this.M - this.Gk) ? this.Gk = this.M : this.yi.Rs(!0);
      } else this.Gk = this.M;
      this.WP = !0;
    }
    let i = this.pP.find(((n) => this.Gk >= n.start && this.Gk <= n.end));
    if (i || (this.Gk < this.yP.start ? i = this.pP.find(((n) => n.start === this.yP.start)) : this.Gk > this.yP.end && (i = this.pP.find(((n) => n.end === this.yP.end)))), this.QP = this.CP && i ? i.color : this.GP, this.PP) {
      if (this.qP !== this.QP) {
        const n = this.qP.getR(), a = this.qP.getG(), l = this.qP.getB(), h = this.QP.getR(), u = this.QP.getG(), c = this.QP.getB(), d = Math.sign(h - n), f = Math.sign(u - a), p = Math.sign(c - l), g = 5e-3 * t, y = 3e-3 * t;
        this.qP = N(n + g * d + y * this.YP * (h - n), a + g * f + y * this.YP * (u - a), l + g * p + y * this.YP * (c - l));
        const m = Math.abs(h - this.qP.getR()), A = Math.abs(u - this.qP.getG()), v = Math.abs(c - this.qP.getB());
        m < 1 && A < 1 && v < 1 ? this.qP = this.QP : this.yi.Rs(!0), this.WP = !0;
      }
    } else this.qP = this.QP;
    const s = ui.xv(this.Wr, this.gv), o = this.Ns.reduce(((n, a) => {
      const l = a.Uh(s, this.Hn);
      return { top: Math.max(n.top, l.top), bottom: Math.max(n.bottom, l.bottom), left: Math.max(n.left, l.left), right: Math.max(n.right, l.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    if (o.right === this.JI.right && o.bottom === this.JI.bottom && o.top === this.JI.top && o.left === this.JI.left || (this.WP = !0, this.JI = o), this.WP) {
      let n = wt, a = Pt, l = wt, h = Pt;
      if (new Array(100).fill(0).forEach(((ht, st, bt) => {
        const ct = this.Ju + st / bt.length * (this.Qu - this.Ju), Mt = Math.sin(ct * Math.PI / 180), vt = Math.cos(ct * Math.PI / 180);
        Mt < n && (n = Mt), Mt > a && (a = Mt), vt < l && (l = vt), vt > h && (h = vt);
      })), this.BP ? this.sL.sr(new Gi({ stops: [{ offset: 0, color: Xe("#000000") }, { offset: 1, color: this.qP }], position: { x: 0.5, y: 0.5 } })) : this.sL.sr(new ot({ color: this.qP })), this.wP) {
        const ht = this.kP && i ? this.qP : (e = this.KP) !== null && e !== void 0 ? e : this.$P;
        this.eL.sr(new Gi({ stops: [{ offset: 0, color: ht.setA(this.UP) }, { offset: 1, color: ht.setA(0) }], position: { x: 0.5, y: 0.5 }, extent: hs.farthestSide }));
      } else this.eL.sr(Lt);
      const u = this.LP(this.yP.start), c = this.LP(this.yP.end);
      let d = 0, f = 0;
      const p = this.yi.rh.Pr(u, this.oL.Fh(), this.oL.Lh()), g = this.yi.rh.Pr(c, this.aL.Fh(), this.aL.Lh());
      p.x > d && (d = p.x), p.y > f && (f = p.y), g.x > d && (d = g.x), g.y > f && (f = g.y), this.FP.forEach(((ht, st) => {
        if (st >= this.pP.length) return;
        const bt = this.pP[st], ct = this.LP(bt.start), Mt = this.LP(bt.end), vt = this.yi.rh.Pr(ct, ht.start.Fh(), ht.start.Lh()), mt = this.yi.rh.Pr(Mt, ht.end.Fh(), ht.end.Lh());
        vt.x > d && (d = vt.x), vt.y > f && (f = vt.y), mt.x > d && (d = mt.x), mt.y > f && (f = mt.y);
      }));
      const y = this.pP.length > 0 ? this.SP : 0, m = this.xA.getInnerIntervalPixels();
      ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, o);
      const A = { x: m.x - (this.Hn.left + this.Hn.right), y: m.y - (this.Hn.bottom + this.Hn.top) - s }, v = { x: A.x - o.left - o.right, y: A.y - o.top - o.bottom }, b = { x: this.Hn.left + (A.x + o.left - o.right) / 2, y: this.Hn.bottom + (A.y + o.bottom - o.top) / 2 }, w = y + 2 * this.XP + this.mP / 2, k = d + w, R = f + w, L = R + s, x = v.y - (L + R), M = v.x - (k + k), C = Math.max(0, x < M ? x : M), S = 0.5 * C, E = 0.5 * S, T = (n + a) * E, I = (l + h) * E, F = { x: b.x - I, y: b.y - T }, D = C > 0;
      if (this.sL.setVisible(D), this.TP.forEach(((ht) => ht.setVisible(D))), this.hL.setVisible(D), this.rL.setVisible(D), this.eL.setVisible(D), this.Bf.setVisible(D), this.nL.setVisible(D), this.oL.setVisible(D), this.aL.setVisible(D), this.FP.forEach(((ht) => {
        ht.start.setVisible(D), ht.end.setVisible(D);
      })), !D) return;
      const P = { x: b.x - 0.5 * I, y: b.y - 0.5 * T };
      this.eL.hr(b).uc(0.5 * Math.min(v.x, m.y)), this.nL.hr(P).rn(this.DP(this.Gk));
      let V = this.nL.Bc(), _ = this.Bf.Bc();
      V.y === 0 && (V = this.yi.rh.Pr(this.nL.an(), this.nL.Fh(), this.nL.Lh())), _.y === 0 && (_ = this.yi.rh.Pr(this.Bf.an(), this.Bf.Fh(), this.Bf.Lh())), this.Bf.hr({ x: P.x, y: P.y - V.y - _.y / 4 });
      const O = dl(this.yP, this.Ju, this.Qu, this.Gk, F, S + this.HP * (this.bP / 2 + this.mP / 2)), B = O.angle * (Math.PI / 180), z = 0.5 * this.bP, W = Math.cos(B), G = Math.sin(B);
      this.hL.pr({ x: O.x + z * W, y: O.y + z * G }).yr({ x: O.x - z * W, y: O.y - z * G }), this.rL.pr({ x: O.x + z * W, y: O.y + z * G }).yr({ x: O.x - z * W, y: O.y - z * G });
      const Y = np(F, S, this.Ju, this.Qu, this.mP, this.Vd, !1, !1);
      this.sL.yu(Y).Ti({ min: { x: F.x - S, y: F.y - S }, max: { x: F.x + S, y: F.y + S } });
      const U = F.y + S, $ = F.y - S, Z = F.x + S, q = F.x - S, [Q, nt] = this.yP.start < this.yP.end ? [this.yP.start, this.yP.end] : [this.yP.end, this.yP.start], et = S + 0.5 * this.mP + y / 2 + this.XP, it = et + y / 2;
      this.pP.forEach(((ht, st) => {
        var bt, ct;
        const Mt = ht.start >= Q && ht.end <= nt;
        this.TP[st].setVisible(Mt), this.FP[st].start.setVisible(Mt), this.FP[st].end.setVisible(Mt);
        const vt = dl(this.yP, this.Ju, this.Qu, ht.start, F, it), mt = dl(this.yP, this.Ju, this.Qu, ht.end, F, it), Xt = np(F, et, vt.angle, mt.angle, this.SP, this.Vd, st !== 0, st !== this.pP.length - 1);
        this.TP[st].yu(Xt);
        const Rt = this.yP.start === ht.start || this.yP.end === ht.start, Dt = this.yP.start === ht.end || this.yP.end === ht.end || this.pP.some(((Kt) => Kt.start === ht.end && Kt !== ht));
        this.FP[st].start.hr({ x: vt.x, y: vt.y }).ru({ x: Math.min(1, Math.max(-1, 2 * (vt.x - Z) / (q - Z) - 1)), y: Math.min(1, Math.max(-1, 2 * (vt.y - U) / ($ - U) - 1)) }).rn((bt = ht.startLabel) !== null && bt !== void 0 ? bt : Rt ? "" : this.LP(ht.start)), this.FP[st].end.hr({ x: mt.x, y: mt.y }).ru({ x: Math.min(1, Math.max(-1, 2 * (mt.x - Z) / (q - Z) - 1)), y: Math.min(1, Math.max(-1, 2 * (mt.y - U) / ($ - U) - 1)) }).rn((ct = ht.endLabel) !== null && ct !== void 0 ? ct : Dt ? "" : this.LP(ht.end));
      }));
      const rt = this.pP.some(((ht) => ht.start < ht.end ? this.yP.start >= ht.start && this.yP.start <= ht.end : this.yP.start <= ht.start && this.yP.start >= ht.end)), tt = dl(this.yP, this.Ju, this.Qu, this.yP.start, F, rt ? it : et - this.XP);
      this.oL.hr({ x: tt.x, y: tt.y }).ru({ x: Math.min(1, Math.max(-1, 2 * (tt.x - Z) / (q - Z) - 1)), y: Math.min(1, Math.max(-1, 2 * (tt.y - U) / ($ - U) - 1)) }).rn(u);
      const at = this.pP.some(((ht) => ht.start < ht.end ? this.yP.end >= ht.start && this.yP.end <= ht.end : this.yP.end <= ht.start && this.yP.end >= ht.end)), ut = dl(this.yP, this.Ju, this.Qu, this.yP.end, F, at ? it : et - this.XP);
      this.aL.hr({ x: ut.x, y: ut.y }).ru({ x: Math.min(1, Math.max(-1, 2 * (ut.x - Z) / (q - Z) - 1)), y: Math.min(1, Math.max(-1, 2 * (ut.y - U) / ($ - U) - 1)) }).rn(c), this.WP = !1;
    }
    this.Ns.forEach(((n) => n.rr(s, this.Hn)));
  }
  getMinimumSize() {
    return { x: 150, y: 150 };
  }
  Gg() {
    return [];
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const np = (r, t, e, i, s, o = !0, n = !0, a = !0) => {
  const l = [], h = 0.5 * s, u = e > i, c = Math.sign(e - i), d = -1 * c;
  if (o) {
    const g = h / (2 * Math.PI * t) * 360 + 0.1;
    n && (e += g * d), a && (i += g * c);
  } else e += 0.1 * d, i += 0.1 * c;
  const f = $o(r, t + h, e, i, u);
  if (l.push(...f), o) {
    const g = { x: r.x + t * Math.cos(i * (Math.PI / 180)), y: r.y + t * Math.sin(i * (Math.PI / 180)) };
    let y;
    y = e > i ? $o(g, h, i + 180, i + 360, u) : $o(g, h, i - 180, i - 360, u), l.push(...y);
  }
  const p = $o(r, t - h, i, e, !u);
  if (l.push(...p), o) {
    const g = { x: r.x + t * Math.cos(e * (Math.PI / 180)), y: r.y + t * Math.sin(e * (Math.PI / 180)) };
    let y;
    y = e > i ? $o(g, h, e - 180, e - 360, u) : $o(g, h, e + 180, e + 360, u), l.push(...y);
  }
  return l;
}, $o = (r, t, e, i, s) => {
  e < i && ([e, i] = [i, e]);
  const o = [], n = s ? -2 : 2, a = s ? (c) => c > i : (c) => c < e;
  for (let c = s ? e : i; a(c); c += n) {
    const d = c * (Math.PI / 180), f = r.x + t * Math.cos(d), p = r.y + t * Math.sin(d);
    o.push({ x: f, y: p });
  }
  const l = (s ? i : e) * (Math.PI / 180), h = r.x + t * Math.cos(l), u = r.y + t * Math.sin(l);
  return o.push({ x: h, y: u }), o;
}, dl = (r, t, e, i, s, o) => {
  const [n, a] = r.start < r.end ? [r.start, r.end] : [r.end, r.start], l = Math.max(n, Math.min(a, i)), h = r.start < r.end ? e - t : t - e, u = r.start < r.end ? t + (l - r.start) / (r.end - r.start) * h : t - (l - r.start) / (r.end - r.start) * h, c = u * (Math.PI / 180);
  return { x: s.x + o * Math.cos(c), y: s.y + o * Math.sin(c), angle: Math.round(u) };
};
class Hx extends Rr {
  constructor(t, e, i, s, o, n, a) {
    var l, h, u, c, d, f, p, g, y, m, A, v, b, w, k, R, L, x, M, C, S, E;
    super(t, e, i, e.Av("gaugeChart bg", 0), s, (l = e.yi.xi.linearGaugeChartBackgroundFillStyle) !== null && l !== void 0 ? l : e.yi.xi.gaugeChartBackgroundFillStyle, (h = e.yi.xi.linearGaugeChartBackgroundStrokeStyle) !== null && h !== void 0 ? h : e.yi.xi.gaugeChartBackgroundStrokeStyle, (u = e.yi.xi.linearGaugeChartTitleFont) !== null && u !== void 0 ? u : e.yi.xi.gaugeChartTitleFont, (c = e.yi.xi.linearGaugeChartTitleFillStyle) !== null && c !== void 0 ? c : e.yi.xi.gaugeChartTitleFillStyle, (d = e.yi.xi.linearGaugeChartTitleShadow) !== null && d !== void 0 ? d : e.yi.xi.gaugeChartTitleShadow, n, (f = a?.legend) === null || f === void 0 ? void 0 : f.customLegend), this.M = 0, this.mP = (p = this.xi.linearGaugeChartBarThickness) !== null && p !== void 0 ? p : 50, this.uL = (g = this.xi.linearGaugeChartGradients) === null || g === void 0 || g, this.cL = (y = this.xi.linearGaugeChartColorInterpolation) !== null && y !== void 0 && y, this.IP = !0, this.Gk = this.M, this.LP = (I) => Number.isInteger(I) ? I.toString() : I.toFixed(2), this.DP = (I) => Number.isInteger(I) ? I.toString() : I.toFixed(2), this.EP = (m = this.xi.linearGaugeChartTickFont) !== null && m !== void 0 ? m : this.xi.gaugeChartTickFont, this.dL = this.xi.linearGaugeChartTickShadow, this.RP = (A = this.xi.linearGaugeChartValueLabelFont) !== null && A !== void 0 ? A : this.xi.gaugeChartValueLabelFont, this.fL = this.xi.linearGaugeChartValueLabelShadow, this.OP = (v = this.xi.linearGaugeChartValueLabelFillStyle) !== null && v !== void 0 ? v : this.xi.gaugeChartValueLabelFillStyle, this.NP = (b = this.xi.linearGaugeChartTickFillStyle) !== null && b !== void 0 ? b : this.xi.gaugeChartTickFillStyle, this.jP = 1, this.WP = !1, this.ZP = (w = this.xi.linearGaugeChartBarStrokeStyle) !== null && w !== void 0 ? w : new $t({ thickness: 1, fillStyle: new ot({ color: N(255, 255, 255) }) }), this.JI = Me, this.JP = !1, this.D = new Nt(), this.Qs = a?.orientation === "horizontal" ? jl : ec, this.Ga = a, this.yi.Oa(Ot.Io), this.Wr.rn("Linear Gauge Chart"), this.fv(o, this.xA), this.setAnimationsEnabled(a?.animationsEnabled !== !1), this.tL = this.bs.CA(), this.iL = this.bs.CA().Es(this.xi.effectsText), this.AL = new Fr((() => this.Zg.Od(this.xA).setPointerEvents(!1)), ((I, F, D) => (I.sr(D.fillStyle).ir(D.strokeStyle), F.map(((P) => {
      var V;
      const _ = (V = P.existingMember) !== null && V !== void 0 ? V : I.Qo();
      return _.Gd(P.x1, P.y1, P.x2, P.y2).Nd(P.rounding), _;
    })))), void 0, ((I) => {
      this.tL.Fs(I);
    })), this.gL = typeof this.xi.linearGaugeChartRoundedEdges == "number" ? this.xi.linearGaugeChartRoundedEdges : this.xi.linearGaugeChartRoundedEdges === void 0 || this.xi.linearGaugeChartRoundedEdges === !0 ? 5 : 0, this.vL = new Xi((() => this.Zg.In(this.xA).setPointerEvents(!1))), this.yL = new cr({ warnings: !1, schema: { x: { pattern: null }, y: { pattern: null } } }), this.pL = this.yv.ef(this.xA).gr(Et).sf(Lt).setPointerEvents(!1).qd(this.yL, { x: "x", y: "y" }).df((k = this.xi.linearGaugeChartValueMarkerSize) !== null && k !== void 0 ? k : 20).rf((R = this.xi.linearGaugeChartValueMarkerShape) !== null && R !== void 0 ? R : Je.Arrow).nf((L = a?.orientation === "horizontal" ? this.xi.linearGaugeChartValueMarkerRotationHorizontal : this.xi.linearGaugeChartValueMarkerRotationVertical) !== null && L !== void 0 ? L : -90).uf((x = this.xi.linearGaugeChartValueMarkerStrokeStyle) !== null && x !== void 0 ? x : Et), this.mL = (M = this.xi.linearGaugeChartValueLabelAlignment) !== null && M !== void 0 ? M : 3, this.SL = (C = this.xi.linearGaugeChartValueMarkerAlignment) !== null && C !== void 0 ? C : 2, this.bL = (S = this.xi.linearGaugeChartTickMargin) !== null && S !== void 0 ? S : 5, this.xL = (E = this.xi.linearGaugeChartDefaultRangeColor) !== null && E !== void 0 ? E : this.xi.isDark ? N(255, 255, 255) : N(0, 0, 0), this.ML = { start: 0, end: 10, ranges: [{ _L: !1, start: 0, end: 10, color: this.xL, Ke: void 0 }] }, this.wL(), this.addEventListener("resize", (() => {
      this.WP = !0;
    }));
    const T = { backgroundVisible: !0, ...a?.legend };
    this.legend.setOptions(T);
  }
  wL() {
    this.ML.ranges.forEach(((t, e, i) => {
      var s, o, n;
      const a = i[e + 1];
      this.cL ? t.Ke = new Ci({ angle: ((s = this.Ga) === null || s === void 0 ? void 0 : s.orientation) === "horizontal" ? 90 : 0, stops: [{ offset: 0, color: t.color }, { offset: 1, color: (o = a?.color) !== null && o !== void 0 ? o : t.color }] }) : this.uL ? t.Ke = new Ci({ angle: ((n = this.Ga) === null || n === void 0 ? void 0 : n.orientation) === "horizontal" ? 0 : 90, stops: [{ color: Ki(t.color, N(255, 255, 255), 0.5), offset: 0 }, { color: t.color, offset: 0.35 }, { color: Ki(t.color, N(30, 30, 30), 0.5), offset: 1 }] }) : t.Ke = new ot({ color: t.color });
    }));
  }
  setAnimationsEnabled(t) {
    return this.zr = t, this.IP = t, this;
  }
  setTickMargin(t) {
    return this.bL = t, this.WP = !0, this.yi.Rs(), this;
  }
  getTickMargin() {
    return this.bL;
  }
  setTickFillStyle(t) {
    return this.NP = typeof t == "function" ? t(this.NP) : t, this.WP = !0, this.yi.Rs(), this;
  }
  getTickFillStyle() {
    return this.NP;
  }
  setTickFont(t) {
    return this.EP = typeof t == "function" ? t(this.EP) : t, this.WP = !0, this.yi.Rs(), this;
  }
  getTickFont() {
    return this.EP;
  }
  setTickShadow(t) {
    return this.dL = t, this.WP = !0, this.yi.Rs(), this;
  }
  getTickShadow() {
    return this.dL;
  }
  setTickFormatter(t) {
    return this.LP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getTickFormatter() {
    return this.LP;
  }
  setValueLabelFillStyle(t) {
    return this.OP = typeof t == "function" ? t(this.OP) : t, this.WP = !0, this.yi.Rs(), this;
  }
  getValueLabelFillStyle() {
    return this.OP;
  }
  setValueLabelShadow(t) {
    return this.fL = t, this.WP = !0, this.yi.Rs(), this;
  }
  getValueLabelShadow() {
    return this.fL;
  }
  setValueLabelFont(t) {
    return this.RP = typeof t == "function" ? t(this.RP) : t, this.WP = !0, this.yi.Rs(), this;
  }
  getValueLabelFont() {
    return this.RP;
  }
  setValueFormatter(t) {
    return this.DP = typeof t == "string" ? () => t : t, this.WP = !0, this.yi.Rs(), this;
  }
  setValueMarkerFillStyle(t) {
    return this.pL.tf(t), this.WP = !0, this.yi.Rs(), this;
  }
  getValueMarkerFillStyle() {
    return this.pL.lf();
  }
  setValueMarkerStrokeStyle(t) {
    return this.pL.uf(t), this.WP = !0, this.yi.Rs(), this;
  }
  getValueMarkerStrokeStyle() {
    return this.pL.cf();
  }
  setValueMarkerSize(t) {
    return this.pL.df(t), this.WP = !0, this.yi.Rs(), this;
  }
  getValueMarkerSize() {
    return this.pL.uw();
  }
  setValueMarkerShape(t) {
    return this.pL.rf(t), this.WP = !0, this.yi.Rs(), this;
  }
  getValueMarkerShape() {
    return this.pL.hf();
  }
  setValueMarkerRotation(t) {
    return this.pL.nf(t), this.WP = !0, this.yi.Rs(), this;
  }
  getValueMarkerRotation() {
    return this.pL.af();
  }
  setValueMarkerAlignment(t) {
    return this.SL = t, this.WP = !0, this.yi.Rs(), this;
  }
  getValueMarkerAlignment() {
    return this.SL;
  }
  setValueLabelAlignment(t) {
    return this.mL = t, this.WP = !0, this.yi.Rs(), this;
  }
  getValueLabelAlignment() {
    return this.mL;
  }
  setGradients(t) {
    return this.uL = t, this.wL(), this.WP = !0, this.yi.Rs(), this;
  }
  setColorInterpolation(t) {
    return this.cL = t, this.wL(), this.WP = !0, this.yi.Rs(), this;
  }
  setBarStrokeStyle(t) {
    return this.ZP = typeof t == "function" ? t(this.ZP) : t, this.WP = !0, this.yi.Rs(), this;
  }
  getBarStrokeStyle() {
    return this.ZP;
  }
  setBarThickness(t) {
    return this.mP = t, this.WP = !0, this.yi.Rs(), this;
  }
  getBarThickness() {
    return this.mP;
  }
  setValue(t) {
    return this.JP && this.yi.Oa(Ot.Go), this.JP = !0, this.M = t, this.IP || (this.Gk = this.M), this.WP = !0, this.yi.Rs(), this;
  }
  getValue() {
    return this.M;
  }
  setValueAnimation(t, e = 1) {
    return this.IP = t, this.jP = Math.max(0, e), this.WP = !0, this.yi.Rs(), this;
  }
  setRoundedEdges(t) {
    return this.gL = typeof t == "boolean" ? t ? 5 : 0 : t, this.WP = !0, this.yi.Rs(), this;
  }
  getRoundedEdges() {
    return this.gL;
  }
  setRanges(t) {
    var e, i;
    t = t.sort(((o, n) => {
      var a, l;
      return ((a = o.start) !== null && a !== void 0 ? a : 0) - ((l = n.start) !== null && l !== void 0 ? l : 0);
    }));
    const s = t.map(((o, n) => {
      var a, l;
      const h = t[n - 1], u = t[n + 1], c = o.start !== void 0 ? o.start : h?.end !== void 0 ? h.end : 0, d = o.end !== void 0 ? o.end : (a = u?.start) !== null && a !== void 0 ? a : c;
      return { start: c, end: d, color: (l = o.color) !== null && l !== void 0 ? l : this.xL, Ke: void 0, _L: c === d };
    }));
    return this.ML = { start: (e = s[0].start) !== null && e !== void 0 ? e : 0, end: (i = s[s.length - 1].end) !== null && i !== void 0 ? i : 1, ranges: s }, this.wL(), this.WP = !0, this.yi.Rs(), this;
  }
  getRanges() {
    return this.ML.ranges.slice();
  }
  setBarEffect(t) {
    return this.tL.Es(t), this.yi.Rs(), this;
  }
  getBarEffect() {
    return this.tL.Os();
  }
  setLabelEffect(t) {
    return this.iL.Es(t), this.yi.Rs(), this;
  }
  getLabelEffect() {
    return this.iL.Os();
  }
  rr(t) {
    if (super.rr(t), super.dv(), this.Gk !== this.M) {
      if (this.IP) {
        const s = 5e-4 * t, o = 3e-3 * t, n = Math.sign(this.M - this.Gk);
        this.Gk = this.Gk + s * n + o * this.jP * (this.M - this.Gk), n !== Math.sign(this.M - this.Gk) ? this.Gk = this.M : this.yi.Rs(!0);
      } else this.Gk = this.M;
      this.WP = !0;
    }
    const e = ui.xv(this.Wr, this.gv), i = this.Ns.reduce(((s, o) => {
      const n = o.Uh(e, this.Hn);
      return { top: Math.max(s.top, n.top), bottom: Math.max(s.bottom, n.bottom), left: Math.max(s.left, n.left), right: Math.max(s.right, n.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    if (i.right === this.JI.right && i.bottom === this.JI.bottom && i.top === this.JI.top && i.left === this.JI.left || (this.WP = !0, this.JI = i), this.WP) {
      const s = Jt(this.Gk, this.ML.start, this.ML.end), o = [{ text: this.LP(this.ML.start), font: this.EP, fill: this.NP }, { text: this.LP(this.ML.end), font: this.EP, fill: this.NP }, { text: "0,13579", font: this.RP, fill: this.OP }].map(((k) => Qn(k.fill) ? { x: 0, y: 0 } : this.yi.rh.Pr(k.text, k.font, 0))).reduce(((k, R) => (k.x = Math.max(k.x, R.x), k.y = Math.max(k.y, R.y), k)), { x: 0, y: 0 }), n = this.xA.getInnerIntervalPixels();
      ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, i);
      const a = { x: n.x - (this.Hn.left + this.Hn.right), y: n.y - (this.Hn.bottom + this.Hn.top) - e }, l = { x: a.x - i.left - i.right, y: a.y - i.top - i.bottom }, h = { x: this.Hn.left + (a.x + i.left - i.right) / 2, y: this.Hn.bottom + (a.y + i.bottom - i.top) / 2 }, u = this.Qs.getWidth(l) - this.Qs.getWidth(o), c = u / (this.ML.end - this.ML.start), d = this.AL.rg(), f = this.vL.rg(), p = this.Qs.getHeight(h) - this.mP / 2, g = this.Qs.getHeight(h) + this.mP / 2;
      this.ML.ranges.forEach(((k, R, L) => {
        var x, M;
        if (k._L) return;
        const C = L[R + 1], S = this.Qs.getWidth(h) - u / 2 + (k.start - this.ML.start) * c, E = this.Qs.getWidth(h) - u / 2 + (k.end - this.ML.start) * c;
        let T = { extent: this.gL, c_x1_y1: !1, c_x1_y2: !1, c_x2_y1: !1, c_x2_y2: !1 };
        this.gL > 0 && (R === 0 && (((x = this.Ga) === null || x === void 0 ? void 0 : x.orientation) === "horizontal" ? (T.c_x1_y1 = !0, T.c_x1_y2 = !0) : (T.c_x1_y1 = !0, T.c_x2_y1 = !0)), C && !C._L || (((M = this.Ga) === null || M === void 0 ? void 0 : M.orientation) === "horizontal" ? (T.c_x2_y1 = !0, T.c_x2_y2 = !0) : (T.c_x1_y2 = !0, T.c_x2_y2 = !0)));
        const I = this.Qs.toPoint(S, p), F = this.Qs.toPoint(E, g);
        d.add({ Si: R, x1: I.x, x2: F.x, y1: I.y, y2: F.y, rounding: T }, { strokeStyle: this.ZP, fillStyle: k.Ke });
      }));
      const y = Cn(this.ML.ranges.map(((k) => [k.start, k.end])).flat()), m = p - this.bL, A = [];
      y.forEach(((k) => {
        const R = this.LP(k), L = f.add().sr(this.NP).Ih(this.EP).en(this.dL).rn(R), x = this.Qs.getWidth(h) - u / 2 + (k - this.ML.start) * c;
        L.hr(this.Qs.toPoint(x, m)).ru(this.Qs.toPoint(0, 1)), A.push(L);
      }));
      const v = this.Qs.toPoint(this.Qs.getWidth(h) - u / 2 + (s - this.ML.start) * c, p + (this.SL + 1) / 2 * (g - p));
      this.yL.setSamples({ x: [v.x], y: [v.y] });
      const b = this.Qs.toPoint(this.Qs.getWidth(h) - u / 2 + (s - this.ML.start) * c, p + (this.mL + 1) / 2 * (g - p)), w = this.DP(this.Gk);
      A.push(f.add().sr(this.OP).Ih(this.RP).en(this.fL).rn(w).hr({ x: b.x, y: b.y }).ru(this.Qs.toPoint(0, -1))), this.iL.Fs(A), d.finishPlot(), f.finishPlot(), this.WP = !1;
    }
    this.Ns.forEach(((s) => s.rr(e, this.Hn)));
  }
  getMinimumSize() {
    return { x: 150, y: 150 };
  }
  Gg() {
    return [];
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class kE extends Ax {
  constructor(t, e, i, s, o, n, a, l, h, u, c) {
    super(t, e, i, s, o, n, a, l, h, u), this.kL = c;
  }
  setLabelAlignment(t) {
    return this.kL = t, this.Rs(), this;
  }
  getLabelAlignment() {
    return this.kL;
  }
}
class DE extends eo {
  constructor(t, e, i, s, o, n, a) {
    let l;
    super(t, { yn: () => t.CL ? t.CL[this.key].max : void 0, vn: () => t.CL ? t.CL[this.key].min : void 0, Sn: () => {
    } }, n, e, i, { numeric: e.parallelCoordinateAxisNumericTicks || e.yAxisNumericTicks, datetime: e.parallelCoordinateAxisDateTimeTicks || e.yAxisDateTimeTicks, time: e.parallelCoordinateAxisTimeTicks || e.yAxisTimeTicks }, { type: "linear" }), this.TL = [], this.Kf = [], this.FL = 8, this.ci = !1, this.D = new Nt(), this.chart = t, this.key = s, this.userID = o, this.bs = this.chart.yi.bs.xs(this, {}), this.Js = a, this.IL = a.er(t.PL).sr(this.xi.parallelCoordinateAxisBackgroundFillStyle || Lt).ir(Et).setPointerEvents(!1), this.qr = a.In(t.PL).Ih(this.xi.parallelCoordinateAxisTitleFont || this.xi.yAxisTitleFont).sr(this.xi.parallelCoordinateAxisTitleFillStyle || this.xi.yAxisTitleFillStyle).setPointerEvents(!1).Tn(Me).Fn(Me), this.Bh = this.bs.CA([this.qr]).Es(e.effectsText), this.JF = a.vr(t.PL).gr(e.parallelCoordinateAxisStrokeStyle || e.yAxisStrokeStyle), this.setAnimationsEnabled(!1), this.addEventListener("intervalchange", ((h) => {
      t.LL(this, h.start, h.end);
    })), this.JF.addEventListener("pointerenter", (() => {
      var h, u;
      !((u = (h = this.chart.getUserInteractions().rangeSelectors) === null || h === void 0 ? void 0 : h.create) === null || u === void 0) && u.doubleClickAxis && (l = this.chart.engine.setMouseStyle(Gt.Point));
    })), this.JF.addEventListener("pointerleave", (() => {
      l = this.chart.engine.restoreMouseStyle(l);
    })), this.JF.addEventListener("dblclick", ((h) => {
      var u, c;
      h.defaultPrevented || !((c = (u = this.chart.getUserInteractions().rangeSelectors) === null || u === void 0 ? void 0 : u.create) === null || c === void 0) && c.doubleClickAxis && (this.addRangeSelector(), It(h));
    })), this.setTitle(s);
  }
  setBackgroundFillStyle(t) {
    return this.IL.sr(t), this.Js.Rs(), this;
  }
  getBackgroundFillStyle() {
    return this.IL.kh();
  }
  setStrokeStyle(t) {
    const e = typeof t == "function" ? t(this.JF.po()) : t, i = e.getFillStyle();
    return Ve(i) ? (this.BL = i.lut, this.chart.DL = !0) : this.BL = void 0, this.JF.gr(e), this.chart.yi.Rs(), this;
  }
  getStrokeStyle() {
    return this.JF.po();
  }
  setTickStrategy(t, e) {
    return super.ph(t, e);
  }
  getTickStrategy() {
    return this.Dr;
  }
  addRangeSelector() {
    const t = this.jh(), e = this.Js.er(this.chart.PL).sr(this.xi.parallelCoordinateAxisRangeSelectorFillStyle || this.xi.dataGridScrollBarFillStyle).ir(this.xi.parallelCoordinateAxisRangeSelectorStrokeStyle || this.xi.dataGridScrollBarStrokeStyle);
    let i;
    const s = (l) => {
      var h, u;
      !((u = (h = this.chart.getUserInteractions().rangeSelectors) === null || h === void 0 ? void 0 : h.move) === null || u === void 0) && u.drag && (i = this.chart.engine.setMouseStyle(Gt.Vertical, i));
    }, o = (l) => {
      i = this.chart.engine.restoreMouseStyle(i);
    };
    e.addEventListener("pointermove", s), e.addEventListener("pointerleave", o), e.addEventListener("pointerdown", ((l) => {
      var h, u;
      if (!(!((u = (h = this.chart.getUserInteractions().rangeSelectors) === null || h === void 0 ? void 0 : h.move) === null || u === void 0) && u.drag)) return;
      const c = this.chart.getCursorMode();
      let d;
      this.chart.setCursorMode(void 0);
      const f = this.chart.yi.ul(l), p = xt({ x: f.engineX, y: f.engineY }, this.chart.yi.ai, this.chart.PL), g = this.chart.PL.y.Qt(e.Xi(), 10), y = this.chart.PL.y.Qt(e.Zi(), -10);
      d = p.y <= g ? "scaleMin" : p.y >= y ? "scaleMax" : "move", It(l);
      let m = l;
      const A = (b) => {
        if (this.EL === void 0) return;
        const w = 0.05 * Math.abs(this.Sh - this.mh), k = (b.clientX, m.clientX, b.clientY - m.clientY);
        if (m = b, d === "move") {
          const R = n.max - n.min, L = this.chart.RL(n.max, this.EL, this).y, x = this.chart.PL.y.Qt(L, -k), M = this.chart.OL(x, this.EL, this);
          n.max = Jt(M, Math.max(this.mh, this.Sh), Math.min(this.mh, this.Sh) + R), n.min = n.max - R;
        } else if (d === "scaleMax") {
          const R = this.chart.RL(n.max, this.EL, this).y, L = this.chart.PL.y.Qt(R, -k), x = this.chart.OL(L, this.EL, this);
          n.max = Jt(x, n.min + w, Math.max(this.mh, this.Sh));
        } else if (d === "scaleMin") {
          const R = this.chart.RL(n.min, this.EL, this).y, L = this.chart.PL.y.Qt(R, -k), x = this.chart.OL(L, this.EL, this);
          n.min = Jt(x, n.max - w, Math.min(this.mh, this.Sh));
        }
        this.chart.zL(), It(b);
      }, v = (b) => {
        b.pointerId === l.pointerId && (this.chart.setCursorMode(c), e.addEventListener("pointermove", s), e.addEventListener("pointerleave", o), H.removeEventListener("pointermove", A), H.removeEventListener("pointerup", v), i = this.chart.engine.restoreMouseStyle(i));
      };
      e.removeEventListener("pointermove", s), e.removeEventListener("pointerleave", o), H.addEventListener("pointermove", A), H.addEventListener("pointerup", v);
    })), e.addEventListener("dblclick", ((l) => {
      var h, u;
      if (!(!((u = (h = this.chart.getUserInteractions().rangeSelectors) === null || h === void 0 ? void 0 : h.dispose) === null || u === void 0) && u.doubleClick)) return;
      const c = this.TL.indexOf(n);
      c >= 0 && this.TL.splice(c, 1), n.shape.dispose(), this.chart.zL(), It(l);
    }));
    const n = { min: t.min + 0.25 * (t.max - t.min), max: t.max - 0.25 * (t.max - t.min), shape: e };
    this.TL.push(n), this.chart.zL();
    const a = { setInterval: (l, h) => (n.min = Math.min(l, h), n.max = Math.max(l, h), this.chart.zL(), a), setPointerEvents: (l) => (e.setPointerEvents(l), a), dispose: () => {
      const l = this.TL.indexOf(n);
      return l >= 0 && (this.TL.splice(l, 1), this.chart.zL()), a;
    } };
    return a;
  }
  addCustomTick() {
    const t = new kE((() => this.chart.yi.Rs()), (() => {
      const e = this.Kf.indexOf(t);
      e >= 0 && this.Kf.splice(e, 1);
    }), (this.xi.parallelCoordinateAxisNumericTicks || this.xi.yAxisNumericTicks).majorTickStyle.tickStyle, (this.xi.parallelCoordinateAxisNumericTicks || this.xi.yAxisNumericTicks).majorTickStyle.tickLength, (this.xi.parallelCoordinateAxisNumericTicks || this.xi.yAxisNumericTicks).majorTickStyle.gridStrokeStyle, (this.xi.parallelCoordinateAxisNumericTicks || this.xi.yAxisNumericTicks).majorTickStyle.tickPadding, (this.xi.parallelCoordinateAxisNumericTicks || this.xi.yAxisNumericTicks).majorTickStyle.labelRotation, (this.xi.parallelCoordinateAxisNumericTicks || this.xi.yAxisNumericTicks).majorTickStyle.labelFillStyle, (this.xi.parallelCoordinateAxisNumericTicks || this.xi.yAxisNumericTicks).majorTickStyle.labelFont, ((e) => this.formatValue(e)), (this.xi.parallelCoordinateAxisNumericTicks || this.xi.yAxisNumericTicks).majorTickStyle.labelAlignment);
    return this.Kf.push(t), this.chart.yi.Rs(), t;
  }
  getCustomTicks() {
    return [...this.Kf];
  }
  rr(t) {
    this.EL = t.parallelAxisIndex;
    const e = Math.min(this.mh, this.Sh), i = Math.max(this.mh, this.Sh);
    for (const [n, a] of this.Er) for (const [, l] of a) {
      const h = t.ticksInfo.get(l);
      h && (t.plotAxisLines.add({ positions: [h.positionTicklineStart, h.positionTicklineEnd] }, { lineStyle: n.Lr.tickStyle }), l.Gh.hr(h.labelPosition).ru(h.labelAlignment).Ph(h.labelRotation).Ql(h.labelOffset.x, h.labelOffset.y));
    }
    this.Kf.forEach(((n) => {
      if (!n.di || n.M < e || n.M > i) return;
      const a = this.VL(t.parallelAxisIndex, t.halfAxisThickness, n.M, n.Hv, n.Xv, n.kL);
      t.plotAxisLines.add({ positions: [a.positionTicklineStart, a.positionTicklineEnd] }, { lineStyle: n.Yv }), t.plotAxisText.add().hr(a.labelPosition).ru(a.labelAlignment).sr(n.Zv).Ih(n.Jv).rn(n.yo(n.M)).Ph(n.If).setPointerEvents(n.ui);
    })), this.JF.pr({ x: t.parallelAxisIndex, y: 0 }).yr({ x: t.parallelAxisIndex, y: 1 }), this.qr.hr({ x: t.parallelAxisIndex, y: this.chart.PL.y.Qt(0, -(t.halfAxisThickness + this.FL)) }).Ph(this.getTitleRotation()).ru({ x: 0, y: 1 });
    const s = t.parallelAxisIndex === 0 ? t.parallelAxisIndex : this.chart.PL.x.Qt(t.parallelAxisIndex, -1.2 * t.EA);
    this.IL.hr({ x: s, y: 0 }).K({ x: t.parallelAxisIndex - s, y: 1 });
    const o = this.chart.PL.ni();
    this.TL.forEach(((n) => {
      const a = this.chart.RL(n.min, t.parallelAxisIndex, this), l = this.chart.RL(n.max, t.parallelAxisIndex, this), h = { x: t.parallelAxisIndex - 10 * o.x * 0.5, y: a.y }, u = t.parallelAxisIndex + 10 * o.x * 0.5, c = l.y;
      n.shape.hr(h).K({ x: u - h.x, y: c - h.y });
    }));
  }
  G() {
    this.IL.dispose(), this.qr.dispose(), this.JF.dispose(), this.TL.forEach(((t) => t.shape.dispose())), this.TL.length = 0, this.Dh(), this.qh(), this.ci = !0, this.D.R("dispose", {});
  }
  isDisposed() {
    return this.ci;
  }
  VL(t, e, i, s, o, n) {
    const a = this.chart.PL.Qt({ x: t, y: (i - this.mh) / (this.Sh - this.mh) }, { x: 0 - e, y: 0 }), l = this.chart.PL.Qt(a, { x: -s, y: 0 });
    return { positionTicklineStart: a, positionTicklineEnd: l, labelPosition: this.chart.PL.Qt(l, { x: -o, y: 0 }), labelAlignment: { x: 1, y: n } };
  }
  Wh(t) {
    const e = this.JF.po();
    return { halfAxisThickness: Oi(e) ? e.getThickness() / 2 : 0 };
  }
  Qh(t, e, i, s, o) {
    const n = e.Lr, a = this.getInterval();
    return { ...this.VL(s.parallelAxisIndex, o.halfAxisThickness, t, n.getTickLength(), n.getTickPadding(), 2 * (t - a.start) / (a.end - a.start) - 1), keyValue: t, tickLevel: e, labelText: i, labelRotation: n.labelRotation, labelOffset: { x: 0, y: 0 } };
  }
  hn(t, e) {
    return new Wa(e, t, this.Js, this.chart.PL);
  }
  tn(t, e, i) {
    const s = this.qr && this.qr.an().length > 0 && this.getTitleFillStyle() !== Lt ? this.qr.Uh().Bc() : { x: 0, y: 0 };
    let o = 0;
    this.Er.forEach(((h, u) => {
      const c = u.Lr.tickLength + u.Lr.tickPadding;
      h.forEach(((d) => {
        if (!d.Gh.getVisible()) return void (o = Math.max(o, c));
        const f = c + d.Gh.Uh().Bc().x;
        o = Math.max(o, f);
      }));
    }));
    const n = this.Kf.reduce(((h, u) => Math.max(h, u.di ? this.chart.yi.rh.Pr(u.yo(u.M), u.Jv, u.If).x + u.Hv + u.Xv : 0)), 0);
    o = Math.max(o, n);
    const a = s.y + this.FL;
    o = Math.max(o, s.x / 2);
    const l = o;
    return { EA: o, NL: a, GL: s.x, Of: l, ticksInfo: e, updatedTicks: i };
  }
  ih() {
    return this.chart.PL;
  }
  xn(t, e) {
    return Sa(t, e, this.ai);
  }
  wn(t, e, i) {
    return { start: t, end: e };
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
  setPointerEvents(t) {
    return this.D.setPointerEvents(t), this;
  }
  getPointerEvents() {
    return this.D.getPointerEvents();
  }
}
class FE extends gh {
  constructor(t, e, i, s, o) {
    super(t, e, i, s), this.Vs = "Parallel Coordinate Series", this.$L = !1, this.D = new Nt(), this.chart = t;
    const n = o?.automaticColorIndex !== void 0 ? o.automaticColorIndex : this.chart.getSeries().length;
    this.UL = ue(this.xi.parallelCoordinateChartSeriesColor, n) || (() => {
      const a = ue(this.xi.lineSeriesStrokeStyle, n).getFillStyle();
      return (de(a) ? a.getColor() : void 0) || N(255, 255, 0);
    })(), this.addEventListener("visiblechange", ((a) => {
      this.chart.jL();
    })), this.addEventListener("dispose", ((a) => {
      this.chart.jL();
    })), this.setHighlightOnHover(!1);
  }
  setData(t) {
    const e = this.YL !== void 0;
    return this.YL = this.chart.HL(t), e && this.chart.WL(), this;
  }
  getData() {
    return this.YL;
  }
  setColor(t) {
    const e = typeof t == "function" ? t(this.UL) : t;
    return e === this.UL || (this.UL = e, this.chart.yi.Rs(), this.chart.XL(this)), this;
  }
  getColor() {
    return this.UL;
  }
  Uv() {
    return this.getAutoScrollingEnabled();
  }
  Dv() {
  }
  rr() {
  }
  Ev() {
  }
  nr() {
    return { fill: new ot({ color: this.UL }) };
  }
  Pv() {
    return super.Pv() && !this.$L;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
class Yx extends $a {
  constructor(t, e, i, s, o, n, a) {
    var l, h, u;
    super(t, e, i, e.Av("parallelAxisChart bg", 0), s, e.yi.xi.parallelCoordinateChartBackgroundFillStyle || e.yi.xi.chartXYBackgroundFillStyle, e.yi.xi.parallelCoordinateChartBackgroundStrokeStyle || e.yi.xi.chartXYBackgroundStrokeStyle, e.yi.xi.parallelCoordinateChartTitleFont || e.yi.xi.chartXYTitleFont, e.yi.xi.parallelCoordinateChartTitleFillStyle || e.yi.xi.chartXYTitleFillStyle, e.yi.xi.parallelCoordinateChartTitleShadow || e.yi.xi.chartXYTitleShadow, n, (l = a?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.axes = [], this.ZL = !0, this.JL = Vo(), this.QL = /* @__PURE__ */ new Map(), this.KL = this.xi.parallelCoordinateChartSeriesColorUnselected || N(255, 255, 255, 30), this.qL = le({ resolution: 32 }), this.DL = !1, this.tB = !1, this.iB = !0, this.sB = !1, this.eB = !1, this.rB = !1, this.hB = !1, this.ka = (f) => {
      this.PL.K(f.engineWidth, f.engineHeight);
    }, this.D = new Nt(), this.Lk = e.nS("parallelAxisChart series", 0), this.nB = e.nS("parallelAxisChart labels", 1), this.Wr.rn("Parallel Coordinate Chart"), this.yi.Oa(Ot.Yo), this.PL = this.Kg.d2({ scaleXYConstructor: we }).si(0, 1), this.fv(o, this.PL), this.Yy = this.Zg.er(this.PL).hr({ x: 0, y: 0 }).K({ x: 0, y: 1 }).sr(this.xi.parallelCoordinateChartSeriesBackgroundFillStyle || this.xi.chartXYSeriesBackgroundFillStyle).ir(Et).setPointerEvents(!0), this.Hy = this.Zg.er(this.PL).hr({ x: 0, y: 0 }).K({ x: 0, y: 1 }).sr(Lt).ir(this.xi.parallelCoordinateChartSeriesBackgroundStrokeStyle || this.xi.chartXYBackgroundStrokeStyle).setPointerEvents(!1), super.jy(this.Yy, this.Hy), this.setSeriesBackgroundEffect(!1), this.oB = new $t({ thickness: (h = this.xi.parallelCoordinateChartSeriesLineThickness) !== null && h !== void 0 ? h : 2, fillStyle: new md() }), this.aB = new $t({ thickness: (u = this.xi.parallelCoordinateChartSeriesLineThickness) !== null && u !== void 0 ? u : 2, fillStyle: new ot({ color: this.xi.parallelCoordinateChartSeriesColorUnselected }) }), this.lB = this.JL.Ji(this.Lk.GA(this.PL)).gr(this.oB), this.lB._c = 5e4, this.uB = this.Lk.GA(this.PL).gr(this.xi.parallelCoordinateChartPointedSeriesLineStyle || ue(this.xi.lineSeriesStrokeStyle, 0)).setPointerEvents(!1), this.cB = new Xi((() => this.nB.In(this.PL))), this.dB = new Fr((() => this.nB.GA(this.PL).setPointerEvents(!1)), ((f, p, g) => (f.Vi().gr(g.lineStyle), p.map((({ positions: y }) => f.Qo().UA(y[0], y[1]))))));
    const c = e.fS(), d = $e(a ? a.cursorBuilder : void 0, Rg);
    this.AS = Xr(this, c, d.zm(c, this.uiScale, this.uiScale, ie, this.xi), this, "show-nearest", LE, (() => 0)), this.addEventListener("resize", this.ka), a?.legend !== void 0 && this.legend.setOptions(a.legend);
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  addCursor(t = Rg) {
    const e = this.tv(), i = t.zm(e, this.uiScale, this.uiScale, this.Jg(e), this.xi);
    return this.cv(i), i;
  }
  setUnselectedSeriesColor(t) {
    return this.KL = typeof t == "function" ? t(this.KL) : t, this.aB = new $t({ thickness: this.getSeriesStrokeThickness(), fillStyle: new ot({ color: this.KL }) }), this.yi.Rs(), this;
  }
  getUnselectedSeriesColor() {
    return this.KL;
  }
  setPointedSeriesStrokeStyle(t) {
    return this.uB.gr(t), this.yi.Rs(), this;
  }
  getPointedSeriesStrokeStyle() {
    return this.uB.po();
  }
  setSpline(t, e) {
    return t ? this.qL.C({ resolution: e?.resolution !== void 0 ? e.resolution : 32 }) : this.qL.C(void 0), this.yi.Rs(), this;
  }
  setAxes(t) {
    const e = Array.isArray(t) ? t.map(((o, n) => ({ key: o, id: n }))) : typeof t == "object" ? Object.entries(t).map(((o, n) => ({ key: o[0], id: o[1] }))) : void 0;
    if (!e) return this;
    const i = e.filter(((o) => this.axes.find(((n) => n.key === o.key)) === void 0)), s = this.axes.filter(((o) => e.find(((n) => o.key === n.key)) === void 0));
    return i.forEach(((o) => {
      const n = this.fB(), a = new DE(this, this.xi, !this.zr, o.key, o.id, n, this.nB), l = () => {
        this.iB = !0;
      };
      a.addEventListener("visiblechange", l), a.addEventListener("dispose", (() => a.removeEventListener("visiblechange", l))), this.axes.push(a);
    })), s.forEach(((o) => {
      o.G();
      const n = this.axes.indexOf(o);
      n >= 0 && this.axes.splice(n, 1);
    })), this.axes = e.map(((o) => this.axes.find(((n) => n.key === o.key)))), this.iB = !0, this.CL = void 0, this.yi.Rs(), this;
  }
  getAxis(t) {
    const e = this.AB(t);
    if (!e) throw new Error(`ParallelAxisChart.getAxis | no such axis: "${t}". Found: ${this.axes.map(((i) => i.userID !== void 0 ? `${i.key}, ${i.userID}` : i.key)).join(", ")}`);
    return e;
  }
  hasAxis(t) {
    return this.AB(t) !== void 0;
  }
  addSeries(t) {
    var e, i;
    const s = new FE(this, this.$y, this.xi, this.yi.bs, t);
    return super.Wy(s, { ...t, legend: { ...t?.legend, show: (i = (e = t?.legend) === null || e === void 0 ? void 0 : e.show) !== null && i !== void 0 && i } }), this.eB = !0, this.CL = void 0, this.yi.Rs(), s;
  }
  setSeriesStrokeThickness(t) {
    return this.oB = this.oB.setThickness(t), this.aB = this.aB.setThickness(t), this.lB.gr(this.oB), this.yi.Rs(), this;
  }
  getSeriesStrokeThickness() {
    return this.oB.getThickness();
  }
  setLUT(t) {
    return this.Nf = t, this.Nf && this.Nf.lut.units.length === 0 && (this.Nf.lut = this.Nf.lut.setUnits(this.Nf.axis.getTitle())), this.Ns.forEach(((e) => {
      e.Vg() && e.add(this);
    })), this.hB = !0, this.Ns.forEach(((e) => e.Gs())), this.yi.Rs(), this;
  }
  rr(t) {
    super.rr(t);
    const e = this.axes.filter(((h) => h.getVisible()));
    this.PL.ii(0, e.length - 1), this.Yy.K({ x: e.length - 1, y: 1 }), this.Hy.K({ x: e.length - 1, y: 1 });
    const i = this.CL === void 0;
    if (!this.CL) {
      const h = {};
      e.forEach(((u) => {
        h[u.key] = { min: wt, max: Pt };
      })), this.Ny.forEach(((u) => {
        u.YL && Object.entries(u.YL).forEach((([c, d]) => {
          const f = h[c];
          f && !Number.isNaN(d) && (f.min = Math.min(f.min, d), f.max = Math.max(f.max, d));
        }));
      })), this.CL = h;
    }
    if (this.rB || this.sB || this.eB) {
      const h = e.map(((c, d) => c.TL));
      this.Ny.forEach(((c) => {
        const d = c.YL;
        if (!d) return;
        let f = !1;
        for (let p = 0; p < e.length; p += 1) {
          const g = e[p], y = h[p], m = y.find(((A) => Ii(d[g.key], A.min, A.max))) !== void 0;
          if (y.length > 0 && !m) {
            f = !0;
            break;
          }
        }
        c.$L = f;
      }));
      const u = this.Ny.filter(((c) => !c.$L));
      this.D.R("seriesselect", { selectedSeries: u });
    }
    for (const h of this.Ny) h.Dv();
    for (const h of this.Ny) h.rr();
    super.dv();
    const s = this.yi.Hs(this.Yy) || this.Ny.find(((h) => h.getPointed())) !== void 0 ? this.gB() : void 0;
    this.AS.rr(!1, this.Ny, void 0, { explicitTarget: s, afterCursorPointedAt: (h) => {
      const u = this.yi.Ra();
      if (h.length > 1 && u) {
        const c = this.yi.ul(u);
        this.AS.jw.Tm({ x: c.engineX, y: c.engineY }, this.yi.ai);
      }
    } });
    const o = ui.xv(this.Wr, this.gv), n = this.Ns.reduce(((h, u) => {
      const c = u.Uh(o, this.Hn);
      return { top: Math.max(h.top, c.top), bottom: Math.max(h.bottom, c.bottom), left: Math.max(h.left, c.left), right: Math.max(h.right, c.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    if (ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, n), e.length >= 2) {
      const h = this.cB.rg(), u = this.dB.rg(), c = e.map(((f, p) => (f.bn(), f.Uh({ plotAxisLines: u, plotAxisText: h, physicalAxisSize: this.PL.y.Ct(), parallelAxisIndex: p }))));
      this.PL.qt([this.dt.left + this.Hn.left + c[0].Of + n.left, this.dt.right + this.Hn.right + c[c.length - 1].GL / 2 + n.right]), this.PL.ti([this.dt.bottom + this.Hn.bottom + c.reduce(((f, p) => Math.max(f, p.NL)), 0) + n.bottom, this.dt.top + this.Hn.top + o + n.top]), c.forEach(((f, p) => e[p].rr(f))), h.finishPlot(), u.finishPlot(), (i || this.DL) && e.forEach(((f, p) => {
        if (!f.BL) return;
        const g = f.BL.steps.map(((m) => ({ ...m, value: this.RL(m.value, p, f).y }))), y = f.BL.setSteps(g);
        f.JF.gr(((m) => m.setFillStyle(new kA({ lookUpProperty: "y", lut: y }))));
      }));
      const d = this.iB || this.sB || this.ZL || this.qL.u;
      d && (this.lB.Vi(), this.JL.Vi(), this.QL.clear(), this.Ny.forEach(((f) => {
        const p = f.YL;
        if (!f.getVisible() || !p) return;
        const g = this.vB(f, p, e, this.lB, this.JL);
        this.QL.set(f, g), f.Ps(g);
      }))), (d || this.rB || this.hB || this.sB) && this.yB(this.Ny), !d && this.eB && this.Ny.forEach(((f) => {
        if (f.vs.length > 0) return;
        const p = f.YL;
        if (!f.getVisible() || !p) return;
        const g = this.vB(f, p, e, this.lB, this.JL);
        this.QL.set(f, g), f.Ps(g), this.yB([f]);
      })), this.Ny.find(((f) => f.YL && Object.keys(f.YL).length > 0)) && (this.tB = !0);
    }
    const a = s?.length === 1 ? s[0] : void 0;
    (a !== this.pB || this.sB) && (this.uB.Vi(), a && a.series.YL ? (this.vB(a.series, a.series.YL, e, this.uB, void 0), this.lB.gr(this.aB)) : this.lB.gr(this.oB));
    const l = Af(this.PL.x.wt(), this.PL.y.wt(), this.PL.x.Ct(), this.PL.y.Ct());
    this.Lk.Qm(l), this.Ns.forEach(((h) => h.rr(o, this.Hn)));
    for (const h of this.Ny) h.Ev();
    this.ZL = !1, this.rB = !1, this.iB = !1, this.sB = !1, this.eB = !1, this.hB = !1, this.qL.u = !1, this.DL = !1, this.pB = a;
  }
  yB(t) {
    const e = this.Nf && { lut: this.Nf.lut, key: this.Nf.axis.key };
    t.forEach(((i) => {
      const s = i.YL, o = this.QL.get(i);
      if (!s || !o) return;
      let n;
      if (i.$L) n = this.KL;
      else if (e) {
        const a = s[e.key], l = this.CL && this.CL[e.key];
        n = e.lut.getColors(a, l);
      } else n = i.UL;
      o.forEach(((a) => a.gP(n)));
    }));
  }
  jL() {
    this.sB = !0, this.yi.Rs();
  }
  WL() {
    this.tB && this.yi.Oa(Ot.Go), this.sB = !0, this.yi.Rs();
  }
  AB(t) {
    return this.axes.find(((e) => e.key === t)) || this.axes.find(((e) => e.userID === t));
  }
  fB() {
    return ki.d1({ scale1DConstructor: ts, dimension: "x" }).Z(0, 1);
  }
  HL(t) {
    if (this.CL = void 0, this.yi.Rs(), Array.isArray(t)) {
      const e = {};
      return t.forEach(((i, s) => {
        var o;
        if (typeof i == "number") {
          const n = (o = this.axes[s]) === null || o === void 0 ? void 0 : o.key;
          if (!n) throw new Error("ParallelCoordinateSeries Axis count doesnt match supplied data");
          e[n] = i;
        } else typeof i == "object" && (e[i.key] = i.value);
      })), e;
    }
    if (typeof t == "object") return t;
    throw new Error("ParallelCoordinateSeries unidentified data format");
  }
  LL(t, e, i) {
    this.ZL = !0, this.yi.Rs();
  }
  RL(t, e, i) {
    return { x: e, y: (t - i.ai.$) / (i.ai.U - i.ai.$) };
  }
  OL(t, e, i) {
    const s = i.getInterval();
    return s.start + t * (s.end - s.start);
  }
  XL(t) {
    this.hB = !0, this.yi.Rs();
  }
  zL() {
    this.rB = !0, this.yi.Rs();
  }
  getSeries() {
    return this.Ny.slice();
  }
  Gg() {
    return [this];
  }
  Ws() {
    return this.Nf ? { lut: this.Nf.lut } : void 0;
  }
  getMinimumSize() {
    return { x: 200, y: 200 };
  }
  forEachAxis(t) {
    return this.axes.slice().forEach(((e) => t(e))), this;
  }
  dispose() {
    return super.dispose(), this.axes.forEach(((t) => t.G())), this.AS.G(), this.Lk.G(), this.nB.G(), this;
  }
  vB(t, e, i, s, o) {
    const n = [];
    let a;
    for (let l = 0; l < i.length; l += 1) {
      const h = i[l], u = e[h.key], c = this.RL(u, l, h), d = this.qL.T();
      if (d) {
        if (a !== void 0) {
          const f = d.resolution;
          let p;
          for (let g = 0; g <= f; g += 1) {
            const y = (g - 1) / f, m = g / f, A = m < 0.5 ? 4 * m * m * m : 1 - (-2 * m + 2) ** 3 / 2;
            if (p !== void 0) {
              const v = { x: a.x + y * (c.x - a.x), y: a.y + p * (c.y - a.y) }, b = { x: a.x + m * (c.x - a.x), y: a.y + A * (c.y - a.y) }, w = s.Qo();
              o && o.Ki(w, t), n.push(w), w.UA(v, b);
            }
            p = A;
          }
        }
      } else if (a !== void 0) {
        const f = s.Qo();
        o && o.Ki(f, t), n.push(f), f.UA(a, c);
      }
      a = c;
    }
    return n;
  }
  gB() {
    const t = this.getCursorMode(), e = this.yi.Ra();
    if (t && e) {
      const i = this.yi.ul(e), s = xt({ x: i.engineX, y: i.engineY }, this.yi.ai, this.PL), o = Math.round(s.x), n = this.axes.filter(((h) => h.getVisible()))[o];
      if (!n) return;
      const a = n.key, l = Mr(this.Ny.map(((h) => {
        if (!h.YL || !h.Pv()) return;
        const u = h.YL[a], c = this.RL(u, o, n);
        return { cursorPosition: { pointMarker: c, pointMarkerScale: this.PL, resultTable: c, resultTableScale: this.PL }, value: u, series: h, axis: n };
      })));
      return t === "show-nearest" ? [l.filter(((h) => !Number.isNaN(h.cursorPosition.pointMarker.y))).sort(((h, u) => Math.abs(h.cursorPosition.pointMarker.y - s.y) - Math.abs(u.cursorPosition.pointMarker.y - s.y)))[0]] : (t !== "show-nearest-interpolated" && t !== "show-all-interpolated" || H.console.warn('LightningChart JS ParallelCoordinateChart does not support "interpolated" cursor modes.'), l);
    }
  }
  setUserInteractions(t) {
    return this.cr = t === void 0 ? { rangeSelectors: { create: { doubleClickAxis: !1 }, move: { drag: !1 }, dispose: { doubleClick: !1 } } } : t, this;
  }
  getUserInteractions() {
    return Zi({ rangeSelectors: { create: { doubleClickAxis: !0 }, move: { drag: !0 }, dispose: { doubleClick: !0 } } }, this.cr);
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const LE = (r, t, e) => {
  if (e.length > 1) return [[{ text: e[0].axis.getTitle(), rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], ...Mr(e.map(((o) => {
    const n = o.series.getData(), a = n ? n[o.axis.key] : void 0;
    if (a !== void 0) return Gr(o, [[o.series, "", Ai(o.axis.formatValue(a), o.axis)]]);
  })).flat())];
  const i = e[0], s = [[{ component: i.series, rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }]];
  return r.axes.forEach(((o) => {
    const n = i.series.getData();
    if (!n) return;
    const a = n[o.key];
    if (a === void 0) return;
    const l = r.axes.filter(((h) => h.getVisible()))[i.cursorPosition.pointMarker.x] === o ? { weight: "bold" } : {};
    s.push([{ text: o.getTitle(), font: l }, "", { text: o.formatValue(a), font: l }]);
  })), s;
};
class PE extends Hf {
  constructor(t, e, i, s, o, n, a) {
    var l;
    super(t, e, i, s, o, n), this.legend = new Uf(rc, this, this.rv, this.xA), this.legend.setOptions({ position: zt.LeftTop, autoHideThreshold: 1, ...a }), (l = this.Ns) === null || l === void 0 || l.push(this.legend);
  }
  add(t) {
    return t instanceof $x ? (t.getCells().forEach(((e) => {
      e.panel instanceof Rr && this.add(e.panel);
    })), this.yi.Rs(), this) : (this.legend.add(t), this.yi.Rs(), this);
  }
  getMinimumSize() {
    return super.getMinimumSize();
  }
}
const qa = (r) => r === "show-all-interpolated" || r === "show-nearest-interpolated" || r === "show-pointed-interpolated", Gr = (r, t) => {
  const e = "series" in r ? r.series : void 0;
  if (!e || !("getCursorFormattingOverride" in e)) return t;
  const i = e.getCursorFormattingOverride();
  return i ? i(r, t) : t;
}, un = (r) => {
  var t, e;
  const i = "series" in r ? r.series : "slice" in r ? r.slice : "bar" in r ? r.bar : void 0, s = i && bl(i) && i.Ws(), o = "x" in r && r.x, n = "y" in r && r.y, a = "z" in r && r.z, l = "color" in r && r.color, h = (e = (t = "lookupValue" in r ? r.lookupValue : void 0) !== null && t !== void 0 ? t : "intensity" in r ? r.intensity : void 0) !== null && e !== void 0 ? e : "value" in r ? r.value : void 0;
  if (h !== void 0 && s && s.lookUpProperty === "value") return s.lut.getColors(h, s.valueRange);
  if (o !== void 0 && o !== !1 && s && s.lookUpProperty === "x") return s.lut.getColors(o, op(i) ? { min: i.getXMin(), max: i.getXMax() } : void 0);
  if (n !== void 0 && n !== !1 && s && s.lookUpProperty === "y") return s.lut.getColors(n, op(i) ? { min: i.getYMin(), max: i.getYMax() } : void 0);
  if (a !== void 0 && a !== !1 && s && s.lookUpProperty === "z") return s.lut.getColors(a, RE(i) ? { min: i.getZMin(), max: i.getZMax() } : void 0);
  if (l) return typeof l == "number" ? Em(l) : l;
  if (i) {
    const u = i.nr(), c = Bl(i.chart.getTheme(), !0, u);
    if (de(c)) return c.getColor();
  }
}, op = (r) => !(!r || typeof r != "object" || !("getXMin" in r)), RE = (r) => !(!r || typeof r != "object" || !("getZMin" in r)), Xr = (r, t, e, i, s, o, n) => {
  let a, l, h, u = s, c = r.getTheme().cursorDynamicBehavior, d = o, f = null, p = !0;
  i && (p = !1, i.seriesBackground.addEventListener("pointerenter", (() => {
    var A;
    p = !0, r.getCursorMode() && (l && y && !("explicitTarget" in ((A = y[3]) !== null && A !== void 0 ? A : {})) ? g() : r.yi.Rs());
  })), i.seriesBackground.addEventListener("pointerleave", (() => {
    var A;
    p = !1, r.getCursorMode() && (l && y && !("explicitTarget" in ((A = y[3]) !== null && A !== void 0 ? A : {})) ? g() : r.yi.Rs());
  })), i.seriesBackground.addEventListener("pointermove", (() => {
    var A;
    p = !0, r.getCursorMode() && (l && y && !("explicitTarget" in ((A = y[3]) !== null && A !== void 0 ? A : {})) ? g() : r.yi.Rs());
  })), i.addEventListener("seriesadd", ((A) => {
    const v = A.series;
    v.addEventListener("pointerenter", ((b, w) => {
      var k;
      v.Pv() && (l || r.yi.Rs(), a = w || void 0), r.getCursorMode() && (l && y && !("explicitTarget" in ((k = y[3]) !== null && k !== void 0 ? k : {})) ? g() : r.yi.Rs());
    })), v.addEventListener("pointermove", ((b, w) => {
      var k;
      v.Pv() && (l || r.yi.Rs(), a = w || void 0), r.getCursorMode() && (l && y && !("explicitTarget" in ((k = y[3]) !== null && k !== void 0 ? k : {})) ? g() : r.yi.Rs());
    })), v.addEventListener("pointerleave", ((b) => {
      var w;
      v.Pv() && (l || r.yi.Rs(), a = void 0), r.getCursorMode() && (l && y && !("explicitTarget" in ((w = y[3]) !== null && w !== void 0 ? w : {})) ? g() : r.yi.Rs());
    }));
  })));
  const g = () => {
    if (h && (H.cancelAnimationFrame(h), h = void 0), !y) return;
    const A = y;
    h = H.requestAnimationFrame((() => m.rr(...A)));
  };
  let y;
  const m = { setCursor: (A) => (A(e), r), getCursor: () => e, setCursorMode: (A) => (u = A, r.yi.Rs(), r), getCursorMode: () => u, setCustomCursor: (A) => {
    l = A;
  }, MS: (A) => {
    c = A, r.yi.Rs();
  }, setCursorFormatting: (A) => (d = A, r.yi.Rs(), r), getCursorFormatting: () => d, G: () => {
    e.dispose(), t.G();
  }, rr: (A, v, b, w) => {
    h && (H.cancelAnimationFrame(h), h = void 0), y = [A, v, b, w];
    const k = r.yi.Ra();
    let R = [];
    if (w?.explicitTarget && u) R = Array.isArray(w.explicitTarget) ? w.explicitTarget : [w.explicitTarget];
    else if (!A && u) {
      const C = v.find(((E) => E.getPointed()));
      if (a = (k && C && (!C.getCursorEnabled || C.getCursorEnabled()) && C.Bs ? C.Bs(k) : void 0) || a, a && u !== "show-all" && u !== "show-all-interpolated") R = [a];
      else if (u === "show-all" || u === "show-all-interpolated" || u === "show-nearest" || u === "show-nearest-interpolated") {
        if ((p || C !== void 0) && k && b) {
          for (const E of v) {
            if (!E.getVisible() || E.getCursorEnabled && !E.getCursorEnabled()) continue;
            const T = b(E, k, u);
            T && R.push(T);
          }
          u !== "show-nearest" && u !== "show-nearest-interpolated" || (R.sort(((E, T) => n(E, k) - n(T, k))), R.length = 1);
        }
      } else if ((u === "show-pointed" || u === "show-pointed-interpolated") && k && C && (!C.getCursorEnabled || C.getCursorEnabled()) && b) {
        const E = b(C, k, u);
        E && (R = [E]);
      }
    }
    R = Mr(R.map(((C) => q0(C))));
    const L = w?.overrideCursorPositions || ((C, S) => S), x = R[0], M = R.length > 0 ? R : void 0;
    if (x !== f && k && (l && l({ hit: x, hits: M, mouseLocation: k }), r.D.R("cursortargetchange", { hit: x, hits: M, mouseLocation: k }), f = x), l) e.getVisible() && (e.setVisible(!1), e.Uh().rr());
    else {
      let C = !1;
      if (R && R.length > 0) {
        const S = d(r, R[0], R);
        e.setVisible(!0).setPosition(...L(R, R.map(((E) => {
          const T = E.cursorPosition;
          if (c) {
            const I = un(E);
            I !== void 0 && (T.pointMarkerFillStyle = c.pointMarkerFill && c.pointMarkerFill(I), T.pointMarkerStrokeStyle = c.pointMarkerStroke && c.pointMarkerStroke(I));
            const F = ((D) => {
              if (W0(D)) return D.size !== void 0 ? D.size : D.series instanceof Co ? D.series.getPointSize() : void 0;
            })(E);
            if (F !== void 0 && (T.pointMarkerSize = c.pointMarkerSize && c.pointMarkerSize(F)), c.matchPointMarkerShape !== !1) {
              const D = ((P) => {
                const V = W0(P) && P.series instanceof Co ? P.series.getPointShape() : void 0;
                return V === void 0 || Pn(V) ? void 0 : V;
              })(E);
              D !== void 0 && (T.pointMarkerShape = D);
            }
          }
          return T;
        })))).setResultTable(((E) => E.setContent(S))), C = !0;
      } else e.getVisible() && (e.setVisible(!1).setPosition().setResultTable(((S) => S.setContent([]))), C = !0);
      w?.afterCursorPointedAt && w.afterCursorPointedAt(R), C && (e.Uh(), e.rr());
    }
  }, solveNearest: (A, v, b, w) => {
    const k = A || r.yi.Ra();
    if (!k) return [];
    let R = [];
    if (v === "show-all" || v === "show-all-interpolated" || v === "show-nearest" || v === "show-nearest-interpolated") {
      for (const L of b) {
        if (!L.getCursorEnabled() || !L.getVisible()) continue;
        const x = w(L, k, v);
        x && R.push(x);
      }
      v !== "show-nearest" && v !== "show-nearest-interpolated" || (R.sort(((L, x) => n(L, k) - n(x, k))), R.length = 1);
    }
    return R = Mr(R.map(((L) => q0(L)))), R;
  }, jw: e };
  return m;
}, IE = (r, t, e) => qt(t, pe(kf(0.5 * (r.tc() + r.jt()) * Math.PI / 180), e)), ap = (r, t, e, i, s, o) => {
  const n = r.length;
  let a = 90;
  for (let l = 0; l < n; l += 1) {
    const h = r[l], u = a - 360 * t[l], c = h.getAnimatedExplosion();
    if (c === 0 || n === 1) h.CC.hr(e);
    else {
      const d = qt(e, pe(kf(0.5 * (a + u) * Math.PI / 180), o * c));
      h.CC.hr(d);
    }
    h.CC.lc(a).yr(u).cc(i).fc(i).Ac(s), a = u;
  }
};
class VE extends Rr {
  constructor(t, e, i, s, o, n, a) {
    var l;
    super(t, e, i, e.Av("pieChart bg", 0), s, e.yi.xi.pieChartBackgroundFillStyle, e.yi.xi.pieChartBackgroundStrokeStyle, e.yi.xi.pieChartTitleFont, e.yi.xi.pieChartTitleFillStyle, e.yi.xi.pieChartTitleShadow, n, (l = a?.legend) === null || l === void 0 ? void 0 : l.customLegend), this.Hk = [], this.Wk = Zf.SortByName, this.Wu = 0, this.nC = this.xi.pieChartSliceFillStylePalette, this.oC = this.xi.pieChartSliceStrokeStyle, this.Xk = !0, this.aC = this.xi.pieChartSliceLabelFont, this.lC = this.xi.pieChartSliceLabelFillStyle, this.Zk = this.xi.pieChartSliceLabelShadow, this.Jk = 0, this.mB = !1, this.SB = 20, this.tC = !0, this.eC = !0, this.iC = (d) => {
      const f = this.Hk.indexOf(d);
      f >= 0 && (this.Hk.splice(f, 1), this.sC());
    }, this.D = new Nt(), this.yi.Oa(Ot.Fo), this.rC = e.nS("pieChart bottom", 0), this.hC = e.nS("pieChart top", 1), this.Wr.rn("Pie Chart"), this.fv(o, this.xA), this.background.addEventListener("dblclick", ((d) => {
      d.defaultPrevented || (() => {
        const f = this.getSlices();
        for (let p = 0; p < f.length; p += 1) f[p].setExploded(!1);
      })();
    }));
    const h = e.fS(), u = $e(a ? a.cursorBuilder : void 0, Ta);
    this.AS = Xr(this, h, u.zm(h, this.uiScale, this.uiScale, ie, this.xi), void 0, "show-pointed", _E, (() => 0)), this.setAnimationsEnabled(a?.animationsEnabled !== !1);
    const c = { backgroundVisible: !0, ...a?.legend };
    this.legend.setOptions(c);
  }
  setCursor(t) {
    return this.AS.setCursor(t), this;
  }
  getCursor() {
    return this.AS.getCursor();
  }
  setCursorMode(t) {
    return this.AS.setCursorMode(t), this;
  }
  getCursorMode() {
    return this.AS.getCursorMode();
  }
  setCustomCursor(t) {
    return this.AS.setCustomCursor(t), this;
  }
  setCursorDynamicBehavior(t) {
    return this.AS.MS(t), this;
  }
  setCursorFormatting(t) {
    return this.AS.setCursorFormatting(t), this;
  }
  getCursorFormatting() {
    return this.AS.getCursorFormatting();
  }
  addCursor(t = Ta) {
    const e = this.tv(), i = t.zm(e, this.uiScale, this.uiScale, this.Jg(e), this.xi);
    return this.cv(i), i;
  }
  addSlice(t, e) {
    const i = new z5(this.Jk, this.rC, this.hC, this, this.xA, this.iC, this.xi, this.yi.bs);
    this.Jk += 1, i.setName(t);
    const s = this.zr;
    return this.zr = !1, i.setValue(e), this.zr = s, i.setEffect(this.tC), this.cC(i), this.Hk.push(i), this.sC(), i.setHighlightOnHover(this.Xk), this.Ns.forEach(((o) => {
      o.Vg() && o.Pu(i);
    })), i;
  }
  addSlices(t) {
    const e = [];
    for (let i = 0; i < t.length; i += 1) e.push(this.addSlice(t[i].name, t[i].value));
    return e;
  }
  getSlices() {
    return this.Hk;
  }
  setMultipleSliceExplosion(t) {
    return this.mB = t, this;
  }
  getMultipleSliceExplosion() {
    return this.mB;
  }
  setInnerRadius(t) {
    return this.Wu = t, this.yi.Rs(), this;
  }
  getInnerRadius() {
    return this.Wu;
  }
  setSliceExplosionOffset(t) {
    return this.SB = t, this.yi.Rs(), this;
  }
  getSliceExplosionOffset() {
    return this.SB;
  }
  setLUT(t) {
    return this.Nf = t, this.yi.Rs(), this;
  }
  setSliceFillStyle(t) {
    this.nC = t;
    for (let e = 0; e < this.Hk.length; e += 1) this.cC(this.Hk[e]);
    return this.yi.Rs(), this;
  }
  getSliceFillStyle() {
    return this.nC;
  }
  setSliceStrokeStyle(t) {
    this.oC = typeof t == "function" ? t(this.oC) : t;
    for (let e = 0; e < this.Hk.length; e += 1) this.cC(this.Hk[e]);
    return this.yi.Rs(), this;
  }
  getSliceStrokeStyle() {
    return this.oC;
  }
  setSliceEffect(t) {
    return this.tC = t, this.Hk.forEach(((e) => e.bs._s.Es(t))), this.yi.Rs(), this;
  }
  getSliceEffect() {
    return this.tC;
  }
  setSliceSorter(t) {
    return this.Wk = t, this.Hk = this.Hk.sort(this.Wk), this.yi.Rs(), this;
  }
  getSliceSorter() {
    return this.Wk;
  }
  setLabelFillStyle(t) {
    this.lC = typeof t == "function" ? t(this.lC) : t;
    for (let e = 0; e < this.Hk.length; e += 1) this.cC(this.Hk[e]);
    return this.yi.Rs(), this;
  }
  getLabelFillStyle() {
    return this.lC;
  }
  setLabelShadow(t) {
    return this.Zk = t, this.yi.Rs(), this;
  }
  getLabelShadow() {
    return this.Zk;
  }
  setLabelFont(t) {
    this.aC = typeof t == "function" ? t(this.aC) : t;
    for (let e = 0; e < this.Hk.length; e += 1) this.cC(this.Hk[e]);
    return this.yi.Rs(), this;
  }
  getLabelFont() {
    return this.aC;
  }
  setLabelEffect(t) {
    return this.eC = t, this.Hk.forEach(((e) => e.bs.Ms.Es(t))), this.yi.Rs(), this;
  }
  getLabelEffect() {
    return this.eC;
  }
  setLabelFormatter(t) {
    return this.uC = t, this.yi.Rs(), this;
  }
  getLabelFormatter() {
    return this.uC;
  }
  setSliceHighlightOnHover(t) {
    return this.Xk = t, this.Hk.forEach(((e) => e.setHighlightOnHover(t))), this;
  }
  rr(t) {
    super.rr(t), super.dv();
    const e = ui.xv(this.Wr, this.gv), i = this.Ns.reduce(((c, d) => {
      const f = d.Uh(e, this.Hn);
      return { top: Math.max(c.top, f.top), bottom: Math.max(c.bottom, f.bottom), left: Math.max(c.left, f.left), right: Math.max(c.right, f.right) };
    }), { top: 0, bottom: 0, left: 0, right: 0 });
    ui.Mv(this.Wr, this.gv, this.uiScale.ni(), this.Hn, i);
    const s = j(this.xA.x.getInnerInterval() - (this.Hn.left + this.Hn.right), this.xA.y.getInnerInterval() - (this.Hn.bottom + this.Hn.top + e)), o = j(s.x - i.left - i.right, s.y - i.top - i.bottom), n = j(this.Hn.left + (s.x + i.left - i.right) / 2, this.Hn.bottom + (s.y + i.bottom - i.top) / 2);
    if (this.Nf) {
      const c = this.Nf;
      this.Hk.forEach(((d) => {
        this.cC(d, new ot({ color: c.getColors(d.getAnimatedValue(), void 0) }));
      }));
    }
    for (let c = 0; c < this.Hk.length; c += 1) {
      const d = Math.abs(this.Hk[c].getAnimatedValue()) > 0;
      this.Hk[c].CC.setVisible(d), this.Hk[c].Gh.setVisible(d);
    }
    this.Hk = this.Hk.sort(this.Wk);
    const a = this.Hk.filter(((c) => Math.abs(c.getAnimatedValue()) > 0));
    let l = 0;
    for (let c = 0; c < a.length; c += 1) l += Math.abs(a[c].getAnimatedValue());
    const h = [];
    for (let c = 0; c < a.length; c += 1) h.push((u = Math.abs(a[c].getAnimatedValue())) > 0 ? u / l : 0);
    var u;
    for (let c = 0; c < a.length; c += 1) {
      const d = a[c];
      d.Gh.rn(this.uC(d, h[c])).Uh();
    }
    this.AS.rr(!1, this.Hk, ((c, d, f) => {
      const p = h[a.indexOf(c)] || 0, g = this.yi.ul(d);
      return { cursorPosition: { pointMarker: { x: g.engineX, y: g.engineY }, pointMarkerScale: this.yi.ai, resultTable: { x: g.engineX, y: g.engineY }, resultTableScale: this.yi.ai }, slice: c, category: c.getName(), value: c.getValue(), relativeValue: p };
    })), this.Ns.forEach(((c) => c.rr(e, this.Hn))), this.dC(a, h, n, o);
  }
  cC(t, e = this.nC(t.index, t)) {
    t.setStyle(e, this.oC, this.lC, this.aC, this.Zk);
  }
  sC() {
    this.Hk = this.Hk.sort(this.Wk), this.yi.Rs();
  }
  Gg() {
    return this.Hk;
  }
  dispose() {
    return super.dispose(), this.Hk.slice().forEach(((t) => t.dispose())), this.AS.G(), this.hC.G(), this.rC.G(), this;
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const _E = (r, t, e) => [[{ component: t.slice, rowFillStyle: r.getTheme().cursorResultTableHeaderBackgroundFillStyle }], [{ text: t.value.toString(), font: { weight: "bold" } }]];
class jx extends VE {
  constructor(t, e, i, s, o, n, a) {
    super(t, e, i, s, o, n, a), this.uC = Kf.NamePlusValue, this.pC = [], this.bB = 40, this.xB = 5, this.MB = 10, this.mC = this.xi.pieChartConnectorStrokeStyle;
  }
  setLabelConnectorStyle(t) {
    this.mC = t;
    for (let e = 0; e < this.pC.length; e += 1) this.pC[e].gr(this.mC);
    return this.yi.Rs(), this;
  }
  getLabelConnectorStyle() {
    return this.mC;
  }
  setLabelSliceOffset(t) {
    return this.bB = t, this.yi.Rs(), this;
  }
  getLabelSliceOffset() {
    return this.bB;
  }
  setLabelConnectorGapStart(t) {
    return this.xB = t, this.yi.Rs(), this;
  }
  getLabelConnectorGapStart() {
    return this.xB;
  }
  setLabelConnectorEndLength(t) {
    return this.MB = t, this.yi.Rs(), this;
  }
  getLabelConnectorEndLength() {
    return this.MB;
  }
  dC(t, e, i, s) {
    const o = this.aC.getSize(), n = this.bB, a = this.MB, l = this.xB, h = Math.min(this.SB, n - l);
    let u = 0;
    if (t.length === 1) u = t[0].Gh.Bc().x;
    else for (let d = 0; d < t.length; d += 1) u = Math.max(u, t[d].Gh.Bc().x);
    const c = Math.max(0.5 * (Math.min(s.x - 2 * u - 2 * a, s.y - 2 * o) - 2 * n), 0);
    if (c < 50) {
      const d = Math.max(0.5 * Math.min(s.x, s.y - 2 * o), 0);
      ap(t, e, i, d, this.Wu, h), t.forEach(((f) => f.Gh.setVisible(!1))), this.pC.forEach(((f) => f.setVisible(!1)));
    } else {
      ap(t, e, i, c, this.Wu, h);
      let d = 90;
      const f = t.map(((g, y) => {
        const m = 360 * e[y], A = d - m, v = kf($n(0.5 * (d + A))), b = v.x >= 0 ? -1 : 1, w = qt(qt(i, pe(v, c + n)), { x: b * -a, y: 0 });
        d = A;
        const k = { x: b, y: 0 };
        g.Gh.hr(w).ru(k), g.Gh.Uh();
        const R = g.Gh.Ic();
        return { position: w, alignment: k, shape: g.Gh, boundaries: R, sliceAngleVec: v, slice: g };
      })), p = [];
      for (let g = 0; g < f.length; g += 1) {
        const y = f[g], m = p[p.length - 1];
        m && Gm([m.boundaries, y.boundaries]) !== !1 ? y.shape.setVisible(!1) : (p.push(y), y.shape.setVisible(!0));
      }
      for (let g = 0; g < this.pC.length; g += 1) this.pC[g].setVisible(!1);
      p.forEach(((g, y) => {
        const m = g.slice.CC, A = IE(m, i, c + l + h * g.slice.getAnimatedExplosion()), v = ((w, k, R) => {
          const L = (R.y - k.y) / (R.x - k.x), x = k.x + (w - k.y) / L;
          return j(x, w);
        })(g.position.y, A, i), b = g.position;
        this.SC([A, v, b]);
      }));
    }
  }
  getMinimumSize() {
    return j(500, 300);
  }
  SC(t) {
    let e;
    for (let i = 0; i < this.pC.length; i += 1) if (!this.pC[i].getVisible()) {
      e = this.pC[i].setVisible(!0);
      break;
    }
    e === void 0 && (e = this.hC.Ay(this.xA, void 0, [Ir.InternalUI]).gr(this.mC).setPointerEvents(!1), this.pC.push(e)), e.Vi().Pu(t);
  }
}
const OE = 100001, NE = 200002, BE = 300002, zE = 400001, lp = 510001, fs = (r, t) => {
  const e = Math.floor(99999 / t), i = Math.floor(99999 / t), s = Math.floor(99998 / t), o = Math.floor(99998 / t), n = Math.floor(99999 / (t + 1)), a = Math.floor(89999 / (t + 1)), l = lp + t * a;
  let h = 0;
  return { wB: () => {
    const u = r.kB("dashboard ui", l + h);
    return h += 1, u;
  }, CB: () => r.kB("dashboard legend", 51e4), TB: (u) => {
    const c = 1 + u * e, d = OE + u * i, f = NE + u * s, p = BE + u * o, g = zE + u * n, y = lp + u * a;
    let m = 0;
    return { yi: r, Av: (A, v) => {
      const b = c + v;
      return r.kB(A, b);
    }, hS: (A, v) => {
      const b = d + v;
      return r.kB(A, b);
    }, Ow: (A, v) => {
      const b = f + v;
      return r.kB(A, b);
    }, nS: (A, v) => {
      const b = p + v;
      return r.kB(A, b);
    }, rS: (A, v, b) => {
      const w = p + v;
      return r.FB(A, w, b);
    }, pv: (A, v) => {
      const b = g + v;
      return r.kB(A, b);
    }, ev: (A) => {
      const v = y + m, b = r.kB(A, v);
      return m += 1, b;
    }, hv: () => r.kB("panel legend", 500002 + u), fS: () => r.kB("panel cursor", 600001 + u) };
  } };
};
class kl extends Error {
  constructor(t, e) {
    super(`ChartError: ${t} ${e ? `in ${e.constructor.name}` : ""}`), Object.setPrototypeOf(this, kl.prototype);
  }
}
class pi extends Error {
  constructor(t, e, i = !1) {
    const s = `EngineError: ${t} ${e ? `in ${e.constructor.name}` : ""}`;
    super(s), i && H.alert(s), Object.setPrototypeOf(this, pi.prototype);
  }
}
class qf extends pi {
  constructor(t) {
    super(t), Object.setPrototypeOf(this, qf.prototype);
  }
}
class hp {
  constructor(t) {
    this.D = new Nt(), this.M = t;
  }
  C(t) {
    return this.M = t, this.D.R("change", { value: t }), this;
  }
  T() {
    return this.M;
  }
  O(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  N(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const Hh = (r, t) => t ? r.x : r.y, WE = (r, t, e, i) => t === 1 && i === (e ? r.columnIndex : r.rowIndex) || t === -1 && i === (e ? r.columnIndex + r.columnSpan : r.rowIndex + r.rowSpan), up = (r, t, e, i, s, o) => {
  const n = t.length, a = Math.sign(i), l = [], h = t.reduce(((p, g) => p + g));
  for (let p = 1; p <= n - 1; p += 1) l.push(Hh(s, o) * t.slice(0, p).reduce(((g, y) => g + y), 0) / h);
  const u = l.map(((p) => 0));
  let c = l[e - 1] + i;
  for (let p = e; p > 0 && p < n; p += a) {
    const g = r.filter(((m) => WE(m, a, o, p))).reduce(((m, A) => Math.max(m, Hh(A.panel.getMinimumSize() || { x: 0, y: 0 }, o))), 20), y = l[p - 1];
    if (a === 1 && c > Hh(s, o) - g || a === -1 && c < 0 + g) {
      u.fill(0);
      break;
    }
    if (p !== e && (a === 1 ? y > c : y < c)) break;
    u[p - 1] = c - y, c += g * a;
  }
  const d = u.map(((p, g) => l[g] + p)), f = d.map(((p, g) => (p - (g > 0 ? d[g - 1] : 0)) / Hh(s, o)));
  return f.push(1 - f.reduce(((p, g) => p + g), 0)), f;
};
class $x {
  constructor(t, e, i, s, o, n) {
    this.coordsRelative = "relative", this.coordsClient = "client", this.ci = !1, this.kT = new Array(), this.IB = [], this.PB = void 0, this.LB = !0, this.BB = !0, this.DB = !0, this.Hg = !1, this.EB = !0, this.RB = () => {
      this.EB = !0, this.yi.Rs();
    }, this.OB = [], this.zB = (u) => {
      for (let c = 0; c < this.kT.length; c += 1) if (this.kT[c].panel === u) {
        this.kT.splice(c, 1), this.LB = !0, this.yi.Rs();
        break;
      }
    }, this.VB = (u) => {
      const c = this.IB.indexOf(u);
      c >= 0 && this.IB.splice(c, 1);
    }, this.NB = (u, c, d, f, p) => {
      if (this.GB(c, d, f, p)) {
        const g = { panel: u, columnIndex: c, rowIndex: d, columnSpan: f, rowSpan: p };
        return this.kT.push(g), this.$B(g), this.LB = !0, u;
      }
      throw new kl("Out of dashboard range.");
    }, this.D = new Nt(), this.UB = e.numberOfRows, this.jB = e.numberOfColumns, this.Qg = t, this.YB = e, this.HB = s;
    const a = this.jB * this.UB;
    this.WB = { x: new hp(new Array(this.jB).fill(1)), y: new hp(new Array(this.UB).fill(1)) }, this.xi = i.xi, this.XB = this.xi.dashboardSplitterStyle, this.zr = e?.animationsEnabled !== !1, this.ZB = fs(i, a), this.JB = i.kB("dashboard splitters", 500001), this.QB = () => this.ZB.wB(), this.rv = this.ZB.CB(), this.bs = i.bs.xs(this, { KB: {} }), this.bs.KB.Es(this.xi.effectsDashboardSplitters);
    const l = i.Ft();
    this.uiScale = ki.d2({ scaleXYConstructor: we }).ii(0, 100).si(0, 100).K(l), this.xA = ki.d2({ scaleXYConstructor: we }).ii(0, this.uiScale.x.getCellSize()).si(0, this.uiScale.y.getCellSize()).K(l), this.qB = i.tD.bind(i), this.iD = i.sD.bind(i), this.eD = i.rD.bind(i), this.hD = i.nD.bind(i), this.tl = i.tl.bind(i), this.sl = i.sl.bind(i), this.engine = i.qg, this.yi = i.Dc, i.O("resize", this.RB), i.Rs();
    const h = (u) => {
      this.Hg = u.isInView, this.D.R("inviewchange", { isInView: this.Hg });
    };
    i.O("inviewchanged", h), this.lv = () => {
      i.N("inviewchanged", h);
    }, this.oD(), this.setAnimationsEnabled(this.zr), this.createChartXY = (u) => {
      const c = xs(u, this.YB, this.zr);
      return this.NB(new $f(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, c, this), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createSpiderChart = (u) => {
      const c = xs(u, this.YB, this.zr);
      return this.NB(new Ox(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, c, this), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createPolarChart = (u) => {
      const c = xs(u, this.YB, this.zr);
      return this.NB(new Ix(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, c, this), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createPieChart = (u) => {
      const c = xs(u, this.YB, this.zr), d = c && c.type ? c.type : jx;
      return this.NB(new d(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this, c), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createGaugeChart = (u) => {
      const c = xs(u, this.YB, this.zr);
      return this.NB(new Ux(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this, c), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createRadialGaugeChart = this.createGaugeChart, this.createLinearGaugeChart = (u) => {
      const c = xs(u, this.YB, this.zr);
      return this.NB(new Hx(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this, c), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createFunnelChart = (u) => {
      const c = xs(u, this.YB, this.zr), d = c && c.type ? c.type : Vx;
      return this.NB(new d(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this, c), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createPyramidChart = (u) => {
      const c = xs(u, this.YB, this.zr), d = u && u.type ? u.type : _x;
      return this.NB(new d(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this, c), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createUIPanel = (u) => {
      const c = xs(u, this.YB, this.zr);
      return this.NB(new Hf(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createLegendPanel = (u) => {
      const c = xs(u, this.YB, this.zr);
      return this.NB(new PE(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this, u.legend), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createZoomBandChart = (u) => {
      const c = xs(u, this.YB, this.zr);
      return this.NB(new Rx(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, c, this), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createMapChart = (u) => {
      const c = xs(u, this.YB, this.zr);
      return this.NB(new Ex(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, c, this), c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createChart3D = (u) => {
      const c = xs(u, this.YB, this.zr), d = new jf(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this, c);
      return this.NB(d, c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createDataGrid = (u) => {
      const c = xs(u, this.YB, this.zr), d = new Wx(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this);
      return this.NB(d, c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createBarChart = (u) => {
      const c = xs(u, this.YB, this.zr), d = new Gx(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this, c);
      return this.NB(d, c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    }, this.createParallelCoordinateChart = (u) => {
      const c = xs(u, this.YB, this.zr), d = new Yx(this.Qg, this.ZB.TB(this.aD(u.columnIndex, u.rowIndex)), this.lD(c, this.WB), this.zB, n, this, c);
      return this.NB(d, c.columnIndex, c.rowIndex, c.columnSpan, c.rowSpan);
    };
  }
  setPauseRendering(t, e) {
    return this.yi.uv(t, e), this;
  }
  aD(t, e) {
    return t + e * this.jB;
  }
  lD(t, e) {
    return { d1: (i) => new i.scale1DConstructor(i.dimension === "x" ? t.columnIndex : t.rowIndex, i.dimension === "x" ? t.columnSpan : t.rowSpan, i.dimension === "x" ? this.jB : this.UB, i.dimension === "x" ? e.x : e.y), d2: (i) => new i.scaleXYConstructor().hi({ x: t.columnIndex, y: t.rowIndex }, { x: t.columnSpan, y: t.rowSpan }, { x: this.jB, y: this.UB }, e), d3: () => new Cm({ x: t.columnIndex, y: t.rowIndex }, { x: t.columnSpan, y: t.rowSpan }, { x: this.jB, y: this.UB }, e) };
  }
  setWidth(t) {
    return t instanceof Array || (t = [t, t]), this.qB(t[0]), this.iD(t[1]), this;
  }
  setHeight(t) {
    return t instanceof Array || (t = [t, t]), this.eD(t[0]), this.hD(t[1]), this;
  }
  getWidth() {
    return this.tl();
  }
  getHeight() {
    return this.sl();
  }
  setBackgroundFillStyle(t) {
    return this.engine.setBackgroundFillStyle(t), this.JB.Rs(), this;
  }
  getBackgroundFillStyle() {
    return this.engine.getBackgroundFillStyle();
  }
  setBackgroundStrokeStyle(t) {
    return this.engine.setBackgroundStrokeStyle(t), this.JB.Rs(), this;
  }
  getBackgroundStrokeStyle() {
    return this.engine.getBackgroundStrokeStyle();
  }
  getTheme() {
    return this.xi;
  }
  setSplitterStyle(t) {
    const e = this.XB;
    return this.XB = typeof t == "function" ? t(this.XB) : t, this.uD(e), this;
  }
  getSplitterStyle() {
    return this.XB;
  }
  setSplitterEffect(t) {
    return this.bs.KB.Es(t), this.yi.Rs(), this;
  }
  getSplitterEffect() {
    return this.bs.KB.Os();
  }
  setAnimationHighlight(t) {
    return this.DB = t, this.OB.forEach(((e) => this.yi.ks.Us(e.line, t))), this;
  }
  getAnimationHighlight() {
    return this.DB;
  }
  uD(t) {
    for (const e of this.OB) e.line.gr(this.XB);
    this.oD();
  }
  setColumnWidth(t, e) {
    const i = this.WB.x.T();
    return t >= 0 && t < i.length && (i[t] = e, this.WB.x.C(i)), this.RB(), this;
  }
  getColumnWidth(t) {
    const e = this.WB.x.T();
    if (t >= e.length) throw new kl("Column index is out of dashboard range.");
    return e[t];
  }
  setRowHeight(t, e) {
    const i = this.WB.y.T();
    return t >= 0 && t < i.length && (i[Math.abs(i.length - 1 - t)] = e, this.WB.y.C(i)), this.RB(), this;
  }
  getRowHeight(t) {
    const e = this.WB.y.T();
    if (t >= e.length) throw new kl("Row index is out of dashboard range.");
    return e[Math.abs(e.length - 1 - t)];
  }
  getSizePixels() {
    return this.xA.getInnerIntervalPixels();
  }
  cD(t, e, i) {
    if (i && Math.abs(t.x) > 0) this.dD(e, t.x);
    else {
      if (i || !(Math.abs(t.y) > 0)) return;
      this.fD(e, t.y);
    }
    for (const s of this.kT) s.panel.X();
    this.RB();
  }
  fD(t, e) {
    const i = up(this.kT, this.WB.y.T(), t, e, this.xA.Ft(), !1);
    this.WB.y.C(i), this.RB();
  }
  dD(t, e) {
    const i = up(this.kT, this.WB.x.T(), t, e, this.xA.Ft(), !0);
    this.WB.x.C(i), this.RB();
  }
  AD() {
    this.OB.forEach(((t) => t.line.dispose())), this.OB.length = 0;
    for (let t = 1; t <= this.jB - 1; t += 1) for (let e = 0; e <= this.UB - 1; e += 1) if (this.kT.find(((i) => Ii(e, i.rowIndex, i.rowIndex + i.rowSpan - 1) && (t === i.columnIndex || t === i.columnIndex + i.columnSpan))) !== void 0) {
      const i = this.JB.vr(this.xA).gr(this.XB);
      i.addEventListener("pointerenter", ((s) => {
        this.OB.forEach(((o) => {
          o.alignment === "vertical" && o.column === t && (this.yi.ks.$s(o.line, 1), this.JB.gD(o.line));
        })), this.PB = this.engine.setMouseStyle(Gt.ResizeColumn, this.PB), this.yi.Rs();
      })), i.addEventListener("pointerleave", ((s) => {
        this.OB.forEach(((o) => {
          o.alignment === "vertical" && o.column === t && this.yi.ks.$s(o.line, 0);
        })), this.PB = this.engine.restoreMouseStyle(this.PB), this.yi.Rs();
      })), i.addEventListener("pointerdown", ((s) => {
        It(s);
        let o = s;
        const n = (l) => {
          It(l), this.PB = this.engine.setMouseStyle(Gt.ResizeColumn, this.PB), this.OB.forEach(((u) => {
            u.alignment === "vertical" && u.column === t && (this.yi.ks.$s(u.line, 1), this.JB.gD(u.line));
          }));
          const h = { x: l.clientX - o.clientX, y: l.clientY - o.clientY };
          o = l, this.cD(h, t, !0);
        }, a = (l) => {
          l.pointerId === s.pointerId && (this.OB.forEach(((h) => {
            h.alignment === "vertical" && h.column === t && this.yi.ks.$s(h.line, 0);
          })), this.PB = this.engine.restoreMouseStyle(this.PB), H.removeEventListener("pointermove", n), H.removeEventListener("pointerup", a));
        };
        H.addEventListener("pointermove", n), H.addEventListener("pointerup", a);
      })), this.yi.ks.ws(i, ((s) => i.Ii(s)), { animationEnabled: this.DB }), this.OB.push({ row: e, column: t, line: i, alignment: "vertical" });
    }
    for (let t = 1; t <= this.UB - 1; t += 1) for (let e = 0; e <= this.jB - 1; e += 1) if (this.kT.find(((i) => Ii(e, i.columnIndex, i.columnIndex + i.columnSpan - 1) && (t === i.rowIndex || t === i.rowIndex + i.rowSpan))) !== void 0) {
      const i = this.JB.vr(this.xA).gr(this.XB);
      i.addEventListener("pointerenter", ((s) => {
        this.OB.forEach(((o) => {
          o.alignment === "horizontal" && o.row === t && (this.yi.ks.$s(o.line, 1), this.JB.gD(o.line));
        })), this.PB = this.engine.setMouseStyle(Gt.ResizeRow, this.PB), this.yi.Rs();
      })), i.addEventListener("pointerleave", ((s) => {
        this.OB.forEach(((o) => {
          o.alignment === "horizontal" && o.row === t && this.yi.ks.$s(o.line, 0);
        })), this.PB = this.engine.restoreMouseStyle(this.PB), this.yi.Rs();
      })), i.addEventListener("pointerdown", ((s) => {
        It(s);
        let o = s;
        const n = (l) => {
          It(l), this.PB = this.engine.setMouseStyle(Gt.ResizeRow, this.PB), this.OB.forEach(((u) => {
            u.alignment === "horizontal" && u.row === t && (this.yi.ks.$s(u.line, 1), this.JB.gD(u.line));
          }));
          const h = { x: l.clientX - o.clientX, y: -(l.clientY - o.clientY) };
          o = l, this.cD(h, t, !1);
        }, a = (l) => {
          l.pointerId === s.pointerId && (this.OB.forEach(((h) => {
            h.alignment === "horizontal" && h.row === t && this.yi.ks.$s(h.line, 0);
          })), this.PB = this.engine.restoreMouseStyle(this.PB), H.removeEventListener("pointermove", n), H.removeEventListener("pointerup", a));
        };
        H.addEventListener("pointermove", n), H.addEventListener("pointerup", a);
      })), this.yi.ks.ws(i, ((s) => i.Ii(s)), { animationEnabled: this.DB }), this.OB.push({ row: t, column: e, line: i, alignment: "horizontal" });
    }
    this.bs.KB.Fs(this.OB.map(((t) => t.line)));
  }
  vD() {
    const t = this.xA.Ft(), e = this.WB.x.T(), i = e.reduce(((n, a) => n + a)), s = this.WB.y.T(), o = s.reduce(((n, a) => n + a));
    this.OB.forEach(((n) => {
      if (n.alignment === "vertical") {
        const a = j(t.x * e.slice(0, n.column).reduce(((h, u) => h + u), 0) / i, t.y * s.slice(0, n.row).reduce(((h, u) => h + u), 0) / o), l = j(a.x, t.y * s.slice(0, n.row + 1).reduce(((h, u) => h + u), 0) / o);
        n.line.pr(a).yr(l);
      } else {
        const a = j(t.x * e.slice(0, n.column).reduce(((h, u) => h + u), 0) / i, t.y * s.slice(0, n.row).reduce(((h, u) => h + u), 0) / o), l = j(t.x * e.slice(0, n.column + 1).reduce(((h, u) => h + u), 0) / i, a.y);
        n.line.pr(a).yr(l);
      }
    }));
  }
  setAnimationsEnabled(t) {
    return this.zr = t, this.getCells().filter(((e) => e.panel instanceof Rr)).forEach(((e) => e.panel.setAnimationsEnabled(t))), this.setAnimationHighlight(this.zr), this;
  }
  getAnimationsEnabled() {
    return this.zr;
  }
  getCells() {
    return this.kT.slice();
  }
  dispose() {
    return this.ci || (this.lv && this.lv(), this.kT.slice().forEach(((t) => t.panel.dispose())), this.IB.slice().forEach(((t) => t.dispose())), this.ci = !0, this.HB(), this.D.R("dispose", {})), this;
  }
  isDisposed() {
    return this.ci;
  }
  getIsInView() {
    return this.Hg;
  }
  saveToFile(t, e, i, s) {
    return xx(this.engine, t, e, i, s), this;
  }
  Ec(t) {
    if (this.EB) {
      const e = this.yi.ai.Ft(), i = e.x, s = e.y;
      this.uiScale.K(i, s), this.xA.K(i, s);
      const o = this.uiScale.getInnerIntervalPixels();
      this.xA.ii(0, o.x).si(0, o.y), this.D.R("resize", { width: o.x, height: o.y, engineWidth: i, engineHeight: s }), this.BB = !0;
    }
    this.LB && (this.AD(), this.LB = !1, this.BB = !0), this.BB && (this.vD(), this.BB = !1);
    for (const e of this.kT) e.panel.rr(t);
    return this.IB.forEach(((e) => e.Uh())), this.IB.forEach(((e) => e.rr())), this.EB = !1, this;
  }
  W() {
    for (const t of this.kT) t.panel.W();
    return this.xA.x.W(), this.xA.y.W(), this.uiScale.x.W(), this.uiScale.y.W(), this;
  }
  X() {
    for (const t of this.kT) t.panel.X();
    return this.xA.x.X(), this.xA.y.X(), this.uiScale.x.X(), this.uiScale.y.X(), this;
  }
  translateCoordinate(t, e, i) {
    return sc(t, e, i, this.xA, this.yi);
  }
  addUIElement(t = Gf, e = this.uiScale) {
    e = Do(e, this.xA);
    const i = vx(t, this.QB(), this.uiScale, e, this.VB, this.xi);
    return this.IB.push(i), i;
  }
  GB(t, e, i, s) {
    return e >= 0 && t >= 0 && e + s <= this.UB && t + i <= this.jB;
  }
  $B(t) {
    const e = this.XB, i = e === Et ? 0 : e.getThickness() / 2, s = { left: t.columnIndex > 0 ? i : 0, top: t.rowIndex < this.UB - 1 ? i : 0, right: t.columnIndex < this.jB - 1 ? i : 0, bottom: t.rowIndex > 0 ? i : 0 };
    t.panel.Tn(s);
  }
  oD() {
    this.uiScale.x._t([0, 0]), this.uiScale.y._t([0, 0]), this.xA.x._t([0, 0]), this.xA.y._t([0, 0]);
    for (const t of this.kT) this.$B(t);
    this.yi.Rs();
  }
  addEventListener(t, e, i) {
    this.D.addEventListener(t, e, i);
  }
  removeEventListener(t, e) {
    this.D.removeEventListener(t, e);
  }
}
const xs = (r, t, e) => {
  const i = { ...r, columnSpan: r.columnSpan || 1, rowSpan: r.rowSpan || 1, animationsEnabled: r.animationsEnabled !== void 0 ? r.animationsEnabled : e };
  var s, o;
  return i.rowIndex = (s = i.rowIndex, o = i.rowSpan, t.numberOfRows - (s + o)), i;
}, gs = (r, t = "data:image/png;base64,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", e) => {
  let i, s = 0, o = 0;
  const n = [], a = (c) => {
    const d = new H.Image();
    d.src = c, d.onload = () => {
      n.forEach(((f) => {
        var p;
        const g = new wr({ source: d, fitMode: Li.Stretch });
        (p = f.zd) === null || p === void 0 || p.sr(g), s = d.width, o = d.height, u(f);
      }));
    };
  };
  a(t);
  const l = (c) => {
    a(c.logoDataURI);
  };
  let h;
  if (r.za.addEventListener("logochange", l), new H.Image() instanceof H.HTMLImageElement) {
    const c = new H.Image();
    c.src = t, h = new wr({ source: c, fitMode: Li.Stretch });
  } else if (H.lcjs_setup) {
    const c = new H.Image();
    c.src = t;
    const d = H.lcjs_setup(c.naturalWidth, c.naturalHeight);
    d.getContext("2d").drawImage(c, 0, 0), h = new wr({ source: d, fitMode: Li.Stretch });
  } else h = new ot({ color: Xe("#f00") });
  const u = (c) => {
    if (c.zd) {
      const d = c.ai.Qt({ x: c.ai.x.getInnerEnd(), y: c.ai.y.getInnerStart() }, { x: -(3 + s), y: 3 }), f = c.ai.Qt({ x: c.ai.x.getInnerEnd(), y: c.ai.y.getInnerStart() }, { x: -3, y: 3 + o }), p = { x: f.x - d.x, y: f.y - d.y };
      c.zd.hr(d).K(p);
    }
    i && i.Rs();
  };
  return i = r.kB("logo", Number.MAX_SAFE_INTEGER), (c) => {
    const d = { ai: c };
    return ((f) => {
      const p = e && "cGx1Z2lu" in e && e.cGx1Z2lu === "cHl0aG9u" ? UE : GE;
      if (f.zd && f.zd.dispose(), i) {
        let g;
        f.zd = i.er(f.ai).sr(h).setPointerEvents(!0).ir(Et), f.zd.addEventListener("pointerenter", (() => {
          g = r.Gn(Gt.Point);
        })), f.zd.addEventListener("pointerleave", (() => {
          g = r.$n(g);
        })), f.zd.addEventListener("click", p), u(f);
      }
    })(d), n.push(d), { Uh: () => u(d), G: () => ((f) => {
      f.zd && (f.zd.dispose(), f.zd = void 0);
      const p = n.indexOf(f);
      p >= 0 && n.splice(p, 1), n.length <= 0 && r.za.removeEventListener("logochange", l);
    })(d) };
  };
}, GE = () => H.open("https://lightningchart.com/lightningchart-js/"), UE = () => H.open("https://lightningchart.com/python-charts/"), HE = { testWorker: '!function(){"use strict";const s={Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array},t={},a={};self.postMessage({ready:!0}),self.onmessage=i=>{try{if("b"in i.data){const{b:s,i:a}=i.data;a.forEach(((a,i)=>{const n=s[i];t[a]=n}))}else if("cb"in i.data){const{cb:s,i:t}=i.data;a[t]=s}else{const{id:n,bip:e,biv:h,sp:u,sv:p,ss:m,s:c,ds:f,dc:N,is:l,cbi:o}=i.data,b=t[e],d=t[h],y=a[o],A=new s[u](b),M=new s[p](d),g={id:n,ss:m,nc:r(c,f,N,l,A,M,m,y)};self.postMessage(g)}}catch(s){const t={id:i.data.id,error:s&&"message"in s?s.message:"error"};self.postMessage(t)}};const i=(s,t,a,i)=>s%a,n=(s,t,a)=>a>t?Math.min(Math.max(s,t),a):Math.min(Math.max(s,a),t),r=(s,t,a,r,e,h,u,p)=>{const{cwa:m,vrm:c,vrmm:f,mn:N,mmn:l,vdr:o,das:b,min:d,cs:y,atsc:A,nsi:M}=u,{pdp:g,pdv:v,ilps:F,ifps:S,pcc:U,o:x}=y,I={iLastSample:o.ils,iFirstSample:o.ifs},w=new Int32Array(p);let L=0,C=Math.min(s,s+a*m),k=Math.max(s,s+a*m);const E=[];if(a<0&&C<c||a>0&&k>f)return E;let j=r,q=N,z=N,B=-1,D=l,G=l,H=-1,J=0;for(;j<=I.iLastSample&&j>=I.iFirstSample;){if(L%100==0){const t=Atomics.load(w,0)-b;if(j<t){const i=e[t%b];s=i,C=Math.min(s,s+a*m),k=Math.max(s,s+a*m),u.cs.ilps=void 0,u.cs.ifps=t,u.cs.o=i,u.cs.pcc=0,g.length=0,v.length=0,E.length=0,j=t,J=0,q=N,z=N,B=-1,D=l,G=l,H=-1,I.iFirstSample=Math.max(I.iFirstSample,t),I.iLastSample=Math.max(I.iLastSample,t);continue}}L+=1;const r=j%b,p=e[r],o=h[r];if(d&&Number.isNaN(p))j+=t;else if(C<=p&&p<=k)J+=1,d&&Number.isNaN(o)||(o>z&&(q=p,z=o,B=j),o<G&&(D=p,G=o,H=j)),j+=t;else{if(J>0)q=q===N?Number.NaN:q,z=z===N?Number.NaN:z,D=D===l?Number.NaN:D,G=G===l?Number.NaN:G,B<H?(E.push({if:B,is:H}),t>0?(g.push(q),v.push(z),g.push(D),v.push(G)):(g.unshift(D),v.unshift(G),g.unshift(q),v.unshift(z))):(E.push({if:H,is:B}),t>0?(g.push(D),v.push(G),g.push(q),v.push(z)):(g.unshift(q),v.unshift(z),g.unshift(D),v.unshift(G)));else{const s=t>0?u.cs.ilps:u.cs.ifps;if(void 0===s)E.push({if:0,is:0}),t>0?(g.push(Number.NaN),v.push(Number.NaN),g.push(Number.NaN),v.push(Number.NaN)):(g.unshift(Number.NaN),v.unshift(Number.NaN),g.unshift(Number.NaN),v.unshift(Number.NaN));else{const a=i(s,0,b),r=e[a],u=h[a],m=n((r+p)/2,C,k),c=n((m+p)/2,C,k),f=u+(m-r)/(p-r)*(o-u),N=u+(c-r)/(p-r)*(o-u);E.push({if:s,is:s}),t>0?(g.push(m),v.push(f),g.push(c),v.push(N)):(g.unshift(c),v.unshift(N),g.unshift(m),v.unshift(f))}}if(u.cs.pcc+=1,t>0?u.cs.ilps=j-1:(u.cs.ifps=j+1,u.cs.o=a>0?k:C),C=Math.min(s+E.length*a*m,s+(E.length+1)*a*m),k=Math.max(s+E.length*a*m,s+(E.length+1)*a*m),J=0,q=N,z=N,B=-1,D=l,G=l,H=-1,a<0&&C<c||a>0&&k>f)break}}return E}}();' }, cp = /* @__PURE__ */ new Map();
class YE {
  constructor(t) {
    var e;
    this.yD = /* @__PURE__ */ new Map(), this.pD = /* @__PURE__ */ new WeakMap(), this.mD = /* @__PURE__ */ new WeakMap(), this.Ga = t, this.SD = Math.min((e = this.Ga.maxWorkers) !== null && e !== void 0 ? e : H.navigator.hardwareConcurrency, H.navigator.hardwareConcurrency);
  }
  bD() {
    return this.SD > 0;
  }
  xD(t, e) {
    var i, s;
    const o = this.pD.get(t);
    if (o) return o;
    if (Array.from(this.yD.values()).reduce(((h, u) => h + u.length), 0) >= this.SD) {
      const h = (i = this.yD.get(e)) !== null && i !== void 0 ? i : [], u = h.reduce(((c, d) => !c || d.activeSubscriptions < c.activeSubscriptions ? d : c), h[0]);
      if (!u) throw new Error("Web worker max allowed count reached, requested worker but none available");
      return u.activeSubscriptions += 1, this.pD.set(t, u.worker), u.worker;
    }
    let n = (s = this.yD.get(e)) !== null && s !== void 0 ? s : [];
    const a = n.find(((h) => h.activeSubscriptions <= 0));
    if (a) return a.activeSubscriptions += 1, this.pD.set(t, a.worker), a.worker;
    const l = (function(h) {
      const u = (function(c) {
        let d = cp.get(c);
        if (!d) {
          const f = HE[c];
          if (!f) throw new Error(`Unknown worker type: ${c}`);
          const p = new Blob([f], { type: "application/javascript" });
          d = URL.createObjectURL(p), cp.set(c, d);
        }
        return d;
      })(h);
      return new Worker(u);
    })(e);
    return n.length === 0 && (n = [], this.yD.set(e, n)), n.push({ worker: l, activeSubscriptions: 1 }), this.pD.set(t, l), l;
  }
  MD() {
    this.yD.forEach(((t) => {
      t.slice().forEach(((e) => {
        e.activeSubscriptions <= 0 && (e.worker.terminate(), t.splice(t.indexOf(e), 1));
      }));
    }));
  }
  _D(t) {
    const e = this.pD.get(t);
    e && (this.pD.delete(t), this.yD.forEach(((i) => {
      const s = i.findIndex(((o) => o.worker === e));
      s >= 0 && (i[s].activeSubscriptions -= 1);
    })), H.setTimeout((() => {
      this.MD();
    }), 5e3));
  }
  wD() {
    this.pD = /* @__PURE__ */ new WeakMap(), this.yD.forEach(((t) => {
      t.forEach(((e) => {
        e.worker.terminate();
      }));
    })), this.mD = /* @__PURE__ */ new WeakMap();
  }
  kD(t, e) {
    this.mD.set(t, e);
  }
  CD(t) {
    var e;
    return (e = this.mD.get(t)) !== null && e !== void 0 ? e : {};
  }
}
const jE = (r, t, e) => {
  const i = Mf(), s = (o) => {
    "data" in o && o.data && o.data.id === i && (r.removeEventListener("message", s), e(o.data));
  };
  r.addEventListener("message", s), r.postMessage({ ...t, id: i });
};
class $E {
  constructor(t) {
    this.TD = this.FD.bind(this), H.addEventListener("scroll", this.TD, { passive: !0 }), this.Na = new YE(t);
  }
  G() {
    this.TD && H.removeEventListener("scroll", this.TD), this.TD = void 0, this.Na.wD();
  }
}
class Yh {
  constructor(t, e) {
    this.Rl = t, this.j = e, this._L = !0, this.ID = null, this.PD = null;
  }
}
class zc {
  constructor(t) {
    this.LD = !1, this.BD = 1, this.DD = t, this.ED = { Rl: j(0, 0), j: j(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER), _L: !0, ID: null, PD: null }, this.RD = j(64, 64), this.OD = new Uint8ClampedArray(this.RD.x * this.RD.y * this.BD);
  }
  zD(t, e) {
    if (!t._L) return null;
    if (t.ID && t.PD) {
      const h = this.zD(t.ID, e);
      return h !== null ? h : this.zD(t.PD, e);
    }
    const i = Kn(t.j.x, t.j.y);
    if (t.Rl.x + t.j.x >= Number.MAX_SAFE_INTEGER && (i.x = this.RD.x - t.Rl.x - 1), t.Rl.y + t.j.y >= Number.MAX_SAFE_INTEGER && (i.y = this.RD.y - t.Rl.y - 1), t.j.x === e.x && t.j.y === e.y) return t._L = !1, t;
    if (i.x < e.x || i.y < e.y) return null;
    let s, o;
    const n = i.x - e.x, a = i.y - e.y;
    let l = n < a;
    return n === 0 && a === 0 && (l = !(t.j.x > t.j.y)), l ? (s = new Yh(qt(t.Rl, { x: 0, y: 1 }), j(t.j.x, e.y)), o = new Yh(qt(t.Rl, { x: 0, y: e.y + 1 }), j(t.j.x, t.j.y - 1 - e.y))) : (s = new Yh(qt(t.Rl, { x: 1, y: 0 }), j(e.x, t.j.y)), o = new Yh(qt(t.Rl, { x: e.x + 1, y: 0 }), j(t.j.x - 1 - e.x, t.j.y))), t.ID = s, t.PD = o, this.zD(t.ID, e);
  }
  VD(t, e) {
    const i = { ND: !1, Rl: null };
    let s = this.zD(this.ED, e);
    if (s === null) for (; s === null && this.RD.x < this.DD && this.RD.y < this.DD; ) {
      if (!this.GD(j(2 * this.RD.x, 2 * this.RD.y))) return this.LD = !0, null;
      i.ND = !0, s = this.zD(this.ED, e);
    }
    if (s === null) return this.LD = !0, null;
    for (let o = 0; o < e.y; o += 1) for (let n = 0; n < e.x; n += 1) {
      const a = s.Rl.y + o, l = s.Rl.x + n;
      this.OD[a * this.BD * this.RD.x + l * this.BD + 0] = t[o * this.BD * e.x + n * this.BD + 0];
    }
    return i.Rl = s.Rl, i;
  }
  GD(t) {
    if (t.x > this.DD || t.y > this.DD) return !1;
    const e = new Uint8ClampedArray(t.x * t.y * this.BD);
    for (let i = 0; i < this.RD.y; i += 1) for (let s = 0; s < this.RD.x; s += 1) e[i * t.x * this.BD + s * this.BD + 0] = this.OD[i * this.RD.x * this.BD + s * this.BD + 0];
    return this.RD = t, this.OD = e, !0;
  }
}
class XE {
  constructor(t) {
    this.$D = /* @__PURE__ */ new Map(), this.DD = t, this.$D.set(this.$D.size, new zc(this.DD));
  }
  UD(t) {
    return this.$D.get(t);
  }
  VD(t, e) {
    let i = -1;
    const s = Array.from(this.$D.values());
    for (let a = 0; a < s.length; a += 1) {
      const l = s[a];
      if (!l) break;
      if (!l.LD) {
        i = a;
        break;
      }
    }
    i === -1 && (i = this.$D.size, this.$D.set(this.$D.size, new zc(this.DD)));
    const o = this.$D.get(i);
    if (!o) return null;
    let n = o.VD(t, e);
    if (!n && o.LD) {
      const a = this.$D.size, l = new zc(this.DD);
      this.$D.set(a, l), i = a, n = l.VD(t, e);
    }
    return n ? { jD: i, ...n } : null;
  }
}
var Tn;
(function(r) {
  r[r.Fail = 0] = "Fail", r[r.Success = 1] = "Success", r[r.Resize = 2] = "Resize";
})(Tn || (Tn = {}));
const ZE = wf("font-texture");
class KE {
  constructor(t) {
    this.YD = /* @__PURE__ */ new Map(), this.HD = /* @__PURE__ */ new Map(), this.Si = ZE(), this.WD = t, this.XD = new XE(this.WD.ZD || 4096);
  }
  Rc() {
    return this.HD.forEach(((t) => {
      this.WD.JD(t);
    })), this.HD.clear(), this;
  }
  QD(t, e) {
    const i = this.YD.get(e);
    if (i) return i.get(t);
  }
  KD(t, e, i) {
    let s = this.YD.get(e);
    if (s || (s = /* @__PURE__ */ new Map(), this.YD.set(e, s)), s.has(t.glyph)) return Tn.Success;
    const o = this.XD.VD(i, t.size);
    if (!o || !o.Rl) return Tn.Fail;
    o.ND && this.qD();
    const n = this.XD.UD(o.jD);
    if (!n) return Tn.Fail;
    let a = this.HD.get(o.jD);
    if (!a) {
      const R = this.WD.gl.createTexture();
      if (!R) throw new pi("Failed to create texture for font!");
      a = R, this.HD.set(o.jD, R);
    }
    const l = o.Rl, h = n.RD.x, u = n.RD.y, c = -t.offsetX, d = t.baseline - t.size.y, f = -t.offsetX + t.size.x, p = t.baseline, g = l.x / h, y = (l.y + t.size.y) / u, m = (l.x + t.size.x) / h, A = l.y / u, v = [g, y, m, y, g, A, g, A, m, y, m, A], b = [c, d, f, d, c, p, c, p, f, d, f, p], w = { origin: l, size: t.size, advanceX: t.advance, baseline: t.baseline, vertices: b, texCoords: v, packerId: o.jD, texture: a };
    s.set(t.glyph, w);
    const k = this.WD.gl;
    return k.pixelStorei(k.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), k.bindTexture(k.TEXTURE_2D, a), k.texImage2D(k.TEXTURE_2D, 0, k.LUMINANCE, n.RD.x, n.RD.y, 0, k.LUMINANCE, k.UNSIGNED_BYTE, this.WD.tE ? n.OD : new Uint8Array(n.OD)), k.texParameteri(k.TEXTURE_2D, k.TEXTURE_MIN_FILTER, k.LINEAR), k.texParameteri(k.TEXTURE_2D, k.TEXTURE_MAG_FILTER, k.LINEAR), k.texParameteri(k.TEXTURE_2D, k.TEXTURE_WRAP_S, k.CLAMP_TO_EDGE), k.texParameteri(k.TEXTURE_2D, k.TEXTURE_WRAP_T, k.CLAMP_TO_EDGE), k.bindTexture(k.TEXTURE_2D, null), o.ND ? Tn.Resize : Tn.Success;
  }
  qD() {
    this.YD.forEach(((t) => {
      t.forEach(((e, i) => {
        const s = this.XD.UD(e.packerId);
        if (!s) return;
        const o = e.origin, n = s.RD.x, a = s.RD.y, l = o.x / n, h = (o.y + e.size.y) / a, u = (o.x + e.size.x) / n, c = o.y / a, d = [l, h, u, h, l, c, l, c, u, h, u, c];
        e.texCoords = d, t.set(i, e);
      }));
    }));
  }
}
const qE = (r) => (t, e) => e % 2 ? t : t + r;
class JE {
  constructor(t) {
    this.iE = /* @__PURE__ */ new Map(), this.sE = wf("font"), this.eE = /* @__PURE__ */ new Map(), this.rE = /* @__PURE__ */ new Set(), this.WD = t;
  }
  Rc(t = !1) {
    return (t || this.rE.size === 0) && (this.iE.forEach(((e, i) => {
      e.Rc(), this.iE.delete(i);
    })), this.rE.clear()), this;
  }
  pd(t) {
    this.rE.add(t);
  }
  hE(t) {
    this.rE.delete(t);
  }
  nE(t, e, i, s) {
    const o = H.devicePixelRatio, n = `${s ? "dark" : "light"} - ${qu(e, o).id}`, a = this.eE.get(n), l = this.iE.get(a);
    let h = 0, u = 0, c = 0;
    const d = t.split(""), f = e.size, p = 0.45 * e.size * o, g = Math.round(1 * e.size * o);
    let y = !1;
    for (let A = 0; A < d.length; A += 1) {
      const v = d[A], b = l && l.QD(v, f);
      b ? (v.trim() !== "" && (u = Math.max(u, b.baseline), h = Math.min(h, b.baseline - (b.size.y - 1))), c += b.advanceX) : (v.trim() !== "" && (u = Math.max(u, 0), h = Math.min(h, 0 - (g - 1))), c += p, y = !0);
    }
    const m = qm(c / o, (u - h + 1) / o, i);
    return { x: m.x, y: m.y, isEstimate: y };
  }
  oE(t, e, i) {
    const s = `${i ? "dark" : "light"} - ${e.id}`;
    let o = this.eE.get(s);
    o || (o = this.sE(), this.iE.set(o, new KE(this.WD)), this.eE.set(s, o));
    const n = this.iE.get(o);
    if (!n) throw new pi("Failed to get font texture!");
    let a = 0, l = 0, h = 0;
    const u = t.split(""), c = /* @__PURE__ */ new Map();
    let d = 0;
    const f = e.properties.size;
    for (let y = 0; y < u.length; y += 1) {
      const m = u[y], A = Math.ceil(d);
      let v = n.QD(m, f);
      if (!v) {
        const b = this.WD.aE(m, e.properties, e.dpr, i);
        if (!b) continue;
        const w = n.KD(b[1], f, b[0]);
        if (w === Tn.Resize) {
          this.rE.forEach(((k) => {
            k.Tl.u = !0;
          })), y = -1, d = 0, l = 0, a = 0, c.clear(), this.WD.yi.Rs(!0);
          continue;
        }
        if (w === Tn.Fail) throw new pi("Failed to create glyph");
        if (v = n.QD(m, f), !v) throw new pi("Failed to get glyph after creation");
      }
      if (m.trim() !== "") {
        let b = c.get(v.texture);
        b || (b = { vertices: [], texCoords: [] }, c.set(v.texture, b)), b.vertices.push(...v.vertices.map(qE(A))), b.texCoords.push(...v.texCoords), l = Math.max(l, v.baseline), a = Math.min(a, v.baseline - (v.size.y - 1));
      }
      d += v.advanceX;
    }
    h = d;
    const p = Ee(j(0, a), j(h, l)), g = [];
    return c.forEach(((y, m) => {
      g.push({ texCoords: new Float32Array(y.texCoords), vertices: new Float32Array(y.vertices), texture: m });
    })), [g, p];
  }
}
const Ri = { roundUnsigned: { lE: "roundUnsigned", uE: `float roundUnsigned(float number) {
  return floor(number + 0.5);
}` }, linearStep: { lE: "linearStep", uE: `float linearStep(float step0, float step1, float step) {
  return clamp((step - step0) / (step1 - step0), 0.0, 1.0);
}` }, dither: { lE: "dither", uE: `
const mat4x4 bayerMatrix4x4 = mat4x4(
    0.0,  8.0,  2.0, 10.0,
    12.0, 4.0,  14.0, 6.0,
    3.0,  11.0, 1.0, 9.0,
    15.0, 7.0,  13.0, 5.0
) / 16.0;

vec4 dither(vec2 pos, vec4 c0, vec4 c1, float s0, float s1, float mixVal)
{
    float step = linearStep(s0, s1, mixVal);
    int x = int(pos.x) % 4;
    int y = int(pos.y) % 4;
    float threshold = bayerMatrix4x4[y][x];
    vec4 color = mix(c0, c1, step * 0.95 + threshold * 0.05);
    return color;
}` }, decodeUbyteRGBAEncodedFloat: { lE: "decodeUbyteRGBAEncodedFloat", uE: `
      // Denormalize 8-bit color channels to integers in the range 0 to 255.
      ivec4 floatsToBytes(vec4 inputFloats, bool littleEndian) {
        ivec4 bytes = ivec4(inputFloats * 255.0);
        return (
          littleEndian
          ? bytes.abgr
          : bytes
        );
      }
      
      // Break the four bytes down into an array of 32 bits.
      void bytesToBits(const in ivec4 bytes, out bool bits[32]) {
        for (int channelIndex = 0; channelIndex < 4; ++channelIndex) {
          float acc = float(bytes[channelIndex]);
          for (int indexInByte = 7; indexInByte >= 0; --indexInByte) {
            float powerOfTwo = exp2(float(indexInByte));
            bool bit = acc >= powerOfTwo;
            bits[channelIndex * 8 + (7 - indexInByte)] = bit;
            acc = mod(acc, powerOfTwo);
          }
        }
      }
      
      // Compute the exponent of the 32-bit float.
      float getExponent(bool bits[32]) {
        const int startIndex = 1;
        const int bitStringLength = 8;
        const int endBeforeIndex = startIndex + bitStringLength;
        float acc = 0.0;
        int pow2 = bitStringLength - 1;
        for (int bitIndex = startIndex; bitIndex < endBeforeIndex; ++bitIndex) {
          acc += float(bits[bitIndex]) * exp2(float(pow2--));
        }
        return acc;
      }
      
      // Compute the mantissa of the 32-bit float.
      float getMantissa(bool bits[32], bool subnormal) {
        const int startIndex = 9;
        const int bitStringLength = 23;
        const int endBeforeIndex = startIndex + bitStringLength;
        // Leading/implicit/hidden bit convention:
        // If the number is not subnormal (with exponent 0), we add a leading 1 digit.
        float acc = float(!subnormal) * exp2(float(bitStringLength));
        int pow2 = bitStringLength - 1;
        for (int bitIndex = startIndex; bitIndex < endBeforeIndex; ++bitIndex) {
          acc += float(bits[bitIndex]) * exp2(float(pow2--));
        }
        return acc;
      }
      
      // Parse the float from its 32 bits.
      float bitsToFloat(bool bits[32]) {
        float signBit = float(bits[0]) * -2.0 + 1.0;
        float exponent = getExponent(bits);
        bool subnormal = abs(exponent - 0.0) < 0.01;
        float mantissa = getMantissa(bits, subnormal);
        float exponentBias = 127.0;
        return signBit * mantissa * exp2(exponent - exponentBias - 23.0);
      }
      
      // Decode a 32-bit float from the RGBA color channels of a texel.
      float decodeUbyteRGBAEncodedFloat(vec4 rgba, bool littleEndian) {
        ivec4 rgbaBytes = floatsToBytes(rgba, littleEndian);
        bool bits[32];
        bytesToBits(rgbaBytes, bits);
        return bitsToFloat(bits);
      }
      ` }, texelFetchWithFallback: { webgl2: { lE: "texelFetchWithFallback", uE: `vec4 texelFetchWithFallback(sampler2D textureSampler, ivec2 iTexel, vec2 textureSize) {
  return texelFetch(textureSampler, iTexel, 0);
}` }, webgl1: { lE: "texelFetchWithFallback", uE: `vec4 texelFetchWithFallback(sampler2D textureSampler, ivec2 iTexel, vec2 textureSize) {
  vec2 halfTexel = 0.5 / textureSize;
  return texture2D(textureSampler, (vec2(iTexel) * 2.0 + 1.0) * halfTexel);
}` } }, texelFetchUnsignedWithFallback: { webgl2: { lE: "texelFetchUnsignedWithFallback", uE: `uvec4 texelFetchUnsignedWithFallback(usampler2D textureSampler, ivec2 iTexel, vec2 textureSize) {
  return texelFetch(textureSampler, iTexel, 0);
}` }, webgl1: { lE: "texelFetchUnsignedWithFallback", uE: `uvec4 texelFetchUnsignedWithFallback(usampler2D textureSampler, ivec2 iTexel, vec2 textureSize) {
  vec2 halfTexel = 0.5 / textureSize;
  return texture2D(textureSampler, (vec2(iTexel) * 2.0 + 1.0) * halfTexel);
}` } }, modulus: { lE: "modulus", uE: `int modulus(int a, int b) {
  return (a)-((a)/(b))*(b);
}` }, computeScreenSpaceWireframe: { lE: "computeScreenSpaceWireframe", uE: `#extension GL_OES_standard_derivatives : enable
float computeScreenSpaceWireframe (vec3 barycentric, float lineWidth) {
  vec3 dist = fwidth(barycentric);
  vec3 smoothed = smoothstep(dist * ((lineWidth * 0.5) - 0.5), dist * ((lineWidth * 0.5) + 0.5), barycentric);
  return 1.0 - min(min(smoothed.x, smoothed.y), smoothed.z);
}` } }, Or = "posAxis", Is = "posWorld", nn = "normal", he = "colorFragment", $i = "antiAliasFactor", dp = "mousePickingIdOffset", ea = "uRatioPxClip", fp = "uRatioNwuWu", mr = "uColorTexture", Lu = "uSizePixels", jh = "uOffsetAlignment", Kl = "uMaskTexture", gp = "aNormal", Wc = "Rot", fl = "uUserTransformOffset", gl = "uUserTransformScaling";
class pp {
  constructor(t) {
    this.modifiers = [], this.modifiers = t;
  }
  build(t) {
    const e = this.modifiers.filter(((i) => QE(i)));
    for (const i of e) t = i(t);
    return `${Cn(this.modifiers.filter(((i) => tM(i)))).map(((i) => i.uE)).join(`
`)}
${t}`;
  }
}
const QE = (r) => typeof r == "function", Dd = { lE: "ratioPxClip", uE: `uniform vec2 ${ea};` }, tM = (r) => r && typeof r == "object" && "lE" in r, lt = (...r) => (t) => {
  r = r.reverse();
  for (let e of r) typeof e == "string" && (e = e.includes("{") || e.endsWith(";") ? e : `${e};`, e = e.trim(), t = t.replace("void main(void)", `${e}
void main(void)`));
  return t;
}, Pu = (r) => (t) => (r = r.endsWith(";") ? r : `${r};`, t.replace(r, "")), Wi = (...r) => (t) => {
  const e = r.filter(((s) => s));
  for (let s = 0; s < e.length; s += 1) e[s] = e[s].endsWith(";") ? e[s] : `${e[s]};`, e[s] = e[s].startsWith("	") ? e[s] : `	${e[s]}`;
  const i = e.join(`
`);
  return t.replace(`void main(void) {
`, `void main(void) {
${i}
`);
}, Xx = (r, ...t) => (e) => {
  for (let n = 0; n < t.length; n += 1) t[n] = t[n].endsWith(";") ? t[n] : `${t[n]};`, t[n] = t[n].startsWith("	") ? t[n] : `	${t[n]}`;
  const i = t.join(`
`), s = new RegExp(`(.*${r}.*)`), o = e.replace(s, `${i}
$1`);
  return t.forEach(((n) => {
    if (!o.includes(n)) throw new Error(`ShaderBefore misusage (not found: 
${n}
match: 
${r}
result: 
${o}
)`);
  })), o;
}, Re = (r, ...t) => (e) => {
  const i = t.filter(((u) => typeof u == "string"));
  for (let u = 0; u < i.length; u += 1) i[u] = i[u].endsWith(";") ? i[u] : `${i[u]};`, i[u] = i[u].startsWith("	") ? i[u] : `	${i[u]}`;
  const s = i.join(`
`), o = e.lastIndexOf(r), n = e.substring(o), a = n.indexOf(`
`), l = n.substring(a), h = `${e.substring(0, o + a)}
${s}${l}`;
  return i.forEach(((u) => {
    if (!h.includes(u)) throw new Error(`ShaderAfter misusage (not found: "${u}", match: "${r}", result: "${h}")`);
  })), h;
}, bs = (...r) => (t) => {
  for (let e of r) if (typeof e == "string") {
    e = e.endsWith(";") ? e : `${e};`, e = e.trim(), e = e.startsWith("	") ? e : `	${e}`;
    const i = t.lastIndexOf("}");
    t = `${t.substring(0, i - 1)}
${e}
}`;
  }
  return t;
}, Ji = (r, t) => (e) => {
  let i, s;
  if (r.includes("uniform") || r.includes("attribute")) {
    const o = r.endsWith(";") ? r : `${r};`;
    e = lt(o)(e), i = r.split(" ")[2].replace(";", "");
  } else i = r;
  if (t.includes(" ")) {
    const o = t.endsWith(";") ? t : `${t};`;
    e = lt(o)(e), s = t.split(" ")[2].replace(";", "");
  } else s = t;
  return bs(`	${s} = ${i};`)(e);
}, eM = (...r) => (t) => {
  r = r.reverse();
  for (const e of r) t = e + t;
  return t;
}, Xo = (r, t) => {
  const e = t.steps, i = e.length - 1, s = [lt("uniform vec4 uFallbackColor")], o = [], n = [];
  for (let a = 0; a < t.steps.length; a += 1) o.push(`uniform float uLUTValue${a}`), n.push(`uniform vec4 uLUTColor${a}`);
  return s.push(lt(...o, ...n), t.percentageValues && lt("uniform float uMinValue", "uniform float uMaxValue")), t.interpolate ? s.push(Re(`${he} =`, "vec4 colorLookup = uLUTColor0", "float value = " + (t.percentageValues ? `clamp((${r} - uMinValue) / (uMaxValue  - uMinValue), 0.0, 1.0);` : `${r}`), `if (value <= ${H0}) {
                    colorLookup = uFallbackColor;
                }`, `if (value >= uLUTValue${i}) {
                    colorLookup = uLUTColor${i};
                }`, ...e.slice(0, -1).map(((a, l) => `if (value >= uLUTValue${l} && value <= uLUTValue${l + 1}) {
colorLookup = uLUTColor${l} + vec4(uLUTColor${l + 1}.r -  uLUTColor${l}.r, uLUTColor${l + 1}.g -  uLUTColor${l}.g, uLUTColor${l + 1}.b -  uLUTColor${l}.b, uLUTColor${l + 1}.a -  uLUTColor${l}.a) * (value - uLUTValue${l})/(uLUTValue${l + 1} - uLUTValue${l});} `)), `${he} = colorLookup`)) : s.push(Re(`${he} =`, "vec4 colorLookup = vec4(uLUTValue0)", "float value = " + (t.percentageValues ? `clamp((${r} - uMinValue) / (uMaxValue  - uMinValue), 0.0, 1.0);` : `${r}`), `if (${r} <= ${H0}) {
                    colorLookup = uFallbackColor;
                } else if (${r} < uLUTValue0) { colorLookup = uLUTColor0;} ${e.slice().reverse().map(((a) => {
    const l = e.indexOf(a);
    return `else if (value >= uLUTValue${l}) { colorLookup = uLUTColor${l};} `;
  })).join("")}`, `${he} = colorLookup`)), s;
}, Zo = [lt(`uniform sampler2D ${Kl}`), lt("varying vec2 vMaskTextureCoord"), Re(`${$i} =`, `vec4 maskTextureSample = texture2D(${Kl}, vMaskTextureCoord)`, `${$i} = maskTextureSample.r`)], Ko = [lt(`uniform sampler2D ${Kl}`), lt("varying vec2 vMaskTextureCoord"), Re(`${$i} =`, `vec4 maskTextureSample = texture2D(${Kl}, vMaskTextureCoord)`, `${$i} = maskTextureSample.a`)], yp = [lt("varying vec3 vPosWorld;", "varying vec3 vNormal;", "uniform vec3 uCameraLoc;", "uniform vec3 uLightLoc;", "uniform vec4 uLightColor;", "uniform vec4 uAmbientColor;", "uniform float uShininess;", "uniform float uAmbientReflection;", "uniform float uDiffuseReflection;", "uniform float uSpecularReflection;"), Re(`${he} =`, "float ambientReflection = uAmbientReflection", "float diffuseReflection = uDiffuseReflection", "float specularReflection = uSpecularReflection", "vec3 ambientColor = uAmbientColor.rgb", `vec3 diffuseColor = ${he}.rgb`, "vec3 specularColor = uLightColor.rgb", "vec3 vNormalNormalized = normalize(vNormal)", "vNormalNormalized = (float(gl_FrontFacing) * 2.0 - 1.0) * vNormalNormalized", "vec3 lightDir = normalize( uLightLoc - vPosWorld )", "float lambertian = abs(dot(vNormalNormalized, lightDir))", "float specular = 0.0", "vec3 R =  reflect(-lightDir, vNormalNormalized)", "vec3 V = normalize(uCameraLoc - vPosWorld)", "float specAngle = max(dot(R,V),0.0)", "specular = pow(specAngle, uShininess)", `${he} = vec4(ambientReflection * ambientColor + diffuseReflection * lambertian * diffuseColor + specularReflection * specular * specularColor, ${he}.a)`)], Gc = (r, ...t) => {
  var e, i;
  if (r !== "linear-highPrecision" || t.length === 0) return { vertexShaderModifiers: [], fragmentShaderModifiers: [] };
  const s = t[0];
  return { vertexShaderModifiers: [lt("varying vec4 d"), bs(`d = vec4(${t[0]}.x, ${t[0]}.y, ${(e = t[1]) !== null && e !== void 0 ? e : s}.x, ${(i = t[1]) !== null && i !== void 0 ? i : s}.y)`)], idFragment: "hpfix", fragmentShaderModifiers: [lt("varying vec4 d"), bs("if (d.z == -100.0 + d.z / 10.0) { gl_FragColor = d; }")] };
};
class $h extends Error {
  constructor(t, e, i) {
    super(`Dynamic shader generation error
(id: ${e})
 ${i ? `when applying feature: ${i.idVertex ? `vert: ${i.idVertex}` : ""} ${i.idFragment ? `frag: ${i.idFragment}` : ""}` : ""} | ${t}`);
  }
}
const zi = (...r) => {
  let t = "";
  for (const e of r) {
    if (typeof e != "object") {
      t += `${String(e)},`;
      continue;
    }
    const i = [{ prefix: "", obj: e }];
    for (; i.length > 0; ) {
      const { prefix: s, obj: o } = i.shift();
      t += `${s}:`;
      const n = Object.keys(o).sort();
      for (const a of n) {
        const l = o[a];
        typeof l == "object" && l.__proto__ === Object.prototype || Array.isArray(l) ? i.push({ prefix: a, obj: l }) : t += `${a}=${String(l)},`;
      }
    }
  }
  return t;
}, mp = (r) => r.find(((t) => {
  var e;
  return (e = t.cE) === null || e === void 0 ? void 0 : e.dE;
})) !== void 0, Xh = (r) => r.find(((t) => {
  var e;
  return (e = t.cE) === null || e === void 0 ? void 0 : e.fE;
})) !== void 0, uo = (r, t, ...e) => {
  const i = [], s = t ? "vec3" : "vec2", { axisWorldTranslation: o, scaling: n, translation: a, flipXY: l, flipXZ: h, offsets: u, splitPosAttribute: c, normalSource: d } = r, f = [];
  d === "attribute" && i.push(lt(`attribute vec3 ${gp}`), Wi(`vec3 ${nn} = ${gp}`)), r.userAffineTransform && i.push(lt(`uniform ${s} ${fl}`, `uniform ${s} ${gl}`)), o !== "linear-highPrecision" ? e.forEach(((g) => {
    g.attributeNameAxisCoord !== void 0 && g.variableNameAxisCoord !== void 0 && (c !== !0 ? f.push(`${s} ${g.variableNameAxisCoord} = ${g.attributeNameAxisCoord}`) : f.push(`${s} ${g.variableNameAxisCoord} = ${t ? `vec3(${g.attributeNameAxisCoord}X, ${g.attributeNameAxisCoord}Y, ${g.attributeNameAxisCoord}Z)` : `vec2(${g.attributeNameAxisCoord}X, ${g.attributeNameAxisCoord}Y)`}`));
  })) : e.forEach(((g) => {
    g.attributeNameAxisCoord !== void 0 && g.variableNameAxisCoord !== void 0 && (r.splitPosAttribute !== !0 ? f.push(`${s} ${g.variableNameAxisCoord}_highpart = ${g.attributeNameAxisCoord}_highpart`, `${s} ${g.variableNameAxisCoord}_lowpart = ${g.attributeNameAxisCoord}_lowpart`) : f.push(t ? `${s} ${g.variableNameAxisCoord}_highpart = vec2(${g.attributeNameAxisCoord}_highpartX, ${g.attributeNameAxisCoord}_highpartY, ${g.attributeNameAxisCoord}_highpartZ)` : `${s} ${g.variableNameAxisCoord}_highpart = vec2(${g.attributeNameAxisCoord}_highpartX, ${g.attributeNameAxisCoord}_highpartY)`, t ? `${s} ${g.variableNameAxisCoord}_lowpart = vec2(${g.attributeNameAxisCoord}_lowpartX, ${g.attributeNameAxisCoord}_lowpartY, ${g.attributeNameAxisCoord}_lowpartZ)` : `${s} ${g.variableNameAxisCoord}_lowpart = vec2(${g.attributeNameAxisCoord}_lowpartX, ${g.attributeNameAxisCoord}_lowpartY)`));
  }));
  const p = ((g) => {
    if (g) for (const m of g) {
      const A = ((y = m) == null ? void 0 : y.rotation) && y.rotation.dataType;
      if (A !== void 0 && A !== !1) return A;
    }
    var y;
  })(u);
  if (p === "attribute-deg" && i.push(lt("attribute float aRotDeg"), lt("uniform float uBaseRotDeg")), p === "attribute" && i.push(lt("attribute vec2 aRot")), p === "uniform" && i.push(lt("uniform vec2 uRot")), u?.forEach(((g) => {
    if (g && g.rotation) {
      const y = g.rotation.dataType, m = y === "uniform" ? "u" : "a";
      if (y === "attribute-deg") {
        const A = g.directionVar, v = `c${Wc}`;
        i.push(Wi(`vec2 ${g.directionVar}Rot = vec2(${A}.x * ${v}.y + ${A}.y * ${v}.x, ${A}.y * ${v}.y - ${A}.x * ${v}.x)`));
      } else {
        const A = `${m}${Wc}`, v = g.directionVar;
        i.push(Wi(`vec2 ${g.directionVar}Rot = vec2(${v}.x * ${A}.y + ${v}.y * ${A}.x, ${v}.y * ${A}.y - ${v}.x * ${A}.x)`));
      }
    }
  })), u?.find(((g) => g?.rotation && g.rotation.dataType === "attribute-deg"))) {
    const g = `c${Wc}`;
    i.push(Wi(`vec2 ${g} = vec2(sin((aRotDeg + uBaseRotDeg) * 0.01745329252), cos((aRotDeg + uBaseRotDeg) * 0.01745329252))`));
  }
  if (u && u.forEach(((g) => {
    g && g.skipAddDefinition !== !0 && i.push(lt(`attribute ${s} ${g.directionVar}`));
  })), l === !0) {
    if (o === "linear-highPrecision") throw new Error("Unimplemented vertex location feature combination: linear-highPrecision + flipXY");
    e.forEach(((g) => {
      f.push(`${g.variableNameAxisCoord} = ${t ? `vec3(${g.variableNameAxisCoord}.y, ${g.variableNameAxisCoord}.x, ${g.variableNameAxisCoord}.z)` : `vec2(${g.variableNameAxisCoord}.y, ${g.variableNameAxisCoord}.x)`}`);
    }));
  }
  if (h === !0) {
    if (o === "linear-highPrecision") throw new Error("Unimplemented vertex location feature combination: linear-highPrecision + flipXZ");
    e.forEach(((g) => {
      f.push(`${g.variableNameAxisCoord} = vec3(${g.variableNameAxisCoord}.z, ${g.variableNameAxisCoord}.y, ${g.variableNameAxisCoord}.x)`);
    }));
  }
  if (n) {
    if (o === "linear-highPrecision") throw new Error("Unimplemented vertex location feature combination: linear-highPrecision + scaling");
    const g = (n.dataType === "attribute" ? "a" : "u") + "Scaling", y = t ? "vec3" : "vec2";
    i.push(lt(`${n.dataType} ${y} ${g}`)), e.forEach(((m) => {
      f.push(`${m.variableNameAxisCoord} = ${m.variableNameAxisCoord} * ${g}`);
    }));
  }
  if (a && a.sizeUnit === "axis") {
    if (o === "linear-highPrecision") throw new Error("Unimplemented vertex location feature combination: linear-highPrecision + translation (axis)");
    const g = (a.dataType === "attribute" ? "a" : "u") + "TranslationAxis", y = t ? "vec3" : "vec2";
    i.push(lt(`${a.dataType} ${y} ${g}`)), e.forEach(((m) => {
      f.push(`${m.variableNameAxisCoord} = ${m.variableNameAxisCoord} + ${g}`);
    }));
  }
  if (u?.forEach(((g) => {
    if (g && g.sizeUnit === "axis") {
      const y = (g.dataType === "attribute" ? "a" : "u") + "OffsetAxis", m = g.symmetric === !0 ? "float" : s;
      i.push(lt(`${g.dataType} ${m} ${y}`));
      const A = g.halved ? " * 0.5" : "", v = g.rotation ? `${g.directionVar}Rot` : g.directionVar, b = "offsetGeometry";
      f.push(`${s} ${b} = ${y} * ${v}${A} * sign(uScale)`), t && d === "gpu-calculate" && f.push(`${s} ${nn} = ${v}`), e.forEach(((w) => {
        f.push(r.axisWorldTranslation === "linear" ? `${w.variableNameAxisCoord} = ${w.variableNameAxisCoord} + ${b}` : `${w.variableNameAxisCoord}_highpart = ${w.variableNameAxisCoord}_highpart + ${b}`);
      }));
    }
  })), o === void 0 || o === "linear") i.push(lt(`uniform ${s} uDisp`, `uniform ${s} uScale`)), e.forEach(((g) => {
    f.push(r.userAffineTransform ? `${s} ${g.variableNameWorldCoord} = (${g.variableNameAxisCoord} * ${gl} - uDisp + ${fl}) / uScale` : `${s} ${g.variableNameWorldCoord} = (${g.variableNameAxisCoord} - uDisp) / uScale`);
  }));
  else if (o === "linear-highPrecision") i.push(lt(`uniform ${s} uDisp`, `uniform ${s} uScale`, `uniform ${s} uScaleStart_highpart`, `uniform ${s} uScaleStart_lowpart`)), e.forEach(((g) => {
    f.push(r.userAffineTransform ? `${s} ${g.variableNameAxisCoord}_hprecision = ((${g.variableNameAxisCoord}_highpart - uScaleStart_highpart) + (${g.variableNameAxisCoord}_lowpart - uScaleStart_lowpart)) * ${gl} + ${fl}` : `${s} ${g.variableNameAxisCoord}_hprecision = (${g.variableNameAxisCoord}_highpart - uScaleStart_highpart) + (${g.variableNameAxisCoord}_lowpart - uScaleStart_lowpart)`, `${s} ${g.variableNameWorldCoord} = (${g.variableNameAxisCoord}_hprecision - uDisp) / uScale`, `${s} ${g.variableNameAxisCoord} = ${g.variableNameAxisCoord}_highpart + ${g.variableNameAxisCoord}_lowpart`);
  }));
  else if (o === "matrix") i.push(lt("uniform mat3 uMatrix")), e.forEach(((g) => {
    f.push(`vec2 ${g.variableNameWorldCoord} = (uMatrix * vec3(${g.variableNameAxisCoord}, 1.0)).xy`);
  }));
  else if (o === "matrix4") i.push(lt("uniform mat4 uMatrix")), e.forEach(((g) => {
    f.push(`vec4 ${g.variableNameWorldCoord} = uMatrix * ${g.attributeNameAxisCoord}`);
  }));
  else if (o[0] === "logarithmic") {
    i.push(lt(`uniform ${s} uScaleStart`, `uniform ${s} uScaleStartLog`, `uniform ${s} uScaleInterval`, `uniform ${s} uScaleIntervalLog`, `uniform ${s} uViewportStart`, `uniform ${s} uViewportSize`));
    const g = t ? ["x", "y", "z"] : ["x", "y"], y = [];
    g.forEach(((m) => {
      const A = o[1][m];
      if (A !== void 0) {
        const v = A.base;
        if (v === "e") return;
        const b = `float cLog${v} = 1.0 / log(${xa(v).toFixed(1)})`;
        y.includes(b) || y.push(b);
      }
    })), i.push(lt(...y)), e.forEach(((m, A) => {
      const v = `${A}`, b = [];
      g.forEach(((w) => {
        const k = w.toUpperCase(), R = o[1][w];
        if (R === void 0) f.push(r.userAffineTransform ? `float posPercent${k}${v} = (${m.variableNameAxisCoord}.${w} * ${gl}.${w} - uScaleStart.${w} + ${fl}.${w}) / uScaleInterval.${w}` : `float posPercent${k}${v} = (${m.variableNameAxisCoord}.${w} - uScaleStart.${w}) / uScaleInterval.${w}`);
        else {
          const L = R.base, x = L === "e";
          f.push(r.userAffineTransform ? `float posLog${k}${v} = log(${m.variableNameAxisCoord}.${w} * ${gl}.${w} + ${fl}.${w})${x ? "" : ` * cLog${L}`}` : `float posLog${k}${v} = log(${m.variableNameAxisCoord}.${w})${x ? "" : ` * cLog${L}`}`, `float posPercent${k}${v} = (posLog${k}${v} - uScaleStartLog.${w}) / uScaleIntervalLog.${w}`);
        }
        b.push(`posPercent${k}${v}`);
      })), f.push(`${s} ${m.variableNameWorldCoord} = uViewportStart + ${s}(${b.join(", ")}) * uViewportSize`);
    }));
  }
  return u?.forEach(((g) => {
    if (g && g.sizeUnit === "px") {
      i.push(Dd);
      let y = "vec2(0.0, 0.0)";
      if (g.useAlignment && (i.push(lt(`uniform vec2 ${jh}`)), y = jh), e.find(((m) => m.overrideOffsetPixels))) e.forEach(((m) => {
        f.push(`${m.variableNameWorldCoord} = ${m.variableNameWorldCoord} + ${m.overrideOffsetPixels} * ${ea}`);
      }));
      else {
        const m = `${g.directionVar}Amount`, A = g.symmetric === !0 ? "float" : s;
        i.push(lt(`${g.dataType} ${A} ${m}`));
        const v = g.halved ? " * 0.5" : "";
        let b;
        g.useGeometry !== !1 ? b = `(${g.rotation ? `${g.directionVar}Rot` : g.directionVar} + ${y}) * ${m}${v} * ${ea}` : b = `${m}${v} * ${ea}`, e.forEach(((w) => {
          f.push(`${w.variableNameWorldCoord} = ${w.variableNameWorldCoord} + ${b}`);
        }));
      }
    }
    if (g && g.sizeUnit === "scale") {
      i.push(Dd), i.push(lt(`uniform vec2 ${Lu}`));
      let y = "vec2(0.0, 0.0)";
      g.useAlignment && (i.push(lt(`uniform vec2 ${jh}`)), y = jh);
      const m = (g.dataType === "uniform" ? "u" : "a") + "OffsetScale";
      i.push(lt(`${g.dataType} float ${m}`));
      const A = `(${g.rotation ? `${g.directionVar}Rot` : g.directionVar} + ${y}) * ${m} * ${Lu} * ${ea}`;
      e.forEach(((v) => {
        f.push(`${v.variableNameWorldCoord} = ${v.variableNameWorldCoord} + ${A}`);
      }));
    }
    if (g && g.sizeUnit === "wu") {
      const y = (g.dataType === "attribute" ? "a" : "u") + "OffsetWU", m = g.symmetric === !0 ? "float" : s;
      i.push(lt(`${g.dataType} ${m} ${y}`));
      const A = g.halved ? " * 0.5" : "", v = g.rotation ? `${g.directionVar}Rot` : g.directionVar, b = "offsetGeometry";
      f.push(`${s} ${b} = ${y} * ${v}${A}`), t && d === "gpu-calculate" && f.push(`${s} ${nn} = normalize(${b})`), e.forEach(((w) => {
        f.push(`${w.variableNameWorldCoord} = ${w.variableNameWorldCoord} + ${b}`);
      }));
    }
    if (g && g.sizeUnit === "nwu") {
      i.push(lt(`uniform float ${fp}`));
      const y = (g.dataType === "attribute" ? "a" : "u") + "OffsetNWU", m = g.symmetric === !0 ? "float" : s;
      i.push(lt(`${g.dataType} ${m} ${y}`));
      const A = g.halved ? " * 0.5" : "", v = g.rotation ? `${g.directionVar}Rot` : g.directionVar, b = "offsetGeometry";
      f.push(`${s} ${b} = ${y} * ${v}${A}`), t && d === "gpu-calculate" && f.push(`${s} ${nn} = normalize(${b})`), e.forEach(((w) => {
        f.push(`${w.variableNameWorldCoord} = ${w.variableNameWorldCoord} + ${b} * ${fp}`);
      }));
    }
  })), r.snapToNearestPixel && (i.push(lt("uniform vec2 uViewportSizePx")), e.forEach(((g) => {
    f.push(`${g.variableNameWorldCoord} = 2.0 * floor(((${g.variableNameWorldCoord} + 1.0) * 0.5) * uViewportSizePx + 0.5) / uViewportSizePx - 1.0`);
  }))), i.push(Xx("gl_Position =", ...f)), i;
}, Zh = (r, t, e, i) => {
  const s = [], o = r.axisWorldTranslation, n = t ? "vec3" : "vec2";
  if (o === "linear") s.push(Re(e, `${n} ${i} = ${e} * uScale + uDisp`));
  else if (o === "linear-highPrecision") s.push(Re(e, `${n} ${i} = ${e} * uScale + uDisp + uScaleStart_highpart + uScaleStart_lowpart`));
  else {
    if (o === "matrix") throw new Error("transformWorldCoordBackToAxis | unimplemented vertex location type");
    if (o === "matrix4") throw new Error("transformWorldCoordBackToAxis | unimplemented vertex location type");
    if (o[0] !== "logarithmic") throw new Error("transformWorldCoordBackToAxis | unimplemented vertex location type");
    {
      const a = [`${n} ${e}_percent = (${e} - uViewportStart) / uViewportSize`];
      (t ? ["x", "y", "z"] : ["x", "y"]).forEach(((l) => {
        const h = l.toUpperCase(), u = o[1][l];
        if (u === void 0) a.push(`float pos${h}Back = ${e}_percent.${l} * uScaleInterval.${l} + uScaleStart.${l}`);
        else {
          const c = u.base, d = c === "e" ? "1.0" : `cLog${c}`;
          a.push(`float pos${h}Back = pow(2.71828, (${e}_percent.${l} * uScaleIntervalLog.${l} + uScaleStartLog.${l}) / ${d})`);
        }
      })), a.push(`${n} ${i} = ${n}(posXBack, posYBack${t ? ", posZBack" : ""})`), s.push(Re(e, ...a));
    }
  }
  return s;
}, xp = (r) => ((t) => t.find(((e) => {
  var i;
  return (i = e.cE) === null || i === void 0 ? void 0 : i.AE;
})) !== void 0)(r) ? [Pu("attribute vec4 aColor"), Pu("vColor = aColor"), lt("attribute vec4 aColorA"), lt("attribute vec4 aColorB"), bs("vColor = mix(aColorA, aColorB, aSegmentSide)")] : [], vp = (r) => ((t) => t.find(((e) => {
  var i;
  return (i = e.cE) === null || i === void 0 ? void 0 : i.gE;
})) !== void 0)(r) ? [Pu("attribute float aLookupValue"), Pu("vLookupValue = aLookupValue"), lt("attribute float aLookupValueA"), lt("attribute float aLookupValueB"), bs("vLookupValue = mix(aLookupValueA, aLookupValueB, aSegmentSide)")] : [], K = { "2D": { idFeature: "2D", apply: (r) => ({ idVertex: "2D", idFragment: "2D", defaultVertexShader: "2D", defaultFragmentShader: "FragmentShader" }) }, "2DCompose": { idFeature: "2DCompose", apply: (r) => ({ idVertex: "2DCompose", idFragment: "2DCompose", defaultVertexShader: "2DMatrix", defaultFragmentShader: "Empty" }) }, "3D": { idFeature: "3D", cE: { dE: !0 }, apply: (r) => ({ idVertex: "3D", idFragment: "3D", defaultVertexShader: "3D", defaultFragmentShader: "FragmentShader" }) }, PointSize: (r) => ({ idFeature: "PointSize", apply: (t) => {
  const e = r === "uniform" ? "u" : "a";
  return { idVertex: `SizePrimitive:${zi(r)}`, idFragment: void 0, vertexShaderModifiers: [lt(`${r} float ${e}PointSize`, "uniform float uDevicePixelRatio"), bs(`gl_PointSize = ${e}PointSize * uDevicePixelRatio`)] };
} }), Color: (r) => {
  const t = r && r.dataType, e = r && r.maskTextureText, i = r && r.maskTexture, s = r && r.overrideOpacity;
  return { idFeature: "Color", cE: { fE: !(!Array.isArray(r.dataType) || r.dataType[1] === "value") || void 0, gE: !(!Array.isArray(r.dataType) || r.dataType[1] !== "value") || void 0, AE: r.dataType === "attribute" || void 0 }, apply: (o, n) => {
    let a, l = `Color:${zi(r)}`;
    const h = [];
    let u = "FragmentShader";
    const c = [];
    if (t === "uniform") c.push(lt("uniform vec4 uColor"), Re(`${he} =`, `${he} = uColor`), ...e ? Zo : [], ...i ? Ko : []);
    else if (t === "attribute") a = "colorAttribute", h.push(Ji("attribute vec4 aColor", "varying vec4 vColor")), c.push(lt("varying vec4 vColor"), Re(`${he} =`, `${he} = vColor`), ...e ? Zo : [], ...i ? Ko : []);
    else if (t === "texture") a = "colorTexCoord", h.push(Ji("attribute vec2 aTextureCoord", "varying vec2 vTextureCoord")), c.push(lt("varying vec2 vTextureCoord"), lt(`uniform sampler2D ${mr}`), lt("uniform vec4 uColor"), Re(`${he} =`, `${he} = texture2D(${mr}, vTextureCoord)`, `if(vTextureCoord.x < 0. || vTextureCoord.x > 1. || vTextureCoord.y < 0. || vTextureCoord.y > 1.) {
                        ${he} = uColor;
                    }`), ...e ? Zo : [], ...i ? Ko : []);
    else if (t === "texture-coord-calc-gpu") a = "colorTexCoord", u = "Empty", h.push(lt("attribute vec2 aTextureCoord"), lt("varying vec2 vTextureCoord"), bs("vTextureCoord = gl_Position.xy * 0.5 + 0.5")), c.push(lt("varying vec2 vTextureCoord"), lt(`uniform sampler2D ${mr}`), Wi(`vec4 ${he} = texture2D(${mr}, vTextureCoord)`, `gl_FragColor = ${he};`));
    else if (Array.isArray(t) && t[0] === "image") a = "colorTexCoord", h.push(Ji("attribute vec2 aTextureCoord", "varying vec2 vTextureCoord")), t[1].fitMode === Li.Tile ? c.push(lt(`uniform sampler2D ${mr}`), lt("varying vec2 vTextureCoord"), Re(`${he} =`, `${he} = texture2D(${mr}, vTextureCoord);`)) : c.push(lt(`uniform sampler2D ${mr}`), lt("varying vec2 vTextureCoord"), lt("uniform vec4 uColor"), Re(`${he} =`, `${he} = texture2D(${mr}, vTextureCoord);`, `if(vTextureCoord.x < 0. || vTextureCoord.x > 1. || vTextureCoord.y < 0. || vTextureCoord.y > 1.){
                                ${he} = uColor;
                            }`));
    else if (Array.isArray(t) && t[0] === "lookup") {
      const f = t[1];
      if (f === "value") a = "lookup:value", h.push(Ji("attribute float aLookupValue", "varying float vLookupValue"));
      else {
        const p = `${Or}.${f}`;
        a = `lookup:${f}`, h.push(Ji(p, "varying float vLookupValue"));
      }
      c.push(lt("varying float vLookupValue"), ...Xo("vLookupValue", t[2]), ...e ? Zo : [], ...i ? Ko : []);
    } else if (Array.isArray(t) && t[0] === "gradient") {
      const f = t[1], p = f.getColorStops();
      if (li(f)) {
        const g = n === "webgl2" && !!((d = f) && typeof d == "object" && "type" in d && d.type === "fillstyle" && "fillType" in d && d.fillType === "radial-gradient" && d.ditheringEnabled === !0);
        l = `rgradient${p.length},${i},${e},${g}`, c.push(lt("uniform vec4 uBounds", "uniform vec2 uCenter", "uniform vec2 uDistance", "uniform float uAspect"), lt(...vu(p.map(((y, m) => [`uniform vec4 color_${m}`, `uniform float stop_${m}`])))), Ri.linearStep, g ? Ri.dither : void 0, Re(`${he} =`, "vec2 uv = vec2((((gl_FragCoord.x)-uBounds.x)/(uBounds.z))*uAspect,((gl_FragCoord.y)-uBounds.y)/(uBounds.w))", "float mixVal = distance(uv/uDistance, uCenter/uDistance)", g ? "vec4 color = dither(gl_FragCoord.xy, color_0, color_1, stop_0, stop_1, mixVal)" : "vec4 color = mix(color_0, color_1, linearStep(stop_0, stop_1, mixVal))", ...p.map(((y, m) => m < 2 ? "" : g ? `color = dither(gl_FragCoord.xy, color, color_${m}, stop_${m - 1}, stop_${m}, mixVal);` : `color = mix(color, color_${m}, linearStep(stop_${m - 1}, stop_${m}, mixVal));`)), `${he} = color`), ...e ? Zo : [], ...i ? Ko : []);
      } else hi(f) && (l = `lgradient${p.length},${i},${e}`, c.push(lt("uniform vec4 uBounds", "uniform vec2 uStartPoint", "uniform vec2 uEndPoint"), lt(...vu(p.map(((g, y) => [`uniform vec4 color_${y}`, `uniform float stop_${y}`])))), Ri.linearStep, Re(`${he} =`, "vec2 uv = gl_FragCoord.xy - uBounds.xy", "float magnitude = ((uv.x-uStartPoint.x) * (uEndPoint.x-uStartPoint.x) + (uv.y-uStartPoint.y) * (uEndPoint.y-uStartPoint.y)) / (pow(uEndPoint.x - uStartPoint.x, 2.0) + pow(uEndPoint.y-uStartPoint.y,2.0))", "vec4 color = mix(color_0, color_1, linearStep(stop_0, stop_1, magnitude))", ...p.map(((g, y) => y < 2 ? "" : `color = mix(color, color_${y}, linearStep(stop_${y - 1}, stop_${y}, magnitude))`)), `${he} = color`), ...e ? Zo : [], ...i ? Ko : []));
    }
    var d;
    if (e || i) {
      const f = "maskTexture";
      a = a ? `${a} ${f}` : `Color:${f}`, h.push(Ji("attribute vec2 aMaskTextureCoord", "varying vec2 vMaskTextureCoord"));
    }
    return s && c.push(lt("uniform float uOpacity"), Re(`${he} =`, `${he}.a *= uOpacity`)), { vertexShaderModifiers: h, fragmentShader: u, fragmentShaderModifiers: c, idVertex: a, idFragment: l };
  } };
}, ColorShaded3D: (r) => {
  const { dataType: t, shadingStyle: e, wireframe: i } = r;
  let s = e;
  const o = `ColorShaded3D:${zi(r)}`;
  return { idFeature: "ColorShaded3D", cE: { fE: !(!Array.isArray(r.dataType) || r.dataType[1] === "value") || void 0, gE: !(!Array.isArray(r.dataType) || r.dataType[1] !== "value") || void 0 }, apply: (n, a) => {
    const l = [], h = [];
    if (l.push(e === "phong" && Ji(nn, "varying vec3 vNormal"), Ji(Is, "varying vec3 vPosWorld")), t === "uniform") h.push(lt("uniform vec4 uColorDiffuse"), Re(`${he} =`, `${he} = uColorDiffuse`));
    else if (t === "attribute") s += ",per-vertex-color", l.push(Ji("attribute vec4 aColor", "varying vec4 vColor")), h.push(lt("varying vec4 vColor"), Re(`${he} =`, `${he} = vColor`));
    else if (Array.isArray(t)) {
      const u = t[1];
      if (u === "value") s += ",lookup:value", l.push(Ji("attribute float aLookupValue", "varying float vLookupValue"));
      else {
        const c = `${Or}.${u}`;
        s += `,lookup:${u}`, l.push(Ji(c, "varying float vLookupValue"));
      }
      h.push(lt("varying float vLookupValue"), ...Xo("vLookupValue", t[2]));
    }
    return i && (s += ",wireframe", l.push(Ji("attribute vec3 aTriangleBary", "varying vec3 vTriangleBary")), h.push(lt("varying vec3 vTriangleBary"), lt("uniform vec4 uWireframeColor", "uniform float uWireframeThickness"), Ri.computeScreenSpaceWireframe, Re(`${he} =`, "float edge = computeScreenSpaceWireframe(vTriangleBary, uWireframeThickness)", `${he} = mix(${he}, uWireframeColor, edge)`))), e === "phong" && h.push(...yp), { idVertex: s, idFragment: o, vertexShaderModifiers: l, fragmentShader: "FragmentShader", fragmentShaderModifiers: h };
  } };
}, VertexLocation: (r) => ({ idFeature: "VertexLocation", apply: (t) => {
  const e = Gc(r.axisWorldTranslation, "posAxis_hprecision"), i = [], s = mp(t), o = r.coordType ? r.coordType : s ? "vec3" : "vec2";
  return r.isInstanceRectangleRendering ? i.push(lt("attribute vec2 aRectCorner", "attribute vec2 aMemberStart", "attribute vec2 aMemberEnd"), Wi("vec2 aPos = mix(aMemberStart, aMemberEnd, aRectCorner)")) : r.axisWorldTranslation !== "linear-highPrecision" ? r.splitPosAttribute !== !0 ? i.push(lt(`attribute ${o} aPos`)) : i.push(lt("attribute float aPosX"), lt("attribute float aPosY"), s && lt("attribute float aPosZ")) : r.splitPosAttribute === !0 ? i.push(lt("attribute float aPos_highpartX"), lt("attribute float aPos_lowpartX"), lt("attribute float aPos_highpartY"), lt("attribute float aPos_lowpartY")) : i.push(lt(`attribute ${o} aPos_highpart`), lt(`attribute ${o} aPos_lowpart`)), i.push(...uo(r, s, { attributeNameAxisCoord: "aPos", variableNameAxisCoord: r.coordType === "vec4" ? void 0 : Or, variableNameWorldCoord: Is })), i.push(...e.vertexShaderModifiers), { idVertex: `VertexLocation:${zi(r)}`, idFragment: e.idFragment, vertexShaderModifiers: i, fragmentShaderModifiers: e.fragmentShaderModifiers };
} }), Model3D: (r) => ({ idFeature: "Model3D", apply: (t) => {
  const e = [];
  return e.push(lt("attribute vec3 aGeoPos"), lt("uniform mat4 uModelRotation"), lt("uniform mat4 uModelRotationNormals"), lt("uniform vec3 uLocationAxis"), lt("uniform vec3 uModelAlignment"), lt("uniform vec3 uModelScale"), lt("uniform vec3 uModelSize"), ...uo({ axisWorldTranslation: "linear", normalSource: r.normalSource }, !0, { attributeNameAxisCoord: "uLocationAxis", variableNameAxisCoord: "locationAxis", variableNameWorldCoord: "locationWorld" }), Xx("gl_Position =", "vec3 posWorld = locationWorld + ((uModelRotation * vec4(aGeoPos, 1.0)).xyz  - (uModelAlignment + 1.0) * uModelSize/2.0) * uModelScale;"), r.normalSource === "attribute" && Re(`vec3 ${nn} =`, ` ${nn} = (uModelRotationNormals * vec4(${nn}, 1.0)).xyz;`), ...Xh(t) ? Zh({ axisWorldTranslation: "linear", normalSource: r.normalSource }, !0, Is, Or) : []), { vertexShaderModifiers: e, idVertex: `Model3D:${zi(r)}`, idFragment: void 0 };
} }), LineInstanced2D: (r) => {
  const t = Gc(r.axisWorldTranslation, "locationA_hprecision", "locationB_hprecision"), e = r.offsets && r.offsets[0];
  return { idFeature: "LineInstanced2D", apply: (i) => ({ idVertex: `LineInstanced2D:${zi(r)}`, idFragment: t.idFragment, vertexShaderModifiers: [lt("uniform float uThicknessPixels"), Dd, ...r.axisWorldTranslation !== "linear-highPrecision" && r.splitPosAttribute !== !0 ? [lt("attribute vec2 aLocationA"), lt("attribute vec2 aLocationB")] : r.axisWorldTranslation === "linear-highPrecision" && r.splitPosAttribute !== !0 ? [lt("attribute vec2 aLocationA_highpart"), lt("attribute vec2 aLocationB_highpart"), lt("attribute vec2 aLocationA_lowpart"), lt("attribute vec2 aLocationB_lowpart")] : r.axisWorldTranslation !== "linear-highPrecision" && r.splitPosAttribute === !0 ? [lt("attribute float aLocationAX"), lt("attribute float aLocationAY"), lt("attribute float aLocationBX"), lt("attribute float aLocationBY")] : r.axisWorldTranslation === "linear-highPrecision" && r.splitPosAttribute === !0 ? [lt("attribute float aLocationA_highpartX"), lt("attribute float aLocationA_highpartY"), lt("attribute float aLocationB_highpartX"), lt("attribute float aLocationB_highpartY"), lt("attribute float aLocationA_lowpartX"), lt("attribute float aLocationA_lowpartY"), lt("attribute float aLocationB_lowpartX"), lt("attribute float aLocationB_lowpartY")] : [], lt("attribute vec2 aSegmentPosition"), lt("attribute float aSegmentSide"), e && lt(`attribute vec2 ${e.directionVar}A`, `attribute vec2 ${e.directionVar}B`), ...uo({ ...r, offsets: e ? [{ ...e, skipAddDefinition: !0 }] : [] }, !1, { attributeNameAxisCoord: "aLocationA", variableNameAxisCoord: "locationA", variableNameWorldCoord: "worldA", overrideOffsetPixels: e ? `${e.directionVar}A` : void 0 }, { attributeNameAxisCoord: "aLocationB", variableNameAxisCoord: "locationB", variableNameWorldCoord: "worldB", overrideOffsetPixels: e ? `${e.directionVar}B` : void 0 }), r.ensureMinimumSegmentLength && lt("uniform vec2 uMinSegmentPixelVector"), Re("worldB = ", r.ensureMinimumSegmentLength && "float segmentLengthPixels = sqrt(pow(worldB.x - worldA.x, 2.0) + pow(worldB.y - worldA.y, 2.0)) / length(uRatioPxClip)", r.ensureMinimumSegmentLength && `if (segmentLengthPixels == 0.0 || segmentLengthPixels < length(uMinSegmentPixelVector)) {
                            worldB = worldA + uMinSegmentPixelVector * uRatioPxClip;
                        }`, "vec2 directionBasis = worldB - worldA", "vec2 directionBasisNorm = normalize(directionBasis)", "vec2 perpendBasisNorm = vec2(-directionBasisNorm.y, directionBasisNorm.x)", "vec2 offset = mix(worldA, worldB, aSegmentSide)", "vec2 thicknessDirection = aSegmentPosition.x * directionBasisNorm + aSegmentPosition.y * perpendBasisNorm", `vec2 ${Is} = offset + thicknessDirection * uThicknessPixels * ${ea}`), ...vp(i), ...xp(i), ...Xh(i) ? Zh({ ...r, offsets: e ? [{ ...e, skipAddDefinition: !0 }] : [] }, !1, Is, Or) : [], ...t.vertexShaderModifiers], fragmentShaderModifiers: t.fragmentShaderModifiers }) };
}, Area2D: (r) => ({ idFeature: "Area2D", apply: (t) => {
  const e = Gc(r.axisWorldTranslation, "locationA_hprecision", "locationB_hprecision");
  return { idVertex: `Area2D:${zi(r)}`, idFragment: e.idFragment, vertexShaderModifiers: [...r.axisWorldTranslation !== "linear-highPrecision" && r.splitPosAttribute !== !0 ? [lt("attribute vec2 aLocationA"), lt("attribute vec2 aLocationB")] : r.axisWorldTranslation === "linear-highPrecision" && r.splitPosAttribute !== !0 ? [lt("attribute vec2 aLocationA_highpart"), lt("attribute vec2 aLocationB_highpart"), lt("attribute vec2 aLocationA_lowpart"), lt("attribute vec2 aLocationB_lowpart")] : r.axisWorldTranslation !== "linear-highPrecision" && r.splitPosAttribute === !0 ? [lt("attribute float aLocationAX"), lt("attribute float aLocationAY"), lt("attribute float aLocationBX"), lt("attribute float aLocationBY")] : r.axisWorldTranslation === "linear-highPrecision" && r.splitPosAttribute === !0 ? [lt("attribute float aLocationA_highpartX"), lt("attribute float aLocationA_highpartY"), lt("attribute float aLocationB_highpartX"), lt("attribute float aLocationB_highpartY"), lt("attribute float aLocationA_lowpartX"), lt("attribute float aLocationA_lowpartY"), lt("attribute float aLocationB_lowpartX"), lt("attribute float aLocationB_lowpartY")] : [], lt("attribute float aCurveOrBaseline"), lt("attribute float aSegmentSide"), ...uo(r, !1, { attributeNameAxisCoord: "aLocationA", variableNameAxisCoord: "locationA", variableNameWorldCoord: "worldA" }, { attributeNameAxisCoord: "aLocationB", variableNameAxisCoord: "locationB", variableNameWorldCoord: "worldB" }), Re("worldB = ", "vec2 posCoord = mix(worldA, worldB, aSegmentSide)", r.fill === "bottom" ? "float baseline = min(posCoord.y, -1.0)" : r.fill === "top" ? "float baseline = max(posCoord.y, 1.0)" : r.fill === "left" ? "float baseline = min(posCoord.x, -1.0)" : "float baseline = max(posCoord.x, 1.0)", `vec2 ${Is} = ${r.fill === "bottom" || r.fill === "top" ? "vec2(posCoord.x, mix(posCoord.y, baseline, aCurveOrBaseline))" : "vec2(mix(posCoord.x, baseline, aCurveOrBaseline), posCoord.y)"}`), ...vp(t), ...xp(t), ...Xh(t) ? Zh(r, !1, Is, Or) : [], ...e.vertexShaderModifiers], fragmentShaderModifiers: e.fragmentShaderModifiers };
} }), LineInstanced3D: (r) => ({ idFeature: "LineInstanced3D", apply: (t) => ({ idVertex: `LineInstanced3D:${zi(r)}`, idFragment: void 0, defaultFragmentShader: "FragmentShader", vertexShaderModifiers: [lt("uniform float uOffsetWU"), ...r.axisWorldTranslation !== "linear-highPrecision" ? [lt("attribute vec3 aLocationA"), lt("attribute vec3 aLocationB")] : [lt("attribute vec3 aLocationA_highpart"), lt("attribute vec3 aLocationB_highpart"), lt("attribute vec3 aLocationA_lowpart"), lt("attribute vec3 aLocationB_lowpart")], lt("attribute float aSegmentPosition"), lt("attribute float aPerpendHorizontal"), lt("attribute float aPerpendVertical"), ...uo({ axisWorldTranslation: r.axisWorldTranslation, normalSource: "custom" }, mp(t), { attributeNameAxisCoord: "aLocationA", variableNameAxisCoord: "locationA", variableNameWorldCoord: "worldA" }, { attributeNameAxisCoord: "aLocationB", variableNameAxisCoord: "locationB", variableNameWorldCoord: "worldB" }), Re("worldB = ", "vec3 directionBasis = worldB - worldA", "vec3 directionBasisNorm = normalize(directionBasis)", "vec3 notParallel = normalize(mix( vec3( 0.0, 1.0, 0.0 ), vec3( 0.2, 0.8, 0.0 ), step( abs(directionBasis.y), 0.9 ) ))", "vec3 horizontalBasis = normalize( cross( notParallel, directionBasisNorm ) )", "vec3 verticalBasis = normalize( cross( horizontalBasis, directionBasisNorm ) )", `vec3 ${nn} = aPerpendHorizontal * horizontalBasis + aPerpendVertical * verticalBasis`, `vec3 ${Is} = worldA + aSegmentPosition * directionBasis + ${nn} * uOffsetWU * 0.5`), ...Xh(t) ? Zh({ axisWorldTranslation: r.axisWorldTranslation }, !0, Is, Or) : []] }) }), RoundedEdges3D: { idFeature: "RoundedEdges3D", apply: (r) => ({ idVertex: "RoundedEdges3D", idFragment: void 0, vertexShaderModifiers: [lt("attribute vec3 aEdge"), lt("uniform float uEdgeRoundness"), Re(`${Is} =`, "vec3 boxSizeWorld = abs( aOffsetAxis / uScale )", "float boxMinDimensionWorldXZ = min( boxSizeWorld.x, boxSizeWorld.z )", "vec3 edgeRoundAmount = uEdgeRoundness * vec3( boxMinDimensionWorldXZ, min( boxMinDimensionWorldXZ, boxSizeWorld.y ), boxMinDimensionWorldXZ )", `${Is} = ${Is} + aEdge * edgeRoundAmount`)] }) }, ColorGrid2D: (r) => {
  const t = r.flipXY, e = r.intensityTextureType, i = r.littleEndian, s = r.aggregation;
  return { idFeature: "ColorGrid2D", apply: (o, n) => ({ idVertex: void 0, idFragment: `ColorGrid2D:${zi(r)}`, fragmentShader: "FragmentShader", fragmentShaderModifiers: [lt("uniform vec4 uTileBounds", "uniform vec2 uTileDimensions", "uniform sampler2D uTileIntensityValues", s && "uniform vec2 uAggregationWindowSize"), e === "ubyte" && Ri.decodeUbyteRGBAEncodedFloat, r.interpolation === "bilinear" ? Wi("vec2 cellSizePx = uTileBounds.zw / (uTileDimensions - 1.0)", "vec2 cellIndex = (gl_FragCoord.xy - uTileBounds.xy) / cellSizePx", "vec2 cellStart = floor(cellIndex)", "vec2 cellEnd = ceil(cellIndex)", "vec2 cellStartNormalized = cellStart / (uTileDimensions - 1.0)", "vec2 cellEndNormalized = cellEnd / (uTileDimensions - 1.0)", `vec4 sample00 = texture2D(uTileIntensityValues, ${t ? "cellStartNormalized" : "vec2(cellStartNormalized.y, cellStartNormalized.x)"})`, `vec4 sample01 = texture2D(uTileIntensityValues, ${t ? "vec2(cellStartNormalized.x, cellEndNormalized.y)" : "vec2(cellStartNormalized.y, cellEndNormalized.x)"})`, `vec4 sample10 = texture2D(uTileIntensityValues, ${t ? "vec2(cellEndNormalized.x, cellStartNormalized.y)" : "vec2(cellEndNormalized.y, cellStartNormalized.x)"})`, `vec4 sample11 = texture2D(uTileIntensityValues, ${t ? "cellEndNormalized" : "vec2(cellEndNormalized.y, cellEndNormalized.x)"})`, "float intensity00 = " + (e === "float" ? "sample00.x" : `decodeUbyteRGBAEncodedFloat(sample00, ${i})`), "float intensity01 = " + (e === "float" ? "sample01.x" : `decodeUbyteRGBAEncodedFloat(sample01, ${i})`), "float intensity10 = " + (e === "float" ? "sample10.x" : `decodeUbyteRGBAEncodedFloat(sample10, ${i})`), "float intensity11 = " + (e === "float" ? "sample11.x" : `decodeUbyteRGBAEncodedFloat(sample11, ${i})`), "vec2 lerpFactors = cellIndex - cellStart", `float intensityR1 = mix(intensity00, intensity10, ${t ? "lerpFactors.x" : "lerpFactors.y"})`, `float intensityR2 = mix(intensity01, intensity11, ${t ? "lerpFactors.x" : "lerpFactors.y"})`, `float intensityP = mix(intensityR1, intensityR2,  ${t ? "lerpFactors.y" : "lerpFactors.x"})`) : Wi("vec2 cellSizePx = uTileBounds.zw / (uTileDimensions)", "vec2 cellIndex = (gl_FragCoord.xy - uTileBounds.xy) / cellSizePx", "vec2 cellIndexNormalized = cellIndex / uTileDimensions", ...s ? [`float intensityP = ${s === "max" ? "-" : ""}340282346638528859811704183484516925440.0`, `for (float dy = -uAggregationWindowSize.y; dy <= uAggregationWindowSize.y; dy++) {
                                            for (float dx = -uAggregationWindowSize.x; dx <= uAggregationWindowSize.x; dx++) {
                                                vec2 offset = vec2(dx, dy) / uTileDimensions;
                                                vec2 coord = ${t ? "offset" : "vec2(offset.y, offset.x)"} + ${t ? "cellIndexNormalized" : "vec2(cellIndexNormalized.y, cellIndexNormalized.x)"};
                                                vec4 sample0 = texture2D(uTileIntensityValues, coord);
                                                float intensity0 = ${e === "float" ? "sample0.x;" : `decodeUbyteRGBAEncodedFloat(sample0, ${i};`}
                                                intensityP = ${s === "max" ? "max" : "min"}(intensityP, intensity0);
                                            }
                                        }`] : [`vec4 sample0 = texture2D(uTileIntensityValues, ${t ? "cellIndexNormalized" : "vec2(cellIndexNormalized.y, cellIndexNormalized.x)"})`, "float intensityP = " + (e === "float" ? "sample0.x" : `decodeUbyteRGBAEncodedFloat(sample0, ${i})`)]), ...Xo("intensityP", r.lut)] }) };
}, DrawToNormalTexture: (r) => {
  const t = r.flipXZ, e = r.vertexIdSource, i = r.normalTextureType, s = r.heightmapTextureType, o = r.littleEndian;
  return { idFeature: "DrawToNormalTexture", apply: (n, a) => {
    const l = [], h = [];
    return l.push(lt("uniform ivec2 uTileDimensions", "uniform vec2 uTileDimensionsXZ", "uniform vec2 uTileStartLocationAxisXZ", "uniform vec2 uTileSizeAxisXZ", "uniform sampler2D uHeightmapTexture", i === "uint" ? "flat varying uvec3 vNormalRGB" : "varying vec3 vNormalRGB", e === "attribute" && "attribute float aVertexID"), e !== void 0 && Ri.roundUnsigned, Ri.modulus, Ri.texelFetchWithFallback[a], s === "ubyte" && Ri.decodeUbyteRGBAEncodedFloat, Wi(e === void 0 ? "int iVertex = gl_VertexID" : "int iVertex = int(roundUnsigned(aVertexID))", "int iSecondary = modulus(iVertex, (uTileDimensions.y - 1))", "int iPrimary = iVertex / (uTileDimensions.y - 1)", "vec2 iCell = vec2(float(iPrimary), float(iSecondary))", "vec2 uTileDimensionsMinus1 = vec2(uTileDimensions) - 1.0", "vec2 halfTexelWorld = 2.0 / (uTileDimensionsMinus1 * 2.0)", "vec2 posWorld = vec2(-1.0 + halfTexelWorld.y + iCell.y * 2.0 * halfTexelWorld.y, -1.0 + halfTexelWorld.x + iCell.x * 2.0 * halfTexelWorld.x)", "vec2 cellSizeAxis = uTileSizeAxisXZ / (uTileDimensionsXZ - 1.0)", `vec3 posAxis0 = vec3(
                            uTileStartLocationAxisXZ.x + iCell.${t ? "y" : "x"} * cellSizeAxis.x,
                            ${s === "float" ? "texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y, iCell.x), vec2(uTileDimensions.y, uTileDimensions.x)).x" : `decodeUbyteRGBAEncodedFloat(texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y, iCell.x), vec2(uTileDimensions.y, uTileDimensions.x)), ${o})`} ,
                            uTileStartLocationAxisXZ.y + iCell.${t ? "x" : "y"} * cellSizeAxis.y
                        )`, "vec2 iCell1 = iCell + vec2(1.0, 0.0)", `vec3 posAxis1 = vec3(
                            uTileStartLocationAxisXZ.x + iCell1.${t ? "y" : "x"} * cellSizeAxis.x,
                            ${s === "float" ? "texelFetchWithFallback(uHeightmapTexture, ivec2(iCell1.y, iCell1.x), vec2(uTileDimensions.y, uTileDimensions.x)).x" : `decodeUbyteRGBAEncodedFloat(texelFetchWithFallback(uHeightmapTexture, ivec2(iCell1.y, iCell1.x), vec2(uTileDimensions.y, uTileDimensions.x)), ${o})`},
                            uTileStartLocationAxisXZ.y + iCell1.${t ? "x" : "y"} * cellSizeAxis.y
                        )`, "vec2 iCell2 = iCell + vec2(0.0, 1.0)", `vec3 posAxis2 = vec3(
                            uTileStartLocationAxisXZ.x + iCell2.${t ? "y" : "x"} * cellSizeAxis.x,
                            ${s === "float" ? "texelFetchWithFallback(uHeightmapTexture, ivec2(iCell2.y, iCell2.x), vec2(uTileDimensions.y, uTileDimensions.x)).x" : `decodeUbyteRGBAEncodedFloat(texelFetchWithFallback(uHeightmapTexture, ivec2(iCell2.y, iCell2.x), vec2(uTileDimensions.y, uTileDimensions.x)), ${o})`},
                            uTileStartLocationAxisXZ.y + iCell2.${t ? "x" : "y"} * cellSizeAxis.y
                        )`, "vec2 iCell3 = iCell + vec2(1.0, 1.0)", `vec3 posAxis3 = vec3(
                            uTileStartLocationAxisXZ.x + iCell3.${t ? "y" : "x"} * cellSizeAxis.x,
                            ${s === "float" ? "texelFetchWithFallback(uHeightmapTexture, ivec2(iCell3.y, iCell3.x), vec2(uTileDimensions.y, uTileDimensions.x)).x" : `decodeUbyteRGBAEncodedFloat(texelFetchWithFallback(uHeightmapTexture, ivec2(iCell3.y, iCell3.x), vec2(uTileDimensions.y, uTileDimensions.x)), ${o})`},
                            uTileStartLocationAxisXZ.y + iCell3.${t ? "x" : "y"} * cellSizeAxis.y
                        )`, "vec3 normal = normalize(cross(posAxis2 - posAxis0, posAxis1 - posAxis0) + cross(posAxis1 - posAxis3, posAxis2 - posAxis3))", i === "uint" ? "vNormalRGB = uvec3(((normal / 2.0) + 0.5) * float(-1u))" : "vNormalRGB = (normal / 2.0) + 0.5", "gl_PointSize = 1.0")), h.push(lt(i === "uint" ? "flat varying uvec3 vNormalRGB" : "varying vec3 vNormalRGB"), Wi(i === "uint" ? "gl_FragColor = uvec4(vNormalRGB, -1u)" : "gl_FragColor = vec4(vNormalRGB, 1.0)")), { idVertex: `DrawToNormalTexture:${zi(r)}`, idFragment: `DrawToNormalTexture:${zi(r)}`, vertexShaderModifiers: l, fragmentShaderModifiers: h, fragmentShader: "Empty", hints: [i === "uint" && { type: "fragOutput", fragOutput: "uvec4" }] };
  } };
}, SurfaceGrid: (r) => {
  const t = r.fillColor, e = r.interpolation, i = r.flipXZ, s = r.shadingStyle, o = r.wireframe, n = r.normalTextureType, a = r.heightmapTextureType, l = r.intensityTextureType, h = r.littleEndian;
  return { idFeature: "SurfaceGrid", cE: { vE: !0 }, apply: (u, c) => {
    const d = [], f = [];
    return d.push(lt("attribute vec2 aGeoCellOffset", "uniform int uBaseInstance", "uniform ivec2 uTileDimensions", "uniform vec2 uTileDimensionsXZ", "uniform vec2 uTileStartLocationAxisXZ", "uniform vec2 uTileSizeAxisXZ", "uniform sampler2D uHeightmapTexture"), Ri.modulus, Ri.texelFetchWithFallback[c], a === "ubyte" && Ri.decodeUbyteRGBAEncodedFloat, Wi("int iSecondary = modulus(iInstance + uBaseInstance, (uTileDimensions.y - 1))", "int iPrimary = (iInstance + uBaseInstance) / (uTileDimensions.y - 1)", "vec2 iCell = vec2(float(iPrimary), float(iSecondary))", "vec2 iCellVertex = iCell + aGeoCellOffset", "vec2 uTileDimensionsMinus1 = vec2(float(uTileDimensions.x), float(uTileDimensions.y)) - 1.0", "vec2 ySampleCoordinate = vec2(iCellVertex.y, iCellVertex.x) / vec2(uTileDimensionsMinus1.y, uTileDimensionsMinus1.x)", "float y = " + (a === "float" ? "texelFetchWithFallback(uHeightmapTexture, ivec2(iCellVertex.y, iCellVertex.x), vec2(uTileDimensions.y, uTileDimensions.x)).x" : `decodeUbyteRGBAEncodedFloat(texelFetchWithFallback(uHeightmapTexture, ivec2(iCellVertex.y, iCellVertex.x), vec2(uTileDimensions.y, uTileDimensions.x)), ${h})`), "vec2 cellSizeAxis = uTileSizeAxisXZ / (uTileDimensionsXZ - 1.0)", "vec2 posAxisXZ = uTileStartLocationAxisXZ + cellSizeAxis * " + (i ? "vec2(iCellVertex.y, iCellVertex.x)" : "iCellVertex"), r.axisWorldTranslation !== "linear-highPrecision" && "vec3 posAxis = vec3(posAxisXZ.x, y, posAxisXZ.y)", r.axisWorldTranslation === "linear-highPrecision" && "vec3 posAxis_highpart = vec3(posAxisXZ.x, y, posAxisXZ.y)", r.axisWorldTranslation === "linear-highPrecision" && "vec3 posAxis_lowpart = vec3(0.0)")), d.push(...uo({ axisWorldTranslation: r.axisWorldTranslation, normalSource: "custom" }, !0, { attributeNameAxisCoord: void 0, variableNameAxisCoord: Or, variableNameWorldCoord: Is })), s === "phong" && d.push(Ji(Is, "varying vec3 vPosWorld"), ...n === "uint" ? [Ri.texelFetchUnsignedWithFallback[c], bs("vec4 normalAxisRGB = vec4(texelFetchUnsignedWithFallback(uNormalmapTexture, ivec2(iCell.y, iCell.x), vec2(uTileDimensionsMinus1.y, uTileDimensionsMinus1.x))) / float(-1u)")] : [bs("vec4 normalAxisRGB = texelFetchWithFallback(uNormalmapTexture, ivec2(iCell.y, iCell.x), vec2(uTileDimensionsMinus1.y, uTileDimensionsMinus1.x))")], bs("vec3 normalAxis = (normalAxisRGB.rgb * 2.0) - 1.0", "vNormal = normalize(normalAxis * uScale)"), lt("varying vec3 vNormal", ...n === "uint" ? ["uniform usampler2D uNormalmapTexture"] : ["uniform sampler2D uNormalmapTexture"])), f.push(lt("varying vec3 vTriangleBary")), t === "uniform" ? f.push(lt("uniform vec4 uColorDiffuse"), Re(`${he} =`, `${he} = uColorDiffuse`)) : Array.isArray(t) && t[0] === "lookup" && (t[1] === "value" ? (d.push(Ji(`${Or}.xz`, "varying vec2 vVertexLocationAxisXZ")), f.push(lt("uniform vec4 uTileBoundsAxisXZ", "uniform vec2 uTileDimensionsXZ", "varying vec2 vVertexLocationAxisXZ", "uniform sampler2D uTileIntensityValues", "uniform mat4 uViewProjectionMatrix", "uniform vec3 uScale", "uniform vec3 uDisp"), l === "ubyte" && Ri.decodeUbyteRGBAEncodedFloat, e === "bilinear" ? Wi("vec2 cellSizeAxisXZ = uTileBoundsAxisXZ.zw / (uTileDimensionsXZ - 1.0)", "vec2 cellIndex = (vVertexLocationAxisXZ - uTileBoundsAxisXZ.xy) / cellSizeAxisXZ", "vec2 cellStart = floor(cellIndex)", "vec2 cellEnd = ceil(cellIndex)", "vec2 cellStartNormalized = cellStart / (uTileDimensionsXZ - 1.0)", "vec2 cellEndNormalized = cellEnd / (uTileDimensionsXZ - 1.0)", `vec4 sample00 = texture2D(uTileIntensityValues, ${i ? "cellStartNormalized" : "vec2(cellStartNormalized.y, cellStartNormalized.x)"})`, `vec4 sample01 = texture2D(uTileIntensityValues, ${i ? "vec2(cellStartNormalized.x, cellEndNormalized.y)" : "vec2(cellStartNormalized.y, cellEndNormalized.x)"})`, `vec4 sample10 = texture2D(uTileIntensityValues, ${i ? "vec2(cellEndNormalized.x, cellStartNormalized.y)" : "vec2(cellEndNormalized.y, cellStartNormalized.x)"})`, `vec4 sample11 = texture2D(uTileIntensityValues, ${i ? "cellEndNormalized" : "vec2(cellEndNormalized.y, cellEndNormalized.x)"})`, "float intensity00 = " + (l === "float" ? "sample00.x" : `decodeUbyteRGBAEncodedFloat(sample00, ${h})`), "float intensity01 = " + (l === "float" ? "sample01.x" : `decodeUbyteRGBAEncodedFloat(sample01, ${h})`), "float intensity10 = " + (l === "float" ? "sample10.x" : `decodeUbyteRGBAEncodedFloat(sample10, ${h})`), "float intensity11 = " + (l === "float" ? "sample11.x" : `decodeUbyteRGBAEncodedFloat(sample11, ${h})`), "vec2 lerpFactors = cellIndex - cellStart", `float intensityR1 = mix(intensity00, intensity10, ${i ? "lerpFactors.x" : "lerpFactors.y"})`, `float intensityR2 = mix(intensity01, intensity11, ${i ? "lerpFactors.x" : "lerpFactors.y"})`, `float intensityP = mix(intensityR1, intensityR2,  ${i ? "lerpFactors.y" : "lerpFactors.x"})`) : Wi("vec2 cellSizeAxisXZ = uTileBoundsAxisXZ.zw / (uTileDimensionsXZ - 1.0)", "vec2 cellIndex = floor((vVertexLocationAxisXZ - uTileBoundsAxisXZ.xy) / cellSizeAxisXZ)", "vec2 cellIndexNormalized = cellIndex / (uTileDimensionsXZ - 1.0)", `vec4 sample0 = texture2D(uTileIntensityValues, ${i ? "cellIndexNormalized" : "vec2(cellIndexNormalized.y, cellIndexNormalized.x)"})`, "float intensityP = sample0.x"), ...Xo("intensityP", t[2]))) : (d.push(Ji(`${Or}.${t[1]}`, "varying float vLookupValue")), f.push(lt("varying float vLookupValue"), ...Xo("vLookupValue", t[2])))), s === "phong" && f.push(...yp), o && (d.push(lt("attribute vec3 aTriangleBary"), Ji("aTriangleBary", "varying vec3 vTriangleBary")), f.push(lt("uniform vec4 uWireframeColor", "uniform float uWireframeThickness"), Ri.computeScreenSpaceWireframe, Re(`${he} =`, "float edge = computeScreenSpaceWireframe(vTriangleBary, uWireframeThickness)", t ? `if (edge > 0.0) {
                                    ${he} = vec4(mix(${he}.rgb, uWireframeColor.rgb, edge * uWireframeColor.a), max(${he}.a, uWireframeColor.a));
                                }` : `if (edge > 0.0) {
                                    ${he} = uWireframeColor;
                                  } else {
                                      discard;
                                  }`))), { idVertex: `SurfaceGrid:${zi(r)}`, idFragment: `SurfaceGrid:${zi(r)}`, vertexShaderModifiers: d, fragmentShader: "FragmentShader", fragmentShaderModifiers: f };
  } };
}, DebugSurfaceGridNormals: (r) => ({ idFeature: "DebugSurfaceGridNormals", apply: (t, e) => ({ idVertex: `DebugSurfaceGridNormals:${zi(r)}`, idFragment: `DebugSurfaceGridNormals:${zi(r)}`, vertexShaderModifiers: [lt("attribute float aNormalArrow", "uniform int uBaseInstance", "uniform ivec2 uTileDimensions", "uniform vec2 uTileDimensionsXZ", "uniform vec2 uTileStartLocationAxisXZ", "uniform vec2 uTileSizeAxisXZ", "uniform sampler2D uHeightmapTexture", r.instanceIdSource === "attribute" && "attribute float aInstanceID", ...r.normalTextureType === "uint" ? ["uniform usampler2D uNormalmapTexture"] : ["uniform sampler2D uNormalmapTexture"]), Ri.roundUnsigned, Ri.modulus, Ri.texelFetchWithFallback[e], r.heightmapTextureType === "ubyte" && Ri.decodeUbyteRGBAEncodedFloat, Wi(r.instanceIdSource === void 0 ? "int iInstance = gl_InstanceID" : "int iInstance = int(roundUnsigned(aInstanceID))", "iInstance = iInstance + uBaseInstance", "int iSecondary = modulus(iInstance, (uTileDimensions.y - 1))", "int iPrimary = iInstance / (uTileDimensions.y - 1)", "vec2 iCell = vec2(float(iPrimary), float(iSecondary))", "vec2 uTileDimensionsMinus1 = vec2(float(uTileDimensions.x), float(uTileDimensions.y)) - 1.0", "float y00 = " + (r.heightmapTextureType === "float" ? "texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y, iCell.x), vec2(uTileDimensions.y, uTileDimensions.x)).x" : `decodeUbyteRGBAEncodedFloat(texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y, iCell.x), vec2(uTileDimensions.y, uTileDimensions.x)), ${r.littleEndian})`), "float y01 = " + (r.heightmapTextureType === "float" ? "texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y + 1.0, iCell.x), vec2(uTileDimensions.y, uTileDimensions.x)).x" : `decodeUbyteRGBAEncodedFloat(texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y + 1.0, iCell.x), vec2(uTileDimensions.y, uTileDimensions.x)), ${r.littleEndian})`), "float y10 = " + (r.heightmapTextureType === "float" ? "texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y, iCell.x + 1.0), vec2(uTileDimensions.y, uTileDimensions.x)).x" : `decodeUbyteRGBAEncodedFloat(texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y, iCell.x + 1.0), vec2(uTileDimensions.y, uTileDimensions.x)), ${r.littleEndian})`), "float y11 = " + (r.heightmapTextureType === "float" ? "texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y + 1.0, iCell.x + 1.0), vec2(uTileDimensions.y, uTileDimensions.x)).x" : `decodeUbyteRGBAEncodedFloat(texelFetchWithFallback(uHeightmapTexture, ivec2(iCell.y + 1.0, iCell.x + 1.0), vec2(uTileDimensions.y, uTileDimensions.x)), ${r.littleEndian})`), "float y = (y00 + y01 + y10 + y11) / 4.0", "vec2 cellSizeAxis = uTileSizeAxisXZ / (uTileDimensionsXZ - 1.0)", `vec2 posAxisXZ = uTileStartLocationAxisXZ + cellSizeAxis * (0.5 + ${r.flipXZ ? "vec2(iCell.y, iCell.x)" : "iCell"})`, "vec3 posAxis = vec3(posAxisXZ.x, y, posAxisXZ.y)", ...r.normalTextureType === "uint" ? ["vec4 normalAxisRGB = vec4(texelFetchUnsignedWithFallback(uNormalmapTexture, ivec2(iCell.y, iCell.x), vec2(uTileDimensionsMinus1.y, uTileDimensionsMinus1.x))) / float(-1u)"] : ["vec4 normalAxisRGB = texelFetchWithFallback(uNormalmapTexture, ivec2(iCell.y, iCell.x), vec2(uTileDimensionsMinus1.y, uTileDimensionsMinus1.x))"], "vec3 normalAxis = (normalAxisRGB.rgb * 2.0) - 1.0", "vec3 normalWorld = normalize(normalAxis * uScale)"), ...r.normalTextureType === "uint" ? [Ri.texelFetchUnsignedWithFallback[e]] : [], ...uo({ axisWorldTranslation: r.axisWorldTranslation, normalSource: "custom" }, !0, { attributeNameAxisCoord: void 0, variableNameAxisCoord: Or, variableNameWorldCoord: Is }), Re("posWorld =", "vec3 dirArrow = normalWorld", "vec3 posArrowStart = posWorld", "vec3 posArrowEnd = posWorld + dirArrow * 0.010", "vec3 notParallel = normalize(mix( vec3( 0.0, 1.0, 0.0 ), vec3( 0.2, 0.8, 0.0 ), step( abs(dirArrow.y), 0.9 ) ))", "vec3 dirArrowLeft = normalize(-dirArrow + 0.50 * normalize(cross(dirArrow, notParallel)))", "vec3 dirArrowRight = normalize(-dirArrow + 0.50 * normalize(cross(notParallel, dirArrow)))", "vec3 posArrowLeft = posArrowEnd + dirArrowLeft * 0.0025", "vec3 posArrowRight = posArrowEnd + dirArrowRight * 0.0025", `if (aNormalArrow == 0.0) {
                        posWorld = posArrowStart;
                    } else if (aNormalArrow == 1.0) {
                        posWorld = posArrowEnd;
                    } else if (aNormalArrow == 2.0) {
                        posWorld = posArrowLeft;
                    } else if (aNormalArrow == 3.0) {
                        posWorld = posArrowRight;
                    }`)], fragmentShader: "FragmentShader", fragmentShaderModifiers: [bs("gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0)")] }) }), OffsetTowardsCamera: () => ({ idFeature: "OffsetTowardsCamera", apply: (r) => ({ idVertex: "OffsetTowardsCamera", idFragment: void 0, vertexShaderModifiers: [lt("uniform vec3 uCameraLoc"), Re("posWorld =", "posWorld = posWorld + normalize(uCameraLoc) * 0.0025")] }) }), AliasedEdge: { idFeature: "AliasedEdge", apply: (r) => ({ idVertex: "AliasedEdge", idFragment: "AliasedEdge", vertexShaderModifiers: [lt("attribute float aSegmentInside"), lt("varying float vSegmentInside"), lt("varying float vSegmentSide"), Re("gl_Position = ", `
                vSegmentInside = aSegmentInside;
                vSegmentSide = aSegmentSide;
                `)], fragmentShaderModifiers: [eM("#extension GL_OES_standard_derivatives : enable"), lt("uniform float uAALimit"), lt("varying float vSegmentInside"), lt("varying float vSegmentSide"), Re(`${$i} = `, `
                float dist = (uAALimit - vSegmentInside);
                vec2 ddist = vec2(dFdx(dist), dFdy(dist));
                float pixelDist = dist / length(ddist);
                // additional blurring
                pixelDist *= 0.5;

                float aa = clamp(0.5 - pixelDist, 0.0, 1.0);
                if((vSegmentSide <= 0.0 || vSegmentSide >= 1.0) && aa <=0.99){
                    aa *= 0.5;
                }
                ${$i} = aa;
                `)] }) }, Glow1D: (r) => ({ idFeature: "Glow1D", apply: () => {
  const t = Math.round(r.spreadPx), e = Math.round(r.blurPx), i = t + e, s = r.firstPass, o = [];
  for (let n = -i; n <= i; n += 1) {
    const a = Math.abs(n);
    o.push(s ? { x: n.toFixed(1), y: "0.0", distPx: a.toFixed(1) } : { x: "0.0", y: n.toFixed(1), distPx: a.toFixed(1) });
  }
  return { idVertex: `Glow1D:${zi(r)}`, idFragment: `Glow1D:${zi(r)}`, vertexShaderModifiers: [Ji("attribute vec2 aTextureCoord", "varying vec2 vTextureCoord")], fragmentShader: "FragmentShader", fragmentShaderModifiers: [lt("uniform sampler2D uTexture"), lt("varying vec2 vTextureCoord"), lt("uniform vec2 uTextureSize"), s && lt("uniform vec2 uOffsetPx"), !s && lt("uniform sampler2D uTextureFirstGlowPass"), !s && lt("uniform vec4 uGlowColor"), Re(`${$i} =`, "vec2 oneTexel = vec2(1.0, 1.0) / uTextureSize", "vec2 vTexCoordPixelCenter = vTextureCoord + vec2(0.5, 0.5) / uTextureSize", ...s ? [] : [`float inverseIntensity =
                                    0.25 * texture2D(uTexture, vTexCoordPixelCenter).a +
                                    0.125 * texture2D(uTexture, vTexCoordPixelCenter + vec2(-oneTexel.x, 0.0)).a +
                                    0.125 * texture2D(uTexture, vTexCoordPixelCenter + vec2(oneTexel.x, 0.0)).a +
                                    0.125 * texture2D(uTexture, vTexCoordPixelCenter + vec2(0.0, -oneTexel.y)).a +
                                    0.125 * texture2D(uTexture, vTexCoordPixelCenter + vec2(0.0, oneTexel.y)).a +
                                    0.0625 * texture2D(uTexture, vTexCoordPixelCenter + vec2(-oneTexel.x, -oneTexel.y)).a +
                                    0.0625 * texture2D(uTexture, vTexCoordPixelCenter + vec2(oneTexel.x, -oneTexel.y)).a +
                                    0.0625 * texture2D(uTexture, vTexCoordPixelCenter + vec2(-oneTexel.x, oneTexel.y)).a +
                                    0.0625 * texture2D(uTexture, vTexCoordPixelCenter + vec2(oneTexel.x, oneTexel.y)).a`, `${$i} *= 1.0 - (inverseIntensity * inverseIntensity)`, `if (${$i} <= 0.0) { discard; }`], "float distancePx = 255.0", "vec2 sample_tx = vec2(0.0)", ...s ? ["vec2 texCoordOffset = vTexCoordPixelCenter - uOffsetPx * oneTexel", ...o.map(((n, a) => [`sample_tx = texCoordOffset + oneTexel * vec2(${n.x}, ${n.y})`, `if (distancePx > ${n.distPx} && sample_tx.x <= 1.0 && sample_tx.y <= 1.0 && sample_tx.x >= 0.0 && sample_tx.y >= 0.0 && texture2D(uTexture, sample_tx).a > 0.0) { distancePx = ${n.distPx}; }`])).flat(), `${he} = vec4(distancePx / 255.0, 0.0, 0.0, 1.0)`] : ["vec4 sample_horizontal = vec4(0.0)", "float horizontal_dist = 255.0", "float min_horizontal_dist = 255.0", ...o.map(((n, a) => [`sample_tx = vTexCoordPixelCenter + oneTexel * vec2(${n.x}, ${n.y})`, `if (sample_tx.x <= 1.0 && sample_tx.y <= 1.0 && sample_tx.x >= 0.0 && sample_tx.y >= 0.0) {
                                                sample_horizontal = texture2D(uTextureFirstGlowPass, sample_tx);
                                                horizontal_dist = sample_horizontal.r * 255.0;
                                            }`, "if (sample_horizontal.a < 0.9) { horizontal_dist = 255.0; }", "min_horizontal_dist = min(min_horizontal_dist, horizontal_dist)", `distancePx = min(distancePx, pow(horizontal_dist * horizontal_dist + ${n.y} * ${n.y}, 0.5))`])).flat(), `if (distancePx > ${i.toFixed(1)}) { discard; }`, "vec4 pixelGlowColor = vec4(0.0, 0.0, 0.0, 0.0)", `if (distancePx > ${t.toFixed(1)}) {
                                        float lerpAmount = (distancePx - ${t.toFixed(1)}) / ${(e + 1).toFixed(1)};
                                        pixelGlowColor = mix(uGlowColor, vec4(uGlowColor.rgb, 0.0), 1.0 - (1.0 - lerpAmount) * (1.0 - lerpAmount));
                                    } else {
                                        pixelGlowColor = uGlowColor;
                                    }`, `${he} = pixelGlowColor`])] };
} }), MousePicking: (r) => {
  const t = !!r?.customMousePickingIdInput, e = !t && !!r?.useVertexId, i = !t && !!r?.useAttribute, s = !t && !e && !i;
  return { idFeature: "MousePicking", cE: { vE: s, yE: e }, apply: (o, n) => {
    const a = n === "webgl2" ? "flat" : "", l = n === "webgl2" ? "int" : "float";
    return { idVertex: `MousePicking:${zi(r)}`, idFragment: `MousePicking:${zi(r)}`, vertexShaderModifiers: [...s ? [lt(`${a} varying ${l} vPickingIdOffset`), bs(`vPickingIdOffset = ${l}(iInstance)`)] : [], ...e ? [lt(`${a} varying ${l} vPickingIdOffset`), bs(`vPickingIdOffset = ${l}(iVertex)`)] : [], ...i ? [lt("attribute float aPickingIdOffset", `${a} varying ${l} vPickingIdOffset`), bs(`vPickingIdOffset = ${l}(aPickingIdOffset)`)] : []], fragmentShaderModifiers: [lt("uniform int uFirstId"), ...t ? [] : [lt(`${a} varying ${l} vPickingIdOffset`), Wi(`int ${dp} = ${l === "int" ? "vPickingIdOffset" : "int(floor(vPickingIdOffset + 0.5))"}`)], Re(`${he} =`, `int remainder = ${dp} + uFirstId`, "int r = remainder / 16777216", "remainder -= r * 16777216", "int g = remainder / 65536", "remainder -= g * 65536", "int b = remainder / 256", "remainder -= b * 256", "int a = remainder", `${he} = vec4(float(r) / 255.0, float(g) / 255.0, float(b) / 255.0, float(a) / 255.0)`), (h) => h.replace(`gl_FragColor = vec4(fragColorEnd.rgb, fragColorEnd.a * ${$i})`, `if (${$i} <= 0.0) { discard; }
gl_FragColor = fragColorEnd`).replace("if (fragColorEnd.a <= 0.0) { discard; }", "")] };
  } };
}, AttributeHighlight: { idFeature: "AttributeHighlight", apply: (r) => ({ idVertex: "AttributeHighlight", idFragment: "AttributeHighlight", vertexShaderModifiers: [Ji("attribute float aIsHighlighted", "varying float vIsHighlighted")], fragmentShaderModifiers: [(t) => t.replace("uniform float uIsHighlighted", "varying float vIsHighlighted").replace("uIsHighlighted", "vIsHighlighted")] }) }, StippleTexture: { idFeature: "StippleTexture", apply: (r, t) => ({ idVertex: "StippleTexture", idFragment: "StippleTexture", vertexShaderModifiers: [lt("attribute vec2 aLengthSoFar"), lt("varying float vLengthSoFar"), lt("uniform vec2 uStippleCount"), bs(`
                vec2 len = (((aLengthSoFar) / uScale) / 2.0) * uStippleCount;
                vLengthSoFar = len.x + len.y;
                `)], fragmentShaderModifiers: [lt("uniform sampler2D uStippleTexture"), lt("uniform float uStippleScale"), lt("varying float vLengthSoFar"), t === "webgl1" && lt("uniform float uStippleTextureWidthLimiter"), Re(`${$i} = `, `
                    float stippleSampleY = texture2D(
                        uStippleTexture, 
                        ${t === "webgl1" ? "vec2(mod((vLengthSoFar / uStippleScale) , uStippleTextureWidthLimiter), 0)" : "vec2((vLengthSoFar / uStippleScale), 0)"}
                    ).r;
                    float stippleAA = (stippleSampleY - 0.5) * 2.0;
                    ${$i} *= stippleAA;
                    if (${$i} <= 0.0) { discard; }`)] }) }, StippleTextureInstanced: { idFeature: "StippleTextureInstanced", apply: (r, t) => ({ idVertex: "StippleTextureInstanced", idFragment: "StippleTextureInstanced", vertexShaderModifiers: [lt("attribute vec2 aLengthSoFarA"), lt("attribute vec2 aLengthSoFarB"), lt("varying float vLengthSoFar"), lt("uniform vec2 uStippleCount"), bs(`
                vec2 aLengthSoFar = mix(aLengthSoFarA, aLengthSoFarB, aSegmentSide);
                vec2 len = (((aLengthSoFar) / uScale) / 2.0) * uStippleCount;
                vLengthSoFar = len.x + len.y;
                `)], fragmentShaderModifiers: [lt("uniform sampler2D uStippleTexture"), lt("uniform float uStippleScale"), lt("varying float vLengthSoFar"), t === "webgl1" && lt("uniform float uStippleTextureWidthLimiter"), Re(`${$i} = `, `
                    float stippleSampleY = texture2D(
                        uStippleTexture, 
                        ${t === "webgl1" ? "vec2(mod((vLengthSoFar / uStippleScale) , uStippleTextureWidthLimiter), 0)" : "vec2((vLengthSoFar / uStippleScale), 0)"}
                    ).r;
                    float stippleAA = (stippleSampleY - 0.5) * 2.0;
                    ${$i} *= stippleAA;
                    if (${$i} <= 0.0) { discard; }`)] }) }, PolarHeatmap: (r) => ({ idFeature: "PolarHeatmap", apply: (t, e) => {
  const i = "dataType" in r, s = "interpolation" in r ? r : void 0, o = s ? s.flipXY : void 0, n = s?.interpolation === "bilinear", a = s?.intensityTextureType, l = s?.littleEndian;
  return { idVertex: void 0, idFragment: `PolarHeatmap:${zi(r)}`, vertexShaderModifiers: [], fragmentShaderModifiers: [lt("uniform vec2 uViewportSize", "uniform vec2 uScale", "uniform vec2 uDisp", "uniform float uSectors", "uniform float uAnnuli", "uniform float uAmplitudeStart", "uniform float uAmplitudeStep", "uniform float uAmplitudeAxisStart", "uniform float uAmplitudeAxisEnd", "uniform float uAngleOffset", "uniform float uAngleDirection", s && "uniform sampler2D uTileIntensityValues", i && "uniform vec4 uColor"), Ri.texelFetchWithFallback[e], a === "ubyte" && Ri.decodeUbyteRGBAEncodedFloat, Wi("vec2 posWorld = (2.0 * gl_FragCoord.xy / uViewportSize) - 1.0", "vec2 posAxis = posWorld * uScale + uDisp", "float amplitudeAxisInterval = uAmplitudeAxisEnd - uAmplitudeAxisStart", "float amplitude = uAmplitudeAxisStart + sign(amplitudeAxisInterval) * sqrt(posAxis.x * posAxis.x + posAxis.y * posAxis.y)", "float iAnnulus = (amplitude - uAmplitudeStart) / uAmplitudeStep"), s && Re("iAnnulus", "float angRad = atan(posAxis.y, posAxis.x) * uAngleDirection + uAngleOffset", "if (angRad < 0.0) { angRad = angRad + 2.0 * 3.1415926538; }", "if (angRad > 2.0 * 3.1415926538) { angRad = angRad - 2.0 * 3.1415926538; }", "float iSector = uSectors * angRad / (2.0 * 3.1415926538)", "vec2 cellIndex = vec2(iSector, iAnnulus)", "ivec2 cellStart = ivec2(floor(cellIndex))", "ivec2 cellEnd = cellStart + ivec2(1)", "if (cellEnd.x >= int(uSectors)) { cellEnd = ivec2(0, cellEnd.y); }", o && "cellIndex = vec2(cellIndex.y, cellIndex.x)", o && "cellStart = ivec2(cellStart.y, cellStart.x)", o && "cellEnd = ivec2(cellEnd.y, cellEnd.x)"), i && Re(`${he} =`, `${he} = uColor`), s && Re("cellEnd", "vec2 tileDimensions = " + (o ? "vec2(uAnnuli, uSectors)" : "vec2(uSectors, uAnnuli)"), n && "vec4 sample00 = texelFetchWithFallback(uTileIntensityValues, cellStart, tileDimensions)", n && "vec4 sample01 = texelFetchWithFallback(uTileIntensityValues, ivec2(cellStart.x, cellEnd.y), tileDimensions)", n && "vec4 sample10 = texelFetchWithFallback(uTileIntensityValues, ivec2(cellEnd.x, cellStart.y), tileDimensions)", n && "vec4 sample11 = texelFetchWithFallback(uTileIntensityValues, cellEnd, tileDimensions)", n && "float intensity00 = " + (a === "float" ? "sample00.x" : `decodeUbyteRGBAEncodedFloat(sample00, ${l})`), n && "float intensity01 = " + (a === "float" ? "sample01.x" : `decodeUbyteRGBAEncodedFloat(sample01, ${l})`), n && "float intensity10 = " + (a === "float" ? "sample10.x" : `decodeUbyteRGBAEncodedFloat(sample10, ${l})`), n && "float intensity11 = " + (a === "float" ? "sample11.x" : `decodeUbyteRGBAEncodedFloat(sample11, ${l})`), n && "vec2 lerpFactors = cellIndex - vec2(cellStart)", n && "float intensityR1 = mix(intensity00, intensity10, lerpFactors.x)", n && "float intensityR2 = mix(intensity01, intensity11, lerpFactors.x)", n && "float intensityP = mix(intensityR1, intensityR2,  lerpFactors.y)", !n && "vec4 sample0 = texelFetchWithFallback(uTileIntensityValues, cellStart, tileDimensions)", !n && "float intensityP = " + (a === "float" ? "sample0.x" : `decodeUbyteRGBAEncodedFloat(sample0, ${l})`)), ...s ? Xo("intensityP", s.lut) : []] };
} }) }, iM = { "2D": `
void main(void) {
    gl_Position = vec4(posWorld, 0.0, 1.0 );
}
`, "2DMatrix": `
void main(void) {
    gl_Position = posWorld;
}
`, "3D": `
uniform mat4 uViewProjectionMatrix;
void main(void) {
    gl_Position = uViewProjectionMatrix * vec4(posWorld, 1.0);
}
` }, sM = { FragmentShader: `
uniform float uIsHighlighted;
uniform vec4 uHighlightColorOffset;
uniform float uRenderEffectMask;
void main(void) {
    vec4 ${he} = vec4(0.0, 0.0, 0.0, 0.0);
    float ${$i} = 1.0;
    vec4 fragColorEnd = ${he};
    if (fragColorEnd.a <= 0.0) { discard; }
    fragColorEnd = clamp(fragColorEnd + uIsHighlighted * uHighlightColorOffset, vec4(0.0), vec4(1.0));
    fragColorEnd = mix(fragColorEnd, vec4(1.0), uRenderEffectMask * fragColorEnd.a * 1000.0);
    gl_FragColor = vec4(fragColorEnd.rgb, fragColorEnd.a * ${$i});
}
`, Empty: `
void main(void) {
}
` };
class Zx {
  constructor(t, e, i, s, o) {
    if (this.id = t, this.shader = i, this.gl = s, this.info = o, !e || !i) throw new qf(`Could not find ${this.pE()} ${this.mE()} shader source code.`);
    this.gl.shaderSource(i, e), this.gl.compileShader(i);
  }
  get src() {
    return "";
  }
  pE() {
    return this.id.toString();
  }
  mE() {
    return this.gl.getShaderParameter(this.shader, this.gl.SHADER_TYPE) === this.gl.FRAGMENT_SHADER ? "fragment" : "vertex";
  }
}
class rM extends Zx {
  constructor(t, e, i, s) {
    super(t, e, i.createShader(i.VERTEX_SHADER), i, s);
  }
}
class nM extends Zx {
  constructor(t, e, i, s) {
    super(t, e, i.createShader(i.FRAGMENT_SHADER), i, s);
  }
}
class oM {
  constructor(t, e, i, s) {
    this.SE = /* @__PURE__ */ new Map(), this.bE = /* @__PURE__ */ new Map(), this.xE = i, this.ME = i.createProgram(), this._E = `${t.pE()} vertex`, this.wE = `${e.pE()} fragment`, i.attachShader(this.ME, t.shader), i.attachShader(this.ME, e.shader), i.bindAttribLocation(this.ME, 0, "aPos"), i.linkProgram(this.ME), i.deleteShader(t.shader), i.deleteShader(e.shader), this.allAttributeNames = t.info.allAttributeNames, this.allUniformNames = Array.from(new Set(t.info.allUniformNames.concat(e.info.allUniformNames)).values()), this.vertexSharedRemovedVariables = t.info.removedVariableNames, this.fragmentSharedRemovedVariables = e.info.removedVariableNames;
  }
  get vertexShaderSrc() {
    return "";
  }
  get fragmentShaderSrc() {
    return "";
  }
  kE(t) {
    return Js(0, (() => Bm()));
  }
  CE(t) {
    const e = this.TE(t);
    if (e === void 0) throw this.kE(`Could not get ${t} uniform from ${this._E} and ${this.wE} shaders.`);
    return e;
  }
  TE(t) {
    const e = this.SE.get(t);
    if (e) return e;
    const i = this.xE.getUniformLocation(this.ME, t);
    return i ? (this.SE.set(t, i), i) : void 0;
  }
  FE(t) {
    const e = this.IE(t);
    if (e === void 0) throw this.kE(`Could not get ${t} attribute from ${this._E} and ${this.wE} shaders.`);
    return e;
  }
  IE(t) {
    const e = this.bE.get(t);
    if (e || e === 0) return e;
    const i = this.xE.getAttribLocation(this.ME, t);
    return i >= 0 ? (this.bE.set(t, i), i) : void 0;
  }
  G() {
    this.xE.deleteProgram(this.ME);
  }
}
const aM = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/, Fd = (r) => {
  let t;
  try {
    t = H.getComputedStyle(r);
  } catch {
    return null;
  }
  return t;
};
/**
 * stacking-order by Rich Harris
 * https://github.com/Rich-Harris/stacking-order
 *
 * @license MIT
 *
 * Converted to TypeScript and edited to match LCJS requirements.
 */
function lM(r) {
  const t = Fd(r);
  return !!t && (t.position === "fixed" || !!(t.zIndex !== "auto" && t.position !== "static" || (function(e) {
    const i = Fd(Kx(e)), s = i ? i.display : "auto";
    return s === "flex" || s === "inline-flex";
  })(r)) || +t.opacity < 1 || "transform" in t && t.transform !== "none" || "webkitTransform" in t && t.webkitTransform !== "none" || "mixBlendMode" in t && t.mixBlendMode !== "normal" || "filter" in t && t.filter !== "none" || "webkitFilter" in t && t.webkitFilter !== "none" || "isolation" in t && t.isolation === "isolate" || !!aM.test(t.willChange) || t.webkitOverflowScrolling === "touch");
}
function Sp(r) {
  let t = r.length;
  for (; t--; ) if (lM(r[t])) return r[t];
  return null;
}
function Ap(r) {
  var t;
  return r && Number(((t = Fd(r)) === null || t === void 0 ? void 0 : t.zIndex) || 0) || 0;
}
function bp(r) {
  const t = [];
  for (; r; ) t.push(r), r = Kx(r);
  return t;
}
function Kx(r) {
  var t;
  return ((t = r.parentNode) === null || t === void 0 ? void 0 : t.host) || r.parentNode;
}
const lu = (r) => r && "resize" in r;
class hM extends $E {
  constructor(t) {
    if (super(t.PE), this.LE = /* @__PURE__ */ new Map(), this.BE = /* @__PURE__ */ new Map(), this.DE = /* @__PURE__ */ new Map(), this.EE = !0, this.RE = null, this.OE = null, this.zE = null, this.VE = null, this.NE = 0, this.GE = 0, this.$E = 0, this.UE = !1, this.jE = !0, this.ci = !1, this.YE = wf(`chart-engine-${(/* @__PURE__ */ new Date()).getTime()}${Math.trunc(1e6 * Math.random()).toString()}`), this.j = { x: 100, y: 100 }, this.HE = () => {
      this.WE && clearTimeout(this.WE), this.WE = setTimeout((() => this.na()), 12);
    }, this.XE = (a) => {
      const l = a.intersectionRatio > 0, h = a.target.getAttribute("data-lcjs-engine-id");
      if (h) {
        const u = this.LE.get(h);
        if (u) {
          const c = u.ZE();
          u.JE(l), l ? this.BE.set(h, u) : this.BE.delete(h), c !== l && u.Rs();
        }
      }
    }, this.QE = (a, l, h, u, c) => {
      const d = c[0], f = this.gl;
      if (f.bindFramebuffer(f?.FRAMEBUFFER, null), f.useProgram(this.OE.ME), f.clear(f.COLOR_BUFFER_BIT), d.Un.getBoundingClientRect()) {
        const p = d.KE();
        f.viewport(0, 0, p.x, p.y), f.activeTexture(f.TEXTURE0), f.bindTexture(f.TEXTURE_2D, d.qE), f.uniform1i(this.NE, 0), f.uniformMatrix4fv(this.GE, !1, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]), f.bindBuffer(f.ARRAY_BUFFER, this.zE), f.enableVertexAttribArray(0), f.vertexAttribPointer(this.$E, 2, f.FLOAT, !1, 0, 0), f.drawArrays(f.TRIANGLES, 0, 6), f.bindFramebuffer(f.FRAMEBUFFER, null), d.tR && (d.tR.clearRect(0, 0, d.tR.canvas.width, d.tR.canvas.height), d.tR.drawImage(this.iR, 0, this.iR.height - p.y, p.x, p.y, 0, 0, d.tR.canvas.width, d.tR.canvas.height));
      }
    }, this.sR = (a, l, h, u, c) => {
      const d = this.gl;
      d.bindFramebuffer(d?.FRAMEBUFFER, null), d.useProgram(this.OE.ME), d.clear(d.COLOR_BUFFER_BIT), c.forEach(((f) => {
        const p = f.Un.getBoundingClientRect();
        if (p) {
          const g = p.right - p.left, y = p.bottom - p.top, m = p.left, A = u - p.bottom;
          d.viewport(m * this.eR - a * this.eR, A * this.eR + l * this.eR, g * this.eR, y * this.eR);
        }
        d.activeTexture(d.TEXTURE0), d.bindTexture(d.TEXTURE_2D, f.qE), d.uniform1i(this.NE, 0), d.uniformMatrix4fv(this.GE, !1, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]), d.bindBuffer(d.ARRAY_BUFFER, this.zE), d.enableVertexAttribArray(0), d.vertexAttribPointer(this.$E, 2, d.FLOAT, !1, 0, 0), d.drawArrays(d.TRIANGLES, 0, 6);
      })), d.bindFramebuffer(d.FRAMEBUFFER, null);
    }, this.rR = (a, l, h, u, c) => {
      const d = c[0], f = this.gl2.ctx;
      f.bindFramebuffer(f.DRAW_FRAMEBUFFER, null), f.clear(f.COLOR_BUFFER_BIT);
      const p = d.KE();
      f.bindFramebuffer(f.READ_FRAMEBUFFER, d.hR[1]), f.blitFramebuffer(0, 0, p.x, p.y, 0, this.iR.height - p.y, p.x, this.iR.height, f.COLOR_BUFFER_BIT, f.LINEAR), d.tR && (d.tR.clearRect(0, 0, d.tR.canvas.width, d.tR.canvas.height), d.tR.drawImage(this.iR, 0, 0)), f.bindFramebuffer(f.FRAMEBUFFER, null);
    }, this.nR = (a, l, h, u, c) => {
      const d = this.gl2.ctx;
      d.bindFramebuffer(d.DRAW_FRAMEBUFFER, null), d.clear(d.COLOR_BUFFER_BIT), c.forEach(((f) => {
        const p = f.Un.getBoundingClientRect();
        if (p) {
          const g = p.right - p.left, y = p.bottom - p.top, m = p.left, A = u - p.bottom, v = f.KE();
          d.bindFramebuffer(d.READ_FRAMEBUFFER, f.hR[1]), d.blitFramebuffer(0, 0, v.x, v.y, m * this.eR - a * this.eR, A * this.eR + l * this.eR, (m - a + g) * this.eR, (A + l + y) * this.eR, d.COLOR_BUFFER_BIT, d.LINEAR);
        }
      })), d.bindFramebuffer(d.FRAMEBUFFER, null);
    }, this.WE = void 0, this.Ga = t, !H.requestAnimationFrame || !H.cancelAnimationFrame) throw new Error("LightningChart JS depends on requestAnimationFrame. Make sure to load a polyfill in older browsers.");
    let e = 1;
    if (t && t.oR) e = t.oR === !0 ? H.devicePixelRatio || 1 : t.oR || 1;
    else {
      const a = H.document.head.querySelector('meta[name="viewport"]');
      a && a.content.includes("width=device-width") && (e = H.devicePixelRatio || 1);
    }
    this.eR = e, t.$a = t.$a === !0, this.jE = t.aR !== !1, this.lR = t.uR !== !1, this.cR = t.cR || !1;
    let i = !1;
    if (t.iR) if (typeof t.iR == "string") {
      const a = H.document.getElementById(t.iR);
      if (!a) throw new Error(`Canvas "${t.iR}" doesn't exist.`);
      this.iR = a, i = !0;
    } else this.iR = t.iR, i = !0;
    else this.iR = H.document.createElement("canvas");
    const s = { preserveDrawingBuffer: !0, alpha: !0, antialias: !1 };
    if (t.dR !== 2 && t.dR) {
      const a = this.iR.getContext("webgl", { ...s, antialias: !!t.aR }) || this.iR.getContext("experimental-webgl", { ...s, antialias: !!t.aR });
      this.gl = a, this.fR = !1;
    } else {
      const a = this.iR.getContext("webgl2", s);
      this.gl2 = { ctx: a }, this.gl = a, this.fR = !0;
    }
    if (!this.gl) throw new pi("No WebGL context available." + (t?.dR ? `
Selected explicit target: WebGL ${t.dR}` : ""));
    const o = [];
    if (this.AR = { WEBGL_lose_context: this.gl.getExtension("WEBGL_lose_context") }, Object.keys(this.AR).forEach(((a) => {
      this.AR[a] === null && o.push(a);
    })), this.fR) this.gR = !0;
    else {
      const a = { ANGLE_instanced_arrays: this.gl.getExtension("ANGLE_instanced_arrays"), EXT_blend_minmax: this.gl.getExtension("EXT_blend_minmax"), OES_element_index_uint: this.gl.getExtension("OES_element_index_uint"), OES_standard_derivatives: this.gl.getExtension("OES_standard_derivatives"), OES_vertex_array_object: this.gl.getExtension("OES_vertex_array_object") };
      a.OES_standard_derivatives || (this.EE = !1), Object.keys(a).forEach(((h) => {
        a[h] === null && o.push(h);
      }));
      const l = { OES_texture_float: this.gl.getExtension("OES_texture_float") };
      this.gR = !!l.OES_texture_float, this.gl1 = { ctx: this.gl, AR: a, optional: l };
    }
    const n = o;
    if (n.length > 0 && t.$a !== !1) {
      const a = H.document.createElement("div");
      a.innerText = "LightningChart JS: Some features might not work properly, due to missing WebGL features.", a.style.cssText = "position:absolute;top:0;background:red;width:100%;padding:10px;text-align:center;color:white;z-index:1;";
      const l = H.document.createElement("button");
      l.innerText = "X", l.addEventListener("click", (() => {
        a.parentElement && a.parentElement.removeChild(a);
      })), H.document.body.appendChild(a), a.appendChild(l), H.console.warn("LightningChart JS - Following WebGL extensions could not be loaded:", n.join(", "));
    }
    if (this.vR = this.cR ? this.yR(this.fR ? this.rR.bind(this) : this.QE.bind(this)).bind(this) : this.pR(this.fR ? this.nR.bind(this) : this.sR.bind(this)).bind(this), H.ResizeObserver) {
      const a = (l) => {
        for (const h of l) h.target === this.iR && this.mR();
      };
      this.Ha = new H.ResizeObserver(a.bind(this)), this.Ha.observe(this.iR);
    }
    if (this.SR = /* @__PURE__ */ ((a, l) => {
      const h = a, u = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map(), f = { totalMs: 0, vertexShaders: 0, fragmentShaders: 0, programs: 0 }, p = (g, y, m = []) => {
        const A = [], v = [], b = { allAttributeNames: Array.from(g.matchAll(/attribute\s[^\s]*\s(.*);/g)).map(((w) => w[1])), allUniformNames: Array.from(g.matchAll(/uniform\s[^\s]*\s(.*);/g)).map(((w) => w[1])), allVaryingNames: Array.from(g.matchAll(/varying\s[^\s]*\s(.*);/g)).map(((w) => w[1])), removedVariableNames: [] };
        if (l) {
          const w = g.match(/#extension.*/g);
          w && v.push(...w), g = g.replace(/#extension.*/g, "");
        } else if (A.push("#version 300 es"), (g = (g = (g = g.replace(/#extension.*/g, "")).replace(/attribute/g, "in")).replace(/texture2D/g, "texture")).includes("usampler2D") && A.push("precision highp usampler2D;"), y === "vertex") g = g.replace(/varying/g, "out");
        else {
          g = g.replace(/varying/g, "in");
          const w = m.find(((k) => k.type === "fragOutput"));
          g = (g = w ? `out ${w.fragOutput} fragOutput;
${g}` : `out vec4 fragOutput;
${g}`).replace(/gl_FragColor/g, "fragOutput");
        }
        return v && A.push(...v), A.push("precision highp float;"), A.push("precision highp int;"), { source: g = `${A.join(`
`)}
${g}`, info: b };
      };
      return (...g) => {
        const y = l ? "webgl1" : "webgl2";
        let m, A, v, b, w, k, R, L, x;
        try {
          const M = H.performance.now();
          m = g.filter(((P) => P !== !1 && P !== void 0)), A = ((P, V) => {
            const _ = P.map(((Q) => Q.apply(P, V))), O = _.map(((Q) => Q.idVertex)).filter(((Q) => Q !== void 0)).sort().join(" "), B = _.map(((Q) => Q.idFragment)).filter(((Q) => Q !== void 0)).sort().join(" "), z = `vert: ${O} frag: ${B}`;
            let W, G = !1, Y = !1;
            const U = [];
            let $;
            const Z = [], q = [];
            if (_.forEach(((Q) => {
              if (Q.defaultVertexShader && (G || (W = Q.defaultVertexShader)), Q.vertexShader) {
                if (W && G && W !== Q.vertexShader) throw new $h(`Conflicting vertex shader templates ${W} vs ${Q.vertexShader}`, z, Q);
                W = Q.vertexShader, G = !0;
              }
              if (Q.vertexShaderModifiers) for (const nt of Q.vertexShaderModifiers) nt !== void 0 && nt !== !1 && U.push(nt);
              if (Q.defaultFragmentShader && (Y || ($ = Q.defaultFragmentShader)), Q.fragmentShader) {
                if ($ && Y && $ !== Q.fragmentShader) throw new $h(`Conflicting fragment shader templates ${$} vs ${Q.fragmentShader}`, z, Q);
                $ = Q.fragmentShader, Y = !0;
              }
              if (Q.fragmentShaderModifiers) for (const nt of Q.fragmentShaderModifiers) nt !== void 0 && nt !== !1 && Z.push(nt);
              Q.hints && Q.hints.forEach(((nt) => {
                nt && q.push(nt);
              }));
            })), P.find(((Q) => {
              var nt;
              return (nt = Q.cE) === null || nt === void 0 ? void 0 : nt.vE;
            })) && (V === "webgl1" ? U.push(lt("attribute float aInstanceID"), Wi("int iInstance = int(aInstanceID)")) : U.push(Wi("int iInstance = gl_InstanceID"))), P.find(((Q) => {
              var nt;
              return (nt = Q.cE) === null || nt === void 0 ? void 0 : nt.yE;
            })) && (V === "webgl1" ? U.push(lt("attribute float aVertexID"), Wi("int iVertex = int(aVertexID)")) : U.push(Wi("int iVertex = gl_VertexID"))), !W) throw new $h("No vertex shader template defined", z);
            if (!$) throw new $h("Fragment shader not defined", z);
            return { id: z, vertexShader: { id: O, template: W, modifiers: U }, fragmentShader: { id: B, template: $, modifiers: Z }, hints: q };
          })(m, y);
          const C = d.get(A.id);
          if (v = "new", C) return v = "existing", k = C.vertexShaderSrc, R = C.fragmentShaderSrc, C;
          const S = A.vertexShader.id;
          let E = u.get(S);
          if (E) k = E.src, b = "existing";
          else {
            b = "new";
            const P = new pp(A.vertexShader.modifiers).build(iM[A.vertexShader.template]), { source: V, info: _ } = p(P, "vertex");
            k = V, L = _, E = new rM(S, V, h, _), u.set(S, E), f.vertexShaders += 1;
          }
          const T = A.fragmentShader;
          let I;
          const F = T.id;
          if (I = c.get(F), I) R = I.src, w = "existing";
          else {
            w = "new";
            const P = sM[T.template], V = new pp([...T.modifiers]).build(P), { source: _, info: O } = p(V, "fragment", A.hints);
            R = _, x = O, I = new nM(F, _, h, O), c.set(F, I), f.fragmentShaders += 1;
          }
          const D = new oM(E, I, h, A);
          return d.set(A.id, D), f.programs += 1, f.totalMs += H.performance.now() - M, D;
        } catch {
          throw Js(0, (() => {
            const C = `Unexpected LightningChart JS rendering error.
This can mean a bug in the library, or that it is simply used in unsupported manner (passing wrong type to method, using disposed component, etc).`;
            return H.alert(C), new Error(C);
          }));
        }
      };
    })(this.gl, !this.fR), this.aE = (() => {
      const a = H.document.createElement("canvas"), l = a.getContext("2d", { willReadFrequently: !0 });
      if (!l) throw new pi("Failed to get Text canvas rendering context");
      return l.fillStyle = "#fff", (h, u, c, d) => {
        const f = `${u.style} ${u.weight} ${u.size * c}px ${u.family}`;
        l.font = f, l.textBaseline = "alphabetic", l.textAlign = "left";
        const p = l.measureText(h);
        if (p.width === 0) return;
        const g = p.actualBoundingBoxLeft !== void 0 && p.actualBoundingBoxRight !== void 0 ? Math.ceil(p.actualBoundingBoxLeft + p.actualBoundingBoxRight) : Math.ceil(p.width), y = p.width, m = Math.round(u.size * c), A = p.actualBoundingBoxLeft !== void 0 ? p.actualBoundingBoxLeft : 0;
        a.width = g > 0 ? g : y, a.height = 2 * m, l.font = f, l.textBaseline = "alphabetic", l.textAlign = "left", d ? (l.clearRect(0, 0, a.width, a.height), l.fillStyle = "#fff") : (l.fillStyle = "rgba(255,255,255,0)", l.fillRect(0, 0, a.width, a.height), l.fillStyle = "#000"), l.fillText(h, A, m);
        const v = l.getImageData(0, 0, a.width, a.height);
        let b = 0, w = 0;
        const k = v.width;
        for (let C = 0; C < v.height; C += 1) {
          for (let S = 0; S < k; S += 1) if (v.data[C * k * 4 + 4 * S + 3] !== 0) {
            b = C;
            break;
          }
          if (b !== 0) break;
        }
        for (let C = v.height - 1; C >= 0; C -= 1) {
          for (let S = 0; S < k; S += 1) if (v.data[C * k * 4 + 4 * S + 3] !== 0) {
            w = C;
            break;
          }
          if (w !== 0) break;
        }
        const R = l.canvas.height / 2 - b, L = w - b + 1, x = k, M = new Uint8ClampedArray(x * L * 1);
        for (let C = 0; C < L; C += 1) for (let S = 0; S < x; S += 1) M[1 * C * x + 1 * S + 0] = v.data[(C + b) * x * 4 + 4 * S + 3];
        return [M, { advance: y, offsetX: A, baseline: R, glyph: h, size: j(x, L) }];
      };
    })(), t.bR || (this.cR ? this.iR.style.display = "none" : (this.iR.style.position = "absolute", this.iR.style.top = "0", this.iR.style.left = "0", this.iR.style.right = "0", this.iR.style.bottom = "0", this.iR.style.width = "100%", this.iR.style.height = "100%", this.iR.style.boxSizing = "content-box", this.iR.style.display = "block", this.iR.style.pointerEvents = "none")), this.iR.classList.add("lcjs-canvas"), t.xR && this.iR.setAttribute("data-lcjs-id", t.xR), i || H.document.body.appendChild(this.iR), H.IntersectionObserver && (this.MR = new H.IntersectionObserver(((a) => {
      for (let l = 0; l < a.length; l += 1) {
        const h = a[l];
        this.XE(h);
      }
    }), { threshold: Array.from(Array(100)).map(((a, l) => l / 100)) })), H.addEventListener("resize", this.HE, { passive: !0 }), !this.fR) {
      if (this.OE = this.SR(K["2DCompose"], K.Color({ dataType: "texture-coord-calc-gpu" }), K.VertexLocation({ axisWorldTranslation: "matrix4", normalSource: void 0, coordType: "vec4" })), !this.OE.ME) throw new pi("Unable to setup composition shader!");
      const a = this.gl, l = a.getUniformLocation(this.OE.ME, "uColorTexture");
      if (!l) throw new pi("Unable to setup composition shader! Failed to find uColorTexture");
      const h = a.getUniformLocation(this.OE.ME, "uMatrix");
      if (!h) throw new pi("Unable to setup composition shader! Failed to find uMatrix");
      this.NE = l, this.GE = h, this.$E = a.getAttribLocation(this.OE.ME, "aPos"), this.zE = a.createBuffer(), a.bindBuffer(a.ARRAY_BUFFER, this.zE), a.bufferData(a.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), a.STATIC_DRAW), a.bindBuffer(a.ARRAY_BUFFER, null), this.VE = a.createBuffer(), a.bindBuffer(a.ARRAY_BUFFER, this.VE), a.bufferData(a.ARRAY_BUFFER, new Float32Array([0, 0, 0, 1, 1, 0, 1, 0, 0, 1, 1, 1]), a.STATIC_DRAW), a.bindBuffer(a.ARRAY_BUFFER, null);
    }
  }
  yR(t) {
    return (e) => {
      this.RE = null;
      const i = this.gl.canvas, s = Array.from(this.BE.values());
      this.UE = !1, s.forEach(((o) => {
        const n = o.KE();
        (this.j.x < n.x || this.j.y < n.y) && (this.j.x = Math.max(this.j.x, n.x), this.j.y = Math.max(this.j.y, n.y), i instanceof HTMLCanvasElement && (i.width = this.j.x, i.height = this.j.y)), o.da && o._R(e), t(0, 0, 0, 0, [o]);
      })), this.UE && this.mR();
    };
  }
  pR(t) {
    return (e) => {
      this.RE = null, "style" in this.gl.canvas && !this.Ga.wR && (this.gl.canvas.style.transform = `translateX(${window.scrollX}px) translateY(${window.scrollY}px)`);
      const i = this.gl.canvas, s = this.iR.clientHeight, o = this.iR.clientWidth;
      let n = 0, a = 0;
      if (i instanceof HTMLCanvasElement) {
        i.width === o * this.eR && i.height === s * this.eR || (i.width = o * this.eR, i.height = s * this.eR);
        const h = i.getBoundingClientRect();
        n = h.x, a = h.y;
      }
      const l = Array.from(this.BE.values());
      this.UE = !1, l.sort(((h, u) => h.kR() - u.kR())).forEach(((h) => {
        h.da && h._R(e);
      })), t(n, a, o, s, l), this.UE && this.mR();
    };
  }
  mR(t) {
    return lu(this.gl) || (!this.UE && t && (this.UE = !0), this.RE || this.ci || (this.RE = H.requestAnimationFrame(this.vR))), this;
  }
  CR(t) {
    const e = this.YE();
    return t.Un.setAttribute("data-lcjs-engine-id", e), this.LE.set(e, t), t.TR(this.LE.size - 1), t.JE(!0), this.BE.set(e, t), this.MR && this.MR.observe(t.Un), this.WE && clearTimeout(this.WE), this.WE = setTimeout((() => this.na()), 0), this;
  }
  FR(t) {
    const e = t.Un.getAttribute("data-lcjs-engine-id");
    return e ? (this.LE.delete(e), this.BE.delete(e), this.MR && this.MR.unobserve(t.Un), t.Un.removeAttribute("data-lcjs-engine-id"), this) : this;
  }
  na() {
    if (this.MR) {
      const t = this.MR.takeRecords();
      for (let e = 0; e < t.length; e += 1) {
        const i = t[e];
        this.XE(i);
      }
    }
    return !this.cR && this.lR && Array.from(this.LE.values()).sort(((t, e) => (function(i, s) {
      if (i === s) return 0;
      const o = { a: bp(i), b: bp(s) };
      let n;
      for (; o.a[o.a.length - 1] === o.b[o.b.length - 1]; ) i = o.a.pop(), s = o.b.pop(), n = i;
      const a = Ap(Sp(o.a)), l = Ap(Sp(o.b));
      if (a === l && n) {
        const h = n.childNodes, u = { a: o.a[o.a.length - 1], b: o.b[o.b.length - 1] };
        let c = h.length;
        for (; c--; ) {
          const d = h[c];
          if (d === u.a) return 1;
          if (d === u.b) return -1;
        }
      }
      return Math.sign(a - l);
    })(t.Un, e.Un))).forEach(((t, e) => t.TR(e))), this.mR(!0), this;
  }
  FD() {
    return this.mR(), this;
  }
  IR() {
    this.ci || this.LE.forEach(((t) => t.qg.layout()));
  }
  G() {
    var t;
    if (this.ci) return;
    this.ci = !0, super.G(), this.RE && (H.cancelAnimationFrame(this.RE), this.RE = null), this.UE = !1, this.Ha && (this.Ha.disconnect(), this.Ha = void 0), this.MR && (this.MR.disconnect(), this.MR = void 0), H.removeEventListener("resize", this.HE), this.HE = void 0, this.LE.forEach(((i) => {
      i.G();
    })), this.LE.clear(), Array.from(this.DE.values()).forEach(((i) => {
      i.Rc(!0);
    })), this.DE.clear();
    const e = this.gl;
    e.deleteBuffer(this.zE), e.deleteBuffer(this.VE), this.iR && !this.Ga.iR ? (this.iR.width = 1, this.iR.height = 1, (t = this.iR.parentElement) === null || t === void 0 || t.removeChild(this.iR), this.iR = void 0) : this.iR = void 0, this.SR = void 0, this.aE = void 0, this.vR = () => {
    }, this.AR.WEBGL_lose_context && this.AR.WEBGL_lose_context.loseContext();
  }
}
const uM = (r, t, e, i) => (s) => {
  const o = { theme: ds, ...e, ...s }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new $x(n.Ga, s, n, n.G.bind(n), o, a);
  return n.ol(((h) => l.Ec(h))).nl((() => l.W())).Rs(), l;
}, Ls = (r, t) => {
  r.ol(((e) => {
    t.rr(e);
  })).nl((() => t.W())).Rs();
}, cM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new Hf(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0, s?.legend);
  return Ls(n, l), l;
}, dM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new $f(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, s);
  return Ls(n, l), l;
}, fM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new Ox(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, s);
  return Ls(n, l), l;
}, gM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new Ix(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, s);
  return Ls(n, l), l;
}, pM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new (s && s.type ? s.type : jx)(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0, s);
  return Ls(n, l), l;
}, Ep = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new Ux(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0, s);
  return Ls(n, l), l;
}, yM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new Hx(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0, s);
  return Ls(n, l), l;
}, mM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new (s && s.type ? s.type : Vx)(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0, s);
  return Ls(n, l), l;
}, xM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new (s && s.type ? s.type : _x)(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0, s);
  return Ls(n, l), l;
}, vM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new Ex(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, s, void 0);
  return Ls(n, l), l;
}, SM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new jf(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0, s);
  return Ls(n, l), l;
}, AM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new Wx(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0);
  return Ls(n, l), l;
}, bM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new Gx(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0, s);
  return Ls(n, l), l;
}, EM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new Rx(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, s);
  return Ls(n, l), l;
}, MM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t || i ? gs(n, i, e?.licenseInformation) : void 0, l = new wE(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, s);
  return Ls(n, l), l;
}, CM = (r, t, e, i) => (s) => {
  const o = { ...e, ...s, theme: s?.theme || ds }, n = r(o), a = t ? gs(n, i) : void 0, l = new Yx(n.Ga, fs(n, 1).TB(0), ki, n.G.bind(n), a, void 0, s);
  return Ls(n, l), l;
}, xe = { translation: (r, t, e) => [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, r, t, e, 1], xRotation(r) {
  const t = Math.cos(r), e = Math.sin(r);
  return [1, 0, 0, 0, 0, t, e, 0, 0, -e, t, 0, 0, 0, 0, 1];
}, yRotation(r) {
  const t = Math.cos(r), e = Math.sin(r);
  return [t, 0, -e, 0, 0, 1, 0, 0, e, 0, t, 0, 0, 0, 0, 1];
}, zRotation(r) {
  const t = Math.cos(r), e = Math.sin(r);
  return [t, e, 0, 0, -e, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
}, scaling: (r, t, e) => [r, 0, 0, 0, 0, t, 0, 0, 0, 0, e, 0, 0, 0, 0, 1], translate: (r, t, e, i) => xe.multiply(r, xe.translation(t, e, i)), xRotate: (r, t) => xe.multiply(r, xe.xRotation(t)), yRotate: (r, t) => xe.multiply(r, xe.yRotation(t)), zRotate: (r, t) => xe.multiply(r, xe.zRotation(t)), rotateXYZ(r, t) {
  let e = xe.xRotate(r, t.x);
  return e = xe.yRotate(e, t.y), e = xe.zRotate(e, t.z), e;
}, scale: (r, t, e, i) => xe.multiply(r, xe.scaling(t, e, i)), multiply(r, t) {
  const e = t[0], i = t[1], s = t[2], o = t[3], n = t[4], a = t[5], l = t[6], h = t[7], u = t[8], c = t[9], d = t[10], f = t[11], p = t[12], g = t[13], y = t[14], m = t[15], A = r[0], v = r[1], b = r[2], w = r[3], k = r[4], R = r[5], L = r[6], x = r[7], M = r[8], C = r[9], S = r[10], E = r[11], T = r[12], I = r[13], F = r[14], D = r[15], P = [];
  return P[0] = e * A + i * k + s * M + o * T, P[1] = e * v + i * R + s * C + o * I, P[2] = e * b + i * L + s * S + o * F, P[3] = e * w + i * x + s * E + o * D, P[4] = n * A + a * k + l * M + h * T, P[5] = n * v + a * R + l * C + h * I, P[6] = n * b + a * L + l * S + h * F, P[7] = n * w + a * x + l * E + h * D, P[8] = u * A + c * k + d * M + f * T, P[9] = u * v + c * R + d * C + f * I, P[10] = u * b + c * L + d * S + f * F, P[11] = u * w + c * x + d * E + f * D, P[12] = p * A + g * k + y * M + m * T, P[13] = p * v + g * R + y * C + m * I, P[14] = p * b + g * L + y * S + m * F, P[15] = p * w + g * x + y * E + m * D, P;
}, inverse(r) {
  const t = [], e = r[0], i = r[1], s = r[2], o = r[3], n = r[4], a = r[5], l = r[6], h = r[7], u = r[8], c = r[9], d = r[10], f = r[11], p = r[12], g = r[13], y = r[14], m = r[15], A = d * m, v = y * f, b = l * m, w = y * h, k = l * f, R = d * h, L = s * m, x = y * o, M = s * f, C = d * o, S = s * h, E = l * o, T = u * g, I = p * c, F = n * g, D = p * a, P = n * c, V = u * a, _ = e * g, O = p * i, B = e * c, z = u * i, W = e * a, G = n * i, Y = A * a + w * c + k * g - (v * a + b * c + R * g), U = v * i + L * c + C * g - (A * i + x * c + M * g), $ = b * i + x * a + S * g - (w * i + L * a + E * g), Z = R * i + M * a + E * c - (k * i + C * a + S * c), q = 1 / (e * Y + n * U + u * $ + p * Z);
  return t[0] = q * Y, t[1] = q * U, t[2] = q * $, t[3] = q * Z, t[4] = q * (v * n + b * u + R * p - (A * n + w * u + k * p)), t[5] = q * (A * e + x * u + M * p - (v * e + L * u + C * p)), t[6] = q * (w * e + L * n + E * p - (b * e + x * n + S * p)), t[7] = q * (k * e + C * n + S * u - (R * e + M * n + E * u)), t[8] = q * (T * h + D * f + P * m - (I * h + F * f + V * m)), t[9] = q * (I * o + _ * f + z * m - (T * o + O * f + B * m)), t[10] = q * (F * o + O * h + W * m - (D * o + _ * h + G * m)), t[11] = q * (V * o + B * h + G * f - (P * o + z * h + W * f)), t[12] = q * (F * d + V * y + I * l - (P * y + T * l + D * d)), t[13] = q * (B * y + T * s + O * d - (_ * d + z * y + I * s)), t[14] = q * (_ * l + G * y + D * s - (W * y + F * s + O * l)), t[15] = q * (W * d + P * s + z * l - (B * l + G * d + V * s)), t;
}, projectionPerspective(r, t, e, i) {
  const s = 1 / Math.tan(r * Math.PI / 180 / 2), o = 1 / (e - i);
  return [s / t, 0, 0, 0, 0, s, 0, 0, 0, 0, (e + i) * o, -1, 0, 0, e * i * o * 2, 0];
}, projectionOrthographic: (r, t, e, i, s, o) => [2 / (t - r), 0, 0, 0, 0, 2 / (i - e), 0, 0, 0, 0, 2 / (s - o), 0, (r + t) / (r - t), (e + i) / (e - i), (s + o) / (s - o), 1], quaternionToRotationMatrix(r) {
  const t = Math.sqrt(r[0] * r[0] + r[1] * r[1] + r[2] * r[2] + r[3] * r[3]), e = [r[0] / t, r[1] / t, r[2] / t, r[3] / t], i = e[0] + e[0], s = e[1] + e[1], o = e[2] + e[2], n = e[0] * i, a = e[0] * s, l = e[0] * o, h = e[1] * s, u = e[1] * o, c = e[2] * o, d = e[3] * i, f = e[3] * s, p = e[3] * o;
  return [1 - (h + c), a - p, l + f, 0, a + p, 1 - (n + c), u - d, 0, l - f, u + d, 1 - (n + h), 0, 0, 0, 0, 1];
} };
function Ws(r, t, e, i, s, o) {
  let n = t.x.Rt(r.max.x), a = t.x.Rt(r.min.x), l = t.y.Rt(r.max.y), h = t.y.Rt(r.min.y), u = n - a, c = l - h;
  if (u < 1) {
    const R = (a + n) / 2;
    a = R - 0.5, n = R + 0.5, u = 1;
  }
  if (c < 1) {
    const R = (h + l) / 2;
    h = R - 0.5, l = R + 0.5, c = 1;
  }
  const d = u / c, f = u * e.x, p = c * e.y, g = u - f, y = c - p, m = f > g ? [g, f] : [f, g], A = p > y ? [y, p] : [p, y];
  let v, b, w = 1, k = 1;
  switch (i) {
    default:
    case hs.closestSide:
      if (v = m[0] / u, b = A[0] / c, s === Cs.circle) {
        const R = Math.min(v * d, b);
        w = R, k = R;
      } else w = v * d, k = b;
      break;
    case hs.farthestSide:
      if (v = m[1] / u, b = A[1] / c, s === Cs.circle) {
        const R = Math.max(v * d, b);
        w = R, k = R;
      } else w = v * d, k = b;
      break;
    case hs.closestCorner:
      if (b = A[0] / c, s === Cs.circle) {
        v = m[0] / u * d;
        const R = Math.sqrt(v * v + b * b);
        w = R, k = R;
      } else {
        v = m[0] / u;
        const R = Math.sqrt(v * v + b * b);
        w = R * d, k = R;
      }
      break;
    case hs.farthestCorner:
      if (b = A[1] / c, s === Cs.circle) {
        v = m[1] / u * d;
        const R = Math.sqrt(v * v + b * b);
        w = R, k = R;
      } else {
        v = m[1] / u;
        const R = Math.sqrt(v * v + b * b);
        w = R * d, k = R;
      }
  }
  return { bounds: [a * o, h * o, u * o, c * o], center: [e.x * d, e.y], distance: [Math.max(w, 1e-4), Math.max(k, 1e-4)], aspectRatio: d };
}
function Gs(r, t, e, i) {
  const s = t.x.Rt(r.max.x), o = t.x.Rt(r.min.x), n = t.y.Rt(r.max.y), a = t.y.Rt(r.min.y), l = s - o, h = n - a, u = Math.abs(l * Math.sin(e)) + Math.abs(h * Math.cos(e)), c = j(l / 2 - Math.sin(e) * (u / 2), h / 2 - Math.cos(e) * (u / 2)), d = j(l / 2 + Math.sin(e) * (u / 2), h / 2 + Math.cos(e) * (u / 2));
  return { bounds: [o * i, a * i, l * i, h * i], startPoint: [c.x * i, c.y * i], endPoint: [d.x * i, d.y * i] };
}
class Ja {
  constructor(t) {
    this.WD = t;
  }
}
class wM {
  constructor() {
    this.PR = new Array(), this.LR = (t) => (this.PR.push(t), t), this.BR = this.LR(/* @__PURE__ */ new Map()), this.DR = this.LR(/* @__PURE__ */ new Map()), this.ER = this.LR(/* @__PURE__ */ new Map()), this.RR = this.LR(/* @__PURE__ */ new Map()), this.OR = this.LR(/* @__PURE__ */ new Map()), this.zR = this.LR(/* @__PURE__ */ new Map()), this.VR = this.LR(/* @__PURE__ */ new Map()), this.NR = this.LR(/* @__PURE__ */ new Map());
  }
  GR() {
    this.PR.forEach(((t) => {
      t.forEach(((e) => e.GR())), t.clear();
    }));
  }
}
const Kh = (r, t, e = void 0) => () => {
  r.$R = t, e && e();
}, Ah = (r, t, e, i, s) => {
  const o = Math.min(e / r, i / t), n = r * o, a = t * o, l = e / n, h = i / a, u = n / e, c = a / i;
  let d = 0, f = 1, p = 0, g = 1;
  switch (s) {
    case Li.Fill:
      h < l ? (d = 0, f = 1, p = 0.5 + -u / 2, g = 0.5 + u / 2) : (p = 0, g = 1, d = 0.5 + -c / 2, f = 0.5 + c / 2);
      break;
    case Li.Fit:
      h < l ? (p = 0, g = 1, d = 0.5 + -l / 2, f = 0.5 + l / 2) : (d = 0, f = 1, p = 0.5 + -h / 2, g = 0.5 + h / 2);
      break;
    case Li.Center:
      {
        const y = e / r, m = i / t;
        d = 0.5 + -y / 2, f = 0.5 + y / 2, p = 0.5 + -m / 2, g = 0.5 + m / 2;
      }
      break;
    case Li.Tile:
      d = 0, f = e / r, p = 0, g = i / t;
      break;
    case Li.Stretch:
    default:
      d = 0, f = 1, p = 0, g = 1;
  }
  return new Float32Array([d, g, f, g, f, p, d, p]);
};
class TM {
  constructor(t, e) {
    if (this.UR = 0, this.jR = 0, this.YR = !1, this.$R = !1, this.HR = !1, this.WR = !1, this.XR = !1, this.ZR = /* @__PURE__ */ new Set(), this.JR = /* @__PURE__ */ new Set(), this.qs = e, this.xE = t, this.QR = null, this.YR = e instanceof H.HTMLVideoElement, this.qs instanceof H.HTMLImageElement) this.qs.addEventListener("load", (() => {
      this.WR = !0, this.KR();
    })), this.qs.addEventListener("error", (() => {
      this.XR = !0;
    })), this.qs.complete && (this.WR = !0, this.KR());
    else if (this.qs instanceof H.HTMLVideoElement) {
      const i = this;
      this.qs.addEventListener("canplay", (function() {
        i.jR = this.videoHeight, i.UR = this.videoWidth, i.WR = !0, i.KR();
      }), !0), this.qs.addEventListener("play", Kh(this, !0, (() => this.KR()))), this.qs.addEventListener("playing", Kh(this, !0, (() => this.KR()))), this.qs.addEventListener("pause", Kh(this, !1)), this.qs.addEventListener("ended", Kh(this, !1)), this.qs.readyState >= 1 && (this.UR = this.qs.videoWidth, this.jR = this.qs.videoHeight, this.$R = !this.qs.paused, this.WR = !0, this.KR());
    } else this.WR = !0, this.KR();
  }
  pd(t) {
    this.JR.size === 0 && this.WR && this.KR(), this.JR.add(t);
  }
  hE(t) {
    this.JR.delete(t), this.JR.size === 0 && this.unbindResources();
  }
  qR(t) {
    this.ZR.add(t), this.HR && (t(), this.tO(t));
  }
  tO(t) {
    this.ZR.delete(t);
  }
  KR() {
    if (this.XR || this.HR || !this.WR) return;
    const t = this.xE.gl;
    if (!this.QR && this.qs && t) {
      this.QR = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.QR), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1);
      const e = 0, i = t.RGBA, s = t.RGBA, o = t.UNSIGNED_BYTE, n = this.qs, a = this.UR > 0 ? this.UR : n.width, l = this.jR > 0 ? this.jR : n.height;
      t.texImage2D(t.TEXTURE_2D, e, i, s, o, n), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), this.UR = a, this.jR = l, t.bindTexture(t.TEXTURE_2D, null);
    }
    this.HR = !0, this.ZR && this.ZR.forEach(((e) => {
      e(), this.tO(e);
    }));
  }
  Uh() {
    const t = this.xE.gl;
    if (!this.XR && this.HR && this.QR) {
      const i = t.RGBA, s = t.RGBA, o = t.UNSIGNED_BYTE, n = this.qs;
      n && (t.bindTexture(t.TEXTURE_2D, this.QR), t.texImage2D(t.TEXTURE_2D, 0, i, s, o, n));
    }
  }
  iO() {
    return this.QR;
  }
  unbindResources() {
    return this.HR && (this.QR && (this.xE.JD(this.QR), this.QR = null), this.HR = !1), this;
  }
}
class Ld extends Dm {
  constructor(t, e, i) {
    super(t.yi, e, i), this.Cv = !0, this._v = le(Na), this.Js = t, this.ai = t.ai;
  }
  sO() {
    var t;
    return this._v.u && this._v.T().type !== ((t = this.eO) === null || t === void 0 ? void 0 : t.type);
  }
  Bv(t) {
    return this.Cv = t, this;
  }
}
const kM = (r, t, e, i) => {
  const s = r.rO(), o = Math.round(Math.min(e.spread, 10) * s), n = Math.round(Math.min(e.blur, 10) * s), a = Math.round(e.offset.x * s), l = Math.round(e.offset.y * s), h = r.hO(), u = r.nO(), c = r.oO(), d = r.aO(), f = r.lO();
  r.uO("disabled"), r.Bv(!1), r.cO(!1);
  const p = r.yi.oa.fR, g = t.dO(), y = o + n / 2, m = ((L, x, M, C) => {
    const S = L.gl, E = L.rO(), T = L.fO();
    L.AO(S.FRAMEBUFFER, C.frameBuffer), S.bindRenderbuffer(S.RENDERBUFFER, C.depthBuffer), S.bindTexture(S.TEXTURE_2D, C.texture), S.clearDepth(1), S.clearColor(0, 0, 0, 0), S.clear(S.COLOR_BUFFER_BIT | S.DEPTH_BUFFER_BIT);
    const I = C.sizeDpr;
    L.gO(0, 0, I.x, I.y);
    const F = [], D = L.yi.oa.fR;
    return x.forEach(((P) => {
      let V;
      if (P instanceof Cu) {
        V = P.fs || P.Js.bv();
        let _ = !1;
        if (!V) {
          const O = P.Js.vO(P);
          O && O.max.x - O.min.x > 0 && O.max.y - O.min.y > 0 && (V = { x: O.min.x, y: O.min.y, width: O.max.x - O.min.x, height: O.max.y - O.min.y }, _ = !0);
        }
        V && (V.width > 0 && V.height > 0 ? (_ && (V.x -= M.left / E, V.y -= M.top / E, V.width += (M.left + M.right) / E, V.height += (M.top + M.bottom) / E), F.push({ x: V.x, y: V.y, width: V.width, height: V.height })) : V = void 0);
      } else P instanceof Ld && (V = P.Js.Jm());
      if (V) {
        const _ = V.x + (D ? 0 : M.left), O = V.y + (D ? 0 : M.bottom), B = Math.max(V.width - (D ? 0 : M.left + M.right), 0), z = Math.max(V.height - (D ? 0 : M.bottom + M.top), 0);
        L.yO(_ * E, O * E, B * E, z * E);
      } else L.cO(!1);
      P.Ec(2, 0);
    })), L.AO(S.FRAMEBUFFER, T), S.bindRenderbuffer(S.RENDERBUFFER, null), S.bindTexture(S.TEXTURE_2D, null), L.cO(!1), F;
  })(r, i, { left: y + (a < 0 ? -a : 0), top: y + (l > 0 ? l : 0), right: y + (a > 0 ? a : 0), bottom: y + (l < 0 ? -l : 0) }, g), A = g, v = o + n + 5, b = ((L, x, M, C) => {
    const S = ((F) => {
      const D = [];
      for (let P = 0; P < F.length; P += 1) {
        let V, _ = F[P];
        do {
          const O = D.findIndex(((B) => ma(_, B)));
          V = O >= 0 ? D[O] : void 0, V && (D.splice(O, 1), _ = Qs(_, V));
        } while (V);
        D.push(_);
      }
      return D;
    })(x.map(((F) => {
      const D = F instanceof Cu || F instanceof Ld ? F.Js.vO(F) : Ie;
      if (K0(D)) return Ie;
      const P = { min: { x: Math.max(D.min.x - M.left, 0), y: Math.max(D.min.y - M.bottom, 0) }, max: { x: Math.min(D.max.x + M.right, C.x), y: Math.min(D.max.y + M.top, C.y) } };
      return P.max.x <= P.min.x || P.max.y <= P.min.y ? Ie : P;
    })).filter(((F) => !K0(F)))), E = 6 * S.length, T = new Float32Array(4 * E);
    let I = 0;
    return S.forEach(((F) => {
      const D = wl(F.min, C), P = wl(F.max, C), V = D, _ = P;
      T[I + 0] = D.x, T[I + 1] = D.y, T[I + 2] = V.x, T[I + 3] = V.y, T[I + 4] = P.x, T[I + 5] = D.y, T[I + 6] = _.x, T[I + 7] = V.y, T[I + 8] = P.x, T[I + 9] = P.y, T[I + 10] = _.x, T[I + 11] = _.y, T[I + 12] = P.x, T[I + 13] = P.y, T[I + 14] = _.x, T[I + 15] = _.y, T[I + 16] = D.x, T[I + 17] = P.y, T[I + 18] = V.x, T[I + 19] = _.y, T[I + 20] = D.x, T[I + 21] = D.y, T[I + 22] = V.x, T[I + 23] = V.y, I += 24;
    })), { vertexBuffer: L.pO(T), vertexCount: E };
  })(r, i, { left: v + (a < 0 ? -a : 0), top: v + (l > 0 ? l : 0), right: v + (a > 0 ? a : 0), bottom: v + (l < 0 ? -l : 0) }, t.mO()), w = t.dO(A), k = r.SR(K["2D"], K.Glow1D({ spreadPx: o, blurPx: n, firstPass: !0 }), K.VertexLocation({ scaling: { dataType: "uniform" }, translation: { dataType: "uniform", sizeUnit: "axis" }, axisWorldTranslation: "linear", normalSource: void 0 }));
  ((L, x, M, C, S, E) => {
    const T = L.gl, I = L.fO();
    L.AO(T.FRAMEBUFFER, M.frameBuffer), T.bindRenderbuffer(T.RENDERBUFFER, M.depthBuffer), T.bindTexture(T.TEXTURE_2D, M.texture), T.clearDepth(1), T.clearColor(0, 0, 0, 0), T.clear(T.COLOR_BUFFER_BIT | T.DEPTH_BUFFER_BIT), L.gO(0, 0, M.sizeDpr.x, M.sizeDpr.y), L.SO(C, ((F, D, P, V) => (L.pd(C), E && E(F), L._O(F("uIsHighlighted"), 0).gP(F("uHighlightColorOffset"), ya)._O(F("uRenderEffectMask"), 0).MO(F("uTexture"), x.texture, 0).xO(V("uTextureSize"), [x.sizeDpr.x, x.sizeDpr.y]).xO(F("uScale"), M.uniforms.wO()).xO(F("uDisp"), M.uniforms.kO()).xO(F("uScaling"), [M.size.x, M.size.y]).xO(F("uTranslationAxis"), [0, 0]).bO(S.vertexBuffer, void 0, { location: D("aPos"), size: 2 }, { location: D("aTextureCoord"), size: 2 }).dC(T.TRIANGLES, S.vertexCount, 0), !0))), L.AO(T.FRAMEBUFFER, I), T.bindRenderbuffer(T.RENDERBUFFER, null), T.bindTexture(T.TEXTURE_2D, null);
  })(r, A, w, k, b, ((L, x, M, C) => (r.xO(L("uOffsetPx"), [a + 1, l + 1]), !0))), r.cO(u), r.CO(f), p && (((L, x) => {
    if (x === void 0 || x.length < 1) return;
    const M = L.gl, C = 6 * x.length * 2, S = [C];
    let E = 0;
    for (let V = 0; V < x.length; V += 1) {
      const _ = x[V];
      S[E + 0] = _.x, S[E + 1] = _.y, S[E + 2] = _.x + _.width, S[E + 3] = _.y, S[E + 4] = _.x, S[E + 5] = _.y + _.height, S[E + 6] = _.x + _.width, S[E + 7] = _.y, S[E + 8] = _.x + _.width, S[E + 9] = _.y + _.height, S[E + 10] = _.x, S[E + 11] = _.y + _.height, E += 12;
    }
    const T = L.pO(S, !0), I = { x: L.yi.Ft().x, y: L.yi.Ft().y }, F = ki.d2({ scaleXYConstructor: we }).K(I).ii(0, I.x).si(0, I.y), D = new Fs();
    D.TO(F);
    const P = L.SR(K["2D"], K.VertexLocation({ scaling: { dataType: "uniform" }, translation: void 0, axisWorldTranslation: "linear", normalSource: void 0 }), K.Color({ dataType: "uniform" }));
    L.FO(!0), M.clearStencil(0), M.clear(M.STENCIL_BUFFER_BIT), M.stencilFunc(M.ALWAYS, 1, 255), M.stencilOp(M.KEEP, M.KEEP, M.REPLACE), M.stencilMask(255), M.colorMask(!1, !1, !1, !1), L.pd(P).PO(P.FE("aPos"), T).xO(P.CE("uDisp"), D.kO()).xO(P.CE("uScaling"), [1, 1]).xO(P.CE("uScale"), D.wO()).IO(P.CE("uColor"), [1, 1, 1, 1]).dC(M.TRIANGLES, C / 2), L.LO(T), M.colorMask(!0, !0, !0, !0);
  })(r, m), r.gl.stencilFunc(r.gl.EQUAL, 1, 255), r.gl.stencilOp(r.gl.KEEP, r.gl.KEEP, r.gl.KEEP), r.FO(!0));
  const R = r.SR(K["2D"], K.Glow1D({ spreadPx: o, blurPx: n, firstPass: !1 }), K.VertexLocation({ scaling: { dataType: "uniform" }, translation: { dataType: "uniform", sizeUnit: "axis" }, axisWorldTranslation: "linear", normalSource: void 0 }));
  ((L, x, M, C, S) => {
    const E = L.gl, T = { x: L.yi.Ft().x, y: L.yi.Ft().y };
    L.gO(0, 0, T.x * L.rO(), T.y * L.rO());
    const I = ki.d2({ scaleXYConstructor: we }).K(T).ii(0, T.x).si(0, T.y), F = new Fs();
    F.TO(I), L.SO(M, ((D, P, V, _) => (L.pd(M), S && S(D), L._O(D("uIsHighlighted"), 0).gP(D("uHighlightColorOffset"), ya)._O(D("uRenderEffectMask"), 0).MO(D("uTexture"), x.texture, 0).xO(_("uTextureSize"), [x.sizeDpr.x, x.sizeDpr.y]).xO(D("uScale"), F.wO()).xO(D("uDisp"), F.kO()).xO(D("uScaling"), [T.x, T.y]).xO(D("uTranslationAxis"), [0, 0]).bO(C.vertexBuffer, void 0, { location: P("aPos"), size: 2 }, { location: P("aTextureCoord"), size: 2 }).dC(E.TRIANGLES, C.vertexCount, 0), !0)));
  })(r, g, R, b, ((L, x, M, C) => (r.MO(L("uTextureFirstGlowPass"), w.texture, 1).gP(L("uGlowColor"), e.color), !0))), r.gO(h.x, h.y, h.width, h.height), r.uO(c), r.Bv(d), r.LO(b.vertexBuffer), p && r.FO(!1);
};
class DM {
  constructor(t) {
    this.BO = [], this.WD = t;
  }
  DO(t, e) {
    kM(this.WD, this, e, t);
  }
  mO() {
    const t = this.WD.yi.Ft();
    return { x: Math.ceil(t.x), y: Math.ceil(t.y) };
  }
  dO(...t) {
    const e = this.BO, i = this.mO(), s = { x: Math.ceil(i.x * this.WD.rO()), y: Math.ceil(i.y * this.WD.rO()) }, o = this.WD.gl, n = e.find(((p) => !t.includes(p)));
    if (n) return n.sizeDpr.x === s.x && n.sizeDpr.y === s.y || (n.size = i, n.sizeDpr = s, o.bindTexture(o.TEXTURE_2D, n.texture), o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, s.x, s.y, 0, o.RGBA, o.UNSIGNED_BYTE, null), o.bindRenderbuffer(o.RENDERBUFFER, n.depthBuffer), o.renderbufferStorage(o.RENDERBUFFER, o.DEPTH_STENCIL, s.x, s.y), o.bindTexture(o.TEXTURE_2D, null), o.bindRenderbuffer(o.RENDERBUFFER, null), n.scale.K(i).ii(0, i.x).si(0, i.y), n.uniforms.TO(n.scale)), n;
    const a = o.createTexture(), l = this.WD.EO(), h = this.WD.RO();
    o.bindTexture(o.TEXTURE_2D, a), o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, s.x, s.y, 0, o.RGBA, o.UNSIGNED_BYTE, null), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.pixelStorei(o.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1);
    const u = this.WD.fO();
    this.WD.AO(o.FRAMEBUFFER, l), o.framebufferTexture2D(o.FRAMEBUFFER, o.COLOR_ATTACHMENT0, o.TEXTURE_2D, a, 0), o.bindRenderbuffer(o.RENDERBUFFER, h), o.renderbufferStorage(o.RENDERBUFFER, o.DEPTH_STENCIL, s.x, s.y), o.framebufferRenderbuffer(o.FRAMEBUFFER, o.DEPTH_STENCIL_ATTACHMENT, o.RENDERBUFFER, h), o.bindTexture(o.TEXTURE_2D, null), this.WD.AO(o.FRAMEBUFFER, u), o.bindRenderbuffer(o.RENDERBUFFER, null);
    const c = ki.d2({ scaleXYConstructor: we }).K(i).ii(0, i.x).si(0, i.y), d = new Fs();
    d.TO(c);
    const f = { size: i, sizeDpr: s, texture: a, frameBuffer: l, depthBuffer: h, scale: c, uniforms: d };
    return e.push(f), f;
  }
  G() {
    [this.BO].forEach(((t) => {
      t.forEach(((e) => {
        this.WD.OO(e.depthBuffer), this.WD.zO(e.frameBuffer), this.WD.JD(e.texture);
      })), t.length = 0;
    }));
  }
}
class FM {
  constructor(t, e, i, s, o = !0) {
    this.VO = new wM(), this.NO = /* @__PURE__ */ new Map(), this.GO = /* @__PURE__ */ new Map(), this.$O = [], this.oR = 1, this.IS_MACHINE_LITTLE_ENDIAN = (() => {
      const n = new Uint32Array([287454020]), a = new Uint8Array(n.buffer);
      return a[0] === 68 || a[0] !== 17 && (H.console.error("Unidentified machine endianness. Some features might behave unexpectedly."), !0);
    })(), this.Cv = !1, this.UO = !1, this.xO = (n, [a, l]) => (n === void 0 || this.gl.uniform2f(n, a, l), this), this.jO = (n, [a, l]) => (n === void 0 || this.gl.uniform2i(n, a, l), this), this.IO = (n, [a, l, h, u]) => (n === void 0 || this.gl.uniform4f(n, a, l, h, u), this), this.YO = (n, [a, l, h]) => (n === void 0 || this.gl.uniform3f(n, a, l, h), this), this.HO = (n, a) => (n === void 0 || this.gl.uniformMatrix3fv(n, !1, a), this), this.WO = (n, a) => (n === void 0 || this.gl.uniformMatrix4fv(n, !1, a), this), this.gP = (n, a) => (n === void 0 || this.gl.uniform4f(n, a.r, a.g, a.b, a.a), this), this._O = (n, a) => (n === void 0 || this.gl.uniform1f(n, a), this), this.XO = (n, a) => (this.gl.uniform1i(n, a), this), this.MO = (n, a, l) => {
      if (n === void 0) return this;
      if (a) {
        const h = this.gl.TEXTURE0 + l;
        return this.gl.activeTexture(h), this.gl.bindTexture(this.gl.TEXTURE_2D, a), this.gl.uniform1i(n, l), this;
      }
      throw new pi("Could not bind a texture.");
    }, this.ZO = (n) => (((a, l) => {
      l === Li.Tile ? (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.REPEAT), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.REPEAT)) : (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE));
    })(this.gl, n), this), this.pO = (n, a = !1, l, h = Float32Array) => {
      const u = n.length, c = this.JO(u, l);
      if (this.gl.bindBuffer(this.gl.ARRAY_BUFFER, c), this.gl.bufferData(this.gl.ARRAY_BUFFER, n instanceof h ? n : new h(n), a ? this.gl.DYNAMIC_DRAW : this.gl.STATIC_DRAW), this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null), c) return c;
      throw new pi("Could not create vertex buffer");
    }, this.QO = (n, a, l, h = Float32Array) => {
      const u = l || this.gl.createBuffer();
      if (this.gl.bindBuffer(this.gl.ARRAY_BUFFER, u), a && a.length === n ? this.gl.bufferData(this.gl.ARRAY_BUFFER, a instanceof h ? a : new h(a), this.gl.STATIC_DRAW) : (this.gl.bufferData(this.gl.ARRAY_BUFFER, n * h.BYTES_PER_ELEMENT, this.gl.STATIC_DRAW), a && this.gl.bufferSubData(this.gl.ARRAY_BUFFER, 0, a instanceof h ? a : new h(a))), this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null), u) return u;
      throw new pi("Could not create vertex buffer");
    }, this.KO = (n, a, l, h = Float32Array) => {
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, n), this.gl.bufferSubData(this.gl.ARRAY_BUFFER, a * h.BYTES_PER_ELEMENT, l instanceof h ? l : new h(l)), this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null);
    }, this.qO = (n, a, l, h, u) => {
      if (h && n && (n.usedSize = 0), !n) {
        const c = a.length + l, d = new u(c);
        return d.set(a), { buffer: this.QO(c, d, void 0, u), dataCache: d, preallocSize: c, usedSize: a.length };
      }
      if (n.usedSize + a.length > n.preallocSize) {
        const c = n.usedSize + a.length + l, d = new u(c);
        return d.set(n.dataCache), d.set(a, n.usedSize), { buffer: this.QO(c, d, n.buffer, u), dataCache: d, preallocSize: c, usedSize: n.usedSize + a.length };
      }
      return n.dataCache.set(a, n.usedSize), this.KO(n.buffer, n.usedSize, a, u), n.usedSize += a.length, n;
    }, this.tz = (n, a, l = !1) => {
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, n), this.gl.bufferData(this.gl.ARRAY_BUFFER, a, l ? this.gl.DYNAMIC_DRAW : this.gl.STATIC_DRAW), this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null);
    }, this.iz = (n, a) => {
      const l = n.length, h = this.JO(l, a);
      if (this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, h), this.gl.bufferData(this.gl.ELEMENT_ARRAY_BUFFER, n, this.gl.STATIC_DRAW), this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null), h) return h;
      throw new pi("Could not create index buffer");
    }, this.sz = (n) => {
      const a = this.gl.createBuffer();
      if (this.gl.bindBuffer(this.gl.ARRAY_BUFFER, a), this.gl.bufferData(this.gl.ARRAY_BUFFER, n instanceof Float32Array ? n : new Float32Array(n), this.gl.STATIC_DRAW), this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null), a) return a;
      throw new pi("Could not create float buffer");
    }, this.PO = (n, a) => (n === void 0 || (this.gl.bindBuffer(this.gl.ARRAY_BUFFER, a), this.gl.enableVertexAttribArray(n), this.gl.vertexAttribPointer(n, 2, this.gl.FLOAT, !1, 0, 0)), this), this.ez = (n, a) => (n === void 0 || (this.gl.bindBuffer(this.gl.ARRAY_BUFFER, a), this.gl.vertexAttribPointer(n, 3, this.gl.FLOAT, !1, 0, 0), this.gl.enableVertexAttribArray(n)), this), this.bO = (n, a, ...l) => {
      var h;
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, n);
      const u = l.length;
      let c = 0;
      for (let f = 0; f < u; f += 1) c += l[f].size;
      for (let f = 0; f < u; f += 1) {
        const p = l[f].location;
        p !== void 0 && p > -1 && this.gl.enableVertexAttribArray(p);
      }
      let d = 0;
      for (let f = 0; f < u; f += 1) {
        const p = l[f];
        p.location !== void 0 && p.location > -1 && this.gl.vertexAttribPointer(p.location, p.size, this.gl.FLOAT, !1, c * Float32Array.BYTES_PER_ELEMENT, d * Float32Array.BYTES_PER_ELEMENT + ((h = p.extraOffset) !== null && h !== void 0 ? h : 0)), d += p.size;
      }
      if (a !== void 0) for (let f = 0; f < u; f += 1) {
        const p = l[f].location;
        p !== void 0 && p > -1 && this.rz(p, a);
      }
      return this;
    }, this.hz = (...n) => {
      const a = n.length;
      for (let l = 0; l < a; l += 1) {
        const h = n[l];
        h !== 0 && h > -1 && this.gl.disableVertexAttribArray(h);
      }
      return this;
    }, this.nz = (n, a) => (n === void 0 || (this.gl.bindBuffer(this.gl.ARRAY_BUFFER, a), this.gl.enableVertexAttribArray(n), this.gl.vertexAttribPointer(n, 4, this.gl.FLOAT, !1, 0, 0)), this), this.oz = (n, a, l, h = 0) => (n === void 0 || (this.gl.bindBuffer(this.gl.ARRAY_BUFFER, a), this.gl.vertexAttribPointer(n, 1, this.gl.FLOAT, !1, 0, h), this.gl.enableVertexAttribArray(n), l !== void 0 && this.rz(n, l)), this), this.az = (n) => (this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, n), this), this.lz = null, this.dC = (n, a, l = 0) => (a > 0 && this.gl.drawArrays(n, l, a), this), this.uz = (n, a = this.gl.TRIANGLES, l = 0, h = this.gl.UNSIGNED_SHORT) => (n > 0 && this.gl.drawElements(a, n, h, l), this), this.cz = (n, a, l, h) => {
      if (h > 0 && (this.gl2 && this.gl2.ctx.drawArraysInstanced(n, a, l, h), this.gl1)) {
        if (!this.gl1.AR.ANGLE_instanced_arrays) return H.console.warn(`The browser does not support REQUIRED WebGL 1 extension: ANGLE_instanced_arrays.
This application will NOT work properly!`), this;
        this.gl1.AR.ANGLE_instanced_arrays.drawArraysInstancedANGLE(n, a, l, h);
      }
      return this;
    }, this.dz = (n, a, l, h, u = this.gl.UNSIGNED_SHORT) => {
      if (h > 0 && (this.gl2 && this.gl2.ctx.drawElementsInstanced(n, a, u, l, h), this.gl1)) {
        if (!this.gl1.AR.ANGLE_instanced_arrays) return H.console.warn(`The browser does not support REQUIRED WebGL 1 extension: ANGLE_instanced_arrays.
This application will NOT work properly!`), this;
        this.gl1.AR.ANGLE_instanced_arrays.drawElementsInstancedANGLE(n, a, u, l, h);
      }
      return this;
    }, this.rz = (n, a) => {
      if (n > -1 && (this.gl2 && this.gl2.ctx.vertexAttribDivisor(n, a), this.gl1)) {
        if (!this.gl1.AR.ANGLE_instanced_arrays) return H.console.warn(`The browser does not support REQUIRED WebGL 1 extension: ANGLE_instanced_arrays.
This application will NOT work properly!`), this;
        this.gl1.AR.ANGLE_instanced_arrays.vertexAttribDivisorANGLE(n, a);
      }
      return this;
    }, this.fz = (n, a, l, h = 0) => {
      const u = this.gl.TEXTURE0 + h;
      this.gl.activeTexture(u);
      const c = this.fO();
      this.AO(this.gl.FRAMEBUFFER, a), this.gl.bindTexture(this.gl.TEXTURE_2D, l), this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, l, 0);
      const d = this.nO();
      d && this.cO(!1), n(), d && this.cO(!0), this.gl.bindTexture(this.gl.TEXTURE_2D, null), this.AO(this.gl.FRAMEBUFFER, c);
    }, this.Vi = () => (this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT), this), this.Az = (n) => (this.gl.clearColor(n.r, n.g, n.b, n.a), this), this.pd = (n) => (this.gl.useProgram(n.ME), this), this.gz = !1, this.vz = [], this.yi = t, this.Qg = e, this.yi = t, this.gl = i.ctx, this.yz = i.antialias, this.pz = !!this.yi.oa.EE && i.lineAntialias, this.gR = this.yi.oa.gR, this.mz = /* @__PURE__ */ new Map(), this.gl1 = this.yi.oa.gl1, this.gl2 = this.yi.oa.gl2, o && (this.CO(!0), this.Sz()), this.AR = this.yi.oa.AR, this.ZD = this.gl.getParameter(this.gl.MAX_TEXTURE_SIZE), this.tE = this.bz(), this.SR = this.yi.oa.SR, this.xz = new RM(this), this.aE = this.yi.oa.aE, this.Mz = new DM(this), this.DE = this.yi.oa.DE, this._z = this.pO([0, 0, 1, 0, 1, 1, 0, 1]), this.wz = this.pO([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]);
  }
  uO(t) {
    return t !== this.kz && (this.kz = t, t === "disabled" ? this.gl.disable(this.gl.CULL_FACE) : t === "cull-back" ? (this.gl.enable(this.gl.CULL_FACE), this.gl.cullFace(this.gl.BACK)) : t === "cull-front" && (this.gl.enable(this.gl.CULL_FACE), this.gl.cullFace(this.gl.FRONT))), this;
  }
  oO() {
    return this.kz || "disabled";
  }
  Bv(t) {
    return t !== this.Cv && (this.Cv = t, t ? this.gl.enable(this.gl.DEPTH_TEST) : this.gl.disable(this.gl.DEPTH_TEST)), this;
  }
  FO(t) {
    return t !== this.UO && (this.UO = t, t ? this.gl.enable(this.gl.STENCIL_TEST) : this.gl.disable(this.gl.STENCIL_TEST)), this;
  }
  aO() {
    return this.Cv;
  }
  Cz(t) {
    return this.oR = t, this;
  }
  rO() {
    return this.oR;
  }
  JO(t, e) {
    let i;
    if (e) {
      const s = this.mz.get(e);
      s && s.size >= t && s.size - t < 1e6 ? i = e : this.LO(e);
    }
    return i || (i = this.gl.createBuffer(), this.mz.set(i, { size: t })), i;
  }
  Dx(t, e = this.gl.RGBA, i = !1, s, o, n = !1, a = this.gl.UNSIGNED_BYTE, l = e) {
    const h = this.gl.createTexture();
    if (!h) throw new pi("Couldn't reserve Texture.");
    return this.gl.bindTexture(this.gl.TEXTURE_2D, h), this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n), t && o === null ? this.gl.texImage2D(this.gl.TEXTURE_2D, 0, l, e, a, t) : o && this.gl.texImage2D(this.gl.TEXTURE_2D, 0, l, o.x, o.y, 0, e, a, t), this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE), this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE), this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, s ? this.gl.NEAREST : this.gl.LINEAR), i ? (this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR_MIPMAP_LINEAR), this.gl.generateMipmap(this.gl.TEXTURE_2D)) : this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, s ? this.gl.NEAREST : this.gl.LINEAR), this.gl.bindTexture(this.gl.TEXTURE_2D, null), h;
  }
  JD(t) {
    this.gl.deleteTexture(t);
  }
  EO() {
    const t = this.gl.createFramebuffer();
    if (!t) throw new pi("Couldn't reserve Framebuffer.");
    return t;
  }
  AO(t, e) {
    this.lz = e, this.gl.bindFramebuffer(t, e);
  }
  fO() {
    return this.lz;
  }
  zO(t) {
    this.gl.deleteFramebuffer(t);
  }
  RO() {
    const t = this.gl.createRenderbuffer();
    if (!t) throw new pi("Couldn't reserve Render buffer.");
    return t;
  }
  OO(t) {
    this.gl.deleteRenderbuffer(t);
  }
  Tz() {
    const t = this.gl;
    switch (t.checkFramebufferStatus(t.FRAMEBUFFER)) {
      default:
      case t.FRAMEBUFFER_COMPLETE:
        H.console.log("FRAMEBUFFER_COMPLETE");
        break;
      case t.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
        H.console.log("FRAMEBUFFER_INCOMPLETE_ATTACHMENT");
        break;
      case t.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
        H.console.log("FRAMEBUFFER_INCOMPLETE_DIMENSIONS");
        break;
      case t.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
        H.console.log("FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT");
        break;
      case t.FRAMEBUFFER_UNSUPPORTED:
        H.console.log("FRAMEBUFFER_UNSUPPORTED");
    }
  }
  gO(t, e, i, s) {
    return this.gl.viewport(t, e, i, s), this.Fz && t === this.Fz.x && e === this.Fz.y && i === this.Fz.width && s === this.Fz.height || (this.Fz = { x: t, y: e, width: i, height: s }), this;
  }
  hO() {
    return this.Fz || { x: 0, y: 0, width: 0, height: 0 };
  }
  yO(t, e, i, s) {
    return this.cO(!0), this.gl.scissor(Math.max(t, 0), Math.max(e, 0), Math.max(i, 0), Math.max(s, 0)), this;
  }
  cO(t) {
    return t === this.Iz || (t ? this.gl.enable(this.gl.SCISSOR_TEST) : this.gl.disable(this.gl.SCISSOR_TEST), this.Iz = t), this;
  }
  CO(t) {
    return t !== this.gz && (this.gz = t, t && this.gl.enable(this.gl.BLEND), t || this.gl.disable(this.gl.BLEND)), this;
  }
  lO() {
    return this.gz;
  }
  Sz(t, e, i, s) {
    return t ? (t !== void 0 && e !== void 0 && (i !== void 0 && s !== void 0 ? this.gl.blendFuncSeparate(t, e, i, s) : this.gl.blendFunc(t, e)), this) : (this.gl.blendFuncSeparate(this.gl.SRC_ALPHA, this.gl.ONE_MINUS_SRC_ALPHA, this.gl.ONE, this.gl.ONE_MINUS_SRC_ALPHA), this);
  }
  nO() {
    return this.Iz !== void 0 && this.Iz;
  }
  SO(t, e) {
    const i = new IM(this, t), s = e(i.uniform, i.attribute, i, i.uniformOptional);
    i.finish(s);
  }
  LO(t) {
    t && (this.gl.deleteBuffer(t), this.mz.delete(t));
  }
  Pz(t, e, i) {
    this.xO(t.uniform("uCenter"), e.center).xO(t.uniform("uDistance"), e.distance).IO(t.uniform("uBounds"), e.bounds)._O(t.uniform("uAspect"), e.aspectRatio);
    const s = i.getColorStops();
    if (s.length < 2) throw new Error("Minimum two color stops required");
    for (let o = 0; o < s.length; o += 1) this.gP(t.uniform(`color_${o}`), s[o].color)._O(t.uniform(`stop_${o}`), s[o].offset);
    return this;
  }
  Lz(t, e, i) {
    this.xO(t.uniform("uStartPoint"), e.startPoint).xO(t.uniform("uEndPoint"), e.endPoint).IO(t.uniform("uBounds"), e.bounds);
    const s = i.getColorStops();
    if (s.length < 2) throw new Error("Minimum two color stops required");
    for (let o = 0; o < s.length; o += 1) this.gP(t.uniform(`color_${o}`), s[o].color)._O(t.uniform(`stop_${o}`), s[o].offset);
    return this;
  }
  Fh(t) {
    const e = this.DE.get(t);
    if (!e) {
      const i = new JE(this);
      return this.DE.set(t, i), i;
    }
    return e;
  }
  Bz(t) {
    const e = this.NO.get(t);
    if (!e) {
      const i = new TM(this, t);
      return this.Dz(t, i), i;
    }
    return e;
  }
  Dz(t, e) {
    this.NO.set(t, e);
  }
  bz() {
    const t = this.gl, e = t.createTexture();
    t.bindTexture(t.TEXTURE_2D, e), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, !1), t.texImage2D(t.TEXTURE_2D, 0, t.ALPHA, 1, 1, 0, t.ALPHA, t.UNSIGNED_BYTE, new Uint8ClampedArray([0]));
    const i = t.getError() === 0;
    return i || this.Qg.$a !== !1 && H.console.info("LightningChart JS - Uint8ClampedArray is not supported as texture data. The above WebGL error/warning is from the feature detection. There is nothing to worry about."), t.deleteTexture(e), i;
  }
  Ez(t, e, i, s) {
    if (i) this.bO(e, s, { location: t.attribute("aPos_highpart"), size: 2 }, { location: t.attribute("aPos_lowpart"), size: 2 });
    else {
      const o = t.attribute("aPos");
      this.PO(o, e), s !== void 0 && this.rz(o, s);
    }
    return this;
  }
  Rz() {
    this.AR.WEBGL_lose_context && this.AR.WEBGL_lose_context.loseContext();
  }
  Oz(t) {
    if (this.zz && this.zz.bufferIdsCount >= t) return this.zz.buffer;
    this.zz && (this.LO(this.zz.buffer), this.zz = void 0);
    const e = t, i = new Float32Array(e);
    for (let o = 0; o < e; o += 1) i[o] = o;
    const s = this.pO(i);
    return this.zz = { buffer: s, bufferIdsCount: e }, s;
  }
  Vz() {
    return this.gl2 ? void 0 : "attribute";
  }
  Nz(t, e) {
    if (this.Vz() === "attribute") {
      const i = this.Oz(e);
      this.bO(i, void 0, { location: t.attribute("aVertexID"), size: 1 });
    }
    return this;
  }
  Gz() {
    return this.gl2 ? void 0 : "attribute";
  }
  $z(t, e) {
    if (this.Gz() === "attribute") {
      const i = this.Oz(e);
      this.bO(i, 1, { location: t.attribute("aInstanceID"), size: 1 });
    }
    return this;
  }
  Uz(t, e, i, s, o, n, a, l, h) {
    const u = t.createBuffer();
    return this.vz.push(u), t.bindFramebuffer(t.FRAMEBUFFER, e), t.bindBuffer(t.PIXEL_PACK_BUFFER, u), t.bufferData(t.PIXEL_PACK_BUFFER, h.byteLength, t.STREAM_READ), t.readPixels(i, s, o, n, a, l, 0), t.bindBuffer(t.PIXEL_PACK_BUFFER, null), t.bindFramebuffer(t.FRAMEBUFFER, null), LM(t, (() => this.yi.ci), t.PIXEL_PACK_BUFFER, u, 0, h).then((() => h)).catch(((c) => {
      throw c;
    })).finally((() => {
      t.deleteBuffer(u), this.vz.splice(this.vz.indexOf(u), 1);
    }));
  }
  jz(t, e, i, s, o, n, a, l) {
    const h = this.gl, u = this.fO();
    this.AO(h.FRAMEBUFFER, t), h.readPixels(e, i, s, o, n, a, l), this.AO(this.gl.FRAMEBUFFER, u);
  }
  Yz(t) {
    const e = this.GO.get(t);
    if (!e) {
      const s = this.gl.createTexture();
      if (!s) throw new pi("Couldn't reserve Texture.");
      this.gl.bindTexture(this.gl.TEXTURE_2D, s);
      const o = [];
      let n = 255;
      for (let h = 0; h < t.length; h += 1) {
        for (let u = 0; u < t[h]; u += 1) o.push(n);
        n = n === 255 ? 0 : 255;
      }
      const a = o.length;
      if (!this.gl2 && (i = o.length) & i - 1) {
        const h = ((u) => {
          u -= 1;
          for (let c = 1; c < 32; c <<= 1) u |= u >> 1;
          return u + 1;
        })(o.length);
        for (let u = o.length; u < h; u += 1) o[u] = 0;
      }
      this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), this.gl.pixelStorei(this.gl.PACK_ALIGNMENT, 1), this.gl.pixelStorei(this.gl.UNPACK_ALIGNMENT, 1), this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.NEAREST), this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.NEAREST), this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.REPEAT), this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.REPEAT), this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.LUMINANCE, o.length, 1, 0, this.gl.LUMINANCE, this.gl.UNSIGNED_BYTE, new Uint8Array(o)), this.gl.bindTexture(this.gl.TEXTURE_2D, null);
      const l = { Wz: s, Xz: a, Zz: o.length };
      return this.GO.set(t, l), l;
    }
    var i;
    return e;
  }
  Jz(t, e, i) {
    const { uniform: s } = t;
    this.gP(s("uFallbackColor"), e.getFallbackColor());
    for (let o = 0; o < e.steps.length; o += 1) this._O(s(`uLUTValue${o}`), e.steps[o].value), this.gP(s(`uLUTColor${o}`), e.steps[o].color);
    if (e.percentageValues) {
      if (!i) return Js(0, (() => {
      })), this;
      this._O(s("uMinValue"), i.min), this._O(s("uMaxValue"), i.max);
    }
    return this;
  }
  Qz(t, e, i, s, o, n) {
    const a = i && i.getSource() || s && s.qs, l = i ? i.getFitMode() : Li.Stretch, h = (u) => {
      u.texCoordsBuffer = this.pO(n(u.texture.UR, u.texture.jR, l), !1, u.texCoordsBuffer);
    };
    if (a) {
      let u = e;
      if ((!e || a !== e.source) && a) {
        e && (e.texture.hE(t), this.LO(e.texCoordsBuffer));
        const c = this.Bz(a);
        c.pd(t);
        const d = i ? i.getSourceMissingColor() : Qm.color;
        u = { texture: c, source: a, texCoordsBuffer: this.pO([]), sourceMissingTexture: this.Dx(new Uint8Array([d.getR(), d.getG(), d.getB(), d.getA()]), this.gl.RGBA, !1, !0, { x: 1, y: 1 }, !1), textureReadyCallback: () => {
          u && a && (h(u), this.yi.Rs());
        } }, c.qR(u.textureReadyCallback), h(u);
      }
      return u && u.texture.HR && u.texture.YR && u.texture.$R && (u.texture.Uh(), this.yi.Rs()), o && u && u.texture.HR && h(u), u;
    }
    e && this.Kz(t, e);
  }
  Kz(t, e) {
    e && (e.texture.hE(t), e.texture.tO(e.textureReadyCallback), this.JD(e.sourceMissingTexture), this.LO(e.texCoordsBuffer));
  }
  qz(t, e, i, s) {
    var o, n, a, l;
    const { uniform: h, uniformOptional: u, attribute: c } = t, d = i.ai, f = this.rO();
    if (this.gP(h("uHighlightColorOffset"), e === 1 || e === 2 ? Qe : i.bi)._O(h("uRenderEffectMask"), e === 2 ? 1 : 0).xO(u("uRatioPxClip"), [2 / this.yi.Ft().x, 2 / this.yi.Ft().y])._O(u("uDevicePixelRatio"), f), s.highlightBuffer === void 0) this._O(h("uIsHighlighted"), e === 1 || e === 2 ? 0 : i.gi);
    else {
      if (!s.highlightBuffer) throw new Error("Highlight buffer not supplied for attribute highlighting");
      this.bO(s.highlightBuffer, (o = s.highlightAttribDivisor) !== null && o !== void 0 ? o : void 0, { location: c("aIsHighlighted"), size: 1 });
    }
    d instanceof we || d instanceof zs ? this.xO(h("uScale"), s.uniforms.wO()).xO(h("uDisp"), s.uniforms.kO()).xO(u("uScaleStart_highpart"), s.uniforms.tV()).xO(u("uScaleStart_lowpart"), s.uniforms.iV()) : d instanceof Ti && this.xO(u("uScaleStart"), s.uniforms.MixedScaleXY.uScaleStart).xO(u("uScaleStartLog"), s.uniforms.MixedScaleXY.uScaleStartLog).xO(u("uScaleInterval"), s.uniforms.MixedScaleXY.uScaleInterval).xO(u("uScaleIntervalLog"), s.uniforms.MixedScaleXY.uScaleIntervalLog).xO(h("uViewportStart"), s.uniforms.MixedScaleXY.uViewportStart).xO(h("uViewportSize"), s.uniforms.MixedScaleXY.uViewportSize);
    const p = s.coordsHighPrecision === !0;
    if (s.coordsX) if (p) {
      const g = c("aPos_highpartX"), y = c("aPos_lowpartX");
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, s.coordsX), this.gl.vertexAttribPointer(g, 1, this.gl.FLOAT, !1, 2 * Float32Array.BYTES_PER_ELEMENT, 0 * Float32Array.BYTES_PER_ELEMENT), this.gl.enableVertexAttribArray(g), this.gl.vertexAttribPointer(y, 1, this.gl.FLOAT, !1, 2 * Float32Array.BYTES_PER_ELEMENT, 1 * Float32Array.BYTES_PER_ELEMENT), this.gl.enableVertexAttribArray(y);
    } else this.oz(c("aPosX"), s.coordsX);
    if (s.coordsY) if (p) {
      const g = c("aPos_highpartY"), y = c("aPos_lowpartY");
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, s.coordsY), this.gl.vertexAttribPointer(g, 1, this.gl.FLOAT, !1, 2 * Float32Array.BYTES_PER_ELEMENT, 0 * Float32Array.BYTES_PER_ELEMENT), this.gl.enableVertexAttribArray(g), this.gl.vertexAttribPointer(y, 1, this.gl.FLOAT, !1, 2 * Float32Array.BYTES_PER_ELEMENT, 1 * Float32Array.BYTES_PER_ELEMENT), this.gl.enableVertexAttribArray(y);
    } else this.oz(c("aPosY"), s.coordsY);
    if (e === 1) {
      if (this.XO(h("uFirstId"), s.idFirst), s.mousePickingOffsetBuffer !== void 0) {
        if (!s.mousePickingOffsetBuffer) throw new Error("No mouse picking offset buffer for attribute mouse picking");
        this.oz(c("aPickingIdOffset"), s.mousePickingOffsetBuffer, (n = s.mousePickingOffsetAttribDivisor) !== null && n !== void 0 ? n : void 0);
      }
    } else {
      if (s.fillStyleSolid && this.gP(h("uColor"), s.fillStyleSolid.getColor()), s.fillStylePaletted) {
        if (s.fillStylePaletted.getLookUpProperty() === "value" && s.lookupValueBuffer !== null) {
          if (!s.lookupValueBuffer) return !1;
          const g = c("aLookupValue");
          this.oz(g, s.lookupValueBuffer, s.lookupValueAttribDivisor, (a = s.lookupValueBufferByteOffset) !== null && a !== void 0 ? a : 0);
        }
        this.Jz(t, s.fillStylePaletted.lut, s.lookupValueRange);
      }
      if (s.fillStyleLinearGradient) {
        if (!s.linearGradientInfo) return !1;
        this.Lz(t, s.linearGradientInfo, s.fillStyleLinearGradient);
      }
      if (s.fillStyleRadialGradient) {
        if (!s.radialGradientInfo) return !1;
        this.Pz(t, s.radialGradientInfo, s.fillStyleRadialGradient);
      }
      if (s.fillStyleIndividual && s.colorBuffer !== null) {
        if (!s.colorBuffer) return !1;
        const g = c("aColor");
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, s.colorBuffer), this.gl.vertexAttribPointer(g, 4, this.gl.UNSIGNED_BYTE, !0, 0, (l = s.colorBufferByteOffset) !== null && l !== void 0 ? l : 0), this.gl.enableVertexAttribArray(g), s.colorAttribDivisor !== void 0 && this.rz(g, s.colorAttribDivisor);
      }
      if (s.fillStyleImage) {
        if (!s.texturedFillGLInfo) return !1;
        const g = s.texturedFillGLInfo && s.texturedFillGLInfo.texture.iO();
        this.gP(u("uColor"), s.fillStyleImage.getSurroundingColor()).MO(h(mr), g || s.texturedFillGLInfo.sourceMissingTexture, 0).bO(s.texturedFillGLInfo.texCoordsBuffer, s.texCoordAttribDivisor, { location: c("aTextureCoord"), size: 2 }).ZO(s.fillStyleImage.fitMode);
      }
      if (s.maskTexture) {
        const g = s.maskTexture && s.maskTexture.texture.iO();
        this.MO(h(Kl), g || s.maskTexture.sourceMissingTexture, 0).bO(s.maskTexture.texCoordsBuffer, s.maskTextureCoordsAttribDivisor, { location: c("aMaskTextureCoord"), size: 2 });
      }
    }
    return s.useInstanceID !== void 0 && this.$z(t, s.useInstanceID), s.useVertexID !== void 0 && this.Nz(t, s.useVertexID), !0;
  }
  sV(t, e, i) {
    if (t) return Gs(i || e.Fi(), e.ai, t.getAngle(!0), this.rO());
  }
  eV(t, e, i) {
    if (t) return Ws(i || e.Fi(), e.ai, t.getPosition(), t.getExtent(), t.getShape(), this.rO());
  }
}
const LM = async (r, t, e, i, s, o, n, a) => {
  const l = r.fenceSync(r.SYNC_GPU_COMMANDS_COMPLETE, 0);
  return r.flush(), ((h, u, c, d) => {
    const f = d.flags !== void 0 ? d.flags : 0, p = d.retryTimeout !== void 0 ? d.retryTimeout : 10;
    return new Promise(((g, y) => {
      const m = () => {
        if (c()) return g(void 0);
        const A = h.clientWaitSync(u, f, 0);
        return A === h.WAIT_FAILED ? y(new Error(`WebGL Sync WAIT_FAILED ${h.getError()}`)) : A !== h.TIMEOUT_EXPIRED ? g(void 0) : void H.setTimeout(m, p);
      };
      H.setTimeout(m, 0);
    }));
  })(r, l, t, { retryTimeout: 10 }).then((() => {
    if (!t()) return r.deleteSync(l), r.bindBuffer(e, i), r.getBufferSubData(e, s, o, n, a), r.bindBuffer(e, null), o;
  })).catch(((h) => {
    throw h;
  }));
};
class Fs {
  TO(t) {
    if (t instanceof we || t instanceof zs) {
      const e = t.ht();
      this.rV = e.x.scaling, this.hV = -e.x.displacement, this.nV = e.y.scaling, this.oV = -e.y.displacement;
      const i = Math.fround(e.x.highPrecisionOffset), s = Math.fround(e.y.highPrecisionOffset);
      this.aV = i, this.lV = e.x.highPrecisionOffset - i, this.uV = s, this.cV = e.y.highPrecisionOffset - s;
    } else t instanceof Ti && (this.MixedScaleXY = t.ht());
    return this;
  }
  kO() {
    return [this.hV, this.oV];
  }
  wO() {
    return [this.rV, this.nV];
  }
  tV() {
    return [this.aV, this.uV];
  }
  iV() {
    return [this.lV, this.cV];
  }
}
class PM {
  constructor() {
    this.rV = 0, this.nV = 0, this.dV = 0, this.hV = 0, this.oV = 0, this.fV = 0;
  }
  AV(t) {
    const e = t.ht();
    this.rV = e.scaling, this.hV = e.displacement;
    const i = Math.fround(e.highPrecisionOffset);
    return this.aV = i, this.lV = e.highPrecisionOffset - i, this;
  }
  gV(t) {
    const e = t.ht();
    this.nV = e.scaling, this.oV = e.displacement;
    const i = Math.fround(e.highPrecisionOffset);
    return this.uV = i, this.cV = e.highPrecisionOffset - i, this;
  }
  vV(t) {
    const e = t.ht();
    this.dV = e.scaling, this.fV = e.displacement;
    const i = Math.fround(e.highPrecisionOffset);
    return this.yV = i, this.pV = e.highPrecisionOffset - i, this;
  }
  wO() {
    return [this.rV, this.nV, this.dV];
  }
  kO() {
    return [this.hV, this.oV, this.fV];
  }
  tV() {
    return [this.aV, this.uV, this.yV];
  }
  iV() {
    return [this.lV, this.cV, this.pV];
  }
  mV() {
    return { x: this.aV + this.lV, z: this.yV + this.pV, y: this.uV + this.cV };
  }
  SV(t, e, i, s, o) {
    const n = j(2 * (t - i.x) / (i.width - i.x) - 1, 2 * (e - i.y) / (i.height - i.y) - 1), a = xe.multiply(s, [n.x, n.y, o, 1]);
    return Ht(a[0], a[1], a[2]);
  }
}
class RM {
  constructor(t) {
    this.WD = t;
  }
  Ec(t, e, i, s, o, n = 0) {
    const a = this.WD, l = s === void 0;
    if (!(s = s || a.EO())) throw new pi("Could not bind a framebuffer.");
    const h = a.hO(), u = a.lO();
    a.CO(!1), a.fz((() => {
      a.gO(0, 0, i.x, i.y), t();
    }), s, e, n), l && a.zO(s), this.WD.Az(o), this.WD.gO(h.x, h.y, h.width, h.height), a.CO(u);
  }
}
class IM {
  constructor(t, e) {
    this.bV = [], this.xV = [], this.uniform = (i) => {
      const s = this.shader.CE(i);
      return this.xV.push({ name: i, optional: !1 }), s;
    }, this.uniformOptional = (i) => {
      const s = this.shader.TE(i);
      return this.xV.push({ name: i, optional: !0 }), s;
    }, this.attribute = (i) => {
      const s = this.shader.FE(i);
      return this.bV.push({ name: i, location: s }), s;
    }, this.glUtils = t, this.shader = e;
  }
  finish(t) {
    for (const e of this.bV) this.glUtils.hz(e.location), this.glUtils.rz(e.location, 0);
  }
}
class VM extends Cu {
  constructor(t, e, i, s, o) {
    super(t, e, i, s), this.MV = /* @__PURE__ */ new Map(), this._V = t, this.wV = e, this.WD = t.kV(), this.CV = o, this.wV = e;
  }
  Rc() {
    return this;
  }
  Ec(t, e) {
    if (!this.CV || t !== 0 || this.MV.size === 0) return {};
    let i = Array.from(this.MV.values()).map(((o) => o.TV.filter(((n) => n.FV)).map(((n) => n.ps)).flat().filter(((n) => n !== void 0)).filter(((n) => n.getVisible())))).flat();
    if (this.yi.Pc && (i = i.filter(((o) => !(o instanceof Nf)))), i.length === 0) return {};
    const s = this.CV;
    return this.WD.Mz.DO(i, s), {};
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  Uh() {
    return this;
  }
  Wi() {
    return 0;
  }
  Hi() {
    return 0;
  }
  Zi() {
    return 0;
  }
  Xi() {
    return 0;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
  xs(t, e) {
    const i = { TV: [] }, s = (l, h) => {
      const u = { ps: l || [], FV: h === void 0 || h };
      i.TV.push(u);
      const c = { Fs: (d) => (u.ps = d, c), Es: (d) => (u.FV = d, c), Os: () => u.FV };
      return c;
    }, o = {};
    Object.keys(e).forEach(((l) => {
      const h = e[l], u = h.shapes || [], c = h.themeEffectEnabled === void 0 || h.themeEffectEnabled, d = s(u, c);
      o[l] = d;
    }));
    const n = { CA: s, ...o };
    this.MV.set(t, i);
    const a = () => {
      this.MV.delete(t), t.removeEventListener("dispose", a);
    };
    return H.requestAnimationFrame((() => {
      t.addEventListener("dispose", a);
    })), n;
  }
}
function Mp(r, t, e, i, s, o = Math.floor(Math.sqrt(i > s ? 25 * i : 25 * s))) {
  const n = Array(o + 2), a = Math.PI;
  let l = 0, h = 0;
  const u = t * a / 180, c = (e * a / 180 - u) / o;
  for (n[l] = j(r.x, r.y), l += 1; l <= o + 1; ) n[l] = j(r.x + i * Math.cos(u + h * c), r.y + s * Math.sin(u + h * c)), l += 1, h += 1;
  return [n, o];
}
const qx = (r, t, e) => ((i, s, o) => {
  const n = [];
  let a = 0;
  const l = pe(s, o / 2);
  let h, u, c, d, f = i[i.length - 1], p = 0;
  for (let g = 0; g < i.length; g += 1) {
    h = i[g], u = g === i.length - 1 ? i[0] : i[g + 1], g > 0 && (f = i[g - 1]), j0(h, f) && (f = qt(h, Os(pe(oi(u, h), -1)))), j0(h, u) && (u = qt(h, Os(pe(oi(f, h), -1))));
    const y = wl(f, s), m = wl(h, s), A = wl(u, s), v = Os(oi(m, y)), b = Os(oi(A, m)), w = qt(v, b), k = j(-w.y, w.x), R = j(-v.y, v.x), L = 1 / nu(k, R), x = an(k), M = Os(oi(v, b)), C = Math.sign(nu(k, M)) || 1, S = ls(k, pe(l, L)), E = ls(k, pe(l, -L));
    if (x < 1 || L === 1 / 0) {
      let T = { x: 0, y: 0 }, I = { x: 0, y: 0 }, F = { x: 0, y: 0 }, D = { x: 0, y: 0 };
      const P = j(-b.y, b.x), V = Math.sign(nu(v, k)) || C, _ = ls(R, pe(l, V)), O = ls(P, pe(l, V));
      C === 1 ? (T = _, I = E, F = O, D = E) : (T = S, I = _, F = S, D = O);
      const B = 4 * ws(f, h), z = 4 * ws(h, u);
      (L > B || L > z) && (C === 1 ? (T = _, I = O, F = O, D = _) : (T = O, I = _, F = _, D = O));
      const W = qt(h, T), G = qt(h, I), Y = qt(h, F), U = qt(h, D);
      n[a] = W, a += 1, n[a] = G, a += 1, n[a] = Y, a += 1, n[a] = U, a += 1, p = 4;
    } else {
      const T = qt(h, S), I = qt(h, E);
      n[a] = T, a += 1, n[a] = I, a += 1, p = 2;
    }
    d = c, c = i[g];
  }
  return n[a] = n[0], a += 1, n[a] = n[1], a += 1, [n, p, [d, c]];
})(r, t, e)[0];
class _M extends Lb {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.SE = new Fs(), this.IV = Ie, this.PV = Ie, this.LV = ss({ arcStyleSolid: () => de(this.Ke) && this.Ke, arcStyleRadialGradient: () => li(this.Ke) && this.Ke, arcStyleLinearGradient: () => hi(this.Ke) && this.Ke }), this._V = t, this.wV = e, this.WD = t.kV();
  }
  BV(t, e) {
    let i = 0, s = Array(0), o = 0;
    if (e !== void 0) {
      const a = t.length, l = Array(a + e.length);
      let h = 0, u = 0;
      for (; h < a; ) l[u] = t[h], l[u + 1] = e[h], u += 2, h += 1;
      s = l, i = this.WD.gl.TRIANGLE_STRIP;
    } else s = t, i = this.WD.gl.TRIANGLE_FAN;
    const n = ks(s, this.ai.Nt());
    return o = s.length, [s, this.WD.pO(n), o, i];
  }
  DV(t, e, i, s) {
    let o = Array(0);
    if (e === void 0) o = t;
    else {
      let a = 0, l = 0;
      const h = t.length;
      for (a = 0, l = h, o = Array(h + e.length - 2), e.reverse(); a < h; ) o[a] = t[a], o[l] = e[a], l += 1, a += 1;
    }
    if (i === 1 || i === -1) return [ks(o, this.ai.Nt()), o.length];
    const n = qx(o, s, i);
    return [ks(n, this.ai.Nt()), n.length];
  }
  Uh() {
    const t = this.bl(), e = this.ui.T();
    if (this.xl()) {
      const i = Math.abs(this.Yt.T() - this.ju.T());
      this.SE.TO(this.ai);
      const s = this.ai.ei() || t, o = this.ai.ni(), n = this.Yu.T(), a = this.Hu.T(), [l, h] = Mp(this.Rn.T(), this.ju.T(), this.Yt.T(), this.Yu.T(), this.Hu.T(), this.Xu.T()), u = this.Wu.T(), c = u > 0 ? Mp(this.Rn.T(), this.ju.T(), this.Yt.T(), this.Yu.T() * u / 100, this.Hu.T() * u / 100, h)[0] : [this.Rn.T()], d = l.length - 1;
      if (d === 2) {
        const w = (l[d - 1].x + l[1].x) / 2, k = (l[d - 1].y + l[1].y) / 2;
        this.Zu = j(w, k);
      } else {
        const w = Math.floor(d / 2);
        this.Zu = j(l[w].x, l[w].y);
      }
      this.Ju = l[1];
      const f = l.length - 1;
      this.Qu = l[f], this.Wu.T() && (l.shift(), c.shift());
      let p = !1;
      (this.Rn.u || this.ju.u || this.Yt.u || this.Yu.u || this.Hu.u || this.Wu.u || this.Xu.u || s) && (this.PV = Ee(j(this.Xl().x - n, this.Xl().y - a), j(this.Xl().x + n, this.Xl().y + a)), p = !0, this.Rn.u = !1, this.ju.u = !1, this.Yt.u = !1, this.Yu.u = !1, this.Hu.u = !1, this.Wu.u = !1, this.Xu.u = !1);
      const g = this.ml();
      (p || g) && this.Ke !== Lt && (this.Wu.T() ? (this.EV && this.WD.LO(this.EV), [this.RV, this.EV, this.OV, this.zV] = this.BV(l, c)) : (this.EV && this.WD.LO(this.EV), [this.RV, this.EV, this.OV, this.zV] = this.BV(l, void 0)), li(this.Ke) ? this.VV = Ws(this.PV, this.ai, this.Ke.getPosition(), this.Ke.getExtent(), this.Ke.getShape(), this.WD.rO()) : hi(this.Ke) ? this.NV = Gs(this.PV, this.ai, this.Ke.getAngle(!0), this.WD.rO()) : (this.VV = void 0, this.NV = void 0));
      const y = this.LV.arcStyleSolid(g), m = this.LV.arcStyleLinearGradient(g), A = this.LV.arcStyleRadialGradient(g), v = y || m || A;
      g && (this.GV = v ? this.WD.SR(K["2D"], K.Color({ dataType: li(this.Ke) || hi(this.Ke) ? ["gradient", this.Ke] : "uniform" }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0, this.Ml(this.Ke));
      const b = this.qe;
      if (Oi(b) && (p || this.kl(b.getThickness()) || s)) {
        this.Wu.T() ? i === 360 ? (l.pop(), c.pop(), [this.$V, this.UV] = this.DV(l, void 0, b.getThickness(), o), this.jV && this.$V ? this.WD.tz(this.jV, this.$V, !0) : !this.jV && this.$V ? this.jV = this.WD.pO(this.$V, !0) : this.jV && !this.$V && (this.WD.LO(this.jV), this.jV = void 0), [this.YV, this.HV] = this.DV(c, void 0, b.getThickness(), o), this.WV && this.YV ? this.WD.tz(this.WV, this.YV, !0) : !this.WV && this.YV ? this.WV = this.WD.pO(this.YV, !0) : this.WV && !this.YV && (this.WD.LO(this.WV), this.WV = void 0)) : ([this.$V, this.UV] = this.DV(l, c, b.getThickness(), o), this.jV && this.$V ? this.WD.tz(this.jV, this.$V, !0) : !this.jV && this.$V ? this.jV = this.WD.pO(this.$V, !0) : this.jV && !this.$V && (this.WD.LO(this.jV), this.jV = void 0), this.YV && (this.WV && this.WD.LO(this.WV), this.WV = void 0, this.HV = 0)) : (i === 360 && (l.shift(), l.pop()), [this.$V, this.UV] = this.DV(l, void 0, b.getThickness(), o), this.jV && this.$V ? this.WD.tz(this.jV, this.$V, !0) : !this.jV && this.$V ? this.jV = this.WD.pO(this.$V, !0) : this.jV && !this.$V && (this.WD.LO(this.jV), this.jV = void 0));
        const w = b.getFillStyle();
        li(w) ? this.XV = Ws(this.PV, this.ai, w.getPosition(), w.getExtent(), w.getShape(), this.WD.rO()) : hi(w) ? this.ZV = Gs(this.PV, this.ai, w.getAngle(!0), this.WD.rO()) : (this.XV = void 0, this.ZV = void 0), this.JV = w === Lt ? void 0 : this.WD.SR(K["2D"], K.Color({ dataType: li(w) || hi(w) ? ["gradient", w] : "uniform" }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })), this.Cl(b);
      }
      if (p) {
        let w = 1, k = 1;
        Oi(b) && (w = b.getThickness() * o.x, k = b.getThickness() * o.y), this.IV = Ee(j(this.PV.min.x - w, this.PV.min.y - k), j(this.PV.max.x + w, this.PV.max.y + k));
      }
      this.QV = e && v ? this.QV || this.WD.SR(K["2D"], K.MousePicking(), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0, this.KV = e && this.qe !== Et ? this.KV || this.WD.SR(K["2D"], K.MousePicking(), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0;
    }
    return this;
  }
  Ec(t, e) {
    if (this.xl()) {
      const i = t === 1 ? this.QV : this.GV, s = this.Ke, o = this.EV;
      i && o && this.WD.pd(i).SO(i, ((a, l, h, u) => {
        if (this.WD.xO(a("uScale"), this.SE.wO()).xO(a("uDisp"), this.SE.kO()).xO(u("uScaleStart_highpart"), this.SE.tV()).xO(u("uScaleStart_lowpart"), this.SE.iV()).Ez(h, o, this.ai.Nt(), void 0)._O(a("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(a("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(a("uRenderEffectMask"), t === 2 ? 1 : 0), t === 1) this.WD.XO(a("uFirstId"), e).$z(h, 1);
        else if (de(s)) this.WD.gP(a("uColor"), s.getColor());
        else if (li(s)) {
          if (!this.VV) return !1;
          this.WD.Pz(h, this.VV, s);
        } else if (hi(s)) {
          if (!this.NV) return !1;
          this.WD.Lz(h, this.NV, s);
        }
        return this.WD.dC(this.zV, this.OV), !0;
      }));
      const n = this.qe;
      Oi(n) && (this.jV !== void 0 && this.qV(t, this.jV, this.UV, n, e), this.WV !== void 0 && this.qV(t, this.WV, this.HV, n, e));
    }
    return { idCount: 1 };
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  qV(t, e, i, s, o) {
    const n = t === 1 ? this.KV : this.JV, a = s.getFillStyle();
    n && this.WD.pd(n).SO(n, ((l, h, u, c) => {
      if (this.WD.xO(l("uScale"), this.SE.wO()).xO(l("uDisp"), this.SE.kO()).Ez(u, e, this.ai.Nt(), void 0)._O(l("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(l("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(l("uRenderEffectMask"), t === 2 ? 1 : 0), t === 1) this.WD.XO(l("uFirstId"), o).$z(u, 1);
      else if (de(a)) this.WD.gP(l("uColor"), a.getColor());
      else if (li(a)) {
        if (!this.XV) return !1;
        this.WD.Pz(u, this.XV, a);
      } else if (hi(a)) {
        if (!this.ZV) return !1;
        this.WD.Lz(u, this.ZV, a);
      }
      const d = s.getThickness(), f = d === -1 || d === 1;
      return this.WD.dC(f ? this.WD.gl.LINE_LOOP : this.WD.gl.TRIANGLE_STRIP, i), !0;
    }));
  }
  Rc() {
    return this.tN && (this.WD.LO(this.tN), this.tN = void 0), this.iN && (this.WD.LO(this.iN), this.iN = void 0), this.EV && (this.WD.LO(this.EV), this.EV = void 0), this.jV && (this.WD.LO(this.jV), this.jV = void 0), this.WV && (this.WD.LO(this.WV), this.WV = void 0), this.GV = void 0, this.JV = void 0, this.QV = void 0, this.KV = void 0, this;
  }
  Wi() {
    return this.PV.max.x;
  }
  Hi() {
    return this.PV.min.x;
  }
  Zi() {
    return this.PV.max.y;
  }
  Xi() {
    return this.PV.min.y;
  }
  mu() {
    return qi(this.qe);
  }
  Su() {
    return qi(this.qe);
  }
}
class OM {
  constructor() {
    this.first = 0, this.second = 1, this.third = 2, this.fourth = 3, this.fifth = 4, this.sixth = 5;
  }
  sN(t) {
    return this.first = t, this.second = t + 1, this.third = t + 2, this.fourth = t + 3, this.fifth = t + 4, this.sixth = t + 5, t += 6, this;
  }
  eN() {
    return this.first = this.second, this.second = this.third, this.third = this.fourth, this.fourth = this.fifth, this.fifth = this.sixth, this.sixth += 1, this;
  }
  rN() {
    return this.first = this.third, this.second = this.fourth, this.third = this.fifth, this.fourth = this.sixth, this.fifth = this.fourth + 1, this.sixth = this.fifth + 1, this;
  }
  hN(t) {
    const e = t.buffer;
    let { position: i } = t;
    return e[i] = this.first, e[i + 1] = this.second, e[i + 2] = this.third, i += 3, t.position = i, t.next && this.eN(), this;
  }
  nN(t) {
    const e = t.buffer;
    let { position: i } = t;
    return e[i] = this.first, e[i + 1] = this.third, e[i + 2] = this.second, e[i + 3] = this.third, e[i + 4] = this.fourth, e[i + 5] = this.second, i += 6, t.position = i, t.next && this.rN(), this;
  }
  oN(t, e) {
    e.next = !0, 6 * t >= e.buffer.length && (e.buffer = Array(6 * t));
    for (let i = 0; i < t; i += 1) this.nN(e);
    return this;
  }
  aN() {
    return [this.first, this.second, this.third, this.fourth, this.fifth, this.sixth];
  }
}
const je = ((r = 0) => new OM().sN(r))(), Cp = (r, t, e, i, s, o, n, a, l, h) => (a === void 0 && n === void 0 || je.eN(), o.push(r, t), s.push(je.first, je.second, je.third), a = void 0, n = void 0, s.push(je.third, je.fourth, je.second), l = je.third, je.rN(), h && o.push(e, i), [n, a, l]), wp = (r, t, e, i, s, o, n, a, l, h, u) => {
  l === void 0 && a === void 0 || je.eN(), n.push(r, t), s.push(je.first, je.second, je.third);
  const c = Um(r, e, t, i);
  return l = void 0, c !== void 0 && (l === void 0 && (l = c), n.push(l), o.push(je.third, je.fourth, je.fifth), h = je.fourth), je.rN(), u && n.push(e, i), [a, l, h];
}, Tp = (r, t, e, i, s, o, n, a, l, h) => (n === void 0 && o === void 0 || je.eN(), s.push(r, t), i.push(je.first, je.second, je.third), o = e, n = void 0, a = je.third, h ? s.push(e) : l = !0, [o, n, a, l]), kp = (r, t, e, i, s, o, n, a, l, h, u) => (o.length !== 0 ? (a === void 0 && n === void 0 || je.eN(), je.eN()) : l > 0 && (je.eN(), u > 0 && (u -= 1)), o.push(r), s.push(je.first, je.second, je.third), l = je.second, n = r, a = void 0, h && o.push(e, i), [n, a, l, u]), Dp = (r, t = 0) => {
  je.sN(t);
  const [e, i] = r, s = e.length, o = [], n = [], a = [];
  let l, h, u = t, c = 0, d = e[c], f = i[c], p = e[c], g = i[c], y = !1, m = u > 0 ? p.y !== g.y ? 2 : 1 : 0;
  if (s > 1) for (; c < s - 1; ) {
    p = d, g = f, c += 1, d = e[c], f = i[c];
    const A = c === s - 1;
    p.y > g.y ? d.y > f.y ? [l, h, u] = Cp(p, g, d, f, o, a, l, h, u, A) : d.y < f.y ? [l, h, u] = wp(p, g, d, f, o, n, a, l, h, u, A) : [l, h, u, y] = Tp(p, g, d, o, a, l, h, u, y, A) : p.y < g.y ? d.y < f.y ? [l, h, u] = Cp(p, g, d, f, n, a, l, h, u, A) : d.y > f.y ? [l, h, u] = wp(p, g, d, f, n, o, a, l, h, u, A) : [l, h, u, y] = Tp(p, g, d, n, a, l, h, u, y, A) : d.y === f.y ? (l = p, y && (a.push(p), y = !1, je.eN()), a.length === 0 && u > 0 && m > 0 && (m -= 1)) : d.y > f.y ? [l, h, u, m] = kp(p, 0, d, f, o, a, l, h, u, A, m) : [l, h, u, m] = kp(p, 0, d, f, n, a, l, h, u, A, m);
  }
  return [a, new Uint16Array(o), new Uint16Array(n), u, m];
};
class NM extends Fb {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.SE = new Fs(), this.lN = 0, this.Au = Array(), this.uN = 0, this.cN = new Uint16Array(0), this.dN = new Uint16Array(0), this.LV = ss({ hightFillSolid: () => de(this.Ke) && this.Ke, hightFillRadialGradient: () => li(this.Ke) && this.Ke, hightFillLinearGradient: () => hi(this.Ke) && this.Ke, hightFillPaletted: () => Ve(this.Ke) && this.Ke, lowFillSolid: () => de(this.Cu) && this.Cu, lowFillRadialGradient: () => li(this.Cu) && this.Cu, lowFillLinearGradient: () => hi(this.Cu) && this.Cu, lowFillPaletted: () => Ve(this.Cu) && this.Cu }), this._V = t, this.wV = e, this.WD = t.kV();
  }
  Uh() {
    const t = this.bl(), e = this.ui.T(), i = this.Tu;
    if (this.xl()) {
      this.SE.TO(this.ai);
      const s = i;
      if (s && (this.lN = 0, this.cN = new Uint16Array(0), this.dN = new Uint16Array(0), this.Au.length = 0, this.uN = 0, this.Mu > 1)) {
        const [v, b, w, k] = Dp([this.bu, this.xu]);
        this.lN = k, this.cN = b, this.dN = w, this.Au = v, this.uN = v.length;
      }
      if (this.ku && this.wu[0].length > 1) {
        const [v, b] = this.wu, w = v.length, [k, R, L, x, M] = Dp([v, b], this.lN);
        this.lN = x;
        const C = k.length;
        for (let S = M; S < C; S += 1) this.Au[this.uN] = k[S], this.uN += 1;
        this.cN = tg(this.cN, R), this.dN = tg(this.dN, L);
        for (let S = M > 0 || this.Mu > 0 ? 1 : M; S < w; S += 1) this.bu[this.Mu] = v[S], this.xu[this.Mu] = b[S], this.Mu += 1;
        this._u = !0, this.ku = !1, this.wu = [];
      }
      const o = this.Ke, n = this.Sl !== o, a = this.LV.hightFillSolid(n), l = this.LV.hightFillRadialGradient(n), h = this.LV.hightFillLinearGradient(n), u = this.LV.hightFillPaletted(n), c = a || l || h || u && ["x", "y"].includes(u.getLookUpProperty()) && u, d = this.Cu, f = this.$u !== d, p = this.LV.lowFillSolid(f), g = this.LV.lowFillRadialGradient(f), y = this.LV.lowFillLinearGradient(f), m = this.LV.lowFillPaletted(f), A = p || g || y || m && ["x", "y"].includes(m.getLookUpProperty()) && m;
      if ((n || t) && (this.fN = c ? this.WD.SR(K["2D"], K.Color({ dataType: h ? ["gradient", h] : l ? ["gradient", l] : u ? ["lookup", u.getLookUpProperty(), u.lut] : "uniform" }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0), l ? this.VV = Ws(this.Ai || this.gu, this.ai, l.getPosition(), l.getExtent(), l.getShape(), this.WD.rO()) : h ? this.NV = Gs(this.Ai || this.gu, this.ai, h.getAngle(!0), this.WD.rO()) : (this.VV = void 0, this.NV = void 0), (f || t) && (this.AN = A ? this.WD.SR(K["2D"], K.Color({ dataType: y ? ["gradient", y] : g ? ["gradient", g] : m ? ["lookup", m.getLookUpProperty(), m.lut] : "uniform" }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0), g ? this.gN = Ws(this.Ai || this.gu, this.ai, g.getPosition(), g.getExtent(), g.getShape(), this.WD.rO()) : y ? this.vN = Gs(this.Ai || this.gu, this.ai, y.getAngle(!0), this.WD.rO()) : (this.gN = void 0, this.vN = void 0), (t || this._u || s) && this._u || s) {
        const v = this.Au, b = ks(v, this.ai.Nt());
        this.yN = this.WD.pO(b, !1, this.yN), c && (this.pN = this.WD.iz(this.cN, this.pN), this.mN = this.cN.length), A && (this.SN = this.WD.iz(this.dN, this.SN), this.bN = this.dN.length), this._u = !1;
      }
      this.QV = e && (A || c) ? this.QV || this.WD.SR(K["2D"], K.MousePicking(), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0, this.Ml(this.Ke), this.Uu(this.Cu), this.Tu = !1;
    }
    return this;
  }
  Ec(t, e) {
    const i = this.Ke, s = this.Cu, o = t === 1 ? this.QV : this.AN;
    if (o && this.yN && this.SN) {
      const a = this.yN, l = this.SN;
      this.WD.pd(o).SO(o, ((h, u, c, d) => {
        if (this.WD.Ez(c, a, this.ai.Nt(), void 0).az(l)._O(h("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(h("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(h("uRenderEffectMask"), t === 2 ? 1 : 0), this.ai instanceof we || this.ai instanceof zs ? this.WD.xO(h("uScale"), this.SE.wO()).xO(h("uDisp"), this.SE.kO()).xO(d("uScaleStart_highpart"), this.SE.tV()).xO(d("uScaleStart_lowpart"), this.SE.iV()) : this.ai instanceof Ti && this.WD.xO(d("uScaleStart"), this.SE.MixedScaleXY.uScaleStart).xO(d("uScaleStartLog"), this.SE.MixedScaleXY.uScaleStartLog).xO(d("uScaleInterval"), this.SE.MixedScaleXY.uScaleInterval).xO(d("uScaleIntervalLog"), this.SE.MixedScaleXY.uScaleIntervalLog).xO(h("uViewportStart"), this.SE.MixedScaleXY.uViewportStart).xO(h("uViewportSize"), this.SE.MixedScaleXY.uViewportSize), t === 1) this.WD.XO(h("uFirstId"), e).$z(c, 1);
        else if (de(s)) this.WD.gP(h("uColor"), s.getColor());
        else if (li(s)) {
          if (!this.gN) return !1;
          this.WD.Pz(c, this.gN, s);
        } else if (hi(s)) {
          if (!this.vN) return !1;
          this.WD.Lz(c, this.vN, s);
        } else if (Ve(s)) {
          const f = er(s, this, void 0);
          if (!f && s.lut.percentageValues) return !1;
          this.WD.Jz(c, s.lut, f);
        }
        return this.WD.uz(this.bN), !0;
      }));
    }
    const n = t === 1 ? this.QV : this.fN;
    if (n && this.yN && this.pN) {
      const a = this.yN, l = this.pN;
      this.WD.pd(n).SO(n, ((h, u, c, d) => {
        if (this.WD.Ez(c, a, this.ai.Nt(), void 0).az(l)._O(h("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(h("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(h("uRenderEffectMask"), t === 2 ? 1 : 0), this.ai instanceof we || this.ai instanceof zs ? this.WD.xO(h("uScale"), this.SE.wO()).xO(h("uDisp"), this.SE.kO()).xO(d("uScaleStart_highpart"), this.SE.tV()).xO(d("uScaleStart_lowpart"), this.SE.iV()) : this.ai instanceof Ti && this.WD.xO(d("uScaleStart"), this.SE.MixedScaleXY.uScaleStart).xO(d("uScaleStartLog"), this.SE.MixedScaleXY.uScaleStartLog).xO(d("uScaleInterval"), this.SE.MixedScaleXY.uScaleInterval).xO(d("uScaleIntervalLog"), this.SE.MixedScaleXY.uScaleIntervalLog).xO(h("uViewportStart"), this.SE.MixedScaleXY.uViewportStart).xO(h("uViewportSize"), this.SE.MixedScaleXY.uViewportSize), t === 1) this.WD.XO(h("uFirstId"), e).$z(c, 1);
        else if (de(i)) this.WD.gP(h("uColor"), i.getColor());
        else if (li(i)) {
          if (!this.VV) return !1;
          this.WD.Pz(c, this.VV, i);
        } else if (hi(i)) {
          if (!this.NV) return !1;
          this.WD.Lz(c, this.NV, i);
        } else if (Ve(i)) {
          const f = er(i, this, void 0);
          if (!f && i.lut.percentageValues) return !1;
          this.WD.Jz(c, i.lut, f);
        }
        return this.WD.uz(this.mN), !0;
      }));
    }
    return { idCount: 1 };
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  Wi() {
    return this.gu.max.x;
  }
  Hi() {
    return this.gu.min.x;
  }
  Zi() {
    return this.gu.max.y;
  }
  Xi() {
    return this.gu.min.y;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
  Db(t) {
    this.Ou() > 0 && this.Uh();
    const [e, i] = this.Lu(), s = e.length > 2 && e[1].x < e[0].x, o = Tm(e, t, Ms.NearestX, this.Fu, this.Iu, this.ai, this.yi.ai, this.gu, "x", s);
    if (o === void 0) return;
    const n = [e[o], i[o]];
    return Number.isNaN(n[0].y) || Number.isNaN(n[1].y) ? void 0 : n;
  }
  eM(t) {
    this.Ou() > 0 && this.Uh();
    const [e, i] = this.Lu(), s = e.length;
    if (s === 0) return;
    const o = this.Fu ? 1 : 0, n = s - (this.Iu ? 2 : 1), a = e.length > 2 && e[1].x < e[0].x, l = km(e, xt(t, this.yi.ai, this.ai), "x", a, o, n);
    if (!l) return;
    const h = [Ln(e[l.a], e[l.b], l.lerpAmount), Ln(i[l.a], i[l.b], l.lerpAmount)];
    return Number.isNaN(h[0].y) || Number.isNaN(h[1].y) ? void 0 : h;
  }
  dispose() {
    return super.dispose(), this.SN && (this.WD.LO(this.SN), this.SN = void 0), this.pN && (this.WD.LO(this.pN), this.pN = void 0), this.yN && (this.WD.LO(this.yN), this.yN = void 0), this;
  }
  Rc() {
    return this.dispose(), this;
  }
}
class BM extends Ja {
  constructor(t, e) {
    super(t), this.xN = e;
    const { vertices: i, indices: s, indicesCount: o, drawMode: n } = this.MN();
    this._N = t.pO(i), this.wN = t.iz(s), this.kN = o, this.CN = n;
  }
  pd(t, e) {
    return this.WD.bO(this._N, 0, { location: t.attribute("aSegmentPosition"), size: 2 }, { location: t.attribute("aSegmentSide"), size: 1 }, { location: e ? t.attribute("aSegmentInside") : void 0, size: 1 }), this.WD.az(this.wN), this;
  }
  dC(t, e) {
    return this.WD.dz(e !== void 0 ? e : this.CN, this.kN, 0, t, this.WD.gl.UNSIGNED_BYTE), this;
  }
  MN() {
    const t = [];
    [1, 0].forEach(((s) => {
      const o = s === 1 ? 0.5 * Math.PI : 1.5 * Math.PI;
      for (let n = 0; n <= this.xN; n += 1) {
        const a = o - n * Math.PI / this.xN;
        t.push(0.5 * Math.cos(a), 0.5 * Math.sin(a), s, 0);
      }
    })), t.push(0, 0, 1, 1), t.push(0, 0, 0, 1);
    const e = t.length / 4, i = [];
    for (let s = 0; s < this.xN; s += 1) i.push(s, s + 1, e - 2), i.push(s + e / 2 - 1, s + e / 2, e - 1);
    return i.push(0, e - 2, e - 1), i.push(e - 1, e - 2, e / 2 - 1), i.push(0, e - 3, e - 1), i.push(e / 2 - 2, e - 2, e / 2 - 1), { vertices: new Float32Array(t), indices: new Uint8Array(i), indicesCount: i.length, verticesCount: e, drawMode: this.WD.gl.TRIANGLES };
  }
  GR() {
    this.WD.LO(this._N), this.WD.LO(this.wN);
  }
}
const Bo = (r, t, e = !0) => ((i, s) => {
  let o = i.VO.RR.get(s);
  return o || (o = new BM(i, s), i.VO.RR.set(s, o), o);
})(r, e ? t >= 50 ? 8 : t >= 20 ? 6 : t >= 7 ? 4 : t >= 4 ? 3 : t === 1 ? 1 : 2 : 1), Ts = { TN: (r, t, e, i, s, o, n = 1) => {
  const { attribute: a } = i, l = t.gl;
  if (l.bindBuffer(l.ARRAY_BUFFER, e), r) {
    const h = a("aLocationA_highpart"), u = a("aLocationA_lowpart"), c = a("aLocationB_highpart"), d = a("aLocationB_lowpart");
    l.vertexAttribPointer(h, 2, l.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, o * Float32Array.BYTES_PER_ELEMENT), t.rz(h, n), l.enableVertexAttribArray(h), l.vertexAttribPointer(u, 2, l.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, (o + 2) * Float32Array.BYTES_PER_ELEMENT), t.rz(u, n), l.enableVertexAttribArray(u), l.vertexAttribPointer(c, 2, l.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, (o + s) * Float32Array.BYTES_PER_ELEMENT), t.rz(c, n), l.enableVertexAttribArray(c), l.vertexAttribPointer(d, 2, l.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, (o + s + 2) * Float32Array.BYTES_PER_ELEMENT), t.rz(d, n), l.enableVertexAttribArray(d);
  } else {
    const h = a("aLocationA"), u = a("aLocationB");
    l.vertexAttribPointer(h, 2, l.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, o * Float32Array.BYTES_PER_ELEMENT), t.rz(h, n), l.enableVertexAttribArray(h), l.vertexAttribPointer(u, 2, l.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, (o + s) * Float32Array.BYTES_PER_ELEMENT), t.rz(u, n), l.enableVertexAttribArray(u);
  }
}, FN: (r, t, e, i, s, o, n, a) => {
  const l = r.gl;
  l.bindBuffer(l.ARRAY_BUFFER, e), l.vertexAttribPointer(i, o, l.FLOAT, !1, n * Float32Array.BYTES_PER_ELEMENT, a * Float32Array.BYTES_PER_ELEMENT), r.rz(i, 1), l.enableVertexAttribArray(i), l.vertexAttribPointer(s, o, l.FLOAT, !1, n * Float32Array.BYTES_PER_ELEMENT, (a + n) * Float32Array.BYTES_PER_ELEMENT), r.rz(s, 1), l.enableVertexAttribArray(s);
}, IN: (r, t, e, i, s, o) => {
  const { attribute: n } = i, a = t.gl;
  if (a.bindBuffer(a.ARRAY_BUFFER, e), r) {
    const l = n("aLocationA_highpart"), h = n("aLocationA_lowpart"), u = n("aLocationB_highpart"), c = n("aLocationB_lowpart");
    a.vertexAttribPointer(l, 2, a.FLOAT, !1, 2 * s * Float32Array.BYTES_PER_ELEMENT, o * Float32Array.BYTES_PER_ELEMENT), t.rz(l, 1), a.enableVertexAttribArray(l), a.vertexAttribPointer(h, 2, a.FLOAT, !1, 2 * s * Float32Array.BYTES_PER_ELEMENT, (o + 2) * Float32Array.BYTES_PER_ELEMENT), t.rz(h, 1), a.enableVertexAttribArray(h), a.vertexAttribPointer(u, 2, a.FLOAT, !1, 2 * s * Float32Array.BYTES_PER_ELEMENT, (o + s) * Float32Array.BYTES_PER_ELEMENT), t.rz(u, 1), a.enableVertexAttribArray(u), a.vertexAttribPointer(c, 2, a.FLOAT, !1, 2 * s * Float32Array.BYTES_PER_ELEMENT, (o + s + 2) * Float32Array.BYTES_PER_ELEMENT), t.rz(c, 1), a.enableVertexAttribArray(c);
  } else {
    const l = n("aLocationA"), h = n("aLocationB");
    a.vertexAttribPointer(l, 2, a.FLOAT, !1, 2 * s * Float32Array.BYTES_PER_ELEMENT, o * Float32Array.BYTES_PER_ELEMENT), t.rz(l, 1), a.enableVertexAttribArray(l), a.vertexAttribPointer(h, 2, a.FLOAT, !1, 2 * s * Float32Array.BYTES_PER_ELEMENT, (o + s) * Float32Array.BYTES_PER_ELEMENT), t.rz(h, 1), a.enableVertexAttribArray(h);
  }
}, PN: (r, t, e, i, s, o, n, a, l, h) => {
  const u = r.gl;
  u.bindBuffer(u.ARRAY_BUFFER, e), u.vertexAttribPointer(i, o, l, a, 2 * o * h, n * h), r.rz(i, 1), u.enableVertexAttribArray(i), u.vertexAttribPointer(s, o, l, a, 2 * o * h, (n + o) * h), r.rz(s, 1), u.enableVertexAttribArray(s);
}, Ec: (r, t, e, i, s, o, n) => {
  const a = r.kV(), { uniform: l, uniformOptional: h } = e, u = 1 / r.Ga.Ua, c = (s ? Math.max(o, u) : Math.max(o, 0)) + 1;
  a._O(l("uThicknessPixels"), c)._O(h("uAALimit"), 1 - (c - 1) / c).xO(l("uRatioPxClip"), [2 / r.Ft().x, 2 / r.Ft().y]), t.pd(e, i).dC(n);
} }, oa = { TN: (r, t, e, i, s, o) => {
  const { attribute: n } = i, a = t.gl;
  if (a.bindBuffer(a.ARRAY_BUFFER, e), r) {
    const l = n("aPos_highpart");
    a.vertexAttribPointer(l, 2, a.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, o * Float32Array.BYTES_PER_ELEMENT), a.enableVertexAttribArray(l);
    const h = n("aPos_lowpart");
    a.vertexAttribPointer(h, 2, a.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, (o + 2) * Float32Array.BYTES_PER_ELEMENT), a.enableVertexAttribArray(h);
  } else {
    const l = n("aPos");
    a.vertexAttribPointer(l, 2, a.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, o * Float32Array.BYTES_PER_ELEMENT), a.enableVertexAttribArray(l);
  }
}, FN: (r, t, e, i, s, o) => {
  const n = r.gl;
  n.bindBuffer(n.ARRAY_BUFFER, e), n.vertexAttribPointer(i, s, n.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, o * Float32Array.BYTES_PER_ELEMENT), n.enableVertexAttribArray(i);
}, IN: (r, t, e, i, s, o) => {
  const { attribute: n } = i, a = t.gl;
  if (a.bindBuffer(a.ARRAY_BUFFER, e), r) {
    const l = n("aPos_highpart"), h = n("aPos_lowpart");
    a.vertexAttribPointer(l, 2, a.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, o * Float32Array.BYTES_PER_ELEMENT), a.enableVertexAttribArray(l), a.vertexAttribPointer(h, 2, a.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, (o + 2) * Float32Array.BYTES_PER_ELEMENT), a.enableVertexAttribArray(h);
  } else {
    const l = n("aPos");
    a.vertexAttribPointer(l, 2, a.FLOAT, !1, s * Float32Array.BYTES_PER_ELEMENT, o * Float32Array.BYTES_PER_ELEMENT), a.enableVertexAttribArray(l);
  }
}, LN: (r, t) => {
  const e = r.kV();
  e.dC(e.gl.LINE_STRIP, t, 0);
}, DN: (r, t) => {
  const e = r.kV();
  e.dC(e.gl.LINES, 2 * t, 0);
} }, Gn = (r, t, e, i, s, o, n, a, l, h, u = n, c = 0) => {
  const d = r.gl;
  if (e) {
    const f = t.attribute(`${s}A_highpart${o}`), p = t.attribute(`${s}A_lowpart${o}`), g = t.attribute(`${s}B_highpart${o}`), y = t.attribute(`${s}B_lowpart${o}`);
    d.bindBuffer(d.ARRAY_BUFFER, i), d.vertexAttribPointer(f, n, l, a, 2 * u * h, 2 * c * h), d.vertexAttribPointer(p, n, l, a, 2 * u * h, (u + 2 * c) * h), r.rz(f, 1), r.rz(p, 1), d.enableVertexAttribArray(f), d.enableVertexAttribArray(p), d.vertexAttribPointer(g, n, l, a, 2 * u * h, (2 * u + 2 * c) * h), d.vertexAttribPointer(y, n, l, a, 2 * u * h, (3 * u + 2 * c) * h), r.rz(g, 1), r.rz(y, 1), d.enableVertexAttribArray(g), d.enableVertexAttribArray(y), d.bindBuffer(d.ARRAY_BUFFER, null);
  } else {
    const f = t.attribute(`${s}A${o}`), p = t.attribute(`${s}B${o}`);
    d.bindBuffer(d.ARRAY_BUFFER, i), d.vertexAttribPointer(f, n, l, a, u * h, (0 + c) * h), d.vertexAttribPointer(p, n, l, a, u * h, (u + c) * h), r.rz(f, 1), r.rz(p, 1), d.enableVertexAttribArray(f), d.enableVertexAttribArray(p), d.bindBuffer(d.ARRAY_BUFFER, null);
  }
};
class zM extends Ob {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.SE = new Fs(), this.gu = Ie, this.LV = ss({ lineStyleSolid: () => Oi(this.vc) && this.vc, lineStyleDashed: () => Oo(this.vc) && this.vc, strokeFillSolid: () => {
      const n = this.vc.getFillStyle();
      return de(n) && n;
    }, strokeFillLinearGradient: () => {
      const n = this.vc.getFillStyle();
      return hi(n) && n;
    }, strokeFillRadialGradient: () => {
      const n = this.vc.getFillStyle();
      return li(n) && n;
    }, strokeFillPaletted: () => {
      const n = this.vc.getFillStyle();
      return Ve(n) && n;
    } }), this._V = t, this.wV = e, this.WD = t.kV(), this.EN = this.WD.pz;
  }
  Uh() {
    const t = this._l(), e = this.vc, i = this.LV.lineStyleSolid(t), s = this.LV.lineStyleDashed(t), o = i || s, n = this.LV.strokeFillSolid(t), a = this.LV.strokeFillLinearGradient(t), l = this.LV.strokeFillRadialGradient(t), h = this.LV.strokeFillPaletted(t), u = n || a || l || h && ["x", "y"].includes(h.getLookUpProperty()) && h, c = this.Ht(), d = this.jt(), f = this.ui.T(), p = this.ui.u, g = e.Yi();
    if (s && this.ai instanceof Ti) return H.console.error("LightningChart JS DashedLine is not supported on logarithmic axis"), this;
    if (this.SE.TO(this.ai), this.xc && (this.RN = this.WD.pO(ks([c, d], this.ai.Nt()), !1, this.RN), this.gu = Ee(j(c.x, c.y), j(d.x, d.y))), t || p) {
      const y = this.xl() && o && u && g > 0, m = a ? ["gradient", a] : l ? ["gradient", l] : h ? ["lookup", h.getLookUpProperty(), h.lut] : "uniform";
      this.ON = y ? { type: "triangulated", shader: this.WD.SR(K["2D"], K.Color({ dataType: m }), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), this.EN ? K.AliasedEdge : void 0, s && K.StippleTextureInstanced), mousePickingShader: f ? this.WD.SR(K["2D"], K.MousePicking(), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), s && K.StippleTextureInstanced) : void 0, geometry: Bo(this.WD, g), thickness: g, lineStyleSolid: i, lineStyleDashed: s, fillStyleSolid: n, fillStyleLinearGradient: a, fillStyleRadialGradient: l, fillStylePaletted: h } : void 0;
    }
    if (l ? this.XV = Ws(Ul(this.gu, { x: this.mu(), y: this.Su() }, this.ai), this.ai, l.getPosition(), l.getExtent(), l.getShape(), this.WD.rO()) : a ? this.ZV = Gs(Ul(this.gu, { x: this.mu(), y: this.Su() }, this.ai), this.ai, a.getAngle(!0), this.WD.rO()) : (this.XV = void 0, this.ZV = void 0), s) {
      if (t || this.xc) {
        const y = [0, 0, Math.abs(d.x - c.x), Math.abs(d.y - c.y)];
        this.zN = this.WD.pO(y, !1, this.zN);
      }
      this.VN = this.WD.Yz(s.getPattern());
    } else this.zN && (this.WD.LO(this.zN), this.zN = void 0), this.VN = void 0;
    return this.bc(e), this.xc = !1, this.ui.u = !1, this;
  }
  Ec(t, e) {
    var i, s;
    const o = this.RN;
    if (!o) return {};
    const n = this.ON;
    if (!n) return {};
    const { fillStyleSolid: a, fillStyleLinearGradient: l, fillStyleRadialGradient: h, fillStylePaletted: u, lineStyleDashed: c, thickness: d } = n, f = t === 1 ? (i = this.ON) === null || i === void 0 ? void 0 : i.mousePickingShader : (s = this.ON) === null || s === void 0 ? void 0 : s.shader;
    return f ? (this.WD.pd(f).SO(f, ((p, g, y, m) => {
      if (this.WD._O(p("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(p("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(p("uRenderEffectMask"), t === 2 ? 1 : 0), this.ai instanceof we || this.ai instanceof zs ? this.WD.xO(p("uScale"), this.SE.wO()).xO(p("uDisp"), this.SE.kO()).xO(m("uScaleStart_highpart"), this.SE.tV()).xO(m("uScaleStart_lowpart"), this.SE.iV()) : this.ai instanceof Ti && this.WD.xO(m("uScaleStart"), this.SE.MixedScaleXY.uScaleStart).xO(m("uScaleStartLog"), this.SE.MixedScaleXY.uScaleStartLog).xO(m("uScaleInterval"), this.SE.MixedScaleXY.uScaleInterval).xO(m("uScaleIntervalLog"), this.SE.MixedScaleXY.uScaleIntervalLog).xO(p("uViewportStart"), this.SE.MixedScaleXY.uViewportStart).xO(p("uViewportSize"), this.SE.MixedScaleXY.uViewportSize), t === 1) this.WD.XO(p("uFirstId"), e).$z(y, 1);
      else if (a) this.WD.gP(p("uColor"), a.getColor());
      else if (h) {
        if (!this.XV) return !1;
        this.WD.Pz(y, this.XV, h);
      } else if (l) {
        if (!this.ZV) return !1;
        this.WD.Lz(y, this.ZV, l);
      } else if (u) {
        const A = er(u, this, void 0);
        if (!A && u.lut.percentageValues) return !1;
        this.WD.Jz(y, u.lut, A);
      }
      if (c) {
        if (!this.zN || !this.VN) return !1;
        Ts.FN(this.WD, y, this.zN, g("aLengthSoFarA"), g("aLengthSoFarB"), 2, 2, 0), this.WD.xO(p("uStippleCount"), [this.yi.Ft().x / this.VN.Zz, this.yi.Ft().y / this.VN.Zz])._O(m("uStippleTextureWidthLimiter"), this.VN.Xz / this.VN.Zz)._O(p("uStippleScale"), c.getPatternScale()).MO(p("uStippleTexture"), this.VN.Wz, 1);
      }
      return Ts.TN(this.ai.Nt(), this.WD, o, y, this.ai.Nt() ? 4 : 2, 0), Ts.Ec(this._V, n.geometry, y, this.EN && t !== 1, t === 1, d, 1), !0;
    })), { idCount: 1 }) : {};
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  dispose() {
    return super.dispose(), this.ON = void 0, this.RN && (this.WD.LO(this.RN), this.RN = void 0), this.zN && (this.WD.LO(this.zN), this.zN = void 0), this.VN = void 0, this;
  }
  Rc() {
    return this;
  }
  Wi() {
    return this.gu.max.x;
  }
  Hi() {
    return this.gu.min.x;
  }
  Zi() {
    return this.gu.max.y;
  }
  Xi() {
    return this.gu.min.y;
  }
  mu() {
    return qi(this.vc);
  }
  Su() {
    return qi(this.vc);
  }
}
class WM extends Nb {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.NN = [], this.GN = !1, this.$N = !1, this.UN = !1, this.jN = !1, this.YN = !1, this.SE = new Fs(), this.gu = Ie, this.LV = ss({ lineStyleSolid: () => Oi(this.vc) && this.vc, lineStyleDashed: () => Oo(this.vc) && this.vc, lineFillSolid: () => {
      const n = this.vc.getFillStyle();
      return de(n) && n;
    }, lineFillRadialGradient: () => {
      const n = this.vc.getFillStyle();
      return li(n) && n;
    }, lineFillLinearGradient: () => {
      const n = this.vc.getFillStyle();
      return hi(n) && n;
    }, lineIndividualPointFill: () => {
      const n = this.vc.getFillStyle();
      return Tr(n) && n;
    } }), this._V = t, this.wV = e, this.WD = t.kV(), this.EN = this.WD.pz, this.HN = t.Ga.Ya;
  }
  Qo() {
    const t = { Ls: (e) => this.WN(t, e), Ii: (e) => this.XN(t, e), UA: (e, i) => this.ZN(t, e, i), gP: (e) => this.JN(t, e), Wt: { x: 0, y: 0 }, Yt: { x: 0, y: 0 }, gi: 0, UL: void 0, QN: this.NN.length, cg: !0, KN: !0 };
    return this.$N = !0, this.NN.push(t), t;
  }
  Vi() {
    return this.NN.length = 0, this.GN = !0, this.yi.Ci(this), this;
  }
  qN() {
    return this.NN.length;
  }
  T(t) {
    const e = this.NN[t];
    return [e.Wt, e.Yt];
  }
  sy() {
    return this.NN;
  }
  gf(t) {
    const e = this.NN.indexOf(t);
    e >= 0 && (this.NN.splice(e, 1), t.KN || (this.GN = !0), this.yi.Ci(this));
  }
  WN(t, e) {
    if (e && !t.cg) t.QN = this.NN.length, this.NN.push(t);
    else if (!e) {
      const i = this.NN.indexOf(t);
      this.NN.splice(i, 1);
    }
    return t.cg = e, t.KN || (this.jN = !0), t;
  }
  XN(t, e) {
    return t.gi = e, t.KN || (this.UN = !0), t;
  }
  ZN(t, e, i) {
    return t.Wt = e, t.Yt = i, t.KN || (this.GN = !0), t;
  }
  JN(t, e) {
    return t.UL = e, t.KN || (this.YN = !0), t;
  }
  Uh() {
    const t = this.ui.T(), e = this.ui.u, i = this._l(), s = this.vc, o = this.NN, n = this.UN, a = this.GN, l = this.jN, h = this.YN, u = this.$N, c = this.LV.lineStyleSolid(i), d = this.LV.lineStyleDashed(i), f = c || d, p = this.LV.lineFillSolid(i), g = this.LV.lineIndividualPointFill(i), y = this.LV.lineFillRadialGradient(i), m = this.LV.lineFillLinearGradient(i), A = p || g || m || y, v = s.Yi(), b = d ? "triangulated" : s.getThickness() < 0 ? "primitive" : "triangulated";
    if (d && this.ai instanceof Ti) return H.console.error("LightningChart JS DashedLine is not supported on logarithmic axis"), this;
    this.SE.TO(this.ai);
    const w = this._c, k = a || l, R = !k && u;
    if (k || R) {
      const L = k ? o : o.filter(((I) => I.KN)), x = [], M = L.length;
      let C = wt, S = wt, E = Pt, T = Pt;
      for (let I = 0; I < M; I += 1) {
        const F = L[I];
        x.push(F.Wt), x.push(F.Yt), C = Math.min(C, F.Wt.x, F.Yt.x), S = Math.min(S, F.Wt.y, F.Yt.y), E = Math.max(E, F.Wt.x, F.Yt.x), T = Math.max(T, F.Wt.y, F.Yt.y);
      }
      this.RN = this.WD.qO(this.RN, ks(x, this.ai.Nt()), w * (this.ai.Nt() ? 8 : 4), k, Float32Array), this.gu = R ? Qs(this.gu, { min: { x: C, y: S }, max: { x: E, y: T } }) : { min: { x: C, y: S }, max: { x: E, y: T } };
    }
    if (i || e) {
      const L = p ? "uniform" : g ? "attribute" : m ? ["gradient", m] : y ? ["gradient", y] : void 0, x = f && A && v > 0 && L;
      this.ON = x ? b === "triangulated" ? { type: "triangulated", shader: this.WD.SR(K["2D"], K.Color({ dataType: L }), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0, snapToNearestPixel: this.HN, ensureMinimumSegmentLength: this.Mc !== void 0 }), this.EN ? K.AliasedEdge : void 0, d && K.StippleTextureInstanced, K.AttributeHighlight), mousePicking: t ? { shader: this.WD.SR(K["2D"], K.MousePicking({ useAttribute: !0 }), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0, snapToNearestPixel: this.HN, ensureMinimumSegmentLength: this.Mc !== void 0 }), d && K.StippleTextureInstanced, K.AttributeHighlight) } : void 0, geometry: Bo(this.WD, v, !1), thickness: v, lineStyleSolid: c, lineStyleDashed: d, fillStyleSolid: p, fillStyleIndividual: g, fillStyleLinearGradient: m, fillStyleRadialGradient: y } : { type: "primitive", shader: this.WD.SR(K["2D"], K.Color({ dataType: L }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0, snapToNearestPixel: this.HN }), K.AttributeHighlight), mousePicking: t ? { shader: this.WD.SR(K["2D"], K.MousePicking({ useAttribute: !0 }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0, snapToNearestPixel: this.HN }), K.AttributeHighlight) } : void 0, lineStyleSolid: c, lineStyleDashed: d, fillStyleSolid: p, fillStyleIndividual: g, fillStyleLinearGradient: m, fillStyleRadialGradient: y } : void 0;
    }
    if (d) {
      if (i || k || R) {
        const L = k || i ? o : o.filter(((C) => C.KN)), x = new Float32Array(4 * L.length);
        let M = 0;
        for (let C = 0; C < L.length; C += 1) {
          const S = L[C].Wt, E = L[C].Yt;
          x[M] = 0, x[M + 1] = 0, x[M + 2] = Math.abs(E.x - S.x), x[M + 3] = Math.abs(E.y - S.y), M += 4;
        }
        this.zN = this.WD.qO(this.zN, x, 4 * w, k || i, Float32Array);
      }
      this.VN = this.WD.Yz(d.getPattern());
    } else this.zN && (this.WD.LO(this.zN.buffer), this.zN = void 0), this.VN = void 0;
    if (n || k || R) {
      const L = b === "triangulated" ? 1 : 2, x = k || n ? o : o.filter(((S) => S.KN)), M = new Float32Array(x.length * L);
      let C = 0;
      x.forEach(((S) => {
        for (let E = 0; E < L; E += 1) M[C + E] = S.gi;
        C += L;
      })), this.tG = this.WD.qO(this.tG, M, w * L, k || n, Float32Array);
    }
    if ((h || k || R || i) && g) {
      const L = k || h || i ? o : o.filter(((C) => C.KN)), x = new Uint32Array(2 * L.length);
      let M = 0;
      L.forEach(((C) => {
        const S = (C.UL || g.color).toUint32();
        for (let E = M; E < M + 2; E += 1) x[E] = S;
        M += 2;
      })), this.iG = this.WD.qO(this.iG, x, 2 * w, k || h, Uint32Array);
    }
    if (t) {
      if (k || R || e) {
        const L = b === "triangulated" ? 1 : 2, x = k || e ? o : o.filter(((S) => S.KN)), M = new Float32Array(x.length * L);
        let C = 0;
        x.forEach(((S) => {
          for (let E = 0; E < L; E += 1) M[C + E] = S.QN || 0;
          C += L;
        })), this.sG = this.WD.qO(this.sG, M, w * L, k, Float32Array);
      }
    } else this.sG && (this.WD.LO(this.sG.buffer), this.sG = void 0);
    y ? this.VV = Ws(this.Ai || this.gu, this.ai, y.getPosition(), y.getExtent(), y.getShape(), this.WD.rO()) : m ? this.NV = Gs(this.Ai || this.gu, this.ai, m.getAngle(!0), this.WD.rO()) : (this.VV = void 0, this.NV = void 0), this.bc(s), this.UN = !1, this.jN = !1, this.GN = !1, this.YN = !1, this.ui.u = !1, this.$N = !1;
    for (const L of o) L.KN = !1;
    return this;
  }
  Ec(t, e) {
    var i;
    const s = this.RN, o = this.tG, n = this.sG;
    if (!s || !o) return {};
    const a = this.ON;
    if (!a) return {};
    const { type: l, fillStyleSolid: h, fillStyleIndividual: u, fillStyleLinearGradient: c, fillStyleRadialGradient: d, lineStyleDashed: f } = a, p = t === 1 ? (i = a.mousePicking) === null || i === void 0 ? void 0 : i.shader : a.shader;
    return p ? (this.WD.pd(p).SO(p, ((g, y, m, A) => {
      if (this.ai instanceof we || this.ai instanceof zs ? this.WD.xO(g("uScale"), this.SE.wO()).xO(g("uDisp"), this.SE.kO()).xO(A("uScaleStart_highpart"), this.SE.tV()).xO(A("uScaleStart_lowpart"), this.SE.iV()) : this.ai instanceof Ti && this.WD.xO(A("uScaleStart"), this.SE.MixedScaleXY.uScaleStart).xO(A("uScaleStartLog"), this.SE.MixedScaleXY.uScaleStartLog).xO(A("uScaleInterval"), this.SE.MixedScaleXY.uScaleInterval).xO(A("uScaleIntervalLog"), this.SE.MixedScaleXY.uScaleIntervalLog).xO(g("uViewportStart"), this.SE.MixedScaleXY.uViewportStart).xO(g("uViewportSize"), this.SE.MixedScaleXY.uViewportSize), this.HN && this.WD.xO(A("uViewportSizePx"), [this.yi.Ft().x * this.WD.rO(), this.yi.Ft().y * this.WD.rO()]), this.Mc !== void 0 && this.WD.xO(g("uMinSegmentPixelVector"), [this.Mc.x, this.Mc.y]), this.WD.gP(g("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(g("uRenderEffectMask"), t === 2 ? 1 : 0), t === 1) {
        if (this.WD.XO(g("uFirstId"), e), !n) return !1;
        l === "triangulated" ? this.WD.bO(n.buffer, 1, { location: y("aPickingIdOffset"), size: 1 }) : this.WD.oz(y("aPickingIdOffset"), n.buffer);
      } else if (h) this.WD.gP(g("uColor"), h.getColor());
      else if (u) {
        if (!this.iG) return !1;
        if (l === "triangulated") Ts.PN(this.WD, m, this.iG.buffer, y("aColorA"), y("aColorB"), 4, 0, !0, this.WD.gl.UNSIGNED_BYTE, 1);
        else {
          const v = y("aColor");
          this.WD.gl.bindBuffer(this.WD.gl.ARRAY_BUFFER, this.iG.buffer), this.WD.gl.vertexAttribPointer(v, 4, this.WD.gl.UNSIGNED_BYTE, !0, 0, 0), this.WD.gl.enableVertexAttribArray(v);
        }
      } else if (d) {
        if (!this.VV) return !1;
        this.WD.Pz(m, this.VV, d);
      } else if (c) {
        if (!this.NV) return !1;
        this.WD.Lz(m, this.NV, c);
      }
      if (f) {
        if (!this.zN || !this.VN) return !1;
        Ts.PN(this.WD, m, this.zN.buffer, y("aLengthSoFarA"), y("aLengthSoFarB"), 2, 0, !1, this.WD.gl.FLOAT, Float32Array.BYTES_PER_ELEMENT), this.WD.xO(g("uStippleCount"), [this.yi.Ft().x / this.VN.Zz, this.yi.Ft().y / this.VN.Zz])._O(A("uStippleTextureWidthLimiter"), this.VN.Xz / this.VN.Zz)._O(g("uStippleScale"), f.getPatternScale()).MO(g("uStippleTexture"), this.VN.Wz, 0);
      }
      if (l === "triangulated") {
        const { geometry: v, thickness: b } = a;
        Ts.IN(this.ai.Nt(), this.WD, s.buffer, m, this.ai.Nt() ? 4 : 2, 0), this.WD.bO(o.buffer, 1, { location: y("aIsHighlighted"), size: 1 }), Ts.Ec(this._V, v, m, this.EN && t !== 1, t === 1, b, this.NN.length);
      } else oa.IN(this.ai.Nt(), this.WD, s.buffer, m, this.ai.Nt() ? 4 : 2, 0), this.WD.oz(y("aIsHighlighted"), o.buffer), oa.DN(this._V, this.NN.length);
      return !0;
    })), { idCount: this.NN.length }) : {};
  }
  dispose() {
    return super.dispose(), this.ON = void 0, this.RN && (this.WD.LO(this.RN.buffer), this.RN = void 0), this.zN && (this.WD.LO(this.zN.buffer), this.zN = void 0), this.tG && (this.WD.LO(this.tG.buffer), this.tG = void 0), this.sG && (this.WD.LO(this.sG.buffer), this.sG = void 0), this.iG && (this.WD.LO(this.iG.buffer), this.iG = void 0), this.VN = void 0, this;
  }
  Oc(t, e, i, s, o) {
    return { collectionMember: this.NN.find(((n) => e + n.QN === t)) };
  }
  Rc() {
    return this;
  }
  Ii(t) {
    super.Ii(t);
    for (const e of this.NN) e.Ii(t);
    return this;
  }
  Wi() {
    return this.gu.max.x;
  }
  Hi() {
    return this.gu.min.x;
  }
  Zi() {
    return this.gu.max.y;
  }
  Xi() {
    return this.gu.min.y;
  }
  mu() {
    return qi(this.vc);
  }
  Su() {
    return qi(this.vc);
  }
}
class ac {
  constructor(t, e) {
    this.eG = !1, this.rG = !1, this.ai = t, this.hG = e, this.hG._i("DataPattern", ((i) => {
      i.pattern !== "ProgressiveX" && i.pattern !== "RegressiveX" || (this.eG = "x"), i.pattern !== "ProgressiveY" && i.pattern !== "RegressiveY" || (this.eG = "y"), i.pattern !== "RegressiveX" && i.pattern !== "RegressiveY" || (this.rG = !0);
    }));
  }
  calculateUserDataPointsProgressiveRange(t) {
    if (t.length === 0) throw new Error("calculateUserDataPointsProgressiveRange called with 0 data points");
    return { start: this.eG === "x" ? t[0].x : t[0].y, end: this.eG === "x" ? t[t.length - 1].x : t[t.length - 1].y };
  }
  calculateUserDataPointsBoundaries(t) {
    return this.eG ? this.eG === "x" ? (function(e) {
      const i = e.length;
      if (i > 0) {
        const s = Math.max(e[i - 1].x, e[0].x), o = Math.min(e[i - 1].x, e[0].x);
        let n = e[0].y, a = e[0].y;
        for (let l = 0; l < i; l += 1) {
          const h = e[l];
          h.y > n && (n = h.y), h.y < a && (a = h.y);
        }
        return Ee(j(o, a), j(s, n));
      }
      return Ie;
    })(t) : (function(e) {
      const i = e.length;
      if (i > 0) {
        const s = Math.max(e[i - 1].y, e[0].y), o = Math.min(e[i - 1].y, e[0].y);
        let n = e[0].x, a = e[0].x;
        for (let l = 0; l < i; l += 1) {
          const h = e[l];
          h.x > n && (n = h.x), h.x < a && (a = h.x);
        }
        return Ee(j(a, o), j(n, s));
      }
      return Ie;
    })(t) : Vi(t);
  }
  calculateAvgStepBetweenDataPoints(t, e, i) {
    return Math.abs(t - e) / (i - 1);
  }
}
const GM = Math.min(1, 1.5);
class UM extends ac {
  constructor(t, e, i) {
    super(t, e), this.nG = !1, this.oG = { enabled: !1, totalDataPointsAtTime: 0 }, this.aG = [], this.Rs = i, this.lG = t instanceof we ? { type: "linear", scale: t } : t instanceof Ti ? { type: "mixed", scale: t } : { type: "unknown" }, this.hG._i("DataPattern", ((s) => {
      s.allowDataGrouping === !1 && (this.nG = !0);
    }));
  }
  uG(t, e = !1) {
    if (this.nG || !this.eG || this.lG.type !== "linear") return !1;
    e === !1 && this.cG && (clearTimeout(this.cG), this.cG = void 0);
    const i = this.eG === "x" ? this.lG.scale.x.gA : this.lG.scale.y.gA;
    if (!i) throw new Error("CP helper has no information about Axis state.");
    const s = t.length;
    if (s < 2) return !1;
    const o = t[0], n = t[s - 1], a = this.calculateAvgStepBetweenDataPoints(this.eG === "x" ? o.x : o.y, this.eG === "x" ? n.x : n.y, s), l = this.lG.scale, h = Math.abs(this.eG === "x" ? l.ni().x : l.ni().y), u = h / a, c = Math.floor(u * GM), d = c * a, f = H.performance.now(), p = !(f - i.Yr < 500) && (i.Vr ? f - i.jr < 1e3 : f - i.Nr < 2e3 || i.$r), g = s > 2 * this.oG.totalDataPointsAtTime;
    if (p && !g) return this.cG = setTimeout((() => this.dG(t)), 1e3), !1;
    const y = c >= 10, m = this.oG.enabled ? this.oG.columnWidthAxis / h < 1.5 : void 0, A = this.oG.enabled && c > this.oG.dataPointsPerColumn ? c / this.oG.dataPointsPerColumn >= 2 : void 0;
    let v;
    this.oG.enabled === !0 ? m ? A && (v = { enabled: !0, columnWidthAxis: d, dataPointsPerColumn: c, totalDataPointsAtTime: s }) : v = y ? { enabled: !0, columnWidthAxis: d, dataPointsPerColumn: c, totalDataPointsAtTime: s } : { enabled: !1, totalDataPointsAtTime: s } : y && (v = { enabled: !0, columnWidthAxis: d, dataPointsPerColumn: c, totalDataPointsAtTime: s });
    const b = e === !1;
    return v ? (b && (this.oG = v), !0) : (b && (this.oG = { ...this.oG, totalDataPointsAtTime: s }), !1);
  }
  fG() {
    this.AG = void 0, this.aG.length = 0, this.cG && (clearTimeout(this.cG), this.cG = void 0);
  }
  gG(t) {
    if (t.length === 0 || this.nG || !this.eG || this.lG.type !== "linear" || !this.oG.enabled) return t;
    let e;
    e = this.aG.length > 0 ? us(this.aG, t, { canReturnB: !0 }) : t;
    const i = e.length, s = [];
    let o, n, a = this.AG === void 0, l = -1, h = -1, u = 0, c = 0;
    if (this.eG !== "x" || this.rG) if (this.eG === "x" && this.rG) {
      const f = this.oG.columnWidthAxis;
      let p = this.AG ? this.AG.x : e[0].x, g = p - f;
      for (let y = 0; y < i; y += 1) {
        const m = e[y];
        m.x >= g ? ((!o || m.y > o.y) && (o = m, l = y), (!n || m.y < n.y) && (n = m, h = y), c = y) : (o && n && (a && s.push(e[0]), l < h ? s.push(o, n) : s.push(n, o)), a = !1, p = m.x, g = p - f, o = m, l = y, n = m, h = y, u = y, c = y);
      }
    } else if (this.eG !== "y" || this.rG) {
      if (this.eG === "y" && this.rG) {
        const f = this.oG.columnWidthAxis;
        let p = this.AG ? this.AG.y : e[0].y, g = p - f;
        for (let y = 0; y < i; y += 1) {
          const m = e[y];
          m.y >= g ? ((!o || m.x > o.x) && (o = m, l = y), (!n || m.x < n.x) && (n = m, h = y), c = y) : (n && o && (a && s.push(e[0]), l < h ? s.push(o, n) : s.push(n, o)), a = !1, p = m.y, g = p - f, o = m, l = y, n = m, h = y, u = y, c = y);
        }
      }
    } else {
      const f = this.oG.columnWidthAxis;
      let p = this.AG ? this.AG.y : e[0].y, g = p + f;
      for (let y = 0; y < i; y += 1) {
        const m = e[y];
        m.y <= g ? ((!o || m.x > o.x) && (o = m, l = y), (!n || m.x < n.x) && (n = m, h = y), c = y) : (n && o && (a && s.push(e[0]), l < h ? s.push(o, n) : s.push(n, o)), a = !1, p = m.y, g = p + f, o = m, l = y, n = m, h = y, u = y, c = y);
      }
    }
    else {
      const f = this.oG.columnWidthAxis;
      let p = this.AG ? this.AG.x : e[0].x, g = p + f;
      for (let y = 0; y < i; y += 1) {
        const m = e[y];
        m.x <= g ? ((!o || m.y > o.y) && (o = m, l = y), (!n || m.y < n.y) && (n = m, h = y), c = y) : (o && n && (a && s.push(e[0]), l < h ? s.push(o, n) : s.push(n, o)), a = !1, p = m.x, g = p + f, o = m, l = y, n = m, h = y, u = y, c = y);
      }
    }
    if (o || n) {
      const f = e.slice(u, c + 1);
      this.aG = f;
    } else this.aG.length = 0;
    const d = s.length;
    return d > 0 && (this.AG = s[d - 1]), s;
  }
  vG(t) {
    var e, i;
    if (this.eG && this.lG.type === "linear") {
      const s = this.eG === "x" ? this.lG.scale.x.gA : this.lG.scale.y.gA;
      if (!s) throw new Error("CP helper has no information about Axis state.");
      if (((e = s.Vh) === null || e === void 0 ? void 0 : e.id) === Gl || ((i = s.Vh) === null || i === void 0 ? void 0 : i.id) === Aa) {
        const o = Math.abs(this.eG === "x" ? this.lG.scale.x.getInnerInterval() : this.lG.scale.y.getInnerInterval());
        if (this.oG.enabled) return 2 * o / this.oG.columnWidthAxis;
        const n = t.length, a = t[0], l = t[n - 1];
        return o / this.calculateAvgStepBetweenDataPoints(this.eG === "x" ? a.x : a.y, this.eG === "x" ? l.x : l.y, n);
      }
    }
  }
  yG(t, e, i) {
    if (!this.eG) return e;
    const s = i.length;
    let o = dd(i, t.min, this.eG, this.rG, 0, s - 1);
    o === void 0 && (o = this.rG ? s - 1 : 0);
    let n = dd(i, t.max, this.eG, this.rG, 0, s - 1);
    return n === void 0 && (n = this.rG ? 0 : s - 1), 1 + Math.abs(n - o);
  }
  pG() {
    this.cG && (clearTimeout(this.cG), this.cG = void 0);
  }
  dG(t) {
    this.uG(t, !0) && this.Rs();
  }
}
class HM extends ac {
  renderVisibleOnly(t, e, i = !1) {
    const s = this.ai.x.getInnerStart(), o = this.ai.x.getInnerEnd(), n = Math.min(s, o), a = Math.max(s, o), l = this.ai.y.getInnerStart(), h = this.ai.y.getInnerEnd(), u = Math.min(l, h), c = Math.max(l, h);
    t.forEach(((d, f) => {
      d.existingCoordinatesCount <= 1 || i === !1 && (d.boundaries.max.x < n || d.boundaries.min.x > a || d.boundaries.max.y < u || d.boundaries.min.y > c) || e(d);
    }));
  }
}
class Jf {
  constructor(t, e, i) {
    this.mG = e, this.SG = i, this.bG = t, this.xG = [];
  }
  MG(t, e, i, s) {
    const o = t.length;
    if (o === 0) return;
    let n = t, a = o, l = this.bG[this.bG.length - 1];
    do {
      const h = this.bG.length;
      let u;
      l || (l = this._G(e, a)), l && l.allocatedCoordinatesCount - l.existingCoordinatesCount == 0 && (l = void 0);
      let c = 0;
      if (this.SG && h > 0 && (l === void 0 || l.existingCoordinatesCount === 0)) {
        const d = this.bG[h - 1].lastDataPoint;
        d ? (n.splice(0, 0, d), c = 1, a += 1) : console.error("SegmentationHelper _connectSegments = true, but segment has no lastDataPoint information!");
      }
      if (l) u = Math.min(a, l.allocatedCoordinatesCount - l.existingCoordinatesCount), s(l, n.slice(0, u), u, c);
      else {
        const d = Math.ceil(e) + c;
        u = Math.min(d, a);
        const f = { ...i(d, n.slice(0, u), u, c), isDropped: !1 };
        this.bG.push(f);
      }
      u > 0 && (a > u ? (n = n.slice(u), a = n.length) : (n = [], a = 0));
    } while (a > 0);
    this.wG();
  }
  kG(t) {
    const e = t, i = this.bG.indexOf(e);
    i >= 0 && this.bG.splice(i, 1), e.droppedTimestamp = H.performance.now(), this.xG.push(e);
  }
  CG() {
    this.bG.slice().forEach(((t) => this.kG(t)));
  }
  TG() {
    this.bG.forEach(((t) => this.mG(t))), this.xG.forEach(((t) => this.mG(t))), this.bG.length = 0, this.xG.length = 0;
  }
  _G(t, e) {
    const i = 2 * t / 3, s = 4 * t / 3, o = this.xG.findIndex(((n) => n.allocatedCoordinatesCount >= i && n.allocatedCoordinatesCount <= s));
    if (o >= 0) {
      const n = this.xG[o];
      return this.xG.splice(o, 1), this.bG.push(n), n;
    }
  }
  wG() {
    if (this.xG.length > 5) {
      const t = H.performance.now();
      for (let e = 0; e < this.xG.length - 5; e += 1) {
        const i = this.xG[e];
        (i.droppedTimestamp === void 0 || t - i.droppedTimestamp >= 1e4) && (this.mG(i), this.xG.splice(e, 1), e -= 1);
      }
    }
  }
}
class Jx extends ac {
  FG(t, e) {
    if (!e || typeof e != "object") return 0;
    const i = this.ai.x.getInnerStart(), s = this.ai.x.getInnerEnd(), o = Math.min(i, s), n = Math.max(i, s), a = this.ai.y.getInnerStart(), l = this.ai.y.getInnerEnd(), h = Math.min(a, l), u = Math.max(a, l);
    if ("maxDataPointCount" in e) return this.IG(t, e.maxDataPointCount, o, n, h, u);
    if ("minDataPointCount" in e) return this.PG(t, e.minDataPointCount, o, n, h, u);
    if ("progressiveDataCleaningThreshold" in e) return this.LG(t, e.progressiveDataCleaningThreshold, o, n, h, u);
    throw new Error(`Unimplemented data cleaning configuration: ${JSON.stringify(e)}`);
  }
  IG(t, e, i, s, o, n) {
    if (e === void 0 || e <= 0) return 0;
    const a = t.reduce(((u, c) => u + c.existingDataPointsCount), 0);
    if (a <= e) return 0;
    let l = 0, h = a;
    for (let u = 0; u < t.length; u += 1) {
      const c = t[u];
      h > e && (l += 1, h -= c.existingDataPointsCount);
    }
    return l;
  }
  LG(t, e, i, s, o, n) {
    if (e === void 0 || !this.eG) return 0;
    let a = 0;
    for (let l = 0; l < t.length; l += 1) {
      const h = t[l], u = this.rG ? this.eG === "x" ? h.boundaries.min.x > s : h.boundaries.min.y > n : this.eG === "x" ? h.boundaries.max.x < i : h.boundaries.max.y < o;
      if (!((this.rG ? this.eG === "x" ? h.boundaries.min.x > e : h.boundaries.min.y > e : this.eG === "x" ? h.boundaries.max.x < e : h.boundaries.max.y < e) && u && h.existingCoordinatesCount > 2)) break;
      a += 1;
    }
    return a;
  }
  PG(t, e, i, s, o, n) {
    if (e === void 0 || e === 0) return 0;
    let a = 0, l = 0;
    for (let h = t.length - 1; h >= 0; h -= 1) {
      const u = t[h];
      if (l > e) if (this.eG) {
        if (this.rG ? this.eG === "x" ? u.boundaries.min.x > s : u.boundaries.min.y > n : this.eG === "x" ? u.boundaries.max.x < i : u.boundaries.max.y < o) {
          a = 1 + h;
          break;
        }
      } else u.boundaries.max.x < i || u.boundaries.min.x > s || u.boundaries.max.y < o || u.boundaries.min.y > n ? a += 1 : a = 0;
      l += u.existingDataPointsCount;
    }
    return a;
  }
  BG(t, e) {
    const i = t.reduce(((s, o) => Qs(s, o.boundaries)), Ie);
    if (e && "progressiveDataCleaningThreshold" in e && e.progressiveDataCleaningThreshold) {
      const s = e.progressiveDataCleaningThreshold;
      this.eG !== "x" || this.rG ? this.eG === "x" && this.rG ? i.max.x = Math.min(i.max.x, s) : this.eG !== "y" || this.rG ? this.eG === "y" && this.rG && (i.max.y = Math.min(i.max.y, s)) : i.min.y = Math.max(i.min.y, s) : i.min.x = Math.max(i.min.x, s);
    }
    return i;
  }
}
class YM extends Bb {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o), this.SE = new Fs(), this.Wx = [], this.DG = new HM(this.ai, this), this.EG = new UM(this.ai, this, (() => this.yi.Rs())), this.OG = new Jf(this.Wx, ((p) => {
      p.coordsBuffer && this.WD.LO(p.coordsBuffer), p.zN && this.WD.LO(p.zN);
    }), !0), this.zG = new Jx(this.ai, this), this.VG = 0, this.NG = 0, this.GG = !1, this.LV = ss({ lineStyleSolid: () => Oi(this.vc) && this.vc, lineStyleDashed: () => Oo(this.vc) && this.vc, strokeFillSolid: () => {
      const p = this.vc.getFillStyle();
      return de(p) && p;
    }, strokeFillLinearGradient: () => {
      const p = this.vc.getFillStyle();
      return hi(p) && p;
    }, strokeFillRadialGradient: () => {
      const p = this.vc.getFillStyle();
      return li(p) && p;
    }, strokeFillPaletted: () => {
      const p = this.vc.getFillStyle();
      return Ve(p) && p;
    } }), this.wV = e, this.Ga = n, this.ON = { type: "none" }, this.WD = t.kV(), this._V = t, this.EN = this.WD.pz;
    const a = this.ai.Nt(), l = n?.individualLookupValuesEnabled === !0;
    let h, u, c, d = 0;
    a || (h = d, d += 2), a && (u = d, d += 4), l && (c = d, d += 1);
    const f = /* @__PURE__ */ ((p, g) => g ? (y, m) => ((A, v) => {
      if (!v) {
        const R = A.length, L = new Float32Array(3 * R);
        for (let x = 0, M = 0; x < R; x += 1) {
          const C = A[x];
          L[M + 0] = C.x, L[M + 1] = C.y, L[M + 2] = C.value !== void 0 ? C.value : 0, M += 3;
        }
        return L;
      }
      const b = A.length, w = new Float32Array(5 * b);
      let k = 0;
      for (let R = 0; R < b; R += 1) {
        const L = A[R], x = Math.fround(L.x), M = Math.fround(L.y);
        w[k + 0] = x, w[k + 1] = M, w[k + 2] = L.x - x, w[k + 3] = L.y - M, w[k + 4] = L.value !== void 0 ? L.value : 0, k += 5;
      }
      return w;
    })(y, p) : (y, m) => ks(y, p, Float32Array))(a, l);
    this.$G = { individualLookupValuesEnabled: l, attributesPerVertex: d, attributeOffsetCoordinateLowPrecision: h, attributeOffsetCoordinateHighPrecision: u, attributeOffsetLookUpValue: c, prepareRenderData: (p, g) => f(p, this.vc.getFillStyle()) };
  }
  UG(t, e, i) {
    const s = new Float32Array(2 * e);
    let o = 0, n = i || t[0];
    for (let a = 0; a < e; a += 1) {
      const l = t[a];
      this.VG += Math.abs(n.x - l.x), this.NG += Math.abs(n.y - l.y), s[o] = this.VG, s[o + 1] = this.NG, o += 2, n = l;
    }
    return s;
  }
  Uh() {
    const t = this.Tu, e = this.vc, i = this._l(), s = this.wu, o = s.length, n = o > 0, a = this.ui.T(), l = this.ui.u, h = this.LV.lineStyleSolid(i), u = this.LV.lineStyleDashed(i), c = h || u, d = c && c.getThickness(), f = this.LV.strokeFillSolid(i), p = this.LV.strokeFillLinearGradient(i), g = this.LV.strokeFillRadialGradient(i), y = this.LV.strokeFillPaletted(i), m = f || p || g || y, A = this.$G.individualLookupValuesEnabled;
    if (u && this.ai instanceof Ti) return H.console.error("LightningChart JS DashedLine is not supported on logarithmic axis"), this;
    n && (this.wc = us(this.wc, s, { canReturnB: !0 }), this.kc += o);
    let v = this.Cc.u;
    const b = this.zG.FG(this.Wx, this.Cc.T());
    if (b > 0) {
      let x = 0;
      for (let M = 0; M < b; M += 1) {
        const C = this.Wx[0];
        x += C.existingDataPointsCount, C.existingDataPointsCount = 0, C.existingCoordinatesCount = 0, C.jointPointsCount = 0, C.boundaries = Ie, C.lastDataPoint = void 0, this.OG.kG(C);
      }
      this.wc = this.wc.slice(x), this.kc = this.wc.length, v = !0;
    }
    let w = s, k = !1;
    (this.EG.uG(this.wc) || t) && (k = !0), u && !this.GG ? (k = !0, this.GG = !0, this.OG.TG()) : !u && this.GG && (this.Wx.forEach(((x) => {
      x.zN && (this.WD.LO(x.zN), x.zN = void 0);
    })), this.GG = !1), k && (this.EG.fG(), this.Wx.forEach(((x) => {
      x.existingDataPointsCount = 0, x.existingCoordinatesCount = 0, x.jointPointsCount = 0, x.boundaries = Ie, x.lastDataPoint = void 0;
    })), this.OG.CG(), w = this.wc, this.VG = 0, this.NG = 0);
    const R = this.EG.gG(w), L = R.length;
    if (L > 0) {
      let x = this.EG.vG(this.wc) || (this._i("ApplicationType", ((M) => M.type === "InternalUI")) ? this.kc : 1e5);
      L / x > 10 && (x = L / 10), this.OG.MG(R, x, ((M, C, S, E) => {
        const T = this.DG.calculateUserDataPointsBoundaries(C), I = this.EG.yG(T, S, this.wc) - E;
        return this.jG = C[S - 1], { allocatedCoordinatesCount: M, existingDataPointsCount: I, existingCoordinatesCount: S, jointPointsCount: E, boundaries: T, coordsBuffer: this.WD.QO(M * this.$G.attributesPerVertex, this.$G.prepareRenderData(C, S)), lastDataPoint: C[S - 1], zN: this.GG ? this.WD.QO(2 * M, this.UG(C, S, this.jG)) : void 0 };
      }), ((M, C, S, E) => {
        const T = Qs(M.boundaries, this.DG.calculateUserDataPointsBoundaries(C)), I = this.EG.yG(T, M.existingCoordinatesCount + S, this.wc) - (M.jointPointsCount + E);
        this.WD.KO(M.coordsBuffer, M.existingCoordinatesCount * this.$G.attributesPerVertex, this.$G.prepareRenderData(C, S)), this.GG && M.zN && this.WD.KO(M.zN, 2 * M.existingCoordinatesCount, this.UG(C, S, this.jG)), this.jG = C[S - 1], M.jointPointsCount += E, M.lastDataPoint = C[S - 1], M.existingDataPointsCount = I, M.existingCoordinatesCount += S, M.boundaries = T;
      }));
    }
    if (v && (this.gu = this.zG.BG(this.Wx, this.Cc.T())), this.SE.TO(this.ai), g ? this.XV = Ws(this.Ai || this.gu, this.ai, g.getPosition(), g.getExtent(), g.getShape(), this.WD.rO()) : p ? this.ZV = Gs(this.Ai || this.gu, this.ai, p.getAngle(!0), this.WD.rO()) : (this.XV = void 0, this.ZV = void 0), i || l) {
      if (y && y.getLookUpProperty() === "value" && !A) {
        const x = 'LCJS misusage error: Series individualLookupValuesEnabled flag must be set if using PalettedFill with lookUpProperty="value" !';
        throw H.alert(x), new Error(x);
      }
      if (m && c && d !== !1) {
        const x = d === -1 ? "primitive" : "triangulated", M = p ? ["gradient", p] : g ? ["gradient", g] : y ? ["lookup", y.getLookUpProperty(), y.lut] : "uniform";
        this.ON = x === "primitive" ? { type: x, shader: this.WD.SR(K["2D"], K.Color({ dataType: M }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), u && K.StippleTexture), mousePickingShader: a ? this.WD.SR(K["2D"], K.MousePicking({ useVertexId: !0 }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), u && K.StippleTexture) : void 0, lineStyleSolid: h, lineStyleDashed: u, fillStyleSolid: f, fillStyleLinearGradient: p, fillStyleRadialGradient: g, fillStylePaletted: y } : x === "triangulated" ? { type: x, shader: this.WD.SR(K["2D"], K.Color({ dataType: M }), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), this.EN ? K.AliasedEdge : void 0, u && K.StippleTextureInstanced), mousePickingShader: a ? this.WD.SR(K["2D"], K.MousePicking(), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), u && K.StippleTextureInstanced) : void 0, geometry: Bo(this.WD, d), thickness: d, lineStyleSolid: h, lineStyleDashed: u, fillStyleSolid: f, fillStyleLinearGradient: p, fillStyleRadialGradient: g, fillStylePaletted: y } : { type: "none" };
      } else this.ON = { type: "none" };
    }
    return this.VN = u ? this.WD.Yz(u.getPattern()) : void 0, this.bc(e), this.Tu = !1, this.wu = [], this.ui.u = !1, this;
  }
  Ec(t, e) {
    const i = this.WD.gl, s = this.ON;
    if (!s || s.type === "none") return {};
    const o = t === 1 ? s.mousePickingShader : s.shader;
    if (!o) return {};
    const { lineStyleDashed: n, fillStyleSolid: a, fillStyleLinearGradient: l, fillStyleRadialGradient: h, fillStylePaletted: u } = s;
    return this.WD.pd(o).SO(o, ((c, d, f, p) => {
      let g = !1;
      if (this.WD._O(c("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(c("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(c("uRenderEffectMask"), t === 2 ? 1 : 0), this.ai instanceof we || this.ai instanceof zs ? this.WD.xO(c("uScale"), this.SE.wO()).xO(c("uDisp"), this.SE.kO()).xO(p("uScaleStart_highpart"), this.SE.tV()).xO(p("uScaleStart_lowpart"), this.SE.iV()) : this.ai instanceof Ti && this.WD.xO(p("uScaleStart"), this.SE.MixedScaleXY.uScaleStart).xO(p("uScaleStartLog"), this.SE.MixedScaleXY.uScaleStartLog).xO(p("uScaleInterval"), this.SE.MixedScaleXY.uScaleInterval).xO(p("uScaleIntervalLog"), this.SE.MixedScaleXY.uScaleIntervalLog).xO(c("uViewportStart"), this.SE.MixedScaleXY.uViewportStart).xO(c("uViewportSize"), this.SE.MixedScaleXY.uViewportSize), t !== 1) {
        if (a) this.WD.gP(c("uColor"), a.getColor());
        else if (h) {
          if (!this.XV) return !1;
          this.WD.Pz(f, this.XV, h);
        } else if (l) {
          if (!this.ZV) return !1;
          this.WD.Lz(f, this.ZV, l);
        } else if (u) {
          const m = er(u, this, void 0);
          if (!m && u.lut.percentageValues) return !1;
          this.WD.Jz(f, u.lut, m);
        }
      }
      const y = Cl(e);
      return this.DG.renderVisibleOnly(this.Wx, ((m) => {
        const { coordsBuffer: A } = m;
        if (!A) return;
        if (t === 1) {
          const [b, w] = y.es(m.existingDataPointsCount);
          this.WD.XO(c("uFirstId"), b), s.type === "triangulated" ? this.WD.$z(f, w) : this.WD.Nz(f, w);
        }
        i.bindBuffer(i.ARRAY_BUFFER, A);
        const v = s.type === "triangulated" ? Ts.TN : oa.TN;
        if (this.ai.Nt() || this.$G.attributeOffsetCoordinateLowPrecision === void 0 ? this.ai.Nt() && this.$G.attributeOffsetCoordinateHighPrecision !== void 0 && v(!0, this.WD, A, f, this.$G.attributesPerVertex, this.$G.attributeOffsetCoordinateHighPrecision) : v(!1, this.WD, A, f, this.$G.attributesPerVertex, this.$G.attributeOffsetCoordinateLowPrecision), n) {
          if (!m.zN || !this.VN) return;
          s.type === "triangulated" ? Ts.FN(this.WD, f, m.zN, d("aLengthSoFarA"), d("aLengthSoFarB"), 2, 2, 0) : oa.FN(this.WD, f, m.zN, d("aLengthSoFar"), 2, 0), this.WD.xO(c("uStippleCount"), [this.yi.Ft().x / this.VN.Zz, this.yi.Ft().y / this.VN.Zz])._O(p("uStippleTextureWidthLimiter"), this.VN.Xz / this.VN.Zz)._O(c("uStippleScale"), n.getPatternScale()).MO(c("uStippleTexture"), this.VN.Wz, 1);
        }
        if (u && u.lookUpProperty === "value" && this.$G.attributeOffsetLookUpValue !== void 0 && t !== 1) if (s.type === "triangulated") {
          const b = d("aLookupValueA");
          i.vertexAttribPointer(b, 1, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetLookUpValue * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(b, 1), i.enableVertexAttribArray(b);
          const w = d("aLookupValueB");
          i.vertexAttribPointer(w, 1, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, (this.$G.attributeOffsetLookUpValue + this.$G.attributesPerVertex) * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(w, 1), i.enableVertexAttribArray(w);
        } else {
          const b = d("aLookupValue");
          i.vertexAttribPointer(b, 1, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetLookUpValue * Float32Array.BYTES_PER_ELEMENT), i.enableVertexAttribArray(b);
        }
        if (s.type === "triangulated") {
          const { thickness: b } = s;
          Ts.Ec(this._V, s.geometry, f, this.EN && t !== 1, t === 1, b, m.existingCoordinatesCount - 1);
        } else oa.LN(this._V, m.existingCoordinatesCount);
        g = !0;
      }), this.fs === void 0), i.bindBuffer(i.ARRAY_BUFFER, null), g;
    })), { idCount: this.kc };
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  Pu(t, e) {
    return Array.isArray(t) || (t = [t]), this.wu = us(this.wu, t, { canReturnB: !0 }), this.gu = Qs(this.gu, e || e || this.DG.calculateUserDataPointsBoundaries(t)), this;
  }
  Vi() {
    return super.Vi(), this.VG = 0, this.NG = 0, this.jG = void 0, this;
  }
  dispose() {
    return super.dispose(), this.OG.TG(), this.EG.pG(), this.ON = { type: "none" }, this.VN = void 0, this;
  }
  Rc() {
    return this;
  }
  Db(t) {
    this.Ou() > 0 && this.Uh();
    const e = this.Lu(), i = Tm(e, t, this.Mi(), this.Fu, this.Iu, this.ai, this.engine.ai, this.gu, this.DG.eG, this.DG.rG);
    return i !== void 0 ? e[i] : void 0;
  }
  eM(t) {
    this.Ou() > 0 && this.Uh();
    const e = this.Lu(), i = e.length;
    if (i === 0) return;
    const s = this.Fu ? 1 : 0, o = i - (this.Iu ? 2 : 1), n = this.Mi();
    if (n === Ms.Nearest) {
      let a, l, h = wt;
      for (let u = 0; u < i; u += 1) {
        const c = xt(e[u], this.ai, this.yi.ai);
        if (l !== void 0) {
          const d = yA(l, c, t), f = (d.x - t.x) ** 2 + (d.y - t.y) ** 2;
          f < h && (h = f, a = d);
        }
        l = c;
      }
      return a !== void 0 ? xt(a, this.yi.ai, this.ai) : void 0;
    }
    if (this.DG.eG === "x" && n === Ms.NearestX || this.DG.eG === "y" && n === Ms.NearestY) {
      const a = km(e, xt(t, this.yi.ai, this.ai), this.DG.eG, this.DG.rG, s, o);
      return a ? Ln(e[a.a], e[a.b], a.lerpAmount) : void 0;
    }
    return this.Db(t);
  }
  Wi() {
    return this.gu.max.x;
  }
  Hi() {
    return this.gu.min.x;
  }
  Zi() {
    return this.gu.max.y;
  }
  Xi() {
    return this.gu.min.y;
  }
  mu() {
    return qi(this.vc);
  }
  Su() {
    return qi(this.vc);
  }
}
class jM extends dh {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.ON = { fill: void 0, border: void 0 }, this.SE = new Fs(), this.gu = Ie, this.YG = !1, this.HG = !1, this.WG = !1, this.XG = !1, this.ZG = !1, this.ff = [], this.LV = ss({ polygonStyleSolid: () => de(this.Ke) && this.Ke, polygonStyleImage: () => cn(this.Ke) && this.Ke, polygonStyleRadialGradient: () => li(this.Ke) && this.Ke, polygonStyleLinearGradient: () => hi(this.Ke) && this.Ke, polygonStylePaletted: () => Ve(this.Ke) && this.Ke, polygonStyleIndividual: () => Tr(this.Ke) && this.Ke, lineStyleSolid: () => Oi(this.qe) && this.qe, lineStyleDashed: () => Oo(this.qe) && this.qe, lineStyleFilled: () => {
      const n = this.qe && this.qe.getFillStyle();
      return de(n) && n;
    } }), this._V = t, this.wV = e, this.WD = t.kV(), this.EN = this.WD.pz;
  }
  Qo() {
    const t = { Ls: (e) => this.WN(t, e), Ii: (e) => this.XN(t, e), yu: (e) => this.JG(t, e), ZS: (e) => this.QG(t, e), gP: (e) => this.JN(t, e), Au: [], M: void 0, KG: void 0, gi: 0, cg: !0, qG: this.ff.length };
    return this.ff.push(t), t;
  }
  Vi() {
    return this.ff.length = 0, this.YG = !0, this.yi.Ci(this), this;
  }
  sy() {
    return this.ff;
  }
  gf(t) {
    const e = this.ff.indexOf(t);
    e >= 0 && (this.ff.splice(e, 1), this.ZG = !0, this.yi.Ci(this, t));
  }
  WN(t, e) {
    return t.cg = e, this.ZG = !0, t.cg || this.yi.Ci(this, t), t;
  }
  XN(t, e) {
    return t.gi = e, this.XG = !0, t;
  }
  JG(t, e) {
    return t.Au = e, this.YG = !0, t;
  }
  QG(t, e) {
    return t.M = e, this.HG = !0, t;
  }
  JN(t, e) {
    return t.KG = e?.toUint32(), this.WG = !0, t;
  }
  Uh() {
    const t = this.ui.T(), e = this.ui.u, i = this.ml(), s = this.XG, o = this.YG, n = this.HG, a = this.WG, l = this.ZG, h = this.qe, u = this._l(), c = this.ff.filter(((x) => x.cg && x.Au.length > 0));
    if (this.SE.TO(this.ai), (o || l) && (this.gu = Qs(...c.map(((x) => Vi(x.Au))))), o || l) {
      const x = c.map(((T) => [...T.Au, T.Au[0], { x: Number.NaN, y: Number.NaN }])).flat(), M = ks(x, !1, Float64Array), C = this.ai.Nt() ? ks(x, !0) : M;
      this.RN = this.WD.pO(C, !1, this.RN);
      let S = [];
      c.reduce(((T, I) => {
        const F = T, D = 2 * (I.Au.length + 1), P = new Float64Array(M.buffer, F, D), V = vm(P, void 0, 2), _ = T / (2 * Float64Array.BYTES_PER_ELEMENT);
        for (let O = 0; O < V.length; O += 1) V[O] += _;
        return S = us(S, V, { canReturnB: !0 }), F + (D + 2) * Float64Array.BYTES_PER_ELEMENT;
      }), 0);
      const E = new Uint32Array(S);
      this.t$ = this.WD.iz(E, this.t$), this.i$ = E.length, this.s$ = M.length / 2 - 1;
    }
    const d = this.LV.polygonStyleSolid(i), f = this.LV.polygonStylePaletted(i), p = this.LV.polygonStyleIndividual(i), g = this.LV.polygonStyleRadialGradient(i), y = this.LV.polygonStyleLinearGradient(i), m = this.LV.polygonStyleImage(i), A = d || f || y || g || m || p, v = this.LV.lineStyleSolid(u), b = this.LV.lineStyleDashed(i), w = v || b, k = this.LV.lineStyleFilled(u), R = k, L = w && Math.max(w.getThickness(), 0);
    if ((i || u || e) && (this.ON.fill = A ? { shader: this.WD.SR(K["2D"], d && K.Color({ dataType: "uniform" }), y && K.Color({ dataType: ["gradient", y] }), g && K.Color({ dataType: ["gradient", g] }), f && K.Color({ dataType: ["lookup", f.getLookUpProperty(), f.lut] }), p && K.Color({ dataType: "attribute" }), m && K.Color({ dataType: ["image", m] }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), K.AttributeHighlight), mousePicking: t ? { shader: this.WD.SR(K["2D"], K.MousePicking({ useAttribute: !0 }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), K.AttributeHighlight) } : void 0, fillStyleSolid: d, fillStyleLinearGradient: y, fillStyleRadialGradient: g, fillStylePaletted: f, fillStyleImage: m, fillStyleIndividual: p } : void 0, this.ON.border = w && R && typeof L == "number" && L !== 0 ? { shader: this.WD.SR(K["2D"], K.Color({ dataType: "uniform" }), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), this.EN ? K.AliasedEdge : void 0, b && K.StippleTextureInstanced, K.AttributeHighlight), geometry: Bo(this.WD, L), mousePicking: t ? { shader: this.WD.SR(K["2D"], K.MousePicking({ useAttribute: !0 }), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), b && K.StippleTextureInstanced, K.AttributeHighlight) } : void 0, fillStyleSolid: k, lineStyleDashed: b, thickness: L } : void 0), s || o) {
      const x = c.reduce(((S, E) => S + E.Au.length + 2), 0), M = new Float32Array(x);
      let C = 0;
      c.forEach(((S) => {
        const E = S.Au.length + 2;
        for (let T = C; T < C + E; T += 1) M[T] = S.gi;
        C += E;
      })), this.e$ = this.WD.pO(M, !0, this.e$);
    }
    if (t) {
      if (o) {
        const x = c.reduce(((S, E) => S + E.Au.length + 2), 0), M = new Float32Array(x);
        let C = 0;
        c.forEach(((S) => {
          const E = S.Au.length + 2;
          for (let T = C; T < C + E; T += 1) M[T] = S.qG;
          C += E;
        })), this.r$ = this.WD.pO(M, !1, this.r$);
      }
    } else this.r$ && (this.WD.LO(this.r$), this.r$ = void 0);
    if (n || o && f && f.getLookUpProperty() === "value") {
      const x = c.reduce(((E, T) => E + T.Au.length + 2), 0), M = new Float32Array(x);
      let C = 0;
      const S = { min: wt, max: Pt };
      c.forEach(((E) => {
        const T = E.M !== void 0 ? E.M : ju, I = E.Au.length + 2;
        for (let F = C; F < C + I; F += 1) M[F] = T;
        C += I, E.M !== void 0 && (S.min = Math.min(S.min, T), S.max = Math.max(S.max, T));
      })), this.h$ = S, this.n$ = this.WD.pO(M, !1, this.n$);
    }
    if (a || o && p) {
      const x = c.reduce(((E, T) => E + T.Au.length + 2), 0), M = new Uint32Array(x);
      let C = 0;
      const S = p ? p.getFallbackColor().toUint32() : ya.toUint32();
      c.forEach(((E) => {
        const T = E.KG !== void 0 ? E.KG : S, I = E.Au.length + 2;
        for (let F = C; F < C + I; F += 1) M[F] = T;
        C += I;
      })), this.o$ = this.WD.pO(M, !1, this.o$, Uint32Array);
    }
    if (g ? this.VV = Ws(this.Ai || this.gu, this.ai, g.getPosition(), g.getExtent(), g.getShape(), this.WD.rO()) : y ? this.NV = Gs(this.Ai || this.gu, this.ai, y.getAngle(!0), this.WD.rO()) : (this.VV = void 0, this.NV = void 0), b) {
      if (o) {
        const x = c.reduce(((S, E) => S + E.Au.length), 2 * c.length), M = new Float32Array(2 * x);
        let C = 0;
        c.forEach(((S) => {
          let E = S.Au[0], T = 0, I = 0;
          for (const F of S.Au) T += Math.abs(F.x - E.x), I += Math.abs(F.y - E.y), M[C] = T, M[C + 1] = I, C += 2, E = F;
          M[C + 0] = T + Math.abs(S.Au[0].x - E.x), M[C + 1] = I + Math.abs(S.Au[0].y - E.y), M[C + 2] = Number.NaN, M[C + 3] = Number.NaN, C += 4;
        })), this.zN = this.WD.pO(M, !1, this.zN);
      }
      this.VN = this.WD.Yz(b.getPattern());
    } else this.zN && (this.WD.LO(this.zN), this.zN = void 0), this.VN = void 0;
    return this.a$ = this.WD.Qz(this, this.a$, m, void 0, o || l || this.ai.ei(), ((x, M, C) => this.l$(x, M, C, c))), this.XG = !1, this.ZG = !1, this.YG = !1, this.HG = !1, this.WG = !1, this.ui.u = !1, this.Ml(this.Ke), this.Cl(h), this;
  }
  wi() {
    return this.h$;
  }
  Ec(t, e) {
    var i, s;
    const { fill: o, border: n } = this.ON, a = this.RN, l = this.e$, h = this.r$;
    if (!a || !l) return {};
    if (o) {
      const { fillStyleSolid: u, fillStyleLinearGradient: c, fillStyleRadialGradient: d, fillStylePaletted: f, fillStyleImage: p, fillStyleIndividual: g } = o, y = this.t$, m = this.i$, A = t === 1 ? (i = o.mousePicking) === null || i === void 0 ? void 0 : i.shader : o.shader;
      A && a && y && m !== void 0 && this.WD.pd(A).SO(A, ((v, b, w, k) => {
        if (this.ai instanceof we || this.ai instanceof zs ? this.WD.xO(v("uScale"), this.SE.wO()).xO(v("uDisp"), this.SE.kO()).xO(k("uScaleStart_highpart"), this.SE.tV()).xO(k("uScaleStart_lowpart"), this.SE.iV()) : this.ai instanceof Ti && this.WD.xO(k("uScaleStart"), this.SE.MixedScaleXY.uScaleStart).xO(k("uScaleStartLog"), this.SE.MixedScaleXY.uScaleStartLog).xO(k("uScaleInterval"), this.SE.MixedScaleXY.uScaleInterval).xO(k("uScaleIntervalLog"), this.SE.MixedScaleXY.uScaleIntervalLog).xO(v("uViewportStart"), this.SE.MixedScaleXY.uViewportStart).xO(v("uViewportSize"), this.SE.MixedScaleXY.uViewportSize), this.WD.Ez(w, a, this.ai.Nt(), void 0).az(y).oz(b("aIsHighlighted"), l).gP(v("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(v("uRenderEffectMask"), t === 2 ? 1 : 0), t === 1) {
          if (this.WD.XO(v("uFirstId"), e), !h) return !1;
          this.WD.oz(b("aPickingIdOffset"), h);
        } else if (u) this.WD.gP(v("uColor"), u.getColor());
        else if (d) {
          if (!this.VV) return !1;
          this.WD.Pz(w, this.VV, d);
        } else if (c) {
          if (!this.NV) return !1;
          this.WD.Lz(w, this.NV, c);
        } else if (f) {
          const R = er(f, this, this.h$);
          if (!R && f.lut.percentageValues) return !1;
          if (this.WD.Jz(w, f.lut, R), f.getLookUpProperty() === "value") {
            if (!this.n$) return !1;
            this.WD.oz(b("aLookupValue"), this.n$);
          }
        } else if (p) {
          if (!this.a$) return !1;
          this.WD.gP(k("uColor"), p.getSurroundingColor()).MO(v(mr), this.a$.texture.iO() || this.a$.sourceMissingTexture, 0).bO(this.a$.texCoordsBuffer, void 0, { location: b("aTextureCoord"), size: 2 }).ZO(p.fitMode);
        } else if (g) {
          if (!this.o$) return !1;
          const R = b("aColor");
          this.WD.gl.bindBuffer(this.WD.gl.ARRAY_BUFFER, this.o$), this.WD.gl.vertexAttribPointer(R, 4, this.WD.gl.UNSIGNED_BYTE, !0, 0, 0), this.WD.gl.enableVertexAttribArray(R);
        }
        return this.WD.uz(m, void 0, void 0, this.WD.gl.UNSIGNED_INT), !0;
      }));
    }
    if (n) {
      const { geometry: u, fillStyleSolid: c, thickness: d, lineStyleDashed: f } = n, p = this.s$, g = t === 1 ? (s = n.mousePicking) === null || s === void 0 ? void 0 : s.shader : n.shader;
      g && a && p && this.WD.pd(g).SO(g, ((y, m, A, v) => {
        if (this.ai instanceof we || this.ai instanceof zs ? this.WD.xO(y("uScale"), this.SE.wO()).xO(y("uDisp"), this.SE.kO()).xO(v("uScaleStart_highpart"), this.SE.tV()).xO(v("uScaleStart_lowpart"), this.SE.iV()) : this.ai instanceof Ti && this.WD.xO(v("uScaleStart"), this.SE.MixedScaleXY.uScaleStart).xO(v("uScaleStartLog"), this.SE.MixedScaleXY.uScaleStartLog).xO(v("uScaleInterval"), this.SE.MixedScaleXY.uScaleInterval).xO(v("uScaleIntervalLog"), this.SE.MixedScaleXY.uScaleIntervalLog).xO(y("uViewportStart"), this.SE.MixedScaleXY.uViewportStart).xO(y("uViewportSize"), this.SE.MixedScaleXY.uViewportSize), this.WD.bO(l, 1, { location: m("aIsHighlighted"), size: 1 }).gP(y("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(y("uRenderEffectMask"), t === 2 ? 1 : 0), t === 1) {
          if (this.WD.XO(y("uFirstId"), e), !h) return !1;
          this.WD.oz(m("aPickingIdOffset"), h, 1);
        } else c && this.WD.gP(y("uColor"), c.getColor());
        if (f) {
          if (!this.VN || !this.zN) return !1;
          Ts.FN(this.WD, A, this.zN, m("aLengthSoFarA"), m("aLengthSoFarB"), 2, 2, 0), this.WD.xO(y("uStippleCount"), [this.yi.Ft().x / this.VN.Zz, this.yi.Ft().y / this.VN.Zz])._O(v("uStippleTextureWidthLimiter"), this.VN.Xz / this.VN.Zz)._O(y("uStippleScale"), f.getPatternScale()).MO(y("uStippleTexture"), this.VN.Wz, 1);
        }
        return Ts.TN(this.ai.Nt(), this.WD, a, A, this.ai.Nt() ? 4 : 2, 0), Ts.Ec(this._V, u, A, this.EN && t !== 1, t === 1, d, p), !0;
      }));
    }
    return { idCount: this.ff.length };
  }
  l$(t, e, i, s) {
    const o = xt({ x: this.gu.min.x, y: this.gu.min.y }, this.ai, this.yi.ai), n = xt({ x: this.gu.max.x, y: this.gu.max.y }, this.ai, this.yi.ai), a = { x: Math.abs(o.x - n.x), y: Math.abs(o.y - n.y) }, l = Ah(t, e, a.x, a.y, i), h = l[1], u = l[4], c = l[6], d = l[7], f = s.reduce(((b, w) => b + w.Au.length + 2), 0), p = new Float32Array(2 * f), g = this.gu.max.x - this.gu.min.x, y = this.gu.max.y - this.gu.min.y, m = u - c, A = d - h;
    let v = 0;
    for (const b of s) {
      for (const R of b.Au) {
        const L = c + m * ((R.x - this.gu.min.x) / g), x = h + A * ((R.y - this.gu.min.y) / y);
        p[v] = L, p[v + 1] = x, v += 2;
      }
      const w = c + m * ((b.Au[0].x - this.gu.min.x) / g), k = h + A * ((b.Au[0].y - this.gu.min.y) / y);
      p[v] = w, p[v + 1] = k, v += 2, p[v] = Number.NaN, p[v + 1] = Number.NaN, v += 2;
    }
    return p;
  }
  Oc(t, e, i, s, o) {
    return { collectionMember: this.ff.find(((n) => e + n.qG === t)) };
  }
  Rc() {
    return this.t$ && (this.WD.LO(this.t$), this.t$ = void 0), this.RN && (this.WD.LO(this.RN), this.RN = void 0), this.e$ && (this.WD.LO(this.e$), this.e$ = void 0), this.r$ && (this.WD.LO(this.r$), this.r$ = void 0), this.n$ && (this.WD.LO(this.n$), this.n$ = void 0), this.o$ && (this.WD.LO(this.o$), this.o$ = void 0), this.zN && (this.WD.LO(this.zN), this.zN = void 0), this.ON = { fill: void 0, border: void 0 }, this.a$ = this.WD.Kz(this, this.a$), this;
  }
  Wi() {
    return this.gu.max.x;
  }
  Hi() {
    return this.gu.min.x;
  }
  Zi() {
    return this.gu.max.y;
  }
  Xi() {
    return this.gu.min.y;
  }
  mu() {
    return qi(this.qe);
  }
  Su() {
    return qi(this.qe);
  }
}
class $M extends kb {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.SE = new Fs(), this.u$ = Ie, this.LV = ss({ fillStyleSolid: () => de(this.Ke) && this.Ke, fillStyleRadialGradient: () => li(this.Ke) && this.Ke, fillStyleLinearGradient: () => hi(this.Ke) && this.Ke, fillStyleImage: () => cn(this.Ke) && this.Ke, strokeStyleSolid: () => Oi(this.qe) && this.qe, strokeFillSolid: () => {
      const n = this.qe.getFillStyle();
      return de(n) && n;
    }, strokeFillLinearGradient: () => {
      const n = this.qe.getFillStyle();
      return hi(n) && n;
    }, strokeFillRadialGradient: () => {
      const n = this.qe.getFillStyle();
      return li(n) && n;
    } }), this.l$ = (n, a, l) => {
      const h = xt(this.Xl(), this.ai, this.yi.ai), u = oi(xt(qt(this.Xl(), this.Ft()), this.ai, this.yi.ai), h);
      return Ah(n, a, u.x, u.y, l);
    }, this._V = t, this.wV = e, this.WD = t.kV(), this.wV = e;
  }
  Uh() {
    super.Uh();
    const t = this.ui.T(), e = this.ml(), i = this.Rn.u || this.j.u || this.Dl.u || this.Rl.u, s = this.qe, o = this._l(), n = s.getThickness(), a = this.Dl.T();
    this.SE.TO(this.ai);
    const l = this.ai.ei();
    if (i) {
      const b = this.j.T();
      this.Au = (function(k, R, L, x, M) {
        const C = ((S, E, T) => [S, j(S.x + E, S.y), j(S.x + E, S.y + T), j(S.x, S.y + T)])(k, R, L);
        if (x !== 0 || x % 360 != 0) {
          const S = x * Math.PI / 180;
          C[0] = Un(C[0], M, S), C[1] = Un(C[1], M, S), C[2] = Un(C[2], M, S), C[3] = Un(C[3], M, S);
        }
        return C;
      })(this.Rn.T(), b.x, b.y, a, this.Rl.T());
      const w = ks(this.Au, this.ai.Nt());
      this.EV = this.WD.pO(w, !1, this.EV), this.OV = this.Au.length, this.u$ = Vi(this.Au);
    }
    const h = this.LV.fillStyleSolid(e), u = this.LV.fillStyleRadialGradient(e), c = this.LV.fillStyleLinearGradient(e), d = this.LV.fillStyleImage(e), f = h || u || c || d;
    e && (this.GV = f ? this.WD.SR(K["2D"], h && K.Color({ dataType: "uniform" }), c && K.Color({ dataType: ["gradient", c] }), u && K.Color({ dataType: ["gradient", u] }), d && K.Color({ dataType: ["image", d] }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0), u ? this.VV = Ws(this.Ai || this.u$, this.ai, u.getPosition(), u.getExtent(), u.getShape(), this.WD.rO()) : c ? this.NV = Gs(this.Ai || this.u$, this.ai, c.getAngle(!0), this.WD.rO()) : (this.VV = void 0, this.NV = void 0), this.a$ = this.WD.Qz(this, this.a$, d, void 0, l || i, this.l$);
    const p = this.LV.strokeStyleSolid(o), g = this.LV.strokeFillSolid(o), y = this.LV.strokeFillLinearGradient(o), m = this.LV.strokeFillRadialGradient(o), A = p, v = g || y || m;
    if (A && (i || o || l && n !== 1)) {
      if (n === 1 || n === -1) [this.$V, this.c$] = [this.Au, void 0];
      else {
        const b = this.ai;
        [this.$V, this.c$] = b instanceof Ti ? ((w, k, R) => {
          const L = w[0], x = w[1], M = w[2], C = w[3], S = k / 2;
          return [[R.oi(L, x, S, -S), R.oi(x, L, -S, -S), R.oi(C, M, -S, -S), R.oi(M, C, S, -S), R.oi(L, x, -S, S), R.oi(x, L, S, S), R.oi(C, M, S, S), R.oi(M, C, -S, S)], [0, 4, 5, 0, 5, 1, 1, 5, 7, 1, 3, 7, 3, 7, 6, 3, 2, 6, 2, 4, 0, 2, 6, 4]];
        })(this.Au, n, b) : ((w, k, R) => {
          const L = w[0], x = w[1], M = w[2], C = w[3], S = j(k.x * R * 0.5, k.y * R * 0.5), E = Os(J0(x, L)), T = Os(J0(C, L)), I = Q0(E), F = Q0(T);
          return [[qt(L, qt(pe(I, S.x), pe(F, S.y))), qt(x, qt(pe(E, S.x), pe(F, S.y))), qt(C, qt(pe(I, S.x), pe(T, S.y))), qt(M, qt(pe(E, S.x), pe(T, S.y))), qt(L, qt(pe(E, S.x), pe(T, S.y))), qt(x, qt(pe(I, S.x), pe(T, S.y))), qt(C, qt(pe(E, S.x), pe(F, S.y))), qt(M, qt(pe(I, S.x), pe(F, S.y)))], [0, 4, 5, 0, 5, 1, 1, 5, 7, 1, 3, 7, 3, 7, 6, 3, 2, 6, 2, 4, 0, 2, 6, 4]];
        })(this.Au, b.ni(), n);
      }
      this.jV = this.WD.pO(ks(this.$V, this.ai.Nt()), !1, this.jV), this.c$ ? (this.wN = this.WD.iz(new Uint16Array(this.c$), this.wN), this.UV = this.c$.length) : (this.wN && this.WD.LO(this.wN), this.wN = void 0, this.UV = this.$V.length);
    }
    return o && (this.JV = A && v ? this.WD.SR(K["2D"], K.Color({ dataType: m ? ["gradient", m] : y ? ["gradient", y] : "uniform" }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0), m ? this.XV = Ws(this.u$, this.ai, m.getPosition(), m.getExtent(), m.getShape(), this.WD.rO()) : y ? this.ZV = Gs(this.u$, this.ai, y.getAngle(!0), this.WD.rO()) : (this.XV = void 0, this.ZV = void 0), this.QV = t && f ? this.QV || this.WD.SR(K["2D"], K.MousePicking(), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0, this.KV = t && this.qe !== Et ? this.KV || this.WD.SR(K["2D"], K.MousePicking(), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0, this.Ml(this.Ke), this.Cl(s), this.Rn.u = !1, this.Dl.u = !1, this.j.u = !1, this.Rl.u = !1, this;
  }
  Ec(t, e) {
    const i = t === 1 ? this.QV : this.GV, s = this.EV, o = this.OV, n = this.LV.fillStyleSolid(!1), a = this.LV.fillStyleRadialGradient(!1), l = this.LV.fillStyleLinearGradient(!1), h = this.LV.fillStyleImage(!1);
    i && s && o && this.Ke !== Lt && (this.WD.pd(i), this.WD.SO(i, ((y, m, A, v) => {
      if (this.ai instanceof we || this.ai instanceof zs ? this.WD.xO(y("uScale"), this.SE.wO()).xO(y("uDisp"), this.SE.kO()).xO(v("uScaleStart_highpart"), this.SE.tV()).xO(v("uScaleStart_lowpart"), this.SE.iV()) : this.ai instanceof Ti && this.WD.xO(v("uScaleStart"), this.SE.MixedScaleXY.uScaleStart).xO(v("uScaleStartLog"), this.SE.MixedScaleXY.uScaleStartLog).xO(v("uScaleInterval"), this.SE.MixedScaleXY.uScaleInterval).xO(v("uScaleIntervalLog"), this.SE.MixedScaleXY.uScaleIntervalLog).xO(y("uViewportStart"), this.SE.MixedScaleXY.uViewportStart).xO(y("uViewportSize"), this.SE.MixedScaleXY.uViewportSize), t === 1) this.WD.XO(y("uFirstId"), e).$z(A, 1);
      else if (n) this.WD.gP(y("uColor"), n.getColor());
      else if (a) {
        if (!this.VV) return !1;
        this.WD.Pz(A, this.VV, a);
      } else if (l) {
        if (!this.NV) return !1;
        this.WD.Lz(A, this.NV, l);
      } else if (h) {
        if (!this.a$) return !1;
        const b = this.a$ && this.a$.texture.iO();
        this.WD.gP(v("uColor"), h.getSurroundingColor()).MO(y(mr), b || this.a$.sourceMissingTexture, 0).bO(this.a$.texCoordsBuffer, void 0, { location: m("aTextureCoord"), size: 2 }).ZO(h.fitMode);
      }
      return this.WD._O(y("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(y("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(y("uRenderEffectMask"), t === 2 ? 1 : 0).Ez(A, s, this.ai.Nt(), void 0).dC(this.WD.gl.TRIANGLE_FAN, o), !0;
    })));
    const u = t === 1 ? this.KV : this.JV, c = this.LV.strokeStyleSolid(!1), d = this.LV.strokeFillSolid(!1), f = this.LV.strokeFillLinearGradient(!1), p = this.LV.strokeFillRadialGradient(!1), g = this.jV;
    return u && g && c && (this.WD.pd(u), this.WD.SO(u, ((y, m, A, v) => {
      if (this.ai instanceof we || this.ai instanceof zs ? this.WD.xO(y("uScale"), this.SE.wO()).xO(y("uDisp"), this.SE.kO()).xO(v("uScaleStart_highpart"), this.SE.tV()).xO(v("uScaleStart_lowpart"), this.SE.iV()) : this.ai instanceof Ti && this.WD.xO(v("uScaleStart"), this.SE.MixedScaleXY.uScaleStart).xO(v("uScaleStartLog"), this.SE.MixedScaleXY.uScaleStartLog).xO(v("uScaleInterval"), this.SE.MixedScaleXY.uScaleInterval).xO(v("uScaleIntervalLog"), this.SE.MixedScaleXY.uScaleIntervalLog).xO(y("uViewportStart"), this.SE.MixedScaleXY.uViewportStart).xO(y("uViewportSize"), this.SE.MixedScaleXY.uViewportSize), t === 1) this.WD.XO(y("uFirstId"), e).$z(A, 1);
      else if (d) this.WD.gP(y("uColor"), d.getColor());
      else if (p) {
        if (!this.XV) return !1;
        this.WD.Pz(A, this.XV, p);
      } else if (f) {
        if (!this.ZV) return !1;
        this.WD.Lz(A, this.ZV, f);
      }
      return this.WD._O(y("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(y("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(y("uRenderEffectMask"), t === 2 ? 1 : 0).Ez(A, g, this.ai.Nt(), void 0), this.wN ? this.WD.az(this.wN).uz(this.UV) : this.WD.dC(this.WD.gl.LINE_LOOP, this.UV), !0;
    }))), { idCount: 1 };
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  Rc() {
    return this.wN && (this.WD.LO(this.wN), this.wN = void 0), this.EV && (this.WD.LO(this.EV), this.EV = void 0), this.jV && (this.WD.LO(this.jV), this.jV = void 0), this.a$ = this.WD.Kz(this, this.a$), this.GV = void 0, this.JV = void 0, this.QV = void 0, this.KV = void 0, this;
  }
  Wi() {
    return Math.max(this.Rn.T().x, this.Rn.T().x + this.j.T().x);
  }
  Hi() {
    return Math.min(this.Rn.T().x, this.Rn.T().x + this.j.T().x);
  }
  Zi() {
    return Math.max(this.Rn.T().y, this.Rn.T().y + this.j.T().y);
  }
  Xi() {
    return Math.min(this.Rn.T().y, this.Rn.T().y + this.j.T().y);
  }
  mu() {
    return qi(this.qe);
  }
  Su() {
    return qi(this.qe);
  }
}
class XM extends Db {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.SE = new Fs(), this.LV = ss({ fillStyleSolid: () => de(this.Ke) && this.Ke, fillStylePaletted: () => Ve(this.Ke) && this.Ke, fillStyleRadialGradient: () => li(this.Ke) && this.Ke, fillStyleLinearGradient: () => hi(this.Ke) && this.Ke, fillStyleImage: () => cn(this.Ke) && this.Ke, strokeLineStyleSolid: () => Oi(this.qe) && this.qe, strokeLineSolidFill: () => {
      const n = this.qe.getFillStyle();
      return de(n) && n;
    }, strokeLinearGradientFill: () => {
      const n = this.qe.getFillStyle();
      return hi(n) && n;
    }, strokeRadialGradientFill: () => {
      const n = this.qe.getFillStyle();
      return li(n) && n;
    } }), this.l$ = (n, a, l) => {
      const h = xt({ x: this.gu.min.x, y: this.gu.min.y }, this.ai, this.yi.ai), u = xt({ x: this.gu.max.x, y: this.gu.max.y }, this.ai, this.yi.ai), c = { x: Math.abs(h.x - u.x), y: Math.abs(h.y - u.y) }, d = Ah(n, a, c.x, c.y, l), f = d[1], p = d[4], g = d[6], y = d[7], m = new Float32Array(2 * this.Au.length), A = this.gu.max.x - this.gu.min.x, v = this.gu.max.y - this.gu.min.y, b = p - g, w = y - f;
      let k = 0;
      for (const R of this.Au) {
        const L = g + b * ((R.x - this.gu.min.x) / A), x = f + w * ((R.y - this.gu.min.y) / v);
        m[k] = L, m[k + 1] = x, k += 2;
      }
      return m;
    }, this._V = t, this.wV = e, this.WD = t.kV(), this.wV = e;
  }
  Rd(t) {
    let e, i = Number.MAX_VALUE;
    for (const s of this.Au) {
      const o = ws(xt(s, this.ai, this.yi.ai), t);
      o < i && (i = o, e = s);
    }
    return e;
  }
  Uh() {
    const t = this.ui.T(), e = this.ml(), i = this.vu, s = this.Au.length >= 3, o = this.qe, n = this._l(), a = o.getThickness(), l = this.kl(a);
    this.SE.TO(this.ai), this.le = this.ai.ni();
    const h = this.ai.ei();
    if (i && (this.gu = Vi(this.Au)), i && s) {
      const k = ks(this.Au, this.ai.Nt());
      this.EV = this.WD.pO(k, !1, this.EV), this.d$ = new Uint16Array(vm(k)), this.f$ = this.WD.iz(this.d$, this.f$), this.OV = this.d$.length;
    }
    const u = this.LV.fillStyleSolid(e), c = this.LV.fillStylePaletted(e), d = this.LV.fillStyleRadialGradient(e), f = this.LV.fillStyleLinearGradient(e), p = this.LV.fillStyleImage(e), g = u || c && c.getLookUpProperty() !== "value" && c || f || d || p;
    if (e && (this.GV = g ? this.WD.SR(K["2D"], u && K.Color({ dataType: "uniform" }), f && K.Color({ dataType: ["gradient", f] }), d && K.Color({ dataType: ["gradient", d] }), c && K.Color({ dataType: ["lookup", c.getLookUpProperty(), c.lut] }), p && K.Color({ dataType: ["image", p] }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0), d ? this.VV = Ws(this.Ai || this.gu, this.ai, d.getPosition(), d.getExtent(), d.getShape(), this.WD.rO()) : f ? this.NV = Gs(this.Ai || this.gu, this.ai, f.getAngle(!0), this.WD.rO()) : (this.VV = void 0, this.NV = void 0), this.a$ = this.WD.Qz(this, this.a$, p, void 0, h || i, this.l$), (i || l || h && a !== 1) && s) {
      const k = a === 1 || a === -1 ? this.Au : qx(this.Au, this.le, a);
      this.$V = ks(k, this.ai.Nt()), this.jV = this.WD.pO(this.$V, !0, this.jV), this.UV = k.length;
    }
    const y = this.LV.strokeLineStyleSolid(n), m = this.LV.strokeLineSolidFill(n), A = this.LV.strokeLinearGradientFill(n), v = this.LV.strokeRadialGradientFill(n), b = y, w = m || A || v;
    return n && (this.JV = b && w ? this.WD.SR(K["2D"], K.Color({ dataType: v ? ["gradient", v] : A ? ["gradient", A] : "uniform" }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0), v ? this.XV = Ws(this.Ai || this.gu, this.ai, v.getPosition(), v.getExtent(), v.getShape(), this.WD.rO()) : A ? this.ZV = Gs(this.Ai || this.gu, this.ai, A.getAngle(!0), this.WD.rO()) : (this.XV = void 0, this.ZV = void 0), this.QV = t && g ? this.QV || this.WD.SR(K["2D"], K.MousePicking(), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0, this.KV = t && this.qe !== Et ? this.QV || this.WD.SR(K["2D"], K.MousePicking(), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) : void 0, this.vu = !1, this.Ml(this.Ke), this.Cl(o), this;
  }
  Ec(t, e) {
    const i = t === 1 ? this.QV : this.GV, s = this.EV, o = this.OV, n = this.LV.fillStyleSolid(!1), a = this.LV.fillStyleRadialGradient(!1), l = this.LV.fillStyleLinearGradient(!1), h = this.LV.fillStylePaletted(!1), u = this.LV.fillStyleImage(!1);
    i && s && o && this.WD.pd(i).SO(i, ((g, y, m, A) => {
      if (this.WD.xO(g("uScale"), this.SE.wO()).xO(g("uDisp"), this.SE.kO()).xO(A("uScaleStart_highpart"), this.SE.tV()).xO(A("uScaleStart_lowpart"), this.SE.iV()).Ez(m, s, this.ai.Nt(), void 0).az(this.f$)._O(g("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(g("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(g("uRenderEffectMask"), t === 2 ? 1 : 0), t === 1) this.WD.XO(g("uFirstId"), e).$z(m, 1);
      else if (n) this.WD.gP(g("uColor"), n.getColor());
      else if (a) {
        if (!this.VV) return !1;
        this.WD.Pz(m, this.VV, a);
      } else if (l) {
        if (!this.NV) return !1;
        this.WD.Lz(m, this.NV, l);
      } else if (h) {
        const v = er(h, this, void 0);
        if (!v && h.lut.percentageValues) return !1;
        this.WD.Jz(m, h.lut, v);
      } else if (u) {
        if (!this.a$) return !1;
        this.WD.gP(A("uColor"), u.getSurroundingColor()).MO(g(mr), this.a$.texture.iO() || this.a$.sourceMissingTexture, 0).bO(this.a$.texCoordsBuffer, void 0, { location: y("aTextureCoord"), size: 2 }).ZO(u.fitMode);
      }
      return this.WD.uz(this.OV), !0;
    }));
    const c = t === 1 ? this.KV : this.JV, d = this.qe, f = this.jV, p = this.UV;
    return c && f && p && this.WD.pd(c).SO(c, ((g, y, m, A) => {
      this.WD._O(g("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(g("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(g("uRenderEffectMask"), t === 2 ? 1 : 0).xO(g("uScale"), this.SE.wO()).xO(g("uDisp"), this.SE.kO()).Ez(m, f, this.ai.Nt(), void 0);
      const v = d.getFillStyle();
      if (t === 1) this.WD.XO(g("uFirstId"), e).$z(m, 1);
      else if (de(v)) this.WD.gP(g("uColor"), v.getColor());
      else if (li(v)) {
        if (!this.XV) return !1;
        this.WD.Pz(m, this.XV, v);
      } else if (hi(v)) {
        if (!this.ZV) return !1;
        this.WD.Lz(m, this.ZV, v);
      }
      const b = d.getThickness(), w = b === -1 || b === 1;
      return this.WD.dC(w ? this.WD.gl.LINE_LOOP : this.WD.gl.TRIANGLE_STRIP, this.UV), !0;
    })), { idCount: 1 };
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  Rc() {
    return this.f$ && (this.WD.LO(this.f$), this.f$ = void 0), this.EV && (this.WD.LO(this.EV), this.EV = void 0), this.jV && (this.WD.LO(this.jV), this.jV = void 0), this.GV = void 0, this.JV = void 0, this.QV = void 0, this.KV = void 0, this.a$ = this.WD.Kz(this, this.a$), this;
  }
}
class ZM extends Ja {
  constructor(t) {
    super(t);
    const { vertices: e, drawMode: i, drawSize: s } = this.MN();
    this._N = t.pO(e), this.kN = s, this.CN = i;
  }
  pd(t) {
    return this.WD.bO(this._N, 0, { location: t.attribute("aCurveOrBaseline"), size: 1 }, { location: t.attribute("aSegmentSide"), size: 1 }), this;
  }
  dC(t, e, i) {
    return this.WD.cz(e !== void 0 ? e : this.CN, i || 0, this.kN, t), this;
  }
  MN() {
    return { vertices: new Float32Array([1, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 0]), drawMode: this.WD.gl.TRIANGLES, drawSize: 6 };
  }
  GR() {
    this.WD.LO(this._N);
  }
}
const KM = (r) => {
  let t = r.VO.OR.get(void 0);
  return t || (t = new ZM(r), r.VO.OR.set(void 0, t), t);
};
class bi extends Ja {
  constructor(t, e, i, s, o) {
    super(t), this.CN = i, this.A$ = e.length, this.OD = t.pO(ks(e, !1)), this.g$ = s, o && (this.v$ = { ...o, OD: t.pO(o.NM, !1), A$: o.NM.length / 4 });
  }
  y$(t) {
    return t > 1;
  }
  dC(t, e, i, s, o, n) {
    return typeof o == "object" ? e ? this.WD.oz(t.attribute("aOffsetScale"), e, 1, i * Float32Array.BYTES_PER_ELEMENT).xO(t.uniform(Lu), [o.width, o.height]) : this.WD._O(t.uniform("uOffsetScale"), o.scale).xO(t.uniform(Lu), [o.width, o.height]) : n ? e ? this.WD.oz(t.attribute(`${bi.p$}Amount`), e, 1, i * Float32Array.BYTES_PER_ELEMENT) : this.WD._O(t.uniform(`${bi.p$}Amount`), o) : this.WD._O(t.uniform("uPointSize"), o), n ? this.WD.bO(this.OD, 0, { location: t.attribute(bi.p$), size: 2 }).cz(this.CN, 0, this.A$, s) : this.WD.dC(this.WD.gl.POINTS, s), this;
  }
  m$(t, e, i, s, o, n) {
    return !(!this.v$ || !o || (e ? this.WD.oz(t.attribute(`${bi.p$}Amount`), e, 1) : this.WD._O(t.uniform(`${bi.p$}Amount`), s), this.WD._O(t.uniform(`${bi.S$}Amount`), n).bO(this.v$.OD, 0, { location: t.attribute(bi.p$), size: 2 }, { location: t.attribute(bi.S$), size: 2 }).cz(this.v$.CN, 0, this.v$.A$, i), 0));
  }
  GR() {
    var t;
    this.WD.LO(this.OD), this.WD.LO((t = this.v$) === null || t === void 0 ? void 0 : t.OD);
  }
}
bi.p$ = "aFillOffset", bi.S$ = "aBorderOffset";
const Fp = (r, t = 0) => {
  const e = [j(-0.5, -0.5), j(0.5, -0.5), j(0.5, 0.5), j(-0.5, 0.5)];
  return new bi(r, e, r.gl.TRIANGLE_FAN, t, { NM: [-0.5, -0.5, 0, 0, -0.5, -0.5, -1, -1, 0.5, -0.5, 0, 0, 0.5, -0.5, 1, -1, 0.5, 0.5, 0, 0, 0.5, 0.5, 1, 1, -0.5, 0.5, 0, 0, -0.5, 0.5, -1, 1, -0.5, -0.5, 0, 0, -0.5, -0.5, -1, -1], CN: r.gl.TRIANGLE_STRIP });
}, Lp = (r, t = 0) => {
  const i = [j(-0.5, -0.05), j(0.5, -0.05), j(0.5, 0.05), j(0.5, 0.05), j(-0.5, 0.05), j(-0.5, -0.05), j(-0.05, -0.5), j(0.05, -0.5), j(0.05, -0.05), j(0.05, -0.05), j(-0.05, -0.05), j(-0.05, -0.5), j(-0.05, 0.5), j(0.05, 0.5), j(0.05, 0.05), j(0.05, 0.05), j(-0.05, 0.05), j(-0.05, 0.5)];
  return new bi(r, i, r.gl.TRIANGLES, t, { NM: [-0.05, 0.5, 0, 0, -0.05, 0.5, -1, 1, 0.05, 0.5, 0, 0, 0.05, 0.5, 1, 1, 0.05, 0.05, 0, 0, 0.05, 0.05, 1, 1, 0.5, 0.05, 0, 0, 0.5, 0.05, 1, 1, 0.5, -0.05, 0, 0, 0.5, -0.05, 1, -1, 0.05, -0.05, 0, 0, 0.05, -0.05, 1, -1, 0.05, -0.5, 0, 0, 0.05, -0.5, 1, -1, -0.05, -0.5, 0, 0, -0.05, -0.5, -1, -1, -0.05, -0.05, 0, 0, -0.05, -0.05, -1, -1, -0.5, -0.05, 0, 0, -0.5, -0.05, -1, -1, -0.5, 0.05, 0, 0, -0.5, 0.05, -1, 1, -0.05, 0.05, 0, 0, -0.05, 0.05, -1, 1, -0.05, 0.5, 0, 0, -0.05, 0.5, -1, 1], CN: r.gl.TRIANGLE_STRIP });
}, Qx = (r, t, e) => {
  if (Pn(r)) return Qx(Je.Square, t, e);
  let i = t.VO.BR.get(r);
  if (r === Je.Circle || r === Je.HollowCircle) {
    const s = e <= 3 ? 4 : e <= 5 ? 8 : e <= 10 ? 16 : 24;
    return r === Je.Circle ? (i = t.VO.DR.get(s) || ((o, n, a = 0) => {
      const l = 2 * Math.PI / n, h = [], u = [];
      h.push({ x: 0, y: 0 });
      for (let c = 0; c <= n; c += 1) {
        const d = c * l, f = Math.cos(d), p = Math.sin(d), g = 0.5 * f, y = 0.5 * p;
        h.push({ x: g, y }), u.push(g, y, 0, 0, g, y, f, p);
      }
      return new bi(o, h, o.gl.TRIANGLE_FAN, a, { NM: u, CN: o.gl.TRIANGLE_STRIP });
    })(t, s), t.VO.DR.set(s, i), i) : (i = t.VO.ER.get(s) || ((o, n, a = 0) => {
      const l = [], h = 2 * Math.PI / n;
      for (let u = 0; u <= n; u += 1) {
        const c = u * h, d = Math.cos(c), f = Math.sin(c);
        l.push({ x: 0.5 * d, y: 0.5 * f }), l.push({ x: 0.3 * d, y: 0.3 * f });
      }
      return new bi(o, l, o.gl.TRIANGLE_STRIP, a, void 0);
    })(t, s), t.VO.ER.set(s, i), i);
  }
  if (!i) {
    switch (r) {
      case Je.Triangle:
        i = ((s, o = 0) => {
          const n = [{ x: -0.5773502691892515, y: 0.3333333333333333 }, { x: 0, y: -0.6666666666666666 }, { x: 0.5773502691892515, y: 0.3333333333333333 }];
          return new bi(s, n, s.gl.TRIANGLES, o, { NM: [n[0].x, n[0].y, 0, 0, n[0].x, n[0].y, 2 * n[0].x, 2 * n[0].y, n[1].x, n[1].y, 0, 0, n[1].x, n[1].y, 2 * n[1].x, 2 * n[1].y, n[2].x, n[2].y, 0, 0, n[2].x, n[2].y, 2 * n[2].x, 2 * n[2].y, n[0].x, n[0].y, 0, 0, n[0].x, n[0].y, 2 * n[0].x, 2 * n[0].y], CN: s.gl.TRIANGLE_STRIP });
        })(t);
        break;
      case Je.Square:
        i = Fp(t);
        break;
      case Je.Plus:
        i = Lp(t);
        break;
      case Je.Cross:
        i = Lp(t, 45);
        break;
      case Je.Diamond:
        i = Fp(t, 45);
        break;
      case Je.Arrow:
        i = ((s, o = 0) => {
          const a = [j(-0.05, -0.5), j(0.05, -0.5), j(0.05, 0.45), j(0.05, 0.45), j(-0.05, 0.45), j(-0.05, -0.5), j(-0.5, 0), j(-0.4, 0), j(0, 0.4), j(0, 0.4), j(0, 0.5), j(-0.5, 0), j(0.5, 0), j(0.4, 0), j(0, 0.4), j(0, 0.4), j(0, 0.5), j(0.5, 0)];
          return new bi(s, a, s.gl.TRIANGLES, o, { NM: [-0.5, 0, 0, 0, -0.5, 0, -2, -1, 0, 0.5, 0, 0, 0, 0.5, 0, 1, 0.5, 0, 0, 0, 0.5, 0, 2, -1, 0.4, 0, 0, 0, 0.4, 0, 0, -1, 0.05, 0.355, 0, 0, 0.05, 0.355, 1, -2, 0.05, -0.5, 0, 0, 0.05, -0.5, 1, -1, -0.05, -0.5, 0, 0, -0.05, -0.5, -1, -1, -0.05, 0.355, 0, 0, -0.05, 0.355, -1, -2, -0.4, 0, 0, 0, -0.4, 0, 0, -1, -0.5, 0, 0, 0, -0.5, 0, -2, -1], CN: s.gl.TRIANGLE_STRIP });
        })(t);
        break;
      case Je.Star:
        i = ((s, o = 0) => new bi(s, [{ x: 0, y: 0 }, { x: 0, y: 0.5 }, { x: 0.1, y: 0.1 }, { x: 0.5, y: 0.1 }, { x: 0.2, y: -0.1 }, { x: 0.3, y: -0.5 }, { x: 0, y: -0.25 }, { x: -0.3, y: -0.5 }, { x: -0.2, y: -0.1 }, { x: -0.5, y: 0.1 }, { x: -0.1, y: 0.1 }, { x: 0, y: 0.5 }], s.gl.TRIANGLE_FAN, o, { NM: [0, 0.5, 0, 0, 0, 0.5, 0, 1, 0.1, 0.1, 0, 0, 0.1, 0.1, 1, 1, 0.5, 0.1, 0, 0, 0.5, 0.1, 2, 1, 0.2, -0.1, 0, 0, 0.2, -0.1, 1, -1, 0.3, -0.5, 0, 0, 0.3, -0.5, 1, -2, 0, -0.25, 0, 0, 0, -0.25, 0, -1, -0.3, -0.5, 0, 0, -0.3, -0.5, -1, -2, -0.2, -0.1, 0, 0, -0.2, -0.1, -1, -1, -0.5, 0.1, 0, 0, -0.5, 0.1, -2, 1, -0.1, 0.1, 0, 0, -0.1, 0.1, -1, 1, 0, 0.5, 0, 0, 0, 0.5, 0, 1], CN: s.gl.TRIANGLE_STRIP }))(t);
        break;
      case Je.Minus:
        i = ((s, o = 0) => {
          const a = [j(-0.5, -0.05), j(0.5, -0.05), j(0.5, 0.05), j(0.5, 0.05), j(-0.5, 0.05), j(-0.5, -0.05)];
          return new bi(s, a, s.gl.TRIANGLES, o, { NM: [-0.5, -0.05, 0, 0, -0.5, -0.05, -1, -1, 0.5, -0.05, 0, 0, 0.5, -0.05, 1, -1, 0.5, 0.05, 0, 0, 0.5, 0.05, 1, 1, -0.5, 0.05, 0, 0, -0.5, 0.05, -1, 1, -0.5, -0.05, 0, 0, -0.5, -0.05, -1, -1], CN: s.gl.TRIANGLE_STRIP });
        })(t);
        break;
      default:
        return Oa(0, "LightningChart JS unidentified point shape");
    }
    t.VO.BR.set(r, i);
  }
  return i;
};
class qM extends Ju {
  constructor(t, e, i, s) {
    super(t, e, i, s, [{ type: "DataPattern", args: { pattern: "ProgressiveX" } }]), this.b$ = Hi.fillStyle, this.x$ = le("bottom"), this.M$ = Hi.fillStyle, this._$ = Et, this.w$ = le(Je.Circle), this.k$ = le(5), this.C$ = le(0), this.T$ = le(void 0), this.sw = !0, this.F$ = { x: 0, y: 0 }, this.I$ = le(void 0);
  }
  ew(t) {
    return this.I$.C(t), this;
  }
  rw() {
    return this.I$.T();
  }
  bw(t) {
    this.x$.T() !== t && this.x$.C(t);
  }
  sf(t) {
    return this.b$ = ba(this.b$, t), this;
  }
  lw() {
    return this.b$;
  }
  P$() {
    return Ea(this.L$, this.b$);
  }
  B$() {
    return Ea(this.D$, this.M$);
  }
  E$() {
    return this._$ !== this.R$;
  }
  tf(t) {
    return this.M$ = ba(this.M$, t), cn(this.M$) && (this.rf(Je.Square), this.df(1)), this;
  }
  lf() {
    return this.M$;
  }
  uf(t) {
    return this._$ = typeof t == "function" ? t(this._$) : t, this;
  }
  cf() {
    return this._$;
  }
  rf(t) {
    return this.w$.C(t), Pn(this.w$.T()) && this.df(1), this;
  }
  hf() {
    return this.w$.T();
  }
  df(t) {
    return this.k$.C(t), this;
  }
  uw() {
    return this.k$.T();
  }
  nf(t) {
    return this.C$.C(t), this;
  }
  af() {
    return this.C$.T();
  }
  lg(t) {
    return this.F$ = t, this;
  }
  cw() {
    return this.F$;
  }
  dw(t) {
    return this.O$ = t, this;
  }
  fw() {
    return this.O$;
  }
  iw(t) {
    return this.T$.C(t), this;
  }
  Aw() {
    return this.T$.T();
  }
}
class JM extends ac {
  constructor(t, e, i) {
    super(t, e), this.nG = !1, this.oG = { z$: !1, V$: 0 }, this.Na = i, this.lG = t instanceof we ? { type: "linear", scale: t } : { type: "unknown" }, this.hG._i("DataPattern", ((s) => {
      s.allowDataGrouping === !1 && (this.nG = !0);
    })), this.yi = e.yi;
  }
  N$(t, e, i) {
    const s = t.Uc, o = t.Bd(e), n = t.Ld(e), a = o ? o[i] : void 0, l = n ? n[i] : void 0;
    if (!(l === void 0 || a === void 0 || s < 2)) return this.calculateAvgStepBetweenDataPoints(l, a, s);
  }
  G$(t, e, i) {
    var s, o, n;
    const a = this.Na.xD(this, "testWorker"), l = this.Na.CD(a);
    let h = [];
    const u = (p) => {
      var g;
      const y = gg(p);
      return !((g = l.bufferIds) === null || g === void 0) && g.includes(y) || (a.postMessage({ id: y, b: [p], i: [y] }), h.push(y)), y;
    }, c = u(e), d = u(i);
    let f;
    return h.length > 0 && this.Na.kD(a, { ...l, bufferIds: [...(s = l.bufferIds) !== null && s !== void 0 ? s : [], ...h] }), t.ed && (f = gg(t.ed.sab), !((o = l.controlBufferIds) === null || o === void 0) && o.includes(f) || (a.postMessage({ id: f, cb: t.ed.sab, i: f }), this.Na.kD(a, { ...l, controlBufferIds: [...(n = l.controlBufferIds) !== null && n !== void 0 ? n : [], f] }))), { worker: a, idProg: c, idValues: d, controlBufferId: f };
  }
  $$(t, e, i) {
    const s = t?.pd(e), o = s?.bd, n = s?.xd, a = t?.Uc, l = t?.$c, h = t?.yd(e);
    if (!t || this.nG || !h || this.lG.type !== "linear" || !o || !n || a === void 0 || l === void 0 || !i || !e) {
      const k = this.oG.z$;
      return this.oG = { z$: !1, V$: a ?? 0 }, { cpStateChanged: k, cpActive: !1 };
    }
    const u = js(h);
    (!this.U$ || this.U$.j$ === 0) && Al(o.buffer) && Al(n.buffer) && this.Na.bD() && this.G$(t, o.buffer, n.buffer);
    const c = !(!this.Y$ || !this.Y$.ready), d = this.N$(t, e, u);
    if (d === void 0 || Number.isNaN(d)) {
      const k = this.oG.z$;
      return this.oG = { z$: !1, V$: a ?? 0 }, { cpStateChanged: k, cpActive: !1 };
    }
    const f = this.lG.scale, p = Math.abs(f.ni()[u]), g = p / d, y = Math.floor(0.8 * g), m = y * d;
    if (Number.isNaN(m)) {
      const k = this.oG.z$;
      return this.oG = { z$: !1, V$: a ?? 0 }, { cpStateChanged: k, cpActive: !1 };
    }
    const A = y >= 4, v = this.oG.z$ ? this.oG.H$ / p < 1.5 : void 0, b = this.oG.z$ && y > this.oG.W$ ? y / this.oG.W$ >= 2 : void 0;
    let w;
    return this.oG.z$ === !0 ? v ? b && (w = { z$: !0, H$: m, W$: y, V$: a }) : w = A ? { z$: !0, H$: m, W$: y, V$: a } : { z$: !1, V$: a } : A && (w = { z$: !0, H$: m, W$: y, V$: a }), this.oG = w || { ...this.oG, V$: a }, w && this.fG(), { cpStateChanged: !(!c && !this.Y$ && !w), cpActive: this.oG.z$ };
  }
  X$(t, e) {
    var i, s, o;
    const n = t?.pd(e), a = n.dataPattern, l = n.bd, h = n.xd, u = t.jc, c = t.Uc, d = t.$c, f = t.Qc;
    if (this.nG || !this.oG.z$ || !l || !h || a === void 0 || this.lG.type !== "linear") return;
    const p = this.oG, g = js(a), y = Wn(a), m = g === "x" ? l : h, A = g === "x" ? h : l, v = m.length, b = g === "x" ? this.lG.scale.x : this.lG.scale.y, w = this.oG.H$, k = b.getPixelSize(), R = Math.min(b.Wt, b.Yt), L = Math.max(b.Wt, b.Yt), x = zf(R, L, m, u, c, d, Wn(a) ? "progressive" : "regressive", 1);
    if (!x) return;
    const M = m[x.iFirstSampleDataArray], C = !(!this.Y$ || !this.Y$.ready);
    if (this.Y$) if (this.Y$.ready) this.Y$ = void 0;
    else {
      if (this.Y$.config.H$ === p.H$) return this.Y$.Z$ ? (this.Y$.Z$.NM.J$ = !0, this.Q$(this.Y$.Z$, t, e, g, w, x, v, m, A, f, n), this.Y$.Z$.NM) : void 0;
      this.Y$.cancelled = !0, this.Y$ = void 0;
    }
    const S = m[x.iFirstSampleDataArray], E = m[x.iLastSampleDataArray], T = !!this.U$ && this.U$.K$;
    if (Math.abs(S - E) <= 2 * this.oG.H$) {
      if (T) return;
      let z = wt, W = Pt;
      for (let U = 0; U < v; U += 1) {
        const $ = A[U];
        z = $ < z ? $ : z, W = $ > W ? $ : W;
      }
      const G = [l[x.iFirstSampleDataArray], l[x.iLastSampleDataArray]], Y = [z, W];
      return this.U$ = { K$: !0, Rl: 0, j$: 0, q$: [], tU: [], iU: void 0, sU: void 0, eU: void 0, rU: void 0, hU: 0, nU: void 0, H$: 0 }, { oU: g === "x" ? G : Y, aU: g === "y" ? G : Y, UL: n.Md && [n.Md[x.iFirstSampleDataArray], n.Md[x.iLastSampleDataArray]], lU: n.kd && [n.kd[x.iFirstSampleDataArray], n.kd[x.iLastSampleDataArray]], j: n.wd && [n.wd[x.iFirstSampleDataArray], n.wd[x.iLastSampleDataArray]], Dl: n._d && [n._d[x.iFirstSampleDataArray], n._d[x.iLastSampleDataArray]], J$: !1, uU: !1 };
    }
    if (this.U$) {
      if (this.U$.hU < x.iFirstSample) {
        const z = Math.min(Math.floor((M - this.U$.Rl) / w), this.U$.j$);
        if (z > 0) if (this.U$.j$ -= z, this.U$.j$ > 0) {
          this.U$.q$.splice(0, 2 * z), this.U$.tU.splice(0, 2 * z), this.U$.iU && this.U$.iU.splice(0, 2 * z), this.U$.sU && this.U$.sU.splice(0, 2 * z), this.U$.Rl += z * w;
          const W = ln(this.U$.Rl, Math.max(u - 1 - v + 1, 0), u - 1, y, ((Y) => m[ri(Y, u, v)])), G = ri(W, u, v);
          this.U$.hU = m[G] >= this.U$.Rl ? W : W + 1;
        } else this.U$ = void 0;
      }
      if (((i = this.U$) === null || i === void 0 ? void 0 : i.nU) !== void 0 && this.U$.nU > x.iLastSample) {
        const z = m[x.iLastSampleDataArray], W = Math.min(Math.floor((this.U$.Rl + this.U$.j$ * w - z) / w), this.U$.j$);
        if (W > 0) if (this.U$.j$ -= W, this.U$.j$ > 0) {
          for (let U = 0; U < 2 * W; U += 1) this.U$.q$.pop(), this.U$.tU.pop(), this.U$.iU && this.U$.iU.pop(), this.U$.sU && this.U$.sU.pop();
          const G = ln(this.U$.Rl + this.U$.j$ * w, Math.max(u - 1 - v + 1, 0), u - 1, y, ((U) => m[ri(U, u, v)])), Y = ri(G, u, v);
          this.U$.nU = m[Y] <= this.U$.Rl + this.U$.j$ * w ? G : G - 1;
        } else this.U$ = void 0;
      }
    }
    const I = !T && this.U$ ? this.U$ : { Rl: M, j$: 0, q$: [], tU: [], iU: n.Md ? [] : void 0, sU: n.kd ? [] : void 0, eU: n.wd ? [] : void 0, rU: n._d ? [] : void 0, hU: x.iFirstSample, nU: void 0, K$: !1, H$: w }, F = (z, W, G) => {
      var Y, U, $, Z, q;
      const Q = { config: { ...p }, ready: !1, cancelled: !1, Z$: void 0 };
      this.Y$ = Q;
      const nt = this.yi.Xa(), et = (() => {
        let tt = [], at = [], ut = { ...I, q$: I.q$.slice(), tU: I.tU.slice() };
        return new Promise(((ht, st) => {
          const { worker: bt, idProg: ct, idValues: Mt, controlBufferId: vt } = this.G$(t, W, G);
          (async () => {
            try {
              for (const Xt of Object.entries(z)) {
                if (Q.cancelled) throw new Error("Cancelled");
                const Rt = { ...Xt[1], ss: { cwa: w, vrm: R, vrmm: L, mn: Pt, mmn: wt, vdr: { ils: x.iLastSample, ifs: x.iFirstSample }, das: v, min: f, atsc: u, nsi: d, cs: { pdp: ut.q$, pdv: ut.tU, ilps: ut.nU, ifps: ut.hU, pcc: ut.j$, o: ut.Rl } }, bip: ct, biv: Mt, cbi: vt, sp: m.constructor.name, sv: A.constructor.name };
                await new Promise(((Dt, Kt) => {
                  jE(bt, Rt, ((_t) => {
                    const Ut = _t.nc, te = _t.ss;
                    Ut.length > 0 && (ut.q$ = te.cs.pdp, ut.tU = te.cs.pdv, ut.j$ = te.cs.pcc, ut.nU = te.cs.ilps, ut.hU = te.cs.ifps, ut.Rl = te.cs.o), Q.cancelled ? Kt(new Error("Async CP result out of date")) : Dt(Ut);
                  }));
                })).then(((Dt) => {
                  const Kt = Xt[0];
                  Kt === "left" && (tt = Dt), Kt === "right" && (at = Dt);
                })).catch(((Dt) => {
                  Js(0, (() => {
                  }));
                }));
              }
              if (Q.cancelled) throw new Error("Async CP result out of date");
              const mt = Uc({ cpState: ut, newColumnsLeft: tt, newColumnsRight: at, progPlane: g, data: n, allTimeSampleCount: u, dataArraySize: v, nextSampleIndex: d, wasAsyncCPCompleted: !1, J$: !1 });
              this.U$ = ut, Q.ready = !0, ht(mt?.cpOutput);
            } catch (mt) {
              st(mt instanceof Error ? mt : new Error(String(mt)));
            }
          })();
        }));
      })().catch(((tt) => {
        Js(0, (() => {
        }));
      })).finally((() => {
        nt.Za();
      }));
      let it = this.U$ || this.cU;
      const rt = it && it.H$ / w;
      if (rt && rt >= 10 && (it = void 0), it && it.nU !== void 0) {
        const tt = it.Rl, at = it.Rl + it.j$ * it.H$;
        tt < L && at > R && (Q.Z$ = { dU: it.hU, fU: it.nU, NM: { oU: g === "x" ? it.q$.slice() : it.tU.slice(), aU: g === "y" ? it.q$.slice() : it.tU.slice(), UL: (Y = it.iU) === null || Y === void 0 ? void 0 : Y.slice(), lU: (U = it.sU) === null || U === void 0 ? void 0 : U.slice(), j: ($ = it.eU) === null || $ === void 0 ? void 0 : $.slice(), Dl: (Z = it.rU) === null || Z === void 0 ? void 0 : Z.slice(), J$: !1, uU: !0 } });
      }
      return Q.Z$ || (Q.Z$ = { dU: x.iFirstSample, fU: x.iFirstSample, NM: { oU: [], aU: [], UL: [], lU: [], j: [], Dl: [], J$: !1, uU: !0 } }), this.Q$(Q.Z$, t, e, g, w, x, v, m, A, f, n), { promise: et, temporaryDataToShow: (q = Q.Z$) === null || q === void 0 ? void 0 : q.NM };
    };
    let D;
    const P = ((s = this.U$) === null || s === void 0 ? void 0 : s.nU) !== void 0 ? this.U$.nU + 1 : x.iFirstSample, V = x.iLastSample - P;
    let _;
    V > 0 && (D = { s: I.Rl + (Wn(a) ? 1 : -1) * I.j$ * w, ds: 1, dc: 1 * (Wn(a) ? 1 : -1), is: P });
    const O = ((o = this.U$) === null || o === void 0 ? void 0 : o.hU) !== void 0 ? this.U$.hU - 1 : x.iFirstSample, B = O - x.iFirstSample;
    if (B > 0 && (_ = { s: I.Rl, ds: -1, dc: -1 * (Wn(a) ? 1 : -1), is: O }), _ || D) {
      const z = Al(m.buffer) && m.buffer, W = Al(A.buffer) && A.buffer, G = this.N$(t, e, g);
      if (B + V > 25e3 && ((G === void 0 ? 0 : V * G / k) > 1.6 || (G === void 0 ? 0 : B * G / k) > 1.6) && z && W && this.Na.bD()) return F({ left: _, right: D }, z, W);
      {
        const Y = _ && Pp(_.s, _.ds, _.dc, _.is, { columnWidthAxis: w, visibleDataRanges: x, visibleRangeMax: L, visibleRangeMin: R, dataArraySize: v, dataArrProg: m, dataArrValues: A, mayIncludeNaN: f, allTimeSampleCount: u, nextSampleIndex: d, cpState: I }), U = D && Pp(D.s, D.ds, D.dc, D.is, { columnWidthAxis: w, visibleDataRanges: x, visibleRangeMax: L, visibleRangeMin: R, dataArraySize: v, dataArrProg: m, dataArrValues: A, mayIncludeNaN: f, allTimeSampleCount: u, nextSampleIndex: d, cpState: I }), $ = Uc({ cpState: I, newColumnsLeft: Y ?? [], newColumnsRight: U ?? [], progPlane: g, data: n, allTimeSampleCount: u, dataArraySize: v, nextSampleIndex: d, wasAsyncCPCompleted: C, J$: !C && !T });
        return this.U$ = I.j$ > 0 ? I : void 0, $?.cpOutput;
      }
    }
    {
      const z = Uc({ cpState: I, newColumnsLeft: [], newColumnsRight: [], progPlane: g, data: n, allTimeSampleCount: u, dataArraySize: v, nextSampleIndex: d, wasAsyncCPCompleted: C, J$: !C && !T });
      return this.U$ = I.j$ > 0 ? I : void 0, z?.cpOutput;
    }
  }
  Q$(t, e, i, s, o, n, a, l, h, u, c) {
    const d = s === "x" ? t.NM.oU : t.NM.aU, f = t.NM.aU, p = this.N$(e, i, s), g = p !== void 0 ? Math.round(2 * o / p) : void 0, y = c.Md && t.NM.UL ? [c.Md, t.NM.UL] : void 0, m = c.kd && t.NM.lU ? [c.kd, t.NM.lU] : void 0, A = c.wd && t.NM.j ? [c.wd, t.NM.j] : void 0, v = c._d && t.NM.Dl ? [c._d, t.NM.Dl] : void 0, b = (w, k) => {
      if (g === void 0) return;
      let R = w + g * k;
      for (; R <= n.iLastSample && R >= n.iFirstSample; ) {
        const L = R % a, x = l[L], M = h[L];
        u && Number.isNaN(x) || (k > 0 ? (d.push(x), f.push(M), t.fU = R, y && y[1].push(y[0][L]), m && m[1].push(m[0][L]), A && A[1].push(A[0][L]), v && v[1].push(v[0][L])) : (d.unshift(x), f.unshift(M), t.dU = R, y && y[1].unshift(y[0][L]), m && m[1].unshift(m[0][L]), A && A[1].unshift(A[0][L]), v && v[1].unshift(v[0][L]))), R += g * k;
      }
    };
    b(t.fU, 1), b(t.dU, -1);
  }
  fG() {
    this.cU = this.U$ ? this.U$ : this.cU, this.U$ = void 0;
  }
  pG() {
    this.Na._D(this);
  }
}
const Pp = (r, t, e, i, s) => {
  const { columnWidthAxis: o, visibleRangeMin: n, visibleRangeMax: a, visibleDataRanges: l, dataArrProg: h, dataArrValues: u, dataArraySize: c, mayIncludeNaN: d, allTimeSampleCount: f, nextSampleIndex: p, cpState: g } = s;
  let y = Math.min(r, r + e * o), m = Math.max(r, r + e * o);
  const A = [];
  if (e < 0 && y < n || e > 0 && m > a) return A;
  let v = i, b = Pt, w = Pt, k = -1, R = wt, L = wt, x = -1, M = 0;
  for (; v <= l.iLastSample && v >= l.iFirstSample; ) {
    const C = v % c, S = h[C], E = u[C];
    if (d && Number.isNaN(S)) v += t;
    else if (y <= S && S <= m) M += 1, d && Number.isNaN(E) || (E > w && (b = S, w = E, k = v), E < L && (R = S, L = E, x = v)), v += t;
    else {
      if (M > 0) b = b === Pt ? Number.NaN : b, w = w === Pt ? Number.NaN : w, R = R === wt ? Number.NaN : R, L = L === wt ? Number.NaN : L, k < x ? (A.push({ if: k, is: x }), t > 0 ? (g.q$.push(b), g.tU.push(w), g.q$.push(R), g.tU.push(L)) : (g.q$.unshift(R), g.tU.unshift(L), g.q$.unshift(b), g.tU.unshift(w))) : (A.push({ if: x, is: k }), t > 0 ? (g.q$.push(R), g.tU.push(L), g.q$.push(b), g.tU.push(w)) : (g.q$.unshift(b), g.tU.unshift(w), g.q$.unshift(R), g.tU.unshift(L)));
      else {
        const T = t > 0 ? g.nU : g.hU;
        if (T === void 0) A.push({ if: 0, is: 0 }), t > 0 ? (g.q$.push(Number.NaN), g.tU.push(Number.NaN), g.q$.push(Number.NaN), g.tU.push(Number.NaN)) : (g.q$.unshift(Number.NaN), g.tU.unshift(Number.NaN), g.q$.unshift(Number.NaN), g.tU.unshift(Number.NaN));
        else {
          const I = ri(T, f, c), F = h[I], D = u[I], P = Jt((F + S) / 2, y, m), V = Jt((P + S) / 2, y, m), _ = D + (P - F) / (S - F) * (E - D), O = D + (V - F) / (S - F) * (E - D);
          A.push({ if: T, is: T }), t > 0 ? (g.q$.push(P), g.tU.push(_), g.q$.push(V), g.tU.push(O)) : (g.q$.unshift(V), g.tU.unshift(O), g.q$.unshift(P), g.tU.unshift(_));
        }
      }
      if (g.j$ += 1, t > 0 ? g.nU = v - 1 : (g.hU = v + 1, g.Rl = e > 0 ? m : y), y = Math.min(r + A.length * e * o, r + (A.length + 1) * e * o), m = Math.max(r + A.length * e * o, r + (A.length + 1) * e * o), M = 0, b = Pt, w = Pt, k = -1, R = wt, L = wt, x = -1, e < 0 && y < n || e > 0 && m > a) break;
    }
  }
  return A;
}, Uc = (r) => {
  const { cpState: t, newColumnsLeft: e, newColumnsRight: i, progPlane: s, data: o, allTimeSampleCount: n, dataArraySize: a, nextSampleIndex: l, wasAsyncCPCompleted: h, J$: u } = r;
  if (e.length === 0 && i.length === 0) return h ? { cpOutput: { oU: s === "x" ? t.q$ : t.tU, aU: s === "y" ? t.q$ : t.tU, UL: t.iU, lU: t.sU, j: t.eU, Dl: t.rU, J$: !1, uU: !1 }, cpState: t } : void 0;
  const c = o.Md && t.iU ? [o.Md, t.iU] : void 0, d = o.kd && t.sU ? [o.kd, t.sU] : void 0, f = o.wd && t.eU ? [o.wd, t.eU] : void 0, p = o._d && t.rU ? [o._d, t.rU] : void 0;
  if (c || d || f || p) {
    for (const g of i) {
      const y = ri(g.if, n, a), m = ri(g.is, n, a);
      c && c[1].push(c[0][y], c[0][m]), d && d[1].push(d[0][y], d[0][m]), f && f[1].push(f[0][y], f[0][m]), p && p[1].push(p[0][y], p[0][m]);
    }
    for (const g of e) {
      const y = ri(g.if, n, a), m = ri(g.is, n, a);
      c && c[1].unshift(c[0][m], c[0][y]), d && d[1].unshift(d[0][m], d[0][y]), f && f[1].unshift(f[0][m], f[0][y]), p && p[1].unshift(p[0][m], p[0][y]);
    }
  }
  return { cpOutput: { oU: s === "x" ? t.q$ : t.tU, aU: s === "y" ? t.q$ : t.tU, UL: t.iU, lU: t.sU, j: t.eU, Dl: t.rU, J$: u, uU: !1 }, cpState: t };
};
class t1 extends qM {
  constructor(t, e, i, s) {
    super(t, e, i, s), this.SE = new Fs(), this.EG = new JM(this.ai, this, this.yi.Na), this.LV = ss({ lineStyleSolid: () => Oi(this.vc) && this.vc, lineStyleDashed: () => Oo(this.vc) && this.vc, strokeFillSolid: () => {
      const o = this.vc.getFillStyle();
      return de(o) && o;
    }, strokeFillLinearGradient: () => {
      const o = this.vc.getFillStyle();
      return hi(o) && o;
    }, strokeFillRadialGradient: () => {
      const o = this.vc.getFillStyle();
      return li(o) && o;
    }, strokeFillIndividual: () => {
      const o = this.vc.getFillStyle();
      return Tr(o) && o;
    }, strokeFillPaletted: () => {
      const o = this.vc.getFillStyle();
      return Ve(o) && o;
    }, areaFillSolid: () => de(this.b$) && this.b$, areaFillLinearGradient: () => hi(this.b$) && this.b$, areaFillRadialGradient: () => li(this.b$) && this.b$, areaFillIndividual: () => Tr(this.b$) && this.b$, areaFillPaletted: () => Ve(this.b$) && this.b$, markerFillSolid: () => de(this.M$) && this.M$, markerFillLinearGradient: () => hi(this.M$) && this.M$, markerFillRadialGradient: () => li(this.M$) && this.M$, markerFillPaletted: () => Ve(this.M$) && this.M$, markerFillIndividual: () => Tr(this.M$) && this.M$, markerFillImage: () => cn(this.M$) && this.M$, markerShapeIcon: () => {
      const o = this.w$.T();
      return Pn(o) && o;
    }, markerStrokeFillSolid: () => {
      const o = this._$.getFillStyle();
      return de(o) && o;
    } }), this.Kd = le(void 0), this.AU = [], this.Tu = !1, this.gU = [], this.vU = void 0, this.l$ = (o, n, a) => {
      var l;
      const h = (l = this.yU) === null || l === void 0 ? void 0 : l.shapeIcon;
      let u = o, c = n;
      return h && (u = h.Ft().x, c = h.Ft().y), Ah(o, n, u * this.k$.T(), c * this.k$.T(), a);
    }, this.pU = QM(), this.wV = e, this.ON = { type: "none" }, this.WD = t.kV(), this._V = t, this.EN = this.WD.pz;
  }
  mU(t) {
    const e = t === "ProgressiveX" || t === "RegressiveX" ? this.ai.x : this.ai.y;
    return e instanceof ts ? { lin: e } : { log: e };
  }
  qd(t, e) {
    var i;
    return e && Object.entries(e).forEach(((s) => {
      s[1] === void 0 && delete e[s[0]];
    })), this.EG.fG(), this.SU = void 0, this.vU = void 0, t && e ? (this.Kd.C(Wm(t, this.Kd.T(), (() => ({ change: (s) => {
      this.AU.push({ min: s.iDataStart, max: s.iDataEnd }), this.SU && this.gU.length > 1e3 && Date.now() - this.SU.bU > 5e3 && (this.SU = void 0, this.gU.length = 0), this.SU && this.gU.push({ min: s.iDataStart, max: s.iDataEnd });
    }, clear: () => {
      this.Tu = !0, this.SU = void 0, this.vU = void 0, this.EG.fG();
    }, loop: () => {
    } })))), this.nw = e, this) : ((i = this.Kd.T()) === null || i === void 0 || i.qi(), this.Kd.C(void 0), this.nw = void 0, this);
  }
  Al() {
    var t;
    const e = (t = this.Kd.T()) === null || t === void 0 ? void 0 : t.ts, i = e?.yd(this.nw);
    return i && { pw: js(i), mw: () => this.wy() };
  }
  wy() {
    var t, e, i, s, o, n, a, l, h, u, c, d, f, p, g, y, m, A, v, b, w, k, R, L, x, M, C, S, E, T, I, F, D;
    const P = (t = this.Kd.T()) === null || t === void 0 ? void 0 : t.ts, V = this.Kd.u, _ = this.nw, O = P?.pd(_), B = O?.bd, z = O?.xd;
    if (!(P && B && z && _)) return;
    const W = O.dataPattern, G = W && this.ai[js(W)], Y = O.kd, U = O.Md, $ = O.wd, Z = O._d, q = P.jc, Q = P.Uc, nt = P.$c, et = V || this._l() || this.P$() || this.B$() || this.E$() || this.x$.u || this.I$.u, it = this.LV.lineStyleSolid(et), rt = this.LV.lineStyleDashed(et), tt = it || rt, at = tt && tt.getThickness(), ut = this.LV.strokeFillSolid(et), ht = this.LV.strokeFillLinearGradient(et), st = this.LV.strokeFillRadialGradient(et), bt = this.LV.strokeFillIndividual(et), ct = this.LV.strokeFillPaletted(et), Mt = ut || ht || st || bt || ct, vt = this.LV.areaFillSolid(et), mt = this.LV.areaFillLinearGradient(et), Xt = this.LV.areaFillRadialGradient(et), Rt = this.LV.areaFillIndividual(et), Dt = this.LV.areaFillPaletted(et), Kt = vt || mt || Xt || Rt || Dt, _t = this.LV.markerFillSolid(et), Ut = this.LV.markerFillLinearGradient(et), te = this.LV.markerFillRadialGradient(et), ye = this.LV.markerFillPaletted(et), ne = this.LV.markerFillIndividual(et), ti = this.LV.markerFillImage(et), fe = _t || Ut || te || ye || ne || ti, ve = this.LV.markerStrokeFillSolid(et), ci = this.w$.T(), At = this.w$.u, yt = this.LV.markerShapeIcon(At), ft = this.k$.T(), Tt = this.k$.u, oe = this.T$.u, vi = this.AU.length > 0 || oe, Te = this.Tu || V, Ze = Te ? [P.Id()] : ((Bt) => {
      const Wt = [];
      for (const J of Bt) {
        let pt = !1;
        for (const St of Wt) if (J.min >= St.min && J.min <= St.max || J.max >= St.min && J.max <= St.max) {
          St.min = Math.min(St.min, J.min), St.max = Math.min(St.max, J.max), pt = !0;
          break;
        }
        pt || Wt.push(J);
      }
      return Wt;
    })(this.AU), ps = !!rt, Fe = this.ui.T(), qe = this.ui.u, rs = this.I$.T() !== void 0;
    V && Object.entries(_).forEach((([Bt, Wt]) => {
      if (P.sd && Wt && Bt && !P.sd[Wt]) throw new Error(`LightningChart JS data supply error - key ${Wt} does not exist in data set. Mapped to '${Bt}'`);
    })), (V || et) && ((ct && ct.lookUpProperty === "value" || Dt && Dt.lookUpProperty === "value" || ye && ye.lookUpProperty === "value") && _.lookupValue === void 0 && H.console.warn('LightningChart JS warning - using PalettedFill with lookUpProperty=value, but there is no data mapping for "lookupValue"'), (bt || Rt || ne) && _.color === void 0 && H.console.warn('LightningChart JS warning - using IndividualPointFill, but there is no data mapping for "color"'));
    const ii = this.sw && (!!tt || !!Kt), { cpStateChanged: Ge, cpActive: vn } = this.EG.$$(P, _, ii);
    if (W && vn && G && (Ge || Te || vi || G.ot || G.ct || et)) {
      const Bt = this.EG.X$(P, _);
      let Wt, J = !(Ge || Te || et || V);
      if (Bt && "promise" in Bt ? (Wt = Bt.temporaryDataToShow, J = !1, Bt.promise.then(((pt) => {
        pt && pt.oU.length > 0 && this.yi.Rs(!0);
      }))) : Wt = Bt, Wt) {
        Wt?.uU ? this.xU = Wt : this.xU = void 0, J = J && Wt.J$, this.MU = Hc(this.WD, [Wt.oU, Wt.aU], Wt.UL, Wt.lU, Wt.j, Wt.Dl, ps, this.MU, J, W, 1e3, this.ai.Nt(), ((Ft) => Mn(Ft, this.ai.Nt())), P.Qc), this._U = { min: wt, max: Pt };
        const pt = js(W) === "x" ? Wt.aU : Wt.oU, St = pt.length;
        for (let Ft = 0; Ft < St; Ft += 1) {
          const Qt = pt[Ft];
          P.Qc && Number.isNaN(Qt) || (this._U.min = Math.min(this._U.min, Qt), this._U.max = Math.max(this._U.max, Qt));
        }
        ((e = this.wU) === null || e === void 0 ? void 0 : e.bufferX) !== this.MU.bufferX && (this.WD.LO((i = this.wU) === null || i === void 0 ? void 0 : i.bufferX), this.WD.LO((s = this.wU) === null || s === void 0 ? void 0 : s.bufferY), this.WD.LO((o = this.wU) === null || o === void 0 ? void 0 : o.bufferColors), this.WD.LO((n = this.wU) === null || n === void 0 ? void 0 : n.bufferLengthSoFar), this.WD.LO((a = this.wU) === null || a === void 0 ? void 0 : a.bufferRotations), this.WD.LO((l = this.wU) === null || l === void 0 ? void 0 : l.bufferLookupValues), this.WD.LO((h = this.wU) === null || h === void 0 ? void 0 : h.bufferSizes)), this.wU = void 0;
      }
    }
    if (W && G && !vn) {
      if (Ge || Te || vi || G.ot || G.ct || oe || et) {
        const Bt = this.mU(W), Wt = Math.min("lin" in Bt ? Bt.lin.Wt : Bt.log.getInnerStart(), "lin" in Bt ? Bt.lin.Yt : Bt.log.getInnerEnd()), J = Math.max("lin" in Bt ? Bt.lin.Wt : Bt.log.getInnerStart(), "lin" in Bt ? Bt.lin.Yt : Bt.log.getInnerEnd()), pt = js(W) === "x" ? B : z, St = js(W) === "x" ? z : B, Ft = zf(Wt, J, pt, q, Q, nt, Wn(W) ? "progressive" : "regressive", 1);
        if (!this.kU || Ft?.iFirstSample !== this.kU.iFirstSample || Ft.iLastSample !== this.kU.iLastSample || Te) {
          const Qt = this.pU(O, this.kU, Ft, Te || Ge, pt, St, P.Qc);
          this._U = Qt.visibleBoundaries, this.CU = Qt.avgPointGap;
        }
        if (this.kU = Ft, Ft === void 0) this.WD.LO((u = this.MU) === null || u === void 0 ? void 0 : u.bufferX), this.WD.LO((c = this.MU) === null || c === void 0 ? void 0 : c.bufferY), this.WD.LO((d = this.MU) === null || d === void 0 ? void 0 : d.bufferColors), this.WD.LO((f = this.MU) === null || f === void 0 ? void 0 : f.bufferLengthSoFar), this.WD.LO((p = this.MU) === null || p === void 0 ? void 0 : p.bufferRotations), this.WD.LO((g = this.MU) === null || g === void 0 ? void 0 : g.bufferLookupValues), this.WD.LO((y = this.MU) === null || y === void 0 ? void 0 : y.bufferSizes), this.MU = void 0, this.WD.LO((m = this.wU) === null || m === void 0 ? void 0 : m.bufferX), this.WD.LO((A = this.wU) === null || A === void 0 ? void 0 : A.bufferY), this.WD.LO((v = this.wU) === null || v === void 0 ? void 0 : v.bufferColors), this.WD.LO((b = this.wU) === null || b === void 0 ? void 0 : b.bufferLengthSoFar), this.WD.LO((w = this.wU) === null || w === void 0 ? void 0 : w.bufferRotations), this.WD.LO((k = this.wU) === null || k === void 0 ? void 0 : k.bufferLookupValues), this.WD.LO((R = this.wU) === null || R === void 0 ? void 0 : R.bufferSizes), this.wU = void 0, this.TU = Ft;
        else if (Ge || Te || !this.TU || Ft.iFirstSample < this.TU.iFirstSample || Ft.iLastSample > this.TU.iLastSample || et) {
          const Qt = vr({ srcLoopArray: B, dataRanges: Ft.dataRanges, NewArray: O.md }), Se = vr({ srcLoopArray: z, dataRanges: Ft.dataRanges, NewArray: O.Sd }), ce = U ? vr({ srcLoopArray: U, dataRanges: Ft.dataRanges, NewArray: Uint32Array }) : void 0, se = Y ? vr({ srcLoopArray: Y, dataRanges: Ft.dataRanges, NewArray: Float32Array }) : void 0, Si = $ ? vr({ srcLoopArray: $, dataRanges: Ft.dataRanges, NewArray: Float32Array }) : void 0, Le = Z ? vr({ srcLoopArray: Z, dataRanges: Ft.dataRanges, NewArray: Float32Array }) : void 0, We = !(Ge || Te || et || V), gi = ii || this._i("ApplicationType", ((Bi) => Bi.type === "InternalUI")) ? 1e3 : Math.min((L = P.getMaxSampleCount()) !== null && L !== void 0 ? L : 1e6, 1e6);
          this.wU = Hc(this.WD, [Qt, Se], ce, se, Si, Le, ps, this.wU, We, W, gi, this.ai.Nt(), ((Bi) => Mn(Bi, this.ai.Nt())), P.Qc);
          let Di = Qt, ns = Se, Ni = ce, no = se;
          const Zr = this.T$.T();
          if (Zr) {
            const Bi = Zr.type === "spline" ? ((os, as, oo) => {
              const ys = js(oo), Kr = ys === "x" ? os.xValues : os.yValues, Wo = ys === "x" ? os.yValues : os.xValues, { lookupValues: Sn, colors: Vn } = os;
              if (Kr.length <= 2) return { xValues: Array.from(os.xValues), yValues: Array.from(os.yValues), lookupValues: Sn ? Array.from(Sn) : void 0, colors: Vn ? Array.from(Vn) : void 0 };
              const qr = ((ee, Pe) => {
                const ms = ee.length - 1, Vr = Array(ms);
                if (ms > 1) {
                  let Hs = j(0, 0), Rs = j(0, 0), Uo = j(0, 0), Ho = Os(oi({ x: ee.elementAt(1), y: Pe.elementAt(1) }, { x: ee.elementAt(0), y: Pe.elementAt(0) }));
                  const u0 = 3;
                  let uc = 0, cc = 0;
                  for (let _r = 0; _r < ms; _r += 1) {
                    const dc = ee.elementAt(_r), tl = ee.elementAt(_r + 1), fc = Pe.elementAt(_r), el = Pe.elementAt(_r + 1), En = Array(4);
                    En[0] = { x: dc, y: fc }, En[1] = { x: dc, y: fc }, En[3] = { x: tl, y: el }, En[2] = { x: tl, y: el }, Uo = Ho, Hs = Rs, Number.isNaN(Hs.y) && (Hs = j(0, 0));
                    const gc = _r + 2 < Pe.length ? Pe.elementAt(_r + 2) : Number.NaN;
                    if (_r + 1 < ms && !Number.isNaN(gc)) {
                      const il = ee.elementAt(_r + 2);
                      Ho = il === tl && gc === el ? j(0, 0) : Os(oi({ x: il, y: gc }, { x: tl, y: el })), Rs = Os(qt(Uo, Ho));
                    } else Rs = j(0, 0);
                    if (el === fc) uc = 0, cc = 0;
                    else {
                      const il = tl - dc;
                      uc = Math.abs(Hs.x) > 1e-5 ? Math.abs(il / (u0 * Hs.x)) : 1, cc = Math.abs(Rs.x) > 1e-5 ? Math.abs(il / (u0 * Rs.x)) : 1;
                    }
                    En[1] = qt(pe(Hs, uc), En[1]), En[2] = oi(En[2], pe(Rs, cc)), Vr[_r] = En;
                  }
                }
                return Vr.length > 0 ? Vr : [];
              })(Kr, Wo), An = qr.length, Ps = [], rr = [], bn = [], Go = [];
              for (let ee = 0; ee < An; ee += 1) {
                const Pe = qr[ee];
                for (let gr = 0; gr < as; gr += 1) {
                  const ms = gr / (as - 1), Vr = ms * ms, Hs = Vr * ms, Rs = 1 - ms, Uo = Rs * Rs, Ho = Uo * Rs;
                  Ps.push(Ho * Pe[0].x + 3 * ms * Uo * Pe[1].x + 3 * Vr * Rs * Pe[2].x + Hs * Pe[3].x), rr.push(Ho * Pe[0].y + 3 * ms * Uo * Pe[1].y + 3 * Vr * Rs * Pe[2].y + Hs * Pe[3].y);
                }
              }
              if (Sn) for (let ee = 0; ee < Ps.length; ee += 1) {
                const Pe = Math.round(ee / as), gr = Sn.elementAt(Pe);
                Go[ee] = gr;
              }
              if (Vn) for (let ee = 0; ee < Ps.length; ee += 1) {
                const Pe = Math.round(ee / as), gr = Vn.elementAt(Pe);
                bn[ee] = gr;
              }
              return { xValues: ys === "x" ? Ps : rr, yValues: ys === "x" ? rr : Ps, lookupValues: Sn ? Go : void 0, colors: Vn ? bn : void 0 };
            })({ xValues: Qt, yValues: Se, lookupValues: se, colors: ce }, Zr.resolution || 20, W) : Zr.type === "step" ? ((os, as, oo) => {
              const { lookupValues: ys, colors: Kr } = os, Wo = js(oo), Sn = Wo === "x" ? os.xValues : os.yValues, Vn = Wo === "x" ? os.yValues : os.xValues, qr = [], An = [], Ps = [], rr = [], bn = Sn.length, Go = as === "before" ? 0 : as === "after" ? 1 : 0.5;
              if (bn > 0) {
                let ee = 0, Pe = Sn.elementAt(0), gr = Vn.elementAt(0);
                qr[ee] = Pe, An[ee] = gr, ee += 1;
                for (let ms = 1; ms < bn; ms += 1) {
                  const Vr = Sn.elementAt(ms), Hs = Vn.elementAt(ms);
                  if (Go <= 0) qr[ee] = Pe, An[ee] = Hs, ee += 1;
                  else {
                    const Rs = Pe * (1 - Go) + Vr * Go;
                    qr[ee] = Rs, An[ee] = gr, ee += 1, qr[ee] = Rs, An[ee] = Hs, ee += 1;
                  }
                  qr[ee] = Vr, An[ee] = Hs, ee += 1, Pe = Vr, gr = Hs;
                }
              }
              if (ys) {
                if (as === "before") {
                  rr[0] = ys.elementAt(0);
                  for (let ee = 1; ee < bn; ee += 1) {
                    const Pe = ys.elementAt(ee);
                    rr[2 * ee - 1] = Pe, rr[2 * ee] = Pe;
                  }
                } else if (as === "middle" || as === "after") {
                  rr[0] = ys.elementAt(0), rr[1] = ys.elementAt(0);
                  for (let ee = 1; ee < bn; ee += 1) {
                    const Pe = ys.elementAt(ee);
                    rr[3 * ee - 1] = Pe, rr[3 * ee] = Pe, rr[3 * ee + 1] = Pe;
                  }
                }
              }
              if (Kr) {
                if (as === "before") {
                  Ps[0] = Kr.elementAt(0);
                  for (let ee = 1; ee < bn; ee += 1) {
                    const Pe = Kr.elementAt(ee);
                    Ps[2 * ee - 1] = Pe, Ps[2 * ee] = Pe;
                  }
                } else if (as === "middle" || as === "after") {
                  Ps[0] = Kr.elementAt(0), Ps[1] = Kr.elementAt(0);
                  for (let ee = 1; ee < bn; ee += 1) {
                    const Pe = Kr.elementAt(ee);
                    Ps[3 * ee - 1] = Pe, Ps[3 * ee] = Pe, Ps[3 * ee + 1] = Pe;
                  }
                }
              }
              return { xValues: Wo === "x" ? qr : An, yValues: Wo === "x" ? An : qr, lookupValues: ys ? rr : void 0, colors: Kr ? Ps : void 0 };
            })({ xValues: Qt, yValues: Se, lookupValues: se, colors: ce }, (x = Zr.step) !== null && x !== void 0 ? x : "middle", W) : void 0;
            Di = Bi ? Bi.xValues : Di, ns = Bi ? Bi.yValues : ns, Ni = Bi?.colors ? Bi.colors : Ni, no = Bi?.lookupValues ? Bi.lookupValues : no;
          }
          this.MU = Di === Qt && ns === Se ? this.wU : Hc(this.WD, [Di, ns], Ni, no, void 0, void 0, ps, ((M = this.MU) === null || M === void 0 ? void 0 : M.bufferX) === this.wU.bufferX ? void 0 : this.MU, !(!We || oe || Zr), W, 1e3, this.ai.Nt(), ((Bi) => Mn(Bi, this.ai.Nt())), P.Qc), this.TU = Ft;
        }
      }
    } else this.kU = void 0;
    if (!W && (Te || vi || et)) {
      if (!this.MU || this.MU.bufferSize < P.Uc || ps) {
        const Bt = P.ld !== void 0 ? P.ld : P.Uc;
        let Wt, J = 0, pt = 0;
        if (ps) {
          const St = Pd(B, z, B[0], z[0], 0, 0, P.Qc);
          Wt = this.WD.QO(2 * Bt, St[0], (C = this.MU) === null || C === void 0 ? void 0 : C.bufferLengthSoFar, Float32Array), J = St[1], pt = St[2];
        }
        this.MU = { bufferX: this.WD.QO(Bt * (this.ai.Nt() ? 2 : 1), Mn(B, this.ai.Nt()), (S = this.MU) === null || S === void 0 ? void 0 : S.bufferX), bufferY: this.WD.QO(Bt * (this.ai.Nt() ? 2 : 1), Mn(z, this.ai.Nt()), (E = this.MU) === null || E === void 0 ? void 0 : E.bufferY), bufferColors: U ? this.WD.QO(Bt, U, (T = this.MU) === null || T === void 0 ? void 0 : T.bufferColors, Uint32Array) : void 0, bufferLookupValues: Y ? this.WD.QO(Bt, Y, (I = this.MU) === null || I === void 0 ? void 0 : I.bufferLookupValues, Float32Array) : void 0, bufferSizes: $ ? this.WD.QO(Bt, $, (F = this.MU) === null || F === void 0 ? void 0 : F.bufferSizes, Float32Array) : void 0, bufferRotations: Z ? this.WD.QO(Bt, Z, (D = this.MU) === null || D === void 0 ? void 0 : D.bufferRotations, Float32Array) : void 0, bufferLengthSoFar: Wt, lengthSoFarX: J, lengthSoFarY: pt, bufferSize: Bt, valueCount: P.Uc };
      } else {
        const Bt = this.MU.bufferX, Wt = this.MU.bufferY;
        Ze.forEach(((J) => {
          var pt, St, Ft, Qt;
          const Se = B.subarray(J.min, J.max + 1), ce = z.subarray(J.min, J.max + 1);
          if (this.WD.KO(Bt, J.min * (this.ai.Nt() ? 2 : 1), Mn(Se, this.ai.Nt())), this.WD.KO(Wt, J.min * (this.ai.Nt() ? 2 : 1), Mn(ce, this.ai.Nt())), U && ((pt = this.MU) === null || pt === void 0 ? void 0 : pt.bufferColors)) {
            const se = U.subarray(J.min, J.max + 1);
            this.WD.KO(this.MU.bufferColors, J.min, se, Uint32Array);
          }
          if (Y && (!((St = this.MU) === null || St === void 0) && St.bufferLookupValues)) {
            const se = Y.subarray(J.min, J.max + 1);
            this.WD.KO(this.MU.bufferLookupValues, J.min, se, Float32Array);
          }
          if (Z && (!((Ft = this.MU) === null || Ft === void 0) && Ft.bufferRotations)) {
            const se = Z.subarray(J.min, J.max + 1);
            this.WD.KO(this.MU.bufferRotations, J.min, se, Float32Array);
          }
          if ($ && (!((Qt = this.MU) === null || Qt === void 0) && Qt.bufferSizes)) {
            const se = $.subarray(J.min, J.max + 1);
            this.WD.KO(this.MU.bufferSizes, J.min, se, Float32Array);
          }
        })), this.MU.valueCount = P.Uc;
      }
      this.wU = this.MU;
    }
    if (et || Tt || At || qe) {
      if (Mt && tt && at !== !1) {
        const Bt = at === -1 ? "primitive" : "triangulated", Wt = ct ? ["lookup", ct.lookUpProperty, ct.lut] : bt ? "attribute" : ht ? ["gradient", ht] : st ? ["gradient", st] : "uniform";
        this.ON = Bt === "primitive" ? { type: Bt, shader: this.WD.SR(K["2D"], K.Color({ dataType: Wt }), K.VertexLocation({ userAffineTransform: rs, axisWorldTranslation: jt(this.ai), normalSource: void 0, splitPosAttribute: !0 }), rt && K.StippleTexture), lineStyleSolid: it, lineStyleDashed: rt, fillStyleSolid: ut, fillStyleLinearGradient: ht, fillStyleRadialGradient: st, fillStyleIndividual: bt, fillStylePaletted: ct, mousePickingShader: Fe && this.WD.SR(K["2D"], K.VertexLocation({ userAffineTransform: rs, axisWorldTranslation: jt(this.ai), normalSource: void 0, splitPosAttribute: !0 }), rt && K.StippleTexture, K.MousePicking({ useVertexId: !0 })) } : Bt === "triangulated" ? { type: Bt, shader: this.WD.SR(K["2D"], K.Color({ dataType: Wt }), K.LineInstanced2D({ userAffineTransform: rs, axisWorldTranslation: jt(this.ai), normalSource: void 0, splitPosAttribute: !0 }), this.EN ? K.AliasedEdge : void 0, rt && K.StippleTextureInstanced), geometry: Bo(this.WD, at), thickness: at, lineStyleSolid: it, lineStyleDashed: rt, fillStyleSolid: ut, fillStyleLinearGradient: ht, fillStyleRadialGradient: st, fillStyleIndividual: bt, fillStylePaletted: ct, mousePickingShader: Fe && this.WD.SR(K["2D"], K.LineInstanced2D({ userAffineTransform: rs, axisWorldTranslation: jt(this.ai), normalSource: void 0, splitPosAttribute: !0 }), rt && K.StippleTextureInstanced, K.MousePicking()) } : { type: "none" };
      } else this.ON = { type: "none" };
      if (this.FU = Kt ? { shader: this.WD.SR(K["2D"], Dt && K.Color({ dataType: ["lookup", Dt.lookUpProperty, Dt.lut] }), Rt && K.Color({ dataType: "attribute" }), vt && K.Color({ dataType: "uniform" }), mt && K.Color({ dataType: ["gradient", mt] }), Xt && K.Color({ dataType: ["gradient", Xt] }), K.Area2D({ userAffineTransform: rs, axisWorldTranslation: jt(this.ai), normalSource: void 0, splitPosAttribute: !0, fill: this.x$.T() })), geometry: KM(this.WD), fillStyleSolid: vt, fillStyleLinearGradient: mt, fillStyleRadialGradient: Xt, fillStyleIndividual: Rt, fillStylePaletted: Dt, mousePickingShader: Fe && this.WD.SR(K["2D"], K.Area2D({ userAffineTransform: rs, axisWorldTranslation: jt(this.ai), normalSource: void 0, splitPosAttribute: !0, fill: this.x$.T() }), K.MousePicking()) } : void 0, fe) {
        const Bt = !(!ti && !yt), Wt = ft > 1 || Bt, J = $ ? "attribute" : "uniform", pt = !Wt && K.PointSize("uniform"), St = K.VertexLocation({ userAffineTransform: rs, offsets: [Wt && !Bt ? { directionVar: bi.p$, dataType: J, sizeUnit: "px", symmetric: !0, rotation: { dataType: Z ? "attribute-deg" : "uniform" }, useAlignment: !0 } : Wt && Bt ? { directionVar: bi.p$, dataType: J, sizeUnit: "scale", rotation: { dataType: Z ? "attribute-deg" : "uniform" }, useAlignment: !0 } : void 0], axisWorldTranslation: jt(this.ai), normalSource: void 0, splitPosAttribute: !0 });
        this.yU = { shader: this.WD.SR(K["2D"], pt, St, _t && K.Color({ dataType: "uniform", overrideOpacity: !0, maskTexture: !!yt }), Ut && K.Color({ dataType: ["gradient", Ut], overrideOpacity: !0, maskTexture: !!yt }), te && K.Color({ dataType: ["gradient", te], overrideOpacity: !0, maskTexture: !!yt }), ye && K.Color({ dataType: ["lookup", ye.getLookUpProperty(), ye.getPalette()], overrideOpacity: !0, maskTexture: !!yt }), ne && K.Color({ dataType: "attribute", overrideOpacity: !0, maskTexture: !!yt }), ti && K.Color({ dataType: ["image", ti], overrideOpacity: !0, maskTexture: !!yt })), geometry: Qx(ci, this.WD, J === "uniform" ? ft : 25), fillStyleSolid: _t, fillStyleLinearGradient: Ut, fillStyleRadialGradient: te, fillStylePaletted: ye, fillStyleIndividual: ne, fillStyleImage: ti, mousePickingShader: Fe && this.WD.SR(K["2D"], pt, St, K.MousePicking({ useVertexId: !Wt })), shapeIcon: yt, pointSizeAsScale: Bt, instancedRendering: Wt, borders: ve && !Bt && { shader: this.WD.SR(K["2D"], pt, K.VertexLocation({ userAffineTransform: rs, offsets: [Wt && !Bt ? { directionVar: bi.p$, dataType: J, sizeUnit: "px", symmetric: !0, rotation: { dataType: Z ? "attribute-deg" : "uniform" }, useAlignment: !0 } : Wt && Bt ? { directionVar: bi.p$, dataType: J, sizeUnit: "scale", rotation: { dataType: Z ? "attribute-deg" : "uniform" }, useAlignment: !0 } : void 0, { directionVar: bi.S$, dataType: "uniform", sizeUnit: "px", symmetric: !0, rotation: { dataType: Z ? "attribute-deg" : "uniform" } }], axisWorldTranslation: jt(this.ai), normalSource: void 0, splitPosAttribute: !0 }), K.Color({ dataType: "uniform", overrideOpacity: !0, maskTexture: !!yt })), fillStyleSolid: ve } };
      } else this.yU = void 0;
    }
    if ((this.vU === void 0 || vi) && Y && (Dc(ct) || Dc(Dt) || Dc(ye))) {
      const Bt = this.vU ? Ze : [P.Id()];
      let Wt = this.vU ? this.vU.max : Pt, J = this.vU ? this.vU.min : wt;
      const pt = Y;
      Bt.forEach(((St) => {
        for (let Ft = St.min; Ft <= St.max; Ft += 1) {
          const Qt = pt[Ft];
          J = Qt < J ? Qt : J, Wt = Qt > Wt ? Qt : Wt;
        }
      })), this.vU = { min: J, max: Wt };
    }
    this.a$ = this.WD.Qz(this, this.a$, ti, yt, Tt, this.l$), this.VN = rt ? this.WD.Yz(rt.getPattern()) : void 0, this.bc(this.vc), this.L$ = this.b$, this.D$ = this.M$, this.R$ = this._$, this.w$.u = !1, this.k$.u = !1, this.AU.length = 0, this.Tu = !1, this.T$.u = !1, this.Kd.u = !1, this.ui.u = !1, this.x$.u = !1, this.I$.u = !1;
  }
  Uh() {
    this.wy();
    const t = this.LV.strokeFillLinearGradient(!1), e = this.LV.strokeFillRadialGradient(!1), i = this.LV.areaFillLinearGradient(!1), s = this.LV.areaFillRadialGradient(!1), o = this.LV.markerFillLinearGradient(!1), n = this.LV.markerFillRadialGradient(!1);
    if (this.SE.TO(this.ai), i || s) {
      let a;
      const l = this.x$.T();
      a = Ul(l === "bottom" || l === "top" ? { min: { x: this.Hi(!1), y: Math.min(this.ai.y.getInnerStart(), this.ai.y.getInnerEnd(), this.Xi(!1), this.Zi(!1)) }, max: { x: this.Wi(!1), y: Math.max(this.ai.y.getInnerStart(), this.ai.y.getInnerEnd(), this.Xi(!1), this.Zi(!1)) } } : { min: { x: Math.min(this.ai.x.getInnerStart(), this.ai.x.getInnerEnd(), this.Hi(!1), this.Wi(!1)), y: this.Xi(!1) }, max: { x: Math.max(this.ai.x.getInnerStart(), this.ai.x.getInnerEnd(), this.Hi(!1), this.Wi(!1)), y: this.Zi(!1) } }, { x: this.mu() / 2, y: this.Su() / 2 }, this.ai), this.IU = this.WD.sV(i, this, a), this.PU = this.WD.eV(s, this, a);
    }
    if (t || e || o || n) {
      const a = Ul({ min: { x: this.Hi(!1), y: this.Xi(!1) }, max: { x: this.Wi(!1), y: this.Zi(!1) } }, { x: this.mu() / 2, y: this.Su() / 2 }, this.ai);
      this.LU = this.WD.sV(t, this, a), this.BU = this.WD.eV(e, this, a), this.DU = this.WD.sV(o, this, a), this.EU = this.WD.eV(n, this, a);
    }
    return this;
  }
  Ec(t, e) {
    var i, s, o, n, a, l, h, u, c, d, f, p, g, y, m, A, v, b, w, k, R;
    const L = this.WD.gl, x = (i = this.MU) === null || i === void 0 ? void 0 : i.bufferX, M = (s = this.MU) === null || s === void 0 ? void 0 : s.bufferY, C = (o = this.MU) === null || o === void 0 ? void 0 : o.bufferColors, S = (n = this.MU) === null || n === void 0 ? void 0 : n.bufferLookupValues, E = (a = this.MU) === null || a === void 0 ? void 0 : a.valueCount, T = (l = this.wU) === null || l === void 0 ? void 0 : l.valueCount, I = (h = this.Kd.T()) === null || h === void 0 ? void 0 : h.ts, F = I?.yd(this.nw), D = Math.max(((u = this.MU) === null || u === void 0 ? void 0 : u.valueCount) || 0, ((c = this.wU) === null || c === void 0 ? void 0 : c.valueCount) || 0), P = this.I$.T();
    if (!x || !M || !I) return {};
    const V = (Q, nt, et) => {
      if (P && (this.WD.xO(Q.uniform("uUserTransformOffset"), [P.x.offset, P.y.offset]), this.WD.xO(Q.uniform("uUserTransformScaling"), [P.x.scaling, P.y.scaling])), Gn(this.WD, Q, this.ai.Nt(), x, "aLocation", "X", 1, !1, L.FLOAT, Float32Array.BYTES_PER_ELEMENT, void 0), Gn(this.WD, Q, this.ai.Nt(), M, "aLocation", "Y", 1, !1, L.FLOAT, Float32Array.BYTES_PER_ELEMENT, void 0), nt && t !== 1) {
        if (!C) return !1;
        Gn(this.WD, Q, !1, C, "aColor", "", 4, !0, L.UNSIGNED_BYTE, 1, void 0);
      }
      if (et && et.lookUpProperty === "value" && t !== 1) {
        if (!S) return !1;
        Gn(this.WD, Q, !1, S, "aLookupValue", "", 1, !1, L.FLOAT, Float32Array.BYTES_PER_ELEMENT, void 0);
      }
      return !0;
    }, _ = t === 1 ? (d = this.FU) === null || d === void 0 ? void 0 : d.mousePickingShader : (f = this.FU) === null || f === void 0 ? void 0 : f.shader;
    if (this.FU && _ && E !== void 0 && E > 0 && F && t !== 2) {
      const Q = this.FU;
      this.WD.pd(_).SO(_, ((nt, et, it, rt) => !!this.WD.qz(it, t, this, { uniforms: this.SE, idFirst: e, useInstanceID: t === 1 ? D : void 0, fillStyleSolid: Q.fillStyleSolid, fillStyleLinearGradient: Q.fillStyleLinearGradient, fillStyleRadialGradient: Q.fillStyleRadialGradient, fillStylePaletted: Q.fillStylePaletted, linearGradientInfo: this.IU, radialGradientInfo: this.PU, lookupValueRange: Q.fillStylePaletted ? er(Q.fillStylePaletted, this, this.vU) : void 0, lookupValueBuffer: null }) && !!V(it, Q.fillStyleIndividual, Q.fillStylePaletted) && (Q?.geometry.pd(it).dC(E - 1), !0)));
    }
    const O = this.ON.type === "none" ? void 0 : t === 1 ? this.ON.mousePickingShader : this.ON.shader;
    if (this.ON.type !== "none" && O && E !== void 0 && E > 0) {
      const Q = this.ON;
      this.WD.pd(O).SO(O, ((nt, et, it, rt) => {
        var tt, at;
        if (!this.MU || !this.WD.qz(it, t, this, { uniforms: this.SE, idFirst: e, useInstanceID: t === 1 && Q.type === "triangulated" ? D : void 0, useVertexID: t === 1 && Q.type === "primitive" ? D : void 0, fillStyleSolid: Q.fillStyleSolid, fillStylePaletted: Q.fillStylePaletted, fillStyleLinearGradient: Q.fillStyleLinearGradient, fillStyleRadialGradient: Q.fillStyleRadialGradient, fillStyleIndividual: Q.fillStyleIndividual, linearGradientInfo: this.LU, radialGradientInfo: this.BU, lookupValueRange: Q.fillStylePaletted ? er(Q.fillStylePaletted, this, this.vU) : void 0, lookupValueBuffer: Q.type === "primitive" ? S : null, colorBuffer: Q.type === "primitive" ? C : null, coordsX: Q.type === "primitive" ? x : void 0, coordsY: Q.type === "primitive" ? M : void 0, coordsHighPrecision: this.ai.Nt() })) return !1;
        if (Q.lineStyleDashed) {
          if (!this.VN) return !1;
          this.WD.xO(nt("uStippleCount"), [this.yi.Ft().x / this.VN.Zz, this.yi.Ft().y / this.VN.Zz])._O(rt("uStippleTextureWidthLimiter"), this.VN.Xz / this.VN.Zz)._O(nt("uStippleScale"), Q.lineStyleDashed.getPatternScale()).MO(nt("uStippleTexture"), this.VN.Wz, 1);
        }
        if (Q.type === "primitive") {
          if (Q.lineStyleDashed) {
            if (!(!((tt = this.MU) === null || tt === void 0) && tt.bufferLengthSoFar)) return !1;
            this.WD.PO(et("aLengthSoFar"), this.MU.bufferLengthSoFar);
          }
          oa.LN(this._V, E);
        } else {
          if (!V(it, Q.fillStyleIndividual, Q.fillStylePaletted)) return !1;
          if (Q.lineStyleDashed) {
            if (!(!((at = this.MU) === null || at === void 0) && at.bufferLengthSoFar)) return !1;
            Gn(this.WD, it, !1, this.MU.bufferLengthSoFar, "aLengthSoFar", "", 2, !1, L.FLOAT, Float32Array.BYTES_PER_ELEMENT, void 0);
          }
          Ts.Ec(this._V, Q.geometry, it, this.EN && t !== 1, t === 1, Q.thickness, this.MU.valueCount - 1);
        }
        return !0;
      }));
    }
    const B = (p = this.wU) === null || p === void 0 ? void 0 : p.bufferX, z = (g = this.wU) === null || g === void 0 ? void 0 : g.bufferY, W = (y = this.wU) === null || y === void 0 ? void 0 : y.bufferColors, G = (m = this.wU) === null || m === void 0 ? void 0 : m.bufferLookupValues, Y = (A = this.wU) === null || A === void 0 ? void 0 : A.bufferSizes, U = (v = this.wU) === null || v === void 0 ? void 0 : v.bufferRotations, $ = t === 1 ? (b = this.yU) === null || b === void 0 ? void 0 : b.mousePickingShader : (w = this.yU) === null || w === void 0 ? void 0 : w.shader, Z = this.yU;
    let q = 1;
    if (F && (_ || O) && this.CU !== void 0 && !Number.isNaN(this.CU)) {
      const Q = (R = (k = this.O$) === null || k === void 0 ? void 0 : k.sensitivity) !== null && R !== void 0 ? R : 1, nt = js(F) === "x" ? this.ai.x : this.ai.y, et = this.CU, it = nt.getInnerInterval() / et, rt = this.k$.T(), tt = nt.Ct() / rt * Q, at = 2 * tt;
      q = it <= tt ? 1 : Math.max(1 - (it - tt) / (at - tt), 0);
    }
    if ($ && Z && B && z && q > 0 && T !== void 0 && T > 0) {
      const Q = Z, nt = Q.instancedRendering ? 1 : 0;
      if (Z.borders && t === 0) {
        const et = Z.borders;
        this.WD.pd(et.shader).SO(et.shader, ((it, rt, tt, at) => {
          if (!this.WD.qz(tt, t, this, { uniforms: this.SE, idFirst: e, fillStyleSolid: et.fillStyleSolid })) return !1;
          if (P && (this.WD.xO(it("uUserTransformOffset"), [P.x.offset, P.y.offset]), this.WD.xO(it("uUserTransformScaling"), [P.x.scaling, P.y.scaling])), this.ai.Nt() ? this.WD.bO(B, nt, { location: rt("aPos_highpartX"), size: 1 }, { location: rt("aPos_lowpartX"), size: 1 }).bO(z, nt, { location: rt("aPos_highpartY"), size: 1 }, { location: rt("aPos_lowpartY"), size: 1 }) : this.WD.oz(rt("aPosX"), B, nt).oz(rt("aPosY"), z, nt), this.WD._O(it("uOpacity"), q), Q.instancedRendering) if (U) this.WD.oz(rt("aRotDeg"), U, nt)._O(it("uBaseRotDeg"), Q.geometry.g$);
          else {
            const ut = $n(this.C$.T() + Q.geometry.g$), ht = Math.sin(ut), st = Math.cos(ut);
            this.WD.xO(it("uRot"), [ht, st]);
          }
          return this.WD.xO(at("uOffsetAlignment"), [-this.F$.x / 2, -this.F$.y / 2]), Q.geometry.m$(tt, Y, T, this.k$.T(), Q.instancedRendering, this._$.getThickness());
        }));
      }
      this.WD.pd($).SO($, ((et, it, rt, tt) => {
        if (!this.wU || !this.WD.qz(rt, t, this, { uniforms: this.SE, idFirst: e, useInstanceID: Q.instancedRendering && t === 1 ? D : void 0, useVertexID: Q.instancedRendering || t !== 1 ? void 0 : D, fillStyleSolid: Q.fillStyleSolid, fillStyleLinearGradient: Q.fillStyleLinearGradient, fillStyleRadialGradient: Q.fillStyleRadialGradient, linearGradientInfo: this.DU, radialGradientInfo: this.EU, fillStylePaletted: Q.fillStylePaletted, fillStyleIndividual: Q.fillStyleIndividual, lookupValueRange: Q.fillStylePaletted ? er(Q.fillStylePaletted, this, this.vU) : void 0, lookupValueBuffer: G, lookupValueAttribDivisor: nt, colorBuffer: W, colorAttribDivisor: nt, fillStyleImage: Q.fillStyleImage, texturedFillGLInfo: this.a$, texCoordAttribDivisor: 0, maskTexture: Q.shapeIcon && this.a$, maskTextureCoordsAttribDivisor: 0 })) return !1;
        if (P && (this.WD.xO(et("uUserTransformOffset"), [P.x.offset, P.y.offset]), this.WD.xO(et("uUserTransformScaling"), [P.x.scaling, P.y.scaling])), this.ai.Nt() ? this.WD.bO(B, nt, { location: it("aPos_highpartX"), size: 1 }, { location: it("aPos_lowpartX"), size: 1 }).bO(z, nt, { location: it("aPos_highpartY"), size: 1 }, { location: it("aPos_lowpartY"), size: 1 }) : this.WD.oz(it("aPosX"), B, nt).oz(it("aPosY"), z, nt), t !== 1 && this.WD._O(et("uOpacity"), q), Q.instancedRendering) if (U) this.WD.oz(it("aRotDeg"), U, nt)._O(et("uBaseRotDeg"), Q.geometry.g$);
        else {
          const at = $n(this.C$.T() + Q.geometry.g$), ut = Math.sin(at), ht = Math.cos(at);
          this.WD.xO(et("uRot"), [ut, ht]);
        }
        return this.WD.xO(tt("uOffsetAlignment"), [-this.F$.x / 2, -this.F$.y / 2]), Q.geometry.dC(rt, Y, 0, this.wU.valueCount, Q.pointSizeAsScale && this.a$ ? { scale: this.k$.T(), width: Q.shapeIcon ? Q.shapeIcon.Ft().x : this.a$.texture.UR, height: Q.shapeIcon ? Q.shapeIcon.Ft().y : this.a$.texture.jR } : this.k$.T(), Q.instancedRendering), !0;
      }));
    }
    return { idCount: D };
  }
  wi() {
    return this.vU;
  }
  Oc(t, e, i, s, o) {
    var n;
    const a = (n = this.Kd.T()) === null || n === void 0 ? void 0 : n.ts;
    if (a?.yd(this.nw)) return {};
    const l = t - e;
    return { info: { dataPoint: a?.Ed(this.nw, l) } };
  }
  dispose() {
    var t, e, i, s, o, n, a, l, h, u, c, d, f;
    return super.dispose(), this.WD.LO((t = this.MU) === null || t === void 0 ? void 0 : t.bufferX), this.WD.LO((e = this.MU) === null || e === void 0 ? void 0 : e.bufferY), this.WD.LO((i = this.MU) === null || i === void 0 ? void 0 : i.bufferColors), this.WD.LO((s = this.MU) === null || s === void 0 ? void 0 : s.bufferLookupValues), this.WD.LO((o = this.MU) === null || o === void 0 ? void 0 : o.bufferRotations), this.WD.LO((n = this.MU) === null || n === void 0 ? void 0 : n.bufferSizes), this.WD.LO((a = this.wU) === null || a === void 0 ? void 0 : a.bufferX), this.WD.LO((l = this.wU) === null || l === void 0 ? void 0 : l.bufferY), this.WD.LO((h = this.wU) === null || h === void 0 ? void 0 : h.bufferColors), this.WD.LO((u = this.wU) === null || u === void 0 ? void 0 : u.bufferLookupValues), this.WD.LO((c = this.wU) === null || c === void 0 ? void 0 : c.bufferRotations), this.WD.LO((d = this.wU) === null || d === void 0 ? void 0 : d.bufferSizes), this.ON = { type: "none" }, this.FU = void 0, this.yU = void 0, this.EG.fG(), (f = this.Kd.T()) === null || f === void 0 || f.qi(), this.MU = void 0, this.wU = void 0, this.LU = void 0, this.BU = void 0, this.IU = void 0, this.PU = void 0, this.DU = void 0, this.EU = void 0, this.WD.Kz(this, this.a$), this.EG.pG(), this;
  }
  Rc() {
    return this.dispose(), this;
  }
  RU(t) {
    if (!this.nw) return this.SU || Ie;
    if (!this.SU) {
      if (this.xU) {
        this.SU = { min: { x: wt, y: wt }, max: { x: Pt, y: Pt }, bU: Date.now() };
        for (let a = 0; a < this.xU.oU.length; a += 1) {
          const l = this.xU.oU[a], h = this.xU.aU[a];
          this.SU.min.x = l < this.SU.min.x ? l : this.SU.min.x, this.SU.min.y = h < this.SU.min.y ? h : this.SU.min.y, this.SU.max.x = l > this.SU.max.x ? l : this.SU.max.x, this.SU.max.y = h > this.SU.max.y ? h : this.SU.max.y;
        }
        return this.SU;
      }
      const o = t.Td(this.nw);
      if (o.xValues.length === 0) return Ie;
      this.SU = { min: { x: wt, y: wt }, max: { x: Pt, y: Pt }, bU: Date.now() };
      const n = o.xValues.length;
      for (let a = 0; a < n; a += 1) {
        const l = o.xValues[a], h = o.yValues[a];
        this.SU.min.x = l < this.SU.min.x ? l : this.SU.min.x, this.SU.min.y = h < this.SU.min.y ? h : this.SU.min.y, this.SU.max.x = l > this.SU.max.x ? l : this.SU.max.x, this.SU.max.y = h > this.SU.max.y ? h : this.SU.max.y;
      }
      return this.gU.length = 0, this.SU;
    }
    const e = t.pd(this.nw), i = e.bd, s = e.xd;
    if (this.gU.length > 0 && i && s) {
      for (const o of this.gU) {
        for (let n = o.min; n <= o.max; n += 1) {
          const a = i[n], l = s[n];
          this.SU.min.x = a < this.SU.min.x ? a : this.SU.min.x, this.SU.min.y = l < this.SU.min.y ? l : this.SU.min.y, this.SU.max.x = a > this.SU.max.x ? a : this.SU.max.x, this.SU.max.y = l > this.SU.max.y ? l : this.SU.max.y;
        }
        this.gU.length = 0;
      }
      return this.SU;
    }
    return this.SU;
  }
  Wi(t = !0) {
    var e, i, s, o, n;
    const a = (e = this.Kd.T()) === null || e === void 0 ? void 0 : e.ts;
    if (!a) return 0;
    const l = a.yd(this.nw);
    return l === "ProgressiveX" ? ((i = a.Bd(this.nw)) === null || i === void 0 ? void 0 : i.x) || 0 : l === "RegressiveX" ? ((s = a.Ld(this.nw)) === null || s === void 0 ? void 0 : s.x) || 0 : l === "ProgressiveY" && t ? ((o = this._U) === null || o === void 0 ? void 0 : o.max) || 0 : l === "RegressiveY" && t ? ((n = this._U) === null || n === void 0 ? void 0 : n.max) || 0 : this.RU(a).max.x;
  }
  Hi(t = !0) {
    var e, i, s, o, n;
    const a = (e = this.Kd.T()) === null || e === void 0 ? void 0 : e.ts;
    if (!a) return 0;
    const l = a.yd(this.nw);
    return l === "ProgressiveX" ? ((i = a.Ld(this.nw)) === null || i === void 0 ? void 0 : i.x) || 0 : l === "RegressiveX" ? ((s = a.Bd(this.nw)) === null || s === void 0 ? void 0 : s.x) || 0 : l === "ProgressiveY" && t ? ((o = this._U) === null || o === void 0 ? void 0 : o.min) || 0 : l === "RegressiveY" && t ? ((n = this._U) === null || n === void 0 ? void 0 : n.min) || 0 : this.RU(a).min.x;
  }
  Zi(t = !0) {
    var e, i, s, o, n;
    const a = (e = this.Kd.T()) === null || e === void 0 ? void 0 : e.ts;
    if (!a) return 0;
    const l = a.yd(this.nw);
    return l === "ProgressiveX" && t ? $e((i = this._U) === null || i === void 0 ? void 0 : i.max, 0) : l === "RegressiveX" && t ? $e((s = this._U) === null || s === void 0 ? void 0 : s.max, 0) : l === "ProgressiveY" ? $e((o = a.Bd(this.nw)) === null || o === void 0 ? void 0 : o.y, 0) : l === "RegressiveY" ? $e((n = a.Ld(this.nw)) === null || n === void 0 ? void 0 : n.y, 0) : this.RU(a).max.y;
  }
  Xi(t = !0) {
    var e, i, s, o, n;
    const a = (e = this.Kd.T()) === null || e === void 0 ? void 0 : e.ts;
    if (!a) return 0;
    const l = a.yd(this.nw);
    return l === "ProgressiveX" && t ? $e((i = this._U) === null || i === void 0 ? void 0 : i.min, 0) : l === "RegressiveX" && t ? $e((s = this._U) === null || s === void 0 ? void 0 : s.min, 0) : l === "ProgressiveY" ? $e((o = a.Ld(this.nw)) === null || o === void 0 ? void 0 : o.y, 0) : l === "RegressiveY" ? $e((n = a.Bd(this.nw)) === null || n === void 0 ? void 0 : n.y, 0) : this.RU(a).min.y;
  }
  mu() {
    var t, e;
    let i = this.k$.T();
    this.a$ && (i = Math.max(this.a$.texture.UR, this.a$.texture.jR) * this.k$.T());
    const s = !!(!((t = this.nw) === null || t === void 0) && t.size), o = Math.max(qi(this.vc), s ? 25 : i), n = (e = this.Kd.T()) === null || e === void 0 ? void 0 : e.ts.yd(this.nw);
    return !n || n !== "ProgressiveX" && n !== "RegressiveX" ? o : 0;
  }
  Su() {
    var t, e;
    let i = this.k$.T();
    this.a$ && (i = Math.max(this.a$.texture.UR, this.a$.texture.jR) * this.k$.T());
    const s = !!(!((t = this.nw) === null || t === void 0) && t.size), o = Math.max(qi(this.vc), s ? 25 : i), n = (e = this.Kd.T()) === null || e === void 0 ? void 0 : e.ts.yd(this.nw);
    return !n || n !== "ProgressiveY" && n !== "RegressiveY" ? o : 0;
  }
}
const QM = () => {
  const t = (i, s, o, n, a) => {
    const l = { min: wt, max: Pt };
    let h, u = 0, c = 0;
    for (let d = n; d <= a; d += 1) {
      const f = d % i.length, p = i[f], g = s[f];
      o && Number.isNaN(g) ? h = void 0 : (l.min = Math.min(l.min, g), l.max = Math.max(l.max, g), h !== void 0 && (u += 1, c += Math.abs(p - h)), h = p);
    }
    return { visibleBoundaries: l, avgPointGap: c / u, sampleMin: n, sampleMax: a, finitePointPairCount: u };
  };
  let e;
  return (i, s, o, n, a, l, h) => {
    if (!o) return e = void 0, { visibleBoundaries: void 0, avgPointGap: 0 };
    if (o.iLastSample - o.iFirstSample + 1 < 2e3) return t(a, l, h, o.iFirstSample, o.iLastSample);
    n && (e = void 0), e || (e = { iFirst: o.iFirstSample, chunks: [] });
    let u = e.iFirst, c = e.iFirst + e.chunks.length * 1e3 - 1;
    for (; ; ) {
      const y = c + 1, m = c + 1e3;
      if (!(o.iLastSample >= m)) break;
      {
        const A = t(a, l, h, y, m);
        e.chunks.push(A), c = m;
      }
    }
    for (; ; ) {
      const y = u - 1, m = u - 1e3;
      if (!(o.iFirstSample <= m)) break;
      {
        const A = t(a, l, h, m, y);
        e.chunks.unshift(A), e.iFirst = m, u = m;
      }
    }
    for (let y = 0; y < e.chunks.length && e.chunks[y].sampleMin < o.iFirstSample; y++) e.chunks.splice(y, 1), e.iFirst += 1e3, y--;
    for (let y = e.chunks.length - 1; y >= 0 && e.chunks[y].sampleMax > o.iLastSample; y--) e.chunks.splice(y, 1);
    if (e.chunks.length === 0) return e = void 0, { visibleBoundaries: void 0, avgPointGap: 0 };
    const d = { min: wt, max: Pt }, f = [];
    for (const y of e.chunks) d.min = Math.min(y.visibleBoundaries.min, d.min), d.max = Math.max(y.visibleBoundaries.max, d.max), f.push(y.avgPointGap);
    const p = t(a, l, h, o.iFirstSample, e.iFirst - 1), g = t(a, l, h, e.chunks[e.chunks.length - 1].sampleMax + 1, o.iLastSample);
    return p.finitePointPairCount > 0 && (d.min = Math.min(p.visibleBoundaries.min, d.min), d.max = Math.max(p.visibleBoundaries.max, d.max), f.push(p.avgPointGap)), g.finitePointPairCount > 0 && (d.min = Math.min(g.visibleBoundaries.min, d.min), d.max = Math.max(g.visibleBoundaries.max, d.max), f.push(g.avgPointGap)), { visibleBoundaries: d, avgPointGap: f.reduce(((y, m) => y + m / f.length), 0) };
  };
}, Hc = (r, t, e, i, s, o, n, a, l, h, u, c, d, f) => {
  const p = js(h), g = Wn(h), y = Array.isArray(t[0]) || Xs(t[0]) ? vr(t[0]) : t[0], m = Array.isArray(t[1]) || Xs(t[1]) ? vr(t[1]) : t[1], A = e && (Array.isArray(e) || Xs(e)) ? vr(e) : e, v = i && (Array.isArray(i) || Xs(i)) ? vr(i) : i, b = s && (Array.isArray(s) || Xs(s)) ? vr(s) : s, w = o && (Array.isArray(o) || Xs(o)) ? vr(o) : o, k = y.length, R = y.elementAt(0), L = y.elementAt(k - 1), x = m.elementAt(0), M = m.elementAt(k - 1), C = c ? 2 : 1;
  if (a && l && a.firstX !== void 0 && a.lastX !== void 0 && a.firstY !== void 0 && a.lastY !== void 0 && (h === "ProgressiveX" && R >= a.firstX || h === "RegressiveX" && R <= a.firstX || h === "ProgressiveY" && x >= a.firstY || h === "RegressiveY" && x <= a.firstY)) {
    const W = p === "x" ? y : m, G = p === "x" ? a.lastX : a.lastY, Y = ln(G, 0, k - 1, g, ((U) => W.elementAt(U)));
    if (W.elementAt(Y) === G) {
      const U = a.bufferSize - a.valueCount, $ = Y + 1, Z = k - $;
      if (Z === 0) return a;
      if (U >= Z) {
        const q = y.toArray($, $ + Z - 1), Q = m.toArray($, $ + Z - 1);
        if (r.KO(a.bufferX, a.valueCount * C, d(q), Float32Array), r.KO(a.bufferY, a.valueCount * C, d(Q), Float32Array), A && a.bufferColors) {
          const nt = A.toArray($, $ + Z - 1);
          r.KO(a.bufferColors, a.valueCount, nt, Uint32Array);
        }
        if (v && a.bufferLookupValues) {
          const nt = v.toArray($, $ + Z - 1);
          r.KO(a.bufferLookupValues, a.valueCount, nt, Float32Array);
        }
        if (b && a.bufferSizes) {
          const nt = b.toArray($, $ + Z - 1);
          r.KO(a.bufferSizes, a.valueCount, nt, Float32Array);
        }
        if (w && a.bufferRotations) {
          const nt = w.toArray($, $ + Z - 1);
          r.KO(a.bufferRotations, a.valueCount, nt, Float32Array);
        }
        if (n && a.bufferLengthSoFar) {
          const [nt, et, it] = Pd(q, Q, a.lastX || 0, a.lastY || 0, a.lengthSoFarX, a.lengthSoFarY, f);
          r.KO(a.bufferLengthSoFar, 2 * a.valueCount, nt, Float32Array), a.lengthSoFarX = et, a.lengthSoFarY = it;
        }
        return a.valueCount += Z, a.lastX = L, a.lastY = M, a;
      }
    }
  }
  const S = y.toArray(0, k - 1), E = m.toArray(0, k - 1), T = k + u, I = r.QO(T * C, d(S), a?.bufferX, Float32Array), F = r.QO(T * C, d(E), a?.bufferY, Float32Array), D = A ? r.QO(T, A.toArray(0, k - 1), a?.bufferColors, Uint32Array) : void 0, P = v ? r.QO(T, v.toArray(0, k - 1), a?.bufferLookupValues, Float32Array) : void 0, V = b ? r.QO(T, b.toArray(0, k - 1), a?.bufferSizes, Float32Array) : void 0, _ = w ? r.QO(T, w.toArray(0, k - 1), a?.bufferRotations, Float32Array) : void 0;
  let O, B = 0, z = 0;
  if (n) {
    const W = Pd(S, E, S[0], E[0], 0, 0, f);
    O = r.QO(2 * T, W[0], a?.bufferLengthSoFar, Float32Array), B = W[1], z = W[2];
  }
  return { bufferX: I, bufferY: F, bufferColors: D, bufferLookupValues: P, bufferSizes: V, bufferRotations: _, bufferSize: T, bufferLengthSoFar: O, valueCount: k, firstX: R, lastX: L, firstY: x, lastY: M, lengthSoFarX: B, lengthSoFarY: z };
}, Pd = (r, t, e, i, s, o, n) => {
  const a = r.length, l = new Float32Array(2 * a);
  if (a === 0) return [l, 0, 0];
  let h = 0, u = e, c = i, d = s, f = o;
  if (n) for (let p = 0; p < a; p += 1) {
    const g = r[p], y = t[p];
    Number.isNaN(g) || Number.isNaN(y) || Number.isNaN(u) || Number.isNaN(c) ? (d = 0, f = 0, l[h] = 0, l[h + 1] = 0, h += 2) : (d += Math.abs(u - g), f += Math.abs(c - y), l[h] = d, l[h + 1] = f, h += 2), u = g, c = y;
  }
  else for (let p = 0; p < a; p += 1) {
    const g = r[p], y = t[p];
    d += Math.abs(u - g), f += Math.abs(c - y), l[h] = d, l[h + 1] = f, h += 2, u = g, c = y;
  }
  return [l, d, f];
}, Es = { translation: (r, t) => [1, 0, 0, 0, 1, 0, r, t, 1], rotation(r) {
  const t = Math.cos(r), e = Math.sin(r);
  return [t, -e, 0, e, t, 0, 0, 0, 1];
}, scaling: (r, t) => [r, 0, 0, 0, t, 0, 0, 0, 1], translate: (r, t, e) => Es.multiply(r, Es.translation(t, e)), rotate: (r, t) => Es.multiply(r, Es.rotation(t)), scale: (r, t, e) => Es.multiply(r, Es.scaling(t, e)), multiply(r, t) {
  const e = r[0], i = r[1], s = r[2], o = r[3], n = r[4], a = r[5], l = r[6], h = r[7], u = r[8], c = t[0], d = t[1], f = t[2], p = t[3], g = t[4], y = t[5], m = t[6], A = t[7], v = t[8];
  return [c * e + d * o + f * l, c * i + d * n + f * h, c * s + d * a + f * u, p * e + g * o + y * l, p * i + g * n + y * h, p * s + g * a + y * u, m * e + A * o + v * l, m * i + A * n + v * h, m * s + A * a + v * u];
}, projection: (r, t, e) => [2 / r, 0, 0, 0, -2 * e / t, 0, -1, 1 * e, 1] };
let hu = class extends Nf {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.OU = [], this.SE = new Fs(), this.zU = [j(0, 0), j(0, 0), j(0, 0), j(0, 0)], this.VU = Ee(j(0, 0), j(0, 0)), this.NU = Ee(j(0, 0), j(0, 0)), this.GU = j(0, 0), this.$U = j(0, 0), this.UU = j(0, 0), this.jU = 0, this.YU = 0, this.LV = ss({ fillStyleSolid: () => de(this.Ke) && this.Ke, fillStyleRadialGradient: () => li(this.Ke) && this.Ke, fillStyleLinearGradient: () => hi(this.Ke) && this.Ke }), this._V = t, this.wV = e, this.WD = t.kV(), this.wV = e, this.HN = t.Ga.Ya;
  }
  Uh() {
    const t = this.xl(), e = this.bl(), i = this.ui.T();
    if (t) {
      const s = this.ml(), o = this.LV.fillStyleSolid(s), n = this.LV.fillStyleRadialGradient(s), a = this.LV.fillStyleLinearGradient(s), l = o || n || a, h = this.WD, u = this.WD.rO(), c = u !== this.YU;
      if (this.YU = u, this.SE.TO(this.ai), this.El.u || c) {
        this.HU && this.HU.hE(this), this.font.C(qu(this.El.T(), u));
        const m = this.font.T();
        this.HU = this.WD.Fh(m.properties.family), this.HU.pd(this);
      }
      const d = this.font.u || this.Tl.u;
      if (d && this.HU) {
        const m = this.font.T();
        [this.WU, this.NU] = this.HU.oE(this.Tl.T(), m, this._V.xi.isDark), this.OU.forEach(((A) => {
          A.texCoordBuff && h.LO(A.texCoordBuff), A.vertexBuff && h.LO(A.vertexBuff);
        })), this.OU = this.WU.map(((A) => ({ texCoordBuff: h.pO(A.texCoords, !1), texture: A.texture, info: A }))), this.El.u = !1, this.font.u = !1, this.Tl.u = !1;
      }
      const f = this.ai.ei() || e, p = this.Rn.u || this.Ll.u || this.Pl.u || this.Bl.u || this.Hn.u || this.dt.u || d || f, g = this.Hn.T(), y = pe(j(this.Ll.T() + 1, this.Pl.T() + 1), 0.5);
      if (p && this.WU && (this.GU = j(-(g.left * u + this.NU.max.x - this.NU.min.x + g.right * u) * y.x, -(g.bottom * u + this.NU.max.y - this.NU.min.y + g.top * u) * y.y)), (p || f || this.Dl.u || this.ml()) && this.Ke !== Lt) {
        if (this.WU) {
          const m = qt(this.Rn.T(), this.Bl.T()), A = xt(m, this.ai, this.yi.ai), v = pe(A, u);
          this.UU = v;
          const b = $n(this.Dl.T());
          this.jU = b, d && this.OU.forEach(((C) => {
            const S = C.info;
            S && (C.vertexBuffLen = S.vertices.length / 2, C.vertexBuff = h.pO(S.vertices, !0, C.vertexBuff));
          }));
          const w = this.dt.T(), k = [qt(Un(j((this.NU.min.x + (-w.left - g.left) * u + this.GU.x) / u, (this.NU.max.y + (w.top + g.top) * u + this.GU.y) / u), this.Rl, b), A), qt(Un(j((this.NU.max.x + (w.right + g.right) * u + this.GU.x) / u, (this.NU.max.y + (w.top + g.top) * u + this.GU.y) / u), this.Rl, b), A), qt(Un(j((this.NU.max.x + (w.right + g.right) * u + this.GU.x) / u, (this.NU.min.y + (-w.bottom - g.bottom) * u + this.GU.y) / u), this.Rl, b), A), qt(Un(j((this.NU.min.x + (-w.left - g.left) * u + this.GU.x) / u, (this.NU.min.y + (-w.bottom - g.bottom) * u + this.GU.y) / u), this.Rl, b), A)];
          this.zU = [xt(k[0], this.yi.ai, this.ai), xt(k[1], this.yi.ai, this.ai), xt(k[2], this.yi.ai, this.ai), xt(k[3], this.yi.ai, this.ai)];
          const R = Vi(k);
          this.$U = j(-(R.max.x - R.min.x) * u * y.x - R.min.x * u + this.UU.x, -(R.max.y - R.min.y) * u * y.y - R.min.y * u + this.UU.y), this.Pr = oi(R.max, R.min), this.$U = { x: this.$U.x / u, y: this.$U.y / u };
          const L = Vi(this.zU), x = this.ai.Qt(L.min, this.$U), M = this.ai.Qt(L.max, this.$U);
          this.VU = Vi([x, M]), this.$U = { x: this.$U.x * u, y: this.$U.y * u };
        }
        n ? this.VV = Ws(this.VU, this.ai, n.getPosition(), n.getExtent(), n.getShape(), this.WD.rO()) : a ? this.NV = Gs(this.VU, this.ai, a.getAngle(!0), this.WD.rO()) : (this.VV = void 0, this.NV = void 0);
      }
      this.ml() && (this.ME = l ? this.WD.SR(K["2D"], K.VertexLocation({ axisWorldTranslation: "matrix", normalSource: void 0, snapToNearestPixel: this.HN }), K.Color({ dataType: n ? ["gradient", n] : a ? ["gradient", a] : "uniform", maskTextureText: !0 })) : void 0), this.XU = !this.Zl || this.Ke === Lt || o && o.getColor().getA() === 0 ? void 0 : this.XU || this.WD.SR(K["2D"], K.VertexLocation({ axisWorldTranslation: "matrix", normalSource: void 0, snapToNearestPixel: this.HN }), K.Color({ dataType: "uniform", maskTextureText: !0 })), this.ZU = i && l ? this.ZU || this.WD.SR(K["2D"], K.MousePicking(), K.VertexLocation({ axisWorldTranslation: "matrix", normalSource: void 0, snapToNearestPixel: this.HN })) : void 0, this.Rn.u = !1, this.Ll.u = !1, this.Pl.u = !1, this.Bl.u = !1, this.Dl.u = !1, this.Ml(this.Ke);
    }
    return this.Ol = t, this;
  }
  Ec(t, e) {
    if (this.Fl) {
      const i = Math.min(this.zU[0].x, this.zU[1].x), s = Math.max(this.zU[0].x, this.zU[1].x), o = Math.min(this.zU[0].y, this.zU[2].y), n = Math.max(this.zU[0].y, this.zU[2].y);
      this.Js.bv();
      const a = Math.min(this.ai.x.$, this.ai.x.U), l = Math.max(this.ai.x.$, this.ai.x.U), h = Math.min(this.ai.y.$, this.ai.y.U), u = Math.max(this.ai.y.$, this.ai.y.U);
      if (!(i <= l && a <= s && o <= u && h <= n)) return { idCount: 1 };
    }
    if (this.xl()) {
      const i = t === 0 ? this.XU : void 0, s = this.Zl, o = t === 1 ? this.ZU : this.ME;
      if (!o || this.OU.length === 0) return {};
      const n = this.LV.fillStyleSolid(!1), a = this.LV.fillStyleRadialGradient(!1), l = this.LV.fillStyleLinearGradient(!1), h = this.yi.KE(), u = h.x, c = h.y;
      let d = Es.projection(u, c, -1);
      const f = Es.translation(this.GU.x, this.GU.y), p = Es.translation(this.$U.x, this.$U.y);
      d = Es.translate(d, this.UU.x, this.UU.y), d = Es.multiply(d, p), d = Es.rotate(d, this.jU), d = Es.multiply(d, f), t === 1 && (d = Es.scale(d, this.NU.max.x, this.NU.max.y)), i && s && (d = Es.translate(d, this.Il.x, this.Il.y), this.WD.pd(i).SO(i, ((g, y, m, A) => (this.WD.HO(g("uMatrix"), d)._O(g("uIsHighlighted"), 0).gP(g("uHighlightColorOffset"), Qe)._O(g("uRenderEffectMask"), 0).gP(g("uColor"), s), this.HN && this.WD.xO(A("uViewportSizePx"), [h.x * this.WD.rO(), h.y * this.WD.rO()]), this.OU.forEach(((v) => {
        this.WD.PO(y("aPos"), v.vertexBuff).PO(y("aMaskTextureCoord"), v.texCoordBuff).MO(g("uMaskTexture"), v.texture, 0).dC(this.WD.gl.TRIANGLES, v.vertexBuffLen);
      })), !0))), d = Es.translate(d, -this.Il.x, -this.Il.y)), this.WD.pd(o).SO(o, ((g, y, m, A) => {
        if (this.WD.HO(g("uMatrix"), d)._O(g("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(g("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(g("uRenderEffectMask"), t === 2 ? 1 : 0), this.HN && this.WD.xO(A("uViewportSizePx"), [h.x * this.WD.rO(), h.y * this.WD.rO()]), t === 1) this.WD.XO(g("uFirstId"), e).$z(m, 1);
        else if (n) this.WD.gP(g("uColor"), n.getColor());
        else if (a && this.VV) {
          this.WD.xO(g("uCenter"), this.VV.center).xO(g("uDistance"), this.VV.distance).IO(g("uBounds"), this.VV.bounds)._O(g("uAspect"), this.VV.aspectRatio);
          const v = a.getColorStops();
          for (let b = 0; b < v.length; b += 1) this.WD.gP(g(`color_${b}`), v[b].color)._O(g(`stop_${b}`), v[b].offset);
        } else if (l && this.NV) {
          this.WD.xO(g("uStartPoint"), this.NV.startPoint).xO(g("uEndPoint"), this.NV.endPoint).IO(g("uBounds"), this.NV.bounds);
          const v = l.getColorStops();
          for (let b = 0; b < v.length; b += 1) this.WD.gP(g(`color_${b}`), v[b].color)._O(g(`stop_${b}`), v[b].offset);
        }
        return t === 1 && this.WD.PO(y("aPos"), this.WD.wz).dC(this.WD.gl.TRIANGLES, 6), t !== 1 && this.OU.forEach(((v) => {
          this.WD.PO(y("aPos"), v.vertexBuff).PO(y("aMaskTextureCoord"), v.texCoordBuff).MO(g("uMaskTexture"), v.texture, 0).dC(this.WD.gl.TRIANGLES, v.vertexBuffLen);
        })), !0;
      }));
    }
    return { idCount: 1 };
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  Ic() {
    return this.xl() ? Vi(this.zU) : Ie;
  }
  Bc() {
    return this.xl() && this.Pr ? this.Pr : j(0, 0);
  }
  Ft() {
    if (this.xl() && this.VU) {
      const t = this.VU;
      return j(t.max.x - t.min.x, t.max.y - t.min.y);
    }
    return j(0, 0);
  }
  Rc() {
    return this.OU.forEach(((t) => {
      t.texCoordBuff && this.WD.LO(t.texCoordBuff), t.vertexBuff && this.WD.LO(t.vertexBuff);
    })), this.OU = [], this.HU && this.HU.hE(this), this.ME = void 0, this.XU = void 0, this.ZU = void 0, this;
  }
  Wi() {
    return this.VU.max.x;
  }
  Hi() {
    return this.VU.min.x;
  }
  Zi() {
    return this.VU.max.y;
  }
  Xi() {
    return this.VU.min.y;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
};
class tC {
  constructor(t) {
    this.qN = 0, this.JU = null, this.QU = t;
  }
  KU() {
    return this.QU;
  }
  qU(t, e, i, s) {
    for (var o, n, a, l, h, u, c, d, f, p, g = this.JU, y = null, m = null, A = !1, v = !1; g && (y === null && (this.tj(t, e, (o = g.head) === null || o === void 0 ? void 0 : o.px, (n = g.head) === null || n === void 0 ? void 0 : n.py) ? (y = g, A = !0) : this.tj(t, e, (a = g.tail) === null || a === void 0 ? void 0 : a.px, (l = g.tail) === null || l === void 0 ? void 0 : l.py) && (y = g)), m === null && (this.tj(i, s, (h = g.head) === null || h === void 0 ? void 0 : h.px, (u = g.head) === null || u === void 0 ? void 0 : u.py) ? (m = g, v = !0) : this.tj(i, s, (c = g.tail) === null || c === void 0 ? void 0 : c.px, (d = g.tail) === null || d === void 0 ? void 0 : d.py) && (m = g)), m == null || y == null); ) g = g.next;
    switch ((y != null ? 1 : 0) | (m != null ? 2 : 0)) {
      case 0:
        var b = { px: t, py: e, prev: null }, w = { px: i, py: s, next: null };
        b.next = w, w.prev = b, y = { head: b, tail: w, next: this.JU, prev: null, closed: !1 }, this.JU && (this.JU.prev = y), this.JU = y, ++this.qN;
        break;
      case 1:
        var k = { px: i, py: s };
        A ? (k.next = y.head, k.prev = null, y.head.prev = k, y.head = k) : (k.next = null, k.prev = y.tail, y.tail.next = k, y.tail = k);
        break;
      case 2:
        k = { px: t, py: e }, v ? (k.next = m.head, k.prev = null, m.head.prev = k, m.head = k) : (k.next = null, k.prev = m.tail, m.tail.next = k, m.tail = k);
        break;
      case 3:
        if (y === m) {
          k = { px: (f = y.tail) === null || f === void 0 ? void 0 : f.px, py: (p = y.tail) === null || p === void 0 ? void 0 : p.py, next: y.head, prev: null }, y.head.prev = k, y.head = k, y.closed = !0;
          break;
        }
        switch ((A ? 1 : 0) | (v ? 2 : 0)) {
          case 0:
            this.ij(y);
          case 1:
            m.tail.next = y.head, y.head.prev = m.tail, m.tail = y.tail, this.sj(y);
            break;
          case 3:
            this.ij(y);
          case 2:
            y.tail.next = m.head, m.head.prev = y.tail, y.tail = m.tail, this.sj(m);
        }
    }
  }
  sj(t) {
    t.prev ? t.prev.next = t.next : this.JU = t.next, t.next && (t.next.prev = t.prev), --this.qN;
  }
  ej(t, e, i = 1e-10) {
    return Math.abs(t - e) < Math.min(Math.abs(t), Math.abs(e)) * i;
  }
  tj(t, e, i, s) {
    return !!(t && e && i && s) && this.ej(t, i) && this.ej(e, s);
  }
  ij(t) {
    for (var e = t.head; e; ) {
      var i = e.next;
      e.next = e.prev, e.prev = i, e = i;
    }
    i = t.head, t.head = t.tail, t.tail = i;
  }
}
class e1 {
  constructor(t) {
    this.h = new Array(5), this.sh = new Array(5), this.xh = new Array(5), this.yh = new Array(5), this.contours = {}, t && (this.rj = t);
  }
  hj(t, e, i, s) {
    const o = e.length - 1, n = i.length - 1;
    var a = this.h, l = this.sh, h = this.xh, u = this.yh;
    const c = s.length;
    this.contours = {};
    for (var d, f, p, g, y, m = function(F, D) {
      return (a[D] * h[F] - a[F] * h[D]) / (a[D] - a[F]);
    }, A = function(F, D) {
      return (a[D] * u[F] - a[F] * u[D]) / (a[D] - a[F]);
    }, v = 0, b = 0, w = 0, k = 0, R = [0, 1, 1, 0], L = [0, 0, 1, 1], x = [[[0, 0, 8], [0, 2, 5], [7, 6, 9]], [[0, 3, 4], [1, 3, 1], [4, 3, 0]], [[9, 6, 7], [5, 2, 0], [8, 0, 0]]], M = n - 1; M >= 0; M--) for (var C = 0; C < o; C++) {
      let F = t(C, M), D = t(C + 1, M), P = t(C, M + 1), V = t(C + 1, M + 1);
      var S = Math.min(P, F), E = Math.min(V, D);
      if (g = Math.min(S, E), S = Math.max(P, F), E = Math.max(V, D), !((y = Math.max(S, E)) < s[0] && g > s[c - 1])) {
        for (var T = 0; T < c; T++) if (s[T] >= g && s[T] <= y) {
          for (var I = 4; I >= 0; I--) I > 0 ? (a[I] = t(C + R[I - 1], M + L[I - 1]) - s[T], h[I] = e[C + R[I - 1]], u[I] = i[M + L[I - 1]]) : (a[0] = 0.25 * (a[1] + a[2] + a[3] + a[4]), h[0] = 0.5 * (e[C] + e[C + 1]), u[0] = 0.5 * (i[M] + i[M + 1])), a[I] > 1e-10 ? l[I] = 2 : a[I] < -1e-10 ? l[I] = 0 : l[I] = 1;
          for (I = 1; I <= 4; I++) if (f = I != 4 ? I + 1 : 1, (p = x[l[d = I]][l[0]][l[f]]) != 0) {
            switch (p) {
              case 1:
                v = h[d], w = u[d], b = h[0], k = u[0];
                break;
              case 2:
                v = h[0], w = u[0], b = h[f], k = u[f];
                break;
              case 3:
                v = h[f], w = u[f], b = h[d], k = u[d];
                break;
              case 4:
                v = h[d], w = u[d], b = m(0, f), k = A(0, f);
                break;
              case 5:
                v = h[0], w = u[0], b = m(f, d), k = A(f, d);
                break;
              case 6:
                v = h[f], w = u[f], b = m(d, 0), k = A(d, 0);
                break;
              case 7:
                v = m(d, 0), w = A(d, 0), b = m(0, f), k = A(0, f);
                break;
              case 8:
                v = m(0, f), w = A(0, f), b = m(f, d), k = A(f, d);
                break;
              case 9:
                v = m(f, d), w = A(f, d), b = m(d, 0), k = A(d, 0);
            }
            this.rj(v, w, b, k, s[T], T);
          }
        }
      }
    }
  }
  rj(t, e, i, s, o, n) {
    let a = this.contours[n];
    a || (a = this.contours[n] = new tC(o)), a.qU(t, e, i, s);
  }
  get nj() {
    var t = [], e = this.contours;
    for (var i in e) for (var s = e[i].JU, o = e[i].QU; s; ) {
      var n = s.head, a = [];
      for (a.ax = [], a.ay = [], a.level = o, a.k = i; n && n.px && n.py; ) a.ax.push(n.px), a.ay.push(n.py), n = n.next;
      t.push(a), s = s.next;
    }
    return t.sort(((l, h) => l.length - h.length)), t;
  }
}
class eC extends Ua {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o), this.oj = le("bilinear"), this.aj = le(void 0), this.lj = !0, this.Wt = { x: 0, y: 0 }, this.uj = { x: 1, y: 1 }, this.kp = Hi.lineStyle, this.cj = le(void 0), this.engine = t;
    const a = n.dataOrder === "columns" ? n.columns : n.rows, l = n.dataOrder === "columns" ? n.rows : n.columns;
    this.Ga = { ...n, primaryDimensionVectorsCount: a, secondaryDimensionVectorsCount: l }, this.dj = new e1();
  }
  Ep(t) {
    return this.oj.C(t), this;
  }
  Rp() {
    return this.oj.T();
  }
  $x(t) {
    return this.aj.C(t), this;
  }
  Ux() {
    return this.aj.T();
  }
  Ip(t, e) {
    return this.lj = this.Wt != t || this.uj != e, this.Wt = t, this.uj = e, this;
  }
  Pp() {
    return { start: this.Wt, step: this.uj, end: { x: this.Wt.x + this.uj.x * this.Ga.columns, y: this.Wt.y + this.uj.y * this.Ga.rows } };
  }
  Cp(t) {
    return this.kp = typeof t == "function" ? t(this.kp) : t, this;
  }
  Dp() {
    return this.kp;
  }
  Lp(t) {
    return this.cj.C(t), this;
  }
  Bp() {
    return this.cj.T();
  }
}
class lc extends eC {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o, n), this.SE = new Fs(), this.ON = {}, this.fj = [], this.Aj = !1, this.Tu = !1, this.LV = ss({ fillStyleSolid: () => de(this.Ke) && this.Ke, fillStylePaletted: () => Ve(this.Ke) && this.Ke, wireframeStyleLine: () => Oi(this.kp) && this.kp, wireframeStyleFill: () => {
      const d = this.kp && this.kp.getFillStyle();
      return de(d) && d;
    } }), this.gj = void 0, this.vj = o5, this._V = t, this.wV = e, this.WD = t.kV(), this.wV = e;
    const a = Math.min(this.WD.ZD, n.Ox !== void 0 ? n.Ox : 2048), l = { x: Math.min(a, this.Ga.primaryDimensionVectorsCount), y: Math.min(a, this.Ga.secondaryDimensionVectorsCount) }, h = ((d, f, p) => {
      const g = [], y = p(d.primaryDimensionVectorsCount, f.x), m = p(d.secondaryDimensionVectorsCount, f.y);
      let A;
      return y.forEach(((v) => m.forEach(((b) => {
        const w = { iFirstVector: { primary: v.start, secondary: b.start }, iFirstUniqueVector: { primary: v.startUnique, secondary: b.startUnique }, sizeHeatmapDataVectors: { primary: v.sizeData, secondary: b.sizeData }, sizeUniqueHeatmapDataVectors: { primary: v.sizeUniqueData, secondary: b.sizeUniqueData } };
        g.push(w);
      })))), A = [], g.forEach(((v) => {
        let b = A.find(((w) => w.sizeHeatmapData.primary === v.sizeHeatmapDataVectors.primary && w.sizeHeatmapData.secondary === v.sizeHeatmapDataVectors.secondary));
        b || (b = { sizeHeatmapData: v.sizeHeatmapDataVectors, tiles: [] }, A.push(b)), b.tiles.push(v);
      })), { gridTiles: g, gridTileSizes: A };
    })(this.Ga, l, this.vj), u = h.gridTiles.map(((d) => ({ ...d, intensityData: void 0, hasIntensityData: !1 }))), c = h.gridTileSizes.map(((d) => ({ ...d, tiles: u.filter(((f) => f.sizeHeatmapDataVectors.primary === d.sizeHeatmapData.primary && f.sizeHeatmapDataVectors.secondary === d.sizeHeatmapData.secondary)) })));
    this.yj = { gridTiles: u, gridTileSizes: c }, this.Ip(this.Wt, this.uj), this.pj = [], this.mj = new Xi((() => {
      const d = new t1(this._V, this.wV, this.ai, ie);
      return d.sf(Lt).tf(Lt), d;
    })), this.Sj = [], this.bj = new Xi((() => {
      const d = new hu(this._V, this.wV, this.ai, ie, []);
      return d.ru({ x: 0, y: 0 }), d;
    }));
  }
  xj() {
    return this.WD.yi.oa.fR;
  }
  wi() {
    return this.Mj;
  }
  _j(t) {
    return t.intensityData || (t.intensityData = new Float32Array(t.sizeHeatmapDataVectors.primary * t.sizeHeatmapDataVectors.secondary)), t.intensityData;
  }
  wj(t, e) {
    return 0 <= t && t < e ? t : t < 0 ? t % e + e : t % e;
  }
  kj(t, e) {
    const i = xt(t, this.ai, this.wV.yi.ai), s = xt(e, this.ai, this.wV.yi.ai);
    let o = 180 * Math.atan2(i.y - s.y, s.x - i.x) / Math.PI;
    return (o < -90 || 90 < o) && (o += 180), o;
  }
  Cj(t, e, i, s) {
    const o = Um(t, e, i, s);
    if (o) {
      let n = Math.min(t.x, e.x, i.x, s.x), a = Math.max(t.x, e.x, i.x, s.x), l = Math.min(t.y, e.y, i.y, s.y), h = Math.max(t.y, e.y, i.y, s.y);
      if (o.x <= n || a <= o.x || o.y <= l || h <= o.y) return;
    }
    return o;
  }
  Tj(t, e, i, s) {
    if (e.length < 5) return { labelPos: [{ x: NaN, y: NaN }], labelAngle: [Number.NaN] };
    this.gj === void 0 && (this.gj = new hu(this._V, this.wV, this.ai, this.pi, []));
    const o = t.labelFont;
    let n = this.gj.rn(s).Ph(0).Ih(o).Uh().Ft().x;
    Number.isNaN(n) && (this.gj.dispose(), this.gj = new hu(this._V, this.wV, this.ai, this.pi, []), n = this.gj.rn(s).Ph(0).Ih(o).Uh().Ft().x);
    const a = this.gj, l = this.ai.x.$, h = this.ai.x.U, u = this.ai.y.$, c = this.ai.y.U, d = { x: l, y: u }, f = { x: h, y: c }, p = [{ x: d.x, y: d.y }, { x: d.x, y: f.y }], g = [{ x: d.x, y: f.y }, { x: f.x, y: f.y }], y = [{ x: f.x, y: d.y }, { x: f.x, y: f.y }], m = [{ x: d.x, y: d.y }, { x: f.x, y: d.y }];
    let A = { x: e[0], y: i[0] }, v = { x: e[1], y: i[1] }, b = [];
    const w = d.x, k = f.x, R = d.y, L = f.y, x = (V, _, O, B) => {
      const z = wc(V, d, f), W = wc(_, d, f);
      if (z && W) return B ? (O.push(V), O.push(_), !1) : (O.push(_), !1);
      {
        if (!z && !W && (V.x < w && _.x < w || V.y < R && _.y < R || k < V.x && k < _.x || L < V.y && L < _.y)) return !(0 < O.length && isNaN(O[O.length - 1].x) == 0 && (O.push({ x: NaN, y: NaN }), 0));
        const G = this.Cj(p[0], p[1], V, _), Y = this.Cj(g[0], g[1], V, _), U = this.Cj(y[0], y[1], V, _), $ = this.Cj(m[0], m[1], V, _), Z = [];
        if (G && Z.push(G), Y && Z.push(Y), U && Z.push(U), $ && Z.push($), Z.length == 1) {
          if (z) B && O.push(V), O.push(_), O.push({ x: NaN, y: NaN });
          else if (W) return O.push(V), O.push(_), !1;
        } else Z.length == 2 && (0 < O.length && isNaN(O[O.length - 1].x) == 0 && O.push({ x: NaN, y: NaN }), O.push(Z[0]), O.push(Z[1]), O.push({ x: NaN, y: NaN }));
        return !0;
      }
    };
    let M = x(A, v, b, !0);
    const C = 4 * this.ai.x.getPixelSize() / 2;
    for (let V = 2; V < e.length; V++) v = { x: e[V], y: i[V] }, C <= Math.abs(v.x - A.x) + Math.abs(v.y - A.y) && (M = x(A, v, b, M), A = v);
    const S = b.length;
    if (S < 2) return { labelPos: [{ x: NaN, y: NaN }], labelAngle: [Number.NaN] };
    A = { x: e[e.length - 1], y: i[i.length - 1] }, wc(A, d, f) && A.x == b[0].x && A.y == b[0].y && b.push(b[0]);
    let E = [];
    const T = [];
    let I = 0;
    for (let V = I + 1; V < 2 * S; V++) {
      let _ = this.wj(V, S);
      if (S < V && n < this.Rf(b[_], b[0])) break;
      let O = this.wj(I, S);
      if (isNaN(b[O].x)) {
        0 < E.length && (T.push(E), E = []), ++I, V = I;
        continue;
      }
      const B = isNaN(b[_].x);
      let z = 0;
      if (B) {
        0 < E.length && (T.push(E), E = []), ++V, I = V;
        continue;
      }
      const W = 0;
      if (b[_].x < d.x + W || f.x - W < b[_].x || b[_].y < d.y + W || f.y - W < b[_].y) ++V, I = V;
      else if (z = this.Rf(b[_], b[O]), n < z) {
        const G = b[O], Y = b[_];
        let U = Number.MIN_VALUE;
        const $ = 0;
        for (let Z = I + 1; Z < V - 1; Z++) {
          const q = this.wj(Z, S);
          if (isNaN(b[q].x)) break;
          if (U != Number.MIN_VALUE && (b[q].x < d.x + $ || f.x - $ < b[q].x || b[q].y < d.y + $ || f.y - $ < b[q].y)) continue;
          const Q = mA({ x: b[q].x, y: b[q].y }, G, Y);
          U < Q && (U = Q);
        }
        if (U != Number.MIN_VALUE && (E.push({ x: U, y: O, z: _ }), S <= V && 0 <= O)) break;
        ++I, V = I;
      } else B && (++I, V = I);
    }
    v = { x: 0, y: 0 };
    let F = -1;
    const D = [], P = [];
    T.length < 1 && 0 < E.length && T.push(E);
    for (let V = 0; V < T.length; V++) {
      E = T[V], E.sort(((U, $) => U.x - $.x)), F = E[0].y;
      let _ = 0, O = E[0].z;
      this.Sj.forEach(((U, $) => {
        const Z = a.hr({ x: U.position.x, y: U.position.y }).Ph(U.angle).Ih(U.font).Uh().Ic();
        if (isNaN(Z.min.x)) return;
        let q = F, Q = O;
        if (b[q] && b[Q] && !isNaN(b[q].x) && !isNaN(b[Q].x)) {
          let nt = this.kj(b[q], b[Q]), et = a.hr({ x: e[F], y: i[F] }).Ph(nt).Ih(o).Uh().Ic();
          for (; ma(Z, et) && _ < E.length - 1; ) if (q = E[++_].y, Q = E[_].z, b[q] && b[Q] && !isNaN(b[q].x) && !isNaN(b[Q].x)) {
            const it = (b[q].x + b[Q].x) / 2, rt = (b[q].y + b[Q].y) / 2;
            nt = this.kj(b[q], b[Q]), et = a.hr({ x: it, y: rt }).Ph(nt).Ih(o).Uh().Ic();
          }
        }
      })), E.length <= _ && (_ = 0);
      let B = E[_].y, z = E[_].z, W = 0;
      W = B < z ? z - B : S - B + z, 3 < W && (W -= 2), F = B;
      let G = Number.NaN, Y = Number.NaN;
      if (b[0].x == b[b.length - 1].x && b[0].y === b[b.length - 1].y) {
        F = B;
        let U = this.wj(B - 1, b.length), $ = this.wj(B + W, b.length);
        G = (b[U].x + b[$].x) / 2, Y = (b[U].y + b[$].y) / 2;
      } else if (B < 4) {
        F = 3, B = F, z = this.wj(B + W + 1, b.length);
        let U = this.wj(B, b.length), $ = this.wj(z, b.length);
        G = (b[U].x + b[$].x) / 2, Y = (b[U].y + b[$].y) / 2;
      } else {
        for (F = B - 1; F < b.length && isNaN(b[F].x); ) ++F;
        if (F == b.length) for (; F < b.length && isNaN(b[F].x); ) ++F;
        let U = this.wj(F, b.length), $ = this.wj(F + W + 1, b.length);
        G = (b[U].x + b[$].x) / 2, Y = (b[U].y + b[$].y) / 2;
      }
      0 <= F && (A = b[B], v = b[z], D.push({ x: G, y: Y }), P.push(this.kj(A, v)));
    }
    return 0 <= D.length ? { labelPos: D, labelAngle: P } : { labelPos: [{ x: NaN, y: NaN }], labelAngle: [Number.NaN] };
  }
  Rf(t, e) {
    const i = t.x - e.x, s = t.y - e.y;
    return Math.sqrt(i * i + s * s);
  }
  Fj(t, e) {
    if (!this.yj) return this;
    if (!t) return this.Ij(!0), this.Pj(!0), this;
    if (!e) return (this.ai.x.Bt || this.ai.x.ot || this.ai.y.Bt || this.ai.y.ot) && this.Lj(t), this;
    if (!this.yj.gridTiles) return this;
    if (!this.Bj) return this;
    const i = this.Bj.boundaries.min.x, s = this.Bj.boundaries.min.y, o = this.Bj.boundaries.max.x, n = this.Bj.boundaries.max.y;
    if (i == null || s == null || o == null || n == null) return this;
    const a = this.Ga.columns, l = this.Ga.rows, h = (o - i) / a, u = (n - s) / l, c = new Array(a).fill(0, 0, a).map(((y, m) => i + m * h + h / 2)), d = new Array(l).fill(0, 0, l).map(((y, m) => s + m * u + u / 2));
    let f = [];
    t.levels.forEach(((y) => {
      f.push(y.value);
    }));
    const p = (y, m) => this.Ga.dataOrder == "rows" ? m : y, g = (y, m) => this.Ga.dataOrder == "rows" ? y : m;
    return this.dj.hj(((y, m) => this.Dj(p(y, m), g(y, m))), c, d, f), this.Ej(t), this.Lj(t), this;
  }
  Ej(t) {
    this.Ij();
    let e = /* @__PURE__ */ new Map();
    return t.levels.forEach(((i) => {
      e.set(i.value, i.strokeStyle);
    })), this.dj.nj.forEach(((i) => {
      let s = i.level;
      const o = e.get(s), n = this.pj.find(((a) => a.lineStyle === o));
      if (n) n.points.appendSample({ xValues: NaN, yValues: NaN }), n.points.appendSamples({ xValues: i.ax, yValues: i.ay });
      else {
        const a = new cr({ warnings: !1, schema: { xValues: { pattern: null }, yValues: { pattern: null } } });
        a.appendSamples({ xValues: i.ax, yValues: i.ay });
        const l = { lineStyle: o, points: a };
        this.pj.push(l);
      }
    })), this;
  }
  Lj(t) {
    this.Pj();
    const e = Ve(this.Ke) ? this.Ke.lut : void 0;
    return this.dj.nj.forEach(((i) => {
      var s, o, n;
      let a = [], l = [];
      const h = i.k, u = t.levels[h], c = (o = (s = u.label) !== null && s !== void 0 ? s : e?.getFormatter()(u.value, { min: e.min, max: e.max })) !== null && o !== void 0 ? o : u.value.toString();
      if (t.showLabels && ({ labelPos: a, labelAngle: l } = this.Tj(t.levels[h], i.ax, i.ay, c), 0 < a.length)) for (let d = 0; d < a.length; d++) this.Sj.push({ text: c, position: a[d], angle: l[d], font: u.labelFont, fill: u.labelFillStyle, shadow: (n = t.shadows) !== null && n !== void 0 ? n : void 0 });
    })), this;
  }
  Uh() {
    const t = this.fj, e = this.Ke, i = this.ml(), s = this.kp, o = s !== this.Rj, n = this.LV.wireframeStyleLine(o), a = this.LV.wireframeStyleFill(o), l = n && a && !this.ai.Nt(), h = this.LV.fillStylePaletted(i), u = this.LV.fillStyleSolid(i), c = this.oj.u, d = this.aj.u, f = this.oj.T(), p = this.Tu, g = this.ui.T();
    this.Oj = this.Oj || this.zj();
    const y = this.Oj, m = Cx(t, y, p ? "intensity" : void 0, ((w) => w.sizeHeatmapDataVectors)), A = this.cj.T(), v = A !== this.Vj;
    this.Fj(A, v || m.size > 0 || this.lj), this.Vj = this.cj.T(), this.lj = !1, m.size > 0 && (Dx(this.WD, m, ((w) => this._j(w.tileData)), ((w) => w.intensityDataTexture)), this.Aj = !0), this.SE.TO(this.ai);
    const b = this.ON;
    if ((i || c || d) && (b.tile = h ? { renderMode: "paletted", fillStylePaletted: h, shader: this.WD.SR(K["2D"], K.ColorGrid2D({ heatmapType: "intensity", interpolation: f === "bilinear" && "bilinear", flipXY: this.Ga.dataOrder === "rows", intensityTextureType: this.WD.gR ? "float" : "ubyte", littleEndian: this.WD.IS_MACHINE_LITTLE_ENDIAN, lut: h.lut, aggregation: this.aj.T() }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) } : u ? { renderMode: "solid", fillStyleSolid: u, shader: this.WD.SR(K["2D"], K.Color({ dataType: "uniform" }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) } : void 0), o && (b.wireframe = l && n && a ? n.getThickness() === -1 ? { renderMode: "primitive", shader: this.WD.SR(K["2D"], K.Color({ dataType: "uniform" }), K.VertexLocation({ translation: { dataType: "uniform", sizeUnit: "axis" }, scaling: { dataType: "uniform" }, flipXY: this.Ga.dataOrder === "rows", axisWorldTranslation: jt(this.ai), normalSource: void 0 })), fillStyleSolid: a } : { renderMode: "triangulated", shader: this.WD.SR(K["2D"], K.Color({ dataType: "uniform" }), K.LineInstanced2D({ translation: { dataType: "uniform", sizeUnit: "axis" }, scaling: { dataType: "uniform" }, flipXY: this.Ga.dataOrder === "rows", axisWorldTranslation: jt(this.ai), normalSource: void 0 })), geometry: Bo(this.WD, 1), solidLine: n, fillStyleSolid: a } : void 0, b.wireframe ? this.Nj = this.Nj || this.Gj() : this.Nj && (this.WD.LO(this.Nj.wireframeCoordinatesBuffer), this.Nj = void 0)), b.mousePicking = g ? this.ON.mousePicking || { shader: this.WD.SR(K["2D"], K.MousePicking(), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) } : void 0, this.ON = b, this.Mj === void 0 && h && h.lookUpProperty === "value" && h.lut.percentageValues) {
      let w = wt, k = Pt;
      this.Oj.gridTiles.forEach(((R) => {
        const L = this._j(R.tileData);
        for (let x = 0; x < L.length; x += 1) {
          const M = L[x];
          M < w && (w = M), M > k && (k = M);
        }
      })), this.Mj = { min: w, max: k };
    }
    return this.Tu = !1, this.fj.length = 0, this.Ml(e), this.Rj = s, this.oj.u = !1, this.aj.u = !1, this;
  }
  zj() {
    const t = this.yj.gridTiles.map(((o) => {
      const n = kx(this.WD, o.sizeHeatmapDataVectors.secondary, o.sizeHeatmapDataVectors.primary);
      return { ...o, intensityDataTexture: n, tileData: o };
    })), e = this.yj.gridTileSizes.map(((o) => ({ ...o, tiles: t.filter(((n) => n.sizeHeatmapDataVectors.primary === o.sizeHeatmapData.primary && n.sizeHeatmapDataVectors.secondary === o.sizeHeatmapData.secondary)) }))), i = this.WD.pO(new Float32Array(16)), s = this.WD.gl.TRIANGLE_STRIP;
    return { gridTiles: t, gridTileSizes: e, rectangleLocationsBuffer: i, rectangleLocationsDrawMode: s, rectangleLocationsDrawLength: 4 };
  }
  Gj() {
    const t = this.Ga.primaryDimensionVectorsCount + 1 + this.Ga.secondaryDimensionVectorsCount + 1, e = new Float32Array(4 * t);
    let i = 0;
    for (let s = 0; s < this.Ga.primaryDimensionVectorsCount + 1; s += 1) e[i + 0] = s, e[i + 1] = 0, e[i + 2] = s, e[i + 3] = this.Ga.secondaryDimensionVectorsCount, i += 4;
    for (let s = 0; s < this.Ga.secondaryDimensionVectorsCount + 1; s += 1) e[i + 0] = 0, e[i + 1] = s, e[i + 2] = this.Ga.primaryDimensionVectorsCount, e[i + 3] = s, i += 4;
    return { wireframeCoordinatesBuffer: this.WD.pO(e), wireframeSegmentsLength: t };
  }
  Ip(t, e) {
    super.Ip(t, e);
    const i = this.Ga, s = Ee({ x: Math.min(this.Wt.x, this.Wt.x + i.columns * this.uj.x), y: Math.min(this.Wt.y, this.Wt.y + i.rows * this.uj.y) }, { x: Math.max(this.Wt.x, this.Wt.x + i.columns * this.uj.x), y: Math.max(this.Wt.y, this.Wt.y + i.rows * this.uj.y) }), o = /* @__PURE__ */ new Map();
    return this.yj.gridTiles.forEach(((n) => {
      const a = this.Ga.dataOrder === "columns" ? { x: this.Wt.x + this.uj.x * n.iFirstVector.primary, y: this.Wt.y + this.uj.y * n.iFirstVector.secondary } : { x: this.Wt.x + this.uj.x * n.iFirstVector.secondary, y: this.Wt.y + this.uj.y * n.iFirstVector.primary }, l = this.Ga.dataOrder === "columns" ? { x: this.uj.x * n.sizeHeatmapDataVectors.primary, y: this.uj.y * n.sizeHeatmapDataVectors.secondary } : { x: this.uj.x * n.sizeHeatmapDataVectors.secondary, y: this.uj.y * n.sizeHeatmapDataVectors.primary }, h = this.Ga.dataOrder === "columns" ? { x: this.Wt.x + this.uj.x * n.iFirstUniqueVector.primary, y: this.Wt.y + this.uj.y * n.iFirstUniqueVector.secondary } : { x: this.Wt.x + this.uj.x * n.iFirstUniqueVector.secondary, y: this.Wt.y + this.uj.y * n.iFirstUniqueVector.primary }, u = this.Ga.dataOrder === "columns" ? { x: this.uj.x * n.sizeUniqueHeatmapDataVectors.primary, y: this.uj.y * n.sizeUniqueHeatmapDataVectors.secondary } : { x: this.uj.x * n.sizeUniqueHeatmapDataVectors.secondary, y: this.uj.y * n.sizeUniqueHeatmapDataVectors.primary };
      o.set(n, { startLocationAxis: a, sizeAxis: l, startRenderLocationAxis: h, renderSizeAxis: u });
    })), this.Bj = { boundaries: s, tilesInfo: o }, this;
  }
  Ec(t, e) {
    var i, s;
    const o = this.Oj, n = this.Bj;
    if (this.aj.T() && this.oj.T() === "bilinear") return H.console.warn("LightningChart JS error | heatmap has both bilinear interpolation and aggregation enabled at same time. Disable one of them"), { idCount: 0 };
    const a = t === 1 ? (i = this.ON.mousePicking) === null || i === void 0 ? void 0 : i.shader : (s = this.ON.tile) === null || s === void 0 ? void 0 : s.shader;
    if (this.ON.tile && a && o && n) {
      const c = a, d = this.ON.tile, f = { x: (n.boundaries.max.x - n.boundaries.min.x) * Math.sign(this.uj.x), y: (n.boundaries.max.y - n.boundaries.min.y) * Math.sign(this.uj.y) }, p = { x: f.x / this.Ga.columns, y: f.y / this.Ga.rows }, g = this.ai.ni(), y = { x: p.x / g.x, y: p.y / g.y };
      this.WD.pd(c).SO(c, ((m, A, v, b) => {
        let w = !1;
        if (!this.WD.qz(v, t, this, { uniforms: this.SE, idFirst: e, fillStyleSolid: d.renderMode === "solid" && d.fillStyleSolid })) return !1;
        if (d.renderMode === "solid" || t === 1) {
          const L = ks([{ x: this.Wt.x, y: this.Wt.y }, { x: this.Wt.x + this.uj.x * this.Ga.columns, y: this.Wt.y }, { x: this.Wt.x, y: this.Wt.y + this.uj.y * this.Ga.rows }, { x: this.Wt.x + this.uj.x * this.Ga.columns, y: this.Wt.y + this.uj.y * this.Ga.rows }], this.ai.Nt());
          this.WD.KO(o.rectangleLocationsBuffer, 0, L), this.WD.Ez(v, o.rectangleLocationsBuffer, this.ai.Nt(), void 0).dC(this.WD.gl.TRIANGLE_STRIP, 4), w = !0;
        } else if (d.renderMode === "paletted") {
          if (this.WD.Jz(v, d.fillStylePaletted.lut, this.Mj), this.aj.T()) {
            const L = y.x < 1 ? Math.max(Math.ceil(0.5 / y.x), 1) : 0, x = y.y < 1 ? Math.max(Math.ceil(0.5 / y.y), 1) : 0;
            this.WD.xO(m("uAggregationWindowSize"), [L, x]);
          }
          k = (L) => {
            this.WD.xO(m("uTileDimensions"), [this.Ga.dataOrder === "columns" ? L.sizeHeatmapData.primary : L.sizeHeatmapData.secondary, this.Ga.dataOrder === "columns" ? L.sizeHeatmapData.secondary : L.sizeHeatmapData.primary]);
          }, R = (L, x) => {
            const M = n.tilesInfo.get(L.tileData);
            if (!M) return;
            let C;
            const S = this.WD.rO();
            if (this.oj.T() === "bilinear") {
              const T = (this.ai.x.Rt(M.startLocationAxis.x) + y.x / 2) * S, I = (this.ai.y.Rt(M.startLocationAxis.y) + y.y / 2) * S;
              C = [T, I, (this.ai.x.Rt(M.startLocationAxis.x + M.sizeAxis.x) - y.x / 2) * S - T, (this.ai.y.Rt(M.startLocationAxis.y + M.sizeAxis.y) - y.y / 2) * S - I];
            } else {
              const T = this.ai.x.Rt(M.startLocationAxis.x) * S, I = this.ai.y.Rt(M.startLocationAxis.y) * S;
              C = [T, I, this.ai.x.Rt(M.startLocationAxis.x + M.sizeAxis.x) * S - T, this.ai.y.Rt(M.startLocationAxis.y + M.sizeAxis.y) * S - I];
            }
            const E = ks([{ x: M.startRenderLocationAxis.x, y: M.startRenderLocationAxis.y }, { x: M.startRenderLocationAxis.x + M.renderSizeAxis.x, y: M.startRenderLocationAxis.y }, { x: M.startRenderLocationAxis.x, y: M.startRenderLocationAxis.y + M.renderSizeAxis.y }, { x: M.startRenderLocationAxis.x + M.renderSizeAxis.x, y: M.startRenderLocationAxis.y + M.renderSizeAxis.y }], this.ai.Nt());
            this.WD.KO(o.rectangleLocationsBuffer, 0, E), this.WD.IO(m("uTileBounds"), C).MO(m("uTileIntensityValues"), L.intensityDataTexture, 1).Ez(v, o.rectangleLocationsBuffer, this.ai.Nt(), void 0).dC(this.WD.gl.TRIANGLE_STRIP, 4), w = !0;
          }, o.gridTileSizes.forEach(((L) => {
            k(L), L.tiles.forEach(((x) => {
              R(x);
            }));
          }));
        }
        var k, R;
        return t === 1 && this.WD.$z(v, 1), w;
      }));
    }
    const l = this.Nj, h = this.ON.wireframe, u = t === 1 || h == null ? void 0 : h.shader;
    if (l && h && u && h.renderMode === "primitive") {
      const { fillStyleSolid: c } = h;
      this.WD.pd(u).SO(u, ((d, f, p) => ((this.ai instanceof we || this.ai instanceof zs) && this.WD.xO(d("uScale"), this.SE.wO()).xO(d("uDisp"), this.SE.kO()), this.WD._O(d("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(d("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(d("uRenderEffectMask"), t === 2 ? 1 : 0).gP(d("uColor"), c.getColor()).bO(l.wireframeCoordinatesBuffer, void 0, { location: f("aPos"), size: 2 }).xO(d("uScaling"), [this.uj.x, this.uj.y]).xO(d("uTranslationAxis"), [this.Wt.x, this.Wt.y]).dC(this.WD.gl.LINES, 2 * l.wireframeSegmentsLength), !0)));
    } else if (l && h && u && h.renderMode === "triangulated") {
      const { geometry: c, solidLine: d, fillStyleSolid: f } = h;
      this.WD.pd(u).SO(u, ((p, g, y) => ((this.ai instanceof we || this.ai instanceof zs) && this.WD.xO(p("uScale"), this.SE.wO()).xO(p("uDisp"), this.SE.kO()), this.WD._O(p("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(p("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(p("uRenderEffectMask"), t === 2 ? 1 : 0).gP(p("uColor"), f.getColor())._O(p("uThicknessPixels"), d.getThickness()).xO(p("uRatioPxClip"), [2 / this.yi.Ft().x, 2 / this.yi.Ft().y]).bO(l.wireframeCoordinatesBuffer, 1, { location: g("aLocationA"), size: 2 }, { location: g("aLocationB"), size: 2 }).xO(p("uScaling"), [this.uj.x, this.uj.y]).xO(p("uTranslationAxis"), [this.Wt.x, this.Wt.y]), c.pd(y, !1).dC(l.wireframeSegmentsLength), !0)));
    }
    if (t === 0) {
      const c = this.xj() && this.Sj, d = this.WD, f = this.ai.x.Ht(), p = this.ai.x.jt(), g = this.ai.y.Ht(), y = this.ai.y.jt(), m = (b, w, k) => {
        const R = w.position;
        return f < R.x && R.x < p && g < R.y && R.y < y && (k.add().hr(R).en(w.shadow).rn(w.text).Ph(w.angle).Ih(w.font).sr(w.fill).Uh().Ec(b, 0), !0);
      }, A = this.bj.rg();
      c && (((b, w) => {
        if (w === void 0) return;
        const k = b.gl;
        b.FO(!0), k.clearStencil(1), k.clear(k.STENCIL_BUFFER_BIT), k.stencilFunc(k.ALWAYS, 0, 255), k.stencilOp(k.KEEP, k.KEEP, k.REPLACE), k.stencilMask(255), k.colorMask(!1, !1, !1, !1), w(), k.colorMask(!0, !0, !0, !0);
      })(d, (() => {
        this.Sj.forEach(((b) => {
          m(1, b, A);
        }));
      })), d.gl.stencilFunc(d.gl.EQUAL, 1, 255), d.gl.stencilOp(d.gl.KEEP, d.gl.KEEP, d.gl.KEEP), d.FO(!0));
      const v = this.mj.rg();
      if (v) {
        const b = v.add();
        this.pj.forEach(((w) => {
          b.qd(w.points, { x: "xValues", y: "yValues" }), b.gr(w.lineStyle), b.Uh(), b.Ec(t, 0);
        }));
      }
      v.finishPlot(), c && d.FO(!1), this.Sj && this.Sj.forEach(((b) => {
        m(t, b, A);
      })), A.finishPlot();
    }
    return { idCount: 1 };
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  Op(t) {
    return t.lengthPrimary === 0 || t.lengthSecondary === 0 || (this.fj.push(t), Tx(this.yj.gridTiles, t, ((e) => (e.hasIntensityData = !0, this._j(e))), ((e, i) => {
      e.hasIntensityData = !0, e.intensityData = i;
    })), this.Mj = void 0), this;
  }
  Vi() {
    return this.Aj && (this.yj.gridTiles.forEach(((t) => {
      t.intensityData && t.intensityData.fill(0), t.hasIntensityData = !1;
    })), this.Tu = !0, this.Aj = !1, this.Mj = void 0), this;
  }
  Ij(t = !1) {
    return t && this.mj.ag(), this.pj.length = 0, this;
  }
  Pj(t = !1) {
    return t && (this.bj.ag(), this.gj && (this.gj.dispose(), this.gj = void 0)), this.Sj.length = 0, this;
  }
  dispose() {
    super.dispose();
    const t = this.Oj;
    t && (t.gridTiles.forEach(((i) => {
      this.WD.JD(i.intensityDataTexture);
    })), t.gridTiles.length = 0, t.gridTileSizes.forEach((() => {
    })), t.gridTileSizes.length = 0, this.WD.LO(t.rectangleLocationsBuffer)), this.Oj = void 0;
    const e = this.Nj;
    return e && this.WD.LO(e.wireframeCoordinatesBuffer), this.Nj = void 0, this.Ij(!0), this.Pj(!0), this.ON = {}, this;
  }
  Rc() {
    return this.dispose(), this;
  }
  Rd(t) {
    const e = t, i = this.Ga.dataOrder === "columns" ? e.x : e.y, s = this.Ga.dataOrder === "columns" ? e.y : e.x, o = this.Ga.dataOrder === "columns" ? this.Wt.x : this.Wt.y, n = this.Ga.dataOrder === "columns" ? this.Wt.y : this.Wt.x;
    let a = (i - o) / (this.Ga.dataOrder === "columns" ? this.uj.x : this.uj.y), l = (s - n) / (this.Ga.dataOrder === "columns" ? this.uj.y : this.uj.x);
    a = Math.floor(Jt(a, 0, this.Ga.primaryDimensionVectorsCount - 1)), l = Math.floor(Jt(l, 0, this.Ga.secondaryDimensionVectorsCount - 1));
    const h = this.Dj(a, l), u = this.Ga.dataOrder === "columns" ? { x: this.Wt.x + (a + 0.5) * this.uj.x, y: this.Wt.y + (l + 0.5) * this.uj.y } : { x: this.Wt.x + (l + 0.5) * this.uj.x, y: this.Wt.y + (a + 0.5) * this.uj.y }, c = this.Ga.dataOrder === "columns" ? a : l, d = this.Ga.dataOrder === "columns" ? l : a;
    return { x: u.x, y: u.y, column: c, row: d, cellValue: h };
  }
  Nx(t) {
    const e = this.Bj;
    if (!e || t.x < e.boundaries.min.x || t.x > e.boundaries.max.x || t.y < e.boundaries.min.y || t.y > e.boundaries.max.y) return;
    const i = t, s = this.Ga.dataOrder === "columns" ? i.x : i.y, o = this.Ga.dataOrder === "columns" ? i.y : i.x, n = this.Ga.dataOrder === "columns" ? this.Wt.x : this.Wt.y, a = this.Ga.dataOrder === "columns" ? this.Wt.y : this.Wt.x, l = this.Ga.dataOrder === "columns" ? this.uj.x : this.uj.y, h = this.Ga.dataOrder === "columns" ? this.uj.y : this.uj.x, u = Jt((s - n) / l - 0.5, 0, this.Ga.primaryDimensionVectorsCount - 1), c = Jt((o - a) / h - 0.5, 0, this.Ga.secondaryDimensionVectorsCount - 1), d = Jt(Math.ceil(u) - 1, 0, this.Ga.primaryDimensionVectorsCount - 1), f = Jt(Math.ceil(c) - 1, 0, this.Ga.secondaryDimensionVectorsCount - 1), p = { point: { x: d, y: f }, value: this.Dj(d, f) }, g = { point: { x: d, y: f + 1 }, value: this.Dj(d, f + 1) }, y = { point: { x: d + 1, y: f }, value: this.Dj(d + 1, f) }, m = { point: { x: d + 1, y: f + 1 }, value: this.Dj(d + 1, f + 1) }, A = Lf({ x: u, y: c }, p, g, y, m);
    if (A === void 0) return;
    const v = Jt(Math.floor(u + 0.5), 0, this.Ga.primaryDimensionVectorsCount - 1), b = Jt(Math.floor(c + 0.5), 0, this.Ga.secondaryDimensionVectorsCount - 1), w = this.Ga.dataOrder === "columns" ? v : b, k = this.Ga.dataOrder === "columns" ? b : v, R = t;
    return { x: R.x, y: R.y, column: w, row: k, cellValue: A };
  }
  Dj(t, e) {
    for (let i = 0; i < this.yj.gridTiles.length; i += 1) {
      const s = this.yj.gridTiles[i];
      if (t >= s.iFirstVector.primary && t <= s.iFirstVector.primary + s.sizeHeatmapDataVectors.primary - 1 && e >= s.iFirstVector.secondary && e <= s.iFirstVector.secondary + s.sizeHeatmapDataVectors.secondary - 1) {
        if (!s.intensityData) return 0;
        const o = t - s.iFirstVector.primary, n = e - s.iFirstVector.secondary, a = o * s.sizeHeatmapDataVectors.secondary + n;
        return s.intensityData[a];
      }
    }
    return 0;
  }
  Wi() {
    var t;
    return ((t = this.Bj) === null || t === void 0 ? void 0 : t.boundaries.max.x) || 0;
  }
  Hi() {
    var t;
    return ((t = this.Bj) === null || t === void 0 ? void 0 : t.boundaries.min.x) || 0;
  }
  Zi() {
    var t;
    return ((t = this.Bj) === null || t === void 0 ? void 0 : t.boundaries.max.y) || 0;
  }
  Xi() {
    var t;
    return ((t = this.Bj) === null || t === void 0 ? void 0 : t.boundaries.min.y) || 0;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
  Gx() {
    const t = [];
    return this.yj.gridTiles.forEach(((e) => {
      if (!e.hasIntensityData || !e.intensityData) return;
      const i = new Array(e.sizeUniqueHeatmapDataVectors.primary).fill(0).map(((s) => new Array(e.sizeUniqueHeatmapDataVectors.secondary).fill(0)));
      for (let s = 0; s < e.sizeUniqueHeatmapDataVectors.primary; s += 1) {
        const o = s * e.sizeHeatmapDataVectors.secondary, n = i[s];
        for (let a = 0; a < e.sizeUniqueHeatmapDataVectors.secondary; a += 1) {
          const l = e.intensityData[o + a];
          n[a] = l;
        }
      }
      t.push({ type: "intensity", startPrimary: e.iFirstUniqueVector.primary, startSecondary: e.iFirstUniqueVector.secondary, lengthPrimary: e.sizeUniqueHeatmapDataVectors.primary, lengthSecondary: e.sizeUniqueHeatmapDataVectors.secondary, values: i });
    })), t;
  }
}
class iC extends Ua {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o), this.Wt = { x: 0, y: 0 }, this.uj = { x: 1, y: 1 }, this.aj = le(void 0), this.kp = Hi.lineStyle, this.Cc = le(void 0), this.oj = le("bilinear"), this.engine = t, this.Ga = n;
  }
  Ip(t, e) {
    return this.Wt = t, this.uj = e, this;
  }
  Pp() {
    return { start: this.Wt, step: this.uj };
  }
  $x(t) {
    return this.aj.C(t), this;
  }
  Ux() {
    return this.aj.T();
  }
  Cp(t) {
    return this.kp = typeof t == "function" ? t(this.kp) : t, this;
  }
  Dp() {
    return this.kp;
  }
  Hx(t) {
    return this.Cc.C(t), this;
  }
  $j() {
    return this.Cc.T();
  }
  Ep(t) {
    return this.oj.C(t), this;
  }
  Rp() {
    return this.oj.T();
  }
}
let sC = class extends iC {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o, n), this.Uj = 0, this.Wx = [], this._V = t, this.wV = e, this.WD = t.kV(), this.wV = e, this.gu = n.scrollDimension === "columns" ? Ee({ x: this.Wt.x, y: this.Wt.y }, { x: this.Wt.x, y: this.Wt.y + n.resolution * this.uj.y }) : Ee({ x: this.Wt.x, y: this.Wt.y }, { x: this.Wt.x + n.resolution * this.uj.x, y: this.Wt.y }), this.jj = { dataPerSegment: 2048 };
  }
  Uh() {
    this.zG || (this.mi.push({ type: "DataPattern", args: { pattern: this.Ga.scrollDimension === "columns" ? this.uj.x > 0 ? "ProgressiveX" : "RegressiveX" : this.uj.y > 0 ? "ProgressiveY" : "RegressiveY" } }), this.zG = new Jx(this.ai, this));
    const t = this.zG.FG(this.Wx, this.Cc.T());
    if (t > 0) {
      for (let i = 0; i < t; i += 1) this.Wx[0].shape.dispose().Rc(), this.Wx.shift();
      this.Ga.scrollDimension === "columns" ? this.gu.min.x = this.Wx.length > 0 ? this.Wx[0].boundaries.min.x : wt : this.gu.min.y = this.Wx.length > 0 ? this.Wx[0].boundaries.min.y : wt;
    }
    this.Wx.forEach(((i) => i.shape.$x(this.aj.T()).Uh()));
    const e = this.Wx.reduce(((i, s) => {
      var o, n;
      return i.min = Math.min(i.min, $e((o = s.shape.Mj) === null || o === void 0 ? void 0 : o.min, wt)), i.max = Math.max(i.max, $e((n = s.shape.Mj) === null || n === void 0 ? void 0 : n.max, Pt)), i;
    }), { min: wt, max: Pt });
    return this.Wx.forEach(((i) => {
      i.shape.Mj = e;
    })), this.Cc.u = !1, this;
  }
  Ec(t, e) {
    let i = 0;
    return this.Wx.forEach(((s) => {
      const { idCount: o } = s.shape.Ec(t, e + i);
      o !== void 0 && (i += o);
    })), { idCount: i };
  }
  wi() {
    if (this.Wx.length !== 0) return this.Wx.reduce(((t, e) => {
      const i = e.shape.wi();
      return i ? { min: Math.min(i.min, t.min), max: Math.max(i.max, t.max) } : t;
    }), { min: wt, max: Pt });
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  $p(t) {
    if (t.length === 0) return this;
    let e = 0;
    const i = this.jj.dataPerSegment, s = t.length;
    do {
      let o = this.Wx[this.Wx.length - 1], n = o ? i - (o.existingDataPointsCount + (o.hasJoint ? 1 : 0)) : 0, a = !1;
      if (!o || n === 0) {
        const d = { columns: this.Ga.scrollDimension === "columns" ? i : this.Ga.resolution, rows: this.Ga.scrollDimension === "rows" ? i : this.Ga.resolution, heatmapDataType: this.Ga.heatmapDataType, dataOrder: this.Ga.scrollDimension };
        let f = this.Ga.scrollDimension === "columns" ? { x: this.Wt.x + this.uj.x * this.Uj, y: this.Wt.y } : { x: this.Wt.x, y: this.Wt.y + this.uj.y * this.Uj };
        this.Wx.length > 0 && (f = this.Ga.scrollDimension === "columns" ? { x: f.x - 1 * this.uj.x, y: f.y } : { x: f.x, y: f.y - 1 * this.uj.y }, a = !0);
        const p = new lc(this._V, this.wV, this.ai, ie, [], d).Ep(this.oj.T()).sr(this.Ke).Cp(this.kp).Ip(f, this.uj);
        o = { shape: p, existingDataPointsCount: 0, existingCoordinatesCount: 0, allocatedCoordinatesCount: i, dataStartIndex: this.Uj, hasJoint: !1, boundaries: { min: { x: p.Hi(), y: p.Xi() }, max: { x: p.Wi(), y: p.Zi() } } }, this.Wx.push(o), n = i - (a ? 1 : 0);
      }
      const l = s - e, h = Math.min(n, l), u = t.slice(e, e + h), c = { type: "intensity", values: u, startPrimary: o.existingDataPointsCount + (o.hasJoint ? 1 : 0), startSecondary: 0, lengthPrimary: h, lengthSecondary: this.Ga.resolution };
      a && (c.values.unshift(this.Yj), c.lengthPrimary += 1, o.hasJoint = !0), o.shape.Op(c), o.existingDataPointsCount += h, o.existingCoordinatesCount += h + (a ? 1 : 0), this.Yj = u[u.length - 1], this.Uj += h, e += h;
    } while (e < s);
    return this.gu.max = this.Ga.scrollDimension === "columns" ? { ...this.gu.max, x: this.Wt.x + this.Uj * this.uj.x } : { ...this.gu.max, y: this.Wt.y + this.Uj * this.uj.y }, this;
  }
  Op(t, e) {
    if (e.length <= 0) return this;
    const i = t, s = t + e.length - 1, o = e[0].length;
    if (o <= 0) return this;
    this.Wx.forEach(((a) => {
      const l = a.dataStartIndex, h = a.dataStartIndex + a.existingDataPointsCount - 1;
      if (s < l || i > h) return;
      const u = Math.max(i, l), c = Math.min(s, h), d = c - u + 1, f = e.slice(u - i, c - i + 1), p = i - l + (a.hasJoint ? 1 : 0), g = { type: "intensity", startSecondary: 0, lengthSecondary: o, startPrimary: p, lengthPrimary: d, values: f };
      a.shape.Op(g);
    }));
    const n = this.Uj - 1;
    if (s > n) {
      const a = s - n, l = e.slice(-a);
      if (l.length < a) {
        const h = this.Yj || new Array(o).fill(0);
        for (let u = l.length; u < a; u += 1) l.unshift(h);
      }
      this.$p(l);
    }
    return this;
  }
  jp() {
    return this.Uj;
  }
  Vi() {
    return this.Wx.forEach(((t) => {
      t.shape.dispose().Rc();
    })), this.Wx.length = 0, this.gu = this.Ga.scrollDimension === "columns" ? Ee({ x: this.Wt.x, y: this.Wt.y }, { x: this.Wt.x, y: this.Wt.y + this.Ga.resolution * this.uj.y }) : Ee({ x: this.Wt.x, y: this.Wt.y }, { x: this.Wt.x + this.Ga.resolution * this.uj.x, y: this.Wt.y }), this.Uj = 0, this.Yj = void 0, this;
  }
  Ip(t, e) {
    return super.Ip(t, e), this.Wx.forEach(((i, s) => {
      const o = { x: t.x + (this.Ga.scrollDimension === "columns" ? i.dataStartIndex * e.x : 0), y: t.y + (this.Ga.scrollDimension === "rows" ? i.dataStartIndex * e.y : 0) };
      i.shape.Ip(o, e), i.boundaries = { min: { x: i.shape.Hi(), y: i.shape.Xi() }, max: { x: i.shape.Wi(), y: i.shape.Zi() } };
    })), this.Wx.length > 0 ? this.gu = Qs(...this.Wx.map(((i) => i.boundaries))) : this.gu = this.Ga.scrollDimension === "columns" ? Ee({ x: this.Wt.x, y: this.Wt.y }, { x: this.Wt.x, y: this.Wt.y + this.Ga.resolution * this.uj.y }) : Ee({ x: this.Wt.x, y: this.Wt.y }, { x: this.Wt.x + this.Ga.resolution * this.uj.x, y: this.Wt.y }), this;
  }
  sr(t) {
    return super.sr(t), this.Wx.forEach(((e) => e.shape.sr(this.Ke))), this;
  }
  Cp(t) {
    return super.Cp(t), this.Wx.forEach(((e) => e.shape.Cp(this.kp))), this;
  }
  Ep(t) {
    return super.Ep(t), this.Wx.forEach(((e) => e.shape.Ep(t))), this;
  }
  dispose() {
    return super.dispose(), this.Wx.forEach(((t) => t.shape.dispose())), this;
  }
  setVisible(t) {
    return super.setVisible(t), this.Wx.forEach(((e) => e.shape.setVisible(t))), this;
  }
  Rc() {
    return this.Wx.forEach(((t) => t.shape.Rc())), this;
  }
  Rd(t) {
    const e = xt(t, this.ai, this.engine.ai), i = this.Wx.reduce(((s, o) => {
      const n = o.shape.Rd(t);
      if (n) {
        const a = Au(xt(n, this.ai, this.engine.ai), e);
        if (s === void 0 || a < s.distance) return { result: n, distance: a, segment: o };
      }
      return s;
    }), void 0);
    if (i && i.result) {
      const s = this.Ga.scrollDimension === "columns" ? i.result.column + i.segment.dataStartIndex : i.result.column, o = this.Ga.scrollDimension === "rows" ? i.result.row + i.segment.dataStartIndex : i.result.row;
      return this.Ga.scrollDimension === "columns" && s >= this.Uj || this.Ga.scrollDimension === "rows" && o >= this.Uj ? void 0 : { x: i.result.x, y: i.result.y, column: s, row: o, cellValue: i.result.cellValue };
    }
  }
  Nx(t) {
    const e = xt(t, this.ai, this.engine.ai), i = this.Wx.reduce(((s, o) => {
      const n = o.shape.Nx(t);
      if (n) {
        const a = Au(xt(n, this.ai, this.engine.ai), e);
        if (s === void 0 || a < s.distance) return { result: n, distance: a, segment: o };
      }
      return s;
    }), void 0);
    if (i && i.result) {
      const s = this.Ga.scrollDimension === "columns" ? i.result.column + i.segment.dataStartIndex : i.result.column, o = this.Ga.scrollDimension === "rows" ? i.result.row + i.segment.dataStartIndex : i.result.row;
      return this.Ga.scrollDimension === "columns" && s >= this.Uj || this.Ga.scrollDimension === "rows" && o >= this.Uj ? void 0 : { x: i.result.x, y: i.result.y, column: s, row: o, cellValue: i.result.cellValue };
    }
  }
  Wi() {
    return this.gu.max.x;
  }
  Hi() {
    return this.gu.min.x;
  }
  Zi() {
    return this.gu.max.y;
  }
  Xi() {
    return this.gu.min.y;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
  Ii(t) {
    return super.Ii(t), this.Wx.forEach(((e) => e.shape.Ii(t))), this;
  }
};
class rC extends Ua {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o), this.oj = le("bilinear"), this.kp = Hi.lineStyle, this.Ga = n;
  }
  Ep(t) {
    return this.oj.C(t), this;
  }
  Rp() {
    return this.oj.T();
  }
  Cp(t) {
    return this.kp = typeof t == "function" ? t(this.kp) : t, this;
  }
  Dp() {
    return this.kp;
  }
}
class nC extends rC {
  constructor(t, e, i, s, o, n) {
    super(t, e, i, s, o, n), this.SE = new Fs(), this.ON = {}, this.LV = ss({ fillStyleSolid: () => de(this.Ke) && this.Ke, fillStylePaletted: () => Ve(this.Ke) && this.Ke }), this._V = t, this.wV = e, this.WD = t.kV(), this.wV = e, this.zx = new lc(this._V, t.Hj, t.ai, ie, [], { columns: n.sectors, rows: n.annuli, heatmapDataType: "intensity", dataOrder: n.dataOrder === "annuli" ? "rows" : "columns", Ox: this.WD.ZD }).Cp(Et);
    const a = 2 * Math.PI / 360, l = new Float32Array(724);
    let h = 0;
    l[h + 0] = 0, l[h + 1] = 0, h += 2;
    for (let u = 0; u <= 360; u += 1) {
      const c = u * a, d = Math.cos(c), f = Math.sin(c);
      l[h + 0] = d, l[h + 1] = f, h += 2;
    }
    this.Wj = { vertexBuffer: this.WD.pO(l), drawMode: this.WD.gl.TRIANGLE_FAN, drawLength: 362 };
  }
  Uh() {
    const t = this.ml(), e = this.Ke, i = this.LV.fillStyleSolid(t), s = this.LV.fillStylePaletted(t), o = i || s, n = this.oj.T(), a = this.oj.u, l = this.ui.T(), h = this.ui.u;
    return this.SE.TO(this.ai), this.zx.Uh(), this.zx.Oj ? ((t || a) && (this.ON.fill = o ? { shader: this.WD.SR(K["2D"], K.VertexLocation({ scaling: { dataType: "uniform" }, translation: { dataType: "uniform", sizeUnit: "axis" }, axisWorldTranslation: jt(this.ai), normalSource: void 0 }), s && K.PolarHeatmap({ interpolation: n === "bilinear" && "bilinear", intensityTextureType: this.WD.gR ? "float" : "ubyte", littleEndian: this.WD.IS_MACHINE_LITTLE_ENDIAN, flipXY: this.Ga.dataOrder === "sectors", lut: s.lut }), i && K.PolarHeatmap({ dataType: "uniform" })), fillStylePaletted: s, fillStyleSolid: i } : void 0), h && (this.ON.mousePicking = l ? { shader: this.WD.SR(K["2D"], K.VertexLocation({ scaling: { dataType: "uniform" }, translation: { dataType: "uniform", sizeUnit: "axis" }, axisWorldTranslation: jt(this.ai), normalSource: void 0 }), K.MousePicking()) } : void 0), this.Ml(e), this.oj.u = !1, this.ui.u = !1, this) : this;
  }
  Ec(t, e) {
    var i;
    const { vertexBuffer: s, drawLength: o, drawMode: n } = this.Wj, a = this.zx.Oj;
    if (!this.ON.fill || !a) return {};
    const { fillStylePaletted: l, fillStyleSolid: h } = this.ON.fill, u = t === 1 ? (i = this.ON.mousePicking) === null || i === void 0 ? void 0 : i.shader : this.ON.fill.shader;
    if (!u) return {};
    const c = this.ai.de(), d = Math.min(c.start, c.end), f = Math.max(c.start, c.end), p = Math.min(this.Ga.amplitudeStart, this.Ga.amplitudeStart + (this.Ga.annuli - 1) * this.Ga.amplitudeStep), g = Math.max(this.Ga.amplitudeStart, this.Ga.amplitudeStart + (this.Ga.annuli - 1) * this.Ga.amplitudeStep);
    let y;
    return y = c.end > c.start ? Math.min(g, f) - c.start : Math.max(p, d) - c.start, this.WD.pd(u).SO(u, ((m, A, v, b) => {
      if (this.WD.xO(m("uScale"), this.SE.wO()).xO(m("uDisp"), this.SE.kO())._O(m("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(m("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(m("uRenderEffectMask"), t === 2 ? 1 : 0).xO(b("uViewportSize"), [this._V.Ft().x * this.WD.rO() / (t === 1 ? this.yi.Ga.Ua : 1), this._V.Ft().y * this.WD.rO() / (t === 1 ? this.yi.Ga.Ua : 1)]).xO(m("uScaling"), [y, y]).xO(m("uTranslationAxis"), [0, 0]).bO(s, void 0, { location: A("aPos"), size: 2 })._O(b("uAngleOffset"), this.ai.ye() % (2 * Math.PI))._O(b("uAngleDirection"), this.ai.ge() ? 1 : -1)._O(b("uSectors"), this.Ga.sectors)._O(b("uAnnuli"), this.Ga.annuli), t === 1) this.WD.XO(m("uFirstId"), e).$z(v, 1);
      else {
        if (l) {
          const w = this.zx.Mj;
          this.WD._O(m("uAmplitudeStart"), this.Ga.amplitudeStart)._O(m("uAmplitudeStep"), this.Ga.amplitudeStep)._O(m("uAmplitudeAxisStart"), this.ai.de().start)._O(m("uAmplitudeAxisEnd"), this.ai.de().end).Jz(v, l.lut, w).MO(m("uTileIntensityValues"), a.gridTiles[0].intensityDataTexture, 0);
        }
        h && this.WD.gP(m("uColor"), h.getColor());
      }
      return this.WD.dC(n, o), !0;
    })), { idCount: 1 };
  }
  wi() {
    return this.zx.wi();
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  Op(t) {
    return this.zx.Op(t), this;
  }
  Vi() {
    return this.zx.Vi(), this;
  }
  dispose() {
    return super.dispose(), this.zx.dispose(), this.ON = {}, this.WD.LO(this.Wj.vertexBuffer), this;
  }
  Rc() {
    return this.dispose(), this;
  }
  sr(t) {
    return super.sr(t), this.zx.sr(this.Ke), this;
  }
  Rd(t) {
    const e = this.Ga.amplitudeStart, i = this.Ga.amplitudeStart + (this.Ga.annuli - 1) * this.Ga.amplitudeStep, s = Math.min(e, i), o = Math.max(e, i);
    (t.angle < 0 || t.angle > 360 || t.amplitude < s || t.amplitude > o) && (t.angle = Jt(t.angle, 0, 360), t.amplitude = Jt(t.amplitude, o, o));
    let n = Math.round((t.angle - 0) / 360 * this.Ga.sectors);
    n >= this.Ga.sectors && (n = 0);
    const a = Math.round((t.amplitude - e) / (i - e) * (this.Ga.annuli - 1));
    return { iAnnulus: a, iSector: n, cellValue: this.Dj(a, n), angle: n * (360 / this.Ga.sectors), amplitude: e + a * (i - e) / (this.Ga.annuli - 1) };
  }
  Nx(t) {
    const e = this.Ga.amplitudeStart, i = this.Ga.amplitudeStart + (this.Ga.annuli - 1) * this.Ga.amplitudeStep, s = Math.min(e, i), o = Math.max(e, i);
    (t.angle < 0 || t.angle > 360 || t.amplitude < s || t.amplitude > o) && (t.angle = Jt(t.angle, 0, 360), t.amplitude = Jt(t.amplitude, o, o));
    const n = (t.angle - 0) / 360 * this.Ga.sectors, a = (t.amplitude - e) / (i - e) * (this.Ga.annuli - 1), l = Math.floor(n), h = Math.floor(a), u = { point: { x: h, y: l }, value: this.Dj(h, l) }, c = { point: { x: h, y: l + 1 }, value: this.Dj(h, l + 1) }, d = { point: { x: h + 1, y: l }, value: this.Dj(h + 1, l) }, f = { point: { x: h + 1, y: l + 1 }, value: this.Dj(h + 1, l + 1) }, p = Lf({ x: a, y: n }, u, c, d, f);
    if (p !== void 0) return { iAnnulus: h, iSector: l, cellValue: p, angle: t.angle, amplitude: t.amplitude };
  }
  Dj(t, e) {
    const i = this.Ga.dataOrder === "annuli" ? t : e, s = this.Ga.dataOrder === "annuli" ? e : t;
    for (let o = 0; o < this.zx.yj.gridTiles.length; o += 1) {
      const n = this.zx.yj.gridTiles[o];
      if (i >= n.iFirstVector.primary && i <= n.iFirstVector.primary + n.sizeHeatmapDataVectors.primary - 1 && s >= n.iFirstVector.secondary && s <= n.iFirstVector.secondary + n.sizeHeatmapDataVectors.secondary - 1) {
        const a = i - n.iFirstVector.primary, l = s - n.iFirstVector.secondary, h = a * n.sizeHeatmapDataVectors.secondary + l;
        return n.intensityData ? n.intensityData[h] : 0;
      }
    }
    return 0;
  }
  Wi() {
    return 0;
  }
  Hi() {
    return 0;
  }
  Zi() {
    return 0;
  }
  Xi() {
    return 0;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
}
class i1 {
  constructor(t, e, i) {
    this.Ei = /* @__PURE__ */ new Set(), this.Xj = (s) => (this.Ei.add(s), s), this.Zj = (s) => (this.Ei.delete(s), s.Rc(), this), this.yi = t, this.Zn = e, this.Jj = i;
  }
  gD(t) {
    this.Ei.delete(t) && this.Ei.add(t);
  }
  G() {
    for (const t of this.Ei) t.Rc().dispose();
    this.yi.Ea(this.Zn);
  }
  Rs() {
    return this.yi.Rs(), this;
  }
  Da() {
    return this.Zn;
  }
}
class oC extends i1 {
  constructor() {
    super(...arguments), this.Qj = le(void 0), this.fl = !1;
  }
  Qm(t) {
    return this.Qj.C(t), this;
  }
  bv() {
    return this.Qj.T();
  }
}
class aC extends dh {
  constructor(t, e, i, s, o) {
    super(t, e, i, s, o), this.ON = { fill: void 0, border: void 0 }, this.SE = new Fs(), this.gu = Ie, this.Kj = !1, this.qj = !1, this.tY = !1, this.iY = !1, this.ff = [], this.sY = 0, this.LV = ss({ rectangleStyleSolid: () => de(this.Ke) && this.Ke, rectangleStyleImage: () => cn(this.Ke) && this.Ke, rectangleStyleRadialGradient: () => li(this.Ke) && this.Ke, rectangleStyleLinearGradient: () => hi(this.Ke) && this.Ke, rectangleStylePaletted: () => Ve(this.Ke) && this.Ke, rectangleStyleIndividual: () => Tr(this.Ke) && this.Ke, lineStyleSolid: () => Oi(this.qe) && this.qe, lineStyleDashed: () => Oo(this.qe) && this.qe, lineStyleFilled: () => {
      const n = this.qe && this.qe.getFillStyle();
      return de(n) && n;
    } }), this._V = t, this.wV = e, this.WD = t.kV(), this.EN = this.WD.pz;
  }
  Qo() {
    const t = { Ls: (e) => this.WN(t, e), Ii: (e) => this.XN(t, e), Gd: (e, i, s, o) => this.eY(t, e, i, s, o), Nd: (e) => this.rY(t, e), ZS: (e) => this.QG(t, e), gP: (e) => this.JN(t, e), hY: 0, nY: 0, oY: 0, aY: 0, M: void 0, KG: void 0, gi: 0, cg: !0, qG: this.ff.length, lY: void 0 };
    return this.ff.push(t), t;
  }
  Vi() {
    return this.ff.length = 0, this.Kj = !0, this.yi.Ci(this), this;
  }
  sy() {
    return this.ff;
  }
  gf(t) {
    const e = this.ff.indexOf(t);
    e >= 0 && (this.ff.splice(e, 1), this.Kj = !0, this.yi.Ci(this, t));
  }
  WN(t, e) {
    return t.cg = e, this.Kj = !0, t.cg || this.yi.Ci(this, t), t;
  }
  XN(t, e) {
    return t.gi = e, this.iY = !0, t;
  }
  eY(t, e, i, s, o) {
    return t.hY = e, t.nY = i, t.oY = s, t.aY = o, this.Kj = !0, t;
  }
  rY(t, e) {
    return t.lY = e?.c_x1_y1 === !0 || e?.c_x1_y2 === !0 || e?.c_x2_y1 || e?.c_x2_y2 === !0 ? e : void 0, this.Kj = !0, t;
  }
  QG(t, e) {
    return t.M = e, this.qj = !0, t;
  }
  JN(t, e) {
    return t.KG = e?.toUint32(), this.tY = !0, t;
  }
  Uh() {
    const t = this.ui.T(), e = this.ui.u, i = this.ml(), s = this.iY;
    let o = this.Kj;
    const n = this.qj, a = this.tY, l = this.qe, h = this._l(), u = this.ff.filter(((M) => M.cg)), c = this.ff.find(((M) => M.lY)) !== void 0, d = this.ai.ei();
    c && d && (o = !0);
    const f = this.LV.rectangleStyleSolid(i), p = this.LV.rectangleStylePaletted(i), g = this.LV.rectangleStyleIndividual(i), y = this.LV.rectangleStyleRadialGradient(i), m = this.LV.rectangleStyleLinearGradient(i), A = this.LV.rectangleStyleImage(i), v = f || p || m || y || A || g, b = this.LV.lineStyleSolid(h), w = this.LV.lineStyleDashed(i), k = b || w, R = this.LV.lineStyleFilled(h), L = R, x = k && Math.max(k.getThickness(), 0);
    if (this.SE.TO(this.ai), o && (this.gu = Qs(...u.map(((M) => Vi([{ x: M.hY, y: M.nY }, { x: M.oY, y: M.aY }]))))), o || h && w) {
      const M = [], C = [], S = [];
      let E = 0, T = 0;
      const I = [];
      let F = 0;
      if (c) {
        const D = this.ai instanceof we ? this.ai.ni() : { x: 1e-4, y: 1e-4 }, P = 5;
        this.sY = 4 + 4 * P;
        const V = Math.sign(this.ai.x.U - this.ai.x.$), _ = Math.sign(this.ai.y.U - this.ai.y.$);
        u.forEach(((O) => {
          var B, z, W, G, Y;
          const U = Math.sign(O.oY - O.hY), $ = Math.sign(O.aY - O.nY), Z = { x: U === V ? O.hY : O.oY, y: $ === _ ? O.nY : O.aY }, q = { x: U === V ? O.oY : O.hY, y: $ === _ ? O.aY : O.nY }, Q = E, nt = T, et = Math.abs((q.x - Z.x) / D.x), it = Math.abs((q.y - Z.y) / D.y), rt = O.lY && O.lY.skipTooSmallCheck !== !0 && Math.min(et, it) < 2 * O.lY.extent;
          M[Q + 0] = (O.hY + O.oY) / 2, C[Q + 0] = (O.nY + O.aY) / 2, S[nt + 0] = 0, S[nt + 1] = 0, M[Q + 1] = Number.NaN, C[Q + 1] = Number.NaN, S[nt + 2] = 0, S[nt + 3] = 0, E += 2, T += 4;
          for (let tt = 0; tt <= 3; tt += 1) {
            const at = tt === 0 || tt === 3 ? q.x : Z.x, ut = tt === 0 || tt === 1 ? q.y : Z.y, ht = at === O.hY && ut === O.nY ? (B = O.lY) === null || B === void 0 ? void 0 : B.c_x1_y1 : at === O.oY && ut === O.nY ? (z = O.lY) === null || z === void 0 ? void 0 : z.c_x2_y1 : at === O.hY && ut === O.aY ? (W = O.lY) === null || W === void 0 ? void 0 : W.c_x1_y2 : (G = O.lY) === null || G === void 0 ? void 0 : G.c_x2_y2, st = (Y = O.lY) === null || Y === void 0 ? void 0 : Y.extent;
            if (ht && st && !rt) {
              const bt = 0.5 * tt * Math.PI;
              for (let ct = 0; ct < P; ct += 1) {
                const Mt = bt + ct / (P - 1) * 0.5 * Math.PI;
                let vt, mt;
                tt === 0 ? (vt = Math.cos(Mt) - 1, mt = -1 + Math.sin(Mt)) : tt === 1 ? (vt = 1 + Math.cos(Mt), mt = Math.sin(Mt) - 1) : tt === 2 ? (vt = 1 + Math.cos(Mt), mt = 1 + Math.sin(Mt)) : (vt = -1 + Math.cos(Mt), mt = 1 + Math.sin(Mt)), M[E + 0] = at, C[E + 0] = ut, S[T + 0] = vt * st, S[T + 1] = mt * st, E > 1 && (I[F + 0] = Q, I[F + 1] = E - 1, I[F + 2] = E, F += 3), E += 1, T += 2;
              }
            } else for (let bt = 0; bt < P; bt += 1) M[E + 0] = at, C[E + 0] = ut, S[T + 0] = 0, S[T + 1] = 0, I[F + 0] = Q, I[F + 1] = E - 1, I[F + 2] = E, F += 3, E += 1, T += 2;
          }
          I[F + 0] = Q, I[F + 1] = Q + 2, I[F + 2] = E - 1, F += 3, M[E + 0] = M[Q + 2], C[E + 0] = C[Q + 2], S[T + 0] = S[nt + 4], S[T + 1] = S[nt + 5], M[E + 1] = Number.NaN, C[E + 1] = Number.NaN, S[T + 2] = 0, S[T + 3] = 0, E += 2, T += 4;
        }));
      } else this.sY = 6, u.forEach(((D) => {
        M[E + 0] = D.hY, C[E + 0] = D.nY, S[T + 0] = 0, S[T + 1] = 0, M[E + 1] = D.oY, C[E + 1] = D.nY, S[T + 2] = 0, S[T + 3] = 0, M[E + 2] = D.oY, C[E + 2] = D.aY, S[T + 4] = 0, S[T + 5] = 0, M[E + 3] = D.hY, C[E + 3] = D.aY, S[T + 6] = 0, S[T + 7] = 0, M[E + 4] = D.hY, C[E + 4] = D.nY, S[T + 8] = 0, S[T + 9] = 0, M[E + 5] = Number.NaN, C[E + 5] = Number.NaN, S[T + 10] = 0, S[T + 11] = 0, I[F + 0] = E + 0, I[F + 1] = E + 1, I[F + 2] = E + 3, I[F + 3] = E + 1, I[F + 4] = E + 3, I[F + 5] = E + 2, E += 6, T += 12, F += 6;
      }));
      if (this.uY = this.WD.pO(Mn(M, this.ai.Nt()), void 0, this.uY), this.cY = this.WD.pO(Mn(C, this.ai.Nt()), void 0, this.cY), this.dY = this.WD.pO(S, void 0, this.dY), this.fY = this.WD.iz(new Uint32Array(I), this.fY), this.AY = I.length, this.gY = E - 1, w) {
        const D = new Float32Array(2 * M.length);
        let P = 0, V = 0, _ = 0, O = M[0], B = C[0];
        for (let z = 0; z < M.length; z += 1) {
          const W = M[z], G = C[z];
          Number.isNaN(W) || (V += Math.abs(W - O), _ += Math.abs(G - B), O = W, B = G), D[P] = V, D[P + 1] = _, P += 2;
        }
        this.zN = this.WD.pO(D, !1, this.zN);
      }
      this.vY = [M, C];
    }
    if ((i || h || e) && (this.ON.fill = v ? { shader: this.WD.SR(K["2D"], f && K.Color({ dataType: "uniform" }), m && K.Color({ dataType: ["gradient", m] }), y && K.Color({ dataType: ["gradient", y] }), p && K.Color({ dataType: ["lookup", p.getLookUpProperty(), p.lut] }), g && K.Color({ dataType: "attribute" }), A && K.Color({ dataType: ["image", A] }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0, offsets: [{ directionVar: "aGeo", sizeUnit: "px", dataType: "attribute", useGeometry: !1 }], splitPosAttribute: !0 }), K.AttributeHighlight), mousePicking: t ? { shader: this.WD.SR(K["2D"], K.MousePicking({ useAttribute: !0 }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0, offsets: [{ directionVar: "aGeo", sizeUnit: "px", dataType: "attribute", useGeometry: !1 }], splitPosAttribute: !0 }), K.AttributeHighlight) } : void 0, fillStyleSolid: f, fillStyleLinearGradient: m, fillStyleRadialGradient: y, fillStylePaletted: p, fillStyleImage: A, fillStyleIndividual: g } : void 0, this.ON.border = k && L && typeof x == "number" && x !== 0 ? { shader: this.WD.SR(K["2D"], K.Color({ dataType: "uniform" }), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0, offsets: [{ directionVar: "aGeo", sizeUnit: "px", dataType: "attribute", useGeometry: !1 }], splitPosAttribute: !0 }), this.EN ? K.AliasedEdge : void 0, w && K.StippleTextureInstanced, K.AttributeHighlight), geometry: Bo(this.WD, x), mousePicking: t ? { shader: this.WD.SR(K["2D"], K.MousePicking({ useAttribute: !0 }), K.LineInstanced2D({ axisWorldTranslation: jt(this.ai), normalSource: void 0, offsets: [{ directionVar: "aGeo", sizeUnit: "px", dataType: "attribute", useGeometry: !1 }], splitPosAttribute: !0 }), w && K.StippleTextureInstanced, K.AttributeHighlight) } : void 0, fillStyleSolid: R, lineStyleDashed: w, thickness: x } : void 0), s || o) {
      const M = new Float32Array(u.length * this.sY);
      u.forEach(((C, S) => {
        for (let E = 0; E < this.sY; E += 1) M[S * this.sY + E] = C.gi;
      })), this.yY = this.WD.pO(M, !0, this.yY);
    }
    if (t) {
      if (o || e) {
        const M = new Float32Array(u.length * this.sY);
        u.forEach(((C, S) => {
          for (let E = 0; E < this.sY; E += 1) M[S * this.sY + E] = C.qG;
        })), this.pY = this.WD.pO(M, !1, this.pY);
      }
    } else this.pY && (this.WD.LO(this.pY), this.pY = void 0);
    if (n || o && p && p.getLookUpProperty() === "value") {
      const M = new Float32Array(u.length * this.sY), C = { min: wt, max: Pt };
      u.forEach(((S, E) => {
        const T = S.M !== void 0 ? S.M : ju;
        for (let I = 0; I < this.sY; I += 1) M[E * this.sY + I] = T;
        S.M !== void 0 && (C.min = Math.min(C.min, T), C.max = Math.max(C.max, T));
      })), this.h$ = C, this.mY = this.WD.pO(M, !1, this.mY);
    }
    if (a || o && g) {
      const M = new Uint32Array(u.length * this.sY), C = g ? g.getFallbackColor().toUint32() : ya.toUint32();
      u.forEach(((S, E) => {
        const T = S.KG !== void 0 ? S.KG : C;
        for (let I = 0; I < this.sY; I += 1) M[E * this.sY + I] = T;
      })), this.SY = this.WD.pO(M, !1, this.SY, Uint32Array);
    }
    return y ? this.VV = Ws(this.Ai || this.gu, this.ai, y.getPosition(), y.getExtent(), y.getShape(), this.WD.rO()) : m ? this.NV = Gs(this.Ai || this.gu, this.ai, m.getAngle(!0), this.WD.rO()) : (this.VV = void 0, this.NV = void 0), w ? this.VN = this.WD.Yz(w.getPattern()) : (this.zN && (this.WD.LO(this.zN), this.zN = void 0), this.VN = void 0), this.a$ = this.WD.Qz(this, this.a$, A, void 0, o || this.ai.ei(), ((M, C, S) => this.l$(M, C, S, u))), this.iY = !1, this.Kj = !1, this.qj = !1, this.tY = !1, this.ui.u = !1, this.Ml(this.Ke), this.Cl(l), this;
  }
  Ec(t, e) {
    var i, s;
    const { fill: o, border: n } = this.ON, a = this.uY, l = this.cY, h = this.dY, u = this.fY, c = this.AY, d = this.gY, f = this.yY, p = this.pY;
    if (!(f && a && l && h)) return {};
    if (o && u && c) {
      const g = t === 1 ? (i = o.mousePicking) === null || i === void 0 ? void 0 : i.shader : o.shader;
      g && this.WD.pd(g).SO(g, ((y, m, A, v) => !!this.WD.qz(A, t, this, { uniforms: this.SE, idFirst: e, fillStyleSolid: o.fillStyleSolid, fillStyleLinearGradient: o.fillStyleLinearGradient, fillStyleRadialGradient: o.fillStyleRadialGradient, fillStylePaletted: o.fillStylePaletted, fillStyleImage: o.fillStyleImage, fillStyleIndividual: o.fillStyleIndividual, linearGradientInfo: this.NV, radialGradientInfo: this.VV, texturedFillGLInfo: this.a$, colorBuffer: this.SY, lookupValueBuffer: this.mY, lookupValueRange: this.h$, highlightBuffer: f, coordsX: a, coordsY: l, coordsHighPrecision: this.ai.Nt(), mousePickingOffsetBuffer: p }) && (this.WD.bO(h, void 0, { location: m("aGeoAmount"), size: 2 }).az(u), this.WD.uz(c, this.WD.gl.TRIANGLES, void 0, this.WD.gl.UNSIGNED_INT), !0)));
    }
    if (n && d) {
      const { geometry: g, thickness: y, lineStyleDashed: m } = n, A = t === 1 ? (s = n.mousePicking) === null || s === void 0 ? void 0 : s.shader : n.shader;
      A && this.WD.pd(A).SO(A, ((v, b, w, k) => {
        if (!this.WD.qz(w, t, this, { uniforms: this.SE, idFirst: e, fillStyleSolid: n.fillStyleSolid, highlightBuffer: f, highlightAttribDivisor: 1, mousePickingOffsetBuffer: p, mousePickingOffsetAttribDivisor: 1 })) return !1;
        if (m) {
          if (!this.VN || !this.zN) return !1;
          Ts.FN(this.WD, w, this.zN, b("aLengthSoFarA"), b("aLengthSoFarB"), 2, 2, 0), this.WD.xO(v("uStippleCount"), [this.yi.Ft().x / this.VN.Zz, this.yi.Ft().y / this.VN.Zz])._O(k("uStippleTextureWidthLimiter"), this.VN.Xz / this.VN.Zz)._O(v("uStippleScale"), m.getPatternScale()).MO(v("uStippleTexture"), this.VN.Wz, 1);
        }
        return Gn(this.WD, w, this.ai.Nt(), a, "aLocation", "X", 1, !1, this.WD.gl.FLOAT, Float32Array.BYTES_PER_ELEMENT), Gn(this.WD, w, this.ai.Nt(), l, "aLocation", "Y", 1, !1, this.WD.gl.FLOAT, Float32Array.BYTES_PER_ELEMENT), Gn(this.WD, w, !1, h, "aGeo", "", 2, !1, this.WD.gl.FLOAT, Float32Array.BYTES_PER_ELEMENT), Ts.Ec(this._V, g, w, this.EN && t !== 1, t === 1, y, d), !0;
      }));
    }
    return { idCount: this.ff.length };
  }
  l$(t, e, i, s) {
    if (!this.vY) return new Float32Array();
    const o = xt({ x: this.gu.min.x, y: this.gu.min.y }, this.ai, this.yi.ai), n = xt({ x: this.gu.max.x, y: this.gu.max.y }, this.ai, this.yi.ai), a = { x: Math.abs(o.x - n.x), y: Math.abs(o.y - n.y) }, l = Ah(t, e, a.x, a.y, i), h = l[1], u = l[4], c = l[6], d = l[7], f = this.gu.max.x - this.gu.min.x, p = this.gu.max.y - this.gu.min.y, g = u - c, y = d - h, m = new Float32Array(2 * this.vY[0].length);
    let A = 0;
    for (let v = 0; v < this.vY[0].length; v += 1) {
      const b = this.vY[0][v], w = this.vY[1][v], k = c + g * ((b - this.gu.min.x) / f), R = h + y * ((w - this.gu.min.y) / p);
      m[A] = k, m[A + 1] = R, A += 2;
    }
    return m;
  }
  Oc(t, e, i, s, o) {
    return { collectionMember: this.ff.find(((n) => e + n.qG === t)) };
  }
  Rc() {
    return this.uY = this.WD.LO(this.uY), this.cY = this.WD.LO(this.cY), this.dY = this.WD.LO(this.dY), this.yY && (this.WD.LO(this.yY), this.yY = void 0), this.pY && (this.WD.LO(this.pY), this.pY = void 0), this.mY && (this.WD.LO(this.mY), this.mY = void 0), this.SY && (this.WD.LO(this.SY), this.SY = void 0), this.zN && (this.WD.LO(this.zN), this.zN = void 0), this.fY && (this.WD.LO(this.fY), this.fY = void 0), this.ON = { fill: void 0, border: void 0 }, this.a$ = this.WD.Kz(this, this.a$), this;
  }
  Wi() {
    return this.gu.max.x;
  }
  Hi() {
    return this.gu.min.x;
  }
  Zi() {
    return this.gu.max.y;
  }
  Xi() {
    return this.gu.min.y;
  }
  mu() {
    return qi(this.qe);
  }
  Su() {
    return qi(this.qe);
  }
}
class Rp extends oC {
  constructor(t, e, i) {
    super(t, e, i), this._V = t, this.gl = t.kV(), this.bY = this.Ei;
  }
  vO(t) {
    const e = t instanceof Of && t;
    if (!e) return Ie;
    const i = e.Hi(), s = e.Wi(), o = e.Xi(), n = e.Zi();
    if (i === wt || s === Pt || o === wt || n === Pt) return Ie;
    const a = e.mu(), l = e.Su(), h = Ul({ min: { x: i, y: o }, max: { x: s, y: n } }, { x: a, y: l }, e.ai), u = { min: xt(h.min, e.ai, t.yi.ai), max: xt(h.max, e.ai, t.yi.ai) }, c = this.Qj.T();
    let d;
    if (c) {
      if (d = { min: { x: Math.min(u.min.x, c.x), y: Math.min(u.min.y, c.y) }, max: { x: Math.max(u.max.x, c.x + c.width), y: Math.max(u.max.y, c.y + c.height) } }, d.max.x < d.min.x || d.max.y < d.min.y) return Ie;
    } else d = u;
    return d;
  }
  vr(t) {
    return this.Xj(new zM(this._V, this, t, this.Zj, []));
  }
  GA(t) {
    return this.Xj(new WM(this._V, this, t, this.Zj, []));
  }
  Ay(t, e, i) {
    return this.Xj(new YM(this._V, this, t, this.Zj, i, e));
  }
  ef(t) {
    return this.Xj(new t1(this._V, this, t, this.Zj));
  }
  In(t, e) {
    return this.yi.Pc && e !== !1 ? this.Xj(this.yi.Pc.In(this._V, this, t, this.Zj)) : this.Xj(new hu(this._V, this, t, this.Zj, []));
  }
  Vc(t, e = fr.Simple) {
    if (e === fr.Simple) return this.Xj(new XM(this._V, this, t, this.Zj, []));
    throw new Error("GlEngine.addPolygon | No such polygon type!");
  }
  yy(t) {
    return this.Xj(new jM(this._V, this, t, this.Zj, []));
  }
  Od(t) {
    return this.Xj(new aC(this._V, this, t, this.Zj, []));
  }
  er(t) {
    return this.Xj(new $M(this._V, this, t, this.Zj, []));
  }
  bM(t) {
    return this.Xj(new NM(this._V, this, t, this.Zj, []));
  }
  Ud(t) {
    return this.Xj(new _M(this._V, this, t, this.Zj, []));
  }
  Yx(t, e, i) {
    if (i.heatmapDataType === "intensity") return this.Xj(new sC(this._V, this, t, this.Zj, e, i));
    throw new pi("Unimplemented Heatmap Grid Static type");
  }
  Vx(t, e, i) {
    return this.Xj(new lc(this._V, this, t, this.Zj, e, i));
  }
  yk(t, e, i) {
    return this.Xj(new nC(this._V, this, t, this.Zj, e, i));
  }
  xY(t) {
    return this.Xj(new VM(this._V, this, this.Zj, [], t));
  }
  Uh() {
    if (this.fl) {
      this.fl = !1;
      const t = Array.from(this.Ei).sort(((e, i) => e.yl() - i.yl()));
      this.Ei.clear();
      for (const e of t) this.Ei.add(e);
    }
    for (const t of this.Ei) t.Uh();
    return this;
  }
  Ec(t, e, i) {
    var s;
    const o = this.Qj.T();
    let n;
    if (o) {
      const a = o.x * this.gl.rO() * e, l = o.y * this.gl.rO() * e, h = Math.ceil(a), u = Math.ceil(l);
      n = [h, u, Math.floor(a + o.width * this.gl.rO() * e) - h, Math.floor(l + o.height * this.gl.rO() * e) - u], this.gl.yO(n[0], n[1], n[2], n[3]);
    }
    if (t !== 1) {
      for (const a of this.Ei) if (a.getVisible()) {
        if (a.fs) {
          const l = a.fs.x * this.gl.rO() * e, h = a.fs.y * this.gl.rO() * e, u = Math.ceil(l), c = Math.ceil(h), d = Math.floor(l + a.fs.width * this.gl.rO() * e) - u, f = Math.floor(h + a.fs.height * this.gl.rO() * e) - c;
          this.gl.yO(u, c, d, f);
        }
        a.Ec(t, 0), a.fs && n && this.gl.yO(n[0], n[1], n[2], n[3]);
      }
    } else {
      let a = (((s = i[i.length - 1]) === null || s === void 0 ? void 0 : s.idLast) || 0) + 1;
      const l = Array.from(this.bY.values());
      for (let h = 0; h < l.length; h += 1) {
        const u = l[h];
        if (u.getPointerEvents() && u.getVisible()) {
          if (u.fs) {
            const d = u.fs.x * this.gl.rO() * e, f = u.fs.y * this.gl.rO() * e, p = Math.ceil(d), g = Math.ceil(f), y = Math.floor(d + u.fs.width * this.gl.rO() * e) - p, m = Math.floor(f + u.fs.height * this.gl.rO() * e) - g;
            this.gl.yO(p, g, y, m);
          }
          const { idCount: c } = u.Ec(t, a);
          u.fs && n && this.gl.yO(n[0], n[1], n[2], n[3]), c !== void 0 && (i.push({ entity: u, layer: this, entityIndex: h, idFirst: a, idCount: c, idLast: a + c - 1 }), a += c);
        }
      }
    }
    return this.gl.cO(!1), this;
  }
}
class s1 extends Ja {
  constructor(t) {
    super(t);
  }
}
class lC extends s1 {
  constructor(t) {
    super(t), this.MY = "attribute";
    const { vertices: e, drawSize: i, drawMode: s } = hC(t.gl);
    this.OD = t.pO(e), this.kN = i, this.CN = s;
  }
  dC(t, e, i, s) {
    return this.WD.bO(this.OD, 0, { location: t.attribute("aInstanceGeo"), size: 3 }, { location: i ? t.attribute("aNormal") : void 0, size: 3 }, { location: s ? t.attribute("aTriangleBary") : void 0, size: 3 }).cz(this.CN, 0, this.kN, e), this;
  }
  GR() {
    this.WD.LO(this.OD);
  }
}
const hC = (r) => {
  const t = new Float32Array(324);
  let e = 0;
  return t[e + 0] = -1, t[e + 1] = 1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = 1, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = 1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = 1, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = 1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = 1, t[e + 5] = 0, t[e + 6] = 0, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = -1, t[e + 1] = 1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = 1, t[e + 5] = 0, t[e + 6] = 0, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = 1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = 1, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = 1, t[e + 1] = 1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = 1, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = -1, t[e + 2] = -1, t[e + 3] = -1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = -1, t[e + 2] = 1, t[e + 3] = -1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = 1, t[e + 2] = -1, t[e + 3] = -1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 0, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = -1, t[e + 1] = 1, t[e + 2] = -1, t[e + 3] = -1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 0, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = -1, t[e + 2] = 1, t[e + 3] = -1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = -1, t[e + 1] = 1, t[e + 2] = 1, t[e + 3] = -1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = -1, t[e + 2] = 1, t[e + 3] = 1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = -1, t[e + 2] = -1, t[e + 3] = 1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = 1, t[e + 2] = 1, t[e + 3] = 1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 0, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = 1, t[e + 1] = 1, t[e + 2] = 1, t[e + 3] = 1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 0, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = -1, t[e + 2] = -1, t[e + 3] = 1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = 1, t[e + 1] = 1, t[e + 2] = -1, t[e + 3] = 1, t[e + 4] = 0, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = -1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = 1, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = -1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = 1, t[e + 6] = 1, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = 1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = 1, t[e + 6] = 0, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = -1, t[e + 1] = 1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = 1, t[e + 6] = 0, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = -1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = 1, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = 1, t[e + 1] = 1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = 1, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = -1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = -1, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = -1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = -1, t[e + 6] = 1, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = 1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = -1, t[e + 6] = 0, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = 1, t[e + 1] = 1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = -1, t[e + 6] = 0, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = -1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = -1, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = -1, t[e + 1] = 1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = 0, t[e + 5] = -1, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = -1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = -1, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = -1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = -1, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = -1, t[e + 1] = -1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = -1, t[e + 5] = 0, t[e + 6] = 0, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = -1, t[e + 1] = -1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = -1, t[e + 5] = 0, t[e + 6] = 0, t[e + 7] = 1, t[e + 8] = 0, e += 9, t[e + 0] = 1, t[e + 1] = -1, t[e + 2] = -1, t[e + 3] = 0, t[e + 4] = -1, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 1, e += 9, t[e + 0] = 1, t[e + 1] = -1, t[e + 2] = 1, t[e + 3] = 0, t[e + 4] = -1, t[e + 5] = 0, t[e + 6] = 1, t[e + 7] = 0, t[e + 8] = 0, e += 9, { vertices: t, drawSize: e / 9, drawMode: r.TRIANGLES };
};
class uC extends s1 {
  constructor(t, e) {
    super(t), this.MY = "attribute", this._Y = e;
    const { vertices: i, indices: s } = cC();
    this.OD = t.pO(i), this.wN = t.iz(s), this.kN = s.length, this.CN = t.gl.TRIANGLES;
  }
  dC(t, e, i, s) {
    return this.WD.bO(this.OD, 0, { location: t.attribute("aEdge"), size: 3 }, { location: i ? t.attribute("aNormal") : void 0, size: 3 }, { location: t.attribute("aInstanceGeo"), size: 3 }).az(this.wN)._O(t.uniform("uEdgeRoundness"), this._Y / 2).dz(this.CN, this.kN, 0, e), this;
  }
  GR() {
    this.WD.LO(this.OD), this.WD.LO(this.wN);
  }
  wY(t) {
    return this._Y = t, this;
  }
  kY() {
    return this._Y;
  }
}
const cC = () => {
  const r = [{ normal: { x: 0, y: 1, z: 0 }, perpendA: { x: 0, y: 0, z: 1 }, perpendB: { x: -1, y: 0, z: 0 } }, { normal: { x: 0, y: 0, z: -1 }, perpendA: { x: 0, y: 1, z: 0 }, perpendB: { x: -1, y: 0, z: 0 } }, { normal: { x: -1, y: 0, z: 0 }, perpendA: { x: 0, y: 1, z: 0 }, perpendB: { x: 0, y: 0, z: 1 } }, { normal: { x: 1, y: 0, z: 0 }, perpendA: { x: 0, y: 1, z: 0 }, perpendB: { x: 0, y: 0, z: -1 } }, { normal: { x: 0, y: 0, z: 1 }, perpendA: { x: 0, y: 1, z: 0 }, perpendB: { x: 1, y: 0, z: 0 } }, { normal: { x: 0, y: -1, z: 0 }, perpendA: { x: 0, y: 0, z: -1 }, perpendB: { x: -1, y: 0, z: 0 } }], t = [];
  let e = 0;
  const i = [];
  let s = 0;
  for (const c of r) {
    const { normal: d, perpendA: f, perpendB: p } = c, g = gt.multiply(f, -1), y = gt.multiply(p, -1), m = e;
    t[e] = { thicknessDirection: gt.addVec(d, f, p), edge: gt.addVec(g, y), normal: d }, e += 1;
    const A = e;
    t[e] = { thicknessDirection: gt.addVec(d, g, p), edge: gt.addVec(f, y), normal: d }, e += 1;
    const v = e;
    t[e] = { thicknessDirection: gt.addVec(d, g, y), edge: gt.addVec(f, p), normal: d }, e += 1;
    const b = e;
    t[e] = { thicknessDirection: gt.addVec(d, f, y), edge: gt.addVec(g, p), normal: d }, e += 1, i[s + 0] = v, i[s + 1] = m, i[s + 2] = b, i[s + 3] = v, i[s + 4] = A, i[s + 5] = m, s += 6;
    const w = [{ A: f, B: p }, { A: g, B: p }, { A: g, B: y }, { A: f, B: y }];
    for (const k of w) {
      k.thicknessDirection = gt.addVec(d, k.A, k.B), k.stripVerticesA = [], k.stripVerticesB = [];
      const R = [{ direction: k.A, other: k.B, vertices: k.stripVerticesA }, { direction: k.B, other: k.A, vertices: k.stripVerticesB }];
      for (const L of R) for (let x = 0; x < 8; x += 1) {
        const M = 0.5 * x / 7, C = gt.normalize(gt.lerp(d, L.direction, M)), S = Math.PI / 2 - gt.angle(C, d), E = gt.addVec(gt.multiply(gt.multiply(L.direction, -1), 1 - Math.cos(S)), gt.multiply(gt.multiply(d, -1), 1 - Math.sin(S)), gt.multiply(L.other, -1)), T = e;
        t[e] = { thicknessDirection: k.thicknessDirection, normal: C, edge: E };
        const I = t[e];
        e += 1, L.vertices.push({ index: T, vertex: I });
      }
    }
    for (let k = 0; k < w.length; k += 1) {
      const R = w[k], L = w[k < w.length - 1 ? k + 1 : 0], x = k % 2 == 0 ? R.stripVerticesB : R.stripVerticesA, M = k % 2 == 0 ? L.stripVerticesB : L.stripVerticesA;
      for (let C = 1; C < x.length; C += 1) {
        const S = x[C - 1], E = M[C - 1], T = x[C], I = M[C];
        i[s + 0] = S.index, i[s + 1] = E.index, i[s + 2] = I.index, i[s + 3] = T.index, i[s + 4] = S.index, i[s + 5] = I.index, s += 6;
      }
    }
  }
  const o = [{ x: -1, y: 1, z: -1, flipVertexOrder: !1 }, { x: -1, y: 1, z: 1, flipVertexOrder: !0 }, { x: 1, y: 1, z: 1, flipVertexOrder: !1 }, { x: 1, y: 1, z: -1, flipVertexOrder: !0 }, { x: -1, y: -1, z: -1, flipVertexOrder: !0 }, { x: -1, y: -1, z: 1, flipVertexOrder: !1 }, { x: 1, y: -1, z: 1, flipVertexOrder: !0 }, { x: 1, y: -1, z: -1, flipVertexOrder: !1 }], n = Math.PI / 15, a = 2 * Math.PI / 15;
  let l = e;
  for (const c of o) {
    let d = 0;
    t[e] = { thicknessDirection: c, normal: { x: 0, y: c.y, z: 0 }, edge: { x: -c.x, y: 0, z: -c.z } }, e += 1, d += 1;
    for (let y = 1; y < 8.5; y += 1) {
      const m = y === 15 ? Math.PI : y * n, A = 1 * Math.cos(m) * c.y, v = Math.sin(m);
      for (let b = 0; b < Math.ceil(3.75) + 1; b += 1) {
        const w = b === 15 ? 0 : b * a, k = v * Math.cos(w) * 1 * c.x, R = v * Math.sin(w) * 1 * c.z, L = { x: k, y: A, z: R }, x = gt.normalize({ x: k, y: A, z: R });
        t[e] = { thicknessDirection: c, normal: x, edge: { x: L.x - c.x, y: L.y - c.y, z: L.z - c.z } }, e += 1, d += 1;
      }
    }
    const f = [];
    for (let y = 1; y <= Math.ceil(3.75); y += 1) f.push(l), y === 15 ? f.push(l + 1) : f.push(l + y + 1), f.push(l + y);
    const p = l + 1, g = Math.ceil(3.75) + 1;
    for (let y = 0; y < 6.5; y += 1) for (let m = 0; m < Math.ceil(3.75); m += 1) {
      let A = 0;
      const v = p + (y + 1) * g + m;
      let b = 0;
      m === 14 ? (A = p + y * g, b = p + (y + 1) * g) : (A = p + y * g + m + 1, b = p + (y + 1) * g + m + 1), f.push(p + y * g + m), f.push(A), f.push(v), f.push(v), f.push(A), f.push(b);
    }
    i.push.apply(i, c.flipVertexOrder ? f.reverse() : f), l += d;
  }
  const h = new Float32Array(9 * t.length);
  let u = 0;
  for (const c of t) h[u + 0] = c.edge.x, h[u + 1] = c.edge.y, h[u + 2] = c.edge.z, h[u + 3] = c.normal.x, h[u + 4] = c.normal.y, h[u + 5] = c.normal.z, h[u + 6] = c.thicknessDirection.x, h[u + 7] = c.thicknessDirection.y, h[u + 8] = c.thicknessDirection.z, u += 9;
  return { vertices: h, indices: new Uint16Array(i) };
}, Qf = (r, t) => {
  let e = r.VO.NR.get(t);
  return e || (e = t !== void 0 && t > 0 ? new uC(r, Jt(t, 0, 1)) : new lC(r), r.VO.NR.set(t, e), e);
};
class dC extends Ld {
  Lv(t) {
    return this.eO = this._v.T(), this._v.C(t), this;
  }
  Vp(t) {
    return this.CY = t, this;
  }
  Np() {
    return this.CY;
  }
}
class zo extends dC {
  constructor(t, e, i) {
    super(t, e, i), this.TY = t, this._V = t._V, this.WD = this._V.kV();
  }
  Nt() {
    return this.ai.x.Y || this.ai.y.Y || this.ai.z.Y;
  }
}
const co = 11;
class fC extends zo {
  constructor(t, e, i) {
    super(t, e, i), this.CY = "cull-back", this.gu = _s, this.FY = {}, this.IY = [], this.LV = ss({ fillStyleSolid: () => de(this.Ke) && this.Ke, fillStyleIndividual: () => Tr(this.Ke) && this.Ke, fillStylePaletted: () => Ve(this.Ke) && this.Ke }), this.Ke = Hi.fillStyle, this._v.C(Ba);
  }
  Uh(t) {
    const e = this.IY, i = this.Ke, s = i !== Lt, o = this.PY, n = this.ml() || this.LY !== o, a = this.sO(), l = this.ui.T(), h = this.ui.u;
    if (s) {
      for (const y of e) y.id = y.id !== void 0 ? String(y.id) : void 0, y.xSize = y.xSize !== void 0 && y.xSize < 0 ? -y.xSize : y.xSize, y.ySize = y.ySize !== void 0 && y.ySize < 0 ? -y.ySize : y.ySize, y.zSize = y.zSize !== void 0 && y.zSize < 0 ? -y.zSize : y.zSize;
      const u = this.BY || 0;
      let c = u;
      for (const y of e) {
        const m = y.id;
        m !== void 0 && this.FY[m] !== void 0 || (c += 1);
      }
      let d, f = !1, p = !1;
      if (f = c !== u, p = f, d = !p && (e.length < 100 ? "chunks" : "all"), f) {
        const y = c * co, m = new Float32Array(y);
        this.DY && m.set(this.DY), this.DY = m, this.EY = y, this.RY = u * co;
      }
      const g = Tr(i) ? i.getFallbackColor() : void 0;
      for (const y of e) {
        const m = y.id, A = m !== void 0 && this.FY[m], v = [y.xCenter, y.yCenter, y.zCenter, y.xSize, y.ySize, y.zSize, y.color ? y.color.r : g ? g.r : void 0, y.color ? y.color.g : g ? g.g : void 0, y.color ? y.color.b : g ? g.b : void 0, y.color ? y.color.a : g ? g.a : void 0, y.value];
        if (A) {
          for (let b = 0; b < co; b += 1) v[b] = v[b] !== void 0 ? v[b] : A.buffer[b];
          A.buffer.set(v);
        } else {
          const b = this.RY, w = new Float32Array(this.DY.buffer, b * Float32Array.BYTES_PER_ELEMENT, co);
          w.set(v), m !== void 0 && (this.FY[m] = { location: b, buffer: w }), this.RY += co;
        }
      }
      if (p && (this._N = this.WD.pO(this.DY, !0)), d === "all") this.WD.KO(this._N, 0, this.DY);
      else if (d === "chunks") for (const y of e) {
        const m = y.id;
        if (m !== void 0) {
          const A = this.FY[m];
          this.WD.KO(this._N, A.location, A.buffer);
        }
      }
      if (n || a || h) {
        const y = this.LV.fillStyleSolid(n), m = this.LV.fillStyleIndividual(n), A = this.LV.fillStylePaletted(n);
        y || m || A ? (this.OY = Qf(this.WD, this.zY()), this.ME = this.WD.SR(K["3D"], K.ColorShaded3D({ dataType: m ? "attribute" : A ? ["lookup", A.getLookUpProperty(), A.lut] : "uniform", shadingStyle: this._v.T().type }), K.VertexLocation({ offsets: [{ directionVar: "aInstanceGeo", sizeUnit: "axis", dataType: "attribute", halved: !0 }], axisWorldTranslation: jt(this.ai), normalSource: this.OY.MY }), this.PY !== void 0 && K.RoundedEdges3D), this.ZU = l ? this.WD.SR(K["3D"], K.VertexLocation({ offsets: [{ directionVar: "aInstanceGeo", sizeUnit: "axis", dataType: "attribute", halved: !0 }], axisWorldTranslation: jt(this.ai), normalSource: void 0 }), K.MousePicking(), this.PY !== void 0 && K.RoundedEdges3D) : void 0) : (this.OY = void 0, this.ME = void 0, this.ZU = void 0);
      }
      if (e.length > 0) {
        const y = Ee({ x: wt, y: wt, z: wt }, { x: Pt, y: Pt, z: Pt });
        for (let m = 0; m < this.RY; m += co) {
          const A = this.DY[m + 0], v = this.DY[m + 3] / 2, b = A - v, w = A + v, k = this.DY[m + 1], R = this.DY[m + 4] / 2, L = k - R, x = k + R, M = this.DY[m + 2], C = this.DY[m + 5] / 2, S = M - C, E = M + C;
          y.min.x = y.min.x < b ? y.min.x : b, y.min.y = y.min.y < L ? y.min.y : L, y.min.z = y.min.z < S ? y.min.z : S, y.max.x = y.max.x > w ? y.max.x : w, y.max.y = y.max.y > x ? y.max.y : x, y.max.z = y.max.z > E ? y.max.z : E;
        }
        this.gu = y;
      }
      this.BY = c, this.IY.length = 0;
    }
    return this.Ml(i), this.LY = o, this._v.u = !1, this.ui.u = !1, this;
  }
  Ec(t, e) {
    const i = t === 1 ? this.ZU : this.ME, s = this.OY, o = this._N, n = this.Ke, a = this.BY, l = this._v.T(), h = a || 0;
    return i && o && a !== void 0 && this.WD.SO(i, ((u, c, d, f) => {
      let p = !1;
      const g = c("aOffsetAxis");
      this.WD.pd(i).YO(u("uScale"), this.TY.SE.wO()).YO(u("uDisp"), this.TY.SE.kO()).YO(f("uScaleStart_highpart"), this.TY.SE.tV()).YO(f("uScaleStart_lowpart"), this.TY.SE.iV()).WO(u("uViewProjectionMatrix"), this.VY)._O(u("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(u("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(u("uRenderEffectMask"), t === 2 ? 1 : 0);
      const y = { location: this.Nt() ? c("aPos_highpart") : c("aPos"), size: 3 }, m = { location: g, size: 3 }, A = { location: void 0, size: 4 }, v = { location: void 0, size: 1 };
      if (t !== 1 && l.type === "phong" && this.WD.YO(u("uCameraLoc"), this.NY).YO(u("uLightLoc"), this.GY)._O(u("uAmbientReflection"), l.ambientReflection)._O(u("uSpecularReflection"), l.specularReflection)._O(u("uDiffuseReflection"), l.diffuseReflection)._O(u("uShininess"), l.shininess).gP(u("uLightColor"), l.specularColor).gP(u("uAmbientColor"), l.ambientColor), t === 1) this.WD.XO(u("uFirstId"), e).$z(d, h);
      else if (de(n)) this.WD.gP(u("uColorDiffuse"), n.getColor());
      else if (Tr(n)) {
        const b = c("aColor");
        A.location = b;
      } else if (Ve(n)) {
        const b = er(n, this, void 0);
        if (!b && n.lut.percentageValues) return !1;
        this.WD.Jz(d, n.lut, b), n.lookUpProperty === "value" && (v.location = c("aLookupValue"));
      }
      return o && (this.WD.bO(o, 1, y, m, A, v), this.Nt() && this.WD.gl.vertexAttrib3f(c("aPos_lowpart"), 0, 0, 0), s.dC(d, a, l.type === "phong" && t !== 1, !1), p = !0), p;
    })), { idCount: h };
  }
  Oc(t, e, i, s, o) {
    const n = (t - e) * co;
    if (!this.DY) return {};
    const a = this.DY[n + 0], l = this.DY[n + 1], h = this.DY[n + 2], u = this.DY[n + 3], c = this.DY[n + 4], d = this.DY[n + 5], f = $e(this.DY[n + 6], void 0), p = $e(this.DY[n + 7], void 0), g = $e(this.DY[n + 8], void 0), y = $e(this.DY[n + 9], void 0), m = $e(this.DY[n + 10], void 0);
    let A;
    for (const v of Object.keys(this.FY)) if (this.FY[v].location === n) {
      A = v;
      break;
    }
    return { info: { dataPoint: { x: a, y: l, z: h, xSize: u, ySize: c, zSize: d, r: f, g: p, b: g, a: y, intensity: m, id: A } } };
  }
  dispose() {
    return super.dispose(), this._N && (this.WD.LO(this._N), this._N = void 0), this.ME = void 0, this;
  }
  Rc() {
    return this.dispose(), this;
  }
  $v(t) {
    this.IY = us(this.IY, t, { canReturnB: !0 });
  }
  Vi() {
    this._N && (this.WD.LO(this._N), this._N = void 0), this.DY = void 0, this.EY = 0, this.RY = 0, this.FY = {}, this.BY = 0, this.IY = [], this.gu = _s;
  }
  sr(t) {
    return this.Ke = ba(this.Ke, t), this;
  }
  kh() {
    return this.Ke;
  }
  Vv(t) {
    return this.PY = t !== void 0 && t > 0 ? Jt(t, 0, 1) : void 0, this;
  }
  zY() {
    return this.PY;
  }
  Wi() {
    return this.gu.max.x;
  }
  Hi() {
    return this.gu.min.x;
  }
  Zi() {
    return this.gu.max.y;
  }
  Xi() {
    return this.gu.min.y;
  }
  be() {
    return this.gu.max.z;
  }
  Se() {
    return this.gu.min.z;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
  Rv() {
    return 0;
  }
  ml() {
    return Ea(this.Sl, this.Ke);
  }
  Ml(t) {
    this.Sl = t;
  }
}
class gC extends Ja {
  constructor(t, e) {
    super(t), this.MY = "custom", this.xN = e;
    const { vertices: i, drawSize: s } = this.MN();
    this._N = t.pO(i), this.kN = s;
  }
  pd(t) {
    return this.WD.bO(this._N, 0, { location: t.attribute("aSegmentPosition"), size: 1 }, { location: t.attribute("aPerpendHorizontal"), size: 1 }, { location: t.attribute("aPerpendVertical"), size: 1 }), this;
  }
  dC(t) {
    return this.WD.cz(this.WD.gl.TRIANGLE_STRIP, 0, this.kN, t), this;
  }
  MN() {
    const t = this.xN, e = new Float32Array(2 * (t + 1) * 3);
    let i = 0;
    for (let s = 0; s <= t; s += 1) {
      const o = 2 * Math.PI * s / t, n = Math.cos(o), a = Math.sin(o);
      for (const l of [0, 1]) e[i + 0] = l, e[i + 1] = n, e[i + 2] = a, i += 3;
    }
    return { vertices: e, drawSize: i / 3 };
  }
  GR() {
    this.WD.LO(this._N);
  }
}
const r1 = (r, t = 16) => {
  let e = r.VO.zR.get(t);
  return e || (e = new gC(r, t), r.VO.zR.set(t, e), e);
};
class pC extends zo {
  constructor(t, e, i) {
    super(t, e, i), this.CY = "cull-back", this.$Y = _s, this.UY = [], this.jY = !1, this.vc = Hi.lineStyle, this._v.C(Na);
  }
  Uh(t) {
    const e = this.jY, i = this.vc, s = this.mc !== i, o = this.sO(), n = e;
    if (e) {
      const a = Im(this.UY, this.Nt());
      this.YY = this.WD.pO(a, !1, this.YY);
    }
    if (n && (this.$Y = Tf(this.UY)), s || o) {
      const l = Oi(i) && i.getFillStyle(), h = i.getThickness() === 1 || i.getThickness() < 0 ? "primitive" : "instanced";
      this.ON = void 0, de(l) && (h === "primitive" ? this.ON = { type: h, shader: this.WD.SR(K["3D"], K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 }), K.Color({ dataType: "uniform" })), fillStyle: l } : h === "instanced" && (this.ON = { type: h, shader: this.WD.SR(K["3D"], K.ColorShaded3D({ dataType: "uniform", shadingStyle: this._v.T().type }), K.LineInstanced3D({ axisWorldTranslation: jt(this.ai) })), geometry: r1(this.WD, 8), fillStyle: l }));
    }
    return this.jY = !1, this.mc = i, this._v.u = !1, this;
  }
  Ec(t, e) {
    if (t === 1) return {};
    const i = this.WD.gl, s = this.ON, o = this.YY, n = this.vc, a = this._v.T();
    if (s && o && Oi(n)) switch (s.type) {
      case "instanced": {
        const l = 0.5 * this.Js.Sy(n.thickness), h = s.fillStyle.getColor(), u = s.shader, c = s.geometry;
        this.WD.SO(u, ((d, f, p, g) => {
          if (this.WD.pd(u).YO(d("uScale"), this.TY.SE.wO()).YO(d("uDisp"), this.TY.SE.kO()).YO(g("uScaleStart_highpart"), this.TY.SE.tV()).YO(g("uScaleStart_lowpart"), this.TY.SE.iV()).WO(d("uViewProjectionMatrix"), this.VY).gP(d("uColorDiffuse"), h)._O(d("uOffsetWU"), l)._O(d("uIsHighlighted"), this.gi).gP(d("uHighlightColorOffset"), t === 2 ? Qe : this.bi)._O(d("uRenderEffectMask"), t === 2 ? 1 : 0), a.type === "phong" && this.WD.YO(d("uCameraLoc"), this.NY).YO(d("uLightLoc"), this.GY)._O(d("uAmbientReflection"), a.ambientReflection)._O(d("uSpecularReflection"), a.specularReflection)._O(d("uDiffuseReflection"), a.diffuseReflection)._O(d("uShininess"), a.shininess).gP(d("uLightColor"), a.specularColor).gP(d("uAmbientColor"), a.ambientColor), this.Nt()) {
            i.bindBuffer(i.ARRAY_BUFFER, o);
            const y = f("aLocationA_highpart"), m = f("aLocationA_lowpart"), A = f("aLocationB_highpart"), v = f("aLocationB_lowpart");
            i.vertexAttribPointer(y, 3, i.FLOAT, !1, 12 * Float32Array.BYTES_PER_ELEMENT, 0 * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(y, 1), i.enableVertexAttribArray(y), i.vertexAttribPointer(m, 3, i.FLOAT, !1, 12 * Float32Array.BYTES_PER_ELEMENT, 3 * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(m, 1), i.enableVertexAttribArray(m), i.vertexAttribPointer(A, 3, i.FLOAT, !1, 12 * Float32Array.BYTES_PER_ELEMENT, 6 * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(A, 1), i.enableVertexAttribArray(A), i.vertexAttribPointer(v, 3, i.FLOAT, !1, 12 * Float32Array.BYTES_PER_ELEMENT, 9 * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(v, 1), i.enableVertexAttribArray(v);
          } else {
            i.bindBuffer(i.ARRAY_BUFFER, o);
            const y = f("aLocationA"), m = f("aLocationB");
            i.vertexAttribPointer(y, 3, i.FLOAT, !1, 6 * Float32Array.BYTES_PER_ELEMENT, 0 * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(y, 1), i.enableVertexAttribArray(y), i.vertexAttribPointer(m, 3, i.FLOAT, !1, 6 * Float32Array.BYTES_PER_ELEMENT, 3 * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(m, 1), i.enableVertexAttribArray(m);
          }
          return c.pd(p).dC(this.UY.length / 2), !0;
        }));
        break;
      }
      case "primitive": {
        const l = Oi(n) ? n.getFillStyle() : void 0, h = l && de(l) ? l.getColor() : void 0;
        if (h) {
          const u = s.shader;
          this.WD.SO(u, ((c, d, f, p) => (this.WD.pd(u).YO(c("uScale"), this.TY.SE.wO()).YO(c("uDisp"), this.TY.SE.kO()).YO(p("uScaleStart_highpart"), this.TY.SE.tV()).YO(p("uScaleStart_lowpart"), this.TY.SE.iV()).WO(c("uViewProjectionMatrix"), this.VY).gP(c("uColor"), h)._O(c("uIsHighlighted"), this.gi).gP(c("uHighlightColorOffset"), t === 2 ? Qe : this.bi)._O(c("uRenderEffectMask"), t === 2 ? 1 : 0), this.Nt() ? this.WD.bO(o, void 0, { location: d("aPos_highpart"), size: 3 }, { location: d("aPos_lowpart"), size: 3 }) : this.WD.bO(o, void 0, { location: d("aPos"), size: 3 }), this.WD.dC(i.LINES, this.UY.length), !0)));
        }
        break;
      }
    }
    return { idCount: this.UY.length };
  }
  Oc(t, e, i, s, o) {
    return {};
  }
  Pu(t) {
    for (let e = 0; e < t.length - 1; e += 1) {
      const i = t[e], s = t[e + 1];
      this.UY.push(i), this.UY.push(s);
    }
    return this.jY = !0, { Ii() {
      return this;
    }, Ls() {
      return this;
    } };
  }
  Vi() {
    return this.UY.length = 0, this.jY = !0, this;
  }
  sy() {
    return [];
  }
  gf(t) {
  }
  gr(t) {
    return this.vc = typeof t == "function" ? t(this.vc) : t, this;
  }
  po() {
    return this.vc;
  }
  Rc() {
    return this.YY && (this.WD.LO(this.YY), this.YY = void 0), this;
  }
  Wi() {
    return this.$Y.max.x;
  }
  Hi() {
    return this.$Y.min.x;
  }
  Zi() {
    return this.$Y.max.y;
  }
  Xi() {
    return this.$Y.min.y;
  }
  be() {
    return this.$Y.max.z;
  }
  Se() {
    return this.$Y.min.z;
  }
  mu() {
    const t = this.vc;
    return t === Et ? 0 : t.getThickness();
  }
  Su() {
    const t = this.vc;
    return t === Et ? 0 : t.getThickness();
  }
  Rv() {
    const t = this.vc;
    return t === Et ? 0 : t.getThickness();
  }
}
class yC extends Ja {
  constructor(t, e, i) {
    super(t), this.MY = "gpu-calculate", this.HY = e, this.WY = i;
    const { vertices: s, drawSize: o } = this.MN();
    this._N = t.pO(s), this.kN = o;
  }
  dC(t, e, i, s) {
    return this.WD.bO(this._N, 0, { location: t.attribute("aInstanceGeo"), size: 3 }, { location: s ? t.attribute("aTriangleBary") : void 0, size: 3 }).cz(this.WD.gl.TRIANGLES, 0, this.kN, e), this;
  }
  MN() {
    const t = this.WY, e = this.HY, i = new Float32Array(6 * (6 * e + 6 * (t - 2) * e));
    let s = 0;
    const o = 2 * Math.PI / e, n = Math.PI / t, a = (l, h, u, c, d) => {
      const f = h * o, p = Math.PI / 2 - l * n, g = Math.cos(p), y = g * Math.cos(f), m = g * Math.sin(f), A = Math.sin(p);
      i[s] = y, i[s + 1] = A, i[s + 2] = m, i[s + 3] = u, i[s + 4] = c, i[s + 5] = d, s += 6;
    };
    for (let l = 0; l < t; l += 1) for (let h = 0; h < e; h += 1) l > 0 && (a(l, h, 1, 0, 0), a(l, h + 1, 1, 1, 0), a(l + 1, h, 0, 0, 1)), l < t - 1 && (a(l, h + 1, 1, 1, 0), a(l + 1, h + 1, 0, 1, 0), a(l + 1, h, 0, 0, 1));
    return s !== i.length && Js(0, (() => {
      this.WD.Qg.$a && s > i.length && H.console.warn(`LightningChart JS unexpected error scenario, sphere geometry buffer size mismatch.
A point series 3D component might have missing points.

This warning can be omitted with LightningChartOptions.warnings`);
    })), { vertices: i, drawSize: s / 6 };
  }
  GR() {
    this.WD.LO(this._N);
  }
}
const n1 = (r, t) => {
  const e = Math.round(t);
  e < 3 && Js(0, ie);
  const i = e;
  let s = r.VO.VR.get(Array.from(r.VO.VR.keys()).find(((o) => o.sectors === e && o.stacks === i)));
  return s || (s = new yC(r, e, i), r.VO.VR.set({ sectors: e, stacks: i }, s), s);
};
class o1 extends zo {
  constructor(t, e, i, s) {
    super(t, e, i), this.CY = "cull-back", this.Wx = [], this.ON = {}, this.OG = new Jf(this.Wx, ((h) => h.vertexBuffer && this.WD.LO(h.vertexBuffer)), !0), this.wc = [], this.kc = 0, this.wu = [], this.ZY = 0, this.gu = _s, this.JY = _s, this.LV = ss({ lineStyleSolid: () => {
      const h = this.vc;
      return Oi(h) && h;
    }, lineFillSolid: () => {
      const h = this.vc.getFillStyle();
      return de(h) && h;
    }, lineFillPaletted: () => {
      const h = this.vc.getFillStyle();
      return Ve(h) && h;
    }, jointStyleTriangulatedPoints: () => wn(this.Dy) && this.Dy, jointSizeTriangulated: () => {
      const h = this.Dy;
      return wn(h) && h.getSize();
    }, jointFillSolid: () => {
      const h = this.Dy.getFillStyle();
      return de(h) && h;
    }, jointFillPaletted: () => {
      const h = this.Dy.getFillStyle();
      return Ve(h) && h;
    }, wireframeLineStyleSolid: () => {
      const h = wn(this.Dy) && this.Dy.getWireframeStyle();
      return Oi(h) && h;
    }, wireframeFillSolid: () => {
      const h = wn(this.Dy) && this.Dy.getWireframeStyle(), u = h && h.getFillStyle();
      return de(u) && u;
    } }), this.Mj = le(void 0), this.Tu = !1, this.Ga = s, this.vc = Hi.lineStyle, this.Dy = Hi.pointStyle3D, this._v.C(Ba);
    const o = s?.individualLookupValuesEnabled === !0;
    let n, a = 0;
    a += this.Nt() ? 6 : 3, o && (n = a, a += 1);
    const l = Vm(!1, !1, o, !1, this.Nt());
    this.$G = { attributeOffsetCoordinate: 0, individualLookupValuesEnabled: o, attributesPerVertex: a, attributeOffsetLookUpValue: n, prepareRenderData: (h, u) => l(h, void 0, this.vc.getFillStyle()) };
  }
  wi() {
    return this.Mj.T() || this.Mj._;
  }
  Oc(t, e, i, s, o) {
    return { info: { dataPoint: this.wc[t - e] } };
  }
  Uh(t) {
    const e = this.Tu, i = this.wu, s = this.ZY, o = s > 0, n = this.vc, a = n !== this.mc, l = this.Dy, h = l !== this.QY, u = this.sO(), c = this.ui.u, d = this.ui.T();
    this.JY && (this.gu = bu(this.gu, this.JY), this.JY = void 0), o && (this.wc = us(this.wc, i, { canReturnB: !0 }), this.kc += s);
    let f = i, p = s;
    if (e && (this.Wx.forEach(((v) => {
      v.existingCoordinatesCount = 0, v.existingDataPointsCount = 0, v.boundaries = _s;
    })), this.OG.CG(), f = this.wc, p = this.kc), p > 0) {
      const b = Math.floor(this._V.KY / (this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT)), w = this._i("ApplicationType", ((R) => R.type === "UserSeries")) ? p : 1e3, k = Jt(w, 1e5, b);
      this.OG.MG(f, k, ((R, L, x, M) => ({ existingDataPointsCount: x - M, existingCoordinatesCount: x, allocatedCoordinatesCount: R, jointPointsCount: M, lastDataPoint: L[x - 1], boundaries: _s, vertexBuffer: this.WD.QO(R * this.$G.attributesPerVertex, this.$G.prepareRenderData(L, x)) })), ((R, L, x, M) => {
        this.WD.KO(R.vertexBuffer, R.existingCoordinatesCount * this.$G.attributesPerVertex, this.$G.prepareRenderData(L, x)), R.existingDataPointsCount += x - M, R.existingCoordinatesCount += x, R.jointPointsCount += M, R.lastDataPoint = L[x - 1];
      }));
    }
    const g = this.LV.lineStyleSolid(a), y = this.LV.lineFillSolid(a), m = this.LV.lineFillPaletted(a), A = y || m;
    if (a || h || u || c) {
      const v = {}, b = this.LV.jointStyleTriangulatedPoints(h), w = this.LV.jointSizeTriangulated(h), k = this.LV.jointFillSolid(h), R = this.LV.jointFillPaletted(h), L = k || R, x = this.LV.wireframeLineStyleSolid(h), M = this.LV.wireframeFillSolid(h), C = this.$G.individualLookupValuesEnabled, S = n.getThickness() < 0 || n.getThickness() === 1 && this._i("ApplicationType", ((T) => T.type === "InternalUI")) ? "primitive" : "instanced", E = m ? ["lookup", m.getLookUpProperty(), m.lut] : "uniform";
      if (m && m.getLookUpProperty() === "value" && !C) {
        const T = 'LCJS misusage error: Series individualLookupValuesEnabled flag must be set if using PalettedFill with lookUpProperty="value" !';
        throw H.alert(T), new Error(T);
      }
      if (S === "primitive" && A ? v.lines = { type: "primitive", fillStyleSolid: y, fillStylePaletted: m, shader: this.WD.SR(K["3D"], K.Color({ dataType: E }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })), mousePicking: d ? { shader: this.WD.SR(K["3D"], K.MousePicking({ useVertexId: !0 }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) } : void 0 } : S === "instanced" && g && A && (v.lines = { type: "instanced", lineStyleSolid: g, fillStyleSolid: y, fillStylePaletted: m, shader: this.WD.SR(K["3D"], K.ColorShaded3D({ dataType: E, shadingStyle: this._v.T().type }), K.LineInstanced3D({ axisWorldTranslation: jt(this.ai) })), geometry: mC(this.WD, g.getThickness()), mousePicking: d ? { shader: this.WD.SR(K["3D"], K.MousePicking(), K.LineInstanced3D({ axisWorldTranslation: jt(this.ai) })) } : void 0 }), v.markers = void 0, L && b) {
        const T = Nm(b.getShape(), { cube: () => Qf(this.WD), sphere: () => xC(this.WD, b) });
        v.markers = { geometry: T, pointStyle: b, pointSizeNWU: typeof w == "number" && w, pointSizeAxis: typeof w == "object" && w, fillStyleSolid: k, fillStylePaletted: R, shader: this.WD.SR(K["3D"], K.ColorShaded3D({ dataType: R ? ["lookup", R.getLookUpProperty(), R.lut] : "uniform", shadingStyle: this._v.T().type, wireframe: M !== !1 }), K.VertexLocation({ offsets: [{ directionVar: "aInstanceGeo", dataType: "uniform", sizeUnit: typeof w == "number" ? "nwu" : "axis", symmetric: typeof w == "number", halved: !0 }], axisWorldTranslation: jt(this.ai), normalSource: T.MY })), mousePicking: d ? { shader: this.WD.SR(K["3D"], K.MousePicking(), K.VertexLocation({ offsets: [{ directionVar: "aInstanceGeo", dataType: "uniform", sizeUnit: typeof w == "number" ? "nwu" : "axis", symmetric: typeof w == "number", halved: !0 }], axisWorldTranslation: jt(this.ai), normalSource: void 0 })) } : void 0, wireframe: x && M && { thickness: x.getThickness(), fillStyleSolid: M } };
      }
      this.ON = v;
    }
    if (this.Mj.T() === void 0 && m && m.lookUpProperty === "value" && m.lut.percentageValues) {
      let v = Pt, b = wt;
      for (let w = 0; w < this.wc.length; w += 1) {
        const k = this.wc[w];
        k.value !== void 0 && k.value < b && (b = k.value), k.value !== void 0 && k.value > v && (v = k.value);
      }
      this.Mj.C({ min: b, max: v });
    }
    return this.Mj._ = void 0, this.Tu = !1, this.wu = [], this.ZY = 0, this.mc = n, this.QY = l, this._v.u = !1, this.ui.u = !1, this;
  }
  Ec(t, e) {
    var i, s;
    const o = this.WD.gl, { lines: n, markers: a } = this.ON, l = this._v.T(), h = this.kc, u = t === 1 ? (i = n?.mousePicking) === null || i === void 0 ? void 0 : i.shader : n?.shader;
    if (n && u && n.type === "instanced") {
      const d = u, { geometry: f, lineStyleSolid: p, fillStyleSolid: g, fillStylePaletted: y } = n;
      this.WD.SO(d, ((m, A, v, b) => {
        let w = !1;
        if (this.WD.pd(d).YO(m("uScale"), this.TY.SE.wO()).YO(m("uDisp"), this.TY.SE.kO()).YO(b("uScaleStart_highpart"), this.TY.SE.tV()).YO(b("uScaleStart_lowpart"), this.TY.SE.iV()).WO(m("uViewProjectionMatrix"), this.VY)._O(m("uOffsetWU"), this.Js.Sy(p.getThickness()))._O(m("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(m("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(m("uRenderEffectMask"), t === 2 ? 1 : 0), t !== 1 && l.type === "phong" && this.WD.YO(m("uCameraLoc"), this.NY).YO(m("uLightLoc"), this.GY)._O(m("uAmbientReflection"), l.ambientReflection)._O(m("uSpecularReflection"), l.specularReflection)._O(m("uDiffuseReflection"), l.diffuseReflection)._O(m("uShininess"), l.shininess).gP(m("uLightColor"), l.specularColor).gP(m("uAmbientColor"), l.ambientColor), t !== 1) {
          if (g) this.WD.gP(m("uColorDiffuse"), g.getColor());
          else if (y) {
            const R = er(y, this, this.Mj.T());
            if (!R && y.lut.percentageValues) return !1;
            this.WD.Jz(v, y.lut, R);
          }
        }
        const k = Cl(e);
        return this.Wx.forEach(((R) => {
          if (t === 1) {
            const [L, x] = k.es(R.existingDataPointsCount);
            this.WD.XO(m("uFirstId"), L).$z(v, x);
          }
          if (o.bindBuffer(o.ARRAY_BUFFER, R.vertexBuffer), this.Nt()) {
            const L = A("aLocationA_highpart"), x = A("aLocationA_lowpart"), M = A("aLocationB_highpart"), C = A("aLocationB_lowpart");
            o.vertexAttribPointer(L, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetCoordinate * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(L, 1), o.enableVertexAttribArray(L), o.vertexAttribPointer(x, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, (this.$G.attributeOffsetCoordinate + 3) * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(x, 1), o.enableVertexAttribArray(x), o.vertexAttribPointer(M, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, (this.$G.attributeOffsetCoordinate + this.$G.attributesPerVertex) * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(M, 1), o.enableVertexAttribArray(M), o.vertexAttribPointer(C, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, (this.$G.attributeOffsetCoordinate + this.$G.attributesPerVertex + 3) * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(C, 1), o.enableVertexAttribArray(C);
          } else {
            const L = A("aLocationA"), x = A("aLocationB");
            o.vertexAttribPointer(L, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetCoordinate * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(L, 1), o.enableVertexAttribArray(L), o.vertexAttribPointer(x, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, (this.$G.attributeOffsetCoordinate + this.$G.attributesPerVertex) * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(x, 1), o.enableVertexAttribArray(x);
          }
          if (y && y.getLookUpProperty() === "value" && this.$G.attributeOffsetLookUpValue !== void 0 && t !== 1) {
            const L = A("aLookupValue");
            o.vertexAttribPointer(L, 1, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetLookUpValue * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(L, 1), o.enableVertexAttribArray(L);
          }
          f.pd(v).dC(R.existingCoordinatesCount - 1), w = !0;
        })), w;
      }));
    }
    if (n && u && n.type === "primitive") {
      const d = u, { fillStyleSolid: f, fillStylePaletted: p } = n;
      this.WD.SO(d, ((g, y, m, A) => {
        let v = !1;
        if (this.WD.pd(d).YO(g("uScale"), this.TY.SE.wO()).YO(g("uDisp"), this.TY.SE.kO()).YO(A("uScaleStart_highpart"), this.TY.SE.tV()).YO(A("uScaleStart_lowpart"), this.TY.SE.iV()).WO(g("uViewProjectionMatrix"), this.VY)._O(g("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(g("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(g("uRenderEffectMask"), t === 2 ? 1 : 0), t !== 1) {
          if (f) this.WD.gP(g("uColor"), f.getColor());
          else if (p) {
            const w = er(p, this, this.Mj.T());
            if (!w && p.lut.percentageValues) return !1;
            this.WD.Jz(m, p.lut, w);
          }
        }
        const b = Cl(e);
        return this.Wx.forEach(((w) => {
          if (t === 1) {
            const [k, R] = b.es(w.existingDataPointsCount);
            this.WD.XO(g("uFirstId"), k).Nz(m, R);
          }
          if (this.Nt()) {
            o.bindBuffer(o.ARRAY_BUFFER, w.vertexBuffer);
            const k = y("aPos_highpart"), R = y("aPos_lowpart");
            o.vertexAttribPointer(k, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetCoordinate * Float32Array.BYTES_PER_ELEMENT), o.enableVertexAttribArray(k), o.vertexAttribPointer(R, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, (this.$G.attributeOffsetCoordinate + 3) * Float32Array.BYTES_PER_ELEMENT), o.enableVertexAttribArray(R);
          } else {
            o.bindBuffer(o.ARRAY_BUFFER, w.vertexBuffer);
            const k = y("aPos");
            o.vertexAttribPointer(k, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetCoordinate * Float32Array.BYTES_PER_ELEMENT), o.enableVertexAttribArray(k);
          }
          if (p && p.getLookUpProperty() === "value" && this.$G.attributeOffsetLookUpValue !== void 0 && t !== 1) {
            const k = y("aLookupValue");
            o.vertexAttribPointer(k, 1, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetLookUpValue * Float32Array.BYTES_PER_ELEMENT), o.enableVertexAttribArray(k);
          }
          this.WD.dC(o.LINE_STRIP, w.existingCoordinatesCount), v = !0;
        })), v;
      }));
    }
    const c = t === 1 ? (s = a?.mousePicking) === null || s === void 0 ? void 0 : s.shader : a?.shader;
    if (a && c) {
      const d = c, { geometry: f, fillStyleSolid: p, fillStylePaletted: g, pointSizeAxis: y, pointSizeNWU: m, wireframe: A } = a;
      this.WD.SO(d, ((v, b, w, k) => {
        let R = !1;
        if (this.WD.pd(d).YO(v("uScale"), this.TY.SE.wO()).YO(v("uDisp"), this.TY.SE.kO()).YO(k("uScaleStart_highpart"), this.TY.SE.tV()).YO(k("uScaleStart_lowpart"), this.TY.SE.iV()).WO(v("uViewProjectionMatrix"), this.VY)._O(k("uRatioNwuWu"), this.TY.qY())._O(v("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(v("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(v("uRenderEffectMask"), t === 2 ? 1 : 0), t !== 1 && l.type === "phong" && this.WD.YO(v("uCameraLoc"), this.NY).YO(v("uLightLoc"), this.GY)._O(v("uAmbientReflection"), l.ambientReflection)._O(v("uSpecularReflection"), l.specularReflection)._O(v("uDiffuseReflection"), l.diffuseReflection)._O(v("uShininess"), l.shininess).gP(v("uLightColor"), l.specularColor).gP(v("uAmbientColor"), l.ambientColor), t !== 1) {
          if (p) this.WD.gP(v("uColorDiffuse"), p.getColor());
          else if (g) {
            const x = er(g, this, this.Mj.T());
            if (!x && g.lut.percentageValues) return !1;
            this.WD.Jz(w, g.lut, x);
          }
        }
        A && t !== 1 && this.WD._O(v("uWireframeThickness"), A.thickness).gP(v("uWireframeColor"), A.fillStyleSolid.getColor()), y !== !1 && this.WD.YO(v("uOffsetAxis"), [y.x, y.y, y.z]), m !== !1 && this.WD._O(v("uOffsetNWU"), m);
        const L = Cl(e);
        return this.Wx.forEach(((x) => {
          if (t === 1) {
            const [M, C] = L.es(x.existingDataPointsCount);
            this.WD.XO(v("uFirstId"), M).$z(w, C);
          }
          if (o.bindBuffer(o.ARRAY_BUFFER, x.vertexBuffer), this.Nt()) {
            const M = b("aPos_highpart"), C = b("aPos_lowpart");
            o.vertexAttribPointer(M, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetCoordinate * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(M, 1), o.enableVertexAttribArray(M), o.vertexAttribPointer(C, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, (this.$G.attributeOffsetCoordinate + 3) * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(C, 1), o.enableVertexAttribArray(C);
          } else {
            const M = b("aPos");
            o.vertexAttribPointer(M, 3, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetCoordinate * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(M, 1), o.enableVertexAttribArray(M);
          }
          if (g && g.getLookUpProperty() === "value" && this.$G.attributeOffsetLookUpValue !== void 0 && t !== 1) {
            const M = b("aLookupValue");
            o.vertexAttribPointer(M, 1, o.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetLookUpValue * Float32Array.BYTES_PER_ELEMENT), this.WD.rz(M, 1), o.enableVertexAttribArray(M);
          }
          f.dC(w, x.existingCoordinatesCount, l.type === "phong" && t !== 1, !!A && t !== 1), R = !0;
        })), R;
      }));
    }
    return { idCount: h };
  }
  Pu(t, e) {
    Array.isArray(t) || (t = [t]), this.wu = us(this.wu, t, { canReturnB: !0 }), this.ZY += t.length;
    const i = e || Tf(t);
    return this.JY = this.JY ? bu(this.JY, i) : i, this;
  }
  gr(t) {
    return this.vc = typeof t == "function" ? t(this.vc) : t, this;
  }
  po() {
    return this.vc;
  }
  uy(t) {
    return this.Dy = typeof t == "function" ? t(this.Dy) : t, this;
  }
  tH() {
    return this.Dy;
  }
  Wi() {
    return this.JY ? Math.max(this.JY.max.x, this.gu.max.x) : this.gu.max.x;
  }
  Hi() {
    return this.JY ? Math.min(this.JY.min.x, this.gu.min.x) : this.gu.min.x;
  }
  Zi() {
    return this.JY ? Math.max(this.JY.max.y, this.gu.max.y) : this.gu.max.y;
  }
  Xi() {
    return this.JY ? Math.min(this.JY.min.y, this.gu.min.y) : this.gu.min.y;
  }
  be() {
    return this.JY ? Math.max(this.JY.max.z, this.gu.max.z) : this.gu.max.z;
  }
  Se() {
    return this.JY ? Math.min(this.JY.min.z, this.gu.min.z) : this.gu.min.z;
  }
  mu() {
    return qi(this.vc);
  }
  Su() {
    return qi(this.vc);
  }
  Rv() {
    return qi(this.vc);
  }
  Lu() {
    return this.wc;
  }
  Bu() {
    return this.wu;
  }
  Ru() {
    return this.kc;
  }
  Ou() {
    return this.ZY;
  }
  Vi() {
    return this.Tu = !0, this.wc.length = 0, this.kc = 0, this.wu = [], this.ZY = 0, this.gu = _s, this.JY = void 0, this;
  }
  dispose() {
    return super.dispose(), this.OG.TG(), this.ON = {}, this;
  }
  Rc() {
    return this.dispose(), this;
  }
}
const mC = (r, t) => r1(r, t > 50 ? 20 : t > 20 ? 16 : t > 10 ? 12 : t > 5 ? 8 : 6), xC = (r, t) => {
  const e = t.getSize();
  return n1(r, typeof e == "number" ? e > 50 ? 20 : e > 20 ? 16 : e > 10 ? 12 : e > 5 ? 8 : 6 : 20);
};
class vC extends zo {
  constructor(t, e, i) {
    super(t, e, i), this.CY = "disabled", this.iH = !1, this.sH = !1, this.eH = { x: 1, y: 1, z: 1 }, this.Zp = { x: 0, y: 0, z: 0 }, this.Xp = { x: 0, y: 0, z: 0 }, this.rH = { x: 0, y: 0, z: 0 }, this.Qp = { x: 0, y: 0, z: 0, w: 1 }, this.Kp = { x: 1, y: 1, z: 1 }, this.hH = N(255, 255, 255), this.nH = xe.projectionOrthographic(-1, 1, -1, 1, 1, -1), this.oH = xe.projectionOrthographic(-1, 1, -1, 1, 1, -1), this.aH = !1, this.isEulerRotation = !0, this.LV = ss({ fillStyleSolid: () => de(this.Ke) && this.Ke, fillStyleValuePalette: () => Ve(this.Ke) && this.Ke.lookUpProperty === "value" && this.Ke }), this.Ke = Hi.fillStyle, this._v.C(Ba);
  }
  Uh(t) {
    var e;
    const i = this.sO(), s = this.ui.T(), o = this.ui.u, n = this.ml();
    this.LV.fillStyleSolid(n);
    const a = this.LV.fillStyleValuePalette(n), l = this.rH, h = this.Kp;
    if (this.iH && this.lH && (this._N = this.WD.pO(this.lH.vertices, void 0, this._N), this.wN = this.WD.iz(this.lH.indices, this.wN), this.uH = this.lH.indices.length), this._v.T().type === "phong" && (i || this.iH) && (!((e = this.lH) === null || e === void 0) && e.normals) && (this.cH = this.WD.pO(this.lH.normals, void 0, this.cH)), !this.dH && a && a.lookUpProperty === "value" && this.lH && (this.dH = new Float32Array(this.lH.vertices.length / 3), this.sH = !0), this.dH && this.sH && (this.fH = this.WD.pO(this.dH, void 0, this.fH)), i || n || o) {
      if (a && a.lookUpProperty !== "value") throw new Error("LightningChart JS MeshModel3D does not support look up by x/y/z. Must be value");
      this.ME = this.WD.SR(K["3D"], K.ColorShaded3D({ dataType: a ? ["lookup", "value", a.lut] : "uniform", shadingStyle: this._v.T().type, wireframe: !1 }), K.Model3D({ normalSource: this._v.T().type === "phong" ? "attribute" : void 0 })), this.ZU = s ? this.WD.SR(K["3D"], K.MousePicking({ useVertexId: !0 }), K.Model3D({ normalSource: void 0 })) : void 0;
    }
    if (this.aH) {
      const u = xe.projectionOrthographic(-1, 1, -1, 1, 1, -1);
      if (this.isEulerRotation) this.oH = xe.rotateXYZ(u, l), this.nH = xe.translate(u, h.x / 2, h.y / 2, h.z / 2), this.nH = xe.rotateXYZ(this.nH, l), this.nH = xe.translate(this.nH, -h.x / 2, -h.y / 2, -h.z / 2);
      else {
        const c = [-this.Qp.x, -this.Qp.y, -this.Qp.z, this.Qp.w];
        this.oH = xe.quaternionToRotationMatrix(c), this.nH = xe.translate(u, h.x / 2, h.y / 2, h.z / 2), this.nH = xe.multiply(this.nH, this.oH), this.nH = xe.translate(this.nH, -h.x / 2, -h.y / 2, -h.z / 2);
      }
      this.aH = !1;
    }
    return this._v.u = !1, this.Ml(this.Ke), this.ui.u = !1, this.iH = !1, this.sH = !1, this;
  }
  Ec(t, e) {
    var i;
    const s = t === 1 ? this.ZU : this.ME, o = t === 1, n = this.wN, a = this._N, l = this.cH, h = this.fH, u = this.Zp, c = this.Xp, d = this.eH, f = this.Kp, p = this.nH, g = this.oH, y = this.LV.fillStyleValuePalette(!1), m = this.LV.fillStyleSolid(!1), A = this._v.T(), v = { location: void 0, size: 1 };
    let b = this.uH;
    if (!(s && a && n && this.lH)) return {};
    const w = this.lH ? (i = this.lH) === null || i === void 0 ? void 0 : i.parts.length : 0;
    if (w < 1) return {};
    const k = this.lH.vertices.length;
    return this.WD.SO(s, ((R, L, x) => {
      var M;
      this.WD.pd(s).YO(R("uScale"), this.TY.SE.wO()).YO(R("uDisp"), this.TY.SE.kO()).WO(R("uViewProjectionMatrix"), this.VY)._O(R("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(R("uHighlightColorOffset"), this.bi)._O(R("uRenderEffectMask"), t === 2 ? 1 : 0).WO(R("uModelRotation"), p).YO(R("uModelScale"), [d.x, d.y, d.z]).YO(R("uLocationAxis"), [u.x - this.TY.SE.mV().x, u.y - this.TY.SE.mV().y, u.z - this.TY.SE.mV().z]).YO(R("uModelAlignment"), [c.x, c.y, c.z]).YO(R("uModelSize"), [f.x, f.y, f.z]).bO(a, 0, { location: x.attribute("aGeoPos"), size: 3 }).az(n);
      let C = !1;
      if (o) this.WD.XO(R("uFirstId"), e).Nz(x, k);
      else {
        if (this.Ke === Lt && k < 1) return !1;
        if (m) this.WD.gP(R("uColorDiffuse"), m.getColor());
        else if (y) {
          if (!h) return !1;
          const E = y.getPalette();
          v.location = L("aLookupValue"), this.WD.Jz(x, E, void 0).bO(h, void 0, v), C = !0;
        }
      }
      A.type !== "phong" || o || (this.WD.YO(R("uCameraLoc"), this.NY).YO(R("uLightLoc"), this.GY)._O(R("uAmbientReflection"), A.ambientReflection)._O(R("uSpecularReflection"), A.specularReflection)._O(R("uDiffuseReflection"), A.diffuseReflection)._O(R("uShininess"), A.shininess).gP(R("uLightColor"), A.specularColor).gP(R("uAmbientColor"), A.ambientColor).WO(R("uModelRotationNormals"), g), l && this.WD.bO(l, void 0, { location: x.attribute("aNormal"), size: 3 }));
      let S = !1;
      for (let E = 0; E < w; E += 1) {
        b = 0;
        let T = this.hH, I = 0, F = 0, D = 0, P = !0;
        this.lH && this.lH.parts && this.lH.parts[E].material && (T = this.lH.parts[E].material.specular, b = this.lH.parts[E].count, F = this.lH.parts[E].count, D = this.lH.parts[E].offset, P = this.lH.parts[E].useIndexBuffer, I = this.lH.parts[E].indexStart, o || m || C || this.WD.gP(R("uColorDiffuse"), this.lH.parts[E].material.diffuse)), (b > 0 || F > 0) && (A.type !== "phong" || o || (this.WD.gP(R("uLightColor"), T), g ? this.WD.WO(R("uModelRotationNormals"), g) : this.WD.gP(R("uLightColor"), A.specularColor)), P ? this.WD.uz(b, this.WD.gl.TRIANGLES, I, ((M = this.lH) === null || M === void 0 ? void 0 : M.indices) instanceof Uint32Array ? this.WD.gl.UNSIGNED_INT : this.WD.gl.UNSIGNED_SHORT) : this.WD.dC(this.WD.gl.TRIANGLES, F, D), S = !0);
      }
      return S;
    })), { idCount: k };
  }
  AH(t) {
    if (this.gH) return this.gH;
    const e = this.Zp, i = this.Xp, s = this.eH, o = this.Kp, n = this.rH, a = this.Qp, l = this.TY._S(e), h = [], u = xe.projectionOrthographic(-1, 1, -1, 1, 1, -1);
    let c;
    if (this.isEulerRotation) c = xe.translate(u, o.x / 2, o.y / 2, o.z / 2), c = xe.rotateXYZ(c, n), c = xe.translate(c, -o.x / 2, -o.y / 2, -o.z / 2);
    else {
      const g = [-a.x, -a.y, -a.z, a.w];
      c = xe.translate(u, o.x / 2, o.y / 2, o.z / 2), c = xe.multiply(c, xe.quaternionToRotationMatrix(g)), c = xe.translate(c, -o.x / 2, -o.y / 2, -o.z / 2);
    }
    const d = (i.x + 1) * (o.x / 2), f = (i.y + 1) * (o.y / 2), p = (i.z + 1) * (o.z / 2);
    for (let g = 0; g < t.vertices.length; g += 3) {
      const y = xe.multiply(c, [t.vertices[g], t.vertices[g + 1], t.vertices[g + 2], 1]), m = { x: l.x + (y[0] - d) * s.x, y: l.y + (y[1] - f) * s.y, z: l.z + (y[2] - p) * s.z };
      h.push(m);
    }
    return this.gH = h, this.gH;
  }
  nm(t) {
    const e = this.lH;
    if (!e) return;
    const i = this.AH(e), s = t(i);
    s.length !== 0 && (s.length !== i.length && this.yi.Ga.$a === !0 && H.console.warn(`LightningChart JS warning - MeshModel3D.setVertexValues returned array length is not equal to vertex locations array length.
This is most likely an application error.`), this.dH = s instanceof Float32Array ? s : new Float32Array(s), this.sH = !0);
  }
  Oc(t, e, i, s, o) {
    return { info: { iVertex: t - e } };
  }
  sm(t, e) {
    const i = this.lH;
    if (!i || t?.iVertex === void 0) return;
    if (i.indices.length > 0) {
      const l = [];
      for (let p = 0; p < i.indices.length; p += 3) {
        const g = i.indices[p], y = i.indices[p + 1], m = i.indices[p + 2];
        g !== t.iVertex && y !== t.iVertex && m !== t.iVertex || l.push([g, y, m]);
      }
      const h = this.AH(i), u = this.yi.lr(e.clientX, e.clientY), c = l.map(((p) => p.map(((g) => {
        const y = { x: i.vertices[3 * g], y: i.vertices[3 * g + 1], z: i.vertices[3 * g + 2] }, m = h[g], A = this.TY.wS(m), v = this.TY.xy(A);
        return { index: g, vertex: y, world: m, axis: A, dist: v ? Au(v, u) : wt };
      })))).flat();
      c.sort(((p, g) => p.dist - g.dist));
      const d = c[0];
      if (!d) return;
      const f = this.dH ? this.dH[d.index] : void 0;
      return { coordModel: d.vertex, coordAxis: d.axis, index: d.index, value: f };
    }
    const s = t.iVertex, o = this.dH ? this.dH[s] : void 0, n = { x: i.vertices[3 * s], y: i.vertices[3 * s + 1], z: i.vertices[3 * s + 2] }, a = this.AH(i)[s];
    return { coordModel: n, coordAxis: this.TY.wS(a), index: s, value: o };
  }
  dispose() {
    return super.dispose(), this._N && (this.WD.LO(this._N), this._N = void 0), this.wN && (this.WD.LO(this.wN), this.wN = void 0), this.cH && (this.WD.LO(this.cH), this.cH = void 0), this.fH && (this.WD.LO(this.fH), this.fH = void 0), this.ME = void 0, this.ZU = void 0, this.lH = void 0, this.dH = void 0, this;
  }
  Rc() {
    return this.dispose(), this;
  }
  rm(t) {
    return this.lH = t, this.iH = !0, this.Kp = t.modelSize, this;
  }
  sr(t) {
    return this.Ke = ba(this.Ke, t), this;
  }
  kh() {
    return this.Ke;
  }
  om(t) {
    return this.eH = t, this.gH = void 0, this;
  }
  wO() {
    return this.eH;
  }
  am(t) {
    return this.Zp = t, this.gH = void 0, this;
  }
  lm(t) {
    return this.Xp = t, this.gH = void 0, this;
  }
  um(t) {
    return this.rH = t, this.aH = !0, this.isEulerRotation = !0, this.gH = void 0, this;
  }
  dm(t) {
    return this.Qp = t, this.aH = !0, this.isEulerRotation = !1, this.gH = void 0, this;
  }
  fm(t) {
    return this.CY = t, this;
  }
  Am() {
    return this.CY;
  }
  Wi() {
    return Pt;
  }
  Hi() {
    return wt;
  }
  Zi() {
    return Pt;
  }
  Xi() {
    return wt;
  }
  be() {
    return Pt;
  }
  Se() {
    return wt;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
  Rv() {
    return 0;
  }
  ml() {
    return Ea(this.Sl, this.Ke);
  }
  Ml(t) {
    this.Sl = t;
  }
}
class SC extends zo {
  constructor(t, e, i, s) {
    super(t, e, i), this.CY = "cull-back", this.Wx = [], this.OG = new Jf(this.Wx, ((g) => g.vertexBuffer && this.WD.LO(g.vertexBuffer)), !1), this.wc = [], this.kc = 0, this.wu = [], this.ZY = 0, this.gu = _s, this.JY = _s, this.Tu = !1, this.LV = ss({ fillStyleSolid: () => {
      const g = this.Oy.getFillStyle();
      return de(g) && g;
    }, fillStyleIndividual: () => {
      const g = this.Oy.getFillStyle();
      return Tr(g) && g;
    }, fillStylePalette: () => {
      const g = this.Oy.getFillStyle();
      return Ve(g) && g;
    }, triangulatedPointStyle: () => {
      const g = this.Oy;
      return wn(g) && g;
    }, wireframeLineStyleSolid: () => {
      const g = wn(this.Oy) && this.Oy, y = g && g.getWireframeStyle();
      return Oi(y) && y;
    }, wireframeFillStyleSolid: () => {
      const g = wn(this.Oy) && this.Oy, y = g && g.getWireframeStyle(), m = y && y.getFillStyle();
      return de(m) && m;
    } }), this.Mj = le(void 0), this.Ga = s, this.Oy = Hi.pointStyle3D, this._v.C(Ba);
    const o = s?.individualPointColorEnabled === !0, n = s?.individualPointSizeEnabled === !0, a = s?.individualLookupValuesEnabled === !0, l = s?.individualPointSizeAxisEnabled === !0;
    let h, u, c, d, f = 0;
    f += this.Nt() ? 6 : 3, o && (h = f, f += 4), n && (u = f, f += 1), a && (c = f, f += 1), l && (d = f, f += 3);
    const p = Vm(o, n, a, l, this.Nt());
    this.$G = { individualPointColorEnabled: o, individualPointSizeEnabled: n, individualLookupValuesEnabled: a, individualPointSizeAxisEnabled: l, attributesPerVertex: f, attributeOffsetCoordinate: 0, attributeOffsetColor: h, attributeOffsetSize: u, attributeOffsetLookUpValue: c, attributeOffsetPointSize3D: d, prepareRenderData: (g, y) => p(g, this.Oy, this.Oy.fillStyle) };
  }
  wi() {
    return this.Mj.T() || this.Mj._;
  }
  Oc(t, e, i, s, o) {
    return { info: { dataPoint: this.wc[t - e] } };
  }
  Uh(t) {
    const e = this.Tu, i = this.wu, s = this.ZY, o = s > 0, n = this.Oy, a = this.Oy !== this.vH, l = this.ui.T(), h = this.ui.u, u = this.sO();
    this.JY && (this.gu = bu(this.gu, this.JY), this.JY = void 0), o && (this.wc = us(this.wc, i, { canReturnB: !0 }), this.kc += s);
    let c = i, d = s;
    if (e && (this.Wx.forEach(((A) => {
      A.existingDataPointsCount = 0, A.existingCoordinatesCount = 0, A.boundaries = _s;
    })), this.OG.CG(), c = this.wc, d = this.kc), d > 0) {
      const A = Math.floor(this._V.KY / (this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT)), v = Jt(d, 1e5, A);
      this.OG.MG(c, v, ((b, w, k) => ({ existingDataPointsCount: k, existingCoordinatesCount: k, allocatedCoordinatesCount: b, boundaries: _s, vertexBuffer: this.WD.QO(b * this.$G.attributesPerVertex, this.$G.prepareRenderData(w, k)) })), ((b, w, k) => {
        this.WD.KO(b.vertexBuffer, b.existingCoordinatesCount * this.$G.attributesPerVertex, this.$G.prepareRenderData(w, k)), b.existingDataPointsCount += k, b.existingCoordinatesCount = b.existingDataPointsCount;
      }));
    }
    const f = n.getFillStyle(), p = this.LV.fillStyleSolid(a), g = this.LV.fillStyleIndividual(a), y = this.LV.fillStylePalette(a), m = f === Lt && Lt;
    if (a || u || h) {
      let A;
      const v = n.getSize(), b = this.$G.individualPointColorEnabled, w = this.$G.individualPointSizeEnabled, k = this.$G.individualPointSizeAxisEnabled, R = this.$G.individualLookupValuesEnabled;
      if (g && !b) {
        const M = "LCJS misusage error: Series individualPointColorEnabled flag must be set if using IndividualPointFill !";
        throw H.alert(M), new Error(M);
      }
      if (y && y.getLookUpProperty() === "value" && !R) {
        const M = 'LCJS misusage error: Series individualLookupValuesEnabled flag must be set if using PalettedFill with lookUpProperty="value" !';
        throw H.alert(M), new Error(M);
      }
      const L = this.LV.wireframeLineStyleSolid(a), x = this.LV.wireframeFillStyleSolid(a);
      if (p || g || y || x) {
        const M = g ? "attribute" : y ? ["lookup", y.getLookUpProperty(), y.lut] : "uniform", C = w && typeof v == "number", S = k && typeof v == "object", E = C || S ? "attribute" : "uniform";
        if (wn(n)) {
          const T = Nm(n.getShape(), { cube: () => Qf(this.WD), sphere: () => AC(this.WD, n, w) });
          A = { type: "instanced", shader: this.WD.SR(K["3D"], K.ColorShaded3D({ dataType: M, shadingStyle: this._v.T().type, wireframe: x !== !1 }), K.VertexLocation({ offsets: [{ directionVar: "aInstanceGeo", dataType: E, sizeUnit: typeof v == "number" ? "nwu" : "axis", halved: !0, symmetric: typeof v == "number" }], axisWorldTranslation: jt(this.ai), normalSource: T.MY })), pointStyle: n, useIndividualPointSize: C, useIndividualPointSize3D: S, pointSizeNWU: typeof v == "number" && v, pointSizeAxis: typeof v == "object" && v, fillStyleSolid: p, fillStyleIndividual: g, fillStylePaletted: y, fillStyleEmpty: m, mousePickingShader: l && this.WD.SR(K["3D"], K.MousePicking(), K.VertexLocation({ offsets: [{ directionVar: "aInstanceGeo", dataType: E, sizeUnit: typeof v == "number" ? "nwu" : "axis", halved: !0, symmetric: typeof v == "number" }], axisWorldTranslation: jt(this.ai), normalSource: void 0 })), geometry: T, wireframe: L && x && { thickness: L.getThickness() < 0 ? 1 : L.getThickness(), fillStyleSolid: x } };
        } else rg(n) && typeof v == "number" && (A = { type: "primitive", shader: this.WD.SR(K["3D"], K.PointSize(E), K.Color({ dataType: M }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })), pointStyle: n, pointSizePixels: v, useIndividualPointSize: C, fillStyleSolid: p, fillStyleIndividual: g, fillStylePaletted: y, mousePickingShader: l && this.WD.SR(K["3D"], K.PointSize(E), K.MousePicking({ useVertexId: !0 }), K.VertexLocation({ axisWorldTranslation: jt(this.ai), normalSource: void 0 })) });
      }
      this.ON = A;
    }
    if (this.Mj.T() === void 0 && y && y.lookUpProperty === "value" && y.lut.percentageValues) {
      let A = Pt, v = wt;
      for (let b = 0; b < this.wc.length; b += 1) {
        const w = this.wc[b];
        w.value !== void 0 && w.value < v && (v = w.value), w.value !== void 0 && w.value > A && (A = w.value);
      }
      this.Mj.C({ min: v, max: A });
    }
    return this.Mj._ = void 0, this.Tu = !1, this.wu = [], this.ZY = 0, this.vH = n, this._v.u = !1, this;
  }
  Ec(t, e) {
    const i = this.WD.gl, s = this.ON, o = this.kc;
    if (!s) return {};
    const n = t === 1 ? s.mousePickingShader : s.shader;
    if (!n) return {};
    const a = this._v.T(), { fillStyleSolid: l, fillStylePaletted: h, useIndividualPointSize: u } = s, c = s.type === "instanced" && s.useIndividualPointSize3D, d = s.type === "instanced" && s.wireframe;
    return this.WD.SO(n, ((f, p, g, y) => {
      let m = !1;
      if (this.WD.pd(n).YO(f("uScale"), this.TY.SE.wO()).YO(f("uDisp"), this.TY.SE.kO()).YO(y("uScaleStart_highpart"), this.TY.SE.tV()).YO(y("uScaleStart_lowpart"), this.TY.SE.iV()).WO(f("uViewProjectionMatrix"), this.VY)._O(f("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(f("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(f("uRenderEffectMask"), t === 2 ? 1 : 0), s.type === "instanced") {
        const { pointSizeAxis: v, pointSizeNWU: b } = s;
        v !== !1 && c === !1 && this.WD.YO(f("uOffsetAxis"), [v.x, v.y, v.z]), b !== !1 && u === !1 && this.WD._O(f("uOffsetNWU"), b)._O(y("uRatioNwuWu"), this.TY.qY());
      } else if (s.type === "primitive") {
        const { pointSizePixels: v } = s;
        u || this.WD._O(f("uPointSize"), v)._O(f("uDevicePixelRatio"), this.WD.rO());
      }
      if (t !== 1) {
        if (s.type === "instanced" ? (a.type === "phong" && this.WD.YO(f("uCameraLoc"), this.NY).YO(f("uLightLoc"), this.GY)._O(f("uAmbientReflection"), a.ambientReflection)._O(f("uSpecularReflection"), a.specularReflection)._O(f("uDiffuseReflection"), a.diffuseReflection)._O(f("uShininess"), a.shininess).gP(f("uLightColor"), a.specularColor).gP(f("uAmbientColor"), a.ambientColor), d && this.WD._O(f("uWireframeThickness"), d.thickness).gP(f("uWireframeColor"), d.fillStyleSolid.getColor()), l && this.WD.gP(f("uColorDiffuse"), l.getColor()), s.fillStyleEmpty && this.WD.gP(f("uColorDiffuse"), Qe)) : s.type === "primitive" && l && this.WD.gP(f("uColor"), l.getColor()), h) {
          const v = er(h, this, this.Mj.T());
          if (!v && h.lut.percentageValues) return !1;
          this.WD.Jz(g, h.lut, v);
        }
      }
      const A = Cl(e);
      return this.Wx.forEach(((v) => {
        if (t === 1) {
          const [b, w] = A.es(v.existingDataPointsCount);
          this.WD.XO(f("uFirstId"), b), s.type === "instanced" ? this.WD.$z(g, w) : this.WD.Nz(g, w);
        }
        if (i.bindBuffer(i.ARRAY_BUFFER, v.vertexBuffer), this.Nt()) {
          const b = p("aPos_highpart"), w = p("aPos_lowpart");
          i.vertexAttribPointer(b, 3, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetCoordinate * Float32Array.BYTES_PER_ELEMENT), s.type === "instanced" && this.WD.rz(b, 1), i.enableVertexAttribArray(b), i.vertexAttribPointer(w, 3, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, (this.$G.attributeOffsetCoordinate + 3) * Float32Array.BYTES_PER_ELEMENT), s.type === "instanced" && this.WD.rz(w, 1), i.enableVertexAttribArray(w);
        } else {
          const b = p("aPos");
          i.vertexAttribPointer(b, 3, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetCoordinate * Float32Array.BYTES_PER_ELEMENT), s.type === "instanced" && this.WD.rz(b, 1), i.enableVertexAttribArray(b);
        }
        if (s.fillStyleIndividual && this.$G.attributeOffsetColor !== void 0 && t !== 1) {
          const b = p("aColor");
          i.vertexAttribPointer(b, 4, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetColor * Float32Array.BYTES_PER_ELEMENT), s.type === "instanced" && this.WD.rz(b, 1), i.enableVertexAttribArray(b);
        }
        if (u && this.$G.attributeOffsetSize !== void 0) {
          s.type === "instanced" ? this.WD._O(y("uRatioNwuWu"), this.TY.qY()) : s.type === "primitive" && this.WD._O(f("uDevicePixelRatio"), this.WD.rO());
          const b = p(s.type === "instanced" ? "aOffsetNWU" : "aPointSize");
          i.vertexAttribPointer(b, 1, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetSize * Float32Array.BYTES_PER_ELEMENT), s.type === "instanced" && this.WD.rz(b, 1), i.enableVertexAttribArray(b);
        }
        if (c && this.$G.attributeOffsetPointSize3D !== void 0 && s.type === "instanced") {
          const b = p("aOffsetAxis");
          i.vertexAttribPointer(b, 3, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetPointSize3D * Float32Array.BYTES_PER_ELEMENT), s.type === "instanced" && this.WD.rz(b, 1), i.enableVertexAttribArray(b);
        }
        if (s.fillStylePaletted && s.fillStylePaletted.getLookUpProperty() === "value" && this.$G.attributeOffsetLookUpValue !== void 0 && t !== 1) {
          const b = p("aLookupValue");
          i.vertexAttribPointer(b, 1, i.FLOAT, !1, this.$G.attributesPerVertex * Float32Array.BYTES_PER_ELEMENT, this.$G.attributeOffsetLookUpValue * Float32Array.BYTES_PER_ELEMENT), s.type === "instanced" && this.WD.rz(b, 1), i.enableVertexAttribArray(b);
        }
        s.type === "instanced" ? (s.geometry.dC(g, v.existingCoordinatesCount, a.type === "phong" && t !== 1, !!d && t !== 1), m = !0) : s.type === "primitive" && (this.WD.dC(i.POINTS, v.existingCoordinatesCount), m = !0);
      })), m;
    })), { idCount: o };
  }
  Pu(t, e) {
    Array.isArray(t) || (t = [t]), this.wu = us(this.wu, t, { canReturnB: !0 }), this.ZY += t.length;
    const i = e || Tf(t);
    return this.JY = this.JY ? bu(this.JY, i) : i, this.Mj.C(void 0), this;
  }
  zy(t) {
    return this.Oy = typeof t == "function" ? t(this.Oy) : t, this;
  }
  yH() {
    return this.Oy;
  }
  Wi() {
    return this.JY ? Math.max(this.JY.max.x, this.gu.max.x) : this.gu.max.x;
  }
  Hi() {
    return this.JY ? Math.min(this.JY.min.x, this.gu.min.x) : this.gu.min.x;
  }
  Zi() {
    return this.JY ? Math.max(this.JY.max.y, this.gu.max.y) : this.gu.max.y;
  }
  Xi() {
    return this.JY ? Math.min(this.JY.min.y, this.gu.min.y) : this.gu.min.y;
  }
  be() {
    return this.JY ? Math.max(this.JY.max.z, this.gu.max.z) : this.gu.max.z;
  }
  Se() {
    return this.JY ? Math.min(this.JY.min.z, this.gu.min.z) : this.gu.min.z;
  }
  mu() {
    const t = this.Oy, e = t.getSize();
    return typeof e == "number" ? wn(t) ? e / 2 : rg(t) ? 5 : 0 : 0;
  }
  Su() {
    return this.mu();
  }
  Rv() {
    return this.mu();
  }
  Lu() {
    return this.wc;
  }
  Bu() {
    return this.wu;
  }
  Ru() {
    return this.kc;
  }
  Ou() {
    return this.ZY;
  }
  Vi() {
    return this.Tu = !0, this.wc.length = 0, this.kc = 0, this.wu = [], this.ZY = 0, this.gu = _s, this.JY = void 0, this.Mj.C(void 0), this;
  }
  dispose() {
    return super.dispose(), this.OG.TG(), this.ON = void 0, this;
  }
  Rc() {
    return this.dispose(), this;
  }
}
const AC = (r, t, e) => {
  const i = t.getSize();
  return n1(r, typeof i == "number" ? e || i >= 50 ? 20 : i >= 10 ? 10 : i >= 3 ? 5 : 3 : 32);
};
class a1 extends zo {
  constructor(t, e, i, s) {
    super(t, e, i), this.CY = "disabled", this.Ke = Hi.fillStyle, this.kp = Hi.lineStyle, this.oj = le("bilinear"), this.pH = new Km(), this.mH = new Zm.Simple(), this.SH = [], this.bH = void 0, this.ON = {}, this.xH = !1, this.LV = ss({ fillStyleSolid: () => de(this.Ke) && this.Ke, fillStylePaletted: () => Ve(this.Ke) && this.Ke, wireframeStyleLine: () => Oi(this.kp) && this.kp, wireframeStyleFill: () => {
      const u = this.kp && this.kp.getFillStyle();
      return de(u) && u;
    } }), this.cj = le(void 0), this.Wt = { x: 0, z: 0 }, this.uj = { x: 1, z: 1 }, this.lj = !1, this._v.C(Na);
    const o = s.dataOrder === "columns" ? s.columns : s.rows, n = s.dataOrder === "columns" ? s.rows : s.columns;
    this.Ga = { ...s, primaryDimensionVectorsCount: o, secondaryDimensionVectorsCount: n }, this.MH = new Array(this.Ga.primaryDimensionVectorsCount).fill(void 0), this.zx = new lc(this._V, t._V.Hj, t.yi.ai, ie, [], this.Ga).Cp(Et), this.zx.vj = a5;
    const a = this.zx.yj.gridTiles.map(((u) => {
      const c = u.sizeHeatmapDataVectors, d = u.sizeUniqueHeatmapDataVectors, f = u.iFirstVector, p = u.iFirstUniqueVector, g = new Float32Array(u.sizeHeatmapDataVectors.primary * u.sizeHeatmapDataVectors.secondary), y = { primary: u.sizeHeatmapDataVectors.primary - 1, secondary: u.sizeHeatmapDataVectors.secondary - 1 };
      return { iFirstVector: u.iFirstVector, iFirstUniqueVector: u.iFirstUniqueVector, sizeHeatmapDataVectors: u.sizeHeatmapDataVectors, sizeUniqueHeatmapDataVectors: u.sizeUniqueHeatmapDataVectors, iFirstGeometryVector: f, iFirstGeometryUniqueVector: p, sizeGeometryDataVectors: c, sizeUniqueGeometryDataVectors: d, heightmapData: g, normalmapSize: y };
    })), l = this.zx.yj.gridTileSizes.map(((u) => {
      const c = a.filter(((f) => f.sizeHeatmapDataVectors.primary === u.sizeHeatmapData.primary && f.sizeHeatmapDataVectors.secondary === u.sizeHeatmapData.secondary)), d = c[0].sizeGeometryDataVectors;
      return { ...u, tiles: c, sizeGeometryData: d };
    })), h = a.reduce(((u, c) => {
      const d = c.sizeHeatmapDataVectors.primary, f = c.sizeHeatmapDataVectors.secondary, p = d * f;
      return p > u.cells ? { primary: d, secondary: f, cells: p } : u;
    }), { primary: 0, secondary: 0, cells: 0 });
    this._H = { gridTiles: a, gridTileSizes: l, largestGridTileSize: h }, this.Ip(this.Wt, this.uj), this.dj = new e1(), this.mj = [];
  }
  Lp(t) {
    return this.cj.C(t), this;
  }
  Bp() {
    return this.cj.T();
  }
  Oc(t, e, i, s, o) {
    const n = t - e, a = n % (this.Ga.secondaryDimensionVectorsCount - 1), l = Math.floor(n / (this.Ga.secondaryDimensionVectorsCount - 1)), h = this.Ga.dataOrder === "columns" ? l : a, u = this.Ga.dataOrder === "rows" ? l : a, c = [{ x: this.Wt.x + h * this.uj.x, z: this.Wt.z + u * this.uj.z, y: this.wH(l, a), intensity: this.kH(l, a), column: this.Ga.dataOrder === "columns" ? l : a, row: this.Ga.dataOrder === "columns" ? a : l }, { x: this.Wt.x + (h + (this.Ga.dataOrder === "columns" ? 1 : 0)) * this.uj.x, z: this.Wt.z + (u + (this.Ga.dataOrder === "rows" ? 1 : 0)) * this.uj.z, y: this.wH(l + 1, a), intensity: this.kH(l + 1, a), column: this.Ga.dataOrder === "columns" ? l + 1 : a, row: this.Ga.dataOrder === "columns" ? a : l + 1 }, { x: this.Wt.x + (h + 1) * this.uj.x, z: this.Wt.z + (u + 1) * this.uj.z, y: this.wH(l + 1, a + 1), intensity: this.kH(l + 1, a + 1), column: this.Ga.dataOrder === "columns" ? l + 1 : a + 1, row: this.Ga.dataOrder === "columns" ? a + 1 : l + 1 }, { x: this.Wt.x + (h + (this.Ga.dataOrder === "columns" ? 0 : 1)) * this.uj.x, z: this.Wt.z + (u + (this.Ga.dataOrder === "rows" ? 0 : 1)) * this.uj.z, y: this.wH(l, a + 1), intensity: this.kH(l, a + 1), column: this.Ga.dataOrder === "columns" ? l : a + 1, row: this.Ga.dataOrder === "columns" ? a + 1 : l }], d = c.map(((f) => this.TY.xy(f))).map(((f) => f === void 0 ? wt : Au(f, { x: s, y: o }))).map(((f, p) => ({ i: p, dist: f })));
    return d.sort(((f, p) => f.dist - p.dist)), { info: { dataPoint: { ...c[d[0].i] } } };
  }
  wH(t, e) {
    for (let i = 0; i < this._H.gridTiles.length; i += 1) {
      const s = this._H.gridTiles[i];
      if (t >= s.iFirstVector.primary && t <= s.iFirstVector.primary + s.sizeHeatmapDataVectors.primary - 1 && e >= s.iFirstVector.secondary && e <= s.iFirstVector.secondary + s.sizeHeatmapDataVectors.secondary - 1) {
        const o = t - s.iFirstVector.primary, n = e - s.iFirstVector.secondary, a = o * s.sizeHeatmapDataVectors.secondary + n;
        return s.heightmapData[a];
      }
    }
    return 0;
  }
  kH(t, e) {
    if (this.zx.Aj) for (let i = 0; i < this.zx.yj.gridTiles.length; i += 1) {
      const s = this.zx.yj.gridTiles[i];
      if (t >= s.iFirstVector.primary && t <= s.iFirstVector.primary + s.sizeHeatmapDataVectors.primary - 1 && e >= s.iFirstVector.secondary && e <= s.iFirstVector.secondary + s.sizeHeatmapDataVectors.secondary - 1) {
        const o = t - s.iFirstVector.primary, n = e - s.iFirstVector.secondary, a = o * s.sizeHeatmapDataVectors.secondary + n;
        return s.intensityData ? s.intensityData[a] : void 0;
      }
    }
  }
  CH(t) {
    this.TH = t, this.bH = void 0;
  }
  Ip(t, e) {
    this.lj = this.lj || this.Wt != t || this.uj != e, this.Wt = t, this.uj = e;
    const i = this.Ga, s = { min: { x: Math.min(this.Wt.x, this.Wt.x + (i.columns - 1) * this.uj.x), z: Math.min(this.Wt.z, this.Wt.z + (i.rows - 1) * this.uj.z) }, max: { x: Math.max(this.Wt.x, this.Wt.x + (i.columns - 1) * this.uj.x), z: Math.max(this.Wt.z, this.Wt.z + (i.rows - 1) * this.uj.z) } }, o = /* @__PURE__ */ new Map();
    return this._H.gridTiles.forEach(((n) => {
      const a = this.Ga.dataOrder === "columns" ? { x: this.uj.x * (n.sizeHeatmapDataVectors.primary - 1), z: this.uj.z * (n.sizeHeatmapDataVectors.secondary - 1) } : { x: this.uj.x * (n.sizeHeatmapDataVectors.secondary - 1), z: this.uj.z * (n.sizeHeatmapDataVectors.primary - 1) }, l = this.Ga.dataOrder === "columns" ? { x: this.Wt.x + this.uj.x * n.iFirstVector.primary, z: this.Wt.z + this.uj.z * n.iFirstVector.secondary } : { x: this.Wt.x + this.uj.x * n.iFirstVector.secondary, z: this.Wt.z + this.uj.z * n.iFirstVector.primary };
      o.set(n, { sizeAxis: a, startLocationAxis: l });
    })), this.Bj = { FH: s, tilesInfo: o }, this;
  }
  Pp() {
    return { start: this.Wt, step: this.uj, end: { x: this.Wt.x + this.uj.x * this.Ga.columns, z: this.Wt.z + this.uj.z * this.Ga.rows } };
  }
  Fj(t, e) {
    if (!this._H) return this;
    if (!t) return this.IH(), this;
    if (!e) return this.mj.forEach(((w) => {
      w.VY = this.VY, w.Uh(!0);
    })), this;
    if (!this._H.gridTiles) return this;
    if (!this.Bj) return this;
    const i = this.Bj.FH.min.x, s = this.Bj.FH.min.z, o = this.Bj.FH.max.x, n = this.Bj.FH.max.z;
    if (i == null || s == null || o == null || n == null) return this;
    const a = this.Ga.columns, l = this.Ga.rows, h = (o - i) / (a - 1), u = (n - s) / (l - 1), c = new Array(a).fill(0, 0, a).map(((w, k) => i + k * h)), d = new Array(l).fill(0, 0, l).map(((w, k) => s + k * u));
    let f = [];
    const p = [];
    t.levels.forEach(((w) => {
      f.push(w.value), p.push({ level: w.value, width: w.strokeStyle.getThickness(), fill: w.strokeStyle.getFillStyle() });
    }));
    const g = (w, k) => this.Ga.dataOrder == "rows" ? k : w, y = (w, k) => this.Ga.dataOrder == "rows" ? w : k;
    let m, A;
    const v = o - i, b = n - s;
    switch (t.valueSource) {
      case "y":
        m = (w, k) => this.wH(g(w, k), y(w, k)), A = (w, k, R, L) => {
          k.push({ x: w.ax[R], y: L, z: w.ay[R] });
        };
        break;
      case "intensity":
        m = (w, k) => this.kH(g(w, k), y(w, k)), A = (w, k, R, L) => {
          const x = w.ax[R], M = w.ay[R], C = Math.floor((x - i) / v * (a - 1)), S = Math.floor((M - s) / b * (l - 1)), E = i + C * h, T = s + S * u, I = Lf({ x, y: M }, { point: { x: E, y: T }, value: this.wH(g(C, S), y(C, S)) }, { point: { x: E, y: T + u }, value: this.wH(g(C, S + 1), y(C, S + 1)) }, { point: { x: E + h, y: T }, value: this.wH(g(C + 1, S), y(C + 1, S)) }, { point: { x: E + h, y: T + u }, value: this.wH(g(C + 1, S + 1), y(C + 1, S + 1)) });
          k.push({ x, y: I, z: M });
        };
    }
    return this.dj.hj(m, c, d, f), this.IH(), this.dj.nj.forEach(((w) => {
      var k, R;
      const L = [];
      w.ax.forEach(((S, E) => {
        A(w, L, E, w.level);
      })), w.ax[0] == w.ax[w.ax.length - 1] && w.ay[0] == w.ay[w.ay.length - 1] && A(w, L, w.ax.length - 1, w.level);
      const x = (k = t.levels.find(((S) => S.value == w.level))) === null || k === void 0 ? void 0 : k.strokeStyle;
      if (0 < this.mj.length) {
        const S = this.mj.find(((E) => E.po() === x));
        if (S) return S.Pu({ x: Number.NaN, y: Number.NaN, z: Number.NaN }), void S.Pu(L);
      }
      const M = x.getThickness(), C = new o1(this.TY, this.pi, this.mi, void 0);
      1 < M ? C.uy(new Rf({ shape: "sphere", size: M, fillStyle: (R = p.find(((S) => S.level == w.level))) === null || R === void 0 ? void 0 : R.fill })) : C.uy(this.pH), C.gr(x), C.Pu(L), C.Lv(this.mH), this.mj.push(C);
    })), this;
  }
  Uh(t) {
    const e = this.SH, i = Ea(this.Sl, this.Ke), s = this.LV.fillStyleSolid(i), o = this.LV.fillStylePaletted(i), n = this.kp, a = this.kp !== this.Rj, l = this.LV.wireframeStyleLine(a), h = this.LV.wireframeStyleFill(a), u = h !== !1, c = this.oj.u, d = this.oj.T(), f = this._v.T(), p = this.sO(), g = this.ui.T();
    this.zx.Uh();
    const y = this.zx.Oj;
    if (!y) return this;
    this.PH = this.PH || this.LH(y);
    const m = this.PH;
    this.BH(m);
    const A = Cx(e, m, void 0, ((k) => k.sizeGeometryDataVectors));
    if (A.size > 0 && (Dx(this.WD, A, ((k) => k.heightmapData), ((k) => k.heightmapDataTexture)), this.xH = !0), f.type === "phong" && (A.size > 0 || p)) {
      const k = this.WD.gl, R = this.WD.SR(K["2D"], K.DrawToNormalTexture({ flipXZ: this.Ga.dataOrder === "rows", vertexIdSource: this.WD.Vz(), normalTextureType: this.WD.gl2 ? "uint" : "ubyte", heightmapTextureType: this.WD.gR ? "float" : "ubyte", littleEndian: this.WD.IS_MACHINE_LITTLE_ENDIAN }));
      m.gridTileSizes.forEach(((L) => {
        L.tiles.forEach(((x) => {
          var M;
          const C = x.normalmapTexture, S = (M = this.Bj) === null || M === void 0 ? void 0 : M.tilesInfo.get(x.tileData);
          if (!C || !S) return;
          const E = { x: x.normalmapSize.secondary, y: x.normalmapSize.primary }, T = E.x * E.y;
          this.WD.xz.Ec((() => {
            this.WD.SO(R, ((I, F, D, P) => (this.WD.pd(R).Nz(D, T).xO(I("uTileDimensionsXZ"), [this.Ga.dataOrder === "columns" ? L.sizeHeatmapData.primary : L.sizeHeatmapData.secondary, this.Ga.dataOrder === "columns" ? L.sizeHeatmapData.secondary : L.sizeHeatmapData.primary]).jO(I("uTileDimensions"), [L.sizeHeatmapData.primary, L.sizeHeatmapData.secondary]).xO(I("uTileStartLocationAxisXZ"), [S.startLocationAxis.x, S.startLocationAxis.z]).xO(I("uTileSizeAxisXZ"), [S.sizeAxis.x, S.sizeAxis.z]).MO(I("uHeightmapTexture"), x.heightmapDataTexture, 1).dC(k.POINTS, T), !0)));
          }), C, E, void 0, this.yi.Fa(), 0);
        }));
      }));
    }
    const v = this.ON;
    if (i || a || c) {
      const k = l && h ? { wireframeSolid: l, wireframeFillSolid: h } : void 0;
      s ? v.surface = { shader: this.WD.SR(K["3D"], K.SurfaceGrid({ axisWorldTranslation: jt(this.ai), fillColor: "uniform", interpolation: d === "bilinear" && "bilinear", flipXZ: this.Ga.dataOrder === "rows", shadingStyle: f.type, wireframe: u, normalTextureType: this.WD.gl2 ? "uint" : "ubyte", intensityTextureType: this.WD.gR ? "float" : "ubyte", heightmapTextureType: this.WD.gR ? "float" : "ubyte", littleEndian: this.WD.IS_MACHINE_LITTLE_ENDIAN })), fill: { fillMode: "solid", fillStyleSolid: s }, wireframe: k } : o && o.getLookUpProperty() === "value" ? v.surface = { shader: this.WD.SR(K["3D"], K.SurfaceGrid({ axisWorldTranslation: jt(this.ai), fillColor: ["lookup", "value", o.lut], interpolation: d === "bilinear" && "bilinear", flipXZ: this.Ga.dataOrder === "rows", shadingStyle: f.type, wireframe: u, normalTextureType: this.WD.gl2 ? "uint" : "ubyte", intensityTextureType: this.WD.gR ? "float" : "ubyte", heightmapTextureType: this.WD.gR ? "float" : "ubyte", littleEndian: this.WD.IS_MACHINE_LITTLE_ENDIAN })), fill: { fillMode: "intensity", fillStylePaletted: o }, wireframe: k } : o ? v.surface = { shader: this.WD.SR(K["3D"], K.SurfaceGrid({ axisWorldTranslation: jt(this.ai), fillColor: ["lookup", o.getLookUpProperty(), o.lut], interpolation: d === "bilinear" && "bilinear", flipXZ: this.Ga.dataOrder === "rows", shadingStyle: f.type, wireframe: u, normalTextureType: this.WD.gl2 ? "uint" : "ubyte", intensityTextureType: this.WD.gR ? "float" : "ubyte", heightmapTextureType: this.WD.gR ? "float" : "ubyte", littleEndian: this.WD.IS_MACHINE_LITTLE_ENDIAN })), fill: { fillMode: "xyz", fillStylePaletted: o }, wireframe: k } : u && (v.surface = { shader: this.WD.SR(K["3D"], K.SurfaceGrid({ axisWorldTranslation: jt(this.ai), fillColor: void 0, interpolation: d === "bilinear" && "bilinear", flipXZ: this.Ga.dataOrder === "rows", shadingStyle: f.type, wireframe: u, normalTextureType: this.WD.gl2 ? "uint" : "ubyte", intensityTextureType: this.WD.gR ? "float" : "ubyte", heightmapTextureType: this.WD.gR ? "float" : "ubyte", littleEndian: this.WD.IS_MACHINE_LITTLE_ENDIAN })), fill: void 0, wireframe: k });
    }
    v.mousePicking = g ? this.ON.mousePicking || { shader: this.WD.SR(K["3D"], K.MousePicking(), K.SurfaceGrid({ axisWorldTranslation: jt(this.ai), fillColor: void 0, interpolation: d === "bilinear" && "bilinear", flipXZ: this.Ga.dataOrder === "rows", shadingStyle: "simple", wireframe: !1, normalTextureType: this.WD.gl2 ? "uint" : "ubyte", intensityTextureType: this.WD.gR ? "float" : "ubyte", heightmapTextureType: this.WD.gR ? "float" : "ubyte", littleEndian: this.WD.IS_MACHINE_LITTLE_ENDIAN })) } : void 0, this.ON = v, this.SH.length = 0, this.Sl = this.Ke, this.Rj = n, this._v.u = !1;
    const b = this.cj.T(), w = b !== this.Vj;
    return this.Fj(b, w || A.size > 0 || this.lj), this.lj = !1, this.Vj = this.cj.T(), this;
  }
  LH(t) {
    const e = this._H.gridTiles.map(((n) => {
      const a = kx(this.WD, n.sizeHeatmapDataVectors.secondary, n.sizeHeatmapDataVectors.primary), l = t.gridTiles.find(((h) => h.iFirstUniqueVector.primary === n.iFirstUniqueVector.primary && h.iFirstUniqueVector.secondary === n.iFirstUniqueVector.secondary));
      if (!l) throw new Error("Internal LC JS error prepare surface data 2D render data not found");
      return { ...n, intensityDataTexture: l.intensityDataTexture, heightmapDataTexture: a, normalmap: void 0, tileData: n };
    })), i = this._H.gridTileSizes.map(((n) => {
      const a = e.filter(((l) => l.sizeHeatmapDataVectors.primary === n.sizeHeatmapData.primary && l.sizeHeatmapDataVectors.secondary === n.sizeHeatmapData.secondary));
      return { ...n, tiles: a };
    })), s = this.WD.pO([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 0, 0]), o = this.WD.gl.TRIANGLES;
    return { gridTiles: e, gridTileSizes: i, rectangleLocationsBuffer: s, rectangleLocationsDrawLength: 6, rectangleLocationsDrawMode: o };
  }
  BH(t) {
    var e;
    if (this._v.T().type === "phong") for (let i = 0; i < t.gridTiles.length; i += 1) {
      const s = t.gridTiles[i];
      if (s.normalmapTexture) return;
      let o;
      const n = (e = this.WD.gl2) === null || e === void 0 ? void 0 : e.ctx;
      if (n) o = this.WD.Dx(null, n.RGBA_INTEGER, !1, !0, { x: s.normalmapSize.secondary, y: s.normalmapSize.primary }, !1, n.UNSIGNED_INT, n.RGBA32UI);
      else {
        const a = this.WD.gl;
        o = this.WD.Dx(null, a.RGBA, !1, !0, { x: s.normalmapSize.secondary, y: s.normalmapSize.primary }, !1, a.UNSIGNED_BYTE);
      }
      s.normalmapTexture = o;
    }
    else t.gridTiles.forEach(((i) => {
      i.normalmapTexture && (this.WD.JD(i.normalmapTexture), i.normalmapTexture = void 0);
    }));
  }
  Ec(t, e) {
    var i, s, o, n;
    const a = this.WD.gl, l = this.PH;
    if (!l) return {};
    const h = this._v.T(), u = this.ON, c = t === 1 ? (i = u.mousePicking) === null || i === void 0 ? void 0 : i.shader : (s = u.surface) === null || s === void 0 ? void 0 : s.shader;
    if (!c) return {};
    const d = t !== 1 ? (o = u.surface) === null || o === void 0 ? void 0 : o.wireframe : void 0, f = t !== 1 ? (n = u.surface) === null || n === void 0 ? void 0 : n.fill : void 0;
    return this.WD.SO(c, ((p, g, y, m) => {
      let A = !1;
      if (this.WD.pd(c).$z(y, this._H.largestGridTileSize.cells).YO(p("uScale"), this.TY.SE.wO()).YO(p("uDisp"), this.TY.SE.kO()).YO(m("uScaleStart_highpart"), this.TY.SE.tV()).YO(m("uScaleStart_lowpart"), this.TY.SE.iV()).WO(p("uViewProjectionMatrix"), this.VY)._O(p("uIsHighlighted"), t === 1 || t === 2 ? 0 : this.gi).gP(p("uHighlightColorOffset"), t === 1 || t === 2 ? Qe : this.bi)._O(p("uRenderEffectMask"), t === 2 ? 1 : 0), t !== 1 && (h.type === "phong" && this.WD.YO(p("uCameraLoc"), this.NY).YO(p("uLightLoc"), this.GY)._O(p("uAmbientReflection"), h.ambientReflection)._O(p("uSpecularReflection"), h.specularReflection)._O(p("uDiffuseReflection"), h.diffuseReflection)._O(p("uShininess"), h.shininess).gP(p("uLightColor"), h.specularColor).gP(p("uAmbientColor"), h.ambientColor), d)) {
        const { wireframeFillSolid: v, wireframeSolid: b } = d, w = b.getThickness() < 0 ? 1 : b.getThickness();
        this.WD.gP(p("uWireframeColor"), v.getColor())._O(p("uWireframeThickness"), w);
      }
      return t === 1 || f?.fillMode === "solid" && this.WD.gP(p("uColorDiffuse"), f.fillStyleSolid.getColor()), l.gridTileSizes.forEach(((v) => {
        this.WD.xO(p("uTileDimensionsXZ"), [this.Ga.dataOrder === "columns" ? v.sizeHeatmapData.primary : v.sizeHeatmapData.secondary, this.Ga.dataOrder === "columns" ? v.sizeHeatmapData.secondary : v.sizeHeatmapData.primary]).jO(p("uTileDimensions"), [v.sizeHeatmapData.primary, v.sizeHeatmapData.secondary]), v.tiles.forEach(((b) => {
          var w;
          const k = (w = this.Bj) === null || w === void 0 ? void 0 : w.tilesInfo.get(b.tileData);
          if (!k) return;
          let R = 0, L = (b.sizeHeatmapDataVectors.primary - 1) * (b.sizeHeatmapDataVectors.secondary - 1);
          if (this.TH) {
            const x = this.TH.fill.iFirstPrimary, M = this.TH.fill.iFirstPrimary + this.TH.fill.amountPrimary - 1, C = b.iFirstVector.primary, S = b.iFirstVector.primary + b.sizeHeatmapDataVectors.primary - 1;
            if (C > M || S < x) return;
            const E = ((T, I, F, D) => Ee(Math.max(T, F), Math.min(I, D)))(x, M, C, S);
            R = (E.min - b.iFirstVector.primary) * (v.sizeGeometryData.secondary - 1), L = (E.max - E.min) * (v.sizeGeometryData.secondary - 1);
          }
          if (!(R < 0 || L <= 0)) {
            if (f?.fillMode === "intensity") {
              const { fillStylePaletted: x } = f, M = this.zx.Mj;
              this.WD.Jz(y, x.lut, M).MO(p("uTileIntensityValues"), b.intensityDataTexture, 2).IO(p("uTileBoundsAxisXZ"), [k.startLocationAxis.x, k.startLocationAxis.z, k.sizeAxis.x, k.sizeAxis.z]);
            }
            if (f?.fillMode === "xyz") {
              const { fillStylePaletted: x } = f, M = x.getLookUpProperty() === "x" ? { min: this.Hi(), max: this.Wi() } : x.getLookUpProperty() === "y" ? { min: this.Xi(), max: this.Zi() } : x.getLookUpProperty() === "z" ? { min: this.Se(), max: this.be() } : void 0;
              if (!M && x.lut.percentageValues) return;
              this.WD.Jz(y, x.lut, M);
            }
            t !== 1 && this._v.T().type === "phong" && b.normalmapTexture && this.WD.MO(p("uNormalmapTexture"), b.normalmapTexture, 3), t === 1 && this.WD.XO(p("uFirstId"), e + R), this.WD.bO(l.rectangleLocationsBuffer, 0, { location: g("aGeoCellOffset"), size: 2 }, { location: d ? g("aTriangleBary") : void 0, size: 3 }).XO(p("uBaseInstance"), R).xO(p("uTileStartLocationAxisXZ"), [k.startLocationAxis.x, k.startLocationAxis.z]).xO(p("uTileSizeAxisXZ"), [k.sizeAxis.x, k.sizeAxis.z]).MO(p("uHeightmapTexture"), b.heightmapDataTexture, 0).cz(l.rectangleLocationsDrawMode, 0, l.rectangleLocationsDrawLength, L), A = !0, a.bindBuffer(a.ARRAY_BUFFER, null);
          }
        }));
      })), A;
    })), t !== 1 && this.mj.forEach(((p) => {
      p.VY || (p.VY = this.TY.VY), p.NY || (p.NY = [this.TY.NY.x, this.TY.NY.y, this.TY.NY.z]), p.GY || (p.GY = [this.TY.NY.x, this.TY.NY.y, this.TY.NY.z]), p.Uh(!0), p.Ec(t, 0);
    })), { idCount: this.Ga.columns * this.Ga.rows };
  }
  wi() {
    return this.zx.wi();
  }
  IH() {
    return this.mj.forEach(((t) => t.dispose())), this.mj.length = 0, this;
  }
  dispose() {
    return super.dispose(), this.zx.dispose(), this.PH && (this.PH.gridTileSizes.forEach(((t) => {
    })), this.PH.gridTiles.forEach(((t) => {
      this.WD.JD(t.heightmapDataTexture), t.normalmapTexture && this.WD.JD(t.normalmapTexture);
    })), this.WD.LO(this.PH.rectangleLocationsBuffer), this.PH = void 0), this.IH(), this.ON = {}, this;
  }
  Rc() {
    return this.dispose(), this.zx.Rc(), this;
  }
  Op(t) {
    return this.zx.Op(t), this;
  }
  zp(t) {
    this.SH.push(t), Tx(this._H.gridTiles, t, ((e) => e.heightmapData), ((e, i) => {
      e.heightmapData = i;
    }));
    for (let e = t.startPrimary; e < t.startPrimary + t.lengthPrimary; e += 1) this.MH[e] = void 0;
    return this.bH = void 0, this;
  }
  Ep(t) {
    return this.oj.C(t), this;
  }
  Rp() {
    return this.oj.T();
  }
  sr(t) {
    return this.Ke = ba(this.Ke, t), this.zx.sr(this.Ke), this;
  }
  kh() {
    return this.Ke;
  }
  Cp(t) {
    return this.kp = typeof t == "function" ? t(this.kp) : t, this;
  }
  Dp() {
    return this.kp;
  }
  Wi() {
    var t;
    return ((t = this.Bj) === null || t === void 0 ? void 0 : t.FH.max.x) || 0;
  }
  Hi() {
    var t;
    return ((t = this.Bj) === null || t === void 0 ? void 0 : t.FH.min.x) || 0;
  }
  Zi() {
    const t = this.bH || this.DH();
    return this.bH = t, t.max;
  }
  Xi() {
    const t = this.bH || this.DH();
    return this.bH = t, t.min;
  }
  be() {
    var t;
    return ((t = this.Bj) === null || t === void 0 ? void 0 : t.FH.max.z) || 0;
  }
  Se() {
    var t;
    return ((t = this.Bj) === null || t === void 0 ? void 0 : t.FH.min.z) || 0;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
  Rv() {
    return 0;
  }
  DH() {
    if (this.bH) return this.bH;
    const t = this.TH ? this.TH.fill.iFirstPrimary : 0, e = this.TH ? t + this.TH.fill.amountPrimary - 1 : this.Ga.primaryDimensionVectorsCount - 1;
    let i = wt, s = Pt;
    return this._H.gridTiles.forEach(((o) => {
      for (let n = Math.max(t, o.iFirstUniqueVector.primary); n <= Math.min(e, o.iFirstUniqueVector.primary + o.sizeUniqueHeatmapDataVectors.primary - 1); n += 1) {
        const a = (n - o.iFirstUniqueVector.primary) * o.sizeHeatmapDataVectors.secondary;
        let l = this.MH[n];
        if (l) i = i < l.min ? i : l.min, s = s > l.max ? s : l.max;
        else {
          l = { min: wt, max: Pt }, this.MH[n] = l;
          for (let h = 0; h < o.sizeHeatmapDataVectors.secondary; h += 1) {
            const u = o.heightmapData[a + h];
            i = i < u ? i : u, s = s > u ? s : u, l.min = Math.min(l.min, u), l.max = Math.max(l.max, u);
          }
        }
      }
    })), this.bH = { min: i, max: s }, this.bH;
  }
}
class bC extends zo {
  constructor(t, e, i, s) {
    super(t, e, i), this.CY = "disabled", this.Uj = 0, this.Yj = {}, this.EH = /* @__PURE__ */ new Map(), this.Wt = { x: 0, z: 0 }, this.uj = { x: 1, z: 1 }, this.Ga = { ...s, scrollDimensionSize: s.scrollDimension === "columns" ? s.columns : s.rows, staticDimensionSize: s.scrollDimension === "columns" ? s.rows : s.columns }, this.FH = { min: { x: this.Wt.x, z: this.Wt.z }, max: { x: s.scrollDimension === "rows" ? this.Wt.x + (s.columns - 1) * this.uj.x : this.Wt.x, z: s.scrollDimension === "columns" ? this.Wt.z + (s.rows - 1) * this.uj.z : this.Wt.z } };
    const o = () => ({ shape: new a1(this.TY, ie, this.mi, { columns: s.columns + (s.scrollDimension === "columns" ? 1 : 0), rows: s.rows + (s.scrollDimension === "rows" ? 1 : 0), dataOrder: s.scrollDimension, heatmapDataType: "intensity" }).setVisible(!1), hasData: !1 });
    this.Wx = [o(), o()];
  }
  Uh(t) {
    this.Wx.forEach(((s) => {
      s.shape.Uh(t);
    }));
    const e = this.Wx.reduce(((s, o) => {
      var n, a;
      return s.min = Math.min(s.min, $e((n = o.shape.zx.Mj) === null || n === void 0 ? void 0 : n.min, wt)), s.max = Math.max(s.max, $e((a = o.shape.zx.Mj) === null || a === void 0 ? void 0 : a.max, Pt)), s;
    }), { min: wt, max: Pt }), i = this.Wx.reduce(((s, o) => {
      var n, a;
      return s.min = Math.min(s.min, $e((n = o.shape.bH) === null || n === void 0 ? void 0 : n.min, wt)), s.max = Math.max(s.max, $e((a = o.shape.bH) === null || a === void 0 ? void 0 : a.max, Pt)), s;
    }), { min: wt, max: Pt });
    return this.Wx.forEach(((s) => {
      s.shape.zx.Mj = e, s.shape.bH = i;
    })), this;
  }
  Ec(t, e) {
    let i = 0, s = e;
    return this.Wx.forEach(((o) => {
      if (!o.hasData) return;
      o.shape.VY = this.VY, o.shape.NY = this.NY, o.shape.GY = this.GY;
      const { idCount: n } = o.shape.Ec(t, s);
      n !== void 0 && (t === 1 && this.EH.set(o, { idFirst: s, idCount: n }), i += n, s += n);
    })), { idCount: i };
  }
  Oc(t, e, i, s, o) {
    const n = Array.from(this.EH).find(((a) => Ii(t, a[1].idFirst, a[1].idFirst + a[1].idCount - 1)));
    return n ? n[0].shape.Oc(t, n[1].idFirst, n[1].idCount, s, o) : {};
  }
  Ip(t, e) {
    return this.Wt = t, this.uj = e, this.Wx.forEach(((i) => {
      i.shape.Ip(this.Ga.scrollDimension === "columns" ? { x: i.shape.Pp().start.x, z: this.Wt.z } : { x: this.Wt.x, z: i.shape.Pp().start.z }, this.uj);
    })), this.Ga.scrollDimension === "columns" ? (this.FH.min.z = t.z, this.FH.max.z = this.Wt.z + (this.Ga.rows - 1) * this.uj.z) : (this.FH.min.x = t.x, this.FH.max.x = this.Wt.x + (this.Ga.columns - 1) * this.uj.x), this;
  }
  Pp() {
    return { start: this.Wt, step: this.uj };
  }
  Vi() {
    return this.Uj = 0, this.Yj = {}, this.FH = { min: { x: this.Wt.x, z: this.Wt.z }, max: { x: this.Ga.scrollDimension === "rows" ? this.Wt.x + (this.Ga.columns - 1) * this.uj.x : this.Wt.x, z: this.Ga.scrollDimension === "columns" ? this.Wt.z + (this.Ga.rows - 1) * this.uj.z : this.Wt.z } }, this.Wx.forEach(((t) => {
      t.shape.setVisible(!1), t.shape.xH = !1, t.hasData = !1;
    })), this;
  }
  $p(t) {
    var e;
    const i = this.Wx[0], s = this.Wx[1], o = t.heightMapValues ? t.heightMapValues.length : (e = t.intensityValues) === null || e === void 0 ? void 0 : e.length;
    let n = 0;
    if (!o) return this;
    do {
      const a = Math.floor(this.Uj / this.Ga.scrollDimensionSize) % this.Wx.length, l = this.Wx[a], h = this.Uj % this.Ga.scrollDimensionSize, u = this.Ga.scrollDimensionSize - h, c = h === 0, d = Math.min(u, o), f = h + d, p = h, g = p + 1, y = n, m = n + d, A = this.Uj >= this.Ga.scrollDimensionSize && f <= this.Ga.scrollDimensionSize - 1, v = c;
      c && (l.shape.Ip(this.Ga.scrollDimension === "columns" ? { x: this.Wt.x + (this.Uj - 1) * this.uj.x, z: this.Wt.z } : { x: this.Wt.x, z: this.Wt.z + (this.Uj - 1) * this.uj.z }, this.uj), l.shape.setVisible(!0));
      const b = A ? 0 : 1, w = f + (A ? 1 : 0);
      l.shape.CH({ fill: { iFirstPrimary: b, amountPrimary: w }, wireframe: { iFirstPrimary: b, amountPrimary: w, connectNext: !1 } });
      const k = l === i ? s : i, R = f + 1, L = 1 + this.Ga.scrollDimensionSize - R;
      k.shape.CH({ fill: { iFirstPrimary: R, amountPrimary: L }, wireframe: { iFirstPrimary: R, amountPrimary: L - 1, connectNext: !0 } });
      const x = {};
      if (t.heightMapValues) {
        const M = t.heightMapValues.slice(y, m);
        let C = !1;
        v && this.Yj.yValues && (C = !0, M.splice(0, 0, this.Yj.yValues));
        const S = { startPrimary: C ? p : g, startSecondary: 0, lengthPrimary: M.length, lengthSecondary: this.Ga.staticDimensionSize, values: M, type: "y" };
        l.shape.zp(S), l.hasData = !0, x.yValues = Array.from(M[d - 1]);
      }
      if (t.intensityValues) {
        const M = t.intensityValues.slice(y, m);
        let C = !1;
        v && this.Yj.intensityValues && (C = !0, M.splice(0, 0, this.Yj.intensityValues));
        const S = { startPrimary: C ? p : g, startSecondary: 0, lengthPrimary: M.length, lengthSecondary: this.Ga.staticDimensionSize, values: M, type: "intensity" };
        l.shape.Op(S), l.hasData = !0, x.intensityValues = Array.from(M[d - 1]);
      }
      this.Uj += d, n += d, this.Yj = x;
    } while (n < o);
    return this.Ga.scrollDimension === "columns" ? (this.FH.min.x = this.Wt.x + Math.max(this.Uj - this.Ga.scrollDimensionSize, 0) * this.uj.x, this.FH.max.x = this.Wt.x + (this.Uj - 1) * this.uj.x) : (this.FH.min.z = this.Wt.z + Math.max(this.Uj - this.Ga.scrollDimensionSize, 0) * this.uj.z, this.FH.max.z = this.Wt.z + (this.Uj - 1) * this.uj.z), this;
  }
  Op(t) {
    var e;
    const { iSample: i, yValues: s, intensityValues: o } = t, n = s || o;
    if (!n) return this;
    const a = i, l = i + n.length - 1, h = n[0].length;
    this.Wx.forEach(((c, d) => {
      const f = Math.floor(this.Uj / this.Ga.scrollDimensionSize) % this.Wx.length, p = this.Uj % this.Ga.scrollDimensionSize;
      let g, y;
      if (d === f ? p === 0 ? (y = -1, g = -1) : (y = this.Uj - 1, g = y - p + 1) : (y = this.Uj - p - 1, g = y - this.Ga.scrollDimensionSize + 1), l < g || a > y) return;
      const m = Math.max(a, g), A = Math.min(l, y), v = A - m + 1, b = o && o.slice(m - a, A - a + 1), w = s && s.slice(m - a, A - a + 1), k = b && { type: "intensity", startSecondary: 0, lengthSecondary: h, startPrimary: m + 1, lengthPrimary: v, values: b }, R = w && { type: "y", startSecondary: 0, lengthSecondary: h, startPrimary: m + 1, lengthPrimary: v, values: w };
      k && c.shape.Op(k), R && c.shape.zp(R), A === this.Uj - 1 && (this.Yj = { yValues: w ? Array.from(w[w.length - 1]) : void 0, intensityValues: b ? Array.from(b[b.length - 1]) : void 0 });
    }));
    const u = this.Uj - 1;
    if (l > u) {
      const c = l - u, d = s && s.slice(-c).map(((g) => Array.isArray(g) ? g : Array.from(g))), f = o && o.slice(-c).map(((g) => Array.isArray(g) ? g : Array.from(g))), p = d ? d.length : (e = f?.length) !== null && e !== void 0 ? e : 0;
      if (p < c) {
        const g = this.Yj || new Array(h).fill(0);
        for (let y = p; y < c; y += 1) d && g.yValues && d.unshift(g.yValues), f && g.intensityValues && f.unshift(g.intensityValues);
      }
      this.$p({ heightMapValues: d, intensityValues: f, lengthPrimary: p, lengthSecondary: h });
    }
    return this;
  }
  jp() {
    return this.Uj;
  }
  Ep(t) {
    return this.Wx.forEach(((e) => e.shape.Ep(t))), this;
  }
  Rp() {
    return this.Wx[0].shape.Rp();
  }
  sr(t) {
    return this.Wx.forEach(((e) => e.shape.sr(t))), this;
  }
  kh() {
    return this.Wx[0].shape.kh();
  }
  Cp(t) {
    return this.Wx.forEach(((e) => e.shape.Cp(t))), this;
  }
  Dp() {
    return this.Wx[0].shape.Dp();
  }
  Rc() {
    return this.dispose(), this.Wx.forEach(((t) => t.shape.Rc())), this;
  }
  dispose() {
    return super.dispose(), this.Wx.forEach(((t) => t.shape.dispose())), this;
  }
  setVisible(t) {
    return super.setVisible(t), this.Wx.forEach(((e) => e.shape.setVisible(t && e.hasData))), this;
  }
  Lv(t) {
    return super.Lv(t), this.Wx.forEach(((e) => e.shape.Lv(t))), this;
  }
  Wi() {
    return this.FH.max.x;
  }
  Hi() {
    return this.FH.min.x;
  }
  Zi() {
    return Math.max(this.Wx[0].shape.Zi(), this.Wx[1].shape.Zi());
  }
  Xi() {
    return Math.min(this.Wx[0].shape.Xi(), this.Wx[1].shape.Xi());
  }
  be() {
    return this.FH.max.z;
  }
  Se() {
    return this.FH.min.z;
  }
  mu() {
    return 0;
  }
  Su() {
    return 0;
  }
  Rv() {
    return 0;
  }
  Ii(t) {
    return super.Ii(t), this.Wx.forEach(((e) => e.shape.Ii(t))), this;
  }
}
class EC extends i1 {
  constructor(t, e, i, s) {
    super(t, e, i), this.NY = Ht(0, 0, 1), this.RH = Ht(0, 0, -1), this.OH = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1], this._v = new Pf(), this.ai = s;
  }
  Jm() {
    const { cellIndex: t, cellSpan: e, cellsAmount: i } = this.ai, s = e.x / i.x, o = e.y / i.y, n = t.x / i.x, a = t.y / i.y, l = this.yi.Ft();
    return { x: n * l.x, y: a * l.y, width: s * l.x, height: o * l.y };
  }
  setCameraLocation(t) {
    return this.NY = t, this;
  }
  getCameraLocation() {
    return this.NY;
  }
  setCameraDirection(t) {
    return this.RH = gt.normalize(t), this;
  }
  getCameraDirection() {
    return this.RH;
  }
  setLightLocation(t) {
    return this.GY = t, this;
  }
  getLightLocation() {
    return this.GY;
  }
  zH() {
    return Ht(this.OH[0], this.OH[1], this.OH[2]);
  }
  VH() {
    return Ht(this.OH[4], this.OH[5], this.OH[6]);
  }
}
class Ip extends EC {
  constructor(t, e, i, s) {
    super(t, e, i, s), this.SE = new PM(), this.NH = !0, this.GH = () => {
      this.NH = !0;
    }, this.$H = "perspective", this._V = t, this.gl = t.kV(), this.bY = this.Ei, this.yi.O("resize", this.GH), s.addEventListener("cellresize", this.GH);
  }
  vO(t) {
    const e = t.Hi(), i = t.Xi(), s = t.Se(), o = t.Wi(), n = t.Zi(), a = t.be();
    if (e === wt || o === Pt || i === wt || n === Pt || s === wt || a === Pt) return Ie;
    const l = t.mu(), h = t.Su(), u = t.Rv(), c = Math.abs(t.Js.Sy(l) * t.ai.x.et()), d = Math.abs(t.Js.Sy(h) * t.ai.y.et()), f = Math.abs(t.Js.Sy(u) * t.ai.z.et()), p = e - c, g = o + c, y = i - d, m = n + d, A = s - f, v = a + f;
    let b;
    return [{ x: p, y, z: A }, { x: g, y, z: A }, { x: p, y: m, z: A }, { x: g, y: m, z: A }, { x: p, y, z: v }, { x: g, y, z: v }, { x: p, y: m, z: v }, { x: g, y: m, z: v }].map(((w) => t.Js.xy(w))).forEach(((w) => {
      if (!w) return;
      b = b ? Qs(b, { min: w, max: w }) : { min: w, max: w };
    })), b || Ie;
  }
  xy(t) {
    if (this.UH(), this.jH(), !this.VY) return;
    const e = this.SE.kO(), i = Ht(e[0], e[1], e[2]), s = this.SE.wO(), o = Ht(s[0], s[1], s[2]);
    let n;
    if (this.ai.x.Y) {
      const c = gt.subtractVec(t, this.SE.mV());
      n = gt.divideVec(gt.subtractVec(c, i), o);
    } else n = gt.divideVec(gt.subtractVec(t, i), o);
    const a = this.VY, l = xe.multiply(a, [n.x, n.y, n.z, 1]), h = j(l[0] / l[3], l[1] / l[3]), u = this.yi.Ft();
    return { x: 0.5 * (1 + h.x) * u.x, y: 0.5 * (1 + h.y) * u.y };
  }
  _S(t) {
    const e = this.SE.kO(), i = Ht(e[0], e[1], e[2]), s = this.SE.wO(), o = Ht(s[0], s[1], s[2]);
    let n;
    if (this.ai.x.Y) {
      const a = gt.subtractVec(t, this.SE.mV());
      n = gt.divideVec(gt.subtractVec(a, i), o);
    } else n = gt.divideVec(gt.subtractVec(t, i), o);
    return { ...t, x: n.x, y: n.y, z: n.z };
  }
  wS(t) {
    const e = this.SE.kO(), i = Ht(e[0], e[1], e[2]), s = this.SE.wO(), o = Ht(s[0], s[1], s[2]);
    let n;
    if (this.ai.x.Y) {
      const a = gt.addVec(gt.multiplyVec(t, o), i);
      n = gt.addVec(a, this.SE.mV());
    } else n = gt.addVec(gt.multiplyVec(t, o), i);
    return { ...t, x: n.x, y: n.y, z: n.z };
  }
  Sy(t) {
    return t / 1e3;
  }
  qY() {
    return 1e-3;
  }
  Uh() {
    const t = this.NY, e = this.GY, i = this.ai.x.u || this.ai.y.u || this.ai.z.u;
    if (!e) throw Js(0, (() => Bm()));
    const { viewProjectionMatrix: s } = this.UH();
    this.jH();
    const o = [t.x, t.y, t.z], n = [e.x, e.y, e.z];
    return this.Ei.forEach(((a) => {
      a.VY = s, a.NY = o, a.GY = n, a.Uh(i);
    })), this;
  }
  bS(t) {
    this.$H !== t && (this.$H = t, this.NH = !0);
  }
  xS() {
    return this.$H;
  }
  UH() {
    if (!this.NH && this.VY) return { viewProjectionMatrix: this.VY };
    const t = this.Jm(), e = t.width / t.height;
    if (this.$H === "perspective") this.YH = xe.projectionPerspective(45, e, 0.1, 100);
    else {
      let m, A;
      const v = 0.5 * gt.length(this.NY);
      e > 1 ? (m = v, A = m / e) : (A = v, m = A * e), this.YH = xe.projectionOrthographic(-m, m, -A, A, -400, 100);
    }
    const i = this.NY;
    this.OH[12] = i.x, this.OH[13] = i.y, this.OH[14] = i.z;
    const s = this.RH, o = Ht(0, 1, 0), n = gt.multiply(s, -1), a = gt.normalize(gt.cross(o, n)), l = gt.normalize(gt.cross(n, a));
    this.OH[0] = a.x, this.OH[1] = a.y, this.OH[2] = a.z, this.OH[4] = l.x, this.OH[5] = l.y, this.OH[6] = l.z, this.OH[8] = n.x, this.OH[9] = n.y, this.OH[10] = n.z, this.HH = xe.inverse(this.OH);
    const { cellIndex: h, cellSpan: u, cellsAmount: c } = this.ai, d = u.x / c.x, f = u.y / c.y, p = (h.x + u.x / 2) / c.x, g = (h.y + u.y / 2) / c.y, y = xe.multiply(xe.translation(tr(-1, 1, p), tr(-1, 1, g), 0), xe.scaling(d, f, 1));
    return this.VY = xe.multiply(y, xe.multiply(this.YH, this.HH)), this.WH = xe.inverse(this.VY), this.NH = !1, { viewProjectionMatrix: this.VY };
  }
  jH() {
    this.SE.AV(this.ai.x), this.SE.gV(this.ai.y), this.SE.vV(this.ai.z);
  }
  Ec(t, e, i) {
    var s;
    const o = this.gl.rO(), n = this.Jm(), a = { x: n.x * o * e, y: n.y * o * e, width: n.width * o * e, height: n.height * o * e };
    this.gl.yO(a.x, a.y, a.width, a.height);
    let l = (((s = i[i.length - 1]) === null || s === void 0 ? void 0 : s.idLast) || 0) + 1;
    const h = Array.from(this.bY.values());
    for (let u = 0; u < h.length; u += 1) {
      const c = h[u];
      if (c.getVisible()) {
        if (this.gl.uO(c.CY), this.gl.Bv(c.Cv), t !== 1) c.Ec(t, 0);
        else if (t === 1 && c.getPointerEvents()) {
          const { idCount: d } = c.Ec(t, l);
          d !== void 0 && (i.push({ entity: c, layer: this, entityIndex: u, idFirst: l, idCount: d, idLast: l + d - 1 }), l += d);
        }
      }
    }
    return this.gl.uO("disabled"), this.gl.Bv(!1), this.gl.cO(!1), this;
  }
  setCameraLocation(t) {
    return this.NY.x === t.x && this.NY.y === t.y && this.NY.z === t.z || (this.NH = !0), super.setCameraLocation(t), this;
  }
  setCameraDirection(t) {
    return this.RH.x === t.x && this.RH.y === t.y && this.RH.z === t.z || (this.NH = !0), super.setCameraDirection(t), this;
  }
  G() {
    super.G(), this.yi.N("resize", this.GH), this.ai.removeEventListener("cellresize", this.GH);
  }
  Vy(t) {
    return this.Xj(new SC(this, this.Zj, [], t));
  }
  Ay(t, e) {
    return this.Xj(new o1(this, this.Zj, t, e));
  }
  Nv() {
    return this.Xj(new fC(this, this.Zj, []));
  }
  im() {
    return this.Xj(new vC(this, this.Zj, []));
  }
  GA() {
    return this.Xj(new pC(this, this.Zj, []));
  }
  Tp(t) {
    return this.Xj(new a1(this, this.Zj, [], t));
  }
  Gp(t) {
    return this.Xj(new bC(this, this.Zj, [], t));
  }
}
class MC {
  constructor(t, e) {
    this.XH = [], this.ZH = [], this.JH = (i, s) => {
      const o = this.XH.find(((n) => n.Tc === i));
      o && (s.type !== "pointerenter" && s.type !== "pointermove" || this.yi.Ja(o, !0, s.timeStamp), s.type === "pointerleave" && this.yi.Ja(o, !1, s.timeStamp));
    }, this.yi = t, this.Lc = "init" in e ? e.init({ engine: t.qg, handleEvent: this.JH }) : e, this.QH = 0, this.KH = String(Math.round(1e6 * Math.random()));
  }
  In(t, e, i, s) {
    const o = new lx(t, e, i, s, `${this.KH}-${this.QH}`);
    return this.XH.push(o), o.addEventListener("dispose", (() => {
      var n;
      const a = this.XH.indexOf(o);
      a >= 0 && this.XH.splice(a, 1), ((n = this.yi.Qa) === null || n === void 0 ? void 0 : n.entity) === o && this.yi.Ja(void 0, !1, H.performance.now());
    })), this.QH += 1, o;
  }
  ea() {
    const t = this.XH.filter(((i) => i.getVisible() && i.an().length > 0 && de(i.Ke))).map(((i) => i.Fc())), e = this.ZH;
    this.Lc.update({ textList: t, engine: this.yi.qg, obstructingOverlays: e }), this.ZH.length = 0;
  }
  G() {
    const t = this.XH.filter(((e) => e.getVisible() && e.an().length > 0 && de(e.Ke))).map(((e) => e.Fc()));
    this.Lc.dispose && this.Lc.dispose({ textList: t, engine: this.yi.qg });
  }
  XA(t) {
    this.ZH.push(t);
  }
}
class CC extends wb {
  constructor(t, e, i, s = FM) {
    if (super(t, e, i), this.j = Kn(1, 1), this.qH = !1, this.tW = 0, this.iW = !0, this.sW = 0, this.KY = 8388608, this.hR = [null, null], this.eW = null, this.rW = null, this.hW = 0, this.Hg = !1, this.nW = 0, this.Rs = (m = !1) => (this.ci || this.pa || lu(this.WD.gl) || (m && (this.qH = !0), this.da = !0, this.oW || this.oa.mR(m)), this), this.oW = !1, this._R = (m) => {
      if (this.ci || this.pa || this.aW && (this.aW.unpauseDuringResize !== !0 || !this.lW)) return;
      const A = m - this.tW;
      if (A >= this.Wa || this.Wa === -1) {
        this.oW = !0, this.tW = m, this.qH = !1;
        const v = A > 50 ? 1e3 / 60 : A;
        this.fa && this.fa(v), this.ks.Uh(A), this.Pa(), this.La(), this.da = !1, this.Wa !== -1 && this.qH && (this.oa.mR(this.qH), this.da = !0), this.Aa && this.Aa(), this.oW = !1;
        const b = this.ma.size > 0;
        this.D.R("renderframe", { asyncRenderingPending: b }), this.da && this.Rs(this.qH);
      } else this.da = !0, this.oa.mR();
    }, this.uW = /* @__PURE__ */ new Map(), this.kV = () => this.WD, this.cW = () => {
      var m, A;
      const v = this.Ra(), b = this.iW, w = H.performance.now(), k = (m = this.dW) === null || m === void 0 ? void 0 : m.fW.reduce(((M, C) => M ? C.AW && M.AW && C.AW > M.AW ? C : M : C), void 0), R = k?.AW, L = (A = this.Ma) === null || A === void 0 ? void 0 : A.timeStamp, x = this.gW;
      return b ? (this.Rs(!0), !1) : k === void 0 || (k === void 0 || !k.vW) && (R !== void 0 && v === void 0 ? w - R >= 1e3 : !(R !== void 0 && L !== void 0 && w - L >= 2e3 && (x === void 0 || w - x >= 2e3)) || w - R >= 1e3);
    }, this.yW = () => {
      var m, A;
      this.pW = void 0;
      const v = (A = (m = this.dW) === null || m === void 0 ? void 0 : m.mW) === null || A === void 0 ? void 0 : A.SW;
      v === void 0 || v >= this.sW || this.bW();
    }, this.La = () => {
      if (this.ci || this.pa) return this;
      const m = this.WD.gl, A = H.performance.now();
      this.WD.AO(m.FRAMEBUFFER, this.oa.fR ? this.hR[0] : null);
      const v = this.j, b = v.x > 0 && v.y > 0, w = this.WD.rO();
      if (this.Ta.u && this.WD.Az(this.Ta.T()), this.oa.cR && this.tR && (this.tR.canvas.width = v.x * w, this.tR.canvas.height = v.y * w), m.resize && b && m.resize(v.x * w, v.y * w), this.WD.gO(0, 0, v.x * w, v.y * w), this.WD.yO(0, 0, v.x * w, v.y * w), this.lW = !1, this.WD.Vi(), b) for (const k of this.la.values()) k.Ec(0, 1, []);
      if (this.Pc && this.Pc.ea(), this.Ga.ja && b && (this.pW && (H.clearTimeout(this.pW), this.pW = void 0), this.cW() ? (this.bW(), this.WD.AO(m.FRAMEBUFFER, this.oa.fR ? this.hR[0] : null)) : this.pW = H.setTimeout(this.yW, 500)), this.W(), this.ha(), Array.from(this.ba.values()).forEach(((k) => {
        k.lastEvent.isLcjsArtificialEvent = !0, this.xa("pointermove", k.lastEvent);
      })), this.oa.fR) {
        const k = this.WD.gl2.ctx;
        k.bindFramebuffer(k.READ_FRAMEBUFFER, this.hR[0]), k.bindFramebuffer(k.DRAW_FRAMEBUFFER, this.hR[1]), k.clearBufferfv(k.COLOR, 0, [1, 1, 1, 1]), k.blitFramebuffer(0, 0, this.j.x * w, this.j.y * w, 0, 0, this.j.x * w, this.j.y * w, m.COLOR_BUFFER_BIT, m.LINEAR);
      } else m.bindTexture(m.TEXTURE_2D, this.qE), m.copyTexImage2D(m.TEXTURE_2D, 0, m.RGBA, 0, 0, this.j.x * w, this.j.y * w, 0), m.bindTexture(m.TEXTURE_2D, null);
      return this.WD.AO(m.FRAMEBUFFER, null), lu(this.WD.gl) ? this.oa.QE(0, 0, this.j.x * w, this.j.y * w, [this]) : this.oa.mR(), this.iW = !1, this.sW = A, this;
    }, this.Pa = () => {
      if (this.xW.mode === "use-window") {
        const A = H.devicePixelRatio || 1;
        this.WD.Cz(A);
      }
      const m = this.j;
      if (m.x === 0 || m.y === 0) return this;
      this.rl.K(m);
      for (const A of this.la.values()) A.Uh();
      return this.W(), this;
    }, this.lW = !0, this.oa = t, this.oa.cR) {
      this.MW = H.document.createElement("canvas"), this.MW.style.width = "100%", this.MW.style.height = "100%", this.MW.style.display = "block", this.MW.style.boxSizing = "content-box", this.MW.style.position = "absolute";
      const m = this.MW.getContext("2d", { willReadFrequently: !1, alpha: !0, desynchronized: !1 });
      if (!m) throw new pi("No Canvas context available.");
      this.tR = m, this.Un.appendChild(this.MW);
    }
    this.oa.CR(this);
    const o = { antialias: e ? e.antialias : void 0, lineAntialias: !e || (e.lineAntiAlias === !0 || e.lineAntiAlias === !1 ? e.lineAntiAlias : e.antialias !== !1) };
    let n;
    if (this.oa.fR && t.gl2 && (n = new s(this, this.Ga, { type: "webgl2", ctx: t.gl2.ctx, antialias: o.antialias, lineAntialias: o.lineAntialias }, this.xi.isDark)), n || this.oa.fR || (n = new s(this, this.Ga, { type: "webgl1", ctx: t.gl, antialias: o.antialias, lineAntialias: o.lineAntialias }, this.xi.isDark)), !n) throw new pi("No WebGL context available");
    if (this.WD = n, typeof e?.devicePixelRatio == "number") this.xW = { mode: "fixed", value: e.devicePixelRatio }, this.WD.Cz(e.devicePixelRatio);
    else {
      const m = H.document.head.querySelector('meta[name="viewport"]'), A = e.devicePixelRatio === !0 || m?.content.includes("width=device-width"), v = H.devicePixelRatio || 1;
      this.xW = A ? { mode: "use-window" } : { mode: "fixed", value: v }, this.WD.Cz(v);
    }
    const a = e ? e.width : void 0, l = e ? e.height : void 0;
    this.il = this._W(a), this.el = this._W(l), this.wW(this.il, this.el), this.Hj = this.kB("engine offscreen", 1e6), this.kW = this.kB("engine bg", 0);
    const h = typeof this.xi.lcjsBackgroundFillStyle == "function" ? Pm({ resourcesBaseUrl: this.Ga.xe, styleFactory: this.xi.lcjsBackgroundFillStyle, apply: (m) => this.setBackgroundFillStyle(m) }) : this.xi.lcjsBackgroundFillStyle;
    this.rl = this.kW.er(this.ai).sr(h).ir(this.xi.lcjsBackgroundStrokeStyle).setPointerEvents(!1).hr({ x: 0, y: 0 });
    const u = this.kB("engine effects", 200001).xY(this.xi.effect);
    this.bs = u;
    const c = this.oa.fR, d = this.Ft();
    c && (this.hR = [n.EO(), n.EO()]);
    const f = this.WD.gl;
    c && (this.eW = f.createRenderbuffer(), this.rW = f.createRenderbuffer()), this.qE = f.createTexture();
    const p = d.x * this.WD.rO(), g = d.y * this.WD.rO();
    if (c) {
      f.bindRenderbuffer(f.RENDERBUFFER, this.eW);
      const m = this.WD.gl2.ctx;
      this.hW = this.oa.jE && e.antialias !== !1 ? m.getParameter(m.MAX_SAMPLES) : 0, m.renderbufferStorageMultisample(m.RENDERBUFFER, this.hW, m.RGBA8, p, g), f.bindRenderbuffer(f.RENDERBUFFER, this.rW), m.renderbufferStorageMultisample(m.RENDERBUFFER, this.hW, m.DEPTH24_STENCIL8, p, g);
    }
    c && (this.WD.AO(f.FRAMEBUFFER, this.hR[0]), f.framebufferRenderbuffer(f.FRAMEBUFFER, f.COLOR_ATTACHMENT0, f.RENDERBUFFER, this.eW), f.framebufferRenderbuffer(f.FRAMEBUFFER, f.DEPTH_STENCIL_ATTACHMENT, f.RENDERBUFFER, this.rW)), f.bindTexture(f.TEXTURE_2D, this.qE), f.texImage2D(f.TEXTURE_2D, 0, f.RGBA, p, g, 0, f.RGBA, f.UNSIGNED_BYTE, null), f.texParameteri(f.TEXTURE_2D, f.TEXTURE_MIN_FILTER, f.LINEAR), f.texParameteri(f.TEXTURE_2D, f.TEXTURE_WRAP_S, f.CLAMP_TO_EDGE), f.texParameteri(f.TEXTURE_2D, f.TEXTURE_WRAP_T, f.CLAMP_TO_EDGE), c && (this.WD.AO(f.FRAMEBUFFER, this.hR[1]), f.framebufferTexture2D(f.FRAMEBUFFER, f.COLOR_ATTACHMENT0, f.TEXTURE_2D, this.qE, 0)), this.WD.AO(f.FRAMEBUFFER, null), this.ka(), this.ha(), this.qg = Cb(this), this.Dc = { xi: this.xi, uv: (m, A) => this.uv(m, A), ks: this.ks, ai: this.ai, Rs: (m) => this.Rs(m), Gw: () => this.da, Ra: () => this.Ra(), Ds: (m) => (this.gW = H.performance.now(), this.Ds({ x: m.clientX, y: m.clientY })), YF: (m) => this.YF(m), Ga: this.Ga, Oa: (m) => this.Oa(m), bs: this.bs, ul: (m) => this.ul(m), cl: (m) => this.cl(m), rh: { Pr: (m, A, v) => {
      const b = this.WD.Fh(A.family).nE(m, A, v, this.xi.isDark);
      return this.Pc ? { x: b.x, y: b.y, isEstimate: !1 } : b;
    } }, Ys: () => this.ba.size > 0, Hs: (m, A) => Array.from(this.ba.values()).find(((v) => !(m !== void 0 && v.entity !== m || A !== void 0 && A !== v.collectionMember))) !== void 0 }, e.textRenderer && (this.Pc = new MC(this, e.textRenderer));
    const y = () => {
      this.G();
    };
    H.addEventListener("unload", y), this.ga.push((() => {
      H.removeEventListener("unload", y);
    }));
  }
  get TW() {
    return this.la;
  }
  uv(t, e) {
    return this.aW = t ? e ?? {} : void 0, this.aW || this.Rs(!0), this;
  }
  aa(t, e) {
    let i = this.uW.get(t);
    if (!i) {
      const o = this.WD.Bz(t), n = /* @__PURE__ */ new Set(), a = (u) => {
        n.add(u);
      }, l = (u) => {
        n.delete(u) && n.size === 0 && (o.unbindResources(), this.uW.delete(t));
      }, h = [];
      i = { imageTexture: o, instances: n, handleNewInstance: a, handleInstanceDisposed: l, sharedEngineReference: { HF: () => o.HR, WF: (u) => {
        o.HR ? u() : h.push(u);
      } } }, this.uW.set(t, i), o.pd(this), o.qR((() => {
        h.forEach(((u) => {
          u();
        })), h.length = 0;
      }));
    }
    const s = new _A(t, i.handleNewInstance, i.handleInstanceDisposed, e);
    return i.handleNewInstance(s), s;
  }
  YF(t) {
    const e = Array.from(this.uW.values()).find(((i) => i.instances.has(t)));
    if (!e) throw Js(0, (() => new Error("LightningChart JS error, attempted to use Icon that is disposed. Please check that you are not disposing an Icon that is still in use, or attempting to use a previously disposed Icon!")));
    return e.sharedEngineReference;
  }
  Ds(t) {
    var e;
    if (this.Qa && this.Qa.entity.getPointerEvents()) {
      if (this.Qa.pointed || !(H.performance.now() - this.Qa.timestamp >= 50)) return { entity: this.Qa.entity, collectionMember: void 0, info: void 0 };
      this.Qa = void 0;
    }
    const i = (e = this.dW) === null || e === void 0 ? void 0 : e.mW;
    if (!i) return;
    (!this.wa || H.performance.now() - this.wa > 100) && this.ha();
    const s = this.lr(t.x, t.y), o = Math.round(s.x * this.WD.rO()), n = Math.round(s.y * this.WD.rO());
    return [[-1, -1], [-1, 0], [-1, 1], [0, 1], [1, 1], [1, 0], [1, -1], [0, -1], [0, 0]].map(((a) => this.FW(i, o + a[0] / i.IW, n + a[1] / i.IW))).reduce(((a, l) => {
      if (l === void 0) return a || void 0;
      const h = 1e6 * l.layerIndex + l.entityIndex;
      return !a || h > a.zIndexForComparison ? { zIndexForComparison: h, entity: l.entity, collectionMember: l.collectionMember, info: l.info } : a;
    }), void 0);
  }
  FW(t, e, i) {
    const s = Math.round(e * t.IW), o = Math.round(i * t.IW);
    if (s < 0 || s >= t.j.x || o < 0 || o >= t.j.y) return;
    const n = 4 * (s + o * t.j.x), a = t.PW[n + 0], l = t.PW[n + 1], h = t.PW[n + 2], u = t.PW[n + 3];
    if (a === void 0 || l === void 0 || h === void 0 || u === void 0 || a === 0 && l === 0 && h === 0 && u === 0) return;
    const c = 16777216 * a + 65536 * l + 256 * h + u, d = t.LW.find(((g) => c >= g.idFirst && c <= g.idLast));
    if (!d) return;
    const { collectionMember: f, info: p } = d.entity.Oc(c, d.idFirst, d.idCount, e, i);
    return { entity: d.entity, collectionMember: f, entityIndex: d.entityIndex, layerIndex: d.layer.Da(), info: p };
  }
  sa(t, e, i, s = 1) {
    const o = s !== 1, n = this.WD.gl;
    let a, l = !this.oa.fR || o || !this.Hg;
    if (this.Pc) {
      const A = this.Pc;
      this.Pc = void 0;
      const v = [], b = [];
      this.la.forEach(((w) => {
        w.Ei.forEach(((k) => {
          k.getVisible() && k instanceof lx && b.push(k);
        }));
      })), b.forEach(((w) => {
        const k = w.Js.In(w.ai);
        v.push(k), k.hr(w.Xl()).rn(w.an()).Ih(w.Fh()).sr(w.kh()).ru(w.iu()).Tn(w.hu()).Fn(w.nu()).Ph(w.Lh()).en(w.Jl()).vl(w.yl()).setPointerEvents(!1);
      })), a = { ctr: A, temporaryWebglTextObjects: v }, l = !0;
    }
    const h = this.j;
    o && this.ka({ x: h.x * s, y: h.y * s }), l && (o && this.fa && this.fa(0), this.Pa(), this.La()), this.oa.fR ? (this.WD.AO(n.FRAMEBUFFER, this.hR[1]), n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, this.qE, 0)) : this.WD.AO(n.FRAMEBUFFER, null);
    const u = this.KE(), c = u.x, d = u.y, f = new Uint8Array(c * d * 4);
    n.readPixels(0, 0, c, d, n.RGBA, n.UNSIGNED_BYTE, f), a && (a.temporaryWebglTextObjects.forEach(((A) => A.dispose())), this.Pc = a.ctr, this.La());
    const p = new ImageData(new Uint8ClampedArray(f), c, d), g = document.createElement("canvas"), y = g.getContext("2d");
    if (!y) throw new Error("Failed to create 2D context for saving image.");
    g.width = c, g.height = d, y.putImageData(p, 0, 0), y.translate(0, d), y.scale(1, -1), y.drawImage(g, 0, 0), this.oa.fR && (this.WD.AO(n.FRAMEBUFFER, this.hR[0]), n.framebufferRenderbuffer(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.RENDERBUFFER, this.eW), this.WD.AO(n.FRAMEBUFFER, this.hR[1]), n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, this.qE, 0)), this.WD.AO(n.FRAMEBUFFER, null);
    const m = g.toDataURL(t, e);
    return o && this.ka(h), i ? m : ((A) => {
      const v = A.split(",")[0].split(":")[1].split(";")[0], b = H.atob(A.split(",")[1]), w = new Uint8Array(b.length);
      for (let k = 0; k < b.length; k += 1) w[k] = b.charCodeAt(k);
      return new H.Blob([w.buffer], { type: v });
    })(m);
  }
  ea(t, e, i = !1) {
    this.ka(j(Math.round(t), Math.round(e))), this.Ia();
    const s = this.WD.gl.drawingBufferWidth, o = this.WD.gl.drawingBufferHeight, n = new Uint8Array(s * o * 4);
    if (this.WD.gl.readPixels(0, 0, s, o, this.WD.gl.RGBA, this.WD.gl.UNSIGNED_BYTE, n), !i) {
      const a = o / 2 | 0, l = 4 * s, h = new Uint8Array(4 * s);
      for (let u = 0; u < a; u += 1) {
        const c = u * l, d = (o - u - 1) * l;
        h.set(n.subarray(c, c + l)), n.copyWithin(c, d, d + l), n.set(h, d);
      }
    }
    return this.ca = { x: 0, y: e }, n;
  }
  tD(t) {
    return this.il !== void 0 ? this.il[0] = t : this.il = [t, void 0], this.Un.style.minWidth = `${this.il[0]}px`, this.ka(), this;
  }
  sD(t) {
    return this.il !== void 0 ? this.il[1] = t : this.il = [void 0, t], this.Un.style.maxWidth = `${this.il[1]}px`, this.ka(), this;
  }
  rD(t) {
    return this.el !== void 0 ? this.el[0] = t : this.el = [t, void 0], this.Un.style.minHeight = `${this.el[0]}px`, this.ka(), this;
  }
  nD(t) {
    return this.el !== void 0 ? this.el[1] = t : this.el = [void 0, t], this.Un.style.maxHeight = `${this.el[1]}px`, this.ka(), this;
  }
  wW(t, e) {
    return this.il = t, this.el = e, this.Un.style.minWidth = `${this.il[0]}px`, this.Un.style.maxWidth = `${this.il[1]}px`, this.Un.style.minHeight = `${this.el[0]}px`, this.Un.style.maxHeight = `${this.el[1]}px`, this.ka(), this;
  }
  JE(t) {
    return this.Hg !== t && (this.D.R("inviewchanged", { isInView: t }), this.Hg = t), this;
  }
  ZE() {
    return this.Hg;
  }
  TR(t) {
    this.nW = t;
  }
  kR() {
    return this.nW;
  }
  kB(t, e = this.ll()) {
    const i = this.al(e);
    if (i) {
      if (Js(0, (() => {
      })), !(i instanceof Rp)) throw new Error("Unexpected Engine Layer error");
      return i;
    }
    return this.Ba(new Rp(this, e, t));
  }
  FB(t, e, i) {
    const s = this.al(e);
    if (s) {
      if (Js(0, (() => {
      })), !(s instanceof Ip)) throw new Error("Unexpected Engine Layer error");
      return s;
    }
    return this.Ba(new Ip(this, e, t, i));
  }
  Ft() {
    return this.j;
  }
  KE() {
    const t = this.WD.rO();
    return { x: Math.round(this.j.x * t), y: Math.round(this.j.y * t) };
  }
  _W(t) {
    return t instanceof Array || (t = [t, t]), t;
  }
  BW() {
    return this.oa.iR;
  }
  DW() {
    return lu(this.WD.gl);
  }
  bW() {
    var t;
    const e = this.WD.gl, i = H.performance.now(), s = this.Ga.Ua, o = { x: Math.ceil(this.j.x * this.WD.rO() * s), y: Math.ceil(this.j.y * this.WD.rO() * s) };
    this.dW || (this.dW = { IW: s, EW: o, fW: [], mW: void 0 });
    let n = this.dW.fW.find(((d) => !d.vW)), a = !1;
    n || (a = !0, n = { vW: !1, j: o, Wz: e.createTexture(), RW: this.WD.EO(), rW: this.WD.RO(), OW: new Uint8Array(), AW: void 0 }, this.dW.fW.push(n));
    const l = n;
    (a || l.j.x !== o.x || l.j.y !== o.y) && (e.bindTexture(e.TEXTURE_2D, l.Wz), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, o.x, o.y, 0, e.RGBA, e.UNSIGNED_BYTE, null), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), this.WD.AO(e.FRAMEBUFFER, l.RW), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, l.Wz, 0), e.bindRenderbuffer(e.RENDERBUFFER, l.rW), e.renderbufferStorage(e.RENDERBUFFER, e.DEPTH_COMPONENT16, o.x, o.y), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.RENDERBUFFER, l.rW), l.OW = new Uint8Array(o.x * o.y * 4), l.j = o), l.vW = !0, l.AW = i, this.WD.AO(e.FRAMEBUFFER, l.RW), e.clearDepth(1), e.clearColor(0, 0, 0, 0), e.clear(e.COLOR_BUFFER_BIT | e.DEPTH_BUFFER_BIT), e.disable(e.BLEND), e.resize && e.resize(o.x, o.y), this.WD.gO(0, 0, o.x, o.y);
    const h = [];
    for (const d of this.la.values()) d.Ec(1, s, h);
    this.WD.AO(e.FRAMEBUFFER, null), e.bindTexture(e.TEXTURE_2D, null), e.bindRenderbuffer(e.RENDERBUFFER, null), e.enable(e.BLEND);
    const u = (t = this.WD.gl2) === null || t === void 0 ? void 0 : t.ctx, c = () => {
      if (this.dW) {
        const d = this.dW.mW;
        if (d && d.SW > i) return;
        this.dW.mW = { SW: i, IW: s, j: o, PW: l.OW, LW: h };
      }
    };
    u ? this.WD.Uz(u, l.RW, 0, 0, o.x, o.y, e.RGBA, e.UNSIGNED_BYTE, l.OW).then((() => {
      this.ci || (l.vW = !1, c());
    })).catch(((d) => {
      this.ci || (l.vW = !1, H.console.warn(`LightningChart JS mouse picking failed unexpectedly. This could mean that user interactions on charts are compromised.
Please report this issue to https://lightningchart.com/js-charts/docs/contact`));
    })) : (this.WD.jz(l.RW, 0, 0, o.x, o.y, e.RGBA, e.UNSIGNED_BYTE, l.OW), l.vW = !1, c());
  }
  ka(t) {
    const e = this.WD.rO();
    if (this.xW.mode === "use-window") {
      const a = H.devicePixelRatio || 1;
      this.WD.Cz(a);
    }
    const i = this.j.x, s = this.j.y, o = t || { x: this.Un.offsetWidth, y: this.Un.offsetHeight }, n = this.WD.rO();
    if (o.x !== 0 && o.y !== 0 && (o.x !== i || o.y !== s || e !== n)) {
      this.j = o, this.ai.x.Z(0, o.x).K(o.x), this.ai.y.Z(0, o.y).K(o.y);
      const a = o.x * n, l = o.y * n, h = this.WD.gl, u = this.oa.fR;
      if (this.qE && (h.bindTexture(h.TEXTURE_2D, this.qE), h.texImage2D(h.TEXTURE_2D, 0, h.RGBA, a, l, 0, h.RGBA, h.UNSIGNED_BYTE, null)), u) {
        const c = this.WD.gl2.ctx;
        this.eW && (h.bindRenderbuffer(h.RENDERBUFFER, this.eW), c.renderbufferStorageMultisample(c.RENDERBUFFER, this.hW, c.RGBA8, a, l)), this.rW && (h.bindRenderbuffer(h.RENDERBUFFER, this.rW), c.renderbufferStorageMultisample(c.RENDERBUFFER, this.hW, c.DEPTH24_STENCIL8, a, l));
      }
      h.bindRenderbuffer(h.RENDERBUFFER, null), this.D.R("resize", { engineWidth: this.j.x, engineHeight: this.j.y, width: this.j.x, height: this.j.y }), this.lW = !0;
    }
  }
  G() {
    var t;
    this.ci || (super.G(), this.Pc && this.Pc.G(), this.pW && (H.clearTimeout(this.pW), this.pW = void 0), Array.from(this.WD.DE.entries()).forEach((([e, i]) => {
      i.Rc(!1), this.WD.DE.delete(e);
    })), Array.from(this.WD.NO.values()).forEach(((e) => {
      e.unbindResources();
    })), this.WD.NO.clear(), this.WD.VO.GR(), this.WD.Mz.G(), this.WD.LO(this.WD._z), this.WD.LO(this.WD.wz), this.WD.mz.forEach(((e, i) => {
      this.WD.gl.deleteBuffer(i);
    })), this.WD.mz.clear(), this.WD.zz && (this.WD.LO(this.WD.zz.buffer), this.WD.zz = void 0), this.WD.zO(this.hR[0]), this.WD.zO(this.hR[1]), this.WD.OO(this.eW), this.WD.JD(this.qE), this.WD.OO(this.rW), this.dW && (this.dW.fW.forEach(((e) => {
      this.WD.OO(e.rW), this.WD.zO(e.RW), this.WD.JD(e.Wz);
    })), this.dW = void 0), this.WD.vz.forEach(((e) => this.WD.LO(e))), this.uW.clear(), this.oa.FR(this), this.MW && ((t = this.MW.parentElement) === null || t === void 0 || t.removeChild(this.MW), this.MW = void 0), this.tR && (this.tR = void 0), this.WD.gl = void 0);
  }
}
var uu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Rd = { exports: {} };
(function(r, t) {
  function e(x, M) {
    if (!x) throw new Error(M || "Assertion failed");
  }
  function i(x, M) {
    x.super_ = M;
    var C = function() {
    };
    C.prototype = M.prototype, x.prototype = new C(), x.prototype.constructor = x;
  }
  function s(x, M, C) {
    if (s.isBN(x)) return x;
    this.negative = 0, this.words = null, this.length = 0, this.red = null, x !== null && (M !== "le" && M !== "be" || (C = M, M = 10), this.KR(x || 0, M || 10, C || "be"));
  }
  var o;
  typeof Rd == "object" ? Rd.exports = s : t.BN = s, s.BN = s, s.wordSize = 26;
  try {
    o = (void 0).Buffer;
  } catch {
  }
  function n(x, M, C) {
    for (var S = 0, E = Math.min(x.length, C), T = 0, I = M; I < E; I++) {
      var F, D = x.charCodeAt(I) - 48;
      S <<= 4, S |= F = D >= 49 && D <= 54 ? D - 49 + 10 : D >= 17 && D <= 22 ? D - 17 + 10 : D, T |= F;
    }
    return e(!(240 & T), "Invalid character in " + x), S;
  }
  function a(x, M, C, S) {
    for (var E = 0, T = 0, I = Math.min(x.length, C), F = M; F < I; F++) {
      var D = x.charCodeAt(F) - 48;
      E *= S, T = D >= 49 ? D - 49 + 10 : D >= 17 ? D - 17 + 10 : D, e(D >= 0 && T < S, "Invalid character"), E += T;
    }
    return E;
  }
  function l(x, M) {
    x.words = M.words, x.length = M.length, x.negative = M.negative, x.red = M.red;
  }
  if (s.isBN = function(x) {
    return x instanceof s || x !== null && typeof x == "object" && x.constructor.wordSize === s.wordSize && Array.isArray(x.words);
  }, s.max = function(x, M) {
    return x.cmp(M) > 0 ? x : M;
  }, s.min = function(x, M) {
    return x.cmp(M) < 0 ? x : M;
  }, s.prototype.KR = function(x, M, C) {
    if (typeof x == "number") return this.zW(x, M, C);
    if (typeof x == "object") return this.VW(x, M, C);
    M === "hex" && (M = 16), e(M === (0 | M) && M >= 2 && M <= 36);
    var S = 0;
    (x = x.toString().replace(/\s+/g, ""))[0] === "-" && S++, M === 16 ? this.NW(x, S) : this.GW(x, M, S), x[0] === "-" && (this.negative = 1), this.$W(), C === "le" && this.VW(this.toArray(), M, C);
  }, s.prototype.zW = function(x, M, C) {
    x < 0 && (this.negative = 1, x = -x), x < 67108864 ? (this.words = [67108863 & x], this.length = 1) : x < 4503599627370496 ? (this.words = [67108863 & x, x / 67108864 & 67108863], this.length = 2) : (e(x < 9007199254740992), this.words = [67108863 & x, x / 67108864 & 67108863, 1], this.length = 3), C === "le" && this.VW(this.toArray(), M, C);
  }, s.prototype.VW = function(x, M, C) {
    if (e(typeof x.length == "number"), x.length <= 0) return this.words = [0], this.length = 1, this;
    this.length = Math.ceil(x.length / 3), this.words = new Array(this.length);
    for (var S = 0; S < this.length; S++) this.words[S] = 0;
    var E, T, I = 0;
    if (C === "be") for (S = x.length - 1, E = 0; S >= 0; S -= 3) T = x[S] | x[S - 1] << 8 | x[S - 2] << 16, this.words[E] |= T << I & 67108863, this.words[E + 1] = T >>> 26 - I & 67108863, (I += 24) >= 26 && (I -= 26, E++);
    else if (C === "le") for (S = 0, E = 0; S < x.length; S += 3) T = x[S] | x[S + 1] << 8 | x[S + 2] << 16, this.words[E] |= T << I & 67108863, this.words[E + 1] = T >>> 26 - I & 67108863, (I += 24) >= 26 && (I -= 26, E++);
    return this.$W();
  }, s.prototype.NW = function(x, M) {
    this.length = Math.ceil((x.length - M) / 6), this.words = new Array(this.length);
    for (var C = 0; C < this.length; C++) this.words[C] = 0;
    var S, E, T = 0;
    for (C = x.length - 6, S = 0; C >= M; C -= 6) E = n(x, C, C + 6), this.words[S] |= E << T & 67108863, this.words[S + 1] |= E >>> 26 - T & 4194303, (T += 24) >= 26 && (T -= 26, S++);
    C + 6 !== M && (E = n(x, M, C + 6), this.words[S] |= E << T & 67108863, this.words[S + 1] |= E >>> 26 - T & 4194303), this.$W();
  }, s.prototype.GW = function(x, M, C) {
    this.words = [0], this.length = 1;
    for (var S = 0, E = 1; E <= 67108863; E *= M) S++;
    S--, E = E / M | 0;
    for (var T = x.length - C, I = T % S, F = Math.min(T, T - I) + C, D = 0, P = C; P < F; P += S) D = a(x, P, P + S, M), this.imuln(E), this.words[0] + D < 67108864 ? this.words[0] += D : this.UW(D);
    if (I !== 0) {
      var V = 1;
      for (D = a(x, P, x.length, M), P = 0; P < I; P++) V *= M;
      this.imuln(V), this.words[0] + D < 67108864 ? this.words[0] += D : this.UW(D);
    }
  }, s.prototype.copy = function(x) {
    x.words = new Array(this.length);
    for (var M = 0; M < this.length; M++) x.words[M] = this.words[M];
    x.length = this.length, x.negative = this.negative, x.red = this.red;
  }, s.prototype.jW = function(x) {
    l(x, this);
  }, s.prototype.clone = function() {
    var x = new s(null);
    return this.copy(x), x;
  }, s.prototype.YW = function(x) {
    for (; this.length < x; ) this.words[this.length++] = 0;
    return this;
  }, s.prototype.$W = function() {
    for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
    return this.HW();
  }, s.prototype.HW = function() {
    return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
  }, typeof Symbol < "u" && typeof Symbol.for == "function") try {
    s.prototype[Symbol.for("nodejs.util.inspect.custom")] = h;
  } catch {
    s.prototype.inspect = h;
  }
  else s.prototype.inspect = h;
  function h() {
    return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
  }
  var u = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"], c = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5], d = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
  function f(x, M, C) {
    C.negative = M.negative ^ x.negative;
    var S = x.length + M.length | 0;
    C.length = S, S = S - 1 | 0;
    var E = 0 | x.words[0], T = 0 | M.words[0], I = E * T, F = 67108863 & I, D = I / 67108864 | 0;
    C.words[0] = F;
    for (var P = 1; P < S; P++) {
      for (var V = D >>> 26, _ = 67108863 & D, O = Math.min(P, M.length - 1), B = Math.max(0, P - x.length + 1); B <= O; B++) {
        var z = P - B | 0;
        V += (I = (E = 0 | x.words[z]) * (T = 0 | M.words[B]) + _) / 67108864 | 0, _ = 67108863 & I;
      }
      C.words[P] = 0 | _, D = 0 | V;
    }
    return D !== 0 ? C.words[P] = 0 | D : C.length--, C.$W();
  }
  s.prototype.toString = function(x, M) {
    var C;
    if (M = 0 | M || 1, (x = x || 10) === 16 || x === "hex") {
      C = "";
      for (var S = 0, E = 0, T = 0; T < this.length; T++) {
        var I = this.words[T], F = (16777215 & (I << S | E)).toString(16);
        C = (E = I >>> 24 - S & 16777215) != 0 || T !== this.length - 1 ? u[6 - F.length] + F + C : F + C, (S += 2) >= 26 && (S -= 26, T--);
      }
      for (E !== 0 && (C = E.toString(16) + C); C.length % M != 0; ) C = "0" + C;
      return this.negative !== 0 && (C = "-" + C), C;
    }
    if (x === (0 | x) && x >= 2 && x <= 36) {
      var D = c[x], P = d[x];
      C = "";
      var V = this.clone();
      for (V.negative = 0; !V.isZero(); ) {
        var _ = V.modrn(P).toString(x);
        C = (V = V.idivn(P)).isZero() ? _ + C : u[D - _.length] + _ + C;
      }
      for (this.isZero() && (C = "0" + C); C.length % M != 0; ) C = "0" + C;
      return this.negative !== 0 && (C = "-" + C), C;
    }
    e(!1, "Base should be between 2 and 36");
  }, s.prototype.toNumber = function() {
    var x = this.words[0];
    return this.length === 2 ? x += 67108864 * this.words[1] : this.length === 3 && this.words[2] === 1 ? x += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && e(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -x : x;
  }, s.prototype.toJSON = function() {
    return this.toString(16, 2);
  }, o && (s.prototype.toBuffer = function(x, M) {
    return this.toArrayLike(o, x, M);
  }), s.prototype.toArray = function(x, M) {
    return this.toArrayLike(Array, x, M);
  }, s.prototype.toArrayLike = function(x, M, C) {
    this.$W();
    var S = this.byteLength(), E = C || Math.max(1, S);
    e(S <= E, "byte array longer than desired length"), e(E > 0, "Requested array length <= 0");
    var T = (function(I, F) {
      return I.allocUnsafe ? I.allocUnsafe(F) : new I(F);
    })(x, E);
    return this["_toArrayLike" + (M === "le" ? "LE" : "BE")](T, S), T;
  }, s.prototype.WW = function(x, M) {
    for (var C = 0, S = 0, E = 0, T = 0; E < this.length; E++) {
      var I = this.words[E] << T | S;
      x[C++] = 255 & I, C < x.length && (x[C++] = I >> 8 & 255), C < x.length && (x[C++] = I >> 16 & 255), T === 6 ? (C < x.length && (x[C++] = I >> 24 & 255), S = 0, T = 0) : (S = I >>> 24, T += 2);
    }
    if (C < x.length) for (x[C++] = S; C < x.length; ) x[C++] = 0;
  }, s.prototype.XW = function(x, M) {
    for (var C = x.length - 1, S = 0, E = 0, T = 0; E < this.length; E++) {
      var I = this.words[E] << T | S;
      x[C--] = 255 & I, C >= 0 && (x[C--] = I >> 8 & 255), C >= 0 && (x[C--] = I >> 16 & 255), T === 6 ? (C >= 0 && (x[C--] = I >> 24 & 255), S = 0, T = 0) : (S = I >>> 24, T += 2);
    }
    if (C >= 0) for (x[C--] = S; C >= 0; ) x[C--] = 0;
  }, Math.clz32 ? s.prototype.ZW = function(x) {
    return 32 - Math.clz32(x);
  } : s.prototype.ZW = function(x) {
    var M = x, C = 0;
    return M >= 4096 && (C += 13, M >>>= 13), M >= 64 && (C += 7, M >>>= 7), M >= 8 && (C += 4, M >>>= 4), M >= 2 && (C += 2, M >>>= 2), C + M;
  }, s.prototype.JW = function(x) {
    if (x === 0) return 26;
    var M = x, C = 0;
    return 8191 & M || (C += 13, M >>>= 13), 127 & M || (C += 7, M >>>= 7), 15 & M || (C += 4, M >>>= 4), 3 & M || (C += 2, M >>>= 2), 1 & M || C++, C;
  }, s.prototype.bitLength = function() {
    var x = this.words[this.length - 1], M = this.ZW(x);
    return 26 * (this.length - 1) + M;
  }, s.prototype.zeroBits = function() {
    if (this.isZero()) return 0;
    for (var x = 0, M = 0; M < this.length; M++) {
      var C = this.JW(this.words[M]);
      if (x += C, C !== 26) break;
    }
    return x;
  }, s.prototype.byteLength = function() {
    return Math.ceil(this.bitLength() / 8);
  }, s.prototype.toTwos = function(x) {
    return this.negative !== 0 ? this.abs().inotn(x).iaddn(1) : this.clone();
  }, s.prototype.fromTwos = function(x) {
    return this.testn(x - 1) ? this.notn(x).iaddn(1).ineg() : this.clone();
  }, s.prototype.isNeg = function() {
    return this.negative !== 0;
  }, s.prototype.neg = function() {
    return this.clone().ineg();
  }, s.prototype.ineg = function() {
    return this.isZero() || (this.negative ^= 1), this;
  }, s.prototype.iuor = function(x) {
    for (; this.length < x.length; ) this.words[this.length++] = 0;
    for (var M = 0; M < x.length; M++) this.words[M] = this.words[M] | x.words[M];
    return this.$W();
  }, s.prototype.ior = function(x) {
    return e(!(this.negative | x.negative)), this.iuor(x);
  }, s.prototype.or = function(x) {
    return this.length > x.length ? this.clone().ior(x) : x.clone().ior(this);
  }, s.prototype.uor = function(x) {
    return this.length > x.length ? this.clone().iuor(x) : x.clone().iuor(this);
  }, s.prototype.iuand = function(x) {
    var M;
    M = this.length > x.length ? x : this;
    for (var C = 0; C < M.length; C++) this.words[C] = this.words[C] & x.words[C];
    return this.length = M.length, this.$W();
  }, s.prototype.iand = function(x) {
    return e(!(this.negative | x.negative)), this.iuand(x);
  }, s.prototype.and = function(x) {
    return this.length > x.length ? this.clone().iand(x) : x.clone().iand(this);
  }, s.prototype.uand = function(x) {
    return this.length > x.length ? this.clone().iuand(x) : x.clone().iuand(this);
  }, s.prototype.iuxor = function(x) {
    var M, C;
    this.length > x.length ? (M = this, C = x) : (M = x, C = this);
    for (var S = 0; S < C.length; S++) this.words[S] = M.words[S] ^ C.words[S];
    if (this !== M) for (; S < M.length; S++) this.words[S] = M.words[S];
    return this.length = M.length, this.$W();
  }, s.prototype.ixor = function(x) {
    return e(!(this.negative | x.negative)), this.iuxor(x);
  }, s.prototype.xor = function(x) {
    return this.length > x.length ? this.clone().ixor(x) : x.clone().ixor(this);
  }, s.prototype.uxor = function(x) {
    return this.length > x.length ? this.clone().iuxor(x) : x.clone().iuxor(this);
  }, s.prototype.inotn = function(x) {
    e(typeof x == "number" && x >= 0);
    var M = 0 | Math.ceil(x / 26), C = x % 26;
    this.YW(M), C > 0 && M--;
    for (var S = 0; S < M; S++) this.words[S] = 67108863 & ~this.words[S];
    return C > 0 && (this.words[S] = ~this.words[S] & 67108863 >> 26 - C), this.$W();
  }, s.prototype.notn = function(x) {
    return this.clone().inotn(x);
  }, s.prototype.setn = function(x, M) {
    e(typeof x == "number" && x >= 0);
    var C = x / 26 | 0, S = x % 26;
    return this.YW(C + 1), this.words[C] = M ? this.words[C] | 1 << S : this.words[C] & ~(1 << S), this.$W();
  }, s.prototype.iadd = function(x) {
    var M, C, S;
    if (this.negative !== 0 && x.negative === 0) return this.negative = 0, M = this.isub(x), this.negative ^= 1, this.HW();
    if (this.negative === 0 && x.negative !== 0) return x.negative = 0, M = this.isub(x), x.negative = 1, M.HW();
    this.length > x.length ? (C = this, S = x) : (C = x, S = this);
    for (var E = 0, T = 0; T < S.length; T++) M = (0 | C.words[T]) + (0 | S.words[T]) + E, this.words[T] = 67108863 & M, E = M >>> 26;
    for (; E !== 0 && T < C.length; T++) M = (0 | C.words[T]) + E, this.words[T] = 67108863 & M, E = M >>> 26;
    if (this.length = C.length, E !== 0) this.words[this.length] = E, this.length++;
    else if (C !== this) for (; T < C.length; T++) this.words[T] = C.words[T];
    return this;
  }, s.prototype.add = function(x) {
    var M;
    return x.negative !== 0 && this.negative === 0 ? (x.negative = 0, M = this.sub(x), x.negative ^= 1, M) : x.negative === 0 && this.negative !== 0 ? (this.negative = 0, M = x.sub(this), this.negative = 1, M) : this.length > x.length ? this.clone().iadd(x) : x.clone().iadd(this);
  }, s.prototype.isub = function(x) {
    if (x.negative !== 0) {
      x.negative = 0;
      var M = this.iadd(x);
      return x.negative = 1, M.HW();
    }
    if (this.negative !== 0) return this.negative = 0, this.iadd(x), this.negative = 1, this.HW();
    var C, S, E = this.cmp(x);
    if (E === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
    E > 0 ? (C = this, S = x) : (C = x, S = this);
    for (var T = 0, I = 0; I < S.length; I++) T = (M = (0 | C.words[I]) - (0 | S.words[I]) + T) >> 26, this.words[I] = 67108863 & M;
    for (; T !== 0 && I < C.length; I++) T = (M = (0 | C.words[I]) + T) >> 26, this.words[I] = 67108863 & M;
    if (T === 0 && I < C.length && C !== this) for (; I < C.length; I++) this.words[I] = C.words[I];
    return this.length = Math.max(this.length, I), C !== this && (this.negative = 1), this.$W();
  }, s.prototype.sub = function(x) {
    return this.clone().isub(x);
  };
  var p = function(x, M, C) {
    var S, E, T, I = x.words, F = M.words, D = C.words, P = 0, V = 0 | I[0], _ = 8191 & V, O = V >>> 13, B = 0 | I[1], z = 8191 & B, W = B >>> 13, G = 0 | I[2], Y = 8191 & G, U = G >>> 13, $ = 0 | I[3], Z = 8191 & $, q = $ >>> 13, Q = 0 | I[4], nt = 8191 & Q, et = Q >>> 13, it = 0 | I[5], rt = 8191 & it, tt = it >>> 13, at = 0 | I[6], ut = 8191 & at, ht = at >>> 13, st = 0 | I[7], bt = 8191 & st, ct = st >>> 13, Mt = 0 | I[8], vt = 8191 & Mt, mt = Mt >>> 13, Xt = 0 | I[9], Rt = 8191 & Xt, Dt = Xt >>> 13, Kt = 0 | F[0], _t = 8191 & Kt, Ut = Kt >>> 13, te = 0 | F[1], ye = 8191 & te, ne = te >>> 13, ti = 0 | F[2], fe = 8191 & ti, ve = ti >>> 13, ci = 0 | F[3], At = 8191 & ci, yt = ci >>> 13, ft = 0 | F[4], Tt = 8191 & ft, oe = ft >>> 13, vi = 0 | F[5], Te = 8191 & vi, Ze = vi >>> 13, ps = 0 | F[6], Fe = 8191 & ps, qe = ps >>> 13, rs = 0 | F[7], ii = 8191 & rs, Ge = rs >>> 13, vn = 0 | F[8], Bt = 8191 & vn, Wt = vn >>> 13, J = 0 | F[9], pt = 8191 & J, St = J >>> 13;
    C.negative = x.negative ^ M.negative, C.length = 19;
    var Ft = (P + (S = Math.imul(_, _t)) | 0) + ((8191 & (E = (E = Math.imul(_, Ut)) + Math.imul(O, _t) | 0)) << 13) | 0;
    P = ((T = Math.imul(O, Ut)) + (E >>> 13) | 0) + (Ft >>> 26) | 0, Ft &= 67108863, S = Math.imul(z, _t), E = (E = Math.imul(z, Ut)) + Math.imul(W, _t) | 0, T = Math.imul(W, Ut);
    var Qt = (P + (S = S + Math.imul(_, ye) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(_, ne) | 0) + Math.imul(O, ye) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(O, ne) | 0) + (E >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, S = Math.imul(Y, _t), E = (E = Math.imul(Y, Ut)) + Math.imul(U, _t) | 0, T = Math.imul(U, Ut), S = S + Math.imul(z, ye) | 0, E = (E = E + Math.imul(z, ne) | 0) + Math.imul(W, ye) | 0, T = T + Math.imul(W, ne) | 0;
    var Se = (P + (S = S + Math.imul(_, fe) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(_, ve) | 0) + Math.imul(O, fe) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(O, ve) | 0) + (E >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, S = Math.imul(Z, _t), E = (E = Math.imul(Z, Ut)) + Math.imul(q, _t) | 0, T = Math.imul(q, Ut), S = S + Math.imul(Y, ye) | 0, E = (E = E + Math.imul(Y, ne) | 0) + Math.imul(U, ye) | 0, T = T + Math.imul(U, ne) | 0, S = S + Math.imul(z, fe) | 0, E = (E = E + Math.imul(z, ve) | 0) + Math.imul(W, fe) | 0, T = T + Math.imul(W, ve) | 0;
    var ce = (P + (S = S + Math.imul(_, At) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(_, yt) | 0) + Math.imul(O, At) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(O, yt) | 0) + (E >>> 13) | 0) + (ce >>> 26) | 0, ce &= 67108863, S = Math.imul(nt, _t), E = (E = Math.imul(nt, Ut)) + Math.imul(et, _t) | 0, T = Math.imul(et, Ut), S = S + Math.imul(Z, ye) | 0, E = (E = E + Math.imul(Z, ne) | 0) + Math.imul(q, ye) | 0, T = T + Math.imul(q, ne) | 0, S = S + Math.imul(Y, fe) | 0, E = (E = E + Math.imul(Y, ve) | 0) + Math.imul(U, fe) | 0, T = T + Math.imul(U, ve) | 0, S = S + Math.imul(z, At) | 0, E = (E = E + Math.imul(z, yt) | 0) + Math.imul(W, At) | 0, T = T + Math.imul(W, yt) | 0;
    var se = (P + (S = S + Math.imul(_, Tt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(_, oe) | 0) + Math.imul(O, Tt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(O, oe) | 0) + (E >>> 13) | 0) + (se >>> 26) | 0, se &= 67108863, S = Math.imul(rt, _t), E = (E = Math.imul(rt, Ut)) + Math.imul(tt, _t) | 0, T = Math.imul(tt, Ut), S = S + Math.imul(nt, ye) | 0, E = (E = E + Math.imul(nt, ne) | 0) + Math.imul(et, ye) | 0, T = T + Math.imul(et, ne) | 0, S = S + Math.imul(Z, fe) | 0, E = (E = E + Math.imul(Z, ve) | 0) + Math.imul(q, fe) | 0, T = T + Math.imul(q, ve) | 0, S = S + Math.imul(Y, At) | 0, E = (E = E + Math.imul(Y, yt) | 0) + Math.imul(U, At) | 0, T = T + Math.imul(U, yt) | 0, S = S + Math.imul(z, Tt) | 0, E = (E = E + Math.imul(z, oe) | 0) + Math.imul(W, Tt) | 0, T = T + Math.imul(W, oe) | 0;
    var Si = (P + (S = S + Math.imul(_, Te) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(_, Ze) | 0) + Math.imul(O, Te) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(O, Ze) | 0) + (E >>> 13) | 0) + (Si >>> 26) | 0, Si &= 67108863, S = Math.imul(ut, _t), E = (E = Math.imul(ut, Ut)) + Math.imul(ht, _t) | 0, T = Math.imul(ht, Ut), S = S + Math.imul(rt, ye) | 0, E = (E = E + Math.imul(rt, ne) | 0) + Math.imul(tt, ye) | 0, T = T + Math.imul(tt, ne) | 0, S = S + Math.imul(nt, fe) | 0, E = (E = E + Math.imul(nt, ve) | 0) + Math.imul(et, fe) | 0, T = T + Math.imul(et, ve) | 0, S = S + Math.imul(Z, At) | 0, E = (E = E + Math.imul(Z, yt) | 0) + Math.imul(q, At) | 0, T = T + Math.imul(q, yt) | 0, S = S + Math.imul(Y, Tt) | 0, E = (E = E + Math.imul(Y, oe) | 0) + Math.imul(U, Tt) | 0, T = T + Math.imul(U, oe) | 0, S = S + Math.imul(z, Te) | 0, E = (E = E + Math.imul(z, Ze) | 0) + Math.imul(W, Te) | 0, T = T + Math.imul(W, Ze) | 0;
    var Le = (P + (S = S + Math.imul(_, Fe) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(_, qe) | 0) + Math.imul(O, Fe) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(O, qe) | 0) + (E >>> 13) | 0) + (Le >>> 26) | 0, Le &= 67108863, S = Math.imul(bt, _t), E = (E = Math.imul(bt, Ut)) + Math.imul(ct, _t) | 0, T = Math.imul(ct, Ut), S = S + Math.imul(ut, ye) | 0, E = (E = E + Math.imul(ut, ne) | 0) + Math.imul(ht, ye) | 0, T = T + Math.imul(ht, ne) | 0, S = S + Math.imul(rt, fe) | 0, E = (E = E + Math.imul(rt, ve) | 0) + Math.imul(tt, fe) | 0, T = T + Math.imul(tt, ve) | 0, S = S + Math.imul(nt, At) | 0, E = (E = E + Math.imul(nt, yt) | 0) + Math.imul(et, At) | 0, T = T + Math.imul(et, yt) | 0, S = S + Math.imul(Z, Tt) | 0, E = (E = E + Math.imul(Z, oe) | 0) + Math.imul(q, Tt) | 0, T = T + Math.imul(q, oe) | 0, S = S + Math.imul(Y, Te) | 0, E = (E = E + Math.imul(Y, Ze) | 0) + Math.imul(U, Te) | 0, T = T + Math.imul(U, Ze) | 0, S = S + Math.imul(z, Fe) | 0, E = (E = E + Math.imul(z, qe) | 0) + Math.imul(W, Fe) | 0, T = T + Math.imul(W, qe) | 0;
    var We = (P + (S = S + Math.imul(_, ii) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(_, Ge) | 0) + Math.imul(O, ii) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(O, Ge) | 0) + (E >>> 13) | 0) + (We >>> 26) | 0, We &= 67108863, S = Math.imul(vt, _t), E = (E = Math.imul(vt, Ut)) + Math.imul(mt, _t) | 0, T = Math.imul(mt, Ut), S = S + Math.imul(bt, ye) | 0, E = (E = E + Math.imul(bt, ne) | 0) + Math.imul(ct, ye) | 0, T = T + Math.imul(ct, ne) | 0, S = S + Math.imul(ut, fe) | 0, E = (E = E + Math.imul(ut, ve) | 0) + Math.imul(ht, fe) | 0, T = T + Math.imul(ht, ve) | 0, S = S + Math.imul(rt, At) | 0, E = (E = E + Math.imul(rt, yt) | 0) + Math.imul(tt, At) | 0, T = T + Math.imul(tt, yt) | 0, S = S + Math.imul(nt, Tt) | 0, E = (E = E + Math.imul(nt, oe) | 0) + Math.imul(et, Tt) | 0, T = T + Math.imul(et, oe) | 0, S = S + Math.imul(Z, Te) | 0, E = (E = E + Math.imul(Z, Ze) | 0) + Math.imul(q, Te) | 0, T = T + Math.imul(q, Ze) | 0, S = S + Math.imul(Y, Fe) | 0, E = (E = E + Math.imul(Y, qe) | 0) + Math.imul(U, Fe) | 0, T = T + Math.imul(U, qe) | 0, S = S + Math.imul(z, ii) | 0, E = (E = E + Math.imul(z, Ge) | 0) + Math.imul(W, ii) | 0, T = T + Math.imul(W, Ge) | 0;
    var gi = (P + (S = S + Math.imul(_, Bt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(_, Wt) | 0) + Math.imul(O, Bt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(O, Wt) | 0) + (E >>> 13) | 0) + (gi >>> 26) | 0, gi &= 67108863, S = Math.imul(Rt, _t), E = (E = Math.imul(Rt, Ut)) + Math.imul(Dt, _t) | 0, T = Math.imul(Dt, Ut), S = S + Math.imul(vt, ye) | 0, E = (E = E + Math.imul(vt, ne) | 0) + Math.imul(mt, ye) | 0, T = T + Math.imul(mt, ne) | 0, S = S + Math.imul(bt, fe) | 0, E = (E = E + Math.imul(bt, ve) | 0) + Math.imul(ct, fe) | 0, T = T + Math.imul(ct, ve) | 0, S = S + Math.imul(ut, At) | 0, E = (E = E + Math.imul(ut, yt) | 0) + Math.imul(ht, At) | 0, T = T + Math.imul(ht, yt) | 0, S = S + Math.imul(rt, Tt) | 0, E = (E = E + Math.imul(rt, oe) | 0) + Math.imul(tt, Tt) | 0, T = T + Math.imul(tt, oe) | 0, S = S + Math.imul(nt, Te) | 0, E = (E = E + Math.imul(nt, Ze) | 0) + Math.imul(et, Te) | 0, T = T + Math.imul(et, Ze) | 0, S = S + Math.imul(Z, Fe) | 0, E = (E = E + Math.imul(Z, qe) | 0) + Math.imul(q, Fe) | 0, T = T + Math.imul(q, qe) | 0, S = S + Math.imul(Y, ii) | 0, E = (E = E + Math.imul(Y, Ge) | 0) + Math.imul(U, ii) | 0, T = T + Math.imul(U, Ge) | 0, S = S + Math.imul(z, Bt) | 0, E = (E = E + Math.imul(z, Wt) | 0) + Math.imul(W, Bt) | 0, T = T + Math.imul(W, Wt) | 0;
    var Di = (P + (S = S + Math.imul(_, pt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(_, St) | 0) + Math.imul(O, pt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(O, St) | 0) + (E >>> 13) | 0) + (Di >>> 26) | 0, Di &= 67108863, S = Math.imul(Rt, ye), E = (E = Math.imul(Rt, ne)) + Math.imul(Dt, ye) | 0, T = Math.imul(Dt, ne), S = S + Math.imul(vt, fe) | 0, E = (E = E + Math.imul(vt, ve) | 0) + Math.imul(mt, fe) | 0, T = T + Math.imul(mt, ve) | 0, S = S + Math.imul(bt, At) | 0, E = (E = E + Math.imul(bt, yt) | 0) + Math.imul(ct, At) | 0, T = T + Math.imul(ct, yt) | 0, S = S + Math.imul(ut, Tt) | 0, E = (E = E + Math.imul(ut, oe) | 0) + Math.imul(ht, Tt) | 0, T = T + Math.imul(ht, oe) | 0, S = S + Math.imul(rt, Te) | 0, E = (E = E + Math.imul(rt, Ze) | 0) + Math.imul(tt, Te) | 0, T = T + Math.imul(tt, Ze) | 0, S = S + Math.imul(nt, Fe) | 0, E = (E = E + Math.imul(nt, qe) | 0) + Math.imul(et, Fe) | 0, T = T + Math.imul(et, qe) | 0, S = S + Math.imul(Z, ii) | 0, E = (E = E + Math.imul(Z, Ge) | 0) + Math.imul(q, ii) | 0, T = T + Math.imul(q, Ge) | 0, S = S + Math.imul(Y, Bt) | 0, E = (E = E + Math.imul(Y, Wt) | 0) + Math.imul(U, Bt) | 0, T = T + Math.imul(U, Wt) | 0;
    var ns = (P + (S = S + Math.imul(z, pt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(z, St) | 0) + Math.imul(W, pt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(W, St) | 0) + (E >>> 13) | 0) + (ns >>> 26) | 0, ns &= 67108863, S = Math.imul(Rt, fe), E = (E = Math.imul(Rt, ve)) + Math.imul(Dt, fe) | 0, T = Math.imul(Dt, ve), S = S + Math.imul(vt, At) | 0, E = (E = E + Math.imul(vt, yt) | 0) + Math.imul(mt, At) | 0, T = T + Math.imul(mt, yt) | 0, S = S + Math.imul(bt, Tt) | 0, E = (E = E + Math.imul(bt, oe) | 0) + Math.imul(ct, Tt) | 0, T = T + Math.imul(ct, oe) | 0, S = S + Math.imul(ut, Te) | 0, E = (E = E + Math.imul(ut, Ze) | 0) + Math.imul(ht, Te) | 0, T = T + Math.imul(ht, Ze) | 0, S = S + Math.imul(rt, Fe) | 0, E = (E = E + Math.imul(rt, qe) | 0) + Math.imul(tt, Fe) | 0, T = T + Math.imul(tt, qe) | 0, S = S + Math.imul(nt, ii) | 0, E = (E = E + Math.imul(nt, Ge) | 0) + Math.imul(et, ii) | 0, T = T + Math.imul(et, Ge) | 0, S = S + Math.imul(Z, Bt) | 0, E = (E = E + Math.imul(Z, Wt) | 0) + Math.imul(q, Bt) | 0, T = T + Math.imul(q, Wt) | 0;
    var Ni = (P + (S = S + Math.imul(Y, pt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(Y, St) | 0) + Math.imul(U, pt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(U, St) | 0) + (E >>> 13) | 0) + (Ni >>> 26) | 0, Ni &= 67108863, S = Math.imul(Rt, At), E = (E = Math.imul(Rt, yt)) + Math.imul(Dt, At) | 0, T = Math.imul(Dt, yt), S = S + Math.imul(vt, Tt) | 0, E = (E = E + Math.imul(vt, oe) | 0) + Math.imul(mt, Tt) | 0, T = T + Math.imul(mt, oe) | 0, S = S + Math.imul(bt, Te) | 0, E = (E = E + Math.imul(bt, Ze) | 0) + Math.imul(ct, Te) | 0, T = T + Math.imul(ct, Ze) | 0, S = S + Math.imul(ut, Fe) | 0, E = (E = E + Math.imul(ut, qe) | 0) + Math.imul(ht, Fe) | 0, T = T + Math.imul(ht, qe) | 0, S = S + Math.imul(rt, ii) | 0, E = (E = E + Math.imul(rt, Ge) | 0) + Math.imul(tt, ii) | 0, T = T + Math.imul(tt, Ge) | 0, S = S + Math.imul(nt, Bt) | 0, E = (E = E + Math.imul(nt, Wt) | 0) + Math.imul(et, Bt) | 0, T = T + Math.imul(et, Wt) | 0;
    var no = (P + (S = S + Math.imul(Z, pt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(Z, St) | 0) + Math.imul(q, pt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(q, St) | 0) + (E >>> 13) | 0) + (no >>> 26) | 0, no &= 67108863, S = Math.imul(Rt, Tt), E = (E = Math.imul(Rt, oe)) + Math.imul(Dt, Tt) | 0, T = Math.imul(Dt, oe), S = S + Math.imul(vt, Te) | 0, E = (E = E + Math.imul(vt, Ze) | 0) + Math.imul(mt, Te) | 0, T = T + Math.imul(mt, Ze) | 0, S = S + Math.imul(bt, Fe) | 0, E = (E = E + Math.imul(bt, qe) | 0) + Math.imul(ct, Fe) | 0, T = T + Math.imul(ct, qe) | 0, S = S + Math.imul(ut, ii) | 0, E = (E = E + Math.imul(ut, Ge) | 0) + Math.imul(ht, ii) | 0, T = T + Math.imul(ht, Ge) | 0, S = S + Math.imul(rt, Bt) | 0, E = (E = E + Math.imul(rt, Wt) | 0) + Math.imul(tt, Bt) | 0, T = T + Math.imul(tt, Wt) | 0;
    var Zr = (P + (S = S + Math.imul(nt, pt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(nt, St) | 0) + Math.imul(et, pt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(et, St) | 0) + (E >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, S = Math.imul(Rt, Te), E = (E = Math.imul(Rt, Ze)) + Math.imul(Dt, Te) | 0, T = Math.imul(Dt, Ze), S = S + Math.imul(vt, Fe) | 0, E = (E = E + Math.imul(vt, qe) | 0) + Math.imul(mt, Fe) | 0, T = T + Math.imul(mt, qe) | 0, S = S + Math.imul(bt, ii) | 0, E = (E = E + Math.imul(bt, Ge) | 0) + Math.imul(ct, ii) | 0, T = T + Math.imul(ct, Ge) | 0, S = S + Math.imul(ut, Bt) | 0, E = (E = E + Math.imul(ut, Wt) | 0) + Math.imul(ht, Bt) | 0, T = T + Math.imul(ht, Wt) | 0;
    var Bi = (P + (S = S + Math.imul(rt, pt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(rt, St) | 0) + Math.imul(tt, pt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(tt, St) | 0) + (E >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, S = Math.imul(Rt, Fe), E = (E = Math.imul(Rt, qe)) + Math.imul(Dt, Fe) | 0, T = Math.imul(Dt, qe), S = S + Math.imul(vt, ii) | 0, E = (E = E + Math.imul(vt, Ge) | 0) + Math.imul(mt, ii) | 0, T = T + Math.imul(mt, Ge) | 0, S = S + Math.imul(bt, Bt) | 0, E = (E = E + Math.imul(bt, Wt) | 0) + Math.imul(ct, Bt) | 0, T = T + Math.imul(ct, Wt) | 0;
    var os = (P + (S = S + Math.imul(ut, pt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(ut, St) | 0) + Math.imul(ht, pt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(ht, St) | 0) + (E >>> 13) | 0) + (os >>> 26) | 0, os &= 67108863, S = Math.imul(Rt, ii), E = (E = Math.imul(Rt, Ge)) + Math.imul(Dt, ii) | 0, T = Math.imul(Dt, Ge), S = S + Math.imul(vt, Bt) | 0, E = (E = E + Math.imul(vt, Wt) | 0) + Math.imul(mt, Bt) | 0, T = T + Math.imul(mt, Wt) | 0;
    var as = (P + (S = S + Math.imul(bt, pt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(bt, St) | 0) + Math.imul(ct, pt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(ct, St) | 0) + (E >>> 13) | 0) + (as >>> 26) | 0, as &= 67108863, S = Math.imul(Rt, Bt), E = (E = Math.imul(Rt, Wt)) + Math.imul(Dt, Bt) | 0, T = Math.imul(Dt, Wt);
    var oo = (P + (S = S + Math.imul(vt, pt) | 0) | 0) + ((8191 & (E = (E = E + Math.imul(vt, St) | 0) + Math.imul(mt, pt) | 0)) << 13) | 0;
    P = ((T = T + Math.imul(mt, St) | 0) + (E >>> 13) | 0) + (oo >>> 26) | 0, oo &= 67108863;
    var ys = (P + (S = Math.imul(Rt, pt)) | 0) + ((8191 & (E = (E = Math.imul(Rt, St)) + Math.imul(Dt, pt) | 0)) << 13) | 0;
    return P = ((T = Math.imul(Dt, St)) + (E >>> 13) | 0) + (ys >>> 26) | 0, ys &= 67108863, D[0] = Ft, D[1] = Qt, D[2] = Se, D[3] = ce, D[4] = se, D[5] = Si, D[6] = Le, D[7] = We, D[8] = gi, D[9] = Di, D[10] = ns, D[11] = Ni, D[12] = no, D[13] = Zr, D[14] = Bi, D[15] = os, D[16] = as, D[17] = oo, D[18] = ys, P !== 0 && (D[19] = P, C.length++), C;
  };
  function g(x, M, C) {
    C.negative = M.negative ^ x.negative, C.length = x.length + M.length;
    for (var S = 0, E = 0, T = 0; T < C.length - 1; T++) {
      var I = E;
      E = 0;
      for (var F = 67108863 & S, D = Math.min(T, M.length - 1), P = Math.max(0, T - x.length + 1); P <= D; P++) {
        var V = T - P, _ = (0 | x.words[V]) * (0 | M.words[P]), O = 67108863 & _;
        F = 67108863 & (O = O + F | 0), E += (I = (I = I + (_ / 67108864 | 0) | 0) + (O >>> 26) | 0) >>> 26, I &= 67108863;
      }
      C.words[T] = F, S = I, I = E;
    }
    return S !== 0 ? C.words[T] = S : C.length--, C.$W();
  }
  function y(x, M, C) {
    return g(x, M, C);
  }
  Math.imul || (p = f), s.prototype.mulTo = function(x, M) {
    var C = this.length + x.length;
    return this.length === 10 && x.length === 10 ? p(this, x, M) : C < 63 ? f(this, x, M) : C < 1024 ? g(this, x, M) : y(this, x, M);
  }, s.prototype.mul = function(x) {
    var M = new s(null);
    return M.words = new Array(this.length + x.length), this.mulTo(x, M);
  }, s.prototype.mulf = function(x) {
    var M = new s(null);
    return M.words = new Array(this.length + x.length), y(this, x, M);
  }, s.prototype.imul = function(x) {
    return this.clone().mulTo(x, this);
  }, s.prototype.imuln = function(x) {
    var M = x < 0;
    M && (x = -x), e(typeof x == "number"), e(x < 67108864);
    for (var C = 0, S = 0; S < this.length; S++) {
      var E = (0 | this.words[S]) * x, T = (67108863 & E) + (67108863 & C);
      C >>= 26, C += E / 67108864 | 0, C += T >>> 26, this.words[S] = 67108863 & T;
    }
    return C !== 0 && (this.words[S] = C, this.length++), M ? this.ineg() : this;
  }, s.prototype.muln = function(x) {
    return this.clone().imuln(x);
  }, s.prototype.sqr = function() {
    return this.mul(this);
  }, s.prototype.isqr = function() {
    return this.imul(this.clone());
  }, s.prototype.pow = function(x) {
    var M = (function(T) {
      for (var I = new Array(T.bitLength()), F = 0; F < I.length; F++) {
        var D = F / 26 | 0, P = F % 26;
        I[F] = T.words[D] >>> P & 1;
      }
      return I;
    })(x);
    if (M.length === 0) return new s(1);
    for (var C = this, S = 0; S < M.length && M[S] === 0; S++, C = C.sqr()) ;
    if (++S < M.length) for (var E = C.sqr(); S < M.length; S++, E = E.sqr()) M[S] !== 0 && (C = C.mul(E));
    return C;
  }, s.prototype.iushln = function(x) {
    e(typeof x == "number" && x >= 0);
    var M, C = x % 26, S = (x - C) / 26, E = 67108863 >>> 26 - C << 26 - C;
    if (C !== 0) {
      var T = 0;
      for (M = 0; M < this.length; M++) {
        var I = this.words[M] & E, F = (0 | this.words[M]) - I << C;
        this.words[M] = F | T, T = I >>> 26 - C;
      }
      T && (this.words[M] = T, this.length++);
    }
    if (S !== 0) {
      for (M = this.length - 1; M >= 0; M--) this.words[M + S] = this.words[M];
      for (M = 0; M < S; M++) this.words[M] = 0;
      this.length += S;
    }
    return this.$W();
  }, s.prototype.ishln = function(x) {
    return e(this.negative === 0), this.iushln(x);
  }, s.prototype.iushrn = function(x, M, C) {
    var S;
    e(typeof x == "number" && x >= 0), S = M ? (M - M % 26) / 26 : 0;
    var E = x % 26, T = Math.min((x - E) / 26, this.length), I = 67108863 ^ 67108863 >>> E << E, F = C;
    if (S -= T, S = Math.max(0, S), F) {
      for (var D = 0; D < T; D++) F.words[D] = this.words[D];
      F.length = T;
    }
    if (T !== 0) if (this.length > T) for (this.length -= T, D = 0; D < this.length; D++) this.words[D] = this.words[D + T];
    else this.words[0] = 0, this.length = 1;
    var P = 0;
    for (D = this.length - 1; D >= 0 && (P !== 0 || D >= S); D--) {
      var V = 0 | this.words[D];
      this.words[D] = P << 26 - E | V >>> E, P = V & I;
    }
    return F && P !== 0 && (F.words[F.length++] = P), this.length === 0 && (this.words[0] = 0, this.length = 1), this.$W();
  }, s.prototype.ishrn = function(x, M, C) {
    return e(this.negative === 0), this.iushrn(x, M, C);
  }, s.prototype.shln = function(x) {
    return this.clone().ishln(x);
  }, s.prototype.ushln = function(x) {
    return this.clone().iushln(x);
  }, s.prototype.shrn = function(x) {
    return this.clone().ishrn(x);
  }, s.prototype.ushrn = function(x) {
    return this.clone().iushrn(x);
  }, s.prototype.testn = function(x) {
    e(typeof x == "number" && x >= 0);
    var M = x % 26, C = (x - M) / 26, S = 1 << M;
    return !(this.length <= C || !(this.words[C] & S));
  }, s.prototype.imaskn = function(x) {
    e(typeof x == "number" && x >= 0);
    var M = x % 26, C = (x - M) / 26;
    if (e(this.negative === 0, "imaskn works only with positive numbers"), this.length <= C) return this;
    if (M !== 0 && C++, this.length = Math.min(C, this.length), M !== 0) {
      var S = 67108863 ^ 67108863 >>> M << M;
      this.words[this.length - 1] &= S;
    }
    return this.$W();
  }, s.prototype.maskn = function(x) {
    return this.clone().imaskn(x);
  }, s.prototype.iaddn = function(x) {
    return e(typeof x == "number"), e(x < 67108864), x < 0 ? this.isubn(-x) : this.negative !== 0 ? this.length === 1 && (0 | this.words[0]) <= x ? (this.words[0] = x - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(x), this.negative = 1, this) : this.UW(x);
  }, s.prototype.UW = function(x) {
    this.words[0] += x;
    for (var M = 0; M < this.length && this.words[M] >= 67108864; M++) this.words[M] -= 67108864, M === this.length - 1 ? this.words[M + 1] = 1 : this.words[M + 1]++;
    return this.length = Math.max(this.length, M + 1), this;
  }, s.prototype.isubn = function(x) {
    if (e(typeof x == "number"), e(x < 67108864), x < 0) return this.iaddn(-x);
    if (this.negative !== 0) return this.negative = 0, this.iaddn(x), this.negative = 1, this;
    if (this.words[0] -= x, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
    else for (var M = 0; M < this.length && this.words[M] < 0; M++) this.words[M] += 67108864, this.words[M + 1] -= 1;
    return this.$W();
  }, s.prototype.addn = function(x) {
    return this.clone().iaddn(x);
  }, s.prototype.subn = function(x) {
    return this.clone().isubn(x);
  }, s.prototype.iabs = function() {
    return this.negative = 0, this;
  }, s.prototype.abs = function() {
    return this.clone().iabs();
  }, s.prototype.QW = function(x, M, C) {
    var S, E, T = x.length + C;
    this.YW(T);
    var I = 0;
    for (S = 0; S < x.length; S++) {
      E = (0 | this.words[S + C]) + I;
      var F = (0 | x.words[S]) * M;
      I = ((E -= 67108863 & F) >> 26) - (F / 67108864 | 0), this.words[S + C] = 67108863 & E;
    }
    for (; S < this.length - C; S++) I = (E = (0 | this.words[S + C]) + I) >> 26, this.words[S + C] = 67108863 & E;
    if (I === 0) return this.$W();
    for (e(I === -1), I = 0, S = 0; S < this.length; S++) I = (E = -(0 | this.words[S]) + I) >> 26, this.words[S] = 67108863 & E;
    return this.negative = 1, this.$W();
  }, s.prototype.KW = function(x, M) {
    var C = (this.length, x.length), S = this.clone(), E = x, T = 0 | E.words[E.length - 1];
    (C = 26 - this.ZW(T)) != 0 && (E = E.ushln(C), S.iushln(C), T = 0 | E.words[E.length - 1]);
    var I, F = S.length - E.length;
    if (M !== "mod") {
      (I = new s(null)).length = F + 1, I.words = new Array(I.length);
      for (var D = 0; D < I.length; D++) I.words[D] = 0;
    }
    var P = S.clone().QW(E, 1, F);
    P.negative === 0 && (S = P, I && (I.words[F] = 1));
    for (var V = F - 1; V >= 0; V--) {
      var _ = 67108864 * (0 | S.words[E.length + V]) + (0 | S.words[E.length + V - 1]);
      for (_ = Math.min(_ / T | 0, 67108863), S.QW(E, _, V); S.negative !== 0; ) _--, S.negative = 0, S.QW(E, 1, V), S.isZero() || (S.negative ^= 1);
      I && (I.words[V] = _);
    }
    return I && I.$W(), S.$W(), M !== "div" && C !== 0 && S.iushrn(C), { div: I || null, mod: S };
  }, s.prototype.divmod = function(x, M, C) {
    return e(!x.isZero()), this.isZero() ? { div: new s(0), mod: new s(0) } : this.negative !== 0 && x.negative === 0 ? (T = this.neg().divmod(x, M), M !== "mod" && (S = T.div.neg()), M !== "div" && (E = T.mod.neg(), C && E.negative !== 0 && E.iadd(x)), { div: S, mod: E }) : this.negative === 0 && x.negative !== 0 ? (T = this.divmod(x.neg(), M), M !== "mod" && (S = T.div.neg()), { div: S, mod: T.mod }) : this.negative & x.negative ? (T = this.neg().divmod(x.neg(), M), M !== "div" && (E = T.mod.neg(), C && E.negative !== 0 && E.isub(x)), { div: T.div, mod: E }) : x.length > this.length || this.cmp(x) < 0 ? { div: new s(0), mod: this } : x.length === 1 ? M === "div" ? { div: this.divn(x.words[0]), mod: null } : M === "mod" ? { div: null, mod: new s(this.modrn(x.words[0])) } : { div: this.divn(x.words[0]), mod: new s(this.modrn(x.words[0])) } : this.KW(x, M);
    var S, E, T;
  }, s.prototype.div = function(x) {
    return this.divmod(x, "div", !1).div;
  }, s.prototype.mod = function(x) {
    return this.divmod(x, "mod", !1).mod;
  }, s.prototype.umod = function(x) {
    return this.divmod(x, "mod", !0).mod;
  }, s.prototype.divRound = function(x) {
    var M = this.divmod(x);
    if (M.mod.isZero()) return M.div;
    var C = M.div.negative !== 0 ? M.mod.isub(x) : M.mod, S = x.ushrn(1), E = x.andln(1), T = C.cmp(S);
    return T < 0 || E === 1 && T === 0 ? M.div : M.div.negative !== 0 ? M.div.isubn(1) : M.div.iaddn(1);
  }, s.prototype.modrn = function(x) {
    var M = x < 0;
    M && (x = -x), e(x <= 67108863);
    for (var C = (1 << 26) % x, S = 0, E = this.length - 1; E >= 0; E--) S = (C * S + (0 | this.words[E])) % x;
    return M ? -S : S;
  }, s.prototype.modn = function(x) {
    return this.modrn(x);
  }, s.prototype.idivn = function(x) {
    var M = x < 0;
    M && (x = -x), e(x <= 67108863);
    for (var C = 0, S = this.length - 1; S >= 0; S--) {
      var E = (0 | this.words[S]) + 67108864 * C;
      this.words[S] = E / x | 0, C = E % x;
    }
    return this.$W(), M ? this.ineg() : this;
  }, s.prototype.divn = function(x) {
    return this.clone().idivn(x);
  }, s.prototype.egcd = function(x) {
    e(x.negative === 0), e(!x.isZero());
    var M = this, C = x.clone();
    M = M.negative !== 0 ? M.umod(x) : M.clone();
    for (var S = new s(1), E = new s(0), T = new s(0), I = new s(1), F = 0; M.isEven() && C.isEven(); ) M.iushrn(1), C.iushrn(1), ++F;
    for (var D = C.clone(), P = M.clone(); !M.isZero(); ) {
      for (var V = 0, _ = 1; !(M.words[0] & _) && V < 26; ++V, _ <<= 1) ;
      if (V > 0) for (M.iushrn(V); V-- > 0; ) (S.isOdd() || E.isOdd()) && (S.iadd(D), E.isub(P)), S.iushrn(1), E.iushrn(1);
      for (var O = 0, B = 1; !(C.words[0] & B) && O < 26; ++O, B <<= 1) ;
      if (O > 0) for (C.iushrn(O); O-- > 0; ) (T.isOdd() || I.isOdd()) && (T.iadd(D), I.isub(P)), T.iushrn(1), I.iushrn(1);
      M.cmp(C) >= 0 ? (M.isub(C), S.isub(T), E.isub(I)) : (C.isub(M), T.isub(S), I.isub(E));
    }
    return { a: T, b: I, gcd: C.iushln(F) };
  }, s.prototype.qW = function(x) {
    e(x.negative === 0), e(!x.isZero());
    var M = this, C = x.clone();
    M = M.negative !== 0 ? M.umod(x) : M.clone();
    for (var S, E = new s(1), T = new s(0), I = C.clone(); M.cmpn(1) > 0 && C.cmpn(1) > 0; ) {
      for (var F = 0, D = 1; !(M.words[0] & D) && F < 26; ++F, D <<= 1) ;
      if (F > 0) for (M.iushrn(F); F-- > 0; ) E.isOdd() && E.iadd(I), E.iushrn(1);
      for (var P = 0, V = 1; !(C.words[0] & V) && P < 26; ++P, V <<= 1) ;
      if (P > 0) for (C.iushrn(P); P-- > 0; ) T.isOdd() && T.iadd(I), T.iushrn(1);
      M.cmp(C) >= 0 ? (M.isub(C), E.isub(T)) : (C.isub(M), T.isub(E));
    }
    return (S = M.cmpn(1) === 0 ? E : T).cmpn(0) < 0 && S.iadd(x), S;
  }, s.prototype.gcd = function(x) {
    if (this.isZero()) return x.abs();
    if (x.isZero()) return this.abs();
    var M = this.clone(), C = x.clone();
    M.negative = 0, C.negative = 0;
    for (var S = 0; M.isEven() && C.isEven(); S++) M.iushrn(1), C.iushrn(1);
    for (; ; ) {
      for (; M.isEven(); ) M.iushrn(1);
      for (; C.isEven(); ) C.iushrn(1);
      var E = M.cmp(C);
      if (E < 0) {
        var T = M;
        M = C, C = T;
      } else if (E === 0 || C.cmpn(1) === 0) break;
      M.isub(C);
    }
    return C.iushln(S);
  }, s.prototype.invm = function(x) {
    return this.egcd(x).a.umod(x);
  }, s.prototype.isEven = function() {
    return !(1 & this.words[0]);
  }, s.prototype.isOdd = function() {
    return !(1 & ~this.words[0]);
  }, s.prototype.andln = function(x) {
    return this.words[0] & x;
  }, s.prototype.bincn = function(x) {
    e(typeof x == "number");
    var M = x % 26, C = (x - M) / 26, S = 1 << M;
    if (this.length <= C) return this.YW(C + 1), this.words[C] |= S, this;
    for (var E = S, T = C; E !== 0 && T < this.length; T++) {
      var I = 0 | this.words[T];
      E = (I += E) >>> 26, I &= 67108863, this.words[T] = I;
    }
    return E !== 0 && (this.words[T] = E, this.length++), this;
  }, s.prototype.isZero = function() {
    return this.length === 1 && this.words[0] === 0;
  }, s.prototype.cmpn = function(x) {
    var M, C = x < 0;
    if (this.negative !== 0 && !C) return -1;
    if (this.negative === 0 && C) return 1;
    if (this.$W(), this.length > 1) M = 1;
    else {
      C && (x = -x), e(x <= 67108863, "Number is too big");
      var S = 0 | this.words[0];
      M = S === x ? 0 : S < x ? -1 : 1;
    }
    return this.negative !== 0 ? 0 | -M : M;
  }, s.prototype.cmp = function(x) {
    if (this.negative !== 0 && x.negative === 0) return -1;
    if (this.negative === 0 && x.negative !== 0) return 1;
    var M = this.ucmp(x);
    return this.negative !== 0 ? 0 | -M : M;
  }, s.prototype.ucmp = function(x) {
    if (this.length > x.length) return 1;
    if (this.length < x.length) return -1;
    for (var M = 0, C = this.length - 1; C >= 0; C--) {
      var S = 0 | this.words[C], E = 0 | x.words[C];
      if (S !== E) {
        S < E ? M = -1 : S > E && (M = 1);
        break;
      }
    }
    return M;
  }, s.prototype.gtn = function(x) {
    return this.cmpn(x) === 1;
  }, s.prototype.gt = function(x) {
    return this.cmp(x) === 1;
  }, s.prototype.gten = function(x) {
    return this.cmpn(x) >= 0;
  }, s.prototype.gte = function(x) {
    return this.cmp(x) >= 0;
  }, s.prototype.ltn = function(x) {
    return this.cmpn(x) === -1;
  }, s.prototype.lt = function(x) {
    return this.cmp(x) === -1;
  }, s.prototype.lten = function(x) {
    return this.cmpn(x) <= 0;
  }, s.prototype.lte = function(x) {
    return this.cmp(x) <= 0;
  }, s.prototype.eqn = function(x) {
    return this.cmpn(x) === 0;
  }, s.prototype.eq = function(x) {
    return this.cmp(x) === 0;
  }, s.red = function(x) {
    return new R(x);
  }, s.prototype.toRed = function(x) {
    return e(!this.red, "Already a number in reduction context"), e(this.negative === 0, "red works only with positives"), x.convertTo(this).tX(x);
  }, s.prototype.fromRed = function() {
    return e(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
  }, s.prototype.tX = function(x) {
    return this.red = x, this;
  }, s.prototype.forceRed = function(x) {
    return e(!this.red, "Already a number in reduction context"), this.tX(x);
  }, s.prototype.redAdd = function(x) {
    return e(this.red, "redAdd works only with red numbers"), this.red.add(this, x);
  }, s.prototype.redIAdd = function(x) {
    return e(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, x);
  }, s.prototype.redSub = function(x) {
    return e(this.red, "redSub works only with red numbers"), this.red.sub(this, x);
  }, s.prototype.redISub = function(x) {
    return e(this.red, "redISub works only with red numbers"), this.red.isub(this, x);
  }, s.prototype.redShl = function(x) {
    return e(this.red, "redShl works only with red numbers"), this.red.shl(this, x);
  }, s.prototype.redMul = function(x) {
    return e(this.red, "redMul works only with red numbers"), this.red.iX(this, x), this.red.mul(this, x);
  }, s.prototype.redIMul = function(x) {
    return e(this.red, "redMul works only with red numbers"), this.red.iX(this, x), this.red.imul(this, x);
  }, s.prototype.redSqr = function() {
    return e(this.red, "redSqr works only with red numbers"), this.red.sX(this), this.red.sqr(this);
  }, s.prototype.redISqr = function() {
    return e(this.red, "redISqr works only with red numbers"), this.red.sX(this), this.red.isqr(this);
  }, s.prototype.redSqrt = function() {
    return e(this.red, "redSqrt works only with red numbers"), this.red.sX(this), this.red.sqrt(this);
  }, s.prototype.redInvm = function() {
    return e(this.red, "redInvm works only with red numbers"), this.red.sX(this), this.red.invm(this);
  }, s.prototype.redNeg = function() {
    return e(this.red, "redNeg works only with red numbers"), this.red.sX(this), this.red.neg(this);
  }, s.prototype.redPow = function(x) {
    return e(this.red && !x.red, "redPow(normalNum)"), this.red.sX(this), this.red.pow(this, x);
  };
  var m = { k256: null, p224: null, p192: null, p25519: null };
  function A(x, M) {
    this.name = x, this.p = new s(M, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this.eX();
  }
  function v() {
    A.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
  }
  function b() {
    A.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
  }
  function w() {
    A.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
  }
  function k() {
    A.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
  }
  function R(x) {
    if (typeof x == "string") {
      var M = s.rX(x);
      this.m = M.p, this.prime = M;
    } else e(x.gtn(1), "modulus must be greater than 1"), this.m = x, this.prime = null;
  }
  function L(x) {
    R.call(this, x), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r.qW(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
  }
  A.prototype.eX = function() {
    var x = new s(null);
    return x.words = new Array(Math.ceil(this.n / 13)), x;
  }, A.prototype.ireduce = function(x) {
    var M, C = x;
    do
      this.split(C, this.tmp), M = (C = (C = this.imulK(C)).iadd(this.tmp)).bitLength();
    while (M > this.n);
    var S = M < this.n ? -1 : C.ucmp(this.p);
    return S === 0 ? (C.words[0] = 0, C.length = 1) : S > 0 ? C.isub(this.p) : C.strip !== void 0 ? C.strip() : C.$W(), C;
  }, A.prototype.split = function(x, M) {
    x.iushrn(this.n, 0, M);
  }, A.prototype.imulK = function(x) {
    return x.imul(this.k);
  }, i(v, A), v.prototype.split = function(x, M) {
    for (var C = 4194303, S = Math.min(x.length, 9), E = 0; E < S; E++) M.words[E] = x.words[E];
    if (M.length = S, x.length <= 9) return x.words[0] = 0, void (x.length = 1);
    var T = x.words[9];
    for (M.words[M.length++] = T & C, E = 10; E < x.length; E++) {
      var I = 0 | x.words[E];
      x.words[E - 10] = (I & C) << 4 | T >>> 22, T = I;
    }
    T >>>= 22, x.words[E - 10] = T, T === 0 && x.length > 10 ? x.length -= 10 : x.length -= 9;
  }, v.prototype.imulK = function(x) {
    x.words[x.length] = 0, x.words[x.length + 1] = 0, x.length += 2;
    for (var M = 0, C = 0; C < x.length; C++) {
      var S = 0 | x.words[C];
      M += 977 * S, x.words[C] = 67108863 & M, M = 64 * S + (M / 67108864 | 0);
    }
    return x.words[x.length - 1] === 0 && (x.length--, x.words[x.length - 1] === 0 && x.length--), x;
  }, i(b, A), i(w, A), i(k, A), k.prototype.imulK = function(x) {
    for (var M = 0, C = 0; C < x.length; C++) {
      var S = 19 * (0 | x.words[C]) + M, E = 67108863 & S;
      S >>>= 26, x.words[C] = E, M = S;
    }
    return M !== 0 && (x.words[x.length++] = M), x;
  }, s.rX = function(x) {
    if (m[x]) return m[x];
    var M;
    if (x === "k256") M = new v();
    else if (x === "p224") M = new b();
    else if (x === "p192") M = new w();
    else {
      if (x !== "p25519") throw new Error("Unknown prime " + x);
      M = new k();
    }
    return m[x] = M, M;
  }, R.prototype.sX = function(x) {
    e(x.negative === 0, "red works only with positives"), e(x.red, "red works only with red numbers");
  }, R.prototype.iX = function(x, M) {
    e(!(x.negative | M.negative), "red works only with positives"), e(x.red && x.red === M.red, "red works only with red numbers");
  }, R.prototype.imod = function(x) {
    return this.prime ? this.prime.ireduce(x).tX(this) : (l(x, x.umod(this.m).tX(this)), x);
  }, R.prototype.neg = function(x) {
    return x.isZero() ? x.clone() : this.m.sub(x).tX(this);
  }, R.prototype.add = function(x, M) {
    this.iX(x, M);
    var C = x.add(M);
    return C.cmp(this.m) >= 0 && C.isub(this.m), C.tX(this);
  }, R.prototype.iadd = function(x, M) {
    this.iX(x, M);
    var C = x.iadd(M);
    return C.cmp(this.m) >= 0 && C.isub(this.m), C;
  }, R.prototype.sub = function(x, M) {
    this.iX(x, M);
    var C = x.sub(M);
    return C.cmpn(0) < 0 && C.iadd(this.m), C.tX(this);
  }, R.prototype.isub = function(x, M) {
    this.iX(x, M);
    var C = x.isub(M);
    return C.cmpn(0) < 0 && C.iadd(this.m), C;
  }, R.prototype.shl = function(x, M) {
    return this.sX(x), this.imod(x.ushln(M));
  }, R.prototype.imul = function(x, M) {
    return this.iX(x, M), this.imod(x.imul(M));
  }, R.prototype.mul = function(x, M) {
    return this.iX(x, M), this.imod(x.mul(M));
  }, R.prototype.isqr = function(x) {
    return this.imul(x, x.clone());
  }, R.prototype.sqr = function(x) {
    return this.mul(x, x);
  }, R.prototype.sqrt = function(x) {
    if (x.isZero()) return x.clone();
    var M = this.m.andln(3);
    if (e(M % 2 == 1), M === 3) {
      var C = this.m.add(new s(1)).iushrn(2);
      return this.pow(x, C);
    }
    for (var S = this.m.subn(1), E = 0; !S.isZero() && S.andln(1) === 0; ) E++, S.iushrn(1);
    e(!S.isZero());
    var T = new s(1).toRed(this), I = T.redNeg(), F = this.m.subn(1).iushrn(1), D = this.m.bitLength();
    for (D = new s(2 * D * D).toRed(this); this.pow(D, F).cmp(I) !== 0; ) D.redIAdd(I);
    for (var P = this.pow(D, S), V = this.pow(x, S.addn(1).iushrn(1)), _ = this.pow(x, S), O = E; _.cmp(T) !== 0; ) {
      for (var B = _, z = 0; B.cmp(T) !== 0; z++) B = B.redSqr();
      e(z < O);
      var W = this.pow(P, new s(1).iushln(O - z - 1));
      V = V.redMul(W), P = W.redSqr(), _ = _.redMul(P), O = z;
    }
    return V;
  }, R.prototype.invm = function(x) {
    var M = x.qW(this.m);
    return M.negative !== 0 ? (M.negative = 0, this.imod(M).redNeg()) : this.imod(M);
  }, R.prototype.pow = function(x, M) {
    if (M.isZero()) return new s(1).toRed(this);
    if (M.cmpn(1) === 0) return x.clone();
    var C = new Array(16);
    C[0] = new s(1).toRed(this), C[1] = x;
    for (var S = 2; S < C.length; S++) C[S] = this.mul(C[S - 1], x);
    var E = C[0], T = 0, I = 0, F = M.bitLength() % 26;
    for (F === 0 && (F = 26), S = M.length - 1; S >= 0; S--) {
      for (var D = M.words[S], P = F - 1; P >= 0; P--) {
        var V = D >> P & 1;
        E !== C[0] && (E = this.sqr(E)), V !== 0 || T !== 0 ? (T <<= 1, T |= V, (++I == 4 || S === 0 && P === 0) && (E = this.mul(E, C[T]), I = 0, T = 0)) : I = 0;
      }
      F = 26;
    }
    return E;
  }, R.prototype.convertTo = function(x) {
    var M = x.umod(this.m);
    return M === x ? M.clone() : M;
  }, R.prototype.convertFrom = function(x) {
    var M = x.clone();
    return M.red = null, M;
  }, s.mont = function(x) {
    return new L(x);
  }, i(L, R), L.prototype.convertTo = function(x) {
    return this.imod(x.ushln(this.shift));
  }, L.prototype.convertFrom = function(x) {
    var M = this.imod(x.mul(this.rinv));
    return M.red = null, M;
  }, L.prototype.imul = function(x, M) {
    if (x.isZero() || M.isZero()) return x.words[0] = 0, x.length = 1, x;
    var C = x.imul(M), S = C.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), E = C.isub(S).iushrn(this.shift), T = E;
    return E.cmp(this.m) >= 0 ? T = E.isub(this.m) : E.cmpn(0) < 0 && (T = E.iadd(this.m)), T.tX(this);
  }, L.prototype.mul = function(x, M) {
    if (x.isZero() || M.isZero()) return new s(0).tX(this);
    var C = x.mul(M), S = C.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), E = C.isub(S).iushrn(this.shift), T = E;
    return E.cmp(this.m) >= 0 ? T = E.isub(this.m) : E.cmpn(0) < 0 && (T = E.iadd(this.m)), T.tX(this);
  }, L.prototype.invm = function(x) {
    return this.imod(x.qW(this.m).mul(this.r2)).tX(this);
  };
})(0, uu);
var Be = Rd.exports;
function l1(r, t) {
  if (Array.isArray(r)) return r.slice();
  if (!r) return [];
  const e = [];
  if (typeof r != "string") {
    for (let i = 0; i < r.length; i++) e[i] = 0 | r[i];
    return e;
  }
  if (t === "hex") {
    (r = r.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (r = `0${r}`);
    for (let i = 0; i < r.length; i += 2) e.push(parseInt(r[i] + r[i + 1], 16));
  } else for (let i = 0; i < r.length; i++) {
    const s = r.charCodeAt(i), o = s >> 8, n = 255 & s;
    o ? e.push(o, n) : e.push(n);
  }
  return e;
}
const qh = function(r, t, e) {
  const i = new Array(Math.max(r.bitLength(), e) + 1);
  i.fill(0);
  const s = 1 << t + 1, o = r.clone();
  for (let n = 0; n < i.length; n++) {
    let a;
    const l = o.andln(s - 1);
    o.isOdd() ? (a = l > (s >> 1) - 1 ? (s >> 1) - l : l, o.isubn(a)) : a = 0, i[n] = a, o.iushrn(1);
  }
  return i;
}, wC = function(r, t) {
  const e = [[], []];
  r = r.clone(), t = t.clone();
  let i = 0, s = 0;
  for (; r.cmpn(-i) > 0 || t.cmpn(-s) > 0; ) {
    let o, n, a = r.andln(3) + i & 3, l = t.andln(3) + s & 3;
    if (a === 3 && (a = -1), l === 3 && (l = -1), 1 & a) {
      const h = r.andln(7) + i & 7;
      o = h !== 3 && h !== 5 || l !== 2 ? a : -a;
    } else o = 0;
    if (e[0].push(o), 1 & l) {
      const h = t.andln(7) + s & 7;
      n = h !== 3 && h !== 5 || a !== 2 ? l : -l;
    } else n = 0;
    e[1].push(n), 2 * i === o + 1 && (i = 1 - i), 2 * s === n + 1 && (s = 1 - s), r.iushrn(1), t.iushrn(1);
  }
  return e;
};
class TC {
  constructor(t, e) {
    this.type = t, this.p = new Be(e.p, 16), this.red = e.prime ? Be.red(e.prime) : Be.mont(this.p), this.zero = new Be(0).toRed(this.red), this.one = new Be(1).toRed(this.red), this.two = new Be(2).toRed(this.red), this.n = e.n && new Be(e.n, 16), this.g = e.g && this.pointFromJSON(e.g, e.gRed), this.hX = new Array(4), this.nX = new Array(4), this.oX = new Array(4), this.aX = new Array(4), this.lX = this.n ? this.n.bitLength() : 0;
    const i = this.n && this.p.div(this.n);
    !i || i.cmpn(100) > 0 ? this.redN = null : (this.uX = !0, this.redN = this.n.toRed(this.red));
  }
  cX(t, e) {
    const i = t.dX(), s = qh(e, 1, this.lX);
    let o = (1 << i.step + 1) - (i.step % 2 == 0 ? 2 : 1);
    o /= 3;
    const n = [];
    for (let h = 0; h < s.length; h += i.step) {
      let u = 0;
      for (let c = h + i.step - 1; c >= h; c--) u = (u << 1) + s[c];
      n.push(u);
    }
    let a = this.jpoint(null, null, null), l = this.jpoint(null, null, null);
    for (let h = o; h > 0; h--) {
      for (let u = 0; u < n.length; u++) {
        const c = n[u];
        c === h ? l = l.mixedAdd(i.points[u]) : c === -h && (l = l.mixedAdd(i.points[u].neg()));
      }
      a = a.add(l);
    }
    return a.toP();
  }
  fX(t, e) {
    let i = 4;
    const s = t.AX(i);
    i = s.wnd;
    const o = s.points, n = qh(e, i, this.lX);
    let a = this.jpoint(null, null, null);
    for (let l = n.length - 1; l >= 0; l--) {
      for (let u = 0; l >= 0 && n[l] === 0; l--) u++;
      if (l >= 0 && e++, a = a.dblp(e), l < 0) break;
      const h = n[l];
      a = t.type === "affine" ? h > 0 ? a.mixedAdd(o[h - 1 >> 1]) : a.mixedAdd(o[-h - 1 >> 1].neg()) : h > 0 ? a.add(o[h - 1 >> 1]) : a.add(o[-h - 1 >> 1].neg());
    }
    return t.type === "affine" ? a.toP() : a;
  }
  gX(t, e, i, s, o) {
    const n = this.hX, a = this.nX, l = this.oX;
    let h = 0;
    for (let d = 0; d < s; d++) {
      const f = e[d].AX(t);
      n[d] = f.wnd, a[d] = f.points;
    }
    for (let d = s - 1; d >= 1; d -= 2) {
      const f = d - 1, p = d;
      if (n[f] !== 1 || n[p] !== 1) {
        l[f] = qh(i[f], n[f], this.lX), l[p] = qh(i[p], n[p], this.lX), h = Math.max(l[f].length, h), h = Math.max(l[p].length, h);
        continue;
      }
      const g = [e[f], null, null, e[p]];
      e[f].y.cmp(e[p].y) === 0 ? (g[1] = e[f].add(e[p]), g[2] = e[f].toJ().mixedAdd(e[p].neg())) : e[f].y.cmp(e[p].y.redNeg()) === 0 ? (g[1] = e[f].toJ().mixedAdd(e[p]), g[2] = e[f].add(e[p].neg())) : (g[1] = e[f].toJ().mixedAdd(e[p]), g[2] = e[f].toJ().mixedAdd(e[p].neg()));
      const y = [-3, -1, -5, -7, 0, 7, 5, 1, 3], m = wC(i[f], i[p]);
      h = Math.max(m[0].length, h), l[f] = new Array(h), l[p] = new Array(h);
      for (let A = 0; A < h; A++) {
        const v = 0 | m[0][A], b = 0 | m[1][A];
        l[f][A] = y[3 * (v + 1) + (b + 1)], l[p][A] = 0, a[f] = g;
      }
    }
    let u = this.jpoint(null, null, null);
    const c = this.aX;
    for (let d = h; d >= 0; d--) {
      let f = 0;
      for (; d >= 0; ) {
        let p = !0;
        for (let g = 0; g < s; g++) c[g] = 0 | l[g][d], c[g] !== 0 && (p = !1);
        if (!p) break;
        f++, d--;
      }
      if (d >= 0 && f++, u = u.dblp(f), d < 0) break;
      for (let p = 0; p < s; p++) {
        const g = c[p];
        let y;
        g !== 0 && (g > 0 ? y = a[p][g - 1 >> 1] : g < 0 && (y = a[p][-g - 1 >> 1].neg()), u = y.type === "affine" ? u.mixedAdd(y) : u.add(y));
      }
    }
    for (let d = 0; d < s; d++) a[d] = null;
    return o ? u : u.toP();
  }
  decodePoint(t, e) {
    t = l1(t, e);
    const i = this.p.byteLength();
    if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 == 2 * i) return this.point(t.slice(1, 1 + i), t.slice(1 + i, 1 + 2 * i));
    if ((t[0] === 2 || t[0] === 3) && t.length - 1 === i) return this.pointFromX(t.slice(1, 1 + i), t[0] === 3);
    throw new Error("Unknown point format");
  }
}
class h1 {
  constructor(t, e) {
    this.curve = t, this.type = e, this.precomputed = null;
  }
  eq(t) {
    throw new Error("Not implemented");
  }
  validate() {
    return this.curve.validate(this);
  }
  encodeCompressed(t) {
    return this.encode(t, !0);
  }
  vX(t) {
    const e = this.curve.p.byteLength(), i = this.getX().toArray("be", e);
    return t ? [this.getY().isEven() ? 2 : 3].concat(i) : [4].concat(i, this.getY().toArray("be", e));
  }
  encode(t, e) {
    return (function(i, s) {
      return s === "hex" ? (function(o) {
        let n = "";
        for (let l = 0; l < o.length; l++) n += (a = o[l].toString(16)).length === 1 ? `0${a}` : a;
        var a;
        return n;
      })(i) : i;
    })(this.vX(e), t);
  }
  precompute(t) {
    if (this.precomputed) return this;
    const e = { doubles: null, naf: null, beta: null };
    return e.naf = this.AX(8), e.doubles = this.dX(4, t), e.beta = this.yX(), this.precomputed = e, this;
  }
  pX(t) {
    if (!this.precomputed) return !1;
    const e = this.precomputed.doubles;
    return !!e && e.points.length >= Math.ceil((t.bitLength() + 1) / e.step);
  }
  dX(t, e) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    const i = [this];
    let s = this;
    for (let o = 0; o < e; o += t) {
      for (let n = 0; n < t; n++) s = s.dbl();
      i.push(s);
    }
    return { step: t, points: i };
  }
  AX(t) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    const e = [this], i = (1 << t) - 1, s = i === 1 ? null : this.dbl();
    for (let o = 1; o < i; o++) e[o] = e[o - 1].add(s);
    return { wnd: t, points: e };
  }
  yX() {
    return null;
  }
  dblp(t) {
    let e = this;
    for (let i = 0; i < t; i++) e = e.dbl();
    return e;
  }
}
class kC extends TC {
  constructor(t) {
    super("short", t), this.a = new Be(t.a, 16).toRed(this.red), this.b = new Be(t.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this.mX(t), this.SX = new Array(4), this.bX = new Array(4);
  }
  pointFromJSON(t, e) {
    return Ru.fromJSON(this, t, e);
  }
  mX(t) {
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    let e, i, s;
    if (t.beta) e = new Be(t.beta, 16).toRed(this.red);
    else {
      const o = this.xX(this.p);
      e = o[0].cmp(o[1]) < 0 ? o[0] : o[1], e = e.toRed(this.red);
    }
    if (t.lambda) i = new Be(t.lambda, 16);
    else {
      const o = this.xX(this.n);
      i = this.g.mul(o[0]).x.cmp(this.g.x.redMul(e)) === 0 ? o[0] : o[1];
    }
    return s = t.basis ? t.basis.map(((o) => ({ a: new Be(o.a, 16), b: new Be(o.b, 16) }))) : this.MX(i), { beta: e, lambda: i, basis: s };
  }
  xX(t) {
    const e = t === this.p ? this.red : Be.mont(t), i = new Be(2).toRed(e).redInvm(), s = i.redNeg(), o = new Be(3).toRed(e).redNeg().redSqrt().redMul(i);
    return [s.redAdd(o).fromRed(), s.redSub(o).fromRed()];
  }
  MX(t) {
    const e = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    let i, s, o, n, a, l, h, u, c, d = t, f = this.n.clone(), p = new Be(1), g = new Be(0), y = new Be(0), m = new Be(1), A = 0;
    for (; d.cmpn(0) !== 0; ) {
      const b = f.div(d);
      u = f.sub(b.mul(d)), c = y.sub(b.mul(p));
      const w = m.sub(b.mul(g));
      if (!o && u.cmp(e) < 0) i = h.neg(), s = p, o = u.neg(), n = c;
      else if (o && ++A == 2) break;
      h = u, f = d, d = u, y = p, p = c, m = g, g = w;
    }
    a = u.neg(), l = c;
    const v = o.sqr().add(n.sqr());
    return a.sqr().add(l.sqr()).cmp(v) >= 0 && (a = i, l = s), o.negative && (o = o.neg(), n = n.neg()), a.negative && (a = a.neg(), l = l.neg()), [{ a: o, b: n }, { a, b: l }];
  }
  _X(t) {
    const e = this.endo.basis, i = e[0], s = e[1], o = s.b.mul(t).divRound(this.n), n = i.b.neg().mul(t).divRound(this.n), a = o.mul(i.a), l = n.mul(s.a), h = o.mul(i.b), u = n.mul(s.b);
    return { k1: t.sub(a).sub(l), k2: h.add(u).neg() };
  }
  point(t, e, i) {
    return new Ru(this, t, e, i);
  }
  pointFromX(t, e) {
    (t = new Be(t, 16)).red || (t = t.toRed(this.red));
    const i = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b);
    let s = i.redSqrt();
    if (s.redSqr().redSub(i).cmp(this.zero) !== 0) throw new Error("invalid point");
    const o = s.fromRed().isOdd();
    return (e && !o || !e && o) && (s = s.redNeg()), this.point(t, s);
  }
  validate(t) {
    if (t.inf) return !0;
    const e = t.x, i = t.y, s = this.a.redMul(e), o = e.redSqr().redMul(e).redIAdd(s).redIAdd(this.b);
    return i.redSqr().redISub(o).cmpn(0) === 0;
  }
  wX(t, e, i) {
    const s = this.SX, o = this.bX;
    let n = 0;
    for (n = 0; n < t.length; n++) {
      const l = this._X(e[n]);
      let h = t[n], u = h.yX();
      l.k1.negative && (l.k1.ineg(), h = h.neg(!0)), l.k2.negative && (l.k2.ineg(), u = u.neg(!0)), s[2 * n] = h, s[2 * n + 1] = u, o[2 * n] = l.k1, o[2 * n + 1] = l.k2;
    }
    const a = this.gX(1, s, o, 2 * n, i);
    for (let l = 0; l < 2 * n; l++) s[l] = null, o[l] = null;
    return a;
  }
  jpoint(t, e, i) {
    return new t0(this, t, e, i);
  }
}
class Ru extends h1 {
  constructor(t, e, i, s) {
    super(t, "affine"), e === null && i === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new Be(e, 16), this.y = new Be(i, 16), s && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  pointFromX(t, e) {
    throw new Error("Method not implemented.");
  }
  point(t, e, i) {
    return new Ru(this, t, e, i);
  }
  yX() {
    if (!this.curve.endo) return;
    const t = this.precomputed;
    if (t && t.beta) return t.beta;
    const e = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (t) {
      const i = this.curve, s = function(o) {
        return i.point(o.x.redMul(i.endo.beta), o.y);
      };
      t.beta = e, e.precomputed = { beta: null, naf: t.naf && { wnd: t.naf.wnd, points: t.naf.points.map(s) }, doubles: t.doubles && { step: t.doubles.step, points: t.doubles.points.map(s) } };
    }
    return e;
  }
  toJSON() {
    return this.precomputed ? [this.x, this.y, this.precomputed && { doubles: this.precomputed.doubles && { step: this.precomputed.doubles.step, points: this.precomputed.doubles.points.slice(1) }, naf: this.precomputed.naf && { wnd: this.precomputed.naf.wnd, points: this.precomputed.naf.points.slice(1) } }] : [this.x, this.y];
  }
  static fromJSON(t, e, i) {
    typeof e == "string" && (e = JSON.parse(e));
    const s = t.point(e[0], e[1], i);
    if (!e[2]) return s;
    function o(a) {
      return t.point(a[0], a[1], i);
    }
    const n = e[2];
    return s.precomputed = { beta: null, doubles: n.doubles && { step: n.doubles.step, points: [s].concat(n.doubles.points.map(o)) }, naf: n.naf && { wnd: n.naf.wnd, points: [s].concat(n.naf.points.map(o)) } }, s;
  }
  inspect() {
    return this.isInfinity() ? "<EC Point Infinity>" : `<EC Point x: ${this.x.fromRed().toString(16, 2)} y: ${this.y.fromRed().toString(16, 2)}>`;
  }
  isInfinity() {
    return this.inf;
  }
  add(t) {
    if (this.inf) return t;
    if (t.inf) return this;
    if (this.eq(t)) return this.dbl();
    if (this.neg().eq(t)) return this.curve.point(null, null);
    if (this.x.cmp(t.x) === 0) return this.curve.point(null, null);
    let e = this.y.redSub(t.y);
    e.cmpn(0) !== 0 && (e = e.redMul(this.x.redSub(t.x).redInvm()));
    const i = e.redSqr().redISub(this.x).redISub(t.x), s = e.redMul(this.x.redSub(i)).redISub(this.y);
    return this.curve.point(i, s);
  }
  dbl() {
    if (this.inf) return this;
    const t = this.y.redAdd(this.y);
    if (t.cmpn(0) === 0) return this.curve.point(null, null);
    const e = this.curve.a, i = this.x.redSqr(), s = t.redInvm(), o = i.redAdd(i).redIAdd(i).redIAdd(e).redMul(s), n = o.redSqr().redISub(this.x.redAdd(this.x)), a = o.redMul(this.x.redSub(n)).redISub(this.y);
    return this.curve.point(n, a);
  }
  getX() {
    return this.x.fromRed();
  }
  getY() {
    return this.y.fromRed();
  }
  mul(t) {
    return t = new Be(t, 16), this.isInfinity() ? this : this.pX(t) ? this.curve.cX(this, t) : this.curve.endo ? this.curve.wX([this], [t]) : this.curve.fX(this, t);
  }
  mulAdd(t, e, i) {
    const s = [this, e], o = [t, i];
    return this.curve.endo ? this.curve.wX(s, o) : this.curve.gX(1, s, o, 2);
  }
  jmulAdd(t, e, i) {
    const s = [this, e], o = [t, i];
    return this.curve.endo ? this.curve.wX(s, o, !0) : this.curve.gX(1, s, o, 2, !0);
  }
  eq(t) {
    return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
  }
  neg(t) {
    if (this.inf) return this;
    const e = this.curve.point(this.x, this.y.redNeg());
    if (t && this.precomputed) {
      const i = this.precomputed, s = function(o) {
        return o.neg();
      };
      e.precomputed = { naf: i.naf && { wnd: i.naf.wnd, points: i.naf.points.map(s) }, doubles: i.doubles && { step: i.doubles.step, points: i.doubles.points.map(s) } };
    }
    return e;
  }
  toJ() {
    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
  }
}
class t0 extends h1 {
  constructor(t, e, i, s) {
    super(t, "jacobian"), e === null && i === null && s === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new Be(0)) : (this.x = new Be(e, 16), this.y = new Be(i, 16), this.z = new Be(s, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  getY() {
    throw new Error("Method not implemented.");
  }
  getX() {
    throw new Error("Method not implemented.");
  }
  pointFromX(t, e) {
    throw new Error("Method not implemented.");
  }
  point(t, e, i) {
    throw new Error("Method not implemented.");
  }
  jpoint(t, e, i) {
    return new t0(this, t, e, i);
  }
  toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    const t = this.z.redInvm(), e = t.redSqr(), i = this.x.redMul(e), s = this.y.redMul(e).redMul(t);
    return this.curve.point(i, s);
  }
  neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }
  add(t) {
    if (this.isInfinity()) return t;
    if (t.isInfinity()) return this;
    const e = t.z.redSqr(), i = this.z.redSqr(), s = this.x.redMul(e), o = t.x.redMul(i), n = this.y.redMul(e.redMul(t.z)), a = t.y.redMul(i.redMul(this.z)), l = s.redSub(o), h = n.redSub(a);
    if (l.cmpn(0) === 0) return h.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    const u = l.redSqr(), c = u.redMul(l), d = s.redMul(u), f = h.redSqr().redIAdd(c).redISub(d).redISub(d), p = h.redMul(d.redISub(f)).redISub(n.redMul(c)), g = this.z.redMul(t.z).redMul(l);
    return this.curve.jpoint(f, p, g);
  }
  mixedAdd(t) {
    if (this.isInfinity()) return t.toJ();
    if (t.isInfinity()) return this;
    const e = this.z.redSqr(), i = this.x, s = t.x.redMul(e), o = this.y, n = t.y.redMul(e).redMul(this.z), a = i.redSub(s), l = o.redSub(n);
    if (a.cmpn(0) === 0) return l.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    const h = a.redSqr(), u = h.redMul(a), c = i.redMul(h), d = l.redSqr().redIAdd(u).redISub(c).redISub(c), f = l.redMul(c.redISub(d)).redISub(o.redMul(u)), p = this.z.redMul(a);
    return this.curve.jpoint(d, f, p);
  }
  dblp(t) {
    if (t === 0) return this;
    if (this.isInfinity()) return this;
    if (!t) return this.dbl();
    if (this.curve.zeroA || this.curve.threeA) {
      let h = this;
      for (let u = 0; u < t; u++) h = h.dbl();
      return h;
    }
    const e = this.curve.a, i = this.curve.tinv;
    let s = this.x;
    const o = this.y;
    let n = this.z, a = n.redSqr().redSqr(), l = o.redAdd(o);
    for (let h = 0; h < t; h++) {
      const u = s.redSqr(), c = l.redSqr(), d = c.redSqr(), f = u.redAdd(u).redIAdd(u).redIAdd(e.redMul(a)), p = s.redMul(c), g = f.redSqr().redISub(p.redAdd(p)), y = p.redISub(g);
      let m = f.redMul(y);
      m = m.redIAdd(m).redISub(d);
      const A = l.redMul(n);
      h + 1 < t && (a = a.redMul(d)), s = g, n = A, l = m;
    }
    return this.curve.jpoint(s, l.redMul(i), n);
  }
  dbl() {
    return this.isInfinity() ? this : this.curve.zeroA ? this.kX() : this.curve.threeA ? this.CX() : this.TX();
  }
  kX() {
    let t, e, i;
    if (this.zOne) {
      const s = this.x.redSqr(), o = this.y.redSqr(), n = o.redSqr();
      let a = this.x.redAdd(o).redSqr().redISub(s).redISub(n);
      a = a.redIAdd(a);
      const l = s.redAdd(s).redIAdd(s), h = l.redSqr().redISub(a).redISub(a);
      let u = n.redIAdd(n);
      u = u.redIAdd(u), u = u.redIAdd(u), t = h, e = l.redMul(a.redISub(h)).redISub(u), i = this.y.redAdd(this.y);
    } else {
      const s = this.x.redSqr(), o = this.y.redSqr(), n = o.redSqr();
      let a = this.x.redAdd(o).redSqr().redISub(s).redISub(n);
      a = a.redIAdd(a);
      const l = s.redAdd(s).redIAdd(s), h = l.redSqr();
      let u = n.redIAdd(n);
      u = u.redIAdd(u), u = u.redIAdd(u), t = h.redISub(a).redISub(a), e = l.redMul(a.redISub(t)).redISub(u), i = this.y.redMul(this.z), i = i.redIAdd(i);
    }
    return this.curve.jpoint(t, e, i);
  }
  CX() {
    let t, e, i;
    if (this.zOne) {
      const s = this.x.redSqr(), o = this.y.redSqr(), n = o.redSqr();
      let a = this.x.redAdd(o).redSqr().redISub(s).redISub(n);
      a = a.redIAdd(a);
      const l = s.redAdd(s).redIAdd(s).redIAdd(this.curve.a), h = l.redSqr().redISub(a).redISub(a);
      t = h;
      let u = n.redIAdd(n);
      u = u.redIAdd(u), u = u.redIAdd(u), e = l.redMul(a.redISub(h)).redISub(u), i = this.y.redAdd(this.y);
    } else {
      const s = this.z.redSqr(), o = this.y.redSqr(), n = this.x.redMul(o);
      let a = this.x.redSub(s).redMul(this.x.redAdd(s));
      a = a.redAdd(a).redIAdd(a);
      let l = n.redIAdd(n);
      l = l.redIAdd(l);
      const h = l.redAdd(l);
      t = a.redSqr().redISub(h), i = this.y.redAdd(this.z).redSqr().redISub(o).redISub(s);
      let u = o.redSqr();
      u = u.redIAdd(u), u = u.redIAdd(u), u = u.redIAdd(u), e = a.redMul(l.redISub(t)).redISub(u);
    }
    return this.curve.jpoint(t, e, i);
  }
  TX() {
    const t = this.curve.a, e = this.x, i = this.y, s = this.z, o = s.redSqr().redSqr(), n = e.redSqr(), a = i.redSqr(), l = n.redAdd(n).redIAdd(n).redIAdd(t.redMul(o));
    let h = e.redAdd(e);
    h = h.redIAdd(h);
    const u = h.redMul(a), c = l.redSqr().redISub(u.redAdd(u)), d = u.redISub(c);
    let f = a.redSqr();
    f = f.redIAdd(f), f = f.redIAdd(f), f = f.redIAdd(f);
    const p = l.redMul(d).redISub(f), g = i.redAdd(i).redMul(s);
    return this.curve.jpoint(c, p, g);
  }
  trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    const t = this.x.redSqr(), e = this.y.redSqr(), i = this.z.redSqr(), s = e.redSqr(), o = t.redAdd(t).redIAdd(t), n = o.redSqr();
    let a = this.x.redAdd(e).redSqr().redISub(t).redISub(s);
    a = a.redIAdd(a), a = a.redAdd(a).redIAdd(a), a = a.redISub(n);
    const l = a.redSqr();
    let h = s.redIAdd(s);
    h = h.redIAdd(h), h = h.redIAdd(h), h = h.redIAdd(h);
    const u = o.redIAdd(a).redSqr().redISub(n).redISub(l).redISub(h);
    let c = e.redMul(u);
    c = c.redIAdd(c), c = c.redIAdd(c);
    let d = this.x.redMul(l).redISub(c);
    d = d.redIAdd(d), d = d.redIAdd(d);
    let f = this.y.redMul(u.redMul(h.redISub(u)).redISub(a.redMul(l)));
    f = f.redIAdd(f), f = f.redIAdd(f), f = f.redIAdd(f);
    const p = this.z.redAdd(a).redSqr().redISub(i).redISub(l);
    return this.curve.jpoint(d, f, p);
  }
  mul(t, e) {
    return t = new Be(t, e), this.curve.fX(this, t);
  }
  eq(t) {
    if (t.type === "affine") return this.eq(t.toJ());
    if (this === t) return !0;
    const e = this.z.redSqr(), i = t.z.redSqr();
    if (this.x.redMul(i).redISub(t.x.redMul(e)).cmpn(0) !== 0) return !1;
    const s = e.redMul(this.z), o = i.redMul(t.z);
    return this.y.redMul(o).redISub(t.y.redMul(s)).cmpn(0) === 0;
  }
  eqXToP(t) {
    const e = this.z.redSqr(), i = t.toRed(this.curve.red).redMul(e);
    if (this.x.cmp(i) === 0) return !0;
    const s = t.clone(), o = this.curve.redN.redMul(e);
    for (; ; ) {
      if (s.iadd(this.curve.n), s.cmp(this.curve.p) >= 0) return !1;
      if (i.redIAdd(o), this.x.cmp(i) === 0) return !0;
    }
  }
  inspect() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : `<EC JPoint x: ${this.x.toString(16, 2)} y: ${this.y.toString(16, 2)} z: ${this.z.toString(16, 2)}>`;
  }
  isInfinity() {
    return this.z.cmpn(0) === 0;
  }
}
class Vp {
  constructor(t) {
    this.curve = new kC(t), this.g = this.curve.g, this.n = this.curve.n;
  }
}
const Dl = {};
var Yc, _p;
Dl.PresetCurve = Vp, Yc = "secp256k1", _p = { type: "short", prime: "k256", p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f", a: "0", b: "7", n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141", h: "1", beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee", lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72", basis: [{ a: "3086d221a7d46bcde86c90e49284eb15", b: "-e4437ed6010e88286f547fa90abfe4c3" }, { a: "114ca50f7a8e2f3f657c1108d9d44cfd8", b: "3086d221a7d46bcde86c90e49284eb15" }], gRed: !1, g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", { doubles: { step: 4, points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]] }, naf: { wnd: 7, points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]] } }] }, Object.defineProperty(Dl, Yc, { configurable: !0, enumerable: !0, get() {
  const r = new Vp(_p);
  return Object.defineProperty(Dl, Yc, { configurable: !0, enumerable: !0, value: r }), r;
} });
class Iu {
  constructor(t, e) {
    this.ec = t, this.priv = null, this.pub = null, e.pub && this.FX(e.pub, e.pubEnc);
  }
  static fromPublic(t, e, i) {
    return e instanceof Iu ? e : new Iu(t, { pub: e, pubEnc: i });
  }
  validate() {
    const t = this.getPublic();
    return t.isInfinity() ? { result: !1, reason: "Invalid public key" } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }
  getPublic(t, e) {
    return typeof t == "string" && (e = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), e ? this.pub.encode(e, t) : this.pub;
  }
  FX(t, e) {
    if (t.x || t.y) return this.ec.curve.type === "mont" || this.ec.curve.type === "short" || this.ec.curve.type, void (this.pub = this.ec.curve.point(t.x, t.y));
    this.pub = this.ec.curve.decodePoint(t, e);
  }
  verify(t, e) {
    return this.ec.verify(t, e, this);
  }
}
function jc(r, t) {
  const e = r[t.place++];
  if (!(128 & e)) return e;
  const i = 15 & e;
  if (i === 0 || i > 4) return !1;
  let s = 0, o = t.place;
  for (let n = 0; n < i; n++, o++) s <<= 8, s |= r[o], s >>>= 0;
  return !(s <= 127) && (t.place = o, s);
}
class DC {
  constructor() {
    this.place = 0;
  }
}
class e0 {
  constructor(t, e) {
    if (t instanceof e0) return t;
    this.IX(t, e) || (this.r = new Be(t.r, 16), this.s = new Be(t.s, 16), t.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = t.recoveryParam);
  }
  IX(t, e) {
    t = l1(t, e);
    const i = new DC();
    if (t[i.place++] !== 48) return !1;
    const s = jc(t, i);
    if (s === !1 || s + i.place !== t.length || t[i.place++] !== 2) return !1;
    const o = jc(t, i);
    if (o === !1) return !1;
    let n = t.slice(i.place, o + i.place);
    if (i.place += o, t[i.place++] !== 2) return !1;
    const a = jc(t, i);
    if (a === !1 || t.length !== a + i.place) return !1;
    let l = t.slice(i.place, a + i.place);
    if (n[0] === 0) {
      if (!(128 & n[1])) return !1;
      n = n.slice(1);
    }
    if (l[0] === 0) {
      if (!(128 & l[1])) return !1;
      l = l.slice(1);
    }
    return this.r = new Be(n), this.s = new Be(l), this.recoveryParam = null, !0;
  }
}
let FC = class Id {
  constructor(t) {
    if (!(this instanceof Id)) return new Id(t);
    typeof t == "string" && (t = Dl[t]), t instanceof Dl.PresetCurve && (t = { curve: t }), this.curve = t.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = t.curve.g, this.g.precompute(t.curve.n.bitLength() + 1);
  }
  keyFromPublic(t, e) {
    return Iu.fromPublic(this, t, e);
  }
  PX(t, e) {
    const i = 8 * t.byteLength() - this.n.bitLength();
    return i > 0 && (t = t.ushrn(i)), !e && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
  }
  verify(t, e, i, s) {
    t = this.PX(new Be(t, 16)), i = this.keyFromPublic(i, s);
    const o = (e = new e0(e, "hex")).r, n = e.s;
    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0 || n.cmpn(1) < 0 || n.cmp(this.n) >= 0) return !1;
    const a = n.invm(this.n), l = a.mul(t).umod(this.n), h = a.mul(o).umod(this.n);
    if (!this.curve.uX) {
      const c = this.g.mulAdd(l, i.getPublic(), h);
      return !c.isInfinity() && c.getX().umod(this.n).cmp(o) === 0;
    }
    const u = this.g.jmulAdd(l, i.getPublic(), h);
    return !u.isInfinity() && u.eqXToP(o);
  }
};
var $c, u1 = { exports: {} }, Us = { exports: {} };
Us.exports = ($c = $c || (function(r, t) {
  var e;
  if (typeof window < "u" && window.crypto && (e = window.crypto), typeof self < "u" && self.crypto && (e = self.crypto), typeof globalThis < "u" && globalThis.crypto && (e = globalThis.crypto), !e && typeof window < "u" && window.msCrypto && (e = window.msCrypto), !e && uu !== void 0 && uu.crypto && (e = uu.crypto), !e) try {
    e = t;
  } catch {
  }
  var i = function() {
    if (e) {
      if (typeof e.getRandomValues == "function") try {
        return e.getRandomValues(new Uint32Array(1))[0];
      } catch {
      }
      if (typeof e.randomBytes == "function") try {
        return e.randomBytes(4).readInt32LE();
      } catch {
      }
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
  }, s = Object.create || /* @__PURE__ */ (function() {
    function g() {
    }
    return function(y) {
      var m;
      return g.prototype = y, m = new g(), g.prototype = null, m;
    };
  })(), o = {}, n = o.lib = {}, a = n.Base = { extend: function(g) {
    var y = s(this);
    return g && y.mixIn(g), y.hasOwnProperty("init") && this.init !== y.init || (y.init = function() {
      y.$super.init.apply(this, arguments);
    }), y.init.prototype = y, y.$super = this, y;
  }, create: function() {
    var g = this.extend();
    return g.init.apply(g, arguments), g;
  }, init: function() {
  }, mixIn: function(g) {
    for (var y in g) g.hasOwnProperty(y) && (this[y] = g[y]);
    g.hasOwnProperty("toString") && (this.toString = g.toString);
  }, clone: function() {
    return this.init.prototype.extend(this);
  } }, l = n.WordArray = a.extend({ init: function(g, y) {
    g = this.words = g || [], this.sigBytes = y != t ? y : 4 * g.length;
  }, toString: function(g) {
    return (g || u).stringify(this);
  }, concat: function(g) {
    var y = this.words, m = g.words, A = this.sigBytes, v = g.sigBytes;
    if (this.clamp(), A % 4) for (var b = 0; b < v; b++) {
      var w = m[b >>> 2] >>> 24 - b % 4 * 8 & 255;
      y[A + b >>> 2] |= w << 24 - (A + b) % 4 * 8;
    }
    else for (var k = 0; k < v; k += 4) y[A + k >>> 2] = m[k >>> 2];
    return this.sigBytes += v, this;
  }, clamp: function() {
    var g = this.words, y = this.sigBytes;
    g[y >>> 2] &= 4294967295 << 32 - y % 4 * 8, g.length = r.ceil(y / 4);
  }, clone: function() {
    var g = a.clone.call(this);
    return g.words = this.words.slice(0), g;
  }, random: function(g) {
    for (var y = [], m = 0; m < g; m += 4) y.push(i());
    return new l.init(y, g);
  } }), h = o.enc = {}, u = h.Hex = { stringify: function(g) {
    for (var y = g.words, m = g.sigBytes, A = [], v = 0; v < m; v++) {
      var b = y[v >>> 2] >>> 24 - v % 4 * 8 & 255;
      A.push((b >>> 4).toString(16)), A.push((15 & b).toString(16));
    }
    return A.join("");
  }, parse: function(g) {
    for (var y = g.length, m = [], A = 0; A < y; A += 2) m[A >>> 3] |= parseInt(g.substr(A, 2), 16) << 24 - A % 8 * 4;
    return new l.init(m, y / 2);
  } }, c = h.Latin1 = { stringify: function(g) {
    for (var y = g.words, m = g.sigBytes, A = [], v = 0; v < m; v++) {
      var b = y[v >>> 2] >>> 24 - v % 4 * 8 & 255;
      A.push(String.fromCharCode(b));
    }
    return A.join("");
  }, parse: function(g) {
    for (var y = g.length, m = [], A = 0; A < y; A++) m[A >>> 2] |= (255 & g.charCodeAt(A)) << 24 - A % 4 * 8;
    return new l.init(m, y);
  } }, d = h.Utf8 = { stringify: function(g) {
    try {
      return decodeURIComponent(escape(c.stringify(g)));
    } catch {
      throw new Error("Malformed UTF-8 data");
    }
  }, parse: function(g) {
    return c.parse(unescape(encodeURIComponent(g)));
  } }, f = n.BufferedBlockAlgorithm = a.extend({ reset: function() {
    this.NM = new l.init(), this.LX = 0;
  }, BX: function(g) {
    typeof g == "string" && (g = d.parse(g)), this.NM.concat(g), this.LX += g.sigBytes;
  }, DX: function(g) {
    var y, m = this.NM, A = m.words, v = m.sigBytes, b = this.blockSize, w = v / (4 * b), k = (w = g ? r.ceil(w) : r.max((0 | w) - this.EX, 0)) * b, R = r.min(4 * k, v);
    if (k) {
      for (var L = 0; L < k; L += b) this.RX(A, L);
      y = A.splice(0, k), m.sigBytes -= R;
    }
    return new l.init(y, R);
  }, clone: function() {
    var g = a.clone.call(this);
    return g.NM = this.NM.clone(), g;
  }, EX: 0 });
  n.Hasher = f.extend({ cfg: a.extend(), init: function(g) {
    this.cfg = this.cfg.extend(g), this.reset();
  }, reset: function() {
    f.reset.call(this), this.OX();
  }, update: function(g) {
    return this.BX(g), this.DX(), this;
  }, finalize: function(g) {
    return g && this.BX(g), this.zX();
  }, blockSize: 16, VX: function(g) {
    return function(y, m) {
      return new g.init(m).finalize(y);
    };
  }, NX: function(g) {
    return function(y, m) {
      return new p.HMAC.init(g, m).finalize(y);
    };
  } });
  var p = o.algo = {};
  return o;
})(Math), $c);
var c1 = { exports: {} };
c1.exports = (function(r) {
  return (function(t) {
    var e = r, i = e.lib, s = i.WordArray, o = i.Hasher, n = e.algo, a = [], l = [];
    (function() {
      function c(g) {
        for (var y = t.sqrt(g), m = 2; m <= y; m++) if (!(g % m)) return !1;
        return !0;
      }
      function d(g) {
        return 4294967296 * (g - (0 | g)) | 0;
      }
      for (var f = 2, p = 0; p < 64; ) c(f) && (p < 8 && (a[p] = d(t.pow(f, 0.5))), l[p] = d(t.pow(f, 1 / 3)), p++), f++;
    })();
    var h = [], u = n.SHA256 = o.extend({ OX: function() {
      this.GX = new s.init(a.slice(0));
    }, RX: function(c, d) {
      for (var f = this.GX.words, p = f[0], g = f[1], y = f[2], m = f[3], A = f[4], v = f[5], b = f[6], w = f[7], k = 0; k < 64; k++) {
        if (k < 16) h[k] = 0 | c[d + k];
        else {
          var R = h[k - 15], L = (R << 25 | R >>> 7) ^ (R << 14 | R >>> 18) ^ R >>> 3, x = h[k - 2], M = (x << 15 | x >>> 17) ^ (x << 13 | x >>> 19) ^ x >>> 10;
          h[k] = L + h[k - 7] + M + h[k - 16];
        }
        var C = p & g ^ p & y ^ g & y, S = (p << 30 | p >>> 2) ^ (p << 19 | p >>> 13) ^ (p << 10 | p >>> 22), E = w + ((A << 26 | A >>> 6) ^ (A << 21 | A >>> 11) ^ (A << 7 | A >>> 25)) + (A & v ^ ~A & b) + l[k] + h[k];
        w = b, b = v, v = A, A = m + E | 0, m = y, y = g, g = p, p = E + (S + C) | 0;
      }
      f[0] = f[0] + p | 0, f[1] = f[1] + g | 0, f[2] = f[2] + y | 0, f[3] = f[3] + m | 0, f[4] = f[4] + A | 0, f[5] = f[5] + v | 0, f[6] = f[6] + b | 0, f[7] = f[7] + w | 0;
    }, zX: function() {
      var c = this.NM, d = c.words, f = 8 * this.LX, p = 8 * c.sigBytes;
      return d[p >>> 5] |= 128 << 24 - p % 32, d[14 + (p + 64 >>> 9 << 4)] = t.floor(f / 4294967296), d[15 + (p + 64 >>> 9 << 4)] = f, c.sigBytes = 4 * d.length, this.DX(), this.GX;
    }, clone: function() {
      var c = o.clone.call(this);
      return c.GX = this.GX.clone(), c;
    } });
    e.SHA256 = o.VX(u), e.HmacSHA256 = o.NX(u);
  })(Math), r.SHA256;
})(Us.exports);
var Jh = c1.exports;
u1.exports = (function(r) {
  return e = (t = r).lib.WordArray, i = t.algo, s = i.SHA256, o = i.SHA224 = s.extend({ OX: function() {
    this.GX = new e.init([3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428]);
  }, zX: function() {
    var n = s.zX.call(this);
    return n.sigBytes -= 4, n;
  } }), t.SHA224 = s.VX(o), t.HmacSHA224 = s.NX(o), r.SHA224;
  var t, e, i, s, o;
})(Us.exports);
var LC = u1.exports, d1 = { exports: {} };
d1.exports = Us.exports.enc.Hex;
var Hn = d1.exports, f1 = { exports: {} };
f1.exports = Us.exports.enc.Utf8;
var Op = f1.exports, g1 = { exports: {} };
(function(r) {
  return e = (t = r).lib.WordArray, t.enc.Base64 = { stringify: function(i) {
    var s = i.words, o = i.sigBytes, n = this.$X;
    i.clamp();
    for (var a = [], l = 0; l < o; l += 3) for (var h = (s[l >>> 2] >>> 24 - l % 4 * 8 & 255) << 16 | (s[l + 1 >>> 2] >>> 24 - (l + 1) % 4 * 8 & 255) << 8 | s[l + 2 >>> 2] >>> 24 - (l + 2) % 4 * 8 & 255, u = 0; u < 4 && l + 0.75 * u < o; u++) a.push(n.charAt(h >>> 6 * (3 - u) & 63));
    var c = n.charAt(64);
    if (c) for (; a.length % 4; ) a.push(c);
    return a.join("");
  }, parse: function(i) {
    var s = i.length, o = this.$X, n = this.UX;
    if (!n) {
      n = this.UX = [];
      for (var a = 0; a < o.length; a++) n[o.charCodeAt(a)] = a;
    }
    var l = o.charAt(64);
    if (l) {
      var h = i.indexOf(l);
      h !== -1 && (s = h);
    }
    return (function(u, c, d) {
      for (var f = [], p = 0, g = 0; g < c; g++) if (g % 4) {
        var y = d[u.charCodeAt(g - 1)] << g % 4 * 2 | d[u.charCodeAt(g)] >>> 6 - g % 4 * 2;
        f[p >>> 2] |= y << 24 - p % 4 * 8, p++;
      }
      return e.create(f, p);
    })(i, s, n);
  }, $X: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" }, r.enc.Base64;
  var t, e;
})(Us.exports);
(function(r) {
  (function(t) {
    var e = r, i = e.lib, s = i.WordArray, o = i.Hasher, n = e.algo, a = [];
    (function() {
      for (var f = 0; f < 64; f++) a[f] = 4294967296 * t.abs(t.sin(f + 1)) | 0;
    })();
    var l = n.MD5 = o.extend({ OX: function() {
      this.GX = new s.init([1732584193, 4023233417, 2562383102, 271733878]);
    }, RX: function(f, p) {
      for (var g = 0; g < 16; g++) {
        var y = p + g, m = f[y];
        f[y] = 16711935 & (m << 8 | m >>> 24) | 4278255360 & (m << 24 | m >>> 8);
      }
      var A = this.GX.words, v = f[p + 0], b = f[p + 1], w = f[p + 2], k = f[p + 3], R = f[p + 4], L = f[p + 5], x = f[p + 6], M = f[p + 7], C = f[p + 8], S = f[p + 9], E = f[p + 10], T = f[p + 11], I = f[p + 12], F = f[p + 13], D = f[p + 14], P = f[p + 15], V = A[0], _ = A[1], O = A[2], B = A[3];
      V = h(V, _, O, B, v, 7, a[0]), B = h(B, V, _, O, b, 12, a[1]), O = h(O, B, V, _, w, 17, a[2]), _ = h(_, O, B, V, k, 22, a[3]), V = h(V, _, O, B, R, 7, a[4]), B = h(B, V, _, O, L, 12, a[5]), O = h(O, B, V, _, x, 17, a[6]), _ = h(_, O, B, V, M, 22, a[7]), V = h(V, _, O, B, C, 7, a[8]), B = h(B, V, _, O, S, 12, a[9]), O = h(O, B, V, _, E, 17, a[10]), _ = h(_, O, B, V, T, 22, a[11]), V = h(V, _, O, B, I, 7, a[12]), B = h(B, V, _, O, F, 12, a[13]), O = h(O, B, V, _, D, 17, a[14]), V = u(V, _ = h(_, O, B, V, P, 22, a[15]), O, B, b, 5, a[16]), B = u(B, V, _, O, x, 9, a[17]), O = u(O, B, V, _, T, 14, a[18]), _ = u(_, O, B, V, v, 20, a[19]), V = u(V, _, O, B, L, 5, a[20]), B = u(B, V, _, O, E, 9, a[21]), O = u(O, B, V, _, P, 14, a[22]), _ = u(_, O, B, V, R, 20, a[23]), V = u(V, _, O, B, S, 5, a[24]), B = u(B, V, _, O, D, 9, a[25]), O = u(O, B, V, _, k, 14, a[26]), _ = u(_, O, B, V, C, 20, a[27]), V = u(V, _, O, B, F, 5, a[28]), B = u(B, V, _, O, w, 9, a[29]), O = u(O, B, V, _, M, 14, a[30]), V = c(V, _ = u(_, O, B, V, I, 20, a[31]), O, B, L, 4, a[32]), B = c(B, V, _, O, C, 11, a[33]), O = c(O, B, V, _, T, 16, a[34]), _ = c(_, O, B, V, D, 23, a[35]), V = c(V, _, O, B, b, 4, a[36]), B = c(B, V, _, O, R, 11, a[37]), O = c(O, B, V, _, M, 16, a[38]), _ = c(_, O, B, V, E, 23, a[39]), V = c(V, _, O, B, F, 4, a[40]), B = c(B, V, _, O, v, 11, a[41]), O = c(O, B, V, _, k, 16, a[42]), _ = c(_, O, B, V, x, 23, a[43]), V = c(V, _, O, B, S, 4, a[44]), B = c(B, V, _, O, I, 11, a[45]), O = c(O, B, V, _, P, 16, a[46]), V = d(V, _ = c(_, O, B, V, w, 23, a[47]), O, B, v, 6, a[48]), B = d(B, V, _, O, M, 10, a[49]), O = d(O, B, V, _, D, 15, a[50]), _ = d(_, O, B, V, L, 21, a[51]), V = d(V, _, O, B, I, 6, a[52]), B = d(B, V, _, O, k, 10, a[53]), O = d(O, B, V, _, E, 15, a[54]), _ = d(_, O, B, V, b, 21, a[55]), V = d(V, _, O, B, C, 6, a[56]), B = d(B, V, _, O, P, 10, a[57]), O = d(O, B, V, _, x, 15, a[58]), _ = d(_, O, B, V, F, 21, a[59]), V = d(V, _, O, B, R, 6, a[60]), B = d(B, V, _, O, T, 10, a[61]), O = d(O, B, V, _, w, 15, a[62]), _ = d(_, O, B, V, S, 21, a[63]), A[0] = A[0] + V | 0, A[1] = A[1] + _ | 0, A[2] = A[2] + O | 0, A[3] = A[3] + B | 0;
    }, zX: function() {
      var f = this.NM, p = f.words, g = 8 * this.LX, y = 8 * f.sigBytes;
      p[y >>> 5] |= 128 << 24 - y % 32;
      var m = t.floor(g / 4294967296), A = g;
      p[15 + (y + 64 >>> 9 << 4)] = 16711935 & (m << 8 | m >>> 24) | 4278255360 & (m << 24 | m >>> 8), p[14 + (y + 64 >>> 9 << 4)] = 16711935 & (A << 8 | A >>> 24) | 4278255360 & (A << 24 | A >>> 8), f.sigBytes = 4 * (p.length + 1), this.DX();
      for (var v = this.GX, b = v.words, w = 0; w < 4; w++) {
        var k = b[w];
        b[w] = 16711935 & (k << 8 | k >>> 24) | 4278255360 & (k << 24 | k >>> 8);
      }
      return v;
    }, clone: function() {
      var f = o.clone.call(this);
      return f.GX = this.GX.clone(), f;
    } });
    function h(f, p, g, y, m, A, v) {
      var b = f + (p & g | ~p & y) + m + v;
      return (b << A | b >>> 32 - A) + p;
    }
    function u(f, p, g, y, m, A, v) {
      var b = f + (p & y | g & ~y) + m + v;
      return (b << A | b >>> 32 - A) + p;
    }
    function c(f, p, g, y, m, A, v) {
      var b = f + (p ^ g ^ y) + m + v;
      return (b << A | b >>> 32 - A) + p;
    }
    function d(f, p, g, y, m, A, v) {
      var b = f + (g ^ (p | ~y)) + m + v;
      return (b << A | b >>> 32 - A) + p;
    }
    e.MD5 = o.VX(l), e.HmacMD5 = o.NX(l);
  })(Math), r.MD5;
})(Us.exports);
(function(r) {
  return e = (t = r).lib, i = e.WordArray, s = e.Hasher, o = t.algo, n = [], a = o.SHA1 = s.extend({ OX: function() {
    this.GX = new i.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
  }, RX: function(l, h) {
    for (var u = this.GX.words, c = u[0], d = u[1], f = u[2], p = u[3], g = u[4], y = 0; y < 80; y++) {
      if (y < 16) n[y] = 0 | l[h + y];
      else {
        var m = n[y - 3] ^ n[y - 8] ^ n[y - 14] ^ n[y - 16];
        n[y] = m << 1 | m >>> 31;
      }
      var A = (c << 5 | c >>> 27) + g + n[y];
      A += y < 20 ? 1518500249 + (d & f | ~d & p) : y < 40 ? 1859775393 + (d ^ f ^ p) : y < 60 ? (d & f | d & p | f & p) - 1894007588 : (d ^ f ^ p) - 899497514, g = p, p = f, f = d << 30 | d >>> 2, d = c, c = A;
    }
    u[0] = u[0] + c | 0, u[1] = u[1] + d | 0, u[2] = u[2] + f | 0, u[3] = u[3] + p | 0, u[4] = u[4] + g | 0;
  }, zX: function() {
    var l = this.NM, h = l.words, u = 8 * this.LX, c = 8 * l.sigBytes;
    return h[c >>> 5] |= 128 << 24 - c % 32, h[14 + (c + 64 >>> 9 << 4)] = Math.floor(u / 4294967296), h[15 + (c + 64 >>> 9 << 4)] = u, l.sigBytes = 4 * h.length, this.DX(), this.GX;
  }, clone: function() {
    var l = s.clone.call(this);
    return l.GX = this.GX.clone(), l;
  } }), t.SHA1 = s.VX(a), t.HmacSHA1 = s.NX(a), r.SHA1;
  var t, e, i, s, o, n, a;
})(Us.exports);
var Xc, Np, Bp;
Np = (Xc = Us.exports).lib.Base, Bp = Xc.enc.Utf8, Xc.algo.HMAC = Np.extend({ init: function(r, t) {
  r = this.jX = new r.init(), typeof t == "string" && (t = Bp.parse(t));
  var e = r.blockSize, i = 4 * e;
  t.sigBytes > i && (t = r.finalize(t)), t.clamp();
  for (var s = this.YX = t.clone(), o = this.HX = t.clone(), n = s.words, a = o.words, l = 0; l < e; l++) n[l] ^= 1549556828, a[l] ^= 909522486;
  s.sigBytes = o.sigBytes = i, this.reset();
}, reset: function() {
  var r = this.jX;
  r.reset(), r.update(this.HX);
}, update: function(r) {
  return this.jX.update(r), this;
}, finalize: function(r) {
  var t = this.jX, e = t.finalize(r);
  return t.reset(), t.finalize(this.YX.clone().concat(e));
} }), (function(r) {
  return i = (e = (t = r).lib).Base, s = e.WordArray, n = (o = t.algo).MD5, a = o.EvpKDF = i.extend({ cfg: i.extend({ keySize: 4, hasher: n, iterations: 1 }), init: function(l) {
    this.cfg = this.cfg.extend(l);
  }, compute: function(l, h) {
    for (var u, c = this.cfg, d = c.hasher.create(), f = s.create(), p = f.words, g = c.keySize, y = c.iterations; p.length < g; ) {
      u && d.update(u), u = d.update(l).finalize(h), d.reset();
      for (var m = 1; m < y; m++) u = d.finalize(u), d.reset();
      f.concat(u);
    }
    return f.sigBytes = 4 * g, f;
  } }), t.EvpKDF = function(l, h, u) {
    return a.create(u).compute(l, h);
  }, r.EvpKDF;
  var t, e, i, s, o, n, a;
})(Us.exports);
(function(r) {
  r.lib.Cipher || (function() {
    var t = r, e = t.lib, i = e.Base, s = e.WordArray, o = e.BufferedBlockAlgorithm, n = t.enc;
    n.Utf8;
    var a = n.Base64, l = t.algo.EvpKDF, h = e.Cipher = o.extend({ cfg: i.extend(), createEncryptor: function(v, b) {
      return this.create(this.WX, v, b);
    }, createDecryptor: function(v, b) {
      return this.create(this.XX, v, b);
    }, init: function(v, b, w) {
      this.cfg = this.cfg.extend(w), this.ZX = v, this.JX = b, this.reset();
    }, reset: function() {
      o.reset.call(this), this.OX();
    }, process: function(v) {
      return this.BX(v), this.DX();
    }, finalize: function(v) {
      return v && this.BX(v), this.zX();
    }, keySize: 4, ivSize: 4, WX: 1, XX: 2, VX: /* @__PURE__ */ (function() {
      function v(b) {
        return typeof b == "string" ? A : y;
      }
      return function(b) {
        return { encrypt: function(w, k, R) {
          return v(k).encrypt(b, w, k, R);
        }, decrypt: function(w, k, R) {
          return v(k).decrypt(b, w, k, R);
        } };
      };
    })() });
    e.StreamCipher = h.extend({ zX: function() {
      return this.DX(!0);
    }, blockSize: 1 });
    var u = t.mode = {}, c = e.BlockCipherMode = i.extend({ createEncryptor: function(v, b) {
      return this.Encryptor.create(v, b);
    }, createDecryptor: function(v, b) {
      return this.Decryptor.create(v, b);
    }, init: function(v, b) {
      this.QX = v, this.KX = b;
    } }), d = u.CBC = (function() {
      var v = c.extend();
      function b(w, k, R) {
        var L, x = this.KX;
        x ? (L = x, this.KX = void 0) : L = this.qX;
        for (var M = 0; M < R; M++) w[k + M] ^= L[M];
      }
      return v.Encryptor = v.extend({ processBlock: function(w, k) {
        var R = this.QX, L = R.blockSize;
        b.call(this, w, k, L), R.encryptBlock(w, k), this.qX = w.slice(k, k + L);
      } }), v.Decryptor = v.extend({ processBlock: function(w, k) {
        var R = this.QX, L = R.blockSize, x = w.slice(k, k + L);
        R.decryptBlock(w, k), b.call(this, w, k, L), this.qX = x;
      } }), v;
    })(), f = (t.pad = {}).Pkcs7 = { pad: function(v, b) {
      for (var w = 4 * b, k = w - v.sigBytes % w, R = k << 24 | k << 16 | k << 8 | k, L = [], x = 0; x < k; x += 4) L.push(R);
      var M = s.create(L, k);
      v.concat(M);
    }, unpad: function(v) {
      var b = 255 & v.words[v.sigBytes - 1 >>> 2];
      v.sigBytes -= b;
    } };
    e.BlockCipher = h.extend({ cfg: h.cfg.extend({ mode: d, padding: f }), reset: function() {
      var v;
      h.reset.call(this);
      var b = this.cfg, w = b.iv, k = b.mode;
      this.ZX == this.WX ? v = k.createEncryptor : (v = k.createDecryptor, this.EX = 1), this.tZ && this.tZ.iZ == v ? this.tZ.init(this, w && w.words) : (this.tZ = v.call(k, this, w && w.words), this.tZ.iZ = v);
    }, RX: function(v, b) {
      this.tZ.processBlock(v, b);
    }, zX: function() {
      var v, b = this.cfg.padding;
      return this.ZX == this.WX ? (b.pad(this.NM, this.blockSize), v = this.DX(!0)) : (v = this.DX(!0), b.unpad(v)), v;
    }, blockSize: 4 });
    var p = e.CipherParams = i.extend({ init: function(v) {
      this.mixIn(v);
    }, toString: function(v) {
      return (v || this.formatter).stringify(this);
    } }), g = (t.format = {}).OpenSSL = { stringify: function(v) {
      var b = v.ciphertext, w = v.salt;
      return (w ? s.create([1398893684, 1701076831]).concat(w).concat(b) : b).toString(a);
    }, parse: function(v) {
      var b, w = a.parse(v), k = w.words;
      return k[0] == 1398893684 && k[1] == 1701076831 && (b = s.create(k.slice(2, 4)), k.splice(0, 4), w.sigBytes -= 16), p.create({ ciphertext: w, salt: b });
    } }, y = e.SerializableCipher = i.extend({ cfg: i.extend({ format: g }), encrypt: function(v, b, w, k) {
      k = this.cfg.extend(k);
      var R = v.createEncryptor(w, k), L = R.finalize(b), x = R.cfg;
      return p.create({ ciphertext: L, key: w, iv: x.iv, algorithm: v, mode: x.mode, padding: x.padding, blockSize: v.blockSize, formatter: k.format });
    }, decrypt: function(v, b, w, k) {
      return k = this.cfg.extend(k), b = this.sZ(b, k.format), v.createDecryptor(w, k).finalize(b.ciphertext);
    }, sZ: function(v, b) {
      return typeof v == "string" ? b.parse(v, this) : v;
    } }), m = (t.kdf = {}).OpenSSL = { execute: function(v, b, w, k) {
      k || (k = s.random(8));
      var R = l.create({ keySize: b + w }).compute(v, k), L = s.create(R.words.slice(b), 4 * w);
      return R.sigBytes = 4 * b, p.create({ key: R, iv: L, salt: k });
    } }, A = e.PasswordBasedCipher = y.extend({ cfg: y.cfg.extend({ kdf: m }), encrypt: function(v, b, w, k) {
      var R = (k = this.cfg.extend(k)).kdf.execute(w, v.keySize, v.ivSize);
      k.iv = R.iv;
      var L = y.encrypt.call(this, v, b, R.key, k);
      return L.mixIn(R), L;
    }, decrypt: function(v, b, w, k) {
      k = this.cfg.extend(k), b = this.sZ(b, k.format);
      var R = k.kdf.execute(w, v.keySize, v.ivSize, b.salt);
      return k.iv = R.iv, y.decrypt.call(this, v, b, R.key, k);
    } });
  })();
})(Us.exports), g1.exports = (function(r) {
  return (function() {
    var t = r, e = t.lib.BlockCipher, i = t.algo, s = [], o = [], n = [], a = [], l = [], h = [], u = [], c = [], d = [], f = [];
    (function() {
      for (var y = [], m = 0; m < 256; m++) y[m] = m < 128 ? m << 1 : m << 1 ^ 283;
      var A = 0, v = 0;
      for (m = 0; m < 256; m++) {
        var b = v ^ v << 1 ^ v << 2 ^ v << 3 ^ v << 4;
        b = b >>> 8 ^ 255 & b ^ 99, s[A] = b, o[b] = A;
        var w = y[A], k = y[w], R = y[k], L = 257 * y[b] ^ 16843008 * b;
        n[A] = L << 24 | L >>> 8, a[A] = L << 16 | L >>> 16, l[A] = L << 8 | L >>> 24, h[A] = L, L = 16843009 * R ^ 65537 * k ^ 257 * w ^ 16843008 * A, u[b] = L << 24 | L >>> 8, c[b] = L << 16 | L >>> 16, d[b] = L << 8 | L >>> 24, f[b] = L, A ? (A = w ^ y[y[y[R ^ w]]], v ^= y[y[v]]) : A = v = 1;
      }
    })();
    var p = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], g = i.AES = e.extend({ OX: function() {
      if (!this.eZ || this.rZ !== this.JX) {
        for (var y = this.rZ = this.JX, m = y.words, A = y.sigBytes / 4, v = 4 * ((this.eZ = A + 6) + 1), b = this.hZ = [], w = 0; w < v; w++) w < A ? b[w] = m[w] : (L = b[w - 1], w % A ? A > 6 && w % A == 4 && (L = s[L >>> 24] << 24 | s[L >>> 16 & 255] << 16 | s[L >>> 8 & 255] << 8 | s[255 & L]) : (L = s[(L = L << 8 | L >>> 24) >>> 24] << 24 | s[L >>> 16 & 255] << 16 | s[L >>> 8 & 255] << 8 | s[255 & L], L ^= p[w / A | 0] << 24), b[w] = b[w - A] ^ L);
        for (var k = this.nZ = [], R = 0; R < v; R++) {
          if (w = v - R, R % 4) var L = b[w];
          else L = b[w - 4];
          k[R] = R < 4 || w <= 4 ? L : u[s[L >>> 24]] ^ c[s[L >>> 16 & 255]] ^ d[s[L >>> 8 & 255]] ^ f[s[255 & L]];
        }
      }
    }, encryptBlock: function(y, m) {
      this.oZ(y, m, this.hZ, n, a, l, h, s);
    }, decryptBlock: function(y, m) {
      var A = y[m + 1];
      y[m + 1] = y[m + 3], y[m + 3] = A, this.oZ(y, m, this.nZ, u, c, d, f, o), A = y[m + 1], y[m + 1] = y[m + 3], y[m + 3] = A;
    }, oZ: function(y, m, A, v, b, w, k, R) {
      for (var L = this.eZ, x = y[m] ^ A[0], M = y[m + 1] ^ A[1], C = y[m + 2] ^ A[2], S = y[m + 3] ^ A[3], E = 4, T = 1; T < L; T++) {
        var I = v[x >>> 24] ^ b[M >>> 16 & 255] ^ w[C >>> 8 & 255] ^ k[255 & S] ^ A[E++], F = v[M >>> 24] ^ b[C >>> 16 & 255] ^ w[S >>> 8 & 255] ^ k[255 & x] ^ A[E++], D = v[C >>> 24] ^ b[S >>> 16 & 255] ^ w[x >>> 8 & 255] ^ k[255 & M] ^ A[E++], P = v[S >>> 24] ^ b[x >>> 16 & 255] ^ w[M >>> 8 & 255] ^ k[255 & C] ^ A[E++];
        x = I, M = F, C = D, S = P;
      }
      I = (R[x >>> 24] << 24 | R[M >>> 16 & 255] << 16 | R[C >>> 8 & 255] << 8 | R[255 & S]) ^ A[E++], F = (R[M >>> 24] << 24 | R[C >>> 16 & 255] << 16 | R[S >>> 8 & 255] << 8 | R[255 & x]) ^ A[E++], D = (R[C >>> 24] << 24 | R[S >>> 16 & 255] << 16 | R[x >>> 8 & 255] << 8 | R[255 & M]) ^ A[E++], P = (R[S >>> 24] << 24 | R[x >>> 16 & 255] << 16 | R[M >>> 8 & 255] << 8 | R[255 & C]) ^ A[E++], y[m] = I, y[m + 1] = F, y[m + 2] = D, y[m + 3] = P;
    }, keySize: 8 });
    t.AES = e.VX(g);
  })(), r.AES;
})(Us.exports);
var zp = g1.exports, p1 = { exports: {} };
p1.exports = (function(r) {
  return r.mode.CTR = (e = (t = r.lib.BlockCipherMode.extend()).Encryptor = t.extend({ processBlock: function(i, s) {
    var o = this.QX, n = o.blockSize, a = this.KX, l = this.aZ;
    a && (l = this.aZ = a.slice(0), this.KX = void 0);
    var h = l.slice(0);
    o.encryptBlock(h, 0), l[n - 1] = l[n - 1] + 1 | 0;
    for (var u = 0; u < n; u++) i[s + u] ^= h[u];
  } }), t.Decryptor = e, t), r.mode.CTR;
  var t, e;
})(Us.exports);
var Wp = p1.exports, y1 = { exports: {} };
y1.exports = (function(r) {
  return (function() {
    if (typeof ArrayBuffer == "function") {
      var t = r.lib.WordArray, e = t.init, i = t.init = function(s) {
        if (s instanceof ArrayBuffer && (s = new Uint8Array(s)), (s instanceof Int8Array || typeof Uint8ClampedArray < "u" && s instanceof Uint8ClampedArray || s instanceof Int16Array || s instanceof Uint16Array || s instanceof Int32Array || s instanceof Uint32Array || s instanceof Float32Array || s instanceof Float64Array) && (s = new Uint8Array(s.buffer, s.byteOffset, s.byteLength)), s instanceof Uint8Array) {
          for (var o = s.byteLength, n = [], a = 0; a < o; a++) n[a >>> 2] |= s[a] << 24 - a % 4 * 8;
          e.call(this, n, o);
        } else e.apply(this, arguments);
      };
      i.prototype = t;
    }
  })(), r.lib.WordArray;
})(Us.exports);
var Gp = y1.exports, m1 = { exports: {} };
m1.exports = (function(r) {
  return r.pad.NoPadding = { pad: function() {
  }, unpad: function() {
  } }, r.pad.NoPadding;
})(Us.exports);
var Up = m1.exports;
const Hp = "aHR0cHM6Ly9saWdodG5pbmdjaGFydC5jb20vanMtY2hhcnRzL2RvY3MvbGljZW5zZXMvYXBwLWRlcGxveW1lbnQv", Yp = 9e5, PC = { "-4": ["MDQxMmQ1MWU5MjFhYTMzODUwMWE4ZGYzN2ViZTE4NTU3ZDViYmRlZDg1Yzk0OGI3YTJkMDBmZTNhZGVlMjdjY2VmNzBiMWVlOWI3MDZjMTIwYTAzZDZlZTNkNmYyOTc5Y2E2NGEzN2Y3YjY4N2E1ZjljZWY2ODYxN2I1NWU5ZmJjMA=="], "-3": ["MjAyNjAzMDk="], "-2": ["aHR0cHM6Ly9qc2xpY2Vuc2luZy5saWdodG5pbmdjaGFydC5jb20vc2Vzc2lvbg==", "aHR0cHM6Ly9saWdodG5pbmdjaGFydC5jb20vanMtY2hhcnRzL2RvY3MvdHJvdWJsZXNob290aW5nL3Jlc3RyaWN0ZWQtZmVhdHVyZXMv", "aHR0cHM6Ly9saWdodG5pbmdjaGFydC5jb20vanMtY2hhcnRzLw==", "aHR0cHM6Ly9saWdodG5pbmdjaGFydC5jb20vcHl0aG9uLWNoYXJ0cy8="], "-1": ["WE1MSHR0cFJlcXVlc3Q=", "ZG9jdW1lbnQ=", "ZGVmYXVsdFZpZXc=", "YQ==", "Yg==", "bGljZW5zZV9leHBpcmF0aW9uX2RhdGU=", "bG9jYXRpb24=", "aG9zdG5hbWU=", "dGVzdF9kb21haW4=", "ZG9tYWlucw==", "Y3J5cHRv", "U2lnbmF0dXJl", "RUNEU0E=", "U0hBMjI0d2l0aEVDRFNB", "YWxn", "Y3VydmU=", "c2VjcDI1Nmsx", "YWRkRXZlbnRMaXN0ZW5lcg==", "cmVtb3ZlRXZlbnRMaXN0ZW5lcg==", "bG9hZGVuZA==", "ZXJyb3I=", "YWJvcnQ=", "dGltZW91dA==", "cmVzcG9uc2VUZXh0", "Q29udGVudC1UeXBl", "YXBwbGljYXRpb24vanNvbg==", "TWVzc2FnZURpZ2VzdA==", "c2hhMjU2", "Y3J5cHRvanM=", "dXBkYXRlU3RyaW5n", "ZGlnZXN0", "Y29tcGFueQ==", "YXBwVGl0bGU=", "bGNqcy1zZXNzaW9u", "bG9jYWxTdG9yYWdl", "Z2V0SXRlbQ==", "c2V0SXRlbQ==", "ZA==", "dA==", "bGNqcy1zZXNzaW9uLTI=", "aG9zdA==", "dG9w"], 0: ["TGljZW5zZQ==", "IA==", "a2V5", "aGFz", "ZXhwaXJlZA==", "Lg==", "dmVyc2lvbg==", "aXM=", "dG9v", "bmV3", "b2xk", "b3I=", "aW52YWxpZA==", "MDAwMQ==", "SW52YWxpZA==", "bnVtYmVy", "b2Y=", "ZG9tYWlucw==", "ZGVwbG95bWVudA==", "aW4=", "ZG9tYWlu", "RGVwbG95bWVudA==", "ZG9tYWlu", "dmFsaWRhdGlvbg==", "ZmFpbGVk", "Og==", "UE9TVA==", "c2VydmVy", "cmVzcG9uZGVk", "d2l0aA==", "dW5leHBlY3RlZA==", "dmFsdWU=", "cmVxdWVzdA==", "VEVTVA==", "REVQTE9ZTUVOVA==", "S2V5", "VGFtcGVyaW5n", "YmVlbg==", "ZGV0ZWN0ZWQ=", "TWlzc2luZw==", "TGljZW5zZQ==", "aW5mb3JtYXRpb24=", "ZG9lcw==", "bm90", "aW5jbHVkZQ==", "cGVybWlzc2lvbg==", "dG8=", "dXNl", "Q2hhcnQ=", "M0Q=", "WFk=", "RGF0YUdyaWQ=", "TWFw", "UG9sYXI=", "RnVubmVs", "R2F1Z2U=", "UGll", "UHlyYW1pZA==", "U3BpZGVy", "Zm9y", "dGhpcw==", "VHJhZGluZw==", "ZmVhdHVyZXM=", "Q2xpY2s=", "aGVyZQ==", "bW9yZQ==", "c3VwcGxpZWQ=", "Z2V0", "bGljZW5zZQ==", "VHJlZQ==", "dW5leHBlY3RlZA==", "ZXJyb3I="], 1: ["aHR0cHM6Ly9qc2xpY2Vuc2luZy5saWdodG5pbmdjaGFydC5jb20vc2FuZGJveA==", "aHR0cHM6Ly9qc2xpY2Vuc2luZy5saWdodG5pbmdjaGFydC5jb20vcGx1Z2lu"] }, ke = H, dt = (...r) => r.slice(1).reduce(((t, e) => t + ke.atob(PC[r[0]][e].toString())), "");
let si, kt, jp, $s = new Uint8Array([]);
const Ys = (r) => r && "cGx1Z2lu" in r && r.cGx1Z2lu === "cHl0aG9u" ? dt(-2, 3) : dt(-2, 2);
class RC {
  set e(t) {
    si = t;
  }
  get e() {
    kt = { bo: !1, xo: !1, Mo: !1, _o: !1, wo: !1, ko: !1, Co: !1, To: !1, Fo: !1, Io: !1, Po: !1, Lo: !1, Bo: !1, Do: !1, Eo: !1, Ro: !1, Oo: !1, zo: !1, Vo: !1, No: !1, Go: !1, $o: !1, Uo: !1, jo: !1, Yo: !1, Ho: !1, Wo: !1 };
    const t = $s.length, e = t >= 1 ? $s[0] : void 0, i = t >= 2 ? $s[1] : void 0, s = t >= 3 ? $s[2] : void 0, o = t >= 4 ? $s[3] : void 0;
    return e !== void 0 && (kt.bo = !!(1 & e), kt.xo = !!(2 & e), kt.Mo = !!(4 & e), kt._o = !!(8 & e), kt.wo = !!(16 & e), kt.ko = !!(32 & e), kt.Co = !!(64 & e), kt.To = !!(128 & e)), i !== void 0 && (kt.Fo = !!(1 & i), kt.Io = !!(2 & i), kt.Po = !!(4 & i), kt.Lo = !!(8 & i), kt.Bo = !!(16 & i), kt.Do = !!(32 & i), kt.Eo = !!(64 & i), kt.Ro = !!(128 & i)), s !== void 0 && (kt.Oo = !!(1 & s), kt.zo = !!(2 & s), kt.Vo = !!(4 & s), kt.No = !!(8 & s), kt.Go = !!(16 & s), kt.$o = !!(32 & s), kt.Uo = !!(64 & s), kt.jo = !!(128 & s)), o !== void 0 && (kt.Yo = !!(1 & o), kt.Ho = !!(2 & o), kt.Wo = !!(4 & o)), kt.ko;
  }
  set l(t) {
    jp = t;
  }
  get l() {
    return jp;
  }
}
let go = !1;
const po = (r, t) => {
  const e = new RegExp(`.{${t}}`, "g");
  return (r.match(e) || []).map(((i) => parseInt(i, 16)));
}, Vd = (r) => {
  if (r.byteLength === 4) return `${r[0].toString().padStart(2, "0")}${r[1].toString().padStart(2, "0")}${r[2].toString().padStart(2, "0")}${r[3].toString().padStart(2, "0")}`;
}, Vu = (r) => r.getFullYear().toString() + (r.getMonth() + 1).toString().padStart(2, "0") + r.getDate().toString().padStart(2, "0"), i0 = (r) => {
  const t = {}, e = r.split("-");
  if (e.length !== 3) return { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
  let i = 0;
  const s = Uint8Array.from(ke.atob(e[1]), ((p) => p.charCodeAt(0)));
  i += 1;
  const o = s.subarray(i, i += 20), n = new DataView(s.buffer).getUint16(i, !0);
  i += 2;
  const a = Uint8Array.from(Array(n));
  for (let p = 0; p < n; p += 1) a[p] = s[p + i] ^ o[p % o.byteLength];
  const l = new DataView(a.buffer);
  t.uZ = a, i = 0;
  const h = Uint8Array.from(Array(l.getUint16(i, !0)));
  i += 2, h.set(a.subarray(i, i += h.byteLength)), $s = new Uint8Array(h);
  const u = Vd(a.subarray(i, i += 4)), c = dt(-3, 0);
  if (!u) return { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
  if (u < c) return { lZ: dt(0, 40, 1, 2, 1, 7, 1, 8, 1, 10, 1, 59, 1, 60, 1, 6, 5) };
  if (8 & h[0]) {
    const p = Vd(a.subarray(i, i += 4)), g = Vu(/* @__PURE__ */ new Date());
    if (!p) return { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
    if (p < g) return { lZ: dt(0, 0, 1, 2, 1, 3, 1, 4, 5), cZ: Ys() };
  }
  t.dZ = i;
  const d = `${e[0]}-${e[1]}`, f = Array.prototype.reduce.call(ke.atob(e[2]), ((p, g) => p + `0${g.charCodeAt(0).toString(16)}`.slice(-2)), "");
  return or(d, f) ? t : { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
}, $p = (r) => {
  const t = r.slice(0, 4);
  let e = r.slice(5);
  switch (t) {
    case "0001": {
      e = e.replace(/-/g, "");
      const i = Uint8Array.from(po(e, 2)), s = i.slice(36, 40), o = new Uint8Array(4), n = ((u) => {
        let c;
        const d = [];
        for (let p = 0; p < 256; p += 1) {
          c = p;
          for (let g = 0; g < 8; g += 1) c = 1 & c ? 3988292384 ^ c >>> 1 : c >>> 1;
          d[p] = c;
        }
        let f = -1;
        for (let p = 0; p < u.length; p += 1) f = f >>> 8 ^ d[255 & (f ^ u[p])];
        return ~f >>> 0;
      })(i.slice(0, 36));
      new DataView(o.buffer).setUint32(0, n, !0);
      const a = i.slice(28, 34);
      let l = 0;
      for (let u = a.length - 1; u > 0; u -= 1) l += a[u] * 2 ** (8 * u);
      const h = new Date(l);
      if (Vu(h) < dt(-3, 0)) return { lZ: dt(0, 0, 1, 2, 1, 3, 1, 4, 5), cZ: Ys() };
      if (s.every(((u, c) => o[c] === u))) return {};
      break;
    }
    case "0002":
      return i0(r);
    default:
      return { lZ: dt(0, 0, 1, 2, 1, 6, 1, 7, 1, 8, 1, 9, 1, 11, 1, 10, 5) };
  }
  return { lZ: dt(0, 0, 1, 2, 1, 7, 1, 12, 5) };
}, Xp = (r) => {
  if (!r) return { lZ: dt(0, 14, 1, 15, 1, 16, 1, 17, 1, 19, 1, 18, 1, 2, 5) };
  const t = (r[dt(-1, 9)] || r[dt(-1, 37)]).map(((o) => (o || "").trim())), e = ke[dt(-1, 41)];
  try {
    if (e && t.indexOf(e[dt(-1, 6)][dt(-1, 7)]) > -1) return { fZ: !0 };
  } catch {
  }
  if (t.indexOf(ke[dt(-1, 6)][dt(-1, 7)]) > -1) return { fZ: !0 };
  const i = t.filter(((o) => o.indexOf("*") > -1));
  try {
    if (e && Qh(e[dt(-1, 6)][dt(-1, 7)], i)) return { fZ: !0 };
  } catch {
  }
  if (Qh(ke[dt(-1, 6)][dt(-1, 7)], i)) return { fZ: !0 };
  const s = r[dt(-1, 8)] || r[dt(-1, 38)];
  if (s !== "" && s != null) {
    try {
      if (e && Qh(e[dt(-1, 6)][dt(-1, 7)], [s])) return { fZ: !1 };
    } catch {
    }
    if (Qh(ke[dt(-1, 6)][dt(-1, 7)], [s])) return { fZ: !1 };
    try {
      if (e && s === e[dt(-1, 6)][dt(-1, 7)]) return { fZ: !1 };
    } catch {
    }
    if (s === ke[dt(-1, 6)][dt(-1, 7)]) return { fZ: !1 };
  }
  return { lZ: dt(0, 14, 1, 20, 5), cZ: "aHR0cHM6Ly9saWdodG5pbmdjaGFydC5jb20vanMtY2hhcnRzL2RvY3MvbGljZW5zZXMvd2ViLWRlcGxveW1lbnQv" };
}, or = (r, t) => {
  const e = new FC("secp256k1").keyFromPublic(dt(-4, 0), "hex"), i = LC(r).toString();
  return e.verify(i, t);
}, Zp = (r) => {
  switch (r.slice(0, 4)) {
    case "0001":
      return ((t) => {
        let e, i = "";
        try {
          const o = t.split("-"), n = o[1], a = o[2], l = o[3];
          if (!or(a, l)) return { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
          const h = Hn.parse(a);
          i = zp.decrypt({ ciphertext: Hn.parse(n) }, h, { mode: Wp, padding: Up, iv: Hn.parse("00000000000000000000000000000001") }).toString(Op);
        } catch {
          return { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
        }
        try {
          e = JSON.parse(i);
        } catch {
          return { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
        }
        if (e[dt(-1, 5)] === void 0 || e[dt(-1, 4)] === null || !e[dt(-1, 9)]) return { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
        const s = parseInt(dt(-3, 0), 10) || Number(parseInt(dt(-3, 0), 10));
        return e[dt(-1, 5)] < s ? { lZ: dt(0, 21, 1, 2, 1, 3, 1, 4, 5) } : Xp(e);
      })(r);
    case "0002":
      return ((t) => {
        const e = i0(t), i = e.uZ, s = e.dZ;
        if (e.lZ || i === void 0 || s === void 0) return e;
        let o, n = "";
        try {
          const a = i.slice(e.dZ, s + 16), l = new DataView(a.buffer), h = new Int32Array(4);
          for (let m = 0; m < h.length; m += 1) h[m] = l.getInt32(4 * m, !1);
          const u = Gp.create(Array.from(h)), c = s + 16, d = i.slice(c, i.length), f = new DataView(d.buffer), p = new Int32Array(Math.floor(d.byteLength / 4));
          for (let m = 0; m < p.length; m += 1) p[m] = f.getInt32(4 * m, !1);
          const g = Gp.create(Array.from(p)), y = zp.decrypt({ ciphertext: g }, u, { mode: Wp, padding: Up, iv: Hn.parse("00000000000000000000000000000001") });
          n = ke.atob(y.toString(Op));
        } catch {
          return { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
        }
        try {
          o = JSON.parse(n);
        } catch {
          return { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
        }
        return o[dt(-1, 37)] ? Xp(o) : { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
      })(r);
    default:
      return { lZ: dt(0, 21, 1, 2, 1, 6, 1, 7, 1, 8, 1, 9, 1, 11, 1, 10, 5) };
  }
}, Kp = (r, t) => {
  switch (r.slice(0, 4)) {
    case "0001":
      return ((e, i) => {
        if (!i) return { lZ: dt(0, 39, 1, 40, 1, 41, 5), cZ: Hp };
        const s = e.split("-"), o = s[1].slice(1), n = s[2], a = s[3];
        if (!or(`${o}-${n}`, a)) return { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
        const l = Uint8Array.from(po(n, 2));
        let h = 0;
        for (let y = l.length - 1; y > 0; y -= 1) h += l[y] * 2 ** (8 * y);
        if (h < (parseInt(dt(-3, 0), 10) || Number(parseInt(dt(-3, 0), 10)))) return { lZ: dt(0, 21, 1, 2, 1, 3, 1, 4, 5) };
        const u = Int32Array.from(po(o, 8)), c = Jh(i[dt(-1, 31)]).toString(Hn), d = Int32Array.from(po(c, 8)), f = Jh(i[dt(-1, 32)]).toString(Hn), p = Int32Array.from(po(f, 8)), g = new Int32Array(d.length);
        for (let y = 0; y < g.length; y += 1) g[y] = d[y] ^ p[y];
        return u.every(((y, m) => g[m] === y)) ? {} : { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
      })(r, t);
    case "0002":
      return ((e, i) => {
        if (!i) return { lZ: dt(0, 39, 1, 40, 1, 41, 5), cZ: Hp };
        const s = i0(e), o = s.uZ, n = s.dZ;
        if (s.lZ || o === void 0 || n === void 0) return s;
        const a = o.slice(n, o.length), l = new DataView(a.buffer), h = new Int32Array(8);
        for (let g = 0; g < h.length; g += 1) h[g] = l.getInt32(4 * g, !1);
        const u = Jh(i[dt(-1, 31)]).toString(Hn), c = Int32Array.from(po(u, 8)), d = Jh(i[dt(-1, 32)]).toString(Hn), f = Int32Array.from(po(d, 8)), p = new Int32Array(c.length);
        for (let g = 0; g < p.length; g += 1) p[g] = c[g] ^ f[g];
        return h.every(((g, y) => p[y] === g)) ? {} : { lZ: dt(0, 21, 1, 2, 1, 7, 1, 12, 5) };
      })(r, t);
    default:
      return { lZ: dt(0, 21, 1, 2, 1, 6, 1, 7, 1, 8, 1, 9, 1, 11, 1, 10, 5) };
  }
}, vs = (r, t, e = !0, i) => {
  go = !1, t.qa();
  const s = t.Un, o = !!s && (s === H.document.body || H.document.body.contains(s)), n = s && o ? s : document.body;
  if (Array.from(n.children).find(((a) => a.id === "lcjs-error")) === void 0) {
    const a = H.document.createElement("div");
    a.id = "lcjs-error", n.append(a), a.style.position = "absolute", a.style.top = "0px", a.style.left = "0px", a.style.width = "100%", a.style.height = "100%", a.style.backgroundColor = "black", a.style.boxSizing = "border-box", a.style.padding = "20px", a.style.font = "Arial", a.style.fontSize = "20px";
    let l, h = (r || "LICENSE_ERROR").split("_").join(" ");
    if (h = (e ? dt(0, 0, 1, 2, 1, 23, 1, 24, 25, 1) : "") + h.charAt(0).toUpperCase() + h.substr(1), i) {
      const u = H.document.createElement("a");
      u.href = i, l = u;
    } else l = H.document.createElement("p1");
    a.append(l), l.innerHTML = h, l.style.color = "red", t.DW() && ke.console.error(h);
  }
}, Ss = (r, t, e) => {
  t ? (r[dt(-1, 17)](dt(-1, 19), e), r[dt(-1, 17)](dt(-1, 20), e), r[dt(-1, 17)](dt(-1, 21), e), r[dt(-1, 17)](dt(-1, 22), e)) : (r[dt(-1, 18)](dt(-1, 19), e), r[dt(-1, 18)](dt(-1, 20), e), r[dt(-1, 18)](dt(-1, 21), e), r[dt(-1, 18)](dt(-1, 22), e));
}, Qh = (r, t) => {
  const e = r.split(".").reverse();
  return t.some(((i) => {
    const s = i.split(".").reverse();
    let o = !1;
    const n = s.findIndex(((l) => l === "*")), a = e.every(((l, h) => !(!o && (!(h < s.length) || (o = s[h] === "*" && h + 1 > 2, !o && l !== s[h])))));
    return !(n > e.length - 1 || !a);
  }));
}, IC = /* @__PURE__ */ new Map(), VC = (r, t) => {
  let e = typeof r == "object" ? r.license : r;
  e && (e = e.trim());
  const i = typeof r == "object" ? r.licenseInformation : t, s = typeof r == "object" ? r : void 0, o = new RC();
  o.e = e;
  let n = IC.get(e || "E");
  return n || (n = ((a, l) => {
    let h, u, c = !1, d = !1, f = !1, p = !1, g = "", y = !1, m = !1, A = !1;
    try {
      if (si) {
        const R = (() => {
          if (!si) return;
          const x = si.split("-");
          if (x.length > 0) switch (x[0]) {
            case "0001":
              return "0001";
            case "0002":
              return "0002";
            case "T001":
              return "T001";
            case "P001":
              return "P001";
            default:
              return;
          }
        })(), L = a && "cGx1Z2lu" in a;
        if (R === "0001") {
          $s = new Uint8Array([2]);
          const x = (() => {
            if (!si) return;
            const M = si.split("-");
            return M.length === 4 ? M[1].startsWith("m") ? 2 : 1 : 0;
          })();
          if (x === 1) {
            const M = Zp(si);
            f = !M.fZ, h = M, c = !0;
          } else x === 2 ? (h = Kp(si, a), d = !0) : (go = !0, h = $p(si), p = !0);
          L && (h = { lZ: dt(0, 0, 1, 7, 1, 12, 5) });
        } else if (R === "0002") {
          const x = (() => {
            if (!si) return;
            const C = si.split("-");
            return C.length >= 2 ? Uint8Array.from(ke.atob(C[1]), ((S) => S.charCodeAt(0)))[0] : void 0;
          })();
          if (x === 104) go = !0, h = $p(si), p = !0;
          else if (x === 189) {
            const C = Zp(si);
            f = !C.fZ, h = C, c = !0;
          } else x === 159 ? (h = Kp(si, a), d = !0) : h = { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
          const M = $s.length > 3 && 2 & $s[3];
          (M && !L || !M && L || M && L && a.cGx1Z2lu !== "cHl0aG9u") && (h = { lZ: dt(0, 0, 1, 7, 1, 12, 5) });
        } else if (R === "T001") {
          const x = ((C, S) => {
            const E = si.split("-");
            if (E.length !== 3) return { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
            const T = `${E[1]}`, I = Array.prototype.reduce.call(ke.atob(E[2]), ((q, Q) => q + `0${Q.charCodeAt(0).toString(16)}`.slice(-2)), "");
            if (!or(T, I)) return { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
            let F = 0;
            const D = Uint8Array.from(ke.atob(E[1]), ((q) => q.charCodeAt(F))), P = D.subarray(F, F += 20), V = new DataView(D.buffer).getUint16(F, !0);
            F += 2;
            const _ = Uint8Array.from(Array(V));
            for (let q = 0; q < V; q += 1) _[q] = D[q + F] ^ P[q % P.byteLength];
            F = 0;
            const O = new DataView(_.buffer), B = Vd(_.subarray(F, F += 4)), z = dt(-3, 0);
            if (!B) return { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
            if (B < z) return { lZ: dt(0, 40, 1, 2, 1, 7, 1, 8, 1, 10, 1, 59, 1, 60, 1, 6, 5) };
            const W = /* @__PURE__ */ new Date(), G = /* @__PURE__ */ new Date();
            W.setDate(W.getDate() + 1), G.setDate(G.getDate() - 1);
            const Y = Vu(G), U = Vu(W);
            if (B < Y || B > U) return { lZ: dt(0, 0, 1, 2, 1, 3, 1, 4, 5) };
            const $ = O.getUint16(F, !0), Z = _.subarray(F += 2, F + $);
            if ($s = new Uint8Array(Z), S && "dHJhZGVy" in S && S.dHJhZGVy === "dGVjaG5pY2FsIGFuYWx5c2lz") return { AZ: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" };
            if (S && "logoGraphic" in S && S.logoGraphic) {
              const q = S.logoGraphic.split("-");
              return q.length === 3 && or(q[0], q[2]) ? { AZ: q[0] } : { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
            }
            return { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
          })(0, a);
          h = x;
          const M = x.AZ;
          M && l ? (typeof M == "string" && (l.l = M), c = !0) : h = { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
        } else R === "P001" ? (h = ((x, M) => {
          const C = si.split("-");
          if (C.length !== 3) return { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
          const S = `${C[0]}-${C[1]}`, E = Array.prototype.reduce.call(ke.atob(C[2]), ((B, z) => B + `0${z.charCodeAt(0).toString(16)}`.slice(-2)), "");
          if (!or(S, E)) return { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
          let T = 0;
          const I = Uint8Array.from(ke.atob(C[1]), ((B) => B.charCodeAt(0)));
          T += 1;
          const F = I.subarray(T, T += 20), D = new DataView(I.buffer).getUint16(T, !0);
          T += 2;
          const P = Uint8Array.from(Array(D));
          for (let B = 0; B < D; B += 1) P[B] = I[B + T] ^ F[B % F.byteLength];
          T = 0;
          const V = new DataView(P.buffer).getUint16(T, !0);
          T += 2;
          const _ = P.subarray(T, V + T), O = new TextDecoder("utf-8").decode(_);
          return M && "cGx1Z2lu" in M && O === ke.atob(M.cGx1Z2lu) ? ($s = new Uint8Array([38]), {}) : { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
        })(0, a), !h.lZ && l && (c = !0, m = !0)) : h = { lZ: dt(0, 0, 1, 7, 1, 12, 5) };
      } else {
        const R = /^(10\.|172\.(1[6-9]|2[0-9]|3[0-1])|192\.168)\./;
        ["localhost", "127.0.0.1", "::1"].includes(ke[dt(-1, 6)][dt(-1, 7)]) || R.test(ke[dt(-1, 6)][dt(-1, 7)]) ? h = { lZ: dt(0, 0, 1, 2, 1, 43, 1, 66, 5, 1, 63, 1, 64, 1, 46, 1, 67, 1, 68), cZ: Ys(a) } : ke[dt(-1, 6)][dt(-1, 40)] === ke.atob("c3RhY2tzbmlwcGV0cy5uZXQ=") ? (A = !0, y = !1, $s = new Uint8Array([38]), h = {}) : (A = !0, y = !0, $s = new Uint8Array([38]), h = {});
      }
    } catch {
      h = { lZ: dt(0, 0, 1, 7, 1, 12, 5, 1, 70, 1, 71, 5) };
    }
    try {
      p && (u = ke[dt(-1, 34)][dt(-1, 35)](dt(-1, 39)) || void 0);
    } catch (R) {
      ke.console.error(R);
    }
    let v = !1;
    if (u) {
      const R = u.split("-");
      if (R.length === 2 && or(R[0], R[1])) {
        const [L, x] = R[0].split(":").map(((M) => Number(M)));
        Date.now() - x < 0.95 * L * 1e3 && (v = !0);
      }
    }
    const b = !(A || y || m || h.lZ || c || d || v), w = (() => {
      const R = new ke[dt(-1, 0)]();
      return R.open(dt(0, 26), dt(-2, 0)), R.setRequestHeader(dt(-1, 24), dt(-1, 25)), R.withCredentials = !0, R;
    })(), k = new Nt();
    if (b) {
      let R;
      try {
        R = parseInt(si ? si.split("-")[1] : Math.floor(1e6 * Math.random()).toString(), 16);
      } catch {
        R = Math.floor(1e6 * Math.random());
      }
      const L = Math.floor(1e6 * Math.random());
      g = (R ^ L).toString();
      const x = {};
      let M = "", C = "", S = "";
      si = si || "";
      const E = dt(-4, 0);
      for (let I = 0; I < si.length; I += 1) {
        const F = si.charCodeAt(I) ^ E.charCodeAt(I);
        M += String.fromCharCode(F);
      }
      const T = dt(-3, 0);
      for (let I = 0; I < T.length; I += 1) C += String.fromCharCode(T.charCodeAt(I) ^ E.charCodeAt(I));
      for (let I = 0; I < g.length; I += 1) S += String.fromCharCode(g.charCodeAt(I) ^ E.charCodeAt(I));
      x[dt(-1, 3)] = ke.btoa(M), x[dt(-1, 4)] = ke.btoa(C), x.h = ke.btoa(S), x.v = 3, x.s = ke[dt(-1, 34)][dt(-1, 35)](dt(-1, 33)) || void 0, w.send(JSON.stringify(x));
    }
    return (R, L) => {
      const x = [], M = { Oa: (D) => {
        x.indexOf(D) >= 0 || (x.push(D), C(), kt && kt.Wo && k.R("logochange", { logoDataURI: "data:image/png;base64,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" }));
      }, Va: k }, C = () => {
        x.forEach(((D) => {
          const P = E(D);
          if (!P) return;
          const { gZ: V, vZ: _ } = P, O = _ ? dt(-2, 1) : void 0, B = `${dt(0, 40, 1, 42, 1, 43, 1, 44, 1, 45, 1, 46, 1, 47, 1)}${V}${O ? dt(0, 5, 1, 63, 1, 64, 1, 59, 1, 65, 1, 41, 5) : ""}`;
          vs(B, T, !1, O);
        }));
      }, S = (D) => ke.atob(D), E = (D) => {
        const P = Object.values(Ot).includes(D) ? D : void 0;
        if (P) {
          switch (D) {
            case Ot.Mo:
              return kt.bo || kt.Mo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Co:
              return kt.bo || kt.Co ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.To:
              return kt.bo || kt.xo || kt.To ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.xo:
              return kt.bo || kt.xo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Bo:
              return kt.bo || kt.xo || kt.Bo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Ro:
              return kt.bo || kt.xo || kt.Ro ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.No:
              return kt.bo || kt.xo || kt.No ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.$o:
              return kt.bo || kt.xo || kt.$o ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Uo:
              return kt.bo || kt.xo || kt.Uo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Go:
              return kt.bo || kt.xo || kt.Go ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Io:
              return kt.bo || kt.xo || kt.Io ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Eo:
              return kt.bo || kt.xo || kt.Eo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Lo:
              return kt.bo || kt.xo || kt.Lo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Oo:
              return kt.bo || kt.xo || kt.Oo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Vo:
              return kt.bo || kt.xo || kt.Vo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.zo:
              return kt.bo || kt.xo || kt.zo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Fo:
              return kt.bo || kt.xo || kt.Fo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Po:
              return kt.bo || kt.xo || kt.Po ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Do:
              return kt.bo || kt.xo || kt.Do ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.jo:
              return kt.bo || kt.xo || kt.jo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.Yo:
              return kt.bo || kt.xo || kt.Yo ? void 0 : { gZ: S(P), vZ: !0 };
            case Ot.bo:
            case Ot._o:
            case Ot.ko:
            case Ot.wo:
            case Ot.Ho:
            case Ot.Wo:
              return;
          }
          return Oa(0, "");
        }
      }, T = new CC(L, R, M);
      Array.from(T.Un.children).forEach(((D) => {
        D.id === "lcjs-error" && T.Un.removeChild(D);
      })), h?.lZ && vs(h.lZ, T, void 0, h.cZ);
      const I = (D) => {
        if (D?.type === "error" && u) {
          const P = u.split("-");
          if (P.length === 2 && or(P[0], P[1])) {
            const [, V] = P[0].split(":").map(((O) => Number(O))), _ = Date.now();
            if (V + Yp > _) return go = !1, void Ss(w, !1, F);
          }
        }
        if (w.readyState === ke[dt(-1, 0)].DONE) if (w.status === 200) {
          const P = JSON.parse(w[dt(-1, 23)]);
          if (!or(g + dt(-3, 0), P.h)) {
            const V = dt(0, 0, 1, 27, 1, 28, 1, 29, 1, 30, 1, 31, 5);
            vs(V, T);
          }
          ke[dt(-1, 34)][dt(-1, 36)](dt(-1, 39), P.t), ke[dt(-1, 34)][dt(-1, 36)](dt(-1, 33), P.s), go = !1;
        } else {
          let P = dt(0, 0, 1, 2, 1, 7, 1, 12, 5);
          try {
            P = D && D.type !== "loadend" ? dt(0, 0, 1, 23, 1, 32, 1, 24, 5) : JSON.parse(w[dt(-1, 23)]).message, Ss(w, !1, F);
          } catch (V) {
            console.error(V);
          }
          vs(P, T, void 0, "aHR0cHM6Ly9saWdodG5pbmdjaGFydC5jb20vanMtY2hhcnRzL2RvY3MvbGljZW5zZXMvZGV2ZWxvcGVyLWxpY2Vuc2Vz");
        }
      }, F = (D) => {
        I(D);
      };
      if (Ss(w, !0, F), b ? setTimeout((() => {
        if (go) {
          let D = !0;
          if (u) {
            const P = u.split("-");
            if (P.length === 2 && or(P[0], P[1])) {
              const [, V] = P[0].split(":").map(((O) => Number(O))), _ = Date.now();
              V + Yp > _ && (D = !1);
            }
          }
          D && vs(dt(0, 25, 1, 23, 1, 32, 1, 24, 5), T);
        }
      }), 1e4) : Ss(w, !1, F), y) {
        const D = (() => {
          const O = new ke[dt(-1, 0)]();
          return O.open(dt(0, 26), dt(1, 0)), O.setRequestHeader("Content-Type", "text/plain"), O.withCredentials = !0, O;
        })(), P = Array.from({ length: 10 }, (() => String.fromCharCode(Math.floor(256 * Math.random())))).join(""), V = (O) => {
          if (O?.type === "error") {
            const B = dt(0, 0, 1, 2, 1, 43, 1, 66, 5, 1, 63, 1, 64, 1, 46, 1, 67, 1, 68);
            vs(B, T, !1, Ys(a)), Ss(w, !1, _);
          }
          if (D.readyState === ke.XMLHttpRequest.DONE) {
            const B = D.getResponseHeader("X-LCJS-SANDBOX-V");
            if (D.status !== 200 || B && B !== "1") {
              const z = dt(0, 0, 1, 2, 1, 43, 1, 66, 5, 1, 63, 1, 64, 1, 46, 1, 67, 1, 68);
              vs(z, T, !1, Ys(a)), Ss(w, !1, _);
            } else {
              const z = JSON.parse(D.responseText);
              if (!or(P, z.s)) {
                const W = dt(0, 0, 1, 2, 1, 43, 1, 66, 5, 1, 63, 1, 64, 1, 46, 1, 67, 1, 68);
                vs(W, T, !1, Ys(a)), Ss(w, !1, _);
              }
              l !== void 0 && (l.l = z.l), k.R("logochange", { logoDataURI: z.l });
            }
          } else {
            const B = dt(0, 0, 1, 2, 1, 43, 1, 66, 5, 1, 63, 1, 64, 1, 46, 1, 67, 1, 68);
            vs(B, T, !1, Ys(a)), Ss(w, !1, _);
          }
        }, _ = (O) => {
          V(O);
        };
        Ss(D, !0, _), D.send(P), setTimeout((() => {
          if (D.readyState < 2) {
            const O = dt(0, 0, 1, 2, 1, 43, 1, 66, 5, 1, 63, 1, 64, 1, 46, 1, 67, 1, 68);
            vs(O, T, !1, Ys(a)), Ss(w, !1, _);
          }
        }), 1e4);
      }
      if (m) {
        const D = (() => {
          const Y = new ke[dt(-1, 0)]();
          return Y.open(dt(0, 26), dt(1, 1)), Y.setRequestHeader(dt(-1, 24), dt(-1, 25)), Y.withCredentials = !0, Y;
        })();
        let P;
        try {
          P = parseInt(si ? si.split("-")[1] : Math.floor(1e6 * Math.random()).toString(), 16);
        } catch {
          P = Math.floor(1e6 * Math.random());
        }
        const V = Math.floor(1e6 * Math.random());
        g = (P ^ V).toString();
        const _ = {};
        let O = "", B = "";
        si = si || "";
        const z = dt(-4, 0);
        for (let Y = 0; Y < si.length; Y += 1) {
          const U = si.charCodeAt(Y) ^ z.charCodeAt(Y);
          O += String.fromCharCode(U);
        }
        for (let Y = 0; Y < g.length; Y += 1) B += String.fromCharCode(g.charCodeAt(Y) ^ z.charCodeAt(Y));
        _[dt(-1, 3)] = ke.btoa(O), _.h = ke.btoa(B), _.v = 1, D.send(JSON.stringify(_));
        const W = (Y) => {
          var U;
          if (Y?.type === "error") {
            const $ = dt(0, 0, 1, 2, 1, 43, 1, 66, 5, 1, 63, 1, 64, 1, 46, 1, 67, 1, 68);
            vs($, T, !1, Ys(a)), Ss(w, !1, G);
          }
          if (D.readyState === ke.XMLHttpRequest.DONE) if (D.status === 200) {
            const $ = JSON.parse(D.responseText);
            if (!or(g, $.h)) {
              const st = dt(0, 0, 1, 7, 1, 12, 5);
              vs(st, T, !1, Ys(a)), Ss(w, !1, G);
            }
            const Z = $.l.split("-"), q = Z[0], Q = Z[1];
            if (or(q, Q)) l !== void 0 && (l.l = q, k.R("logochange", { logoDataURI: q }));
            else {
              const st = dt(0, 0, 1, 7, 1, 12, 5);
              vs(st, T, !1, Ys(a));
            }
            const nt = $.f, et = Uint8Array.from(ke.atob(nt), ((st) => st.charCodeAt(0)));
            let it = 0;
            const rt = et.subarray(it, it += 20), tt = new DataView(et.buffer).getUint16(it, !0);
            it += 2;
            const at = Uint8Array.from(Array(tt));
            for (let st = 0; st < tt; st += 1) at[st] = et[st + it] ^ rt[st % rt.byteLength];
            const ut = new DataView(at.buffer);
            it = 0;
            const ht = Uint8Array.from(Array(ut.getUint16(it, !0)));
            it += 2, ht.set(at.subarray(it, it += ht.byteLength)), $s = new Uint8Array(ht), l && l.e && C();
          } else {
            const $ = (U = JSON.parse(D.responseText).message) !== null && U !== void 0 ? U : dt(0, 0, 1, 7, 1, 12, 5);
            vs($, T, !1, Ys(a)), Ss(w, !1, G);
          }
          else {
            const $ = dt(0, 0, 1, 2, 1, 43, 1, 66, 5, 1, 63, 1, 64, 1, 46, 1, 67, 1, 68);
            vs($, T, !1, Ys(a)), Ss(w, !1, G);
          }
        }, G = (Y) => {
          W(Y);
        };
        Ss(D, !0, G), setTimeout((() => {
          if (D.readyState < 2) {
            const Y = dt(0, 0, 1, 2, 1, 43, 1, 66, 5, 1, 63, 1, 64, 1, 46, 1, 67, 1, 68);
            vs(Y, T, !1, Ys(a)), Ss(w, !1, G);
          }
        }), 1e4);
      }
      return f ? ((D) => {
        let P;
        go = !1;
        const V = () => {
          P && (D.Ea(P.Da()), P = void 0);
          const _ = D.Ft();
          P = D.kB("deployment test"), P.In(D.ai).rn(dt(0, 34, 1, 33)).hr({ x: _.x / 2, y: _.y / 2 }).Nl(50).Ph(13).sr(new ot({ color: N(128, 128, 128, 100) })).zl("Arial").$l(500).setPointerEvents(!1), D.Pa().La();
        };
        D.O("resize", (() => {
          V();
        })), setTimeout(V, 0), setInterval((() => {
          P && P.Da() < D.ll() - 1 ? V() : P || V();
        }), 1e3);
      })(T) : w.readyState === ke[dt(-1, 0)].DONE && I(), T;
    };
  })(i, o)), ((a, l, h, u) => {
    var c, d, f, p, g, y, m, A, v;
    let b;
    if (h && h.license) {
      const x = h.license.split("-");
      b = x[x.length - 1];
    }
    const w = (c = h?.webgl) === null || c === void 0 ? void 0 : c.version, k = { iR: (d = h?.sharedContextOptions) === null || d === void 0 ? void 0 : d.canvas, $a: h?.warnings, dR: w === "webgl1" ? 1 : w === "webgl2" ? 2 : void 0, aR: ((f = h?.sharedContextOptions) === null || f === void 0 ? void 0 : f.antialias) !== !1, oR: ((p = h?.sharedContextOptions) === null || p === void 0 ? void 0 : p.devicePixelRatio) || void 0, bR: ((g = h?.sharedContextOptions) === null || g === void 0 ? void 0 : g.noCanvasStyles) || void 0, wR: ((y = h?.sharedContextOptions) === null || y === void 0 ? void 0 : y.noCanvasTransform) || void 0, uR: ((m = h?.sharedContextOptions) === null || m === void 0 ? void 0 : m.useStackingOrder) !== !1, cR: ((A = h?.sharedContextOptions) === null || A === void 0 ? void 0 : A.useIndividualCanvas) !== !1, xR: b || void 0, PE: (v = h?.webWorkers) !== null && v !== void 0 ? v : { maxWorkers: void 0 } }, R = new hM(k), L = (x) => a({ ...x, textRenderer: x.textRenderer ? x.textRenderer : void 0, textPixelSnappingEnabled: x?.textPixelSnappingEnabled !== void 0 ? x.textPixelSnappingEnabled : !x?.textRenderer && void 0 }, R);
    return { Dashboard: uM(L, l, h, u), ChartXY: dM(L, l, h, u), Spider: fM(L, l, h, u), Polar: gM(L, l, h, u), Pie: pM(L, l, h, u), UIPanel: cM(L, l, h, u), Gauge: Ep(L, l, h, u), RadialGauge: Ep(L, l, h, u), Funnel: mM(L, l, h, u), Pyramid: xM(L, l, h, u), Chart3D: SM(L, l, h, u), Map: vM(L, l, h, u), DataGrid: AM(L, l, h, u), BarChart: bM(L, l, h, u), ParallelCoordinateChart: CM(L, l, h, u), ZoomBandChart: EM(L, l, h, u), TreeMapChart: MM(L, l, h, u), LinearGauge: yM(L, l, h, u), dispose: R.G.bind(R), layout: R.IR.bind(R) };
  })(n, o.e, s, o.l);
}, qp = 1440 * 60 * 1e3, _C = 720 * 60 * 1e3;
function x1(r) {
  const t = new Date(r), e = String(t.getDate()).padStart(2, "0"), i = String(t.getMonth() + 1).padStart(2, "0"), s = t.getFullYear(), o = String(t.getHours()).padStart(2, "0"), n = String(t.getMinutes()).padStart(2, "0"), a = String(t.getSeconds()).padStart(2, "0");
  return `${e}/${i}/${s} ${o}:${n}:${a}`;
}
function Jp(r) {
  const t = Math.max(0, Math.round(r / 1e3)), e = Math.floor(t / 3600), i = Math.floor(t % 3600 / 60), s = t % 60;
  return [e, i, s].map((o) => String(o).padStart(2, "0")).join(":");
}
function _d(r) {
  const t = Math.max(0, Math.round(r)), e = Math.floor(t / 3600), i = Math.floor(t % 3600 / 60), s = t % 60;
  return e > 0 ? i === 0 && s === 0 ? `${e} h` : i > 0 && s === 0 ? `${e} h ${i} min` : i === 0 && s > 0 ? `${e} h ${s} sec` : `${e} h ${i} min ${s} sec` : i === 0 && s === 0 ? "0 sec" : i > 0 && s === 0 ? `${i} min` : i === 0 && s > 0 ? `${s} sec` : `${i} min ${s} sec`;
}
const OC = 16, NC = (r) => {
  const t = (n) => Math.max(0, n.x2 - n.x1) * Math.max(0, n.y2 - n.y1), e = (n, a) => n.x1 < a.x2 && a.x1 < n.x2, i = r.map((n, a) => ({ index: a, item: n, area: t(n) })).sort((n, a) => a.area - n.area || n.index - a.index), s = new Array(r.length).fill(0), o = [];
  for (const { index: n, item: a, area: l } of i) {
    let h = 0;
    for (const u of o)
      u.area > l && e(u.item, a) && (h = Math.max(h, u.layer + 1));
    s[n] = Math.min(h, OC), o.push({ item: a, area: l, layer: s[n] });
  }
  return s;
};
var ka = /* @__PURE__ */ ((r) => (r[r.Signals = 900] = "Signals", r[r.Text = 800] = "Text", r[r.Events = 700] = "Events", r))(ka || {});
const ql = (r, t, e, i, s) => {
  const o = t.getInterval().start, n = r.translateCoordinate(
    { x: o, y: i },
    { x: t, y: e },
    r.coordsClient
  ), a = r.translateCoordinate(
    { x: o, y: s },
    { x: t, y: e },
    r.coordsClient
  );
  return {
    top: Math.min(n.clientY, a.clientY),
    bottom: Math.max(n.clientY, a.clientY)
  };
}, Od = 61, v1 = 8, _u = (r) => {
  const { chart: t } = r;
  t.setUserInteractions({
    pan: {
      x: !0,
      y: !1,
      drag: !1,
      lmb: !1,
      rmb: {
        drag: {}
      },
      mmb: !1
    },
    rectangleZoom: !1,
    zoom: {
      x: !0,
      y: !1,
      drag: !1
    },
    // Replaced by a day-bounded fit (see setupDoubleClickFitToData).
    restoreDefault: !1
  });
}, Lo = 0.015, s0 = (r) => Math.max(0, Math.min(1, r)), r0 = (r) => ({
  y1: Lo,
  y2: r === 1 ? r - Lo : r
}), n0 = (r) => s0((r.y2 ?? 1) - (r.y1 ?? 0)), BC = (r, t) => Math.round(
  Math.max(t, Math.min(100, n0(r) * 100)) / t
) * t, S1 = (r) => {
  const e = 1 - n0(r) - Lo * 2;
  return e <= 0 ? 0.5 : s0(((r.y1 ?? 0) - Lo) / e);
}, Qp = (r, t) => {
  const e = 1 - r - Lo * 2;
  return e <= 0 ? 0 : Lo + e * s0(t);
}, o0 = new ot({
  color: Xe("#FFFFFF00")
}), zC = (r) => {
  const t = r.replace("#", ""), e = t.length === 3 ? t.split("").map((u) => u + u).join("") : t;
  if (e.length !== 6) return "#000000";
  const i = (u) => {
    const c = u / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  }, s = i(parseInt(e.slice(0, 2), 16)), o = i(parseInt(e.slice(2, 4), 16)), n = i(parseInt(e.slice(4, 6), 16)), a = 0.2126 * s + 0.7152 * o + 0.0722 * n, l = 1.05 / (a + 0.05), h = (a + 0.05) / 0.05;
  return l > h ? "#FFFFFF" : "#000000";
}, Nd = (r, t, e, i, s) => {
  const o = r.setHighlightOnHover(!1).addCustomTick(Yl.AxisTickMajor).setVisible(!0).setValue(t).setMarker((n) => {
    n.setPointerEvents(!1), n.setTextFont((a) => a.setSize(12).setFamily("Noto Sans")).setTextFillStyle(new ot({ color: Xe(e) }));
  }).setGridStrokeStyle(i);
  s !== void 0 && o.setTextFormatter(() => s);
}, ty = (r) => {
  const {
    axisPairsByChannelType: t,
    channelType: e,
    configuration: i,
    chartRuntime: s,
    index: o,
    isVisible: n,
    signals: a,
    onAxesSwapped: l,
    heightPxOverride: h
  } = r, { chart: u } = s, c = new $t({
    thickness: 1,
    fillStyle: new ot({ color: Xe("#E8E8E8") })
  }), d = u.addAxisY({ iStack: o }).setLength(
    h !== void 0 ? { pixels: h } : { relative: i.relativeHeight }
  ).setStrokeStyle(Et).setOverlayStyle(o0).setTickStrategy(jr.Empty).setMarginAfterTicks(16).setUserInteractions({
    rectangleZoom: !1,
    zoom: {
      drag: !1
    }
  }).setPointerEvents(!0).setStopped(!0).setMargins(0, 20);
  if (i.tickInterval) {
    const { start: g, end: y, step: m, snapToStep: A } = i.tickInterval;
    d.setInterval({ start: g, end: y });
    const v = i.marks ?? [], b = new Set(v.map((k) => k.value)), w = A ? Math.ceil(g / m) * m : g;
    for (let k = w; k <= y; k += m)
      b.has(k) || Nd(d, k, "#8B8B8B", c);
    for (const k of v)
      k.value < g || k.value > y || (Nd(d, k.value, k.color, Et), d.addConstantLine({ onTop: !0 }).setValue(k.value).setStrokeStyle(
        new Xu({
          thickness: 1,
          pattern: uh.DashedLoose,
          fillStyle: new ot({ color: Xe(k.color) })
        })
      ).setHighlightOnHover(!1).setPointerEvents(!1));
  }
  const f = WC(
    s,
    d,
    a
  ), p = t.get(e);
  return n ? (t.set(e, { ...p, main: d }), A1(
    s,
    d,
    e,
    t,
    l
  )) : t.set(e, {
    ...p,
    opposite: d
  }), _u(s), { axis: d, bindWindow: f };
}, WC = (r, t, e) => {
  const { chart: i, axisX: s } = r, o = [];
  return (n, a) => {
    for (const { series: l, removeListener: h } of o)
      h(), l.dispose();
    o.length = 0, e.forEach((l) => {
      if (!l.data) return;
      const { startMs: h, dtMs: u, samples: c } = l.data;
      if (c.length === 0 || u <= 0) return;
      const d = Math.max(0, Math.ceil((n - h) / u)), f = Math.min(
        c.length - 1,
        Math.floor((a - h) / u)
      );
      if (f < d) return;
      const { color: p, label: g, zoomRestriction: y } = l.config, m = i.addLineSeries({
        schema: {
          x: { storage: Float64Array, pattern: "progressive" },
          y: { storage: Float32Array }
        },
        axisY: t
      }).setName(g).setAreaFillStyle(Lt).setStrokeStyle(
        (k) => k.setFillStyle(new ot({ color: Xe(p) })).setThickness(1)
      ).setHighlightOnHover(!1).setPointerEvents(!1).setDrawOrder({ seriesDrawOrderIndex: ka.Signals }), A = c.subarray(d, f + 1), v = new Float64Array(A.length);
      for (let k = 0; k < v.length; k++)
        v[k] = h + (d + k) * u;
      m.appendSamples({ x: v, y: A });
      const b = () => {
        const { start: k, end: R } = s.getInterval(), L = R - k;
        if (y) {
          const x = (y.min ? L >= y.min : !0) && (y.max ? L <= y.max : !0);
          m.setVisible(x);
        } else
          m.setVisible(!0);
      };
      b();
      const w = r.onChartEvent(
        s,
        "intervalchange",
        b
      );
      o.push({ series: m, removeListener: w });
    });
  };
}, cu = (r) => {
  const {
    axisPairsByChannelType: t,
    channelType: e,
    configuration: i,
    events: s,
    index: o,
    isVisible: n,
    onAxesSwapped: a,
    heightPxOverride: l,
    chartRuntime: h,
    selectedEventKey: u,
    registerEventRectangle: c
  } = r, { chart: d } = h, f = d.addAxisY({ iStack: o, opposite: !n }).setInterval({ start: 0, end: 1, stopAxisAfter: !0 }).setLength(
    l !== void 0 ? { pixels: l } : { relative: i.relativeHeight }
  ).setMargins(0, 20).setStopped(!0);
  if (f.setStrokeStyle(Et).setOverlayStyle(o0).setTickStrategy(jr.Empty).setUserInteractions(void 0).setPointerEvents(!0), n && i.tickInterval) {
    const { start: m, end: A, step: v, snapToStep: b } = i.tickInterval, w = A - m;
    if (w > 0) {
      const k = new $t({
        thickness: 1,
        fillStyle: new ot({ color: Xe("#E8E8E8") })
      });
      f.setMarginAfterTicks(16);
      const R = b ? Math.ceil(m / v) * v : m;
      for (let L = R; L <= A; L += v)
        Nd(
          f,
          (L - m) / w,
          "#8B8B8B",
          k,
          String(L)
        );
    }
  }
  const { bindWindow: p, updateLabelFits: g } = GC(
    h,
    f,
    s,
    u,
    c
  ), y = t.get(e);
  return n ? (t.set(e, { ...y, main: f }), A1(
    h,
    f,
    e,
    t,
    a
  )) : t.set(e, {
    ...y,
    opposite: f
  }), { syncEventsToYAxis: g, axis: f, bindWindow: p };
}, GC = (r, t, e, i, s) => {
  const { axisX: o, chart: n } = r, a = (b) => {
    switch (b) {
      case "top-left":
        return { x: -1, y: 1 };
      case "bottom-left":
        return { x: -1, y: -1 };
      case "top-right":
        return { x: 1, y: 1 };
      case "bottom-right":
        return { x: 1, y: -1 };
      case "center":
      case "none":
      default:
        return { x: 0, y: 0 };
    }
  }, l = (b, w, k) => {
    if (k === "center")
      return { x1: b, x2: w };
    const R = o.getInterval();
    return {
      x1: Math.max(b, R.start),
      x2: Math.min(w, R.end)
    };
  }, h = (b, w, k, R, L) => {
    if (L === "center")
      return { x: (b + w) / 2, y: (k + R) / 2 };
    const x = l(b, w, L);
    switch (L) {
      case "top-left":
        return { x: x.x1, y: R };
      case "bottom-left":
        return { x: x.x1, y: k };
      case "top-right":
        return { x: x.x2, y: R };
      case "bottom-right":
        return { x: x.x2, y: k };
    }
  }, u = (b) => ka.Events + b * 2, c = (b) => u(b) + 1, d = /* @__PURE__ */ new Map(), f = (b) => {
    const w = d.get(b);
    if (w) return w;
    const k = n.addRectangleSeries({ axisY: t }).setHighlightOnHover(!1).setDrawOrder({ seriesDrawOrderIndex: u(b) }).setPointerEvents(!1);
    return d.set(b, k), k;
  }, p = /* @__PURE__ */ new Map(), g = (b) => {
    const w = p.get(b);
    if (w) return w;
    const k = n.addTextSeries({ yAxis: t }).setCursorEnabled(!1).setDrawOrder({ seriesDrawOrderIndex: c(b) }).setPointerEvents(!1);
    return p.set(b, k), k;
  };
  let y = [];
  const m = (b, w) => {
    for (const L of d.values()) L.dispose();
    d.clear();
    for (const L of p.values()) L.dispose();
    p.clear();
    const k = e.flatMap((L) => {
      if (!L.data) return [];
      const { borderColor: x, fillColor: M, label: C, labelPlacement: S, relativeHeight: E } = L.config, T = new $t({
        thickness: 1,
        fillStyle: new ot({ color: Xe(x) })
      }), I = S ?? "top-left", F = r0(E);
      return L.data.filter(
        (D) => D.x2 >= b && D.x1 <= w
      ).map((D) => {
        const P = D.fillColor ?? M;
        return {
          x1: D.x1,
          x2: D.x2,
          y1: D.y1 ?? F.y1,
          y2: D.y2 ?? F.y2,
          fill: new ot({ color: Xe(P) }),
          blinkFill: new ot({
            color: Xe(P).setA(45)
          }),
          border: T,
          labelFill: new ot({
            color: Xe(zC(P))
          }),
          label: C,
          labelPlacement: I,
          eventKey: D.eventKey,
          isSelected: i != null && D.eventKey === i
        };
      });
    }), R = NC(k);
    y = k.map((L, x) => {
      const { x1: M, x2: C, y1: S, y2: E, labelPlacement: T } = L, I = f(R[x]).add({ x1: M, x2: C, y1: S, y2: E }).setFillStyle(L.fill).setStrokeStyle(L.border), F = g(R[x]).add({
        text: L.label,
        location: T === "none" ? { x: (M + C) / 2, y: (S + E) / 2 } : h(M, C, S, E, T),
        fillStyle: L.labelFill
      });
      return F.setFont(
        (D) => D.setFamily("Noto Sans, sans-serif").setSize(14)
      ), F.setAlignment(a(T)), F.setVisible(!1), L.isSelected && I.setStrokeStyle(
        new $t({
          thickness: 2,
          fillStyle: new ot({ color: Xe("#1890FF") })
        })
      ), s?.(L.eventKey, {
        rectangle: I,
        defaultFill: L.fill,
        blinkFill: L.blinkFill
      }), { rectangle: I, text: F, labelPlacement: T };
    }), v();
  }, A = () => {
    y.forEach(({ rectangle: b, text: w, labelPlacement: k }) => {
      const { x1: R, x2: L, y1: x, y2: M } = b.getDimensionsTwoPoints();
      if (k === "none") {
        w.setVisible(!1);
        return;
      }
      const C = l(R, L, k);
      if (C.x2 <= C.x1) {
        w.setVisible(!1);
        return;
      }
      w.setLocation(h(R, L, x, M, k));
      const S = (t.getInterval().start + t.getInterval().end) / 2, E = n.translateCoordinate(
        { x: C.x1, y: S },
        { x: o, y: t },
        n.coordsClient
      ), T = n.translateCoordinate(
        { x: C.x2, y: S },
        { x: o, y: t },
        n.coordsClient
      ), I = n.translateCoordinate(
        { x: C.x1, y: x },
        { x: o, y: t },
        n.coordsClient
      ), F = n.translateCoordinate(
        { x: C.x1, y: M },
        { x: o, y: t },
        n.coordsClient
      ), D = Math.abs(T.clientX - E.clientX), P = Math.abs(F.clientY - I.clientY), V = w.getSizePixels(), _ = 4;
      w.setVisible(
        D >= V.x + _ && P >= V.y + _
      );
    });
  }, v = r.rafOnce(A);
  return r.onChartEvent(o, "intervalchange", v), r.onChartEvent(n, "resize", v), { bindWindow: m, updateLabelFits: A };
}, A1 = (r, t, e, i, s) => {
  const { chart: o } = r;
  t.draggable = !0;
  const n = (h) => {
    h.dataTransfer && (h.dataTransfer.effectAllowed = "move", h.dataTransfer.setData("text/plain", e), h.dataTransfer.setDragImage(new Image(), 0, 0));
  }, a = (h) => {
    h.preventDefault(), h.dataTransfer && (h.dataTransfer.dropEffect = "move");
  }, l = (h) => {
    if (h.preventDefault(), !h.dataTransfer)
      return;
    const u = h.dataTransfer.getData("text/plain"), c = i.get(u), d = i.get(e);
    !c || !d || u === e || (c.main && d.main && o.swapAxes(c.main, d.main), c.opposite && d.opposite && o.swapAxes(c.opposite, d.opposite), s());
  };
  r.onChartEvent(t, "dragstart", n), r.onChartEvent(t, "dragover", a), r.onChartEvent(t, "drop", l);
}, UC = (r) => {
  const { chartRuntime: t, index: e, heightPx: i } = r, { chart: s } = t, o = (l) => s.addAxisY({ iStack: e, opposite: l }).setInterval({ start: 0, end: 1, stopAxisAfter: !0 }).setLength({ pixels: i }).setStrokeStyle(Et).setOverlayStyle(o0).setTickStrategy(jr.Empty).setMarginAfterTicks(16).setMargins(0, 20).setUserInteractions(void 0).setPointerEvents(!1).setStopped(!0), n = o(!1);
  return [o(!0), n];
}, ey = (r) => cu({
  ...r,
  events: [],
  isVisible: !1,
  onAxesSwapped: () => {
  }
}), hc = (r, t) => {
  if (r === tv.CalendarDay)
    return {
      startDateTimeInMs: t,
      endDateTimeInMs: t + qp
    };
  const e = t + _C, i = e + qp;
  return { startDateTimeInMs: e, endDateTimeInMs: i };
}, b1 = (r, t, e) => {
  if (!r.length)
    return [{ start: t, end: e }];
  const i = r.map((n) => ({
    start: Math.max(n.startMs, t),
    end: Math.min(n.startMs + n.duration, e)
  })).filter((n) => n.end > n.start).sort((n, a) => n.start - a.start);
  if (!i.length)
    return [{ start: t, end: e }];
  const s = [];
  i[0].start > t && s.push({
    start: t,
    end: i[0].start
  });
  for (let n = 1; n < i.length; n++) {
    const a = i[n - 1], l = i[n];
    l.start > a.end && s.push({
      start: a.end,
      end: l.start
    });
  }
  const o = i[i.length - 1];
  return o.end < e && s.push({
    start: o.end,
    end: e
  }), s;
}, HC = (r, t, e) => {
  const i = [...r].sort((n, a) => n.start - a.start), s = [];
  let o = t;
  for (const n of i)
    n.start > o && s.push({ start: o, end: Math.min(n.start, e) }), o = Math.max(o, n.end);
  return o < e && s.push({ start: o, end: e }), s;
}, YC = (r, t) => {
  const { axisX: e, container: i } = r, s = () => {
    const n = t();
    n && e.setInterval({
      start: n.start,
      end: n.end,
      stopAxisAfter: !0
    });
  };
  return { dispose: r.onDom(i, "dblclick", s) };
}, jC = (r, t, e, i) => {
  if (t === e)
    return r;
  const s = [...r], o = s.findIndex((u) => u.id === t), n = s.findIndex((u) => u.id === e);
  if (o === -1 || n === -1)
    return r;
  const [a] = s.splice(o, 1);
  if (i === void 0)
    return s.splice(n, 0, a), s;
  const l = s.findIndex(
    (u) => u.id === e
  ), h = i === "above" ? l : l + 1;
  return s.splice(h, 0, a), s;
}, $C = (r, t) => {
  if (r.length !== t.length)
    return !1;
  for (let e = 0; e < r.length; e += 1)
    if (r[e] !== t[e])
      return !1;
  return !0;
}, iy = (r, t) => {
  const e = new Map(
    r.map((i) => [i.id, i])
  );
  return t.map((i) => e.get(i)).filter((i) => !!i);
}, XC = (r, t) => {
  const e = new Set(t), i = r.filter((o) => e.has(o)), s = new Set(i);
  return [...i, ...t.filter((o) => !s.has(o))];
}, ZC = ({
  channels: r,
  controlledHiddenIds: t,
  initialHiddenIds: e,
  initialOrderIds: i,
  syncOrderWithChannels: s,
  onToggleVisibility: o
}) => {
  const n = ni(() => r.map((A) => A.id), [r]), [a, l] = ze(
    () => i ?? n
  ), [h, u] = ze(
    () => e ?? []
  ), [c, d] = ze(
    []
  ), f = t ?? h;
  mi(() => {
    l((A) => {
      const v = s ? n : XC(A, n);
      return $C(A, v) ? A : v;
    });
  }, [n, s]), mi(() => {
    const A = new Set(n);
    u((v) => {
      const b = v.filter((w) => A.has(w));
      return b.length === v.length ? v : b;
    });
  }, [n]), mi(() => {
    const A = new Set(n);
    d((v) => {
      const b = v.filter((w) => A.has(w.id));
      return b.length === v.length ? v : b;
    });
  }, [n]);
  const p = ni(
    () => iy(r, a),
    [r, a]
  ), g = ni(
    () => new Map(c.map((A) => [A.id, A])),
    [c]
  ), y = Fi(
    (A) => {
      if (t) {
        o?.(
          A,
          !t.includes(A)
        );
        return;
      }
      u(
        (v) => v.includes(A) ? v.filter((b) => b !== A) : [...v, A]
      );
    },
    [t, o]
  ), m = Fi(
    (A, v, b) => {
      l(
        (w) => jC(
          iy(r, w),
          A,
          v,
          b
        ).map((k) => k.id)
      );
    },
    [r]
  );
  return {
    orderedChannels: p,
    hiddenChannelIds: f,
    geometryByChannelId: g,
    setChannelGeometries: d,
    toggleVisibility: y,
    reorder: m
  };
}, KC = 150, qC = (r, t) => {
  let e = /* @__PURE__ */ new Map(), i = null, s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), a = {
    positions: [],
    plotLeftPx: void 0,
    plotRightPx: void 0
  }, l = null;
  const h = (f, p, g) => {
    if (a = { positions: f, plotLeftPx: p, plotRightPx: g }, f.length === 0) return;
    const y = g !== void 0 ? `calc(100% - ${g}px)` : "0", m = new Map(
      f.map((b) => [b.id, b])
    ), A = [...f].sort((b, w) => b.centerYPx - w.centerYPx).map((b) => b.id), v = m.get(A[0]);
    i && v && (i.style.paddingTop = `${Yn(v)}px`), A.forEach((b, w) => {
      const k = m.get(b);
      if (!k) return;
      const R = m.get(A[w + 1]), L = My(k, R), x = e.get(b);
      x?.container && (x.container.style.height = `${k.heightPx}px`, x.container.style.visibility = ""), x?.wrapper && (x.wrapper.style.paddingBottom = `${L}px`);
      const M = s.get(b);
      M && R && (M.style.top = `${Ou(k)}px`, M.style.height = `${L}px`, M.style.left = p !== void 0 ? `${p}px` : "0", M.style.right = y);
      const C = o.get(b);
      C && (C.style.top = `${Yn(k)}px`, C.style.height = `${k.heightPx}px`, C.style.right = y);
      const S = n.get(b);
      S && (S.style.top = `${Yn(k)}px`, S.style.height = `${k.heightPx}px`, S.style.left = p !== void 0 ? `${p}px` : "0", S.style.right = y);
    });
  }, u = () => {
    l !== null && (clearTimeout(l), l = null), r(a.positions), a.plotLeftPx !== void 0 && a.plotRightPx !== void 0 && t({
      plotLeftPx: a.plotLeftPx,
      plotRightPx: a.plotRightPx
    });
  };
  return {
    registerTitlesColumn: (f) => {
      i = f;
    },
    registerTitles: (f) => {
      e = f;
    },
    registerGapBands: (f) => {
      s = f;
    },
    registerHiddenBands: (f) => {
      o = f;
    },
    registerPlaceholderBands: (f) => {
      n = f;
    },
    apply: h,
    commit: u,
    commitMeasurement: (f, p, g) => {
      a = { positions: f, plotLeftPx: p, plotRightPx: g }, u();
    },
    scheduleCommit: () => {
      l !== null && clearTimeout(l), l = setTimeout(() => {
        l = null, u();
      }, KC);
    },
    getSnapshot: () => a,
    dispose: () => {
      l !== null && (clearTimeout(l), l = null), e = /* @__PURE__ */ new Map(), i = null, s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    }
  };
}, JC = (r, t) => {
  const e = Ei(null);
  return e.current || (e.current = qC(
    r,
    t
  )), mi(() => () => e.current?.dispose(), []), e.current;
}, Qr = 8, QC = {
  "backward-diagonal": 1,
  "wide-upward-diagonal": 3
}, tw = (r, t, e) => {
  const i = document.createElement("canvas");
  i.width = Qr, i.height = Qr;
  const s = i.getContext("2d");
  return s && (s.fillStyle = r, s.fillRect(0, 0, Qr, Qr), s.strokeStyle = t, s.lineWidth = e, s.beginPath(), s.moveTo(0, Qr), s.lineTo(Qr, 0), s.moveTo(-2, 2), s.lineTo(2, -2), s.moveTo(Qr - 2, Qr + 2), s.lineTo(Qr + 2, Qr - 2), s.stroke()), i;
}, ew = (r) => {
  const t = QC[r.fillType ?? "solid"];
  return t === void 0 ? new ot({ color: Xe(r.backgroundColor) }) : new wr({
    source: tw(
      r.backgroundColor,
      r.stripeColor ?? r.backgroundColor,
      t
    ),
    fitMode: Li.Tile
  });
}, iw = (r) => r.map((t) => ({
  globalEvent: t,
  intervals: t.data ?? []
})).filter(({ intervals: t }) => t.length > 0).sort(
  (t, e) => e.globalEvent.config.priority - t.globalEvent.config.priority
), sw = 2, rw = (r, t, e) => {
  const { chart: i, axisX: s } = r, o = iw(t);
  let n = [];
  const a = () => {
    const h = e();
    if (!h || n.length === 0) return;
    const u = s.getInterval(), c = Math.abs(u.end - u.start);
    if (c <= 0) return;
    const d = i.translateCoordinate(
      { x: u.start, y: 0.5 },
      { x: s, y: h },
      i.coordsClient
    ), f = i.translateCoordinate(
      { x: u.end, y: 0.5 },
      { x: s, y: h },
      i.coordsClient
    ), p = Math.abs(f.clientX - d.clientX);
    if (p <= 0) return;
    const g = sw * c / p;
    for (const { band: y, x1: m, x2: A } of n)
      if (A - m >= g)
        y.setValueStart(m).setValueEnd(A);
      else {
        const v = (m + A) / 2;
        y.setValueStart(v - g / 2).setValueEnd(v + g / 2);
      }
  }, l = r.rafOnce(a);
  return r.onChartEvent(s, "intervalchange", l), r.onChartEvent(i, "resize", l), (h, u) => {
    n.forEach(({ band: c }) => c.dispose()), n = [];
    for (const { globalEvent: c, intervals: d } of o) {
      const f = ew(c.config);
      for (const p of d) {
        if (p.x2 <= h || p.x1 >= u)
          continue;
        const g = s.addBand({ onTop: !1 }).setValueStart(p.x1).setValueEnd(p.x2).setFillStyle(f).setStrokeStyle(Et).setPointerEvents(!1).setHighlightOnHover(!1);
        n.push({ band: g, x1: p.x1, x2: p.x2 });
      }
    }
    l();
  };
}, nw = (r, t) => r.flatMap(
  (e) => (e.data ?? []).filter((i) => t >= i.x1 && t <= i.x2).map((i) => ({ globalEvent: e, interval: i }))
), E1 = 11, ow = (r) => {
  const t = Math.round(r * 10) / 10;
  return Number.isInteger(t) ? String(t) : t.toFixed(1);
}, aw = (r) => r.length * E1 * 0.65 + 12, lw = (r, t, e, i) => {
  const s = r.map((a) => ({
    startMs: Math.max(a.startMs, e),
    endMs: Math.min(a.endMs, i),
    value: t(a)
  })).filter((a) => a.endMs > a.startMs), o = [], n = [];
  return s.forEach((a, l) => {
    o.push(a.startMs, a.endMs), n.push(a.value, a.value);
    const h = s[l + 1];
    h && h.startMs > a.endMs && (o.push(a.endMs), n.push(Number.NaN));
  }), { x: new Float64Array(o), y: new Float32Array(n) };
}, hw = (r, t, e, i) => {
  const s = /* @__PURE__ */ new Map();
  for (const o of r) {
    const n = Math.max(o.startMs, e), a = Math.min(o.endMs, i);
    if (a <= n) continue;
    const l = t(o), h = s.get(l);
    h ? h.push({ startMs: n, endMs: a }) : s.set(l, [{ startMs: n, endMs: a }]);
  }
  return [...s.entries()].map(([o, n]) => ({
    value: o,
    spans: n.sort((a, l) => a.startMs - l.startMs)
  }));
}, uw = (r, t, e, i) => {
  const { chart: s, axisX: o } = r, n = [], a = [
    {
      selectValue: (c) => c.max,
      color: e.max.color,
      rightOrigin: Sl.RightTop,
      leftOrigin: Sl.LeftTop
    },
    {
      selectValue: (c) => c.min,
      color: e.min.color,
      rightOrigin: Sl.RightBottom,
      leftOrigin: Sl.LeftBottom
    }
  ], l = [], h = () => {
    const c = o.getInterval(), d = c.end - c.start;
    if (d <= 0) return;
    const f = s.translateCoordinate(
      { x: c.start, y: 0 },
      { x: o, y: t },
      s.coordsClient
    ), p = s.translateCoordinate(
      { x: c.end, y: 0 },
      { x: o, y: t },
      s.coordsClient
    ), g = Math.abs(p.clientX - f.clientX);
    if (g <= 0) return;
    const y = d / g;
    for (const m of l) {
      const A = m.spans.find(
        (b) => b.endMs > c.start && b.startMs < c.end
      );
      if (!A) {
        m.box.setVisible(!1);
        continue;
      }
      m.box.setVisible(!0);
      const v = m.widthPx * y;
      A.startMs - v >= c.start ? m.box.setOrigin(m.rightOrigin).setPosition({ x: A.startMs, y: m.value }) : m.box.setOrigin(m.leftOrigin).setPosition({ x: c.start, y: m.value });
    }
  }, u = r.rafOnce(h);
  return r.onChartEvent(o, "intervalchange", u), r.onChartEvent(s, "resize", u), (c, d) => {
    for (const f of n) f.dispose();
    n.length = 0;
    for (const f of l) f.box.dispose();
    if (l.length = 0, i.length !== 0) {
      for (const {
        selectValue: f,
        color: p,
        rightOrigin: g,
        leftOrigin: y
      } of a) {
        const m = Xe(p), A = new Xu({
          thickness: 1,
          pattern: uh.Dotted,
          fillStyle: new ot({ color: m })
        }), v = new ot({ color: m }), b = lw(
          i,
          f,
          c,
          d
        );
        if (b.x.length === 0) continue;
        const w = s.addLineSeries({
          schema: {
            x: { storage: Float64Array },
            y: { storage: Float32Array }
          },
          axisY: t
        }).setAreaFillStyle(Lt).setStrokeStyle(A).setHighlightOnHover(!1).setPointerEvents(!1).setDrawOrder({ seriesDrawOrderIndex: ka.Signals });
        w.appendSamples({ x: b.x, y: b.y }), n.push(w);
        const k = hw(
          i,
          f,
          c,
          d
        );
        for (const R of k) {
          const L = ow(R.value), x = s.addUIElement(Yl.TextBox, {
            x: o,
            y: t
          }).setOrigin(g).setText(L).setTextFont(
            (M) => M.setSize(E1).setFamily("Noto Sans")
          ).setTextFillStyle(v).setBackground(
            (M) => M.setFillStyle(new ot({ color: Xe("#FFFFFFCC") })).setStrokeStyle(Et)
          ).setPointerEvents(!1);
          l.push({
            box: x,
            value: R.value,
            spans: R.spans,
            widthPx: aw(L),
            rightOrigin: g,
            leftOrigin: y
          });
        }
      }
      u();
    }
  };
}, Zc = 15;
function M1(r, t, e) {
  const { offsetWidth: i, offsetHeight: s } = r, n = t + Zc + i > window.innerWidth ? Math.max(0, t - Zc - i) : t + Zc, a = Math.max(
    0,
    Math.min(e - 10, window.innerHeight - s)
  );
  r.style.left = `${n}px`, r.style.top = `${a}px`;
}
let C1 = !1;
const Kc = (r) => {
  C1 = r;
}, cw = () => C1;
function dw(r, t) {
  if (!r.data) return null;
  const { startMs: e, dtMs: i, samples: s } = r.data, o = Math.round((t - e) / i);
  if (o < 0 || o >= s.length) return null;
  const n = s[o];
  return Number.isFinite(n) ? n : null;
}
function fw(r) {
  return !r || r === "-" ? "" : ` (<i>${r}</i>)`;
}
let Fl = null, Ll = null;
const gw = () => {
  Fl && (Fl.style.opacity = "0"), Ll && (Ll.style.opacity = "0");
}, pw = (r, t, e = /* @__PURE__ */ new Set(), i = []) => {
  const { chart: s, axisX: o, container: n } = r, a = t.filter((v) => !e.has(v.id)).reverse(), l = Fl ?? document.createElement("div");
  Fl || (Fl = l, document.body.append(l)), l.className = "chart-container__tooltip", l.style.opacity = "0", l.innerHTML = "";
  const h = Ll ?? document.createElement("div");
  Ll || (Ll = h, document.body.append(h)), h.className = "chart-container__cursor-line", s.setCursorMode(void 0);
  let u = !1;
  const c = () => {
    l.style.opacity = "0", h.style.opacity = "0";
  }, d = () => {
    u = !0, c();
  }, f = () => {
    u = !1, c();
  }, p = (v, b) => `
      <div style="display: flex; align-items: center; margin-bottom: 4px;">
        <span style="display: inline-block; width: 12px; height: 12px; background: ${v.config.color}; margin-right: 10px; border-radius: 2px;"></span>
        <span style="flex: 1; font-family: 'Noto Sans', sans-serif; color: #5D5D5D; font-weight: 400;">${v.config.label}${fw(v.data?.physicalDimension)}</span>
        <span style="margin-left: 16px; font-weight: 400; color: #181818; font-size: 14px;">${b.toFixed(1)}</span>
      </div>
    `, g = (v) => {
    if (!v.fillType || v.fillType === "solid")
      return v.backgroundColor;
    const b = v.fillType === "wide-upward-diagonal" ? 3 : 1, w = v.stripeColor ?? v.backgroundColor;
    return `repeating-linear-gradient(135deg, ${v.backgroundColor} 0 ${6 - b}px, ${w} ${6 - b}px 6px)`;
  }, y = (v, b) => {
    const w = _d((b.x2 - b.x1) / 1e3);
    return `
          <div style="display: flex; align-items: center; margin-bottom: 4px;">
            <span style="display: inline-block; box-sizing: border-box; width: 12px; height: 12px; background: ${g(v.config)}; margin-right: 10px; border-radius: 2px;"></span>
            <span style="flex: 1; font-family: 'Noto Sans', sans-serif; color: #5D5D5D; font-weight: 400;">${v.config.label}</span>
            <span style="margin-left: 16px; font-weight: 400; color: #181818; font-size: 14px;">${w}</span>
          </div>
        `;
  }, m = (v, b) => {
    const w = _d((b.x2 - b.x1) / 1e3), k = v.config.borderColor ? `border: 1px solid ${v.config.borderColor};` : "";
    return `
          <div style="display: flex; align-items: center; margin-bottom: 4px;">
            <span style="display: inline-block; box-sizing: border-box; width: 12px; height: 12px; background: ${v.config.fillColor}; ${k} margin-right: 10px; border-radius: 2px;"></span>
            <span style="flex: 1; font-family: 'Noto Sans', sans-serif; color: #5D5D5D; font-weight: 400;">${v.config.label}</span>
            <span style="margin-left: 16px; font-weight: 400; color: #181818; font-size: 14px;">${w}</span>
          </div>
        `;
  }, A = (v) => {
    if (u || cw()) {
      c();
      return;
    }
    const b = n.getBoundingClientRect(), w = b.top + Od, k = b.bottom - v1;
    if (v.clientY < w || v.clientY > k) {
      c();
      return;
    }
    const R = s.translateCoordinate(v, s.coordsAxis).x, { start: L, end: x } = o.getInterval();
    if (!Number.isFinite(R) || R < Math.min(L, x) || R > Math.max(L, x)) {
      c();
      return;
    }
    h.style.opacity = "1", h.style.left = `${v.clientX}px`, h.style.top = `${w}px`, h.style.height = `${Math.max(0, k - w)}px`;
    const M = nw(i, R).map(
      ({ globalEvent: T, interval: I }) => y(T, I)
    ).join(""), C = a.map((T) => {
      const I = T.signals.map((D) => {
        const P = dw(D, R);
        return P !== null ? p(D, P) : "";
      }).join(""), F = T.events.flatMap(
        (D) => (D?.data || []).filter(
          (P) => R >= P.x1 && R <= P.x2
        ).map((P) => m(D, P))
      ).join("");
      return I + F;
    }).join(""), S = M + C, E = S ? " margin-bottom: 8px; border-bottom: 1px solid #eee; padding-bottom: 6px;" : "";
    l.innerHTML = `
      <div style="color: #666; font-size: 14px;${E}">
        ${x1(new Date(R).toISOString())}
        </div>
        ${S}
    `, l.style.opacity = "1", M1(l, v.clientX, v.clientY);
  };
  return r.onDom(n, "mousemove", A), r.onDom(n, "mouseleave", c), {
    suspend: d,
    resume: f,
    hide: c,
    dispose: c
  };
}, yw = (r, t, e, i, s) => {
  const { axisX: o, chart: n } = r, a = /* @__PURE__ */ new Map(), l = 100;
  let h = !1, u = 0, c = null, d = null, f = null;
  const p = (E) => {
    if (E.button !== 0 || !E.ctrlKey) return;
    A();
    const T = L(E.clientY), I = n.translateCoordinate(E, n.coordsAxis);
    if (!T) {
      m();
      return;
    }
    T.channel.configuration.axisType !== Ct.EventOnly && (i?.(), m(), c = T.channel.id, d = T.axis, h = !0, u = I.x, n.setUserInteractions({
      pan: !1,
      rectangleZoom: !1
    }), k());
  };
  r.onChartEvent(
    n.seriesBackground,
    "pointerdown",
    p
  );
  const g = () => {
    if (A(), f) {
      if (!t.some(
        (T) => T.id === f?.channelId
      )) {
        m();
        return;
      }
      v(
        f.channelId,
        f.axisY,
        f.xMin,
        f.xMax
      );
    }
  };
  r.onChartEvent(o, "intervalchange", g);
  const y = () => {
    for (const E of a.values())
      E.clear();
  }, m = () => {
    f = null, h = !1, c = null, d = null, y(), s?.(null);
  }, A = () => {
    const E = new Set(t.map((T) => T.id));
    for (const [T, I] of a.entries())
      E.has(T) || (I.clear(), a.delete(T));
    f && !E.has(f.channelId) && m();
  }, v = (E, T, I, F) => {
    const D = w(E, T), P = T.getInterval(), V = Math.min(P.start, P.end), _ = Math.max(P.start, P.end), B = Math.max(_ - V, 1e-9) * l, z = V - B, W = _ + B;
    y(), D.add({
      x: I,
      y: z,
      width: F - I,
      height: W - z
    }).setFillStyle(new ot({ color: Xe("#40A9FF80") })).setStrokeStyle(
      new Xu({
        pattern: uh.Dashed,
        fillStyle: new ot({ color: Xe("#096DD9") })
      })
    );
  }, b = (E) => e.get(E)?.main ?? null, w = (E, T) => {
    let I = a.get(E);
    return I || (I = n.addRectangleSeries({
      xAxis: o,
      axisY: T
    }).setPointerEvents(!1), a.set(E, I)), I;
  }, k = () => {
    R(), document.body.addEventListener("pointermove", C), document.body.addEventListener("pointerup", S);
  }, R = () => {
    document.body.removeEventListener("pointermove", C), document.body.removeEventListener("pointerup", S);
  }, L = (E) => {
    for (const T of t) {
      const I = b(T.id);
      if (!I) continue;
      const F = I.getInterval(), { top: D, bottom: P } = ql(
        n,
        o,
        I,
        F.start,
        F.end
      );
      if (E >= D && E <= P)
        return { channel: T, axis: I };
    }
    return null;
  }, x = (E, T, I) => {
    const F = t.find((P) => P.id === E);
    if (!F)
      return console.warn("Channel not found:", E), null;
    const D = [];
    for (const P of F.signals) {
      if (!P.data) continue;
      const V = M(P.data, T, I);
      V && D.push({
        signalType: P.type,
        physicalDimension: P.data.physicalDimension,
        min: V.min,
        minTimeMs: P.data.startMs + V.minIndex * P.data.dtMs,
        max: V.max,
        maxTimeMs: P.data.startMs + V.maxIndex * P.data.dtMs,
        avg: V.avg
      });
    }
    return {
      channelId: E,
      intervalStartMs: T,
      intervalEndMs: I,
      durationMs: I - T,
      signals: D
    };
  }, M = (E, T, I) => {
    const { startMs: F, dtMs: D, samples: P } = E, V = Math.max(0, Math.floor((T - F) / D)), _ = Math.min(
      P.length - 1,
      Math.ceil((I - F) / D)
    );
    if (_ < V || V >= P.length || _ < 0)
      return null;
    let O = Number.POSITIVE_INFINITY, B = Number.NEGATIVE_INFINITY, z = -1, W = -1, G = 0, Y = 0;
    for (let U = V; U <= _; U++) {
      const $ = P[U];
      $ < O && (O = $, z = U), $ > B && (B = $, W = U), G += $, Y++;
    }
    return Y === 0 || z === -1 || W === -1 ? null : {
      startIndex: V,
      endIndex: _,
      count: Y,
      min: O,
      minIndex: z,
      max: B,
      maxIndex: W,
      avg: G / Y
    };
  }, C = (E) => {
    if (!h || !d || !c) return;
    const T = n.translateCoordinate(E, n.coordsAxis), I = Math.min(u, T.x), F = Math.max(u, T.x);
    v(c, d, I, F);
  }, S = (E) => {
    if (!h || !d || !c) return;
    h = !1, R(), _u(r);
    const I = n.translateCoordinate(E, n.coordsAxis).x, F = Math.min(u, I), D = Math.max(u, I);
    if (Math.abs(D - F) < 1e-6) {
      m();
      return;
    }
    f = {
      channelId: c,
      axisY: d,
      xMin: F,
      xMax: D
    }, v(c, d, F, D);
    const P = x(c, F, D);
    s?.(P);
  };
  return {
    clearSelection: () => {
      m(), R(), _u(r);
    },
    dispose: () => {
      R(), y();
    }
  };
}, mw = (r, t) => {
  const { axisX: e, chart: i, container: s } = r, o = document.createElement("div");
  o.style.position = "absolute", o.style.pointerEvents = "none", o.style.zIndex = "20", o.style.left = "0px", o.style.width = "0px", o.style.background = "rgba(52, 155, 213, 0.32)", o.style.borderLeft = "2px solid #40A9FF", o.style.borderRight = "2px solid #40A9FF", o.style.boxSizing = "border-box", o.style.opacity = "0", getComputedStyle(s).position === "static" && (s.style.position = "relative"), s.appendChild(o);
  let n = !1, a = 0, l = 0;
  const h = () => {
    o.style.top = `${Od}px`, o.style.height = `${Math.max(0, s.clientHeight - Od - v1)}px`;
  }, u = () => {
    o.style.opacity = "0", o.style.width = "0px";
  }, c = (m, A) => {
    const v = s.getBoundingClientRect(), b = Math.min(m, A) - v.left, w = Math.abs(A - m);
    h(), o.style.left = `${b}px`, o.style.width = `${w}px`, o.style.opacity = "1";
  }, d = (m) => {
    m.button === 0 && (m.ctrlKey || (n = !0, l = m.clientX, a = i.translateCoordinate(m, i.coordsAxis).x, t?.suspend(), c(l, l), i.setUserInteractions({
      pan: !1,
      rectangleZoom: !1,
      zoom: !1
    }), g()));
  }, f = (m) => {
    n && c(l, m.clientX);
  }, p = (m) => {
    if (!n) return;
    n = !1;
    const A = i.translateCoordinate(m, i.coordsAxis).x, v = Math.min(a, A), b = Math.max(a, A), w = Math.abs(m.clientX - l);
    y(), u(), _u(r), t?.resume(), !(w < 3 || Math.abs(b - v) < 1e-6) && e.setInterval({
      start: v,
      end: b,
      stopAxisAfter: !0
    });
  }, g = () => {
    y(), document.body.addEventListener("pointermove", f), document.body.addEventListener("pointerup", p), window.addEventListener("resize", h);
  }, y = () => {
    document.body.removeEventListener("pointermove", f), document.body.removeEventListener("pointerup", p), window.removeEventListener("resize", h);
  };
  return r.onChartEvent(
    i.seriesBackground,
    "pointerdown",
    d
  ), {
    dispose: () => {
      y(), u(), t?.resume(), o.remove();
    }
  };
}, xw = (r, t, e, i, s) => {
  const { axisX: o, chart: n, container: a } = r, l = document.createElement("div");
  l.style.position = "absolute", l.style.pointerEvents = "none", l.style.zIndex = "35", l.style.boxSizing = "border-box", l.style.border = "2px solid #1890ff", l.style.background = "rgba(24, 144, 255, 0.14)", l.style.opacity = "0", a.append(l);
  let h = null;
  const u = (S) => {
    const E = e.get(S);
    return E?.opposite ?? E?.main ?? null;
  }, c = (S, E, T, I, F) => {
    const D = u(S);
    if (!D) return null;
    const P = n.translateCoordinate(
      { x: E, y: I },
      { x: o, y: D },
      n.coordsClient
    ), V = n.translateCoordinate(
      { x: T, y: F },
      { x: o, y: D },
      n.coordsClient
    ), _ = n.translateCoordinate(
      { x: E, y: I },
      { x: o, y: D },
      n.coordsClient
    ), O = n.translateCoordinate(
      { x: E, y: F },
      { x: o, y: D },
      n.coordsClient
    );
    return {
      left: Math.min(P.clientX, V.clientX),
      right: Math.max(P.clientX, V.clientX),
      top: Math.min(O.clientY, _.clientY),
      bottom: Math.max(O.clientY, _.clientY)
    };
  }, d = (S) => {
    const E = u(S);
    if (!E) return null;
    const { top: T, bottom: I } = ql(n, o, E, 0, 1);
    return I - T;
  }, f = (S, E) => n.translateCoordinate(E, n.coordsAxis).x - n.translateCoordinate(
    { clientX: S.startClientX, clientY: E.clientY },
    n.coordsAxis
  ).x, p = (S, E) => {
    const T = d(S.hit.channelId);
    return T ? -(E.clientY - S.startClientY) / T : 0;
  }, g = (S, E) => {
    const T = f(S, E), I = p(S, E), F = 1e3, D = 0.05, P = S.originalY2 - S.originalY1;
    if (S.hit.edge === "left")
      return {
        startMs: Math.min(
          S.originalEndMs - F,
          S.originalStartMs + T
        ),
        endMs: S.originalEndMs,
        y1: S.originalY1,
        y2: S.originalY2
      };
    if (S.hit.edge === "right")
      return {
        startMs: S.originalStartMs,
        endMs: Math.max(
          S.originalStartMs + F,
          S.originalEndMs + T
        ),
        y1: S.originalY1,
        y2: S.originalY2
      };
    if (S.hit.edge === "top")
      return {
        startMs: S.originalStartMs,
        endMs: S.originalEndMs,
        y1: S.originalY1,
        y2: Math.max(
          S.originalY1 + D,
          Math.min(1, S.originalY2 + I)
        )
      };
    if (S.hit.edge === "bottom")
      return {
        startMs: S.originalStartMs,
        endMs: S.originalEndMs,
        y1: Math.min(
          S.originalY2 - D,
          Math.max(0, S.originalY1 + I)
        ),
        y2: S.originalY2
      };
    const V = Math.max(
      0,
      Math.min(1 - P, S.originalY1 + I)
    );
    return {
      startMs: S.originalStartMs + T,
      endMs: S.originalEndMs + T,
      y1: V,
      y2: V + P
    };
  }, y = (S, E, T, I) => {
    const F = a.getBoundingClientRect(), D = Math.min(S, E) - F.left, P = Math.min(T, I) - F.top, V = Math.abs(E - S), _ = Math.abs(I - T);
    l.style.left = `${D}px`, l.style.top = `${P}px`, l.style.width = `${V}px`, l.style.height = `${_}px`, l.style.opacity = "1";
  }, m = () => {
    l.style.opacity = "0";
  }, A = (S, E, T) => {
    if (!(S.clientX >= E.left - T && S.clientX <= E.right + T && S.clientY >= E.top - T && S.clientY <= E.bottom + T)) return null;
    const F = S.clientX >= E.left && S.clientX <= E.right && S.clientY >= E.top && S.clientY <= E.bottom, D = Math.abs(S.clientY - E.top) <= T, P = Math.abs(S.clientY - E.bottom) <= T, V = Math.abs(S.clientX - E.left) <= T, _ = Math.abs(S.clientX - E.right) <= T, O = S.clientX >= E.left - T && S.clientX <= E.right + T;
    return O && D ? "top" : O && P ? "bottom" : V ? "left" : _ ? "right" : F ? "body" : null;
  }, v = (S) => {
    let E = null, T = 1 / 0;
    for (const I of t)
      for (const F of I.events)
        for (const D of F.data ?? []) {
          if (!D.eventKey) continue;
          const P = r0(F.config.relativeHeight), V = D.y1 ?? P.y1, _ = D.y2 ?? P.y2, O = c(
            I.id,
            D.x1,
            D.x2,
            V,
            _
          );
          if (!O) continue;
          const z = A(S, O, 7);
          if (!z) continue;
          const W = Math.max(0, D.x2 - D.x1) * Math.max(0, _ - V);
          W > T || (T = W, E = {
            channelId: I.id,
            edge: z,
            eventKey: D.eventKey,
            eventType: D.eventType ?? F.type,
            eventName: F.config.label || F.type,
            startMs: D.x1,
            endMs: D.x2,
            fillColor: D.fillColor ?? F.config.fillColor,
            isAlarm: D.isAlarm,
            y1: V,
            y2: _
          });
        }
    return E;
  }, b = (S) => {
    for (const E of t) {
      const T = u(E.id);
      if (!T) continue;
      const I = ql(n, o, T, 0, 1);
      if (S >= I.top && S <= I.bottom)
        return { channelId: E.id, ...I };
    }
    return null;
  }, w = (S) => {
    if (!i.active || S.button !== 0) return;
    if (i.mode === "create") {
      S.preventDefault(), S.stopPropagation();
      const I = n.translateCoordinate(S, n.coordsAxis).x, F = b(S.clientY);
      if (!F) return;
      h = {
        kind: "create",
        channelId: F.channelId,
        startMs: I,
        startClientX: S.clientX,
        channelRect: F
      }, s?.suspend(), y(
        S.clientX,
        S.clientX,
        F.top,
        F.bottom
      ), M();
      return;
    }
    const E = v(S);
    if (!E) return;
    if (S.preventDefault(), S.stopPropagation(), E.eventKey !== i.selectedEventKey) {
      i.onSelectEvent(E);
      return;
    }
    h = {
      kind: "edit",
      hit: E,
      startClientX: S.clientX,
      startClientY: S.clientY,
      originalStartMs: E.startMs,
      originalEndMs: E.endMs,
      originalY1: E.y1,
      originalY2: E.y2
    }, s?.suspend();
    const T = c(
      E.channelId,
      E.startMs,
      E.endMs,
      E.y1,
      E.y2
    );
    T && y(T.left, T.right, T.top, T.bottom), M();
  }, k = (S) => {
    if (!h) return;
    if (h.kind === "create") {
      y(
        h.startClientX,
        S.clientX,
        h.channelRect.top,
        h.channelRect.bottom
      );
      return;
    }
    const E = h, T = g(E, S), I = c(
      E.hit.channelId,
      T.startMs,
      T.endMs,
      T.y1,
      T.y2
    );
    I && y(I.left, I.right, I.top, I.bottom);
  }, R = (S) => {
    if (!h) return;
    const E = h;
    if (h = null, m(), s?.resume(), C(), E.kind === "create") {
      const I = n.translateCoordinate(S, n.coordsAxis).x, F = Math.min(E.startMs, I), D = Math.max(E.startMs, I);
      if (Math.abs(D - F) < 1e3) return;
      i.onCreateEvent({
        channelId: E.channelId,
        eventType: i.createEventType,
        startMs: F,
        endMs: D
      });
      return;
    }
    const T = g(E, S);
    i.onChangeEvent(E.hit.eventKey, {
      startMs: T.startMs,
      endMs: T.endMs,
      y1: T.y1,
      y2: T.y2
    });
  }, L = (S) => {
    if (!i.active) {
      a.style.cursor = "";
      return;
    }
    if (h) return;
    if (i.mode === "create") {
      a.style.cursor = b(S.clientY) ? "crosshair" : "";
      return;
    }
    const E = v(S);
    if (!E) {
      a.style.cursor = "";
      return;
    }
    if (E.eventKey !== i.selectedEventKey) {
      a.style.cursor = "pointer";
      return;
    }
    a.style.cursor = E.edge === "left" || E.edge === "right" ? "ew-resize" : E.edge === "top" || E.edge === "bottom" ? "ns-resize" : "move";
  }, x = () => {
    h || (a.style.cursor = "");
  }, M = () => {
    C(), document.body.addEventListener("pointermove", k), document.body.addEventListener("pointerup", R);
  }, C = () => {
    document.body.removeEventListener("pointermove", k), document.body.removeEventListener("pointerup", R);
  };
  return r.onDom(a, "pointerdown", w, !0), r.onDom(a, "pointermove", L, !0), r.onDom(a, "pointerleave", x, !0), {
    dispose: () => {
      C(), a.style.cursor = "", l.remove(), s?.resume();
    }
  };
};
function w1(r) {
  const t = r.flatMap((e) => vw(e)).sort((e, i) => e.startMs - i.startMs);
  return Ew(t);
}
function vw(r) {
  return r.sections.flatMap((t) => Sw(t));
}
function Sw(r) {
  return Aw(r.snapshots, r.endMs);
}
function Aw(r, t) {
  if (r.length === 0) return [];
  const e = [...r].sort(
    (i, s) => i.startMs - s.startMs
  );
  return e.map((i, s) => {
    const o = e[s + 1], n = i.startMs, a = Math.min(
      o ? o.startMs : t,
      t
    );
    if (n >= a) return null;
    const l = [...i.rows].sort((h, u) => (h.order ?? 0) - (u.order ?? 0)).map((h) => bw(h));
    return l.length > 0 ? {
      startMs: n,
      endMs: a,
      mode: i.mode || null,
      texts: l
    } : null;
  }).filter((i) => i != null);
}
function bw(r) {
  const t = r.numericValue ?? Number(r.value), e = {
    id: r.id,
    key: r.id,
    title: r.label,
    value: r.value,
    changeValue: r.changeValue ?? r.value,
    isChanged: !1
  };
  return r.unit && (e.unit = r.unit), Number.isFinite(t) && (e.numericValue = t), e;
}
function Ew(r) {
  const t = /* @__PURE__ */ new Map();
  let e = /* @__PURE__ */ new Set();
  return r.map((i, s) => {
    const o = new Set(i.texts.map((a) => a.id)), n = i.texts.map((a) => {
      const l = t.get(a.id), h = s > 0 && !e.has(a.id), u = l != null && (l.changeValue !== a.changeValue || l.value !== a.value), c = { ...a, isChanged: h || u };
      return t.set(a.id, c), c;
    });
    return e = o, {
      ...i,
      texts: n
    };
  });
}
const sy = 25, ry = 0.04, Mw = "#DEF1F2", Cw = "#ABDDDE", ww = "#ABDDDE", Tw = "#1a1a1a", kw = "#1890FF", Dw = 0.56, Fw = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.1464 8.14645C10.3417 7.95118 10.6582 7.95118 10.8535 8.14645C11.0487 8.34171 11.0487 8.65823 10.8535 8.85348L7.85348 11.8535C7.65823 12.0487 7.34171 12.0487 7.14645 11.8535L4.14645 8.85348C3.95118 8.65822 3.95118 8.34171 4.14645 8.14645C4.34171 7.95118 4.65822 7.95118 4.85348 8.14645L7.49996 10.7929L10.1464 8.14645ZM10.1464 4.14645C10.3417 3.95118 10.6582 3.95118 10.8535 4.14645C11.0487 4.34171 11.0487 4.65823 10.8535 4.85348L7.85348 7.85348C7.65823 8.04873 7.34171 8.0487 7.14645 7.85348L4.14645 4.85348C3.95118 4.65822 3.95118 4.34171 4.14645 4.14645C4.34171 3.95118 4.65822 3.95118 4.85348 4.14645L7.49996 6.79293L10.1464 4.14645Z" fill="#1890FF"/></svg>', Lw = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.85355 7.85355C4.65829 8.04881 4.34178 8.04881 4.14652 7.85355C3.9513 7.65829 3.95127 7.34177 4.14652 7.14652L7.14652 4.14652C7.34177 3.95127 7.65829 3.9513 7.85355 4.14652L10.8536 7.14652C11.0488 7.34178 11.0488 7.65829 10.8536 7.85355C10.6583 8.04882 10.3418 8.04882 10.1465 7.85355L7.50004 5.20707L4.85355 7.85355ZM4.85355 11.8536C4.65829 12.0488 4.34178 12.0488 4.14652 11.8536C3.9513 11.6583 3.95127 11.3418 4.14652 11.1465L7.14652 8.14652C7.34177 7.95127 7.65829 7.9513 7.85355 8.14652L10.8536 11.1465C11.0488 11.3418 11.0488 11.6583 10.8536 11.8536C10.6583 12.0488 10.3418 12.0488 10.1465 11.8536L7.50004 9.20707L4.85355 11.8536Z" fill="#1890FF"/></svg>';
let qc = null;
function Pw() {
  if (qc) return qc;
  const r = document.createElement("div");
  return r.style.cssText = `
    position: fixed; z-index: 10000; pointer-events: none;
    background: #fff; border: 1px solid #ddd; border-radius: 6px;
    padding: 10px 14px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    font-family: 'Noto Sans', sans-serif; font-size: 14px; line-height: 20px;
    font-weight: 400; color: #181818;
    opacity: 0; transition: opacity 0.1s;
    width: 320px;
  `, document.body.append(r), qc = r, r;
}
function Rw(r, t, e) {
  if (t.numericValue == null) return null;
  for (let i = r - 1; i >= 0; i--) {
    const s = e[i].texts.find(
      (o) => o.id === t.id
    );
    if (s)
      return s.numericValue == null ? null : t.numericValue > s.numericValue ? "up" : t.numericValue < s.numericValue ? "down" : null;
  }
  return null;
}
function Iw(r) {
  return r ? `<span aria-hidden="true" style="display:inline-flex;align-items:center;margin-left:4px;line-height:1;">${r === "up" ? Lw : Fw}</span>` : "";
}
function Vw(r) {
  return r ? r === "cmH2O" ? "cmH₂O" : r : "";
}
function _w(r, t, e) {
  const i = r.mode ? `<div style="font-size:14px;line-height:20px;font-weight:400;color:#181818;margin-bottom:6px;padding-bottom:4px;border-bottom:1px solid #eee;">Mode: ${r.mode}</div>` : "", s = r.texts.filter((n) => n.title !== "Mode" && n.key !== "Mode").map((n) => {
    const a = n.isChanged ? Rw(t, n, e) : null, l = Iw(a), h = Vw(n.unit), u = h ? `${n.value} ${h}` : n.value, c = n.isChanged ? `color:${kw};font-weight:600;` : "color:#181818;font-weight:400;";
    return `<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:3px;">
        <span style="font-size:14px;line-height:20px;font-weight:400;color:#5D5D5D;">${n.title}</span>
        <span style="display:inline-flex;align-items:center;margin-left:20px;${c}">${u}${l}</span>
      </div>`;
  }).join(""), o = r.texts.some((n) => n.isChanged) ? `<div style="margin-top:8px;padding-top:6px;border-top:1px solid #eee;display:flex;justify-content:space-between;align-items:center;">
        <span style="font-size:14px;line-height:20px;font-weight:400;color:#5D5D5D;">Applied from</span>
        <span style="font-size:14px;line-height:20px;font-weight:400;color:#181818;">${x1(new Date(r.startMs).toISOString())}</span>
      </div>` : "";
  return i + s + o;
}
const Ow = ({
  chartRuntime: r,
  therapySettings: t
}) => {
  const e = w1(t);
  if (e.length === 0) return null;
  const { axisX: i, chart: s, container: o } = r, n = s.addAxisY({ iStack: 999 }).setInterval({ start: 0, end: 1, stopAxisAfter: !0 }).setLength({ pixels: sy }).setStopped(!0);
  n.setStrokeStyle(Et).setUserInteractions(void 0).setTickStrategy(jr.Empty).setPointerEvents(!1), s.addAxisY({ iStack: 999, opposite: !0 }).setInterval({ start: 0, end: 1, stopAxisAfter: !0 }).setLength({ pixels: sy }).setStopped(!0).setStrokeStyle(Et).setUserInteractions(void 0).setTickStrategy(jr.Empty).setPointerEvents(!1);
  const l = s.addRectangleSeries({ axisY: n }).setHighlightOnHover(!1).setDrawOrder({ seriesDrawOrderIndex: ka.Events }).setCursorEnabled(!1).setPointerEvents(!1), h = s.addTextSeries({ yAxis: n }).setCursorEnabled(!1).setDrawOrder({ seriesDrawOrderIndex: ka.Text }).setPointerEvents(!1), u = new ot({ color: Xe(Mw) }), c = new ot({
    color: Xe(Cw)
  }), d = new $t({
    thickness: 1,
    fillStyle: new ot({ color: Xe(ww) })
  }), f = new ot({
    color: Xe(Tw)
  }), p = e.map((L) => {
    const x = l.add({
      x1: L.startMs,
      x2: L.endMs,
      y1: ry,
      y2: 1 - ry
    }).setFillStyle(u).setStrokeStyle(d), M = L.mode ?? "", C = h.add({
      text: M,
      location: { x: (L.startMs + L.endMs) / 2, y: Dw },
      fillStyle: f
    });
    return { rectangle: x, text: C, mark: L };
  });
  let g = null;
  const y = (L) => {
    if (g === L) return;
    const x = p.find((C) => C.mark === g);
    x && x.rectangle.setFillStyle(u);
    const M = p.find((C) => C.mark === L);
    M && M.rectangle.setFillStyle(c), g = L;
  }, m = () => {
    for (const { rectangle: x, text: M } of p) {
      const { x1: C, x2: S } = x.getDimensionsTwoPoints(), E = s.translateCoordinate(
        { x: C, y: 0.5 },
        { x: i, y: n },
        s.coordsClient
      ), I = s.translateCoordinate(
        { x: S, y: 0.5 },
        { x: i, y: n },
        s.coordsClient
      ).clientX - E.clientX, F = M.getSizePixels().x;
      M.setVisible(I > F + 4);
    }
  }, A = r.rafOnce(m);
  r.onChartEvent(i, "intervalchange", A), r.onChartEvent(s, "resize", A), A();
  const v = Pw(), b = (L) => {
    const { top: x, bottom: M } = ql(s, i, n, 0, 1);
    return L.clientY >= x && L.clientY <= M;
  }, w = (L) => {
    if (!b(L)) return null;
    const M = s.translateCoordinate(L, {
      x: i,
      y: n
    }).x;
    return e.find((C) => M >= C.startMs && M <= C.endMs) ?? null;
  }, k = (L) => {
    const x = b(L);
    Kc(x), x && gw();
    const M = w(L);
    y(M), M ? (v.innerHTML = _w(
      M,
      e.indexOf(M),
      e
    ), v.style.opacity = "1", M1(v, L.clientX, L.clientY)) : v.style.opacity = "0";
  }, R = () => {
    Kc(!1), y(null), v.style.opacity = "0";
  };
  return r.onDom(o, "mousemove", k), r.onDom(o, "mouseleave", R), r.onDispose(() => {
    Kc(!1), v.style.opacity = "0";
  }), n;
}, Nw = (r, t, e) => {
  const i = new AbortController(), s = /* @__PURE__ */ new Set(), o = (a) => {
    s.delete(a), a();
  }, n = {
    chart: r,
    axisX: t,
    container: e,
    isDisposed: () => i.signal.aborted,
    ifAlive: (a) => (...l) => {
      i.signal.aborted || a(...l);
    },
    raf: (a) => {
      if (i.signal.aborted) return () => {
      };
      const l = requestAnimationFrame(() => {
        s.delete(h), !i.signal.aborted && a();
      }), h = () => cancelAnimationFrame(l);
      return s.add(h), () => o(h);
    },
    rafOnce: (a) => {
      let l = null;
      return () => {
        i.signal.aborted || l || (l = n.raf(() => {
          l = null, a();
        }));
      };
    },
    timeout: (a, l) => {
      if (i.signal.aborted) return () => {
      };
      const h = setTimeout(() => {
        s.delete(u), !i.signal.aborted && a();
      }, l), u = () => clearTimeout(h);
      return s.add(u), () => o(u);
    },
    onDom: (a, l, h, u) => {
      if (i.signal.aborted) return () => {
      };
      const c = typeof u == "boolean" ? { capture: u, signal: i.signal } : { ...u, signal: i.signal };
      return a.addEventListener(
        l,
        h,
        c
      ), () => a.removeEventListener(l, h, u);
    },
    onChartEvent: (a, l, h) => {
      if (i.signal.aborted) return () => {
      };
      const u = n.ifAlive(h);
      a.addEventListener(l, u);
      const c = () => a.removeEventListener(l, u);
      return s.add(c), () => o(c);
    },
    onDispose: (a) => i.signal.aborted ? () => {
    } : (s.add(a), () => s.delete(a)),
    dispose: () => {
      if (!i.signal.aborted) {
        i.abort();
        for (const a of [...s])
          o(a);
      }
    }
  };
  return n;
}, ny = 1440 * 60 * 1e3, Bw = 180, zw = 4, du = 28, Ww = ({
  lc: r,
  container: t,
  startDateTimeInMs: e,
  endDateTimeInMs: i,
  missingIntervals: s,
  channels: o,
  globalEvents: n = [],
  hiddenChannelIds: a,
  channelHeightOverrides: l,
  therapySettings: h,
  limits: u,
  onZoomIntervalChange: c,
  onLayoutMeasured: d,
  onCollapsedContentHeightMeasured: f,
  isGestureActive: p,
  onSelectionStart: g,
  onSelectionChange: y,
  eventEditor: m
}) => {
  const A = new $t({
    thickness: 1,
    fillStyle: new ot({ color: Xe("#E8E8E8") })
  }), v = new ot({ color: N(255, 255, 255) }), b = new ot({
    color: Xe("#FFFFFF00")
  }), w = {
    ...pE(zx.light),
    lcjsBackgroundFillStyle: v,
    chartXYBackgroundFillStyle: v,
    chartXYSeriesBackgroundFillStyle: v,
    uiBackgroundFillStyle: v,
    xAxisOverlayStyle: b,
    yAxisOverlayStyle: b
  }, k = r.ChartXY({
    antialias: !0,
    defaultAxisX: { type: "linear-highPrecision", opposite: !0 },
    animationsEnabled: !1,
    theme: w,
    legend: { visible: !1 },
    container: t,
    devicePixelRatio: !0,
    textRenderer: NA,
    textPixelSnappingEnabled: !1
  });
  k.engine.setBackgroundFillStyle(v), k.setBackgroundFillStyle(v), k.setBackgroundStrokeStyle(Et), k.setSeriesBackgroundFillStyle(v), k.setSeriesBackgroundStrokeStyle(Et), k.setSeriesBackgroundEffect(!1), k.setTitle(""), k.axisY.dispose(), t.style.position = "relative";
  const R = k.getDefaultAxisX().setStrokeStyle(Et).setOverlayStyle(b).setTickStrategy(
    jr.DateTime,
    (nt) => nt.setMajorTickStyle(
      (et) => et.setGridStrokeStyle(A).setLabelFont((it) => it.setFamily("Noto Sans").setSize(14)).setLabelFillStyle(
        new ot({ color: N(139, 139, 139) })
      )
    ).setMinorTickStyle(
      (et) => et.setGridStrokeStyle(A).setLabelFont((it) => it.setFamily("Noto Sans").setSize(14)).setLabelFillStyle(
        new ot({ color: N(139, 139, 139) })
      )
    )
  ), L = Nw(k, R, t);
  c && L.onChartEvent(
    R,
    "intervalchange",
    (nt) => c(nt.end - nt.start)
  ), R.setInterval({
    start: e,
    end: i,
    stopAxisAfter: !0
  }).setIntervalRestrictions({
    startMin: e,
    intervalMax: ny,
    endMax: i
  });
  const x = pw(
    L,
    o,
    a,
    n
  ), M = /* @__PURE__ */ new Map(), C = /* @__PURE__ */ new Map(), S = {}, E = (nt, et) => {
    nt && (S[nt] = et);
  }, T = (nt) => {
    const et = S[nt];
    if (et)
      for (let it = 0; it < zw; it += 1) {
        const rt = it % 2 === 0;
        L.timeout(() => {
          S[nt] === et && et.rectangle.setFillStyle(
            rt ? et.blinkFill : et.defaultFill
          );
        }, (it + 1) * Bw);
      }
  }, I = new ot({
    color: Xe("#000000").setA(12)
  }), F = [], D = [];
  let P = null;
  const V = (nt, et) => {
    if (!P) return null;
    const it = ql(
      k,
      R,
      P,
      0,
      1
    ), rt = Math.abs(
      it.bottom - it.top
    ), tt = nt.reduce(
      (ut, ht) => Math.max(ut, ht.centerYPx + ht.heightPx / 2),
      0
    ), at = Math.max(
      et - rt,
      tt
    );
    return Number.isFinite(at) && at > 0 ? at : null;
  }, _ = L.rafOnce(() => {
    k.engine.layout();
    const nt = t.getBoundingClientRect(), et = R.getInterval(), it = et.start, rt = [...C.values()][0]?.[0];
    let tt, at;
    rt && (tt = k.translateCoordinate(
      { x: it, y: 0.5 },
      { x: R, y: rt },
      k.coordsClient
    ).clientX - nt.left, at = k.translateCoordinate(
      { x: et.end, y: 0.5 },
      { x: R, y: rt },
      k.coordsClient
    ).clientX - nt.left);
    const ut = [...C.entries()].map(([st, bt]) => {
      const ct = bt[0], Mt = k.translateCoordinate(
        { x: it, y: 0.5 },
        { x: R, y: ct },
        k.coordsClient
      ), vt = k.translateCoordinate(
        { x: it, y: 1 },
        { x: R, y: ct },
        k.coordsClient
      ), mt = k.translateCoordinate(
        { x: it, y: 0 },
        { x: R, y: ct },
        k.coordsClient
      );
      return {
        id: st,
        centerYPx: Mt.clientY - nt.top,
        heightPx: Math.abs(mt.clientY - vt.clientY)
      };
    }), ht = V(
      ut,
      nt.height
    );
    ht !== null && f?.(ht), d(ut, tt, at);
  }), O = (nt, et) => {
    for (const it of et ?? []) {
      const rt = u.find((tt) => tt.type === it.type)?.segments ?? [];
      F.push(
        uw(L, nt, it, rt)
      );
    }
  };
  if (o.forEach((nt, et) => {
    if (a.has(nt.id)) {
      const st = UC({
        chartRuntime: L,
        index: et,
        heightPx: du
      });
      C.set(nt.id, st);
      return;
    }
    const { configuration: it, signals: rt, events: tt, id: at } = nt, ut = Cy(nt), ht = {
      chartRuntime: L,
      index: et,
      configuration: it,
      channelType: at,
      axisPairsByChannelType: M,
      onAxesSwapped: _,
      heightPxOverride: l?.get(at)
    };
    switch (it.axisType) {
      case Ct.SignalsWithEvents: {
        const { axis: st, bindWindow: bt } = ty({ ...ht, signals: rt, isVisible: !0 }), {
          axis: ct,
          syncEventsToYAxis: Mt,
          bindWindow: vt
        } = cu({
          ...ht,
          events: tt,
          isVisible: !1,
          selectedEventKey: m?.selectedEventKey,
          registerEventRectangle: E
        });
        F.push(bt, vt), O(st, it.limits), C.set(at, [ct, st]), L.onChartEvent(
          st,
          "intervalchange",
          () => Mt()
        );
        break;
      }
      case Ct.EventOnly: {
        const {
          axis: st,
          syncEventsToYAxis: bt,
          bindWindow: ct
        } = cu({
          ...ht,
          events: tt,
          isVisible: !0,
          selectedEventKey: m?.selectedEventKey,
          registerEventRectangle: E
        });
        F.push(ct);
        const { axis: Mt } = ey(ht);
        C.set(at, [st, Mt]), L.onChartEvent(
          st,
          "intervalchange",
          () => bt()
        );
        break;
      }
      case Ct.SignalOnly: {
        const { axis: st, bindWindow: bt } = ty({ ...ht, signals: rt, isVisible: !0 });
        F.push(bt), O(st, it.limits);
        const ct = tt.some((Xt) => (Xt.data?.length ?? 0) > 0), {
          axis: Mt,
          syncEventsToYAxis: vt,
          bindWindow: mt
        } = ct ? cu({
          ...ht,
          events: tt,
          isVisible: !1,
          selectedEventKey: m?.selectedEventKey,
          registerEventRectangle: E
        }) : ey(ht);
        ct && F.push(mt), C.set(at, [Mt, st]), vt && L.onChartEvent(
          st,
          "intervalchange",
          () => vt()
        );
        break;
      }
      default:
        throw new Error(`axisType: ${it.axisType} is not supported`);
    }
    if (ut === "no-data") {
      const st = C.get(at)?.[0];
      st && D.push(st);
    }
  }), n.length > 0 && F.push(
    rw(
      L,
      n,
      // Any live Y axis works as the pixel-projection reference: the binder's
      // min-width clamp translates x-interval endpoints to client pixels, and
      // translateCoordinate requires a Y axis even though only X is read.
      () => {
        const [nt] = C.values();
        return nt?.[0];
      }
    )
  ), Ow({
    chartRuntime: L,
    therapySettings: h
  }), f) {
    const nt = (et) => k.addAxisY({ iStack: -1, opposite: et }).setInterval({ start: 0, end: 1, stopAxisAfter: !0 }).setLength({ relative: 1 }).setStrokeStyle(Et).setTickStrategy(jr.Empty).setMarginAfterTicks(0).setMargins(0, 0).setUserInteractions(void 0).setPointerEvents(!1).setStopped(!0);
    P = nt(!1), nt(!0);
  }
  const B = m ? xw(
    L,
    o,
    M,
    m,
    x
  ) : null;
  L.onChartEvent(k, "resize", () => {
    p?.() || _();
  }), _();
  const z = yw(
    L,
    o,
    M,
    g,
    y
  ), W = mw(
    L,
    x
  );
  let G = [];
  const Y = (nt) => {
    G.forEach((et) => et.dispose()), G = nt.map(
      (et) => R.addBand({ onTop: !0 }).setValueStart(et.start).setValueEnd(et.end).setFillStyle(I).setStrokeStyle(Et).setPointerEvents(!1).setHighlightOnHover(!1)
    );
  };
  let U = [];
  const $ = (nt) => {
    U.forEach((et) => et.dispose()), U = D.map((et) => {
      const it = k.addRectangleSeries({ axisY: et }).setHighlightOnHover(!1).setCursorEnabled(!1).setPointerEvents(!1);
      for (const rt of nt)
        it.add({ x1: rt.start, y1: 0, x2: rt.end, y2: 1 }).setFillStyle(I).setStrokeStyle(Et);
      return it;
    });
  };
  let Z = null;
  const q = YC(
    L,
    () => Z
  ), Q = (nt, et, it) => {
    z.clearSelection(), Object.keys(S).forEach(
      (tt) => delete S[tt]
    ), R.setIntervalRestrictions({
      startMin: nt,
      intervalMax: ny,
      endMax: et
    }), R.setInterval({
      start: nt,
      end: et,
      stopAxisAfter: !0
    }), Y(it);
    const rt = HC(
      it,
      nt,
      et
    );
    $(rt), Z = rt.length > 0 ? {
      start: rt[0].start,
      end: rt[rt.length - 1].end
    } : null, F.forEach((tt) => tt(nt, et));
  };
  return Q(e, i, s), {
    chart: k,
    axisX: R,
    axesYByChannelId: C,
    chartRuntime: L,
    intervalSelection: z,
    remeasureChannelLayout: _,
    blinkEvent: T,
    applyDayWindow: Q,
    dispose: () => {
      z.dispose(), B?.dispose(), W.dispose(), q.dispose(), x.dispose(), L.dispose();
    }
  };
}, oy = 80, Gw = 300, Uw = (r, t) => {
  const e = new Map(t?.visibleChannelHeights), i = new Map(t?.visibleChannelHeights);
  let s = t?.manualHeightOffsetPx ?? 0, o = !1, n = !1, a = !1, l = null, h = new Set(t?.channelIds ?? []);
  const u = () => {
    const b = r(), w = new Set(b.hiddenChannelIds);
    b.orderedChannels.forEach((k) => {
      if (w.has(k.id)) return;
      if (!e.has(k.id)) {
        const L = b.geometryByChannelId.get(k.id)?.heightPx;
        L !== void 0 && e.set(k.id, L);
      }
      const R = e.get(k.id);
      R !== void 0 && b.getAxes(k.id)?.forEach((L) => L.setLength({ pixels: R }));
    });
  }, c = () => {
    const b = r(), w = b.getContainer();
    w && (w.style.height = b.computeContainerHeight(s));
  };
  return {
    lockHeights: u,
    resizeChannel: (b, w) => {
      u();
      const k = e.get(b);
      if (k === void 0) {
        console.error(
          "Something went wrong: channel height is not defined for channelId",
          b
        );
        return;
      }
      const R = r(), L = Math.min(
        i.get(b) ?? oy,
        oy
      ), x = Math.max(L, w);
      if (x === k) return;
      const M = x - k;
      e.set(b, x);
      const C = R.getContainer();
      C && (s += M, C.style.height = R.computeContainerHeight(s)), R.getAxes(b)?.forEach((E) => E.setLength({ pixels: x }));
      const S = R.getEngine();
      S?.layout(), S?.layout(), R.remeasure();
    },
    beginResize: () => {
      o = !0;
    },
    endResize: () => {
      requestAnimationFrame(() => {
        o = !1, n = !0, r().remeasure();
      });
    },
    prepareVisibilityToggle: (b, w) => {
      if (w) {
        const k = e.get(b);
        if (k !== void 0)
          s += k - du, c();
        else {
          const R = r();
          R.orderedChannels.every(
            (x) => R.hiddenChannelIds.includes(x.id)
          ) && s !== 0 && (s = 0, c());
        }
      } else {
        u();
        const k = e.get(b);
        k !== void 0 && (s += du - k, c());
      }
    },
    unlockHeights: () => {
      if (e.size === 0) return;
      e.clear(), s = 0;
      const b = r(), w = new Set(b.hiddenChannelIds);
      b.orderedChannels.forEach((k) => {
        b.getAxes(k.id)?.forEach(
          (R) => (
            // Hidden channels stay pinned at their fixed height; reverting them to
            // relative would re-expand the collapsed row.
            w.has(k.id) ? R.setLength({ pixels: du }) : R.setLength({ relative: k.configuration.relativeHeight })
          )
        );
      }), b.remeasure();
    },
    onLayoutMeasured: (b, w, k) => {
      const R = r(), L = R.layoutStore, x = () => {
        const M = new Set(R.hiddenChannelIds);
        b.forEach((C) => {
          M.has(C.id) || e.has(C.id) || i.set(C.id, C.heightPx);
        });
      };
      if (a) {
        x(), L?.commitMeasurement(b, w, k);
        return;
      }
      L?.apply(b, w, k), x(), !o && (n ? (n = !1, L?.commit()) : L?.scheduleCommit());
    },
    beginReorderSettle: () => {
      a = !0, l && clearTimeout(l), l = setTimeout(() => {
        a = !1, l = null;
      }, Gw);
    },
    clearLockedHeightsIfChannelsChanged: () => {
      const b = new Set(r().orderedChannels.map((k) => k.id));
      b.size === h.size && [...b].every((k) => h.has(k)) || e.clear(), h = b;
    },
    getHeightOverrides: () => e,
    getIsResizing: () => o,
    getManualHeightOffset: () => s,
    dispose: () => {
      l && (clearTimeout(l), l = null);
    }
  };
}, Hw = (r, t) => {
  const e = Ei(r);
  e.current = r;
  const i = Ei(null);
  return i.current || (i.current = Uw(
    () => e.current,
    t
  )), mi(() => () => i.current?.dispose(), []), i.current;
}, Yw = ({
  enableResize: r,
  containerRef: t,
  viewportHeightAnchorRef: e,
  gestureController: i
}) => {
  mi(() => {
    if (!r) return;
    const s = () => {
      if (i.getIsResizing()) return;
      const u = t.current;
      if (!u) return;
      const c = e?.current ?? u, d = Math.max(
        0,
        c.getBoundingClientRect().top
      );
      u.style.setProperty("--chart-top", `${d}px`);
    };
    s();
    const o = new ResizeObserver(s), n = e?.current ?? t.current?.parentElement;
    n && o.observe(n);
    const a = () => window.visualViewport?.height ?? window.innerHeight;
    let l = a();
    const h = () => {
      if (i.getIsResizing()) return;
      s();
      const u = a();
      u !== l && (l = u, requestAnimationFrame(() => i.unlockHeights()));
    };
    return window.addEventListener("resize", h), window.visualViewport?.addEventListener("resize", h), () => {
      o.disconnect(), window.removeEventListener("resize", h), window.visualViewport?.removeEventListener(
        "resize",
        h
      );
    };
  }, [
    r,
    t,
    e,
    i
  ]);
}, jw = ({
  gestureController: r,
  orderedChannels: t,
  onChannelsReorder: e
}) => {
  const [i, s] = ze(null), o = (n, a) => {
    if (!i || i.channelId === n) {
      s(null);
      return;
    }
    if (Tv(
      t,
      i.channelId,
      n,
      a
    )) {
      s(null);
      return;
    }
    r.beginReorderSettle(), e?.(i.channelId, n, a), s(null);
  };
  return {
    draggedChannelId: i?.channelId ?? null,
    onDragStart: (n) => s({ channelId: n }),
    onDragEnd: () => s(null),
    onDropOnChannel: o
  };
}, $w = ({
  enabled: r,
  orderedChannels: t,
  hiddenChannelIds: e,
  hasTherapySettings: i
}) => {
  const s = t.length > 0 && t.every(
    (u) => e.includes(u.id)
  ), o = s ? t.length : null, [n, a] = ze(null), l = Fi(
    (u) => {
      if (o === null) return;
      const c = Math.max(1, Math.ceil(u));
      a(
        (d) => d?.channelCount === o && d.hasTherapySettings === i && d.heightPx === c ? d : {
          channelCount: o,
          hasTherapySettings: i,
          heightPx: c
        }
      );
    },
    [o, i]
  );
  return {
    heightPx: r && n?.channelCount === o && n.hasTherapySettings === i ? n.heightPx : null,
    onHeightMeasured: r && s ? l : void 0
  };
}, ay = (r, t, e) => {
  const { startDateTimeInMs: i, endDateTimeInMs: s } = hc(
    t,
    r
  );
  return {
    startDateTimeInMs: i,
    endDateTimeInMs: s,
    missingIntervals: e.length > 0 ? b1(
      e,
      i,
      s
    ) : []
  };
}, Xw = ({
  ref: r,
  chartStateRef: t,
  license: e,
  licenseInformation: i,
  gestureController: s,
  chartId: o,
  side: n,
  selectedDayMs: a,
  therapyTimeInterval: l,
  channels: h,
  globalEvents: u,
  parsedEdfInfo: c,
  therapySettings: d,
  limits: f,
  eventEditor: p,
  orderedChannels: g,
  hiddenChannelIds: y,
  initialAxisInterval: m,
  getPanelViewState: A,
  onZoomIntervalChange: v,
  onIntervalChange: b,
  onSelectionStart: w,
  onSelectionChange: k,
  onCollapsedContentHeightMeasured: R
}) => {
  const L = Ei(null), x = Ei(m), M = Ei(A);
  M.current = A;
  const C = Ei({
    onSelectionStart: w,
    onSelectionChange: k,
    onIntervalChange: b,
    onZoomIntervalChange: v
  });
  mi(() => {
    C.current = {
      onSelectionStart: w,
      onSelectionChange: k,
      onIntervalChange: b,
      onZoomIntervalChange: v
    };
  }, [
    w,
    k,
    b,
    v
  ]);
  const S = Ei({
    selectedDayMs: a,
    therapyTimeInterval: l,
    parsedEdfInfo: c
  });
  mi(() => {
    S.current = { selectedDayMs: a, therapyTimeInterval: l, parsedEdfInfo: c };
  }, [a, l, c]);
  const E = Ei(null);
  Ey(
    r,
    () => ({
      getInterval: () => {
        if (!t.current)
          throw new Error("Chart is not initialized yet");
        return t.current.axisX.getInterval();
      },
      setInterval: (T) => {
        if (!t.current)
          throw new Error("Chart is not initialized yet");
        t.current.axisX.setInterval(T);
      },
      getChart: () => t.current?.chart ?? null,
      getAxisX: () => t.current?.axisX ?? null,
      getViewState: () => ({
        interval: t.current?.axisX.getInterval() ?? null,
        ...M.current()
      }),
      clearSelection: () => {
        t.current?.clearSelection(), C.current.onSelectionChange?.(null);
      },
      blinkEvent: (T) => t.current?.blinkEvent(T)
    }),
    [t]
  ), mi(() => {
    L.current = null;
  }, [a, l, o]), mi(() => {
    if (!e) return;
    s.clearLockedHeightsIfChannelsChanged();
    const T = document.getElementById(
      `${o}-${n}`
    );
    if (!T || h.length === 0) {
      console.error(`Container ${o}-${n} is not defined`);
      return;
    }
    const I = VC({
      license: e,
      licenseInformation: i
    }), { selectedDayMs: F, therapyTimeInterval: D } = S.current, { startDateTimeInMs: P, endDateTimeInMs: V, missingIntervals: _ } = ay(F, D, c), O = Ww({
      lc: I,
      container: T,
      startDateTimeInMs: P,
      endDateTimeInMs: V,
      missingIntervals: _,
      channels: [...g].reverse(),
      globalEvents: u,
      hiddenChannelIds: new Set(y),
      channelHeightOverrides: s.getHeightOverrides(),
      therapySettings: d,
      limits: f,
      onZoomIntervalChange: (z) => C.current.onZoomIntervalChange?.(z),
      isGestureActive: s.getIsResizing,
      onLayoutMeasured: s.onLayoutMeasured,
      onCollapsedContentHeightMeasured: R,
      onSelectionStart: () => C.current.onSelectionStart?.(),
      onSelectionChange: (z) => {
        C.current.onSelectionChange?.(z);
      },
      eventEditor: p
    });
    t.current = {
      chart: O.chart,
      axisX: O.axisX,
      axesYByChannelId: O.axesYByChannelId,
      clearSelection: O.intervalSelection.clearSelection,
      remeasureChannelLayout: O.remeasureChannelLayout,
      blinkEvent: O.blinkEvent,
      applyDayWindow: O.applyDayWindow
    }, E.current = {
      selectedDayMs: F,
      therapyTimeInterval: D
    }, O.chartRuntime.onChartEvent(
      O.axisX,
      "intervalchange",
      () => C.current.onIntervalChange?.()
    );
    const B = L.current ?? x.current;
    return x.current = null, B && O.axisX.setInterval(B), () => {
      const z = t.current;
      t.current = null, z && (L.current = z.axisX.getInterval(), z.clearSelection()), O.dispose(), C.current.onSelectionChange?.(null), I.dispose();
    };
  }, [
    o,
    n,
    e,
    i,
    h,
    u,
    c,
    d,
    f,
    p,
    g,
    y,
    s,
    t,
    R
  ]), mi(() => {
    const T = t.current;
    if (!T) return;
    const I = E.current;
    if (I && I.selectedDayMs === a && I.therapyTimeInterval === l)
      return;
    E.current = { selectedDayMs: a, therapyTimeInterval: l };
    const { startDateTimeInMs: F, endDateTimeInMs: D, missingIntervals: P } = ay(
      a,
      l,
      S.current.parsedEdfInfo
    );
    T.applyDayWindow(F, D, P);
  }, [a, l, t]);
}, Zw = 1500, Kw = 600, qw = 400, Jw = 16, ly = Ql.forwardRef(
  ({
    selectedDayMs: r,
    channels: t,
    globalEvents: e,
    chartId: i,
    side: s,
    parsedEdfInfo: o,
    therapySettings: n,
    limits: a,
    chartSize: l = { width: Zw, height: Kw },
    containerClassName: h,
    enableResize: u = !1,
    viewportHeightAnchorRef: c,
    initialViewState: d,
    therapyTimeInterval: f,
    onZoomIntervalChange: p,
    onSelectionStart: g,
    onSelectionChange: y,
    onChannelDelete: m,
    hiddenChannelIds: A,
    onChannelVisibilityToggle: v,
    onIntervalChange: b,
    onChannelsReorder: w,
    eventEditor: k
  }, R) => {
    const L = ZC({
      channels: t,
      controlledHiddenIds: A,
      initialHiddenIds: d?.hiddenChannelIds,
      initialOrderIds: d?.orderedChannelIds,
      syncOrderWithChannels: d === void 0,
      onToggleVisibility: v
    }), x = $w({
      enabled: u,
      orderedChannels: L.orderedChannels,
      hiddenChannelIds: L.hiddenChannelIds,
      hasTherapySettings: n.length > 0
    }), M = Ei(null), C = Ei(null), [S, E] = ze(null), T = JC(
      L.setChannelGeometries,
      E
    ), I = Hw(
      {
        orderedChannels: L.orderedChannels,
        hiddenChannelIds: L.hiddenChannelIds,
        geometryByChannelId: L.geometryByChannelId,
        getAxes: (G) => M.current?.axesYByChannelId.get(G),
        getContainer: () => C.current,
        getEngine: () => M.current?.chart.engine,
        remeasure: () => M.current?.remeasureChannelLayout(),
        layoutStore: T,
        computeContainerHeight: (G) => W(G).height
      },
      d ? {
        channelIds: d.orderedChannelIds,
        visibleChannelHeights: d.visibleChannelHeights,
        manualHeightOffsetPx: d.manualHeightOffsetPx
      } : void 0
    ), F = Fi(
      (G, Y, U) => {
        L.reorder(G, Y, U), w?.(G, Y, U);
      },
      [w, L.reorder]
    ), D = jw({
      gestureController: I,
      orderedChannels: L.orderedChannels,
      onChannelsReorder: F
    }), P = Fi(
      () => {
        const G = new Set(L.hiddenChannelIds), Y = /* @__PURE__ */ new Map();
        return L.geometryByChannelId.forEach((U, $) => {
          G.has($) || Y.set($, U.heightPx);
        }), {
          hiddenChannelIds: [...L.hiddenChannelIds],
          orderedChannelIds: L.orderedChannels.map((U) => U.id),
          visibleChannelHeights: Y,
          manualHeightOffsetPx: I.getManualHeightOffset()
        };
      },
      [
        I,
        L.geometryByChannelId,
        L.hiddenChannelIds,
        L.orderedChannels
      ]
    ), {
      license: V,
      licenseInformation: _,
      loading: O,
      error: B
    } = Sv();
    Yw({
      enableResize: u,
      containerRef: C,
      viewportHeightAnchorRef: c,
      gestureController: I
    }), Xw({
      ref: R,
      chartStateRef: M,
      license: V,
      licenseInformation: _,
      gestureController: I,
      chartId: i,
      side: s,
      selectedDayMs: r,
      therapyTimeInterval: f,
      channels: t,
      globalEvents: e,
      parsedEdfInfo: o,
      therapySettings: n,
      limits: a,
      eventEditor: k,
      orderedChannels: L.orderedChannels,
      hiddenChannelIds: L.hiddenChannelIds,
      initialAxisInterval: d?.interval,
      getPanelViewState: P,
      onZoomIntervalChange: p,
      onIntervalChange: b,
      onSelectionStart: g,
      onSelectionChange: y,
      onCollapsedContentHeightMeasured: x.onHeightMeasured
    });
    const z = (G) => {
      I.prepareVisibilityToggle(
        G,
        L.hiddenChannelIds.includes(G)
      ), L.toggleVisibility(G);
    }, W = (G) => u ? {
      width: "100%",
      minWidth: 0,
      height: x.heightPx === null ? `calc(max(${qw}px, calc(100dvh - var(--chart-top, 0px) - ${Jw}px)) + ${G}px)` : `${x.heightPx}px`
    } : {
      width: `${l.width}px`,
      minWidth: 0,
      height: `${l.height}px`
    };
    return O ? /* @__PURE__ */ X.jsx("div", { children: "Preparing..." }) : B || !V ? /* @__PURE__ */ X.jsx("div", { style: { color: "red", padding: 20 }, children: "Inner error. Please contact SignalViewer development team." }) : /* @__PURE__ */ X.jsx(
      "div",
      {
        ref: C,
        className: ["chart-container__root", h].filter(Boolean).join(" "),
        style: W(I.getManualHeightOffset()),
        children: /* @__PURE__ */ X.jsx(
          Rv,
          {
            side: s,
            chartId: i,
            channels: L.orderedChannels,
            hiddenChannelIds: L.hiddenChannelIds,
            draggedChannelId: D.draggedChannelId,
            geometryByChannelId: L.geometryByChannelId,
            plotLeftPx: S?.plotLeftPx,
            plotRightPx: S?.plotRightPx,
            layoutStore: T,
            onToggleVisibility: z,
            onDragStart: D.onDragStart,
            onDragEnd: D.onDragEnd,
            onDropOnChannel: D.onDropOnChannel,
            onChannelDelete: m,
            onResizeStart: I.beginResize,
            onResizeHeight: I.resizeChannel,
            onResizeEnd: I.endResize
          }
        )
      }
    );
  }
), Qw = () => /* @__PURE__ */ X.jsxs(
  "svg",
  {
    width: "138",
    height: "84",
    viewBox: "0 0 138 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": !0,
    children: [
      /* @__PURE__ */ X.jsx("path", { d: "M1 1H137V83H1V1Z", fill: "#F3F3F3" }),
      /* @__PURE__ */ X.jsx(
        "path",
        {
          d: "M2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1H1H2ZM138 1C138 0.447715 137.552 0 137 0C136.448 0 136 0.447715 136 1H137H138ZM136 83C136 83.5523 136.448 84 137 84C137.552 84 138 83.5523 138 83H137H136ZM0 83C0 83.5523 0.447715 84 1 84C1.55228 84 2 83.5523 2 83H1H0ZM0 7.15C0 7.70228 0.447715 8.15 1 8.15C1.55228 8.15 2 7.70228 2 7.15H1H0ZM2 11.25C2 10.6977 1.55228 10.25 1 10.25C0.447715 10.25 0 10.6977 0 11.25H1H2ZM0 23.55C0 24.1023 0.447715 24.55 1 24.55C1.55228 24.55 2 24.1023 2 23.55H1H0ZM2 27.65C2 27.0977 1.55228 26.65 1 26.65C0.447715 26.65 0 27.0977 0 27.65H1H2ZM0 39.95C0 40.5023 0.447715 40.95 1 40.95C1.55228 40.95 2 40.5023 2 39.95H1H0ZM2 44.05C2 43.4977 1.55228 43.05 1 43.05C0.447715 43.05 0 43.4977 0 44.05H1H2ZM0 56.35C0 56.9023 0.447715 57.35 1 57.35C1.55228 57.35 2 56.9023 2 56.35H1H0ZM2 60.45C2 59.8977 1.55228 59.45 1 59.45C0.447715 59.45 0 59.8977 0 60.45H1H2ZM0 72.75C0 73.3023 0.447715 73.75 1 73.75C1.55228 73.75 2 73.3023 2 72.75H1H0ZM2 76.85C2 76.2977 1.55228 75.85 1 75.85C0.447715 75.85 0 76.2977 0 76.85H1H2ZM138 76.85C138 76.2977 137.552 75.85 137 75.85C136.448 75.85 136 76.2977 136 76.85H137H138ZM136 72.75C136 73.3023 136.448 73.75 137 73.75C137.552 73.75 138 73.3023 138 72.75H137H136ZM138 60.45C138 59.8977 137.552 59.45 137 59.45C136.448 59.45 136 59.8977 136 60.45H137H138ZM136 56.35C136 56.9023 136.448 57.35 137 57.35C137.552 57.35 138 56.35 138 56.35H137H136ZM138 44.05C138 43.4977 137.552 43.05 137 43.05C136.448 43.05 136 43.4977 136 44.05H137H138ZM136 39.95C136 40.5023 136.448 40.95 137 40.95C137.552 40.95 138 40.5023 138 39.95H137H136ZM138 27.65C138 27.0977 137.552 26.65 137 26.65C136.448 26.65 136 27.0977 136 27.65H137H138ZM136 23.55C136 24.1023 136.448 24.55 137 24.55C137.552 24.55 138 24.1023 138 23.55H137H136ZM138 11.25C138 10.6977 137.552 10.25 137 10.25C136.448 10.25 136 10.6977 136 11.25H137H138ZM136 7.15C136 7.70229 136.448 8.15 137 8.15C137.552 8.15 138 7.70229 138 7.15H137H136ZM1 1H0V7.15H1H2V1H1ZM1 11.25H0V23.55H1H2V11.25H1ZM1 27.65H0V39.95H1H2V27.65H1ZM1 44.05H0V56.35H1H2V44.05H1ZM1 60.45H0V72.75H1H2V60.45H1ZM1 76.85H0V83H1H2V76.85H1ZM137 83H138V76.85H137H136V83H137ZM137 72.75H138V60.45H137H136V72.75H137ZM137 56.35H138V44.05H137H136V56.35H137ZM137 39.95H138V27.65H137H136V39.95H137ZM137 23.55H138V11.25H137H136V23.55H137ZM137 7.15H138V1H137H136V7.15H137Z",
          fill: "#BABABA"
        }
      ),
      /* @__PURE__ */ X.jsx(
        "path",
        {
          d: "M30 40.4344C31.463 34.9906 35.2667 27.3693 38.7778 40.4344C43.1667 56.7658 46.0926 56.7659 50.4815 40.4344C54.8704 24.1029 57.7963 -9.84255 65.1111 40.4338C72.4889 91.1427 79.7518 69.8691 85.5926 40.4341C91.4444 10.9432 95.8333 31.7286 97.2963 40.4341C99.0768 51.0293 104.611 58.4527 109 40.4341",
          stroke: "#BABABA",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      )
    ]
  }
), T1 = ({ onClick: r }) => /* @__PURE__ */ X.jsx(
  "button",
  {
    type: "button",
    className: "therapy-protocol-hide-button",
    onClick: r,
    "aria-label": "Collapse therapy protocol",
    children: /* @__PURE__ */ X.jsx(
      "svg",
      {
        width: "15",
        height: "13",
        viewBox: "0 0 15 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": !0,
        children: /* @__PURE__ */ X.jsx(
          "path",
          {
            d: "M14.5 0C14.7761 0 15 0.223858 15 0.5V12.5C15 12.7761 14.7761 13 14.5 13C14.2239 13 14 12.7761 14 12.5V0.5C14 0.223858 14.2239 0 14.5 0ZM7.14648 2.14648C7.34175 1.95122 7.65825 1.95122 7.85352 2.14648L11.8535 6.14648C12.0488 6.34175 12.0488 6.65825 11.8535 6.85352L7.85352 10.8535C7.65825 11.0488 7.34175 11.0488 7.14648 10.8535C6.95122 10.6583 6.95122 10.3417 7.14648 10.1465L10.293 7H0.5C0.223858 7 0 6.77614 0 6.5C0 6.22386 0.223858 6 0.5 6H10.293L7.14648 2.85352C6.95122 2.65825 6.95122 2.34175 7.14648 2.14648Z",
            fill: "currentColor"
          }
        )
      }
    )
  }
), tu = (r) => new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: !1
}).format(new Date(r)), t3 = (r, t, e) => {
  const i = r.find((o) => o.id === t);
  if (!i)
    return;
  const s = i.signals.find((o) => o.type === e);
  if (s)
    return s.config.color;
}, e3 = (r) => r && r !== "-" ? r : null, i3 = ({
  selectionStats: r,
  channels: t,
  className: e,
  onClose: i
}) => /* @__PURE__ */ X.jsx(
  "aside",
  {
    className: ["selected-data-panel", e].filter(Boolean).join(" "),
    children: /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__content", children: [
      /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__header", children: [
        /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__title", children: "MEASUREMENT" }),
        /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__title-actions", children: /* @__PURE__ */ X.jsx(T1, { onClick: () => i?.() }) })
      ] }),
      r && /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__summary", children: [
        /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__interval", children: [
          tu(r.intervalStartMs),
          " –",
          " ",
          tu(r.intervalEndMs)
        ] }),
        /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__duration", children: [
          /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__duration-label", children: "Duration:" }),
          " ",
          /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__duration-value", children: _d(r.durationMs / 1e3) })
        ] })
      ] }),
      r ? /* @__PURE__ */ X.jsxs(X.Fragment, { children: [
        /* @__PURE__ */ X.jsx("div", { className: "selected-data-panel__divider" }),
        /* @__PURE__ */ X.jsx("div", { className: "selected-data-panel__signals", children: r.signals.map((s) => {
          const o = t3(
            t,
            r.channelId,
            s.signalType
          ), n = e3(
            s.physicalDimension
          );
          return /* @__PURE__ */ X.jsxs(
            "div",
            {
              className: "selected-data-panel__signal",
              children: [
                /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__signal-header", children: [
                  /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__signal-name-wrap", children: [
                    /* @__PURE__ */ X.jsx(
                      "span",
                      {
                        className: "selected-data-panel__signal-color",
                        style: o ? { backgroundColor: o } : void 0
                      }
                    ),
                    /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__signal-name", children: s.signalType })
                  ] }),
                  n && /* @__PURE__ */ X.jsxs("span", { className: "selected-data-panel__signal-unit", children: [
                    "(",
                    n,
                    ")"
                  ] })
                ] }),
                /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__metric-row", children: [
                  /* @__PURE__ */ X.jsxs("span", { className: "selected-data-panel__metric-label", children: [
                    "Min ",
                    /* @__PURE__ */ X.jsxs("span", { className: "selected-data-panel__metric-time", children: [
                      "(",
                      tu(s.minTimeMs),
                      ")"
                    ] })
                  ] }),
                  /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__metric-value", children: s.min.toFixed(1) })
                ] }),
                /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__metric-row", children: [
                  /* @__PURE__ */ X.jsxs("span", { className: "selected-data-panel__metric-label", children: [
                    "Max ",
                    /* @__PURE__ */ X.jsxs("span", { className: "selected-data-panel__metric-time", children: [
                      "(",
                      tu(s.maxTimeMs),
                      ")"
                    ] })
                  ] }),
                  /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__metric-value", children: s.max.toFixed(1) })
                ] }),
                /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__metric-row", children: [
                  /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__metric-label", children: "Average" }),
                  /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__metric-value", children: s.avg.toFixed(1) })
                ] })
              ]
            },
            s.signalType
          );
        }) })
      ] }) : /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__empty", children: [
        /* @__PURE__ */ X.jsx(Qw, {}),
        /* @__PURE__ */ X.jsx("div", { className: "selected-data-panel__empty-title", children: "Select the area" }),
        /* @__PURE__ */ X.jsxs("div", { className: "selected-data-panel__empty-text", children: [
          "To measure, hold down",
          " ",
          /* @__PURE__ */ X.jsx("span", { className: "selected-data-panel__empty-accent", children: "ctrl and select" }),
          " ",
          "the area with the mouse"
        ] })
      ] })
    ] })
  }
), s3 = ({ label: r, onRemove: t }) => /* @__PURE__ */ X.jsxs("span", { className: "chip-tab", children: [
  /* @__PURE__ */ X.jsx("span", { className: "chip-tab__label", children: r }),
  /* @__PURE__ */ X.jsx(
    "button",
    {
      type: "button",
      className: "chip-tab__remove",
      onClick: t,
      "aria-label": `Remove ${r}`,
      children: /* @__PURE__ */ X.jsx(
        "svg",
        {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": "true",
          focusable: "false",
          children: /* @__PURE__ */ X.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.1464 4.14645C11.3417 3.9512 11.6582 3.95119 11.8535 4.14645C12.0487 4.34171 12.0487 4.65824 11.8535 4.85348L8.70699 7.99996L11.8535 11.1464C12.0485 11.3417 12.0487 11.6583 11.8535 11.8535C11.6583 12.0486 11.3417 12.0485 11.1464 11.8535L7.99996 8.70699L4.85348 11.8535C4.65824 12.0487 4.34171 12.0487 4.14645 11.8535C3.95118 11.6582 3.95118 11.3417 4.14645 11.1464L7.29293 7.99996L4.14645 4.85348C3.95122 4.65825 3.95129 4.34172 4.14645 4.14645C4.34171 3.95118 4.65822 3.95118 4.85348 4.14645L7.99996 7.29293L11.1464 4.14645Z",
              fill: "currentColor"
            }
          )
        }
      )
    }
  )
] }), r3 = ({ isActive: r, onClick: t }) => /* @__PURE__ */ X.jsx(
  "button",
  {
    type: "button",
    className: [
      "therapy-protocol-filter-button",
      r ? "therapy-protocol-filter-button--active" : ""
    ].filter(Boolean).join(" "),
    onClick: t,
    "aria-label": "Toggle filters",
    "aria-expanded": r,
    children: /* @__PURE__ */ X.jsx(
      "svg",
      {
        width: "14",
        height: "15",
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": !0,
        children: /* @__PURE__ */ X.jsx(
          "path",
          {
            d: "M12.155 0C13.4363 0.000321584 14.1276 1.50365 13.2937 2.47656L8.94893 7.54492C8.87145 7.63549 8.82882 7.75091 8.82882 7.87012V11.9648C8.82879 12.4663 8.57812 12.9347 8.16085 13.2129L7.16085 13.8799C6.16413 14.5442 4.82908 13.8296 4.82882 12.6318V7.87012C4.82882 7.75092 4.78618 7.63549 4.7087 7.54492L0.363974 2.47656C-0.469948 1.50365 0.221365 0.000298075 1.50265 0H12.155ZM1.50265 1C1.07571 1.0003 0.845822 1.50096 1.12374 1.8252L5.46749 6.89355C5.70048 7.16541 5.82882 7.51208 5.82882 7.87012V12.6318C5.82908 13.0309 6.274 13.2691 6.60616 13.0479L7.60616 12.3809C7.74523 12.2881 7.82879 12.132 7.82882 11.9648V7.87012C7.82882 7.51207 7.95714 7.16541 8.19015 6.89355L12.5339 1.8252C12.8118 1.50096 12.5819 1.00032 12.155 1H1.50265Z",
            fill: "currentColor"
          }
        )
      }
    )
  }
), n3 = ({ state: r }) => /* @__PURE__ */ X.jsx(
  "span",
  {
    className: [
      "event-type-multiselect-select-all-checkbox",
      r === "checked" ? "event-type-multiselect-select-all-checkbox--checked" : "",
      r === "partial" ? "event-type-multiselect-select-all-checkbox--partial" : ""
    ].filter(Boolean).join(" "),
    "aria-hidden": "true"
  }
), o3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": !0,
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.1206 6.17438C15.3003 5.96509 15.6161 5.94029 15.8256 6.11969C16.0349 6.29927 16.0595 6.61517 15.8803 6.82477L9.88033 13.8248C9.78987 13.9303 9.65885 13.994 9.51998 13.9996C9.38089 14.0049 9.2454 13.9515 9.14693 13.8531L5.14693 9.85309C4.95167 9.65783 4.95167 9.34132 5.14693 9.14606C5.34222 8.95111 5.65881 8.9509 5.85397 9.14606L9.47213 12.7642L15.1206 6.17438Z",
        fill: "#096DD9"
      }
    )
  }
), a3 = ({
  options: r,
  selectedValues: t,
  onChange: e,
  placeholder: i = "Select event type"
}) => {
  const [s, o] = ze(!1), [n, a] = ze(""), l = Ei(null), h = Ei(null);
  mi(() => {
    const v = (b) => {
      l.current?.contains(b.target) || (o(!1), a(""));
    };
    return document.addEventListener("mousedown", v), () => document.removeEventListener("mousedown", v);
  }, []), mi(() => {
    s && h.current?.focus();
  }, [s]);
  const u = ni(() => {
    const v = n.trim().toLocaleLowerCase();
    return v === "" ? r : r.filter(
      (b) => b.toLocaleLowerCase().includes(v)
    );
  }, [r, n]), c = ni(
    () => new Set(t),
    [t]
  ), d = u.filter(
    (v) => c.has(v)
  ).length, f = u.length > 0, p = f && d === u.length, g = d > 0 && !p, y = (v) => {
    if (c.has(v)) {
      e(t.filter((b) => b !== v));
      return;
    }
    e([...t, v]);
  }, m = () => {
    if (!f) return;
    const v = new Set(u);
    if (p) {
      e(t.filter((b) => !v.has(b)));
      return;
    }
    e(Array.from(/* @__PURE__ */ new Set([...t, ...u])));
  }, A = () => {
    o(!0), h.current?.focus();
  };
  return /* @__PURE__ */ X.jsxs(
    "div",
    {
      ref: l,
      className: ["event-type-multiselect", s && "event-type-multiselect--open"].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ X.jsxs(
          "div",
          {
            className: "event-type-multiselect__trigger",
            onClick: A,
            children: [
              /* @__PURE__ */ X.jsx(
                "input",
                {
                  ref: h,
                  className: [
                    "event-type-multiselect__search",
                    n === "" ? "event-type-multiselect__search--placeholder" : ""
                  ].filter(Boolean).join(" "),
                  value: s ? n : "",
                  placeholder: s ? i : "",
                  onChange: (v) => {
                    a(v.target.value), o(!0);
                  },
                  onFocus: () => o(!0),
                  onKeyDown: (v) => {
                    v.key === "Escape" && (v.preventDefault(), o(!1), a(""));
                  },
                  role: "combobox",
                  "aria-haspopup": "listbox",
                  "aria-expanded": s
                }
              ),
              /* @__PURE__ */ X.jsx(
                "span",
                {
                  className: [
                    "event-type-multiselect__value",
                    n === "" ? "event-type-multiselect__value--placeholder" : ""
                  ].filter(Boolean).join(" "),
                  "aria-hidden": "true",
                  children: !s && i
                }
              ),
              /* @__PURE__ */ X.jsx("span", { className: "event-type-multiselect__arrow", "aria-hidden": "true", children: /* @__PURE__ */ X.jsx(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "14",
                  height: "7",
                  viewBox: "0 0 14 7",
                  fill: "none",
                  children: /* @__PURE__ */ X.jsx(
                    "path",
                    {
                      d: "M6.66633 6.70406L0 0.745582L0.666413 0L6.99954 5.66065L13.3327 0L13.9991 0.745582L7.33275 6.70406L6.99954 7.00188L6.66633 6.70406Z",
                      fill: "#1890FF",
                      fillRule: "evenodd",
                      clipRule: "evenodd"
                    }
                  )
                }
              ) })
            ]
          }
        ),
        s && /* @__PURE__ */ X.jsxs("div", { className: "event-type-multiselect__dropdown", role: "listbox", children: [
          /* @__PURE__ */ X.jsxs(
            "button",
            {
              type: "button",
              className: "event-type-multiselect__select-all",
              onClick: m,
              disabled: !f,
              role: "checkbox",
              "aria-checked": g ? "mixed" : p,
              children: [
                /* @__PURE__ */ X.jsx("span", { children: "Select all" }),
                /* @__PURE__ */ X.jsx(
                  n3,
                  {
                    state: p ? "checked" : g ? "partial" : "unchecked"
                  }
                )
              ]
            }
          ),
          u.map((v) => /* @__PURE__ */ X.jsxs("label", { className: "event-type-multiselect__option", children: [
            /* @__PURE__ */ X.jsx(
              "input",
              {
                type: "checkbox",
                checked: c.has(v),
                onChange: () => y(v)
              }
            ),
            /* @__PURE__ */ X.jsx("span", { children: v }),
            /* @__PURE__ */ X.jsx(
              "span",
              {
                className: "event-type-multiselect__option-check",
                "aria-hidden": "true",
                children: c.has(v) ? /* @__PURE__ */ X.jsx(o3, {}) : null
              }
            )
          ] }, v)),
          u.length === 0 && /* @__PURE__ */ X.jsx("div", { className: "event-type-multiselect__empty", children: "No results" })
        ] })
      ]
    }
  );
}, l3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    className: "visible-events__alarm-icon",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": !0,
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.49908 3.5C9.67591 3.49999 9.83978 3.59386 9.92975 3.74609L16.4307 14.7461C16.5218 14.9005 16.5234 15.0923 16.4346 15.248C16.3456 15.4038 16.1795 15.5 16.0001 15.5H3.00006C2.82064 15.5 2.65449 15.4038 2.56549 15.248C2.47669 15.0923 2.4784 14.9005 2.56939 14.7461L9.06842 3.74609C9.15833 3.59391 9.32234 3.50009 9.49908 3.5ZM3.87701 14.5H15.1231L9.49908 4.98242L3.87701 14.5ZM13.084 4.22266C13.2372 3.99289 13.5476 3.93081 13.7774 4.08398C15.3202 5.11256 16.3951 6.17201 17.0723 7.52637C17.7466 8.87491 18.0001 10.4634 18.0001 12.5C17.9999 12.776 17.7761 13 17.5001 13C17.224 13 17.0002 12.776 17.0001 12.5C17.0001 10.5367 16.7534 9.12501 16.1778 7.97363C15.605 6.82803 14.6798 5.88742 13.2227 4.91602C12.993 4.76289 12.9311 4.4524 13.084 4.22266Z",
        fill: "#DC6D2A"
      }
    )
  }
), h3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M10.1967 3.00391C10.9265 3.00411 11.5501 3.52978 11.6742 4.24902L11.7582 4.73242C11.7877 4.90337 11.9175 5.07319 12.1312 5.1748C12.3609 5.28391 12.5819 5.40821 12.7924 5.5459C12.9841 5.67129 13.1891 5.69668 13.3471 5.63965L13.9017 5.43848C14.577 5.19433 15.3311 5.46281 15.6996 6.0791L16.1732 6.87207C16.5587 7.51711 16.4069 8.3477 15.8187 8.81543L15.4389 9.11816C15.3014 9.22767 15.2136 9.429 15.2289 9.67383C15.2357 9.78307 15.2396 9.89313 15.2396 10.0039C15.2396 10.1147 15.2357 10.2247 15.2289 10.334C15.2136 10.5788 15.3014 10.7801 15.4389 10.8896L15.8187 11.1924C16.4069 11.6601 16.5587 12.4907 16.1732 13.1357L15.6996 13.9287C15.3311 14.545 14.577 14.8135 13.9017 14.5693L13.3471 14.3682C13.1891 14.3111 12.9841 14.3365 12.7924 14.4619C12.5819 14.5996 12.3609 14.7239 12.1312 14.833C11.9175 14.9346 11.7877 15.1044 11.7582 15.2754L11.6742 15.7588C11.5501 16.478 10.9265 17.0037 10.1967 17.0039H9.18886C8.45907 17.0036 7.8354 16.478 7.71132 15.7588L7.62733 15.2754C7.59783 15.1044 7.46806 14.9346 7.25429 14.833C7.02463 14.7239 6.80366 14.5996 6.59315 14.4619C6.40145 14.3366 6.19644 14.3111 6.03847 14.3682L5.48378 14.5693C4.80843 14.8134 4.05436 14.5442 3.68593 13.9277L3.21229 13.1357C2.82685 12.4907 2.97873 11.6601 3.56679 11.1924L3.94667 10.8896C4.08424 10.7802 4.17197 10.5789 4.15663 10.334C4.14979 10.2247 4.14589 10.1147 4.14589 10.0039C4.14589 9.89313 4.14979 9.78306 4.15663 9.67383C4.17197 9.42895 4.08422 9.22766 3.94667 9.11816L3.56679 8.81543C2.97873 8.3477 2.82685 7.51707 3.21229 6.87207L3.68593 6.0791C4.05442 5.46278 4.8085 5.19437 5.48378 5.43848L6.03847 5.63965C6.19644 5.69673 6.40143 5.67127 6.59315 5.5459C6.80366 5.40821 7.02463 5.28391 7.25429 5.1748C7.46806 5.0732 7.59783 4.90339 7.62733 4.73242L7.71132 4.24902C7.8354 3.52981 8.45907 3.00418 9.18886 3.00391H10.1967ZM9.18886 4.00391C8.94576 4.00418 8.73801 4.17933 8.69667 4.41895L8.61268 4.90234C8.5176 5.45344 8.13102 5.86529 7.683 6.07812C7.49451 6.16768 7.31358 6.26995 7.141 6.38281C6.7393 6.64554 6.2065 6.76326 5.69765 6.5791L5.14393 6.37891C4.9188 6.29749 4.66715 6.38726 4.54433 6.59277L4.07069 7.38477C3.94225 7.59974 3.9929 7.87729 4.18886 8.0332L4.56874 8.33496C5.01423 8.68924 5.18592 9.2377 5.15468 9.73633C5.14914 9.82477 5.14589 9.914 5.14589 10.0039C5.14589 10.0938 5.14914 10.183 5.15468 10.2715C5.18592 10.7701 5.01423 11.3186 4.56874 11.6729L4.18886 11.9746C3.99289 12.1305 3.94225 12.4081 4.07069 12.623L4.54433 13.415C4.66715 13.6205 4.9188 13.7103 5.14393 13.6289L5.69765 13.4287C6.20637 13.2446 6.73836 13.3624 7.14003 13.625C7.31271 13.738 7.49438 13.8401 7.683 13.9297C8.13102 14.1425 8.5176 14.5544 8.61268 15.1055L8.69667 15.5889C8.73801 15.8285 8.94576 16.0036 9.18886 16.0039H10.1967C10.4398 16.0037 10.6475 15.8285 10.6889 15.5889L10.7728 15.1055C10.8679 14.5544 11.2545 14.1425 11.7025 13.9297C11.891 13.8401 12.0719 13.7379 12.2445 13.625C12.6462 13.3623 13.179 13.2446 13.6879 13.4287L14.2416 13.6289C14.4667 13.7104 14.7183 13.6205 14.8412 13.415L15.3148 12.623C15.4433 12.408 15.3927 12.1305 15.1967 11.9746L14.8168 11.6729C14.3714 11.3186 14.1996 10.7701 14.2308 10.2715C14.2364 10.183 14.2396 10.0938 14.2396 10.0039C14.2396 9.91399 14.2364 9.82478 14.2308 9.73633C14.1996 9.23773 14.3714 8.68924 14.8168 8.33496L15.1967 8.0332C15.3927 7.87729 15.4433 7.59978 15.3148 7.38477L14.8412 6.59277C14.7183 6.38727 14.4667 6.29743 14.2416 6.37891L13.6879 6.5791C13.179 6.76321 12.6462 6.64557 12.2445 6.38281C12.0719 6.26995 11.891 6.16768 11.7025 6.07812C11.2545 5.86527 10.8679 5.45341 10.7728 4.90234L10.6889 4.41895C10.6475 4.1793 10.4398 4.00411 10.1967 4.00391H9.18886ZM9.683 7C11.3399 7 12.683 8.34315 12.683 10C12.683 11.6569 11.3399 13 9.683 13C8.02636 12.9998 6.683 11.6567 6.683 10C6.683 8.3433 8.02636 7.00025 9.683 7ZM9.683 8C8.57864 8.00025 7.683 8.89558 7.683 10C7.683 11.1044 8.57864 11.9998 9.683 12C10.7876 12 11.683 11.1046 11.683 10C11.683 8.89543 10.7876 8 9.683 8Z",
        fill: "#00A09F"
      }
    )
  }
), u3 = (r) => {
  const t = new Date(r), e = String(t.getDate()).padStart(2, "0"), i = String(t.getMonth() + 1).padStart(2, "0"), s = String(t.getFullYear()).slice(-2), o = String(t.getHours()).padStart(2, "0"), n = String(t.getMinutes()).padStart(2, "0"), a = String(t.getSeconds()).padStart(2, "0");
  return `${e}.${i}.${s}, ${o}:${n}:${a}`;
}, c3 = (r) => new Date(r).toLocaleString(void 0, {
  day: "numeric",
  month: "short"
}), d3 = (r) => new Date(r).toLocaleString(void 0, {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: !1
}), fu = (r) => String(r).padStart(2, "0"), hy = (r) => {
  const t = new Date(r);
  return [
    fu(t.getDate()),
    fu(t.getMonth() + 1),
    fu(t.getFullYear() % 100)
  ].join(".");
}, f3 = (r, t) => new Date(t, r, 0).getDate(), aa = (r, t, e) => {
  if (r.length < 2) return r;
  const i = Number(r);
  return fu(Math.min(e, Math.max(t, i)));
}, uy = (r, t) => {
  const e = r.replace(/\D/g, "").slice(0, 6), i = (/* @__PURE__ */ new Date()).getFullYear(), s = i % 100, o = e.slice(0, 2), n = aa(e.slice(2, 4), 1, 12), a = aa(e.slice(4, 6), 0, s), l = n.length === 2 ? Number(n) : (/* @__PURE__ */ new Date()).getMonth() + 1, h = a.length === 2 ? 2e3 + Number(a) : t, u = f3(l, Math.min(h, i));
  return [aa(o, 1, u), n, a].filter(Boolean).join(".");
}, cy = (r) => {
  const t = r.replace(/\D/g, "").slice(0, 6);
  return [
    aa(t.slice(0, 2), 0, 23),
    aa(t.slice(2, 4), 0, 59),
    aa(t.slice(4, 6), 0, 59)
  ].filter(Boolean).join(":");
}, g3 = (r, t, e) => {
  const { startDateTimeInMs: i, endDateTimeInMs: s } = hc(
    e,
    t
  ), o = r.filter((l) => {
    if (!Number.isFinite(l.startMs)) return !1;
    const h = l.startMs, u = l.startMs + l.duration;
    return h < s && u > i;
  });
  if (!o.length)
    return {
      fromDate: "",
      fromTime: "",
      toDate: "",
      toTime: ""
    };
  const n = Math.min(
    ...o.map((l) => l.startMs)
  ), a = Math.max(
    ...o.map((l) => l.startMs + l.duration)
  );
  return {
    fromDate: hy(n),
    fromTime: "",
    toDate: hy(a),
    toTime: ""
  };
}, dy = (r, t, e) => k1(r, t || e), k1 = (r, t) => {
  if (r === "" && t === "") return null;
  if (!/^\d{2}\.\d{2}\.\d{2}$/.test(r) || !/^\d{2}:\d{2}:\d{2}$/.test(t)) return;
  const [e, i, s] = r.split(".").map(Number), [o, n, a] = t.split(":").map(Number), l = new Date(2e3 + s, i - 1, e, o, n, a);
  if (!(l.getFullYear() !== 2e3 + s || l.getMonth() !== i - 1 || l.getDate() !== e || l.getHours() !== o || l.getMinutes() !== n || l.getSeconds() !== a))
    return l.getTime();
}, eu = (r) => {
  r.ctrlKey || r.metaKey || r.altKey || [
    "Backspace",
    "Delete",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End"
  ].includes(r.key) || /^\d$/.test(r.key) || r.preventDefault();
}, p3 = ({
  channels: r,
  globalEvents: t,
  onEventClick: e,
  isExpanded: i,
  onExpandedChange: s,
  parsedEdfInfo: o,
  selectedDayMs: n,
  therapyTimeInterval: a,
  therapySettings: l
}) => {
  const h = ni(
    () => g3(o, n, a),
    [o, n, a]
  ), u = ni(() => {
    const z = k1(
      h.fromDate,
      "00:00:00"
    );
    return z == null ? (/* @__PURE__ */ new Date()).getFullYear() : new Date(z).getFullYear();
  }, [h.fromDate]), [c, d] = ze([]), [f, p] = ze("startMs"), [g, y] = ze("asc"), [m, A] = ze(!1), [v, b] = ze(h.fromDate), [w, k] = ze(h.fromTime), [R, L] = ze(h.toDate), [x, M] = ze(h.toTime), C = c.slice(0, 5), S = c.length - C.length;
  mi(() => {
    b(h.fromDate), k(h.fromTime), L(h.toDate), M(h.toTime);
  }, [h]);
  const E = ni(() => {
    const z = (U, $, Z) => (Z ?? []).map((q, Q) => ({
      key: `${U}-${q.x1}-${q.x2}-${Q}`,
      eventKey: q.eventKey,
      eventName: $,
      startMs: q.x1,
      endMs: q.x2,
      type: q.isAlarm === !0 ? "alarm" : "generic"
    })), W = r.flatMap(
      (U) => U.events.flatMap(
        ($) => z(
          `${U.id}-${$.type}`,
          $.config.label || $.type,
          $.data
        )
      )
    ), G = (t ?? []).filter((U) => U.config.showInProtocol !== !1).flatMap(
      (U) => z(
        `global-${U.type}`,
        U.config.label || U.type,
        U.data
      )
    ), Y = w1(
      l
    ).filter((U) => U.texts.some(($) => $.isChanged)).map((U, $) => ({
      key: `therapy-settings-change-${U.startMs}-${U.endMs}-${$}`,
      eventName: "Settings change",
      startMs: U.startMs,
      endMs: U.endMs,
      type: "therapy-settings-change"
    }));
    return [...W, ...G, ...Y].sort(
      (U, $) => U.startMs - $.startMs
    );
  }, [r, t, l]), T = ni(
    () => Array.from(new Set(E.map((z) => z.eventName))).sort(
      (z, W) => z.localeCompare(W)
    ),
    [E]
  ), I = ni(
    () => dy(v, w, "00:00:00"),
    [v, w]
  ), F = ni(
    () => dy(R, x, "23:59:59"),
    [R, x]
  ), D = (z) => !(I != null && z.startMs < I || F != null && z.startMs > F), P = ni(
    () => c.length === 0 ? E.filter(D) : E.filter(
      (z) => c.includes(z.eventName) && D(z)
    ),
    [E, I, c, F]
  ), V = ni(() => {
    const z = [...P];
    return z.sort((W, G) => {
      if (f === "name") {
        const U = W.eventName.localeCompare(G.eventName) || W.startMs - G.startMs;
        return g === "asc" ? U : -U;
      }
      const Y = W.startMs - G.startMs || W.eventName.localeCompare(G.eventName);
      return g === "asc" ? Y : -Y;
    }), z;
  }, [P, g, f]), _ = (z) => {
    if (f === z) {
      y((W) => W === "asc" ? "desc" : "asc");
      return;
    }
    p(z), y("asc");
  }, O = (z) => f !== z ? "↕" : g === "asc" ? "↑" : "↓", B = ni(() => {
    const { startDateTimeInMs: z, endDateTimeInMs: W } = hc(
      a,
      n
    ), G = b1(
      o,
      z,
      W
    );
    return (G.length === 0 ? [{ start: z, end: W }] : (() => {
      const U = [];
      let $ = z;
      return G.forEach((Z) => {
        Z.start > $ && U.push({
          start: $,
          end: Z.start
        }), $ = Math.max($, Z.end);
      }), $ < W && U.push({
        start: $,
        end: W
      }), U;
    })()).map((U, $) => ({
      key: `session-${U.start}-${U.end}-${$}`,
      startMs: U.start,
      endMs: U.end,
      events: V.filter(
        (Z) => Z.startMs < U.end && Z.endMs > U.start
      )
    })).filter((U) => U.events.length > 0);
  }, [o, n, V, a]);
  return i ? /* @__PURE__ */ X.jsxs("section", { className: "visible-events", children: [
    /* @__PURE__ */ X.jsxs("div", { className: "visible-events__title", children: [
      /* @__PURE__ */ X.jsx("span", { className: "visible-events__title-text", children: "THERAPY PROTOCOL" }),
      /* @__PURE__ */ X.jsxs("span", { className: "visible-events__title-actions", children: [
        /* @__PURE__ */ X.jsx(
          r3,
          {
            isActive: m,
            onClick: (z) => {
              z.stopPropagation(), A((W) => !W);
            }
          }
        ),
        /* @__PURE__ */ X.jsx(
          T1,
          {
            onClick: () => s?.(!1)
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ X.jsxs("div", { className: "visible-events__body", children: [
      m && /* @__PURE__ */ X.jsxs("div", { className: "visible-events__filters-container", children: [
        /* @__PURE__ */ X.jsxs("div", { className: "visible-events__filters-card", children: [
          /* @__PURE__ */ X.jsx("span", { className: "visible-events__select-label", children: "Date and time range" }),
          /* @__PURE__ */ X.jsxs("div", { className: "visible-events__range-row", children: [
            /* @__PURE__ */ X.jsxs("div", { className: "visible-events__date-time-group", children: [
              /* @__PURE__ */ X.jsx(
                "input",
                {
                  className: "visible-events__filter-input",
                  value: v,
                  placeholder: "dd.mm.yy",
                  inputMode: "numeric",
                  maxLength: 8,
                  onKeyDown: eu,
                  onChange: (z) => b(
                    uy(z.target.value, u)
                  ),
                  "aria-label": "Filter from date"
                }
              ),
              /* @__PURE__ */ X.jsx(
                "input",
                {
                  className: "visible-events__filter-input",
                  value: w,
                  placeholder: "hh:mm:ss",
                  inputMode: "numeric",
                  maxLength: 8,
                  onKeyDown: eu,
                  onChange: (z) => k(cy(z.target.value)),
                  "aria-label": "Filter from time"
                }
              )
            ] }),
            /* @__PURE__ */ X.jsx("span", { className: "visible-events__range-separator", children: "-" }),
            /* @__PURE__ */ X.jsxs("div", { className: "visible-events__date-time-group", children: [
              /* @__PURE__ */ X.jsx(
                "input",
                {
                  className: "visible-events__filter-input",
                  value: R,
                  placeholder: "dd.mm.yy",
                  inputMode: "numeric",
                  maxLength: 8,
                  onKeyDown: eu,
                  onChange: (z) => L(
                    uy(z.target.value, u)
                  ),
                  "aria-label": "Filter to date"
                }
              ),
              /* @__PURE__ */ X.jsx(
                "input",
                {
                  className: "visible-events__filter-input",
                  value: x,
                  placeholder: "hh:mm:ss",
                  inputMode: "numeric",
                  maxLength: 8,
                  onKeyDown: eu,
                  onChange: (z) => M(cy(z.target.value)),
                  "aria-label": "Filter to time"
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ X.jsxs("div", { className: "visible-events__select-wrap", children: [
          /* @__PURE__ */ X.jsx("span", { className: "visible-events__select-label", children: "Event type" }),
          /* @__PURE__ */ X.jsx(
            a3,
            {
              options: T,
              selectedValues: c,
              onChange: d,
              placeholder: "Select event type"
            }
          ),
          c.length > 0 && /* @__PURE__ */ X.jsxs(
            "div",
            {
              className: "visible-events__selected-types",
              "aria-label": "Selected event types",
              children: [
                C.map((z) => /* @__PURE__ */ X.jsx(
                  s3,
                  {
                    label: z,
                    onRemove: () => d(
                      (W) => W.filter(
                        (G) => G !== z
                      )
                    )
                  },
                  z
                )),
                S > 0 && /* @__PURE__ */ X.jsxs("span", { className: "visible-events__selected-types-more", children: [
                  "+ ",
                  S,
                  " more"
                ] })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ X.jsx("div", { className: "visible-events__list-container", children: B.length === 0 ? /* @__PURE__ */ X.jsx("p", { className: "visible-events__empty", children: "No events in visible channels." }) : /* @__PURE__ */ X.jsx("div", { className: "visible-events__sessions", children: B.map((z) => /* @__PURE__ */ X.jsxs("section", { className: "visible-events__session", children: [
        /* @__PURE__ */ X.jsxs("div", { className: "visible-events__session-header", children: [
          /* @__PURE__ */ X.jsxs("h3", { className: "visible-events__session-title", children: [
            "Session on ",
            c3(z.startMs)
          ] }),
          /* @__PURE__ */ X.jsx("div", { className: "visible-events__session-header-divider" }),
          /* @__PURE__ */ X.jsxs(
            "button",
            {
              className: "visible-events__session-title visible-events__session-title-duration",
              type: "button",
              onClick: () => e?.({
                startMs: z.startMs,
                endMs: z.endMs
              }),
              children: [
                "Start time: ",
                d3(z.startMs)
              ]
            }
          ),
          /* @__PURE__ */ X.jsx("div", { className: "visible-events__session-header-divider" }),
          /* @__PURE__ */ X.jsxs("h3", { className: "visible-events__session-title", children: [
            "Duration: ",
            Jp(z.endMs - z.startMs)
          ] })
        ] }),
        /* @__PURE__ */ X.jsxs("div", { className: "visible-events__header", children: [
          /* @__PURE__ */ X.jsxs(
            "button",
            {
              type: "button",
              className: "visible-events__header-btn",
              onClick: () => _("name"),
              children: [
                /* @__PURE__ */ X.jsx("span", { children: "Name" }),
                /* @__PURE__ */ X.jsx(
                  "span",
                  {
                    className: "visible-events__sort-indicator",
                    "aria-hidden": !0,
                    children: O("name")
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ X.jsxs(
            "button",
            {
              type: "button",
              className: "visible-events__header-btn",
              onClick: () => _("startMs"),
              children: [
                /* @__PURE__ */ X.jsx("span", { children: "Start time" }),
                /* @__PURE__ */ X.jsx(
                  "span",
                  {
                    className: "visible-events__sort-indicator",
                    "aria-hidden": !0,
                    children: O("startMs")
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ X.jsx("span", { children: "Duration" })
        ] }),
        /* @__PURE__ */ X.jsx("ul", { className: "visible-events__list", children: z.events.map((W) => /* @__PURE__ */ X.jsx("li", { className: "visible-events__item", children: /* @__PURE__ */ X.jsxs(
          "button",
          {
            type: "button",
            className: "visible-events__item-btn",
            onClick: () => e?.({
              startMs: W.startMs,
              endMs: W.endMs,
              eventKey: W.eventKey
            }),
            children: [
              /* @__PURE__ */ X.jsxs("span", { className: "visible-events__name", children: [
                W.eventName,
                W.type === "alarm" ? /* @__PURE__ */ X.jsx(l3, {}) : null,
                W.type === "therapy-settings-change" ? /* @__PURE__ */ X.jsx(h3, {}) : null
              ] }),
              /* @__PURE__ */ X.jsx("span", { className: "visible-events__time", children: u3(W.startMs) }),
              W.type !== "therapy-settings-change" ? /* @__PURE__ */ X.jsx("span", { className: "visible-events__duration", children: Jp(
                W.endMs - W.startMs
              ) }) : null
            ]
          }
        ) }, W.key)) })
      ] }, z.key)) }) })
    ] })
  ] }) : null;
}, y3 = ({
  icon: r,
  label: t,
  tooltip: e,
  active: i = !1,
  className: s,
  ...o
}) => /* @__PURE__ */ X.jsxs(
  "button",
  {
    ...o,
    type: "button",
    className: [
      "feature-sidebar__button",
      i ? "feature-sidebar__button--active" : "",
      s ?? ""
    ].filter(Boolean).join(" "),
    "aria-label": t,
    children: [
      /* @__PURE__ */ X.jsx("span", { className: "feature-sidebar__button-icon", children: r }),
      /* @__PURE__ */ X.jsx("span", { className: "feature-sidebar__tooltip", role: "tooltip", children: e ?? t })
    ]
  }
), rk = () => /* @__PURE__ */ X.jsx("div", { className: "feature-sidebar__separator", role: "separator" }), m3 = ({
  activeItemId: r,
  items: t,
  renderPanel: e,
  extension: i,
  stretch: s = !0,
  height: o
}) => {
  const n = r !== null, a = r ? t.find((c) => c.id === r) : void 0, l = r ? e?.(r) : null, h = a?.panelWidth, u = h === void 0 ? void 0 : h + 60;
  return /* @__PURE__ */ X.jsxs(
    "div",
    {
      className: [
        "feature-sidebar",
        s ? "feature-sidebar--stretch" : "feature-sidebar--top-aligned",
        n ? "feature-sidebar--expanded" : "feature-sidebar--collapsed"
      ].filter(Boolean).join(" "),
      style: {
        ...o !== void 0 ? { height: typeof o == "number" ? `${o}px` : o } : {},
        ...n && u ? {
          width: `${u}px`,
          minWidth: `${u}px`,
          flexBasis: `${u}px`
        } : {}
      },
      children: [
        /* @__PURE__ */ X.jsx(
          "div",
          {
            className: "feature-sidebar__panel",
            style: h ? { flexBasis: `${h}px` } : void 0,
            children: l
          }
        ),
        /* @__PURE__ */ X.jsxs("div", { className: "feature-sidebar__rail", children: [
          t.map((c) => /* @__PURE__ */ X.jsx(
            y3,
            {
              icon: c.icon,
              label: c.label,
              tooltip: c.tooltip,
              active: r === c.id,
              "aria-expanded": r === c.id,
              onClick: c.onClick
            },
            c.id
          )),
          i
        ] })
      ]
    }
  );
}, x3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": !0,
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M4.90006 0.500393C4.90015 0.224383 5.12405 0.000483722 5.40006 0.000392555L6.69205 0.000392499C6.96793 0.000636828 7.19196 0.224478 7.19205 0.500392C7.19198 0.776321 6.96794 1.00015 6.69205 1.00039L6.60709 1.00039L13.944 8.33731L13.944 8.25235C13.944 7.97621 14.1679 7.75235 14.444 7.75235C14.7199 7.75259 14.944 7.97636 14.944 8.25235L14.944 9.54434C14.9439 9.82027 14.7199 10.0441 14.444 10.0443L13.152 10.0443C12.8759 10.0443 12.6521 9.82041 12.652 9.54434C12.652 9.2682 12.8759 9.04435 13.152 9.04434L13.237 9.04434L5.90006 1.70742L5.90006 1.79238C5.89999 2.06831 5.67595 2.29214 5.40006 2.29238C5.12404 2.29229 4.90014 2.06841 4.90006 1.79238L4.90006 0.500393ZM0.335609 6.47891C-0.111897 6.0314 -0.111844 5.30536 0.335609 4.85781L2.65104 2.54141C3.09849 2.09394 3.82457 2.09412 4.27213 2.54141L8.97916 7.25039C8.98015 7.25136 8.98209 7.25137 8.98307 7.25235C8.98397 7.25324 8.98414 7.25535 8.98502 7.25625L10.2653 8.5375C10.2681 8.5402 10.2723 8.54156 10.2751 8.54434C10.2778 8.54712 10.2792 8.55127 10.2819 8.5541L11.5573 9.82949C11.5601 9.8322 11.5643 9.83355 11.5671 9.83633C11.5698 9.83905 11.5712 9.84333 11.5739 9.8461L12.402 10.6723C12.8494 11.1198 12.8495 11.8449 12.402 12.2924L10.0866 14.6088C9.63911 15.0562 8.91303 15.0561 8.46549 14.6088L0.335609 6.47891ZM1.04264 5.56485C0.985695 5.62186 0.985652 5.71489 1.04264 5.77188L9.17252 13.9018C9.22953 13.9586 9.3226 13.9587 9.37956 13.9018L11.695 11.5854C11.7519 11.5284 11.7518 11.4363 11.695 11.3793L11.2126 10.8979L10.2751 11.8354C10.0798 12.0306 9.76329 12.0306 9.56803 11.8354C9.37297 11.6401 9.37285 11.3235 9.56803 11.1283L10.5046 10.1918L9.92057 9.60684L9.62955 9.89785C9.43428 10.093 9.11677 10.0931 8.92155 9.89785C8.72666 9.7027 8.72675 9.38603 8.92155 9.19082L9.21354 8.89883L8.62858 8.31387L7.69108 9.25137C7.49582 9.44662 7.17931 9.44663 6.98405 9.25137C6.78906 9.05609 6.78889 8.73951 6.98405 8.54434L7.92155 7.60684L7.33756 7.02188L7.04557 7.31387C6.8503 7.509 6.53278 7.50909 6.33756 7.31387C6.14272 7.11871 6.14278 6.80203 6.33756 6.60684L6.62955 6.31485L6.04459 5.72988L5.10709 6.66738C4.91183 6.86263 4.59532 6.86264 4.40006 6.66738C4.20512 6.4721 4.20492 6.15551 4.40006 5.96035L5.33756 5.02285L4.75358 4.43789L4.46159 4.72988C4.26631 4.92502 3.9488 4.9251 3.75358 4.72988C3.55878 4.53472 3.55881 4.21803 3.75358 4.02285L4.04557 3.73086L3.5651 3.24942C3.50809 3.1924 3.41606 3.1924 3.35905 3.24942L1.04264 5.56485Z",
        fill: "currentColor"
      }
    )
  }
), v3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": !0,
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M11.6533 2.00781C12.2388 2.06726 12.7234 2.46385 12.9131 3H14C15.1046 3 16 3.89543 16 5V16C16 17.0357 15.2128 17.887 14.2041 17.9893L14 18H5L4.7959 17.9893C3.85435 17.8938 3.1062 17.1457 3.01074 16.2041L3 16V5C3 3.89543 3.89543 3 5 3H6.08691C6.29297 2.41766 6.84707 2 7.5 2H11.5L11.6533 2.00781ZM5 4C4.44772 4 4 4.44772 4 5V16C4 16.5523 4.44772 17 5 17H14C14.5523 17 15 16.5523 15 16V5C15 4.44772 14.5523 4 14 4H12.9131C12.7234 4.53615 12.2388 4.93274 11.6533 4.99219L11.5 5H7.5C6.84707 5 6.29297 4.58234 6.08691 4H5ZM9.99902 7C10.2096 6.99959 10.3977 7.1312 10.4697 7.3291L12.0273 11.6133L12.1523 11.3105L12.1865 11.2432C12.2758 11.094 12.4378 11.0001 12.6152 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H12.9512L12.4629 13.1895C12.3845 13.3804 12.1966 13.504 11.9902 13.5C11.7838 13.4958 11.6009 13.365 11.5303 13.1709L10.0039 8.97363L7.9707 14.668C7.90003 14.8658 7.71305 14.9986 7.50293 15C7.29294 15.0012 7.10444 14.8707 7.03125 14.6738L6.03711 12H5.5C5.22386 12 5 11.7761 5 11.5C5.00001 11.2239 5.22387 11 5.5 11H6.38477L6.46191 11.0059C6.6386 11.0334 6.78982 11.1549 6.85352 11.3262L7.49023 13.04L9.5293 7.33203L9.56055 7.26074C9.64681 7.10218 9.81448 7.00053 9.99902 7ZM7.5 3C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4H11.5C11.7761 4 12 3.77614 12 3.5C12 3.22386 11.7761 3 11.5 3H7.5Z",
        fill: "currentColor"
      }
    )
  }
), S3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M10.5 4C10.7761 4 11 4.22386 11 4.5C11 4.77614 10.7761 5 10.5 5H5.5C5.22386 5 5 5.22386 5 5.5V14.5C5 14.7761 5.22386 15 5.5 15H14.5C14.7761 15 15 14.7761 15 14.5V9.5C15 9.22386 15.2239 9 15.5 9C15.7761 9 16 9.22386 16 9.5V14.5C16 15.3284 15.3284 16 14.5 16H5.5C4.67157 16 4 15.3284 4 14.5V5.5C4 4.67157 4.67157 4 5.5 4H10.5ZM15.1465 4.14648C15.3417 3.95122 15.6583 3.95122 15.8535 4.14648C16.0488 4.34175 16.0488 4.65825 15.8535 4.85352L10.8535 9.85352C10.6583 10.0488 10.3417 10.0488 10.1465 9.85352C9.95122 9.65825 9.95122 9.34175 10.1465 9.14648L15.1465 4.14648Z",
        fill: "currentColor"
      }
    )
  }
);
function D1(r) {
  var t, e, i = "";
  if (typeof r == "string" || typeof r == "number") i += r;
  else if (typeof r == "object") if (Array.isArray(r)) {
    var s = r.length;
    for (t = 0; t < s; t++) r[t] && (e = D1(r[t])) && (i && (i += " "), i += e);
  } else for (e in r) r[e] && (i && (i += " "), i += e);
  return i;
}
function Jl() {
  for (var r, t, e = 0, i = "", s = arguments.length; e < s; e++) (r = arguments[e]) && (t = D1(r)) && (i && (i += " "), i += t);
  return i;
}
const fy = (r) => `#${r.replace(/[^0-9a-f]/gi, "").slice(0, 6).toUpperCase()}`, A3 = (r) => /^#[0-9A-F]{6}$/i.test(r), b3 = ({
  value: r,
  onChange: t
}) => {
  const [e, i] = ze(r);
  mi(() => {
    i(r);
  }, [r]);
  const s = (o) => {
    const n = fy(o);
    if (A3(n)) {
      i(n), t(n);
      return;
    }
    i(r);
  };
  return /* @__PURE__ */ X.jsxs("label", { className: "event-editor__color-control", children: [
    /* @__PURE__ */ X.jsx("span", { className: "event-editor__color-label", children: "Color" }),
    /* @__PURE__ */ X.jsxs("div", { className: "event-editor__color-input-wrap", children: [
      /* @__PURE__ */ X.jsx(
        "input",
        {
          className: "event-editor__color-input",
          value: e,
          maxLength: 7,
          spellCheck: !1,
          onChange: (o) => i(fy(o.target.value)),
          onBlur: () => s(e),
          onKeyDown: (o) => {
            o.key === "Enter" && (s(e), o.currentTarget.blur());
          },
          "aria-label": "Event color"
        }
      ),
      /* @__PURE__ */ X.jsxs("span", { className: "event-editor__color-swatch-wrap", children: [
        /* @__PURE__ */ X.jsx(
          "span",
          {
            className: "event-editor__color-swatch",
            style: { backgroundColor: r }
          }
        ),
        /* @__PURE__ */ X.jsx(
          "input",
          {
            className: "event-editor__color-native",
            type: "color",
            value: r,
            onChange: (o) => {
              const n = o.target.value.toUpperCase();
              i(n), t(n);
            },
            "aria-label": "Pick event color"
          }
        )
      ] })
    ] })
  ] });
}, pl = ({
  icon: r,
  children: t,
  onClick: e,
  className: i
}) => /* @__PURE__ */ X.jsxs(
  "button",
  {
    type: "button",
    className: Jl("event-editor__action-btn", i),
    onClick: e,
    disabled: !e,
    children: [
      r,
      /* @__PURE__ */ X.jsx("span", { children: t })
    ]
  }
), E3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    className: "event-editor__action-icon",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M8.82324 2.06072C9.55853 1.66856 10.4415 1.66856 11.1768 2.06072L16.6768 4.99431C17.4913 5.42883 18 6.27718 18 7.20037V12.8C18 13.7232 17.4913 14.5715 16.6768 15.006L11.1768 17.9396C10.4415 18.3318 9.55853 18.3318 8.82324 17.9396L3.32324 15.006C2.50873 14.5715 2 13.7232 2 12.8V7.20037C2.00001 6.27718 2.50872 5.42883 3.32324 4.99431L8.82324 2.06072ZM10.7061 2.94353C10.2649 2.70824 9.73512 2.70824 9.29395 2.94353L3.79395 5.87712C3.30535 6.13786 3.00001 6.64653 3 7.20037V12.8C3 13.3539 3.30515 13.8635 3.79395 14.1242L9.29395 17.0568C9.73512 17.2921 10.2649 17.2921 10.7061 17.0568L16.2061 14.1242C16.6948 13.8635 17 13.3539 17 12.8V7.20037C17 6.64653 16.6946 6.13786 16.2061 5.87712L10.7061 2.94353ZM10 7.00017C11.6568 7.00017 13 8.34333 13 10.0002C13 11.657 11.6569 13.0002 10 13.0002C8.34315 13.0002 7 11.657 7 10.0002C7.00001 8.34333 8.34315 7.00017 10 7.00017ZM10 8.00017C8.89544 8.00017 8.00001 8.89561 8 10.0002C8 11.1047 8.89543 12.0002 10 12.0002C11.1046 12.0002 12 11.1047 12 10.0002C12 8.89561 11.1046 8.00017 10 8.00017Z",
        fill: "#5D5D5D"
      }
    )
  }
), M3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    className: "event-editor__action-icon",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M10.5 7C11.8807 7 13 8.11929 13 9.5C13 10.7094 12.141 11.7175 11 11.9492V17.5C11 17.7761 10.7761 18 10.5 18C10.2239 18 10 17.7761 10 17.5V11.9492C8.85895 11.7175 8 10.7094 8 9.5C8 8.11929 9.11929 7 10.5 7ZM15.5 3C16.3284 3 17 3.67157 17 4.5V14.5C17 15.3284 16.3284 16 15.5 16H13.5C13.2239 16 13 15.7761 13 15.5C13 15.2239 13.2239 15 13.5 15H15.5C15.7761 15 16 14.7761 16 14.5V4.5C16 4.22386 15.7761 4 15.5 4H5.5C5.22386 4 5 4.22386 5 4.5V14.5C5 14.7761 5.22386 15 5.5 15H7.5C7.77614 15 8 15.2239 8 15.5C8 15.7761 7.77614 16 7.5 16H5.5C4.67157 16 4 15.3284 4 14.5V4.5C4 3.67157 4.67157 3 5.5 3H15.5ZM10.5 8C9.67157 8 9 8.67157 9 9.5C9 10.3284 9.67157 11 10.5 11C11.3284 11 12 10.3284 12 9.5C12 8.67157 11.3284 8 10.5 8Z",
        fill: "#5D5D5D"
      }
    )
  }
), C3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    className: "event-editor__action-icon",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M10 4C12.3704 4 14.4178 5.37494 15.3926 7.37012L16.0225 5.35156C16.1046 5.08804 16.3849 4.94054 16.6484 5.02246C16.912 5.10458 17.0595 5.3849 16.9775 5.64844L15.8867 9.14844C15.8055 9.40895 15.5304 9.55629 15.2686 9.47949L11.8594 8.47949C11.5944 8.40177 11.4428 8.12435 11.5205 7.85938C11.5982 7.5944 11.8757 7.4428 12.1406 7.52051L14.6914 8.26855C13.987 6.36064 12.1524 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15C11.2092 15 12.317 14.5715 13.1816 13.8574C13.2674 13.7866 13.3508 13.713 13.4316 13.6367C13.6324 13.4472 13.9491 13.4564 14.1387 13.6572C14.3279 13.858 14.3187 14.1738 14.1182 14.3633C14.0213 14.4547 13.9212 14.543 13.8184 14.6279C12.7811 15.4845 11.4501 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4Z",
        fill: "#5D5D5D"
      }
    )
  }
), w3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    className: "event-editor__action-icon",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M4 5.5C4 4.67157 4.67157 4 5.5 4H14.5C15.3284 4 16 4.67157 16 5.5V14.5C16 15.3284 15.3284 16 14.5 16H5.5C4.67157 16 4 15.3284 4 14.5V5.5ZM5.5 5C5.22386 5 5 5.22386 5 5.5V14.5C5 14.7761 5.22386 15 5.5 15H14.5C14.7761 15 15 14.7761 15 14.5V5.5C15 5.22386 14.7761 5 14.5 5H5.5Z",
        fill: "#5D5D5D"
      }
    )
  }
), T3 = () => /* @__PURE__ */ X.jsx(
  "svg",
  {
    className: "event-editor__action-icon",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    children: /* @__PURE__ */ X.jsx(
      "path",
      {
        d: "M11.5 3C12.3284 3 13 3.67157 13 4.5V6H16.5C16.7761 6 17 6.22386 17 6.5C17 6.77614 16.7761 7 16.5 7H15V15.5C15 16.3284 14.3284 17 13.5 17H6.5C5.67157 17 5 16.3284 5 15.5V7H3.5C3.22386 7 3 6.77614 3 6.5C3 6.22386 3.22386 6 3.5 6H7V4.5C7 3.67157 7.67157 3 8.5 3H11.5ZM6 15.5C6 15.7761 6.22386 16 6.5 16H13.5C13.7761 16 14 15.7761 14 15.5V7H6V15.5ZM8.5 9C8.77614 9 9 9.22386 9 9.5V13.5C9 13.7761 8.77614 14 8.5 14C8.22386 14 8 13.7761 8 13.5V9.5C8 9.22386 8.22386 9 8.5 9ZM11.5 9C11.7761 9 12 9.22386 12 9.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V9.5C11 9.22386 11.2239 9 11.5 9ZM8.5 4C8.22386 4 8 4.22386 8 4.5V6H12V4.5C12 4.22386 11.7761 4 11.5 4H8.5Z",
        fill: "#5D5D5D"
      }
    )
  }
), k3 = ({
  onPushChanges: r,
  onReset: t,
  onClearSelection: e,
  onDelete: i
}) => /* @__PURE__ */ X.jsxs("div", { className: "event-editor__actions", children: [
  /* @__PURE__ */ X.jsx(pl, { icon: /* @__PURE__ */ X.jsx(E3, {}), children: "Go to event type settings" }),
  /* @__PURE__ */ X.jsx(pl, { icon: /* @__PURE__ */ X.jsx(M3, {}), onClick: r, children: "Push changes to event type" }),
  /* @__PURE__ */ X.jsx(pl, { icon: /* @__PURE__ */ X.jsx(C3, {}), onClick: t, children: "Reset to defaults" }),
  /* @__PURE__ */ X.jsx(pl, { icon: /* @__PURE__ */ X.jsx(w3, {}), onClick: e, children: "Clear selection" }),
  /* @__PURE__ */ X.jsx(
    pl,
    {
      icon: /* @__PURE__ */ X.jsx(T3, {}),
      onClick: i,
      className: "event-editor__action-btn--delete",
      children: "Delete event"
    }
  )
] });
function F1(r, [t, e]) {
  return Math.min(e, Math.max(t, r));
}
function ia(r, t, { checkForDefaultPrevented: e = !0 } = {}) {
  return function(s) {
    if (r?.(s), e === !1 || !s || !s.defaultPrevented)
      return t?.(s);
  };
}
function gy(r, t) {
  if (typeof r == "function")
    return r(t);
  r != null && (r.current = t);
}
function D3(...r) {
  return (t) => {
    let e = !1;
    const i = r.map((s) => {
      const o = gy(s, t);
      return !e && typeof o == "function" && (e = !0), o;
    });
    if (e)
      return () => {
        for (let s = 0; s < i.length; s++) {
          const o = i[s];
          typeof o == "function" ? o() : gy(r[s], null);
        }
      };
  };
}
function Rn(...r) {
  return Yt.useCallback(D3(...r), r);
}
function L1(r, t = []) {
  let e = [];
  function i(o, n) {
    const a = Yt.createContext(n);
    a.displayName = o + "Context";
    const l = e.length;
    e = [...e, n];
    const h = (c) => {
      const { scope: d, children: f, ...p } = c, g = d?.[r]?.[l] || a, y = Yt.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ X.jsx(g.Provider, { value: y, children: f });
    };
    h.displayName = o + "Provider";
    function u(c, d, f = {}) {
      const { optional: p = !1 } = f, g = d?.[r]?.[l] || a, y = Yt.useContext(g);
      if (y) return y;
      if (n !== void 0) return n;
      if (!p)
        throw new Error(`\`${c}\` must be used within \`${o}\``);
    }
    return [h, u];
  }
  const s = () => {
    const o = e.map((n) => Yt.createContext(n));
    return function(a) {
      const l = a?.[r] || o;
      return Yt.useMemo(
        () => ({ [`__scope${r}`]: { ...a, [r]: l } }),
        [a, l]
      );
    };
  };
  return s.scopeName = r, [i, F3(s, ...t)];
}
function F3(...r) {
  const t = r[0];
  if (r.length === 1) return t;
  const e = () => {
    const i = r.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(o) {
      const n = i.reduce((a, { useScope: l, scopeName: h }) => {
        const c = l(o)[`__scope${h}`];
        return { ...a, ...c };
      }, {});
      return Yt.useMemo(() => ({ [`__scope${t.scopeName}`]: n }), [n]);
    };
  };
  return e.scopeName = t.scopeName, e;
}
var P1 = globalThis?.document ? Yt.useLayoutEffect : () => {
}, L3 = Yt[" useInsertionEffect ".trim().toString()] || P1;
function P3({
  prop: r,
  defaultProp: t,
  onChange: e = () => {
  },
  caller: i
}) {
  const [s, o, n] = R3({
    defaultProp: t,
    onChange: e
  }), a = r !== void 0, l = a ? r : s;
  {
    const u = Yt.useRef(r !== void 0);
    Yt.useEffect(() => {
      const c = u.current;
      c !== a && console.warn(
        `${i} is changing from ${c ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = a;
    }, [a, i]);
  }
  const h = Yt.useCallback(
    (u) => {
      if (a) {
        const c = I3(u) ? u(r) : u;
        c !== r && n.current?.(c);
      } else
        o(u);
    },
    [a, r, o, n]
  );
  return [l, h];
}
function R3({
  defaultProp: r,
  onChange: t
}) {
  const [e, i] = Yt.useState(r), s = Yt.useRef(e), o = Yt.useRef(t);
  return L3(() => {
    o.current = t;
  }, [t]), Yt.useEffect(() => {
    s.current !== e && (o.current?.(e), s.current = e);
  }, [e, s]), [e, i, o];
}
function I3(r) {
  return typeof r == "function";
}
var V3 = Yt.createContext(void 0);
function _3(r) {
  const t = Yt.useContext(V3);
  return r || t || "ltr";
}
function O3(r) {
  const t = Yt.useRef({ value: r, previous: r });
  return Yt.useMemo(() => (t.current.value !== r && (t.current.previous = t.current.value, t.current.value = r), t.current.previous), [r]);
}
function N3(r) {
  const [t, e] = Yt.useState(void 0);
  return P1(() => {
    if (r) {
      e({ width: r.offsetWidth, height: r.offsetHeight });
      const i = new ResizeObserver((s) => {
        if (!Array.isArray(s) || !s.length)
          return;
        const o = s[0];
        let n, a;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, h = Array.isArray(l) ? l[0] : l;
          n = h.inlineSize, a = h.blockSize;
        } else
          n = r.offsetWidth, a = r.offsetHeight;
        e({ width: n, height: a });
      });
      return i.observe(r, { box: "border-box" }), () => i.unobserve(r);
    } else
      e(void 0);
  }, [r]), t;
}
// @__NO_SIDE_EFFECTS__
function Bd(r) {
  const t = Yt.forwardRef((e, i) => {
    let { children: s, ...o } = e, n = null, a = !1;
    const l = [];
    py(s) && typeof iu == "function" && (s = iu(s._payload)), Yt.Children.forEach(s, (d) => {
      if (U3(d)) {
        a = !0;
        const f = d;
        let p = "child" in f.props ? f.props.child : f.props.children;
        py(p) && typeof iu == "function" && (p = iu(p._payload)), n = z3(f, p), l.push(n?.props?.children);
      } else
        l.push(d);
    }), n ? n = Yt.cloneElement(n, void 0, l) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !a && Yt.Children.count(s) === 1 && Yt.isValidElement(s) && (n = s)
    );
    const h = n ? G3(n) : void 0, u = Rn(i, h);
    if (!n) {
      if (s || s === 0)
        throw new Error(
          a ? $3(r) : j3(r)
        );
      return s;
    }
    const c = W3(o, n.props ?? {});
    return n.type !== Yt.Fragment && (c.ref = i ? u : h), Yt.cloneElement(n, c);
  });
  return t.displayName = `${r}.Slot`, t;
}
var B3 = Symbol.for("radix.slottable"), z3 = (r, t) => {
  if ("child" in r.props) {
    const e = r.props.child;
    return Yt.isValidElement(e) ? Yt.cloneElement(e, void 0, r.props.children(e.props.children)) : null;
  }
  return Yt.isValidElement(t) ? t : null;
};
function W3(r, t) {
  const e = { ...t };
  for (const i in t) {
    const s = r[i], o = t[i];
    /^on[A-Z]/.test(i) ? s && o ? e[i] = (...a) => {
      const l = o(...a);
      return s(...a), l;
    } : s && (e[i] = s) : i === "style" ? e[i] = { ...s, ...o } : i === "className" && (e[i] = [s, o].filter(Boolean).join(" "));
  }
  return { ...r, ...e };
}
function G3(r) {
  let t = Object.getOwnPropertyDescriptor(r.props, "ref")?.get, e = t && "isReactWarning" in t && t.isReactWarning;
  return e ? r.ref : (t = Object.getOwnPropertyDescriptor(r, "ref")?.get, e = t && "isReactWarning" in t && t.isReactWarning, e ? r.props.ref : r.props.ref || r.ref);
}
function U3(r) {
  return Yt.isValidElement(r) && typeof r.type == "function" && "__radixId" in r.type && r.type.__radixId === B3;
}
var H3 = Symbol.for("react.lazy");
function py(r) {
  return r != null && typeof r == "object" && "$$typeof" in r && r.$$typeof === H3 && "_payload" in r && Y3(r._payload);
}
function Y3(r) {
  return typeof r == "object" && r !== null && "then" in r;
}
var j3 = (r) => `${r} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, $3 = (r) => `${r} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, iu = Yt[" use ".trim().toString()], X3 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], bh = X3.reduce((r, t) => {
  const e = /* @__PURE__ */ Bd(`Primitive.${t}`), i = Yt.forwardRef((s, o) => {
    const { asChild: n, ...a } = s, l = n ? e : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ X.jsx(l, { ...a, ref: o });
  });
  return i.displayName = `Primitive.${t}`, { ...r, [t]: i };
}, {});
function Z3(r) {
  const t = r + "CollectionProvider", [e, i] = L1(t), [s, o] = e(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), n = (g) => {
    const { scope: y, children: m } = g, A = Yt.useRef(null), v = Yt.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ X.jsx(s, { scope: y, itemMap: v, collectionRef: A, children: m });
  };
  n.displayName = t;
  const a = r + "CollectionSlot", l = /* @__PURE__ */ Bd(a), h = Yt.forwardRef(
    (g, y) => {
      const { scope: m, children: A } = g, v = o(a, m), b = Rn(y, v.collectionRef);
      return /* @__PURE__ */ X.jsx(l, { ref: b, children: A });
    }
  );
  h.displayName = a;
  const u = r + "CollectionItemSlot", c = "data-radix-collection-item", d = /* @__PURE__ */ Bd(u), f = Yt.forwardRef(
    (g, y) => {
      const { scope: m, children: A, ...v } = g, b = Yt.useRef(null), w = Rn(y, b), k = o(u, m);
      return Yt.useEffect(() => (k.itemMap.set(b, { ref: b, ...v }), () => void k.itemMap.delete(b))), /* @__PURE__ */ X.jsx(d, { [c]: "", ref: w, children: A });
    }
  );
  f.displayName = u;
  function p(g) {
    const y = o(r + "CollectionConsumer", g);
    return Yt.useCallback(() => {
      const A = y.collectionRef.current;
      if (!A) return [];
      const v = Array.from(A.querySelectorAll(`[${c}]`));
      return Array.from(y.itemMap.values()).sort(
        (k, R) => v.indexOf(k.ref.current) - v.indexOf(R.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: n, Slot: h, ItemSlot: f },
    p,
    i
  ];
}
var R1 = ["PageUp", "PageDown"], I1 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], V1 = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Qa = "Slider", [zd, K3, q3] = Z3(Qa), [a0] = L1(Qa, [
  q3
]), [J3, Eh] = a0(Qa), _1 = Yt.forwardRef(
  (r, t) => {
    const {
      name: e,
      min: i = 0,
      max: s = 100,
      step: o = 1,
      orientation: n = "horizontal",
      disabled: a = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: h = [i],
      value: u,
      onValueChange: c = () => {
      },
      onValueCommit: d = () => {
      },
      inverted: f = !1,
      form: p,
      ...g
    } = r, y = Yt.useRef(/* @__PURE__ */ new Set()), m = Yt.useRef(0), A = Yt.useRef(!1), b = n === "horizontal" ? Q3 : tT, [w, k] = Yt.useState(null), R = Rn(t, k), [L = [], x] = P3({
      prop: u,
      defaultProp: h,
      onChange: (F) => {
        [...y.current][m.current]?.focus({
          preventScroll: !0,
          focusVisible: A.current
        }), A.current = !1, c(F);
      }
    }), M = Yt.useRef(L), C = Yt.useRef(L);
    Yt.useEffect(() => {
      const F = p ? w?.ownerDocument.getElementById(p) : w?.closest("form");
      if (F instanceof HTMLFormElement) {
        const D = () => x(C.current);
        return F.addEventListener("reset", D), () => F.removeEventListener("reset", D);
      }
    }, [w, p, x]);
    function S(F) {
      const D = rT(L, F);
      I(F, D);
    }
    function E(F) {
      I(F, m.current);
    }
    function T() {
      const F = M.current[m.current];
      L[m.current] !== F && d(L);
    }
    function I(F, D, { commit: P } = { commit: !1 }) {
      const V = J1(o), _ = pu(Math.round((F - i) / o) * o + i, V), O = F1(_, [i, s]);
      x((B = []) => {
        const z = iT(B, O, D);
        if (aT(z, l * o)) {
          m.current = z.indexOf(O);
          const W = String(z) !== String(B);
          return W && P && d(z), W ? z : B;
        } else
          return B;
      });
    }
    return /* @__PURE__ */ X.jsx(
      J3,
      {
        scope: r.__scopeSlider,
        name: e,
        disabled: a,
        min: i,
        max: s,
        valueIndexToChangeRef: m,
        thumbs: y.current,
        values: L,
        orientation: n,
        form: p,
        children: /* @__PURE__ */ X.jsx(zd.Provider, { scope: r.__scopeSlider, children: /* @__PURE__ */ X.jsx(zd.Slot, { scope: r.__scopeSlider, children: /* @__PURE__ */ X.jsx(
          b,
          {
            "aria-disabled": a,
            "data-disabled": a ? "" : void 0,
            ...g,
            ref: R,
            onPointerDown: ia(g.onPointerDown, () => {
              a || (M.current = L, A.current = !1);
            }),
            min: i,
            max: s,
            inverted: f,
            onSlideStart: a ? void 0 : S,
            onSlideMove: a ? void 0 : E,
            onSlideEnd: a ? void 0 : T,
            onHomeKeyDown: () => {
              a || (A.current = !0, I(i, 0, { commit: !0 }));
            },
            onEndKeyDown: () => {
              a || (A.current = !0, I(s, L.length - 1, { commit: !0 }));
            },
            onStepKeyDown: ({ event: F, direction: D }) => {
              if (!a) {
                A.current = !0;
                const _ = R1.includes(F.key) || F.shiftKey && I1.includes(F.key) ? 10 : 1, O = m.current, B = L[O], z = lT(B, {
                  min: i,
                  step: o,
                  direction: D,
                  multiplier: _
                });
                I(z, O, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
_1.displayName = Qa;
var [O1, N1] = a0(Qa, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Q3 = Yt.forwardRef(
  (r, t) => {
    const {
      min: e,
      max: i,
      dir: s,
      inverted: o,
      onSlideStart: n,
      onSlideMove: a,
      onSlideEnd: l,
      onStepKeyDown: h,
      ...u
    } = r, [c, d] = Yt.useState(null), f = Rn(t, d), p = Yt.useRef(void 0), g = _3(s), y = g === "ltr", m = y && !o || !y && o;
    function A(v) {
      const b = p.current || c.getBoundingClientRect(), w = [0, b.width], R = l0(w, m ? [e, i] : [i, e]);
      return p.current = b, R(v - b.left);
    }
    return /* @__PURE__ */ X.jsx(
      O1,
      {
        scope: r.__scopeSlider,
        startEdge: m ? "left" : "right",
        endEdge: m ? "right" : "left",
        direction: m ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ X.jsx(
          B1,
          {
            dir: g,
            "data-orientation": "horizontal",
            ...u,
            ref: f,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (v) => {
              const b = A(v.clientX);
              n?.(b);
            },
            onSlideMove: (v) => {
              const b = A(v.clientX);
              a?.(b);
            },
            onSlideEnd: () => {
              p.current = void 0, l?.();
            },
            onStepKeyDown: (v) => {
              const w = V1[m ? "from-left" : "from-right"].includes(v.key);
              h?.({ event: v, direction: w ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), tT = Yt.forwardRef(
  (r, t) => {
    const {
      min: e,
      max: i,
      inverted: s,
      onSlideStart: o,
      onSlideMove: n,
      onSlideEnd: a,
      onStepKeyDown: l,
      ...h
    } = r, u = Yt.useRef(null), c = Rn(t, u), d = Yt.useRef(void 0), f = !s;
    function p(g) {
      const y = d.current || u.current.getBoundingClientRect(), m = [0, y.height], v = l0(m, f ? [i, e] : [e, i]);
      return d.current = y, v(g - y.top);
    }
    return /* @__PURE__ */ X.jsx(
      O1,
      {
        scope: r.__scopeSlider,
        startEdge: f ? "bottom" : "top",
        endEdge: f ? "top" : "bottom",
        size: "height",
        direction: f ? 1 : -1,
        children: /* @__PURE__ */ X.jsx(
          B1,
          {
            "data-orientation": "vertical",
            ...h,
            ref: c,
            style: {
              ...h.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (g) => {
              const y = p(g.clientY);
              o?.(y);
            },
            onSlideMove: (g) => {
              const y = p(g.clientY);
              n?.(y);
            },
            onSlideEnd: () => {
              d.current = void 0, a?.();
            },
            onStepKeyDown: (g) => {
              const m = V1[f ? "from-bottom" : "from-top"].includes(g.key);
              l?.({ event: g, direction: m ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), B1 = Yt.forwardRef(
  (r, t) => {
    const {
      __scopeSlider: e,
      onSlideStart: i,
      onSlideMove: s,
      onSlideEnd: o,
      onHomeKeyDown: n,
      onEndKeyDown: a,
      onStepKeyDown: l,
      ...h
    } = r, u = Eh(Qa, e);
    return /* @__PURE__ */ X.jsx(
      bh.span,
      {
        ...h,
        ref: t,
        onKeyDown: ia(r.onKeyDown, (c) => {
          c.key === "Home" ? (n(c), c.preventDefault()) : c.key === "End" ? (a(c), c.preventDefault()) : R1.concat(I1).includes(c.key) && (l(c), c.preventDefault());
        }),
        onPointerDown: ia(r.onPointerDown, (c) => {
          const d = c.target;
          d.setPointerCapture(c.pointerId), c.preventDefault(), u.thumbs.has(d) ? d.focus({ preventScroll: !0, focusVisible: !1 }) : i(c);
        }),
        onPointerMove: ia(r.onPointerMove, (c) => {
          c.target.hasPointerCapture(c.pointerId) && s(c);
        }),
        onPointerUp: ia(r.onPointerUp, (c) => {
          const d = c.target;
          d.hasPointerCapture(c.pointerId) && (d.releasePointerCapture(c.pointerId), o(c));
        })
      }
    );
  }
), z1 = "SliderTrack", W1 = Yt.forwardRef(
  (r, t) => {
    const { __scopeSlider: e, ...i } = r, s = Eh(z1, e);
    return /* @__PURE__ */ X.jsx(
      bh.span,
      {
        "data-disabled": s.disabled ? "" : void 0,
        "data-orientation": s.orientation,
        ...i,
        ref: t
      }
    );
  }
);
W1.displayName = z1;
var Wd = "SliderRange", G1 = Yt.forwardRef(
  (r, t) => {
    const { __scopeSlider: e, ...i } = r, s = Eh(Wd, e), o = N1(Wd, e), n = Yt.useRef(null), a = Rn(t, n), l = s.values.length, h = s.values.map(
      (d) => q1(d, s.min, s.max)
    ), u = l > 1 ? Math.min(...h) : 0, c = 100 - Math.max(...h);
    return /* @__PURE__ */ X.jsx(
      bh.span,
      {
        "data-orientation": s.orientation,
        "data-disabled": s.disabled ? "" : void 0,
        ...i,
        ref: a,
        style: {
          ...r.style,
          [o.startEdge]: u + "%",
          [o.endEdge]: c + "%"
        }
      }
    );
  }
);
G1.displayName = Wd;
var U1 = "SliderThumb", [eT, H1] = a0(U1), Y1 = "SliderThumbProvider";
function j1(r) {
  const {
    __scopeSlider: t,
    name: e,
    children: i,
    // @ts-expect-error internal render prop
    internal_do_not_use_render: s
  } = r, o = Eh(Y1, t), n = K3(t), [a, l] = Yt.useState(null), h = Yt.useMemo(
    () => a ? n().findIndex((y) => y.ref.current === a) : -1,
    [n, a]
  ), u = N3(a), c = a ? !!o.form || !!a.closest("form") : !0, d = o.values[h], f = e ?? (o.name ? o.name + (o.values.length > 1 ? "[]" : "") : void 0), p = d === void 0 ? 0 : q1(d, o.min, o.max);
  Yt.useEffect(() => {
    if (a)
      return o.thumbs.add(a), () => {
        o.thumbs.delete(a);
      };
  }, [a, o.thumbs]);
  const g = {
    value: d,
    name: f,
    form: o.form,
    isFormControl: c,
    index: h,
    thumb: a,
    onThumbChange: l,
    percent: p,
    size: u
  };
  return /* @__PURE__ */ X.jsx(eT, { scope: t, ...g, children: hT(s) ? s(g) : i });
}
j1.displayName = Y1;
var gu = "SliderThumbTrigger", $1 = Yt.forwardRef(
  (r, t) => {
    const { __scopeSlider: e, ...i } = r, s = Eh(gu, e), o = N1(gu, e), { index: n, value: a, percent: l, size: h, onThumbChange: u } = H1(
      gu,
      e
    ), c = Rn(t, u), d = sT(n, s.values.length), f = h?.[o.size], p = f ? nT(f, l, o.direction) : 0;
    return /* @__PURE__ */ X.jsx(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [o.startEdge]: `calc(${l}% + ${p}px)`
        },
        children: /* @__PURE__ */ X.jsx(zd.ItemSlot, { scope: e, children: /* @__PURE__ */ X.jsx(
          bh.span,
          {
            role: "slider",
            "aria-label": r["aria-label"] || d,
            "aria-valuemin": s.min,
            "aria-valuenow": a,
            "aria-valuemax": s.max,
            "aria-orientation": s.orientation,
            "data-orientation": s.orientation,
            "data-disabled": s.disabled ? "" : void 0,
            tabIndex: s.disabled ? void 0 : 0,
            ...i,
            ref: c,
            style: a === void 0 ? { display: "none" } : r.style,
            onFocus: ia(r.onFocus, () => {
              s.valueIndexToChangeRef.current = n;
            })
          }
        ) })
      }
    );
  }
);
$1.displayName = gu;
var X1 = Yt.forwardRef(
  (r, t) => {
    const { __scopeSlider: e, name: i, ...s } = r;
    return /* @__PURE__ */ X.jsx(
      j1,
      {
        __scopeSlider: e,
        name: i,
        internal_do_not_use_render: ({ index: o, isFormControl: n }) => /* @__PURE__ */ X.jsxs(X.Fragment, { children: [
          /* @__PURE__ */ X.jsx(
            $1,
            {
              ...s,
              ref: t,
              __scopeSlider: e
            }
          ),
          n ? /* @__PURE__ */ X.jsx(
            K1,
            {
              __scopeSlider: e
            },
            o
          ) : null
        ] })
      }
    );
  }
);
X1.displayName = U1;
var Z1 = "SliderBubbleInput", K1 = Yt.forwardRef(
  ({ __scopeSlider: r, ...t }, e) => {
    const { value: i, name: s, form: o } = H1(Z1, r), n = Yt.useRef(null), a = Rn(n, e), l = O3(i);
    return Yt.useEffect(() => {
      const h = n.current;
      if (!h) return;
      const u = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(u, "value").set;
      if (l !== i && d) {
        const f = new Event("input", { bubbles: !0 });
        d.call(h, i), h.dispatchEvent(f);
      }
    }, [l, i]), /* @__PURE__ */ X.jsx(
      bh.input,
      {
        style: { display: "none" },
        name: s,
        form: o,
        ...t,
        ref: a,
        defaultValue: i
      }
    );
  }
);
K1.displayName = Z1;
function iT(r = [], t, e) {
  const i = [...r];
  return i[e] = t, i.sort((s, o) => s - o);
}
function q1(r, t, e) {
  const o = 100 / (e - t) * (r - t);
  return F1(o, [0, 100]);
}
function sT(r, t) {
  return t > 2 ? `Value ${r + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][r] : void 0;
}
function rT(r, t) {
  if (r.length === 1) return 0;
  const e = r.map((s) => Math.abs(s - t)), i = Math.min(...e);
  return e.indexOf(i);
}
function nT(r, t, e) {
  const i = r / 2, o = l0([0, 50], [0, i]);
  return (i - o(t) * e) * e;
}
function oT(r) {
  return r.slice(0, -1).map((t, e) => r[e + 1] - t);
}
function aT(r, t) {
  if (t > 0) {
    const e = oT(r);
    return Math.min(...e) >= t;
  }
  return !0;
}
function l0(r, t) {
  return (e) => {
    if (r[0] === r[1] || t[0] === t[1]) return t[0];
    const i = (t[1] - t[0]) / (r[1] - r[0]);
    return t[0] + i * (e - r[0]);
  };
}
function J1(r) {
  if (!Number.isFinite(r)) return 0;
  const t = r.toString();
  if (t.includes("e")) {
    const [i, s] = t.split("e"), o = i.split(".")[1] || "", n = Number(s);
    return Math.max(0, o.length - n);
  }
  const e = t.split(".")[1];
  return e ? e.length : 0;
}
function pu(r, t) {
  const e = Math.pow(10, t);
  return Math.round(r * e) / e;
}
function lT(r, {
  min: t,
  step: e,
  direction: i,
  multiplier: s
}) {
  const o = J1(e), n = (r - t) / e, a = Math.round(n), l = pu(a * e + t, o) === pu(r, o);
  let h;
  return l ? h = a + s * i : i > 0 ? h = Math.ceil(n) : h = Math.floor(n), pu(h * e + t, o);
}
function hT(r) {
  return typeof r == "function";
}
const yu = 10, uT = Array.from({ length: 9 }, (r, t) => t + 1), cT = ({
  value: r,
  onChange: t
}) => /* @__PURE__ */ X.jsxs("div", { className: "event-editor__height-control", children: [
  /* @__PURE__ */ X.jsxs("div", { className: "event-editor__height-header", children: [
    /* @__PURE__ */ X.jsx("span", { children: "Height" }),
    /* @__PURE__ */ X.jsxs("span", { children: [
      r,
      "%"
    ] })
  ] }),
  /* @__PURE__ */ X.jsxs(
    _1,
    {
      className: "event-editor__height-slider",
      value: [r],
      min: 0,
      max: 100,
      step: yu,
      onValueChange: ([e]) => {
        e !== void 0 && t(Math.max(yu, e));
      },
      children: [
        /* @__PURE__ */ X.jsxs(W1, { className: "event-editor__height-track", children: [
          /* @__PURE__ */ X.jsx(G1, { className: "event-editor__height-fill" }),
          /* @__PURE__ */ X.jsx("div", { className: "event-editor__height-marks", children: uT.map((e) => {
            const i = e * yu, s = i <= r;
            return /* @__PURE__ */ X.jsx(
              "span",
              {
                className: Jl("event-editor__height-mark", {
                  "event-editor__height-mark--active": s
                }),
                style: { left: `calc(${i}% - 3px)` }
              },
              i
            );
          }) })
        ] }),
        /* @__PURE__ */ X.jsx(
          X1,
          {
            className: "event-editor__height-thumb",
            "aria-label": "Event height"
          }
        )
      ]
    }
  )
] }), dT = (r) => String(r).padStart(2, "0"), Jc = (r, t, e) => {
  if (r.length < 2) return r;
  const i = Number(r);
  return Number.isFinite(i) ? dT(Math.min(e, Math.max(t, i))) : r;
}, fT = (r) => {
  const t = r.replace(/\D/g, "").slice(0, 6);
  return [
    Jc(t.slice(0, 2), 0, 23),
    Jc(t.slice(2, 4), 0, 59),
    Jc(t.slice(4, 6), 0, 59)
  ].filter(Boolean).join(":");
}, gT = (r) => {
  r.ctrlKey || r.metaKey || r.altKey || [
    "Backspace",
    "Delete",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
    "Enter"
  ].includes(r.key) || /^\d$/.test(r.key) || r.preventDefault();
}, yy = ({
  label: r,
  value: t,
  ariaLabel: e,
  onChange: i,
  onCommit: s
}) => /* @__PURE__ */ X.jsxs("label", { className: "event-editor__time-group", children: [
  /* @__PURE__ */ X.jsx("span", { children: r }),
  /* @__PURE__ */ X.jsx(
    "input",
    {
      className: "event-editor__time-input",
      value: t,
      placeholder: "hh:mm:ss",
      inputMode: "numeric",
      maxLength: 8,
      onKeyDown: (o) => {
        gT(o), o.key === "Enter" && s();
      },
      onChange: (o) => i(fT(o.target.value)),
      onBlur: s,
      "aria-label": e
    }
  )
] }), Gd = [
  { label: "Bottom", value: 0, topPx: 23 },
  { label: "Low", value: 0.25, topPx: 18 },
  { label: "Center", value: 0.5, topPx: 13 },
  { label: "High", value: 0.75, topPx: 8 },
  { label: "Top", value: 1, topPx: 4 }
], pT = (r) => Gd.reduce(
  (t, e) => Math.abs(e.value - r) < Math.abs(t.value - r) ? e : t,
  Gd[0]
), yT = ({ onChange: r, selectedEvent: t }) => {
  const e = t ? S1(t) : 0.5, i = pT(e);
  return /* @__PURE__ */ X.jsxs("div", { className: "event-editor__vertical-control", children: [
    /* @__PURE__ */ X.jsxs("div", { className: "event-editor__vertical-header", children: [
      /* @__PURE__ */ X.jsx("span", { children: "Vertical position" }),
      /* @__PURE__ */ X.jsx("span", { children: i.label })
    ] }),
    /* @__PURE__ */ X.jsx("div", { className: "event-editor__vertical-options", children: Gd.map((s) => {
      const o = s.value === i.value;
      return /* @__PURE__ */ X.jsx(
        "button",
        {
          type: "button",
          className: Jl("event-editor__vertical-option", {
            "event-editor__vertical-option--active": o
          }),
          "aria-label": `Set vertical position to ${s.label}`,
          "aria-pressed": o,
          onClick: () => r(s.value),
          children: /* @__PURE__ */ X.jsx(
            "span",
            {
              className: "event-editor__vertical-option-mark",
              style: { top: s.topPx }
            }
          )
        },
        s.value
      );
    }) })
  ] });
}, Qc = (r) => String(r).padStart(2, "0"), su = (r) => {
  const t = new Date(r);
  return [
    Qc(t.getHours()),
    Qc(t.getMinutes()),
    Qc(t.getSeconds())
  ].join(":");
}, my = (r, t, e) => {
  if (!/^\d{2}:\d{2}:\d{2}$/.test(r)) return null;
  const [i, s, o] = r.split(":").map(Number), n = new Date(t);
  return [
    new Date(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      i,
      s,
      o
    ).getTime(),
    new Date(
      n.getFullYear(),
      n.getMonth(),
      n.getDate() + 1,
      i,
      s,
      o
    ).getTime()
  ].find(
    (l) => l >= t && l <= e
  ) ?? null;
}, mT = (r, t) => {
  const e = Math.max(0, Math.round((t - r) / 1e3)), i = Math.floor(e / 60), s = e % 60;
  return `${i}:${String(s).padStart(2, "0")}`;
}, xT = ({
  mode: r,
  selectedEvent: t,
  selectedCreateType: e,
  intervalStartMs: i,
  intervalEndMs: s,
  channels: o,
  onModeChange: n,
  onCreateTypeChange: a,
  onUpdateSelectedTime: l,
  onUpdateSelectedHeight: h,
  onUpdateSelectedVerticalPosition: u,
  onUpdateSelectedColor: c,
  onPushSelectedChangesToEventType: d,
  onResetSelectedEventType: f,
  onDeleteSelected: p,
  onClearSelected: g
}) => {
  const [y, m] = ze(""), [A, v] = ze("");
  mi(() => {
    if (!t) {
      m(""), v("");
      return;
    }
    m(su(t.startMs)), v(su(t.endMs));
  }, [t]);
  const b = Array.from(
    new Map(
      o.flatMap(
        (R) => R.events.map((L) => [
          L.type,
          L.config.label || L.type
        ])
      )
    ).entries()
  ).sort((R, L) => R[1].localeCompare(L[1])), w = () => {
    if (!t) return;
    const R = my(
      y,
      i,
      s
    ), L = my(
      A,
      i,
      s
    );
    if (R === null || L === null || L <= R) {
      m(su(t.startMs)), v(su(t.endMs));
      return;
    }
    l(R, L);
  }, k = t ? BC(t, yu) : 0;
  return /* @__PURE__ */ X.jsxs("div", { className: "event-editor", children: [
    /* @__PURE__ */ X.jsx("div", { className: "event-editor__header", children: /* @__PURE__ */ X.jsx("span", { className: "event-editor__title", children: "EVENT EDITOR" }) }),
    /* @__PURE__ */ X.jsxs("div", { className: "event-editor__mode", children: [
      /* @__PURE__ */ X.jsx(
        "button",
        {
          type: "button",
          className: Jl({
            "event-editor__mode-btn--active": r === "select"
          }),
          onClick: () => n("select"),
          children: "Edit"
        }
      ),
      /* @__PURE__ */ X.jsx(
        "button",
        {
          type: "button",
          className: Jl({
            "event-editor__mode-btn--active": r === "create"
          }),
          onClick: () => n("create"),
          children: "Add"
        }
      )
    ] }),
    r === "create" ? /* @__PURE__ */ X.jsxs("div", { className: "event-editor__section", children: [
      /* @__PURE__ */ X.jsxs("label", { className: "event-editor__label", children: [
        "Event type",
        /* @__PURE__ */ X.jsx(
          "select",
          {
            className: "event-editor__select",
            value: e,
            onChange: (R) => a(R.target.value),
            children: b.map(([R, L]) => /* @__PURE__ */ X.jsx("option", { value: R, children: L }, R))
          }
        )
      ] }),
      /* @__PURE__ */ X.jsx("p", { className: "event-editor__hint", children: "Drag over the chart to create an event interval of the selected type." })
    ] }) : /* @__PURE__ */ X.jsx("div", { className: "event-editor__section", children: t ? /* @__PURE__ */ X.jsxs(X.Fragment, { children: [
      /* @__PURE__ */ X.jsx("div", { className: "event-editor__selected-name", children: t.eventName }),
      /* @__PURE__ */ X.jsxs("div", { className: "event-editor__time-range", children: [
        /* @__PURE__ */ X.jsx(
          yy,
          {
            label: "Start",
            value: y,
            ariaLabel: "Event start time",
            onChange: m,
            onCommit: w
          }
        ),
        /* @__PURE__ */ X.jsx("span", { className: "event-editor__range-separator", children: "-" }),
        /* @__PURE__ */ X.jsx(
          yy,
          {
            label: "End",
            value: A,
            ariaLabel: "Event end time",
            onChange: v,
            onCommit: w
          }
        )
      ] }),
      /* @__PURE__ */ X.jsx("dl", { className: "event-editor__details", children: /* @__PURE__ */ X.jsxs("div", { children: [
        /* @__PURE__ */ X.jsx("dt", { children: "Duration" }),
        /* @__PURE__ */ X.jsx("dd", { children: mT(t.startMs, t.endMs) })
      ] }) }),
      /* @__PURE__ */ X.jsxs("div", { className: "event-editor__visual-controls", children: [
        /* @__PURE__ */ X.jsx(
          cT,
          {
            value: k,
            onChange: h
          }
        ),
        /* @__PURE__ */ X.jsx(
          yT,
          {
            selectedEvent: t,
            onChange: u
          }
        ),
        /* @__PURE__ */ X.jsx(
          b3,
          {
            value: t.fillColor ?? "#FFCC66",
            onChange: c
          }
        )
      ] }),
      /* @__PURE__ */ X.jsx(
        k3,
        {
          onPushChanges: d,
          onReset: f,
          onClearSelection: g,
          onDelete: p
        }
      )
    ] }) : /* @__PURE__ */ X.jsx("p", { className: "event-editor__hint", children: "Click an event rectangle. Drag its body to move it, or drag near the left/right/top/bottom edge to resize." }) })
  ] });
}, Q1 = "custom:", xy = (r) => r.startsWith(Q1), vy = (r) => r.map((t) => ({ ...t })), vT = (r, t, e) => {
  const i = Object.keys(e).length > 0;
  if (t.length === 0 && !i) return r;
  const s = new Map(
    r.flatMap(
      (o) => o.events.map((n) => [n.type, n.config])
    )
  );
  return r.map((o) => {
    const n = o.events.map((l) => ({
      ...l,
      data: ST(l.data, e)
    })), a = t.filter(
      (l) => l.channelId === o.id
    );
    for (const l of a) {
      const h = n.find(
        (c) => c.type === l.eventType
      ), u = AT(l);
      if (h) {
        h.data = [...h.data ?? [], u].sort(
          (c, d) => c.x1 - d.x1
        );
        continue;
      }
      n.push({
        type: l.eventType,
        config: s.get(l.eventType) ?? {
          label: l.eventName,
          fillColor: "#FFCC66",
          borderColor: "#8A6D2A",
          relativeHeight: 0.8
        },
        data: [u]
      });
    }
    return { ...o, events: n };
  });
}, ST = (r, t) => r?.map((e) => ({
  ...e,
  ...e.eventKey ? t[e.eventKey] : void 0
})), AT = (r) => ({
  x1: r.startMs,
  x2: r.endMs,
  y1: r.y1,
  y2: r.y2,
  isAlarm: r.isAlarm,
  fillColor: r.fillColor,
  eventKey: r.eventKey,
  eventType: r.eventType
}), bT = "5.7.5", ET = 100, MT = 0, CT = 260, wT = 300, TT = 200, kT = "Comp 1", DT = 0, FT = [{ id: "0", layers: [{ ddd: 0, ind: 1, ty: 4, sr: 1, ks: { p: { a: 0, k: [-15, -62], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "sh", d: 1, ks: { a: 0, k: { c: !0, v: [[0, 0], [59, 0], [59, 105.28], [0, 105.28], [0, 0], [0, 0]], i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]] } } }, { ty: "gf", o: { a: 0, k: 100, ix: 2 }, r: 1, bm: 0, g: { p: 2, k: { a: 1, k: [{ t: 0, s: [0, 0, 0.67, 1, 1, 0, 0.67, 1, 0, 1, 1, 0], i: { x: [0.6850000023841858], y: [0.9950000047683716] }, o: { x: [0.29499998688697815], y: [0.004999999888241291] } }, { t: 220, s: [0, 0, 0.67, 1, 1, 0, 0.67, 1, 0, 1, 1, 0], i: { x: [0.75], y: [0.75] }, o: { x: [0.25], y: [0.25] } }, { t: 260, s: [0, 0, 0.67, 1, 1, 0, 0.67, 1, 0, 1, 1, 0] }], ix: 2 } }, s: { a: 0, k: [59, 42], ix: 2 }, e: { a: 0, k: [0, 41.5], ix: 2 }, t: 1 }, { ty: "tr", p: { a: 1, k: [{ t: 0, s: [-13.5, 102.31], i: { x: [0.6850000023841858], y: [0.9950000047683716] }, o: { x: [0.29499998688697815], y: [0.004999999888241291] } }, { t: 220, s: [216.5, 100.31], i: { x: [0.75], y: [0.75] }, o: { x: [0.25], y: [0.25] } }, { t: 260, s: [216.5, 100.31] }], ix: 2 }, a: { a: 0, k: [29.5, 52.64], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }] }], ip: 0, op: 261, st: 0 }, { ddd: 0, ind: 2, ty: 4, sr: 1, ks: { p: { a: 0, k: [-15, -62], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }, ao: 0, shapes: [{ ty: "rc", d: 1, s: { a: 0, k: [170, 79], ix: 2 }, p: { a: 0, k: [100, 101.5], ix: 2 }, r: { a: 0, k: 0, ix: 2 } }, { ty: "fl", c: { a: 0, k: [0, 0, 0], ix: 2 }, o: { a: 0, k: 0, ix: 2 }, r: 1, bm: 0 }], ip: 0, op: 261, st: 0 }] }, { id: "1", layers: [{ ddd: 0, ind: 3, ty: 4, sr: 1, ks: { p: { a: 0, k: [-15, -62], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }, td: 1, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "gr", it: [{ ty: "sh", d: 1, ks: { a: 0, k: { c: !1, v: [[0, 60.28], [7.95, 64.66], [21.08, 45.64], [30, 61.5], [44.6, 69.4], [54.85, 53.84], [66.96, 56.18], [76.08, 23.46], [83, 44], [92.8, 28.9], [100.16, 63.54], [107.91, 36.58], [116.56, 20.74], [125, 26], [133.2, -0.42], [139.92, 24.82], [148.67, 15.46], [155.85, 6.7], [161, 0]], i: [[0, 0], [-4.37, -0.9], [-4.87, -2.32], [-4.36, 2.32], [-4.87, -0.52], [-1.54, 4.89], [-5.64, 0.77], [-4, 3], [-3.08, -2.58], [-2.56, 2.06], [-3.59, -0.77], [-2.15, 5.24], [-4.61, -0.52], [-3.84, 3.09], [-3.34, 0.18], [-3.59, 2.06], [-4.87, 0.52], [-1.28, 3.86], [-4, 0]], o: [[4.5, 0], [4.05, 0.84], [4.87, 2.32], [4.36, -2.32], [4.87, 0.52], [1.54, -4.89], [5.64, -0.77], [3.72, -2.79], [3.08, 2.58], [2.56, -2.06], [3.59, 0.77], [2.09, -5.08], [4.61, 0.52], [3.84, -3.09], [3.45, -0.19], [3.59, -2.06], [4.87, -0.52], [1.03, -3.09], [0, 0]] } } }, { ty: "st", c: { a: 0, k: [1, 1, 1], ix: 2 }, o: { a: 0, k: 100, ix: 2 }, w: { a: 0, k: 2, ix: 2 }, lc: 2, lj: 1, ml: 4 }, { ty: "tr", o: { a: 0, k: 100, ix: 2 } }] }, { ty: "tr", p: { a: 0, k: [99.5, 99.67], ix: 2 }, a: { a: 0, k: [80.5, 32.67], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }] }], ip: 0, op: 261, st: 0 }, { ddd: 0, refId: "0", w: 170, h: 79, ind: 4, ty: 0, sr: 1, ks: { p: { a: 0, k: [100, 101.5], ix: 2 }, a: { a: 0, k: [100, 101.5], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }, ao: 0, ip: 0, op: 261, st: 0, tt: 1 }] }, { id: "2", layers: [{ ddd: 0, ind: 5, ty: 4, sr: 1, ks: { p: { a: 0, k: [3, 3], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "sh", d: 1, ks: { a: 0, k: { c: !1, v: [[0, 60.28], [7.95, 64.66], [21.08, 45.64], [30, 61.5], [44.6, 69.4], [54.85, 53.84], [66.96, 56.18], [76.08, 23.46], [83, 44], [92.8, 28.9], [100.16, 63.54], [107.91, 36.58], [116.56, 20.74], [125, 26], [133.2, -0.42], [139.92, 24.82], [148.67, 15.46], [155.85, 6.7], [161, 0]], i: [[0, 0], [-4.37, -0.9], [-4.87, -2.32], [-4.36, 2.32], [-4.87, -0.52], [-1.54, 4.89], [-5.64, 0.77], [-4, 3], [-3.08, -2.58], [-2.56, 2.06], [-3.59, -0.77], [-2.15, 5.24], [-4.61, -0.52], [-3.84, 3.09], [-3.34, 0.18], [-3.59, 2.06], [-4.87, 0.52], [-1.28, 3.86], [-4, 0]], o: [[4.5, 0], [4.05, 0.84], [4.87, 2.32], [4.36, -2.32], [4.87, 0.52], [1.54, -4.89], [5.64, -0.77], [3.72, -2.79], [3.08, 2.58], [2.56, -2.06], [3.59, 0.77], [2.09, -5.08], [4.61, 0.52], [3.84, -3.09], [3.45, -0.19], [3.59, -2.06], [4.87, -0.52], [1.03, -3.09], [0, 0]] } } }, { ty: "st", c: { a: 0, k: [0.326, 0.695, 0.875], ix: 2 }, o: { a: 0, k: 100, ix: 2 }, w: { a: 0, k: 1, ix: 2 }, lc: 2, lj: 1, ml: 4 }, { ty: "tr", o: { a: 0, k: 100, ix: 2 } }] }], ip: 0, op: 261, st: 0 }, { ddd: 0, ind: 6, ty: 4, sr: 1, ks: { p: { a: 0, k: [3, 3], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }, ao: 0, hd: !0, shapes: [], ip: 0, op: 261, st: 0 }] }], LT = [{ ddd: 0, ind: 7, ty: 3, sr: 1, ks: { p: { a: 0, k: [-11.65, -64.9], ix: 2 }, s: { a: 0, k: [162.46, 162.46], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }, ao: 0, ip: 0, op: 261, st: 0 }, { ddd: 0, refId: "1", w: 170, h: 79, ind: 4, ty: 0, sr: 1, ks: { p: { a: 0, k: [15, 62], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }, ao: 0, ip: 0, op: 261, st: 0, parent: 7 }, { ddd: 0, ind: 8, ty: 3, sr: 1, ks: { p: { a: 0, k: [19.22, 43.95], ix: 2 }, s: { a: 0, k: [162.46, 162.46], ix: 2 }, o: { a: 0, k: 100, ix: 2 } }, ao: 0, ip: 0, op: 261, st: 0 }, { ddd: 0, refId: "2", w: 167, h: 75, ind: 9, ty: 0, sr: 1, ks: { p: { a: 0, k: [-3, -3], ix: 2 }, o: { a: 1, k: [{ t: 0, s: [0], i: { x: [0.6850000023841858], y: [0.9950000047683716] }, o: { x: [0.29499998688697815], y: [0.004999999888241291] } }, { t: 220, s: [20], i: { x: [0.75], y: [0.75] }, o: { x: [0.25], y: [0.25] } }, { t: 260, s: [0] }], ix: 2 } }, ao: 0, ip: 0, op: 261, st: 0, parent: 8 }], PT = [], RT = {
  v: bT,
  fr: ET,
  ip: MT,
  op: CT,
  w: wT,
  h: TT,
  nm: kT,
  ddd: DT,
  assets: FT,
  layers: LT,
  markers: PT
}, IT = ({ width: r = 300 }) => /* @__PURE__ */ X.jsx(
  av,
  {
    animationData: RT,
    loop: !0,
    autoplay: !0,
    role: "status",
    "aria-label": "Loading",
    style: { width: r, height: r * 2 / 3 }
  }
), VT = ({ visible: r }) => r ? /* @__PURE__ */ X.jsx(
  "div",
  {
    style: {
      position: "absolute",
      inset: 0,
      background: "rgba(255,255,255,0.6)",
      backdropFilter: "blur(2px)",
      zIndex: 1e3,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "all"
    },
    children: /* @__PURE__ */ X.jsx(IT, { width: 180 })
  }
) : null;
var tv = /* @__PURE__ */ ((r) => (r.TherapyDay = "TherapyDay", r.CalendarDay = "CalendarDay", r))(tv || {});
const _T = Ql.forwardRef(
  ({
    providedConfigs: r,
    globalEvents: t,
    data: e,
    selectedDayMs: i,
    size: s,
    enableSplitScreen: o = !1,
    enableResize: n,
    onSuccess: a,
    onParseProgress: l,
    therapyTimeInterval: h,
    containerClassName: u,
    toolbarExtension: c,
    onZoomIntervalChange: d,
    onChannelDelete: f,
    hiddenChannelIds: p,
    onChannelVisibilityToggle: g,
    onParseError: y,
    onEventTypeVisualsApplied: m,
    onChannelsReorder: A
  }, v) => {
    const [b, w] = ze([]), [k, R] = ze([]), [L, x] = ze(
      () => vy(e.events)
    ), [M, C] = ze([]), [S, E] = ze({}), [T, I] = ze("select"), [F, D] = ze(null), [P, V] = ze(""), [_, O] = ze(null), [B, z] = ze(null), W = (At) => {
      w(At), a?.(At);
    };
    mi(() => {
      x(vy(e.events)), C([]), E({}), D(null);
    }, [e.events]);
    const G = ni(
      () => ({
        ...e,
        events: L
      }),
      [e, L]
    ), { channels: Y, parseErrors: U, therapySettings: $, limits: Z } = mv(
      r ?? [],
      G,
      W,
      l
    ), q = ni(
      () => (t ?? []).map((At) => ({
        ...At,
        data: e.events.filter(
          (yt) => yt.eventType === At.type
        )
      })),
      [t, e.events]
    ), Q = ni(() => vT(
      Y,
      M,
      S
    ), [Y, M, S]);
    mi(() => {
      U.length > 0 && y?.(U);
    }, [U]), mi(() => {
      R(Q);
    }, [Q]), mi(() => {
      const At = Y.flatMap((yt) => yt.events).map((yt) => yt.type);
      P && At.includes(P) || V(At[0] ?? "");
    }, [Y, P]);
    const nt = ni(() => `therapy-chart-${id()}`, []), et = Ei(null), it = Ei(null), rt = Ei(null), tt = Ei(null), [at, ut] = ze(), ht = Fi(
      () => et.current?.getViewState() ?? {
        interval: null,
        hiddenChannelIds: [...p ?? []],
        orderedChannelIds: Q.map(
          (At) => At.id
        ),
        visibleChannelHeights: /* @__PURE__ */ new Map(),
        manualHeightOffsetPx: 0
      },
      [Q, p]
    );
    by(() => {
      if (!o) {
        ut(void 0);
        return;
      }
      ut((At) => At ?? ht());
    }, [ht, o]);
    const st = Fi(
      (At) => {
        o && (At === "top" ? it.current?.clearSelection() : et.current?.clearSelection());
      },
      [o]
    ), bt = Fi(
      (At) => {
        z(At), At && O("measurements");
      },
      []
    ), ct = Fi(() => {
      et.current?.clearSelection(), it.current?.clearSelection(), z(null), O(
        (At) => At === "measurements" ? null : At
      );
    }, []), Mt = Fi((At) => {
      O((yt) => {
        const ft = yt === At ? null : At;
        return ft !== "event-editor" && D(null), ft;
      });
    }, []), vt = Fi(
      (At) => Y.flatMap((yt) => yt.events).find((yt) => yt.type === At)?.config,
      [Y]
    ), mt = Fi(
      (At) => {
        const yt = vt(At);
        return {
          ...r0(yt?.relativeHeight ?? 0.8),
          fillColor: yt?.fillColor ?? "#FFCC66"
        };
      },
      [vt]
    ), Xt = Fi(
      ({
        startMs: At,
        endMs: yt,
        eventKey: ft
      }) => {
        const Tt = et.current?.getAxisX();
        if (!Tt) return;
        ft && (et.current?.blinkEvent(ft), it.current?.blinkEvent(ft));
        const oe = Math.max(0, yt - At), vi = Math.max(1e4, oe * 0.15);
        Tt.setInterval({
          start: At - vi,
          end: yt + vi,
          stopAxisAfter: !0
        });
      },
      []
    ), Rt = Fi(
      (At, yt) => {
        if (xy(At)) {
          C(
            (ft) => ft.map(
              (Tt) => Tt.eventKey === At ? {
                ...Tt,
                startMs: yt.startMs,
                endMs: yt.endMs,
                y1: yt.y1 ?? Tt.y1,
                y2: yt.y2 ?? Tt.y2,
                fillColor: yt.fillColor ?? Tt.fillColor
              } : Tt
            )
          ), D(
            (ft) => ft?.eventKey === At ? {
              ...ft,
              startMs: yt.startMs,
              endMs: yt.endMs,
              y1: yt.y1 ?? ft.y1,
              y2: yt.y2 ?? ft.y2,
              fillColor: yt.fillColor ?? ft.fillColor
            } : ft
          );
          return;
        }
        (yt.y1 !== void 0 || yt.y2 !== void 0 || yt.fillColor !== void 0) && E((ft) => ({
          ...ft,
          [At]: {
            ...ft[At],
            y1: yt.y1 ?? ft[At]?.y1,
            y2: yt.y2 ?? ft[At]?.y2,
            fillColor: yt.fillColor ?? ft[At]?.fillColor
          }
        })), x(
          (ft) => ft.map(
            (Tt) => Tt.eventKey === At ? {
              ...Tt,
              x1: yt.startMs,
              x2: yt.endMs,
              y1: yt.y1 ?? Tt.y1,
              y2: yt.y2 ?? Tt.y2,
              fillColor: yt.fillColor ?? Tt.fillColor
            } : Tt
          )
        ), D(
          (ft) => ft?.eventKey === At ? {
            ...ft,
            startMs: yt.startMs,
            endMs: yt.endMs,
            y1: yt.y1 ?? ft.y1,
            y2: yt.y2 ?? ft.y2,
            fillColor: yt.fillColor ?? ft.fillColor
          } : ft
        );
      },
      []
    ), Dt = Fi((At) => {
      if (xy(At)) {
        C(
          (yt) => yt.filter((ft) => ft.eventKey !== At)
        ), D(
          (yt) => yt?.eventKey === At ? null : yt
        );
        return;
      }
      x(
        (yt) => yt.filter((ft) => ft.eventKey !== At)
      ), E((yt) => {
        const ft = { ...yt };
        return delete ft[At], ft;
      }), D(
        (yt) => yt?.eventKey === At ? null : yt
      );
    }, []), Kt = Fi(
      ({
        channelId: At,
        eventType: yt,
        startMs: ft,
        endMs: Tt
      }) => {
        const oe = Y.flatMap((Fe) => Fe.events).find((Fe) => Fe.type === yt)?.config, vi = oe?.label || yt, Te = `${Q1}${id()}`, Ze = Lo, ps = (oe?.relativeHeight ?? 0.8) === 1 ? 1 - Ze : oe?.relativeHeight ?? 0.8;
        C(
          (Fe) => [
            ...Fe,
            {
              eventKey: Te,
              channelId: At,
              eventType: yt,
              eventName: vi,
              startMs: ft,
              endMs: Tt,
              y1: Ze,
              y2: ps,
              fillColor: oe?.fillColor,
              isAlarm: !1
            }
          ].sort((qe, rs) => qe.startMs - rs.startMs)
        ), D({
          eventKey: Te,
          eventName: vi,
          eventType: yt,
          startMs: ft,
          endMs: Tt,
          y1: Ze,
          y2: ps,
          fillColor: oe?.fillColor,
          isAlarm: !1
        }), I("select");
      },
      [Y]
    ), _t = Fi(
      (At, yt) => {
        F && Rt(F.eventKey, {
          startMs: At,
          endMs: yt
        });
      },
      [Rt, F]
    ), Ut = Fi(
      (At) => {
        if (!F) return;
        const yt = At / 100, ft = Qp(
          yt,
          S1(F)
        );
        Rt(F.eventKey, {
          startMs: F.startMs,
          endMs: F.endMs,
          y1: ft,
          y2: ft + yt
        });
      },
      [Rt, F]
    ), te = Fi(
      (At) => {
        if (!F) return;
        const yt = n0(F), ft = Qp(yt, At);
        Rt(F.eventKey, {
          startMs: F.startMs,
          endMs: F.endMs,
          y1: ft,
          y2: ft + yt
        });
      },
      [Rt, F]
    ), ye = Fi(
      (At) => {
        F && Rt(F.eventKey, {
          startMs: F.startMs,
          endMs: F.endMs,
          fillColor: At
        });
      },
      [Rt, F]
    ), ne = Fi(() => {
      if (!F) return;
      const At = {
        y1: F.y1,
        y2: F.y2,
        fillColor: F.fillColor
      }, yt = F.eventType;
      x(
        (ft) => ft.map(
          (Tt) => Tt.eventType === yt ? {
            ...Tt,
            ...At
          } : Tt
        )
      ), E((ft) => {
        const Tt = { ...ft };
        for (const oe of L)
          oe.eventType === yt && oe.eventKey && (Tt[oe.eventKey] = {
            ...Tt[oe.eventKey],
            ...At
          });
        return Tt;
      }), C(
        (ft) => ft.map(
          (Tt) => Tt.eventType === yt ? {
            ...Tt,
            ...At
          } : Tt
        )
      ), D(
        (ft) => ft?.eventType === yt ? {
          ...ft,
          ...At
        } : ft
      ), m?.(F.eventName);
    }, [L, m, F]), ti = Fi(() => {
      if (!F) return;
      const At = F.eventType, yt = mt(At);
      x(
        (ft) => ft.map(
          (Tt) => Tt.eventType === At ? {
            ...Tt,
            y1: void 0,
            y2: void 0,
            fillColor: void 0
          } : Tt
        )
      ), E((ft) => {
        const Tt = { ...ft };
        for (const oe of L)
          oe.eventType === At && oe.eventKey && delete Tt[oe.eventKey];
        return Tt;
      }), C(
        (ft) => ft.map(
          (Tt) => Tt.eventType === At ? {
            ...Tt,
            y1: void 0,
            y2: void 0,
            fillColor: void 0
          } : Tt
        )
      ), D(
        (ft) => ft?.eventType === At ? {
          ...ft,
          ...yt
        } : ft
      );
    }, [L, mt, F]), fe = Fi(() => {
      F && Dt(F.eventKey);
    }, [Dt, F]);
    Ey(
      v,
      () => ({
        getInterval: () => {
          if (!et.current)
            throw new Error("Chart is not initialized yet");
          return et.current.getInterval();
        },
        setInterval: (At) => {
          if (!et.current)
            throw new Error("Chart is not initialized yet");
          et.current.setInterval(At);
        },
        getChart: () => et.current?.getChart() ?? null,
        getAxisX: () => et.current?.getAxisX() ?? null
      }),
      []
    ), mi(() => {
      const At = rt.current, yt = tt.current;
      if (!At || !yt) return;
      const ft = (oe) => {
        yt.style.setProperty("--top-chart-height", `${oe}px`);
      }, Tt = new ResizeObserver((oe) => {
        const vi = oe[0];
        vi && ft(vi.contentRect.height);
      });
      return Tt.observe(At), ft(At.getBoundingClientRect().height), () => Tt.disconnect();
    }, [i, o, s?.height]);
    const ve = ni(
      () => ({
        active: _ === "event-editor",
        mode: T,
        createEventType: P,
        selectedEventKey: F?.eventKey ?? null,
        onSelectEvent: D,
        onChangeEvent: Rt,
        onDeleteEvent: Dt,
        onCreateEvent: Kt
      }),
      [
        _,
        P,
        T,
        Rt,
        Kt,
        Dt,
        F?.eventKey
      ]
    ), ci = ni(
      () => i === null ? null : hc(h, i),
      [i, h]
    );
    return !Y || i === null || !ci ? null : /* @__PURE__ */ X.jsxs("div", { className: "signal-viewer", ref: tt, children: [
      /* @__PURE__ */ X.jsxs(
        "div",
        {
          className: "signal-viewer__charts-layout",
          style: {
            gap: o ? "12px" : void 0
          },
          children: [
            /* @__PURE__ */ X.jsx("div", { ref: rt, children: /* @__PURE__ */ X.jsx(
              ly,
              {
                ref: et,
                side: "top",
                containerClassName: u,
                selectedDayMs: i,
                channels: Q,
                globalEvents: q,
                parsedEdfInfo: b,
                therapySettings: $,
                limits: Z,
                chartId: nt,
                chartSize: s,
                enableResize: n,
                viewportHeightAnchorRef: rt,
                therapyTimeInterval: h,
                onZoomIntervalChange: d,
                onSelectionStart: () => st("top"),
                onSelectionChange: bt,
                onChannelDelete: f,
                hiddenChannelIds: p,
                onChannelVisibilityToggle: g,
                onChannelsReorder: A,
                eventEditor: ve
              }
            ) }),
            o && at && /* @__PURE__ */ X.jsx(
              ly,
              {
                ref: it,
                side: "bottom",
                containerClassName: u,
                selectedDayMs: i,
                channels: Q,
                globalEvents: q,
                parsedEdfInfo: b,
                therapySettings: $,
                limits: Z,
                chartId: nt,
                chartSize: s,
                enableResize: n,
                viewportHeightAnchorRef: rt,
                initialViewState: at,
                therapyTimeInterval: h,
                onSelectionStart: () => st("bottom"),
                onSelectionChange: bt,
                onChannelDelete: f,
                eventEditor: ve
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ X.jsx(
        m3,
        {
          activeItemId: _,
          stretch: !1,
          height: "var(--top-chart-height)",
          extension: c,
          items: [
            {
              id: "measurements",
              label: "Toggle measurement",
              panelWidth: 270,
              tooltip: /* @__PURE__ */ X.jsxs(X.Fragment, { children: [
                /* @__PURE__ */ X.jsx("span", { children: "Measurement" }),
                /* @__PURE__ */ X.jsx("span", { className: "feature-sidebar__tooltip-shortcut", children: "Ctrl + Select" })
              ] }),
              icon: /* @__PURE__ */ X.jsx(x3, {}),
              onClick: () => Mt("measurements")
            },
            {
              id: "event-editor",
              label: "Toggle event editor",
              panelWidth: 300,
              tooltip: "Event editor",
              icon: /* @__PURE__ */ X.jsx(S3, {}),
              onClick: () => Mt("event-editor")
            },
            {
              id: "therapy-protocol",
              label: "Toggle therapy protocol",
              tooltip: "Therapy protocol",
              icon: /* @__PURE__ */ X.jsx(v3, {}),
              onClick: () => Mt("therapy-protocol")
            }
          ],
          renderPanel: (At) => At === "measurements" ? /* @__PURE__ */ X.jsx(
            i3,
            {
              selectionStats: B,
              channels: Y,
              onClose: ct
            }
          ) : At === "therapy-protocol" ? /* @__PURE__ */ X.jsx(
            p3,
            {
              channels: k,
              globalEvents: q,
              onEventClick: Xt,
              isExpanded: !0,
              onExpandedChange: (yt) => Mt(yt ? "therapy-protocol" : null),
              parsedEdfInfo: b,
              selectedDayMs: i,
              therapyTimeInterval: h,
              therapySettings: $
            }
          ) : At === "event-editor" ? /* @__PURE__ */ X.jsx(
            xT,
            {
              mode: T,
              selectedEvent: F,
              selectedCreateType: P,
              intervalStartMs: ci.startDateTimeInMs,
              intervalEndMs: ci.endDateTimeInMs,
              channels: Y,
              onModeChange: I,
              onCreateTypeChange: V,
              onUpdateSelectedTime: _t,
              onUpdateSelectedHeight: Ut,
              onUpdateSelectedVerticalPosition: te,
              onUpdateSelectedColor: ye,
              onPushSelectedChangesToEventType: ne,
              onResetSelectedEventType: ti,
              onDeleteSelected: fe,
              onClearSelected: () => D(null)
            }
          ) : null
        }
      )
    ] });
  }
), OT = Ql.forwardRef(({ data: r, isLoading: t = !1, ...e }, i) => /* @__PURE__ */ X.jsxs(X.Fragment, { children: [
  /* @__PURE__ */ X.jsx(VT, { visible: t }),
  r && /* @__PURE__ */ X.jsx(_T, { ref: i, data: r, ...e })
] }));
OT.displayName = "SignalViewer";
var Ue = /* @__PURE__ */ ((r) => (r.SoftStart = "241", r.SoftStop = "242", r.TimedBreath = "221", r.MaskTest = "172", r.ALeckage = "103", r.AMovement = "106", r.HLeckage = "113", r.Artefact = "141", r.eFL = "3", r.eMO = "2", r.eSO = "1", r.LeakageAlert = "305", r.DisconnectionAlert = "307", r.SEL = "330", r.CriticalLeakage = "161", r.oA = "101", r.oH = "111", r.uA = "108", r.CSRespiration = "181", r.cA = "102", r.cH = "112", r.HighPressure = "105", r.eS = "4", r.Snore = "131", r.RERA = "121", r.SpO2Low = "490", r.SpO2High = "491", r.SpO2SignalQualityPoorOrLow = "790", r.FiO2Low = "494", r.FiO2High = "495", r.CO2Low = "496", r.CO2High = "497", r.PressureLow = "321", r.PressureHigh = "322", r.PressurePermanentLow = "323", r.Occlusion = "757", r.PressureContinuouslyConstant = "758", r.BackwardBreathing = "796", r.PressureLimitExceeded = "811", r.PressureLimitReached = "825", r.Apnea = "311", r.FlowLow = "365", r.VolumePermanentLow = "756", r.MinuteVolumeLow = "309", r.MinuteVolumeHigh = "320", r.VolumeLow = "315", r.VolumeHigh = "316", r.FrequencyLow = "317", r.FrequencyHigh = "318", r.PulseLow = "492", r.PulseHigh = "493", r.HumidifierLevel1 = "device:1601", r.HumidifierLevel2 = "device:1602", r.HumidifierLevel3 = "device:1603", r.HumidifierLevel4 = "device:1604", r.HumidifierLevel5 = "device:1605", r.HumidifierEmpty = "device:25501", r.HumidifierError = "device:25504", r))(Ue || {}), He = /* @__PURE__ */ ((r) => (r.Pressure = "1", r.RespFlow = "2", r.Obstruction = "3", r.rMV = "4", r.RespiratoryInstability = "5", r.Leak = "6", r.ObstructiveAH = "7", r.CentralAH = "8", r.Snore = "9", r.SpO2 = "10", r.FiO2 = "11", r.CO2 = "12", r.VolumeTrend = "13", r.RespCycles = "14", r.MinuteVolume = "15", r.TidalVolume = "16", r.RespRate = "17", r.TiT = "18", r.PartInspExp = "19", r.Ti_Te = "20", r.PulseRate = "21", r.PhaseTrigger = "22", r.PressureP5 = "23", r.TargetVolume = "24", r.Humidifier = "25", r))(He || {});
const ev = [
  {
    templateId: "p28.pressure",
    title: "Pressure of P2.8",
    requiredSignals: ["Pressure", "IPAP", "EPAP", "CPAPPressure"],
    optionalSignals: [],
    channel: {
      id: He.Pressure,
      configuration: {
        name: "Pressure",
        relativeHeight: 18,
        tickInterval: { start: 0, end: 25, step: 5 },
        limits: [
          {
            type: "pressure-limits",
            max: { color: "#8A4545" },
            min: { color: "#8A4545" }
          }
        ],
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        {
          type: "Pressure",
          config: {
            label: "Pressure",
            color: "#454545",
            zoomRestriction: { max: 3600 * 1e3 }
          }
        },
        {
          type: "IPAP",
          config: {
            label: "IPAP",
            color: "#446CAB",
            zoomRestriction: { min: 60 * 1e3 }
          }
        },
        {
          type: "EPAP",
          config: {
            label: "EPAP",
            color: "#D17D7D",
            zoomRestriction: { min: 60 * 1e3 }
          }
        },
        {
          type: "CPAPPressure",
          config: {
            label: "(auto)CPAP/EEPAP",
            color: "#8A4545",
            zoomRestriction: { min: 60 * 1e3 }
          }
        }
      ],
      events: [
        {
          type: Ue.MaskTest,
          config: {
            label: "Mask test",
            fillColor: "#D6E3BC",
            borderColor: "#000000",
            relativeHeight: 1
          }
        },
        {
          type: Ue.SoftStart,
          config: {
            label: "softSTART",
            fillColor: "#DCDCDC",
            borderColor: "#000000",
            labelPlacement: "top-left",
            relativeHeight: 1
          }
        },
        {
          type: Ue.TimedBreath,
          config: {
            label: "Timed breath",
            fillColor: "#8B0000",
            borderColor: "#8B0000",
            relativeHeight: 0.14
          }
        }
      ]
    }
  },
  {
    templateId: "p28.respFlow",
    title: "P2.8 Resp. Flow",
    requiredSignals: ["RespFlow"],
    optionalSignals: [],
    channel: {
      id: He.RespFlow,
      configuration: {
        name: "Resp. Flow",
        relativeHeight: 16,
        tickInterval: { start: -100, end: 100, step: 50 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "RespFlow", config: { label: "Resp. Flow", color: "#454545" } }
      ],
      events: [
        {
          type: Ue.ALeckage,
          config: {
            label: "A leakage",
            fillColor: "#ffffff",
            borderColor: "#808080",
            relativeHeight: 0.9
          }
        },
        {
          type: Ue.AMovement,
          config: {
            label: "A movement",
            fillColor: "#ffffff",
            borderColor: "#808080",
            relativeHeight: 0.9
          }
        },
        {
          type: Ue.HLeckage,
          config: {
            label: "H leakage",
            fillColor: "#ffffff",
            borderColor: "#bfbfbf",
            relativeHeight: 0.9
          }
        },
        {
          type: Ue.Artefact,
          config: {
            label: "Artefact",
            fillColor: "#FFCC66",
            borderColor: "#000000",
            labelPlacement: "top-left",
            relativeHeight: 1
          }
        }
      ]
    }
  },
  {
    templateId: "p28.obstructiveAH",
    title: "P2.8 Obstructive AH",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: He.ObstructiveAH,
      configuration: {
        name: "Obstructive AH",
        relativeHeight: 5,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        {
          type: Ue.oA,
          config: {
            label: "oA",
            fillColor: "#CC6556",
            borderColor: "#808080",
            relativeHeight: 1
          }
        },
        {
          type: Ue.uA,
          config: {
            label: "hPrA",
            fillColor: "#D3D3D3",
            borderColor: "#808080",
            relativeHeight: 1
          }
        },
        {
          type: Ue.oH,
          config: {
            label: "oH",
            fillColor: "#FFAFA3",
            borderColor: "#808080",
            relativeHeight: 0.6
          }
        }
      ]
    }
  },
  {
    templateId: "p28.centralAh",
    title: "P2.8 Central AH",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: He.CentralAH,
      configuration: {
        name: "Central AH",
        relativeHeight: 5,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        {
          type: Ue.CSRespiration,
          config: {
            label: "CS respiration",
            fillColor: "#ffff00",
            borderColor: "#808080",
            relativeHeight: 0.8
          }
        },
        {
          type: Ue.cA,
          config: {
            label: "cA",
            fillColor: "#3311DD",
            borderColor: "#808080",
            relativeHeight: 1
          }
        },
        {
          type: Ue.cH,
          config: {
            label: "cH",
            fillColor: "#6677DD",
            borderColor: "#808080",
            relativeHeight: 0.6
          }
        },
        {
          type: Ue.HighPressure,
          config: {
            label: "A high pressure",
            fillColor: "#bfbfbf",
            borderColor: "#7f7f7f",
            relativeHeight: 0.8
          }
        }
      ]
    }
  },
  {
    templateId: "p28.snoreRera",
    title: "P2.8 Snoring/RERA",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: He.Snore,
      configuration: {
        name: "Snoring/RERA",
        relativeHeight: 5,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        {
          type: Ue.eS,
          config: {
            label: "eS",
            fillColor: "#7DB56E",
            borderColor: "#808080",
            relativeHeight: 1
          }
        },
        {
          type: Ue.Snore,
          config: {
            label: "Snore",
            fillColor: "#d6e3bc",
            borderColor: "#808080",
            relativeHeight: 0.6
          }
        },
        {
          type: Ue.RERA,
          config: {
            label: "RERA",
            fillColor: "#E8C064",
            borderColor: "#808080",
            relativeHeight: 1
          }
        }
      ]
    }
  },
  {
    templateId: "p28.obstruction",
    title: "P2.8 Obstruction",
    requiredSignals: ["ObstructLevel"],
    optionalSignals: [],
    channel: {
      id: He.Obstruction,
      configuration: {
        name: "Obstruction",
        relativeHeight: 10,
        tickInterval: { start: 0, end: 100, step: 20 },
        axisType: Ct.SignalOnly
      },
      signals: [
        {
          type: "ObstructLevel",
          config: { label: "Obstruction Level", color: "#8b0000" }
        }
      ],
      events: []
    }
  },
  {
    templateId: "p28.rmv",
    title: "rMV for P2.8",
    requiredSignals: ["rRMV"],
    optionalSignals: [],
    channel: {
      id: He.rMV,
      configuration: {
        name: "rMV",
        relativeHeight: 10,
        tickInterval: { start: 0, end: 200, step: 100 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "rRMV", config: { label: "rel. MV", color: "#404040" } }
      ],
      events: [
        {
          type: Ue.eFL,
          config: {
            label: "eFL",
            fillColor: "#FFFFBB",
            borderColor: "#000000",
            relativeHeight: 0.1
          }
        },
        {
          type: Ue.eMO,
          config: {
            label: "eMO",
            fillColor: "#D17D7D",
            borderColor: "#111111",
            relativeHeight: 0.15
          }
        },
        {
          type: Ue.eSO,
          config: {
            label: "eSO",
            fillColor: "#8A4545",
            borderColor: "#111111",
            relativeHeight: 0.15
          }
        }
      ]
    }
  },
  {
    templateId: "p28.respiratoryInstability",
    title: "P2.8 Respiratory instability",
    requiredSignals: ["rMVFluctuation"],
    optionalSignals: [],
    channel: {
      id: He.RespiratoryInstability,
      configuration: {
        name: "Respiratory instability",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 10, step: 10 },
        axisType: Ct.SignalOnly
      },
      signals: [
        {
          type: "rMVFluctuation",
          config: { label: "Respiratory instability", color: "#B200FF" }
        }
      ],
      events: []
    }
  },
  {
    templateId: "p28.leakUnintentional",
    title: "Unintentional leak (P2.8)",
    requiredSignals: ["LeakFlowBreath"],
    optionalSignals: [],
    channel: {
      id: He.Leak,
      configuration: {
        name: "Leakage",
        relativeHeight: 18,
        tickInterval: { start: 0, end: 75, step: 25 },
        marks: [
          { value: 50, color: "#B32400" },
          { value: 25, color: "#994C00" }
        ],
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        {
          type: "LeakFlowBreath",
          config: { label: "Leakage", color: "#000000" }
        }
      ],
      events: [
        {
          type: Ue.LeakageAlert,
          config: {
            label: "Leakage alert",
            fillColor: "#CC6556",
            borderColor: "#000000",
            relativeHeight: 0.15
          }
        },
        {
          type: Ue.DisconnectionAlert,
          config: {
            label: "Disconn. alert",
            fillColor: "#8b0000",
            borderColor: "#000000",
            relativeHeight: 0.25
          }
        },
        {
          type: Ue.SEL,
          config: {
            label: "SEL",
            fillColor: "#ADD8E6",
            borderColor: "#000000",
            relativeHeight: 1
          }
        }
      ]
    }
  },
  {
    templateId: "p28.humidifier",
    title: "P2.8 Humidifier level",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: He.Humidifier,
      configuration: {
        name: "Humidifier level",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 5, step: 1 },
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        // Bar height encodes the level (SBAS_P28: TopMarginPercents 80..0), so the
        // bars themselves stay unlabeled like in pTS.
        {
          type: Ue.HumidifierLevel1,
          config: {
            label: "Level 1",
            fillColor: "#96BE1F",
            borderColor: "#96BE1F",
            labelPlacement: "none",
            relativeHeight: 0.2
          }
        },
        {
          type: Ue.HumidifierLevel2,
          config: {
            label: "Level 2",
            fillColor: "#96BE1F",
            borderColor: "#96BE1F",
            labelPlacement: "none",
            relativeHeight: 0.4
          }
        },
        {
          type: Ue.HumidifierLevel3,
          config: {
            label: "Level 3",
            fillColor: "#96BE1F",
            borderColor: "#96BE1F",
            labelPlacement: "none",
            relativeHeight: 0.6
          }
        },
        {
          type: Ue.HumidifierLevel4,
          config: {
            label: "Level 4",
            fillColor: "#96BE1F",
            borderColor: "#96BE1F",
            labelPlacement: "none",
            relativeHeight: 0.8
          }
        },
        {
          type: Ue.HumidifierLevel5,
          config: {
            label: "Level 5",
            fillColor: "#96BE1F",
            borderColor: "#96BE1F",
            labelPlacement: "none",
            relativeHeight: 1
          }
        },
        // pTS hatches these full-height over the level bar; solid fill is this
        // repo's standing simplification (the event renderer has no fill patterns).
        {
          type: Ue.HumidifierEmpty,
          config: {
            label: "Humidifier empty",
            fillColor: "#FFD800",
            borderColor: "#000000",
            labelPlacement: "none",
            relativeHeight: 1
          }
        },
        {
          type: Ue.HumidifierError,
          config: {
            label: "Humidifier error",
            fillColor: "#FFD800",
            borderColor: "#000000",
            labelPlacement: "none",
            relativeHeight: 1
          }
        }
      ]
    }
  }
];
var _e = /* @__PURE__ */ ((r) => (r.VentilationRunning = "55", r.UserModeExpert = "56", r.SpO2SensorPresent = "66", r.AirwayPressurePresent = "81", r.FlowLow = "364", r.VolumeLow = "450", r.VolumeHigh = "451", r.FrequencyLow = "452", r.FrequencyHigh = "453", r.MinuteVolumeLow = "454", r.MinuteVolumeHigh = "455", r.PressureHigh = "456", r.PressureLow = "457", r.LeakageHigh = "459", r.DisconnectionDeviceOut = "460", r.DisconnectionAirwayPressure = "461", r.DisconnectionPatient = "464", r.DisconnectionPatientHft = "465", r.PeepHigh = "469", r.VolumeInspLow = "474", r.VolumeInspHigh = "475", r.SpO2Low = "490", r.SpO2High = "491", r.PulseLow = "492", r.PulseHigh = "493", r.BatteryIntAtteCritical = "550", r.BatteryIntAtteLow = "551", r.BatteryIntDefective = "552", r.PowerLost = "580", r.DcSupplyLost = "581", r.AuthenticationDataInvalid = "639", r.LeakageSystemMissing = "753", r.VolumePermanentLow = "756", r.PressureContinuouslyConstant = "758", r.CO2SensorDisconnected = "780", r.SpO2SignalQualityPoorOrLow = "790", r.SpO2FingerClipDisconnected = "791", r.SpO2DeviceDisconnected = "793", r.VentilationSwitchedOff = "794", r.ErrorHoseSystem = "795", r.DisconnectionValvePressure = "798", r.IccWatchdogScLc = "852", r.ScUnexpectedReset = "881", r.FiO2Low = "494", r.FiO2High = "495", r.CO2Low = "496", r.CO2High = "497", r.Occlusion = "757", r.PressurePermanentLow = "755", r.Apnea = "p5-unverified:Apnea", r.BackwardBreathing = "p5-unverified:BackwardBreathing", r.PressureLimitExceeded = "p5-unverified:PressureLimitExceeded", r.PressureLimitReached = "p5-unverified:PressureLimitReached", r))(_e || {});
const NT = [
  {
    templateId: "p5.spO2",
    title: "SpO2 of P5",
    requiredSignals: ["SpO2 Value"],
    optionalSignals: [],
    channel: {
      id: He.SpO2,
      configuration: {
        name: "SpO2",
        relativeHeight: 5,
        tickInterval: { start: 70, end: 100, step: 10 },
        marks: [
          { value: 90, color: "#FFA500" },
          { value: 80, color: "#FF0000" }
        ],
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "SpO2 Value", config: { label: "SpO2", color: "#6544A7" } }
      ],
      events: [
        {
          type: _e.SpO2SignalQualityPoorOrLow,
          config: {
            label: "SpO2 signal quality poor",
            fillColor: "#FFFC6D",
            borderColor: "#000000",
            relativeHeight: 1
          }
        },
        {
          type: _e.SpO2Low,
          config: {
            label: "SpO2 Low",
            fillColor: "#FDB9A7",
            borderColor: "#000000",
            relativeHeight: 0.25
          }
        },
        {
          type: _e.SpO2High,
          config: {
            label: "SpO2 High",
            fillColor: "#FFFFBF",
            borderColor: "#000000",
            relativeHeight: 0.55
          }
        }
      ]
    }
  },
  {
    templateId: "p5.fiO2",
    title: "FiO2 of P5",
    requiredSignals: ["FiO2 Value"],
    optionalSignals: [],
    channel: {
      id: He.FiO2,
      configuration: {
        name: "FiO2",
        relativeHeight: 5,
        tickInterval: { start: 21, end: 100, step: 79 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "FiO2 Value", config: { label: "FiO2", color: "#6544A7" } }
      ],
      events: [
        {
          type: _e.FiO2Low,
          config: {
            label: "FiO2 Low",
            fillColor: "#FFA30F",
            borderColor: "#000000",
            relativeHeight: 0.25
          }
        },
        {
          type: _e.FiO2High,
          config: {
            label: "FiO2 High",
            fillColor: "#E9FF2B",
            borderColor: "#000000",
            relativeHeight: 0.55
          }
        }
      ]
    }
  },
  {
    templateId: "p5.co2",
    title: "CO2 of P5",
    requiredSignals: ["etCO2 Value"],
    optionalSignals: [],
    channel: {
      id: He.CO2,
      configuration: {
        name: "CO2",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 20, step: 20 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "etCO2 Value", config: { label: "CO2", color: "#6544A7" } }
      ],
      events: [
        {
          type: _e.CO2Low,
          config: {
            label: "CO2 Low",
            fillColor: "#FF9575",
            borderColor: "#000000",
            relativeHeight: 0.25
          }
        },
        {
          type: _e.CO2High,
          config: {
            label: "CO2 High",
            fillColor: "#FFE682",
            borderColor: "#000000",
            relativeHeight: 0.55
          }
        }
      ]
    }
  },
  {
    templateId: "p5.pressure",
    title: "Pressure for P5",
    requiredSignals: ["Airway Pressure"],
    optionalSignals: ["IPAPsoll", "EPAPsoll"],
    channel: {
      id: He.PressureP5,
      configuration: {
        name: "Pressure",
        relativeHeight: 10,
        tickInterval: { start: 0, end: 60, step: 5 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "Airway Pressure", config: { label: "Pressure", color: "#696969" } },
        { type: "IPAPsoll", config: { label: "IPAP", color: "#446CAB" } },
        { type: "EPAPsoll", config: { label: "EPAP", color: "#D17D7D" } }
      ],
      events: [
        {
          type: _e.PressureLow,
          config: {
            label: "Pressure Low",
            fillColor: "#DC8FB9",
            borderColor: "#000000",
            relativeHeight: 0.35
          }
        },
        {
          type: _e.PressureHigh,
          config: {
            label: "Pressure High",
            fillColor: "#BE0C7A",
            borderColor: "#000000",
            relativeHeight: 0.65
          }
        },
        {
          type: _e.PressurePermanentLow,
          config: {
            label: "Pressure permanent low",
            fillColor: "#FFB499",
            borderColor: "#000000",
            relativeHeight: 1
          }
        },
        {
          type: _e.Occlusion,
          config: {
            label: "Occlusion",
            fillColor: "#FF4D1C",
            borderColor: "#000000",
            relativeHeight: 1
          }
        },
        {
          type: _e.PressureContinuouslyConstant,
          config: {
            label: "Pressure cont. constant",
            fillColor: "#FFBD19",
            borderColor: "#000000",
            relativeHeight: 1
          }
        },
        {
          type: _e.BackwardBreathing,
          config: {
            label: "Backward breathing",
            fillColor: "#FF3D67",
            borderColor: "#000000",
            relativeHeight: 1
          }
        },
        {
          type: _e.PressureLimitExceeded,
          config: {
            label: "Pressure limit exceeded",
            fillColor: "#FF8490",
            borderColor: "#000000",
            relativeHeight: 1
          }
        },
        {
          type: _e.PressureLimitReached,
          config: {
            label: "Pressure limit reached",
            fillColor: "#FF006A",
            borderColor: "#000000",
            relativeHeight: 1
          }
        },
        {
          type: _e.PeepHigh,
          config: {
            label: "PEEP high",
            fillColor: "#FF91EA",
            borderColor: "#E751FF",
            relativeHeight: 1
          }
        }
      ]
    }
  },
  {
    templateId: "p5.flow",
    title: "Patient Flow for P5",
    requiredSignals: ["Patient Flow"],
    optionalSignals: [],
    channel: {
      id: He.RespFlow,
      configuration: {
        name: "Flow",
        relativeHeight: 9,
        tickInterval: { start: -100, end: 100, step: 50 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "Patient Flow", config: { label: "Patient Flow", color: "#000000" } }
      ],
      events: [
        {
          type: _e.Apnea,
          config: {
            label: "Apnea",
            fillColor: "#8B0000",
            borderColor: "#000000",
            relativeHeight: 1
          }
        },
        {
          type: _e.FlowLow,
          config: {
            label: "Flow low",
            fillColor: "#6544A7",
            borderColor: "#000000",
            relativeHeight: 1
          }
        }
      ]
    }
  },
  {
    templateId: "p5.volumes",
    title: "P5 Volumes",
    requiredSignals: ["Online Volume"],
    optionalSignals: [],
    channel: {
      id: He.VolumeTrend,
      configuration: {
        name: "Volumes",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 1500, step: 250 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "Online Volume", config: { label: "Online volume", color: "#446CAB" } }
      ],
      events: [
        {
          type: _e.VolumePermanentLow,
          config: {
            label: "Volume permanent low",
            fillColor: "#FF8142",
            borderColor: "#000000",
            relativeHeight: 1
          }
        }
      ]
    }
  },
  {
    templateId: "p5.respCycles",
    title: "RespCycles P5",
    requiredSignals: ["Breath Phase"],
    optionalSignals: [],
    channel: {
      id: He.RespCycles,
      configuration: {
        name: "RespCycles",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 3, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [
        { type: "Breath Phase", config: { label: "Breath phase", color: "#A9A9A9" } }
      ],
      events: []
    }
  },
  {
    templateId: "p5.phaseTrigger",
    title: "Phase trigger P5",
    requiredSignals: ["Phase Trigger"],
    optionalSignals: [],
    channel: {
      id: He.PhaseTrigger,
      configuration: {
        name: "Phase trigger",
        relativeHeight: 5,
        tickInterval: { start: -1, end: 2, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [
        { type: "Phase Trigger", config: { label: "Phase trigger", color: "#8B0000" } }
      ],
      events: []
    }
  },
  {
    templateId: "p5.minuteVolume",
    title: "Minute volume P5",
    requiredSignals: ["Minute Volume"],
    optionalSignals: ["MinuteVolumeExp"],
    channel: {
      id: He.MinuteVolume,
      configuration: {
        name: "Minute volume",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 99, step: 99 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "Minute Volume", config: { label: "MV", color: "#7DB56E" } },
        { type: "MinuteVolumeExp", config: { label: "MVe", color: "#FF7FED" } }
      ],
      events: [
        {
          type: _e.MinuteVolumeLow,
          config: {
            label: "Minute volume low",
            fillColor: "#FFAFA3",
            borderColor: "#000000",
            relativeHeight: 0.49
          }
        },
        {
          type: _e.MinuteVolumeHigh,
          config: {
            label: "Minute volume high",
            fillColor: "#C93F2D",
            borderColor: "#000000",
            relativeHeight: 0.49
          }
        }
      ]
    }
  },
  {
    templateId: "p5.tidalVolume",
    title: "Tidal volume P5",
    requiredSignals: ["Tidal Volume"],
    optionalSignals: ["TidalVolumeExp"],
    channel: {
      id: He.TidalVolume,
      configuration: {
        name: "Tidal volume",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 2e3, step: 2e3 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "Tidal Volume", config: { label: "Tidal volume", color: "#446CAB" } },
        { type: "TidalVolumeExp", config: { label: "VTe", color: "#FF7FED" } }
      ],
      events: [
        {
          type: _e.VolumeLow,
          config: {
            label: "Volume low",
            fillColor: "#CC6556",
            borderColor: "#000000",
            relativeHeight: 0.49
          }
        },
        {
          type: _e.VolumeHigh,
          config: {
            label: "Volume high",
            fillColor: "#E90505",
            borderColor: "#000000",
            relativeHeight: 0.49
          }
        },
        {
          type: _e.VolumeInspLow,
          config: {
            label: "Volume insp. low",
            fillColor: "#FF7FB6",
            borderColor: "#000000",
            relativeHeight: 0.49
          }
        },
        {
          type: _e.VolumeInspHigh,
          config: {
            label: "Volume insp. high",
            fillColor: "#B200FF",
            borderColor: "#000000",
            relativeHeight: 0.49
          }
        }
      ]
    }
  },
  {
    templateId: "p5.targetVolume",
    title: "Target volume P5",
    requiredSignals: ["Target Volume"],
    optionalSignals: [],
    channel: {
      id: He.TargetVolume,
      configuration: {
        name: "Target volume",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 1, step: 1 },
        axisType: Ct.SignalOnly
      },
      signals: [
        { type: "Target Volume", config: { label: "Target volume", color: "#446CAB" } }
      ],
      events: []
    }
  },
  {
    templateId: "p5.respRate",
    title: "P5 RespRate",
    requiredSignals: ["Frequency"],
    optionalSignals: [],
    channel: {
      id: He.RespRate,
      configuration: {
        name: "RespRate",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 80, step: 80 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "Frequency", config: { label: "Frequency", color: "#8A4545" } }
      ],
      events: [
        {
          type: _e.FrequencyLow,
          config: {
            label: "Frequency low",
            fillColor: "#FC9FB1",
            borderColor: "#000000",
            relativeHeight: 0.25
          }
        },
        {
          type: _e.FrequencyHigh,
          config: {
            label: "Frequency high",
            fillColor: "#FA5061",
            borderColor: "#000000",
            relativeHeight: 0.65
          }
        }
      ]
    }
  },
  {
    templateId: "p5.tiT",
    title: "Ti/Ttot P5",
    requiredSignals: ["Part Inspiration"],
    optionalSignals: [],
    channel: {
      id: He.TiT,
      configuration: {
        name: "Ti/Ttot",
        relativeHeight: 5,
        tickInterval: { start: 20, end: 80, step: 60 },
        axisType: Ct.SignalOnly
      },
      signals: [
        { type: "Part Inspiration", config: { label: "Ti/Ttot", color: "#D17D7D" } }
      ],
      events: []
    }
  },
  {
    templateId: "p5.partInspExp",
    title: "Part spont. insp/exp P5",
    requiredSignals: ["Part Spont. Insp", "Part Spont. Exp"],
    optionalSignals: [],
    channel: {
      id: He.PartInspExp,
      configuration: {
        name: "Part spont.",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 100, step: 100 },
        axisType: Ct.SignalOnly
      },
      signals: [
        { type: "Part Spont. Insp", config: { label: "Part spont. insp", color: "#086A87" } },
        { type: "Part Spont. Exp", config: { label: "Part spont. exp", color: "#6E6E6E" } }
      ],
      events: []
    }
  },
  {
    templateId: "p5.tiTe",
    title: "Ti / Te P5",
    requiredSignals: ["TiApplied", "TeApplied"],
    optionalSignals: [],
    channel: {
      id: He.Ti_Te,
      configuration: {
        name: "Ti / Te",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 9, step: 9 },
        axisType: Ct.SignalOnly
      },
      signals: [
        { type: "TiApplied", config: { label: "Ti applied", color: "#D17D7D" } },
        { type: "TeApplied", config: { label: "Te applied", color: "#446CAB" } }
      ],
      events: []
    }
  },
  {
    templateId: "p5.leak",
    title: "Leakage P5",
    requiredSignals: ["Leakage Flow"],
    optionalSignals: [],
    channel: {
      id: He.Leak,
      configuration: {
        name: "Leakage",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 150, step: 150 },
        marks: [
          { value: 50, color: "#FF0000" },
          { value: 25, color: "#FFA500" }
        ],
        axisType: Ct.SignalOnly
      },
      signals: [
        { type: "Leakage Flow", config: { label: "Leakage", color: "#000000" } }
      ],
      events: []
    }
  },
  {
    templateId: "p5.heartRate",
    title: "Heart rate P5",
    requiredSignals: ["Pulse Rate"],
    optionalSignals: [],
    channel: {
      id: He.PulseRate,
      configuration: {
        name: "Heart rate",
        relativeHeight: 8,
        tickInterval: { start: 30, end: 150, step: 20, snapToStep: !0 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        { type: "Pulse Rate", config: { label: "Heart rate", color: "#D17D7D" } }
      ],
      events: [
        {
          type: _e.PulseLow,
          config: {
            label: "Pulse low",
            fillColor: "#FFB270",
            borderColor: "#000000",
            relativeHeight: 0.25
          }
        },
        {
          type: _e.PulseHigh,
          config: {
            label: "Pulse high",
            fillColor: "#FFF94C",
            borderColor: "#000000",
            relativeHeight: 0.65
          }
        }
      ]
    }
  }
];
function BT(r) {
  const t = new Set(r), e = Sy(ev, t), i = Sy(NT, t);
  return [.../* @__PURE__ */ new Set([...e, ...i])];
}
function Sy(r, t) {
  return r.map((e) => {
    const i = e.requiredSignals;
    if (i.length === 0)
      return null;
    const s = i.filter((a) => t.has(a)), o = s.length / i.length, n = Math.round(o * 100);
    return {
      templateId: e.templateId,
      title: e.title,
      score: n,
      channel: {
        ...e.channel,
        id: e.channel.id + id().toString()
      },
      matchedSignals: s
    };
  }).filter(
    (e) => e !== null && e.score > 0
  ).sort((e, i) => i.score - e.score);
}
const nk = ({
  availableSignalTypes: r,
  onAddSuggestion: t,
  onCreateCustomChannel: e,
  onCancel: i
}) => {
  const [s, o] = ze([]), n = ni(
    () => BT(r),
    [r]
  ), a = (l, h) => {
    o(
      (u) => h ? [...u, l] : u.filter((c) => c !== l)
    );
  };
  return /* @__PURE__ */ X.jsxs("div", { className: "signal-channel-selector", children: [
    /* @__PURE__ */ X.jsx("div", { className: "signal-channel-selector__section-title", children: "Signals in file" }),
    /* @__PURE__ */ X.jsx("div", { className: "signal-channel-selector__signals-list", children: r.map((l) => /* @__PURE__ */ X.jsxs("label", { className: "signal-channel-selector__signal-label", children: [
      /* @__PURE__ */ X.jsx(
        "input",
        {
          type: "checkbox",
          checked: s.includes(l),
          onChange: (h) => a(l, h.target.checked),
          className: "signal-channel-selector__checkbox"
        }
      ),
      l
    ] }, l)) }),
    /* @__PURE__ */ X.jsx(
      "div",
      {
        style: {
          fontSize: 14,
          fontWeight: 600,
          color: "rgba(0,0,0,0.85)",
          marginBottom: 12
        },
        children: "Suggested channels"
      }
    ),
    /* @__PURE__ */ X.jsx("div", { className: "signal-channel-selector-suggestions-container", children: n.map((l) => /* @__PURE__ */ X.jsxs(
      "button",
      {
        onClick: () => t(l),
        className: "signal-channel-selector-suggestions-container__btn",
        children: [
          l.title,
          " (",
          l.score,
          ")"
        ]
      },
      l.templateId
    )) }),
    /* @__PURE__ */ X.jsxs("div", { className: "signal-channel-selector__footer", children: [
      i && /* @__PURE__ */ X.jsx(
        "button",
        {
          className: "signal-channel-selector__cancel-btn",
          onClick: i,
          children: "Cancel"
        }
      ),
      e && /* @__PURE__ */ X.jsx(
        "button",
        {
          onClick: () => e(s),
          disabled: s.length === 0,
          className: "signal-channel-selector__create-btn",
          children: "Create custom channel"
        }
      )
    ] })
  ] });
}, ok = ({
  value: r,
  options: t,
  placeholder: e = "Select...",
  onChange: i,
  className: s,
  disabled: o = !1
}) => {
  const [n, a] = ze(!1), [l, h] = ze(-1), u = Ei(null), c = t.find((f) => f.value === r);
  mi(() => {
    const f = (p) => {
      u.current?.contains(p.target) || (a(!1), h(-1));
    };
    return document.addEventListener("mousedown", f), () => document.removeEventListener("mousedown", f);
  }, []), mi(() => {
    if (!n) {
      h(-1);
      return;
    }
    const f = t.findIndex((p) => p.value === r);
    h(f >= 0 ? f : 0);
  }, [n, t, r]);
  const d = (f) => {
    if (!o) {
      if (f.key === "ArrowDown") {
        if (f.preventDefault(), !n) {
          a(!0);
          return;
        }
        h((p) => p < t.length - 1 ? p + 1 : 0);
      }
      if (f.key === "ArrowUp") {
        if (f.preventDefault(), !n) {
          a(!0);
          return;
        }
        h((p) => p > 0 ? p - 1 : t.length - 1);
      }
      if (f.key === "Enter" || f.key === " ") {
        if (f.preventDefault(), !n) {
          a(!0);
          return;
        }
        l >= 0 && l < t.length && (i(t[l].value), a(!1));
      }
      f.key === "Escape" && (f.preventDefault(), a(!1), h(-1));
    }
  };
  return /* @__PURE__ */ X.jsxs(
    "div",
    {
      ref: u,
      className: [
        "combo-box",
        n && "combo-box--open",
        s,
        o && "combo-box--disabled"
      ].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ X.jsxs(
          "button",
          {
            type: "button",
            className: "combo-box__trigger",
            onClick: () => !o && a((f) => !f),
            onKeyDown: d,
            disabled: o,
            "aria-haspopup": "listbox",
            "aria-expanded": n,
            children: [
              /* @__PURE__ */ X.jsx(
                "span",
                {
                  className: [
                    "combo-box__value",
                    !c && "combo-box__value--placeholder"
                  ].filter(Boolean).join(" "),
                  children: c?.label ?? e
                }
              ),
              /* @__PURE__ */ X.jsx("span", { className: "combo-box__arrow", "aria-hidden": "true", children: /* @__PURE__ */ X.jsx(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "14",
                  height: "7",
                  viewBox: "0 0 14 7",
                  fill: "none",
                  children: /* @__PURE__ */ X.jsx(
                    "path",
                    {
                      d: "M6.66633 6.70406L0 0.745582L0.666413 0L6.99954 5.66065L13.3327 0L13.9991 0.745582L7.33275 6.70406L6.99954 7.00188L6.66633 6.70406Z",
                      fill: "#1890FF",
                      fillRule: "evenodd",
                      clipRule: "evenodd"
                    }
                  )
                }
              ) })
            ]
          }
        ),
        n && /* @__PURE__ */ X.jsx("div", { className: "combo-box__dropdown", role: "listbox", children: t.map((f, p) => {
          const g = f.value === r, y = p === l;
          return /* @__PURE__ */ X.jsx(
            "button",
            {
              type: "button",
              className: [
                "combo-box__option",
                g && "combo-box__option--selected",
                y && "combo-box__option--highlighted"
              ].filter(Boolean).join(" "),
              onMouseEnter: () => h(p),
              onClick: () => {
                i(f.value), a(!1);
              },
              role: "option",
              "aria-selected": g,
              children: f.label
            },
            f.value
          );
        }) })
      ]
    }
  );
}, ak = ev.filter(
  (r) => r.channel.id !== He.Humidifier
).map((r) => {
  switch (r.channel.id) {
    case He.Pressure:
      return {
        ...r,
        requiredSignals: ["Pressure", "IPAPsoll", "EPAPsoll", "EEPAPsoll"],
        channel: {
          ...r.channel,
          signals: [
            {
              type: "Pressure",
              config: {
                label: "Pressure",
                color: "#454545",
                zoomRestriction: { max: 3600 * 1e3 }
              }
            },
            {
              type: "IPAPsoll",
              config: {
                label: "IPAP",
                color: "#446CAB",
                zoomRestriction: { min: 60 * 1e3 }
              }
            },
            {
              type: "EPAPsoll",
              config: {
                label: "EPAP",
                color: "#D17D7D",
                zoomRestriction: { min: 60 * 1e3 }
              }
            },
            {
              type: "EEPAPsoll",
              config: {
                label: "(auto)CPAP/EEPAP",
                color: "#8A4545",
                zoomRestriction: { min: 60 * 1e3 }
              }
            }
          ],
          events: [
            ...r.channel.events,
            {
              type: Ue.SoftStop,
              config: {
                label: "softSTOP",
                fillColor: "#DCDCDC",
                borderColor: "#000000",
                relativeHeight: 1
              }
            }
          ]
        }
      };
    case He.rMV:
      return {
        ...r,
        requiredSignals: ["rAMV"],
        channel: {
          ...r.channel,
          signals: r.channel.signals.map((t) => ({
            ...t,
            type: "rAMV"
          }))
        }
      };
    case He.Leak:
      return {
        ...r,
        requiredSignals: [...r.requiredSignals, "TotalLeakage"],
        channel: {
          ...r.channel,
          signals: [
            {
              type: "TotalLeakage",
              config: { label: "Total leakage", color: "#D3D3D3" }
            },
            ...r.channel.signals
          ]
        }
      };
    default:
      return r;
  }
});
var Vt = /* @__PURE__ */ ((r) => (r.SoftStart = "241", r.SoftStop = "242", r.Artefact = "141", r.oA = "101", r.oH = "111", r.cH = "112", r.uA = "108", r.VolumeLow = "315", r.VolumeHigh = "316", r.MinuteVolumeLow = "309", r.MinuteVolumeHigh = "320", r.PressureLow = "321", r.PressureHigh = "322", r.Apnea = "311", r.FrequencyLow = "317", r.FrequencyHigh = "318", r.FlowLow = "365", r.SuddenEndOfLeakage = "330", r.Disconnection = "307", r.BlowerFeedForwardUnplausible = "251", r.PressureSensorDiscrepancy = "252", r.FlowSensorUnplausible = "254", r))(Vt || {}), Zt = /* @__PURE__ */ ((r) => (r.Pressure = "1", r.RespFlow = "2", r.VolumeTrend = "13", r.RespCycles = "14", r.MinuteVolume = "15", r.TidalVolume = "16", r.RespRate = "17", r.TiT = "18", r.PartInspExp = "19", r.PulseRate = "21", r.PhaseTrigger = "22", r.EventsSdbP32 = "24", r.EventsVaP32 = "25", r.EventsPP32 = "26", r.EventsFP32 = "27", r.LIAM = "28", r.EventsSpO2P32 = "29", r.Leak = "30", r.SpO2 = "31", r))(Zt || {});
const Ne = (r, t, e, i) => ({
  type: r,
  config: { label: t, color: e, ...i ? { zoomRestriction: i } : {} }
}), Ae = (r, t, e, i = 1, s) => ({
  type: r,
  config: {
    label: t,
    fillColor: e,
    borderColor: "#000000",
    relativeHeight: i,
    ...s ? { labelPlacement: s } : {}
  }
}), zT = [
  {
    templateId: "p32-v50.pressure",
    title: "P3.2 V50 Pressure",
    requiredSignals: ["Airway Pressure"],
    optionalSignals: ["IPAPsoll", "EPAPsoll"],
    channel: {
      id: Zt.Pressure,
      configuration: {
        name: "Pressure",
        relativeHeight: 10,
        tickInterval: { start: 0, end: 40, step: 5 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        Ne("Airway Pressure", "Pressure", "#000000", { max: 3600 * 1e3 }),
        Ne("IPAPsoll", "IPAP", "#446CAB", { min: 60 * 1e3 }),
        Ne("EPAPsoll", "EPAP", "#D17D7D", { min: 60 * 1e3 })
      ],
      events: [
        Ae(Vt.SoftStart, "softSTART", "#DCDCDC", 1, "top-left"),
        Ae(Vt.SoftStop, "softSTOP", "#DCDCDC")
      ]
    }
  },
  {
    templateId: "p32-v50.flow",
    title: "P3.2 V50 Flow",
    requiredSignals: ["Patient Flow"],
    optionalSignals: [],
    channel: {
      id: Zt.RespFlow,
      configuration: {
        name: "Flow",
        relativeHeight: 10,
        tickInterval: { start: -100, end: 100, step: 50 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [Ne("Patient Flow", "Resp. Flow", "#000000")],
      events: [
        Ae(Vt.Artefact, "Artefact", "#FFCC66", 1, "top-left")
      ]
    }
  },
  {
    templateId: "p32-v50.volumes",
    title: "P3.2 V50 Volumes",
    requiredSignals: ["Online Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.VolumeTrend,
      configuration: {
        name: "Volumes",
        relativeHeight: 10,
        tickInterval: { start: 0, end: 1500, step: 250 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Online Volume", "Online volume", "#446CAB")],
      events: []
    }
  },
  {
    templateId: "p32-v50.respCycles",
    title: "P3.2 V50 RespCycles",
    requiredSignals: ["Breath Phase"],
    optionalSignals: [],
    channel: {
      id: Zt.RespCycles,
      configuration: {
        name: "RespCycles",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 3, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Breath Phase", "Breath phase", "#A9A9A9")],
      events: []
    }
  },
  {
    templateId: "p32-v50.phaseTrigger",
    title: "P3.2 V50 Phase Trigger",
    requiredSignals: ["Phase Trigger"],
    optionalSignals: [],
    channel: {
      id: Zt.PhaseTrigger,
      configuration: {
        name: "Phase trigger",
        relativeHeight: 5,
        tickInterval: { start: -1, end: 2, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Phase Trigger", "Phase trigger", "#8B0000")],
      events: []
    }
  },
  {
    templateId: "p32-v50.liam",
    title: "P3.2 V50 LIAM",
    requiredSignals: ["LIAM"],
    optionalSignals: [],
    channel: {
      id: Zt.LIAM,
      configuration: {
        name: "LIAM",
        relativeHeight: 4,
        tickInterval: { start: 0, end: 3, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("LIAM", "LIAM", "#00008B")],
      events: []
    }
  },
  {
    templateId: "p32-v50.minuteVolume",
    title: "P3.2 V50 Minute Volume",
    requiredSignals: ["Minute Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.MinuteVolume,
      configuration: {
        name: "Minute volume",
        relativeHeight: 7,
        tickInterval: { start: 0, end: 20, step: 5 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Minute Volume", "Minute Volume", "#7DB56E")],
      events: []
    }
  },
  {
    templateId: "p32-v50.tidalVolume",
    title: "P3.2 V50 Tidal Volume",
    requiredSignals: ["Tidal Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.TidalVolume,
      configuration: {
        name: "Tidal volume",
        relativeHeight: 7,
        tickInterval: { start: 0, end: 1500, step: 250 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Tidal Volume", "Breath volume", "#446CAB")],
      events: []
    }
  },
  {
    templateId: "p32-v50.respRate",
    title: "P3.2 V50 RespRate",
    requiredSignals: ["Frequency"],
    optionalSignals: [],
    channel: {
      id: Zt.RespRate,
      configuration: {
        name: "RespRate",
        relativeHeight: 7,
        tickInterval: { start: 0, end: 40, step: 10 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Frequency", "Breath frequency", "#8A4545")],
      events: []
    }
  },
  {
    templateId: "p32-v50.tiT",
    title: "P3.2 V50 Ti/T",
    requiredSignals: ["Part Inspiration"],
    optionalSignals: [],
    channel: {
      id: Zt.TiT,
      configuration: {
        name: "Ti/T",
        relativeHeight: 7,
        tickInterval: { start: 20, end: 80, step: 20 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Part Inspiration", "Insp/Exp rel", "#D17D7D")],
      events: []
    }
  },
  {
    templateId: "p32-v50.eventsSdb",
    title: "P3.2 V50 SDB Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsSdbP32,
      configuration: {
        name: "Events SDB",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ae(Vt.oA, "oA", "#CC6556"),
        Ae(Vt.oH, "oH", "#FFAFA3", 0.6),
        Ae(Vt.cH, "cH", "#6677DD", 0.6),
        Ae(Vt.uA, "uA", "#D3D3D3")
      ]
    }
  },
  {
    templateId: "p32-v50.partInspExp",
    title: "P3.2 V50 Part Insp/Exp",
    requiredSignals: ["Part Spont Insp.", "Part Spont Exp."],
    optionalSignals: [],
    channel: {
      id: Zt.PartInspExp,
      configuration: {
        name: "PartInspExp",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 100, step: 25 },
        axisType: Ct.SignalOnly
      },
      signals: [
        Ne("Part Spont Insp.", "Part spont insp", "#086A87"),
        Ne("Part Spont Exp.", "Part spont exp", "#6E6E6E")
      ],
      events: []
    }
  },
  {
    templateId: "p32-v50.eventsVa",
    title: "P3.2 V50 VA Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsVaP32,
      configuration: {
        name: "Events VA",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ae(Vt.VolumeLow, "Volume low", "#CC6556", 0.4),
        Ae(Vt.VolumeHigh, "Volume high", "#E90505", 0.65),
        Ae(Vt.MinuteVolumeLow, "Minute volume low", "#FFAFA3", 0.45),
        Ae(Vt.MinuteVolumeHigh, "Minute volume high", "#C93F2D", 0.7),
        Ae(Vt.FlowLow, "Flow low", "#6544A7")
      ]
    }
  },
  {
    templateId: "p32-v50.eventsP",
    title: "P3.2 V50 Pressure Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsPP32,
      configuration: {
        name: "Events P",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ae(Vt.PressureLow, "Pressure low", "#DC8FB9", 0.5),
        Ae(Vt.PressureHigh, "Pressure high", "#BE0C7A", 0.7)
      ]
    }
  },
  {
    templateId: "p32-v50.eventsF",
    title: "P3.2 V50 Frequency Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsFP32,
      configuration: {
        name: "Events F",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ae(Vt.Apnea, "Apnea", "#8B0000"),
        Ae(Vt.FrequencyLow, "Frequency low", "#FC9FB1", 0.45),
        Ae(Vt.FrequencyHigh, "Frequency high", "#FA5061", 0.7)
      ]
    }
  },
  {
    templateId: "p32-v50.leak",
    title: "P3.2 V50 Leak",
    requiredSignals: ["Leakage Flow"],
    optionalSignals: ["TotalLeakage"],
    channel: {
      id: Zt.Leak,
      configuration: {
        name: "Leakage",
        relativeHeight: 7,
        tickInterval: { start: 0, end: 75, step: 25 },
        marks: [
          { value: 50, color: "#B32400" },
          { value: 25, color: "#994C00" }
        ],
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        Ne("TotalLeakage", "Total leakage", "#D3D3D3"),
        Ne("Leakage Flow", "Leak flow breath", "#000000")
      ],
      events: [
        Ae(Vt.SuddenEndOfLeakage, "SEL", "#ADD8E6", 0.7),
        Ae(Vt.Disconnection, "Disconnection", "#8B0000")
      ]
    }
  }
], WT = [
  {
    templateId: "p32-v50-spo2.spo2",
    title: "P3.2 V50 SpO2",
    requiredSignals: ["SpO2 Value"],
    optionalSignals: [],
    channel: {
      id: Zt.SpO2,
      configuration: {
        name: "SpO2 Value",
        relativeHeight: 10,
        tickInterval: { start: 70, end: 100, step: 10 },
        marks: [
          { value: 90, color: "#994C00" },
          { value: 80, color: "#B32400" }
        ],
        axisType: Ct.SignalsWithEvents
      },
      signals: [Ne("SpO2 Value", "SpO2 Value", "#6544A7")],
      events: [
        Ae(
          Vt.FlowSensorUnplausible,
          "Flow sensor unplausible",
          "#FFCC66"
        )
      ]
    }
  },
  {
    templateId: "p32-v50-spo2.eventsSpo2",
    title: "P3.2 V50 SpO2 Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsSpO2P32,
      configuration: {
        name: "Events SpO2",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ae(
          Vt.BlowerFeedForwardUnplausible,
          "Blower feed forward unplausible",
          "#6544A7"
        ),
        Ae(
          Vt.PressureSensorDiscrepancy,
          "Pressure sensor discrepancy",
          "#B6A4DA",
          0.6
        )
      ]
    }
  },
  {
    templateId: "p32-v50-spo2.pressure",
    title: "P3.2 V50 Pressure",
    requiredSignals: ["Airway Pressure"],
    optionalSignals: ["IPAPsoll", "EPAPsoll"],
    channel: {
      id: Zt.Pressure,
      configuration: {
        name: "Pressure",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 40, step: 5 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        Ne("Airway Pressure", "Pressure", "#000000", { max: 3600 * 1e3 }),
        Ne("IPAPsoll", "IPAP", "#446CAB", { min: 60 * 1e3 }),
        Ne("EPAPsoll", "EPAP", "#D17D7D", { min: 60 * 1e3 })
      ],
      events: [
        Ae(Vt.SoftStart, "softSTART", "#DCDCDC", 1, "top-left"),
        Ae(Vt.SoftStop, "softSTOP", "#DCDCDC")
      ]
    }
  },
  {
    templateId: "p32-v50-spo2.flow",
    title: "P3.2 V50 Flow",
    requiredSignals: ["Patient Flow"],
    optionalSignals: [],
    channel: {
      id: Zt.RespFlow,
      configuration: {
        name: "Flow",
        relativeHeight: 8,
        tickInterval: { start: -100, end: 100, step: 50 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [Ne("Patient Flow", "Resp. Flow", "#000000")],
      events: [
        Ae(Vt.Artefact, "Artefact", "#FFCC66", 1, "top-left")
      ]
    }
  },
  {
    templateId: "p32-v50-spo2.volumes",
    title: "P3.2 V50 Volumes",
    requiredSignals: ["Online Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.VolumeTrend,
      configuration: {
        name: "Volumes",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 1500, step: 250 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Online Volume", "Online volume", "#446CAB")],
      events: []
    }
  },
  {
    templateId: "p32-v50-spo2.respCycles",
    title: "P3.2 V50 RespCycles",
    requiredSignals: ["Breath Phase"],
    optionalSignals: [],
    channel: {
      id: Zt.RespCycles,
      configuration: {
        name: "RespCycles",
        relativeHeight: 4,
        tickInterval: { start: 0, end: 3, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Breath Phase", "Breath phase", "#A9A9A9")],
      events: []
    }
  },
  {
    templateId: "p32-v50-spo2.phaseTrigger",
    title: "P3.2 V50 Phase Trigger",
    requiredSignals: ["Phase Trigger"],
    optionalSignals: [],
    channel: {
      id: Zt.PhaseTrigger,
      configuration: {
        name: "Phase trigger",
        relativeHeight: 4,
        tickInterval: { start: -1, end: 2, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Phase Trigger", "Phase trigger", "#8B0000")],
      events: []
    }
  },
  {
    templateId: "p32-v50-spo2.liam",
    title: "P3.2 V50 LIAM",
    requiredSignals: ["LIAM"],
    optionalSignals: [],
    channel: {
      id: Zt.LIAM,
      configuration: {
        name: "LIAM",
        relativeHeight: 4,
        tickInterval: { start: 0, end: 3, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("LIAM", "LIAM", "#00008B")],
      events: []
    }
  },
  {
    templateId: "p32-v50-spo2.minuteVolume",
    title: "P3.2 V50 Minute Volume",
    requiredSignals: ["Minute Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.MinuteVolume,
      configuration: {
        name: "Minute volume",
        relativeHeight: 6,
        tickInterval: { start: 0, end: 20, step: 5 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Minute Volume", "Minute Volume", "#7DB56E")],
      events: []
    }
  },
  {
    templateId: "p32-v50-spo2.tidalVolume",
    title: "P3.2 V50 Tidal Volume",
    requiredSignals: ["Tidal Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.TidalVolume,
      configuration: {
        name: "Tidal volume",
        relativeHeight: 6,
        tickInterval: { start: 0, end: 1500, step: 250 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Tidal Volume", "Breath volume", "#446CAB")],
      events: []
    }
  },
  {
    templateId: "p32-v50-spo2.respRate",
    title: "P3.2 V50 RespRate",
    requiredSignals: ["Frequency"],
    optionalSignals: [],
    channel: {
      id: Zt.RespRate,
      configuration: {
        name: "RespRate",
        relativeHeight: 6,
        tickInterval: { start: 0, end: 40, step: 10 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Frequency", "Breath frequency", "#8A4545")],
      events: []
    }
  },
  {
    templateId: "p32-v50-spo2.tiT",
    title: "P3.2 V50 Ti/T",
    requiredSignals: ["Part Inspiration"],
    optionalSignals: [],
    channel: {
      id: Zt.TiT,
      configuration: {
        name: "Ti/T",
        relativeHeight: 6,
        tickInterval: { start: 20, end: 80, step: 20 },
        axisType: Ct.SignalOnly
      },
      signals: [Ne("Part Inspiration", "Insp/Exp rel", "#D17D7D")],
      events: []
    }
  },
  {
    templateId: "p32-v50-spo2.eventsSdb",
    title: "P3.2 V50 SDB Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsSdbP32,
      configuration: {
        name: "Events SDB",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ae(Vt.oA, "oA", "#CC6556"),
        Ae(Vt.oH, "oH", "#FFAFA3", 0.6),
        Ae(Vt.cH, "cH", "#6677DD", 0.6),
        Ae(Vt.uA, "uA", "#D3D3D3")
      ]
    }
  },
  {
    templateId: "p32-v50-spo2.partInspExp",
    title: "P3.2 V50 Part Insp/Exp",
    requiredSignals: ["Part Spont Insp.", "Part Spont Exp."],
    optionalSignals: [],
    channel: {
      id: Zt.PartInspExp,
      configuration: {
        name: "PartInspExp",
        relativeHeight: 6,
        tickInterval: { start: 0, end: 100, step: 25 },
        axisType: Ct.SignalOnly
      },
      signals: [
        Ne("Part Spont Insp.", "Part spont insp", "#086A87"),
        Ne("Part Spont Exp.", "Part spont exp", "#6E6E6E")
      ],
      events: []
    }
  },
  {
    templateId: "p32-v50-spo2.alarms",
    title: "P3.2 V50 Alarms",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsVaP32,
      configuration: {
        name: "Alarms",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ae(Vt.Apnea, "Apnea", "#8B0000"),
        Ae(Vt.VolumeLow, "Volume low", "#CC6556", 0.4),
        Ae(Vt.VolumeHigh, "Volume high", "#E90505", 0.65),
        Ae(Vt.MinuteVolumeLow, "Minute volume low", "#FFAFA3", 0.45),
        Ae(Vt.MinuteVolumeHigh, "Minute volume high", "#C93F2D", 0.7),
        Ae(Vt.PressureLow, "Pressure low", "#DC8FB9", 0.5),
        Ae(Vt.PressureHigh, "Pressure high", "#BE0C7A", 0.7),
        Ae(Vt.FrequencyLow, "Frequency low", "#FC9FB1", 0.45),
        Ae(Vt.FrequencyHigh, "Frequency high", "#FA5061", 0.7),
        Ae(Vt.FlowLow, "Flow low", "#6544A7")
      ]
    }
  },
  {
    templateId: "p32-v50-spo2.leak",
    title: "P3.2 V50 Leak",
    requiredSignals: ["Leakage Flow"],
    optionalSignals: ["TotalLeakage"],
    channel: {
      id: Zt.Leak,
      configuration: {
        name: "Leakage",
        relativeHeight: 6,
        tickInterval: { start: 0, end: 75, step: 25 },
        marks: [
          { value: 50, color: "#B32400" },
          { value: 25, color: "#994C00" }
        ],
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        Ne("TotalLeakage", "Total leakage", "#D3D3D3"),
        Ne("Leakage Flow", "Leak flow breath", "#000000")
      ],
      events: [
        Ae(Vt.SuddenEndOfLeakage, "SEL", "#ADD8E6", 0.7),
        Ae(Vt.Disconnection, "Disconnection", "#8B0000")
      ]
    }
  },
  {
    templateId: "p32-v50-spo2.heartRate",
    title: "P3.2 V50 Heart Rate",
    requiredSignals: ["Pulse Rate"],
    optionalSignals: [],
    channel: {
      id: Zt.PulseRate,
      configuration: {
        name: "Heart rate",
        relativeHeight: 6,
        tickInterval: { start: 30, end: 150, step: 20 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [Ne("Pulse Rate", "Heart frequency", "#D17D7D")],
      events: [
        Ae(
          Vt.FlowSensorUnplausible,
          "Flow sensor unplausible",
          "#FFCC66"
        )
      ]
    }
  }
], Ye = (r, t, e, i) => ({
  type: r,
  config: { label: t, color: e, ...i ? { zoomRestriction: i } : {} }
}), Ce = (r, t, e, i = 1, s) => ({
  type: r,
  config: {
    label: t,
    fillColor: e,
    borderColor: "#000000",
    relativeHeight: i,
    ...s ? { labelPlacement: s } : {}
  }
}), GT = [
  {
    templateId: "p32-vent.pressure",
    title: "P3.2 VENT Pressure",
    requiredSignals: ["Airway Pressure"],
    optionalSignals: ["IPAPsoll", "EPAPsoll"],
    channel: {
      id: Zt.Pressure,
      configuration: {
        name: "Pressure",
        relativeHeight: 10,
        tickInterval: { start: 0, end: 40, step: 5 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        Ye("Airway Pressure", "Pressure", "#000000", { max: 3600 * 1e3 }),
        Ye("IPAPsoll", "IPAP", "#446CAB", { min: 60 * 1e3 }),
        Ye("EPAPsoll", "EPAP", "#D17D7D", { min: 60 * 1e3 })
      ],
      events: [
        Ce(Vt.SoftStart, "softSTART", "#DCDCDC", 1, "top-left"),
        Ce(Vt.SoftStop, "softSTOP", "#DCDCDC")
      ]
    }
  },
  {
    templateId: "p32-vent.flow",
    title: "P3.2 VENT Flow",
    requiredSignals: ["Patient Flow"],
    optionalSignals: [],
    channel: {
      id: Zt.RespFlow,
      configuration: {
        name: "Flow",
        relativeHeight: 10,
        tickInterval: { start: -100, end: 100, step: 50 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [Ye("Patient Flow", "Resp. Flow", "#000000")],
      events: [
        Ce(Vt.Artefact, "Artefact", "#FFCC66", 1, "top-left")
      ]
    }
  },
  {
    templateId: "p32-vent.volumes",
    title: "P3.2 VENT Volumes",
    requiredSignals: ["Online Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.VolumeTrend,
      configuration: {
        name: "Volumes",
        relativeHeight: 10,
        tickInterval: { start: 0, end: 1500, step: 250 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Online Volume", "Online volume", "#446CAB")],
      events: []
    }
  },
  {
    templateId: "p32-vent.respCycles",
    title: "P3.2 VENT RespCycles",
    requiredSignals: ["Breath Phase"],
    optionalSignals: [],
    channel: {
      id: Zt.RespCycles,
      configuration: {
        name: "RespCycles",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 3, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Breath Phase", "Breath phase", "#A9A9A9")],
      events: []
    }
  },
  {
    templateId: "p32-vent.phaseTrigger",
    title: "P3.2 VENT Phase Trigger",
    requiredSignals: ["Phase Trigger"],
    optionalSignals: [],
    channel: {
      id: Zt.PhaseTrigger,
      configuration: {
        name: "Phase trigger",
        relativeHeight: 5,
        tickInterval: { start: -1, end: 2, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Phase Trigger", "Phase trigger", "#8B0000")],
      events: []
    }
  },
  {
    templateId: "p32-vent.minuteVolume",
    title: "P3.2 VENT Minute Volume",
    requiredSignals: ["Minute Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.MinuteVolume,
      configuration: {
        name: "Minute volume",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 20, step: 5 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Minute Volume", "Minute Volume", "#7DB56E")],
      events: []
    }
  },
  {
    templateId: "p32-vent.tidalVolume",
    title: "P3.2 VENT Tidal Volume",
    requiredSignals: ["Tidal Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.TidalVolume,
      configuration: {
        name: "Tidal volume",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 1500, step: 250 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Tidal Volume", "Breath volume", "#446CAB")],
      events: []
    }
  },
  {
    templateId: "p32-vent.respRate",
    title: "P3.2 VENT RespRate",
    requiredSignals: ["Frequency"],
    optionalSignals: [],
    channel: {
      id: Zt.RespRate,
      configuration: {
        name: "RespRate",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 40, step: 10 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Frequency", "Breath frequency", "#8A4545")],
      events: []
    }
  },
  {
    templateId: "p32-vent.tiT",
    title: "P3.2 VENT Ti/T",
    requiredSignals: ["Part Inspiration"],
    optionalSignals: [],
    channel: {
      id: Zt.TiT,
      configuration: {
        name: "Ti/T",
        relativeHeight: 7,
        tickInterval: { start: 20, end: 80, step: 20 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Part Inspiration", "Insp/Exp rel", "#D17D7D")],
      events: []
    }
  },
  {
    templateId: "p32-vent.eventsSdb",
    title: "P3.2 VENT SDB Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsSdbP32,
      configuration: {
        name: "Events SDB",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ce(Vt.oA, "oA", "#CC6556"),
        Ce(Vt.oH, "oH", "#FFAFA3", 0.6),
        Ce(Vt.cH, "cH", "#6677DD", 0.6),
        Ce(Vt.uA, "uA", "#D3D3D3")
      ]
    }
  },
  {
    templateId: "p32-vent.partInspExp",
    title: "P3.2 VENT Part Insp/Exp",
    requiredSignals: ["Part Spont Insp.", "Part Spont Exp."],
    optionalSignals: [],
    channel: {
      id: Zt.PartInspExp,
      configuration: {
        name: "PartInspExp",
        relativeHeight: 5,
        tickInterval: { start: 0, end: 100, step: 25 },
        axisType: Ct.SignalOnly
      },
      signals: [
        Ye("Part Spont Insp.", "Part spont insp", "#086A87"),
        Ye("Part Spont Exp.", "Part spont exp", "#6E6E6E")
      ],
      events: []
    }
  },
  {
    templateId: "p32-vent.eventsVa",
    title: "P3.2 VENT VA Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsVaP32,
      configuration: {
        name: "Events VA",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ce(Vt.VolumeLow, "Volume low", "#CC6556", 0.4),
        Ce(Vt.VolumeHigh, "Volume high", "#E90505", 0.65),
        Ce(Vt.MinuteVolumeLow, "Minute volume low", "#FFAFA3", 0.45),
        Ce(Vt.MinuteVolumeHigh, "Minute volume high", "#C93F2D", 0.7)
      ]
    }
  },
  {
    templateId: "p32-vent.eventsP",
    title: "P3.2 VENT Pressure Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsPP32,
      configuration: {
        name: "Events P",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ce(Vt.PressureLow, "Pressure low", "#DC8FB9", 0.5),
        Ce(Vt.PressureHigh, "Pressure high", "#BE0C7A", 0.7)
      ]
    }
  },
  {
    templateId: "p32-vent.eventsF",
    title: "P3.2 VENT Frequency Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsFP32,
      configuration: {
        name: "Events F",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ce(Vt.Apnea, "Apnea", "#8B0000"),
        Ce(Vt.FrequencyLow, "Frequency low", "#FC9FB1", 0.45),
        Ce(Vt.FrequencyHigh, "Frequency high", "#FA5061", 0.7)
      ]
    }
  },
  {
    templateId: "p32-vent.leak",
    title: "P3.2 VENT Leak",
    requiredSignals: ["Leakage Flow"],
    optionalSignals: ["TotalLeakage"],
    channel: {
      id: Zt.Leak,
      configuration: {
        name: "Leakage",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 75, step: 25 },
        marks: [
          { value: 50, color: "#B32400" },
          { value: 25, color: "#994C00" }
        ],
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        Ye("TotalLeakage", "Total leakage", "#D3D3D3"),
        Ye("Leakage Flow", "Leak flow breath", "#000000")
      ],
      events: [
        Ce(Vt.SuddenEndOfLeakage, "SEL", "#ADD8E6", 0.7),
        Ce(Vt.Disconnection, "Disconnection", "#8B0000")
      ]
    }
  }
], UT = [
  {
    templateId: "p32-vent-spo2.spo2",
    title: "P3.2 VENT SpO2",
    requiredSignals: ["SpO2 Value"],
    optionalSignals: [],
    channel: {
      id: Zt.SpO2,
      configuration: {
        name: "SpO2 Value",
        relativeHeight: 10,
        tickInterval: { start: 70, end: 100, step: 10 },
        marks: [
          { value: 90, color: "#994C00" },
          { value: 80, color: "#B32400" }
        ],
        axisType: Ct.SignalsWithEvents
      },
      signals: [Ye("SpO2 Value", "SpO2 Value", "#6544A7")],
      events: [
        Ce(
          Vt.FlowSensorUnplausible,
          "Flow sensor unplausible",
          "#FFCC66"
        )
      ]
    }
  },
  {
    templateId: "p32-vent-spo2.eventsSpo2",
    title: "P3.2 VENT SpO2 Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsSpO2P32,
      configuration: {
        name: "Events SpO2",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ce(
          Vt.BlowerFeedForwardUnplausible,
          "Blower feed forward unplausible",
          "#6544A7"
        ),
        Ce(
          Vt.PressureSensorDiscrepancy,
          "Pressure sensor discrepancy",
          "#B6A4DA",
          0.6
        )
      ]
    }
  },
  {
    templateId: "p32-vent-spo2.pressure",
    title: "P3.2 VENT Pressure",
    requiredSignals: ["Airway Pressure"],
    optionalSignals: ["IPAPsoll", "EPAPsoll"],
    channel: {
      id: Zt.Pressure,
      configuration: {
        name: "Pressure",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 40, step: 5 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        Ye("Airway Pressure", "Pressure", "#000000", { max: 3600 * 1e3 }),
        Ye("IPAPsoll", "IPAP", "#446CAB", { min: 60 * 1e3 }),
        Ye("EPAPsoll", "EPAP", "#D17D7D", { min: 60 * 1e3 })
      ],
      events: [
        Ce(Vt.SoftStart, "softSTART", "#DCDCDC", 1, "top-left"),
        Ce(Vt.SoftStop, "softSTOP", "#DCDCDC")
      ]
    }
  },
  {
    templateId: "p32-vent-spo2.flow",
    title: "P3.2 VENT Flow",
    requiredSignals: ["Patient Flow"],
    optionalSignals: [],
    channel: {
      id: Zt.RespFlow,
      configuration: {
        name: "Flow",
        relativeHeight: 8,
        tickInterval: { start: -100, end: 100, step: 50 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [Ye("Patient Flow", "Resp. Flow", "#000000")],
      events: [
        Ce(Vt.Artefact, "Artefact", "#FFCC66", 1, "top-left")
      ]
    }
  },
  {
    templateId: "p32-vent-spo2.volumes",
    title: "P3.2 VENT Volumes",
    requiredSignals: ["Online Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.VolumeTrend,
      configuration: {
        name: "Volumes",
        relativeHeight: 8,
        tickInterval: { start: 0, end: 1500, step: 250 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Online Volume", "Online volume", "#446CAB")],
      events: []
    }
  },
  {
    templateId: "p32-vent-spo2.respCycles",
    title: "P3.2 VENT RespCycles",
    requiredSignals: ["Breath Phase"],
    optionalSignals: [],
    channel: {
      id: Zt.RespCycles,
      configuration: {
        name: "RespCycles",
        relativeHeight: 4,
        tickInterval: { start: 0, end: 3, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Breath Phase", "Breath phase", "#A9A9A9")],
      events: []
    }
  },
  {
    templateId: "p32-vent-spo2.phaseTrigger",
    title: "P3.2 VENT Phase Trigger",
    requiredSignals: ["Phase Trigger"],
    optionalSignals: [],
    channel: {
      id: Zt.PhaseTrigger,
      configuration: {
        name: "Phase trigger",
        relativeHeight: 4,
        tickInterval: { start: -1, end: 2, step: 3 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Phase Trigger", "Phase trigger", "#8B0000")],
      events: []
    }
  },
  {
    templateId: "p32-vent-spo2.minuteVolume",
    title: "P3.2 VENT Minute Volume",
    requiredSignals: ["Minute Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.MinuteVolume,
      configuration: {
        name: "Minute volume",
        relativeHeight: 7,
        tickInterval: { start: 0, end: 20, step: 5 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Minute Volume", "Minute Volume", "#7DB56E")],
      events: []
    }
  },
  {
    templateId: "p32-vent-spo2.tidalVolume",
    title: "P3.2 VENT Tidal Volume",
    requiredSignals: ["Tidal Volume"],
    optionalSignals: [],
    channel: {
      id: Zt.TidalVolume,
      configuration: {
        name: "Tidal volume",
        relativeHeight: 7,
        tickInterval: { start: 0, end: 1500, step: 250 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Tidal Volume", "Breath volume", "#446CAB")],
      events: []
    }
  },
  {
    templateId: "p32-vent-spo2.respRate",
    title: "P3.2 VENT RespRate",
    requiredSignals: ["Frequency"],
    optionalSignals: [],
    channel: {
      id: Zt.RespRate,
      configuration: {
        name: "RespRate",
        relativeHeight: 7,
        tickInterval: { start: 0, end: 40, step: 10 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Frequency", "Breath frequency", "#8A4545")],
      events: []
    }
  },
  {
    templateId: "p32-vent-spo2.tiT",
    title: "P3.2 VENT Ti/T",
    requiredSignals: ["Part Inspiration"],
    optionalSignals: [],
    channel: {
      id: Zt.TiT,
      configuration: {
        name: "Ti/T",
        relativeHeight: 7,
        tickInterval: { start: 20, end: 80, step: 20 },
        axisType: Ct.SignalOnly
      },
      signals: [Ye("Part Inspiration", "Insp/Exp rel", "#D17D7D")],
      events: []
    }
  },
  {
    templateId: "p32-vent-spo2.eventsSdb",
    title: "P3.2 VENT SDB Events",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsSdbP32,
      configuration: {
        name: "Events SDB",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ce(Vt.oA, "oA", "#CC6556"),
        Ce(Vt.oH, "oH", "#FFAFA3", 0.6),
        Ce(Vt.cH, "cH", "#6677DD", 0.6),
        Ce(Vt.uA, "uA", "#D3D3D3")
      ]
    }
  },
  {
    templateId: "p32-vent-spo2.partInspExp",
    title: "P3.2 VENT Part Insp/Exp",
    requiredSignals: ["Part Spont Insp.", "Part Spont Exp."],
    optionalSignals: [],
    channel: {
      id: Zt.PartInspExp,
      configuration: {
        name: "PartInspExp",
        relativeHeight: 6,
        tickInterval: { start: 0, end: 100, step: 25 },
        axisType: Ct.SignalOnly
      },
      signals: [
        Ye("Part Spont Insp.", "Part spont insp", "#086A87"),
        Ye("Part Spont Exp.", "Part spont exp", "#6E6E6E")
      ],
      events: []
    }
  },
  {
    templateId: "p32-vent-spo2.alarms",
    title: "P3.2 VENT Alarms",
    requiredSignals: [],
    optionalSignals: [],
    channel: {
      id: Zt.EventsVaP32,
      configuration: {
        name: "Alarms",
        relativeHeight: 4,
        axisType: Ct.EventOnly
      },
      signals: [],
      events: [
        Ce(Vt.Apnea, "Apnea", "#8B0000"),
        Ce(Vt.VolumeLow, "Volume low", "#CC6556", 0.4),
        Ce(Vt.VolumeHigh, "Volume high", "#E90505", 0.65),
        Ce(Vt.MinuteVolumeLow, "Minute volume low", "#FFAFA3", 0.45),
        Ce(Vt.MinuteVolumeHigh, "Minute volume high", "#C93F2D", 0.7),
        Ce(Vt.PressureLow, "Pressure low", "#DC8FB9", 0.5),
        Ce(Vt.PressureHigh, "Pressure high", "#BE0C7A", 0.7),
        Ce(Vt.FrequencyLow, "Frequency low", "#FC9FB1", 0.45),
        Ce(Vt.FrequencyHigh, "Frequency high", "#FA5061", 0.7)
      ]
    }
  },
  {
    templateId: "p32-vent-spo2.leak",
    title: "P3.2 VENT Leak",
    requiredSignals: ["Leakage Flow"],
    optionalSignals: ["TotalLeakage"],
    channel: {
      id: Zt.Leak,
      configuration: {
        name: "Leakage",
        relativeHeight: 6,
        tickInterval: { start: 0, end: 75, step: 25 },
        marks: [
          { value: 50, color: "#B32400" },
          { value: 25, color: "#994C00" }
        ],
        axisType: Ct.SignalsWithEvents
      },
      signals: [
        Ye("TotalLeakage", "Total leakage", "#D3D3D3"),
        Ye("Leakage Flow", "Leak flow breath", "#000000")
      ],
      events: [
        Ce(Vt.SuddenEndOfLeakage, "SEL", "#ADD8E6", 0.7),
        Ce(Vt.Disconnection, "Disconnection", "#8B0000")
      ]
    }
  },
  {
    templateId: "p32-vent-spo2.heartRate",
    title: "P3.2 VENT Heart Rate",
    requiredSignals: ["Pulse Rate"],
    optionalSignals: [],
    channel: {
      id: Zt.PulseRate,
      configuration: {
        name: "Heart rate",
        relativeHeight: 6,
        tickInterval: { start: 30, end: 150, step: 20 },
        axisType: Ct.SignalsWithEvents
      },
      signals: [Ye("Pulse Rate", "Heart frequency", "#D17D7D")],
      events: [
        Ce(
          Vt.FlowSensorUnplausible,
          "Flow sensor unplausible",
          "#FFCC66"
        )
      ]
    }
  }
];
function lk(r, t) {
  const e = t?.hasSpO2 ?? !1;
  return r === "v50" ? e ? WT : zT : e ? UT : GT;
}
const Ud = {
  label: "Disconnection",
  backgroundColor: "#B8860B",
  // DarkGoldenrod
  priority: 1
}, Ay = {
  label: "Disconnection patient",
  backgroundColor: "#E6A80E",
  priority: 1
}, iv = {
  label: "Critical leakage",
  backgroundColor: "#FFA500",
  // Orange
  priority: 2
}, HT = {
  label: "Recording canceled",
  backgroundColor: "#E3E3E3",
  stripeColor: "#B4B4B4",
  fillType: "backward-diagonal",
  priority: 3,
  showInProtocol: !1
}, sv = {
  label: "Therapy ended",
  backgroundColor: "#DECECE",
  stripeColor: "#000000",
  fillType: "wide-upward-diagonal",
  priority: 4
}, h0 = [
  { type: "171", config: Ud },
  { type: "161", config: iv },
  { type: "9999", config: HT }
], hk = h0, YT = [
  ...h0,
  { type: "794", config: sv }
];
function uk(r) {
  return r === "v50" ? YT : h0;
}
const ck = [
  { type: _e.DisconnectionAirwayPressure, config: Ud },
  { type: _e.DisconnectionValvePressure, config: Ud },
  { type: _e.DisconnectionPatient, config: Ay },
  { type: _e.DisconnectionPatientHft, config: Ay },
  { type: _e.LeakageHigh, config: iv },
  { type: _e.VentilationSwitchedOff, config: sv }
];
function td(r, t) {
  const e = r.getElementsByTagName(t)[0];
  if (!e?.textContent)
    throw new Error(`Missing <${t}> in device.xml`);
  return e.textContent.trim();
}
function ed(r, t) {
  const e = Number.parseInt(r, 10);
  if (Number.isNaN(e))
    throw new Error(`Invalid numeric value for ${t}: "${r}"`);
  return e;
}
function jT(r) {
  return [2, 5, 6].includes(r) ? "v50" : "vent";
}
function $T(r, t, e) {
  const i = `${r}_${t}_${e}`;
  return {
    "0_0_0": "prisma VENT30C",
    "0_0_1": "prisma VENT30",
    "0_0_2": "prisma VENT30",
    "0_1_0": "prisma VENT30",
    "0_1_1": "prisma VENT30",
    "0_1_2": "prisma VENT30",
    "0_2_0": "TIVAN 30",
    "0_2_1": "TIVAN 30",
    "0_2_2": "TIVAN 30",
    "0_3_0": "prisma VENT30",
    "0_3_1": "prisma VENT30",
    "0_3_2": "prisma VENT30",
    "0_4_0": "prisma VENT30",
    "0_4_1": "prisma VENT30",
    "0_4_2": "prisma VENT30",
    "0_5_0": "prisma VENT30",
    "0_5_1": "prisma VENT30",
    "0_5_2": "prisma VENT30",
    "1_0_0": "prisma VENT40",
    "1_0_1": "prisma VENT40",
    "1_0_2": "prisma VENT40",
    "1_1_0": "prisma VENT40",
    "1_1_1": "prisma VENT40",
    "1_1_2": "prisma VENT40",
    "1_2_0": "TIVAN 40",
    "1_2_1": "TIVAN 40",
    "1_2_2": "TIVAN 40",
    "1_3_0": "prisma VENT40",
    "1_3_1": "prisma VENT40",
    "1_3_2": "prisma VENT40",
    "1_4_0": "Prisma Comfort40",
    "1_4_1": "Prisma Comfort40",
    "1_4_2": "Prisma Comfort40",
    "1_5_0": "prisma VENT40",
    "1_5_1": "prisma VENT40",
    "1_5_2": "prisma VENT40",
    "2_0_0": "prisma VENT50C",
    "2_0_1": "prisma VENT50",
    "2_0_2": "prisma VENT50",
    "2_1_0": "prisma VENT50",
    "2_1_1": "prisma VENT50",
    "2_1_2": "prisma VENT50",
    "2_2_0": "TIVAN 50",
    "2_2_1": "TIVAN 50",
    "2_2_2": "TIVAN 50",
    "2_3_0": "prisma VENT50",
    "2_3_1": "prisma VENT50",
    "2_3_2": "prisma VENT50",
    "2_4_0": "prisma VENT50",
    "2_4_1": "prisma VENT50",
    "2_4_2": "prisma VENT50",
    "2_5_0": "prisma VENT50",
    "2_5_1": "prisma VENT50",
    "2_5_2": "prisma VENT50",
    "3_0_0": "prisma VENT30-C",
    "3_0_1": "prisma VENT30-C",
    "3_0_2": "prisma VENT30-C",
    "3_1_0": "prisma VENT30-C",
    "3_1_1": "prisma VENT30-C",
    "3_1_2": "prisma VENT30-C",
    "4_0_0": "prisma VENT dev",
    "4_0_1": "prisma VENT dev",
    "4_0_2": "prisma VENT dev",
    "5_0_0": "prisma VENT50-C",
    "5_0_1": "prisma VENT50-C",
    "5_0_2": "prisma VENT50-C",
    "5_1_0": "prisma VENT50-C",
    "5_1_1": "prisma VENT50-C",
    "5_1_2": "prisma VENT50-C",
    "6_0_0": "prisma VENT50-C",
    "6_0_1": "prisma VENT50-C",
    "6_0_2": "prisma VENT50-C",
    "6_1_0": "prisma VENT50-C",
    "6_1_1": "prisma VENT50-C",
    "6_1_2": "prisma VENT50-C",
    "7_0_0": "prisma VENT40-C",
    "7_0_1": "prisma VENT40-C",
    "7_0_2": "prisma VENT40-C",
    "7_1_0": "prisma VENT40-C",
    "7_1_1": "prisma VENT40-C",
    "7_1_2": "prisma VENT40-C",
    "-1_0_1": "prisma VENT invalid",
    "-1_1_0": "prisma VENT invalid",
    "-1_1_1": "prisma VENT invalid",
    "-1_1_2": "prisma VENT invalid"
  }[i] ?? `P3.2 ${i}`;
}
function dk(r) {
  const t = new DOMParser().parseFromString(r, "application/xml");
  if (t.getElementsByTagName("parsererror")[0])
    throw new Error("Invalid device.xml");
  const i = ed(td(t, "Device_type"), "Device_type"), s = ed(td(t, "Device_branding"), "Device_branding"), o = ed(
    td(t, "Device_battery_support"),
    "Device_battery_support"
  ), n = `${i}_${s}_${o}`;
  return {
    deviceTypeId: i,
    branding: s,
    batterySupport: o,
    compositeKey: n,
    displayName: $T(i, s, o),
    visconfigFamily: jT(i)
  };
}
export {
  Ct as AxisType,
  ok as ComboBox,
  y3 as FeatureSidebarButton,
  rk as FeatureSidebarSeparator,
  IT as Loader,
  a3 as MultiSelectionComboBox,
  h0 as P28_GLOBAL_EVENTS,
  ev as P28_TEMPLATES,
  hk as P3_GLOBAL_EVENTS,
  ak as P3_TEMPLATES,
  ck as P5_GLOBAL_EVENTS,
  NT as P5_TEMPLATES,
  nk as SignalChannelSelector,
  OT as SignalViewer,
  QT as SignalViewerDirectLicenseProvider,
  JT as SignalViewerManagedLicenseProvider,
  p3 as TherapyProtocol,
  tv as TherapyTimeInterval,
  x1 as formatDateTooltip,
  uk as getP32GlobalEvents,
  lk as getP32Templates,
  dk as parseP32DeviceXml,
  jC as reorderChannels,
  BT as suggestChannels,
  Sv as useSignalViewerLicense
};
//# sourceMappingURL=index.js.map
